"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.FulfillmentStatesConfiguration = exports.Field = exports.ExecuteConfigurationActionResult = exports.EndUserFeeConfig = exports.CustomerDeliveryTrackingOrder = exports.CustomerCreateModel = exports.CurrencyData = exports.CreateVoucher = exports.CreateTeammate = exports.CreateProductReference = exports.CreateProduct = exports.CreateMetafieldDefinition = exports.CreateGroupReference = exports.CreateGroup = exports.CreateFullMenuSectionItem = exports.CreateFullMenuItemOptionSetItem = exports.CreateFullMenuItemOptionSet = exports.CreateFullMenu = exports.CreateFulfillmentStatesConfiguration = exports.CreateEndUserFeeConfig = exports.CreateCatalogItem = exports.CreateCatalogGroupReference = exports.CreateAppStoreApp = exports.Channel = exports.CatalogItem = exports.CatalogGroupReference = exports.BusinessHoursPeriodBase = exports.BusinessHoursPeriod = exports.BusinessHoursOverrideBase = exports.BusinessHoursOverride = exports.BluetoothTerminalStatus = exports.BankAccountSummary = exports.BankAccountDetailsUpdateRequest = exports.BankAccountDetail = exports.BankAccountCreate = exports.BankAccount = exports.AppStoreAppSummary = exports.AppStoreAppConfigurationSummary = exports.AppStoreAppConfiguration = exports.AppStoreApp = exports.AppConfigUpdateModel = exports.AppConfigSalesChannel = exports.AppCompliance = exports.App = exports.ApmHourlyDataPoint = exports.AccountFieldKeyValuePair = exports.AccountFieldDefinition = exports.RequiredError = exports.BaseAPI = exports.COLLECTION_FORMATS = void 0;
exports.Payout = exports.OwnerEntityConfiguration = exports.OrderVoucherSummary = exports.OrderSummary = exports.OrderDeliveryInformationBase = exports.OrderDeliveryInformation = exports.Order = exports.OnboardingItemUpdate = exports.OnboardingConfigUpdate = exports.OAuthApp = exports.NextStatusWithOrderType = exports.MobileAppsSubmissionStatus = exports.MobileAppsStatistics = exports.MetafieldDefinitionRecommendation = exports.MetafieldDefinition = exports.MenuTaxDetails = exports.MenuSectionItemBase = exports.MenuSectionItem = exports.MenuSectionAvailabilityBase = exports.MenuSectionAvailability = exports.MenuItemOptionSetItemBase = exports.MenuItemOptionSetItem = exports.MenuItemOptionSetBase = exports.MenuItemOptionSet = exports.MenuElementListItemResponse = exports.MenuElementHide = exports.MenuElementEditResponse = exports.MenuCatalogItem = exports.MenuBase = exports.Menu = exports.LightspeedSettings = exports.KioskTerminalActionStateChangedEvent = exports.KioskBluetoothUnpairingModeEvent = exports.KioskBluetoothTerminalUpdatedEvent = exports.KioskBluetoothTerminalUnpairedEvent = exports.KioskBluetoothTerminalInstallationStatusEvent = exports.KioskBluetoothTerminalFirmwareVersionStatusEvent = exports.KioskBluetoothTerminalCancelUpdateEvent = exports.KioskBluetoothPairingModeEvent = exports.KioskBluetoothInstallUpdateInitiateEvent = exports.HydraStatus = exports.HydraDeviceDetails = exports.HydraCreatedEvent = exports.HydraConnectionStatusChangedEvent = exports.HydraConfig = exports.HomeAction = exports.GroupReference = exports.Group = exports.FulfillmentStatusConfigurationItem = exports.FulfillmentStatesConfigurationSummary = void 0;
exports.UpdateGroupReference = exports.UpdateFulfillmentStatesConfiguration = exports.UpdateCatalogGroupReference = exports.UpdateAppStoreApp = exports.TelephonyConfig = exports.TeammateBase = exports.Teammate = exports.SupportedCountry = exports.SubscriptionSummary = exports.SubscriptionProduct = exports.SubscriptionInvoice = exports.Subscription = exports.StuartSettings = exports.StripeCustomConnectedAccount = exports.StripeConnectedAccountInfo = exports.StripeConnectedAccount = exports.StripeAccountLinkRequest = exports.StoreSummary = exports.StoreOrderCapacityPeriod = exports.StoreOrderCapacityConfig = exports.StoreOpeningHoursUpdatedEvent = exports.StoreGroupExtended = exports.StoreGroupBase = exports.StoreGroup = exports.StoreEndOfDayReport = exports.StoreCreateBase = exports.StoreBase = exports.Store = exports.StatisticsCurrencyDataPoint = exports.SmsProviderCredential = exports.SignupStep = exports.SetVoucherValidityPeriodsSimplifiedRequest = exports.SetUserDeliveryLocationFieldRequest = exports.Reject = exports.RedeemInvitationResult = exports.Range = exports.ProductReference = exports.Product = exports.ProcessingFeeConfig = exports.PreviousOrder = exports.PreOrderConfig = exports.PhoneCall = exports.PayoutSummary = exports.PayoutRequestIds = exports.PayoutReport3RefundedOrder = exports.PayoutRefund = exports.PayoutOtherCharge = exports.PayoutOrder = exports.PayoutDetail = exports.PayoutChargeback = void 0;
exports.AuthorizationTokensApiFetchParamCreator = exports.AuditLogsApi = exports.AuditLogsApiFactory = exports.AuditLogsApiFp = exports.AuditLogsApiFetchParamCreator = exports.AppsApi = exports.AppsApiFactory = exports.AppsApiFp = exports.AppsApiFetchParamCreator = exports.AppStoreEntitlementsApi = exports.AppStoreEntitlementsApiFactory = exports.AppStoreEntitlementsApiFp = exports.AppStoreEntitlementsApiFetchParamCreator = exports.AppStoreDeveloperApi = exports.AppStoreDeveloperApiFactory = exports.AppStoreDeveloperApiFp = exports.AppStoreDeveloperApiFetchParamCreator = exports.AppStoreConfigurationsApi = exports.AppStoreConfigurationsApiFactory = exports.AppStoreConfigurationsApiFp = exports.AppStoreConfigurationsApiFetchParamCreator = exports.AppStoreApi = exports.AppStoreApiFactory = exports.AppStoreApiFp = exports.AppStoreApiFetchParamCreator = exports.ApmApi = exports.ApmApiFactory = exports.ApmApiFp = exports.ApmApiFetchParamCreator = exports.AddressApi = exports.AddressApiFactory = exports.AddressApiFp = exports.AddressApiFetchParamCreator = exports.AccountsApi = exports.AccountsApiFactory = exports.AccountsApiFp = exports.AccountsApiFetchParamCreator = exports.WhiteLabelConfigModel = exports.WebsiteImage = exports.VoucherWithStats = exports.VoucherSummary = exports.Voucher = exports.ValidityPeriod = exports.UserWhiteLabelConfig = exports.UserSearch = exports.UserMonthlyCommission = exports.UpdateVoucher = exports.UpdateProductReference = exports.UpdateMobileAppsSubmissionStatus = exports.UpdateMetafieldDefinition = void 0;
exports.CrossSellApiFactory = exports.CrossSellApiFp = exports.CrossSellApiFetchParamCreator = exports.ContentSecurityPolicyApi = exports.ContentSecurityPolicyApiFactory = exports.ContentSecurityPolicyApiFp = exports.ContentSecurityPolicyApiFetchParamCreator = exports.ClientsApi = exports.ClientsApiFactory = exports.ClientsApiFp = exports.ClientsApiFetchParamCreator = exports.ChannelsApi = exports.ChannelsApiFactory = exports.ChannelsApiFp = exports.ChannelsApiFetchParamCreator = exports.CatalogProductsApi = exports.CatalogProductsApiFactory = exports.CatalogProductsApiFp = exports.CatalogProductsApiFetchParamCreator = exports.CatalogItemsApi = exports.CatalogItemsApiFactory = exports.CatalogItemsApiFp = exports.CatalogItemsApiFetchParamCreator = exports.CatalogImagesApi = exports.CatalogImagesApiFactory = exports.CatalogImagesApiFp = exports.CatalogImagesApiFetchParamCreator = exports.CatalogGroupsApi = exports.CatalogGroupsApiFactory = exports.CatalogGroupsApiFp = exports.CatalogGroupsApiFetchParamCreator = exports.CatalogChangesApi = exports.CatalogChangesApiFactory = exports.CatalogChangesApiFp = exports.CatalogChangesApiFetchParamCreator = exports.CardReadersApi = exports.CardReadersApiFactory = exports.CardReadersApiFp = exports.CardReadersApiFetchParamCreator = exports.CampaignsApi = exports.CampaignsApiFactory = exports.CampaignsApiFp = exports.CampaignsApiFetchParamCreator = exports.BankAccountApi = exports.BankAccountApiFactory = exports.BankAccountApiFp = exports.BankAccountApiFetchParamCreator = exports.AuthorizationTokensApi = exports.AuthorizationTokensApiFactory = exports.AuthorizationTokensApiFp = void 0;
exports.HydraApiFetchParamCreator = exports.HomeApi = exports.HomeApiFactory = exports.HomeApiFp = exports.HomeApiFetchParamCreator = exports.HeartbeatApi = exports.HeartbeatApiFactory = exports.HeartbeatApiFp = exports.HeartbeatApiFetchParamCreator = exports.FulfillmentStateConfigurationApi = exports.FulfillmentStateConfigurationApiFactory = exports.FulfillmentStateConfigurationApiFp = exports.FulfillmentStateConfigurationApiFetchParamCreator = exports.FpmApi = exports.FpmApiFactory = exports.FpmApiFp = exports.FpmApiFetchParamCreator = exports.FirebaseAppsApi = exports.FirebaseAppsApiFactory = exports.FirebaseAppsApiFp = exports.FirebaseAppsApiFetchParamCreator = exports.FeaturesApi = exports.FeaturesApiFactory = exports.FeaturesApiFp = exports.FeaturesApiFetchParamCreator = exports.EventsApi = exports.EventsApiFactory = exports.EventsApiFp = exports.EventsApiFetchParamCreator = exports.EndUserFeesApi = exports.EndUserFeesApiFactory = exports.EndUserFeesApiFp = exports.EndUserFeesApiFetchParamCreator = exports.DriversApi = exports.DriversApiFactory = exports.DriversApiFp = exports.DriversApiFetchParamCreator = exports.DeviceApi = exports.DeviceApiFactory = exports.DeviceApiFp = exports.DeviceApiFetchParamCreator = exports.DeliveryZoneApi = exports.DeliveryZoneApiFactory = exports.DeliveryZoneApiFp = exports.DeliveryZoneApiFetchParamCreator = exports.CustomersApi = exports.CustomersApiFactory = exports.CustomersApiFp = exports.CustomersApiFetchParamCreator = exports.CrossSellApi = void 0;
exports.MenuOptionSetsApiFactory = exports.MenuOptionSetsApiFp = exports.MenuOptionSetsApiFetchParamCreator = exports.MenuOptionSetItemsApi = exports.MenuOptionSetItemsApiFactory = exports.MenuOptionSetItemsApiFp = exports.MenuOptionSetItemsApiFetchParamCreator = exports.LookerSingleSignOnApi = exports.LookerSingleSignOnApiFactory = exports.LookerSingleSignOnApiFp = exports.LookerSingleSignOnApiFetchParamCreator = exports.LookerDashboardApi = exports.LookerDashboardApiFactory = exports.LookerDashboardApiFp = exports.LookerDashboardApiFetchParamCreator = exports.LocationAreasApi = exports.LocationAreasApiFactory = exports.LocationAreasApiFp = exports.LocationAreasApiFetchParamCreator = exports.LocationApi = exports.LocationApiFactory = exports.LocationApiFp = exports.LocationApiFetchParamCreator = exports.LightspeedApi = exports.LightspeedApiFactory = exports.LightspeedApiFp = exports.LightspeedApiFetchParamCreator = exports.KioskIotApi = exports.KioskIotApiFactory = exports.KioskIotApiFp = exports.KioskIotApiFetchParamCreator = exports.KioskEntitlementsApi = exports.KioskEntitlementsApiFactory = exports.KioskEntitlementsApiFp = exports.KioskEntitlementsApiFetchParamCreator = exports.InvoicesApi = exports.InvoicesApiFactory = exports.InvoicesApiFp = exports.InvoicesApiFetchParamCreator = exports.IntercomApi = exports.IntercomApiFactory = exports.IntercomApiFp = exports.IntercomApiFetchParamCreator = exports.IntegrationMetadataCatalogueApi = exports.IntegrationMetadataCatalogueApiFactory = exports.IntegrationMetadataCatalogueApiFp = exports.IntegrationMetadataCatalogueApiFetchParamCreator = exports.HydraApi = exports.HydraApiFactory = exports.HydraApiFp = void 0;
exports.OrdersApiFetchParamCreator = exports.OrderBatchingConfigurationApi = exports.OrderBatchingConfigurationApiFactory = exports.OrderBatchingConfigurationApiFp = exports.OrderBatchingConfigurationApiFetchParamCreator = exports.OrderBatchesApi = exports.OrderBatchesApiFactory = exports.OrderBatchesApiFp = exports.OrderBatchesApiFetchParamCreator = exports.OnboardingApi = exports.OnboardingApiFactory = exports.OnboardingApiFp = exports.OnboardingApiFetchParamCreator = exports.OAuthClientsApi = exports.OAuthClientsApiFactory = exports.OAuthClientsApiFp = exports.OAuthClientsApiFetchParamCreator = exports.MobileAppsApi = exports.MobileAppsApiFactory = exports.MobileAppsApiFp = exports.MobileAppsApiFetchParamCreator = exports.MetafieldDefinitionsApi = exports.MetafieldDefinitionsApiFactory = exports.MetafieldDefinitionsApiFp = exports.MetafieldDefinitionsApiFetchParamCreator = exports.MenusNutritionInfoV2Api = exports.MenusNutritionInfoV2ApiFactory = exports.MenusNutritionInfoV2ApiFp = exports.MenusNutritionInfoV2ApiFetchParamCreator = exports.MenusNutritionInfoApi = exports.MenusNutritionInfoApiFactory = exports.MenusNutritionInfoApiFp = exports.MenusNutritionInfoApiFetchParamCreator = exports.MenusApi = exports.MenusApiFactory = exports.MenusApiFp = exports.MenusApiFetchParamCreator = exports.MenuZonesApi = exports.MenuZonesApiFactory = exports.MenuZonesApiFp = exports.MenuZonesApiFetchParamCreator = exports.MenuSectionsApi = exports.MenuSectionsApiFactory = exports.MenuSectionsApiFp = exports.MenuSectionsApiFetchParamCreator = exports.MenuSectionItemsApi = exports.MenuSectionItemsApiFactory = exports.MenuSectionItemsApiFp = exports.MenuSectionItemsApiFetchParamCreator = exports.MenuOptionSetsApi = void 0;
exports.StoreOrderCapacityApiFactory = exports.StoreOrderCapacityApiFp = exports.StoreOrderCapacityApiFetchParamCreator = exports.StoreGroupsApi = exports.StoreGroupsApiFactory = exports.StoreGroupsApiFp = exports.StoreGroupsApiFetchParamCreator = exports.SmsProviderCredentialsApi = exports.SmsProviderCredentialsApiFactory = exports.SmsProviderCredentialsApiFp = exports.SmsProviderCredentialsApiFetchParamCreator = exports.SearchApi = exports.SearchApiFactory = exports.SearchApiFp = exports.SearchApiFetchParamCreator = exports.RestaurantVouchersPayGreenApi = exports.RestaurantVouchersPayGreenApiFactory = exports.RestaurantVouchersPayGreenApiFp = exports.RestaurantVouchersPayGreenApiFetchParamCreator = exports.ReceiptsApi = exports.ReceiptsApiFactory = exports.ReceiptsApiFp = exports.ReceiptsApiFetchParamCreator = exports.PushNotificationsApi = exports.PushNotificationsApiFactory = exports.PushNotificationsApiFp = exports.PushNotificationsApiFetchParamCreator = exports.ProcessingFeeConfigsApi = exports.ProcessingFeeConfigsApiFactory = exports.ProcessingFeeConfigsApiFp = exports.ProcessingFeeConfigsApiFetchParamCreator = exports.PayoutsApi = exports.PayoutsApiFactory = exports.PayoutsApiFp = exports.PayoutsApiFetchParamCreator = exports.PayoutReportsApi = exports.PayoutReportsApiFactory = exports.PayoutReportsApiFp = exports.PayoutReportsApiFetchParamCreator = exports.PaymentsApi = exports.PaymentsApiFactory = exports.PaymentsApiFp = exports.PaymentsApiFetchParamCreator = exports.PaymentIntentsApi = exports.PaymentIntentsApiFactory = exports.PaymentIntentsApiFp = exports.PaymentIntentsApiFetchParamCreator = exports.OrdersApi = exports.OrdersApiFactory = exports.OrdersApiFp = void 0;
exports.WhiteLabelConfigApiFetchParamCreator = exports.WhiteLabelBuildsApi = exports.WhiteLabelBuildsApiFactory = exports.WhiteLabelBuildsApiFp = exports.WhiteLabelBuildsApiFetchParamCreator = exports.WebsiteApi = exports.WebsiteApiFactory = exports.WebsiteApiFp = exports.WebsiteApiFetchParamCreator = exports.WebhooksApi = exports.WebhooksApiFactory = exports.WebhooksApiFp = exports.WebhooksApiFetchParamCreator = exports.VouchersApi = exports.VouchersApiFactory = exports.VouchersApiFp = exports.VouchersApiFetchParamCreator = exports.UsersApi = exports.UsersApiFactory = exports.UsersApiFp = exports.UsersApiFetchParamCreator = exports.TipsApi = exports.TipsApiFactory = exports.TipsApiFp = exports.TipsApiFetchParamCreator = exports.TerminalIotApi = exports.TerminalIotApiFactory = exports.TerminalIotApiFp = exports.TerminalIotApiFetchParamCreator = exports.TeammatesApi = exports.TeammatesApiFactory = exports.TeammatesApiFp = exports.TeammatesApiFetchParamCreator = exports.SubscriptionsApi = exports.SubscriptionsApiFactory = exports.SubscriptionsApiFp = exports.SubscriptionsApiFetchParamCreator = exports.StuartApi = exports.StuartApiFactory = exports.StuartApiFp = exports.StuartApiFetchParamCreator = exports.StripeCustomConnectApi = exports.StripeCustomConnectApiFactory = exports.StripeCustomConnectApiFp = exports.StripeCustomConnectApiFetchParamCreator = exports.StoresApi = exports.StoresApiFactory = exports.StoresApiFp = exports.StoresApiFetchParamCreator = exports.StoreOrderCapacityApi = void 0;
exports.WhiteLabelContactFormTypeApi = exports.WhiteLabelContactFormTypeApiFactory = exports.WhiteLabelContactFormTypeApiFp = exports.WhiteLabelContactFormTypeApiFetchParamCreator = exports.WhiteLabelConfigApi = exports.WhiteLabelConfigApiFactory = exports.WhiteLabelConfigApiFp = void 0;
var url = require("url");
var portableFetch = require("portable-fetch");
var BASE_PATH = "https://api.flipdish.co/".replace(/\/+$/, "");
exports.COLLECTION_FORMATS = {
    csv: ",",
    ssv: " ",
    tsv: "\t",
    pipes: "|",
};
var BaseAPI = (function () {
    function BaseAPI(configuration, basePath, fetch) {
        if (basePath === void 0) { basePath = BASE_PATH; }
        if (fetch === void 0) { fetch = portableFetch; }
        this.basePath = basePath;
        this.fetch = fetch;
        if (configuration) {
            this.configuration = configuration;
            this.basePath = configuration.basePath || this.basePath;
        }
    }
    return BaseAPI;
}());
exports.BaseAPI = BaseAPI;
;
var RequiredError = (function (_super) {
    __extends(RequiredError, _super);
    function RequiredError(field, msg) {
        var _this = _super.call(this, msg) || this;
        _this.field = field;
        return _this;
    }
    return RequiredError;
}(Error));
exports.RequiredError = RequiredError;
var AccountFieldDefinition;
(function (AccountFieldDefinition) {
    var KeyEnum;
    (function (KeyEnum) {
        KeyEnum[KeyEnum["Iban"] = 'Iban'] = "Iban";
        KeyEnum[KeyEnum["AccountNumber"] = 'AccountNumber'] = "AccountNumber";
        KeyEnum[KeyEnum["RoutingNumber"] = 'RoutingNumber'] = "RoutingNumber";
        KeyEnum[KeyEnum["BSB"] = 'BSB'] = "BSB";
        KeyEnum[KeyEnum["BranchCode"] = 'BranchCode'] = "BranchCode";
        KeyEnum[KeyEnum["BankCode"] = 'BankCode'] = "BankCode";
        KeyEnum[KeyEnum["InstitutionNumber"] = 'InstitutionNumber'] = "InstitutionNumber";
        KeyEnum[KeyEnum["TransitNumber"] = 'TransitNumber'] = "TransitNumber";
        KeyEnum[KeyEnum["ClearingCode"] = 'ClearingCode'] = "ClearingCode";
        KeyEnum[KeyEnum["IfscCode"] = 'IfscCode'] = "IfscCode";
        KeyEnum[KeyEnum["Clabe"] = 'Clabe'] = "Clabe";
        KeyEnum[KeyEnum["SortCode"] = 'SortCode'] = "SortCode";
        KeyEnum[KeyEnum["Swift"] = 'Swift'] = "Swift";
    })(KeyEnum = AccountFieldDefinition.KeyEnum || (AccountFieldDefinition.KeyEnum = {}));
    var TypeEnum;
    (function (TypeEnum) {
        TypeEnum[TypeEnum["None"] = 'None'] = "None";
        TypeEnum[TypeEnum["Iban"] = 'Iban'] = "Iban";
    })(TypeEnum = AccountFieldDefinition.TypeEnum || (AccountFieldDefinition.TypeEnum = {}));
})(AccountFieldDefinition || (exports.AccountFieldDefinition = AccountFieldDefinition = {}));
var AccountFieldKeyValuePair;
(function (AccountFieldKeyValuePair) {
    var KeyEnum;
    (function (KeyEnum) {
        KeyEnum[KeyEnum["Iban"] = 'Iban'] = "Iban";
        KeyEnum[KeyEnum["AccountNumber"] = 'AccountNumber'] = "AccountNumber";
        KeyEnum[KeyEnum["RoutingNumber"] = 'RoutingNumber'] = "RoutingNumber";
        KeyEnum[KeyEnum["BSB"] = 'BSB'] = "BSB";
        KeyEnum[KeyEnum["BranchCode"] = 'BranchCode'] = "BranchCode";
        KeyEnum[KeyEnum["BankCode"] = 'BankCode'] = "BankCode";
        KeyEnum[KeyEnum["InstitutionNumber"] = 'InstitutionNumber'] = "InstitutionNumber";
        KeyEnum[KeyEnum["TransitNumber"] = 'TransitNumber'] = "TransitNumber";
        KeyEnum[KeyEnum["ClearingCode"] = 'ClearingCode'] = "ClearingCode";
        KeyEnum[KeyEnum["IfscCode"] = 'IfscCode'] = "IfscCode";
        KeyEnum[KeyEnum["Clabe"] = 'Clabe'] = "Clabe";
        KeyEnum[KeyEnum["SortCode"] = 'SortCode'] = "SortCode";
        KeyEnum[KeyEnum["Swift"] = 'Swift'] = "Swift";
    })(KeyEnum = AccountFieldKeyValuePair.KeyEnum || (AccountFieldKeyValuePair.KeyEnum = {}));
})(AccountFieldKeyValuePair || (exports.AccountFieldKeyValuePair = AccountFieldKeyValuePair = {}));
var ApmHourlyDataPoint;
(function (ApmHourlyDataPoint) {
    var DayEnum;
    (function (DayEnum) {
        DayEnum[DayEnum["Sunday"] = 'Sunday'] = "Sunday";
        DayEnum[DayEnum["Monday"] = 'Monday'] = "Monday";
        DayEnum[DayEnum["Tuesday"] = 'Tuesday'] = "Tuesday";
        DayEnum[DayEnum["Wednesday"] = 'Wednesday'] = "Wednesday";
        DayEnum[DayEnum["Thursday"] = 'Thursday'] = "Thursday";
        DayEnum[DayEnum["Friday"] = 'Friday'] = "Friday";
        DayEnum[DayEnum["Saturday"] = 'Saturday'] = "Saturday";
    })(DayEnum = ApmHourlyDataPoint.DayEnum || (ApmHourlyDataPoint.DayEnum = {}));
})(ApmHourlyDataPoint || (exports.ApmHourlyDataPoint = ApmHourlyDataPoint = {}));
var App;
(function (App) {
    var AppAccessLevelEnum;
    (function (AppAccessLevelEnum) {
        AppAccessLevelEnum[AppAccessLevelEnum["None"] = 'None'] = "None";
        AppAccessLevelEnum[AppAccessLevelEnum["Owner"] = 'Owner'] = "Owner";
        AppAccessLevelEnum[AppAccessLevelEnum["StoreOwner"] = 'StoreOwner'] = "StoreOwner";
        AppAccessLevelEnum[AppAccessLevelEnum["PropertyOwner"] = 'PropertyOwner'] = "PropertyOwner";
        AppAccessLevelEnum[AppAccessLevelEnum["ManagedOwner"] = 'ManagedOwner'] = "ManagedOwner";
        AppAccessLevelEnum[AppAccessLevelEnum["Integrator"] = 'Integrator'] = "Integrator";
        AppAccessLevelEnum[AppAccessLevelEnum["PropertyManager"] = 'PropertyManager'] = "PropertyManager";
        AppAccessLevelEnum[AppAccessLevelEnum["StoreManager"] = 'StoreManager'] = "StoreManager";
        AppAccessLevelEnum[AppAccessLevelEnum["StoreStaff"] = 'StoreStaff'] = "StoreStaff";
        AppAccessLevelEnum[AppAccessLevelEnum["StaffMember"] = 'StaffMember'] = "StaffMember";
        AppAccessLevelEnum[AppAccessLevelEnum["StoreReadOnlyAccess"] = 'StoreReadOnlyAccess'] = "StoreReadOnlyAccess";
        AppAccessLevelEnum[AppAccessLevelEnum["FinanceManger"] = 'FinanceManger'] = "FinanceManger";
        AppAccessLevelEnum[AppAccessLevelEnum["Onboarding"] = 'Onboarding'] = "Onboarding";
        AppAccessLevelEnum[AppAccessLevelEnum["Support"] = 'Support'] = "Support";
    })(AppAccessLevelEnum = App.AppAccessLevelEnum || (App.AppAccessLevelEnum = {}));
    var AppResourceSetEnum;
    (function (AppResourceSetEnum) {
        AppResourceSetEnum[AppResourceSetEnum["ViewApp"] = 'ViewApp'] = "ViewApp";
        AppResourceSetEnum[AppResourceSetEnum["CreateApp"] = 'CreateApp'] = "CreateApp";
        AppResourceSetEnum[AppResourceSetEnum["UpdateApp"] = 'UpdateApp'] = "UpdateApp";
        AppResourceSetEnum[AppResourceSetEnum["ViewAppName"] = 'ViewAppName'] = "ViewAppName";
        AppResourceSetEnum[AppResourceSetEnum["EditAppAssets"] = 'EditAppAssets'] = "EditAppAssets";
        AppResourceSetEnum[AppResourceSetEnum["EditAppFeatures"] = 'EditAppFeatures'] = "EditAppFeatures";
        AppResourceSetEnum[AppResourceSetEnum["ViewTeammates"] = 'ViewTeammates'] = "ViewTeammates";
        AppResourceSetEnum[AppResourceSetEnum["EditTeammates"] = 'EditTeammates'] = "EditTeammates";
        AppResourceSetEnum[AppResourceSetEnum["CreateTeammateOwner"] = 'CreateTeammateOwner'] = "CreateTeammateOwner";
        AppResourceSetEnum[AppResourceSetEnum["CreateTeammateManagedOwner"] = 'CreateTeammateManagedOwner'] = "CreateTeammateManagedOwner";
        AppResourceSetEnum[AppResourceSetEnum["CreateTeammateStoreOwner"] = 'CreateTeammateStoreOwner'] = "CreateTeammateStoreOwner";
        AppResourceSetEnum[AppResourceSetEnum["CreateTeammateStoreManager"] = 'CreateTeammateStoreManager'] = "CreateTeammateStoreManager";
        AppResourceSetEnum[AppResourceSetEnum["CreateTeammateStoreStaff"] = 'CreateTeammateStoreStaff'] = "CreateTeammateStoreStaff";
        AppResourceSetEnum[AppResourceSetEnum["CreateTeammateStoreReadAccess"] = 'CreateTeammateStoreReadAccess'] = "CreateTeammateStoreReadAccess";
        AppResourceSetEnum[AppResourceSetEnum["CreateTeammateFinanceManager"] = 'CreateTeammateFinanceManager'] = "CreateTeammateFinanceManager";
        AppResourceSetEnum[AppResourceSetEnum["CreateTeammateIntegrator"] = 'CreateTeammateIntegrator'] = "CreateTeammateIntegrator";
        AppResourceSetEnum[AppResourceSetEnum["CreateTeammateOnboarding"] = 'CreateTeammateOnboarding'] = "CreateTeammateOnboarding";
        AppResourceSetEnum[AppResourceSetEnum["CreateTeammatePropertyManager"] = 'CreateTeammatePropertyManager'] = "CreateTeammatePropertyManager";
        AppResourceSetEnum[AppResourceSetEnum["CreateTeammatePropertyOwner"] = 'CreateTeammatePropertyOwner'] = "CreateTeammatePropertyOwner";
        AppResourceSetEnum[AppResourceSetEnum["CreateTeammateStaffMember"] = 'CreateTeammateStaffMember'] = "CreateTeammateStaffMember";
        AppResourceSetEnum[AppResourceSetEnum["ViewApmConfigurations"] = 'ViewApmConfigurations'] = "ViewApmConfigurations";
        AppResourceSetEnum[AppResourceSetEnum["EditApmConfigurations"] = 'EditApmConfigurations'] = "EditApmConfigurations";
        AppResourceSetEnum[AppResourceSetEnum["ViewCampaignsConfigurations"] = 'ViewCampaignsConfigurations'] = "ViewCampaignsConfigurations";
        AppResourceSetEnum[AppResourceSetEnum["CreateCampaignsConfigurations"] = 'CreateCampaignsConfigurations'] = "CreateCampaignsConfigurations";
        AppResourceSetEnum[AppResourceSetEnum["UpdateCampaignsConfigurations"] = 'UpdateCampaignsConfigurations'] = "UpdateCampaignsConfigurations";
        AppResourceSetEnum[AppResourceSetEnum["DeleteCampaignsConfigurations"] = 'DeleteCampaignsConfigurations'] = "DeleteCampaignsConfigurations";
        AppResourceSetEnum[AppResourceSetEnum["StampLoyaltyCardAgainstCampaignsConfigurations"] = 'StampLoyaltyCardAgainstCampaignsConfigurations'] = "StampLoyaltyCardAgainstCampaignsConfigurations";
        AppResourceSetEnum[AppResourceSetEnum["ViewDevelopersSettings"] = 'ViewDevelopersSettings'] = "ViewDevelopersSettings";
        AppResourceSetEnum[AppResourceSetEnum["EditDevelopersSettings"] = 'EditDevelopersSettings'] = "EditDevelopersSettings";
        AppResourceSetEnum[AppResourceSetEnum["ViewOrders"] = 'ViewOrders'] = "ViewOrders";
        AppResourceSetEnum[AppResourceSetEnum["UpdateOrdersAccept"] = 'UpdateOrdersAccept'] = "UpdateOrdersAccept";
        AppResourceSetEnum[AppResourceSetEnum["UpdateOrdersReject"] = 'UpdateOrdersReject'] = "UpdateOrdersReject";
        AppResourceSetEnum[AppResourceSetEnum["UpdateOrdersRefund"] = 'UpdateOrdersRefund'] = "UpdateOrdersRefund";
        AppResourceSetEnum[AppResourceSetEnum["UpdateOrdersDispatch"] = 'UpdateOrdersDispatch'] = "UpdateOrdersDispatch";
        AppResourceSetEnum[AppResourceSetEnum["ViewStores"] = 'ViewStores'] = "ViewStores";
        AppResourceSetEnum[AppResourceSetEnum["CreateStores"] = 'CreateStores'] = "CreateStores";
        AppResourceSetEnum[AppResourceSetEnum["EditStores"] = 'EditStores'] = "EditStores";
        AppResourceSetEnum[AppResourceSetEnum["ViewStoresOpeningHours"] = 'ViewStoresOpeningHours'] = "ViewStoresOpeningHours";
        AppResourceSetEnum[AppResourceSetEnum["UpdateStoresOpenForCollectionOrDelivery"] = 'UpdateStoresOpenForCollectionOrDelivery'] = "UpdateStoresOpenForCollectionOrDelivery";
        AppResourceSetEnum[AppResourceSetEnum["UpdateStoresOpeningHours"] = 'UpdateStoresOpeningHours'] = "UpdateStoresOpeningHours";
        AppResourceSetEnum[AppResourceSetEnum["ViewStoresOpeningHoursOverride"] = 'ViewStoresOpeningHoursOverride'] = "ViewStoresOpeningHoursOverride";
        AppResourceSetEnum[AppResourceSetEnum["EditStoresOpeningHoursOverride"] = 'EditStoresOpeningHoursOverride'] = "EditStoresOpeningHoursOverride";
        AppResourceSetEnum[AppResourceSetEnum["EditStoresOpeningHoursOverrideTemporary"] = 'EditStoresOpeningHoursOverrideTemporary'] = "EditStoresOpeningHoursOverrideTemporary";
        AppResourceSetEnum[AppResourceSetEnum["UpdateStoresName"] = 'UpdateStoresName'] = "UpdateStoresName";
        AppResourceSetEnum[AppResourceSetEnum["EditStoreKioskSettings"] = 'EditStoreKioskSettings'] = "EditStoreKioskSettings";
        AppResourceSetEnum[AppResourceSetEnum["EditStoreOrderCapacity"] = 'EditStoreOrderCapacity'] = "EditStoreOrderCapacity";
        AppResourceSetEnum[AppResourceSetEnum["ArchiveStores"] = 'ArchiveStores'] = "ArchiveStores";
        AppResourceSetEnum[AppResourceSetEnum["PublishStores"] = 'PublishStores'] = "PublishStores";
        AppResourceSetEnum[AppResourceSetEnum["UpdatePrinterTerminalsAssign"] = 'UpdatePrinterTerminalsAssign'] = "UpdatePrinterTerminalsAssign";
        AppResourceSetEnum[AppResourceSetEnum["UpdatePrinterTerminalsToggle"] = 'UpdatePrinterTerminalsToggle'] = "UpdatePrinterTerminalsToggle";
        AppResourceSetEnum[AppResourceSetEnum["EditStoreNotifications"] = 'EditStoreNotifications'] = "EditStoreNotifications";
        AppResourceSetEnum[AppResourceSetEnum["ViewStoreGroups"] = 'ViewStoreGroups'] = "ViewStoreGroups";
        AppResourceSetEnum[AppResourceSetEnum["CreateStoreGroups"] = 'CreateStoreGroups'] = "CreateStoreGroups";
        AppResourceSetEnum[AppResourceSetEnum["UpdateStoreGroups"] = 'UpdateStoreGroups'] = "UpdateStoreGroups";
        AppResourceSetEnum[AppResourceSetEnum["DeleteStoreGroups"] = 'DeleteStoreGroups'] = "DeleteStoreGroups";
        AppResourceSetEnum[AppResourceSetEnum["ViewDeliveryZones"] = 'ViewDeliveryZones'] = "ViewDeliveryZones";
        AppResourceSetEnum[AppResourceSetEnum["CreateDeliveryZones"] = 'CreateDeliveryZones'] = "CreateDeliveryZones";
        AppResourceSetEnum[AppResourceSetEnum["UpdateDeliveryZones"] = 'UpdateDeliveryZones'] = "UpdateDeliveryZones";
        AppResourceSetEnum[AppResourceSetEnum["DeleteDeliveryZones"] = 'DeleteDeliveryZones'] = "DeleteDeliveryZones";
        AppResourceSetEnum[AppResourceSetEnum["ViewMenu"] = 'ViewMenu'] = "ViewMenu";
        AppResourceSetEnum[AppResourceSetEnum["CreateMenu"] = 'CreateMenu'] = "CreateMenu";
        AppResourceSetEnum[AppResourceSetEnum["UpdateMenu"] = 'UpdateMenu'] = "UpdateMenu";
        AppResourceSetEnum[AppResourceSetEnum["DeleteMenu"] = 'DeleteMenu'] = "DeleteMenu";
        AppResourceSetEnum[AppResourceSetEnum["UpdateMenuLock"] = 'UpdateMenuLock'] = "UpdateMenuLock";
        AppResourceSetEnum[AppResourceSetEnum["UpdateMenuItemsHideTemporarily"] = 'UpdateMenuItemsHideTemporarily'] = "UpdateMenuItemsHideTemporarily";
        AppResourceSetEnum[AppResourceSetEnum["EditMenuImage"] = 'EditMenuImage'] = "EditMenuImage";
        AppResourceSetEnum[AppResourceSetEnum["ViewVouchers"] = 'ViewVouchers'] = "ViewVouchers";
        AppResourceSetEnum[AppResourceSetEnum["EditVouchers"] = 'EditVouchers'] = "EditVouchers";
        AppResourceSetEnum[AppResourceSetEnum["ViewWebsiteContent"] = 'ViewWebsiteContent'] = "ViewWebsiteContent";
        AppResourceSetEnum[AppResourceSetEnum["EditWebsiteContent"] = 'EditWebsiteContent'] = "EditWebsiteContent";
        AppResourceSetEnum[AppResourceSetEnum["ViewWebsiteDnsVerified"] = 'ViewWebsiteDnsVerified'] = "ViewWebsiteDnsVerified";
        AppResourceSetEnum[AppResourceSetEnum["ViewWebsiteCertificateCreated"] = 'ViewWebsiteCertificateCreated'] = "ViewWebsiteCertificateCreated";
        AppResourceSetEnum[AppResourceSetEnum["ViewWebsiteCertificateRenewed"] = 'ViewWebsiteCertificateRenewed'] = "ViewWebsiteCertificateRenewed";
        AppResourceSetEnum[AppResourceSetEnum["ViewBankAccounts"] = 'ViewBankAccounts'] = "ViewBankAccounts";
        AppResourceSetEnum[AppResourceSetEnum["CreateBankAccounts"] = 'CreateBankAccounts'] = "CreateBankAccounts";
        AppResourceSetEnum[AppResourceSetEnum["UpdateBankAccounts"] = 'UpdateBankAccounts'] = "UpdateBankAccounts";
        AppResourceSetEnum[AppResourceSetEnum["UpdateBankAccountsAssign"] = 'UpdateBankAccountsAssign'] = "UpdateBankAccountsAssign";
        AppResourceSetEnum[AppResourceSetEnum["ViewAssignedBankAccount"] = 'ViewAssignedBankAccount'] = "ViewAssignedBankAccount";
        AppResourceSetEnum[AppResourceSetEnum["VerifyBankAccounts"] = 'VerifyBankAccounts'] = "VerifyBankAccounts";
        AppResourceSetEnum[AppResourceSetEnum["ViewServiceChargeConfigurations"] = 'ViewServiceChargeConfigurations'] = "ViewServiceChargeConfigurations";
        AppResourceSetEnum[AppResourceSetEnum["EditServiceChargeConfigurations"] = 'EditServiceChargeConfigurations'] = "EditServiceChargeConfigurations";
        AppResourceSetEnum[AppResourceSetEnum["EditStoreDeliveryZoneFees"] = 'EditStoreDeliveryZoneFees'] = "EditStoreDeliveryZoneFees";
        AppResourceSetEnum[AppResourceSetEnum["EditStoreDeliveryFeesLimited"] = 'EditStoreDeliveryFeesLimited'] = "EditStoreDeliveryFeesLimited";
        AppResourceSetEnum[AppResourceSetEnum["ViewHydraConfig"] = 'ViewHydraConfig'] = "ViewHydraConfig";
        AppResourceSetEnum[AppResourceSetEnum["UpdateHydraConfigManage"] = 'UpdateHydraConfigManage'] = "UpdateHydraConfigManage";
        AppResourceSetEnum[AppResourceSetEnum["InitiateBluetoothPairingMode"] = 'InitiateBluetoothPairingMode'] = "InitiateBluetoothPairingMode";
        AppResourceSetEnum[AppResourceSetEnum["DeleteTerminal"] = 'DeleteTerminal'] = "DeleteTerminal";
        AppResourceSetEnum[AppResourceSetEnum["ViewKioskTelemetry"] = 'ViewKioskTelemetry'] = "ViewKioskTelemetry";
        AppResourceSetEnum[AppResourceSetEnum["ViewCustomers"] = 'ViewCustomers'] = "ViewCustomers";
        AppResourceSetEnum[AppResourceSetEnum["EditCustomers"] = 'EditCustomers'] = "EditCustomers";
        AppResourceSetEnum[AppResourceSetEnum["CreateCustomers"] = 'CreateCustomers'] = "CreateCustomers";
        AppResourceSetEnum[AppResourceSetEnum["CreateCatalogElements"] = 'CreateCatalogElements'] = "CreateCatalogElements";
        AppResourceSetEnum[AppResourceSetEnum["UpdateCatalogElements"] = 'UpdateCatalogElements'] = "UpdateCatalogElements";
        AppResourceSetEnum[AppResourceSetEnum["ViewCatalogElements"] = 'ViewCatalogElements'] = "ViewCatalogElements";
        AppResourceSetEnum[AppResourceSetEnum["DeleteCatalogElements"] = 'DeleteCatalogElements'] = "DeleteCatalogElements";
        AppResourceSetEnum[AppResourceSetEnum["ViewMetafieldDefinitions"] = 'ViewMetafieldDefinitions'] = "ViewMetafieldDefinitions";
        AppResourceSetEnum[AppResourceSetEnum["CreateMetafieldDefinitions"] = 'CreateMetafieldDefinitions'] = "CreateMetafieldDefinitions";
        AppResourceSetEnum[AppResourceSetEnum["UpdateMetafieldDefinitions"] = 'UpdateMetafieldDefinitions'] = "UpdateMetafieldDefinitions";
        AppResourceSetEnum[AppResourceSetEnum["DeleteMetafieldDefinitions"] = 'DeleteMetafieldDefinitions'] = "DeleteMetafieldDefinitions";
        AppResourceSetEnum[AppResourceSetEnum["UpdateMetafields"] = 'UpdateMetafields'] = "UpdateMetafields";
        AppResourceSetEnum[AppResourceSetEnum["ViewCatalogMenuChanges"] = 'ViewCatalogMenuChanges'] = "ViewCatalogMenuChanges";
        AppResourceSetEnum[AppResourceSetEnum["PublishCatalogMenuChanges"] = 'PublishCatalogMenuChanges'] = "PublishCatalogMenuChanges";
        AppResourceSetEnum[AppResourceSetEnum["ViewAppStatistics"] = 'ViewAppStatistics'] = "ViewAppStatistics";
        AppResourceSetEnum[AppResourceSetEnum["ViewApmStatistics"] = 'ViewApmStatistics'] = "ViewApmStatistics";
        AppResourceSetEnum[AppResourceSetEnum["ViewCampaignsStatistics"] = 'ViewCampaignsStatistics'] = "ViewCampaignsStatistics";
        AppResourceSetEnum[AppResourceSetEnum["ViewCustomerStatistics"] = 'ViewCustomerStatistics'] = "ViewCustomerStatistics";
        AppResourceSetEnum[AppResourceSetEnum["ViewLiveStatistics"] = 'ViewLiveStatistics'] = "ViewLiveStatistics";
        AppResourceSetEnum[AppResourceSetEnum["ViewOrderStatistics"] = 'ViewOrderStatistics'] = "ViewOrderStatistics";
        AppResourceSetEnum[AppResourceSetEnum["ViewSalesStatistics"] = 'ViewSalesStatistics'] = "ViewSalesStatistics";
        AppResourceSetEnum[AppResourceSetEnum["ViewSalesEndOfDayStatistics"] = 'ViewSalesEndOfDayStatistics'] = "ViewSalesEndOfDayStatistics";
        AppResourceSetEnum[AppResourceSetEnum["ViewVouchersStatistics"] = 'ViewVouchersStatistics'] = "ViewVouchersStatistics";
        AppResourceSetEnum[AppResourceSetEnum["DownloadCustomerCsvExport"] = 'DownloadCustomerCsvExport'] = "DownloadCustomerCsvExport";
        AppResourceSetEnum[AppResourceSetEnum["ViewApmAuditLogs"] = 'ViewApmAuditLogs'] = "ViewApmAuditLogs";
        AppResourceSetEnum[AppResourceSetEnum["ViewStoreAuditLogs"] = 'ViewStoreAuditLogs'] = "ViewStoreAuditLogs";
        AppResourceSetEnum[AppResourceSetEnum["ViewMenuAuditLogs"] = 'ViewMenuAuditLogs'] = "ViewMenuAuditLogs";
        AppResourceSetEnum[AppResourceSetEnum["ViewBankAccountAuditLogs"] = 'ViewBankAccountAuditLogs'] = "ViewBankAccountAuditLogs";
        AppResourceSetEnum[AppResourceSetEnum["ViewFeeConfigurationsAuditLogs"] = 'ViewFeeConfigurationsAuditLogs'] = "ViewFeeConfigurationsAuditLogs";
        AppResourceSetEnum[AppResourceSetEnum["ViewOrdersAuditLogs"] = 'ViewOrdersAuditLogs'] = "ViewOrdersAuditLogs";
        AppResourceSetEnum[AppResourceSetEnum["ViewVouchersAuditLogs"] = 'ViewVouchersAuditLogs'] = "ViewVouchersAuditLogs";
        AppResourceSetEnum[AppResourceSetEnum["ViewUserEventsAuditLogs"] = 'ViewUserEventsAuditLogs'] = "ViewUserEventsAuditLogs";
        AppResourceSetEnum[AppResourceSetEnum["ViewCampaignsAuditLogs"] = 'ViewCampaignsAuditLogs'] = "ViewCampaignsAuditLogs";
        AppResourceSetEnum[AppResourceSetEnum["ViewTeammatesAuditLogs"] = 'ViewTeammatesAuditLogs'] = "ViewTeammatesAuditLogs";
        AppResourceSetEnum[AppResourceSetEnum["ViewAppAuditLogs"] = 'ViewAppAuditLogs'] = "ViewAppAuditLogs";
        AppResourceSetEnum[AppResourceSetEnum["ViewCustomerAuditLogs"] = 'ViewCustomerAuditLogs'] = "ViewCustomerAuditLogs";
        AppResourceSetEnum[AppResourceSetEnum["ViewPrinterAuditLogs"] = 'ViewPrinterAuditLogs'] = "ViewPrinterAuditLogs";
        AppResourceSetEnum[AppResourceSetEnum["ViewHydraAuditLogs"] = 'ViewHydraAuditLogs'] = "ViewHydraAuditLogs";
        AppResourceSetEnum[AppResourceSetEnum["ViewPushNotificationAuditLogs"] = 'ViewPushNotificationAuditLogs'] = "ViewPushNotificationAuditLogs";
        AppResourceSetEnum[AppResourceSetEnum["ViewStripeCustomConnectedAccountAuditLogs"] = 'ViewStripeCustomConnectedAccountAuditLogs'] = "ViewStripeCustomConnectedAccountAuditLogs";
        AppResourceSetEnum[AppResourceSetEnum["ViewKioskBluetoothDeviceAuditLogs"] = 'ViewKioskBluetoothDeviceAuditLogs'] = "ViewKioskBluetoothDeviceAuditLogs";
        AppResourceSetEnum[AppResourceSetEnum["ViewExternalAuditLogs"] = 'ViewExternalAuditLogs'] = "ViewExternalAuditLogs";
        AppResourceSetEnum[AppResourceSetEnum["CreateExternalAuditLogEvents"] = 'CreateExternalAuditLogEvents'] = "CreateExternalAuditLogEvents";
        AppResourceSetEnum[AppResourceSetEnum["ViewCatalogAuditLogs"] = 'ViewCatalogAuditLogs'] = "ViewCatalogAuditLogs";
        AppResourceSetEnum[AppResourceSetEnum["ViewOrderFulfillmentAuditLogs"] = 'ViewOrderFulfillmentAuditLogs'] = "ViewOrderFulfillmentAuditLogs";
        AppResourceSetEnum[AppResourceSetEnum["ViewChannelAuditLogs"] = 'ViewChannelAuditLogs'] = "ViewChannelAuditLogs";
        AppResourceSetEnum[AppResourceSetEnum["ViewAppStoreAuditLogs"] = 'ViewAppStoreAuditLogs'] = "ViewAppStoreAuditLogs";
        AppResourceSetEnum[AppResourceSetEnum["SendPushNotificationToCustomer"] = 'SendPushNotificationToCustomer'] = "SendPushNotificationToCustomer";
        AppResourceSetEnum[AppResourceSetEnum["InviteDriverToApp"] = 'InviteDriverToApp'] = "InviteDriverToApp";
        AppResourceSetEnum[AppResourceSetEnum["GetDriverForApp"] = 'GetDriverForApp'] = "GetDriverForApp";
        AppResourceSetEnum[AppResourceSetEnum["RemoveDriverFromApp"] = 'RemoveDriverFromApp'] = "RemoveDriverFromApp";
        AppResourceSetEnum[AppResourceSetEnum["AssignDriverToOrder"] = 'AssignDriverToOrder'] = "AssignDriverToOrder";
        AppResourceSetEnum[AppResourceSetEnum["UnassignDriverFromOrder"] = 'UnassignDriverFromOrder'] = "UnassignDriverFromOrder";
        AppResourceSetEnum[AppResourceSetEnum["UpdateOrdersDeliveryTrackingStatus"] = 'UpdateOrdersDeliveryTrackingStatus'] = "UpdateOrdersDeliveryTrackingStatus";
        AppResourceSetEnum[AppResourceSetEnum["UpdateOrderFulfillmentStatus"] = 'UpdateOrderFulfillmentStatus'] = "UpdateOrderFulfillmentStatus";
        AppResourceSetEnum[AppResourceSetEnum["ViewFulfillmentStatesConfiguration"] = 'ViewFulfillmentStatesConfiguration'] = "ViewFulfillmentStatesConfiguration";
        AppResourceSetEnum[AppResourceSetEnum["CreateFulfillmentStatesConfiguration"] = 'CreateFulfillmentStatesConfiguration'] = "CreateFulfillmentStatesConfiguration";
        AppResourceSetEnum[AppResourceSetEnum["UpdateFulfillmentStatesConfiguration"] = 'UpdateFulfillmentStatesConfiguration'] = "UpdateFulfillmentStatesConfiguration";
        AppResourceSetEnum[AppResourceSetEnum["DeleteFulfillmentStatesConfiguration"] = 'DeleteFulfillmentStatesConfiguration'] = "DeleteFulfillmentStatesConfiguration";
        AppResourceSetEnum[AppResourceSetEnum["ViewPayouts"] = 'ViewPayouts'] = "ViewPayouts";
        AppResourceSetEnum[AppResourceSetEnum["ViewChannels"] = 'ViewChannels'] = "ViewChannels";
        AppResourceSetEnum[AppResourceSetEnum["ViewOnboarding"] = 'ViewOnboarding'] = "ViewOnboarding";
        AppResourceSetEnum[AppResourceSetEnum["UpdateOnboarding"] = 'UpdateOnboarding'] = "UpdateOnboarding";
        AppResourceSetEnum[AppResourceSetEnum["ViewClientDevices"] = 'ViewClientDevices'] = "ViewClientDevices";
        AppResourceSetEnum[AppResourceSetEnum["UpdateClientDevices"] = 'UpdateClientDevices'] = "UpdateClientDevices";
        AppResourceSetEnum[AppResourceSetEnum["EnrollClientDevices"] = 'EnrollClientDevices'] = "EnrollClientDevices";
        AppResourceSetEnum[AppResourceSetEnum["AssignClientDevices"] = 'AssignClientDevices'] = "AssignClientDevices";
        AppResourceSetEnum[AppResourceSetEnum["ViewClientAuditLogs"] = 'ViewClientAuditLogs'] = "ViewClientAuditLogs";
        AppResourceSetEnum[AppResourceSetEnum["CreateAppStoreAppConfiguration"] = 'CreateAppStoreAppConfiguration'] = "CreateAppStoreAppConfiguration";
        AppResourceSetEnum[AppResourceSetEnum["ViewAppStoreAppConfiguration"] = 'ViewAppStoreAppConfiguration'] = "ViewAppStoreAppConfiguration";
        AppResourceSetEnum[AppResourceSetEnum["UpdateAppStoreAppConfiguration"] = 'UpdateAppStoreAppConfiguration'] = "UpdateAppStoreAppConfiguration";
        AppResourceSetEnum[AppResourceSetEnum["DeleteAppStoreAppConfiguration"] = 'DeleteAppStoreAppConfiguration'] = "DeleteAppStoreAppConfiguration";
        AppResourceSetEnum[AppResourceSetEnum["UpdateAppStoreAppConfigurationSettings"] = 'UpdateAppStoreAppConfigurationSettings'] = "UpdateAppStoreAppConfigurationSettings";
        AppResourceSetEnum[AppResourceSetEnum["CreateAppStoreSubscription"] = 'CreateAppStoreSubscription'] = "CreateAppStoreSubscription";
        AppResourceSetEnum[AppResourceSetEnum["UpdateAppStoreSubscription"] = 'UpdateAppStoreSubscription'] = "UpdateAppStoreSubscription";
        AppResourceSetEnum[AppResourceSetEnum["DeleteAppStoreSubscription"] = 'DeleteAppStoreSubscription'] = "DeleteAppStoreSubscription";
        AppResourceSetEnum[AppResourceSetEnum["ViewSalesChannels"] = 'ViewSalesChannels'] = "ViewSalesChannels";
        AppResourceSetEnum[AppResourceSetEnum["EditSalesChannels"] = 'EditSalesChannels'] = "EditSalesChannels";
        AppResourceSetEnum[AppResourceSetEnum["ViewPayGreenWhiteLabelConfiguration"] = 'ViewPayGreenWhiteLabelConfiguration'] = "ViewPayGreenWhiteLabelConfiguration";
        AppResourceSetEnum[AppResourceSetEnum["CreatePayGreenWhiteLabelConfiguration"] = 'CreatePayGreenWhiteLabelConfiguration'] = "CreatePayGreenWhiteLabelConfiguration";
        AppResourceSetEnum[AppResourceSetEnum["UpdatePayGreenWhiteLabelConfiguration"] = 'UpdatePayGreenWhiteLabelConfiguration'] = "UpdatePayGreenWhiteLabelConfiguration";
        AppResourceSetEnum[AppResourceSetEnum["UpdatePayGreenStoreConfiguration"] = 'UpdatePayGreenStoreConfiguration'] = "UpdatePayGreenStoreConfiguration";
        AppResourceSetEnum[AppResourceSetEnum["ViewSubscriptions"] = 'ViewSubscriptions'] = "ViewSubscriptions";
        AppResourceSetEnum[AppResourceSetEnum["ViewInvoices"] = 'ViewInvoices'] = "ViewInvoices";
        AppResourceSetEnum[AppResourceSetEnum["EditAccountsBills"] = 'EditAccountsBills'] = "EditAccountsBills";
        AppResourceSetEnum[AppResourceSetEnum["ViewAccountsBills"] = 'ViewAccountsBills'] = "ViewAccountsBills";
        AppResourceSetEnum[AppResourceSetEnum["EditAccountsCategories"] = 'EditAccountsCategories'] = "EditAccountsCategories";
        AppResourceSetEnum[AppResourceSetEnum["ViewAccountsCategories"] = 'ViewAccountsCategories'] = "ViewAccountsCategories";
        AppResourceSetEnum[AppResourceSetEnum["EditAccountsCreditAccounts"] = 'EditAccountsCreditAccounts'] = "EditAccountsCreditAccounts";
        AppResourceSetEnum[AppResourceSetEnum["ViewAccountsCreditAccounts"] = 'ViewAccountsCreditAccounts'] = "ViewAccountsCreditAccounts";
        AppResourceSetEnum[AppResourceSetEnum["EditAccountsCreditBooks"] = 'EditAccountsCreditBooks'] = "EditAccountsCreditBooks";
        AppResourceSetEnum[AppResourceSetEnum["ViewAccountsCreditBooks"] = 'ViewAccountsCreditBooks'] = "ViewAccountsCreditBooks";
        AppResourceSetEnum[AppResourceSetEnum["EditAccountsExpenses"] = 'EditAccountsExpenses'] = "EditAccountsExpenses";
        AppResourceSetEnum[AppResourceSetEnum["ViewAccountsExpenses"] = 'ViewAccountsExpenses'] = "ViewAccountsExpenses";
        AppResourceSetEnum[AppResourceSetEnum["EditAccountsTransactionAccounts"] = 'EditAccountsTransactionAccounts'] = "EditAccountsTransactionAccounts";
        AppResourceSetEnum[AppResourceSetEnum["ViewAccountsTransactionAccounts"] = 'ViewAccountsTransactionAccounts'] = "ViewAccountsTransactionAccounts";
        AppResourceSetEnum[AppResourceSetEnum["EditDocumentExplorer"] = 'EditDocumentExplorer'] = "EditDocumentExplorer";
        AppResourceSetEnum[AppResourceSetEnum["ViewDocumentExplorer"] = 'ViewDocumentExplorer'] = "ViewDocumentExplorer";
        AppResourceSetEnum[AppResourceSetEnum["ViewInventoryReports"] = 'ViewInventoryReports'] = "ViewInventoryReports";
        AppResourceSetEnum[AppResourceSetEnum["EditInventoryPurchaseOrders"] = 'EditInventoryPurchaseOrders'] = "EditInventoryPurchaseOrders";
        AppResourceSetEnum[AppResourceSetEnum["ViewInventoryPurchaseOrders"] = 'ViewInventoryPurchaseOrders'] = "ViewInventoryPurchaseOrders";
        AppResourceSetEnum[AppResourceSetEnum["EditInventoryStockItems"] = 'EditInventoryStockItems'] = "EditInventoryStockItems";
        AppResourceSetEnum[AppResourceSetEnum["ViewInventoryStockItems"] = 'ViewInventoryStockItems'] = "ViewInventoryStockItems";
        AppResourceSetEnum[AppResourceSetEnum["EditInventorySupplier"] = 'EditInventorySupplier'] = "EditInventorySupplier";
        AppResourceSetEnum[AppResourceSetEnum["ViewInventorySupplier"] = 'ViewInventorySupplier'] = "ViewInventorySupplier";
        AppResourceSetEnum[AppResourceSetEnum["EditInventoryTrackingProfiles"] = 'EditInventoryTrackingProfiles'] = "EditInventoryTrackingProfiles";
        AppResourceSetEnum[AppResourceSetEnum["ViewInventoryTrackingProfiles"] = 'ViewInventoryTrackingProfiles'] = "ViewInventoryTrackingProfiles";
        AppResourceSetEnum[AppResourceSetEnum["ViewPayrollReports"] = 'ViewPayrollReports'] = "ViewPayrollReports";
        AppResourceSetEnum[AppResourceSetEnum["EditPayrollHoliday"] = 'EditPayrollHoliday'] = "EditPayrollHoliday";
        AppResourceSetEnum[AppResourceSetEnum["ViewPayrollHoliday"] = 'ViewPayrollHoliday'] = "ViewPayrollHoliday";
        AppResourceSetEnum[AppResourceSetEnum["EditPayrollRota"] = 'EditPayrollRota'] = "EditPayrollRota";
        AppResourceSetEnum[AppResourceSetEnum["ViewPayrollRota"] = 'ViewPayrollRota'] = "ViewPayrollRota";
        AppResourceSetEnum[AppResourceSetEnum["EditPayrollStaff"] = 'EditPayrollStaff'] = "EditPayrollStaff";
        AppResourceSetEnum[AppResourceSetEnum["ViewPayrollStaff"] = 'ViewPayrollStaff'] = "ViewPayrollStaff";
        AppResourceSetEnum[AppResourceSetEnum["ViewSalesReports"] = 'ViewSalesReports'] = "ViewSalesReports";
        AppResourceSetEnum[AppResourceSetEnum["ViewCostReports"] = 'ViewCostReports'] = "ViewCostReports";
        AppResourceSetEnum[AppResourceSetEnum["ViewMenuReports"] = 'ViewMenuReports'] = "ViewMenuReports";
    })(AppResourceSetEnum = App.AppResourceSetEnum || (App.AppResourceSetEnum = {}));
    var WebToAppRedirectEnum;
    (function (WebToAppRedirectEnum) {
        WebToAppRedirectEnum[WebToAppRedirectEnum["NoRedirect"] = 'NoRedirect'] = "NoRedirect";
        WebToAppRedirectEnum[WebToAppRedirectEnum["RedirectOnce"] = 'RedirectOnce'] = "RedirectOnce";
        WebToAppRedirectEnum[WebToAppRedirectEnum["RedirectAlways"] = 'RedirectAlways'] = "RedirectAlways";
        WebToAppRedirectEnum[WebToAppRedirectEnum["SuggestPwa"] = 'SuggestPwa'] = "SuggestPwa";
        WebToAppRedirectEnum[WebToAppRedirectEnum["ForcePwa"] = 'ForcePwa'] = "ForcePwa";
    })(WebToAppRedirectEnum = App.WebToAppRedirectEnum || (App.WebToAppRedirectEnum = {}));
    var ApplicationCategoryEnum;
    (function (ApplicationCategoryEnum) {
        ApplicationCategoryEnum[ApplicationCategoryEnum["Restaurant"] = 'Restaurant'] = "Restaurant";
        ApplicationCategoryEnum[ApplicationCategoryEnum["Cafe"] = 'Cafe'] = "Cafe";
        ApplicationCategoryEnum[ApplicationCategoryEnum["Convenience"] = 'Convenience'] = "Convenience";
    })(ApplicationCategoryEnum = App.ApplicationCategoryEnum || (App.ApplicationCategoryEnum = {}));
})(App || (exports.App = App = {}));
var AppCompliance;
(function (AppCompliance) {
    var ComplianceTypeEnum;
    (function (ComplianceTypeEnum) {
        ComplianceTypeEnum[ComplianceTypeEnum["Default"] = 'Default'] = "Default";
        ComplianceTypeEnum[ComplianceTypeEnum["GdprCompliance"] = 'GdprCompliance'] = "GdprCompliance";
    })(ComplianceTypeEnum = AppCompliance.ComplianceTypeEnum || (AppCompliance.ComplianceTypeEnum = {}));
})(AppCompliance || (exports.AppCompliance = AppCompliance = {}));
var AppConfigSalesChannel;
(function (AppConfigSalesChannel) {
    var EmailRequestModeEnum;
    (function (EmailRequestModeEnum) {
        EmailRequestModeEnum[EmailRequestModeEnum["DoNotRequest"] = 'DoNotRequest'] = "DoNotRequest";
        EmailRequestModeEnum[EmailRequestModeEnum["Request"] = 'Request'] = "Request";
        EmailRequestModeEnum[EmailRequestModeEnum["Require"] = 'Require'] = "Require";
    })(EmailRequestModeEnum = AppConfigSalesChannel.EmailRequestModeEnum || (AppConfigSalesChannel.EmailRequestModeEnum = {}));
    var WebToAppRedirectEnum;
    (function (WebToAppRedirectEnum) {
        WebToAppRedirectEnum[WebToAppRedirectEnum["NoRedirect"] = 'NoRedirect'] = "NoRedirect";
        WebToAppRedirectEnum[WebToAppRedirectEnum["RedirectOnce"] = 'RedirectOnce'] = "RedirectOnce";
        WebToAppRedirectEnum[WebToAppRedirectEnum["RedirectAlways"] = 'RedirectAlways'] = "RedirectAlways";
        WebToAppRedirectEnum[WebToAppRedirectEnum["SuggestPwa"] = 'SuggestPwa'] = "SuggestPwa";
        WebToAppRedirectEnum[WebToAppRedirectEnum["ForcePwa"] = 'ForcePwa'] = "ForcePwa";
    })(WebToAppRedirectEnum = AppConfigSalesChannel.WebToAppRedirectEnum || (AppConfigSalesChannel.WebToAppRedirectEnum = {}));
    var AddressEntryTypeEnum;
    (function (AddressEntryTypeEnum) {
        AddressEntryTypeEnum[AddressEntryTypeEnum["MapFirst"] = 'MapFirst'] = "MapFirst";
        AddressEntryTypeEnum[AddressEntryTypeEnum["TextEntryManualAllowed"] = 'TextEntryManualAllowed'] = "TextEntryManualAllowed";
        AddressEntryTypeEnum[AddressEntryTypeEnum["TextEntryManualDisallowed"] = 'TextEntryManualDisallowed'] = "TextEntryManualDisallowed";
    })(AddressEntryTypeEnum = AppConfigSalesChannel.AddressEntryTypeEnum || (AppConfigSalesChannel.AddressEntryTypeEnum = {}));
})(AppConfigSalesChannel || (exports.AppConfigSalesChannel = AppConfigSalesChannel = {}));
var AppConfigUpdateModel;
(function (AppConfigUpdateModel) {
    var ApplicationCategoryEnum;
    (function (ApplicationCategoryEnum) {
        ApplicationCategoryEnum[ApplicationCategoryEnum["Restaurant"] = 'Restaurant'] = "Restaurant";
        ApplicationCategoryEnum[ApplicationCategoryEnum["Cafe"] = 'Cafe'] = "Cafe";
        ApplicationCategoryEnum[ApplicationCategoryEnum["Convenience"] = 'Convenience'] = "Convenience";
    })(ApplicationCategoryEnum = AppConfigUpdateModel.ApplicationCategoryEnum || (AppConfigUpdateModel.ApplicationCategoryEnum = {}));
})(AppConfigUpdateModel || (exports.AppConfigUpdateModel = AppConfigUpdateModel = {}));
var AppStoreApp;
(function (AppStoreApp) {
    var VerificationStatusEnum;
    (function (VerificationStatusEnum) {
        VerificationStatusEnum[VerificationStatusEnum["Draft"] = 'Draft'] = "Draft";
        VerificationStatusEnum[VerificationStatusEnum["Submitted"] = 'Submitted'] = "Submitted";
        VerificationStatusEnum[VerificationStatusEnum["Verified"] = 'Verified'] = "Verified";
    })(VerificationStatusEnum = AppStoreApp.VerificationStatusEnum || (AppStoreApp.VerificationStatusEnum = {}));
    var ConfigurationTypeEnum;
    (function (ConfigurationTypeEnum) {
        ConfigurationTypeEnum[ConfigurationTypeEnum["ExternalLink"] = 'ExternalLink'] = "ExternalLink";
        ConfigurationTypeEnum[ConfigurationTypeEnum["FlipdishHosted"] = 'FlipdishHosted'] = "FlipdishHosted";
    })(ConfigurationTypeEnum = AppStoreApp.ConfigurationTypeEnum || (AppStoreApp.ConfigurationTypeEnum = {}));
    var StoreSelectorTypeEnum;
    (function (StoreSelectorTypeEnum) {
        StoreSelectorTypeEnum[StoreSelectorTypeEnum["None"] = 'None'] = "None";
        StoreSelectorTypeEnum[StoreSelectorTypeEnum["Single"] = 'Single'] = "Single";
        StoreSelectorTypeEnum[StoreSelectorTypeEnum["Multiple"] = 'Multiple'] = "Multiple";
    })(StoreSelectorTypeEnum = AppStoreApp.StoreSelectorTypeEnum || (AppStoreApp.StoreSelectorTypeEnum = {}));
    var TeammateAppAccessLevelEnum;
    (function (TeammateAppAccessLevelEnum) {
        TeammateAppAccessLevelEnum[TeammateAppAccessLevelEnum["Owner"] = 'Owner'] = "Owner";
        TeammateAppAccessLevelEnum[TeammateAppAccessLevelEnum["StoreOwner"] = 'StoreOwner'] = "StoreOwner";
        TeammateAppAccessLevelEnum[TeammateAppAccessLevelEnum["PropertyOwner"] = 'PropertyOwner'] = "PropertyOwner";
        TeammateAppAccessLevelEnum[TeammateAppAccessLevelEnum["ManagedOwner"] = 'ManagedOwner'] = "ManagedOwner";
        TeammateAppAccessLevelEnum[TeammateAppAccessLevelEnum["Integrator"] = 'Integrator'] = "Integrator";
        TeammateAppAccessLevelEnum[TeammateAppAccessLevelEnum["PropertyManager"] = 'PropertyManager'] = "PropertyManager";
        TeammateAppAccessLevelEnum[TeammateAppAccessLevelEnum["StoreManager"] = 'StoreManager'] = "StoreManager";
        TeammateAppAccessLevelEnum[TeammateAppAccessLevelEnum["StoreStaff"] = 'StoreStaff'] = "StoreStaff";
        TeammateAppAccessLevelEnum[TeammateAppAccessLevelEnum["StaffMember"] = 'StaffMember'] = "StaffMember";
        TeammateAppAccessLevelEnum[TeammateAppAccessLevelEnum["StoreReadOnlyAccess"] = 'StoreReadOnlyAccess'] = "StoreReadOnlyAccess";
        TeammateAppAccessLevelEnum[TeammateAppAccessLevelEnum["FinanceManger"] = 'FinanceManger'] = "FinanceManger";
    })(TeammateAppAccessLevelEnum = AppStoreApp.TeammateAppAccessLevelEnum || (AppStoreApp.TeammateAppAccessLevelEnum = {}));
    var PermissionsTypeEnum;
    (function (PermissionsTypeEnum) {
        PermissionsTypeEnum[PermissionsTypeEnum["Teammate"] = 'Teammate'] = "Teammate";
    })(PermissionsTypeEnum = AppStoreApp.PermissionsTypeEnum || (AppStoreApp.PermissionsTypeEnum = {}));
    var CategoriesEnum;
    (function (CategoriesEnum) {
        CategoriesEnum[CategoriesEnum["PointOfSale"] = 'PointOfSale'] = "PointOfSale";
        CategoriesEnum[CategoriesEnum["DeliveryAndLogistics"] = 'DeliveryAndLogistics'] = "DeliveryAndLogistics";
        CategoriesEnum[CategoriesEnum["CRM"] = 'CRM'] = "CRM";
        CategoriesEnum[CategoriesEnum["GiftCard"] = 'GiftCard'] = "GiftCard";
        CategoriesEnum[CategoriesEnum["Accounting"] = 'Accounting'] = "Accounting";
        CategoriesEnum[CategoriesEnum["LoyaltyAndMarketing"] = 'LoyaltyAndMarketing'] = "LoyaltyAndMarketing";
        CategoriesEnum[CategoriesEnum["Other"] = 'Other'] = "Other";
    })(CategoriesEnum = AppStoreApp.CategoriesEnum || (AppStoreApp.CategoriesEnum = {}));
    var CountriesEnum;
    (function (CountriesEnum) {
        CountriesEnum[CountriesEnum["GB"] = 'GB'] = "GB";
        CountriesEnum[CountriesEnum["IE"] = 'IE'] = "IE";
        CountriesEnum[CountriesEnum["FR"] = 'FR'] = "FR";
        CountriesEnum[CountriesEnum["ES"] = 'ES'] = "ES";
        CountriesEnum[CountriesEnum["PT"] = 'PT'] = "PT";
        CountriesEnum[CountriesEnum["IT"] = 'IT'] = "IT";
        CountriesEnum[CountriesEnum["DE"] = 'DE'] = "DE";
        CountriesEnum[CountriesEnum["PL"] = 'PL'] = "PL";
        CountriesEnum[CountriesEnum["BE"] = 'BE'] = "BE";
        CountriesEnum[CountriesEnum["LU"] = 'LU'] = "LU";
        CountriesEnum[CountriesEnum["NL"] = 'NL'] = "NL";
        CountriesEnum[CountriesEnum["US"] = 'US'] = "US";
        CountriesEnum[CountriesEnum["CA"] = 'CA'] = "CA";
        CountriesEnum[CountriesEnum["BG"] = 'BG'] = "BG";
        CountriesEnum[CountriesEnum["MX"] = 'MX'] = "MX";
        CountriesEnum[CountriesEnum["AU"] = 'AU'] = "AU";
        CountriesEnum[CountriesEnum["NZ"] = 'NZ'] = "NZ";
    })(CountriesEnum = AppStoreApp.CountriesEnum || (AppStoreApp.CountriesEnum = {}));
})(AppStoreApp || (exports.AppStoreApp = AppStoreApp = {}));
var AppStoreAppConfiguration;
(function (AppStoreAppConfiguration) {
    var VerificationStatusEnum;
    (function (VerificationStatusEnum) {
        VerificationStatusEnum[VerificationStatusEnum["Draft"] = 'Draft'] = "Draft";
        VerificationStatusEnum[VerificationStatusEnum["Submitted"] = 'Submitted'] = "Submitted";
        VerificationStatusEnum[VerificationStatusEnum["Verified"] = 'Verified'] = "Verified";
    })(VerificationStatusEnum = AppStoreAppConfiguration.VerificationStatusEnum || (AppStoreAppConfiguration.VerificationStatusEnum = {}));
    var ConfigurationTypeEnum;
    (function (ConfigurationTypeEnum) {
        ConfigurationTypeEnum[ConfigurationTypeEnum["ExternalLink"] = 'ExternalLink'] = "ExternalLink";
        ConfigurationTypeEnum[ConfigurationTypeEnum["FlipdishHosted"] = 'FlipdishHosted'] = "FlipdishHosted";
    })(ConfigurationTypeEnum = AppStoreAppConfiguration.ConfigurationTypeEnum || (AppStoreAppConfiguration.ConfigurationTypeEnum = {}));
    var StoreSelectorTypeEnum;
    (function (StoreSelectorTypeEnum) {
        StoreSelectorTypeEnum[StoreSelectorTypeEnum["None"] = 'None'] = "None";
        StoreSelectorTypeEnum[StoreSelectorTypeEnum["Single"] = 'Single'] = "Single";
        StoreSelectorTypeEnum[StoreSelectorTypeEnum["Multiple"] = 'Multiple'] = "Multiple";
    })(StoreSelectorTypeEnum = AppStoreAppConfiguration.StoreSelectorTypeEnum || (AppStoreAppConfiguration.StoreSelectorTypeEnum = {}));
    var TeammateAppAccessLevelEnum;
    (function (TeammateAppAccessLevelEnum) {
        TeammateAppAccessLevelEnum[TeammateAppAccessLevelEnum["Owner"] = 'Owner'] = "Owner";
        TeammateAppAccessLevelEnum[TeammateAppAccessLevelEnum["StoreOwner"] = 'StoreOwner'] = "StoreOwner";
        TeammateAppAccessLevelEnum[TeammateAppAccessLevelEnum["PropertyOwner"] = 'PropertyOwner'] = "PropertyOwner";
        TeammateAppAccessLevelEnum[TeammateAppAccessLevelEnum["ManagedOwner"] = 'ManagedOwner'] = "ManagedOwner";
        TeammateAppAccessLevelEnum[TeammateAppAccessLevelEnum["Integrator"] = 'Integrator'] = "Integrator";
        TeammateAppAccessLevelEnum[TeammateAppAccessLevelEnum["PropertyManager"] = 'PropertyManager'] = "PropertyManager";
        TeammateAppAccessLevelEnum[TeammateAppAccessLevelEnum["StoreManager"] = 'StoreManager'] = "StoreManager";
        TeammateAppAccessLevelEnum[TeammateAppAccessLevelEnum["StoreStaff"] = 'StoreStaff'] = "StoreStaff";
        TeammateAppAccessLevelEnum[TeammateAppAccessLevelEnum["StaffMember"] = 'StaffMember'] = "StaffMember";
        TeammateAppAccessLevelEnum[TeammateAppAccessLevelEnum["StoreReadOnlyAccess"] = 'StoreReadOnlyAccess'] = "StoreReadOnlyAccess";
        TeammateAppAccessLevelEnum[TeammateAppAccessLevelEnum["FinanceManger"] = 'FinanceManger'] = "FinanceManger";
    })(TeammateAppAccessLevelEnum = AppStoreAppConfiguration.TeammateAppAccessLevelEnum || (AppStoreAppConfiguration.TeammateAppAccessLevelEnum = {}));
    var PermissionsTypeEnum;
    (function (PermissionsTypeEnum) {
        PermissionsTypeEnum[PermissionsTypeEnum["Teammate"] = 'Teammate'] = "Teammate";
    })(PermissionsTypeEnum = AppStoreAppConfiguration.PermissionsTypeEnum || (AppStoreAppConfiguration.PermissionsTypeEnum = {}));
    var CategoriesEnum;
    (function (CategoriesEnum) {
        CategoriesEnum[CategoriesEnum["PointOfSale"] = 'PointOfSale'] = "PointOfSale";
        CategoriesEnum[CategoriesEnum["DeliveryAndLogistics"] = 'DeliveryAndLogistics'] = "DeliveryAndLogistics";
        CategoriesEnum[CategoriesEnum["CRM"] = 'CRM'] = "CRM";
        CategoriesEnum[CategoriesEnum["GiftCard"] = 'GiftCard'] = "GiftCard";
        CategoriesEnum[CategoriesEnum["Accounting"] = 'Accounting'] = "Accounting";
        CategoriesEnum[CategoriesEnum["LoyaltyAndMarketing"] = 'LoyaltyAndMarketing'] = "LoyaltyAndMarketing";
        CategoriesEnum[CategoriesEnum["Other"] = 'Other'] = "Other";
    })(CategoriesEnum = AppStoreAppConfiguration.CategoriesEnum || (AppStoreAppConfiguration.CategoriesEnum = {}));
    var CountriesEnum;
    (function (CountriesEnum) {
        CountriesEnum[CountriesEnum["GB"] = 'GB'] = "GB";
        CountriesEnum[CountriesEnum["IE"] = 'IE'] = "IE";
        CountriesEnum[CountriesEnum["FR"] = 'FR'] = "FR";
        CountriesEnum[CountriesEnum["ES"] = 'ES'] = "ES";
        CountriesEnum[CountriesEnum["PT"] = 'PT'] = "PT";
        CountriesEnum[CountriesEnum["IT"] = 'IT'] = "IT";
        CountriesEnum[CountriesEnum["DE"] = 'DE'] = "DE";
        CountriesEnum[CountriesEnum["PL"] = 'PL'] = "PL";
        CountriesEnum[CountriesEnum["BE"] = 'BE'] = "BE";
        CountriesEnum[CountriesEnum["LU"] = 'LU'] = "LU";
        CountriesEnum[CountriesEnum["NL"] = 'NL'] = "NL";
        CountriesEnum[CountriesEnum["US"] = 'US'] = "US";
        CountriesEnum[CountriesEnum["CA"] = 'CA'] = "CA";
        CountriesEnum[CountriesEnum["BG"] = 'BG'] = "BG";
        CountriesEnum[CountriesEnum["MX"] = 'MX'] = "MX";
        CountriesEnum[CountriesEnum["AU"] = 'AU'] = "AU";
        CountriesEnum[CountriesEnum["NZ"] = 'NZ'] = "NZ";
    })(CountriesEnum = AppStoreAppConfiguration.CountriesEnum || (AppStoreAppConfiguration.CountriesEnum = {}));
})(AppStoreAppConfiguration || (exports.AppStoreAppConfiguration = AppStoreAppConfiguration = {}));
var AppStoreAppConfigurationSummary;
(function (AppStoreAppConfigurationSummary) {
    var ConfigurationTypeEnum;
    (function (ConfigurationTypeEnum) {
        ConfigurationTypeEnum[ConfigurationTypeEnum["ExternalLink"] = 'ExternalLink'] = "ExternalLink";
        ConfigurationTypeEnum[ConfigurationTypeEnum["FlipdishHosted"] = 'FlipdishHosted'] = "FlipdishHosted";
    })(ConfigurationTypeEnum = AppStoreAppConfigurationSummary.ConfigurationTypeEnum || (AppStoreAppConfigurationSummary.ConfigurationTypeEnum = {}));
    var StoreSelectorTypeEnum;
    (function (StoreSelectorTypeEnum) {
        StoreSelectorTypeEnum[StoreSelectorTypeEnum["None"] = 'None'] = "None";
        StoreSelectorTypeEnum[StoreSelectorTypeEnum["Single"] = 'Single'] = "Single";
        StoreSelectorTypeEnum[StoreSelectorTypeEnum["Multiple"] = 'Multiple'] = "Multiple";
    })(StoreSelectorTypeEnum = AppStoreAppConfigurationSummary.StoreSelectorTypeEnum || (AppStoreAppConfigurationSummary.StoreSelectorTypeEnum = {}));
})(AppStoreAppConfigurationSummary || (exports.AppStoreAppConfigurationSummary = AppStoreAppConfigurationSummary = {}));
var AppStoreAppSummary;
(function (AppStoreAppSummary) {
    var VerificationStatusEnum;
    (function (VerificationStatusEnum) {
        VerificationStatusEnum[VerificationStatusEnum["Draft"] = 'Draft'] = "Draft";
        VerificationStatusEnum[VerificationStatusEnum["Submitted"] = 'Submitted'] = "Submitted";
        VerificationStatusEnum[VerificationStatusEnum["Verified"] = 'Verified'] = "Verified";
    })(VerificationStatusEnum = AppStoreAppSummary.VerificationStatusEnum || (AppStoreAppSummary.VerificationStatusEnum = {}));
    var CategoriesEnum;
    (function (CategoriesEnum) {
        CategoriesEnum[CategoriesEnum["PointOfSale"] = 'PointOfSale'] = "PointOfSale";
        CategoriesEnum[CategoriesEnum["DeliveryAndLogistics"] = 'DeliveryAndLogistics'] = "DeliveryAndLogistics";
        CategoriesEnum[CategoriesEnum["CRM"] = 'CRM'] = "CRM";
        CategoriesEnum[CategoriesEnum["GiftCard"] = 'GiftCard'] = "GiftCard";
        CategoriesEnum[CategoriesEnum["Accounting"] = 'Accounting'] = "Accounting";
        CategoriesEnum[CategoriesEnum["LoyaltyAndMarketing"] = 'LoyaltyAndMarketing'] = "LoyaltyAndMarketing";
        CategoriesEnum[CategoriesEnum["Other"] = 'Other'] = "Other";
    })(CategoriesEnum = AppStoreAppSummary.CategoriesEnum || (AppStoreAppSummary.CategoriesEnum = {}));
    var CountriesEnum;
    (function (CountriesEnum) {
        CountriesEnum[CountriesEnum["GB"] = 'GB'] = "GB";
        CountriesEnum[CountriesEnum["IE"] = 'IE'] = "IE";
        CountriesEnum[CountriesEnum["FR"] = 'FR'] = "FR";
        CountriesEnum[CountriesEnum["ES"] = 'ES'] = "ES";
        CountriesEnum[CountriesEnum["PT"] = 'PT'] = "PT";
        CountriesEnum[CountriesEnum["IT"] = 'IT'] = "IT";
        CountriesEnum[CountriesEnum["DE"] = 'DE'] = "DE";
        CountriesEnum[CountriesEnum["PL"] = 'PL'] = "PL";
        CountriesEnum[CountriesEnum["BE"] = 'BE'] = "BE";
        CountriesEnum[CountriesEnum["LU"] = 'LU'] = "LU";
        CountriesEnum[CountriesEnum["NL"] = 'NL'] = "NL";
        CountriesEnum[CountriesEnum["US"] = 'US'] = "US";
        CountriesEnum[CountriesEnum["CA"] = 'CA'] = "CA";
        CountriesEnum[CountriesEnum["BG"] = 'BG'] = "BG";
        CountriesEnum[CountriesEnum["MX"] = 'MX'] = "MX";
        CountriesEnum[CountriesEnum["AU"] = 'AU'] = "AU";
        CountriesEnum[CountriesEnum["NZ"] = 'NZ'] = "NZ";
    })(CountriesEnum = AppStoreAppSummary.CountriesEnum || (AppStoreAppSummary.CountriesEnum = {}));
})(AppStoreAppSummary || (exports.AppStoreAppSummary = AppStoreAppSummary = {}));
var BankAccount;
(function (BankAccount) {
    var AccountStateEnum;
    (function (AccountStateEnum) {
        AccountStateEnum[AccountStateEnum["Unverified"] = 'Unverified'] = "Unverified";
        AccountStateEnum[AccountStateEnum["AwatingVerification"] = 'AwatingVerification'] = "AwatingVerification";
        AccountStateEnum[AccountStateEnum["Verified"] = 'Verified'] = "Verified";
        AccountStateEnum[AccountStateEnum["Grandfathered"] = 'Grandfathered'] = "Grandfathered";
    })(AccountStateEnum = BankAccount.AccountStateEnum || (BankAccount.AccountStateEnum = {}));
})(BankAccount || (exports.BankAccount = BankAccount = {}));
var BankAccountCreate;
(function (BankAccountCreate) {
    var CurrencyCodeEnum;
    (function (CurrencyCodeEnum) {
        CurrencyCodeEnum[CurrencyCodeEnum["EUR"] = 'EUR'] = "EUR";
        CurrencyCodeEnum[CurrencyCodeEnum["USD"] = 'USD'] = "USD";
        CurrencyCodeEnum[CurrencyCodeEnum["GBP"] = 'GBP'] = "GBP";
        CurrencyCodeEnum[CurrencyCodeEnum["CAD"] = 'CAD'] = "CAD";
        CurrencyCodeEnum[CurrencyCodeEnum["AUD"] = 'AUD'] = "AUD";
        CurrencyCodeEnum[CurrencyCodeEnum["DJF"] = 'DJF'] = "DJF";
        CurrencyCodeEnum[CurrencyCodeEnum["ZAR"] = 'ZAR'] = "ZAR";
        CurrencyCodeEnum[CurrencyCodeEnum["ETB"] = 'ETB'] = "ETB";
        CurrencyCodeEnum[CurrencyCodeEnum["AED"] = 'AED'] = "AED";
        CurrencyCodeEnum[CurrencyCodeEnum["BHD"] = 'BHD'] = "BHD";
        CurrencyCodeEnum[CurrencyCodeEnum["DZD"] = 'DZD'] = "DZD";
        CurrencyCodeEnum[CurrencyCodeEnum["EGP"] = 'EGP'] = "EGP";
        CurrencyCodeEnum[CurrencyCodeEnum["IQD"] = 'IQD'] = "IQD";
        CurrencyCodeEnum[CurrencyCodeEnum["JOD"] = 'JOD'] = "JOD";
        CurrencyCodeEnum[CurrencyCodeEnum["KWD"] = 'KWD'] = "KWD";
        CurrencyCodeEnum[CurrencyCodeEnum["LBP"] = 'LBP'] = "LBP";
        CurrencyCodeEnum[CurrencyCodeEnum["LYD"] = 'LYD'] = "LYD";
        CurrencyCodeEnum[CurrencyCodeEnum["MAD"] = 'MAD'] = "MAD";
        CurrencyCodeEnum[CurrencyCodeEnum["OMR"] = 'OMR'] = "OMR";
        CurrencyCodeEnum[CurrencyCodeEnum["QAR"] = 'QAR'] = "QAR";
        CurrencyCodeEnum[CurrencyCodeEnum["SAR"] = 'SAR'] = "SAR";
        CurrencyCodeEnum[CurrencyCodeEnum["SYP"] = 'SYP'] = "SYP";
        CurrencyCodeEnum[CurrencyCodeEnum["TND"] = 'TND'] = "TND";
        CurrencyCodeEnum[CurrencyCodeEnum["YER"] = 'YER'] = "YER";
        CurrencyCodeEnum[CurrencyCodeEnum["CLP"] = 'CLP'] = "CLP";
        CurrencyCodeEnum[CurrencyCodeEnum["INR"] = 'INR'] = "INR";
        CurrencyCodeEnum[CurrencyCodeEnum["AZN"] = 'AZN'] = "AZN";
        CurrencyCodeEnum[CurrencyCodeEnum["RUB"] = 'RUB'] = "RUB";
        CurrencyCodeEnum[CurrencyCodeEnum["BYN"] = 'BYN'] = "BYN";
        CurrencyCodeEnum[CurrencyCodeEnum["BGN"] = 'BGN'] = "BGN";
        CurrencyCodeEnum[CurrencyCodeEnum["NGN"] = 'NGN'] = "NGN";
        CurrencyCodeEnum[CurrencyCodeEnum["BDT"] = 'BDT'] = "BDT";
        CurrencyCodeEnum[CurrencyCodeEnum["CNY"] = 'CNY'] = "CNY";
        CurrencyCodeEnum[CurrencyCodeEnum["BAM"] = 'BAM'] = "BAM";
        CurrencyCodeEnum[CurrencyCodeEnum["CZK"] = 'CZK'] = "CZK";
        CurrencyCodeEnum[CurrencyCodeEnum["DKK"] = 'DKK'] = "DKK";
        CurrencyCodeEnum[CurrencyCodeEnum["CHF"] = 'CHF'] = "CHF";
        CurrencyCodeEnum[CurrencyCodeEnum["MVR"] = 'MVR'] = "MVR";
        CurrencyCodeEnum[CurrencyCodeEnum["BTN"] = 'BTN'] = "BTN";
        CurrencyCodeEnum[CurrencyCodeEnum["XCD"] = 'XCD'] = "XCD";
        CurrencyCodeEnum[CurrencyCodeEnum["BZD"] = 'BZD'] = "BZD";
        CurrencyCodeEnum[CurrencyCodeEnum["HKD"] = 'HKD'] = "HKD";
        CurrencyCodeEnum[CurrencyCodeEnum["IDR"] = 'IDR'] = "IDR";
        CurrencyCodeEnum[CurrencyCodeEnum["JMD"] = 'JMD'] = "JMD";
        CurrencyCodeEnum[CurrencyCodeEnum["MYR"] = 'MYR'] = "MYR";
        CurrencyCodeEnum[CurrencyCodeEnum["NZD"] = 'NZD'] = "NZD";
        CurrencyCodeEnum[CurrencyCodeEnum["PHP"] = 'PHP'] = "PHP";
        CurrencyCodeEnum[CurrencyCodeEnum["SGD"] = 'SGD'] = "SGD";
        CurrencyCodeEnum[CurrencyCodeEnum["TTD"] = 'TTD'] = "TTD";
        CurrencyCodeEnum[CurrencyCodeEnum["XDR"] = 'XDR'] = "XDR";
        CurrencyCodeEnum[CurrencyCodeEnum["ARS"] = 'ARS'] = "ARS";
        CurrencyCodeEnum[CurrencyCodeEnum["BOB"] = 'BOB'] = "BOB";
        CurrencyCodeEnum[CurrencyCodeEnum["COP"] = 'COP'] = "COP";
        CurrencyCodeEnum[CurrencyCodeEnum["CRC"] = 'CRC'] = "CRC";
        CurrencyCodeEnum[CurrencyCodeEnum["CUP"] = 'CUP'] = "CUP";
        CurrencyCodeEnum[CurrencyCodeEnum["DOP"] = 'DOP'] = "DOP";
        CurrencyCodeEnum[CurrencyCodeEnum["GTQ"] = 'GTQ'] = "GTQ";
        CurrencyCodeEnum[CurrencyCodeEnum["HNL"] = 'HNL'] = "HNL";
        CurrencyCodeEnum[CurrencyCodeEnum["MXN"] = 'MXN'] = "MXN";
        CurrencyCodeEnum[CurrencyCodeEnum["NIO"] = 'NIO'] = "NIO";
        CurrencyCodeEnum[CurrencyCodeEnum["PAB"] = 'PAB'] = "PAB";
        CurrencyCodeEnum[CurrencyCodeEnum["PEN"] = 'PEN'] = "PEN";
        CurrencyCodeEnum[CurrencyCodeEnum["PYG"] = 'PYG'] = "PYG";
        CurrencyCodeEnum[CurrencyCodeEnum["UYU"] = 'UYU'] = "UYU";
        CurrencyCodeEnum[CurrencyCodeEnum["VEF"] = 'VEF'] = "VEF";
        CurrencyCodeEnum[CurrencyCodeEnum["IRR"] = 'IRR'] = "IRR";
        CurrencyCodeEnum[CurrencyCodeEnum["XOF"] = 'XOF'] = "XOF";
        CurrencyCodeEnum[CurrencyCodeEnum["CDF"] = 'CDF'] = "CDF";
        CurrencyCodeEnum[CurrencyCodeEnum["XAF"] = 'XAF'] = "XAF";
        CurrencyCodeEnum[CurrencyCodeEnum["HTG"] = 'HTG'] = "HTG";
        CurrencyCodeEnum[CurrencyCodeEnum["ILS"] = 'ILS'] = "ILS";
        CurrencyCodeEnum[CurrencyCodeEnum["HRK"] = 'HRK'] = "HRK";
        CurrencyCodeEnum[CurrencyCodeEnum["HUF"] = 'HUF'] = "HUF";
        CurrencyCodeEnum[CurrencyCodeEnum["AMD"] = 'AMD'] = "AMD";
        CurrencyCodeEnum[CurrencyCodeEnum["ISK"] = 'ISK'] = "ISK";
        CurrencyCodeEnum[CurrencyCodeEnum["JPY"] = 'JPY'] = "JPY";
        CurrencyCodeEnum[CurrencyCodeEnum["GEL"] = 'GEL'] = "GEL";
        CurrencyCodeEnum[CurrencyCodeEnum["KZT"] = 'KZT'] = "KZT";
        CurrencyCodeEnum[CurrencyCodeEnum["KHR"] = 'KHR'] = "KHR";
        CurrencyCodeEnum[CurrencyCodeEnum["KRW"] = 'KRW'] = "KRW";
        CurrencyCodeEnum[CurrencyCodeEnum["KGS"] = 'KGS'] = "KGS";
        CurrencyCodeEnum[CurrencyCodeEnum["LAK"] = 'LAK'] = "LAK";
        CurrencyCodeEnum[CurrencyCodeEnum["MKD"] = 'MKD'] = "MKD";
        CurrencyCodeEnum[CurrencyCodeEnum["MNT"] = 'MNT'] = "MNT";
        CurrencyCodeEnum[CurrencyCodeEnum["BND"] = 'BND'] = "BND";
        CurrencyCodeEnum[CurrencyCodeEnum["MMK"] = 'MMK'] = "MMK";
        CurrencyCodeEnum[CurrencyCodeEnum["NOK"] = 'NOK'] = "NOK";
        CurrencyCodeEnum[CurrencyCodeEnum["NPR"] = 'NPR'] = "NPR";
        CurrencyCodeEnum[CurrencyCodeEnum["PKR"] = 'PKR'] = "PKR";
        CurrencyCodeEnum[CurrencyCodeEnum["PLN"] = 'PLN'] = "PLN";
        CurrencyCodeEnum[CurrencyCodeEnum["AFN"] = 'AFN'] = "AFN";
        CurrencyCodeEnum[CurrencyCodeEnum["BRL"] = 'BRL'] = "BRL";
        CurrencyCodeEnum[CurrencyCodeEnum["MDL"] = 'MDL'] = "MDL";
        CurrencyCodeEnum[CurrencyCodeEnum["RON"] = 'RON'] = "RON";
        CurrencyCodeEnum[CurrencyCodeEnum["RWF"] = 'RWF'] = "RWF";
        CurrencyCodeEnum[CurrencyCodeEnum["SEK"] = 'SEK'] = "SEK";
        CurrencyCodeEnum[CurrencyCodeEnum["LKR"] = 'LKR'] = "LKR";
        CurrencyCodeEnum[CurrencyCodeEnum["SOS"] = 'SOS'] = "SOS";
        CurrencyCodeEnum[CurrencyCodeEnum["ALL"] = 'ALL'] = "ALL";
        CurrencyCodeEnum[CurrencyCodeEnum["RSD"] = 'RSD'] = "RSD";
        CurrencyCodeEnum[CurrencyCodeEnum["KES"] = 'KES'] = "KES";
        CurrencyCodeEnum[CurrencyCodeEnum["TJS"] = 'TJS'] = "TJS";
        CurrencyCodeEnum[CurrencyCodeEnum["THB"] = 'THB'] = "THB";
        CurrencyCodeEnum[CurrencyCodeEnum["ERN"] = 'ERN'] = "ERN";
        CurrencyCodeEnum[CurrencyCodeEnum["TMT"] = 'TMT'] = "TMT";
        CurrencyCodeEnum[CurrencyCodeEnum["BWP"] = 'BWP'] = "BWP";
        CurrencyCodeEnum[CurrencyCodeEnum["TRY"] = 'TRY'] = "TRY";
        CurrencyCodeEnum[CurrencyCodeEnum["UAH"] = 'UAH'] = "UAH";
        CurrencyCodeEnum[CurrencyCodeEnum["UZS"] = 'UZS'] = "UZS";
        CurrencyCodeEnum[CurrencyCodeEnum["VND"] = 'VND'] = "VND";
        CurrencyCodeEnum[CurrencyCodeEnum["MOP"] = 'MOP'] = "MOP";
        CurrencyCodeEnum[CurrencyCodeEnum["TWD"] = 'TWD'] = "TWD";
        CurrencyCodeEnum[CurrencyCodeEnum["BMD"] = 'BMD'] = "BMD";
    })(CurrencyCodeEnum = BankAccountCreate.CurrencyCodeEnum || (BankAccountCreate.CurrencyCodeEnum = {}));
    var BusinessTypeEnum;
    (function (BusinessTypeEnum) {
        BusinessTypeEnum[BusinessTypeEnum["Individual"] = 'Individual'] = "Individual";
        BusinessTypeEnum[BusinessTypeEnum["Company"] = 'Company'] = "Company";
        BusinessTypeEnum[BusinessTypeEnum["NonProfit"] = 'NonProfit'] = "NonProfit";
        BusinessTypeEnum[BusinessTypeEnum["GovernmentEntity"] = 'GovernmentEntity'] = "GovernmentEntity";
    })(BusinessTypeEnum = BankAccountCreate.BusinessTypeEnum || (BankAccountCreate.BusinessTypeEnum = {}));
})(BankAccountCreate || (exports.BankAccountCreate = BankAccountCreate = {}));
var BankAccountDetail;
(function (BankAccountDetail) {
    var AccountStateEnum;
    (function (AccountStateEnum) {
        AccountStateEnum[AccountStateEnum["Unverified"] = 'Unverified'] = "Unverified";
        AccountStateEnum[AccountStateEnum["AwatingVerification"] = 'AwatingVerification'] = "AwatingVerification";
        AccountStateEnum[AccountStateEnum["Verified"] = 'Verified'] = "Verified";
        AccountStateEnum[AccountStateEnum["Grandfathered"] = 'Grandfathered'] = "Grandfathered";
    })(AccountStateEnum = BankAccountDetail.AccountStateEnum || (BankAccountDetail.AccountStateEnum = {}));
    var CurrencyCodeEnum;
    (function (CurrencyCodeEnum) {
        CurrencyCodeEnum[CurrencyCodeEnum["EUR"] = 'EUR'] = "EUR";
        CurrencyCodeEnum[CurrencyCodeEnum["USD"] = 'USD'] = "USD";
        CurrencyCodeEnum[CurrencyCodeEnum["GBP"] = 'GBP'] = "GBP";
        CurrencyCodeEnum[CurrencyCodeEnum["CAD"] = 'CAD'] = "CAD";
        CurrencyCodeEnum[CurrencyCodeEnum["AUD"] = 'AUD'] = "AUD";
        CurrencyCodeEnum[CurrencyCodeEnum["DJF"] = 'DJF'] = "DJF";
        CurrencyCodeEnum[CurrencyCodeEnum["ZAR"] = 'ZAR'] = "ZAR";
        CurrencyCodeEnum[CurrencyCodeEnum["ETB"] = 'ETB'] = "ETB";
        CurrencyCodeEnum[CurrencyCodeEnum["AED"] = 'AED'] = "AED";
        CurrencyCodeEnum[CurrencyCodeEnum["BHD"] = 'BHD'] = "BHD";
        CurrencyCodeEnum[CurrencyCodeEnum["DZD"] = 'DZD'] = "DZD";
        CurrencyCodeEnum[CurrencyCodeEnum["EGP"] = 'EGP'] = "EGP";
        CurrencyCodeEnum[CurrencyCodeEnum["IQD"] = 'IQD'] = "IQD";
        CurrencyCodeEnum[CurrencyCodeEnum["JOD"] = 'JOD'] = "JOD";
        CurrencyCodeEnum[CurrencyCodeEnum["KWD"] = 'KWD'] = "KWD";
        CurrencyCodeEnum[CurrencyCodeEnum["LBP"] = 'LBP'] = "LBP";
        CurrencyCodeEnum[CurrencyCodeEnum["LYD"] = 'LYD'] = "LYD";
        CurrencyCodeEnum[CurrencyCodeEnum["MAD"] = 'MAD'] = "MAD";
        CurrencyCodeEnum[CurrencyCodeEnum["OMR"] = 'OMR'] = "OMR";
        CurrencyCodeEnum[CurrencyCodeEnum["QAR"] = 'QAR'] = "QAR";
        CurrencyCodeEnum[CurrencyCodeEnum["SAR"] = 'SAR'] = "SAR";
        CurrencyCodeEnum[CurrencyCodeEnum["SYP"] = 'SYP'] = "SYP";
        CurrencyCodeEnum[CurrencyCodeEnum["TND"] = 'TND'] = "TND";
        CurrencyCodeEnum[CurrencyCodeEnum["YER"] = 'YER'] = "YER";
        CurrencyCodeEnum[CurrencyCodeEnum["CLP"] = 'CLP'] = "CLP";
        CurrencyCodeEnum[CurrencyCodeEnum["INR"] = 'INR'] = "INR";
        CurrencyCodeEnum[CurrencyCodeEnum["AZN"] = 'AZN'] = "AZN";
        CurrencyCodeEnum[CurrencyCodeEnum["RUB"] = 'RUB'] = "RUB";
        CurrencyCodeEnum[CurrencyCodeEnum["BYN"] = 'BYN'] = "BYN";
        CurrencyCodeEnum[CurrencyCodeEnum["BGN"] = 'BGN'] = "BGN";
        CurrencyCodeEnum[CurrencyCodeEnum["NGN"] = 'NGN'] = "NGN";
        CurrencyCodeEnum[CurrencyCodeEnum["BDT"] = 'BDT'] = "BDT";
        CurrencyCodeEnum[CurrencyCodeEnum["CNY"] = 'CNY'] = "CNY";
        CurrencyCodeEnum[CurrencyCodeEnum["BAM"] = 'BAM'] = "BAM";
        CurrencyCodeEnum[CurrencyCodeEnum["CZK"] = 'CZK'] = "CZK";
        CurrencyCodeEnum[CurrencyCodeEnum["DKK"] = 'DKK'] = "DKK";
        CurrencyCodeEnum[CurrencyCodeEnum["CHF"] = 'CHF'] = "CHF";
        CurrencyCodeEnum[CurrencyCodeEnum["MVR"] = 'MVR'] = "MVR";
        CurrencyCodeEnum[CurrencyCodeEnum["BTN"] = 'BTN'] = "BTN";
        CurrencyCodeEnum[CurrencyCodeEnum["XCD"] = 'XCD'] = "XCD";
        CurrencyCodeEnum[CurrencyCodeEnum["BZD"] = 'BZD'] = "BZD";
        CurrencyCodeEnum[CurrencyCodeEnum["HKD"] = 'HKD'] = "HKD";
        CurrencyCodeEnum[CurrencyCodeEnum["IDR"] = 'IDR'] = "IDR";
        CurrencyCodeEnum[CurrencyCodeEnum["JMD"] = 'JMD'] = "JMD";
        CurrencyCodeEnum[CurrencyCodeEnum["MYR"] = 'MYR'] = "MYR";
        CurrencyCodeEnum[CurrencyCodeEnum["NZD"] = 'NZD'] = "NZD";
        CurrencyCodeEnum[CurrencyCodeEnum["PHP"] = 'PHP'] = "PHP";
        CurrencyCodeEnum[CurrencyCodeEnum["SGD"] = 'SGD'] = "SGD";
        CurrencyCodeEnum[CurrencyCodeEnum["TTD"] = 'TTD'] = "TTD";
        CurrencyCodeEnum[CurrencyCodeEnum["XDR"] = 'XDR'] = "XDR";
        CurrencyCodeEnum[CurrencyCodeEnum["ARS"] = 'ARS'] = "ARS";
        CurrencyCodeEnum[CurrencyCodeEnum["BOB"] = 'BOB'] = "BOB";
        CurrencyCodeEnum[CurrencyCodeEnum["COP"] = 'COP'] = "COP";
        CurrencyCodeEnum[CurrencyCodeEnum["CRC"] = 'CRC'] = "CRC";
        CurrencyCodeEnum[CurrencyCodeEnum["CUP"] = 'CUP'] = "CUP";
        CurrencyCodeEnum[CurrencyCodeEnum["DOP"] = 'DOP'] = "DOP";
        CurrencyCodeEnum[CurrencyCodeEnum["GTQ"] = 'GTQ'] = "GTQ";
        CurrencyCodeEnum[CurrencyCodeEnum["HNL"] = 'HNL'] = "HNL";
        CurrencyCodeEnum[CurrencyCodeEnum["MXN"] = 'MXN'] = "MXN";
        CurrencyCodeEnum[CurrencyCodeEnum["NIO"] = 'NIO'] = "NIO";
        CurrencyCodeEnum[CurrencyCodeEnum["PAB"] = 'PAB'] = "PAB";
        CurrencyCodeEnum[CurrencyCodeEnum["PEN"] = 'PEN'] = "PEN";
        CurrencyCodeEnum[CurrencyCodeEnum["PYG"] = 'PYG'] = "PYG";
        CurrencyCodeEnum[CurrencyCodeEnum["UYU"] = 'UYU'] = "UYU";
        CurrencyCodeEnum[CurrencyCodeEnum["VEF"] = 'VEF'] = "VEF";
        CurrencyCodeEnum[CurrencyCodeEnum["IRR"] = 'IRR'] = "IRR";
        CurrencyCodeEnum[CurrencyCodeEnum["XOF"] = 'XOF'] = "XOF";
        CurrencyCodeEnum[CurrencyCodeEnum["CDF"] = 'CDF'] = "CDF";
        CurrencyCodeEnum[CurrencyCodeEnum["XAF"] = 'XAF'] = "XAF";
        CurrencyCodeEnum[CurrencyCodeEnum["HTG"] = 'HTG'] = "HTG";
        CurrencyCodeEnum[CurrencyCodeEnum["ILS"] = 'ILS'] = "ILS";
        CurrencyCodeEnum[CurrencyCodeEnum["HRK"] = 'HRK'] = "HRK";
        CurrencyCodeEnum[CurrencyCodeEnum["HUF"] = 'HUF'] = "HUF";
        CurrencyCodeEnum[CurrencyCodeEnum["AMD"] = 'AMD'] = "AMD";
        CurrencyCodeEnum[CurrencyCodeEnum["ISK"] = 'ISK'] = "ISK";
        CurrencyCodeEnum[CurrencyCodeEnum["JPY"] = 'JPY'] = "JPY";
        CurrencyCodeEnum[CurrencyCodeEnum["GEL"] = 'GEL'] = "GEL";
        CurrencyCodeEnum[CurrencyCodeEnum["KZT"] = 'KZT'] = "KZT";
        CurrencyCodeEnum[CurrencyCodeEnum["KHR"] = 'KHR'] = "KHR";
        CurrencyCodeEnum[CurrencyCodeEnum["KRW"] = 'KRW'] = "KRW";
        CurrencyCodeEnum[CurrencyCodeEnum["KGS"] = 'KGS'] = "KGS";
        CurrencyCodeEnum[CurrencyCodeEnum["LAK"] = 'LAK'] = "LAK";
        CurrencyCodeEnum[CurrencyCodeEnum["MKD"] = 'MKD'] = "MKD";
        CurrencyCodeEnum[CurrencyCodeEnum["MNT"] = 'MNT'] = "MNT";
        CurrencyCodeEnum[CurrencyCodeEnum["BND"] = 'BND'] = "BND";
        CurrencyCodeEnum[CurrencyCodeEnum["MMK"] = 'MMK'] = "MMK";
        CurrencyCodeEnum[CurrencyCodeEnum["NOK"] = 'NOK'] = "NOK";
        CurrencyCodeEnum[CurrencyCodeEnum["NPR"] = 'NPR'] = "NPR";
        CurrencyCodeEnum[CurrencyCodeEnum["PKR"] = 'PKR'] = "PKR";
        CurrencyCodeEnum[CurrencyCodeEnum["PLN"] = 'PLN'] = "PLN";
        CurrencyCodeEnum[CurrencyCodeEnum["AFN"] = 'AFN'] = "AFN";
        CurrencyCodeEnum[CurrencyCodeEnum["BRL"] = 'BRL'] = "BRL";
        CurrencyCodeEnum[CurrencyCodeEnum["MDL"] = 'MDL'] = "MDL";
        CurrencyCodeEnum[CurrencyCodeEnum["RON"] = 'RON'] = "RON";
        CurrencyCodeEnum[CurrencyCodeEnum["RWF"] = 'RWF'] = "RWF";
        CurrencyCodeEnum[CurrencyCodeEnum["SEK"] = 'SEK'] = "SEK";
        CurrencyCodeEnum[CurrencyCodeEnum["LKR"] = 'LKR'] = "LKR";
        CurrencyCodeEnum[CurrencyCodeEnum["SOS"] = 'SOS'] = "SOS";
        CurrencyCodeEnum[CurrencyCodeEnum["ALL"] = 'ALL'] = "ALL";
        CurrencyCodeEnum[CurrencyCodeEnum["RSD"] = 'RSD'] = "RSD";
        CurrencyCodeEnum[CurrencyCodeEnum["KES"] = 'KES'] = "KES";
        CurrencyCodeEnum[CurrencyCodeEnum["TJS"] = 'TJS'] = "TJS";
        CurrencyCodeEnum[CurrencyCodeEnum["THB"] = 'THB'] = "THB";
        CurrencyCodeEnum[CurrencyCodeEnum["ERN"] = 'ERN'] = "ERN";
        CurrencyCodeEnum[CurrencyCodeEnum["TMT"] = 'TMT'] = "TMT";
        CurrencyCodeEnum[CurrencyCodeEnum["BWP"] = 'BWP'] = "BWP";
        CurrencyCodeEnum[CurrencyCodeEnum["TRY"] = 'TRY'] = "TRY";
        CurrencyCodeEnum[CurrencyCodeEnum["UAH"] = 'UAH'] = "UAH";
        CurrencyCodeEnum[CurrencyCodeEnum["UZS"] = 'UZS'] = "UZS";
        CurrencyCodeEnum[CurrencyCodeEnum["VND"] = 'VND'] = "VND";
        CurrencyCodeEnum[CurrencyCodeEnum["MOP"] = 'MOP'] = "MOP";
        CurrencyCodeEnum[CurrencyCodeEnum["TWD"] = 'TWD'] = "TWD";
        CurrencyCodeEnum[CurrencyCodeEnum["BMD"] = 'BMD'] = "BMD";
    })(CurrencyCodeEnum = BankAccountDetail.CurrencyCodeEnum || (BankAccountDetail.CurrencyCodeEnum = {}));
    var BusinessTypeEnum;
    (function (BusinessTypeEnum) {
        BusinessTypeEnum[BusinessTypeEnum["Individual"] = 'Individual'] = "Individual";
        BusinessTypeEnum[BusinessTypeEnum["Company"] = 'Company'] = "Company";
        BusinessTypeEnum[BusinessTypeEnum["NonProfit"] = 'NonProfit'] = "NonProfit";
        BusinessTypeEnum[BusinessTypeEnum["GovernmentEntity"] = 'GovernmentEntity'] = "GovernmentEntity";
    })(BusinessTypeEnum = BankAccountDetail.BusinessTypeEnum || (BankAccountDetail.BusinessTypeEnum = {}));
})(BankAccountDetail || (exports.BankAccountDetail = BankAccountDetail = {}));
var BankAccountDetailsUpdateRequest;
(function (BankAccountDetailsUpdateRequest) {
    var BusinessTypeEnum;
    (function (BusinessTypeEnum) {
        BusinessTypeEnum[BusinessTypeEnum["Individual"] = 'Individual'] = "Individual";
        BusinessTypeEnum[BusinessTypeEnum["Company"] = 'Company'] = "Company";
        BusinessTypeEnum[BusinessTypeEnum["NonProfit"] = 'NonProfit'] = "NonProfit";
        BusinessTypeEnum[BusinessTypeEnum["GovernmentEntity"] = 'GovernmentEntity'] = "GovernmentEntity";
    })(BusinessTypeEnum = BankAccountDetailsUpdateRequest.BusinessTypeEnum || (BankAccountDetailsUpdateRequest.BusinessTypeEnum = {}));
})(BankAccountDetailsUpdateRequest || (exports.BankAccountDetailsUpdateRequest = BankAccountDetailsUpdateRequest = {}));
var BankAccountSummary;
(function (BankAccountSummary) {
    var AccountStateEnum;
    (function (AccountStateEnum) {
        AccountStateEnum[AccountStateEnum["Unverified"] = 'Unverified'] = "Unverified";
        AccountStateEnum[AccountStateEnum["AwatingVerification"] = 'AwatingVerification'] = "AwatingVerification";
        AccountStateEnum[AccountStateEnum["Verified"] = 'Verified'] = "Verified";
        AccountStateEnum[AccountStateEnum["Grandfathered"] = 'Grandfathered'] = "Grandfathered";
    })(AccountStateEnum = BankAccountSummary.AccountStateEnum || (BankAccountSummary.AccountStateEnum = {}));
    var BusinessTypeEnum;
    (function (BusinessTypeEnum) {
        BusinessTypeEnum[BusinessTypeEnum["Individual"] = 'Individual'] = "Individual";
        BusinessTypeEnum[BusinessTypeEnum["Company"] = 'Company'] = "Company";
        BusinessTypeEnum[BusinessTypeEnum["NonProfit"] = 'NonProfit'] = "NonProfit";
        BusinessTypeEnum[BusinessTypeEnum["GovernmentEntity"] = 'GovernmentEntity'] = "GovernmentEntity";
    })(BusinessTypeEnum = BankAccountSummary.BusinessTypeEnum || (BankAccountSummary.BusinessTypeEnum = {}));
})(BankAccountSummary || (exports.BankAccountSummary = BankAccountSummary = {}));
var BluetoothTerminalStatus;
(function (BluetoothTerminalStatus) {
    var DeviceTypeEnum;
    (function (DeviceTypeEnum) {
        DeviceTypeEnum[DeviceTypeEnum["CHIPPER2X"] = 'CHIPPER_2X'] = "CHIPPER2X";
        DeviceTypeEnum[DeviceTypeEnum["COTSDEVICE"] = 'COTS_DEVICE'] = "COTSDEVICE";
        DeviceTypeEnum[DeviceTypeEnum["VERIFONEP400"] = 'VERIFONE_P400'] = "VERIFONEP400";
        DeviceTypeEnum[DeviceTypeEnum["WISEPAD3"] = 'WISEPAD_3'] = "WISEPAD3";
        DeviceTypeEnum[DeviceTypeEnum["WISEPOSE"] = 'WISEPOS_E'] = "WISEPOSE";
    })(DeviceTypeEnum = BluetoothTerminalStatus.DeviceTypeEnum || (BluetoothTerminalStatus.DeviceTypeEnum = {}));
    var StatusEnum;
    (function (StatusEnum) {
        StatusEnum[StatusEnum["NotConnected"] = 'Not_Connected'] = "NotConnected";
        StatusEnum[StatusEnum["Connecting"] = 'Connecting'] = "Connecting";
        StatusEnum[StatusEnum["Connected"] = 'Connected'] = "Connected";
        StatusEnum[StatusEnum["Online"] = 'Online'] = "Online";
        StatusEnum[StatusEnum["Offline"] = 'Offline'] = "Offline";
    })(StatusEnum = BluetoothTerminalStatus.StatusEnum || (BluetoothTerminalStatus.StatusEnum = {}));
})(BluetoothTerminalStatus || (exports.BluetoothTerminalStatus = BluetoothTerminalStatus = {}));
var BusinessHoursOverride;
(function (BusinessHoursOverride) {
    var DeliveryTypeEnum;
    (function (DeliveryTypeEnum) {
        DeliveryTypeEnum[DeliveryTypeEnum["Delivery"] = 'Delivery'] = "Delivery";
        DeliveryTypeEnum[DeliveryTypeEnum["Pickup"] = 'Pickup'] = "Pickup";
    })(DeliveryTypeEnum = BusinessHoursOverride.DeliveryTypeEnum || (BusinessHoursOverride.DeliveryTypeEnum = {}));
    var TypeEnum;
    (function (TypeEnum) {
        TypeEnum[TypeEnum["Open"] = 'Open'] = "Open";
        TypeEnum[TypeEnum["Closed"] = 'Closed'] = "Closed";
        TypeEnum[TypeEnum["ClosedAllowPreOrders"] = 'ClosedAllowPreOrders'] = "ClosedAllowPreOrders";
    })(TypeEnum = BusinessHoursOverride.TypeEnum || (BusinessHoursOverride.TypeEnum = {}));
})(BusinessHoursOverride || (exports.BusinessHoursOverride = BusinessHoursOverride = {}));
var BusinessHoursOverrideBase;
(function (BusinessHoursOverrideBase) {
    var DeliveryTypeEnum;
    (function (DeliveryTypeEnum) {
        DeliveryTypeEnum[DeliveryTypeEnum["Delivery"] = 'Delivery'] = "Delivery";
        DeliveryTypeEnum[DeliveryTypeEnum["Pickup"] = 'Pickup'] = "Pickup";
    })(DeliveryTypeEnum = BusinessHoursOverrideBase.DeliveryTypeEnum || (BusinessHoursOverrideBase.DeliveryTypeEnum = {}));
    var TypeEnum;
    (function (TypeEnum) {
        TypeEnum[TypeEnum["Open"] = 'Open'] = "Open";
        TypeEnum[TypeEnum["Closed"] = 'Closed'] = "Closed";
        TypeEnum[TypeEnum["ClosedAllowPreOrders"] = 'ClosedAllowPreOrders'] = "ClosedAllowPreOrders";
    })(TypeEnum = BusinessHoursOverrideBase.TypeEnum || (BusinessHoursOverrideBase.TypeEnum = {}));
})(BusinessHoursOverrideBase || (exports.BusinessHoursOverrideBase = BusinessHoursOverrideBase = {}));
var BusinessHoursPeriod;
(function (BusinessHoursPeriod) {
    var DayOfWeekEnum;
    (function (DayOfWeekEnum) {
        DayOfWeekEnum[DayOfWeekEnum["Sunday"] = 'Sunday'] = "Sunday";
        DayOfWeekEnum[DayOfWeekEnum["Monday"] = 'Monday'] = "Monday";
        DayOfWeekEnum[DayOfWeekEnum["Tuesday"] = 'Tuesday'] = "Tuesday";
        DayOfWeekEnum[DayOfWeekEnum["Wednesday"] = 'Wednesday'] = "Wednesday";
        DayOfWeekEnum[DayOfWeekEnum["Thursday"] = 'Thursday'] = "Thursday";
        DayOfWeekEnum[DayOfWeekEnum["Friday"] = 'Friday'] = "Friday";
        DayOfWeekEnum[DayOfWeekEnum["Saturday"] = 'Saturday'] = "Saturday";
    })(DayOfWeekEnum = BusinessHoursPeriod.DayOfWeekEnum || (BusinessHoursPeriod.DayOfWeekEnum = {}));
})(BusinessHoursPeriod || (exports.BusinessHoursPeriod = BusinessHoursPeriod = {}));
var BusinessHoursPeriodBase;
(function (BusinessHoursPeriodBase) {
    var DayOfWeekEnum;
    (function (DayOfWeekEnum) {
        DayOfWeekEnum[DayOfWeekEnum["Sunday"] = 'Sunday'] = "Sunday";
        DayOfWeekEnum[DayOfWeekEnum["Monday"] = 'Monday'] = "Monday";
        DayOfWeekEnum[DayOfWeekEnum["Tuesday"] = 'Tuesday'] = "Tuesday";
        DayOfWeekEnum[DayOfWeekEnum["Wednesday"] = 'Wednesday'] = "Wednesday";
        DayOfWeekEnum[DayOfWeekEnum["Thursday"] = 'Thursday'] = "Thursday";
        DayOfWeekEnum[DayOfWeekEnum["Friday"] = 'Friday'] = "Friday";
        DayOfWeekEnum[DayOfWeekEnum["Saturday"] = 'Saturday'] = "Saturday";
    })(DayOfWeekEnum = BusinessHoursPeriodBase.DayOfWeekEnum || (BusinessHoursPeriodBase.DayOfWeekEnum = {}));
})(BusinessHoursPeriodBase || (exports.BusinessHoursPeriodBase = BusinessHoursPeriodBase = {}));
var CatalogGroupReference;
(function (CatalogGroupReference) {
    var GroupTypeEnum;
    (function (GroupTypeEnum) {
        GroupTypeEnum[GroupTypeEnum["ModifierGroup"] = 'ModifierGroup'] = "ModifierGroup";
    })(GroupTypeEnum = CatalogGroupReference.GroupTypeEnum || (CatalogGroupReference.GroupTypeEnum = {}));
})(CatalogGroupReference || (exports.CatalogGroupReference = CatalogGroupReference = {}));
var CatalogItem;
(function (CatalogItem) {
    var ItemTypeEnum;
    (function (ItemTypeEnum) {
        ItemTypeEnum[ItemTypeEnum["Product"] = 'Product'] = "Product";
        ItemTypeEnum[ItemTypeEnum["Modifier"] = 'Modifier'] = "Modifier";
    })(ItemTypeEnum = CatalogItem.ItemTypeEnum || (CatalogItem.ItemTypeEnum = {}));
})(CatalogItem || (exports.CatalogItem = CatalogItem = {}));
var Channel;
(function (Channel) {
    var SourceEnum;
    (function (SourceEnum) {
        SourceEnum[SourceEnum["Internal"] = 'Internal'] = "Internal";
        SourceEnum[SourceEnum["External"] = 'External'] = "External";
    })(SourceEnum = Channel.SourceEnum || (Channel.SourceEnum = {}));
})(Channel || (exports.Channel = Channel = {}));
var CreateAppStoreApp;
(function (CreateAppStoreApp) {
    var ConfigurationTypeEnum;
    (function (ConfigurationTypeEnum) {
        ConfigurationTypeEnum[ConfigurationTypeEnum["ExternalLink"] = 'ExternalLink'] = "ExternalLink";
        ConfigurationTypeEnum[ConfigurationTypeEnum["FlipdishHosted"] = 'FlipdishHosted'] = "FlipdishHosted";
    })(ConfigurationTypeEnum = CreateAppStoreApp.ConfigurationTypeEnum || (CreateAppStoreApp.ConfigurationTypeEnum = {}));
    var StoreSelectorTypeEnum;
    (function (StoreSelectorTypeEnum) {
        StoreSelectorTypeEnum[StoreSelectorTypeEnum["None"] = 'None'] = "None";
        StoreSelectorTypeEnum[StoreSelectorTypeEnum["Single"] = 'Single'] = "Single";
        StoreSelectorTypeEnum[StoreSelectorTypeEnum["Multiple"] = 'Multiple'] = "Multiple";
    })(StoreSelectorTypeEnum = CreateAppStoreApp.StoreSelectorTypeEnum || (CreateAppStoreApp.StoreSelectorTypeEnum = {}));
    var TeammateAppAccessLevelEnum;
    (function (TeammateAppAccessLevelEnum) {
        TeammateAppAccessLevelEnum[TeammateAppAccessLevelEnum["Owner"] = 'Owner'] = "Owner";
        TeammateAppAccessLevelEnum[TeammateAppAccessLevelEnum["StoreOwner"] = 'StoreOwner'] = "StoreOwner";
        TeammateAppAccessLevelEnum[TeammateAppAccessLevelEnum["PropertyOwner"] = 'PropertyOwner'] = "PropertyOwner";
        TeammateAppAccessLevelEnum[TeammateAppAccessLevelEnum["ManagedOwner"] = 'ManagedOwner'] = "ManagedOwner";
        TeammateAppAccessLevelEnum[TeammateAppAccessLevelEnum["Integrator"] = 'Integrator'] = "Integrator";
        TeammateAppAccessLevelEnum[TeammateAppAccessLevelEnum["PropertyManager"] = 'PropertyManager'] = "PropertyManager";
        TeammateAppAccessLevelEnum[TeammateAppAccessLevelEnum["StoreManager"] = 'StoreManager'] = "StoreManager";
        TeammateAppAccessLevelEnum[TeammateAppAccessLevelEnum["StoreStaff"] = 'StoreStaff'] = "StoreStaff";
        TeammateAppAccessLevelEnum[TeammateAppAccessLevelEnum["StaffMember"] = 'StaffMember'] = "StaffMember";
        TeammateAppAccessLevelEnum[TeammateAppAccessLevelEnum["StoreReadOnlyAccess"] = 'StoreReadOnlyAccess'] = "StoreReadOnlyAccess";
        TeammateAppAccessLevelEnum[TeammateAppAccessLevelEnum["FinanceManger"] = 'FinanceManger'] = "FinanceManger";
    })(TeammateAppAccessLevelEnum = CreateAppStoreApp.TeammateAppAccessLevelEnum || (CreateAppStoreApp.TeammateAppAccessLevelEnum = {}));
    var PermissionsTypeEnum;
    (function (PermissionsTypeEnum) {
        PermissionsTypeEnum[PermissionsTypeEnum["Teammate"] = 'Teammate'] = "Teammate";
    })(PermissionsTypeEnum = CreateAppStoreApp.PermissionsTypeEnum || (CreateAppStoreApp.PermissionsTypeEnum = {}));
    var CategoriesEnum;
    (function (CategoriesEnum) {
        CategoriesEnum[CategoriesEnum["PointOfSale"] = 'PointOfSale'] = "PointOfSale";
        CategoriesEnum[CategoriesEnum["DeliveryAndLogistics"] = 'DeliveryAndLogistics'] = "DeliveryAndLogistics";
        CategoriesEnum[CategoriesEnum["CRM"] = 'CRM'] = "CRM";
        CategoriesEnum[CategoriesEnum["GiftCard"] = 'GiftCard'] = "GiftCard";
        CategoriesEnum[CategoriesEnum["Accounting"] = 'Accounting'] = "Accounting";
        CategoriesEnum[CategoriesEnum["LoyaltyAndMarketing"] = 'LoyaltyAndMarketing'] = "LoyaltyAndMarketing";
        CategoriesEnum[CategoriesEnum["Other"] = 'Other'] = "Other";
    })(CategoriesEnum = CreateAppStoreApp.CategoriesEnum || (CreateAppStoreApp.CategoriesEnum = {}));
    var CountriesEnum;
    (function (CountriesEnum) {
        CountriesEnum[CountriesEnum["GB"] = 'GB'] = "GB";
        CountriesEnum[CountriesEnum["IE"] = 'IE'] = "IE";
        CountriesEnum[CountriesEnum["FR"] = 'FR'] = "FR";
        CountriesEnum[CountriesEnum["ES"] = 'ES'] = "ES";
        CountriesEnum[CountriesEnum["PT"] = 'PT'] = "PT";
        CountriesEnum[CountriesEnum["IT"] = 'IT'] = "IT";
        CountriesEnum[CountriesEnum["DE"] = 'DE'] = "DE";
        CountriesEnum[CountriesEnum["PL"] = 'PL'] = "PL";
        CountriesEnum[CountriesEnum["BE"] = 'BE'] = "BE";
        CountriesEnum[CountriesEnum["LU"] = 'LU'] = "LU";
        CountriesEnum[CountriesEnum["NL"] = 'NL'] = "NL";
        CountriesEnum[CountriesEnum["US"] = 'US'] = "US";
        CountriesEnum[CountriesEnum["CA"] = 'CA'] = "CA";
        CountriesEnum[CountriesEnum["BG"] = 'BG'] = "BG";
        CountriesEnum[CountriesEnum["MX"] = 'MX'] = "MX";
        CountriesEnum[CountriesEnum["AU"] = 'AU'] = "AU";
        CountriesEnum[CountriesEnum["NZ"] = 'NZ'] = "NZ";
    })(CountriesEnum = CreateAppStoreApp.CountriesEnum || (CreateAppStoreApp.CountriesEnum = {}));
})(CreateAppStoreApp || (exports.CreateAppStoreApp = CreateAppStoreApp = {}));
var CreateCatalogGroupReference;
(function (CreateCatalogGroupReference) {
    var GroupTypeEnum;
    (function (GroupTypeEnum) {
        GroupTypeEnum[GroupTypeEnum["ModifierGroup"] = 'ModifierGroup'] = "ModifierGroup";
    })(GroupTypeEnum = CreateCatalogGroupReference.GroupTypeEnum || (CreateCatalogGroupReference.GroupTypeEnum = {}));
})(CreateCatalogGroupReference || (exports.CreateCatalogGroupReference = CreateCatalogGroupReference = {}));
var CreateCatalogItem;
(function (CreateCatalogItem) {
    var ItemTypeEnum;
    (function (ItemTypeEnum) {
        ItemTypeEnum[ItemTypeEnum["Product"] = 'Product'] = "Product";
        ItemTypeEnum[ItemTypeEnum["Modifier"] = 'Modifier'] = "Modifier";
    })(ItemTypeEnum = CreateCatalogItem.ItemTypeEnum || (CreateCatalogItem.ItemTypeEnum = {}));
})(CreateCatalogItem || (exports.CreateCatalogItem = CreateCatalogItem = {}));
var CreateEndUserFeeConfig;
(function (CreateEndUserFeeConfig) {
    var ChannelEnum;
    (function (ChannelEnum) {
        ChannelEnum[ChannelEnum["WebApp"] = 'WebApp'] = "WebApp";
        ChannelEnum[ChannelEnum["InStore"] = 'InStore'] = "InStore";
        ChannelEnum[ChannelEnum["Kiosk"] = 'Kiosk'] = "Kiosk";
    })(ChannelEnum = CreateEndUserFeeConfig.ChannelEnum || (CreateEndUserFeeConfig.ChannelEnum = {}));
    var PaymentMethodEnum;
    (function (PaymentMethodEnum) {
        PaymentMethodEnum[PaymentMethodEnum["Cash"] = 'Cash'] = "Cash";
        PaymentMethodEnum[PaymentMethodEnum["Card"] = 'Card'] = "Card";
    })(PaymentMethodEnum = CreateEndUserFeeConfig.PaymentMethodEnum || (CreateEndUserFeeConfig.PaymentMethodEnum = {}));
})(CreateEndUserFeeConfig || (exports.CreateEndUserFeeConfig = CreateEndUserFeeConfig = {}));
var CreateFulfillmentStatesConfiguration;
(function (CreateFulfillmentStatesConfiguration) {
    var StoreSelectorTypeEnum;
    (function (StoreSelectorTypeEnum) {
        StoreSelectorTypeEnum[StoreSelectorTypeEnum["None"] = 'None'] = "None";
        StoreSelectorTypeEnum[StoreSelectorTypeEnum["Single"] = 'Single'] = "Single";
        StoreSelectorTypeEnum[StoreSelectorTypeEnum["Multiple"] = 'Multiple'] = "Multiple";
    })(StoreSelectorTypeEnum = CreateFulfillmentStatesConfiguration.StoreSelectorTypeEnum || (CreateFulfillmentStatesConfiguration.StoreSelectorTypeEnum = {}));
})(CreateFulfillmentStatesConfiguration || (exports.CreateFulfillmentStatesConfiguration = CreateFulfillmentStatesConfiguration = {}));
var CreateFullMenu;
(function (CreateFullMenu) {
    var MenuSectionBehaviourEnum;
    (function (MenuSectionBehaviourEnum) {
        MenuSectionBehaviourEnum[MenuSectionBehaviourEnum["ExpandSingle"] = 'ExpandSingle'] = "ExpandSingle";
        MenuSectionBehaviourEnum[MenuSectionBehaviourEnum["ExpandMultiple"] = 'ExpandMultiple'] = "ExpandMultiple";
    })(MenuSectionBehaviourEnum = CreateFullMenu.MenuSectionBehaviourEnum || (CreateFullMenu.MenuSectionBehaviourEnum = {}));
    var TaxTypeEnum;
    (function (TaxTypeEnum) {
        TaxTypeEnum[TaxTypeEnum["IncludedInBasePrice"] = 'IncludedInBasePrice'] = "IncludedInBasePrice";
        TaxTypeEnum[TaxTypeEnum["ExcludedFromBasePrice"] = 'ExcludedFromBasePrice'] = "ExcludedFromBasePrice";
    })(TaxTypeEnum = CreateFullMenu.TaxTypeEnum || (CreateFullMenu.TaxTypeEnum = {}));
})(CreateFullMenu || (exports.CreateFullMenu = CreateFullMenu = {}));
var CreateFullMenuItemOptionSet;
(function (CreateFullMenuItemOptionSet) {
    var CellLayoutTypeEnum;
    (function (CellLayoutTypeEnum) {
        CellLayoutTypeEnum[CellLayoutTypeEnum["Small"] = 'Small'] = "Small";
        CellLayoutTypeEnum[CellLayoutTypeEnum["Medium"] = 'Medium'] = "Medium";
        CellLayoutTypeEnum[CellLayoutTypeEnum["Large"] = 'Large'] = "Large";
        CellLayoutTypeEnum[CellLayoutTypeEnum["HiddenImage"] = 'HiddenImage'] = "HiddenImage";
    })(CellLayoutTypeEnum = CreateFullMenuItemOptionSet.CellLayoutTypeEnum || (CreateFullMenuItemOptionSet.CellLayoutTypeEnum = {}));
})(CreateFullMenuItemOptionSet || (exports.CreateFullMenuItemOptionSet = CreateFullMenuItemOptionSet = {}));
var CreateFullMenuItemOptionSetItem;
(function (CreateFullMenuItemOptionSetItem) {
    var CellLayoutTypeEnum;
    (function (CellLayoutTypeEnum) {
        CellLayoutTypeEnum[CellLayoutTypeEnum["Small"] = 'Small'] = "Small";
        CellLayoutTypeEnum[CellLayoutTypeEnum["Medium"] = 'Medium'] = "Medium";
        CellLayoutTypeEnum[CellLayoutTypeEnum["Large"] = 'Large'] = "Large";
        CellLayoutTypeEnum[CellLayoutTypeEnum["HiddenImage"] = 'HiddenImage'] = "HiddenImage";
    })(CellLayoutTypeEnum = CreateFullMenuItemOptionSetItem.CellLayoutTypeEnum || (CreateFullMenuItemOptionSetItem.CellLayoutTypeEnum = {}));
})(CreateFullMenuItemOptionSetItem || (exports.CreateFullMenuItemOptionSetItem = CreateFullMenuItemOptionSetItem = {}));
var CreateFullMenuSectionItem;
(function (CreateFullMenuSectionItem) {
    var SpicinessRatingEnum;
    (function (SpicinessRatingEnum) {
        SpicinessRatingEnum[SpicinessRatingEnum["NotRated"] = 'NotRated'] = "NotRated";
        SpicinessRatingEnum[SpicinessRatingEnum["Mild"] = 'Mild'] = "Mild";
        SpicinessRatingEnum[SpicinessRatingEnum["Medium"] = 'Medium'] = "Medium";
        SpicinessRatingEnum[SpicinessRatingEnum["Hot"] = 'Hot'] = "Hot";
    })(SpicinessRatingEnum = CreateFullMenuSectionItem.SpicinessRatingEnum || (CreateFullMenuSectionItem.SpicinessRatingEnum = {}));
    var CellLayoutTypeEnum;
    (function (CellLayoutTypeEnum) {
        CellLayoutTypeEnum[CellLayoutTypeEnum["Small"] = 'Small'] = "Small";
        CellLayoutTypeEnum[CellLayoutTypeEnum["Medium"] = 'Medium'] = "Medium";
        CellLayoutTypeEnum[CellLayoutTypeEnum["Large"] = 'Large'] = "Large";
        CellLayoutTypeEnum[CellLayoutTypeEnum["HiddenImage"] = 'HiddenImage'] = "HiddenImage";
    })(CellLayoutTypeEnum = CreateFullMenuSectionItem.CellLayoutTypeEnum || (CreateFullMenuSectionItem.CellLayoutTypeEnum = {}));
})(CreateFullMenuSectionItem || (exports.CreateFullMenuSectionItem = CreateFullMenuSectionItem = {}));
var CreateGroup;
(function (CreateGroup) {
    var GroupTypeEnum;
    (function (GroupTypeEnum) {
        GroupTypeEnum[GroupTypeEnum["ModifierGroup"] = 'ModifierGroup'] = "ModifierGroup";
    })(GroupTypeEnum = CreateGroup.GroupTypeEnum || (CreateGroup.GroupTypeEnum = {}));
})(CreateGroup || (exports.CreateGroup = CreateGroup = {}));
var CreateGroupReference;
(function (CreateGroupReference) {
    var GroupTypeEnum;
    (function (GroupTypeEnum) {
        GroupTypeEnum[GroupTypeEnum["ModifierGroup"] = 'ModifierGroup'] = "ModifierGroup";
    })(GroupTypeEnum = CreateGroupReference.GroupTypeEnum || (CreateGroupReference.GroupTypeEnum = {}));
})(CreateGroupReference || (exports.CreateGroupReference = CreateGroupReference = {}));
var CreateMetafieldDefinition;
(function (CreateMetafieldDefinition) {
    var OwnerEntityEnum;
    (function (OwnerEntityEnum) {
        OwnerEntityEnum[OwnerEntityEnum["CatalogItem"] = 'CatalogItem'] = "CatalogItem";
        OwnerEntityEnum[OwnerEntityEnum["CatalogGroup"] = 'CatalogGroup'] = "CatalogGroup";
        OwnerEntityEnum[OwnerEntityEnum["Menu"] = 'Menu'] = "Menu";
    })(OwnerEntityEnum = CreateMetafieldDefinition.OwnerEntityEnum || (CreateMetafieldDefinition.OwnerEntityEnum = {}));
    var ValueTypeEnum;
    (function (ValueTypeEnum) {
        ValueTypeEnum[ValueTypeEnum["Boolean"] = 'Boolean'] = "Boolean";
        ValueTypeEnum[ValueTypeEnum["Json"] = 'Json'] = "Json";
        ValueTypeEnum[ValueTypeEnum["SingleLineString"] = 'SingleLineString'] = "SingleLineString";
        ValueTypeEnum[ValueTypeEnum["MultiLineString"] = 'MultiLineString'] = "MultiLineString";
    })(ValueTypeEnum = CreateMetafieldDefinition.ValueTypeEnum || (CreateMetafieldDefinition.ValueTypeEnum = {}));
    var BehaviorsEnum;
    (function (BehaviorsEnum) {
        BehaviorsEnum[BehaviorsEnum["SendToOrder"] = 'SendToOrder'] = "SendToOrder";
        BehaviorsEnum[BehaviorsEnum["SendToMenu"] = 'SendToMenu'] = "SendToMenu";
    })(BehaviorsEnum = CreateMetafieldDefinition.BehaviorsEnum || (CreateMetafieldDefinition.BehaviorsEnum = {}));
})(CreateMetafieldDefinition || (exports.CreateMetafieldDefinition = CreateMetafieldDefinition = {}));
var CreateProduct;
(function (CreateProduct) {
    var ProductTypeEnum;
    (function (ProductTypeEnum) {
        ProductTypeEnum[ProductTypeEnum["Product"] = 'Product'] = "Product";
        ProductTypeEnum[ProductTypeEnum["Modifier"] = 'Modifier'] = "Modifier";
    })(ProductTypeEnum = CreateProduct.ProductTypeEnum || (CreateProduct.ProductTypeEnum = {}));
})(CreateProduct || (exports.CreateProduct = CreateProduct = {}));
var CreateProductReference;
(function (CreateProductReference) {
    var ProductTypeEnum;
    (function (ProductTypeEnum) {
        ProductTypeEnum[ProductTypeEnum["Product"] = 'Product'] = "Product";
        ProductTypeEnum[ProductTypeEnum["Modifier"] = 'Modifier'] = "Modifier";
    })(ProductTypeEnum = CreateProductReference.ProductTypeEnum || (CreateProductReference.ProductTypeEnum = {}));
})(CreateProductReference || (exports.CreateProductReference = CreateProductReference = {}));
var CreateTeammate;
(function (CreateTeammate) {
    var AppAccessLevelEnum;
    (function (AppAccessLevelEnum) {
        AppAccessLevelEnum[AppAccessLevelEnum["None"] = 'None'] = "None";
        AppAccessLevelEnum[AppAccessLevelEnum["Owner"] = 'Owner'] = "Owner";
        AppAccessLevelEnum[AppAccessLevelEnum["StoreOwner"] = 'StoreOwner'] = "StoreOwner";
        AppAccessLevelEnum[AppAccessLevelEnum["PropertyOwner"] = 'PropertyOwner'] = "PropertyOwner";
        AppAccessLevelEnum[AppAccessLevelEnum["ManagedOwner"] = 'ManagedOwner'] = "ManagedOwner";
        AppAccessLevelEnum[AppAccessLevelEnum["Integrator"] = 'Integrator'] = "Integrator";
        AppAccessLevelEnum[AppAccessLevelEnum["PropertyManager"] = 'PropertyManager'] = "PropertyManager";
        AppAccessLevelEnum[AppAccessLevelEnum["StoreManager"] = 'StoreManager'] = "StoreManager";
        AppAccessLevelEnum[AppAccessLevelEnum["StoreStaff"] = 'StoreStaff'] = "StoreStaff";
        AppAccessLevelEnum[AppAccessLevelEnum["StaffMember"] = 'StaffMember'] = "StaffMember";
        AppAccessLevelEnum[AppAccessLevelEnum["StoreReadOnlyAccess"] = 'StoreReadOnlyAccess'] = "StoreReadOnlyAccess";
        AppAccessLevelEnum[AppAccessLevelEnum["FinanceManger"] = 'FinanceManger'] = "FinanceManger";
        AppAccessLevelEnum[AppAccessLevelEnum["Onboarding"] = 'Onboarding'] = "Onboarding";
        AppAccessLevelEnum[AppAccessLevelEnum["Support"] = 'Support'] = "Support";
    })(AppAccessLevelEnum = CreateTeammate.AppAccessLevelEnum || (CreateTeammate.AppAccessLevelEnum = {}));
})(CreateTeammate || (exports.CreateTeammate = CreateTeammate = {}));
var CreateVoucher;
(function (CreateVoucher) {
    var VoucherTypeEnum;
    (function (VoucherTypeEnum) {
        VoucherTypeEnum[VoucherTypeEnum["PercentageDiscount"] = 'PercentageDiscount'] = "PercentageDiscount";
        VoucherTypeEnum[VoucherTypeEnum["LumpDiscount"] = 'LumpDiscount'] = "LumpDiscount";
        VoucherTypeEnum[VoucherTypeEnum["AddItem"] = 'AddItem'] = "AddItem";
        VoucherTypeEnum[VoucherTypeEnum["CreditNote"] = 'CreditNote'] = "CreditNote";
        VoucherTypeEnum[VoucherTypeEnum["FreeDelivery"] = 'FreeDelivery'] = "FreeDelivery";
    })(VoucherTypeEnum = CreateVoucher.VoucherTypeEnum || (CreateVoucher.VoucherTypeEnum = {}));
    var ChannelRestrictionsEnum;
    (function (ChannelRestrictionsEnum) {
        ChannelRestrictionsEnum[ChannelRestrictionsEnum["Ios"] = 'Ios'] = "Ios";
        ChannelRestrictionsEnum[ChannelRestrictionsEnum["Android"] = 'Android'] = "Android";
        ChannelRestrictionsEnum[ChannelRestrictionsEnum["Web"] = 'Web'] = "Web";
        ChannelRestrictionsEnum[ChannelRestrictionsEnum["Kiosk"] = 'Kiosk'] = "Kiosk";
        ChannelRestrictionsEnum[ChannelRestrictionsEnum["Pos"] = 'Pos'] = "Pos";
        ChannelRestrictionsEnum[ChannelRestrictionsEnum["Google"] = 'Google'] = "Google";
    })(ChannelRestrictionsEnum = CreateVoucher.ChannelRestrictionsEnum || (CreateVoucher.ChannelRestrictionsEnum = {}));
    var VoucherSubTypeEnum;
    (function (VoucherSubTypeEnum) {
        VoucherSubTypeEnum[VoucherSubTypeEnum["None"] = 'None'] = "None";
        VoucherSubTypeEnum[VoucherSubTypeEnum["SignUp"] = 'SignUp'] = "SignUp";
        VoucherSubTypeEnum[VoucherSubTypeEnum["Loyalty"] = 'Loyalty'] = "Loyalty";
        VoucherSubTypeEnum[VoucherSubTypeEnum["Loyalty25"] = 'Loyalty25'] = "Loyalty25";
        VoucherSubTypeEnum[VoucherSubTypeEnum["Retention"] = 'Retention'] = "Retention";
        VoucherSubTypeEnum[VoucherSubTypeEnum["SecondaryRetention"] = 'SecondaryRetention'] = "SecondaryRetention";
        VoucherSubTypeEnum[VoucherSubTypeEnum["Custom"] = 'Custom'] = "Custom";
    })(VoucherSubTypeEnum = CreateVoucher.VoucherSubTypeEnum || (CreateVoucher.VoucherSubTypeEnum = {}));
})(CreateVoucher || (exports.CreateVoucher = CreateVoucher = {}));
var CurrencyData;
(function (CurrencyData) {
    var CurrencyEnum;
    (function (CurrencyEnum) {
        CurrencyEnum[CurrencyEnum["EUR"] = 'EUR'] = "EUR";
        CurrencyEnum[CurrencyEnum["USD"] = 'USD'] = "USD";
        CurrencyEnum[CurrencyEnum["GBP"] = 'GBP'] = "GBP";
        CurrencyEnum[CurrencyEnum["CAD"] = 'CAD'] = "CAD";
        CurrencyEnum[CurrencyEnum["AUD"] = 'AUD'] = "AUD";
        CurrencyEnum[CurrencyEnum["DJF"] = 'DJF'] = "DJF";
        CurrencyEnum[CurrencyEnum["ZAR"] = 'ZAR'] = "ZAR";
        CurrencyEnum[CurrencyEnum["ETB"] = 'ETB'] = "ETB";
        CurrencyEnum[CurrencyEnum["AED"] = 'AED'] = "AED";
        CurrencyEnum[CurrencyEnum["BHD"] = 'BHD'] = "BHD";
        CurrencyEnum[CurrencyEnum["DZD"] = 'DZD'] = "DZD";
        CurrencyEnum[CurrencyEnum["EGP"] = 'EGP'] = "EGP";
        CurrencyEnum[CurrencyEnum["IQD"] = 'IQD'] = "IQD";
        CurrencyEnum[CurrencyEnum["JOD"] = 'JOD'] = "JOD";
        CurrencyEnum[CurrencyEnum["KWD"] = 'KWD'] = "KWD";
        CurrencyEnum[CurrencyEnum["LBP"] = 'LBP'] = "LBP";
        CurrencyEnum[CurrencyEnum["LYD"] = 'LYD'] = "LYD";
        CurrencyEnum[CurrencyEnum["MAD"] = 'MAD'] = "MAD";
        CurrencyEnum[CurrencyEnum["OMR"] = 'OMR'] = "OMR";
        CurrencyEnum[CurrencyEnum["QAR"] = 'QAR'] = "QAR";
        CurrencyEnum[CurrencyEnum["SAR"] = 'SAR'] = "SAR";
        CurrencyEnum[CurrencyEnum["SYP"] = 'SYP'] = "SYP";
        CurrencyEnum[CurrencyEnum["TND"] = 'TND'] = "TND";
        CurrencyEnum[CurrencyEnum["YER"] = 'YER'] = "YER";
        CurrencyEnum[CurrencyEnum["CLP"] = 'CLP'] = "CLP";
        CurrencyEnum[CurrencyEnum["INR"] = 'INR'] = "INR";
        CurrencyEnum[CurrencyEnum["AZN"] = 'AZN'] = "AZN";
        CurrencyEnum[CurrencyEnum["RUB"] = 'RUB'] = "RUB";
        CurrencyEnum[CurrencyEnum["BYN"] = 'BYN'] = "BYN";
        CurrencyEnum[CurrencyEnum["BGN"] = 'BGN'] = "BGN";
        CurrencyEnum[CurrencyEnum["NGN"] = 'NGN'] = "NGN";
        CurrencyEnum[CurrencyEnum["BDT"] = 'BDT'] = "BDT";
        CurrencyEnum[CurrencyEnum["CNY"] = 'CNY'] = "CNY";
        CurrencyEnum[CurrencyEnum["BAM"] = 'BAM'] = "BAM";
        CurrencyEnum[CurrencyEnum["CZK"] = 'CZK'] = "CZK";
        CurrencyEnum[CurrencyEnum["DKK"] = 'DKK'] = "DKK";
        CurrencyEnum[CurrencyEnum["CHF"] = 'CHF'] = "CHF";
        CurrencyEnum[CurrencyEnum["MVR"] = 'MVR'] = "MVR";
        CurrencyEnum[CurrencyEnum["BTN"] = 'BTN'] = "BTN";
        CurrencyEnum[CurrencyEnum["XCD"] = 'XCD'] = "XCD";
        CurrencyEnum[CurrencyEnum["BZD"] = 'BZD'] = "BZD";
        CurrencyEnum[CurrencyEnum["HKD"] = 'HKD'] = "HKD";
        CurrencyEnum[CurrencyEnum["IDR"] = 'IDR'] = "IDR";
        CurrencyEnum[CurrencyEnum["JMD"] = 'JMD'] = "JMD";
        CurrencyEnum[CurrencyEnum["MYR"] = 'MYR'] = "MYR";
        CurrencyEnum[CurrencyEnum["NZD"] = 'NZD'] = "NZD";
        CurrencyEnum[CurrencyEnum["PHP"] = 'PHP'] = "PHP";
        CurrencyEnum[CurrencyEnum["SGD"] = 'SGD'] = "SGD";
        CurrencyEnum[CurrencyEnum["TTD"] = 'TTD'] = "TTD";
        CurrencyEnum[CurrencyEnum["XDR"] = 'XDR'] = "XDR";
        CurrencyEnum[CurrencyEnum["ARS"] = 'ARS'] = "ARS";
        CurrencyEnum[CurrencyEnum["BOB"] = 'BOB'] = "BOB";
        CurrencyEnum[CurrencyEnum["COP"] = 'COP'] = "COP";
        CurrencyEnum[CurrencyEnum["CRC"] = 'CRC'] = "CRC";
        CurrencyEnum[CurrencyEnum["CUP"] = 'CUP'] = "CUP";
        CurrencyEnum[CurrencyEnum["DOP"] = 'DOP'] = "DOP";
        CurrencyEnum[CurrencyEnum["GTQ"] = 'GTQ'] = "GTQ";
        CurrencyEnum[CurrencyEnum["HNL"] = 'HNL'] = "HNL";
        CurrencyEnum[CurrencyEnum["MXN"] = 'MXN'] = "MXN";
        CurrencyEnum[CurrencyEnum["NIO"] = 'NIO'] = "NIO";
        CurrencyEnum[CurrencyEnum["PAB"] = 'PAB'] = "PAB";
        CurrencyEnum[CurrencyEnum["PEN"] = 'PEN'] = "PEN";
        CurrencyEnum[CurrencyEnum["PYG"] = 'PYG'] = "PYG";
        CurrencyEnum[CurrencyEnum["UYU"] = 'UYU'] = "UYU";
        CurrencyEnum[CurrencyEnum["VEF"] = 'VEF'] = "VEF";
        CurrencyEnum[CurrencyEnum["IRR"] = 'IRR'] = "IRR";
        CurrencyEnum[CurrencyEnum["XOF"] = 'XOF'] = "XOF";
        CurrencyEnum[CurrencyEnum["CDF"] = 'CDF'] = "CDF";
        CurrencyEnum[CurrencyEnum["XAF"] = 'XAF'] = "XAF";
        CurrencyEnum[CurrencyEnum["HTG"] = 'HTG'] = "HTG";
        CurrencyEnum[CurrencyEnum["ILS"] = 'ILS'] = "ILS";
        CurrencyEnum[CurrencyEnum["HRK"] = 'HRK'] = "HRK";
        CurrencyEnum[CurrencyEnum["HUF"] = 'HUF'] = "HUF";
        CurrencyEnum[CurrencyEnum["AMD"] = 'AMD'] = "AMD";
        CurrencyEnum[CurrencyEnum["ISK"] = 'ISK'] = "ISK";
        CurrencyEnum[CurrencyEnum["JPY"] = 'JPY'] = "JPY";
        CurrencyEnum[CurrencyEnum["GEL"] = 'GEL'] = "GEL";
        CurrencyEnum[CurrencyEnum["KZT"] = 'KZT'] = "KZT";
        CurrencyEnum[CurrencyEnum["KHR"] = 'KHR'] = "KHR";
        CurrencyEnum[CurrencyEnum["KRW"] = 'KRW'] = "KRW";
        CurrencyEnum[CurrencyEnum["KGS"] = 'KGS'] = "KGS";
        CurrencyEnum[CurrencyEnum["LAK"] = 'LAK'] = "LAK";
        CurrencyEnum[CurrencyEnum["MKD"] = 'MKD'] = "MKD";
        CurrencyEnum[CurrencyEnum["MNT"] = 'MNT'] = "MNT";
        CurrencyEnum[CurrencyEnum["BND"] = 'BND'] = "BND";
        CurrencyEnum[CurrencyEnum["MMK"] = 'MMK'] = "MMK";
        CurrencyEnum[CurrencyEnum["NOK"] = 'NOK'] = "NOK";
        CurrencyEnum[CurrencyEnum["NPR"] = 'NPR'] = "NPR";
        CurrencyEnum[CurrencyEnum["PKR"] = 'PKR'] = "PKR";
        CurrencyEnum[CurrencyEnum["PLN"] = 'PLN'] = "PLN";
        CurrencyEnum[CurrencyEnum["AFN"] = 'AFN'] = "AFN";
        CurrencyEnum[CurrencyEnum["BRL"] = 'BRL'] = "BRL";
        CurrencyEnum[CurrencyEnum["MDL"] = 'MDL'] = "MDL";
        CurrencyEnum[CurrencyEnum["RON"] = 'RON'] = "RON";
        CurrencyEnum[CurrencyEnum["RWF"] = 'RWF'] = "RWF";
        CurrencyEnum[CurrencyEnum["SEK"] = 'SEK'] = "SEK";
        CurrencyEnum[CurrencyEnum["LKR"] = 'LKR'] = "LKR";
        CurrencyEnum[CurrencyEnum["SOS"] = 'SOS'] = "SOS";
        CurrencyEnum[CurrencyEnum["ALL"] = 'ALL'] = "ALL";
        CurrencyEnum[CurrencyEnum["RSD"] = 'RSD'] = "RSD";
        CurrencyEnum[CurrencyEnum["KES"] = 'KES'] = "KES";
        CurrencyEnum[CurrencyEnum["TJS"] = 'TJS'] = "TJS";
        CurrencyEnum[CurrencyEnum["THB"] = 'THB'] = "THB";
        CurrencyEnum[CurrencyEnum["ERN"] = 'ERN'] = "ERN";
        CurrencyEnum[CurrencyEnum["TMT"] = 'TMT'] = "TMT";
        CurrencyEnum[CurrencyEnum["BWP"] = 'BWP'] = "BWP";
        CurrencyEnum[CurrencyEnum["TRY"] = 'TRY'] = "TRY";
        CurrencyEnum[CurrencyEnum["UAH"] = 'UAH'] = "UAH";
        CurrencyEnum[CurrencyEnum["UZS"] = 'UZS'] = "UZS";
        CurrencyEnum[CurrencyEnum["VND"] = 'VND'] = "VND";
        CurrencyEnum[CurrencyEnum["MOP"] = 'MOP'] = "MOP";
        CurrencyEnum[CurrencyEnum["TWD"] = 'TWD'] = "TWD";
        CurrencyEnum[CurrencyEnum["BMD"] = 'BMD'] = "BMD";
    })(CurrencyEnum = CurrencyData.CurrencyEnum || (CurrencyData.CurrencyEnum = {}));
})(CurrencyData || (exports.CurrencyData = CurrencyData = {}));
var CustomerCreateModel;
(function (CustomerCreateModel) {
    var AppTypeEnum;
    (function (AppTypeEnum) {
        AppTypeEnum[AppTypeEnum["Unknown"] = 'Unknown'] = "Unknown";
        AppTypeEnum[AppTypeEnum["Ios"] = 'Ios'] = "Ios";
        AppTypeEnum[AppTypeEnum["Android"] = 'Android'] = "Android";
        AppTypeEnum[AppTypeEnum["Web"] = 'Web'] = "Web";
        AppTypeEnum[AppTypeEnum["Kiosk"] = 'Kiosk'] = "Kiosk";
        AppTypeEnum[AppTypeEnum["Pos"] = 'Pos'] = "Pos";
        AppTypeEnum[AppTypeEnum["TelephoneCall"] = 'TelephoneCall'] = "TelephoneCall";
        AppTypeEnum[AppTypeEnum["Sms"] = 'Sms'] = "Sms";
        AppTypeEnum[AppTypeEnum["PwaAndroid"] = 'PwaAndroid'] = "PwaAndroid";
        AppTypeEnum[AppTypeEnum["PwaIos"] = 'PwaIos'] = "PwaIos";
        AppTypeEnum[AppTypeEnum["Google"] = 'Google'] = "Google";
    })(AppTypeEnum = CustomerCreateModel.AppTypeEnum || (CustomerCreateModel.AppTypeEnum = {}));
})(CustomerCreateModel || (exports.CustomerCreateModel = CustomerCreateModel = {}));
var CustomerDeliveryTrackingOrder;
(function (CustomerDeliveryTrackingOrder) {
    var CurrencyEnum;
    (function (CurrencyEnum) {
        CurrencyEnum[CurrencyEnum["EUR"] = 'EUR'] = "EUR";
        CurrencyEnum[CurrencyEnum["USD"] = 'USD'] = "USD";
        CurrencyEnum[CurrencyEnum["GBP"] = 'GBP'] = "GBP";
        CurrencyEnum[CurrencyEnum["CAD"] = 'CAD'] = "CAD";
        CurrencyEnum[CurrencyEnum["AUD"] = 'AUD'] = "AUD";
        CurrencyEnum[CurrencyEnum["DJF"] = 'DJF'] = "DJF";
        CurrencyEnum[CurrencyEnum["ZAR"] = 'ZAR'] = "ZAR";
        CurrencyEnum[CurrencyEnum["ETB"] = 'ETB'] = "ETB";
        CurrencyEnum[CurrencyEnum["AED"] = 'AED'] = "AED";
        CurrencyEnum[CurrencyEnum["BHD"] = 'BHD'] = "BHD";
        CurrencyEnum[CurrencyEnum["DZD"] = 'DZD'] = "DZD";
        CurrencyEnum[CurrencyEnum["EGP"] = 'EGP'] = "EGP";
        CurrencyEnum[CurrencyEnum["IQD"] = 'IQD'] = "IQD";
        CurrencyEnum[CurrencyEnum["JOD"] = 'JOD'] = "JOD";
        CurrencyEnum[CurrencyEnum["KWD"] = 'KWD'] = "KWD";
        CurrencyEnum[CurrencyEnum["LBP"] = 'LBP'] = "LBP";
        CurrencyEnum[CurrencyEnum["LYD"] = 'LYD'] = "LYD";
        CurrencyEnum[CurrencyEnum["MAD"] = 'MAD'] = "MAD";
        CurrencyEnum[CurrencyEnum["OMR"] = 'OMR'] = "OMR";
        CurrencyEnum[CurrencyEnum["QAR"] = 'QAR'] = "QAR";
        CurrencyEnum[CurrencyEnum["SAR"] = 'SAR'] = "SAR";
        CurrencyEnum[CurrencyEnum["SYP"] = 'SYP'] = "SYP";
        CurrencyEnum[CurrencyEnum["TND"] = 'TND'] = "TND";
        CurrencyEnum[CurrencyEnum["YER"] = 'YER'] = "YER";
        CurrencyEnum[CurrencyEnum["CLP"] = 'CLP'] = "CLP";
        CurrencyEnum[CurrencyEnum["INR"] = 'INR'] = "INR";
        CurrencyEnum[CurrencyEnum["AZN"] = 'AZN'] = "AZN";
        CurrencyEnum[CurrencyEnum["RUB"] = 'RUB'] = "RUB";
        CurrencyEnum[CurrencyEnum["BYN"] = 'BYN'] = "BYN";
        CurrencyEnum[CurrencyEnum["BGN"] = 'BGN'] = "BGN";
        CurrencyEnum[CurrencyEnum["NGN"] = 'NGN'] = "NGN";
        CurrencyEnum[CurrencyEnum["BDT"] = 'BDT'] = "BDT";
        CurrencyEnum[CurrencyEnum["CNY"] = 'CNY'] = "CNY";
        CurrencyEnum[CurrencyEnum["BAM"] = 'BAM'] = "BAM";
        CurrencyEnum[CurrencyEnum["CZK"] = 'CZK'] = "CZK";
        CurrencyEnum[CurrencyEnum["DKK"] = 'DKK'] = "DKK";
        CurrencyEnum[CurrencyEnum["CHF"] = 'CHF'] = "CHF";
        CurrencyEnum[CurrencyEnum["MVR"] = 'MVR'] = "MVR";
        CurrencyEnum[CurrencyEnum["BTN"] = 'BTN'] = "BTN";
        CurrencyEnum[CurrencyEnum["XCD"] = 'XCD'] = "XCD";
        CurrencyEnum[CurrencyEnum["BZD"] = 'BZD'] = "BZD";
        CurrencyEnum[CurrencyEnum["HKD"] = 'HKD'] = "HKD";
        CurrencyEnum[CurrencyEnum["IDR"] = 'IDR'] = "IDR";
        CurrencyEnum[CurrencyEnum["JMD"] = 'JMD'] = "JMD";
        CurrencyEnum[CurrencyEnum["MYR"] = 'MYR'] = "MYR";
        CurrencyEnum[CurrencyEnum["NZD"] = 'NZD'] = "NZD";
        CurrencyEnum[CurrencyEnum["PHP"] = 'PHP'] = "PHP";
        CurrencyEnum[CurrencyEnum["SGD"] = 'SGD'] = "SGD";
        CurrencyEnum[CurrencyEnum["TTD"] = 'TTD'] = "TTD";
        CurrencyEnum[CurrencyEnum["XDR"] = 'XDR'] = "XDR";
        CurrencyEnum[CurrencyEnum["ARS"] = 'ARS'] = "ARS";
        CurrencyEnum[CurrencyEnum["BOB"] = 'BOB'] = "BOB";
        CurrencyEnum[CurrencyEnum["COP"] = 'COP'] = "COP";
        CurrencyEnum[CurrencyEnum["CRC"] = 'CRC'] = "CRC";
        CurrencyEnum[CurrencyEnum["CUP"] = 'CUP'] = "CUP";
        CurrencyEnum[CurrencyEnum["DOP"] = 'DOP'] = "DOP";
        CurrencyEnum[CurrencyEnum["GTQ"] = 'GTQ'] = "GTQ";
        CurrencyEnum[CurrencyEnum["HNL"] = 'HNL'] = "HNL";
        CurrencyEnum[CurrencyEnum["MXN"] = 'MXN'] = "MXN";
        CurrencyEnum[CurrencyEnum["NIO"] = 'NIO'] = "NIO";
        CurrencyEnum[CurrencyEnum["PAB"] = 'PAB'] = "PAB";
        CurrencyEnum[CurrencyEnum["PEN"] = 'PEN'] = "PEN";
        CurrencyEnum[CurrencyEnum["PYG"] = 'PYG'] = "PYG";
        CurrencyEnum[CurrencyEnum["UYU"] = 'UYU'] = "UYU";
        CurrencyEnum[CurrencyEnum["VEF"] = 'VEF'] = "VEF";
        CurrencyEnum[CurrencyEnum["IRR"] = 'IRR'] = "IRR";
        CurrencyEnum[CurrencyEnum["XOF"] = 'XOF'] = "XOF";
        CurrencyEnum[CurrencyEnum["CDF"] = 'CDF'] = "CDF";
        CurrencyEnum[CurrencyEnum["XAF"] = 'XAF'] = "XAF";
        CurrencyEnum[CurrencyEnum["HTG"] = 'HTG'] = "HTG";
        CurrencyEnum[CurrencyEnum["ILS"] = 'ILS'] = "ILS";
        CurrencyEnum[CurrencyEnum["HRK"] = 'HRK'] = "HRK";
        CurrencyEnum[CurrencyEnum["HUF"] = 'HUF'] = "HUF";
        CurrencyEnum[CurrencyEnum["AMD"] = 'AMD'] = "AMD";
        CurrencyEnum[CurrencyEnum["ISK"] = 'ISK'] = "ISK";
        CurrencyEnum[CurrencyEnum["JPY"] = 'JPY'] = "JPY";
        CurrencyEnum[CurrencyEnum["GEL"] = 'GEL'] = "GEL";
        CurrencyEnum[CurrencyEnum["KZT"] = 'KZT'] = "KZT";
        CurrencyEnum[CurrencyEnum["KHR"] = 'KHR'] = "KHR";
        CurrencyEnum[CurrencyEnum["KRW"] = 'KRW'] = "KRW";
        CurrencyEnum[CurrencyEnum["KGS"] = 'KGS'] = "KGS";
        CurrencyEnum[CurrencyEnum["LAK"] = 'LAK'] = "LAK";
        CurrencyEnum[CurrencyEnum["MKD"] = 'MKD'] = "MKD";
        CurrencyEnum[CurrencyEnum["MNT"] = 'MNT'] = "MNT";
        CurrencyEnum[CurrencyEnum["BND"] = 'BND'] = "BND";
        CurrencyEnum[CurrencyEnum["MMK"] = 'MMK'] = "MMK";
        CurrencyEnum[CurrencyEnum["NOK"] = 'NOK'] = "NOK";
        CurrencyEnum[CurrencyEnum["NPR"] = 'NPR'] = "NPR";
        CurrencyEnum[CurrencyEnum["PKR"] = 'PKR'] = "PKR";
        CurrencyEnum[CurrencyEnum["PLN"] = 'PLN'] = "PLN";
        CurrencyEnum[CurrencyEnum["AFN"] = 'AFN'] = "AFN";
        CurrencyEnum[CurrencyEnum["BRL"] = 'BRL'] = "BRL";
        CurrencyEnum[CurrencyEnum["MDL"] = 'MDL'] = "MDL";
        CurrencyEnum[CurrencyEnum["RON"] = 'RON'] = "RON";
        CurrencyEnum[CurrencyEnum["RWF"] = 'RWF'] = "RWF";
        CurrencyEnum[CurrencyEnum["SEK"] = 'SEK'] = "SEK";
        CurrencyEnum[CurrencyEnum["LKR"] = 'LKR'] = "LKR";
        CurrencyEnum[CurrencyEnum["SOS"] = 'SOS'] = "SOS";
        CurrencyEnum[CurrencyEnum["ALL"] = 'ALL'] = "ALL";
        CurrencyEnum[CurrencyEnum["RSD"] = 'RSD'] = "RSD";
        CurrencyEnum[CurrencyEnum["KES"] = 'KES'] = "KES";
        CurrencyEnum[CurrencyEnum["TJS"] = 'TJS'] = "TJS";
        CurrencyEnum[CurrencyEnum["THB"] = 'THB'] = "THB";
        CurrencyEnum[CurrencyEnum["ERN"] = 'ERN'] = "ERN";
        CurrencyEnum[CurrencyEnum["TMT"] = 'TMT'] = "TMT";
        CurrencyEnum[CurrencyEnum["BWP"] = 'BWP'] = "BWP";
        CurrencyEnum[CurrencyEnum["TRY"] = 'TRY'] = "TRY";
        CurrencyEnum[CurrencyEnum["UAH"] = 'UAH'] = "UAH";
        CurrencyEnum[CurrencyEnum["UZS"] = 'UZS'] = "UZS";
        CurrencyEnum[CurrencyEnum["VND"] = 'VND'] = "VND";
        CurrencyEnum[CurrencyEnum["MOP"] = 'MOP'] = "MOP";
        CurrencyEnum[CurrencyEnum["TWD"] = 'TWD'] = "TWD";
        CurrencyEnum[CurrencyEnum["BMD"] = 'BMD'] = "BMD";
    })(CurrencyEnum = CustomerDeliveryTrackingOrder.CurrencyEnum || (CustomerDeliveryTrackingOrder.CurrencyEnum = {}));
})(CustomerDeliveryTrackingOrder || (exports.CustomerDeliveryTrackingOrder = CustomerDeliveryTrackingOrder = {}));
var EndUserFeeConfig;
(function (EndUserFeeConfig) {
    var ChannelEnum;
    (function (ChannelEnum) {
        ChannelEnum[ChannelEnum["WebApp"] = 'WebApp'] = "WebApp";
        ChannelEnum[ChannelEnum["InStore"] = 'InStore'] = "InStore";
        ChannelEnum[ChannelEnum["Kiosk"] = 'Kiosk'] = "Kiosk";
    })(ChannelEnum = EndUserFeeConfig.ChannelEnum || (EndUserFeeConfig.ChannelEnum = {}));
    var PaymentMethodEnum;
    (function (PaymentMethodEnum) {
        PaymentMethodEnum[PaymentMethodEnum["Cash"] = 'Cash'] = "Cash";
        PaymentMethodEnum[PaymentMethodEnum["Card"] = 'Card'] = "Card";
    })(PaymentMethodEnum = EndUserFeeConfig.PaymentMethodEnum || (EndUserFeeConfig.PaymentMethodEnum = {}));
})(EndUserFeeConfig || (exports.EndUserFeeConfig = EndUserFeeConfig = {}));
var ExecuteConfigurationActionResult;
(function (ExecuteConfigurationActionResult) {
    var RedirectTargetEnum;
    (function (RedirectTargetEnum) {
        RedirectTargetEnum[RedirectTargetEnum["Default"] = 'Default'] = "Default";
        RedirectTargetEnum[RedirectTargetEnum["NewWindow"] = 'NewWindow'] = "NewWindow";
        RedirectTargetEnum[RedirectTargetEnum["Popup"] = 'Popup'] = "Popup";
    })(RedirectTargetEnum = ExecuteConfigurationActionResult.RedirectTargetEnum || (ExecuteConfigurationActionResult.RedirectTargetEnum = {}));
})(ExecuteConfigurationActionResult || (exports.ExecuteConfigurationActionResult = ExecuteConfigurationActionResult = {}));
var Field;
(function (Field) {
    var FieldTypeEnum;
    (function (FieldTypeEnum) {
        FieldTypeEnum[FieldTypeEnum["Text"] = 'Text'] = "Text";
        FieldTypeEnum[FieldTypeEnum["TextArea"] = 'TextArea'] = "TextArea";
        FieldTypeEnum[FieldTypeEnum["Integer"] = 'Integer'] = "Integer";
        FieldTypeEnum[FieldTypeEnum["Decimal"] = 'Decimal'] = "Decimal";
        FieldTypeEnum[FieldTypeEnum["Date"] = 'Date'] = "Date";
        FieldTypeEnum[FieldTypeEnum["DateTime"] = 'DateTime'] = "DateTime";
        FieldTypeEnum[FieldTypeEnum["Time"] = 'Time'] = "Time";
        FieldTypeEnum[FieldTypeEnum["Select"] = 'Select'] = "Select";
        FieldTypeEnum[FieldTypeEnum["Boolean"] = 'Boolean'] = "Boolean";
        FieldTypeEnum[FieldTypeEnum["ActionButton"] = 'ActionButton'] = "ActionButton";
    })(FieldTypeEnum = Field.FieldTypeEnum || (Field.FieldTypeEnum = {}));
})(Field || (exports.Field = Field = {}));
var FulfillmentStatesConfiguration;
(function (FulfillmentStatesConfiguration) {
    var StoreSelectorTypeEnum;
    (function (StoreSelectorTypeEnum) {
        StoreSelectorTypeEnum[StoreSelectorTypeEnum["None"] = 'None'] = "None";
        StoreSelectorTypeEnum[StoreSelectorTypeEnum["Single"] = 'Single'] = "Single";
        StoreSelectorTypeEnum[StoreSelectorTypeEnum["Multiple"] = 'Multiple'] = "Multiple";
    })(StoreSelectorTypeEnum = FulfillmentStatesConfiguration.StoreSelectorTypeEnum || (FulfillmentStatesConfiguration.StoreSelectorTypeEnum = {}));
})(FulfillmentStatesConfiguration || (exports.FulfillmentStatesConfiguration = FulfillmentStatesConfiguration = {}));
var FulfillmentStatesConfigurationSummary;
(function (FulfillmentStatesConfigurationSummary) {
    var StoreSelectorTypeEnum;
    (function (StoreSelectorTypeEnum) {
        StoreSelectorTypeEnum[StoreSelectorTypeEnum["None"] = 'None'] = "None";
        StoreSelectorTypeEnum[StoreSelectorTypeEnum["Single"] = 'Single'] = "Single";
        StoreSelectorTypeEnum[StoreSelectorTypeEnum["Multiple"] = 'Multiple'] = "Multiple";
    })(StoreSelectorTypeEnum = FulfillmentStatesConfigurationSummary.StoreSelectorTypeEnum || (FulfillmentStatesConfigurationSummary.StoreSelectorTypeEnum = {}));
})(FulfillmentStatesConfigurationSummary || (exports.FulfillmentStatesConfigurationSummary = FulfillmentStatesConfigurationSummary = {}));
var FulfillmentStatusConfigurationItem;
(function (FulfillmentStatusConfigurationItem) {
    var ChangeTypeEnum;
    (function (ChangeTypeEnum) {
        ChangeTypeEnum[ChangeTypeEnum["Manual"] = 'Manual'] = "Manual";
        ChangeTypeEnum[ChangeTypeEnum["Automated"] = 'Automated'] = "Automated";
        ChangeTypeEnum[ChangeTypeEnum["Integrated"] = 'Integrated'] = "Integrated";
    })(ChangeTypeEnum = FulfillmentStatusConfigurationItem.ChangeTypeEnum || (FulfillmentStatusConfigurationItem.ChangeTypeEnum = {}));
    var OrderTypesEnum;
    (function (OrderTypesEnum) {
        OrderTypesEnum[OrderTypesEnum["All"] = 'All'] = "All";
        OrderTypesEnum[OrderTypesEnum["Delivery"] = 'Delivery'] = "Delivery";
        OrderTypesEnum[OrderTypesEnum["Collection"] = 'Collection'] = "Collection";
        OrderTypesEnum[OrderTypesEnum["DineIn"] = 'DineIn'] = "DineIn";
    })(OrderTypesEnum = FulfillmentStatusConfigurationItem.OrderTypesEnum || (FulfillmentStatusConfigurationItem.OrderTypesEnum = {}));
})(FulfillmentStatusConfigurationItem || (exports.FulfillmentStatusConfigurationItem = FulfillmentStatusConfigurationItem = {}));
var Group;
(function (Group) {
    var GroupTypeEnum;
    (function (GroupTypeEnum) {
        GroupTypeEnum[GroupTypeEnum["ModifierGroup"] = 'ModifierGroup'] = "ModifierGroup";
    })(GroupTypeEnum = Group.GroupTypeEnum || (Group.GroupTypeEnum = {}));
})(Group || (exports.Group = Group = {}));
var GroupReference;
(function (GroupReference) {
    var GroupTypeEnum;
    (function (GroupTypeEnum) {
        GroupTypeEnum[GroupTypeEnum["ModifierGroup"] = 'ModifierGroup'] = "ModifierGroup";
    })(GroupTypeEnum = GroupReference.GroupTypeEnum || (GroupReference.GroupTypeEnum = {}));
})(GroupReference || (exports.GroupReference = GroupReference = {}));
var HomeAction;
(function (HomeAction) {
    var HomeActionTypeEnum;
    (function (HomeActionTypeEnum) {
        HomeActionTypeEnum[HomeActionTypeEnum["Portal"] = 'Portal'] = "Portal";
        HomeActionTypeEnum[HomeActionTypeEnum["External"] = 'External'] = "External";
    })(HomeActionTypeEnum = HomeAction.HomeActionTypeEnum || (HomeAction.HomeActionTypeEnum = {}));
})(HomeAction || (exports.HomeAction = HomeAction = {}));
var HydraConfig;
(function (HydraConfig) {
    var PaymentOptionsEnum;
    (function (PaymentOptionsEnum) {
        PaymentOptionsEnum[PaymentOptionsEnum["Online"] = 'Online'] = "Online";
        PaymentOptionsEnum[PaymentOptionsEnum["Emv"] = 'Emv'] = "Emv";
        PaymentOptionsEnum[PaymentOptionsEnum["Counter"] = 'Counter'] = "Counter";
    })(PaymentOptionsEnum = HydraConfig.PaymentOptionsEnum || (HydraConfig.PaymentOptionsEnum = {}));
})(HydraConfig || (exports.HydraConfig = HydraConfig = {}));
var HydraConnectionStatusChangedEvent;
(function (HydraConnectionStatusChangedEvent) {
    var HydraDeviceStatusEnum;
    (function (HydraDeviceStatusEnum) {
        HydraDeviceStatusEnum[HydraDeviceStatusEnum["Online"] = 'Online'] = "Online";
        HydraDeviceStatusEnum[HydraDeviceStatusEnum["PossiblyOffline"] = 'PossiblyOffline'] = "PossiblyOffline";
        HydraDeviceStatusEnum[HydraDeviceStatusEnum["Offline"] = 'Offline'] = "Offline";
    })(HydraDeviceStatusEnum = HydraConnectionStatusChangedEvent.HydraDeviceStatusEnum || (HydraConnectionStatusChangedEvent.HydraDeviceStatusEnum = {}));
})(HydraConnectionStatusChangedEvent || (exports.HydraConnectionStatusChangedEvent = HydraConnectionStatusChangedEvent = {}));
var HydraCreatedEvent;
(function (HydraCreatedEvent) {
    var UserTypeEnum;
    (function (UserTypeEnum) {
        UserTypeEnum[UserTypeEnum["Kiosk"] = 'Kiosk'] = "Kiosk";
        UserTypeEnum[UserTypeEnum["Terminal"] = 'Terminal'] = "Terminal";
        UserTypeEnum[UserTypeEnum["LegacyPrinter"] = 'LegacyPrinter'] = "LegacyPrinter";
    })(UserTypeEnum = HydraCreatedEvent.UserTypeEnum || (HydraCreatedEvent.UserTypeEnum = {}));
    var DeviceTypeEnum;
    (function (DeviceTypeEnum) {
        DeviceTypeEnum[DeviceTypeEnum["Kiosk"] = 'Kiosk'] = "Kiosk";
        DeviceTypeEnum[DeviceTypeEnum["Terminal"] = 'Terminal'] = "Terminal";
        DeviceTypeEnum[DeviceTypeEnum["LegacyPrinter"] = 'LegacyPrinter'] = "LegacyPrinter";
    })(DeviceTypeEnum = HydraCreatedEvent.DeviceTypeEnum || (HydraCreatedEvent.DeviceTypeEnum = {}));
})(HydraCreatedEvent || (exports.HydraCreatedEvent = HydraCreatedEvent = {}));
var HydraDeviceDetails;
(function (HydraDeviceDetails) {
    var DeviceTypeEnum;
    (function (DeviceTypeEnum) {
        DeviceTypeEnum[DeviceTypeEnum["Kiosk"] = 'Kiosk'] = "Kiosk";
        DeviceTypeEnum[DeviceTypeEnum["Terminal"] = 'Terminal'] = "Terminal";
        DeviceTypeEnum[DeviceTypeEnum["LegacyPrinter"] = 'LegacyPrinter'] = "LegacyPrinter";
    })(DeviceTypeEnum = HydraDeviceDetails.DeviceTypeEnum || (HydraDeviceDetails.DeviceTypeEnum = {}));
    var StatusEnum;
    (function (StatusEnum) {
        StatusEnum[StatusEnum["Online"] = 'Online'] = "Online";
        StatusEnum[StatusEnum["PossiblyOffline"] = 'PossiblyOffline'] = "PossiblyOffline";
        StatusEnum[StatusEnum["Offline"] = 'Offline'] = "Offline";
    })(StatusEnum = HydraDeviceDetails.StatusEnum || (HydraDeviceDetails.StatusEnum = {}));
})(HydraDeviceDetails || (exports.HydraDeviceDetails = HydraDeviceDetails = {}));
var HydraStatus;
(function (HydraStatus) {
    var UserTypeEnum;
    (function (UserTypeEnum) {
        UserTypeEnum[UserTypeEnum["Kiosk"] = 'Kiosk'] = "Kiosk";
        UserTypeEnum[UserTypeEnum["Terminal"] = 'Terminal'] = "Terminal";
        UserTypeEnum[UserTypeEnum["LegacyPrinter"] = 'LegacyPrinter'] = "LegacyPrinter";
    })(UserTypeEnum = HydraStatus.UserTypeEnum || (HydraStatus.UserTypeEnum = {}));
    var DeviceTypeEnum;
    (function (DeviceTypeEnum) {
        DeviceTypeEnum[DeviceTypeEnum["Kiosk"] = 'Kiosk'] = "Kiosk";
        DeviceTypeEnum[DeviceTypeEnum["Terminal"] = 'Terminal'] = "Terminal";
        DeviceTypeEnum[DeviceTypeEnum["LegacyPrinter"] = 'LegacyPrinter'] = "LegacyPrinter";
    })(DeviceTypeEnum = HydraStatus.DeviceTypeEnum || (HydraStatus.DeviceTypeEnum = {}));
})(HydraStatus || (exports.HydraStatus = HydraStatus = {}));
var KioskBluetoothInstallUpdateInitiateEvent;
(function (KioskBluetoothInstallUpdateInitiateEvent) {
    var BluetoothTerminalTypeEnum;
    (function (BluetoothTerminalTypeEnum) {
        BluetoothTerminalTypeEnum[BluetoothTerminalTypeEnum["CHIPPER2X"] = 'CHIPPER_2X'] = "CHIPPER2X";
        BluetoothTerminalTypeEnum[BluetoothTerminalTypeEnum["COTSDEVICE"] = 'COTS_DEVICE'] = "COTSDEVICE";
        BluetoothTerminalTypeEnum[BluetoothTerminalTypeEnum["VERIFONEP400"] = 'VERIFONE_P400'] = "VERIFONEP400";
        BluetoothTerminalTypeEnum[BluetoothTerminalTypeEnum["WISEPAD3"] = 'WISEPAD_3'] = "WISEPAD3";
        BluetoothTerminalTypeEnum[BluetoothTerminalTypeEnum["WISEPOSE"] = 'WISEPOS_E'] = "WISEPOSE";
    })(BluetoothTerminalTypeEnum = KioskBluetoothInstallUpdateInitiateEvent.BluetoothTerminalTypeEnum || (KioskBluetoothInstallUpdateInitiateEvent.BluetoothTerminalTypeEnum = {}));
})(KioskBluetoothInstallUpdateInitiateEvent || (exports.KioskBluetoothInstallUpdateInitiateEvent = KioskBluetoothInstallUpdateInitiateEvent = {}));
var KioskBluetoothPairingModeEvent;
(function (KioskBluetoothPairingModeEvent) {
    var BluetoothTerminalTypeEnum;
    (function (BluetoothTerminalTypeEnum) {
        BluetoothTerminalTypeEnum[BluetoothTerminalTypeEnum["CHIPPER2X"] = 'CHIPPER_2X'] = "CHIPPER2X";
        BluetoothTerminalTypeEnum[BluetoothTerminalTypeEnum["COTSDEVICE"] = 'COTS_DEVICE'] = "COTSDEVICE";
        BluetoothTerminalTypeEnum[BluetoothTerminalTypeEnum["VERIFONEP400"] = 'VERIFONE_P400'] = "VERIFONEP400";
        BluetoothTerminalTypeEnum[BluetoothTerminalTypeEnum["WISEPAD3"] = 'WISEPAD_3'] = "WISEPAD3";
        BluetoothTerminalTypeEnum[BluetoothTerminalTypeEnum["WISEPOSE"] = 'WISEPOS_E'] = "WISEPOSE";
    })(BluetoothTerminalTypeEnum = KioskBluetoothPairingModeEvent.BluetoothTerminalTypeEnum || (KioskBluetoothPairingModeEvent.BluetoothTerminalTypeEnum = {}));
})(KioskBluetoothPairingModeEvent || (exports.KioskBluetoothPairingModeEvent = KioskBluetoothPairingModeEvent = {}));
var KioskBluetoothTerminalCancelUpdateEvent;
(function (KioskBluetoothTerminalCancelUpdateEvent) {
    var BluetoothTerminalTypeEnum;
    (function (BluetoothTerminalTypeEnum) {
        BluetoothTerminalTypeEnum[BluetoothTerminalTypeEnum["CHIPPER2X"] = 'CHIPPER_2X'] = "CHIPPER2X";
        BluetoothTerminalTypeEnum[BluetoothTerminalTypeEnum["COTSDEVICE"] = 'COTS_DEVICE'] = "COTSDEVICE";
        BluetoothTerminalTypeEnum[BluetoothTerminalTypeEnum["VERIFONEP400"] = 'VERIFONE_P400'] = "VERIFONEP400";
        BluetoothTerminalTypeEnum[BluetoothTerminalTypeEnum["WISEPAD3"] = 'WISEPAD_3'] = "WISEPAD3";
        BluetoothTerminalTypeEnum[BluetoothTerminalTypeEnum["WISEPOSE"] = 'WISEPOS_E'] = "WISEPOSE";
    })(BluetoothTerminalTypeEnum = KioskBluetoothTerminalCancelUpdateEvent.BluetoothTerminalTypeEnum || (KioskBluetoothTerminalCancelUpdateEvent.BluetoothTerminalTypeEnum = {}));
})(KioskBluetoothTerminalCancelUpdateEvent || (exports.KioskBluetoothTerminalCancelUpdateEvent = KioskBluetoothTerminalCancelUpdateEvent = {}));
var KioskBluetoothTerminalFirmwareVersionStatusEvent;
(function (KioskBluetoothTerminalFirmwareVersionStatusEvent) {
    var UpdateTimeEstimateEnum;
    (function (UpdateTimeEstimateEnum) {
        UpdateTimeEstimateEnum[UpdateTimeEstimateEnum["LessThanOneMinute"] = 'LessThanOneMinute'] = "LessThanOneMinute";
        UpdateTimeEstimateEnum[UpdateTimeEstimateEnum["OneToTwoMinutes"] = 'OneToTwoMinutes'] = "OneToTwoMinutes";
        UpdateTimeEstimateEnum[UpdateTimeEstimateEnum["TwoToFiveMinutes"] = 'TwoToFiveMinutes'] = "TwoToFiveMinutes";
        UpdateTimeEstimateEnum[UpdateTimeEstimateEnum["FiveToFifteenMinutes"] = 'FiveToFifteenMinutes'] = "FiveToFifteenMinutes";
    })(UpdateTimeEstimateEnum = KioskBluetoothTerminalFirmwareVersionStatusEvent.UpdateTimeEstimateEnum || (KioskBluetoothTerminalFirmwareVersionStatusEvent.UpdateTimeEstimateEnum = {}));
})(KioskBluetoothTerminalFirmwareVersionStatusEvent || (exports.KioskBluetoothTerminalFirmwareVersionStatusEvent = KioskBluetoothTerminalFirmwareVersionStatusEvent = {}));
var KioskBluetoothTerminalInstallationStatusEvent;
(function (KioskBluetoothTerminalInstallationStatusEvent) {
    var BluetoothTerminalTypeEnum;
    (function (BluetoothTerminalTypeEnum) {
        BluetoothTerminalTypeEnum[BluetoothTerminalTypeEnum["CHIPPER2X"] = 'CHIPPER_2X'] = "CHIPPER2X";
        BluetoothTerminalTypeEnum[BluetoothTerminalTypeEnum["COTSDEVICE"] = 'COTS_DEVICE'] = "COTSDEVICE";
        BluetoothTerminalTypeEnum[BluetoothTerminalTypeEnum["VERIFONEP400"] = 'VERIFONE_P400'] = "VERIFONEP400";
        BluetoothTerminalTypeEnum[BluetoothTerminalTypeEnum["WISEPAD3"] = 'WISEPAD_3'] = "WISEPAD3";
        BluetoothTerminalTypeEnum[BluetoothTerminalTypeEnum["WISEPOSE"] = 'WISEPOS_E'] = "WISEPOSE";
    })(BluetoothTerminalTypeEnum = KioskBluetoothTerminalInstallationStatusEvent.BluetoothTerminalTypeEnum || (KioskBluetoothTerminalInstallationStatusEvent.BluetoothTerminalTypeEnum = {}));
})(KioskBluetoothTerminalInstallationStatusEvent || (exports.KioskBluetoothTerminalInstallationStatusEvent = KioskBluetoothTerminalInstallationStatusEvent = {}));
var KioskBluetoothTerminalUnpairedEvent;
(function (KioskBluetoothTerminalUnpairedEvent) {
    var BluetoothTerminalTypeEnum;
    (function (BluetoothTerminalTypeEnum) {
        BluetoothTerminalTypeEnum[BluetoothTerminalTypeEnum["CHIPPER2X"] = 'CHIPPER_2X'] = "CHIPPER2X";
        BluetoothTerminalTypeEnum[BluetoothTerminalTypeEnum["COTSDEVICE"] = 'COTS_DEVICE'] = "COTSDEVICE";
        BluetoothTerminalTypeEnum[BluetoothTerminalTypeEnum["VERIFONEP400"] = 'VERIFONE_P400'] = "VERIFONEP400";
        BluetoothTerminalTypeEnum[BluetoothTerminalTypeEnum["WISEPAD3"] = 'WISEPAD_3'] = "WISEPAD3";
        BluetoothTerminalTypeEnum[BluetoothTerminalTypeEnum["WISEPOSE"] = 'WISEPOS_E'] = "WISEPOSE";
    })(BluetoothTerminalTypeEnum = KioskBluetoothTerminalUnpairedEvent.BluetoothTerminalTypeEnum || (KioskBluetoothTerminalUnpairedEvent.BluetoothTerminalTypeEnum = {}));
})(KioskBluetoothTerminalUnpairedEvent || (exports.KioskBluetoothTerminalUnpairedEvent = KioskBluetoothTerminalUnpairedEvent = {}));
var KioskBluetoothTerminalUpdatedEvent;
(function (KioskBluetoothTerminalUpdatedEvent) {
    var BluetoothTerminalTypeEnum;
    (function (BluetoothTerminalTypeEnum) {
        BluetoothTerminalTypeEnum[BluetoothTerminalTypeEnum["CHIPPER2X"] = 'CHIPPER_2X'] = "CHIPPER2X";
        BluetoothTerminalTypeEnum[BluetoothTerminalTypeEnum["COTSDEVICE"] = 'COTS_DEVICE'] = "COTSDEVICE";
        BluetoothTerminalTypeEnum[BluetoothTerminalTypeEnum["VERIFONEP400"] = 'VERIFONE_P400'] = "VERIFONEP400";
        BluetoothTerminalTypeEnum[BluetoothTerminalTypeEnum["WISEPAD3"] = 'WISEPAD_3'] = "WISEPAD3";
        BluetoothTerminalTypeEnum[BluetoothTerminalTypeEnum["WISEPOSE"] = 'WISEPOS_E'] = "WISEPOSE";
    })(BluetoothTerminalTypeEnum = KioskBluetoothTerminalUpdatedEvent.BluetoothTerminalTypeEnum || (KioskBluetoothTerminalUpdatedEvent.BluetoothTerminalTypeEnum = {}));
})(KioskBluetoothTerminalUpdatedEvent || (exports.KioskBluetoothTerminalUpdatedEvent = KioskBluetoothTerminalUpdatedEvent = {}));
var KioskBluetoothUnpairingModeEvent;
(function (KioskBluetoothUnpairingModeEvent) {
    var BluetoothTerminalTypeEnum;
    (function (BluetoothTerminalTypeEnum) {
        BluetoothTerminalTypeEnum[BluetoothTerminalTypeEnum["CHIPPER2X"] = 'CHIPPER_2X'] = "CHIPPER2X";
        BluetoothTerminalTypeEnum[BluetoothTerminalTypeEnum["COTSDEVICE"] = 'COTS_DEVICE'] = "COTSDEVICE";
        BluetoothTerminalTypeEnum[BluetoothTerminalTypeEnum["VERIFONEP400"] = 'VERIFONE_P400'] = "VERIFONEP400";
        BluetoothTerminalTypeEnum[BluetoothTerminalTypeEnum["WISEPAD3"] = 'WISEPAD_3'] = "WISEPAD3";
        BluetoothTerminalTypeEnum[BluetoothTerminalTypeEnum["WISEPOSE"] = 'WISEPOS_E'] = "WISEPOSE";
    })(BluetoothTerminalTypeEnum = KioskBluetoothUnpairingModeEvent.BluetoothTerminalTypeEnum || (KioskBluetoothUnpairingModeEvent.BluetoothTerminalTypeEnum = {}));
})(KioskBluetoothUnpairingModeEvent || (exports.KioskBluetoothUnpairingModeEvent = KioskBluetoothUnpairingModeEvent = {}));
var KioskTerminalActionStateChangedEvent;
(function (KioskTerminalActionStateChangedEvent) {
    var BluetoothTerminalTypeEnum;
    (function (BluetoothTerminalTypeEnum) {
        BluetoothTerminalTypeEnum[BluetoothTerminalTypeEnum["CHIPPER2X"] = 'CHIPPER_2X'] = "CHIPPER2X";
        BluetoothTerminalTypeEnum[BluetoothTerminalTypeEnum["COTSDEVICE"] = 'COTS_DEVICE'] = "COTSDEVICE";
        BluetoothTerminalTypeEnum[BluetoothTerminalTypeEnum["VERIFONEP400"] = 'VERIFONE_P400'] = "VERIFONEP400";
        BluetoothTerminalTypeEnum[BluetoothTerminalTypeEnum["WISEPAD3"] = 'WISEPAD_3'] = "WISEPAD3";
        BluetoothTerminalTypeEnum[BluetoothTerminalTypeEnum["WISEPOSE"] = 'WISEPOS_E'] = "WISEPOSE";
    })(BluetoothTerminalTypeEnum = KioskTerminalActionStateChangedEvent.BluetoothTerminalTypeEnum || (KioskTerminalActionStateChangedEvent.BluetoothTerminalTypeEnum = {}));
})(KioskTerminalActionStateChangedEvent || (exports.KioskTerminalActionStateChangedEvent = KioskTerminalActionStateChangedEvent = {}));
var LightspeedSettings;
(function (LightspeedSettings) {
    var PriceTypeEnum;
    (function (PriceTypeEnum) {
        PriceTypeEnum[PriceTypeEnum["Default"] = 'Default'] = "Default";
        PriceTypeEnum[PriceTypeEnum["Takeaway"] = 'Takeaway'] = "Takeaway";
        PriceTypeEnum[PriceTypeEnum["Delivery"] = 'Delivery'] = "Delivery";
    })(PriceTypeEnum = LightspeedSettings.PriceTypeEnum || (LightspeedSettings.PriceTypeEnum = {}));
})(LightspeedSettings || (exports.LightspeedSettings = LightspeedSettings = {}));
var Menu;
(function (Menu) {
    var MenuSectionBehaviourEnum;
    (function (MenuSectionBehaviourEnum) {
        MenuSectionBehaviourEnum[MenuSectionBehaviourEnum["ExpandSingle"] = 'ExpandSingle'] = "ExpandSingle";
        MenuSectionBehaviourEnum[MenuSectionBehaviourEnum["ExpandMultiple"] = 'ExpandMultiple'] = "ExpandMultiple";
    })(MenuSectionBehaviourEnum = Menu.MenuSectionBehaviourEnum || (Menu.MenuSectionBehaviourEnum = {}));
    var TaxTypeEnum;
    (function (TaxTypeEnum) {
        TaxTypeEnum[TaxTypeEnum["IncludedInBasePrice"] = 'IncludedInBasePrice'] = "IncludedInBasePrice";
        TaxTypeEnum[TaxTypeEnum["ExcludedFromBasePrice"] = 'ExcludedFromBasePrice'] = "ExcludedFromBasePrice";
    })(TaxTypeEnum = Menu.TaxTypeEnum || (Menu.TaxTypeEnum = {}));
})(Menu || (exports.Menu = Menu = {}));
var MenuBase;
(function (MenuBase) {
    var MenuSectionBehaviourEnum;
    (function (MenuSectionBehaviourEnum) {
        MenuSectionBehaviourEnum[MenuSectionBehaviourEnum["ExpandSingle"] = 'ExpandSingle'] = "ExpandSingle";
        MenuSectionBehaviourEnum[MenuSectionBehaviourEnum["ExpandMultiple"] = 'ExpandMultiple'] = "ExpandMultiple";
    })(MenuSectionBehaviourEnum = MenuBase.MenuSectionBehaviourEnum || (MenuBase.MenuSectionBehaviourEnum = {}));
    var TaxTypeEnum;
    (function (TaxTypeEnum) {
        TaxTypeEnum[TaxTypeEnum["IncludedInBasePrice"] = 'IncludedInBasePrice'] = "IncludedInBasePrice";
        TaxTypeEnum[TaxTypeEnum["ExcludedFromBasePrice"] = 'ExcludedFromBasePrice'] = "ExcludedFromBasePrice";
    })(TaxTypeEnum = MenuBase.TaxTypeEnum || (MenuBase.TaxTypeEnum = {}));
})(MenuBase || (exports.MenuBase = MenuBase = {}));
var MenuCatalogItem;
(function (MenuCatalogItem) {
    var CellLayoutTypeEnum;
    (function (CellLayoutTypeEnum) {
        CellLayoutTypeEnum[CellLayoutTypeEnum["Small"] = 'Small'] = "Small";
        CellLayoutTypeEnum[CellLayoutTypeEnum["Medium"] = 'Medium'] = "Medium";
        CellLayoutTypeEnum[CellLayoutTypeEnum["Large"] = 'Large'] = "Large";
        CellLayoutTypeEnum[CellLayoutTypeEnum["HiddenImage"] = 'HiddenImage'] = "HiddenImage";
    })(CellLayoutTypeEnum = MenuCatalogItem.CellLayoutTypeEnum || (MenuCatalogItem.CellLayoutTypeEnum = {}));
})(MenuCatalogItem || (exports.MenuCatalogItem = MenuCatalogItem = {}));
var MenuElementEditResponse;
(function (MenuElementEditResponse) {
    var MenuElementTypeEnum;
    (function (MenuElementTypeEnum) {
        MenuElementTypeEnum[MenuElementTypeEnum["Item"] = 'Item'] = "Item";
        MenuElementTypeEnum[MenuElementTypeEnum["OptionSetItem"] = 'OptionSetItem'] = "OptionSetItem";
    })(MenuElementTypeEnum = MenuElementEditResponse.MenuElementTypeEnum || (MenuElementEditResponse.MenuElementTypeEnum = {}));
    var ValidationCodeEnum;
    (function (ValidationCodeEnum) {
        ValidationCodeEnum[ValidationCodeEnum["Success"] = 'Success'] = "Success";
        ValidationCodeEnum[ValidationCodeEnum["MinimumCountViolation"] = 'MinimumCountViolation'] = "MinimumCountViolation";
        ValidationCodeEnum[ValidationCodeEnum["MasterOptionSetViolation"] = 'MasterOptionSetViolation'] = "MasterOptionSetViolation";
        ValidationCodeEnum[ValidationCodeEnum["IncorrectElementTypeInMenu"] = 'IncorrectElementTypeInMenu'] = "IncorrectElementTypeInMenu";
        ValidationCodeEnum[ValidationCodeEnum["DBFailed"] = 'DBFailed'] = "DBFailed";
    })(ValidationCodeEnum = MenuElementEditResponse.ValidationCodeEnum || (MenuElementEditResponse.ValidationCodeEnum = {}));
})(MenuElementEditResponse || (exports.MenuElementEditResponse = MenuElementEditResponse = {}));
var MenuElementHide;
(function (MenuElementHide) {
    var MenuElementTypeEnum;
    (function (MenuElementTypeEnum) {
        MenuElementTypeEnum[MenuElementTypeEnum["Item"] = 'Item'] = "Item";
        MenuElementTypeEnum[MenuElementTypeEnum["OptionSetItem"] = 'OptionSetItem'] = "OptionSetItem";
    })(MenuElementTypeEnum = MenuElementHide.MenuElementTypeEnum || (MenuElementHide.MenuElementTypeEnum = {}));
})(MenuElementHide || (exports.MenuElementHide = MenuElementHide = {}));
var MenuElementListItemResponse;
(function (MenuElementListItemResponse) {
    var MenuElementTypeEnum;
    (function (MenuElementTypeEnum) {
        MenuElementTypeEnum[MenuElementTypeEnum["Item"] = 'Item'] = "Item";
        MenuElementTypeEnum[MenuElementTypeEnum["OptionSetItem"] = 'OptionSetItem'] = "OptionSetItem";
    })(MenuElementTypeEnum = MenuElementListItemResponse.MenuElementTypeEnum || (MenuElementListItemResponse.MenuElementTypeEnum = {}));
})(MenuElementListItemResponse || (exports.MenuElementListItemResponse = MenuElementListItemResponse = {}));
var MenuItemOptionSet;
(function (MenuItemOptionSet) {
    var CellLayoutTypeEnum;
    (function (CellLayoutTypeEnum) {
        CellLayoutTypeEnum[CellLayoutTypeEnum["Small"] = 'Small'] = "Small";
        CellLayoutTypeEnum[CellLayoutTypeEnum["Medium"] = 'Medium'] = "Medium";
        CellLayoutTypeEnum[CellLayoutTypeEnum["Large"] = 'Large'] = "Large";
        CellLayoutTypeEnum[CellLayoutTypeEnum["HiddenImage"] = 'HiddenImage'] = "HiddenImage";
    })(CellLayoutTypeEnum = MenuItemOptionSet.CellLayoutTypeEnum || (MenuItemOptionSet.CellLayoutTypeEnum = {}));
})(MenuItemOptionSet || (exports.MenuItemOptionSet = MenuItemOptionSet = {}));
var MenuItemOptionSetBase;
(function (MenuItemOptionSetBase) {
    var CellLayoutTypeEnum;
    (function (CellLayoutTypeEnum) {
        CellLayoutTypeEnum[CellLayoutTypeEnum["Small"] = 'Small'] = "Small";
        CellLayoutTypeEnum[CellLayoutTypeEnum["Medium"] = 'Medium'] = "Medium";
        CellLayoutTypeEnum[CellLayoutTypeEnum["Large"] = 'Large'] = "Large";
        CellLayoutTypeEnum[CellLayoutTypeEnum["HiddenImage"] = 'HiddenImage'] = "HiddenImage";
    })(CellLayoutTypeEnum = MenuItemOptionSetBase.CellLayoutTypeEnum || (MenuItemOptionSetBase.CellLayoutTypeEnum = {}));
})(MenuItemOptionSetBase || (exports.MenuItemOptionSetBase = MenuItemOptionSetBase = {}));
var MenuItemOptionSetItem;
(function (MenuItemOptionSetItem) {
    var CellLayoutTypeEnum;
    (function (CellLayoutTypeEnum) {
        CellLayoutTypeEnum[CellLayoutTypeEnum["Small"] = 'Small'] = "Small";
        CellLayoutTypeEnum[CellLayoutTypeEnum["Medium"] = 'Medium'] = "Medium";
        CellLayoutTypeEnum[CellLayoutTypeEnum["Large"] = 'Large'] = "Large";
        CellLayoutTypeEnum[CellLayoutTypeEnum["HiddenImage"] = 'HiddenImage'] = "HiddenImage";
    })(CellLayoutTypeEnum = MenuItemOptionSetItem.CellLayoutTypeEnum || (MenuItemOptionSetItem.CellLayoutTypeEnum = {}));
})(MenuItemOptionSetItem || (exports.MenuItemOptionSetItem = MenuItemOptionSetItem = {}));
var MenuItemOptionSetItemBase;
(function (MenuItemOptionSetItemBase) {
    var CellLayoutTypeEnum;
    (function (CellLayoutTypeEnum) {
        CellLayoutTypeEnum[CellLayoutTypeEnum["Small"] = 'Small'] = "Small";
        CellLayoutTypeEnum[CellLayoutTypeEnum["Medium"] = 'Medium'] = "Medium";
        CellLayoutTypeEnum[CellLayoutTypeEnum["Large"] = 'Large'] = "Large";
        CellLayoutTypeEnum[CellLayoutTypeEnum["HiddenImage"] = 'HiddenImage'] = "HiddenImage";
    })(CellLayoutTypeEnum = MenuItemOptionSetItemBase.CellLayoutTypeEnum || (MenuItemOptionSetItemBase.CellLayoutTypeEnum = {}));
})(MenuItemOptionSetItemBase || (exports.MenuItemOptionSetItemBase = MenuItemOptionSetItemBase = {}));
var MenuSectionAvailability;
(function (MenuSectionAvailability) {
    var AvailabilityModeEnum;
    (function (AvailabilityModeEnum) {
        AvailabilityModeEnum[AvailabilityModeEnum["DisplayAlways"] = 'DisplayAlways'] = "DisplayAlways";
        AvailabilityModeEnum[AvailabilityModeEnum["DisplayBasedOnTimes"] = 'DisplayBasedOnTimes'] = "DisplayBasedOnTimes";
        AvailabilityModeEnum[AvailabilityModeEnum["DisplayAlwaysStartCollapsed"] = 'DisplayAlwaysStartCollapsed'] = "DisplayAlwaysStartCollapsed";
        AvailabilityModeEnum[AvailabilityModeEnum["DisplayAlwaysStartCollapsedBasedOnTimes"] = 'DisplayAlwaysStartCollapsedBasedOnTimes'] = "DisplayAlwaysStartCollapsedBasedOnTimes";
    })(AvailabilityModeEnum = MenuSectionAvailability.AvailabilityModeEnum || (MenuSectionAvailability.AvailabilityModeEnum = {}));
})(MenuSectionAvailability || (exports.MenuSectionAvailability = MenuSectionAvailability = {}));
var MenuSectionAvailabilityBase;
(function (MenuSectionAvailabilityBase) {
    var AvailabilityModeEnum;
    (function (AvailabilityModeEnum) {
        AvailabilityModeEnum[AvailabilityModeEnum["DisplayAlways"] = 'DisplayAlways'] = "DisplayAlways";
        AvailabilityModeEnum[AvailabilityModeEnum["DisplayBasedOnTimes"] = 'DisplayBasedOnTimes'] = "DisplayBasedOnTimes";
        AvailabilityModeEnum[AvailabilityModeEnum["DisplayAlwaysStartCollapsed"] = 'DisplayAlwaysStartCollapsed'] = "DisplayAlwaysStartCollapsed";
        AvailabilityModeEnum[AvailabilityModeEnum["DisplayAlwaysStartCollapsedBasedOnTimes"] = 'DisplayAlwaysStartCollapsedBasedOnTimes'] = "DisplayAlwaysStartCollapsedBasedOnTimes";
    })(AvailabilityModeEnum = MenuSectionAvailabilityBase.AvailabilityModeEnum || (MenuSectionAvailabilityBase.AvailabilityModeEnum = {}));
})(MenuSectionAvailabilityBase || (exports.MenuSectionAvailabilityBase = MenuSectionAvailabilityBase = {}));
var MenuSectionItem;
(function (MenuSectionItem) {
    var SpicinessRatingEnum;
    (function (SpicinessRatingEnum) {
        SpicinessRatingEnum[SpicinessRatingEnum["NotRated"] = 'NotRated'] = "NotRated";
        SpicinessRatingEnum[SpicinessRatingEnum["Mild"] = 'Mild'] = "Mild";
        SpicinessRatingEnum[SpicinessRatingEnum["Medium"] = 'Medium'] = "Medium";
        SpicinessRatingEnum[SpicinessRatingEnum["Hot"] = 'Hot'] = "Hot";
    })(SpicinessRatingEnum = MenuSectionItem.SpicinessRatingEnum || (MenuSectionItem.SpicinessRatingEnum = {}));
    var CellLayoutTypeEnum;
    (function (CellLayoutTypeEnum) {
        CellLayoutTypeEnum[CellLayoutTypeEnum["Small"] = 'Small'] = "Small";
        CellLayoutTypeEnum[CellLayoutTypeEnum["Medium"] = 'Medium'] = "Medium";
        CellLayoutTypeEnum[CellLayoutTypeEnum["Large"] = 'Large'] = "Large";
        CellLayoutTypeEnum[CellLayoutTypeEnum["HiddenImage"] = 'HiddenImage'] = "HiddenImage";
    })(CellLayoutTypeEnum = MenuSectionItem.CellLayoutTypeEnum || (MenuSectionItem.CellLayoutTypeEnum = {}));
})(MenuSectionItem || (exports.MenuSectionItem = MenuSectionItem = {}));
var MenuSectionItemBase;
(function (MenuSectionItemBase) {
    var SpicinessRatingEnum;
    (function (SpicinessRatingEnum) {
        SpicinessRatingEnum[SpicinessRatingEnum["NotRated"] = 'NotRated'] = "NotRated";
        SpicinessRatingEnum[SpicinessRatingEnum["Mild"] = 'Mild'] = "Mild";
        SpicinessRatingEnum[SpicinessRatingEnum["Medium"] = 'Medium'] = "Medium";
        SpicinessRatingEnum[SpicinessRatingEnum["Hot"] = 'Hot'] = "Hot";
    })(SpicinessRatingEnum = MenuSectionItemBase.SpicinessRatingEnum || (MenuSectionItemBase.SpicinessRatingEnum = {}));
    var CellLayoutTypeEnum;
    (function (CellLayoutTypeEnum) {
        CellLayoutTypeEnum[CellLayoutTypeEnum["Small"] = 'Small'] = "Small";
        CellLayoutTypeEnum[CellLayoutTypeEnum["Medium"] = 'Medium'] = "Medium";
        CellLayoutTypeEnum[CellLayoutTypeEnum["Large"] = 'Large'] = "Large";
        CellLayoutTypeEnum[CellLayoutTypeEnum["HiddenImage"] = 'HiddenImage'] = "HiddenImage";
    })(CellLayoutTypeEnum = MenuSectionItemBase.CellLayoutTypeEnum || (MenuSectionItemBase.CellLayoutTypeEnum = {}));
})(MenuSectionItemBase || (exports.MenuSectionItemBase = MenuSectionItemBase = {}));
var MenuTaxDetails;
(function (MenuTaxDetails) {
    var TaxTypeEnum;
    (function (TaxTypeEnum) {
        TaxTypeEnum[TaxTypeEnum["IncludedInBasePrice"] = 'IncludedInBasePrice'] = "IncludedInBasePrice";
        TaxTypeEnum[TaxTypeEnum["ExcludedFromBasePrice"] = 'ExcludedFromBasePrice'] = "ExcludedFromBasePrice";
    })(TaxTypeEnum = MenuTaxDetails.TaxTypeEnum || (MenuTaxDetails.TaxTypeEnum = {}));
})(MenuTaxDetails || (exports.MenuTaxDetails = MenuTaxDetails = {}));
var MetafieldDefinition;
(function (MetafieldDefinition) {
    var OwnerEntityEnum;
    (function (OwnerEntityEnum) {
        OwnerEntityEnum[OwnerEntityEnum["CatalogItem"] = 'CatalogItem'] = "CatalogItem";
        OwnerEntityEnum[OwnerEntityEnum["CatalogGroup"] = 'CatalogGroup'] = "CatalogGroup";
        OwnerEntityEnum[OwnerEntityEnum["Menu"] = 'Menu'] = "Menu";
    })(OwnerEntityEnum = MetafieldDefinition.OwnerEntityEnum || (MetafieldDefinition.OwnerEntityEnum = {}));
    var ValueTypeEnum;
    (function (ValueTypeEnum) {
        ValueTypeEnum[ValueTypeEnum["Boolean"] = 'Boolean'] = "Boolean";
        ValueTypeEnum[ValueTypeEnum["Json"] = 'Json'] = "Json";
        ValueTypeEnum[ValueTypeEnum["SingleLineString"] = 'SingleLineString'] = "SingleLineString";
        ValueTypeEnum[ValueTypeEnum["MultiLineString"] = 'MultiLineString'] = "MultiLineString";
    })(ValueTypeEnum = MetafieldDefinition.ValueTypeEnum || (MetafieldDefinition.ValueTypeEnum = {}));
    var BehaviorsEnum;
    (function (BehaviorsEnum) {
        BehaviorsEnum[BehaviorsEnum["SendToOrder"] = 'SendToOrder'] = "SendToOrder";
        BehaviorsEnum[BehaviorsEnum["SendToMenu"] = 'SendToMenu'] = "SendToMenu";
    })(BehaviorsEnum = MetafieldDefinition.BehaviorsEnum || (MetafieldDefinition.BehaviorsEnum = {}));
})(MetafieldDefinition || (exports.MetafieldDefinition = MetafieldDefinition = {}));
var MetafieldDefinitionRecommendation;
(function (MetafieldDefinitionRecommendation) {
    var OwnerEntityEnum;
    (function (OwnerEntityEnum) {
        OwnerEntityEnum[OwnerEntityEnum["CatalogItem"] = 'CatalogItem'] = "CatalogItem";
        OwnerEntityEnum[OwnerEntityEnum["CatalogGroup"] = 'CatalogGroup'] = "CatalogGroup";
        OwnerEntityEnum[OwnerEntityEnum["Menu"] = 'Menu'] = "Menu";
    })(OwnerEntityEnum = MetafieldDefinitionRecommendation.OwnerEntityEnum || (MetafieldDefinitionRecommendation.OwnerEntityEnum = {}));
    var ValueTypeEnum;
    (function (ValueTypeEnum) {
        ValueTypeEnum[ValueTypeEnum["Boolean"] = 'Boolean'] = "Boolean";
        ValueTypeEnum[ValueTypeEnum["Json"] = 'Json'] = "Json";
        ValueTypeEnum[ValueTypeEnum["SingleLineString"] = 'SingleLineString'] = "SingleLineString";
        ValueTypeEnum[ValueTypeEnum["MultiLineString"] = 'MultiLineString'] = "MultiLineString";
    })(ValueTypeEnum = MetafieldDefinitionRecommendation.ValueTypeEnum || (MetafieldDefinitionRecommendation.ValueTypeEnum = {}));
    var BehaviorsEnum;
    (function (BehaviorsEnum) {
        BehaviorsEnum[BehaviorsEnum["SendToOrder"] = 'SendToOrder'] = "SendToOrder";
        BehaviorsEnum[BehaviorsEnum["SendToMenu"] = 'SendToMenu'] = "SendToMenu";
    })(BehaviorsEnum = MetafieldDefinitionRecommendation.BehaviorsEnum || (MetafieldDefinitionRecommendation.BehaviorsEnum = {}));
})(MetafieldDefinitionRecommendation || (exports.MetafieldDefinitionRecommendation = MetafieldDefinitionRecommendation = {}));
var MobileAppsStatistics;
(function (MobileAppsStatistics) {
    var PlatformTypeEnum;
    (function (PlatformTypeEnum) {
        PlatformTypeEnum[PlatformTypeEnum["None"] = 'None'] = "None";
        PlatformTypeEnum[PlatformTypeEnum["Android"] = 'Android'] = "Android";
        PlatformTypeEnum[PlatformTypeEnum["IOS"] = 'IOS'] = "IOS";
    })(PlatformTypeEnum = MobileAppsStatistics.PlatformTypeEnum || (MobileAppsStatistics.PlatformTypeEnum = {}));
})(MobileAppsStatistics || (exports.MobileAppsStatistics = MobileAppsStatistics = {}));
var MobileAppsSubmissionStatus;
(function (MobileAppsSubmissionStatus) {
    var TypeEnum;
    (function (TypeEnum) {
        TypeEnum[TypeEnum["None"] = 'None'] = "None";
        TypeEnum[TypeEnum["Android"] = 'Android'] = "Android";
        TypeEnum[TypeEnum["IOS"] = 'IOS'] = "IOS";
    })(TypeEnum = MobileAppsSubmissionStatus.TypeEnum || (MobileAppsSubmissionStatus.TypeEnum = {}));
    var AppStatusEnum;
    (function (AppStatusEnum) {
        AppStatusEnum[AppStatusEnum["None"] = 'None'] = "None";
        AppStatusEnum[AppStatusEnum["Published"] = 'Published'] = "Published";
        AppStatusEnum[AppStatusEnum["Unpublished"] = 'Unpublished'] = "Unpublished";
    })(AppStatusEnum = MobileAppsSubmissionStatus.AppStatusEnum || (MobileAppsSubmissionStatus.AppStatusEnum = {}));
    var UpdateStatusEnum;
    (function (UpdateStatusEnum) {
        UpdateStatusEnum[UpdateStatusEnum["None"] = 'None'] = "None";
        UpdateStatusEnum[UpdateStatusEnum["Submitted"] = 'Submitted'] = "Submitted";
        UpdateStatusEnum[UpdateStatusEnum["InReview"] = 'InReview'] = "InReview";
        UpdateStatusEnum[UpdateStatusEnum["Rejected"] = 'Rejected'] = "Rejected";
        UpdateStatusEnum[UpdateStatusEnum["Approved"] = 'Approved'] = "Approved";
        UpdateStatusEnum[UpdateStatusEnum["Published"] = 'Published'] = "Published";
    })(UpdateStatusEnum = MobileAppsSubmissionStatus.UpdateStatusEnum || (MobileAppsSubmissionStatus.UpdateStatusEnum = {}));
})(MobileAppsSubmissionStatus || (exports.MobileAppsSubmissionStatus = MobileAppsSubmissionStatus = {}));
var NextStatusWithOrderType;
(function (NextStatusWithOrderType) {
    var OrderTypeEnum;
    (function (OrderTypeEnum) {
        OrderTypeEnum[OrderTypeEnum["All"] = 'All'] = "All";
        OrderTypeEnum[OrderTypeEnum["Delivery"] = 'Delivery'] = "Delivery";
        OrderTypeEnum[OrderTypeEnum["Collection"] = 'Collection'] = "Collection";
        OrderTypeEnum[OrderTypeEnum["DineIn"] = 'DineIn'] = "DineIn";
    })(OrderTypeEnum = NextStatusWithOrderType.OrderTypeEnum || (NextStatusWithOrderType.OrderTypeEnum = {}));
})(NextStatusWithOrderType || (exports.NextStatusWithOrderType = NextStatusWithOrderType = {}));
var OAuthApp;
(function (OAuthApp) {
    var FlowEnum;
    (function (FlowEnum) {
        FlowEnum[FlowEnum["AuthorizationCode"] = 'AuthorizationCode'] = "AuthorizationCode";
        FlowEnum[FlowEnum["Implicit"] = 'Implicit'] = "Implicit";
        FlowEnum[FlowEnum["Hybrid"] = 'Hybrid'] = "Hybrid";
        FlowEnum[FlowEnum["ClientCredentials"] = 'ClientCredentials'] = "ClientCredentials";
    })(FlowEnum = OAuthApp.FlowEnum || (OAuthApp.FlowEnum = {}));
    var RefreshTokenUsageEnum;
    (function (RefreshTokenUsageEnum) {
        RefreshTokenUsageEnum[RefreshTokenUsageEnum["ReUse"] = 'ReUse'] = "ReUse";
        RefreshTokenUsageEnum[RefreshTokenUsageEnum["OneTimeOnly"] = 'OneTimeOnly'] = "OneTimeOnly";
    })(RefreshTokenUsageEnum = OAuthApp.RefreshTokenUsageEnum || (OAuthApp.RefreshTokenUsageEnum = {}));
})(OAuthApp || (exports.OAuthApp = OAuthApp = {}));
var OnboardingConfigUpdate;
(function (OnboardingConfigUpdate) {
    var ConfigTypeEnum;
    (function (ConfigTypeEnum) {
        ConfigTypeEnum[ConfigTypeEnum["Tutorial"] = 'Tutorial'] = "Tutorial";
        ConfigTypeEnum[ConfigTypeEnum["OnboardingWizard"] = 'OnboardingWizard'] = "OnboardingWizard";
    })(ConfigTypeEnum = OnboardingConfigUpdate.ConfigTypeEnum || (OnboardingConfigUpdate.ConfigTypeEnum = {}));
})(OnboardingConfigUpdate || (exports.OnboardingConfigUpdate = OnboardingConfigUpdate = {}));
var OnboardingItemUpdate;
(function (OnboardingItemUpdate) {
    var StatusEnum;
    (function (StatusEnum) {
        StatusEnum[StatusEnum["Pending"] = 'Pending'] = "Pending";
        StatusEnum[StatusEnum["InProgress"] = 'InProgress'] = "InProgress";
        StatusEnum[StatusEnum["Completed"] = 'Completed'] = "Completed";
    })(StatusEnum = OnboardingItemUpdate.StatusEnum || (OnboardingItemUpdate.StatusEnum = {}));
})(OnboardingItemUpdate || (exports.OnboardingItemUpdate = OnboardingItemUpdate = {}));
var Order;
(function (Order) {
    var DeliveryTypeEnum;
    (function (DeliveryTypeEnum) {
        DeliveryTypeEnum[DeliveryTypeEnum["Delivery"] = 'Delivery'] = "Delivery";
        DeliveryTypeEnum[DeliveryTypeEnum["Pickup"] = 'Pickup'] = "Pickup";
    })(DeliveryTypeEnum = Order.DeliveryTypeEnum || (Order.DeliveryTypeEnum = {}));
    var PickupLocationTypeEnum;
    (function (PickupLocationTypeEnum) {
        PickupLocationTypeEnum[PickupLocationTypeEnum["TakeOut"] = 'TakeOut'] = "TakeOut";
        PickupLocationTypeEnum[PickupLocationTypeEnum["TableService"] = 'TableService'] = "TableService";
        PickupLocationTypeEnum[PickupLocationTypeEnum["DineIn"] = 'DineIn'] = "DineIn";
    })(PickupLocationTypeEnum = Order.PickupLocationTypeEnum || (Order.PickupLocationTypeEnum = {}));
    var TableServiceCatagoryEnum;
    (function (TableServiceCatagoryEnum) {
        TableServiceCatagoryEnum[TableServiceCatagoryEnum["Generic"] = 'Generic'] = "Generic";
        TableServiceCatagoryEnum[TableServiceCatagoryEnum["Villa"] = 'Villa'] = "Villa";
        TableServiceCatagoryEnum[TableServiceCatagoryEnum["House"] = 'House'] = "House";
        TableServiceCatagoryEnum[TableServiceCatagoryEnum["Room"] = 'Room'] = "Room";
        TableServiceCatagoryEnum[TableServiceCatagoryEnum["Area"] = 'Area'] = "Area";
        TableServiceCatagoryEnum[TableServiceCatagoryEnum["Table"] = 'Table'] = "Table";
        TableServiceCatagoryEnum[TableServiceCatagoryEnum["ParkingBay"] = 'ParkingBay'] = "ParkingBay";
        TableServiceCatagoryEnum[TableServiceCatagoryEnum["Gate"] = 'Gate'] = "Gate";
        TableServiceCatagoryEnum[TableServiceCatagoryEnum["DriveThrough"] = 'DriveThrough'] = "DriveThrough";
        TableServiceCatagoryEnum[TableServiceCatagoryEnum["Team"] = 'Team'] = "Team";
    })(TableServiceCatagoryEnum = Order.TableServiceCatagoryEnum || (Order.TableServiceCatagoryEnum = {}));
    var PaymentAccountTypeEnum;
    (function (PaymentAccountTypeEnum) {
        PaymentAccountTypeEnum[PaymentAccountTypeEnum["Card"] = 'Card'] = "Card";
        PaymentAccountTypeEnum[PaymentAccountTypeEnum["Cash"] = 'Cash'] = "Cash";
        PaymentAccountTypeEnum[PaymentAccountTypeEnum["Ideal"] = 'Ideal'] = "Ideal";
        PaymentAccountTypeEnum[PaymentAccountTypeEnum["Bancontact"] = 'Bancontact'] = "Bancontact";
        PaymentAccountTypeEnum[PaymentAccountTypeEnum["Giropay"] = 'Giropay'] = "Giropay";
        PaymentAccountTypeEnum[PaymentAccountTypeEnum["Eps"] = 'Eps'] = "Eps";
        PaymentAccountTypeEnum[PaymentAccountTypeEnum["Emv"] = 'Emv'] = "Emv";
        PaymentAccountTypeEnum[PaymentAccountTypeEnum["PayPal"] = 'PayPal'] = "PayPal";
        PaymentAccountTypeEnum[PaymentAccountTypeEnum["PayGreen"] = 'PayGreen'] = "PayGreen";
        PaymentAccountTypeEnum[PaymentAccountTypeEnum["GoogleWalletToken"] = 'GoogleWalletToken'] = "GoogleWalletToken";
    })(PaymentAccountTypeEnum = Order.PaymentAccountTypeEnum || (Order.PaymentAccountTypeEnum = {}));
    var OrderStateEnum;
    (function (OrderStateEnum) {
        OrderStateEnum[OrderStateEnum["Created"] = 'Created'] = "Created";
        OrderStateEnum[OrderStateEnum["PlacedCanBeCancelled"] = 'PlacedCanBeCancelled'] = "PlacedCanBeCancelled";
        OrderStateEnum[OrderStateEnum["ReadyToProcess"] = 'ReadyToProcess'] = "ReadyToProcess";
        OrderStateEnum[OrderStateEnum["AcceptedByRestaurant"] = 'AcceptedByRestaurant'] = "AcceptedByRestaurant";
        OrderStateEnum[OrderStateEnum["Dispatched"] = 'Dispatched'] = "Dispatched";
        OrderStateEnum[OrderStateEnum["Delivered"] = 'Delivered'] = "Delivered";
        OrderStateEnum[OrderStateEnum["Cancelled"] = 'Cancelled'] = "Cancelled";
        OrderStateEnum[OrderStateEnum["ManualReview"] = 'ManualReview'] = "ManualReview";
        OrderStateEnum[OrderStateEnum["RejectedByStore"] = 'RejectedByStore'] = "RejectedByStore";
        OrderStateEnum[OrderStateEnum["RejectedByFlipdish"] = 'RejectedByFlipdish'] = "RejectedByFlipdish";
        OrderStateEnum[OrderStateEnum["RejectedAutomatically"] = 'RejectedAutomatically'] = "RejectedAutomatically";
        OrderStateEnum[OrderStateEnum["RejectedAfterBeingAccepted"] = 'RejectedAfterBeingAccepted'] = "RejectedAfterBeingAccepted";
        OrderStateEnum[OrderStateEnum["AcceptedAndRefunded"] = 'AcceptedAndRefunded'] = "AcceptedAndRefunded";
        OrderStateEnum[OrderStateEnum["PendingPayment"] = 'PendingPayment'] = "PendingPayment";
    })(OrderStateEnum = Order.OrderStateEnum || (Order.OrderStateEnum = {}));
    var AppTypeEnum;
    (function (AppTypeEnum) {
        AppTypeEnum[AppTypeEnum["Unknown"] = 'Unknown'] = "Unknown";
        AppTypeEnum[AppTypeEnum["Ios"] = 'Ios'] = "Ios";
        AppTypeEnum[AppTypeEnum["Android"] = 'Android'] = "Android";
        AppTypeEnum[AppTypeEnum["Web"] = 'Web'] = "Web";
        AppTypeEnum[AppTypeEnum["Kiosk"] = 'Kiosk'] = "Kiosk";
        AppTypeEnum[AppTypeEnum["Pos"] = 'Pos'] = "Pos";
        AppTypeEnum[AppTypeEnum["TelephoneCall"] = 'TelephoneCall'] = "TelephoneCall";
        AppTypeEnum[AppTypeEnum["Sms"] = 'Sms'] = "Sms";
        AppTypeEnum[AppTypeEnum["PwaAndroid"] = 'PwaAndroid'] = "PwaAndroid";
        AppTypeEnum[AppTypeEnum["PwaIos"] = 'PwaIos'] = "PwaIos";
        AppTypeEnum[AppTypeEnum["Google"] = 'Google'] = "Google";
    })(AppTypeEnum = Order.AppTypeEnum || (Order.AppTypeEnum = {}));
    var PaymentStatusEnum;
    (function (PaymentStatusEnum) {
        PaymentStatusEnum[PaymentStatusEnum["Paid"] = 'Paid'] = "Paid";
        PaymentStatusEnum[PaymentStatusEnum["Unpaid"] = 'Unpaid'] = "Unpaid";
        PaymentStatusEnum[PaymentStatusEnum["Refunded"] = 'Refunded'] = "Refunded";
        PaymentStatusEnum[PaymentStatusEnum["PartiallyRefunded"] = 'PartiallyRefunded'] = "PartiallyRefunded";
        PaymentStatusEnum[PaymentStatusEnum["Disputed"] = 'Disputed'] = "Disputed";
    })(PaymentStatusEnum = Order.PaymentStatusEnum || (Order.PaymentStatusEnum = {}));
    var RejectionReasonEnum;
    (function (RejectionReasonEnum) {
        RejectionReasonEnum[RejectionReasonEnum["TooBusy"] = 'TooBusy'] = "TooBusy";
        RejectionReasonEnum[RejectionReasonEnum["FoodUnavailable"] = 'FoodUnavailable'] = "FoodUnavailable";
        RejectionReasonEnum[RejectionReasonEnum["UnableToDeliver"] = 'UnableToDeliver'] = "UnableToDeliver";
        RejectionReasonEnum[RejectionReasonEnum["UnknownAddress"] = 'UnknownAddress'] = "UnknownAddress";
        RejectionReasonEnum[RejectionReasonEnum["UnknownReason"] = 'UnknownReason'] = "UnknownReason";
        RejectionReasonEnum[RejectionReasonEnum["TooSoon"] = 'TooSoon'] = "TooSoon";
        RejectionReasonEnum[RejectionReasonEnum["TimeUnavailable"] = 'TimeUnavailable'] = "TimeUnavailable";
        RejectionReasonEnum[RejectionReasonEnum["DontDeliverToArea"] = 'DontDeliverToArea'] = "DontDeliverToArea";
        RejectionReasonEnum[RejectionReasonEnum["StoreUncontactable"] = 'StoreUncontactable'] = "StoreUncontactable";
    })(RejectionReasonEnum = Order.RejectionReasonEnum || (Order.RejectionReasonEnum = {}));
    var DeliveryTrackingStatusEnum;
    (function (DeliveryTrackingStatusEnum) {
        DeliveryTrackingStatusEnum[DeliveryTrackingStatusEnum["Unassigned"] = 'Unassigned'] = "Unassigned";
        DeliveryTrackingStatusEnum[DeliveryTrackingStatusEnum["Unaccepted"] = 'Unaccepted'] = "Unaccepted";
        DeliveryTrackingStatusEnum[DeliveryTrackingStatusEnum["Accepted"] = 'Accepted'] = "Accepted";
        DeliveryTrackingStatusEnum[DeliveryTrackingStatusEnum["Carrying"] = 'Carrying'] = "Carrying";
        DeliveryTrackingStatusEnum[DeliveryTrackingStatusEnum["OnTheWay"] = 'OnTheWay'] = "OnTheWay";
        DeliveryTrackingStatusEnum[DeliveryTrackingStatusEnum["ArrivedAtLocation"] = 'ArrivedAtLocation'] = "ArrivedAtLocation";
        DeliveryTrackingStatusEnum[DeliveryTrackingStatusEnum["Delivered"] = 'Delivered'] = "Delivered";
        DeliveryTrackingStatusEnum[DeliveryTrackingStatusEnum["CannotDeliver"] = 'CannotDeliver'] = "CannotDeliver";
    })(DeliveryTrackingStatusEnum = Order.DeliveryTrackingStatusEnum || (Order.DeliveryTrackingStatusEnum = {}));
})(Order || (exports.Order = Order = {}));
var OrderDeliveryInformation;
(function (OrderDeliveryInformation) {
    var StatusEnum;
    (function (StatusEnum) {
        StatusEnum[StatusEnum["None"] = 'None'] = "None";
        StatusEnum[StatusEnum["Unassigned"] = 'Unassigned'] = "Unassigned";
        StatusEnum[StatusEnum["Unaccepted"] = 'Unaccepted'] = "Unaccepted";
        StatusEnum[StatusEnum["Accepted"] = 'Accepted'] = "Accepted";
        StatusEnum[StatusEnum["Carrying"] = 'Carrying'] = "Carrying";
        StatusEnum[StatusEnum["OnTheWay"] = 'OnTheWay'] = "OnTheWay";
        StatusEnum[StatusEnum["ArrivedAtLocation"] = 'ArrivedAtLocation'] = "ArrivedAtLocation";
        StatusEnum[StatusEnum["Delivered"] = 'Delivered'] = "Delivered";
        StatusEnum[StatusEnum["CannotDeliver"] = 'CannotDeliver'] = "CannotDeliver";
    })(StatusEnum = OrderDeliveryInformation.StatusEnum || (OrderDeliveryInformation.StatusEnum = {}));
})(OrderDeliveryInformation || (exports.OrderDeliveryInformation = OrderDeliveryInformation = {}));
var OrderDeliveryInformationBase;
(function (OrderDeliveryInformationBase) {
    var StatusEnum;
    (function (StatusEnum) {
        StatusEnum[StatusEnum["None"] = 'None'] = "None";
        StatusEnum[StatusEnum["Unassigned"] = 'Unassigned'] = "Unassigned";
        StatusEnum[StatusEnum["Unaccepted"] = 'Unaccepted'] = "Unaccepted";
        StatusEnum[StatusEnum["Accepted"] = 'Accepted'] = "Accepted";
        StatusEnum[StatusEnum["Carrying"] = 'Carrying'] = "Carrying";
        StatusEnum[StatusEnum["OnTheWay"] = 'OnTheWay'] = "OnTheWay";
        StatusEnum[StatusEnum["ArrivedAtLocation"] = 'ArrivedAtLocation'] = "ArrivedAtLocation";
        StatusEnum[StatusEnum["Delivered"] = 'Delivered'] = "Delivered";
        StatusEnum[StatusEnum["CannotDeliver"] = 'CannotDeliver'] = "CannotDeliver";
    })(StatusEnum = OrderDeliveryInformationBase.StatusEnum || (OrderDeliveryInformationBase.StatusEnum = {}));
})(OrderDeliveryInformationBase || (exports.OrderDeliveryInformationBase = OrderDeliveryInformationBase = {}));
var OrderSummary;
(function (OrderSummary) {
    var DeliveryTypeEnum;
    (function (DeliveryTypeEnum) {
        DeliveryTypeEnum[DeliveryTypeEnum["Delivery"] = 'Delivery'] = "Delivery";
        DeliveryTypeEnum[DeliveryTypeEnum["Pickup"] = 'Pickup'] = "Pickup";
    })(DeliveryTypeEnum = OrderSummary.DeliveryTypeEnum || (OrderSummary.DeliveryTypeEnum = {}));
    var PickupLocationTypeEnum;
    (function (PickupLocationTypeEnum) {
        PickupLocationTypeEnum[PickupLocationTypeEnum["TakeOut"] = 'TakeOut'] = "TakeOut";
        PickupLocationTypeEnum[PickupLocationTypeEnum["TableService"] = 'TableService'] = "TableService";
        PickupLocationTypeEnum[PickupLocationTypeEnum["DineIn"] = 'DineIn'] = "DineIn";
    })(PickupLocationTypeEnum = OrderSummary.PickupLocationTypeEnum || (OrderSummary.PickupLocationTypeEnum = {}));
    var TableServiceCatagoryEnum;
    (function (TableServiceCatagoryEnum) {
        TableServiceCatagoryEnum[TableServiceCatagoryEnum["Generic"] = 'Generic'] = "Generic";
        TableServiceCatagoryEnum[TableServiceCatagoryEnum["Villa"] = 'Villa'] = "Villa";
        TableServiceCatagoryEnum[TableServiceCatagoryEnum["House"] = 'House'] = "House";
        TableServiceCatagoryEnum[TableServiceCatagoryEnum["Room"] = 'Room'] = "Room";
        TableServiceCatagoryEnum[TableServiceCatagoryEnum["Area"] = 'Area'] = "Area";
        TableServiceCatagoryEnum[TableServiceCatagoryEnum["Table"] = 'Table'] = "Table";
        TableServiceCatagoryEnum[TableServiceCatagoryEnum["ParkingBay"] = 'ParkingBay'] = "ParkingBay";
        TableServiceCatagoryEnum[TableServiceCatagoryEnum["Gate"] = 'Gate'] = "Gate";
        TableServiceCatagoryEnum[TableServiceCatagoryEnum["DriveThrough"] = 'DriveThrough'] = "DriveThrough";
        TableServiceCatagoryEnum[TableServiceCatagoryEnum["Team"] = 'Team'] = "Team";
    })(TableServiceCatagoryEnum = OrderSummary.TableServiceCatagoryEnum || (OrderSummary.TableServiceCatagoryEnum = {}));
    var OrderStateEnum;
    (function (OrderStateEnum) {
        OrderStateEnum[OrderStateEnum["Created"] = 'Created'] = "Created";
        OrderStateEnum[OrderStateEnum["PlacedCanBeCancelled"] = 'PlacedCanBeCancelled'] = "PlacedCanBeCancelled";
        OrderStateEnum[OrderStateEnum["ReadyToProcess"] = 'ReadyToProcess'] = "ReadyToProcess";
        OrderStateEnum[OrderStateEnum["AcceptedByRestaurant"] = 'AcceptedByRestaurant'] = "AcceptedByRestaurant";
        OrderStateEnum[OrderStateEnum["Dispatched"] = 'Dispatched'] = "Dispatched";
        OrderStateEnum[OrderStateEnum["Delivered"] = 'Delivered'] = "Delivered";
        OrderStateEnum[OrderStateEnum["Cancelled"] = 'Cancelled'] = "Cancelled";
        OrderStateEnum[OrderStateEnum["ManualReview"] = 'ManualReview'] = "ManualReview";
        OrderStateEnum[OrderStateEnum["RejectedByStore"] = 'RejectedByStore'] = "RejectedByStore";
        OrderStateEnum[OrderStateEnum["RejectedByFlipdish"] = 'RejectedByFlipdish'] = "RejectedByFlipdish";
        OrderStateEnum[OrderStateEnum["RejectedAutomatically"] = 'RejectedAutomatically'] = "RejectedAutomatically";
        OrderStateEnum[OrderStateEnum["RejectedAfterBeingAccepted"] = 'RejectedAfterBeingAccepted'] = "RejectedAfterBeingAccepted";
        OrderStateEnum[OrderStateEnum["AcceptedAndRefunded"] = 'AcceptedAndRefunded'] = "AcceptedAndRefunded";
        OrderStateEnum[OrderStateEnum["PendingPayment"] = 'PendingPayment'] = "PendingPayment";
    })(OrderStateEnum = OrderSummary.OrderStateEnum || (OrderSummary.OrderStateEnum = {}));
    var PaymentAccountTypeEnum;
    (function (PaymentAccountTypeEnum) {
        PaymentAccountTypeEnum[PaymentAccountTypeEnum["Card"] = 'Card'] = "Card";
        PaymentAccountTypeEnum[PaymentAccountTypeEnum["Cash"] = 'Cash'] = "Cash";
        PaymentAccountTypeEnum[PaymentAccountTypeEnum["Ideal"] = 'Ideal'] = "Ideal";
        PaymentAccountTypeEnum[PaymentAccountTypeEnum["Bancontact"] = 'Bancontact'] = "Bancontact";
        PaymentAccountTypeEnum[PaymentAccountTypeEnum["Giropay"] = 'Giropay'] = "Giropay";
        PaymentAccountTypeEnum[PaymentAccountTypeEnum["Eps"] = 'Eps'] = "Eps";
        PaymentAccountTypeEnum[PaymentAccountTypeEnum["Emv"] = 'Emv'] = "Emv";
        PaymentAccountTypeEnum[PaymentAccountTypeEnum["PayPal"] = 'PayPal'] = "PayPal";
        PaymentAccountTypeEnum[PaymentAccountTypeEnum["PayGreen"] = 'PayGreen'] = "PayGreen";
        PaymentAccountTypeEnum[PaymentAccountTypeEnum["GoogleWalletToken"] = 'GoogleWalletToken'] = "GoogleWalletToken";
    })(PaymentAccountTypeEnum = OrderSummary.PaymentAccountTypeEnum || (OrderSummary.PaymentAccountTypeEnum = {}));
    var PaymentStatusEnum;
    (function (PaymentStatusEnum) {
        PaymentStatusEnum[PaymentStatusEnum["Paid"] = 'Paid'] = "Paid";
        PaymentStatusEnum[PaymentStatusEnum["Unpaid"] = 'Unpaid'] = "Unpaid";
        PaymentStatusEnum[PaymentStatusEnum["Refunded"] = 'Refunded'] = "Refunded";
        PaymentStatusEnum[PaymentStatusEnum["PartiallyRefunded"] = 'PartiallyRefunded'] = "PartiallyRefunded";
        PaymentStatusEnum[PaymentStatusEnum["Disputed"] = 'Disputed'] = "Disputed";
    })(PaymentStatusEnum = OrderSummary.PaymentStatusEnum || (OrderSummary.PaymentStatusEnum = {}));
    var CurrencyEnum;
    (function (CurrencyEnum) {
        CurrencyEnum[CurrencyEnum["EUR"] = 'EUR'] = "EUR";
        CurrencyEnum[CurrencyEnum["USD"] = 'USD'] = "USD";
        CurrencyEnum[CurrencyEnum["GBP"] = 'GBP'] = "GBP";
        CurrencyEnum[CurrencyEnum["CAD"] = 'CAD'] = "CAD";
        CurrencyEnum[CurrencyEnum["AUD"] = 'AUD'] = "AUD";
        CurrencyEnum[CurrencyEnum["DJF"] = 'DJF'] = "DJF";
        CurrencyEnum[CurrencyEnum["ZAR"] = 'ZAR'] = "ZAR";
        CurrencyEnum[CurrencyEnum["ETB"] = 'ETB'] = "ETB";
        CurrencyEnum[CurrencyEnum["AED"] = 'AED'] = "AED";
        CurrencyEnum[CurrencyEnum["BHD"] = 'BHD'] = "BHD";
        CurrencyEnum[CurrencyEnum["DZD"] = 'DZD'] = "DZD";
        CurrencyEnum[CurrencyEnum["EGP"] = 'EGP'] = "EGP";
        CurrencyEnum[CurrencyEnum["IQD"] = 'IQD'] = "IQD";
        CurrencyEnum[CurrencyEnum["JOD"] = 'JOD'] = "JOD";
        CurrencyEnum[CurrencyEnum["KWD"] = 'KWD'] = "KWD";
        CurrencyEnum[CurrencyEnum["LBP"] = 'LBP'] = "LBP";
        CurrencyEnum[CurrencyEnum["LYD"] = 'LYD'] = "LYD";
        CurrencyEnum[CurrencyEnum["MAD"] = 'MAD'] = "MAD";
        CurrencyEnum[CurrencyEnum["OMR"] = 'OMR'] = "OMR";
        CurrencyEnum[CurrencyEnum["QAR"] = 'QAR'] = "QAR";
        CurrencyEnum[CurrencyEnum["SAR"] = 'SAR'] = "SAR";
        CurrencyEnum[CurrencyEnum["SYP"] = 'SYP'] = "SYP";
        CurrencyEnum[CurrencyEnum["TND"] = 'TND'] = "TND";
        CurrencyEnum[CurrencyEnum["YER"] = 'YER'] = "YER";
        CurrencyEnum[CurrencyEnum["CLP"] = 'CLP'] = "CLP";
        CurrencyEnum[CurrencyEnum["INR"] = 'INR'] = "INR";
        CurrencyEnum[CurrencyEnum["AZN"] = 'AZN'] = "AZN";
        CurrencyEnum[CurrencyEnum["RUB"] = 'RUB'] = "RUB";
        CurrencyEnum[CurrencyEnum["BYN"] = 'BYN'] = "BYN";
        CurrencyEnum[CurrencyEnum["BGN"] = 'BGN'] = "BGN";
        CurrencyEnum[CurrencyEnum["NGN"] = 'NGN'] = "NGN";
        CurrencyEnum[CurrencyEnum["BDT"] = 'BDT'] = "BDT";
        CurrencyEnum[CurrencyEnum["CNY"] = 'CNY'] = "CNY";
        CurrencyEnum[CurrencyEnum["BAM"] = 'BAM'] = "BAM";
        CurrencyEnum[CurrencyEnum["CZK"] = 'CZK'] = "CZK";
        CurrencyEnum[CurrencyEnum["DKK"] = 'DKK'] = "DKK";
        CurrencyEnum[CurrencyEnum["CHF"] = 'CHF'] = "CHF";
        CurrencyEnum[CurrencyEnum["MVR"] = 'MVR'] = "MVR";
        CurrencyEnum[CurrencyEnum["BTN"] = 'BTN'] = "BTN";
        CurrencyEnum[CurrencyEnum["XCD"] = 'XCD'] = "XCD";
        CurrencyEnum[CurrencyEnum["BZD"] = 'BZD'] = "BZD";
        CurrencyEnum[CurrencyEnum["HKD"] = 'HKD'] = "HKD";
        CurrencyEnum[CurrencyEnum["IDR"] = 'IDR'] = "IDR";
        CurrencyEnum[CurrencyEnum["JMD"] = 'JMD'] = "JMD";
        CurrencyEnum[CurrencyEnum["MYR"] = 'MYR'] = "MYR";
        CurrencyEnum[CurrencyEnum["NZD"] = 'NZD'] = "NZD";
        CurrencyEnum[CurrencyEnum["PHP"] = 'PHP'] = "PHP";
        CurrencyEnum[CurrencyEnum["SGD"] = 'SGD'] = "SGD";
        CurrencyEnum[CurrencyEnum["TTD"] = 'TTD'] = "TTD";
        CurrencyEnum[CurrencyEnum["XDR"] = 'XDR'] = "XDR";
        CurrencyEnum[CurrencyEnum["ARS"] = 'ARS'] = "ARS";
        CurrencyEnum[CurrencyEnum["BOB"] = 'BOB'] = "BOB";
        CurrencyEnum[CurrencyEnum["COP"] = 'COP'] = "COP";
        CurrencyEnum[CurrencyEnum["CRC"] = 'CRC'] = "CRC";
        CurrencyEnum[CurrencyEnum["CUP"] = 'CUP'] = "CUP";
        CurrencyEnum[CurrencyEnum["DOP"] = 'DOP'] = "DOP";
        CurrencyEnum[CurrencyEnum["GTQ"] = 'GTQ'] = "GTQ";
        CurrencyEnum[CurrencyEnum["HNL"] = 'HNL'] = "HNL";
        CurrencyEnum[CurrencyEnum["MXN"] = 'MXN'] = "MXN";
        CurrencyEnum[CurrencyEnum["NIO"] = 'NIO'] = "NIO";
        CurrencyEnum[CurrencyEnum["PAB"] = 'PAB'] = "PAB";
        CurrencyEnum[CurrencyEnum["PEN"] = 'PEN'] = "PEN";
        CurrencyEnum[CurrencyEnum["PYG"] = 'PYG'] = "PYG";
        CurrencyEnum[CurrencyEnum["UYU"] = 'UYU'] = "UYU";
        CurrencyEnum[CurrencyEnum["VEF"] = 'VEF'] = "VEF";
        CurrencyEnum[CurrencyEnum["IRR"] = 'IRR'] = "IRR";
        CurrencyEnum[CurrencyEnum["XOF"] = 'XOF'] = "XOF";
        CurrencyEnum[CurrencyEnum["CDF"] = 'CDF'] = "CDF";
        CurrencyEnum[CurrencyEnum["XAF"] = 'XAF'] = "XAF";
        CurrencyEnum[CurrencyEnum["HTG"] = 'HTG'] = "HTG";
        CurrencyEnum[CurrencyEnum["ILS"] = 'ILS'] = "ILS";
        CurrencyEnum[CurrencyEnum["HRK"] = 'HRK'] = "HRK";
        CurrencyEnum[CurrencyEnum["HUF"] = 'HUF'] = "HUF";
        CurrencyEnum[CurrencyEnum["AMD"] = 'AMD'] = "AMD";
        CurrencyEnum[CurrencyEnum["ISK"] = 'ISK'] = "ISK";
        CurrencyEnum[CurrencyEnum["JPY"] = 'JPY'] = "JPY";
        CurrencyEnum[CurrencyEnum["GEL"] = 'GEL'] = "GEL";
        CurrencyEnum[CurrencyEnum["KZT"] = 'KZT'] = "KZT";
        CurrencyEnum[CurrencyEnum["KHR"] = 'KHR'] = "KHR";
        CurrencyEnum[CurrencyEnum["KRW"] = 'KRW'] = "KRW";
        CurrencyEnum[CurrencyEnum["KGS"] = 'KGS'] = "KGS";
        CurrencyEnum[CurrencyEnum["LAK"] = 'LAK'] = "LAK";
        CurrencyEnum[CurrencyEnum["MKD"] = 'MKD'] = "MKD";
        CurrencyEnum[CurrencyEnum["MNT"] = 'MNT'] = "MNT";
        CurrencyEnum[CurrencyEnum["BND"] = 'BND'] = "BND";
        CurrencyEnum[CurrencyEnum["MMK"] = 'MMK'] = "MMK";
        CurrencyEnum[CurrencyEnum["NOK"] = 'NOK'] = "NOK";
        CurrencyEnum[CurrencyEnum["NPR"] = 'NPR'] = "NPR";
        CurrencyEnum[CurrencyEnum["PKR"] = 'PKR'] = "PKR";
        CurrencyEnum[CurrencyEnum["PLN"] = 'PLN'] = "PLN";
        CurrencyEnum[CurrencyEnum["AFN"] = 'AFN'] = "AFN";
        CurrencyEnum[CurrencyEnum["BRL"] = 'BRL'] = "BRL";
        CurrencyEnum[CurrencyEnum["MDL"] = 'MDL'] = "MDL";
        CurrencyEnum[CurrencyEnum["RON"] = 'RON'] = "RON";
        CurrencyEnum[CurrencyEnum["RWF"] = 'RWF'] = "RWF";
        CurrencyEnum[CurrencyEnum["SEK"] = 'SEK'] = "SEK";
        CurrencyEnum[CurrencyEnum["LKR"] = 'LKR'] = "LKR";
        CurrencyEnum[CurrencyEnum["SOS"] = 'SOS'] = "SOS";
        CurrencyEnum[CurrencyEnum["ALL"] = 'ALL'] = "ALL";
        CurrencyEnum[CurrencyEnum["RSD"] = 'RSD'] = "RSD";
        CurrencyEnum[CurrencyEnum["KES"] = 'KES'] = "KES";
        CurrencyEnum[CurrencyEnum["TJS"] = 'TJS'] = "TJS";
        CurrencyEnum[CurrencyEnum["THB"] = 'THB'] = "THB";
        CurrencyEnum[CurrencyEnum["ERN"] = 'ERN'] = "ERN";
        CurrencyEnum[CurrencyEnum["TMT"] = 'TMT'] = "TMT";
        CurrencyEnum[CurrencyEnum["BWP"] = 'BWP'] = "BWP";
        CurrencyEnum[CurrencyEnum["TRY"] = 'TRY'] = "TRY";
        CurrencyEnum[CurrencyEnum["UAH"] = 'UAH'] = "UAH";
        CurrencyEnum[CurrencyEnum["UZS"] = 'UZS'] = "UZS";
        CurrencyEnum[CurrencyEnum["VND"] = 'VND'] = "VND";
        CurrencyEnum[CurrencyEnum["MOP"] = 'MOP'] = "MOP";
        CurrencyEnum[CurrencyEnum["TWD"] = 'TWD'] = "TWD";
        CurrencyEnum[CurrencyEnum["BMD"] = 'BMD'] = "BMD";
    })(CurrencyEnum = OrderSummary.CurrencyEnum || (OrderSummary.CurrencyEnum = {}));
    var AppTypeEnum;
    (function (AppTypeEnum) {
        AppTypeEnum[AppTypeEnum["Unknown"] = 'Unknown'] = "Unknown";
        AppTypeEnum[AppTypeEnum["Ios"] = 'Ios'] = "Ios";
        AppTypeEnum[AppTypeEnum["Android"] = 'Android'] = "Android";
        AppTypeEnum[AppTypeEnum["Web"] = 'Web'] = "Web";
        AppTypeEnum[AppTypeEnum["Kiosk"] = 'Kiosk'] = "Kiosk";
        AppTypeEnum[AppTypeEnum["Pos"] = 'Pos'] = "Pos";
        AppTypeEnum[AppTypeEnum["TelephoneCall"] = 'TelephoneCall'] = "TelephoneCall";
        AppTypeEnum[AppTypeEnum["Sms"] = 'Sms'] = "Sms";
        AppTypeEnum[AppTypeEnum["PwaAndroid"] = 'PwaAndroid'] = "PwaAndroid";
        AppTypeEnum[AppTypeEnum["PwaIos"] = 'PwaIos'] = "PwaIos";
        AppTypeEnum[AppTypeEnum["Google"] = 'Google'] = "Google";
    })(AppTypeEnum = OrderSummary.AppTypeEnum || (OrderSummary.AppTypeEnum = {}));
})(OrderSummary || (exports.OrderSummary = OrderSummary = {}));
var OrderVoucherSummary;
(function (OrderVoucherSummary) {
    var TypeEnum;
    (function (TypeEnum) {
        TypeEnum[TypeEnum["PercentageDiscount"] = 'PercentageDiscount'] = "PercentageDiscount";
        TypeEnum[TypeEnum["LumpDiscount"] = 'LumpDiscount'] = "LumpDiscount";
        TypeEnum[TypeEnum["AddItem"] = 'AddItem'] = "AddItem";
        TypeEnum[TypeEnum["CreditNote"] = 'CreditNote'] = "CreditNote";
        TypeEnum[TypeEnum["FreeDelivery"] = 'FreeDelivery'] = "FreeDelivery";
    })(TypeEnum = OrderVoucherSummary.TypeEnum || (OrderVoucherSummary.TypeEnum = {}));
    var SubTypeEnum;
    (function (SubTypeEnum) {
        SubTypeEnum[SubTypeEnum["None"] = 'None'] = "None";
        SubTypeEnum[SubTypeEnum["SignUp"] = 'SignUp'] = "SignUp";
        SubTypeEnum[SubTypeEnum["Loyalty"] = 'Loyalty'] = "Loyalty";
        SubTypeEnum[SubTypeEnum["Loyalty25"] = 'Loyalty25'] = "Loyalty25";
        SubTypeEnum[SubTypeEnum["Retention"] = 'Retention'] = "Retention";
        SubTypeEnum[SubTypeEnum["SecondaryRetention"] = 'SecondaryRetention'] = "SecondaryRetention";
        SubTypeEnum[SubTypeEnum["Custom"] = 'Custom'] = "Custom";
    })(SubTypeEnum = OrderVoucherSummary.SubTypeEnum || (OrderVoucherSummary.SubTypeEnum = {}));
})(OrderVoucherSummary || (exports.OrderVoucherSummary = OrderVoucherSummary = {}));
var OwnerEntityConfiguration;
(function (OwnerEntityConfiguration) {
    var OwnerEntityEnum;
    (function (OwnerEntityEnum) {
        OwnerEntityEnum[OwnerEntityEnum["CatalogItem"] = 'CatalogItem'] = "CatalogItem";
        OwnerEntityEnum[OwnerEntityEnum["CatalogGroup"] = 'CatalogGroup'] = "CatalogGroup";
        OwnerEntityEnum[OwnerEntityEnum["Menu"] = 'Menu'] = "Menu";
    })(OwnerEntityEnum = OwnerEntityConfiguration.OwnerEntityEnum || (OwnerEntityConfiguration.OwnerEntityEnum = {}));
    var AllowedBehaviorsEnum;
    (function (AllowedBehaviorsEnum) {
        AllowedBehaviorsEnum[AllowedBehaviorsEnum["SendToOrder"] = 'SendToOrder'] = "SendToOrder";
        AllowedBehaviorsEnum[AllowedBehaviorsEnum["SendToMenu"] = 'SendToMenu'] = "SendToMenu";
    })(AllowedBehaviorsEnum = OwnerEntityConfiguration.AllowedBehaviorsEnum || (OwnerEntityConfiguration.AllowedBehaviorsEnum = {}));
})(OwnerEntityConfiguration || (exports.OwnerEntityConfiguration = OwnerEntityConfiguration = {}));
var Payout;
(function (Payout) {
    var PayoutStatusEnum;
    (function (PayoutStatusEnum) {
        PayoutStatusEnum[PayoutStatusEnum["Pending"] = 'Pending'] = "Pending";
        PayoutStatusEnum[PayoutStatusEnum["InTransit"] = 'InTransit'] = "InTransit";
        PayoutStatusEnum[PayoutStatusEnum["Paid"] = 'Paid'] = "Paid";
        PayoutStatusEnum[PayoutStatusEnum["Failed"] = 'Failed'] = "Failed";
        PayoutStatusEnum[PayoutStatusEnum["Cancelled"] = 'Cancelled'] = "Cancelled";
    })(PayoutStatusEnum = Payout.PayoutStatusEnum || (Payout.PayoutStatusEnum = {}));
    var PayoutTypeEnum;
    (function (PayoutTypeEnum) {
        PayoutTypeEnum[PayoutTypeEnum["Internal"] = 'Internal'] = "Internal";
        PayoutTypeEnum[PayoutTypeEnum["Stripe"] = 'Stripe'] = "Stripe";
    })(PayoutTypeEnum = Payout.PayoutTypeEnum || (Payout.PayoutTypeEnum = {}));
    var CurrencyEnum;
    (function (CurrencyEnum) {
        CurrencyEnum[CurrencyEnum["EUR"] = 'EUR'] = "EUR";
        CurrencyEnum[CurrencyEnum["USD"] = 'USD'] = "USD";
        CurrencyEnum[CurrencyEnum["GBP"] = 'GBP'] = "GBP";
        CurrencyEnum[CurrencyEnum["CAD"] = 'CAD'] = "CAD";
        CurrencyEnum[CurrencyEnum["AUD"] = 'AUD'] = "AUD";
        CurrencyEnum[CurrencyEnum["DJF"] = 'DJF'] = "DJF";
        CurrencyEnum[CurrencyEnum["ZAR"] = 'ZAR'] = "ZAR";
        CurrencyEnum[CurrencyEnum["ETB"] = 'ETB'] = "ETB";
        CurrencyEnum[CurrencyEnum["AED"] = 'AED'] = "AED";
        CurrencyEnum[CurrencyEnum["BHD"] = 'BHD'] = "BHD";
        CurrencyEnum[CurrencyEnum["DZD"] = 'DZD'] = "DZD";
        CurrencyEnum[CurrencyEnum["EGP"] = 'EGP'] = "EGP";
        CurrencyEnum[CurrencyEnum["IQD"] = 'IQD'] = "IQD";
        CurrencyEnum[CurrencyEnum["JOD"] = 'JOD'] = "JOD";
        CurrencyEnum[CurrencyEnum["KWD"] = 'KWD'] = "KWD";
        CurrencyEnum[CurrencyEnum["LBP"] = 'LBP'] = "LBP";
        CurrencyEnum[CurrencyEnum["LYD"] = 'LYD'] = "LYD";
        CurrencyEnum[CurrencyEnum["MAD"] = 'MAD'] = "MAD";
        CurrencyEnum[CurrencyEnum["OMR"] = 'OMR'] = "OMR";
        CurrencyEnum[CurrencyEnum["QAR"] = 'QAR'] = "QAR";
        CurrencyEnum[CurrencyEnum["SAR"] = 'SAR'] = "SAR";
        CurrencyEnum[CurrencyEnum["SYP"] = 'SYP'] = "SYP";
        CurrencyEnum[CurrencyEnum["TND"] = 'TND'] = "TND";
        CurrencyEnum[CurrencyEnum["YER"] = 'YER'] = "YER";
        CurrencyEnum[CurrencyEnum["CLP"] = 'CLP'] = "CLP";
        CurrencyEnum[CurrencyEnum["INR"] = 'INR'] = "INR";
        CurrencyEnum[CurrencyEnum["AZN"] = 'AZN'] = "AZN";
        CurrencyEnum[CurrencyEnum["RUB"] = 'RUB'] = "RUB";
        CurrencyEnum[CurrencyEnum["BYN"] = 'BYN'] = "BYN";
        CurrencyEnum[CurrencyEnum["BGN"] = 'BGN'] = "BGN";
        CurrencyEnum[CurrencyEnum["NGN"] = 'NGN'] = "NGN";
        CurrencyEnum[CurrencyEnum["BDT"] = 'BDT'] = "BDT";
        CurrencyEnum[CurrencyEnum["CNY"] = 'CNY'] = "CNY";
        CurrencyEnum[CurrencyEnum["BAM"] = 'BAM'] = "BAM";
        CurrencyEnum[CurrencyEnum["CZK"] = 'CZK'] = "CZK";
        CurrencyEnum[CurrencyEnum["DKK"] = 'DKK'] = "DKK";
        CurrencyEnum[CurrencyEnum["CHF"] = 'CHF'] = "CHF";
        CurrencyEnum[CurrencyEnum["MVR"] = 'MVR'] = "MVR";
        CurrencyEnum[CurrencyEnum["BTN"] = 'BTN'] = "BTN";
        CurrencyEnum[CurrencyEnum["XCD"] = 'XCD'] = "XCD";
        CurrencyEnum[CurrencyEnum["BZD"] = 'BZD'] = "BZD";
        CurrencyEnum[CurrencyEnum["HKD"] = 'HKD'] = "HKD";
        CurrencyEnum[CurrencyEnum["IDR"] = 'IDR'] = "IDR";
        CurrencyEnum[CurrencyEnum["JMD"] = 'JMD'] = "JMD";
        CurrencyEnum[CurrencyEnum["MYR"] = 'MYR'] = "MYR";
        CurrencyEnum[CurrencyEnum["NZD"] = 'NZD'] = "NZD";
        CurrencyEnum[CurrencyEnum["PHP"] = 'PHP'] = "PHP";
        CurrencyEnum[CurrencyEnum["SGD"] = 'SGD'] = "SGD";
        CurrencyEnum[CurrencyEnum["TTD"] = 'TTD'] = "TTD";
        CurrencyEnum[CurrencyEnum["XDR"] = 'XDR'] = "XDR";
        CurrencyEnum[CurrencyEnum["ARS"] = 'ARS'] = "ARS";
        CurrencyEnum[CurrencyEnum["BOB"] = 'BOB'] = "BOB";
        CurrencyEnum[CurrencyEnum["COP"] = 'COP'] = "COP";
        CurrencyEnum[CurrencyEnum["CRC"] = 'CRC'] = "CRC";
        CurrencyEnum[CurrencyEnum["CUP"] = 'CUP'] = "CUP";
        CurrencyEnum[CurrencyEnum["DOP"] = 'DOP'] = "DOP";
        CurrencyEnum[CurrencyEnum["GTQ"] = 'GTQ'] = "GTQ";
        CurrencyEnum[CurrencyEnum["HNL"] = 'HNL'] = "HNL";
        CurrencyEnum[CurrencyEnum["MXN"] = 'MXN'] = "MXN";
        CurrencyEnum[CurrencyEnum["NIO"] = 'NIO'] = "NIO";
        CurrencyEnum[CurrencyEnum["PAB"] = 'PAB'] = "PAB";
        CurrencyEnum[CurrencyEnum["PEN"] = 'PEN'] = "PEN";
        CurrencyEnum[CurrencyEnum["PYG"] = 'PYG'] = "PYG";
        CurrencyEnum[CurrencyEnum["UYU"] = 'UYU'] = "UYU";
        CurrencyEnum[CurrencyEnum["VEF"] = 'VEF'] = "VEF";
        CurrencyEnum[CurrencyEnum["IRR"] = 'IRR'] = "IRR";
        CurrencyEnum[CurrencyEnum["XOF"] = 'XOF'] = "XOF";
        CurrencyEnum[CurrencyEnum["CDF"] = 'CDF'] = "CDF";
        CurrencyEnum[CurrencyEnum["XAF"] = 'XAF'] = "XAF";
        CurrencyEnum[CurrencyEnum["HTG"] = 'HTG'] = "HTG";
        CurrencyEnum[CurrencyEnum["ILS"] = 'ILS'] = "ILS";
        CurrencyEnum[CurrencyEnum["HRK"] = 'HRK'] = "HRK";
        CurrencyEnum[CurrencyEnum["HUF"] = 'HUF'] = "HUF";
        CurrencyEnum[CurrencyEnum["AMD"] = 'AMD'] = "AMD";
        CurrencyEnum[CurrencyEnum["ISK"] = 'ISK'] = "ISK";
        CurrencyEnum[CurrencyEnum["JPY"] = 'JPY'] = "JPY";
        CurrencyEnum[CurrencyEnum["GEL"] = 'GEL'] = "GEL";
        CurrencyEnum[CurrencyEnum["KZT"] = 'KZT'] = "KZT";
        CurrencyEnum[CurrencyEnum["KHR"] = 'KHR'] = "KHR";
        CurrencyEnum[CurrencyEnum["KRW"] = 'KRW'] = "KRW";
        CurrencyEnum[CurrencyEnum["KGS"] = 'KGS'] = "KGS";
        CurrencyEnum[CurrencyEnum["LAK"] = 'LAK'] = "LAK";
        CurrencyEnum[CurrencyEnum["MKD"] = 'MKD'] = "MKD";
        CurrencyEnum[CurrencyEnum["MNT"] = 'MNT'] = "MNT";
        CurrencyEnum[CurrencyEnum["BND"] = 'BND'] = "BND";
        CurrencyEnum[CurrencyEnum["MMK"] = 'MMK'] = "MMK";
        CurrencyEnum[CurrencyEnum["NOK"] = 'NOK'] = "NOK";
        CurrencyEnum[CurrencyEnum["NPR"] = 'NPR'] = "NPR";
        CurrencyEnum[CurrencyEnum["PKR"] = 'PKR'] = "PKR";
        CurrencyEnum[CurrencyEnum["PLN"] = 'PLN'] = "PLN";
        CurrencyEnum[CurrencyEnum["AFN"] = 'AFN'] = "AFN";
        CurrencyEnum[CurrencyEnum["BRL"] = 'BRL'] = "BRL";
        CurrencyEnum[CurrencyEnum["MDL"] = 'MDL'] = "MDL";
        CurrencyEnum[CurrencyEnum["RON"] = 'RON'] = "RON";
        CurrencyEnum[CurrencyEnum["RWF"] = 'RWF'] = "RWF";
        CurrencyEnum[CurrencyEnum["SEK"] = 'SEK'] = "SEK";
        CurrencyEnum[CurrencyEnum["LKR"] = 'LKR'] = "LKR";
        CurrencyEnum[CurrencyEnum["SOS"] = 'SOS'] = "SOS";
        CurrencyEnum[CurrencyEnum["ALL"] = 'ALL'] = "ALL";
        CurrencyEnum[CurrencyEnum["RSD"] = 'RSD'] = "RSD";
        CurrencyEnum[CurrencyEnum["KES"] = 'KES'] = "KES";
        CurrencyEnum[CurrencyEnum["TJS"] = 'TJS'] = "TJS";
        CurrencyEnum[CurrencyEnum["THB"] = 'THB'] = "THB";
        CurrencyEnum[CurrencyEnum["ERN"] = 'ERN'] = "ERN";
        CurrencyEnum[CurrencyEnum["TMT"] = 'TMT'] = "TMT";
        CurrencyEnum[CurrencyEnum["BWP"] = 'BWP'] = "BWP";
        CurrencyEnum[CurrencyEnum["TRY"] = 'TRY'] = "TRY";
        CurrencyEnum[CurrencyEnum["UAH"] = 'UAH'] = "UAH";
        CurrencyEnum[CurrencyEnum["UZS"] = 'UZS'] = "UZS";
        CurrencyEnum[CurrencyEnum["VND"] = 'VND'] = "VND";
        CurrencyEnum[CurrencyEnum["MOP"] = 'MOP'] = "MOP";
        CurrencyEnum[CurrencyEnum["TWD"] = 'TWD'] = "TWD";
        CurrencyEnum[CurrencyEnum["BMD"] = 'BMD'] = "BMD";
    })(CurrencyEnum = Payout.CurrencyEnum || (Payout.CurrencyEnum = {}));
})(Payout || (exports.Payout = Payout = {}));
var PayoutChargeback;
(function (PayoutChargeback) {
    var OrderCurrencyEnum;
    (function (OrderCurrencyEnum) {
        OrderCurrencyEnum[OrderCurrencyEnum["EUR"] = 'EUR'] = "EUR";
        OrderCurrencyEnum[OrderCurrencyEnum["USD"] = 'USD'] = "USD";
        OrderCurrencyEnum[OrderCurrencyEnum["GBP"] = 'GBP'] = "GBP";
        OrderCurrencyEnum[OrderCurrencyEnum["CAD"] = 'CAD'] = "CAD";
        OrderCurrencyEnum[OrderCurrencyEnum["AUD"] = 'AUD'] = "AUD";
        OrderCurrencyEnum[OrderCurrencyEnum["DJF"] = 'DJF'] = "DJF";
        OrderCurrencyEnum[OrderCurrencyEnum["ZAR"] = 'ZAR'] = "ZAR";
        OrderCurrencyEnum[OrderCurrencyEnum["ETB"] = 'ETB'] = "ETB";
        OrderCurrencyEnum[OrderCurrencyEnum["AED"] = 'AED'] = "AED";
        OrderCurrencyEnum[OrderCurrencyEnum["BHD"] = 'BHD'] = "BHD";
        OrderCurrencyEnum[OrderCurrencyEnum["DZD"] = 'DZD'] = "DZD";
        OrderCurrencyEnum[OrderCurrencyEnum["EGP"] = 'EGP'] = "EGP";
        OrderCurrencyEnum[OrderCurrencyEnum["IQD"] = 'IQD'] = "IQD";
        OrderCurrencyEnum[OrderCurrencyEnum["JOD"] = 'JOD'] = "JOD";
        OrderCurrencyEnum[OrderCurrencyEnum["KWD"] = 'KWD'] = "KWD";
        OrderCurrencyEnum[OrderCurrencyEnum["LBP"] = 'LBP'] = "LBP";
        OrderCurrencyEnum[OrderCurrencyEnum["LYD"] = 'LYD'] = "LYD";
        OrderCurrencyEnum[OrderCurrencyEnum["MAD"] = 'MAD'] = "MAD";
        OrderCurrencyEnum[OrderCurrencyEnum["OMR"] = 'OMR'] = "OMR";
        OrderCurrencyEnum[OrderCurrencyEnum["QAR"] = 'QAR'] = "QAR";
        OrderCurrencyEnum[OrderCurrencyEnum["SAR"] = 'SAR'] = "SAR";
        OrderCurrencyEnum[OrderCurrencyEnum["SYP"] = 'SYP'] = "SYP";
        OrderCurrencyEnum[OrderCurrencyEnum["TND"] = 'TND'] = "TND";
        OrderCurrencyEnum[OrderCurrencyEnum["YER"] = 'YER'] = "YER";
        OrderCurrencyEnum[OrderCurrencyEnum["CLP"] = 'CLP'] = "CLP";
        OrderCurrencyEnum[OrderCurrencyEnum["INR"] = 'INR'] = "INR";
        OrderCurrencyEnum[OrderCurrencyEnum["AZN"] = 'AZN'] = "AZN";
        OrderCurrencyEnum[OrderCurrencyEnum["RUB"] = 'RUB'] = "RUB";
        OrderCurrencyEnum[OrderCurrencyEnum["BYN"] = 'BYN'] = "BYN";
        OrderCurrencyEnum[OrderCurrencyEnum["BGN"] = 'BGN'] = "BGN";
        OrderCurrencyEnum[OrderCurrencyEnum["NGN"] = 'NGN'] = "NGN";
        OrderCurrencyEnum[OrderCurrencyEnum["BDT"] = 'BDT'] = "BDT";
        OrderCurrencyEnum[OrderCurrencyEnum["CNY"] = 'CNY'] = "CNY";
        OrderCurrencyEnum[OrderCurrencyEnum["BAM"] = 'BAM'] = "BAM";
        OrderCurrencyEnum[OrderCurrencyEnum["CZK"] = 'CZK'] = "CZK";
        OrderCurrencyEnum[OrderCurrencyEnum["DKK"] = 'DKK'] = "DKK";
        OrderCurrencyEnum[OrderCurrencyEnum["CHF"] = 'CHF'] = "CHF";
        OrderCurrencyEnum[OrderCurrencyEnum["MVR"] = 'MVR'] = "MVR";
        OrderCurrencyEnum[OrderCurrencyEnum["BTN"] = 'BTN'] = "BTN";
        OrderCurrencyEnum[OrderCurrencyEnum["XCD"] = 'XCD'] = "XCD";
        OrderCurrencyEnum[OrderCurrencyEnum["BZD"] = 'BZD'] = "BZD";
        OrderCurrencyEnum[OrderCurrencyEnum["HKD"] = 'HKD'] = "HKD";
        OrderCurrencyEnum[OrderCurrencyEnum["IDR"] = 'IDR'] = "IDR";
        OrderCurrencyEnum[OrderCurrencyEnum["JMD"] = 'JMD'] = "JMD";
        OrderCurrencyEnum[OrderCurrencyEnum["MYR"] = 'MYR'] = "MYR";
        OrderCurrencyEnum[OrderCurrencyEnum["NZD"] = 'NZD'] = "NZD";
        OrderCurrencyEnum[OrderCurrencyEnum["PHP"] = 'PHP'] = "PHP";
        OrderCurrencyEnum[OrderCurrencyEnum["SGD"] = 'SGD'] = "SGD";
        OrderCurrencyEnum[OrderCurrencyEnum["TTD"] = 'TTD'] = "TTD";
        OrderCurrencyEnum[OrderCurrencyEnum["XDR"] = 'XDR'] = "XDR";
        OrderCurrencyEnum[OrderCurrencyEnum["ARS"] = 'ARS'] = "ARS";
        OrderCurrencyEnum[OrderCurrencyEnum["BOB"] = 'BOB'] = "BOB";
        OrderCurrencyEnum[OrderCurrencyEnum["COP"] = 'COP'] = "COP";
        OrderCurrencyEnum[OrderCurrencyEnum["CRC"] = 'CRC'] = "CRC";
        OrderCurrencyEnum[OrderCurrencyEnum["CUP"] = 'CUP'] = "CUP";
        OrderCurrencyEnum[OrderCurrencyEnum["DOP"] = 'DOP'] = "DOP";
        OrderCurrencyEnum[OrderCurrencyEnum["GTQ"] = 'GTQ'] = "GTQ";
        OrderCurrencyEnum[OrderCurrencyEnum["HNL"] = 'HNL'] = "HNL";
        OrderCurrencyEnum[OrderCurrencyEnum["MXN"] = 'MXN'] = "MXN";
        OrderCurrencyEnum[OrderCurrencyEnum["NIO"] = 'NIO'] = "NIO";
        OrderCurrencyEnum[OrderCurrencyEnum["PAB"] = 'PAB'] = "PAB";
        OrderCurrencyEnum[OrderCurrencyEnum["PEN"] = 'PEN'] = "PEN";
        OrderCurrencyEnum[OrderCurrencyEnum["PYG"] = 'PYG'] = "PYG";
        OrderCurrencyEnum[OrderCurrencyEnum["UYU"] = 'UYU'] = "UYU";
        OrderCurrencyEnum[OrderCurrencyEnum["VEF"] = 'VEF'] = "VEF";
        OrderCurrencyEnum[OrderCurrencyEnum["IRR"] = 'IRR'] = "IRR";
        OrderCurrencyEnum[OrderCurrencyEnum["XOF"] = 'XOF'] = "XOF";
        OrderCurrencyEnum[OrderCurrencyEnum["CDF"] = 'CDF'] = "CDF";
        OrderCurrencyEnum[OrderCurrencyEnum["XAF"] = 'XAF'] = "XAF";
        OrderCurrencyEnum[OrderCurrencyEnum["HTG"] = 'HTG'] = "HTG";
        OrderCurrencyEnum[OrderCurrencyEnum["ILS"] = 'ILS'] = "ILS";
        OrderCurrencyEnum[OrderCurrencyEnum["HRK"] = 'HRK'] = "HRK";
        OrderCurrencyEnum[OrderCurrencyEnum["HUF"] = 'HUF'] = "HUF";
        OrderCurrencyEnum[OrderCurrencyEnum["AMD"] = 'AMD'] = "AMD";
        OrderCurrencyEnum[OrderCurrencyEnum["ISK"] = 'ISK'] = "ISK";
        OrderCurrencyEnum[OrderCurrencyEnum["JPY"] = 'JPY'] = "JPY";
        OrderCurrencyEnum[OrderCurrencyEnum["GEL"] = 'GEL'] = "GEL";
        OrderCurrencyEnum[OrderCurrencyEnum["KZT"] = 'KZT'] = "KZT";
        OrderCurrencyEnum[OrderCurrencyEnum["KHR"] = 'KHR'] = "KHR";
        OrderCurrencyEnum[OrderCurrencyEnum["KRW"] = 'KRW'] = "KRW";
        OrderCurrencyEnum[OrderCurrencyEnum["KGS"] = 'KGS'] = "KGS";
        OrderCurrencyEnum[OrderCurrencyEnum["LAK"] = 'LAK'] = "LAK";
        OrderCurrencyEnum[OrderCurrencyEnum["MKD"] = 'MKD'] = "MKD";
        OrderCurrencyEnum[OrderCurrencyEnum["MNT"] = 'MNT'] = "MNT";
        OrderCurrencyEnum[OrderCurrencyEnum["BND"] = 'BND'] = "BND";
        OrderCurrencyEnum[OrderCurrencyEnum["MMK"] = 'MMK'] = "MMK";
        OrderCurrencyEnum[OrderCurrencyEnum["NOK"] = 'NOK'] = "NOK";
        OrderCurrencyEnum[OrderCurrencyEnum["NPR"] = 'NPR'] = "NPR";
        OrderCurrencyEnum[OrderCurrencyEnum["PKR"] = 'PKR'] = "PKR";
        OrderCurrencyEnum[OrderCurrencyEnum["PLN"] = 'PLN'] = "PLN";
        OrderCurrencyEnum[OrderCurrencyEnum["AFN"] = 'AFN'] = "AFN";
        OrderCurrencyEnum[OrderCurrencyEnum["BRL"] = 'BRL'] = "BRL";
        OrderCurrencyEnum[OrderCurrencyEnum["MDL"] = 'MDL'] = "MDL";
        OrderCurrencyEnum[OrderCurrencyEnum["RON"] = 'RON'] = "RON";
        OrderCurrencyEnum[OrderCurrencyEnum["RWF"] = 'RWF'] = "RWF";
        OrderCurrencyEnum[OrderCurrencyEnum["SEK"] = 'SEK'] = "SEK";
        OrderCurrencyEnum[OrderCurrencyEnum["LKR"] = 'LKR'] = "LKR";
        OrderCurrencyEnum[OrderCurrencyEnum["SOS"] = 'SOS'] = "SOS";
        OrderCurrencyEnum[OrderCurrencyEnum["ALL"] = 'ALL'] = "ALL";
        OrderCurrencyEnum[OrderCurrencyEnum["RSD"] = 'RSD'] = "RSD";
        OrderCurrencyEnum[OrderCurrencyEnum["KES"] = 'KES'] = "KES";
        OrderCurrencyEnum[OrderCurrencyEnum["TJS"] = 'TJS'] = "TJS";
        OrderCurrencyEnum[OrderCurrencyEnum["THB"] = 'THB'] = "THB";
        OrderCurrencyEnum[OrderCurrencyEnum["ERN"] = 'ERN'] = "ERN";
        OrderCurrencyEnum[OrderCurrencyEnum["TMT"] = 'TMT'] = "TMT";
        OrderCurrencyEnum[OrderCurrencyEnum["BWP"] = 'BWP'] = "BWP";
        OrderCurrencyEnum[OrderCurrencyEnum["TRY"] = 'TRY'] = "TRY";
        OrderCurrencyEnum[OrderCurrencyEnum["UAH"] = 'UAH'] = "UAH";
        OrderCurrencyEnum[OrderCurrencyEnum["UZS"] = 'UZS'] = "UZS";
        OrderCurrencyEnum[OrderCurrencyEnum["VND"] = 'VND'] = "VND";
        OrderCurrencyEnum[OrderCurrencyEnum["MOP"] = 'MOP'] = "MOP";
        OrderCurrencyEnum[OrderCurrencyEnum["TWD"] = 'TWD'] = "TWD";
        OrderCurrencyEnum[OrderCurrencyEnum["BMD"] = 'BMD'] = "BMD";
    })(OrderCurrencyEnum = PayoutChargeback.OrderCurrencyEnum || (PayoutChargeback.OrderCurrencyEnum = {}));
    var OrderTypeEnum;
    (function (OrderTypeEnum) {
        OrderTypeEnum[OrderTypeEnum["Cash"] = 'Cash'] = "Cash";
        OrderTypeEnum[OrderTypeEnum["Online"] = 'Online'] = "Online";
    })(OrderTypeEnum = PayoutChargeback.OrderTypeEnum || (PayoutChargeback.OrderTypeEnum = {}));
})(PayoutChargeback || (exports.PayoutChargeback = PayoutChargeback = {}));
var PayoutDetail;
(function (PayoutDetail) {
    var PayoutStatusEnum;
    (function (PayoutStatusEnum) {
        PayoutStatusEnum[PayoutStatusEnum["Pending"] = 'Pending'] = "Pending";
        PayoutStatusEnum[PayoutStatusEnum["InTransit"] = 'InTransit'] = "InTransit";
        PayoutStatusEnum[PayoutStatusEnum["Paid"] = 'Paid'] = "Paid";
        PayoutStatusEnum[PayoutStatusEnum["Failed"] = 'Failed'] = "Failed";
        PayoutStatusEnum[PayoutStatusEnum["Cancelled"] = 'Cancelled'] = "Cancelled";
    })(PayoutStatusEnum = PayoutDetail.PayoutStatusEnum || (PayoutDetail.PayoutStatusEnum = {}));
    var PayoutTypeEnum;
    (function (PayoutTypeEnum) {
        PayoutTypeEnum[PayoutTypeEnum["Internal"] = 'Internal'] = "Internal";
        PayoutTypeEnum[PayoutTypeEnum["Stripe"] = 'Stripe'] = "Stripe";
    })(PayoutTypeEnum = PayoutDetail.PayoutTypeEnum || (PayoutDetail.PayoutTypeEnum = {}));
    var CurrencyEnum;
    (function (CurrencyEnum) {
        CurrencyEnum[CurrencyEnum["EUR"] = 'EUR'] = "EUR";
        CurrencyEnum[CurrencyEnum["USD"] = 'USD'] = "USD";
        CurrencyEnum[CurrencyEnum["GBP"] = 'GBP'] = "GBP";
        CurrencyEnum[CurrencyEnum["CAD"] = 'CAD'] = "CAD";
        CurrencyEnum[CurrencyEnum["AUD"] = 'AUD'] = "AUD";
        CurrencyEnum[CurrencyEnum["DJF"] = 'DJF'] = "DJF";
        CurrencyEnum[CurrencyEnum["ZAR"] = 'ZAR'] = "ZAR";
        CurrencyEnum[CurrencyEnum["ETB"] = 'ETB'] = "ETB";
        CurrencyEnum[CurrencyEnum["AED"] = 'AED'] = "AED";
        CurrencyEnum[CurrencyEnum["BHD"] = 'BHD'] = "BHD";
        CurrencyEnum[CurrencyEnum["DZD"] = 'DZD'] = "DZD";
        CurrencyEnum[CurrencyEnum["EGP"] = 'EGP'] = "EGP";
        CurrencyEnum[CurrencyEnum["IQD"] = 'IQD'] = "IQD";
        CurrencyEnum[CurrencyEnum["JOD"] = 'JOD'] = "JOD";
        CurrencyEnum[CurrencyEnum["KWD"] = 'KWD'] = "KWD";
        CurrencyEnum[CurrencyEnum["LBP"] = 'LBP'] = "LBP";
        CurrencyEnum[CurrencyEnum["LYD"] = 'LYD'] = "LYD";
        CurrencyEnum[CurrencyEnum["MAD"] = 'MAD'] = "MAD";
        CurrencyEnum[CurrencyEnum["OMR"] = 'OMR'] = "OMR";
        CurrencyEnum[CurrencyEnum["QAR"] = 'QAR'] = "QAR";
        CurrencyEnum[CurrencyEnum["SAR"] = 'SAR'] = "SAR";
        CurrencyEnum[CurrencyEnum["SYP"] = 'SYP'] = "SYP";
        CurrencyEnum[CurrencyEnum["TND"] = 'TND'] = "TND";
        CurrencyEnum[CurrencyEnum["YER"] = 'YER'] = "YER";
        CurrencyEnum[CurrencyEnum["CLP"] = 'CLP'] = "CLP";
        CurrencyEnum[CurrencyEnum["INR"] = 'INR'] = "INR";
        CurrencyEnum[CurrencyEnum["AZN"] = 'AZN'] = "AZN";
        CurrencyEnum[CurrencyEnum["RUB"] = 'RUB'] = "RUB";
        CurrencyEnum[CurrencyEnum["BYN"] = 'BYN'] = "BYN";
        CurrencyEnum[CurrencyEnum["BGN"] = 'BGN'] = "BGN";
        CurrencyEnum[CurrencyEnum["NGN"] = 'NGN'] = "NGN";
        CurrencyEnum[CurrencyEnum["BDT"] = 'BDT'] = "BDT";
        CurrencyEnum[CurrencyEnum["CNY"] = 'CNY'] = "CNY";
        CurrencyEnum[CurrencyEnum["BAM"] = 'BAM'] = "BAM";
        CurrencyEnum[CurrencyEnum["CZK"] = 'CZK'] = "CZK";
        CurrencyEnum[CurrencyEnum["DKK"] = 'DKK'] = "DKK";
        CurrencyEnum[CurrencyEnum["CHF"] = 'CHF'] = "CHF";
        CurrencyEnum[CurrencyEnum["MVR"] = 'MVR'] = "MVR";
        CurrencyEnum[CurrencyEnum["BTN"] = 'BTN'] = "BTN";
        CurrencyEnum[CurrencyEnum["XCD"] = 'XCD'] = "XCD";
        CurrencyEnum[CurrencyEnum["BZD"] = 'BZD'] = "BZD";
        CurrencyEnum[CurrencyEnum["HKD"] = 'HKD'] = "HKD";
        CurrencyEnum[CurrencyEnum["IDR"] = 'IDR'] = "IDR";
        CurrencyEnum[CurrencyEnum["JMD"] = 'JMD'] = "JMD";
        CurrencyEnum[CurrencyEnum["MYR"] = 'MYR'] = "MYR";
        CurrencyEnum[CurrencyEnum["NZD"] = 'NZD'] = "NZD";
        CurrencyEnum[CurrencyEnum["PHP"] = 'PHP'] = "PHP";
        CurrencyEnum[CurrencyEnum["SGD"] = 'SGD'] = "SGD";
        CurrencyEnum[CurrencyEnum["TTD"] = 'TTD'] = "TTD";
        CurrencyEnum[CurrencyEnum["XDR"] = 'XDR'] = "XDR";
        CurrencyEnum[CurrencyEnum["ARS"] = 'ARS'] = "ARS";
        CurrencyEnum[CurrencyEnum["BOB"] = 'BOB'] = "BOB";
        CurrencyEnum[CurrencyEnum["COP"] = 'COP'] = "COP";
        CurrencyEnum[CurrencyEnum["CRC"] = 'CRC'] = "CRC";
        CurrencyEnum[CurrencyEnum["CUP"] = 'CUP'] = "CUP";
        CurrencyEnum[CurrencyEnum["DOP"] = 'DOP'] = "DOP";
        CurrencyEnum[CurrencyEnum["GTQ"] = 'GTQ'] = "GTQ";
        CurrencyEnum[CurrencyEnum["HNL"] = 'HNL'] = "HNL";
        CurrencyEnum[CurrencyEnum["MXN"] = 'MXN'] = "MXN";
        CurrencyEnum[CurrencyEnum["NIO"] = 'NIO'] = "NIO";
        CurrencyEnum[CurrencyEnum["PAB"] = 'PAB'] = "PAB";
        CurrencyEnum[CurrencyEnum["PEN"] = 'PEN'] = "PEN";
        CurrencyEnum[CurrencyEnum["PYG"] = 'PYG'] = "PYG";
        CurrencyEnum[CurrencyEnum["UYU"] = 'UYU'] = "UYU";
        CurrencyEnum[CurrencyEnum["VEF"] = 'VEF'] = "VEF";
        CurrencyEnum[CurrencyEnum["IRR"] = 'IRR'] = "IRR";
        CurrencyEnum[CurrencyEnum["XOF"] = 'XOF'] = "XOF";
        CurrencyEnum[CurrencyEnum["CDF"] = 'CDF'] = "CDF";
        CurrencyEnum[CurrencyEnum["XAF"] = 'XAF'] = "XAF";
        CurrencyEnum[CurrencyEnum["HTG"] = 'HTG'] = "HTG";
        CurrencyEnum[CurrencyEnum["ILS"] = 'ILS'] = "ILS";
        CurrencyEnum[CurrencyEnum["HRK"] = 'HRK'] = "HRK";
        CurrencyEnum[CurrencyEnum["HUF"] = 'HUF'] = "HUF";
        CurrencyEnum[CurrencyEnum["AMD"] = 'AMD'] = "AMD";
        CurrencyEnum[CurrencyEnum["ISK"] = 'ISK'] = "ISK";
        CurrencyEnum[CurrencyEnum["JPY"] = 'JPY'] = "JPY";
        CurrencyEnum[CurrencyEnum["GEL"] = 'GEL'] = "GEL";
        CurrencyEnum[CurrencyEnum["KZT"] = 'KZT'] = "KZT";
        CurrencyEnum[CurrencyEnum["KHR"] = 'KHR'] = "KHR";
        CurrencyEnum[CurrencyEnum["KRW"] = 'KRW'] = "KRW";
        CurrencyEnum[CurrencyEnum["KGS"] = 'KGS'] = "KGS";
        CurrencyEnum[CurrencyEnum["LAK"] = 'LAK'] = "LAK";
        CurrencyEnum[CurrencyEnum["MKD"] = 'MKD'] = "MKD";
        CurrencyEnum[CurrencyEnum["MNT"] = 'MNT'] = "MNT";
        CurrencyEnum[CurrencyEnum["BND"] = 'BND'] = "BND";
        CurrencyEnum[CurrencyEnum["MMK"] = 'MMK'] = "MMK";
        CurrencyEnum[CurrencyEnum["NOK"] = 'NOK'] = "NOK";
        CurrencyEnum[CurrencyEnum["NPR"] = 'NPR'] = "NPR";
        CurrencyEnum[CurrencyEnum["PKR"] = 'PKR'] = "PKR";
        CurrencyEnum[CurrencyEnum["PLN"] = 'PLN'] = "PLN";
        CurrencyEnum[CurrencyEnum["AFN"] = 'AFN'] = "AFN";
        CurrencyEnum[CurrencyEnum["BRL"] = 'BRL'] = "BRL";
        CurrencyEnum[CurrencyEnum["MDL"] = 'MDL'] = "MDL";
        CurrencyEnum[CurrencyEnum["RON"] = 'RON'] = "RON";
        CurrencyEnum[CurrencyEnum["RWF"] = 'RWF'] = "RWF";
        CurrencyEnum[CurrencyEnum["SEK"] = 'SEK'] = "SEK";
        CurrencyEnum[CurrencyEnum["LKR"] = 'LKR'] = "LKR";
        CurrencyEnum[CurrencyEnum["SOS"] = 'SOS'] = "SOS";
        CurrencyEnum[CurrencyEnum["ALL"] = 'ALL'] = "ALL";
        CurrencyEnum[CurrencyEnum["RSD"] = 'RSD'] = "RSD";
        CurrencyEnum[CurrencyEnum["KES"] = 'KES'] = "KES";
        CurrencyEnum[CurrencyEnum["TJS"] = 'TJS'] = "TJS";
        CurrencyEnum[CurrencyEnum["THB"] = 'THB'] = "THB";
        CurrencyEnum[CurrencyEnum["ERN"] = 'ERN'] = "ERN";
        CurrencyEnum[CurrencyEnum["TMT"] = 'TMT'] = "TMT";
        CurrencyEnum[CurrencyEnum["BWP"] = 'BWP'] = "BWP";
        CurrencyEnum[CurrencyEnum["TRY"] = 'TRY'] = "TRY";
        CurrencyEnum[CurrencyEnum["UAH"] = 'UAH'] = "UAH";
        CurrencyEnum[CurrencyEnum["UZS"] = 'UZS'] = "UZS";
        CurrencyEnum[CurrencyEnum["VND"] = 'VND'] = "VND";
        CurrencyEnum[CurrencyEnum["MOP"] = 'MOP'] = "MOP";
        CurrencyEnum[CurrencyEnum["TWD"] = 'TWD'] = "TWD";
        CurrencyEnum[CurrencyEnum["BMD"] = 'BMD'] = "BMD";
    })(CurrencyEnum = PayoutDetail.CurrencyEnum || (PayoutDetail.CurrencyEnum = {}));
})(PayoutDetail || (exports.PayoutDetail = PayoutDetail = {}));
var PayoutOrder;
(function (PayoutOrder) {
    var OrderTypeEnum;
    (function (OrderTypeEnum) {
        OrderTypeEnum[OrderTypeEnum["Cash"] = 'Cash'] = "Cash";
        OrderTypeEnum[OrderTypeEnum["Online"] = 'Online'] = "Online";
    })(OrderTypeEnum = PayoutOrder.OrderTypeEnum || (PayoutOrder.OrderTypeEnum = {}));
    var OrderCurrencyEnum;
    (function (OrderCurrencyEnum) {
        OrderCurrencyEnum[OrderCurrencyEnum["EUR"] = 'EUR'] = "EUR";
        OrderCurrencyEnum[OrderCurrencyEnum["USD"] = 'USD'] = "USD";
        OrderCurrencyEnum[OrderCurrencyEnum["GBP"] = 'GBP'] = "GBP";
        OrderCurrencyEnum[OrderCurrencyEnum["CAD"] = 'CAD'] = "CAD";
        OrderCurrencyEnum[OrderCurrencyEnum["AUD"] = 'AUD'] = "AUD";
        OrderCurrencyEnum[OrderCurrencyEnum["DJF"] = 'DJF'] = "DJF";
        OrderCurrencyEnum[OrderCurrencyEnum["ZAR"] = 'ZAR'] = "ZAR";
        OrderCurrencyEnum[OrderCurrencyEnum["ETB"] = 'ETB'] = "ETB";
        OrderCurrencyEnum[OrderCurrencyEnum["AED"] = 'AED'] = "AED";
        OrderCurrencyEnum[OrderCurrencyEnum["BHD"] = 'BHD'] = "BHD";
        OrderCurrencyEnum[OrderCurrencyEnum["DZD"] = 'DZD'] = "DZD";
        OrderCurrencyEnum[OrderCurrencyEnum["EGP"] = 'EGP'] = "EGP";
        OrderCurrencyEnum[OrderCurrencyEnum["IQD"] = 'IQD'] = "IQD";
        OrderCurrencyEnum[OrderCurrencyEnum["JOD"] = 'JOD'] = "JOD";
        OrderCurrencyEnum[OrderCurrencyEnum["KWD"] = 'KWD'] = "KWD";
        OrderCurrencyEnum[OrderCurrencyEnum["LBP"] = 'LBP'] = "LBP";
        OrderCurrencyEnum[OrderCurrencyEnum["LYD"] = 'LYD'] = "LYD";
        OrderCurrencyEnum[OrderCurrencyEnum["MAD"] = 'MAD'] = "MAD";
        OrderCurrencyEnum[OrderCurrencyEnum["OMR"] = 'OMR'] = "OMR";
        OrderCurrencyEnum[OrderCurrencyEnum["QAR"] = 'QAR'] = "QAR";
        OrderCurrencyEnum[OrderCurrencyEnum["SAR"] = 'SAR'] = "SAR";
        OrderCurrencyEnum[OrderCurrencyEnum["SYP"] = 'SYP'] = "SYP";
        OrderCurrencyEnum[OrderCurrencyEnum["TND"] = 'TND'] = "TND";
        OrderCurrencyEnum[OrderCurrencyEnum["YER"] = 'YER'] = "YER";
        OrderCurrencyEnum[OrderCurrencyEnum["CLP"] = 'CLP'] = "CLP";
        OrderCurrencyEnum[OrderCurrencyEnum["INR"] = 'INR'] = "INR";
        OrderCurrencyEnum[OrderCurrencyEnum["AZN"] = 'AZN'] = "AZN";
        OrderCurrencyEnum[OrderCurrencyEnum["RUB"] = 'RUB'] = "RUB";
        OrderCurrencyEnum[OrderCurrencyEnum["BYN"] = 'BYN'] = "BYN";
        OrderCurrencyEnum[OrderCurrencyEnum["BGN"] = 'BGN'] = "BGN";
        OrderCurrencyEnum[OrderCurrencyEnum["NGN"] = 'NGN'] = "NGN";
        OrderCurrencyEnum[OrderCurrencyEnum["BDT"] = 'BDT'] = "BDT";
        OrderCurrencyEnum[OrderCurrencyEnum["CNY"] = 'CNY'] = "CNY";
        OrderCurrencyEnum[OrderCurrencyEnum["BAM"] = 'BAM'] = "BAM";
        OrderCurrencyEnum[OrderCurrencyEnum["CZK"] = 'CZK'] = "CZK";
        OrderCurrencyEnum[OrderCurrencyEnum["DKK"] = 'DKK'] = "DKK";
        OrderCurrencyEnum[OrderCurrencyEnum["CHF"] = 'CHF'] = "CHF";
        OrderCurrencyEnum[OrderCurrencyEnum["MVR"] = 'MVR'] = "MVR";
        OrderCurrencyEnum[OrderCurrencyEnum["BTN"] = 'BTN'] = "BTN";
        OrderCurrencyEnum[OrderCurrencyEnum["XCD"] = 'XCD'] = "XCD";
        OrderCurrencyEnum[OrderCurrencyEnum["BZD"] = 'BZD'] = "BZD";
        OrderCurrencyEnum[OrderCurrencyEnum["HKD"] = 'HKD'] = "HKD";
        OrderCurrencyEnum[OrderCurrencyEnum["IDR"] = 'IDR'] = "IDR";
        OrderCurrencyEnum[OrderCurrencyEnum["JMD"] = 'JMD'] = "JMD";
        OrderCurrencyEnum[OrderCurrencyEnum["MYR"] = 'MYR'] = "MYR";
        OrderCurrencyEnum[OrderCurrencyEnum["NZD"] = 'NZD'] = "NZD";
        OrderCurrencyEnum[OrderCurrencyEnum["PHP"] = 'PHP'] = "PHP";
        OrderCurrencyEnum[OrderCurrencyEnum["SGD"] = 'SGD'] = "SGD";
        OrderCurrencyEnum[OrderCurrencyEnum["TTD"] = 'TTD'] = "TTD";
        OrderCurrencyEnum[OrderCurrencyEnum["XDR"] = 'XDR'] = "XDR";
        OrderCurrencyEnum[OrderCurrencyEnum["ARS"] = 'ARS'] = "ARS";
        OrderCurrencyEnum[OrderCurrencyEnum["BOB"] = 'BOB'] = "BOB";
        OrderCurrencyEnum[OrderCurrencyEnum["COP"] = 'COP'] = "COP";
        OrderCurrencyEnum[OrderCurrencyEnum["CRC"] = 'CRC'] = "CRC";
        OrderCurrencyEnum[OrderCurrencyEnum["CUP"] = 'CUP'] = "CUP";
        OrderCurrencyEnum[OrderCurrencyEnum["DOP"] = 'DOP'] = "DOP";
        OrderCurrencyEnum[OrderCurrencyEnum["GTQ"] = 'GTQ'] = "GTQ";
        OrderCurrencyEnum[OrderCurrencyEnum["HNL"] = 'HNL'] = "HNL";
        OrderCurrencyEnum[OrderCurrencyEnum["MXN"] = 'MXN'] = "MXN";
        OrderCurrencyEnum[OrderCurrencyEnum["NIO"] = 'NIO'] = "NIO";
        OrderCurrencyEnum[OrderCurrencyEnum["PAB"] = 'PAB'] = "PAB";
        OrderCurrencyEnum[OrderCurrencyEnum["PEN"] = 'PEN'] = "PEN";
        OrderCurrencyEnum[OrderCurrencyEnum["PYG"] = 'PYG'] = "PYG";
        OrderCurrencyEnum[OrderCurrencyEnum["UYU"] = 'UYU'] = "UYU";
        OrderCurrencyEnum[OrderCurrencyEnum["VEF"] = 'VEF'] = "VEF";
        OrderCurrencyEnum[OrderCurrencyEnum["IRR"] = 'IRR'] = "IRR";
        OrderCurrencyEnum[OrderCurrencyEnum["XOF"] = 'XOF'] = "XOF";
        OrderCurrencyEnum[OrderCurrencyEnum["CDF"] = 'CDF'] = "CDF";
        OrderCurrencyEnum[OrderCurrencyEnum["XAF"] = 'XAF'] = "XAF";
        OrderCurrencyEnum[OrderCurrencyEnum["HTG"] = 'HTG'] = "HTG";
        OrderCurrencyEnum[OrderCurrencyEnum["ILS"] = 'ILS'] = "ILS";
        OrderCurrencyEnum[OrderCurrencyEnum["HRK"] = 'HRK'] = "HRK";
        OrderCurrencyEnum[OrderCurrencyEnum["HUF"] = 'HUF'] = "HUF";
        OrderCurrencyEnum[OrderCurrencyEnum["AMD"] = 'AMD'] = "AMD";
        OrderCurrencyEnum[OrderCurrencyEnum["ISK"] = 'ISK'] = "ISK";
        OrderCurrencyEnum[OrderCurrencyEnum["JPY"] = 'JPY'] = "JPY";
        OrderCurrencyEnum[OrderCurrencyEnum["GEL"] = 'GEL'] = "GEL";
        OrderCurrencyEnum[OrderCurrencyEnum["KZT"] = 'KZT'] = "KZT";
        OrderCurrencyEnum[OrderCurrencyEnum["KHR"] = 'KHR'] = "KHR";
        OrderCurrencyEnum[OrderCurrencyEnum["KRW"] = 'KRW'] = "KRW";
        OrderCurrencyEnum[OrderCurrencyEnum["KGS"] = 'KGS'] = "KGS";
        OrderCurrencyEnum[OrderCurrencyEnum["LAK"] = 'LAK'] = "LAK";
        OrderCurrencyEnum[OrderCurrencyEnum["MKD"] = 'MKD'] = "MKD";
        OrderCurrencyEnum[OrderCurrencyEnum["MNT"] = 'MNT'] = "MNT";
        OrderCurrencyEnum[OrderCurrencyEnum["BND"] = 'BND'] = "BND";
        OrderCurrencyEnum[OrderCurrencyEnum["MMK"] = 'MMK'] = "MMK";
        OrderCurrencyEnum[OrderCurrencyEnum["NOK"] = 'NOK'] = "NOK";
        OrderCurrencyEnum[OrderCurrencyEnum["NPR"] = 'NPR'] = "NPR";
        OrderCurrencyEnum[OrderCurrencyEnum["PKR"] = 'PKR'] = "PKR";
        OrderCurrencyEnum[OrderCurrencyEnum["PLN"] = 'PLN'] = "PLN";
        OrderCurrencyEnum[OrderCurrencyEnum["AFN"] = 'AFN'] = "AFN";
        OrderCurrencyEnum[OrderCurrencyEnum["BRL"] = 'BRL'] = "BRL";
        OrderCurrencyEnum[OrderCurrencyEnum["MDL"] = 'MDL'] = "MDL";
        OrderCurrencyEnum[OrderCurrencyEnum["RON"] = 'RON'] = "RON";
        OrderCurrencyEnum[OrderCurrencyEnum["RWF"] = 'RWF'] = "RWF";
        OrderCurrencyEnum[OrderCurrencyEnum["SEK"] = 'SEK'] = "SEK";
        OrderCurrencyEnum[OrderCurrencyEnum["LKR"] = 'LKR'] = "LKR";
        OrderCurrencyEnum[OrderCurrencyEnum["SOS"] = 'SOS'] = "SOS";
        OrderCurrencyEnum[OrderCurrencyEnum["ALL"] = 'ALL'] = "ALL";
        OrderCurrencyEnum[OrderCurrencyEnum["RSD"] = 'RSD'] = "RSD";
        OrderCurrencyEnum[OrderCurrencyEnum["KES"] = 'KES'] = "KES";
        OrderCurrencyEnum[OrderCurrencyEnum["TJS"] = 'TJS'] = "TJS";
        OrderCurrencyEnum[OrderCurrencyEnum["THB"] = 'THB'] = "THB";
        OrderCurrencyEnum[OrderCurrencyEnum["ERN"] = 'ERN'] = "ERN";
        OrderCurrencyEnum[OrderCurrencyEnum["TMT"] = 'TMT'] = "TMT";
        OrderCurrencyEnum[OrderCurrencyEnum["BWP"] = 'BWP'] = "BWP";
        OrderCurrencyEnum[OrderCurrencyEnum["TRY"] = 'TRY'] = "TRY";
        OrderCurrencyEnum[OrderCurrencyEnum["UAH"] = 'UAH'] = "UAH";
        OrderCurrencyEnum[OrderCurrencyEnum["UZS"] = 'UZS'] = "UZS";
        OrderCurrencyEnum[OrderCurrencyEnum["VND"] = 'VND'] = "VND";
        OrderCurrencyEnum[OrderCurrencyEnum["MOP"] = 'MOP'] = "MOP";
        OrderCurrencyEnum[OrderCurrencyEnum["TWD"] = 'TWD'] = "TWD";
        OrderCurrencyEnum[OrderCurrencyEnum["BMD"] = 'BMD'] = "BMD";
    })(OrderCurrencyEnum = PayoutOrder.OrderCurrencyEnum || (PayoutOrder.OrderCurrencyEnum = {}));
})(PayoutOrder || (exports.PayoutOrder = PayoutOrder = {}));
var PayoutOtherCharge;
(function (PayoutOtherCharge) {
    var CurrencyEnum;
    (function (CurrencyEnum) {
        CurrencyEnum[CurrencyEnum["EUR"] = 'EUR'] = "EUR";
        CurrencyEnum[CurrencyEnum["USD"] = 'USD'] = "USD";
        CurrencyEnum[CurrencyEnum["GBP"] = 'GBP'] = "GBP";
        CurrencyEnum[CurrencyEnum["CAD"] = 'CAD'] = "CAD";
        CurrencyEnum[CurrencyEnum["AUD"] = 'AUD'] = "AUD";
        CurrencyEnum[CurrencyEnum["DJF"] = 'DJF'] = "DJF";
        CurrencyEnum[CurrencyEnum["ZAR"] = 'ZAR'] = "ZAR";
        CurrencyEnum[CurrencyEnum["ETB"] = 'ETB'] = "ETB";
        CurrencyEnum[CurrencyEnum["AED"] = 'AED'] = "AED";
        CurrencyEnum[CurrencyEnum["BHD"] = 'BHD'] = "BHD";
        CurrencyEnum[CurrencyEnum["DZD"] = 'DZD'] = "DZD";
        CurrencyEnum[CurrencyEnum["EGP"] = 'EGP'] = "EGP";
        CurrencyEnum[CurrencyEnum["IQD"] = 'IQD'] = "IQD";
        CurrencyEnum[CurrencyEnum["JOD"] = 'JOD'] = "JOD";
        CurrencyEnum[CurrencyEnum["KWD"] = 'KWD'] = "KWD";
        CurrencyEnum[CurrencyEnum["LBP"] = 'LBP'] = "LBP";
        CurrencyEnum[CurrencyEnum["LYD"] = 'LYD'] = "LYD";
        CurrencyEnum[CurrencyEnum["MAD"] = 'MAD'] = "MAD";
        CurrencyEnum[CurrencyEnum["OMR"] = 'OMR'] = "OMR";
        CurrencyEnum[CurrencyEnum["QAR"] = 'QAR'] = "QAR";
        CurrencyEnum[CurrencyEnum["SAR"] = 'SAR'] = "SAR";
        CurrencyEnum[CurrencyEnum["SYP"] = 'SYP'] = "SYP";
        CurrencyEnum[CurrencyEnum["TND"] = 'TND'] = "TND";
        CurrencyEnum[CurrencyEnum["YER"] = 'YER'] = "YER";
        CurrencyEnum[CurrencyEnum["CLP"] = 'CLP'] = "CLP";
        CurrencyEnum[CurrencyEnum["INR"] = 'INR'] = "INR";
        CurrencyEnum[CurrencyEnum["AZN"] = 'AZN'] = "AZN";
        CurrencyEnum[CurrencyEnum["RUB"] = 'RUB'] = "RUB";
        CurrencyEnum[CurrencyEnum["BYN"] = 'BYN'] = "BYN";
        CurrencyEnum[CurrencyEnum["BGN"] = 'BGN'] = "BGN";
        CurrencyEnum[CurrencyEnum["NGN"] = 'NGN'] = "NGN";
        CurrencyEnum[CurrencyEnum["BDT"] = 'BDT'] = "BDT";
        CurrencyEnum[CurrencyEnum["CNY"] = 'CNY'] = "CNY";
        CurrencyEnum[CurrencyEnum["BAM"] = 'BAM'] = "BAM";
        CurrencyEnum[CurrencyEnum["CZK"] = 'CZK'] = "CZK";
        CurrencyEnum[CurrencyEnum["DKK"] = 'DKK'] = "DKK";
        CurrencyEnum[CurrencyEnum["CHF"] = 'CHF'] = "CHF";
        CurrencyEnum[CurrencyEnum["MVR"] = 'MVR'] = "MVR";
        CurrencyEnum[CurrencyEnum["BTN"] = 'BTN'] = "BTN";
        CurrencyEnum[CurrencyEnum["XCD"] = 'XCD'] = "XCD";
        CurrencyEnum[CurrencyEnum["BZD"] = 'BZD'] = "BZD";
        CurrencyEnum[CurrencyEnum["HKD"] = 'HKD'] = "HKD";
        CurrencyEnum[CurrencyEnum["IDR"] = 'IDR'] = "IDR";
        CurrencyEnum[CurrencyEnum["JMD"] = 'JMD'] = "JMD";
        CurrencyEnum[CurrencyEnum["MYR"] = 'MYR'] = "MYR";
        CurrencyEnum[CurrencyEnum["NZD"] = 'NZD'] = "NZD";
        CurrencyEnum[CurrencyEnum["PHP"] = 'PHP'] = "PHP";
        CurrencyEnum[CurrencyEnum["SGD"] = 'SGD'] = "SGD";
        CurrencyEnum[CurrencyEnum["TTD"] = 'TTD'] = "TTD";
        CurrencyEnum[CurrencyEnum["XDR"] = 'XDR'] = "XDR";
        CurrencyEnum[CurrencyEnum["ARS"] = 'ARS'] = "ARS";
        CurrencyEnum[CurrencyEnum["BOB"] = 'BOB'] = "BOB";
        CurrencyEnum[CurrencyEnum["COP"] = 'COP'] = "COP";
        CurrencyEnum[CurrencyEnum["CRC"] = 'CRC'] = "CRC";
        CurrencyEnum[CurrencyEnum["CUP"] = 'CUP'] = "CUP";
        CurrencyEnum[CurrencyEnum["DOP"] = 'DOP'] = "DOP";
        CurrencyEnum[CurrencyEnum["GTQ"] = 'GTQ'] = "GTQ";
        CurrencyEnum[CurrencyEnum["HNL"] = 'HNL'] = "HNL";
        CurrencyEnum[CurrencyEnum["MXN"] = 'MXN'] = "MXN";
        CurrencyEnum[CurrencyEnum["NIO"] = 'NIO'] = "NIO";
        CurrencyEnum[CurrencyEnum["PAB"] = 'PAB'] = "PAB";
        CurrencyEnum[CurrencyEnum["PEN"] = 'PEN'] = "PEN";
        CurrencyEnum[CurrencyEnum["PYG"] = 'PYG'] = "PYG";
        CurrencyEnum[CurrencyEnum["UYU"] = 'UYU'] = "UYU";
        CurrencyEnum[CurrencyEnum["VEF"] = 'VEF'] = "VEF";
        CurrencyEnum[CurrencyEnum["IRR"] = 'IRR'] = "IRR";
        CurrencyEnum[CurrencyEnum["XOF"] = 'XOF'] = "XOF";
        CurrencyEnum[CurrencyEnum["CDF"] = 'CDF'] = "CDF";
        CurrencyEnum[CurrencyEnum["XAF"] = 'XAF'] = "XAF";
        CurrencyEnum[CurrencyEnum["HTG"] = 'HTG'] = "HTG";
        CurrencyEnum[CurrencyEnum["ILS"] = 'ILS'] = "ILS";
        CurrencyEnum[CurrencyEnum["HRK"] = 'HRK'] = "HRK";
        CurrencyEnum[CurrencyEnum["HUF"] = 'HUF'] = "HUF";
        CurrencyEnum[CurrencyEnum["AMD"] = 'AMD'] = "AMD";
        CurrencyEnum[CurrencyEnum["ISK"] = 'ISK'] = "ISK";
        CurrencyEnum[CurrencyEnum["JPY"] = 'JPY'] = "JPY";
        CurrencyEnum[CurrencyEnum["GEL"] = 'GEL'] = "GEL";
        CurrencyEnum[CurrencyEnum["KZT"] = 'KZT'] = "KZT";
        CurrencyEnum[CurrencyEnum["KHR"] = 'KHR'] = "KHR";
        CurrencyEnum[CurrencyEnum["KRW"] = 'KRW'] = "KRW";
        CurrencyEnum[CurrencyEnum["KGS"] = 'KGS'] = "KGS";
        CurrencyEnum[CurrencyEnum["LAK"] = 'LAK'] = "LAK";
        CurrencyEnum[CurrencyEnum["MKD"] = 'MKD'] = "MKD";
        CurrencyEnum[CurrencyEnum["MNT"] = 'MNT'] = "MNT";
        CurrencyEnum[CurrencyEnum["BND"] = 'BND'] = "BND";
        CurrencyEnum[CurrencyEnum["MMK"] = 'MMK'] = "MMK";
        CurrencyEnum[CurrencyEnum["NOK"] = 'NOK'] = "NOK";
        CurrencyEnum[CurrencyEnum["NPR"] = 'NPR'] = "NPR";
        CurrencyEnum[CurrencyEnum["PKR"] = 'PKR'] = "PKR";
        CurrencyEnum[CurrencyEnum["PLN"] = 'PLN'] = "PLN";
        CurrencyEnum[CurrencyEnum["AFN"] = 'AFN'] = "AFN";
        CurrencyEnum[CurrencyEnum["BRL"] = 'BRL'] = "BRL";
        CurrencyEnum[CurrencyEnum["MDL"] = 'MDL'] = "MDL";
        CurrencyEnum[CurrencyEnum["RON"] = 'RON'] = "RON";
        CurrencyEnum[CurrencyEnum["RWF"] = 'RWF'] = "RWF";
        CurrencyEnum[CurrencyEnum["SEK"] = 'SEK'] = "SEK";
        CurrencyEnum[CurrencyEnum["LKR"] = 'LKR'] = "LKR";
        CurrencyEnum[CurrencyEnum["SOS"] = 'SOS'] = "SOS";
        CurrencyEnum[CurrencyEnum["ALL"] = 'ALL'] = "ALL";
        CurrencyEnum[CurrencyEnum["RSD"] = 'RSD'] = "RSD";
        CurrencyEnum[CurrencyEnum["KES"] = 'KES'] = "KES";
        CurrencyEnum[CurrencyEnum["TJS"] = 'TJS'] = "TJS";
        CurrencyEnum[CurrencyEnum["THB"] = 'THB'] = "THB";
        CurrencyEnum[CurrencyEnum["ERN"] = 'ERN'] = "ERN";
        CurrencyEnum[CurrencyEnum["TMT"] = 'TMT'] = "TMT";
        CurrencyEnum[CurrencyEnum["BWP"] = 'BWP'] = "BWP";
        CurrencyEnum[CurrencyEnum["TRY"] = 'TRY'] = "TRY";
        CurrencyEnum[CurrencyEnum["UAH"] = 'UAH'] = "UAH";
        CurrencyEnum[CurrencyEnum["UZS"] = 'UZS'] = "UZS";
        CurrencyEnum[CurrencyEnum["VND"] = 'VND'] = "VND";
        CurrencyEnum[CurrencyEnum["MOP"] = 'MOP'] = "MOP";
        CurrencyEnum[CurrencyEnum["TWD"] = 'TWD'] = "TWD";
        CurrencyEnum[CurrencyEnum["BMD"] = 'BMD'] = "BMD";
    })(CurrencyEnum = PayoutOtherCharge.CurrencyEnum || (PayoutOtherCharge.CurrencyEnum = {}));
    var ChargeTypeEnum;
    (function (ChargeTypeEnum) {
        ChargeTypeEnum[ChargeTypeEnum["Other"] = 'Other'] = "Other";
        ChargeTypeEnum[ChargeTypeEnum["Fees"] = 'Fees'] = "Fees";
        ChargeTypeEnum[ChargeTypeEnum["Chargeback"] = 'Chargeback'] = "Chargeback";
        ChargeTypeEnum[ChargeTypeEnum["TipFailure"] = 'TipFailure'] = "TipFailure";
        ChargeTypeEnum[ChargeTypeEnum["ExternalDisbursement"] = 'ExternalDisbursement'] = "ExternalDisbursement";
        ChargeTypeEnum[ChargeTypeEnum["Goods"] = 'Goods'] = "Goods";
        ChargeTypeEnum[ChargeTypeEnum["RestaurantSales"] = 'RestaurantSales'] = "RestaurantSales";
        ChargeTypeEnum[ChargeTypeEnum["Tips"] = 'Tips'] = "Tips";
    })(ChargeTypeEnum = PayoutOtherCharge.ChargeTypeEnum || (PayoutOtherCharge.ChargeTypeEnum = {}));
})(PayoutOtherCharge || (exports.PayoutOtherCharge = PayoutOtherCharge = {}));
var PayoutRefund;
(function (PayoutRefund) {
    var OrderCurrencyEnum;
    (function (OrderCurrencyEnum) {
        OrderCurrencyEnum[OrderCurrencyEnum["EUR"] = 'EUR'] = "EUR";
        OrderCurrencyEnum[OrderCurrencyEnum["USD"] = 'USD'] = "USD";
        OrderCurrencyEnum[OrderCurrencyEnum["GBP"] = 'GBP'] = "GBP";
        OrderCurrencyEnum[OrderCurrencyEnum["CAD"] = 'CAD'] = "CAD";
        OrderCurrencyEnum[OrderCurrencyEnum["AUD"] = 'AUD'] = "AUD";
        OrderCurrencyEnum[OrderCurrencyEnum["DJF"] = 'DJF'] = "DJF";
        OrderCurrencyEnum[OrderCurrencyEnum["ZAR"] = 'ZAR'] = "ZAR";
        OrderCurrencyEnum[OrderCurrencyEnum["ETB"] = 'ETB'] = "ETB";
        OrderCurrencyEnum[OrderCurrencyEnum["AED"] = 'AED'] = "AED";
        OrderCurrencyEnum[OrderCurrencyEnum["BHD"] = 'BHD'] = "BHD";
        OrderCurrencyEnum[OrderCurrencyEnum["DZD"] = 'DZD'] = "DZD";
        OrderCurrencyEnum[OrderCurrencyEnum["EGP"] = 'EGP'] = "EGP";
        OrderCurrencyEnum[OrderCurrencyEnum["IQD"] = 'IQD'] = "IQD";
        OrderCurrencyEnum[OrderCurrencyEnum["JOD"] = 'JOD'] = "JOD";
        OrderCurrencyEnum[OrderCurrencyEnum["KWD"] = 'KWD'] = "KWD";
        OrderCurrencyEnum[OrderCurrencyEnum["LBP"] = 'LBP'] = "LBP";
        OrderCurrencyEnum[OrderCurrencyEnum["LYD"] = 'LYD'] = "LYD";
        OrderCurrencyEnum[OrderCurrencyEnum["MAD"] = 'MAD'] = "MAD";
        OrderCurrencyEnum[OrderCurrencyEnum["OMR"] = 'OMR'] = "OMR";
        OrderCurrencyEnum[OrderCurrencyEnum["QAR"] = 'QAR'] = "QAR";
        OrderCurrencyEnum[OrderCurrencyEnum["SAR"] = 'SAR'] = "SAR";
        OrderCurrencyEnum[OrderCurrencyEnum["SYP"] = 'SYP'] = "SYP";
        OrderCurrencyEnum[OrderCurrencyEnum["TND"] = 'TND'] = "TND";
        OrderCurrencyEnum[OrderCurrencyEnum["YER"] = 'YER'] = "YER";
        OrderCurrencyEnum[OrderCurrencyEnum["CLP"] = 'CLP'] = "CLP";
        OrderCurrencyEnum[OrderCurrencyEnum["INR"] = 'INR'] = "INR";
        OrderCurrencyEnum[OrderCurrencyEnum["AZN"] = 'AZN'] = "AZN";
        OrderCurrencyEnum[OrderCurrencyEnum["RUB"] = 'RUB'] = "RUB";
        OrderCurrencyEnum[OrderCurrencyEnum["BYN"] = 'BYN'] = "BYN";
        OrderCurrencyEnum[OrderCurrencyEnum["BGN"] = 'BGN'] = "BGN";
        OrderCurrencyEnum[OrderCurrencyEnum["NGN"] = 'NGN'] = "NGN";
        OrderCurrencyEnum[OrderCurrencyEnum["BDT"] = 'BDT'] = "BDT";
        OrderCurrencyEnum[OrderCurrencyEnum["CNY"] = 'CNY'] = "CNY";
        OrderCurrencyEnum[OrderCurrencyEnum["BAM"] = 'BAM'] = "BAM";
        OrderCurrencyEnum[OrderCurrencyEnum["CZK"] = 'CZK'] = "CZK";
        OrderCurrencyEnum[OrderCurrencyEnum["DKK"] = 'DKK'] = "DKK";
        OrderCurrencyEnum[OrderCurrencyEnum["CHF"] = 'CHF'] = "CHF";
        OrderCurrencyEnum[OrderCurrencyEnum["MVR"] = 'MVR'] = "MVR";
        OrderCurrencyEnum[OrderCurrencyEnum["BTN"] = 'BTN'] = "BTN";
        OrderCurrencyEnum[OrderCurrencyEnum["XCD"] = 'XCD'] = "XCD";
        OrderCurrencyEnum[OrderCurrencyEnum["BZD"] = 'BZD'] = "BZD";
        OrderCurrencyEnum[OrderCurrencyEnum["HKD"] = 'HKD'] = "HKD";
        OrderCurrencyEnum[OrderCurrencyEnum["IDR"] = 'IDR'] = "IDR";
        OrderCurrencyEnum[OrderCurrencyEnum["JMD"] = 'JMD'] = "JMD";
        OrderCurrencyEnum[OrderCurrencyEnum["MYR"] = 'MYR'] = "MYR";
        OrderCurrencyEnum[OrderCurrencyEnum["NZD"] = 'NZD'] = "NZD";
        OrderCurrencyEnum[OrderCurrencyEnum["PHP"] = 'PHP'] = "PHP";
        OrderCurrencyEnum[OrderCurrencyEnum["SGD"] = 'SGD'] = "SGD";
        OrderCurrencyEnum[OrderCurrencyEnum["TTD"] = 'TTD'] = "TTD";
        OrderCurrencyEnum[OrderCurrencyEnum["XDR"] = 'XDR'] = "XDR";
        OrderCurrencyEnum[OrderCurrencyEnum["ARS"] = 'ARS'] = "ARS";
        OrderCurrencyEnum[OrderCurrencyEnum["BOB"] = 'BOB'] = "BOB";
        OrderCurrencyEnum[OrderCurrencyEnum["COP"] = 'COP'] = "COP";
        OrderCurrencyEnum[OrderCurrencyEnum["CRC"] = 'CRC'] = "CRC";
        OrderCurrencyEnum[OrderCurrencyEnum["CUP"] = 'CUP'] = "CUP";
        OrderCurrencyEnum[OrderCurrencyEnum["DOP"] = 'DOP'] = "DOP";
        OrderCurrencyEnum[OrderCurrencyEnum["GTQ"] = 'GTQ'] = "GTQ";
        OrderCurrencyEnum[OrderCurrencyEnum["HNL"] = 'HNL'] = "HNL";
        OrderCurrencyEnum[OrderCurrencyEnum["MXN"] = 'MXN'] = "MXN";
        OrderCurrencyEnum[OrderCurrencyEnum["NIO"] = 'NIO'] = "NIO";
        OrderCurrencyEnum[OrderCurrencyEnum["PAB"] = 'PAB'] = "PAB";
        OrderCurrencyEnum[OrderCurrencyEnum["PEN"] = 'PEN'] = "PEN";
        OrderCurrencyEnum[OrderCurrencyEnum["PYG"] = 'PYG'] = "PYG";
        OrderCurrencyEnum[OrderCurrencyEnum["UYU"] = 'UYU'] = "UYU";
        OrderCurrencyEnum[OrderCurrencyEnum["VEF"] = 'VEF'] = "VEF";
        OrderCurrencyEnum[OrderCurrencyEnum["IRR"] = 'IRR'] = "IRR";
        OrderCurrencyEnum[OrderCurrencyEnum["XOF"] = 'XOF'] = "XOF";
        OrderCurrencyEnum[OrderCurrencyEnum["CDF"] = 'CDF'] = "CDF";
        OrderCurrencyEnum[OrderCurrencyEnum["XAF"] = 'XAF'] = "XAF";
        OrderCurrencyEnum[OrderCurrencyEnum["HTG"] = 'HTG'] = "HTG";
        OrderCurrencyEnum[OrderCurrencyEnum["ILS"] = 'ILS'] = "ILS";
        OrderCurrencyEnum[OrderCurrencyEnum["HRK"] = 'HRK'] = "HRK";
        OrderCurrencyEnum[OrderCurrencyEnum["HUF"] = 'HUF'] = "HUF";
        OrderCurrencyEnum[OrderCurrencyEnum["AMD"] = 'AMD'] = "AMD";
        OrderCurrencyEnum[OrderCurrencyEnum["ISK"] = 'ISK'] = "ISK";
        OrderCurrencyEnum[OrderCurrencyEnum["JPY"] = 'JPY'] = "JPY";
        OrderCurrencyEnum[OrderCurrencyEnum["GEL"] = 'GEL'] = "GEL";
        OrderCurrencyEnum[OrderCurrencyEnum["KZT"] = 'KZT'] = "KZT";
        OrderCurrencyEnum[OrderCurrencyEnum["KHR"] = 'KHR'] = "KHR";
        OrderCurrencyEnum[OrderCurrencyEnum["KRW"] = 'KRW'] = "KRW";
        OrderCurrencyEnum[OrderCurrencyEnum["KGS"] = 'KGS'] = "KGS";
        OrderCurrencyEnum[OrderCurrencyEnum["LAK"] = 'LAK'] = "LAK";
        OrderCurrencyEnum[OrderCurrencyEnum["MKD"] = 'MKD'] = "MKD";
        OrderCurrencyEnum[OrderCurrencyEnum["MNT"] = 'MNT'] = "MNT";
        OrderCurrencyEnum[OrderCurrencyEnum["BND"] = 'BND'] = "BND";
        OrderCurrencyEnum[OrderCurrencyEnum["MMK"] = 'MMK'] = "MMK";
        OrderCurrencyEnum[OrderCurrencyEnum["NOK"] = 'NOK'] = "NOK";
        OrderCurrencyEnum[OrderCurrencyEnum["NPR"] = 'NPR'] = "NPR";
        OrderCurrencyEnum[OrderCurrencyEnum["PKR"] = 'PKR'] = "PKR";
        OrderCurrencyEnum[OrderCurrencyEnum["PLN"] = 'PLN'] = "PLN";
        OrderCurrencyEnum[OrderCurrencyEnum["AFN"] = 'AFN'] = "AFN";
        OrderCurrencyEnum[OrderCurrencyEnum["BRL"] = 'BRL'] = "BRL";
        OrderCurrencyEnum[OrderCurrencyEnum["MDL"] = 'MDL'] = "MDL";
        OrderCurrencyEnum[OrderCurrencyEnum["RON"] = 'RON'] = "RON";
        OrderCurrencyEnum[OrderCurrencyEnum["RWF"] = 'RWF'] = "RWF";
        OrderCurrencyEnum[OrderCurrencyEnum["SEK"] = 'SEK'] = "SEK";
        OrderCurrencyEnum[OrderCurrencyEnum["LKR"] = 'LKR'] = "LKR";
        OrderCurrencyEnum[OrderCurrencyEnum["SOS"] = 'SOS'] = "SOS";
        OrderCurrencyEnum[OrderCurrencyEnum["ALL"] = 'ALL'] = "ALL";
        OrderCurrencyEnum[OrderCurrencyEnum["RSD"] = 'RSD'] = "RSD";
        OrderCurrencyEnum[OrderCurrencyEnum["KES"] = 'KES'] = "KES";
        OrderCurrencyEnum[OrderCurrencyEnum["TJS"] = 'TJS'] = "TJS";
        OrderCurrencyEnum[OrderCurrencyEnum["THB"] = 'THB'] = "THB";
        OrderCurrencyEnum[OrderCurrencyEnum["ERN"] = 'ERN'] = "ERN";
        OrderCurrencyEnum[OrderCurrencyEnum["TMT"] = 'TMT'] = "TMT";
        OrderCurrencyEnum[OrderCurrencyEnum["BWP"] = 'BWP'] = "BWP";
        OrderCurrencyEnum[OrderCurrencyEnum["TRY"] = 'TRY'] = "TRY";
        OrderCurrencyEnum[OrderCurrencyEnum["UAH"] = 'UAH'] = "UAH";
        OrderCurrencyEnum[OrderCurrencyEnum["UZS"] = 'UZS'] = "UZS";
        OrderCurrencyEnum[OrderCurrencyEnum["VND"] = 'VND'] = "VND";
        OrderCurrencyEnum[OrderCurrencyEnum["MOP"] = 'MOP'] = "MOP";
        OrderCurrencyEnum[OrderCurrencyEnum["TWD"] = 'TWD'] = "TWD";
        OrderCurrencyEnum[OrderCurrencyEnum["BMD"] = 'BMD'] = "BMD";
    })(OrderCurrencyEnum = PayoutRefund.OrderCurrencyEnum || (PayoutRefund.OrderCurrencyEnum = {}));
    var OrderTypeEnum;
    (function (OrderTypeEnum) {
        OrderTypeEnum[OrderTypeEnum["Cash"] = 'Cash'] = "Cash";
        OrderTypeEnum[OrderTypeEnum["Online"] = 'Online'] = "Online";
    })(OrderTypeEnum = PayoutRefund.OrderTypeEnum || (PayoutRefund.OrderTypeEnum = {}));
})(PayoutRefund || (exports.PayoutRefund = PayoutRefund = {}));
var PayoutReport3RefundedOrder;
(function (PayoutReport3RefundedOrder) {
    var TypeEnum;
    (function (TypeEnum) {
        TypeEnum[TypeEnum["Cash"] = 'Cash'] = "Cash";
        TypeEnum[TypeEnum["Card"] = 'Card'] = "Card";
    })(TypeEnum = PayoutReport3RefundedOrder.TypeEnum || (PayoutReport3RefundedOrder.TypeEnum = {}));
})(PayoutReport3RefundedOrder || (exports.PayoutReport3RefundedOrder = PayoutReport3RefundedOrder = {}));
var PayoutRequestIds;
(function (PayoutRequestIds) {
    var StatesEnum;
    (function (StatesEnum) {
        StatesEnum[StatesEnum["Pending"] = 'Pending'] = "Pending";
        StatesEnum[StatesEnum["InTransit"] = 'InTransit'] = "InTransit";
        StatesEnum[StatesEnum["Paid"] = 'Paid'] = "Paid";
        StatesEnum[StatesEnum["Failed"] = 'Failed'] = "Failed";
        StatesEnum[StatesEnum["Cancelled"] = 'Cancelled'] = "Cancelled";
    })(StatesEnum = PayoutRequestIds.StatesEnum || (PayoutRequestIds.StatesEnum = {}));
})(PayoutRequestIds || (exports.PayoutRequestIds = PayoutRequestIds = {}));
var PayoutSummary;
(function (PayoutSummary) {
    var PayoutStatusEnum;
    (function (PayoutStatusEnum) {
        PayoutStatusEnum[PayoutStatusEnum["Pending"] = 'Pending'] = "Pending";
        PayoutStatusEnum[PayoutStatusEnum["InTransit"] = 'InTransit'] = "InTransit";
        PayoutStatusEnum[PayoutStatusEnum["Paid"] = 'Paid'] = "Paid";
        PayoutStatusEnum[PayoutStatusEnum["Failed"] = 'Failed'] = "Failed";
        PayoutStatusEnum[PayoutStatusEnum["Cancelled"] = 'Cancelled'] = "Cancelled";
    })(PayoutStatusEnum = PayoutSummary.PayoutStatusEnum || (PayoutSummary.PayoutStatusEnum = {}));
    var CurrencyEnum;
    (function (CurrencyEnum) {
        CurrencyEnum[CurrencyEnum["EUR"] = 'EUR'] = "EUR";
        CurrencyEnum[CurrencyEnum["USD"] = 'USD'] = "USD";
        CurrencyEnum[CurrencyEnum["GBP"] = 'GBP'] = "GBP";
        CurrencyEnum[CurrencyEnum["CAD"] = 'CAD'] = "CAD";
        CurrencyEnum[CurrencyEnum["AUD"] = 'AUD'] = "AUD";
        CurrencyEnum[CurrencyEnum["DJF"] = 'DJF'] = "DJF";
        CurrencyEnum[CurrencyEnum["ZAR"] = 'ZAR'] = "ZAR";
        CurrencyEnum[CurrencyEnum["ETB"] = 'ETB'] = "ETB";
        CurrencyEnum[CurrencyEnum["AED"] = 'AED'] = "AED";
        CurrencyEnum[CurrencyEnum["BHD"] = 'BHD'] = "BHD";
        CurrencyEnum[CurrencyEnum["DZD"] = 'DZD'] = "DZD";
        CurrencyEnum[CurrencyEnum["EGP"] = 'EGP'] = "EGP";
        CurrencyEnum[CurrencyEnum["IQD"] = 'IQD'] = "IQD";
        CurrencyEnum[CurrencyEnum["JOD"] = 'JOD'] = "JOD";
        CurrencyEnum[CurrencyEnum["KWD"] = 'KWD'] = "KWD";
        CurrencyEnum[CurrencyEnum["LBP"] = 'LBP'] = "LBP";
        CurrencyEnum[CurrencyEnum["LYD"] = 'LYD'] = "LYD";
        CurrencyEnum[CurrencyEnum["MAD"] = 'MAD'] = "MAD";
        CurrencyEnum[CurrencyEnum["OMR"] = 'OMR'] = "OMR";
        CurrencyEnum[CurrencyEnum["QAR"] = 'QAR'] = "QAR";
        CurrencyEnum[CurrencyEnum["SAR"] = 'SAR'] = "SAR";
        CurrencyEnum[CurrencyEnum["SYP"] = 'SYP'] = "SYP";
        CurrencyEnum[CurrencyEnum["TND"] = 'TND'] = "TND";
        CurrencyEnum[CurrencyEnum["YER"] = 'YER'] = "YER";
        CurrencyEnum[CurrencyEnum["CLP"] = 'CLP'] = "CLP";
        CurrencyEnum[CurrencyEnum["INR"] = 'INR'] = "INR";
        CurrencyEnum[CurrencyEnum["AZN"] = 'AZN'] = "AZN";
        CurrencyEnum[CurrencyEnum["RUB"] = 'RUB'] = "RUB";
        CurrencyEnum[CurrencyEnum["BYN"] = 'BYN'] = "BYN";
        CurrencyEnum[CurrencyEnum["BGN"] = 'BGN'] = "BGN";
        CurrencyEnum[CurrencyEnum["NGN"] = 'NGN'] = "NGN";
        CurrencyEnum[CurrencyEnum["BDT"] = 'BDT'] = "BDT";
        CurrencyEnum[CurrencyEnum["CNY"] = 'CNY'] = "CNY";
        CurrencyEnum[CurrencyEnum["BAM"] = 'BAM'] = "BAM";
        CurrencyEnum[CurrencyEnum["CZK"] = 'CZK'] = "CZK";
        CurrencyEnum[CurrencyEnum["DKK"] = 'DKK'] = "DKK";
        CurrencyEnum[CurrencyEnum["CHF"] = 'CHF'] = "CHF";
        CurrencyEnum[CurrencyEnum["MVR"] = 'MVR'] = "MVR";
        CurrencyEnum[CurrencyEnum["BTN"] = 'BTN'] = "BTN";
        CurrencyEnum[CurrencyEnum["XCD"] = 'XCD'] = "XCD";
        CurrencyEnum[CurrencyEnum["BZD"] = 'BZD'] = "BZD";
        CurrencyEnum[CurrencyEnum["HKD"] = 'HKD'] = "HKD";
        CurrencyEnum[CurrencyEnum["IDR"] = 'IDR'] = "IDR";
        CurrencyEnum[CurrencyEnum["JMD"] = 'JMD'] = "JMD";
        CurrencyEnum[CurrencyEnum["MYR"] = 'MYR'] = "MYR";
        CurrencyEnum[CurrencyEnum["NZD"] = 'NZD'] = "NZD";
        CurrencyEnum[CurrencyEnum["PHP"] = 'PHP'] = "PHP";
        CurrencyEnum[CurrencyEnum["SGD"] = 'SGD'] = "SGD";
        CurrencyEnum[CurrencyEnum["TTD"] = 'TTD'] = "TTD";
        CurrencyEnum[CurrencyEnum["XDR"] = 'XDR'] = "XDR";
        CurrencyEnum[CurrencyEnum["ARS"] = 'ARS'] = "ARS";
        CurrencyEnum[CurrencyEnum["BOB"] = 'BOB'] = "BOB";
        CurrencyEnum[CurrencyEnum["COP"] = 'COP'] = "COP";
        CurrencyEnum[CurrencyEnum["CRC"] = 'CRC'] = "CRC";
        CurrencyEnum[CurrencyEnum["CUP"] = 'CUP'] = "CUP";
        CurrencyEnum[CurrencyEnum["DOP"] = 'DOP'] = "DOP";
        CurrencyEnum[CurrencyEnum["GTQ"] = 'GTQ'] = "GTQ";
        CurrencyEnum[CurrencyEnum["HNL"] = 'HNL'] = "HNL";
        CurrencyEnum[CurrencyEnum["MXN"] = 'MXN'] = "MXN";
        CurrencyEnum[CurrencyEnum["NIO"] = 'NIO'] = "NIO";
        CurrencyEnum[CurrencyEnum["PAB"] = 'PAB'] = "PAB";
        CurrencyEnum[CurrencyEnum["PEN"] = 'PEN'] = "PEN";
        CurrencyEnum[CurrencyEnum["PYG"] = 'PYG'] = "PYG";
        CurrencyEnum[CurrencyEnum["UYU"] = 'UYU'] = "UYU";
        CurrencyEnum[CurrencyEnum["VEF"] = 'VEF'] = "VEF";
        CurrencyEnum[CurrencyEnum["IRR"] = 'IRR'] = "IRR";
        CurrencyEnum[CurrencyEnum["XOF"] = 'XOF'] = "XOF";
        CurrencyEnum[CurrencyEnum["CDF"] = 'CDF'] = "CDF";
        CurrencyEnum[CurrencyEnum["XAF"] = 'XAF'] = "XAF";
        CurrencyEnum[CurrencyEnum["HTG"] = 'HTG'] = "HTG";
        CurrencyEnum[CurrencyEnum["ILS"] = 'ILS'] = "ILS";
        CurrencyEnum[CurrencyEnum["HRK"] = 'HRK'] = "HRK";
        CurrencyEnum[CurrencyEnum["HUF"] = 'HUF'] = "HUF";
        CurrencyEnum[CurrencyEnum["AMD"] = 'AMD'] = "AMD";
        CurrencyEnum[CurrencyEnum["ISK"] = 'ISK'] = "ISK";
        CurrencyEnum[CurrencyEnum["JPY"] = 'JPY'] = "JPY";
        CurrencyEnum[CurrencyEnum["GEL"] = 'GEL'] = "GEL";
        CurrencyEnum[CurrencyEnum["KZT"] = 'KZT'] = "KZT";
        CurrencyEnum[CurrencyEnum["KHR"] = 'KHR'] = "KHR";
        CurrencyEnum[CurrencyEnum["KRW"] = 'KRW'] = "KRW";
        CurrencyEnum[CurrencyEnum["KGS"] = 'KGS'] = "KGS";
        CurrencyEnum[CurrencyEnum["LAK"] = 'LAK'] = "LAK";
        CurrencyEnum[CurrencyEnum["MKD"] = 'MKD'] = "MKD";
        CurrencyEnum[CurrencyEnum["MNT"] = 'MNT'] = "MNT";
        CurrencyEnum[CurrencyEnum["BND"] = 'BND'] = "BND";
        CurrencyEnum[CurrencyEnum["MMK"] = 'MMK'] = "MMK";
        CurrencyEnum[CurrencyEnum["NOK"] = 'NOK'] = "NOK";
        CurrencyEnum[CurrencyEnum["NPR"] = 'NPR'] = "NPR";
        CurrencyEnum[CurrencyEnum["PKR"] = 'PKR'] = "PKR";
        CurrencyEnum[CurrencyEnum["PLN"] = 'PLN'] = "PLN";
        CurrencyEnum[CurrencyEnum["AFN"] = 'AFN'] = "AFN";
        CurrencyEnum[CurrencyEnum["BRL"] = 'BRL'] = "BRL";
        CurrencyEnum[CurrencyEnum["MDL"] = 'MDL'] = "MDL";
        CurrencyEnum[CurrencyEnum["RON"] = 'RON'] = "RON";
        CurrencyEnum[CurrencyEnum["RWF"] = 'RWF'] = "RWF";
        CurrencyEnum[CurrencyEnum["SEK"] = 'SEK'] = "SEK";
        CurrencyEnum[CurrencyEnum["LKR"] = 'LKR'] = "LKR";
        CurrencyEnum[CurrencyEnum["SOS"] = 'SOS'] = "SOS";
        CurrencyEnum[CurrencyEnum["ALL"] = 'ALL'] = "ALL";
        CurrencyEnum[CurrencyEnum["RSD"] = 'RSD'] = "RSD";
        CurrencyEnum[CurrencyEnum["KES"] = 'KES'] = "KES";
        CurrencyEnum[CurrencyEnum["TJS"] = 'TJS'] = "TJS";
        CurrencyEnum[CurrencyEnum["THB"] = 'THB'] = "THB";
        CurrencyEnum[CurrencyEnum["ERN"] = 'ERN'] = "ERN";
        CurrencyEnum[CurrencyEnum["TMT"] = 'TMT'] = "TMT";
        CurrencyEnum[CurrencyEnum["BWP"] = 'BWP'] = "BWP";
        CurrencyEnum[CurrencyEnum["TRY"] = 'TRY'] = "TRY";
        CurrencyEnum[CurrencyEnum["UAH"] = 'UAH'] = "UAH";
        CurrencyEnum[CurrencyEnum["UZS"] = 'UZS'] = "UZS";
        CurrencyEnum[CurrencyEnum["VND"] = 'VND'] = "VND";
        CurrencyEnum[CurrencyEnum["MOP"] = 'MOP'] = "MOP";
        CurrencyEnum[CurrencyEnum["TWD"] = 'TWD'] = "TWD";
        CurrencyEnum[CurrencyEnum["BMD"] = 'BMD'] = "BMD";
    })(CurrencyEnum = PayoutSummary.CurrencyEnum || (PayoutSummary.CurrencyEnum = {}));
})(PayoutSummary || (exports.PayoutSummary = PayoutSummary = {}));
var PhoneCall;
(function (PhoneCall) {
    var CallStatusEnum;
    (function (CallStatusEnum) {
        CallStatusEnum[CallStatusEnum["Queued"] = 'Queued'] = "Queued";
        CallStatusEnum[CallStatusEnum["Ringing"] = 'Ringing'] = "Ringing";
        CallStatusEnum[CallStatusEnum["InProgress"] = 'InProgress'] = "InProgress";
        CallStatusEnum[CallStatusEnum["Completed"] = 'Completed'] = "Completed";
        CallStatusEnum[CallStatusEnum["Failed"] = 'Failed'] = "Failed";
        CallStatusEnum[CallStatusEnum["Busy"] = 'Busy'] = "Busy";
        CallStatusEnum[CallStatusEnum["NoAnswer"] = 'NoAnswer'] = "NoAnswer";
        CallStatusEnum[CallStatusEnum["Unknown"] = 'Unknown'] = "Unknown";
        CallStatusEnum[CallStatusEnum["Canceled"] = 'Canceled'] = "Canceled";
    })(CallStatusEnum = PhoneCall.CallStatusEnum || (PhoneCall.CallStatusEnum = {}));
})(PhoneCall || (exports.PhoneCall = PhoneCall = {}));
var PreOrderConfig;
(function (PreOrderConfig) {
    var PreOrderTimeDisplayTypeEnum;
    (function (PreOrderTimeDisplayTypeEnum) {
        PreOrderTimeDisplayTypeEnum[PreOrderTimeDisplayTypeEnum["SingleTime"] = 'SingleTime'] = "SingleTime";
        PreOrderTimeDisplayTypeEnum[PreOrderTimeDisplayTypeEnum["StartAndEndTime"] = 'StartAndEndTime'] = "StartAndEndTime";
        PreOrderTimeDisplayTypeEnum[PreOrderTimeDisplayTypeEnum["DayOnly"] = 'DayOnly'] = "DayOnly";
    })(PreOrderTimeDisplayTypeEnum = PreOrderConfig.PreOrderTimeDisplayTypeEnum || (PreOrderConfig.PreOrderTimeDisplayTypeEnum = {}));
})(PreOrderConfig || (exports.PreOrderConfig = PreOrderConfig = {}));
var PreviousOrder;
(function (PreviousOrder) {
    var CurrencyEnum;
    (function (CurrencyEnum) {
        CurrencyEnum[CurrencyEnum["EUR"] = 'EUR'] = "EUR";
        CurrencyEnum[CurrencyEnum["USD"] = 'USD'] = "USD";
        CurrencyEnum[CurrencyEnum["GBP"] = 'GBP'] = "GBP";
        CurrencyEnum[CurrencyEnum["CAD"] = 'CAD'] = "CAD";
        CurrencyEnum[CurrencyEnum["AUD"] = 'AUD'] = "AUD";
        CurrencyEnum[CurrencyEnum["DJF"] = 'DJF'] = "DJF";
        CurrencyEnum[CurrencyEnum["ZAR"] = 'ZAR'] = "ZAR";
        CurrencyEnum[CurrencyEnum["ETB"] = 'ETB'] = "ETB";
        CurrencyEnum[CurrencyEnum["AED"] = 'AED'] = "AED";
        CurrencyEnum[CurrencyEnum["BHD"] = 'BHD'] = "BHD";
        CurrencyEnum[CurrencyEnum["DZD"] = 'DZD'] = "DZD";
        CurrencyEnum[CurrencyEnum["EGP"] = 'EGP'] = "EGP";
        CurrencyEnum[CurrencyEnum["IQD"] = 'IQD'] = "IQD";
        CurrencyEnum[CurrencyEnum["JOD"] = 'JOD'] = "JOD";
        CurrencyEnum[CurrencyEnum["KWD"] = 'KWD'] = "KWD";
        CurrencyEnum[CurrencyEnum["LBP"] = 'LBP'] = "LBP";
        CurrencyEnum[CurrencyEnum["LYD"] = 'LYD'] = "LYD";
        CurrencyEnum[CurrencyEnum["MAD"] = 'MAD'] = "MAD";
        CurrencyEnum[CurrencyEnum["OMR"] = 'OMR'] = "OMR";
        CurrencyEnum[CurrencyEnum["QAR"] = 'QAR'] = "QAR";
        CurrencyEnum[CurrencyEnum["SAR"] = 'SAR'] = "SAR";
        CurrencyEnum[CurrencyEnum["SYP"] = 'SYP'] = "SYP";
        CurrencyEnum[CurrencyEnum["TND"] = 'TND'] = "TND";
        CurrencyEnum[CurrencyEnum["YER"] = 'YER'] = "YER";
        CurrencyEnum[CurrencyEnum["CLP"] = 'CLP'] = "CLP";
        CurrencyEnum[CurrencyEnum["INR"] = 'INR'] = "INR";
        CurrencyEnum[CurrencyEnum["AZN"] = 'AZN'] = "AZN";
        CurrencyEnum[CurrencyEnum["RUB"] = 'RUB'] = "RUB";
        CurrencyEnum[CurrencyEnum["BYN"] = 'BYN'] = "BYN";
        CurrencyEnum[CurrencyEnum["BGN"] = 'BGN'] = "BGN";
        CurrencyEnum[CurrencyEnum["NGN"] = 'NGN'] = "NGN";
        CurrencyEnum[CurrencyEnum["BDT"] = 'BDT'] = "BDT";
        CurrencyEnum[CurrencyEnum["CNY"] = 'CNY'] = "CNY";
        CurrencyEnum[CurrencyEnum["BAM"] = 'BAM'] = "BAM";
        CurrencyEnum[CurrencyEnum["CZK"] = 'CZK'] = "CZK";
        CurrencyEnum[CurrencyEnum["DKK"] = 'DKK'] = "DKK";
        CurrencyEnum[CurrencyEnum["CHF"] = 'CHF'] = "CHF";
        CurrencyEnum[CurrencyEnum["MVR"] = 'MVR'] = "MVR";
        CurrencyEnum[CurrencyEnum["BTN"] = 'BTN'] = "BTN";
        CurrencyEnum[CurrencyEnum["XCD"] = 'XCD'] = "XCD";
        CurrencyEnum[CurrencyEnum["BZD"] = 'BZD'] = "BZD";
        CurrencyEnum[CurrencyEnum["HKD"] = 'HKD'] = "HKD";
        CurrencyEnum[CurrencyEnum["IDR"] = 'IDR'] = "IDR";
        CurrencyEnum[CurrencyEnum["JMD"] = 'JMD'] = "JMD";
        CurrencyEnum[CurrencyEnum["MYR"] = 'MYR'] = "MYR";
        CurrencyEnum[CurrencyEnum["NZD"] = 'NZD'] = "NZD";
        CurrencyEnum[CurrencyEnum["PHP"] = 'PHP'] = "PHP";
        CurrencyEnum[CurrencyEnum["SGD"] = 'SGD'] = "SGD";
        CurrencyEnum[CurrencyEnum["TTD"] = 'TTD'] = "TTD";
        CurrencyEnum[CurrencyEnum["XDR"] = 'XDR'] = "XDR";
        CurrencyEnum[CurrencyEnum["ARS"] = 'ARS'] = "ARS";
        CurrencyEnum[CurrencyEnum["BOB"] = 'BOB'] = "BOB";
        CurrencyEnum[CurrencyEnum["COP"] = 'COP'] = "COP";
        CurrencyEnum[CurrencyEnum["CRC"] = 'CRC'] = "CRC";
        CurrencyEnum[CurrencyEnum["CUP"] = 'CUP'] = "CUP";
        CurrencyEnum[CurrencyEnum["DOP"] = 'DOP'] = "DOP";
        CurrencyEnum[CurrencyEnum["GTQ"] = 'GTQ'] = "GTQ";
        CurrencyEnum[CurrencyEnum["HNL"] = 'HNL'] = "HNL";
        CurrencyEnum[CurrencyEnum["MXN"] = 'MXN'] = "MXN";
        CurrencyEnum[CurrencyEnum["NIO"] = 'NIO'] = "NIO";
        CurrencyEnum[CurrencyEnum["PAB"] = 'PAB'] = "PAB";
        CurrencyEnum[CurrencyEnum["PEN"] = 'PEN'] = "PEN";
        CurrencyEnum[CurrencyEnum["PYG"] = 'PYG'] = "PYG";
        CurrencyEnum[CurrencyEnum["UYU"] = 'UYU'] = "UYU";
        CurrencyEnum[CurrencyEnum["VEF"] = 'VEF'] = "VEF";
        CurrencyEnum[CurrencyEnum["IRR"] = 'IRR'] = "IRR";
        CurrencyEnum[CurrencyEnum["XOF"] = 'XOF'] = "XOF";
        CurrencyEnum[CurrencyEnum["CDF"] = 'CDF'] = "CDF";
        CurrencyEnum[CurrencyEnum["XAF"] = 'XAF'] = "XAF";
        CurrencyEnum[CurrencyEnum["HTG"] = 'HTG'] = "HTG";
        CurrencyEnum[CurrencyEnum["ILS"] = 'ILS'] = "ILS";
        CurrencyEnum[CurrencyEnum["HRK"] = 'HRK'] = "HRK";
        CurrencyEnum[CurrencyEnum["HUF"] = 'HUF'] = "HUF";
        CurrencyEnum[CurrencyEnum["AMD"] = 'AMD'] = "AMD";
        CurrencyEnum[CurrencyEnum["ISK"] = 'ISK'] = "ISK";
        CurrencyEnum[CurrencyEnum["JPY"] = 'JPY'] = "JPY";
        CurrencyEnum[CurrencyEnum["GEL"] = 'GEL'] = "GEL";
        CurrencyEnum[CurrencyEnum["KZT"] = 'KZT'] = "KZT";
        CurrencyEnum[CurrencyEnum["KHR"] = 'KHR'] = "KHR";
        CurrencyEnum[CurrencyEnum["KRW"] = 'KRW'] = "KRW";
        CurrencyEnum[CurrencyEnum["KGS"] = 'KGS'] = "KGS";
        CurrencyEnum[CurrencyEnum["LAK"] = 'LAK'] = "LAK";
        CurrencyEnum[CurrencyEnum["MKD"] = 'MKD'] = "MKD";
        CurrencyEnum[CurrencyEnum["MNT"] = 'MNT'] = "MNT";
        CurrencyEnum[CurrencyEnum["BND"] = 'BND'] = "BND";
        CurrencyEnum[CurrencyEnum["MMK"] = 'MMK'] = "MMK";
        CurrencyEnum[CurrencyEnum["NOK"] = 'NOK'] = "NOK";
        CurrencyEnum[CurrencyEnum["NPR"] = 'NPR'] = "NPR";
        CurrencyEnum[CurrencyEnum["PKR"] = 'PKR'] = "PKR";
        CurrencyEnum[CurrencyEnum["PLN"] = 'PLN'] = "PLN";
        CurrencyEnum[CurrencyEnum["AFN"] = 'AFN'] = "AFN";
        CurrencyEnum[CurrencyEnum["BRL"] = 'BRL'] = "BRL";
        CurrencyEnum[CurrencyEnum["MDL"] = 'MDL'] = "MDL";
        CurrencyEnum[CurrencyEnum["RON"] = 'RON'] = "RON";
        CurrencyEnum[CurrencyEnum["RWF"] = 'RWF'] = "RWF";
        CurrencyEnum[CurrencyEnum["SEK"] = 'SEK'] = "SEK";
        CurrencyEnum[CurrencyEnum["LKR"] = 'LKR'] = "LKR";
        CurrencyEnum[CurrencyEnum["SOS"] = 'SOS'] = "SOS";
        CurrencyEnum[CurrencyEnum["ALL"] = 'ALL'] = "ALL";
        CurrencyEnum[CurrencyEnum["RSD"] = 'RSD'] = "RSD";
        CurrencyEnum[CurrencyEnum["KES"] = 'KES'] = "KES";
        CurrencyEnum[CurrencyEnum["TJS"] = 'TJS'] = "TJS";
        CurrencyEnum[CurrencyEnum["THB"] = 'THB'] = "THB";
        CurrencyEnum[CurrencyEnum["ERN"] = 'ERN'] = "ERN";
        CurrencyEnum[CurrencyEnum["TMT"] = 'TMT'] = "TMT";
        CurrencyEnum[CurrencyEnum["BWP"] = 'BWP'] = "BWP";
        CurrencyEnum[CurrencyEnum["TRY"] = 'TRY'] = "TRY";
        CurrencyEnum[CurrencyEnum["UAH"] = 'UAH'] = "UAH";
        CurrencyEnum[CurrencyEnum["UZS"] = 'UZS'] = "UZS";
        CurrencyEnum[CurrencyEnum["VND"] = 'VND'] = "VND";
        CurrencyEnum[CurrencyEnum["MOP"] = 'MOP'] = "MOP";
        CurrencyEnum[CurrencyEnum["TWD"] = 'TWD'] = "TWD";
        CurrencyEnum[CurrencyEnum["BMD"] = 'BMD'] = "BMD";
    })(CurrencyEnum = PreviousOrder.CurrencyEnum || (PreviousOrder.CurrencyEnum = {}));
})(PreviousOrder || (exports.PreviousOrder = PreviousOrder = {}));
var ProcessingFeeConfig;
(function (ProcessingFeeConfig) {
    var PaymentAccountTypeEnum;
    (function (PaymentAccountTypeEnum) {
        PaymentAccountTypeEnum[PaymentAccountTypeEnum["Card"] = 'Card'] = "Card";
        PaymentAccountTypeEnum[PaymentAccountTypeEnum["Cash"] = 'Cash'] = "Cash";
        PaymentAccountTypeEnum[PaymentAccountTypeEnum["Ideal"] = 'Ideal'] = "Ideal";
        PaymentAccountTypeEnum[PaymentAccountTypeEnum["Bancontact"] = 'Bancontact'] = "Bancontact";
        PaymentAccountTypeEnum[PaymentAccountTypeEnum["Giropay"] = 'Giropay'] = "Giropay";
        PaymentAccountTypeEnum[PaymentAccountTypeEnum["Eps"] = 'Eps'] = "Eps";
        PaymentAccountTypeEnum[PaymentAccountTypeEnum["Emv"] = 'Emv'] = "Emv";
        PaymentAccountTypeEnum[PaymentAccountTypeEnum["PayPal"] = 'PayPal'] = "PayPal";
        PaymentAccountTypeEnum[PaymentAccountTypeEnum["PayGreen"] = 'PayGreen'] = "PayGreen";
        PaymentAccountTypeEnum[PaymentAccountTypeEnum["GoogleWalletToken"] = 'GoogleWalletToken'] = "GoogleWalletToken";
    })(PaymentAccountTypeEnum = ProcessingFeeConfig.PaymentAccountTypeEnum || (ProcessingFeeConfig.PaymentAccountTypeEnum = {}));
})(ProcessingFeeConfig || (exports.ProcessingFeeConfig = ProcessingFeeConfig = {}));
var Product;
(function (Product) {
    var ProductTypeEnum;
    (function (ProductTypeEnum) {
        ProductTypeEnum[ProductTypeEnum["Product"] = 'Product'] = "Product";
        ProductTypeEnum[ProductTypeEnum["Modifier"] = 'Modifier'] = "Modifier";
    })(ProductTypeEnum = Product.ProductTypeEnum || (Product.ProductTypeEnum = {}));
})(Product || (exports.Product = Product = {}));
var ProductReference;
(function (ProductReference) {
    var ProductTypeEnum;
    (function (ProductTypeEnum) {
        ProductTypeEnum[ProductTypeEnum["Product"] = 'Product'] = "Product";
        ProductTypeEnum[ProductTypeEnum["Modifier"] = 'Modifier'] = "Modifier";
    })(ProductTypeEnum = ProductReference.ProductTypeEnum || (ProductReference.ProductTypeEnum = {}));
})(ProductReference || (exports.ProductReference = ProductReference = {}));
var Range;
(function (Range) {
    var DayOfWeekEnum;
    (function (DayOfWeekEnum) {
        DayOfWeekEnum[DayOfWeekEnum["Sunday"] = 'Sunday'] = "Sunday";
        DayOfWeekEnum[DayOfWeekEnum["Monday"] = 'Monday'] = "Monday";
        DayOfWeekEnum[DayOfWeekEnum["Tuesday"] = 'Tuesday'] = "Tuesday";
        DayOfWeekEnum[DayOfWeekEnum["Wednesday"] = 'Wednesday'] = "Wednesday";
        DayOfWeekEnum[DayOfWeekEnum["Thursday"] = 'Thursday'] = "Thursday";
        DayOfWeekEnum[DayOfWeekEnum["Friday"] = 'Friday'] = "Friday";
        DayOfWeekEnum[DayOfWeekEnum["Saturday"] = 'Saturday'] = "Saturday";
    })(DayOfWeekEnum = Range.DayOfWeekEnum || (Range.DayOfWeekEnum = {}));
})(Range || (exports.Range = Range = {}));
var RedeemInvitationResult;
(function (RedeemInvitationResult) {
    var InvitationStatusEnum;
    (function (InvitationStatusEnum) {
        InvitationStatusEnum[InvitationStatusEnum["Pending"] = 'Pending'] = "Pending";
        InvitationStatusEnum[InvitationStatusEnum["Accepted"] = 'Accepted'] = "Accepted";
        InvitationStatusEnum[InvitationStatusEnum["Expired"] = 'Expired'] = "Expired";
    })(InvitationStatusEnum = RedeemInvitationResult.InvitationStatusEnum || (RedeemInvitationResult.InvitationStatusEnum = {}));
})(RedeemInvitationResult || (exports.RedeemInvitationResult = RedeemInvitationResult = {}));
var Reject;
(function (Reject) {
    var RejectReasonEnum;
    (function (RejectReasonEnum) {
        RejectReasonEnum[RejectReasonEnum["TooBusy"] = 'TooBusy'] = "TooBusy";
        RejectReasonEnum[RejectReasonEnum["FoodUnavailable"] = 'FoodUnavailable'] = "FoodUnavailable";
        RejectReasonEnum[RejectReasonEnum["UnableToDeliver"] = 'UnableToDeliver'] = "UnableToDeliver";
        RejectReasonEnum[RejectReasonEnum["UnknownAddress"] = 'UnknownAddress'] = "UnknownAddress";
        RejectReasonEnum[RejectReasonEnum["UnknownReason"] = 'UnknownReason'] = "UnknownReason";
        RejectReasonEnum[RejectReasonEnum["TooSoon"] = 'TooSoon'] = "TooSoon";
        RejectReasonEnum[RejectReasonEnum["TimeUnavailable"] = 'TimeUnavailable'] = "TimeUnavailable";
        RejectReasonEnum[RejectReasonEnum["DontDeliverToArea"] = 'DontDeliverToArea'] = "DontDeliverToArea";
        RejectReasonEnum[RejectReasonEnum["StoreUncontactable"] = 'StoreUncontactable'] = "StoreUncontactable";
    })(RejectReasonEnum = Reject.RejectReasonEnum || (Reject.RejectReasonEnum = {}));
})(Reject || (exports.Reject = Reject = {}));
var SetUserDeliveryLocationFieldRequest;
(function (SetUserDeliveryLocationFieldRequest) {
    var FieldEnum;
    (function (FieldEnum) {
        FieldEnum[FieldEnum["DeliveryInstructions"] = 'DeliveryInstructions'] = "DeliveryInstructions";
        FieldEnum[FieldEnum["IsDisplayed"] = 'IsDisplayed'] = "IsDisplayed";
        FieldEnum[FieldEnum["BuildingString"] = 'BuildingString'] = "BuildingString";
        FieldEnum[FieldEnum["StreetString"] = 'StreetString'] = "StreetString";
        FieldEnum[FieldEnum["TownString"] = 'TownString'] = "TownString";
    })(FieldEnum = SetUserDeliveryLocationFieldRequest.FieldEnum || (SetUserDeliveryLocationFieldRequest.FieldEnum = {}));
})(SetUserDeliveryLocationFieldRequest || (exports.SetUserDeliveryLocationFieldRequest = SetUserDeliveryLocationFieldRequest = {}));
var SetVoucherValidityPeriodsSimplifiedRequest;
(function (SetVoucherValidityPeriodsSimplifiedRequest) {
    var DaysOfWeekEnum;
    (function (DaysOfWeekEnum) {
        DaysOfWeekEnum[DaysOfWeekEnum["Sunday"] = 'Sunday'] = "Sunday";
        DaysOfWeekEnum[DaysOfWeekEnum["Monday"] = 'Monday'] = "Monday";
        DaysOfWeekEnum[DaysOfWeekEnum["Tuesday"] = 'Tuesday'] = "Tuesday";
        DaysOfWeekEnum[DaysOfWeekEnum["Wednesday"] = 'Wednesday'] = "Wednesday";
        DaysOfWeekEnum[DaysOfWeekEnum["Thursday"] = 'Thursday'] = "Thursday";
        DaysOfWeekEnum[DaysOfWeekEnum["Friday"] = 'Friday'] = "Friday";
        DaysOfWeekEnum[DaysOfWeekEnum["Saturday"] = 'Saturday'] = "Saturday";
    })(DaysOfWeekEnum = SetVoucherValidityPeriodsSimplifiedRequest.DaysOfWeekEnum || (SetVoucherValidityPeriodsSimplifiedRequest.DaysOfWeekEnum = {}));
})(SetVoucherValidityPeriodsSimplifiedRequest || (exports.SetVoucherValidityPeriodsSimplifiedRequest = SetVoucherValidityPeriodsSimplifiedRequest = {}));
var SignupStep;
(function (SignupStep) {
    var ActionEnum;
    (function (ActionEnum) {
        ActionEnum[ActionEnum["Question"] = 'Question'] = "Question";
        ActionEnum[ActionEnum["StoreLocation"] = 'StoreLocation'] = "StoreLocation";
        ActionEnum[ActionEnum["PaymentSubscription"] = 'PaymentSubscription'] = "PaymentSubscription";
        ActionEnum[ActionEnum["StoreName"] = 'StoreName'] = "StoreName";
    })(ActionEnum = SignupStep.ActionEnum || (SignupStep.ActionEnum = {}));
})(SignupStep || (exports.SignupStep = SignupStep = {}));
var SmsProviderCredential;
(function (SmsProviderCredential) {
    var SmsServiceTypeEnum;
    (function (SmsServiceTypeEnum) {
        SmsServiceTypeEnum[SmsServiceTypeEnum["Nexmo"] = 'Nexmo'] = "Nexmo";
        SmsServiceTypeEnum[SmsServiceTypeEnum["Twilio"] = 'Twilio'] = "Twilio";
        SmsServiceTypeEnum[SmsServiceTypeEnum["Default"] = 'Default'] = "Default";
        SmsServiceTypeEnum[SmsServiceTypeEnum["MessageBird"] = 'MessageBird'] = "MessageBird";
        SmsServiceTypeEnum[SmsServiceTypeEnum["CommunicationService"] = 'CommunicationService'] = "CommunicationService";
    })(SmsServiceTypeEnum = SmsProviderCredential.SmsServiceTypeEnum || (SmsProviderCredential.SmsServiceTypeEnum = {}));
})(SmsProviderCredential || (exports.SmsProviderCredential = SmsProviderCredential = {}));
var StatisticsCurrencyDataPoint;
(function (StatisticsCurrencyDataPoint) {
    var CurrencyEnum;
    (function (CurrencyEnum) {
        CurrencyEnum[CurrencyEnum["EUR"] = 'EUR'] = "EUR";
        CurrencyEnum[CurrencyEnum["USD"] = 'USD'] = "USD";
        CurrencyEnum[CurrencyEnum["GBP"] = 'GBP'] = "GBP";
        CurrencyEnum[CurrencyEnum["CAD"] = 'CAD'] = "CAD";
        CurrencyEnum[CurrencyEnum["AUD"] = 'AUD'] = "AUD";
        CurrencyEnum[CurrencyEnum["DJF"] = 'DJF'] = "DJF";
        CurrencyEnum[CurrencyEnum["ZAR"] = 'ZAR'] = "ZAR";
        CurrencyEnum[CurrencyEnum["ETB"] = 'ETB'] = "ETB";
        CurrencyEnum[CurrencyEnum["AED"] = 'AED'] = "AED";
        CurrencyEnum[CurrencyEnum["BHD"] = 'BHD'] = "BHD";
        CurrencyEnum[CurrencyEnum["DZD"] = 'DZD'] = "DZD";
        CurrencyEnum[CurrencyEnum["EGP"] = 'EGP'] = "EGP";
        CurrencyEnum[CurrencyEnum["IQD"] = 'IQD'] = "IQD";
        CurrencyEnum[CurrencyEnum["JOD"] = 'JOD'] = "JOD";
        CurrencyEnum[CurrencyEnum["KWD"] = 'KWD'] = "KWD";
        CurrencyEnum[CurrencyEnum["LBP"] = 'LBP'] = "LBP";
        CurrencyEnum[CurrencyEnum["LYD"] = 'LYD'] = "LYD";
        CurrencyEnum[CurrencyEnum["MAD"] = 'MAD'] = "MAD";
        CurrencyEnum[CurrencyEnum["OMR"] = 'OMR'] = "OMR";
        CurrencyEnum[CurrencyEnum["QAR"] = 'QAR'] = "QAR";
        CurrencyEnum[CurrencyEnum["SAR"] = 'SAR'] = "SAR";
        CurrencyEnum[CurrencyEnum["SYP"] = 'SYP'] = "SYP";
        CurrencyEnum[CurrencyEnum["TND"] = 'TND'] = "TND";
        CurrencyEnum[CurrencyEnum["YER"] = 'YER'] = "YER";
        CurrencyEnum[CurrencyEnum["CLP"] = 'CLP'] = "CLP";
        CurrencyEnum[CurrencyEnum["INR"] = 'INR'] = "INR";
        CurrencyEnum[CurrencyEnum["AZN"] = 'AZN'] = "AZN";
        CurrencyEnum[CurrencyEnum["RUB"] = 'RUB'] = "RUB";
        CurrencyEnum[CurrencyEnum["BYN"] = 'BYN'] = "BYN";
        CurrencyEnum[CurrencyEnum["BGN"] = 'BGN'] = "BGN";
        CurrencyEnum[CurrencyEnum["NGN"] = 'NGN'] = "NGN";
        CurrencyEnum[CurrencyEnum["BDT"] = 'BDT'] = "BDT";
        CurrencyEnum[CurrencyEnum["CNY"] = 'CNY'] = "CNY";
        CurrencyEnum[CurrencyEnum["BAM"] = 'BAM'] = "BAM";
        CurrencyEnum[CurrencyEnum["CZK"] = 'CZK'] = "CZK";
        CurrencyEnum[CurrencyEnum["DKK"] = 'DKK'] = "DKK";
        CurrencyEnum[CurrencyEnum["CHF"] = 'CHF'] = "CHF";
        CurrencyEnum[CurrencyEnum["MVR"] = 'MVR'] = "MVR";
        CurrencyEnum[CurrencyEnum["BTN"] = 'BTN'] = "BTN";
        CurrencyEnum[CurrencyEnum["XCD"] = 'XCD'] = "XCD";
        CurrencyEnum[CurrencyEnum["BZD"] = 'BZD'] = "BZD";
        CurrencyEnum[CurrencyEnum["HKD"] = 'HKD'] = "HKD";
        CurrencyEnum[CurrencyEnum["IDR"] = 'IDR'] = "IDR";
        CurrencyEnum[CurrencyEnum["JMD"] = 'JMD'] = "JMD";
        CurrencyEnum[CurrencyEnum["MYR"] = 'MYR'] = "MYR";
        CurrencyEnum[CurrencyEnum["NZD"] = 'NZD'] = "NZD";
        CurrencyEnum[CurrencyEnum["PHP"] = 'PHP'] = "PHP";
        CurrencyEnum[CurrencyEnum["SGD"] = 'SGD'] = "SGD";
        CurrencyEnum[CurrencyEnum["TTD"] = 'TTD'] = "TTD";
        CurrencyEnum[CurrencyEnum["XDR"] = 'XDR'] = "XDR";
        CurrencyEnum[CurrencyEnum["ARS"] = 'ARS'] = "ARS";
        CurrencyEnum[CurrencyEnum["BOB"] = 'BOB'] = "BOB";
        CurrencyEnum[CurrencyEnum["COP"] = 'COP'] = "COP";
        CurrencyEnum[CurrencyEnum["CRC"] = 'CRC'] = "CRC";
        CurrencyEnum[CurrencyEnum["CUP"] = 'CUP'] = "CUP";
        CurrencyEnum[CurrencyEnum["DOP"] = 'DOP'] = "DOP";
        CurrencyEnum[CurrencyEnum["GTQ"] = 'GTQ'] = "GTQ";
        CurrencyEnum[CurrencyEnum["HNL"] = 'HNL'] = "HNL";
        CurrencyEnum[CurrencyEnum["MXN"] = 'MXN'] = "MXN";
        CurrencyEnum[CurrencyEnum["NIO"] = 'NIO'] = "NIO";
        CurrencyEnum[CurrencyEnum["PAB"] = 'PAB'] = "PAB";
        CurrencyEnum[CurrencyEnum["PEN"] = 'PEN'] = "PEN";
        CurrencyEnum[CurrencyEnum["PYG"] = 'PYG'] = "PYG";
        CurrencyEnum[CurrencyEnum["UYU"] = 'UYU'] = "UYU";
        CurrencyEnum[CurrencyEnum["VEF"] = 'VEF'] = "VEF";
        CurrencyEnum[CurrencyEnum["IRR"] = 'IRR'] = "IRR";
        CurrencyEnum[CurrencyEnum["XOF"] = 'XOF'] = "XOF";
        CurrencyEnum[CurrencyEnum["CDF"] = 'CDF'] = "CDF";
        CurrencyEnum[CurrencyEnum["XAF"] = 'XAF'] = "XAF";
        CurrencyEnum[CurrencyEnum["HTG"] = 'HTG'] = "HTG";
        CurrencyEnum[CurrencyEnum["ILS"] = 'ILS'] = "ILS";
        CurrencyEnum[CurrencyEnum["HRK"] = 'HRK'] = "HRK";
        CurrencyEnum[CurrencyEnum["HUF"] = 'HUF'] = "HUF";
        CurrencyEnum[CurrencyEnum["AMD"] = 'AMD'] = "AMD";
        CurrencyEnum[CurrencyEnum["ISK"] = 'ISK'] = "ISK";
        CurrencyEnum[CurrencyEnum["JPY"] = 'JPY'] = "JPY";
        CurrencyEnum[CurrencyEnum["GEL"] = 'GEL'] = "GEL";
        CurrencyEnum[CurrencyEnum["KZT"] = 'KZT'] = "KZT";
        CurrencyEnum[CurrencyEnum["KHR"] = 'KHR'] = "KHR";
        CurrencyEnum[CurrencyEnum["KRW"] = 'KRW'] = "KRW";
        CurrencyEnum[CurrencyEnum["KGS"] = 'KGS'] = "KGS";
        CurrencyEnum[CurrencyEnum["LAK"] = 'LAK'] = "LAK";
        CurrencyEnum[CurrencyEnum["MKD"] = 'MKD'] = "MKD";
        CurrencyEnum[CurrencyEnum["MNT"] = 'MNT'] = "MNT";
        CurrencyEnum[CurrencyEnum["BND"] = 'BND'] = "BND";
        CurrencyEnum[CurrencyEnum["MMK"] = 'MMK'] = "MMK";
        CurrencyEnum[CurrencyEnum["NOK"] = 'NOK'] = "NOK";
        CurrencyEnum[CurrencyEnum["NPR"] = 'NPR'] = "NPR";
        CurrencyEnum[CurrencyEnum["PKR"] = 'PKR'] = "PKR";
        CurrencyEnum[CurrencyEnum["PLN"] = 'PLN'] = "PLN";
        CurrencyEnum[CurrencyEnum["AFN"] = 'AFN'] = "AFN";
        CurrencyEnum[CurrencyEnum["BRL"] = 'BRL'] = "BRL";
        CurrencyEnum[CurrencyEnum["MDL"] = 'MDL'] = "MDL";
        CurrencyEnum[CurrencyEnum["RON"] = 'RON'] = "RON";
        CurrencyEnum[CurrencyEnum["RWF"] = 'RWF'] = "RWF";
        CurrencyEnum[CurrencyEnum["SEK"] = 'SEK'] = "SEK";
        CurrencyEnum[CurrencyEnum["LKR"] = 'LKR'] = "LKR";
        CurrencyEnum[CurrencyEnum["SOS"] = 'SOS'] = "SOS";
        CurrencyEnum[CurrencyEnum["ALL"] = 'ALL'] = "ALL";
        CurrencyEnum[CurrencyEnum["RSD"] = 'RSD'] = "RSD";
        CurrencyEnum[CurrencyEnum["KES"] = 'KES'] = "KES";
        CurrencyEnum[CurrencyEnum["TJS"] = 'TJS'] = "TJS";
        CurrencyEnum[CurrencyEnum["THB"] = 'THB'] = "THB";
        CurrencyEnum[CurrencyEnum["ERN"] = 'ERN'] = "ERN";
        CurrencyEnum[CurrencyEnum["TMT"] = 'TMT'] = "TMT";
        CurrencyEnum[CurrencyEnum["BWP"] = 'BWP'] = "BWP";
        CurrencyEnum[CurrencyEnum["TRY"] = 'TRY'] = "TRY";
        CurrencyEnum[CurrencyEnum["UAH"] = 'UAH'] = "UAH";
        CurrencyEnum[CurrencyEnum["UZS"] = 'UZS'] = "UZS";
        CurrencyEnum[CurrencyEnum["VND"] = 'VND'] = "VND";
        CurrencyEnum[CurrencyEnum["MOP"] = 'MOP'] = "MOP";
        CurrencyEnum[CurrencyEnum["TWD"] = 'TWD'] = "TWD";
        CurrencyEnum[CurrencyEnum["BMD"] = 'BMD'] = "BMD";
    })(CurrencyEnum = StatisticsCurrencyDataPoint.CurrencyEnum || (StatisticsCurrencyDataPoint.CurrencyEnum = {}));
})(StatisticsCurrencyDataPoint || (exports.StatisticsCurrencyDataPoint = StatisticsCurrencyDataPoint = {}));
var Store;
(function (Store) {
    var PrintoutLayoutTypeEnum;
    (function (PrintoutLayoutTypeEnum) {
        PrintoutLayoutTypeEnum[PrintoutLayoutTypeEnum["Default"] = 'Default'] = "Default";
        PrintoutLayoutTypeEnum[PrintoutLayoutTypeEnum["Centra"] = 'Centra'] = "Centra";
        PrintoutLayoutTypeEnum[PrintoutLayoutTypeEnum["SmallChefNotes"] = 'SmallChefNotes'] = "SmallChefNotes";
        PrintoutLayoutTypeEnum[PrintoutLayoutTypeEnum["SmallChefNotesAndCentra"] = 'SmallChefNotesAndCentra'] = "SmallChefNotesAndCentra";
    })(PrintoutLayoutTypeEnum = Store.PrintoutLayoutTypeEnum || (Store.PrintoutLayoutTypeEnum = {}));
    var CurrencyEnum;
    (function (CurrencyEnum) {
        CurrencyEnum[CurrencyEnum["EUR"] = 'EUR'] = "EUR";
        CurrencyEnum[CurrencyEnum["USD"] = 'USD'] = "USD";
        CurrencyEnum[CurrencyEnum["GBP"] = 'GBP'] = "GBP";
        CurrencyEnum[CurrencyEnum["CAD"] = 'CAD'] = "CAD";
        CurrencyEnum[CurrencyEnum["AUD"] = 'AUD'] = "AUD";
        CurrencyEnum[CurrencyEnum["DJF"] = 'DJF'] = "DJF";
        CurrencyEnum[CurrencyEnum["ZAR"] = 'ZAR'] = "ZAR";
        CurrencyEnum[CurrencyEnum["ETB"] = 'ETB'] = "ETB";
        CurrencyEnum[CurrencyEnum["AED"] = 'AED'] = "AED";
        CurrencyEnum[CurrencyEnum["BHD"] = 'BHD'] = "BHD";
        CurrencyEnum[CurrencyEnum["DZD"] = 'DZD'] = "DZD";
        CurrencyEnum[CurrencyEnum["EGP"] = 'EGP'] = "EGP";
        CurrencyEnum[CurrencyEnum["IQD"] = 'IQD'] = "IQD";
        CurrencyEnum[CurrencyEnum["JOD"] = 'JOD'] = "JOD";
        CurrencyEnum[CurrencyEnum["KWD"] = 'KWD'] = "KWD";
        CurrencyEnum[CurrencyEnum["LBP"] = 'LBP'] = "LBP";
        CurrencyEnum[CurrencyEnum["LYD"] = 'LYD'] = "LYD";
        CurrencyEnum[CurrencyEnum["MAD"] = 'MAD'] = "MAD";
        CurrencyEnum[CurrencyEnum["OMR"] = 'OMR'] = "OMR";
        CurrencyEnum[CurrencyEnum["QAR"] = 'QAR'] = "QAR";
        CurrencyEnum[CurrencyEnum["SAR"] = 'SAR'] = "SAR";
        CurrencyEnum[CurrencyEnum["SYP"] = 'SYP'] = "SYP";
        CurrencyEnum[CurrencyEnum["TND"] = 'TND'] = "TND";
        CurrencyEnum[CurrencyEnum["YER"] = 'YER'] = "YER";
        CurrencyEnum[CurrencyEnum["CLP"] = 'CLP'] = "CLP";
        CurrencyEnum[CurrencyEnum["INR"] = 'INR'] = "INR";
        CurrencyEnum[CurrencyEnum["AZN"] = 'AZN'] = "AZN";
        CurrencyEnum[CurrencyEnum["RUB"] = 'RUB'] = "RUB";
        CurrencyEnum[CurrencyEnum["BYN"] = 'BYN'] = "BYN";
        CurrencyEnum[CurrencyEnum["BGN"] = 'BGN'] = "BGN";
        CurrencyEnum[CurrencyEnum["NGN"] = 'NGN'] = "NGN";
        CurrencyEnum[CurrencyEnum["BDT"] = 'BDT'] = "BDT";
        CurrencyEnum[CurrencyEnum["CNY"] = 'CNY'] = "CNY";
        CurrencyEnum[CurrencyEnum["BAM"] = 'BAM'] = "BAM";
        CurrencyEnum[CurrencyEnum["CZK"] = 'CZK'] = "CZK";
        CurrencyEnum[CurrencyEnum["DKK"] = 'DKK'] = "DKK";
        CurrencyEnum[CurrencyEnum["CHF"] = 'CHF'] = "CHF";
        CurrencyEnum[CurrencyEnum["MVR"] = 'MVR'] = "MVR";
        CurrencyEnum[CurrencyEnum["BTN"] = 'BTN'] = "BTN";
        CurrencyEnum[CurrencyEnum["XCD"] = 'XCD'] = "XCD";
        CurrencyEnum[CurrencyEnum["BZD"] = 'BZD'] = "BZD";
        CurrencyEnum[CurrencyEnum["HKD"] = 'HKD'] = "HKD";
        CurrencyEnum[CurrencyEnum["IDR"] = 'IDR'] = "IDR";
        CurrencyEnum[CurrencyEnum["JMD"] = 'JMD'] = "JMD";
        CurrencyEnum[CurrencyEnum["MYR"] = 'MYR'] = "MYR";
        CurrencyEnum[CurrencyEnum["NZD"] = 'NZD'] = "NZD";
        CurrencyEnum[CurrencyEnum["PHP"] = 'PHP'] = "PHP";
        CurrencyEnum[CurrencyEnum["SGD"] = 'SGD'] = "SGD";
        CurrencyEnum[CurrencyEnum["TTD"] = 'TTD'] = "TTD";
        CurrencyEnum[CurrencyEnum["XDR"] = 'XDR'] = "XDR";
        CurrencyEnum[CurrencyEnum["ARS"] = 'ARS'] = "ARS";
        CurrencyEnum[CurrencyEnum["BOB"] = 'BOB'] = "BOB";
        CurrencyEnum[CurrencyEnum["COP"] = 'COP'] = "COP";
        CurrencyEnum[CurrencyEnum["CRC"] = 'CRC'] = "CRC";
        CurrencyEnum[CurrencyEnum["CUP"] = 'CUP'] = "CUP";
        CurrencyEnum[CurrencyEnum["DOP"] = 'DOP'] = "DOP";
        CurrencyEnum[CurrencyEnum["GTQ"] = 'GTQ'] = "GTQ";
        CurrencyEnum[CurrencyEnum["HNL"] = 'HNL'] = "HNL";
        CurrencyEnum[CurrencyEnum["MXN"] = 'MXN'] = "MXN";
        CurrencyEnum[CurrencyEnum["NIO"] = 'NIO'] = "NIO";
        CurrencyEnum[CurrencyEnum["PAB"] = 'PAB'] = "PAB";
        CurrencyEnum[CurrencyEnum["PEN"] = 'PEN'] = "PEN";
        CurrencyEnum[CurrencyEnum["PYG"] = 'PYG'] = "PYG";
        CurrencyEnum[CurrencyEnum["UYU"] = 'UYU'] = "UYU";
        CurrencyEnum[CurrencyEnum["VEF"] = 'VEF'] = "VEF";
        CurrencyEnum[CurrencyEnum["IRR"] = 'IRR'] = "IRR";
        CurrencyEnum[CurrencyEnum["XOF"] = 'XOF'] = "XOF";
        CurrencyEnum[CurrencyEnum["CDF"] = 'CDF'] = "CDF";
        CurrencyEnum[CurrencyEnum["XAF"] = 'XAF'] = "XAF";
        CurrencyEnum[CurrencyEnum["HTG"] = 'HTG'] = "HTG";
        CurrencyEnum[CurrencyEnum["ILS"] = 'ILS'] = "ILS";
        CurrencyEnum[CurrencyEnum["HRK"] = 'HRK'] = "HRK";
        CurrencyEnum[CurrencyEnum["HUF"] = 'HUF'] = "HUF";
        CurrencyEnum[CurrencyEnum["AMD"] = 'AMD'] = "AMD";
        CurrencyEnum[CurrencyEnum["ISK"] = 'ISK'] = "ISK";
        CurrencyEnum[CurrencyEnum["JPY"] = 'JPY'] = "JPY";
        CurrencyEnum[CurrencyEnum["GEL"] = 'GEL'] = "GEL";
        CurrencyEnum[CurrencyEnum["KZT"] = 'KZT'] = "KZT";
        CurrencyEnum[CurrencyEnum["KHR"] = 'KHR'] = "KHR";
        CurrencyEnum[CurrencyEnum["KRW"] = 'KRW'] = "KRW";
        CurrencyEnum[CurrencyEnum["KGS"] = 'KGS'] = "KGS";
        CurrencyEnum[CurrencyEnum["LAK"] = 'LAK'] = "LAK";
        CurrencyEnum[CurrencyEnum["MKD"] = 'MKD'] = "MKD";
        CurrencyEnum[CurrencyEnum["MNT"] = 'MNT'] = "MNT";
        CurrencyEnum[CurrencyEnum["BND"] = 'BND'] = "BND";
        CurrencyEnum[CurrencyEnum["MMK"] = 'MMK'] = "MMK";
        CurrencyEnum[CurrencyEnum["NOK"] = 'NOK'] = "NOK";
        CurrencyEnum[CurrencyEnum["NPR"] = 'NPR'] = "NPR";
        CurrencyEnum[CurrencyEnum["PKR"] = 'PKR'] = "PKR";
        CurrencyEnum[CurrencyEnum["PLN"] = 'PLN'] = "PLN";
        CurrencyEnum[CurrencyEnum["AFN"] = 'AFN'] = "AFN";
        CurrencyEnum[CurrencyEnum["BRL"] = 'BRL'] = "BRL";
        CurrencyEnum[CurrencyEnum["MDL"] = 'MDL'] = "MDL";
        CurrencyEnum[CurrencyEnum["RON"] = 'RON'] = "RON";
        CurrencyEnum[CurrencyEnum["RWF"] = 'RWF'] = "RWF";
        CurrencyEnum[CurrencyEnum["SEK"] = 'SEK'] = "SEK";
        CurrencyEnum[CurrencyEnum["LKR"] = 'LKR'] = "LKR";
        CurrencyEnum[CurrencyEnum["SOS"] = 'SOS'] = "SOS";
        CurrencyEnum[CurrencyEnum["ALL"] = 'ALL'] = "ALL";
        CurrencyEnum[CurrencyEnum["RSD"] = 'RSD'] = "RSD";
        CurrencyEnum[CurrencyEnum["KES"] = 'KES'] = "KES";
        CurrencyEnum[CurrencyEnum["TJS"] = 'TJS'] = "TJS";
        CurrencyEnum[CurrencyEnum["THB"] = 'THB'] = "THB";
        CurrencyEnum[CurrencyEnum["ERN"] = 'ERN'] = "ERN";
        CurrencyEnum[CurrencyEnum["TMT"] = 'TMT'] = "TMT";
        CurrencyEnum[CurrencyEnum["BWP"] = 'BWP'] = "BWP";
        CurrencyEnum[CurrencyEnum["TRY"] = 'TRY'] = "TRY";
        CurrencyEnum[CurrencyEnum["UAH"] = 'UAH'] = "UAH";
        CurrencyEnum[CurrencyEnum["UZS"] = 'UZS'] = "UZS";
        CurrencyEnum[CurrencyEnum["VND"] = 'VND'] = "VND";
        CurrencyEnum[CurrencyEnum["MOP"] = 'MOP'] = "MOP";
        CurrencyEnum[CurrencyEnum["TWD"] = 'TWD'] = "TWD";
        CurrencyEnum[CurrencyEnum["BMD"] = 'BMD'] = "BMD";
    })(CurrencyEnum = Store.CurrencyEnum || (Store.CurrencyEnum = {}));
    var SalesChannelTypesEnum;
    (function (SalesChannelTypesEnum) {
        SalesChannelTypesEnum[SalesChannelTypesEnum["Web"] = 'Web'] = "Web";
        SalesChannelTypesEnum[SalesChannelTypesEnum["App"] = 'App'] = "App";
        SalesChannelTypesEnum[SalesChannelTypesEnum["Kiosk"] = 'Kiosk'] = "Kiosk";
        SalesChannelTypesEnum[SalesChannelTypesEnum["Pos"] = 'Pos'] = "Pos";
        SalesChannelTypesEnum[SalesChannelTypesEnum["None"] = 'None'] = "None";
        SalesChannelTypesEnum[SalesChannelTypesEnum["PhoneAgent"] = 'PhoneAgent'] = "PhoneAgent";
    })(SalesChannelTypesEnum = Store.SalesChannelTypesEnum || (Store.SalesChannelTypesEnum = {}));
    var InheritanceConfigTypesEnum;
    (function (InheritanceConfigTypesEnum) {
        InheritanceConfigTypesEnum[InheritanceConfigTypesEnum["CollectionSettings"] = 'CollectionSettings'] = "CollectionSettings";
    })(InheritanceConfigTypesEnum = Store.InheritanceConfigTypesEnum || (Store.InheritanceConfigTypesEnum = {}));
})(Store || (exports.Store = Store = {}));
var StoreBase;
(function (StoreBase) {
    var SalesChannelTypesEnum;
    (function (SalesChannelTypesEnum) {
        SalesChannelTypesEnum[SalesChannelTypesEnum["Web"] = 'Web'] = "Web";
        SalesChannelTypesEnum[SalesChannelTypesEnum["App"] = 'App'] = "App";
        SalesChannelTypesEnum[SalesChannelTypesEnum["Kiosk"] = 'Kiosk'] = "Kiosk";
        SalesChannelTypesEnum[SalesChannelTypesEnum["Pos"] = 'Pos'] = "Pos";
        SalesChannelTypesEnum[SalesChannelTypesEnum["None"] = 'None'] = "None";
        SalesChannelTypesEnum[SalesChannelTypesEnum["PhoneAgent"] = 'PhoneAgent'] = "PhoneAgent";
    })(SalesChannelTypesEnum = StoreBase.SalesChannelTypesEnum || (StoreBase.SalesChannelTypesEnum = {}));
    var InheritanceConfigTypesEnum;
    (function (InheritanceConfigTypesEnum) {
        InheritanceConfigTypesEnum[InheritanceConfigTypesEnum["CollectionSettings"] = 'CollectionSettings'] = "CollectionSettings";
    })(InheritanceConfigTypesEnum = StoreBase.InheritanceConfigTypesEnum || (StoreBase.InheritanceConfigTypesEnum = {}));
})(StoreBase || (exports.StoreBase = StoreBase = {}));
var StoreCreateBase;
(function (StoreCreateBase) {
    var SalesChannelTypeEnum;
    (function (SalesChannelTypeEnum) {
        SalesChannelTypeEnum[SalesChannelTypeEnum["Web"] = 'Web'] = "Web";
        SalesChannelTypeEnum[SalesChannelTypeEnum["App"] = 'App'] = "App";
        SalesChannelTypeEnum[SalesChannelTypeEnum["Kiosk"] = 'Kiosk'] = "Kiosk";
        SalesChannelTypeEnum[SalesChannelTypeEnum["Pos"] = 'Pos'] = "Pos";
        SalesChannelTypeEnum[SalesChannelTypeEnum["None"] = 'None'] = "None";
        SalesChannelTypeEnum[SalesChannelTypeEnum["PhoneAgent"] = 'PhoneAgent'] = "PhoneAgent";
    })(SalesChannelTypeEnum = StoreCreateBase.SalesChannelTypeEnum || (StoreCreateBase.SalesChannelTypeEnum = {}));
})(StoreCreateBase || (exports.StoreCreateBase = StoreCreateBase = {}));
var StoreEndOfDayReport;
(function (StoreEndOfDayReport) {
    var CurrencyEnum;
    (function (CurrencyEnum) {
        CurrencyEnum[CurrencyEnum["EUR"] = 'EUR'] = "EUR";
        CurrencyEnum[CurrencyEnum["USD"] = 'USD'] = "USD";
        CurrencyEnum[CurrencyEnum["GBP"] = 'GBP'] = "GBP";
        CurrencyEnum[CurrencyEnum["CAD"] = 'CAD'] = "CAD";
        CurrencyEnum[CurrencyEnum["AUD"] = 'AUD'] = "AUD";
        CurrencyEnum[CurrencyEnum["DJF"] = 'DJF'] = "DJF";
        CurrencyEnum[CurrencyEnum["ZAR"] = 'ZAR'] = "ZAR";
        CurrencyEnum[CurrencyEnum["ETB"] = 'ETB'] = "ETB";
        CurrencyEnum[CurrencyEnum["AED"] = 'AED'] = "AED";
        CurrencyEnum[CurrencyEnum["BHD"] = 'BHD'] = "BHD";
        CurrencyEnum[CurrencyEnum["DZD"] = 'DZD'] = "DZD";
        CurrencyEnum[CurrencyEnum["EGP"] = 'EGP'] = "EGP";
        CurrencyEnum[CurrencyEnum["IQD"] = 'IQD'] = "IQD";
        CurrencyEnum[CurrencyEnum["JOD"] = 'JOD'] = "JOD";
        CurrencyEnum[CurrencyEnum["KWD"] = 'KWD'] = "KWD";
        CurrencyEnum[CurrencyEnum["LBP"] = 'LBP'] = "LBP";
        CurrencyEnum[CurrencyEnum["LYD"] = 'LYD'] = "LYD";
        CurrencyEnum[CurrencyEnum["MAD"] = 'MAD'] = "MAD";
        CurrencyEnum[CurrencyEnum["OMR"] = 'OMR'] = "OMR";
        CurrencyEnum[CurrencyEnum["QAR"] = 'QAR'] = "QAR";
        CurrencyEnum[CurrencyEnum["SAR"] = 'SAR'] = "SAR";
        CurrencyEnum[CurrencyEnum["SYP"] = 'SYP'] = "SYP";
        CurrencyEnum[CurrencyEnum["TND"] = 'TND'] = "TND";
        CurrencyEnum[CurrencyEnum["YER"] = 'YER'] = "YER";
        CurrencyEnum[CurrencyEnum["CLP"] = 'CLP'] = "CLP";
        CurrencyEnum[CurrencyEnum["INR"] = 'INR'] = "INR";
        CurrencyEnum[CurrencyEnum["AZN"] = 'AZN'] = "AZN";
        CurrencyEnum[CurrencyEnum["RUB"] = 'RUB'] = "RUB";
        CurrencyEnum[CurrencyEnum["BYN"] = 'BYN'] = "BYN";
        CurrencyEnum[CurrencyEnum["BGN"] = 'BGN'] = "BGN";
        CurrencyEnum[CurrencyEnum["NGN"] = 'NGN'] = "NGN";
        CurrencyEnum[CurrencyEnum["BDT"] = 'BDT'] = "BDT";
        CurrencyEnum[CurrencyEnum["CNY"] = 'CNY'] = "CNY";
        CurrencyEnum[CurrencyEnum["BAM"] = 'BAM'] = "BAM";
        CurrencyEnum[CurrencyEnum["CZK"] = 'CZK'] = "CZK";
        CurrencyEnum[CurrencyEnum["DKK"] = 'DKK'] = "DKK";
        CurrencyEnum[CurrencyEnum["CHF"] = 'CHF'] = "CHF";
        CurrencyEnum[CurrencyEnum["MVR"] = 'MVR'] = "MVR";
        CurrencyEnum[CurrencyEnum["BTN"] = 'BTN'] = "BTN";
        CurrencyEnum[CurrencyEnum["XCD"] = 'XCD'] = "XCD";
        CurrencyEnum[CurrencyEnum["BZD"] = 'BZD'] = "BZD";
        CurrencyEnum[CurrencyEnum["HKD"] = 'HKD'] = "HKD";
        CurrencyEnum[CurrencyEnum["IDR"] = 'IDR'] = "IDR";
        CurrencyEnum[CurrencyEnum["JMD"] = 'JMD'] = "JMD";
        CurrencyEnum[CurrencyEnum["MYR"] = 'MYR'] = "MYR";
        CurrencyEnum[CurrencyEnum["NZD"] = 'NZD'] = "NZD";
        CurrencyEnum[CurrencyEnum["PHP"] = 'PHP'] = "PHP";
        CurrencyEnum[CurrencyEnum["SGD"] = 'SGD'] = "SGD";
        CurrencyEnum[CurrencyEnum["TTD"] = 'TTD'] = "TTD";
        CurrencyEnum[CurrencyEnum["XDR"] = 'XDR'] = "XDR";
        CurrencyEnum[CurrencyEnum["ARS"] = 'ARS'] = "ARS";
        CurrencyEnum[CurrencyEnum["BOB"] = 'BOB'] = "BOB";
        CurrencyEnum[CurrencyEnum["COP"] = 'COP'] = "COP";
        CurrencyEnum[CurrencyEnum["CRC"] = 'CRC'] = "CRC";
        CurrencyEnum[CurrencyEnum["CUP"] = 'CUP'] = "CUP";
        CurrencyEnum[CurrencyEnum["DOP"] = 'DOP'] = "DOP";
        CurrencyEnum[CurrencyEnum["GTQ"] = 'GTQ'] = "GTQ";
        CurrencyEnum[CurrencyEnum["HNL"] = 'HNL'] = "HNL";
        CurrencyEnum[CurrencyEnum["MXN"] = 'MXN'] = "MXN";
        CurrencyEnum[CurrencyEnum["NIO"] = 'NIO'] = "NIO";
        CurrencyEnum[CurrencyEnum["PAB"] = 'PAB'] = "PAB";
        CurrencyEnum[CurrencyEnum["PEN"] = 'PEN'] = "PEN";
        CurrencyEnum[CurrencyEnum["PYG"] = 'PYG'] = "PYG";
        CurrencyEnum[CurrencyEnum["UYU"] = 'UYU'] = "UYU";
        CurrencyEnum[CurrencyEnum["VEF"] = 'VEF'] = "VEF";
        CurrencyEnum[CurrencyEnum["IRR"] = 'IRR'] = "IRR";
        CurrencyEnum[CurrencyEnum["XOF"] = 'XOF'] = "XOF";
        CurrencyEnum[CurrencyEnum["CDF"] = 'CDF'] = "CDF";
        CurrencyEnum[CurrencyEnum["XAF"] = 'XAF'] = "XAF";
        CurrencyEnum[CurrencyEnum["HTG"] = 'HTG'] = "HTG";
        CurrencyEnum[CurrencyEnum["ILS"] = 'ILS'] = "ILS";
        CurrencyEnum[CurrencyEnum["HRK"] = 'HRK'] = "HRK";
        CurrencyEnum[CurrencyEnum["HUF"] = 'HUF'] = "HUF";
        CurrencyEnum[CurrencyEnum["AMD"] = 'AMD'] = "AMD";
        CurrencyEnum[CurrencyEnum["ISK"] = 'ISK'] = "ISK";
        CurrencyEnum[CurrencyEnum["JPY"] = 'JPY'] = "JPY";
        CurrencyEnum[CurrencyEnum["GEL"] = 'GEL'] = "GEL";
        CurrencyEnum[CurrencyEnum["KZT"] = 'KZT'] = "KZT";
        CurrencyEnum[CurrencyEnum["KHR"] = 'KHR'] = "KHR";
        CurrencyEnum[CurrencyEnum["KRW"] = 'KRW'] = "KRW";
        CurrencyEnum[CurrencyEnum["KGS"] = 'KGS'] = "KGS";
        CurrencyEnum[CurrencyEnum["LAK"] = 'LAK'] = "LAK";
        CurrencyEnum[CurrencyEnum["MKD"] = 'MKD'] = "MKD";
        CurrencyEnum[CurrencyEnum["MNT"] = 'MNT'] = "MNT";
        CurrencyEnum[CurrencyEnum["BND"] = 'BND'] = "BND";
        CurrencyEnum[CurrencyEnum["MMK"] = 'MMK'] = "MMK";
        CurrencyEnum[CurrencyEnum["NOK"] = 'NOK'] = "NOK";
        CurrencyEnum[CurrencyEnum["NPR"] = 'NPR'] = "NPR";
        CurrencyEnum[CurrencyEnum["PKR"] = 'PKR'] = "PKR";
        CurrencyEnum[CurrencyEnum["PLN"] = 'PLN'] = "PLN";
        CurrencyEnum[CurrencyEnum["AFN"] = 'AFN'] = "AFN";
        CurrencyEnum[CurrencyEnum["BRL"] = 'BRL'] = "BRL";
        CurrencyEnum[CurrencyEnum["MDL"] = 'MDL'] = "MDL";
        CurrencyEnum[CurrencyEnum["RON"] = 'RON'] = "RON";
        CurrencyEnum[CurrencyEnum["RWF"] = 'RWF'] = "RWF";
        CurrencyEnum[CurrencyEnum["SEK"] = 'SEK'] = "SEK";
        CurrencyEnum[CurrencyEnum["LKR"] = 'LKR'] = "LKR";
        CurrencyEnum[CurrencyEnum["SOS"] = 'SOS'] = "SOS";
        CurrencyEnum[CurrencyEnum["ALL"] = 'ALL'] = "ALL";
        CurrencyEnum[CurrencyEnum["RSD"] = 'RSD'] = "RSD";
        CurrencyEnum[CurrencyEnum["KES"] = 'KES'] = "KES";
        CurrencyEnum[CurrencyEnum["TJS"] = 'TJS'] = "TJS";
        CurrencyEnum[CurrencyEnum["THB"] = 'THB'] = "THB";
        CurrencyEnum[CurrencyEnum["ERN"] = 'ERN'] = "ERN";
        CurrencyEnum[CurrencyEnum["TMT"] = 'TMT'] = "TMT";
        CurrencyEnum[CurrencyEnum["BWP"] = 'BWP'] = "BWP";
        CurrencyEnum[CurrencyEnum["TRY"] = 'TRY'] = "TRY";
        CurrencyEnum[CurrencyEnum["UAH"] = 'UAH'] = "UAH";
        CurrencyEnum[CurrencyEnum["UZS"] = 'UZS'] = "UZS";
        CurrencyEnum[CurrencyEnum["VND"] = 'VND'] = "VND";
        CurrencyEnum[CurrencyEnum["MOP"] = 'MOP'] = "MOP";
        CurrencyEnum[CurrencyEnum["TWD"] = 'TWD'] = "TWD";
        CurrencyEnum[CurrencyEnum["BMD"] = 'BMD'] = "BMD";
    })(CurrencyEnum = StoreEndOfDayReport.CurrencyEnum || (StoreEndOfDayReport.CurrencyEnum = {}));
})(StoreEndOfDayReport || (exports.StoreEndOfDayReport = StoreEndOfDayReport = {}));
var StoreGroup;
(function (StoreGroup) {
    var CurrencyEnum;
    (function (CurrencyEnum) {
        CurrencyEnum[CurrencyEnum["EUR"] = 'EUR'] = "EUR";
        CurrencyEnum[CurrencyEnum["USD"] = 'USD'] = "USD";
        CurrencyEnum[CurrencyEnum["GBP"] = 'GBP'] = "GBP";
        CurrencyEnum[CurrencyEnum["CAD"] = 'CAD'] = "CAD";
        CurrencyEnum[CurrencyEnum["AUD"] = 'AUD'] = "AUD";
        CurrencyEnum[CurrencyEnum["DJF"] = 'DJF'] = "DJF";
        CurrencyEnum[CurrencyEnum["ZAR"] = 'ZAR'] = "ZAR";
        CurrencyEnum[CurrencyEnum["ETB"] = 'ETB'] = "ETB";
        CurrencyEnum[CurrencyEnum["AED"] = 'AED'] = "AED";
        CurrencyEnum[CurrencyEnum["BHD"] = 'BHD'] = "BHD";
        CurrencyEnum[CurrencyEnum["DZD"] = 'DZD'] = "DZD";
        CurrencyEnum[CurrencyEnum["EGP"] = 'EGP'] = "EGP";
        CurrencyEnum[CurrencyEnum["IQD"] = 'IQD'] = "IQD";
        CurrencyEnum[CurrencyEnum["JOD"] = 'JOD'] = "JOD";
        CurrencyEnum[CurrencyEnum["KWD"] = 'KWD'] = "KWD";
        CurrencyEnum[CurrencyEnum["LBP"] = 'LBP'] = "LBP";
        CurrencyEnum[CurrencyEnum["LYD"] = 'LYD'] = "LYD";
        CurrencyEnum[CurrencyEnum["MAD"] = 'MAD'] = "MAD";
        CurrencyEnum[CurrencyEnum["OMR"] = 'OMR'] = "OMR";
        CurrencyEnum[CurrencyEnum["QAR"] = 'QAR'] = "QAR";
        CurrencyEnum[CurrencyEnum["SAR"] = 'SAR'] = "SAR";
        CurrencyEnum[CurrencyEnum["SYP"] = 'SYP'] = "SYP";
        CurrencyEnum[CurrencyEnum["TND"] = 'TND'] = "TND";
        CurrencyEnum[CurrencyEnum["YER"] = 'YER'] = "YER";
        CurrencyEnum[CurrencyEnum["CLP"] = 'CLP'] = "CLP";
        CurrencyEnum[CurrencyEnum["INR"] = 'INR'] = "INR";
        CurrencyEnum[CurrencyEnum["AZN"] = 'AZN'] = "AZN";
        CurrencyEnum[CurrencyEnum["RUB"] = 'RUB'] = "RUB";
        CurrencyEnum[CurrencyEnum["BYN"] = 'BYN'] = "BYN";
        CurrencyEnum[CurrencyEnum["BGN"] = 'BGN'] = "BGN";
        CurrencyEnum[CurrencyEnum["NGN"] = 'NGN'] = "NGN";
        CurrencyEnum[CurrencyEnum["BDT"] = 'BDT'] = "BDT";
        CurrencyEnum[CurrencyEnum["CNY"] = 'CNY'] = "CNY";
        CurrencyEnum[CurrencyEnum["BAM"] = 'BAM'] = "BAM";
        CurrencyEnum[CurrencyEnum["CZK"] = 'CZK'] = "CZK";
        CurrencyEnum[CurrencyEnum["DKK"] = 'DKK'] = "DKK";
        CurrencyEnum[CurrencyEnum["CHF"] = 'CHF'] = "CHF";
        CurrencyEnum[CurrencyEnum["MVR"] = 'MVR'] = "MVR";
        CurrencyEnum[CurrencyEnum["BTN"] = 'BTN'] = "BTN";
        CurrencyEnum[CurrencyEnum["XCD"] = 'XCD'] = "XCD";
        CurrencyEnum[CurrencyEnum["BZD"] = 'BZD'] = "BZD";
        CurrencyEnum[CurrencyEnum["HKD"] = 'HKD'] = "HKD";
        CurrencyEnum[CurrencyEnum["IDR"] = 'IDR'] = "IDR";
        CurrencyEnum[CurrencyEnum["JMD"] = 'JMD'] = "JMD";
        CurrencyEnum[CurrencyEnum["MYR"] = 'MYR'] = "MYR";
        CurrencyEnum[CurrencyEnum["NZD"] = 'NZD'] = "NZD";
        CurrencyEnum[CurrencyEnum["PHP"] = 'PHP'] = "PHP";
        CurrencyEnum[CurrencyEnum["SGD"] = 'SGD'] = "SGD";
        CurrencyEnum[CurrencyEnum["TTD"] = 'TTD'] = "TTD";
        CurrencyEnum[CurrencyEnum["XDR"] = 'XDR'] = "XDR";
        CurrencyEnum[CurrencyEnum["ARS"] = 'ARS'] = "ARS";
        CurrencyEnum[CurrencyEnum["BOB"] = 'BOB'] = "BOB";
        CurrencyEnum[CurrencyEnum["COP"] = 'COP'] = "COP";
        CurrencyEnum[CurrencyEnum["CRC"] = 'CRC'] = "CRC";
        CurrencyEnum[CurrencyEnum["CUP"] = 'CUP'] = "CUP";
        CurrencyEnum[CurrencyEnum["DOP"] = 'DOP'] = "DOP";
        CurrencyEnum[CurrencyEnum["GTQ"] = 'GTQ'] = "GTQ";
        CurrencyEnum[CurrencyEnum["HNL"] = 'HNL'] = "HNL";
        CurrencyEnum[CurrencyEnum["MXN"] = 'MXN'] = "MXN";
        CurrencyEnum[CurrencyEnum["NIO"] = 'NIO'] = "NIO";
        CurrencyEnum[CurrencyEnum["PAB"] = 'PAB'] = "PAB";
        CurrencyEnum[CurrencyEnum["PEN"] = 'PEN'] = "PEN";
        CurrencyEnum[CurrencyEnum["PYG"] = 'PYG'] = "PYG";
        CurrencyEnum[CurrencyEnum["UYU"] = 'UYU'] = "UYU";
        CurrencyEnum[CurrencyEnum["VEF"] = 'VEF'] = "VEF";
        CurrencyEnum[CurrencyEnum["IRR"] = 'IRR'] = "IRR";
        CurrencyEnum[CurrencyEnum["XOF"] = 'XOF'] = "XOF";
        CurrencyEnum[CurrencyEnum["CDF"] = 'CDF'] = "CDF";
        CurrencyEnum[CurrencyEnum["XAF"] = 'XAF'] = "XAF";
        CurrencyEnum[CurrencyEnum["HTG"] = 'HTG'] = "HTG";
        CurrencyEnum[CurrencyEnum["ILS"] = 'ILS'] = "ILS";
        CurrencyEnum[CurrencyEnum["HRK"] = 'HRK'] = "HRK";
        CurrencyEnum[CurrencyEnum["HUF"] = 'HUF'] = "HUF";
        CurrencyEnum[CurrencyEnum["AMD"] = 'AMD'] = "AMD";
        CurrencyEnum[CurrencyEnum["ISK"] = 'ISK'] = "ISK";
        CurrencyEnum[CurrencyEnum["JPY"] = 'JPY'] = "JPY";
        CurrencyEnum[CurrencyEnum["GEL"] = 'GEL'] = "GEL";
        CurrencyEnum[CurrencyEnum["KZT"] = 'KZT'] = "KZT";
        CurrencyEnum[CurrencyEnum["KHR"] = 'KHR'] = "KHR";
        CurrencyEnum[CurrencyEnum["KRW"] = 'KRW'] = "KRW";
        CurrencyEnum[CurrencyEnum["KGS"] = 'KGS'] = "KGS";
        CurrencyEnum[CurrencyEnum["LAK"] = 'LAK'] = "LAK";
        CurrencyEnum[CurrencyEnum["MKD"] = 'MKD'] = "MKD";
        CurrencyEnum[CurrencyEnum["MNT"] = 'MNT'] = "MNT";
        CurrencyEnum[CurrencyEnum["BND"] = 'BND'] = "BND";
        CurrencyEnum[CurrencyEnum["MMK"] = 'MMK'] = "MMK";
        CurrencyEnum[CurrencyEnum["NOK"] = 'NOK'] = "NOK";
        CurrencyEnum[CurrencyEnum["NPR"] = 'NPR'] = "NPR";
        CurrencyEnum[CurrencyEnum["PKR"] = 'PKR'] = "PKR";
        CurrencyEnum[CurrencyEnum["PLN"] = 'PLN'] = "PLN";
        CurrencyEnum[CurrencyEnum["AFN"] = 'AFN'] = "AFN";
        CurrencyEnum[CurrencyEnum["BRL"] = 'BRL'] = "BRL";
        CurrencyEnum[CurrencyEnum["MDL"] = 'MDL'] = "MDL";
        CurrencyEnum[CurrencyEnum["RON"] = 'RON'] = "RON";
        CurrencyEnum[CurrencyEnum["RWF"] = 'RWF'] = "RWF";
        CurrencyEnum[CurrencyEnum["SEK"] = 'SEK'] = "SEK";
        CurrencyEnum[CurrencyEnum["LKR"] = 'LKR'] = "LKR";
        CurrencyEnum[CurrencyEnum["SOS"] = 'SOS'] = "SOS";
        CurrencyEnum[CurrencyEnum["ALL"] = 'ALL'] = "ALL";
        CurrencyEnum[CurrencyEnum["RSD"] = 'RSD'] = "RSD";
        CurrencyEnum[CurrencyEnum["KES"] = 'KES'] = "KES";
        CurrencyEnum[CurrencyEnum["TJS"] = 'TJS'] = "TJS";
        CurrencyEnum[CurrencyEnum["THB"] = 'THB'] = "THB";
        CurrencyEnum[CurrencyEnum["ERN"] = 'ERN'] = "ERN";
        CurrencyEnum[CurrencyEnum["TMT"] = 'TMT'] = "TMT";
        CurrencyEnum[CurrencyEnum["BWP"] = 'BWP'] = "BWP";
        CurrencyEnum[CurrencyEnum["TRY"] = 'TRY'] = "TRY";
        CurrencyEnum[CurrencyEnum["UAH"] = 'UAH'] = "UAH";
        CurrencyEnum[CurrencyEnum["UZS"] = 'UZS'] = "UZS";
        CurrencyEnum[CurrencyEnum["VND"] = 'VND'] = "VND";
        CurrencyEnum[CurrencyEnum["MOP"] = 'MOP'] = "MOP";
        CurrencyEnum[CurrencyEnum["TWD"] = 'TWD'] = "TWD";
        CurrencyEnum[CurrencyEnum["BMD"] = 'BMD'] = "BMD";
    })(CurrencyEnum = StoreGroup.CurrencyEnum || (StoreGroup.CurrencyEnum = {}));
})(StoreGroup || (exports.StoreGroup = StoreGroup = {}));
var StoreGroupBase;
(function (StoreGroupBase) {
    var CurrencyEnum;
    (function (CurrencyEnum) {
        CurrencyEnum[CurrencyEnum["EUR"] = 'EUR'] = "EUR";
        CurrencyEnum[CurrencyEnum["USD"] = 'USD'] = "USD";
        CurrencyEnum[CurrencyEnum["GBP"] = 'GBP'] = "GBP";
        CurrencyEnum[CurrencyEnum["CAD"] = 'CAD'] = "CAD";
        CurrencyEnum[CurrencyEnum["AUD"] = 'AUD'] = "AUD";
        CurrencyEnum[CurrencyEnum["DJF"] = 'DJF'] = "DJF";
        CurrencyEnum[CurrencyEnum["ZAR"] = 'ZAR'] = "ZAR";
        CurrencyEnum[CurrencyEnum["ETB"] = 'ETB'] = "ETB";
        CurrencyEnum[CurrencyEnum["AED"] = 'AED'] = "AED";
        CurrencyEnum[CurrencyEnum["BHD"] = 'BHD'] = "BHD";
        CurrencyEnum[CurrencyEnum["DZD"] = 'DZD'] = "DZD";
        CurrencyEnum[CurrencyEnum["EGP"] = 'EGP'] = "EGP";
        CurrencyEnum[CurrencyEnum["IQD"] = 'IQD'] = "IQD";
        CurrencyEnum[CurrencyEnum["JOD"] = 'JOD'] = "JOD";
        CurrencyEnum[CurrencyEnum["KWD"] = 'KWD'] = "KWD";
        CurrencyEnum[CurrencyEnum["LBP"] = 'LBP'] = "LBP";
        CurrencyEnum[CurrencyEnum["LYD"] = 'LYD'] = "LYD";
        CurrencyEnum[CurrencyEnum["MAD"] = 'MAD'] = "MAD";
        CurrencyEnum[CurrencyEnum["OMR"] = 'OMR'] = "OMR";
        CurrencyEnum[CurrencyEnum["QAR"] = 'QAR'] = "QAR";
        CurrencyEnum[CurrencyEnum["SAR"] = 'SAR'] = "SAR";
        CurrencyEnum[CurrencyEnum["SYP"] = 'SYP'] = "SYP";
        CurrencyEnum[CurrencyEnum["TND"] = 'TND'] = "TND";
        CurrencyEnum[CurrencyEnum["YER"] = 'YER'] = "YER";
        CurrencyEnum[CurrencyEnum["CLP"] = 'CLP'] = "CLP";
        CurrencyEnum[CurrencyEnum["INR"] = 'INR'] = "INR";
        CurrencyEnum[CurrencyEnum["AZN"] = 'AZN'] = "AZN";
        CurrencyEnum[CurrencyEnum["RUB"] = 'RUB'] = "RUB";
        CurrencyEnum[CurrencyEnum["BYN"] = 'BYN'] = "BYN";
        CurrencyEnum[CurrencyEnum["BGN"] = 'BGN'] = "BGN";
        CurrencyEnum[CurrencyEnum["NGN"] = 'NGN'] = "NGN";
        CurrencyEnum[CurrencyEnum["BDT"] = 'BDT'] = "BDT";
        CurrencyEnum[CurrencyEnum["CNY"] = 'CNY'] = "CNY";
        CurrencyEnum[CurrencyEnum["BAM"] = 'BAM'] = "BAM";
        CurrencyEnum[CurrencyEnum["CZK"] = 'CZK'] = "CZK";
        CurrencyEnum[CurrencyEnum["DKK"] = 'DKK'] = "DKK";
        CurrencyEnum[CurrencyEnum["CHF"] = 'CHF'] = "CHF";
        CurrencyEnum[CurrencyEnum["MVR"] = 'MVR'] = "MVR";
        CurrencyEnum[CurrencyEnum["BTN"] = 'BTN'] = "BTN";
        CurrencyEnum[CurrencyEnum["XCD"] = 'XCD'] = "XCD";
        CurrencyEnum[CurrencyEnum["BZD"] = 'BZD'] = "BZD";
        CurrencyEnum[CurrencyEnum["HKD"] = 'HKD'] = "HKD";
        CurrencyEnum[CurrencyEnum["IDR"] = 'IDR'] = "IDR";
        CurrencyEnum[CurrencyEnum["JMD"] = 'JMD'] = "JMD";
        CurrencyEnum[CurrencyEnum["MYR"] = 'MYR'] = "MYR";
        CurrencyEnum[CurrencyEnum["NZD"] = 'NZD'] = "NZD";
        CurrencyEnum[CurrencyEnum["PHP"] = 'PHP'] = "PHP";
        CurrencyEnum[CurrencyEnum["SGD"] = 'SGD'] = "SGD";
        CurrencyEnum[CurrencyEnum["TTD"] = 'TTD'] = "TTD";
        CurrencyEnum[CurrencyEnum["XDR"] = 'XDR'] = "XDR";
        CurrencyEnum[CurrencyEnum["ARS"] = 'ARS'] = "ARS";
        CurrencyEnum[CurrencyEnum["BOB"] = 'BOB'] = "BOB";
        CurrencyEnum[CurrencyEnum["COP"] = 'COP'] = "COP";
        CurrencyEnum[CurrencyEnum["CRC"] = 'CRC'] = "CRC";
        CurrencyEnum[CurrencyEnum["CUP"] = 'CUP'] = "CUP";
        CurrencyEnum[CurrencyEnum["DOP"] = 'DOP'] = "DOP";
        CurrencyEnum[CurrencyEnum["GTQ"] = 'GTQ'] = "GTQ";
        CurrencyEnum[CurrencyEnum["HNL"] = 'HNL'] = "HNL";
        CurrencyEnum[CurrencyEnum["MXN"] = 'MXN'] = "MXN";
        CurrencyEnum[CurrencyEnum["NIO"] = 'NIO'] = "NIO";
        CurrencyEnum[CurrencyEnum["PAB"] = 'PAB'] = "PAB";
        CurrencyEnum[CurrencyEnum["PEN"] = 'PEN'] = "PEN";
        CurrencyEnum[CurrencyEnum["PYG"] = 'PYG'] = "PYG";
        CurrencyEnum[CurrencyEnum["UYU"] = 'UYU'] = "UYU";
        CurrencyEnum[CurrencyEnum["VEF"] = 'VEF'] = "VEF";
        CurrencyEnum[CurrencyEnum["IRR"] = 'IRR'] = "IRR";
        CurrencyEnum[CurrencyEnum["XOF"] = 'XOF'] = "XOF";
        CurrencyEnum[CurrencyEnum["CDF"] = 'CDF'] = "CDF";
        CurrencyEnum[CurrencyEnum["XAF"] = 'XAF'] = "XAF";
        CurrencyEnum[CurrencyEnum["HTG"] = 'HTG'] = "HTG";
        CurrencyEnum[CurrencyEnum["ILS"] = 'ILS'] = "ILS";
        CurrencyEnum[CurrencyEnum["HRK"] = 'HRK'] = "HRK";
        CurrencyEnum[CurrencyEnum["HUF"] = 'HUF'] = "HUF";
        CurrencyEnum[CurrencyEnum["AMD"] = 'AMD'] = "AMD";
        CurrencyEnum[CurrencyEnum["ISK"] = 'ISK'] = "ISK";
        CurrencyEnum[CurrencyEnum["JPY"] = 'JPY'] = "JPY";
        CurrencyEnum[CurrencyEnum["GEL"] = 'GEL'] = "GEL";
        CurrencyEnum[CurrencyEnum["KZT"] = 'KZT'] = "KZT";
        CurrencyEnum[CurrencyEnum["KHR"] = 'KHR'] = "KHR";
        CurrencyEnum[CurrencyEnum["KRW"] = 'KRW'] = "KRW";
        CurrencyEnum[CurrencyEnum["KGS"] = 'KGS'] = "KGS";
        CurrencyEnum[CurrencyEnum["LAK"] = 'LAK'] = "LAK";
        CurrencyEnum[CurrencyEnum["MKD"] = 'MKD'] = "MKD";
        CurrencyEnum[CurrencyEnum["MNT"] = 'MNT'] = "MNT";
        CurrencyEnum[CurrencyEnum["BND"] = 'BND'] = "BND";
        CurrencyEnum[CurrencyEnum["MMK"] = 'MMK'] = "MMK";
        CurrencyEnum[CurrencyEnum["NOK"] = 'NOK'] = "NOK";
        CurrencyEnum[CurrencyEnum["NPR"] = 'NPR'] = "NPR";
        CurrencyEnum[CurrencyEnum["PKR"] = 'PKR'] = "PKR";
        CurrencyEnum[CurrencyEnum["PLN"] = 'PLN'] = "PLN";
        CurrencyEnum[CurrencyEnum["AFN"] = 'AFN'] = "AFN";
        CurrencyEnum[CurrencyEnum["BRL"] = 'BRL'] = "BRL";
        CurrencyEnum[CurrencyEnum["MDL"] = 'MDL'] = "MDL";
        CurrencyEnum[CurrencyEnum["RON"] = 'RON'] = "RON";
        CurrencyEnum[CurrencyEnum["RWF"] = 'RWF'] = "RWF";
        CurrencyEnum[CurrencyEnum["SEK"] = 'SEK'] = "SEK";
        CurrencyEnum[CurrencyEnum["LKR"] = 'LKR'] = "LKR";
        CurrencyEnum[CurrencyEnum["SOS"] = 'SOS'] = "SOS";
        CurrencyEnum[CurrencyEnum["ALL"] = 'ALL'] = "ALL";
        CurrencyEnum[CurrencyEnum["RSD"] = 'RSD'] = "RSD";
        CurrencyEnum[CurrencyEnum["KES"] = 'KES'] = "KES";
        CurrencyEnum[CurrencyEnum["TJS"] = 'TJS'] = "TJS";
        CurrencyEnum[CurrencyEnum["THB"] = 'THB'] = "THB";
        CurrencyEnum[CurrencyEnum["ERN"] = 'ERN'] = "ERN";
        CurrencyEnum[CurrencyEnum["TMT"] = 'TMT'] = "TMT";
        CurrencyEnum[CurrencyEnum["BWP"] = 'BWP'] = "BWP";
        CurrencyEnum[CurrencyEnum["TRY"] = 'TRY'] = "TRY";
        CurrencyEnum[CurrencyEnum["UAH"] = 'UAH'] = "UAH";
        CurrencyEnum[CurrencyEnum["UZS"] = 'UZS'] = "UZS";
        CurrencyEnum[CurrencyEnum["VND"] = 'VND'] = "VND";
        CurrencyEnum[CurrencyEnum["MOP"] = 'MOP'] = "MOP";
        CurrencyEnum[CurrencyEnum["TWD"] = 'TWD'] = "TWD";
        CurrencyEnum[CurrencyEnum["BMD"] = 'BMD'] = "BMD";
    })(CurrencyEnum = StoreGroupBase.CurrencyEnum || (StoreGroupBase.CurrencyEnum = {}));
})(StoreGroupBase || (exports.StoreGroupBase = StoreGroupBase = {}));
var StoreGroupExtended;
(function (StoreGroupExtended) {
    var CurrencyEnum;
    (function (CurrencyEnum) {
        CurrencyEnum[CurrencyEnum["EUR"] = 'EUR'] = "EUR";
        CurrencyEnum[CurrencyEnum["USD"] = 'USD'] = "USD";
        CurrencyEnum[CurrencyEnum["GBP"] = 'GBP'] = "GBP";
        CurrencyEnum[CurrencyEnum["CAD"] = 'CAD'] = "CAD";
        CurrencyEnum[CurrencyEnum["AUD"] = 'AUD'] = "AUD";
        CurrencyEnum[CurrencyEnum["DJF"] = 'DJF'] = "DJF";
        CurrencyEnum[CurrencyEnum["ZAR"] = 'ZAR'] = "ZAR";
        CurrencyEnum[CurrencyEnum["ETB"] = 'ETB'] = "ETB";
        CurrencyEnum[CurrencyEnum["AED"] = 'AED'] = "AED";
        CurrencyEnum[CurrencyEnum["BHD"] = 'BHD'] = "BHD";
        CurrencyEnum[CurrencyEnum["DZD"] = 'DZD'] = "DZD";
        CurrencyEnum[CurrencyEnum["EGP"] = 'EGP'] = "EGP";
        CurrencyEnum[CurrencyEnum["IQD"] = 'IQD'] = "IQD";
        CurrencyEnum[CurrencyEnum["JOD"] = 'JOD'] = "JOD";
        CurrencyEnum[CurrencyEnum["KWD"] = 'KWD'] = "KWD";
        CurrencyEnum[CurrencyEnum["LBP"] = 'LBP'] = "LBP";
        CurrencyEnum[CurrencyEnum["LYD"] = 'LYD'] = "LYD";
        CurrencyEnum[CurrencyEnum["MAD"] = 'MAD'] = "MAD";
        CurrencyEnum[CurrencyEnum["OMR"] = 'OMR'] = "OMR";
        CurrencyEnum[CurrencyEnum["QAR"] = 'QAR'] = "QAR";
        CurrencyEnum[CurrencyEnum["SAR"] = 'SAR'] = "SAR";
        CurrencyEnum[CurrencyEnum["SYP"] = 'SYP'] = "SYP";
        CurrencyEnum[CurrencyEnum["TND"] = 'TND'] = "TND";
        CurrencyEnum[CurrencyEnum["YER"] = 'YER'] = "YER";
        CurrencyEnum[CurrencyEnum["CLP"] = 'CLP'] = "CLP";
        CurrencyEnum[CurrencyEnum["INR"] = 'INR'] = "INR";
        CurrencyEnum[CurrencyEnum["AZN"] = 'AZN'] = "AZN";
        CurrencyEnum[CurrencyEnum["RUB"] = 'RUB'] = "RUB";
        CurrencyEnum[CurrencyEnum["BYN"] = 'BYN'] = "BYN";
        CurrencyEnum[CurrencyEnum["BGN"] = 'BGN'] = "BGN";
        CurrencyEnum[CurrencyEnum["NGN"] = 'NGN'] = "NGN";
        CurrencyEnum[CurrencyEnum["BDT"] = 'BDT'] = "BDT";
        CurrencyEnum[CurrencyEnum["CNY"] = 'CNY'] = "CNY";
        CurrencyEnum[CurrencyEnum["BAM"] = 'BAM'] = "BAM";
        CurrencyEnum[CurrencyEnum["CZK"] = 'CZK'] = "CZK";
        CurrencyEnum[CurrencyEnum["DKK"] = 'DKK'] = "DKK";
        CurrencyEnum[CurrencyEnum["CHF"] = 'CHF'] = "CHF";
        CurrencyEnum[CurrencyEnum["MVR"] = 'MVR'] = "MVR";
        CurrencyEnum[CurrencyEnum["BTN"] = 'BTN'] = "BTN";
        CurrencyEnum[CurrencyEnum["XCD"] = 'XCD'] = "XCD";
        CurrencyEnum[CurrencyEnum["BZD"] = 'BZD'] = "BZD";
        CurrencyEnum[CurrencyEnum["HKD"] = 'HKD'] = "HKD";
        CurrencyEnum[CurrencyEnum["IDR"] = 'IDR'] = "IDR";
        CurrencyEnum[CurrencyEnum["JMD"] = 'JMD'] = "JMD";
        CurrencyEnum[CurrencyEnum["MYR"] = 'MYR'] = "MYR";
        CurrencyEnum[CurrencyEnum["NZD"] = 'NZD'] = "NZD";
        CurrencyEnum[CurrencyEnum["PHP"] = 'PHP'] = "PHP";
        CurrencyEnum[CurrencyEnum["SGD"] = 'SGD'] = "SGD";
        CurrencyEnum[CurrencyEnum["TTD"] = 'TTD'] = "TTD";
        CurrencyEnum[CurrencyEnum["XDR"] = 'XDR'] = "XDR";
        CurrencyEnum[CurrencyEnum["ARS"] = 'ARS'] = "ARS";
        CurrencyEnum[CurrencyEnum["BOB"] = 'BOB'] = "BOB";
        CurrencyEnum[CurrencyEnum["COP"] = 'COP'] = "COP";
        CurrencyEnum[CurrencyEnum["CRC"] = 'CRC'] = "CRC";
        CurrencyEnum[CurrencyEnum["CUP"] = 'CUP'] = "CUP";
        CurrencyEnum[CurrencyEnum["DOP"] = 'DOP'] = "DOP";
        CurrencyEnum[CurrencyEnum["GTQ"] = 'GTQ'] = "GTQ";
        CurrencyEnum[CurrencyEnum["HNL"] = 'HNL'] = "HNL";
        CurrencyEnum[CurrencyEnum["MXN"] = 'MXN'] = "MXN";
        CurrencyEnum[CurrencyEnum["NIO"] = 'NIO'] = "NIO";
        CurrencyEnum[CurrencyEnum["PAB"] = 'PAB'] = "PAB";
        CurrencyEnum[CurrencyEnum["PEN"] = 'PEN'] = "PEN";
        CurrencyEnum[CurrencyEnum["PYG"] = 'PYG'] = "PYG";
        CurrencyEnum[CurrencyEnum["UYU"] = 'UYU'] = "UYU";
        CurrencyEnum[CurrencyEnum["VEF"] = 'VEF'] = "VEF";
        CurrencyEnum[CurrencyEnum["IRR"] = 'IRR'] = "IRR";
        CurrencyEnum[CurrencyEnum["XOF"] = 'XOF'] = "XOF";
        CurrencyEnum[CurrencyEnum["CDF"] = 'CDF'] = "CDF";
        CurrencyEnum[CurrencyEnum["XAF"] = 'XAF'] = "XAF";
        CurrencyEnum[CurrencyEnum["HTG"] = 'HTG'] = "HTG";
        CurrencyEnum[CurrencyEnum["ILS"] = 'ILS'] = "ILS";
        CurrencyEnum[CurrencyEnum["HRK"] = 'HRK'] = "HRK";
        CurrencyEnum[CurrencyEnum["HUF"] = 'HUF'] = "HUF";
        CurrencyEnum[CurrencyEnum["AMD"] = 'AMD'] = "AMD";
        CurrencyEnum[CurrencyEnum["ISK"] = 'ISK'] = "ISK";
        CurrencyEnum[CurrencyEnum["JPY"] = 'JPY'] = "JPY";
        CurrencyEnum[CurrencyEnum["GEL"] = 'GEL'] = "GEL";
        CurrencyEnum[CurrencyEnum["KZT"] = 'KZT'] = "KZT";
        CurrencyEnum[CurrencyEnum["KHR"] = 'KHR'] = "KHR";
        CurrencyEnum[CurrencyEnum["KRW"] = 'KRW'] = "KRW";
        CurrencyEnum[CurrencyEnum["KGS"] = 'KGS'] = "KGS";
        CurrencyEnum[CurrencyEnum["LAK"] = 'LAK'] = "LAK";
        CurrencyEnum[CurrencyEnum["MKD"] = 'MKD'] = "MKD";
        CurrencyEnum[CurrencyEnum["MNT"] = 'MNT'] = "MNT";
        CurrencyEnum[CurrencyEnum["BND"] = 'BND'] = "BND";
        CurrencyEnum[CurrencyEnum["MMK"] = 'MMK'] = "MMK";
        CurrencyEnum[CurrencyEnum["NOK"] = 'NOK'] = "NOK";
        CurrencyEnum[CurrencyEnum["NPR"] = 'NPR'] = "NPR";
        CurrencyEnum[CurrencyEnum["PKR"] = 'PKR'] = "PKR";
        CurrencyEnum[CurrencyEnum["PLN"] = 'PLN'] = "PLN";
        CurrencyEnum[CurrencyEnum["AFN"] = 'AFN'] = "AFN";
        CurrencyEnum[CurrencyEnum["BRL"] = 'BRL'] = "BRL";
        CurrencyEnum[CurrencyEnum["MDL"] = 'MDL'] = "MDL";
        CurrencyEnum[CurrencyEnum["RON"] = 'RON'] = "RON";
        CurrencyEnum[CurrencyEnum["RWF"] = 'RWF'] = "RWF";
        CurrencyEnum[CurrencyEnum["SEK"] = 'SEK'] = "SEK";
        CurrencyEnum[CurrencyEnum["LKR"] = 'LKR'] = "LKR";
        CurrencyEnum[CurrencyEnum["SOS"] = 'SOS'] = "SOS";
        CurrencyEnum[CurrencyEnum["ALL"] = 'ALL'] = "ALL";
        CurrencyEnum[CurrencyEnum["RSD"] = 'RSD'] = "RSD";
        CurrencyEnum[CurrencyEnum["KES"] = 'KES'] = "KES";
        CurrencyEnum[CurrencyEnum["TJS"] = 'TJS'] = "TJS";
        CurrencyEnum[CurrencyEnum["THB"] = 'THB'] = "THB";
        CurrencyEnum[CurrencyEnum["ERN"] = 'ERN'] = "ERN";
        CurrencyEnum[CurrencyEnum["TMT"] = 'TMT'] = "TMT";
        CurrencyEnum[CurrencyEnum["BWP"] = 'BWP'] = "BWP";
        CurrencyEnum[CurrencyEnum["TRY"] = 'TRY'] = "TRY";
        CurrencyEnum[CurrencyEnum["UAH"] = 'UAH'] = "UAH";
        CurrencyEnum[CurrencyEnum["UZS"] = 'UZS'] = "UZS";
        CurrencyEnum[CurrencyEnum["VND"] = 'VND'] = "VND";
        CurrencyEnum[CurrencyEnum["MOP"] = 'MOP'] = "MOP";
        CurrencyEnum[CurrencyEnum["TWD"] = 'TWD'] = "TWD";
        CurrencyEnum[CurrencyEnum["BMD"] = 'BMD'] = "BMD";
    })(CurrencyEnum = StoreGroupExtended.CurrencyEnum || (StoreGroupExtended.CurrencyEnum = {}));
})(StoreGroupExtended || (exports.StoreGroupExtended = StoreGroupExtended = {}));
var StoreOpeningHoursUpdatedEvent;
(function (StoreOpeningHoursUpdatedEvent) {
    var DeliveryTypeEnum;
    (function (DeliveryTypeEnum) {
        DeliveryTypeEnum[DeliveryTypeEnum["Delivery"] = 'Delivery'] = "Delivery";
        DeliveryTypeEnum[DeliveryTypeEnum["Pickup"] = 'Pickup'] = "Pickup";
    })(DeliveryTypeEnum = StoreOpeningHoursUpdatedEvent.DeliveryTypeEnum || (StoreOpeningHoursUpdatedEvent.DeliveryTypeEnum = {}));
    var DeliveryTypeStringEnum;
    (function (DeliveryTypeStringEnum) {
        DeliveryTypeStringEnum[DeliveryTypeStringEnum["Delivery"] = 'Delivery'] = "Delivery";
        DeliveryTypeStringEnum[DeliveryTypeStringEnum["Pickup"] = 'Pickup'] = "Pickup";
    })(DeliveryTypeStringEnum = StoreOpeningHoursUpdatedEvent.DeliveryTypeStringEnum || (StoreOpeningHoursUpdatedEvent.DeliveryTypeStringEnum = {}));
})(StoreOpeningHoursUpdatedEvent || (exports.StoreOpeningHoursUpdatedEvent = StoreOpeningHoursUpdatedEvent = {}));
var StoreOrderCapacityConfig;
(function (StoreOrderCapacityConfig) {
    var DeliveryTypeEnum;
    (function (DeliveryTypeEnum) {
        DeliveryTypeEnum[DeliveryTypeEnum["Delivery"] = 'Delivery'] = "Delivery";
        DeliveryTypeEnum[DeliveryTypeEnum["Pickup"] = 'Pickup'] = "Pickup";
    })(DeliveryTypeEnum = StoreOrderCapacityConfig.DeliveryTypeEnum || (StoreOrderCapacityConfig.DeliveryTypeEnum = {}));
})(StoreOrderCapacityConfig || (exports.StoreOrderCapacityConfig = StoreOrderCapacityConfig = {}));
var StoreOrderCapacityPeriod;
(function (StoreOrderCapacityPeriod) {
    var DayOfTheWeekEnum;
    (function (DayOfTheWeekEnum) {
        DayOfTheWeekEnum[DayOfTheWeekEnum["Sunday"] = 'Sunday'] = "Sunday";
        DayOfTheWeekEnum[DayOfTheWeekEnum["Monday"] = 'Monday'] = "Monday";
        DayOfTheWeekEnum[DayOfTheWeekEnum["Tuesday"] = 'Tuesday'] = "Tuesday";
        DayOfTheWeekEnum[DayOfTheWeekEnum["Wednesday"] = 'Wednesday'] = "Wednesday";
        DayOfTheWeekEnum[DayOfTheWeekEnum["Thursday"] = 'Thursday'] = "Thursday";
        DayOfTheWeekEnum[DayOfTheWeekEnum["Friday"] = 'Friday'] = "Friday";
        DayOfTheWeekEnum[DayOfTheWeekEnum["Saturday"] = 'Saturday'] = "Saturday";
    })(DayOfTheWeekEnum = StoreOrderCapacityPeriod.DayOfTheWeekEnum || (StoreOrderCapacityPeriod.DayOfTheWeekEnum = {}));
})(StoreOrderCapacityPeriod || (exports.StoreOrderCapacityPeriod = StoreOrderCapacityPeriod = {}));
var StoreSummary;
(function (StoreSummary) {
    var CurrencyEnum;
    (function (CurrencyEnum) {
        CurrencyEnum[CurrencyEnum["EUR"] = 'EUR'] = "EUR";
        CurrencyEnum[CurrencyEnum["USD"] = 'USD'] = "USD";
        CurrencyEnum[CurrencyEnum["GBP"] = 'GBP'] = "GBP";
        CurrencyEnum[CurrencyEnum["CAD"] = 'CAD'] = "CAD";
        CurrencyEnum[CurrencyEnum["AUD"] = 'AUD'] = "AUD";
        CurrencyEnum[CurrencyEnum["DJF"] = 'DJF'] = "DJF";
        CurrencyEnum[CurrencyEnum["ZAR"] = 'ZAR'] = "ZAR";
        CurrencyEnum[CurrencyEnum["ETB"] = 'ETB'] = "ETB";
        CurrencyEnum[CurrencyEnum["AED"] = 'AED'] = "AED";
        CurrencyEnum[CurrencyEnum["BHD"] = 'BHD'] = "BHD";
        CurrencyEnum[CurrencyEnum["DZD"] = 'DZD'] = "DZD";
        CurrencyEnum[CurrencyEnum["EGP"] = 'EGP'] = "EGP";
        CurrencyEnum[CurrencyEnum["IQD"] = 'IQD'] = "IQD";
        CurrencyEnum[CurrencyEnum["JOD"] = 'JOD'] = "JOD";
        CurrencyEnum[CurrencyEnum["KWD"] = 'KWD'] = "KWD";
        CurrencyEnum[CurrencyEnum["LBP"] = 'LBP'] = "LBP";
        CurrencyEnum[CurrencyEnum["LYD"] = 'LYD'] = "LYD";
        CurrencyEnum[CurrencyEnum["MAD"] = 'MAD'] = "MAD";
        CurrencyEnum[CurrencyEnum["OMR"] = 'OMR'] = "OMR";
        CurrencyEnum[CurrencyEnum["QAR"] = 'QAR'] = "QAR";
        CurrencyEnum[CurrencyEnum["SAR"] = 'SAR'] = "SAR";
        CurrencyEnum[CurrencyEnum["SYP"] = 'SYP'] = "SYP";
        CurrencyEnum[CurrencyEnum["TND"] = 'TND'] = "TND";
        CurrencyEnum[CurrencyEnum["YER"] = 'YER'] = "YER";
        CurrencyEnum[CurrencyEnum["CLP"] = 'CLP'] = "CLP";
        CurrencyEnum[CurrencyEnum["INR"] = 'INR'] = "INR";
        CurrencyEnum[CurrencyEnum["AZN"] = 'AZN'] = "AZN";
        CurrencyEnum[CurrencyEnum["RUB"] = 'RUB'] = "RUB";
        CurrencyEnum[CurrencyEnum["BYN"] = 'BYN'] = "BYN";
        CurrencyEnum[CurrencyEnum["BGN"] = 'BGN'] = "BGN";
        CurrencyEnum[CurrencyEnum["NGN"] = 'NGN'] = "NGN";
        CurrencyEnum[CurrencyEnum["BDT"] = 'BDT'] = "BDT";
        CurrencyEnum[CurrencyEnum["CNY"] = 'CNY'] = "CNY";
        CurrencyEnum[CurrencyEnum["BAM"] = 'BAM'] = "BAM";
        CurrencyEnum[CurrencyEnum["CZK"] = 'CZK'] = "CZK";
        CurrencyEnum[CurrencyEnum["DKK"] = 'DKK'] = "DKK";
        CurrencyEnum[CurrencyEnum["CHF"] = 'CHF'] = "CHF";
        CurrencyEnum[CurrencyEnum["MVR"] = 'MVR'] = "MVR";
        CurrencyEnum[CurrencyEnum["BTN"] = 'BTN'] = "BTN";
        CurrencyEnum[CurrencyEnum["XCD"] = 'XCD'] = "XCD";
        CurrencyEnum[CurrencyEnum["BZD"] = 'BZD'] = "BZD";
        CurrencyEnum[CurrencyEnum["HKD"] = 'HKD'] = "HKD";
        CurrencyEnum[CurrencyEnum["IDR"] = 'IDR'] = "IDR";
        CurrencyEnum[CurrencyEnum["JMD"] = 'JMD'] = "JMD";
        CurrencyEnum[CurrencyEnum["MYR"] = 'MYR'] = "MYR";
        CurrencyEnum[CurrencyEnum["NZD"] = 'NZD'] = "NZD";
        CurrencyEnum[CurrencyEnum["PHP"] = 'PHP'] = "PHP";
        CurrencyEnum[CurrencyEnum["SGD"] = 'SGD'] = "SGD";
        CurrencyEnum[CurrencyEnum["TTD"] = 'TTD'] = "TTD";
        CurrencyEnum[CurrencyEnum["XDR"] = 'XDR'] = "XDR";
        CurrencyEnum[CurrencyEnum["ARS"] = 'ARS'] = "ARS";
        CurrencyEnum[CurrencyEnum["BOB"] = 'BOB'] = "BOB";
        CurrencyEnum[CurrencyEnum["COP"] = 'COP'] = "COP";
        CurrencyEnum[CurrencyEnum["CRC"] = 'CRC'] = "CRC";
        CurrencyEnum[CurrencyEnum["CUP"] = 'CUP'] = "CUP";
        CurrencyEnum[CurrencyEnum["DOP"] = 'DOP'] = "DOP";
        CurrencyEnum[CurrencyEnum["GTQ"] = 'GTQ'] = "GTQ";
        CurrencyEnum[CurrencyEnum["HNL"] = 'HNL'] = "HNL";
        CurrencyEnum[CurrencyEnum["MXN"] = 'MXN'] = "MXN";
        CurrencyEnum[CurrencyEnum["NIO"] = 'NIO'] = "NIO";
        CurrencyEnum[CurrencyEnum["PAB"] = 'PAB'] = "PAB";
        CurrencyEnum[CurrencyEnum["PEN"] = 'PEN'] = "PEN";
        CurrencyEnum[CurrencyEnum["PYG"] = 'PYG'] = "PYG";
        CurrencyEnum[CurrencyEnum["UYU"] = 'UYU'] = "UYU";
        CurrencyEnum[CurrencyEnum["VEF"] = 'VEF'] = "VEF";
        CurrencyEnum[CurrencyEnum["IRR"] = 'IRR'] = "IRR";
        CurrencyEnum[CurrencyEnum["XOF"] = 'XOF'] = "XOF";
        CurrencyEnum[CurrencyEnum["CDF"] = 'CDF'] = "CDF";
        CurrencyEnum[CurrencyEnum["XAF"] = 'XAF'] = "XAF";
        CurrencyEnum[CurrencyEnum["HTG"] = 'HTG'] = "HTG";
        CurrencyEnum[CurrencyEnum["ILS"] = 'ILS'] = "ILS";
        CurrencyEnum[CurrencyEnum["HRK"] = 'HRK'] = "HRK";
        CurrencyEnum[CurrencyEnum["HUF"] = 'HUF'] = "HUF";
        CurrencyEnum[CurrencyEnum["AMD"] = 'AMD'] = "AMD";
        CurrencyEnum[CurrencyEnum["ISK"] = 'ISK'] = "ISK";
        CurrencyEnum[CurrencyEnum["JPY"] = 'JPY'] = "JPY";
        CurrencyEnum[CurrencyEnum["GEL"] = 'GEL'] = "GEL";
        CurrencyEnum[CurrencyEnum["KZT"] = 'KZT'] = "KZT";
        CurrencyEnum[CurrencyEnum["KHR"] = 'KHR'] = "KHR";
        CurrencyEnum[CurrencyEnum["KRW"] = 'KRW'] = "KRW";
        CurrencyEnum[CurrencyEnum["KGS"] = 'KGS'] = "KGS";
        CurrencyEnum[CurrencyEnum["LAK"] = 'LAK'] = "LAK";
        CurrencyEnum[CurrencyEnum["MKD"] = 'MKD'] = "MKD";
        CurrencyEnum[CurrencyEnum["MNT"] = 'MNT'] = "MNT";
        CurrencyEnum[CurrencyEnum["BND"] = 'BND'] = "BND";
        CurrencyEnum[CurrencyEnum["MMK"] = 'MMK'] = "MMK";
        CurrencyEnum[CurrencyEnum["NOK"] = 'NOK'] = "NOK";
        CurrencyEnum[CurrencyEnum["NPR"] = 'NPR'] = "NPR";
        CurrencyEnum[CurrencyEnum["PKR"] = 'PKR'] = "PKR";
        CurrencyEnum[CurrencyEnum["PLN"] = 'PLN'] = "PLN";
        CurrencyEnum[CurrencyEnum["AFN"] = 'AFN'] = "AFN";
        CurrencyEnum[CurrencyEnum["BRL"] = 'BRL'] = "BRL";
        CurrencyEnum[CurrencyEnum["MDL"] = 'MDL'] = "MDL";
        CurrencyEnum[CurrencyEnum["RON"] = 'RON'] = "RON";
        CurrencyEnum[CurrencyEnum["RWF"] = 'RWF'] = "RWF";
        CurrencyEnum[CurrencyEnum["SEK"] = 'SEK'] = "SEK";
        CurrencyEnum[CurrencyEnum["LKR"] = 'LKR'] = "LKR";
        CurrencyEnum[CurrencyEnum["SOS"] = 'SOS'] = "SOS";
        CurrencyEnum[CurrencyEnum["ALL"] = 'ALL'] = "ALL";
        CurrencyEnum[CurrencyEnum["RSD"] = 'RSD'] = "RSD";
        CurrencyEnum[CurrencyEnum["KES"] = 'KES'] = "KES";
        CurrencyEnum[CurrencyEnum["TJS"] = 'TJS'] = "TJS";
        CurrencyEnum[CurrencyEnum["THB"] = 'THB'] = "THB";
        CurrencyEnum[CurrencyEnum["ERN"] = 'ERN'] = "ERN";
        CurrencyEnum[CurrencyEnum["TMT"] = 'TMT'] = "TMT";
        CurrencyEnum[CurrencyEnum["BWP"] = 'BWP'] = "BWP";
        CurrencyEnum[CurrencyEnum["TRY"] = 'TRY'] = "TRY";
        CurrencyEnum[CurrencyEnum["UAH"] = 'UAH'] = "UAH";
        CurrencyEnum[CurrencyEnum["UZS"] = 'UZS'] = "UZS";
        CurrencyEnum[CurrencyEnum["VND"] = 'VND'] = "VND";
        CurrencyEnum[CurrencyEnum["MOP"] = 'MOP'] = "MOP";
        CurrencyEnum[CurrencyEnum["TWD"] = 'TWD'] = "TWD";
        CurrencyEnum[CurrencyEnum["BMD"] = 'BMD'] = "BMD";
    })(CurrencyEnum = StoreSummary.CurrencyEnum || (StoreSummary.CurrencyEnum = {}));
})(StoreSummary || (exports.StoreSummary = StoreSummary = {}));
var StripeAccountLinkRequest;
(function (StripeAccountLinkRequest) {
    var CollectEnum;
    (function (CollectEnum) {
        CollectEnum[CollectEnum["CurrentlyDue"] = 'CurrentlyDue'] = "CurrentlyDue";
        CollectEnum[CollectEnum["EventuallyDue"] = 'EventuallyDue'] = "EventuallyDue";
    })(CollectEnum = StripeAccountLinkRequest.CollectEnum || (StripeAccountLinkRequest.CollectEnum = {}));
    var TypeEnum;
    (function (TypeEnum) {
        TypeEnum[TypeEnum["Onboarding"] = 'Onboarding'] = "Onboarding";
        TypeEnum[TypeEnum["Update"] = 'Update'] = "Update";
    })(TypeEnum = StripeAccountLinkRequest.TypeEnum || (StripeAccountLinkRequest.TypeEnum = {}));
})(StripeAccountLinkRequest || (exports.StripeAccountLinkRequest = StripeAccountLinkRequest = {}));
var StripeConnectedAccount;
(function (StripeConnectedAccount) {
    var CardPaymentsStatusEnum;
    (function (CardPaymentsStatusEnum) {
        CardPaymentsStatusEnum[CardPaymentsStatusEnum["Inactive"] = 'Inactive'] = "Inactive";
        CardPaymentsStatusEnum[CardPaymentsStatusEnum["Pending"] = 'Pending'] = "Pending";
        CardPaymentsStatusEnum[CardPaymentsStatusEnum["Active"] = 'Active'] = "Active";
        CardPaymentsStatusEnum[CardPaymentsStatusEnum["Unrequested"] = 'Unrequested'] = "Unrequested";
    })(CardPaymentsStatusEnum = StripeConnectedAccount.CardPaymentsStatusEnum || (StripeConnectedAccount.CardPaymentsStatusEnum = {}));
    var TransfersStatusEnum;
    (function (TransfersStatusEnum) {
        TransfersStatusEnum[TransfersStatusEnum["Inactive"] = 'Inactive'] = "Inactive";
        TransfersStatusEnum[TransfersStatusEnum["Pending"] = 'Pending'] = "Pending";
        TransfersStatusEnum[TransfersStatusEnum["Active"] = 'Active'] = "Active";
        TransfersStatusEnum[TransfersStatusEnum["Unrequested"] = 'Unrequested'] = "Unrequested";
    })(TransfersStatusEnum = StripeConnectedAccount.TransfersStatusEnum || (StripeConnectedAccount.TransfersStatusEnum = {}));
    var AccountStatusEnum;
    (function (AccountStatusEnum) {
        AccountStatusEnum[AccountStatusEnum["Disabled"] = 'Disabled'] = "Disabled";
        AccountStatusEnum[AccountStatusEnum["Enabled"] = 'Enabled'] = "Enabled";
        AccountStatusEnum[AccountStatusEnum["AdditionalInformationRequired"] = 'AdditionalInformationRequired'] = "AdditionalInformationRequired";
        AccountStatusEnum[AccountStatusEnum["PendingVerification"] = 'PendingVerification'] = "PendingVerification";
        AccountStatusEnum[AccountStatusEnum["Unverified"] = 'Unverified'] = "Unverified";
        AccountStatusEnum[AccountStatusEnum["Rejected"] = 'Rejected'] = "Rejected";
        AccountStatusEnum[AccountStatusEnum["UpdateExternalAccount"] = 'UpdateExternalAccount'] = "UpdateExternalAccount";
        AccountStatusEnum[AccountStatusEnum["PlatformPaused"] = 'PlatformPaused'] = "PlatformPaused";
    })(AccountStatusEnum = StripeConnectedAccount.AccountStatusEnum || (StripeConnectedAccount.AccountStatusEnum = {}));
})(StripeConnectedAccount || (exports.StripeConnectedAccount = StripeConnectedAccount = {}));
var StripeConnectedAccountInfo;
(function (StripeConnectedAccountInfo) {
    var AccountStatusEnum;
    (function (AccountStatusEnum) {
        AccountStatusEnum[AccountStatusEnum["Disabled"] = 'Disabled'] = "Disabled";
        AccountStatusEnum[AccountStatusEnum["Enabled"] = 'Enabled'] = "Enabled";
        AccountStatusEnum[AccountStatusEnum["AdditionalInformationRequired"] = 'AdditionalInformationRequired'] = "AdditionalInformationRequired";
        AccountStatusEnum[AccountStatusEnum["PendingVerification"] = 'PendingVerification'] = "PendingVerification";
        AccountStatusEnum[AccountStatusEnum["Unverified"] = 'Unverified'] = "Unverified";
        AccountStatusEnum[AccountStatusEnum["Rejected"] = 'Rejected'] = "Rejected";
        AccountStatusEnum[AccountStatusEnum["UpdateExternalAccount"] = 'UpdateExternalAccount'] = "UpdateExternalAccount";
        AccountStatusEnum[AccountStatusEnum["PlatformPaused"] = 'PlatformPaused'] = "PlatformPaused";
    })(AccountStatusEnum = StripeConnectedAccountInfo.AccountStatusEnum || (StripeConnectedAccountInfo.AccountStatusEnum = {}));
    var CardPaymentStatusEnum;
    (function (CardPaymentStatusEnum) {
        CardPaymentStatusEnum[CardPaymentStatusEnum["Inactive"] = 'Inactive'] = "Inactive";
        CardPaymentStatusEnum[CardPaymentStatusEnum["Pending"] = 'Pending'] = "Pending";
        CardPaymentStatusEnum[CardPaymentStatusEnum["Active"] = 'Active'] = "Active";
        CardPaymentStatusEnum[CardPaymentStatusEnum["Unrequested"] = 'Unrequested'] = "Unrequested";
    })(CardPaymentStatusEnum = StripeConnectedAccountInfo.CardPaymentStatusEnum || (StripeConnectedAccountInfo.CardPaymentStatusEnum = {}));
    var PayoutScheduleIntervalEnum;
    (function (PayoutScheduleIntervalEnum) {
        PayoutScheduleIntervalEnum[PayoutScheduleIntervalEnum["Manual"] = 'Manual'] = "Manual";
        PayoutScheduleIntervalEnum[PayoutScheduleIntervalEnum["Daily"] = 'Daily'] = "Daily";
        PayoutScheduleIntervalEnum[PayoutScheduleIntervalEnum["Weekly"] = 'Weekly'] = "Weekly";
        PayoutScheduleIntervalEnum[PayoutScheduleIntervalEnum["Monthly"] = 'Monthly'] = "Monthly";
    })(PayoutScheduleIntervalEnum = StripeConnectedAccountInfo.PayoutScheduleIntervalEnum || (StripeConnectedAccountInfo.PayoutScheduleIntervalEnum = {}));
})(StripeConnectedAccountInfo || (exports.StripeConnectedAccountInfo = StripeConnectedAccountInfo = {}));
var StripeCustomConnectedAccount;
(function (StripeCustomConnectedAccount) {
    var CardPaymentsStatusEnum;
    (function (CardPaymentsStatusEnum) {
        CardPaymentsStatusEnum[CardPaymentsStatusEnum["Inactive"] = 'Inactive'] = "Inactive";
        CardPaymentsStatusEnum[CardPaymentsStatusEnum["Pending"] = 'Pending'] = "Pending";
        CardPaymentsStatusEnum[CardPaymentsStatusEnum["Active"] = 'Active'] = "Active";
        CardPaymentsStatusEnum[CardPaymentsStatusEnum["Unrequested"] = 'Unrequested'] = "Unrequested";
    })(CardPaymentsStatusEnum = StripeCustomConnectedAccount.CardPaymentsStatusEnum || (StripeCustomConnectedAccount.CardPaymentsStatusEnum = {}));
    var TransfersStatusEnum;
    (function (TransfersStatusEnum) {
        TransfersStatusEnum[TransfersStatusEnum["Inactive"] = 'Inactive'] = "Inactive";
        TransfersStatusEnum[TransfersStatusEnum["Pending"] = 'Pending'] = "Pending";
        TransfersStatusEnum[TransfersStatusEnum["Active"] = 'Active'] = "Active";
        TransfersStatusEnum[TransfersStatusEnum["Unrequested"] = 'Unrequested'] = "Unrequested";
    })(TransfersStatusEnum = StripeCustomConnectedAccount.TransfersStatusEnum || (StripeCustomConnectedAccount.TransfersStatusEnum = {}));
    var AccountStatusEnum;
    (function (AccountStatusEnum) {
        AccountStatusEnum[AccountStatusEnum["Disabled"] = 'Disabled'] = "Disabled";
        AccountStatusEnum[AccountStatusEnum["Enabled"] = 'Enabled'] = "Enabled";
        AccountStatusEnum[AccountStatusEnum["AdditionalInformationRequired"] = 'AdditionalInformationRequired'] = "AdditionalInformationRequired";
        AccountStatusEnum[AccountStatusEnum["PendingVerification"] = 'PendingVerification'] = "PendingVerification";
        AccountStatusEnum[AccountStatusEnum["Unverified"] = 'Unverified'] = "Unverified";
        AccountStatusEnum[AccountStatusEnum["Rejected"] = 'Rejected'] = "Rejected";
        AccountStatusEnum[AccountStatusEnum["UpdateExternalAccount"] = 'UpdateExternalAccount'] = "UpdateExternalAccount";
        AccountStatusEnum[AccountStatusEnum["PlatformPaused"] = 'PlatformPaused'] = "PlatformPaused";
    })(AccountStatusEnum = StripeCustomConnectedAccount.AccountStatusEnum || (StripeCustomConnectedAccount.AccountStatusEnum = {}));
})(StripeCustomConnectedAccount || (exports.StripeCustomConnectedAccount = StripeCustomConnectedAccount = {}));
var StuartSettings;
(function (StuartSettings) {
    var PackageTypeEnum;
    (function (PackageTypeEnum) {
        PackageTypeEnum[PackageTypeEnum["Xsmall"] = 'Xsmall'] = "Xsmall";
        PackageTypeEnum[PackageTypeEnum["Small"] = 'Small'] = "Small";
        PackageTypeEnum[PackageTypeEnum["Medium"] = 'Medium'] = "Medium";
        PackageTypeEnum[PackageTypeEnum["Large"] = 'Large'] = "Large";
        PackageTypeEnum[PackageTypeEnum["Xlarge"] = 'Xlarge'] = "Xlarge";
    })(PackageTypeEnum = StuartSettings.PackageTypeEnum || (StuartSettings.PackageTypeEnum = {}));
    var TransportTypeEnum;
    (function (TransportTypeEnum) {
        TransportTypeEnum[TransportTypeEnum["Bike"] = 'Bike'] = "Bike";
        TransportTypeEnum[TransportTypeEnum["Cargobike"] = 'Cargobike'] = "Cargobike";
        TransportTypeEnum[TransportTypeEnum["Cargobikexl"] = 'Cargobikexl'] = "Cargobikexl";
        TransportTypeEnum[TransportTypeEnum["Motorbike"] = 'Motorbike'] = "Motorbike";
        TransportTypeEnum[TransportTypeEnum["Motorbikexl"] = 'Motorbikexl'] = "Motorbikexl";
        TransportTypeEnum[TransportTypeEnum["Car"] = 'Car'] = "Car";
        TransportTypeEnum[TransportTypeEnum["Van"] = 'Van'] = "Van";
    })(TransportTypeEnum = StuartSettings.TransportTypeEnum || (StuartSettings.TransportTypeEnum = {}));
})(StuartSettings || (exports.StuartSettings = StuartSettings = {}));
var Subscription;
(function (Subscription) {
    var StatusEnum;
    (function (StatusEnum) {
        StatusEnum[StatusEnum["Incomplete"] = 'Incomplete'] = "Incomplete";
        StatusEnum[StatusEnum["IncompleteExpired"] = 'IncompleteExpired'] = "IncompleteExpired";
        StatusEnum[StatusEnum["Trialing"] = 'Trialing'] = "Trialing";
        StatusEnum[StatusEnum["Active"] = 'Active'] = "Active";
        StatusEnum[StatusEnum["PastDue"] = 'PastDue'] = "PastDue";
        StatusEnum[StatusEnum["Canceled"] = 'Canceled'] = "Canceled";
        StatusEnum[StatusEnum["Unpaid"] = 'Unpaid'] = "Unpaid";
    })(StatusEnum = Subscription.StatusEnum || (Subscription.StatusEnum = {}));
    var CurrencyEnum;
    (function (CurrencyEnum) {
        CurrencyEnum[CurrencyEnum["EUR"] = 'EUR'] = "EUR";
        CurrencyEnum[CurrencyEnum["USD"] = 'USD'] = "USD";
        CurrencyEnum[CurrencyEnum["GBP"] = 'GBP'] = "GBP";
        CurrencyEnum[CurrencyEnum["CAD"] = 'CAD'] = "CAD";
        CurrencyEnum[CurrencyEnum["AUD"] = 'AUD'] = "AUD";
        CurrencyEnum[CurrencyEnum["DJF"] = 'DJF'] = "DJF";
        CurrencyEnum[CurrencyEnum["ZAR"] = 'ZAR'] = "ZAR";
        CurrencyEnum[CurrencyEnum["ETB"] = 'ETB'] = "ETB";
        CurrencyEnum[CurrencyEnum["AED"] = 'AED'] = "AED";
        CurrencyEnum[CurrencyEnum["BHD"] = 'BHD'] = "BHD";
        CurrencyEnum[CurrencyEnum["DZD"] = 'DZD'] = "DZD";
        CurrencyEnum[CurrencyEnum["EGP"] = 'EGP'] = "EGP";
        CurrencyEnum[CurrencyEnum["IQD"] = 'IQD'] = "IQD";
        CurrencyEnum[CurrencyEnum["JOD"] = 'JOD'] = "JOD";
        CurrencyEnum[CurrencyEnum["KWD"] = 'KWD'] = "KWD";
        CurrencyEnum[CurrencyEnum["LBP"] = 'LBP'] = "LBP";
        CurrencyEnum[CurrencyEnum["LYD"] = 'LYD'] = "LYD";
        CurrencyEnum[CurrencyEnum["MAD"] = 'MAD'] = "MAD";
        CurrencyEnum[CurrencyEnum["OMR"] = 'OMR'] = "OMR";
        CurrencyEnum[CurrencyEnum["QAR"] = 'QAR'] = "QAR";
        CurrencyEnum[CurrencyEnum["SAR"] = 'SAR'] = "SAR";
        CurrencyEnum[CurrencyEnum["SYP"] = 'SYP'] = "SYP";
        CurrencyEnum[CurrencyEnum["TND"] = 'TND'] = "TND";
        CurrencyEnum[CurrencyEnum["YER"] = 'YER'] = "YER";
        CurrencyEnum[CurrencyEnum["CLP"] = 'CLP'] = "CLP";
        CurrencyEnum[CurrencyEnum["INR"] = 'INR'] = "INR";
        CurrencyEnum[CurrencyEnum["AZN"] = 'AZN'] = "AZN";
        CurrencyEnum[CurrencyEnum["RUB"] = 'RUB'] = "RUB";
        CurrencyEnum[CurrencyEnum["BYN"] = 'BYN'] = "BYN";
        CurrencyEnum[CurrencyEnum["BGN"] = 'BGN'] = "BGN";
        CurrencyEnum[CurrencyEnum["NGN"] = 'NGN'] = "NGN";
        CurrencyEnum[CurrencyEnum["BDT"] = 'BDT'] = "BDT";
        CurrencyEnum[CurrencyEnum["CNY"] = 'CNY'] = "CNY";
        CurrencyEnum[CurrencyEnum["BAM"] = 'BAM'] = "BAM";
        CurrencyEnum[CurrencyEnum["CZK"] = 'CZK'] = "CZK";
        CurrencyEnum[CurrencyEnum["DKK"] = 'DKK'] = "DKK";
        CurrencyEnum[CurrencyEnum["CHF"] = 'CHF'] = "CHF";
        CurrencyEnum[CurrencyEnum["MVR"] = 'MVR'] = "MVR";
        CurrencyEnum[CurrencyEnum["BTN"] = 'BTN'] = "BTN";
        CurrencyEnum[CurrencyEnum["XCD"] = 'XCD'] = "XCD";
        CurrencyEnum[CurrencyEnum["BZD"] = 'BZD'] = "BZD";
        CurrencyEnum[CurrencyEnum["HKD"] = 'HKD'] = "HKD";
        CurrencyEnum[CurrencyEnum["IDR"] = 'IDR'] = "IDR";
        CurrencyEnum[CurrencyEnum["JMD"] = 'JMD'] = "JMD";
        CurrencyEnum[CurrencyEnum["MYR"] = 'MYR'] = "MYR";
        CurrencyEnum[CurrencyEnum["NZD"] = 'NZD'] = "NZD";
        CurrencyEnum[CurrencyEnum["PHP"] = 'PHP'] = "PHP";
        CurrencyEnum[CurrencyEnum["SGD"] = 'SGD'] = "SGD";
        CurrencyEnum[CurrencyEnum["TTD"] = 'TTD'] = "TTD";
        CurrencyEnum[CurrencyEnum["XDR"] = 'XDR'] = "XDR";
        CurrencyEnum[CurrencyEnum["ARS"] = 'ARS'] = "ARS";
        CurrencyEnum[CurrencyEnum["BOB"] = 'BOB'] = "BOB";
        CurrencyEnum[CurrencyEnum["COP"] = 'COP'] = "COP";
        CurrencyEnum[CurrencyEnum["CRC"] = 'CRC'] = "CRC";
        CurrencyEnum[CurrencyEnum["CUP"] = 'CUP'] = "CUP";
        CurrencyEnum[CurrencyEnum["DOP"] = 'DOP'] = "DOP";
        CurrencyEnum[CurrencyEnum["GTQ"] = 'GTQ'] = "GTQ";
        CurrencyEnum[CurrencyEnum["HNL"] = 'HNL'] = "HNL";
        CurrencyEnum[CurrencyEnum["MXN"] = 'MXN'] = "MXN";
        CurrencyEnum[CurrencyEnum["NIO"] = 'NIO'] = "NIO";
        CurrencyEnum[CurrencyEnum["PAB"] = 'PAB'] = "PAB";
        CurrencyEnum[CurrencyEnum["PEN"] = 'PEN'] = "PEN";
        CurrencyEnum[CurrencyEnum["PYG"] = 'PYG'] = "PYG";
        CurrencyEnum[CurrencyEnum["UYU"] = 'UYU'] = "UYU";
        CurrencyEnum[CurrencyEnum["VEF"] = 'VEF'] = "VEF";
        CurrencyEnum[CurrencyEnum["IRR"] = 'IRR'] = "IRR";
        CurrencyEnum[CurrencyEnum["XOF"] = 'XOF'] = "XOF";
        CurrencyEnum[CurrencyEnum["CDF"] = 'CDF'] = "CDF";
        CurrencyEnum[CurrencyEnum["XAF"] = 'XAF'] = "XAF";
        CurrencyEnum[CurrencyEnum["HTG"] = 'HTG'] = "HTG";
        CurrencyEnum[CurrencyEnum["ILS"] = 'ILS'] = "ILS";
        CurrencyEnum[CurrencyEnum["HRK"] = 'HRK'] = "HRK";
        CurrencyEnum[CurrencyEnum["HUF"] = 'HUF'] = "HUF";
        CurrencyEnum[CurrencyEnum["AMD"] = 'AMD'] = "AMD";
        CurrencyEnum[CurrencyEnum["ISK"] = 'ISK'] = "ISK";
        CurrencyEnum[CurrencyEnum["JPY"] = 'JPY'] = "JPY";
        CurrencyEnum[CurrencyEnum["GEL"] = 'GEL'] = "GEL";
        CurrencyEnum[CurrencyEnum["KZT"] = 'KZT'] = "KZT";
        CurrencyEnum[CurrencyEnum["KHR"] = 'KHR'] = "KHR";
        CurrencyEnum[CurrencyEnum["KRW"] = 'KRW'] = "KRW";
        CurrencyEnum[CurrencyEnum["KGS"] = 'KGS'] = "KGS";
        CurrencyEnum[CurrencyEnum["LAK"] = 'LAK'] = "LAK";
        CurrencyEnum[CurrencyEnum["MKD"] = 'MKD'] = "MKD";
        CurrencyEnum[CurrencyEnum["MNT"] = 'MNT'] = "MNT";
        CurrencyEnum[CurrencyEnum["BND"] = 'BND'] = "BND";
        CurrencyEnum[CurrencyEnum["MMK"] = 'MMK'] = "MMK";
        CurrencyEnum[CurrencyEnum["NOK"] = 'NOK'] = "NOK";
        CurrencyEnum[CurrencyEnum["NPR"] = 'NPR'] = "NPR";
        CurrencyEnum[CurrencyEnum["PKR"] = 'PKR'] = "PKR";
        CurrencyEnum[CurrencyEnum["PLN"] = 'PLN'] = "PLN";
        CurrencyEnum[CurrencyEnum["AFN"] = 'AFN'] = "AFN";
        CurrencyEnum[CurrencyEnum["BRL"] = 'BRL'] = "BRL";
        CurrencyEnum[CurrencyEnum["MDL"] = 'MDL'] = "MDL";
        CurrencyEnum[CurrencyEnum["RON"] = 'RON'] = "RON";
        CurrencyEnum[CurrencyEnum["RWF"] = 'RWF'] = "RWF";
        CurrencyEnum[CurrencyEnum["SEK"] = 'SEK'] = "SEK";
        CurrencyEnum[CurrencyEnum["LKR"] = 'LKR'] = "LKR";
        CurrencyEnum[CurrencyEnum["SOS"] = 'SOS'] = "SOS";
        CurrencyEnum[CurrencyEnum["ALL"] = 'ALL'] = "ALL";
        CurrencyEnum[CurrencyEnum["RSD"] = 'RSD'] = "RSD";
        CurrencyEnum[CurrencyEnum["KES"] = 'KES'] = "KES";
        CurrencyEnum[CurrencyEnum["TJS"] = 'TJS'] = "TJS";
        CurrencyEnum[CurrencyEnum["THB"] = 'THB'] = "THB";
        CurrencyEnum[CurrencyEnum["ERN"] = 'ERN'] = "ERN";
        CurrencyEnum[CurrencyEnum["TMT"] = 'TMT'] = "TMT";
        CurrencyEnum[CurrencyEnum["BWP"] = 'BWP'] = "BWP";
        CurrencyEnum[CurrencyEnum["TRY"] = 'TRY'] = "TRY";
        CurrencyEnum[CurrencyEnum["UAH"] = 'UAH'] = "UAH";
        CurrencyEnum[CurrencyEnum["UZS"] = 'UZS'] = "UZS";
        CurrencyEnum[CurrencyEnum["VND"] = 'VND'] = "VND";
        CurrencyEnum[CurrencyEnum["MOP"] = 'MOP'] = "MOP";
        CurrencyEnum[CurrencyEnum["TWD"] = 'TWD'] = "TWD";
        CurrencyEnum[CurrencyEnum["BMD"] = 'BMD'] = "BMD";
    })(CurrencyEnum = Subscription.CurrencyEnum || (Subscription.CurrencyEnum = {}));
})(Subscription || (exports.Subscription = Subscription = {}));
var SubscriptionInvoice;
(function (SubscriptionInvoice) {
    var CurrencyEnum;
    (function (CurrencyEnum) {
        CurrencyEnum[CurrencyEnum["EUR"] = 'EUR'] = "EUR";
        CurrencyEnum[CurrencyEnum["USD"] = 'USD'] = "USD";
        CurrencyEnum[CurrencyEnum["GBP"] = 'GBP'] = "GBP";
        CurrencyEnum[CurrencyEnum["CAD"] = 'CAD'] = "CAD";
        CurrencyEnum[CurrencyEnum["AUD"] = 'AUD'] = "AUD";
        CurrencyEnum[CurrencyEnum["DJF"] = 'DJF'] = "DJF";
        CurrencyEnum[CurrencyEnum["ZAR"] = 'ZAR'] = "ZAR";
        CurrencyEnum[CurrencyEnum["ETB"] = 'ETB'] = "ETB";
        CurrencyEnum[CurrencyEnum["AED"] = 'AED'] = "AED";
        CurrencyEnum[CurrencyEnum["BHD"] = 'BHD'] = "BHD";
        CurrencyEnum[CurrencyEnum["DZD"] = 'DZD'] = "DZD";
        CurrencyEnum[CurrencyEnum["EGP"] = 'EGP'] = "EGP";
        CurrencyEnum[CurrencyEnum["IQD"] = 'IQD'] = "IQD";
        CurrencyEnum[CurrencyEnum["JOD"] = 'JOD'] = "JOD";
        CurrencyEnum[CurrencyEnum["KWD"] = 'KWD'] = "KWD";
        CurrencyEnum[CurrencyEnum["LBP"] = 'LBP'] = "LBP";
        CurrencyEnum[CurrencyEnum["LYD"] = 'LYD'] = "LYD";
        CurrencyEnum[CurrencyEnum["MAD"] = 'MAD'] = "MAD";
        CurrencyEnum[CurrencyEnum["OMR"] = 'OMR'] = "OMR";
        CurrencyEnum[CurrencyEnum["QAR"] = 'QAR'] = "QAR";
        CurrencyEnum[CurrencyEnum["SAR"] = 'SAR'] = "SAR";
        CurrencyEnum[CurrencyEnum["SYP"] = 'SYP'] = "SYP";
        CurrencyEnum[CurrencyEnum["TND"] = 'TND'] = "TND";
        CurrencyEnum[CurrencyEnum["YER"] = 'YER'] = "YER";
        CurrencyEnum[CurrencyEnum["CLP"] = 'CLP'] = "CLP";
        CurrencyEnum[CurrencyEnum["INR"] = 'INR'] = "INR";
        CurrencyEnum[CurrencyEnum["AZN"] = 'AZN'] = "AZN";
        CurrencyEnum[CurrencyEnum["RUB"] = 'RUB'] = "RUB";
        CurrencyEnum[CurrencyEnum["BYN"] = 'BYN'] = "BYN";
        CurrencyEnum[CurrencyEnum["BGN"] = 'BGN'] = "BGN";
        CurrencyEnum[CurrencyEnum["NGN"] = 'NGN'] = "NGN";
        CurrencyEnum[CurrencyEnum["BDT"] = 'BDT'] = "BDT";
        CurrencyEnum[CurrencyEnum["CNY"] = 'CNY'] = "CNY";
        CurrencyEnum[CurrencyEnum["BAM"] = 'BAM'] = "BAM";
        CurrencyEnum[CurrencyEnum["CZK"] = 'CZK'] = "CZK";
        CurrencyEnum[CurrencyEnum["DKK"] = 'DKK'] = "DKK";
        CurrencyEnum[CurrencyEnum["CHF"] = 'CHF'] = "CHF";
        CurrencyEnum[CurrencyEnum["MVR"] = 'MVR'] = "MVR";
        CurrencyEnum[CurrencyEnum["BTN"] = 'BTN'] = "BTN";
        CurrencyEnum[CurrencyEnum["XCD"] = 'XCD'] = "XCD";
        CurrencyEnum[CurrencyEnum["BZD"] = 'BZD'] = "BZD";
        CurrencyEnum[CurrencyEnum["HKD"] = 'HKD'] = "HKD";
        CurrencyEnum[CurrencyEnum["IDR"] = 'IDR'] = "IDR";
        CurrencyEnum[CurrencyEnum["JMD"] = 'JMD'] = "JMD";
        CurrencyEnum[CurrencyEnum["MYR"] = 'MYR'] = "MYR";
        CurrencyEnum[CurrencyEnum["NZD"] = 'NZD'] = "NZD";
        CurrencyEnum[CurrencyEnum["PHP"] = 'PHP'] = "PHP";
        CurrencyEnum[CurrencyEnum["SGD"] = 'SGD'] = "SGD";
        CurrencyEnum[CurrencyEnum["TTD"] = 'TTD'] = "TTD";
        CurrencyEnum[CurrencyEnum["XDR"] = 'XDR'] = "XDR";
        CurrencyEnum[CurrencyEnum["ARS"] = 'ARS'] = "ARS";
        CurrencyEnum[CurrencyEnum["BOB"] = 'BOB'] = "BOB";
        CurrencyEnum[CurrencyEnum["COP"] = 'COP'] = "COP";
        CurrencyEnum[CurrencyEnum["CRC"] = 'CRC'] = "CRC";
        CurrencyEnum[CurrencyEnum["CUP"] = 'CUP'] = "CUP";
        CurrencyEnum[CurrencyEnum["DOP"] = 'DOP'] = "DOP";
        CurrencyEnum[CurrencyEnum["GTQ"] = 'GTQ'] = "GTQ";
        CurrencyEnum[CurrencyEnum["HNL"] = 'HNL'] = "HNL";
        CurrencyEnum[CurrencyEnum["MXN"] = 'MXN'] = "MXN";
        CurrencyEnum[CurrencyEnum["NIO"] = 'NIO'] = "NIO";
        CurrencyEnum[CurrencyEnum["PAB"] = 'PAB'] = "PAB";
        CurrencyEnum[CurrencyEnum["PEN"] = 'PEN'] = "PEN";
        CurrencyEnum[CurrencyEnum["PYG"] = 'PYG'] = "PYG";
        CurrencyEnum[CurrencyEnum["UYU"] = 'UYU'] = "UYU";
        CurrencyEnum[CurrencyEnum["VEF"] = 'VEF'] = "VEF";
        CurrencyEnum[CurrencyEnum["IRR"] = 'IRR'] = "IRR";
        CurrencyEnum[CurrencyEnum["XOF"] = 'XOF'] = "XOF";
        CurrencyEnum[CurrencyEnum["CDF"] = 'CDF'] = "CDF";
        CurrencyEnum[CurrencyEnum["XAF"] = 'XAF'] = "XAF";
        CurrencyEnum[CurrencyEnum["HTG"] = 'HTG'] = "HTG";
        CurrencyEnum[CurrencyEnum["ILS"] = 'ILS'] = "ILS";
        CurrencyEnum[CurrencyEnum["HRK"] = 'HRK'] = "HRK";
        CurrencyEnum[CurrencyEnum["HUF"] = 'HUF'] = "HUF";
        CurrencyEnum[CurrencyEnum["AMD"] = 'AMD'] = "AMD";
        CurrencyEnum[CurrencyEnum["ISK"] = 'ISK'] = "ISK";
        CurrencyEnum[CurrencyEnum["JPY"] = 'JPY'] = "JPY";
        CurrencyEnum[CurrencyEnum["GEL"] = 'GEL'] = "GEL";
        CurrencyEnum[CurrencyEnum["KZT"] = 'KZT'] = "KZT";
        CurrencyEnum[CurrencyEnum["KHR"] = 'KHR'] = "KHR";
        CurrencyEnum[CurrencyEnum["KRW"] = 'KRW'] = "KRW";
        CurrencyEnum[CurrencyEnum["KGS"] = 'KGS'] = "KGS";
        CurrencyEnum[CurrencyEnum["LAK"] = 'LAK'] = "LAK";
        CurrencyEnum[CurrencyEnum["MKD"] = 'MKD'] = "MKD";
        CurrencyEnum[CurrencyEnum["MNT"] = 'MNT'] = "MNT";
        CurrencyEnum[CurrencyEnum["BND"] = 'BND'] = "BND";
        CurrencyEnum[CurrencyEnum["MMK"] = 'MMK'] = "MMK";
        CurrencyEnum[CurrencyEnum["NOK"] = 'NOK'] = "NOK";
        CurrencyEnum[CurrencyEnum["NPR"] = 'NPR'] = "NPR";
        CurrencyEnum[CurrencyEnum["PKR"] = 'PKR'] = "PKR";
        CurrencyEnum[CurrencyEnum["PLN"] = 'PLN'] = "PLN";
        CurrencyEnum[CurrencyEnum["AFN"] = 'AFN'] = "AFN";
        CurrencyEnum[CurrencyEnum["BRL"] = 'BRL'] = "BRL";
        CurrencyEnum[CurrencyEnum["MDL"] = 'MDL'] = "MDL";
        CurrencyEnum[CurrencyEnum["RON"] = 'RON'] = "RON";
        CurrencyEnum[CurrencyEnum["RWF"] = 'RWF'] = "RWF";
        CurrencyEnum[CurrencyEnum["SEK"] = 'SEK'] = "SEK";
        CurrencyEnum[CurrencyEnum["LKR"] = 'LKR'] = "LKR";
        CurrencyEnum[CurrencyEnum["SOS"] = 'SOS'] = "SOS";
        CurrencyEnum[CurrencyEnum["ALL"] = 'ALL'] = "ALL";
        CurrencyEnum[CurrencyEnum["RSD"] = 'RSD'] = "RSD";
        CurrencyEnum[CurrencyEnum["KES"] = 'KES'] = "KES";
        CurrencyEnum[CurrencyEnum["TJS"] = 'TJS'] = "TJS";
        CurrencyEnum[CurrencyEnum["THB"] = 'THB'] = "THB";
        CurrencyEnum[CurrencyEnum["ERN"] = 'ERN'] = "ERN";
        CurrencyEnum[CurrencyEnum["TMT"] = 'TMT'] = "TMT";
        CurrencyEnum[CurrencyEnum["BWP"] = 'BWP'] = "BWP";
        CurrencyEnum[CurrencyEnum["TRY"] = 'TRY'] = "TRY";
        CurrencyEnum[CurrencyEnum["UAH"] = 'UAH'] = "UAH";
        CurrencyEnum[CurrencyEnum["UZS"] = 'UZS'] = "UZS";
        CurrencyEnum[CurrencyEnum["VND"] = 'VND'] = "VND";
        CurrencyEnum[CurrencyEnum["MOP"] = 'MOP'] = "MOP";
        CurrencyEnum[CurrencyEnum["TWD"] = 'TWD'] = "TWD";
        CurrencyEnum[CurrencyEnum["BMD"] = 'BMD'] = "BMD";
    })(CurrencyEnum = SubscriptionInvoice.CurrencyEnum || (SubscriptionInvoice.CurrencyEnum = {}));
    var StatusEnum;
    (function (StatusEnum) {
        StatusEnum[StatusEnum["Draft"] = 'Draft'] = "Draft";
        StatusEnum[StatusEnum["Open"] = 'Open'] = "Open";
        StatusEnum[StatusEnum["Paid"] = 'Paid'] = "Paid";
        StatusEnum[StatusEnum["UnCollectible"] = 'UnCollectible'] = "UnCollectible";
        StatusEnum[StatusEnum["Void"] = 'Void'] = "Void";
    })(StatusEnum = SubscriptionInvoice.StatusEnum || (SubscriptionInvoice.StatusEnum = {}));
})(SubscriptionInvoice || (exports.SubscriptionInvoice = SubscriptionInvoice = {}));
var SubscriptionProduct;
(function (SubscriptionProduct) {
    var PaymentFrequencyEnum;
    (function (PaymentFrequencyEnum) {
        PaymentFrequencyEnum[PaymentFrequencyEnum["Day"] = 'day'] = "Day";
        PaymentFrequencyEnum[PaymentFrequencyEnum["Week"] = 'week'] = "Week";
        PaymentFrequencyEnum[PaymentFrequencyEnum["Month"] = 'month'] = "Month";
        PaymentFrequencyEnum[PaymentFrequencyEnum["Year"] = 'year'] = "Year";
    })(PaymentFrequencyEnum = SubscriptionProduct.PaymentFrequencyEnum || (SubscriptionProduct.PaymentFrequencyEnum = {}));
})(SubscriptionProduct || (exports.SubscriptionProduct = SubscriptionProduct = {}));
var SubscriptionSummary;
(function (SubscriptionSummary) {
    var StatusEnum;
    (function (StatusEnum) {
        StatusEnum[StatusEnum["Incomplete"] = 'Incomplete'] = "Incomplete";
        StatusEnum[StatusEnum["IncompleteExpired"] = 'IncompleteExpired'] = "IncompleteExpired";
        StatusEnum[StatusEnum["Trialing"] = 'Trialing'] = "Trialing";
        StatusEnum[StatusEnum["Active"] = 'Active'] = "Active";
        StatusEnum[StatusEnum["PastDue"] = 'PastDue'] = "PastDue";
        StatusEnum[StatusEnum["Canceled"] = 'Canceled'] = "Canceled";
        StatusEnum[StatusEnum["Unpaid"] = 'Unpaid'] = "Unpaid";
    })(StatusEnum = SubscriptionSummary.StatusEnum || (SubscriptionSummary.StatusEnum = {}));
    var CurrencyEnum;
    (function (CurrencyEnum) {
        CurrencyEnum[CurrencyEnum["EUR"] = 'EUR'] = "EUR";
        CurrencyEnum[CurrencyEnum["USD"] = 'USD'] = "USD";
        CurrencyEnum[CurrencyEnum["GBP"] = 'GBP'] = "GBP";
        CurrencyEnum[CurrencyEnum["CAD"] = 'CAD'] = "CAD";
        CurrencyEnum[CurrencyEnum["AUD"] = 'AUD'] = "AUD";
        CurrencyEnum[CurrencyEnum["DJF"] = 'DJF'] = "DJF";
        CurrencyEnum[CurrencyEnum["ZAR"] = 'ZAR'] = "ZAR";
        CurrencyEnum[CurrencyEnum["ETB"] = 'ETB'] = "ETB";
        CurrencyEnum[CurrencyEnum["AED"] = 'AED'] = "AED";
        CurrencyEnum[CurrencyEnum["BHD"] = 'BHD'] = "BHD";
        CurrencyEnum[CurrencyEnum["DZD"] = 'DZD'] = "DZD";
        CurrencyEnum[CurrencyEnum["EGP"] = 'EGP'] = "EGP";
        CurrencyEnum[CurrencyEnum["IQD"] = 'IQD'] = "IQD";
        CurrencyEnum[CurrencyEnum["JOD"] = 'JOD'] = "JOD";
        CurrencyEnum[CurrencyEnum["KWD"] = 'KWD'] = "KWD";
        CurrencyEnum[CurrencyEnum["LBP"] = 'LBP'] = "LBP";
        CurrencyEnum[CurrencyEnum["LYD"] = 'LYD'] = "LYD";
        CurrencyEnum[CurrencyEnum["MAD"] = 'MAD'] = "MAD";
        CurrencyEnum[CurrencyEnum["OMR"] = 'OMR'] = "OMR";
        CurrencyEnum[CurrencyEnum["QAR"] = 'QAR'] = "QAR";
        CurrencyEnum[CurrencyEnum["SAR"] = 'SAR'] = "SAR";
        CurrencyEnum[CurrencyEnum["SYP"] = 'SYP'] = "SYP";
        CurrencyEnum[CurrencyEnum["TND"] = 'TND'] = "TND";
        CurrencyEnum[CurrencyEnum["YER"] = 'YER'] = "YER";
        CurrencyEnum[CurrencyEnum["CLP"] = 'CLP'] = "CLP";
        CurrencyEnum[CurrencyEnum["INR"] = 'INR'] = "INR";
        CurrencyEnum[CurrencyEnum["AZN"] = 'AZN'] = "AZN";
        CurrencyEnum[CurrencyEnum["RUB"] = 'RUB'] = "RUB";
        CurrencyEnum[CurrencyEnum["BYN"] = 'BYN'] = "BYN";
        CurrencyEnum[CurrencyEnum["BGN"] = 'BGN'] = "BGN";
        CurrencyEnum[CurrencyEnum["NGN"] = 'NGN'] = "NGN";
        CurrencyEnum[CurrencyEnum["BDT"] = 'BDT'] = "BDT";
        CurrencyEnum[CurrencyEnum["CNY"] = 'CNY'] = "CNY";
        CurrencyEnum[CurrencyEnum["BAM"] = 'BAM'] = "BAM";
        CurrencyEnum[CurrencyEnum["CZK"] = 'CZK'] = "CZK";
        CurrencyEnum[CurrencyEnum["DKK"] = 'DKK'] = "DKK";
        CurrencyEnum[CurrencyEnum["CHF"] = 'CHF'] = "CHF";
        CurrencyEnum[CurrencyEnum["MVR"] = 'MVR'] = "MVR";
        CurrencyEnum[CurrencyEnum["BTN"] = 'BTN'] = "BTN";
        CurrencyEnum[CurrencyEnum["XCD"] = 'XCD'] = "XCD";
        CurrencyEnum[CurrencyEnum["BZD"] = 'BZD'] = "BZD";
        CurrencyEnum[CurrencyEnum["HKD"] = 'HKD'] = "HKD";
        CurrencyEnum[CurrencyEnum["IDR"] = 'IDR'] = "IDR";
        CurrencyEnum[CurrencyEnum["JMD"] = 'JMD'] = "JMD";
        CurrencyEnum[CurrencyEnum["MYR"] = 'MYR'] = "MYR";
        CurrencyEnum[CurrencyEnum["NZD"] = 'NZD'] = "NZD";
        CurrencyEnum[CurrencyEnum["PHP"] = 'PHP'] = "PHP";
        CurrencyEnum[CurrencyEnum["SGD"] = 'SGD'] = "SGD";
        CurrencyEnum[CurrencyEnum["TTD"] = 'TTD'] = "TTD";
        CurrencyEnum[CurrencyEnum["XDR"] = 'XDR'] = "XDR";
        CurrencyEnum[CurrencyEnum["ARS"] = 'ARS'] = "ARS";
        CurrencyEnum[CurrencyEnum["BOB"] = 'BOB'] = "BOB";
        CurrencyEnum[CurrencyEnum["COP"] = 'COP'] = "COP";
        CurrencyEnum[CurrencyEnum["CRC"] = 'CRC'] = "CRC";
        CurrencyEnum[CurrencyEnum["CUP"] = 'CUP'] = "CUP";
        CurrencyEnum[CurrencyEnum["DOP"] = 'DOP'] = "DOP";
        CurrencyEnum[CurrencyEnum["GTQ"] = 'GTQ'] = "GTQ";
        CurrencyEnum[CurrencyEnum["HNL"] = 'HNL'] = "HNL";
        CurrencyEnum[CurrencyEnum["MXN"] = 'MXN'] = "MXN";
        CurrencyEnum[CurrencyEnum["NIO"] = 'NIO'] = "NIO";
        CurrencyEnum[CurrencyEnum["PAB"] = 'PAB'] = "PAB";
        CurrencyEnum[CurrencyEnum["PEN"] = 'PEN'] = "PEN";
        CurrencyEnum[CurrencyEnum["PYG"] = 'PYG'] = "PYG";
        CurrencyEnum[CurrencyEnum["UYU"] = 'UYU'] = "UYU";
        CurrencyEnum[CurrencyEnum["VEF"] = 'VEF'] = "VEF";
        CurrencyEnum[CurrencyEnum["IRR"] = 'IRR'] = "IRR";
        CurrencyEnum[CurrencyEnum["XOF"] = 'XOF'] = "XOF";
        CurrencyEnum[CurrencyEnum["CDF"] = 'CDF'] = "CDF";
        CurrencyEnum[CurrencyEnum["XAF"] = 'XAF'] = "XAF";
        CurrencyEnum[CurrencyEnum["HTG"] = 'HTG'] = "HTG";
        CurrencyEnum[CurrencyEnum["ILS"] = 'ILS'] = "ILS";
        CurrencyEnum[CurrencyEnum["HRK"] = 'HRK'] = "HRK";
        CurrencyEnum[CurrencyEnum["HUF"] = 'HUF'] = "HUF";
        CurrencyEnum[CurrencyEnum["AMD"] = 'AMD'] = "AMD";
        CurrencyEnum[CurrencyEnum["ISK"] = 'ISK'] = "ISK";
        CurrencyEnum[CurrencyEnum["JPY"] = 'JPY'] = "JPY";
        CurrencyEnum[CurrencyEnum["GEL"] = 'GEL'] = "GEL";
        CurrencyEnum[CurrencyEnum["KZT"] = 'KZT'] = "KZT";
        CurrencyEnum[CurrencyEnum["KHR"] = 'KHR'] = "KHR";
        CurrencyEnum[CurrencyEnum["KRW"] = 'KRW'] = "KRW";
        CurrencyEnum[CurrencyEnum["KGS"] = 'KGS'] = "KGS";
        CurrencyEnum[CurrencyEnum["LAK"] = 'LAK'] = "LAK";
        CurrencyEnum[CurrencyEnum["MKD"] = 'MKD'] = "MKD";
        CurrencyEnum[CurrencyEnum["MNT"] = 'MNT'] = "MNT";
        CurrencyEnum[CurrencyEnum["BND"] = 'BND'] = "BND";
        CurrencyEnum[CurrencyEnum["MMK"] = 'MMK'] = "MMK";
        CurrencyEnum[CurrencyEnum["NOK"] = 'NOK'] = "NOK";
        CurrencyEnum[CurrencyEnum["NPR"] = 'NPR'] = "NPR";
        CurrencyEnum[CurrencyEnum["PKR"] = 'PKR'] = "PKR";
        CurrencyEnum[CurrencyEnum["PLN"] = 'PLN'] = "PLN";
        CurrencyEnum[CurrencyEnum["AFN"] = 'AFN'] = "AFN";
        CurrencyEnum[CurrencyEnum["BRL"] = 'BRL'] = "BRL";
        CurrencyEnum[CurrencyEnum["MDL"] = 'MDL'] = "MDL";
        CurrencyEnum[CurrencyEnum["RON"] = 'RON'] = "RON";
        CurrencyEnum[CurrencyEnum["RWF"] = 'RWF'] = "RWF";
        CurrencyEnum[CurrencyEnum["SEK"] = 'SEK'] = "SEK";
        CurrencyEnum[CurrencyEnum["LKR"] = 'LKR'] = "LKR";
        CurrencyEnum[CurrencyEnum["SOS"] = 'SOS'] = "SOS";
        CurrencyEnum[CurrencyEnum["ALL"] = 'ALL'] = "ALL";
        CurrencyEnum[CurrencyEnum["RSD"] = 'RSD'] = "RSD";
        CurrencyEnum[CurrencyEnum["KES"] = 'KES'] = "KES";
        CurrencyEnum[CurrencyEnum["TJS"] = 'TJS'] = "TJS";
        CurrencyEnum[CurrencyEnum["THB"] = 'THB'] = "THB";
        CurrencyEnum[CurrencyEnum["ERN"] = 'ERN'] = "ERN";
        CurrencyEnum[CurrencyEnum["TMT"] = 'TMT'] = "TMT";
        CurrencyEnum[CurrencyEnum["BWP"] = 'BWP'] = "BWP";
        CurrencyEnum[CurrencyEnum["TRY"] = 'TRY'] = "TRY";
        CurrencyEnum[CurrencyEnum["UAH"] = 'UAH'] = "UAH";
        CurrencyEnum[CurrencyEnum["UZS"] = 'UZS'] = "UZS";
        CurrencyEnum[CurrencyEnum["VND"] = 'VND'] = "VND";
        CurrencyEnum[CurrencyEnum["MOP"] = 'MOP'] = "MOP";
        CurrencyEnum[CurrencyEnum["TWD"] = 'TWD'] = "TWD";
        CurrencyEnum[CurrencyEnum["BMD"] = 'BMD'] = "BMD";
    })(CurrencyEnum = SubscriptionSummary.CurrencyEnum || (SubscriptionSummary.CurrencyEnum = {}));
})(SubscriptionSummary || (exports.SubscriptionSummary = SubscriptionSummary = {}));
var SupportedCountry;
(function (SupportedCountry) {
    var AddressLayoutEnum;
    (function (AddressLayoutEnum) {
        AddressLayoutEnum[AddressLayoutEnum["BuildingFirst"] = 'BuildingFirst'] = "BuildingFirst";
        AddressLayoutEnum[AddressLayoutEnum["AddressFirst"] = 'AddressFirst'] = "AddressFirst";
        AddressLayoutEnum[AddressLayoutEnum["FullStreetAddressFirst"] = 'FullStreetAddressFirst'] = "FullStreetAddressFirst";
    })(AddressLayoutEnum = SupportedCountry.AddressLayoutEnum || (SupportedCountry.AddressLayoutEnum = {}));
    var PostCodeTypeEnum;
    (function (PostCodeTypeEnum) {
        PostCodeTypeEnum[PostCodeTypeEnum["None"] = 'None'] = "None";
        PostCodeTypeEnum[PostCodeTypeEnum["PostCode"] = 'PostCode'] = "PostCode";
        PostCodeTypeEnum[PostCodeTypeEnum["Zip"] = 'Zip'] = "Zip";
    })(PostCodeTypeEnum = SupportedCountry.PostCodeTypeEnum || (SupportedCountry.PostCodeTypeEnum = {}));
    var SupportRegionEnum;
    (function (SupportRegionEnum) {
        SupportRegionEnum[SupportRegionEnum["Default"] = 'Default'] = "Default";
        SupportRegionEnum[SupportRegionEnum["Spain"] = 'Spain'] = "Spain";
        SupportRegionEnum[SupportRegionEnum["Benelux"] = 'Benelux'] = "Benelux";
    })(SupportRegionEnum = SupportedCountry.SupportRegionEnum || (SupportedCountry.SupportRegionEnum = {}));
})(SupportedCountry || (exports.SupportedCountry = SupportedCountry = {}));
var Teammate;
(function (Teammate) {
    var InvitationStatusEnum;
    (function (InvitationStatusEnum) {
        InvitationStatusEnum[InvitationStatusEnum["Pending"] = 'Pending'] = "Pending";
        InvitationStatusEnum[InvitationStatusEnum["Accepted"] = 'Accepted'] = "Accepted";
        InvitationStatusEnum[InvitationStatusEnum["Expired"] = 'Expired'] = "Expired";
    })(InvitationStatusEnum = Teammate.InvitationStatusEnum || (Teammate.InvitationStatusEnum = {}));
    var AppAccessLevelEnum;
    (function (AppAccessLevelEnum) {
        AppAccessLevelEnum[AppAccessLevelEnum["None"] = 'None'] = "None";
        AppAccessLevelEnum[AppAccessLevelEnum["Owner"] = 'Owner'] = "Owner";
        AppAccessLevelEnum[AppAccessLevelEnum["StoreOwner"] = 'StoreOwner'] = "StoreOwner";
        AppAccessLevelEnum[AppAccessLevelEnum["PropertyOwner"] = 'PropertyOwner'] = "PropertyOwner";
        AppAccessLevelEnum[AppAccessLevelEnum["ManagedOwner"] = 'ManagedOwner'] = "ManagedOwner";
        AppAccessLevelEnum[AppAccessLevelEnum["Integrator"] = 'Integrator'] = "Integrator";
        AppAccessLevelEnum[AppAccessLevelEnum["PropertyManager"] = 'PropertyManager'] = "PropertyManager";
        AppAccessLevelEnum[AppAccessLevelEnum["StoreManager"] = 'StoreManager'] = "StoreManager";
        AppAccessLevelEnum[AppAccessLevelEnum["StoreStaff"] = 'StoreStaff'] = "StoreStaff";
        AppAccessLevelEnum[AppAccessLevelEnum["StaffMember"] = 'StaffMember'] = "StaffMember";
        AppAccessLevelEnum[AppAccessLevelEnum["StoreReadOnlyAccess"] = 'StoreReadOnlyAccess'] = "StoreReadOnlyAccess";
        AppAccessLevelEnum[AppAccessLevelEnum["FinanceManger"] = 'FinanceManger'] = "FinanceManger";
        AppAccessLevelEnum[AppAccessLevelEnum["Onboarding"] = 'Onboarding'] = "Onboarding";
        AppAccessLevelEnum[AppAccessLevelEnum["Support"] = 'Support'] = "Support";
    })(AppAccessLevelEnum = Teammate.AppAccessLevelEnum || (Teammate.AppAccessLevelEnum = {}));
})(Teammate || (exports.Teammate = Teammate = {}));
var TeammateBase;
(function (TeammateBase) {
    var AppAccessLevelEnum;
    (function (AppAccessLevelEnum) {
        AppAccessLevelEnum[AppAccessLevelEnum["None"] = 'None'] = "None";
        AppAccessLevelEnum[AppAccessLevelEnum["Owner"] = 'Owner'] = "Owner";
        AppAccessLevelEnum[AppAccessLevelEnum["StoreOwner"] = 'StoreOwner'] = "StoreOwner";
        AppAccessLevelEnum[AppAccessLevelEnum["PropertyOwner"] = 'PropertyOwner'] = "PropertyOwner";
        AppAccessLevelEnum[AppAccessLevelEnum["ManagedOwner"] = 'ManagedOwner'] = "ManagedOwner";
        AppAccessLevelEnum[AppAccessLevelEnum["Integrator"] = 'Integrator'] = "Integrator";
        AppAccessLevelEnum[AppAccessLevelEnum["PropertyManager"] = 'PropertyManager'] = "PropertyManager";
        AppAccessLevelEnum[AppAccessLevelEnum["StoreManager"] = 'StoreManager'] = "StoreManager";
        AppAccessLevelEnum[AppAccessLevelEnum["StoreStaff"] = 'StoreStaff'] = "StoreStaff";
        AppAccessLevelEnum[AppAccessLevelEnum["StaffMember"] = 'StaffMember'] = "StaffMember";
        AppAccessLevelEnum[AppAccessLevelEnum["StoreReadOnlyAccess"] = 'StoreReadOnlyAccess'] = "StoreReadOnlyAccess";
        AppAccessLevelEnum[AppAccessLevelEnum["FinanceManger"] = 'FinanceManger'] = "FinanceManger";
        AppAccessLevelEnum[AppAccessLevelEnum["Onboarding"] = 'Onboarding'] = "Onboarding";
        AppAccessLevelEnum[AppAccessLevelEnum["Support"] = 'Support'] = "Support";
    })(AppAccessLevelEnum = TeammateBase.AppAccessLevelEnum || (TeammateBase.AppAccessLevelEnum = {}));
})(TeammateBase || (exports.TeammateBase = TeammateBase = {}));
var TelephonyConfig;
(function (TelephonyConfig) {
    var TypeEnum;
    (function (TypeEnum) {
        TypeEnum[TypeEnum["PreRecorded"] = 'PreRecorded'] = "PreRecorded";
        TypeEnum[TypeEnum["VoiceAI"] = 'VoiceAI'] = "VoiceAI";
    })(TypeEnum = TelephonyConfig.TypeEnum || (TelephonyConfig.TypeEnum = {}));
})(TelephonyConfig || (exports.TelephonyConfig = TelephonyConfig = {}));
var UpdateAppStoreApp;
(function (UpdateAppStoreApp) {
    var ConfigurationTypeEnum;
    (function (ConfigurationTypeEnum) {
        ConfigurationTypeEnum[ConfigurationTypeEnum["ExternalLink"] = 'ExternalLink'] = "ExternalLink";
        ConfigurationTypeEnum[ConfigurationTypeEnum["FlipdishHosted"] = 'FlipdishHosted'] = "FlipdishHosted";
    })(ConfigurationTypeEnum = UpdateAppStoreApp.ConfigurationTypeEnum || (UpdateAppStoreApp.ConfigurationTypeEnum = {}));
    var StoreSelectorTypeEnum;
    (function (StoreSelectorTypeEnum) {
        StoreSelectorTypeEnum[StoreSelectorTypeEnum["None"] = 'None'] = "None";
        StoreSelectorTypeEnum[StoreSelectorTypeEnum["Single"] = 'Single'] = "Single";
        StoreSelectorTypeEnum[StoreSelectorTypeEnum["Multiple"] = 'Multiple'] = "Multiple";
    })(StoreSelectorTypeEnum = UpdateAppStoreApp.StoreSelectorTypeEnum || (UpdateAppStoreApp.StoreSelectorTypeEnum = {}));
    var TeammateAppAccessLevelEnum;
    (function (TeammateAppAccessLevelEnum) {
        TeammateAppAccessLevelEnum[TeammateAppAccessLevelEnum["Owner"] = 'Owner'] = "Owner";
        TeammateAppAccessLevelEnum[TeammateAppAccessLevelEnum["StoreOwner"] = 'StoreOwner'] = "StoreOwner";
        TeammateAppAccessLevelEnum[TeammateAppAccessLevelEnum["PropertyOwner"] = 'PropertyOwner'] = "PropertyOwner";
        TeammateAppAccessLevelEnum[TeammateAppAccessLevelEnum["ManagedOwner"] = 'ManagedOwner'] = "ManagedOwner";
        TeammateAppAccessLevelEnum[TeammateAppAccessLevelEnum["Integrator"] = 'Integrator'] = "Integrator";
        TeammateAppAccessLevelEnum[TeammateAppAccessLevelEnum["PropertyManager"] = 'PropertyManager'] = "PropertyManager";
        TeammateAppAccessLevelEnum[TeammateAppAccessLevelEnum["StoreManager"] = 'StoreManager'] = "StoreManager";
        TeammateAppAccessLevelEnum[TeammateAppAccessLevelEnum["StoreStaff"] = 'StoreStaff'] = "StoreStaff";
        TeammateAppAccessLevelEnum[TeammateAppAccessLevelEnum["StaffMember"] = 'StaffMember'] = "StaffMember";
        TeammateAppAccessLevelEnum[TeammateAppAccessLevelEnum["StoreReadOnlyAccess"] = 'StoreReadOnlyAccess'] = "StoreReadOnlyAccess";
        TeammateAppAccessLevelEnum[TeammateAppAccessLevelEnum["FinanceManger"] = 'FinanceManger'] = "FinanceManger";
    })(TeammateAppAccessLevelEnum = UpdateAppStoreApp.TeammateAppAccessLevelEnum || (UpdateAppStoreApp.TeammateAppAccessLevelEnum = {}));
    var PermissionsTypeEnum;
    (function (PermissionsTypeEnum) {
        PermissionsTypeEnum[PermissionsTypeEnum["Teammate"] = 'Teammate'] = "Teammate";
    })(PermissionsTypeEnum = UpdateAppStoreApp.PermissionsTypeEnum || (UpdateAppStoreApp.PermissionsTypeEnum = {}));
    var CategoriesEnum;
    (function (CategoriesEnum) {
        CategoriesEnum[CategoriesEnum["PointOfSale"] = 'PointOfSale'] = "PointOfSale";
        CategoriesEnum[CategoriesEnum["DeliveryAndLogistics"] = 'DeliveryAndLogistics'] = "DeliveryAndLogistics";
        CategoriesEnum[CategoriesEnum["CRM"] = 'CRM'] = "CRM";
        CategoriesEnum[CategoriesEnum["GiftCard"] = 'GiftCard'] = "GiftCard";
        CategoriesEnum[CategoriesEnum["Accounting"] = 'Accounting'] = "Accounting";
        CategoriesEnum[CategoriesEnum["LoyaltyAndMarketing"] = 'LoyaltyAndMarketing'] = "LoyaltyAndMarketing";
        CategoriesEnum[CategoriesEnum["Other"] = 'Other'] = "Other";
    })(CategoriesEnum = UpdateAppStoreApp.CategoriesEnum || (UpdateAppStoreApp.CategoriesEnum = {}));
    var CountriesEnum;
    (function (CountriesEnum) {
        CountriesEnum[CountriesEnum["GB"] = 'GB'] = "GB";
        CountriesEnum[CountriesEnum["IE"] = 'IE'] = "IE";
        CountriesEnum[CountriesEnum["FR"] = 'FR'] = "FR";
        CountriesEnum[CountriesEnum["ES"] = 'ES'] = "ES";
        CountriesEnum[CountriesEnum["PT"] = 'PT'] = "PT";
        CountriesEnum[CountriesEnum["IT"] = 'IT'] = "IT";
        CountriesEnum[CountriesEnum["DE"] = 'DE'] = "DE";
        CountriesEnum[CountriesEnum["PL"] = 'PL'] = "PL";
        CountriesEnum[CountriesEnum["BE"] = 'BE'] = "BE";
        CountriesEnum[CountriesEnum["LU"] = 'LU'] = "LU";
        CountriesEnum[CountriesEnum["NL"] = 'NL'] = "NL";
        CountriesEnum[CountriesEnum["US"] = 'US'] = "US";
        CountriesEnum[CountriesEnum["CA"] = 'CA'] = "CA";
        CountriesEnum[CountriesEnum["BG"] = 'BG'] = "BG";
        CountriesEnum[CountriesEnum["MX"] = 'MX'] = "MX";
        CountriesEnum[CountriesEnum["AU"] = 'AU'] = "AU";
        CountriesEnum[CountriesEnum["NZ"] = 'NZ'] = "NZ";
    })(CountriesEnum = UpdateAppStoreApp.CountriesEnum || (UpdateAppStoreApp.CountriesEnum = {}));
})(UpdateAppStoreApp || (exports.UpdateAppStoreApp = UpdateAppStoreApp = {}));
var UpdateCatalogGroupReference;
(function (UpdateCatalogGroupReference) {
    var GroupTypeEnum;
    (function (GroupTypeEnum) {
        GroupTypeEnum[GroupTypeEnum["ModifierGroup"] = 'ModifierGroup'] = "ModifierGroup";
    })(GroupTypeEnum = UpdateCatalogGroupReference.GroupTypeEnum || (UpdateCatalogGroupReference.GroupTypeEnum = {}));
})(UpdateCatalogGroupReference || (exports.UpdateCatalogGroupReference = UpdateCatalogGroupReference = {}));
var UpdateFulfillmentStatesConfiguration;
(function (UpdateFulfillmentStatesConfiguration) {
    var StoreSelectorTypeEnum;
    (function (StoreSelectorTypeEnum) {
        StoreSelectorTypeEnum[StoreSelectorTypeEnum["None"] = 'None'] = "None";
        StoreSelectorTypeEnum[StoreSelectorTypeEnum["Single"] = 'Single'] = "Single";
        StoreSelectorTypeEnum[StoreSelectorTypeEnum["Multiple"] = 'Multiple'] = "Multiple";
    })(StoreSelectorTypeEnum = UpdateFulfillmentStatesConfiguration.StoreSelectorTypeEnum || (UpdateFulfillmentStatesConfiguration.StoreSelectorTypeEnum = {}));
})(UpdateFulfillmentStatesConfiguration || (exports.UpdateFulfillmentStatesConfiguration = UpdateFulfillmentStatesConfiguration = {}));
var UpdateGroupReference;
(function (UpdateGroupReference) {
    var GroupTypeEnum;
    (function (GroupTypeEnum) {
        GroupTypeEnum[GroupTypeEnum["ModifierGroup"] = 'ModifierGroup'] = "ModifierGroup";
    })(GroupTypeEnum = UpdateGroupReference.GroupTypeEnum || (UpdateGroupReference.GroupTypeEnum = {}));
})(UpdateGroupReference || (exports.UpdateGroupReference = UpdateGroupReference = {}));
var UpdateMetafieldDefinition;
(function (UpdateMetafieldDefinition) {
    var BehaviorsEnum;
    (function (BehaviorsEnum) {
        BehaviorsEnum[BehaviorsEnum["SendToOrder"] = 'SendToOrder'] = "SendToOrder";
        BehaviorsEnum[BehaviorsEnum["SendToMenu"] = 'SendToMenu'] = "SendToMenu";
    })(BehaviorsEnum = UpdateMetafieldDefinition.BehaviorsEnum || (UpdateMetafieldDefinition.BehaviorsEnum = {}));
})(UpdateMetafieldDefinition || (exports.UpdateMetafieldDefinition = UpdateMetafieldDefinition = {}));
var UpdateMobileAppsSubmissionStatus;
(function (UpdateMobileAppsSubmissionStatus) {
    var TypeEnum;
    (function (TypeEnum) {
        TypeEnum[TypeEnum["None"] = 'None'] = "None";
        TypeEnum[TypeEnum["Android"] = 'Android'] = "Android";
        TypeEnum[TypeEnum["IOS"] = 'IOS'] = "IOS";
    })(TypeEnum = UpdateMobileAppsSubmissionStatus.TypeEnum || (UpdateMobileAppsSubmissionStatus.TypeEnum = {}));
    var AppStatusEnum;
    (function (AppStatusEnum) {
        AppStatusEnum[AppStatusEnum["None"] = 'None'] = "None";
        AppStatusEnum[AppStatusEnum["Published"] = 'Published'] = "Published";
        AppStatusEnum[AppStatusEnum["Unpublished"] = 'Unpublished'] = "Unpublished";
    })(AppStatusEnum = UpdateMobileAppsSubmissionStatus.AppStatusEnum || (UpdateMobileAppsSubmissionStatus.AppStatusEnum = {}));
    var UpdateStatusEnum;
    (function (UpdateStatusEnum) {
        UpdateStatusEnum[UpdateStatusEnum["None"] = 'None'] = "None";
        UpdateStatusEnum[UpdateStatusEnum["Submitted"] = 'Submitted'] = "Submitted";
        UpdateStatusEnum[UpdateStatusEnum["InReview"] = 'InReview'] = "InReview";
        UpdateStatusEnum[UpdateStatusEnum["Rejected"] = 'Rejected'] = "Rejected";
        UpdateStatusEnum[UpdateStatusEnum["Approved"] = 'Approved'] = "Approved";
        UpdateStatusEnum[UpdateStatusEnum["Published"] = 'Published'] = "Published";
    })(UpdateStatusEnum = UpdateMobileAppsSubmissionStatus.UpdateStatusEnum || (UpdateMobileAppsSubmissionStatus.UpdateStatusEnum = {}));
})(UpdateMobileAppsSubmissionStatus || (exports.UpdateMobileAppsSubmissionStatus = UpdateMobileAppsSubmissionStatus = {}));
var UpdateProductReference;
(function (UpdateProductReference) {
    var ProductTypeEnum;
    (function (ProductTypeEnum) {
        ProductTypeEnum[ProductTypeEnum["Product"] = 'Product'] = "Product";
        ProductTypeEnum[ProductTypeEnum["Modifier"] = 'Modifier'] = "Modifier";
    })(ProductTypeEnum = UpdateProductReference.ProductTypeEnum || (UpdateProductReference.ProductTypeEnum = {}));
})(UpdateProductReference || (exports.UpdateProductReference = UpdateProductReference = {}));
var UpdateVoucher;
(function (UpdateVoucher) {
    var ChannelRestrictionsEnum;
    (function (ChannelRestrictionsEnum) {
        ChannelRestrictionsEnum[ChannelRestrictionsEnum["Ios"] = 'Ios'] = "Ios";
        ChannelRestrictionsEnum[ChannelRestrictionsEnum["Android"] = 'Android'] = "Android";
        ChannelRestrictionsEnum[ChannelRestrictionsEnum["Web"] = 'Web'] = "Web";
        ChannelRestrictionsEnum[ChannelRestrictionsEnum["Kiosk"] = 'Kiosk'] = "Kiosk";
        ChannelRestrictionsEnum[ChannelRestrictionsEnum["Pos"] = 'Pos'] = "Pos";
        ChannelRestrictionsEnum[ChannelRestrictionsEnum["Google"] = 'Google'] = "Google";
    })(ChannelRestrictionsEnum = UpdateVoucher.ChannelRestrictionsEnum || (UpdateVoucher.ChannelRestrictionsEnum = {}));
    var VoucherSubTypeEnum;
    (function (VoucherSubTypeEnum) {
        VoucherSubTypeEnum[VoucherSubTypeEnum["None"] = 'None'] = "None";
        VoucherSubTypeEnum[VoucherSubTypeEnum["SignUp"] = 'SignUp'] = "SignUp";
        VoucherSubTypeEnum[VoucherSubTypeEnum["Loyalty"] = 'Loyalty'] = "Loyalty";
        VoucherSubTypeEnum[VoucherSubTypeEnum["Loyalty25"] = 'Loyalty25'] = "Loyalty25";
        VoucherSubTypeEnum[VoucherSubTypeEnum["Retention"] = 'Retention'] = "Retention";
        VoucherSubTypeEnum[VoucherSubTypeEnum["SecondaryRetention"] = 'SecondaryRetention'] = "SecondaryRetention";
        VoucherSubTypeEnum[VoucherSubTypeEnum["Custom"] = 'Custom'] = "Custom";
    })(VoucherSubTypeEnum = UpdateVoucher.VoucherSubTypeEnum || (UpdateVoucher.VoucherSubTypeEnum = {}));
})(UpdateVoucher || (exports.UpdateVoucher = UpdateVoucher = {}));
var UserMonthlyCommission;
(function (UserMonthlyCommission) {
    var CurrencyEnum;
    (function (CurrencyEnum) {
        CurrencyEnum[CurrencyEnum["EUR"] = 'EUR'] = "EUR";
        CurrencyEnum[CurrencyEnum["USD"] = 'USD'] = "USD";
        CurrencyEnum[CurrencyEnum["GBP"] = 'GBP'] = "GBP";
        CurrencyEnum[CurrencyEnum["CAD"] = 'CAD'] = "CAD";
        CurrencyEnum[CurrencyEnum["AUD"] = 'AUD'] = "AUD";
        CurrencyEnum[CurrencyEnum["DJF"] = 'DJF'] = "DJF";
        CurrencyEnum[CurrencyEnum["ZAR"] = 'ZAR'] = "ZAR";
        CurrencyEnum[CurrencyEnum["ETB"] = 'ETB'] = "ETB";
        CurrencyEnum[CurrencyEnum["AED"] = 'AED'] = "AED";
        CurrencyEnum[CurrencyEnum["BHD"] = 'BHD'] = "BHD";
        CurrencyEnum[CurrencyEnum["DZD"] = 'DZD'] = "DZD";
        CurrencyEnum[CurrencyEnum["EGP"] = 'EGP'] = "EGP";
        CurrencyEnum[CurrencyEnum["IQD"] = 'IQD'] = "IQD";
        CurrencyEnum[CurrencyEnum["JOD"] = 'JOD'] = "JOD";
        CurrencyEnum[CurrencyEnum["KWD"] = 'KWD'] = "KWD";
        CurrencyEnum[CurrencyEnum["LBP"] = 'LBP'] = "LBP";
        CurrencyEnum[CurrencyEnum["LYD"] = 'LYD'] = "LYD";
        CurrencyEnum[CurrencyEnum["MAD"] = 'MAD'] = "MAD";
        CurrencyEnum[CurrencyEnum["OMR"] = 'OMR'] = "OMR";
        CurrencyEnum[CurrencyEnum["QAR"] = 'QAR'] = "QAR";
        CurrencyEnum[CurrencyEnum["SAR"] = 'SAR'] = "SAR";
        CurrencyEnum[CurrencyEnum["SYP"] = 'SYP'] = "SYP";
        CurrencyEnum[CurrencyEnum["TND"] = 'TND'] = "TND";
        CurrencyEnum[CurrencyEnum["YER"] = 'YER'] = "YER";
        CurrencyEnum[CurrencyEnum["CLP"] = 'CLP'] = "CLP";
        CurrencyEnum[CurrencyEnum["INR"] = 'INR'] = "INR";
        CurrencyEnum[CurrencyEnum["AZN"] = 'AZN'] = "AZN";
        CurrencyEnum[CurrencyEnum["RUB"] = 'RUB'] = "RUB";
        CurrencyEnum[CurrencyEnum["BYN"] = 'BYN'] = "BYN";
        CurrencyEnum[CurrencyEnum["BGN"] = 'BGN'] = "BGN";
        CurrencyEnum[CurrencyEnum["NGN"] = 'NGN'] = "NGN";
        CurrencyEnum[CurrencyEnum["BDT"] = 'BDT'] = "BDT";
        CurrencyEnum[CurrencyEnum["CNY"] = 'CNY'] = "CNY";
        CurrencyEnum[CurrencyEnum["BAM"] = 'BAM'] = "BAM";
        CurrencyEnum[CurrencyEnum["CZK"] = 'CZK'] = "CZK";
        CurrencyEnum[CurrencyEnum["DKK"] = 'DKK'] = "DKK";
        CurrencyEnum[CurrencyEnum["CHF"] = 'CHF'] = "CHF";
        CurrencyEnum[CurrencyEnum["MVR"] = 'MVR'] = "MVR";
        CurrencyEnum[CurrencyEnum["BTN"] = 'BTN'] = "BTN";
        CurrencyEnum[CurrencyEnum["XCD"] = 'XCD'] = "XCD";
        CurrencyEnum[CurrencyEnum["BZD"] = 'BZD'] = "BZD";
        CurrencyEnum[CurrencyEnum["HKD"] = 'HKD'] = "HKD";
        CurrencyEnum[CurrencyEnum["IDR"] = 'IDR'] = "IDR";
        CurrencyEnum[CurrencyEnum["JMD"] = 'JMD'] = "JMD";
        CurrencyEnum[CurrencyEnum["MYR"] = 'MYR'] = "MYR";
        CurrencyEnum[CurrencyEnum["NZD"] = 'NZD'] = "NZD";
        CurrencyEnum[CurrencyEnum["PHP"] = 'PHP'] = "PHP";
        CurrencyEnum[CurrencyEnum["SGD"] = 'SGD'] = "SGD";
        CurrencyEnum[CurrencyEnum["TTD"] = 'TTD'] = "TTD";
        CurrencyEnum[CurrencyEnum["XDR"] = 'XDR'] = "XDR";
        CurrencyEnum[CurrencyEnum["ARS"] = 'ARS'] = "ARS";
        CurrencyEnum[CurrencyEnum["BOB"] = 'BOB'] = "BOB";
        CurrencyEnum[CurrencyEnum["COP"] = 'COP'] = "COP";
        CurrencyEnum[CurrencyEnum["CRC"] = 'CRC'] = "CRC";
        CurrencyEnum[CurrencyEnum["CUP"] = 'CUP'] = "CUP";
        CurrencyEnum[CurrencyEnum["DOP"] = 'DOP'] = "DOP";
        CurrencyEnum[CurrencyEnum["GTQ"] = 'GTQ'] = "GTQ";
        CurrencyEnum[CurrencyEnum["HNL"] = 'HNL'] = "HNL";
        CurrencyEnum[CurrencyEnum["MXN"] = 'MXN'] = "MXN";
        CurrencyEnum[CurrencyEnum["NIO"] = 'NIO'] = "NIO";
        CurrencyEnum[CurrencyEnum["PAB"] = 'PAB'] = "PAB";
        CurrencyEnum[CurrencyEnum["PEN"] = 'PEN'] = "PEN";
        CurrencyEnum[CurrencyEnum["PYG"] = 'PYG'] = "PYG";
        CurrencyEnum[CurrencyEnum["UYU"] = 'UYU'] = "UYU";
        CurrencyEnum[CurrencyEnum["VEF"] = 'VEF'] = "VEF";
        CurrencyEnum[CurrencyEnum["IRR"] = 'IRR'] = "IRR";
        CurrencyEnum[CurrencyEnum["XOF"] = 'XOF'] = "XOF";
        CurrencyEnum[CurrencyEnum["CDF"] = 'CDF'] = "CDF";
        CurrencyEnum[CurrencyEnum["XAF"] = 'XAF'] = "XAF";
        CurrencyEnum[CurrencyEnum["HTG"] = 'HTG'] = "HTG";
        CurrencyEnum[CurrencyEnum["ILS"] = 'ILS'] = "ILS";
        CurrencyEnum[CurrencyEnum["HRK"] = 'HRK'] = "HRK";
        CurrencyEnum[CurrencyEnum["HUF"] = 'HUF'] = "HUF";
        CurrencyEnum[CurrencyEnum["AMD"] = 'AMD'] = "AMD";
        CurrencyEnum[CurrencyEnum["ISK"] = 'ISK'] = "ISK";
        CurrencyEnum[CurrencyEnum["JPY"] = 'JPY'] = "JPY";
        CurrencyEnum[CurrencyEnum["GEL"] = 'GEL'] = "GEL";
        CurrencyEnum[CurrencyEnum["KZT"] = 'KZT'] = "KZT";
        CurrencyEnum[CurrencyEnum["KHR"] = 'KHR'] = "KHR";
        CurrencyEnum[CurrencyEnum["KRW"] = 'KRW'] = "KRW";
        CurrencyEnum[CurrencyEnum["KGS"] = 'KGS'] = "KGS";
        CurrencyEnum[CurrencyEnum["LAK"] = 'LAK'] = "LAK";
        CurrencyEnum[CurrencyEnum["MKD"] = 'MKD'] = "MKD";
        CurrencyEnum[CurrencyEnum["MNT"] = 'MNT'] = "MNT";
        CurrencyEnum[CurrencyEnum["BND"] = 'BND'] = "BND";
        CurrencyEnum[CurrencyEnum["MMK"] = 'MMK'] = "MMK";
        CurrencyEnum[CurrencyEnum["NOK"] = 'NOK'] = "NOK";
        CurrencyEnum[CurrencyEnum["NPR"] = 'NPR'] = "NPR";
        CurrencyEnum[CurrencyEnum["PKR"] = 'PKR'] = "PKR";
        CurrencyEnum[CurrencyEnum["PLN"] = 'PLN'] = "PLN";
        CurrencyEnum[CurrencyEnum["AFN"] = 'AFN'] = "AFN";
        CurrencyEnum[CurrencyEnum["BRL"] = 'BRL'] = "BRL";
        CurrencyEnum[CurrencyEnum["MDL"] = 'MDL'] = "MDL";
        CurrencyEnum[CurrencyEnum["RON"] = 'RON'] = "RON";
        CurrencyEnum[CurrencyEnum["RWF"] = 'RWF'] = "RWF";
        CurrencyEnum[CurrencyEnum["SEK"] = 'SEK'] = "SEK";
        CurrencyEnum[CurrencyEnum["LKR"] = 'LKR'] = "LKR";
        CurrencyEnum[CurrencyEnum["SOS"] = 'SOS'] = "SOS";
        CurrencyEnum[CurrencyEnum["ALL"] = 'ALL'] = "ALL";
        CurrencyEnum[CurrencyEnum["RSD"] = 'RSD'] = "RSD";
        CurrencyEnum[CurrencyEnum["KES"] = 'KES'] = "KES";
        CurrencyEnum[CurrencyEnum["TJS"] = 'TJS'] = "TJS";
        CurrencyEnum[CurrencyEnum["THB"] = 'THB'] = "THB";
        CurrencyEnum[CurrencyEnum["ERN"] = 'ERN'] = "ERN";
        CurrencyEnum[CurrencyEnum["TMT"] = 'TMT'] = "TMT";
        CurrencyEnum[CurrencyEnum["BWP"] = 'BWP'] = "BWP";
        CurrencyEnum[CurrencyEnum["TRY"] = 'TRY'] = "TRY";
        CurrencyEnum[CurrencyEnum["UAH"] = 'UAH'] = "UAH";
        CurrencyEnum[CurrencyEnum["UZS"] = 'UZS'] = "UZS";
        CurrencyEnum[CurrencyEnum["VND"] = 'VND'] = "VND";
        CurrencyEnum[CurrencyEnum["MOP"] = 'MOP'] = "MOP";
        CurrencyEnum[CurrencyEnum["TWD"] = 'TWD'] = "TWD";
        CurrencyEnum[CurrencyEnum["BMD"] = 'BMD'] = "BMD";
    })(CurrencyEnum = UserMonthlyCommission.CurrencyEnum || (UserMonthlyCommission.CurrencyEnum = {}));
})(UserMonthlyCommission || (exports.UserMonthlyCommission = UserMonthlyCommission = {}));
var UserSearch;
(function (UserSearch) {
    var UserDiscriminatorEnum;
    (function (UserDiscriminatorEnum) {
        UserDiscriminatorEnum[UserDiscriminatorEnum["All"] = 'All'] = "All";
        UserDiscriminatorEnum[UserDiscriminatorEnum["ApplicationUsers"] = 'ApplicationUsers'] = "ApplicationUsers";
        UserDiscriminatorEnum[UserDiscriminatorEnum["RestaurantUsers"] = 'RestaurantUsers'] = "RestaurantUsers";
        UserDiscriminatorEnum[UserDiscriminatorEnum["HydraUsers"] = 'HydraUsers'] = "HydraUsers";
    })(UserDiscriminatorEnum = UserSearch.UserDiscriminatorEnum || (UserSearch.UserDiscriminatorEnum = {}));
})(UserSearch || (exports.UserSearch = UserSearch = {}));
var UserWhiteLabelConfig;
(function (UserWhiteLabelConfig) {
    var LevelEnum;
    (function (LevelEnum) {
        LevelEnum[LevelEnum["None"] = 'None'] = "None";
        LevelEnum[LevelEnum["Owner"] = 'Owner'] = "Owner";
        LevelEnum[LevelEnum["StoreOwner"] = 'StoreOwner'] = "StoreOwner";
        LevelEnum[LevelEnum["PropertyOwner"] = 'PropertyOwner'] = "PropertyOwner";
        LevelEnum[LevelEnum["ManagedOwner"] = 'ManagedOwner'] = "ManagedOwner";
        LevelEnum[LevelEnum["Integrator"] = 'Integrator'] = "Integrator";
        LevelEnum[LevelEnum["PropertyManager"] = 'PropertyManager'] = "PropertyManager";
        LevelEnum[LevelEnum["StoreManager"] = 'StoreManager'] = "StoreManager";
        LevelEnum[LevelEnum["StoreStaff"] = 'StoreStaff'] = "StoreStaff";
        LevelEnum[LevelEnum["StaffMember"] = 'StaffMember'] = "StaffMember";
        LevelEnum[LevelEnum["StoreReadOnlyAccess"] = 'StoreReadOnlyAccess'] = "StoreReadOnlyAccess";
        LevelEnum[LevelEnum["FinanceManager"] = 'FinanceManager'] = "FinanceManager";
        LevelEnum[LevelEnum["Support"] = 'Support'] = "Support";
    })(LevelEnum = UserWhiteLabelConfig.LevelEnum || (UserWhiteLabelConfig.LevelEnum = {}));
})(UserWhiteLabelConfig || (exports.UserWhiteLabelConfig = UserWhiteLabelConfig = {}));
var ValidityPeriod;
(function (ValidityPeriod) {
    var DayOfWeekEnum;
    (function (DayOfWeekEnum) {
        DayOfWeekEnum[DayOfWeekEnum["Sunday"] = 'Sunday'] = "Sunday";
        DayOfWeekEnum[DayOfWeekEnum["Monday"] = 'Monday'] = "Monday";
        DayOfWeekEnum[DayOfWeekEnum["Tuesday"] = 'Tuesday'] = "Tuesday";
        DayOfWeekEnum[DayOfWeekEnum["Wednesday"] = 'Wednesday'] = "Wednesday";
        DayOfWeekEnum[DayOfWeekEnum["Thursday"] = 'Thursday'] = "Thursday";
        DayOfWeekEnum[DayOfWeekEnum["Friday"] = 'Friday'] = "Friday";
        DayOfWeekEnum[DayOfWeekEnum["Saturday"] = 'Saturday'] = "Saturday";
    })(DayOfWeekEnum = ValidityPeriod.DayOfWeekEnum || (ValidityPeriod.DayOfWeekEnum = {}));
})(ValidityPeriod || (exports.ValidityPeriod = ValidityPeriod = {}));
var Voucher;
(function (Voucher) {
    var StatusEnum;
    (function (StatusEnum) {
        StatusEnum[StatusEnum["Valid"] = 'Valid'] = "Valid";
        StatusEnum[StatusEnum["NotYetValid"] = 'NotYetValid'] = "NotYetValid";
        StatusEnum[StatusEnum["Expired"] = 'Expired'] = "Expired";
        StatusEnum[StatusEnum["Used"] = 'Used'] = "Used";
        StatusEnum[StatusEnum["Disabled"] = 'Disabled'] = "Disabled";
    })(StatusEnum = Voucher.StatusEnum || (Voucher.StatusEnum = {}));
    var VoucherTypeEnum;
    (function (VoucherTypeEnum) {
        VoucherTypeEnum[VoucherTypeEnum["PercentageDiscount"] = 'PercentageDiscount'] = "PercentageDiscount";
        VoucherTypeEnum[VoucherTypeEnum["LumpDiscount"] = 'LumpDiscount'] = "LumpDiscount";
        VoucherTypeEnum[VoucherTypeEnum["AddItem"] = 'AddItem'] = "AddItem";
        VoucherTypeEnum[VoucherTypeEnum["CreditNote"] = 'CreditNote'] = "CreditNote";
        VoucherTypeEnum[VoucherTypeEnum["FreeDelivery"] = 'FreeDelivery'] = "FreeDelivery";
    })(VoucherTypeEnum = Voucher.VoucherTypeEnum || (Voucher.VoucherTypeEnum = {}));
    var CurrencyEnum;
    (function (CurrencyEnum) {
        CurrencyEnum[CurrencyEnum["EUR"] = 'EUR'] = "EUR";
        CurrencyEnum[CurrencyEnum["USD"] = 'USD'] = "USD";
        CurrencyEnum[CurrencyEnum["GBP"] = 'GBP'] = "GBP";
        CurrencyEnum[CurrencyEnum["CAD"] = 'CAD'] = "CAD";
        CurrencyEnum[CurrencyEnum["AUD"] = 'AUD'] = "AUD";
        CurrencyEnum[CurrencyEnum["DJF"] = 'DJF'] = "DJF";
        CurrencyEnum[CurrencyEnum["ZAR"] = 'ZAR'] = "ZAR";
        CurrencyEnum[CurrencyEnum["ETB"] = 'ETB'] = "ETB";
        CurrencyEnum[CurrencyEnum["AED"] = 'AED'] = "AED";
        CurrencyEnum[CurrencyEnum["BHD"] = 'BHD'] = "BHD";
        CurrencyEnum[CurrencyEnum["DZD"] = 'DZD'] = "DZD";
        CurrencyEnum[CurrencyEnum["EGP"] = 'EGP'] = "EGP";
        CurrencyEnum[CurrencyEnum["IQD"] = 'IQD'] = "IQD";
        CurrencyEnum[CurrencyEnum["JOD"] = 'JOD'] = "JOD";
        CurrencyEnum[CurrencyEnum["KWD"] = 'KWD'] = "KWD";
        CurrencyEnum[CurrencyEnum["LBP"] = 'LBP'] = "LBP";
        CurrencyEnum[CurrencyEnum["LYD"] = 'LYD'] = "LYD";
        CurrencyEnum[CurrencyEnum["MAD"] = 'MAD'] = "MAD";
        CurrencyEnum[CurrencyEnum["OMR"] = 'OMR'] = "OMR";
        CurrencyEnum[CurrencyEnum["QAR"] = 'QAR'] = "QAR";
        CurrencyEnum[CurrencyEnum["SAR"] = 'SAR'] = "SAR";
        CurrencyEnum[CurrencyEnum["SYP"] = 'SYP'] = "SYP";
        CurrencyEnum[CurrencyEnum["TND"] = 'TND'] = "TND";
        CurrencyEnum[CurrencyEnum["YER"] = 'YER'] = "YER";
        CurrencyEnum[CurrencyEnum["CLP"] = 'CLP'] = "CLP";
        CurrencyEnum[CurrencyEnum["INR"] = 'INR'] = "INR";
        CurrencyEnum[CurrencyEnum["AZN"] = 'AZN'] = "AZN";
        CurrencyEnum[CurrencyEnum["RUB"] = 'RUB'] = "RUB";
        CurrencyEnum[CurrencyEnum["BYN"] = 'BYN'] = "BYN";
        CurrencyEnum[CurrencyEnum["BGN"] = 'BGN'] = "BGN";
        CurrencyEnum[CurrencyEnum["NGN"] = 'NGN'] = "NGN";
        CurrencyEnum[CurrencyEnum["BDT"] = 'BDT'] = "BDT";
        CurrencyEnum[CurrencyEnum["CNY"] = 'CNY'] = "CNY";
        CurrencyEnum[CurrencyEnum["BAM"] = 'BAM'] = "BAM";
        CurrencyEnum[CurrencyEnum["CZK"] = 'CZK'] = "CZK";
        CurrencyEnum[CurrencyEnum["DKK"] = 'DKK'] = "DKK";
        CurrencyEnum[CurrencyEnum["CHF"] = 'CHF'] = "CHF";
        CurrencyEnum[CurrencyEnum["MVR"] = 'MVR'] = "MVR";
        CurrencyEnum[CurrencyEnum["BTN"] = 'BTN'] = "BTN";
        CurrencyEnum[CurrencyEnum["XCD"] = 'XCD'] = "XCD";
        CurrencyEnum[CurrencyEnum["BZD"] = 'BZD'] = "BZD";
        CurrencyEnum[CurrencyEnum["HKD"] = 'HKD'] = "HKD";
        CurrencyEnum[CurrencyEnum["IDR"] = 'IDR'] = "IDR";
        CurrencyEnum[CurrencyEnum["JMD"] = 'JMD'] = "JMD";
        CurrencyEnum[CurrencyEnum["MYR"] = 'MYR'] = "MYR";
        CurrencyEnum[CurrencyEnum["NZD"] = 'NZD'] = "NZD";
        CurrencyEnum[CurrencyEnum["PHP"] = 'PHP'] = "PHP";
        CurrencyEnum[CurrencyEnum["SGD"] = 'SGD'] = "SGD";
        CurrencyEnum[CurrencyEnum["TTD"] = 'TTD'] = "TTD";
        CurrencyEnum[CurrencyEnum["XDR"] = 'XDR'] = "XDR";
        CurrencyEnum[CurrencyEnum["ARS"] = 'ARS'] = "ARS";
        CurrencyEnum[CurrencyEnum["BOB"] = 'BOB'] = "BOB";
        CurrencyEnum[CurrencyEnum["COP"] = 'COP'] = "COP";
        CurrencyEnum[CurrencyEnum["CRC"] = 'CRC'] = "CRC";
        CurrencyEnum[CurrencyEnum["CUP"] = 'CUP'] = "CUP";
        CurrencyEnum[CurrencyEnum["DOP"] = 'DOP'] = "DOP";
        CurrencyEnum[CurrencyEnum["GTQ"] = 'GTQ'] = "GTQ";
        CurrencyEnum[CurrencyEnum["HNL"] = 'HNL'] = "HNL";
        CurrencyEnum[CurrencyEnum["MXN"] = 'MXN'] = "MXN";
        CurrencyEnum[CurrencyEnum["NIO"] = 'NIO'] = "NIO";
        CurrencyEnum[CurrencyEnum["PAB"] = 'PAB'] = "PAB";
        CurrencyEnum[CurrencyEnum["PEN"] = 'PEN'] = "PEN";
        CurrencyEnum[CurrencyEnum["PYG"] = 'PYG'] = "PYG";
        CurrencyEnum[CurrencyEnum["UYU"] = 'UYU'] = "UYU";
        CurrencyEnum[CurrencyEnum["VEF"] = 'VEF'] = "VEF";
        CurrencyEnum[CurrencyEnum["IRR"] = 'IRR'] = "IRR";
        CurrencyEnum[CurrencyEnum["XOF"] = 'XOF'] = "XOF";
        CurrencyEnum[CurrencyEnum["CDF"] = 'CDF'] = "CDF";
        CurrencyEnum[CurrencyEnum["XAF"] = 'XAF'] = "XAF";
        CurrencyEnum[CurrencyEnum["HTG"] = 'HTG'] = "HTG";
        CurrencyEnum[CurrencyEnum["ILS"] = 'ILS'] = "ILS";
        CurrencyEnum[CurrencyEnum["HRK"] = 'HRK'] = "HRK";
        CurrencyEnum[CurrencyEnum["HUF"] = 'HUF'] = "HUF";
        CurrencyEnum[CurrencyEnum["AMD"] = 'AMD'] = "AMD";
        CurrencyEnum[CurrencyEnum["ISK"] = 'ISK'] = "ISK";
        CurrencyEnum[CurrencyEnum["JPY"] = 'JPY'] = "JPY";
        CurrencyEnum[CurrencyEnum["GEL"] = 'GEL'] = "GEL";
        CurrencyEnum[CurrencyEnum["KZT"] = 'KZT'] = "KZT";
        CurrencyEnum[CurrencyEnum["KHR"] = 'KHR'] = "KHR";
        CurrencyEnum[CurrencyEnum["KRW"] = 'KRW'] = "KRW";
        CurrencyEnum[CurrencyEnum["KGS"] = 'KGS'] = "KGS";
        CurrencyEnum[CurrencyEnum["LAK"] = 'LAK'] = "LAK";
        CurrencyEnum[CurrencyEnum["MKD"] = 'MKD'] = "MKD";
        CurrencyEnum[CurrencyEnum["MNT"] = 'MNT'] = "MNT";
        CurrencyEnum[CurrencyEnum["BND"] = 'BND'] = "BND";
        CurrencyEnum[CurrencyEnum["MMK"] = 'MMK'] = "MMK";
        CurrencyEnum[CurrencyEnum["NOK"] = 'NOK'] = "NOK";
        CurrencyEnum[CurrencyEnum["NPR"] = 'NPR'] = "NPR";
        CurrencyEnum[CurrencyEnum["PKR"] = 'PKR'] = "PKR";
        CurrencyEnum[CurrencyEnum["PLN"] = 'PLN'] = "PLN";
        CurrencyEnum[CurrencyEnum["AFN"] = 'AFN'] = "AFN";
        CurrencyEnum[CurrencyEnum["BRL"] = 'BRL'] = "BRL";
        CurrencyEnum[CurrencyEnum["MDL"] = 'MDL'] = "MDL";
        CurrencyEnum[CurrencyEnum["RON"] = 'RON'] = "RON";
        CurrencyEnum[CurrencyEnum["RWF"] = 'RWF'] = "RWF";
        CurrencyEnum[CurrencyEnum["SEK"] = 'SEK'] = "SEK";
        CurrencyEnum[CurrencyEnum["LKR"] = 'LKR'] = "LKR";
        CurrencyEnum[CurrencyEnum["SOS"] = 'SOS'] = "SOS";
        CurrencyEnum[CurrencyEnum["ALL"] = 'ALL'] = "ALL";
        CurrencyEnum[CurrencyEnum["RSD"] = 'RSD'] = "RSD";
        CurrencyEnum[CurrencyEnum["KES"] = 'KES'] = "KES";
        CurrencyEnum[CurrencyEnum["TJS"] = 'TJS'] = "TJS";
        CurrencyEnum[CurrencyEnum["THB"] = 'THB'] = "THB";
        CurrencyEnum[CurrencyEnum["ERN"] = 'ERN'] = "ERN";
        CurrencyEnum[CurrencyEnum["TMT"] = 'TMT'] = "TMT";
        CurrencyEnum[CurrencyEnum["BWP"] = 'BWP'] = "BWP";
        CurrencyEnum[CurrencyEnum["TRY"] = 'TRY'] = "TRY";
        CurrencyEnum[CurrencyEnum["UAH"] = 'UAH'] = "UAH";
        CurrencyEnum[CurrencyEnum["UZS"] = 'UZS'] = "UZS";
        CurrencyEnum[CurrencyEnum["VND"] = 'VND'] = "VND";
        CurrencyEnum[CurrencyEnum["MOP"] = 'MOP'] = "MOP";
        CurrencyEnum[CurrencyEnum["TWD"] = 'TWD'] = "TWD";
        CurrencyEnum[CurrencyEnum["BMD"] = 'BMD'] = "BMD";
    })(CurrencyEnum = Voucher.CurrencyEnum || (Voucher.CurrencyEnum = {}));
    var ChannelRestrictionsEnum;
    (function (ChannelRestrictionsEnum) {
        ChannelRestrictionsEnum[ChannelRestrictionsEnum["Ios"] = 'Ios'] = "Ios";
        ChannelRestrictionsEnum[ChannelRestrictionsEnum["Android"] = 'Android'] = "Android";
        ChannelRestrictionsEnum[ChannelRestrictionsEnum["Web"] = 'Web'] = "Web";
        ChannelRestrictionsEnum[ChannelRestrictionsEnum["Kiosk"] = 'Kiosk'] = "Kiosk";
        ChannelRestrictionsEnum[ChannelRestrictionsEnum["Pos"] = 'Pos'] = "Pos";
        ChannelRestrictionsEnum[ChannelRestrictionsEnum["Google"] = 'Google'] = "Google";
    })(ChannelRestrictionsEnum = Voucher.ChannelRestrictionsEnum || (Voucher.ChannelRestrictionsEnum = {}));
    var VoucherSubTypeEnum;
    (function (VoucherSubTypeEnum) {
        VoucherSubTypeEnum[VoucherSubTypeEnum["None"] = 'None'] = "None";
        VoucherSubTypeEnum[VoucherSubTypeEnum["SignUp"] = 'SignUp'] = "SignUp";
        VoucherSubTypeEnum[VoucherSubTypeEnum["Loyalty"] = 'Loyalty'] = "Loyalty";
        VoucherSubTypeEnum[VoucherSubTypeEnum["Loyalty25"] = 'Loyalty25'] = "Loyalty25";
        VoucherSubTypeEnum[VoucherSubTypeEnum["Retention"] = 'Retention'] = "Retention";
        VoucherSubTypeEnum[VoucherSubTypeEnum["SecondaryRetention"] = 'SecondaryRetention'] = "SecondaryRetention";
        VoucherSubTypeEnum[VoucherSubTypeEnum["Custom"] = 'Custom'] = "Custom";
    })(VoucherSubTypeEnum = Voucher.VoucherSubTypeEnum || (Voucher.VoucherSubTypeEnum = {}));
})(Voucher || (exports.Voucher = Voucher = {}));
var VoucherSummary;
(function (VoucherSummary) {
    var StatusEnum;
    (function (StatusEnum) {
        StatusEnum[StatusEnum["Valid"] = 'Valid'] = "Valid";
        StatusEnum[StatusEnum["NotYetValid"] = 'NotYetValid'] = "NotYetValid";
        StatusEnum[StatusEnum["Expired"] = 'Expired'] = "Expired";
        StatusEnum[StatusEnum["Used"] = 'Used'] = "Used";
        StatusEnum[StatusEnum["Disabled"] = 'Disabled'] = "Disabled";
    })(StatusEnum = VoucherSummary.StatusEnum || (VoucherSummary.StatusEnum = {}));
    var VoucherTypeEnum;
    (function (VoucherTypeEnum) {
        VoucherTypeEnum[VoucherTypeEnum["PercentageDiscount"] = 'PercentageDiscount'] = "PercentageDiscount";
        VoucherTypeEnum[VoucherTypeEnum["LumpDiscount"] = 'LumpDiscount'] = "LumpDiscount";
        VoucherTypeEnum[VoucherTypeEnum["AddItem"] = 'AddItem'] = "AddItem";
        VoucherTypeEnum[VoucherTypeEnum["CreditNote"] = 'CreditNote'] = "CreditNote";
        VoucherTypeEnum[VoucherTypeEnum["FreeDelivery"] = 'FreeDelivery'] = "FreeDelivery";
    })(VoucherTypeEnum = VoucherSummary.VoucherTypeEnum || (VoucherSummary.VoucherTypeEnum = {}));
    var VoucherSubTypeEnum;
    (function (VoucherSubTypeEnum) {
        VoucherSubTypeEnum[VoucherSubTypeEnum["None"] = 'None'] = "None";
        VoucherSubTypeEnum[VoucherSubTypeEnum["SignUp"] = 'SignUp'] = "SignUp";
        VoucherSubTypeEnum[VoucherSubTypeEnum["Loyalty"] = 'Loyalty'] = "Loyalty";
        VoucherSubTypeEnum[VoucherSubTypeEnum["Loyalty25"] = 'Loyalty25'] = "Loyalty25";
        VoucherSubTypeEnum[VoucherSubTypeEnum["Retention"] = 'Retention'] = "Retention";
        VoucherSubTypeEnum[VoucherSubTypeEnum["SecondaryRetention"] = 'SecondaryRetention'] = "SecondaryRetention";
        VoucherSubTypeEnum[VoucherSubTypeEnum["Custom"] = 'Custom'] = "Custom";
    })(VoucherSubTypeEnum = VoucherSummary.VoucherSubTypeEnum || (VoucherSummary.VoucherSubTypeEnum = {}));
    var ChannelRestrictionsEnum;
    (function (ChannelRestrictionsEnum) {
        ChannelRestrictionsEnum[ChannelRestrictionsEnum["Ios"] = 'Ios'] = "Ios";
        ChannelRestrictionsEnum[ChannelRestrictionsEnum["Android"] = 'Android'] = "Android";
        ChannelRestrictionsEnum[ChannelRestrictionsEnum["Web"] = 'Web'] = "Web";
        ChannelRestrictionsEnum[ChannelRestrictionsEnum["Kiosk"] = 'Kiosk'] = "Kiosk";
        ChannelRestrictionsEnum[ChannelRestrictionsEnum["Pos"] = 'Pos'] = "Pos";
        ChannelRestrictionsEnum[ChannelRestrictionsEnum["Google"] = 'Google'] = "Google";
    })(ChannelRestrictionsEnum = VoucherSummary.ChannelRestrictionsEnum || (VoucherSummary.ChannelRestrictionsEnum = {}));
})(VoucherSummary || (exports.VoucherSummary = VoucherSummary = {}));
var VoucherWithStats;
(function (VoucherWithStats) {
    var StatusEnum;
    (function (StatusEnum) {
        StatusEnum[StatusEnum["Valid"] = 'Valid'] = "Valid";
        StatusEnum[StatusEnum["NotYetValid"] = 'NotYetValid'] = "NotYetValid";
        StatusEnum[StatusEnum["Expired"] = 'Expired'] = "Expired";
        StatusEnum[StatusEnum["Used"] = 'Used'] = "Used";
        StatusEnum[StatusEnum["Disabled"] = 'Disabled'] = "Disabled";
    })(StatusEnum = VoucherWithStats.StatusEnum || (VoucherWithStats.StatusEnum = {}));
    var VoucherTypeEnum;
    (function (VoucherTypeEnum) {
        VoucherTypeEnum[VoucherTypeEnum["PercentageDiscount"] = 'PercentageDiscount'] = "PercentageDiscount";
        VoucherTypeEnum[VoucherTypeEnum["LumpDiscount"] = 'LumpDiscount'] = "LumpDiscount";
        VoucherTypeEnum[VoucherTypeEnum["AddItem"] = 'AddItem'] = "AddItem";
        VoucherTypeEnum[VoucherTypeEnum["CreditNote"] = 'CreditNote'] = "CreditNote";
        VoucherTypeEnum[VoucherTypeEnum["FreeDelivery"] = 'FreeDelivery'] = "FreeDelivery";
    })(VoucherTypeEnum = VoucherWithStats.VoucherTypeEnum || (VoucherWithStats.VoucherTypeEnum = {}));
    var CurrencyEnum;
    (function (CurrencyEnum) {
        CurrencyEnum[CurrencyEnum["EUR"] = 'EUR'] = "EUR";
        CurrencyEnum[CurrencyEnum["USD"] = 'USD'] = "USD";
        CurrencyEnum[CurrencyEnum["GBP"] = 'GBP'] = "GBP";
        CurrencyEnum[CurrencyEnum["CAD"] = 'CAD'] = "CAD";
        CurrencyEnum[CurrencyEnum["AUD"] = 'AUD'] = "AUD";
        CurrencyEnum[CurrencyEnum["DJF"] = 'DJF'] = "DJF";
        CurrencyEnum[CurrencyEnum["ZAR"] = 'ZAR'] = "ZAR";
        CurrencyEnum[CurrencyEnum["ETB"] = 'ETB'] = "ETB";
        CurrencyEnum[CurrencyEnum["AED"] = 'AED'] = "AED";
        CurrencyEnum[CurrencyEnum["BHD"] = 'BHD'] = "BHD";
        CurrencyEnum[CurrencyEnum["DZD"] = 'DZD'] = "DZD";
        CurrencyEnum[CurrencyEnum["EGP"] = 'EGP'] = "EGP";
        CurrencyEnum[CurrencyEnum["IQD"] = 'IQD'] = "IQD";
        CurrencyEnum[CurrencyEnum["JOD"] = 'JOD'] = "JOD";
        CurrencyEnum[CurrencyEnum["KWD"] = 'KWD'] = "KWD";
        CurrencyEnum[CurrencyEnum["LBP"] = 'LBP'] = "LBP";
        CurrencyEnum[CurrencyEnum["LYD"] = 'LYD'] = "LYD";
        CurrencyEnum[CurrencyEnum["MAD"] = 'MAD'] = "MAD";
        CurrencyEnum[CurrencyEnum["OMR"] = 'OMR'] = "OMR";
        CurrencyEnum[CurrencyEnum["QAR"] = 'QAR'] = "QAR";
        CurrencyEnum[CurrencyEnum["SAR"] = 'SAR'] = "SAR";
        CurrencyEnum[CurrencyEnum["SYP"] = 'SYP'] = "SYP";
        CurrencyEnum[CurrencyEnum["TND"] = 'TND'] = "TND";
        CurrencyEnum[CurrencyEnum["YER"] = 'YER'] = "YER";
        CurrencyEnum[CurrencyEnum["CLP"] = 'CLP'] = "CLP";
        CurrencyEnum[CurrencyEnum["INR"] = 'INR'] = "INR";
        CurrencyEnum[CurrencyEnum["AZN"] = 'AZN'] = "AZN";
        CurrencyEnum[CurrencyEnum["RUB"] = 'RUB'] = "RUB";
        CurrencyEnum[CurrencyEnum["BYN"] = 'BYN'] = "BYN";
        CurrencyEnum[CurrencyEnum["BGN"] = 'BGN'] = "BGN";
        CurrencyEnum[CurrencyEnum["NGN"] = 'NGN'] = "NGN";
        CurrencyEnum[CurrencyEnum["BDT"] = 'BDT'] = "BDT";
        CurrencyEnum[CurrencyEnum["CNY"] = 'CNY'] = "CNY";
        CurrencyEnum[CurrencyEnum["BAM"] = 'BAM'] = "BAM";
        CurrencyEnum[CurrencyEnum["CZK"] = 'CZK'] = "CZK";
        CurrencyEnum[CurrencyEnum["DKK"] = 'DKK'] = "DKK";
        CurrencyEnum[CurrencyEnum["CHF"] = 'CHF'] = "CHF";
        CurrencyEnum[CurrencyEnum["MVR"] = 'MVR'] = "MVR";
        CurrencyEnum[CurrencyEnum["BTN"] = 'BTN'] = "BTN";
        CurrencyEnum[CurrencyEnum["XCD"] = 'XCD'] = "XCD";
        CurrencyEnum[CurrencyEnum["BZD"] = 'BZD'] = "BZD";
        CurrencyEnum[CurrencyEnum["HKD"] = 'HKD'] = "HKD";
        CurrencyEnum[CurrencyEnum["IDR"] = 'IDR'] = "IDR";
        CurrencyEnum[CurrencyEnum["JMD"] = 'JMD'] = "JMD";
        CurrencyEnum[CurrencyEnum["MYR"] = 'MYR'] = "MYR";
        CurrencyEnum[CurrencyEnum["NZD"] = 'NZD'] = "NZD";
        CurrencyEnum[CurrencyEnum["PHP"] = 'PHP'] = "PHP";
        CurrencyEnum[CurrencyEnum["SGD"] = 'SGD'] = "SGD";
        CurrencyEnum[CurrencyEnum["TTD"] = 'TTD'] = "TTD";
        CurrencyEnum[CurrencyEnum["XDR"] = 'XDR'] = "XDR";
        CurrencyEnum[CurrencyEnum["ARS"] = 'ARS'] = "ARS";
        CurrencyEnum[CurrencyEnum["BOB"] = 'BOB'] = "BOB";
        CurrencyEnum[CurrencyEnum["COP"] = 'COP'] = "COP";
        CurrencyEnum[CurrencyEnum["CRC"] = 'CRC'] = "CRC";
        CurrencyEnum[CurrencyEnum["CUP"] = 'CUP'] = "CUP";
        CurrencyEnum[CurrencyEnum["DOP"] = 'DOP'] = "DOP";
        CurrencyEnum[CurrencyEnum["GTQ"] = 'GTQ'] = "GTQ";
        CurrencyEnum[CurrencyEnum["HNL"] = 'HNL'] = "HNL";
        CurrencyEnum[CurrencyEnum["MXN"] = 'MXN'] = "MXN";
        CurrencyEnum[CurrencyEnum["NIO"] = 'NIO'] = "NIO";
        CurrencyEnum[CurrencyEnum["PAB"] = 'PAB'] = "PAB";
        CurrencyEnum[CurrencyEnum["PEN"] = 'PEN'] = "PEN";
        CurrencyEnum[CurrencyEnum["PYG"] = 'PYG'] = "PYG";
        CurrencyEnum[CurrencyEnum["UYU"] = 'UYU'] = "UYU";
        CurrencyEnum[CurrencyEnum["VEF"] = 'VEF'] = "VEF";
        CurrencyEnum[CurrencyEnum["IRR"] = 'IRR'] = "IRR";
        CurrencyEnum[CurrencyEnum["XOF"] = 'XOF'] = "XOF";
        CurrencyEnum[CurrencyEnum["CDF"] = 'CDF'] = "CDF";
        CurrencyEnum[CurrencyEnum["XAF"] = 'XAF'] = "XAF";
        CurrencyEnum[CurrencyEnum["HTG"] = 'HTG'] = "HTG";
        CurrencyEnum[CurrencyEnum["ILS"] = 'ILS'] = "ILS";
        CurrencyEnum[CurrencyEnum["HRK"] = 'HRK'] = "HRK";
        CurrencyEnum[CurrencyEnum["HUF"] = 'HUF'] = "HUF";
        CurrencyEnum[CurrencyEnum["AMD"] = 'AMD'] = "AMD";
        CurrencyEnum[CurrencyEnum["ISK"] = 'ISK'] = "ISK";
        CurrencyEnum[CurrencyEnum["JPY"] = 'JPY'] = "JPY";
        CurrencyEnum[CurrencyEnum["GEL"] = 'GEL'] = "GEL";
        CurrencyEnum[CurrencyEnum["KZT"] = 'KZT'] = "KZT";
        CurrencyEnum[CurrencyEnum["KHR"] = 'KHR'] = "KHR";
        CurrencyEnum[CurrencyEnum["KRW"] = 'KRW'] = "KRW";
        CurrencyEnum[CurrencyEnum["KGS"] = 'KGS'] = "KGS";
        CurrencyEnum[CurrencyEnum["LAK"] = 'LAK'] = "LAK";
        CurrencyEnum[CurrencyEnum["MKD"] = 'MKD'] = "MKD";
        CurrencyEnum[CurrencyEnum["MNT"] = 'MNT'] = "MNT";
        CurrencyEnum[CurrencyEnum["BND"] = 'BND'] = "BND";
        CurrencyEnum[CurrencyEnum["MMK"] = 'MMK'] = "MMK";
        CurrencyEnum[CurrencyEnum["NOK"] = 'NOK'] = "NOK";
        CurrencyEnum[CurrencyEnum["NPR"] = 'NPR'] = "NPR";
        CurrencyEnum[CurrencyEnum["PKR"] = 'PKR'] = "PKR";
        CurrencyEnum[CurrencyEnum["PLN"] = 'PLN'] = "PLN";
        CurrencyEnum[CurrencyEnum["AFN"] = 'AFN'] = "AFN";
        CurrencyEnum[CurrencyEnum["BRL"] = 'BRL'] = "BRL";
        CurrencyEnum[CurrencyEnum["MDL"] = 'MDL'] = "MDL";
        CurrencyEnum[CurrencyEnum["RON"] = 'RON'] = "RON";
        CurrencyEnum[CurrencyEnum["RWF"] = 'RWF'] = "RWF";
        CurrencyEnum[CurrencyEnum["SEK"] = 'SEK'] = "SEK";
        CurrencyEnum[CurrencyEnum["LKR"] = 'LKR'] = "LKR";
        CurrencyEnum[CurrencyEnum["SOS"] = 'SOS'] = "SOS";
        CurrencyEnum[CurrencyEnum["ALL"] = 'ALL'] = "ALL";
        CurrencyEnum[CurrencyEnum["RSD"] = 'RSD'] = "RSD";
        CurrencyEnum[CurrencyEnum["KES"] = 'KES'] = "KES";
        CurrencyEnum[CurrencyEnum["TJS"] = 'TJS'] = "TJS";
        CurrencyEnum[CurrencyEnum["THB"] = 'THB'] = "THB";
        CurrencyEnum[CurrencyEnum["ERN"] = 'ERN'] = "ERN";
        CurrencyEnum[CurrencyEnum["TMT"] = 'TMT'] = "TMT";
        CurrencyEnum[CurrencyEnum["BWP"] = 'BWP'] = "BWP";
        CurrencyEnum[CurrencyEnum["TRY"] = 'TRY'] = "TRY";
        CurrencyEnum[CurrencyEnum["UAH"] = 'UAH'] = "UAH";
        CurrencyEnum[CurrencyEnum["UZS"] = 'UZS'] = "UZS";
        CurrencyEnum[CurrencyEnum["VND"] = 'VND'] = "VND";
        CurrencyEnum[CurrencyEnum["MOP"] = 'MOP'] = "MOP";
        CurrencyEnum[CurrencyEnum["TWD"] = 'TWD'] = "TWD";
        CurrencyEnum[CurrencyEnum["BMD"] = 'BMD'] = "BMD";
    })(CurrencyEnum = VoucherWithStats.CurrencyEnum || (VoucherWithStats.CurrencyEnum = {}));
    var ChannelRestrictionsEnum;
    (function (ChannelRestrictionsEnum) {
        ChannelRestrictionsEnum[ChannelRestrictionsEnum["Ios"] = 'Ios'] = "Ios";
        ChannelRestrictionsEnum[ChannelRestrictionsEnum["Android"] = 'Android'] = "Android";
        ChannelRestrictionsEnum[ChannelRestrictionsEnum["Web"] = 'Web'] = "Web";
        ChannelRestrictionsEnum[ChannelRestrictionsEnum["Kiosk"] = 'Kiosk'] = "Kiosk";
        ChannelRestrictionsEnum[ChannelRestrictionsEnum["Pos"] = 'Pos'] = "Pos";
        ChannelRestrictionsEnum[ChannelRestrictionsEnum["Google"] = 'Google'] = "Google";
    })(ChannelRestrictionsEnum = VoucherWithStats.ChannelRestrictionsEnum || (VoucherWithStats.ChannelRestrictionsEnum = {}));
    var VoucherSubTypeEnum;
    (function (VoucherSubTypeEnum) {
        VoucherSubTypeEnum[VoucherSubTypeEnum["None"] = 'None'] = "None";
        VoucherSubTypeEnum[VoucherSubTypeEnum["SignUp"] = 'SignUp'] = "SignUp";
        VoucherSubTypeEnum[VoucherSubTypeEnum["Loyalty"] = 'Loyalty'] = "Loyalty";
        VoucherSubTypeEnum[VoucherSubTypeEnum["Loyalty25"] = 'Loyalty25'] = "Loyalty25";
        VoucherSubTypeEnum[VoucherSubTypeEnum["Retention"] = 'Retention'] = "Retention";
        VoucherSubTypeEnum[VoucherSubTypeEnum["SecondaryRetention"] = 'SecondaryRetention'] = "SecondaryRetention";
        VoucherSubTypeEnum[VoucherSubTypeEnum["Custom"] = 'Custom'] = "Custom";
    })(VoucherSubTypeEnum = VoucherWithStats.VoucherSubTypeEnum || (VoucherWithStats.VoucherSubTypeEnum = {}));
})(VoucherWithStats || (exports.VoucherWithStats = VoucherWithStats = {}));
var WebsiteImage;
(function (WebsiteImage) {
    var ImageLocationEnum;
    (function (ImageLocationEnum) {
        ImageLocationEnum[ImageLocationEnum["IndexHeader"] = 'IndexHeader'] = "IndexHeader";
        ImageLocationEnum[ImageLocationEnum["IndexAboutSectionLeft"] = 'IndexAboutSectionLeft'] = "IndexAboutSectionLeft";
        ImageLocationEnum[ImageLocationEnum["IndexAboutSectionRight"] = 'IndexAboutSectionRight'] = "IndexAboutSectionRight";
        ImageLocationEnum[ImageLocationEnum["IndexGallery"] = 'IndexGallery'] = "IndexGallery";
        ImageLocationEnum[ImageLocationEnum["IndexOpeningHoursHeader"] = 'IndexOpeningHoursHeader'] = "IndexOpeningHoursHeader";
        ImageLocationEnum[ImageLocationEnum["IndexTestimonialsHeader"] = 'IndexTestimonialsHeader'] = "IndexTestimonialsHeader";
    })(ImageLocationEnum = WebsiteImage.ImageLocationEnum || (WebsiteImage.ImageLocationEnum = {}));
})(WebsiteImage || (exports.WebsiteImage = WebsiteImage = {}));
var WhiteLabelConfigModel;
(function (WhiteLabelConfigModel) {
    var ComplianceTypeEnum;
    (function (ComplianceTypeEnum) {
        ComplianceTypeEnum[ComplianceTypeEnum["Default"] = 'Default'] = "Default";
        ComplianceTypeEnum[ComplianceTypeEnum["GdprCompliance"] = 'GdprCompliance'] = "GdprCompliance";
    })(ComplianceTypeEnum = WhiteLabelConfigModel.ComplianceTypeEnum || (WhiteLabelConfigModel.ComplianceTypeEnum = {}));
})(WhiteLabelConfigModel || (exports.WhiteLabelConfigModel = WhiteLabelConfigModel = {}));
var AccountsApiFetchParamCreator = function (configuration) {
    return {
        answerSignUpQuestion: function (signupStepAction, body, options) {
            if (options === void 0) { options = {}; }
            if (signupStepAction === null || signupStepAction === undefined) {
                throw new RequiredError('signupStepAction', 'Required parameter signupStepAction was null or undefined when calling answerSignUpQuestion.');
            }
            if (body === null || body === undefined) {
                throw new RequiredError('body', 'Required parameter body was null or undefined when calling answerSignUpQuestion.');
            }
            var localVarPath = "/api/v1.0/accounts/signupstep/{signupStepAction}/answer"
                .replace("{".concat("signupStepAction", "}"), encodeURIComponent(String(signupStepAction)));
            var localVarUrlObj = url.parse(localVarPath, true);
            var localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            var localVarHeaderParameter = {};
            var localVarQueryParameter = {};
            if (configuration && configuration.accessToken) {
                var localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("oauth2", ["api"])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }
            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            var needsSerialization = ("number" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body = needsSerialization ? JSON.stringify(body || {}) : (body || "");
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        changePassword: function (ChangePasswordModel, options) {
            if (options === void 0) { options = {}; }
            if (ChangePasswordModel === null || ChangePasswordModel === undefined) {
                throw new RequiredError('ChangePasswordModel', 'Required parameter ChangePasswordModel was null or undefined when calling changePassword.');
            }
            var localVarPath = "/api/v1.0/accounts/password";
            var localVarUrlObj = url.parse(localVarPath, true);
            var localVarRequestOptions = Object.assign({ method: 'PUT' }, options);
            var localVarHeaderParameter = {};
            var localVarQueryParameter = {};
            if (configuration && configuration.accessToken) {
                var localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("oauth2", ["api"])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }
            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            var needsSerialization = ("ChangePasswordModel" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body = needsSerialization ? JSON.stringify(ChangePasswordModel || {}) : (ChangePasswordModel || "");
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        createAccount: function (CreateAccountModel, options) {
            if (options === void 0) { options = {}; }
            if (CreateAccountModel === null || CreateAccountModel === undefined) {
                throw new RequiredError('CreateAccountModel', 'Required parameter CreateAccountModel was null or undefined when calling createAccount.');
            }
            var localVarPath = "/api/v1.0/accounts";
            var localVarUrlObj = url.parse(localVarPath, true);
            var localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            var localVarHeaderParameter = {};
            var localVarQueryParameter = {};
            if (configuration && configuration.accessToken) {
                var localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("oauth2", ["api"])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }
            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            var needsSerialization = ("CreateAccountModel" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body = needsSerialization ? JSON.stringify(CreateAccountModel || {}) : (CreateAccountModel || "");
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        createBasicAccount: function (CreateBasicAccountModel, options) {
            if (options === void 0) { options = {}; }
            if (CreateBasicAccountModel === null || CreateBasicAccountModel === undefined) {
                throw new RequiredError('CreateBasicAccountModel', 'Required parameter CreateBasicAccountModel was null or undefined when calling createBasicAccount.');
            }
            var localVarPath = "/api/v1.0/accounts/basic-account";
            var localVarUrlObj = url.parse(localVarPath, true);
            var localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            var localVarHeaderParameter = {};
            var localVarQueryParameter = {};
            if (configuration && configuration.accessToken) {
                var localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("oauth2", ["api"])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }
            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            var needsSerialization = ("CreateBasicAccountModel" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body = needsSerialization ? JSON.stringify(CreateBasicAccountModel || {}) : (CreateBasicAccountModel || "");
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        getAccountDetails: function (options) {
            if (options === void 0) { options = {}; }
            var localVarPath = "/api/v1.0/accounts";
            var localVarUrlObj = url.parse(localVarPath, true);
            var localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            var localVarHeaderParameter = {};
            var localVarQueryParameter = {};
            if (configuration && configuration.accessToken) {
                var localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("oauth2", ["api"])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        getLocalisedTimeZones: function (options) {
            if (options === void 0) { options = {}; }
            var localVarPath = "/api/v1.0/accounts/timezones";
            var localVarUrlObj = url.parse(localVarPath, true);
            var localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            var localVarHeaderParameter = {};
            var localVarQueryParameter = {};
            if (configuration && configuration.accessToken) {
                var localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("oauth2", ["api"])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        login: function (LoginModel, options) {
            if (options === void 0) { options = {}; }
            if (LoginModel === null || LoginModel === undefined) {
                throw new RequiredError('LoginModel', 'Required parameter LoginModel was null or undefined when calling login.');
            }
            var localVarPath = "/api/v1.0/accounts/login";
            var localVarUrlObj = url.parse(localVarPath, true);
            var localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            var localVarHeaderParameter = {};
            var localVarQueryParameter = {};
            if (configuration && configuration.accessToken) {
                var localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("oauth2", ["api"])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }
            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            var needsSerialization = ("LoginModel" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body = needsSerialization ? JSON.stringify(LoginModel || {}) : (LoginModel || "");
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        loginSso: function (options) {
            if (options === void 0) { options = {}; }
            var localVarPath = "/api/v1.0/accounts/login/sso";
            var localVarUrlObj = url.parse(localVarPath, true);
            var localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            var localVarHeaderParameter = {};
            var localVarQueryParameter = {};
            if (configuration && configuration.accessToken) {
                var localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("oauth2", ["api"])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        logout: function (options) {
            if (options === void 0) { options = {}; }
            var localVarPath = "/api/v1.0/accounts/logout";
            var localVarUrlObj = url.parse(localVarPath, true);
            var localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            var localVarHeaderParameter = {};
            var localVarQueryParameter = {};
            if (configuration && configuration.accessToken) {
                var localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("oauth2", ["api"])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        passwordResetWithToken: function (PasswordResetModel, options) {
            if (options === void 0) { options = {}; }
            if (PasswordResetModel === null || PasswordResetModel === undefined) {
                throw new RequiredError('PasswordResetModel', 'Required parameter PasswordResetModel was null or undefined when calling passwordResetWithToken.');
            }
            var localVarPath = "/api/v1.0/accounts/password";
            var localVarUrlObj = url.parse(localVarPath, true);
            var localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            var localVarHeaderParameter = {};
            var localVarQueryParameter = {};
            if (configuration && configuration.accessToken) {
                var localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("oauth2", ["api"])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }
            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            var needsSerialization = ("PasswordResetModel" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body = needsSerialization ? JSON.stringify(PasswordResetModel || {}) : (PasswordResetModel || "");
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        recaptchaValidate: function (token, options) {
            if (options === void 0) { options = {}; }
            if (token === null || token === undefined) {
                throw new RequiredError('token', 'Required parameter token was null or undefined when calling recaptchaValidate.');
            }
            var localVarPath = "/api/v1.0/accounts/recaptcha";
            var localVarUrlObj = url.parse(localVarPath, true);
            var localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            var localVarHeaderParameter = {};
            var localVarQueryParameter = {};
            if (configuration && configuration.accessToken) {
                var localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("oauth2", ["api"])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }
            if (token !== undefined) {
                localVarQueryParameter['token'] = token;
            }
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        requestPasswordReset: function (RequestPasswordResetModel, options) {
            if (options === void 0) { options = {}; }
            if (RequestPasswordResetModel === null || RequestPasswordResetModel === undefined) {
                throw new RequiredError('RequestPasswordResetModel', 'Required parameter RequestPasswordResetModel was null or undefined when calling requestPasswordReset.');
            }
            var localVarPath = "/api/v1.0/accounts/passwordreset";
            var localVarUrlObj = url.parse(localVarPath, true);
            var localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            var localVarHeaderParameter = {};
            var localVarQueryParameter = {};
            if (configuration && configuration.accessToken) {
                var localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("oauth2", ["api"])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }
            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            var needsSerialization = ("RequestPasswordResetModel" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body = needsSerialization ? JSON.stringify(RequestPasswordResetModel || {}) : (RequestPasswordResetModel || "");
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        skipSignupStep: function (signupStepAction, options) {
            if (options === void 0) { options = {}; }
            if (signupStepAction === null || signupStepAction === undefined) {
                throw new RequiredError('signupStepAction', 'Required parameter signupStepAction was null or undefined when calling skipSignupStep.');
            }
            var localVarPath = "/api/v1.0/accounts/signupstep/{signupStepAction}/skip"
                .replace("{".concat("signupStepAction", "}"), encodeURIComponent(String(signupStepAction)));
            var localVarUrlObj = url.parse(localVarPath, true);
            var localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            var localVarHeaderParameter = {};
            var localVarQueryParameter = {};
            if (configuration && configuration.accessToken) {
                var localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("oauth2", ["api"])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        updateAccount: function (AccountDetailBase, options) {
            if (options === void 0) { options = {}; }
            if (AccountDetailBase === null || AccountDetailBase === undefined) {
                throw new RequiredError('AccountDetailBase', 'Required parameter AccountDetailBase was null or undefined when calling updateAccount.');
            }
            var localVarPath = "/api/v1.0/accounts";
            var localVarUrlObj = url.parse(localVarPath, true);
            var localVarRequestOptions = Object.assign({ method: 'PUT' }, options);
            var localVarHeaderParameter = {};
            var localVarQueryParameter = {};
            if (configuration && configuration.accessToken) {
                var localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("oauth2", ["api"])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }
            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            var needsSerialization = ("AccountDetailBase" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body = needsSerialization ? JSON.stringify(AccountDetailBase || {}) : (AccountDetailBase || "");
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    };
};
exports.AccountsApiFetchParamCreator = AccountsApiFetchParamCreator;
var AccountsApiFp = function (configuration) {
    return {
        answerSignUpQuestion: function (signupStepAction, body, options) {
            var localVarFetchArgs = (0, exports.AccountsApiFetchParamCreator)(configuration).answerSignUpQuestion(signupStepAction, body, options);
            return function (fetch, basePath) {
                if (fetch === void 0) { fetch = portableFetch; }
                if (basePath === void 0) { basePath = BASE_PATH; }
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then(function (response) {
                    if (response.status >= 200 && response.status < 300) {
                        return response;
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
        changePassword: function (ChangePasswordModel, options) {
            var localVarFetchArgs = (0, exports.AccountsApiFetchParamCreator)(configuration).changePassword(ChangePasswordModel, options);
            return function (fetch, basePath) {
                if (fetch === void 0) { fetch = portableFetch; }
                if (basePath === void 0) { basePath = BASE_PATH; }
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then(function (response) {
                    if (response.status >= 200 && response.status < 300) {
                        return response;
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
        createAccount: function (CreateAccountModel, options) {
            var localVarFetchArgs = (0, exports.AccountsApiFetchParamCreator)(configuration).createAccount(CreateAccountModel, options);
            return function (fetch, basePath) {
                if (fetch === void 0) { fetch = portableFetch; }
                if (basePath === void 0) { basePath = BASE_PATH; }
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then(function (response) {
                    if (response.status >= 200 && response.status < 300) {
                        return response;
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
        createBasicAccount: function (CreateBasicAccountModel, options) {
            var localVarFetchArgs = (0, exports.AccountsApiFetchParamCreator)(configuration).createBasicAccount(CreateBasicAccountModel, options);
            return function (fetch, basePath) {
                if (fetch === void 0) { fetch = portableFetch; }
                if (basePath === void 0) { basePath = BASE_PATH; }
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then(function (response) {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
        getAccountDetails: function (options) {
            var localVarFetchArgs = (0, exports.AccountsApiFetchParamCreator)(configuration).getAccountDetails(options);
            return function (fetch, basePath) {
                if (fetch === void 0) { fetch = portableFetch; }
                if (basePath === void 0) { basePath = BASE_PATH; }
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then(function (response) {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
        getLocalisedTimeZones: function (options) {
            var localVarFetchArgs = (0, exports.AccountsApiFetchParamCreator)(configuration).getLocalisedTimeZones(options);
            return function (fetch, basePath) {
                if (fetch === void 0) { fetch = portableFetch; }
                if (basePath === void 0) { basePath = BASE_PATH; }
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then(function (response) {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
        login: function (LoginModel, options) {
            var localVarFetchArgs = (0, exports.AccountsApiFetchParamCreator)(configuration).login(LoginModel, options);
            return function (fetch, basePath) {
                if (fetch === void 0) { fetch = portableFetch; }
                if (basePath === void 0) { basePath = BASE_PATH; }
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then(function (response) {
                    if (response.status >= 200 && response.status < 300) {
                        return response;
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
        loginSso: function (options) {
            var localVarFetchArgs = (0, exports.AccountsApiFetchParamCreator)(configuration).loginSso(options);
            return function (fetch, basePath) {
                if (fetch === void 0) { fetch = portableFetch; }
                if (basePath === void 0) { basePath = BASE_PATH; }
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then(function (response) {
                    if (response.status >= 200 && response.status < 300) {
                        return response;
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
        logout: function (options) {
            var localVarFetchArgs = (0, exports.AccountsApiFetchParamCreator)(configuration).logout(options);
            return function (fetch, basePath) {
                if (fetch === void 0) { fetch = portableFetch; }
                if (basePath === void 0) { basePath = BASE_PATH; }
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then(function (response) {
                    if (response.status >= 200 && response.status < 300) {
                        return response;
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
        passwordResetWithToken: function (PasswordResetModel, options) {
            var localVarFetchArgs = (0, exports.AccountsApiFetchParamCreator)(configuration).passwordResetWithToken(PasswordResetModel, options);
            return function (fetch, basePath) {
                if (fetch === void 0) { fetch = portableFetch; }
                if (basePath === void 0) { basePath = BASE_PATH; }
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then(function (response) {
                    if (response.status >= 200 && response.status < 300) {
                        return response;
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
        recaptchaValidate: function (token, options) {
            var localVarFetchArgs = (0, exports.AccountsApiFetchParamCreator)(configuration).recaptchaValidate(token, options);
            return function (fetch, basePath) {
                if (fetch === void 0) { fetch = portableFetch; }
                if (basePath === void 0) { basePath = BASE_PATH; }
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then(function (response) {
                    if (response.status >= 200 && response.status < 300) {
                        return response;
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
        requestPasswordReset: function (RequestPasswordResetModel, options) {
            var localVarFetchArgs = (0, exports.AccountsApiFetchParamCreator)(configuration).requestPasswordReset(RequestPasswordResetModel, options);
            return function (fetch, basePath) {
                if (fetch === void 0) { fetch = portableFetch; }
                if (basePath === void 0) { basePath = BASE_PATH; }
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then(function (response) {
                    if (response.status >= 200 && response.status < 300) {
                        return response;
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
        skipSignupStep: function (signupStepAction, options) {
            var localVarFetchArgs = (0, exports.AccountsApiFetchParamCreator)(configuration).skipSignupStep(signupStepAction, options);
            return function (fetch, basePath) {
                if (fetch === void 0) { fetch = portableFetch; }
                if (basePath === void 0) { basePath = BASE_PATH; }
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then(function (response) {
                    if (response.status >= 200 && response.status < 300) {
                        return response;
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
        updateAccount: function (AccountDetailBase, options) {
            var localVarFetchArgs = (0, exports.AccountsApiFetchParamCreator)(configuration).updateAccount(AccountDetailBase, options);
            return function (fetch, basePath) {
                if (fetch === void 0) { fetch = portableFetch; }
                if (basePath === void 0) { basePath = BASE_PATH; }
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then(function (response) {
                    if (response.status >= 200 && response.status < 300) {
                        return response;
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
    };
};
exports.AccountsApiFp = AccountsApiFp;
var AccountsApiFactory = function (configuration, fetch, basePath) {
    return {
        answerSignUpQuestion: function (signupStepAction, body, options) {
            return (0, exports.AccountsApiFp)(configuration).answerSignUpQuestion(signupStepAction, body, options)(fetch, basePath);
        },
        changePassword: function (ChangePasswordModel, options) {
            return (0, exports.AccountsApiFp)(configuration).changePassword(ChangePasswordModel, options)(fetch, basePath);
        },
        createAccount: function (CreateAccountModel, options) {
            return (0, exports.AccountsApiFp)(configuration).createAccount(CreateAccountModel, options)(fetch, basePath);
        },
        createBasicAccount: function (CreateBasicAccountModel, options) {
            return (0, exports.AccountsApiFp)(configuration).createBasicAccount(CreateBasicAccountModel, options)(fetch, basePath);
        },
        getAccountDetails: function (options) {
            return (0, exports.AccountsApiFp)(configuration).getAccountDetails(options)(fetch, basePath);
        },
        getLocalisedTimeZones: function (options) {
            return (0, exports.AccountsApiFp)(configuration).getLocalisedTimeZones(options)(fetch, basePath);
        },
        login: function (LoginModel, options) {
            return (0, exports.AccountsApiFp)(configuration).login(LoginModel, options)(fetch, basePath);
        },
        loginSso: function (options) {
            return (0, exports.AccountsApiFp)(configuration).loginSso(options)(fetch, basePath);
        },
        logout: function (options) {
            return (0, exports.AccountsApiFp)(configuration).logout(options)(fetch, basePath);
        },
        passwordResetWithToken: function (PasswordResetModel, options) {
            return (0, exports.AccountsApiFp)(configuration).passwordResetWithToken(PasswordResetModel, options)(fetch, basePath);
        },
        recaptchaValidate: function (token, options) {
            return (0, exports.AccountsApiFp)(configuration).recaptchaValidate(token, options)(fetch, basePath);
        },
        requestPasswordReset: function (RequestPasswordResetModel, options) {
            return (0, exports.AccountsApiFp)(configuration).requestPasswordReset(RequestPasswordResetModel, options)(fetch, basePath);
        },
        skipSignupStep: function (signupStepAction, options) {
            return (0, exports.AccountsApiFp)(configuration).skipSignupStep(signupStepAction, options)(fetch, basePath);
        },
        updateAccount: function (AccountDetailBase, options) {
            return (0, exports.AccountsApiFp)(configuration).updateAccount(AccountDetailBase, options)(fetch, basePath);
        },
    };
};
exports.AccountsApiFactory = AccountsApiFactory;
var AccountsApi = (function (_super) {
    __extends(AccountsApi, _super);
    function AccountsApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    AccountsApi.prototype.answerSignUpQuestion = function (signupStepAction, body, options) {
        return (0, exports.AccountsApiFp)(this.configuration).answerSignUpQuestion(signupStepAction, body, options)(this.fetch, this.basePath);
    };
    AccountsApi.prototype.changePassword = function (ChangePasswordModel, options) {
        return (0, exports.AccountsApiFp)(this.configuration).changePassword(ChangePasswordModel, options)(this.fetch, this.basePath);
    };
    AccountsApi.prototype.createAccount = function (CreateAccountModel, options) {
        return (0, exports.AccountsApiFp)(this.configuration).createAccount(CreateAccountModel, options)(this.fetch, this.basePath);
    };
    AccountsApi.prototype.createBasicAccount = function (CreateBasicAccountModel, options) {
        return (0, exports.AccountsApiFp)(this.configuration).createBasicAccount(CreateBasicAccountModel, options)(this.fetch, this.basePath);
    };
    AccountsApi.prototype.getAccountDetails = function (options) {
        return (0, exports.AccountsApiFp)(this.configuration).getAccountDetails(options)(this.fetch, this.basePath);
    };
    AccountsApi.prototype.getLocalisedTimeZones = function (options) {
        return (0, exports.AccountsApiFp)(this.configuration).getLocalisedTimeZones(options)(this.fetch, this.basePath);
    };
    AccountsApi.prototype.login = function (LoginModel, options) {
        return (0, exports.AccountsApiFp)(this.configuration).login(LoginModel, options)(this.fetch, this.basePath);
    };
    AccountsApi.prototype.loginSso = function (options) {
        return (0, exports.AccountsApiFp)(this.configuration).loginSso(options)(this.fetch, this.basePath);
    };
    AccountsApi.prototype.logout = function (options) {
        return (0, exports.AccountsApiFp)(this.configuration).logout(options)(this.fetch, this.basePath);
    };
    AccountsApi.prototype.passwordResetWithToken = function (PasswordResetModel, options) {
        return (0, exports.AccountsApiFp)(this.configuration).passwordResetWithToken(PasswordResetModel, options)(this.fetch, this.basePath);
    };
    AccountsApi.prototype.recaptchaValidate = function (token, options) {
        return (0, exports.AccountsApiFp)(this.configuration).recaptchaValidate(token, options)(this.fetch, this.basePath);
    };
    AccountsApi.prototype.requestPasswordReset = function (RequestPasswordResetModel, options) {
        return (0, exports.AccountsApiFp)(this.configuration).requestPasswordReset(RequestPasswordResetModel, options)(this.fetch, this.basePath);
    };
    AccountsApi.prototype.skipSignupStep = function (signupStepAction, options) {
        return (0, exports.AccountsApiFp)(this.configuration).skipSignupStep(signupStepAction, options)(this.fetch, this.basePath);
    };
    AccountsApi.prototype.updateAccount = function (AccountDetailBase, options) {
        return (0, exports.AccountsApiFp)(this.configuration).updateAccount(AccountDetailBase, options)(this.fetch, this.basePath);
    };
    return AccountsApi;
}(BaseAPI));
exports.AccountsApi = AccountsApi;
var AddressApiFetchParamCreator = function (configuration) {
    return {
        addressTemplates: function (StoreAddressForm, options) {
            if (options === void 0) { options = {}; }
            if (StoreAddressForm === null || StoreAddressForm === undefined) {
                throw new RequiredError('StoreAddressForm', 'Required parameter StoreAddressForm was null or undefined when calling addressTemplates.');
            }
            var localVarPath = "/api/v1.0/address/templates";
            var localVarUrlObj = url.parse(localVarPath, true);
            var localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            var localVarHeaderParameter = {};
            var localVarQueryParameter = {};
            if (configuration && configuration.accessToken) {
                var localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("oauth2", ["api"])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }
            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            var needsSerialization = ("StoreAddressForm" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body = needsSerialization ? JSON.stringify(StoreAddressForm || {}) : (StoreAddressForm || "");
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        formByApp: function (appId, language, options) {
            if (options === void 0) { options = {}; }
            if (appId === null || appId === undefined) {
                throw new RequiredError('appId', 'Required parameter appId was null or undefined when calling formByApp.');
            }
            var localVarPath = "/api/v1.0/app/{appId}/address/form"
                .replace("{".concat("appId", "}"), encodeURIComponent(String(appId)));
            var localVarUrlObj = url.parse(localVarPath, true);
            var localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            var localVarHeaderParameter = {};
            var localVarQueryParameter = {};
            if (configuration && configuration.accessToken) {
                var localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("oauth2", ["api"])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }
            if (language !== undefined) {
                localVarQueryParameter['language'] = language;
            }
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        formByCountry: function (countryCode, language, options) {
            if (options === void 0) { options = {}; }
            if (countryCode === null || countryCode === undefined) {
                throw new RequiredError('countryCode', 'Required parameter countryCode was null or undefined when calling formByCountry.');
            }
            var localVarPath = "/api/v1.0/address/country/{countryCode}/form"
                .replace("{".concat("countryCode", "}"), encodeURIComponent(String(countryCode)));
            var localVarUrlObj = url.parse(localVarPath, true);
            var localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            var localVarHeaderParameter = {};
            var localVarQueryParameter = {};
            if (configuration && configuration.accessToken) {
                var localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("oauth2", ["api"])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }
            if (language !== undefined) {
                localVarQueryParameter['language'] = language;
            }
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        formatGoogleAddress: function (GoogleAddress, language, options) {
            if (options === void 0) { options = {}; }
            if (GoogleAddress === null || GoogleAddress === undefined) {
                throw new RequiredError('GoogleAddress', 'Required parameter GoogleAddress was null or undefined when calling formatGoogleAddress.');
            }
            var localVarPath = "/api/v1.0/address/google";
            var localVarUrlObj = url.parse(localVarPath, true);
            var localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            var localVarHeaderParameter = {};
            var localVarQueryParameter = {};
            if (configuration && configuration.accessToken) {
                var localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("oauth2", ["api"])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }
            if (language !== undefined) {
                localVarQueryParameter['language'] = language;
            }
            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            var needsSerialization = ("GoogleAddress" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body = needsSerialization ? JSON.stringify(GoogleAddress || {}) : (GoogleAddress || "");
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        getCountries: function (language, options) {
            if (options === void 0) { options = {}; }
            var localVarPath = "/api/v1.0/address/countries";
            var localVarUrlObj = url.parse(localVarPath, true);
            var localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            var localVarHeaderParameter = {};
            var localVarQueryParameter = {};
            if (configuration && configuration.accessToken) {
                var localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("oauth2", ["api"])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }
            if (language !== undefined) {
                localVarQueryParameter['language'] = language;
            }
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    };
};
exports.AddressApiFetchParamCreator = AddressApiFetchParamCreator;
var AddressApiFp = function (configuration) {
    return {
        addressTemplates: function (StoreAddressForm, options) {
            var localVarFetchArgs = (0, exports.AddressApiFetchParamCreator)(configuration).addressTemplates(StoreAddressForm, options);
            return function (fetch, basePath) {
                if (fetch === void 0) { fetch = portableFetch; }
                if (basePath === void 0) { basePath = BASE_PATH; }
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then(function (response) {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
        formByApp: function (appId, language, options) {
            var localVarFetchArgs = (0, exports.AddressApiFetchParamCreator)(configuration).formByApp(appId, language, options);
            return function (fetch, basePath) {
                if (fetch === void 0) { fetch = portableFetch; }
                if (basePath === void 0) { basePath = BASE_PATH; }
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then(function (response) {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
        formByCountry: function (countryCode, language, options) {
            var localVarFetchArgs = (0, exports.AddressApiFetchParamCreator)(configuration).formByCountry(countryCode, language, options);
            return function (fetch, basePath) {
                if (fetch === void 0) { fetch = portableFetch; }
                if (basePath === void 0) { basePath = BASE_PATH; }
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then(function (response) {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
        formatGoogleAddress: function (GoogleAddress, language, options) {
            var localVarFetchArgs = (0, exports.AddressApiFetchParamCreator)(configuration).formatGoogleAddress(GoogleAddress, language, options);
            return function (fetch, basePath) {
                if (fetch === void 0) { fetch = portableFetch; }
                if (basePath === void 0) { basePath = BASE_PATH; }
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then(function (response) {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
        getCountries: function (language, options) {
            var localVarFetchArgs = (0, exports.AddressApiFetchParamCreator)(configuration).getCountries(language, options);
            return function (fetch, basePath) {
                if (fetch === void 0) { fetch = portableFetch; }
                if (basePath === void 0) { basePath = BASE_PATH; }
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then(function (response) {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
    };
};
exports.AddressApiFp = AddressApiFp;
var AddressApiFactory = function (configuration, fetch, basePath) {
    return {
        addressTemplates: function (StoreAddressForm, options) {
            return (0, exports.AddressApiFp)(configuration).addressTemplates(StoreAddressForm, options)(fetch, basePath);
        },
        formByApp: function (appId, language, options) {
            return (0, exports.AddressApiFp)(configuration).formByApp(appId, language, options)(fetch, basePath);
        },
        formByCountry: function (countryCode, language, options) {
            return (0, exports.AddressApiFp)(configuration).formByCountry(countryCode, language, options)(fetch, basePath);
        },
        formatGoogleAddress: function (GoogleAddress, language, options) {
            return (0, exports.AddressApiFp)(configuration).formatGoogleAddress(GoogleAddress, language, options)(fetch, basePath);
        },
        getCountries: function (language, options) {
            return (0, exports.AddressApiFp)(configuration).getCountries(language, options)(fetch, basePath);
        },
    };
};
exports.AddressApiFactory = AddressApiFactory;
var AddressApi = (function (_super) {
    __extends(AddressApi, _super);
    function AddressApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    AddressApi.prototype.addressTemplates = function (StoreAddressForm, options) {
        return (0, exports.AddressApiFp)(this.configuration).addressTemplates(StoreAddressForm, options)(this.fetch, this.basePath);
    };
    AddressApi.prototype.formByApp = function (appId, language, options) {
        return (0, exports.AddressApiFp)(this.configuration).formByApp(appId, language, options)(this.fetch, this.basePath);
    };
    AddressApi.prototype.formByCountry = function (countryCode, language, options) {
        return (0, exports.AddressApiFp)(this.configuration).formByCountry(countryCode, language, options)(this.fetch, this.basePath);
    };
    AddressApi.prototype.formatGoogleAddress = function (GoogleAddress, language, options) {
        return (0, exports.AddressApiFp)(this.configuration).formatGoogleAddress(GoogleAddress, language, options)(this.fetch, this.basePath);
    };
    AddressApi.prototype.getCountries = function (language, options) {
        return (0, exports.AddressApiFp)(this.configuration).getCountries(language, options)(this.fetch, this.basePath);
    };
    return AddressApi;
}(BaseAPI));
exports.AddressApi = AddressApi;
var ApmApiFetchParamCreator = function (configuration) {
    return {
        getApmStatus: function (appId, options) {
            if (options === void 0) { options = {}; }
            if (appId === null || appId === undefined) {
                throw new RequiredError('appId', 'Required parameter appId was null or undefined when calling getApmStatus.');
            }
            var localVarPath = "/api/v1.0/{appId}/apm/status"
                .replace("{".concat("appId", "}"), encodeURIComponent(String(appId)));
            var localVarUrlObj = url.parse(localVarPath, true);
            var localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            var localVarHeaderParameter = {};
            var localVarQueryParameter = {};
            if (configuration && configuration.accessToken) {
                var localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("oauth2", ["api"])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        getBasicStatistics: function (appId, storeId, options) {
            if (options === void 0) { options = {}; }
            if (appId === null || appId === undefined) {
                throw new RequiredError('appId', 'Required parameter appId was null or undefined when calling getBasicStatistics.');
            }
            var localVarPath = "/api/v1.0/{appId}/apm/statistics"
                .replace("{".concat("appId", "}"), encodeURIComponent(String(appId)));
            var localVarUrlObj = url.parse(localVarPath, true);
            var localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            var localVarHeaderParameter = {};
            var localVarQueryParameter = {};
            if (configuration && configuration.accessToken) {
                var localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("oauth2", ["api"])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }
            if (storeId) {
                localVarQueryParameter['storeId'] = storeId;
            }
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        getCalendarWeekStatistics: function (appId, storeId, options) {
            if (options === void 0) { options = {}; }
            if (appId === null || appId === undefined) {
                throw new RequiredError('appId', 'Required parameter appId was null or undefined when calling getCalendarWeekStatistics.');
            }
            var localVarPath = "/api/v1.0/{appId}/apm/statistics/calendar"
                .replace("{".concat("appId", "}"), encodeURIComponent(String(appId)));
            var localVarUrlObj = url.parse(localVarPath, true);
            var localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            var localVarHeaderParameter = {};
            var localVarQueryParameter = {};
            if (configuration && configuration.accessToken) {
                var localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("oauth2", ["api"])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }
            if (storeId) {
                localVarQueryParameter['storeId'] = storeId;
            }
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        getCallsStatistics: function (appId, aggregateDataBy, dataPointLimit, storeId, options) {
            if (options === void 0) { options = {}; }
            if (appId === null || appId === undefined) {
                throw new RequiredError('appId', 'Required parameter appId was null or undefined when calling getCallsStatistics.');
            }
            if (aggregateDataBy === null || aggregateDataBy === undefined) {
                throw new RequiredError('aggregateDataBy', 'Required parameter aggregateDataBy was null or undefined when calling getCallsStatistics.');
            }
            var localVarPath = "/api/v1.0/{appId}/apm/statistics/calls/{aggregateDataBy}"
                .replace("{".concat("appId", "}"), encodeURIComponent(String(appId)))
                .replace("{".concat("aggregateDataBy", "}"), encodeURIComponent(String(aggregateDataBy)));
            var localVarUrlObj = url.parse(localVarPath, true);
            var localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            var localVarHeaderParameter = {};
            var localVarQueryParameter = {};
            if (configuration && configuration.accessToken) {
                var localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("oauth2", ["api"])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }
            if (dataPointLimit !== undefined) {
                localVarQueryParameter['dataPointLimit'] = dataPointLimit;
            }
            if (storeId) {
                localVarQueryParameter['storeId'] = storeId;
            }
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        getOrderStatistics: function (appId, aggregateDataBy, dataPointLimit, storeId, options) {
            if (options === void 0) { options = {}; }
            if (appId === null || appId === undefined) {
                throw new RequiredError('appId', 'Required parameter appId was null or undefined when calling getOrderStatistics.');
            }
            if (aggregateDataBy === null || aggregateDataBy === undefined) {
                throw new RequiredError('aggregateDataBy', 'Required parameter aggregateDataBy was null or undefined when calling getOrderStatistics.');
            }
            var localVarPath = "/api/v1.0/{appId}/apm/statistics/orders/{aggregateDataBy}"
                .replace("{".concat("appId", "}"), encodeURIComponent(String(appId)))
                .replace("{".concat("aggregateDataBy", "}"), encodeURIComponent(String(aggregateDataBy)));
            var localVarUrlObj = url.parse(localVarPath, true);
            var localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            var localVarHeaderParameter = {};
            var localVarQueryParameter = {};
            if (configuration && configuration.accessToken) {
                var localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("oauth2", ["api"])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }
            if (dataPointLimit !== undefined) {
                localVarQueryParameter['dataPointLimit'] = dataPointLimit;
            }
            if (storeId) {
                localVarQueryParameter['storeId'] = storeId;
            }
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        getPaginatedCallList: function (appId, page, limit, storeId, options) {
            if (options === void 0) { options = {}; }
            if (appId === null || appId === undefined) {
                throw new RequiredError('appId', 'Required parameter appId was null or undefined when calling getPaginatedCallList.');
            }
            var localVarPath = "/api/v1.0/{appId}/apm/calls"
                .replace("{".concat("appId", "}"), encodeURIComponent(String(appId)));
            var localVarUrlObj = url.parse(localVarPath, true);
            var localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            var localVarHeaderParameter = {};
            var localVarQueryParameter = {};
            if (configuration && configuration.accessToken) {
                var localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("oauth2", ["api"])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }
            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }
            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }
            if (storeId) {
                localVarQueryParameter['storeId'] = storeId;
            }
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    };
};
exports.ApmApiFetchParamCreator = ApmApiFetchParamCreator;
var ApmApiFp = function (configuration) {
    return {
        getApmStatus: function (appId, options) {
            var localVarFetchArgs = (0, exports.ApmApiFetchParamCreator)(configuration).getApmStatus(appId, options);
            return function (fetch, basePath) {
                if (fetch === void 0) { fetch = portableFetch; }
                if (basePath === void 0) { basePath = BASE_PATH; }
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then(function (response) {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
        getBasicStatistics: function (appId, storeId, options) {
            var localVarFetchArgs = (0, exports.ApmApiFetchParamCreator)(configuration).getBasicStatistics(appId, storeId, options);
            return function (fetch, basePath) {
                if (fetch === void 0) { fetch = portableFetch; }
                if (basePath === void 0) { basePath = BASE_PATH; }
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then(function (response) {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
        getCalendarWeekStatistics: function (appId, storeId, options) {
            var localVarFetchArgs = (0, exports.ApmApiFetchParamCreator)(configuration).getCalendarWeekStatistics(appId, storeId, options);
            return function (fetch, basePath) {
                if (fetch === void 0) { fetch = portableFetch; }
                if (basePath === void 0) { basePath = BASE_PATH; }
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then(function (response) {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
        getCallsStatistics: function (appId, aggregateDataBy, dataPointLimit, storeId, options) {
            var localVarFetchArgs = (0, exports.ApmApiFetchParamCreator)(configuration).getCallsStatistics(appId, aggregateDataBy, dataPointLimit, storeId, options);
            return function (fetch, basePath) {
                if (fetch === void 0) { fetch = portableFetch; }
                if (basePath === void 0) { basePath = BASE_PATH; }
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then(function (response) {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
        getOrderStatistics: function (appId, aggregateDataBy, dataPointLimit, storeId, options) {
            var localVarFetchArgs = (0, exports.ApmApiFetchParamCreator)(configuration).getOrderStatistics(appId, aggregateDataBy, dataPointLimit, storeId, options);
            return function (fetch, basePath) {
                if (fetch === void 0) { fetch = portableFetch; }
                if (basePath === void 0) { basePath = BASE_PATH; }
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then(function (response) {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
        getPaginatedCallList: function (appId, page, limit, storeId, options) {
            var localVarFetchArgs = (0, exports.ApmApiFetchParamCreator)(configuration).getPaginatedCallList(appId, page, limit, storeId, options);
            return function (fetch, basePath) {
                if (fetch === void 0) { fetch = portableFetch; }
                if (basePath === void 0) { basePath = BASE_PATH; }
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then(function (response) {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
    };
};
exports.ApmApiFp = ApmApiFp;
var ApmApiFactory = function (configuration, fetch, basePath) {
    return {
        getApmStatus: function (appId, options) {
            return (0, exports.ApmApiFp)(configuration).getApmStatus(appId, options)(fetch, basePath);
        },
        getBasicStatistics: function (appId, storeId, options) {
            return (0, exports.ApmApiFp)(configuration).getBasicStatistics(appId, storeId, options)(fetch, basePath);
        },
        getCalendarWeekStatistics: function (appId, storeId, options) {
            return (0, exports.ApmApiFp)(configuration).getCalendarWeekStatistics(appId, storeId, options)(fetch, basePath);
        },
        getCallsStatistics: function (appId, aggregateDataBy, dataPointLimit, storeId, options) {
            return (0, exports.ApmApiFp)(configuration).getCallsStatistics(appId, aggregateDataBy, dataPointLimit, storeId, options)(fetch, basePath);
        },
        getOrderStatistics: function (appId, aggregateDataBy, dataPointLimit, storeId, options) {
            return (0, exports.ApmApiFp)(configuration).getOrderStatistics(appId, aggregateDataBy, dataPointLimit, storeId, options)(fetch, basePath);
        },
        getPaginatedCallList: function (appId, page, limit, storeId, options) {
            return (0, exports.ApmApiFp)(configuration).getPaginatedCallList(appId, page, limit, storeId, options)(fetch, basePath);
        },
    };
};
exports.ApmApiFactory = ApmApiFactory;
var ApmApi = (function (_super) {
    __extends(ApmApi, _super);
    function ApmApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    ApmApi.prototype.getApmStatus = function (appId, options) {
        return (0, exports.ApmApiFp)(this.configuration).getApmStatus(appId, options)(this.fetch, this.basePath);
    };
    ApmApi.prototype.getBasicStatistics = function (appId, storeId, options) {
        return (0, exports.ApmApiFp)(this.configuration).getBasicStatistics(appId, storeId, options)(this.fetch, this.basePath);
    };
    ApmApi.prototype.getCalendarWeekStatistics = function (appId, storeId, options) {
        return (0, exports.ApmApiFp)(this.configuration).getCalendarWeekStatistics(appId, storeId, options)(this.fetch, this.basePath);
    };
    ApmApi.prototype.getCallsStatistics = function (appId, aggregateDataBy, dataPointLimit, storeId, options) {
        return (0, exports.ApmApiFp)(this.configuration).getCallsStatistics(appId, aggregateDataBy, dataPointLimit, storeId, options)(this.fetch, this.basePath);
    };
    ApmApi.prototype.getOrderStatistics = function (appId, aggregateDataBy, dataPointLimit, storeId, options) {
        return (0, exports.ApmApiFp)(this.configuration).getOrderStatistics(appId, aggregateDataBy, dataPointLimit, storeId, options)(this.fetch, this.basePath);
    };
    ApmApi.prototype.getPaginatedCallList = function (appId, page, limit, storeId, options) {
        return (0, exports.ApmApiFp)(this.configuration).getPaginatedCallList(appId, page, limit, storeId, options)(this.fetch, this.basePath);
    };
    return ApmApi;
}(BaseAPI));
exports.ApmApi = ApmApi;
var AppStoreApiFetchParamCreator = function (configuration) {
    return {
        getAppStoreApp: function (appStoreAppId, appId, options) {
            if (options === void 0) { options = {}; }
            if (appStoreAppId === null || appStoreAppId === undefined) {
                throw new RequiredError('appStoreAppId', 'Required parameter appStoreAppId was null or undefined when calling getAppStoreApp.');
            }
            var localVarPath = "/api/v1.0/appstore/apps/{appStoreAppId}"
                .replace("{".concat("appStoreAppId", "}"), encodeURIComponent(String(appStoreAppId)));
            var localVarUrlObj = url.parse(localVarPath, true);
            var localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            var localVarHeaderParameter = {};
            var localVarQueryParameter = {};
            if (configuration && configuration.accessToken) {
                var localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("oauth2", ["api"])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }
            if (appId !== undefined) {
                localVarQueryParameter['appId'] = appId;
            }
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        getAppStoreApps: function (search, page, limit, excludeNotOwned, showOnlyVerified, options) {
            if (options === void 0) { options = {}; }
            if (search === null || search === undefined) {
                throw new RequiredError('search', 'Required parameter search was null or undefined when calling getAppStoreApps.');
            }
            var localVarPath = "/api/v1.0/appstore/apps";
            var localVarUrlObj = url.parse(localVarPath, true);
            var localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            var localVarHeaderParameter = {};
            var localVarQueryParameter = {};
            if (configuration && configuration.accessToken) {
                var localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("oauth2", ["api"])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }
            if (search !== undefined) {
                localVarQueryParameter['search'] = search;
            }
            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }
            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }
            if (excludeNotOwned !== undefined) {
                localVarQueryParameter['excludeNotOwned'] = excludeNotOwned;
            }
            if (showOnlyVerified !== undefined) {
                localVarQueryParameter['showOnlyVerified'] = showOnlyVerified;
            }
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    };
};
exports.AppStoreApiFetchParamCreator = AppStoreApiFetchParamCreator;
var AppStoreApiFp = function (configuration) {
    return {
        getAppStoreApp: function (appStoreAppId, appId, options) {
            var localVarFetchArgs = (0, exports.AppStoreApiFetchParamCreator)(configuration).getAppStoreApp(appStoreAppId, appId, options);
            return function (fetch, basePath) {
                if (fetch === void 0) { fetch = portableFetch; }
                if (basePath === void 0) { basePath = BASE_PATH; }
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then(function (response) {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
        getAppStoreApps: function (search, page, limit, excludeNotOwned, showOnlyVerified, options) {
            var localVarFetchArgs = (0, exports.AppStoreApiFetchParamCreator)(configuration).getAppStoreApps(search, page, limit, excludeNotOwned, showOnlyVerified, options);
            return function (fetch, basePath) {
                if (fetch === void 0) { fetch = portableFetch; }
                if (basePath === void 0) { basePath = BASE_PATH; }
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then(function (response) {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
    };
};
exports.AppStoreApiFp = AppStoreApiFp;
var AppStoreApiFactory = function (configuration, fetch, basePath) {
    return {
        getAppStoreApp: function (appStoreAppId, appId, options) {
            return (0, exports.AppStoreApiFp)(configuration).getAppStoreApp(appStoreAppId, appId, options)(fetch, basePath);
        },
        getAppStoreApps: function (search, page, limit, excludeNotOwned, showOnlyVerified, options) {
            return (0, exports.AppStoreApiFp)(configuration).getAppStoreApps(search, page, limit, excludeNotOwned, showOnlyVerified, options)(fetch, basePath);
        },
    };
};
exports.AppStoreApiFactory = AppStoreApiFactory;
var AppStoreApi = (function (_super) {
    __extends(AppStoreApi, _super);
    function AppStoreApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    AppStoreApi.prototype.getAppStoreApp = function (appStoreAppId, appId, options) {
        return (0, exports.AppStoreApiFp)(this.configuration).getAppStoreApp(appStoreAppId, appId, options)(this.fetch, this.basePath);
    };
    AppStoreApi.prototype.getAppStoreApps = function (search, page, limit, excludeNotOwned, showOnlyVerified, options) {
        return (0, exports.AppStoreApiFp)(this.configuration).getAppStoreApps(search, page, limit, excludeNotOwned, showOnlyVerified, options)(this.fetch, this.basePath);
    };
    return AppStoreApi;
}(BaseAPI));
exports.AppStoreApi = AppStoreApi;
var AppStoreConfigurationsApiFetchParamCreator = function (configuration) {
    return {
        appStoreConfigurationsAppStoreHandleOauthResponseCode: function (appStoreAppId, options) {
            if (options === void 0) { options = {}; }
            if (appStoreAppId === null || appStoreAppId === undefined) {
                throw new RequiredError('appStoreAppId', 'Required parameter appStoreAppId was null or undefined when calling appStoreConfigurationsAppStoreHandleOauthResponseCode.');
            }
            var localVarPath = "/api/v1.0/appstore/oauthresponse/{appStoreAppId}/responsecode"
                .replace("{".concat("appStoreAppId", "}"), encodeURIComponent(String(appStoreAppId)));
            var localVarUrlObj = url.parse(localVarPath, true);
            var localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            var localVarHeaderParameter = {};
            var localVarQueryParameter = {};
            if (configuration && configuration.accessToken) {
                var localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("oauth2", ["api"])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        createAppStoreConfig: function (appId, appStoreAppId, options) {
            if (options === void 0) { options = {}; }
            if (appId === null || appId === undefined) {
                throw new RequiredError('appId', 'Required parameter appId was null or undefined when calling createAppStoreConfig.');
            }
            if (appStoreAppId === null || appStoreAppId === undefined) {
                throw new RequiredError('appStoreAppId', 'Required parameter appStoreAppId was null or undefined when calling createAppStoreConfig.');
            }
            var localVarPath = "/api/v1.0/{appId}/appstore/apps/{appStoreAppId}/config"
                .replace("{".concat("appId", "}"), encodeURIComponent(String(appId)))
                .replace("{".concat("appStoreAppId", "}"), encodeURIComponent(String(appStoreAppId)));
            var localVarUrlObj = url.parse(localVarPath, true);
            var localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            var localVarHeaderParameter = {};
            var localVarQueryParameter = {};
            if (configuration && configuration.accessToken) {
                var localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("oauth2", ["api"])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        deleteAppStoreConfig: function (appId, appStoreAppId, configId, options) {
            if (options === void 0) { options = {}; }
            if (appId === null || appId === undefined) {
                throw new RequiredError('appId', 'Required parameter appId was null or undefined when calling deleteAppStoreConfig.');
            }
            if (appStoreAppId === null || appStoreAppId === undefined) {
                throw new RequiredError('appStoreAppId', 'Required parameter appStoreAppId was null or undefined when calling deleteAppStoreConfig.');
            }
            if (configId === null || configId === undefined) {
                throw new RequiredError('configId', 'Required parameter configId was null or undefined when calling deleteAppStoreConfig.');
            }
            var localVarPath = "/api/v1.0/{appId}/appstore/apps/{appStoreAppId}/config/{configId}"
                .replace("{".concat("appId", "}"), encodeURIComponent(String(appId)))
                .replace("{".concat("appStoreAppId", "}"), encodeURIComponent(String(appStoreAppId)))
                .replace("{".concat("configId", "}"), encodeURIComponent(String(configId)));
            var localVarUrlObj = url.parse(localVarPath, true);
            var localVarRequestOptions = Object.assign({ method: 'DELETE' }, options);
            var localVarHeaderParameter = {};
            var localVarQueryParameter = {};
            if (configuration && configuration.accessToken) {
                var localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("oauth2", ["api"])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        executeConfigurationAction: function (appId, appStoreAppId, configId, ExecuteConfigurationActionRequest, options) {
            if (options === void 0) { options = {}; }
            if (appId === null || appId === undefined) {
                throw new RequiredError('appId', 'Required parameter appId was null or undefined when calling executeConfigurationAction.');
            }
            if (appStoreAppId === null || appStoreAppId === undefined) {
                throw new RequiredError('appStoreAppId', 'Required parameter appStoreAppId was null or undefined when calling executeConfigurationAction.');
            }
            if (configId === null || configId === undefined) {
                throw new RequiredError('configId', 'Required parameter configId was null or undefined when calling executeConfigurationAction.');
            }
            if (ExecuteConfigurationActionRequest === null || ExecuteConfigurationActionRequest === undefined) {
                throw new RequiredError('ExecuteConfigurationActionRequest', 'Required parameter ExecuteConfigurationActionRequest was null or undefined when calling executeConfigurationAction.');
            }
            var localVarPath = "/api/v1.0/{appId}/appstore/apps/{appStoreAppId}/config/{configId}/action"
                .replace("{".concat("appId", "}"), encodeURIComponent(String(appId)))
                .replace("{".concat("appStoreAppId", "}"), encodeURIComponent(String(appStoreAppId)))
                .replace("{".concat("configId", "}"), encodeURIComponent(String(configId)));
            var localVarUrlObj = url.parse(localVarPath, true);
            var localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            var localVarHeaderParameter = {};
            var localVarQueryParameter = {};
            if (configuration && configuration.accessToken) {
                var localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("oauth2", ["api"])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }
            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            var needsSerialization = ("ExecuteConfigurationActionRequest" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body = needsSerialization ? JSON.stringify(ExecuteConfigurationActionRequest || {}) : (ExecuteConfigurationActionRequest || "");
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        getAppStoreConfig: function (appId, appStoreAppId, configId, options) {
            if (options === void 0) { options = {}; }
            if (appId === null || appId === undefined) {
                throw new RequiredError('appId', 'Required parameter appId was null or undefined when calling getAppStoreConfig.');
            }
            if (appStoreAppId === null || appStoreAppId === undefined) {
                throw new RequiredError('appStoreAppId', 'Required parameter appStoreAppId was null or undefined when calling getAppStoreConfig.');
            }
            if (configId === null || configId === undefined) {
                throw new RequiredError('configId', 'Required parameter configId was null or undefined when calling getAppStoreConfig.');
            }
            var localVarPath = "/api/v1.0/{appId}/appstore/apps/{appStoreAppId}/config/{configId}"
                .replace("{".concat("appId", "}"), encodeURIComponent(String(appId)))
                .replace("{".concat("appStoreAppId", "}"), encodeURIComponent(String(appStoreAppId)))
                .replace("{".concat("configId", "}"), encodeURIComponent(String(configId)));
            var localVarUrlObj = url.parse(localVarPath, true);
            var localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            var localVarHeaderParameter = {};
            var localVarQueryParameter = {};
            if (configuration && configuration.accessToken) {
                var localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("oauth2", ["api"])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        getConfiguredAppSingleApp: function (appId, appStoreAppId, options) {
            if (options === void 0) { options = {}; }
            if (appId === null || appId === undefined) {
                throw new RequiredError('appId', 'Required parameter appId was null or undefined when calling getConfiguredAppSingleApp.');
            }
            if (appStoreAppId === null || appStoreAppId === undefined) {
                throw new RequiredError('appStoreAppId', 'Required parameter appStoreAppId was null or undefined when calling getConfiguredAppSingleApp.');
            }
            var localVarPath = "/api/v1.0/{appId}/appstore/apps/{appStoreAppId}"
                .replace("{".concat("appId", "}"), encodeURIComponent(String(appId)))
                .replace("{".concat("appStoreAppId", "}"), encodeURIComponent(String(appStoreAppId)));
            var localVarUrlObj = url.parse(localVarPath, true);
            var localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            var localVarHeaderParameter = {};
            var localVarQueryParameter = {};
            if (configuration && configuration.accessToken) {
                var localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("oauth2", ["api"])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        getConfiguredApps: function (appId, options) {
            if (options === void 0) { options = {}; }
            if (appId === null || appId === undefined) {
                throw new RequiredError('appId', 'Required parameter appId was null or undefined when calling getConfiguredApps.');
            }
            var localVarPath = "/api/v1.0/{appId}/appstore/apps"
                .replace("{".concat("appId", "}"), encodeURIComponent(String(appId)));
            var localVarUrlObj = url.parse(localVarPath, true);
            var localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            var localVarHeaderParameter = {};
            var localVarQueryParameter = {};
            if (configuration && configuration.accessToken) {
                var localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("oauth2", ["api"])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        updateAppStoreConfig: function (appId, appStoreAppId, configId, UpdateAppStoreAppConfiguration, options) {
            if (options === void 0) { options = {}; }
            if (appId === null || appId === undefined) {
                throw new RequiredError('appId', 'Required parameter appId was null or undefined when calling updateAppStoreConfig.');
            }
            if (appStoreAppId === null || appStoreAppId === undefined) {
                throw new RequiredError('appStoreAppId', 'Required parameter appStoreAppId was null or undefined when calling updateAppStoreConfig.');
            }
            if (configId === null || configId === undefined) {
                throw new RequiredError('configId', 'Required parameter configId was null or undefined when calling updateAppStoreConfig.');
            }
            if (UpdateAppStoreAppConfiguration === null || UpdateAppStoreAppConfiguration === undefined) {
                throw new RequiredError('UpdateAppStoreAppConfiguration', 'Required parameter UpdateAppStoreAppConfiguration was null or undefined when calling updateAppStoreConfig.');
            }
            var localVarPath = "/api/v1.0/{appId}/appstore/apps/{appStoreAppId}/config/{configId}"
                .replace("{".concat("appId", "}"), encodeURIComponent(String(appId)))
                .replace("{".concat("appStoreAppId", "}"), encodeURIComponent(String(appStoreAppId)))
                .replace("{".concat("configId", "}"), encodeURIComponent(String(configId)));
            var localVarUrlObj = url.parse(localVarPath, true);
            var localVarRequestOptions = Object.assign({ method: 'PUT' }, options);
            var localVarHeaderParameter = {};
            var localVarQueryParameter = {};
            if (configuration && configuration.accessToken) {
                var localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("oauth2", ["api"])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }
            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            var needsSerialization = ("UpdateAppStoreAppConfiguration" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body = needsSerialization ? JSON.stringify(UpdateAppStoreAppConfiguration || {}) : (UpdateAppStoreAppConfiguration || "");
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        updateAppStoreConfigSettingValues: function (appId, appStoreAppId, configId, UpdateAppStoreAppConfigurationValuesBatch, options) {
            if (options === void 0) { options = {}; }
            if (appId === null || appId === undefined) {
                throw new RequiredError('appId', 'Required parameter appId was null or undefined when calling updateAppStoreConfigSettingValues.');
            }
            if (appStoreAppId === null || appStoreAppId === undefined) {
                throw new RequiredError('appStoreAppId', 'Required parameter appStoreAppId was null or undefined when calling updateAppStoreConfigSettingValues.');
            }
            if (configId === null || configId === undefined) {
                throw new RequiredError('configId', 'Required parameter configId was null or undefined when calling updateAppStoreConfigSettingValues.');
            }
            if (UpdateAppStoreAppConfigurationValuesBatch === null || UpdateAppStoreAppConfigurationValuesBatch === undefined) {
                throw new RequiredError('UpdateAppStoreAppConfigurationValuesBatch', 'Required parameter UpdateAppStoreAppConfigurationValuesBatch was null or undefined when calling updateAppStoreConfigSettingValues.');
            }
            var localVarPath = "/api/v1.0/{appId}/appstore/apps/{appStoreAppId}/config/{configId}/updatesettings"
                .replace("{".concat("appId", "}"), encodeURIComponent(String(appId)))
                .replace("{".concat("appStoreAppId", "}"), encodeURIComponent(String(appStoreAppId)))
                .replace("{".concat("configId", "}"), encodeURIComponent(String(configId)));
            var localVarUrlObj = url.parse(localVarPath, true);
            var localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            var localVarHeaderParameter = {};
            var localVarQueryParameter = {};
            if (configuration && configuration.accessToken) {
                var localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("oauth2", ["api"])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }
            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            var needsSerialization = ("UpdateAppStoreAppConfigurationValuesBatch" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body = needsSerialization ? JSON.stringify(UpdateAppStoreAppConfigurationValuesBatch || {}) : (UpdateAppStoreAppConfigurationValuesBatch || "");
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    };
};
exports.AppStoreConfigurationsApiFetchParamCreator = AppStoreConfigurationsApiFetchParamCreator;
var AppStoreConfigurationsApiFp = function (configuration) {
    return {
        appStoreConfigurationsAppStoreHandleOauthResponseCode: function (appStoreAppId, options) {
            var localVarFetchArgs = (0, exports.AppStoreConfigurationsApiFetchParamCreator)(configuration).appStoreConfigurationsAppStoreHandleOauthResponseCode(appStoreAppId, options);
            return function (fetch, basePath) {
                if (fetch === void 0) { fetch = portableFetch; }
                if (basePath === void 0) { basePath = BASE_PATH; }
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then(function (response) {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
        createAppStoreConfig: function (appId, appStoreAppId, options) {
            var localVarFetchArgs = (0, exports.AppStoreConfigurationsApiFetchParamCreator)(configuration).createAppStoreConfig(appId, appStoreAppId, options);
            return function (fetch, basePath) {
                if (fetch === void 0) { fetch = portableFetch; }
                if (basePath === void 0) { basePath = BASE_PATH; }
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then(function (response) {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
        deleteAppStoreConfig: function (appId, appStoreAppId, configId, options) {
            var localVarFetchArgs = (0, exports.AppStoreConfigurationsApiFetchParamCreator)(configuration).deleteAppStoreConfig(appId, appStoreAppId, configId, options);
            return function (fetch, basePath) {
                if (fetch === void 0) { fetch = portableFetch; }
                if (basePath === void 0) { basePath = BASE_PATH; }
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then(function (response) {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
        executeConfigurationAction: function (appId, appStoreAppId, configId, ExecuteConfigurationActionRequest, options) {
            var localVarFetchArgs = (0, exports.AppStoreConfigurationsApiFetchParamCreator)(configuration).executeConfigurationAction(appId, appStoreAppId, configId, ExecuteConfigurationActionRequest, options);
            return function (fetch, basePath) {
                if (fetch === void 0) { fetch = portableFetch; }
                if (basePath === void 0) { basePath = BASE_PATH; }
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then(function (response) {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
        getAppStoreConfig: function (appId, appStoreAppId, configId, options) {
            var localVarFetchArgs = (0, exports.AppStoreConfigurationsApiFetchParamCreator)(configuration).getAppStoreConfig(appId, appStoreAppId, configId, options);
            return function (fetch, basePath) {
                if (fetch === void 0) { fetch = portableFetch; }
                if (basePath === void 0) { basePath = BASE_PATH; }
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then(function (response) {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
        getConfiguredAppSingleApp: function (appId, appStoreAppId, options) {
            var localVarFetchArgs = (0, exports.AppStoreConfigurationsApiFetchParamCreator)(configuration).getConfiguredAppSingleApp(appId, appStoreAppId, options);
            return function (fetch, basePath) {
                if (fetch === void 0) { fetch = portableFetch; }
                if (basePath === void 0) { basePath = BASE_PATH; }
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then(function (response) {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
        getConfiguredApps: function (appId, options) {
            var localVarFetchArgs = (0, exports.AppStoreConfigurationsApiFetchParamCreator)(configuration).getConfiguredApps(appId, options);
            return function (fetch, basePath) {
                if (fetch === void 0) { fetch = portableFetch; }
                if (basePath === void 0) { basePath = BASE_PATH; }
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then(function (response) {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
        updateAppStoreConfig: function (appId, appStoreAppId, configId, UpdateAppStoreAppConfiguration, options) {
            var localVarFetchArgs = (0, exports.AppStoreConfigurationsApiFetchParamCreator)(configuration).updateAppStoreConfig(appId, appStoreAppId, configId, UpdateAppStoreAppConfiguration, options);
            return function (fetch, basePath) {
                if (fetch === void 0) { fetch = portableFetch; }
                if (basePath === void 0) { basePath = BASE_PATH; }
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then(function (response) {
                    if (response.status >= 200 && response.status < 300) {
                        return response;
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
        updateAppStoreConfigSettingValues: function (appId, appStoreAppId, configId, UpdateAppStoreAppConfigurationValuesBatch, options) {
            var localVarFetchArgs = (0, exports.AppStoreConfigurationsApiFetchParamCreator)(configuration).updateAppStoreConfigSettingValues(appId, appStoreAppId, configId, UpdateAppStoreAppConfigurationValuesBatch, options);
            return function (fetch, basePath) {
                if (fetch === void 0) { fetch = portableFetch; }
                if (basePath === void 0) { basePath = BASE_PATH; }
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then(function (response) {
                    if (response.status >= 200 && response.status < 300) {
                        return response;
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
    };
};
exports.AppStoreConfigurationsApiFp = AppStoreConfigurationsApiFp;
var AppStoreConfigurationsApiFactory = function (configuration, fetch, basePath) {
    return {
        appStoreConfigurationsAppStoreHandleOauthResponseCode: function (appStoreAppId, options) {
            return (0, exports.AppStoreConfigurationsApiFp)(configuration).appStoreConfigurationsAppStoreHandleOauthResponseCode(appStoreAppId, options)(fetch, basePath);
        },
        createAppStoreConfig: function (appId, appStoreAppId, options) {
            return (0, exports.AppStoreConfigurationsApiFp)(configuration).createAppStoreConfig(appId, appStoreAppId, options)(fetch, basePath);
        },
        deleteAppStoreConfig: function (appId, appStoreAppId, configId, options) {
            return (0, exports.AppStoreConfigurationsApiFp)(configuration).deleteAppStoreConfig(appId, appStoreAppId, configId, options)(fetch, basePath);
        },
        executeConfigurationAction: function (appId, appStoreAppId, configId, ExecuteConfigurationActionRequest, options) {
            return (0, exports.AppStoreConfigurationsApiFp)(configuration).executeConfigurationAction(appId, appStoreAppId, configId, ExecuteConfigurationActionRequest, options)(fetch, basePath);
        },
        getAppStoreConfig: function (appId, appStoreAppId, configId, options) {
            return (0, exports.AppStoreConfigurationsApiFp)(configuration).getAppStoreConfig(appId, appStoreAppId, configId, options)(fetch, basePath);
        },
        getConfiguredAppSingleApp: function (appId, appStoreAppId, options) {
            return (0, exports.AppStoreConfigurationsApiFp)(configuration).getConfiguredAppSingleApp(appId, appStoreAppId, options)(fetch, basePath);
        },
        getConfiguredApps: function (appId, options) {
            return (0, exports.AppStoreConfigurationsApiFp)(configuration).getConfiguredApps(appId, options)(fetch, basePath);
        },
        updateAppStoreConfig: function (appId, appStoreAppId, configId, UpdateAppStoreAppConfiguration, options) {
            return (0, exports.AppStoreConfigurationsApiFp)(configuration).updateAppStoreConfig(appId, appStoreAppId, configId, UpdateAppStoreAppConfiguration, options)(fetch, basePath);
        },
        updateAppStoreConfigSettingValues: function (appId, appStoreAppId, configId, UpdateAppStoreAppConfigurationValuesBatch, options) {
            return (0, exports.AppStoreConfigurationsApiFp)(configuration).updateAppStoreConfigSettingValues(appId, appStoreAppId, configId, UpdateAppStoreAppConfigurationValuesBatch, options)(fetch, basePath);
        },
    };
};
exports.AppStoreConfigurationsApiFactory = AppStoreConfigurationsApiFactory;
var AppStoreConfigurationsApi = (function (_super) {
    __extends(AppStoreConfigurationsApi, _super);
    function AppStoreConfigurationsApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    AppStoreConfigurationsApi.prototype.appStoreConfigurationsAppStoreHandleOauthResponseCode = function (appStoreAppId, options) {
        return (0, exports.AppStoreConfigurationsApiFp)(this.configuration).appStoreConfigurationsAppStoreHandleOauthResponseCode(appStoreAppId, options)(this.fetch, this.basePath);
    };
    AppStoreConfigurationsApi.prototype.createAppStoreConfig = function (appId, appStoreAppId, options) {
        return (0, exports.AppStoreConfigurationsApiFp)(this.configuration).createAppStoreConfig(appId, appStoreAppId, options)(this.fetch, this.basePath);
    };
    AppStoreConfigurationsApi.prototype.deleteAppStoreConfig = function (appId, appStoreAppId, configId, options) {
        return (0, exports.AppStoreConfigurationsApiFp)(this.configuration).deleteAppStoreConfig(appId, appStoreAppId, configId, options)(this.fetch, this.basePath);
    };
    AppStoreConfigurationsApi.prototype.executeConfigurationAction = function (appId, appStoreAppId, configId, ExecuteConfigurationActionRequest, options) {
        return (0, exports.AppStoreConfigurationsApiFp)(this.configuration).executeConfigurationAction(appId, appStoreAppId, configId, ExecuteConfigurationActionRequest, options)(this.fetch, this.basePath);
    };
    AppStoreConfigurationsApi.prototype.getAppStoreConfig = function (appId, appStoreAppId, configId, options) {
        return (0, exports.AppStoreConfigurationsApiFp)(this.configuration).getAppStoreConfig(appId, appStoreAppId, configId, options)(this.fetch, this.basePath);
    };
    AppStoreConfigurationsApi.prototype.getConfiguredAppSingleApp = function (appId, appStoreAppId, options) {
        return (0, exports.AppStoreConfigurationsApiFp)(this.configuration).getConfiguredAppSingleApp(appId, appStoreAppId, options)(this.fetch, this.basePath);
    };
    AppStoreConfigurationsApi.prototype.getConfiguredApps = function (appId, options) {
        return (0, exports.AppStoreConfigurationsApiFp)(this.configuration).getConfiguredApps(appId, options)(this.fetch, this.basePath);
    };
    AppStoreConfigurationsApi.prototype.updateAppStoreConfig = function (appId, appStoreAppId, configId, UpdateAppStoreAppConfiguration, options) {
        return (0, exports.AppStoreConfigurationsApiFp)(this.configuration).updateAppStoreConfig(appId, appStoreAppId, configId, UpdateAppStoreAppConfiguration, options)(this.fetch, this.basePath);
    };
    AppStoreConfigurationsApi.prototype.updateAppStoreConfigSettingValues = function (appId, appStoreAppId, configId, UpdateAppStoreAppConfigurationValuesBatch, options) {
        return (0, exports.AppStoreConfigurationsApiFp)(this.configuration).updateAppStoreConfigSettingValues(appId, appStoreAppId, configId, UpdateAppStoreAppConfigurationValuesBatch, options)(this.fetch, this.basePath);
    };
    return AppStoreConfigurationsApi;
}(BaseAPI));
exports.AppStoreConfigurationsApi = AppStoreConfigurationsApi;
var AppStoreDeveloperApiFetchParamCreator = function (configuration) {
    return {
        appVerificationUpdate: function (oauthAppId, appStoreAppId, verificationStatus, options) {
            if (options === void 0) { options = {}; }
            if (oauthAppId === null || oauthAppId === undefined) {
                throw new RequiredError('oauthAppId', 'Required parameter oauthAppId was null or undefined when calling appVerificationUpdate.');
            }
            if (appStoreAppId === null || appStoreAppId === undefined) {
                throw new RequiredError('appStoreAppId', 'Required parameter appStoreAppId was null or undefined when calling appVerificationUpdate.');
            }
            if (verificationStatus === null || verificationStatus === undefined) {
                throw new RequiredError('verificationStatus', 'Required parameter verificationStatus was null or undefined when calling appVerificationUpdate.');
            }
            var localVarPath = "/api/v1.0/oauthclients/{oauthAppId}/appstore/apps/{appStoreAppId}/verification"
                .replace("{".concat("oauthAppId", "}"), encodeURIComponent(String(oauthAppId)))
                .replace("{".concat("appStoreAppId", "}"), encodeURIComponent(String(appStoreAppId)));
            var localVarUrlObj = url.parse(localVarPath, true);
            var localVarRequestOptions = Object.assign({ method: 'PUT' }, options);
            var localVarHeaderParameter = {};
            var localVarQueryParameter = {};
            if (configuration && configuration.accessToken) {
                var localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("oauth2", ["api"])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }
            if (verificationStatus !== undefined) {
                localVarQueryParameter['verificationStatus'] = verificationStatus;
            }
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        createAppStoreApp: function (oauthAppId, CreateAppStoreApp, options) {
            if (options === void 0) { options = {}; }
            if (oauthAppId === null || oauthAppId === undefined) {
                throw new RequiredError('oauthAppId', 'Required parameter oauthAppId was null or undefined when calling createAppStoreApp.');
            }
            if (CreateAppStoreApp === null || CreateAppStoreApp === undefined) {
                throw new RequiredError('CreateAppStoreApp', 'Required parameter CreateAppStoreApp was null or undefined when calling createAppStoreApp.');
            }
            var localVarPath = "/api/v1.0/oauthclients/{oauthAppId}/appstore/apps"
                .replace("{".concat("oauthAppId", "}"), encodeURIComponent(String(oauthAppId)));
            var localVarUrlObj = url.parse(localVarPath, true);
            var localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            var localVarHeaderParameter = {};
            var localVarQueryParameter = {};
            if (configuration && configuration.accessToken) {
                var localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("oauth2", ["api"])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }
            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            var needsSerialization = ("CreateAppStoreApp" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body = needsSerialization ? JSON.stringify(CreateAppStoreApp || {}) : (CreateAppStoreApp || "");
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        deleteAppStoreApp: function (oauthAppId, appStoreAppId, options) {
            if (options === void 0) { options = {}; }
            if (oauthAppId === null || oauthAppId === undefined) {
                throw new RequiredError('oauthAppId', 'Required parameter oauthAppId was null or undefined when calling deleteAppStoreApp.');
            }
            if (appStoreAppId === null || appStoreAppId === undefined) {
                throw new RequiredError('appStoreAppId', 'Required parameter appStoreAppId was null or undefined when calling deleteAppStoreApp.');
            }
            var localVarPath = "/api/v1.0/oauthclients/{oauthAppId}/appstore/apps/{appStoreAppId}"
                .replace("{".concat("oauthAppId", "}"), encodeURIComponent(String(oauthAppId)))
                .replace("{".concat("appStoreAppId", "}"), encodeURIComponent(String(appStoreAppId)));
            var localVarUrlObj = url.parse(localVarPath, true);
            var localVarRequestOptions = Object.assign({ method: 'DELETE' }, options);
            var localVarHeaderParameter = {};
            var localVarQueryParameter = {};
            if (configuration && configuration.accessToken) {
                var localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("oauth2", ["api"])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        getAppExternalProduct: function (oauthAppId, appStoreAppId, options) {
            if (options === void 0) { options = {}; }
            if (oauthAppId === null || oauthAppId === undefined) {
                throw new RequiredError('oauthAppId', 'Required parameter oauthAppId was null or undefined when calling getAppExternalProduct.');
            }
            if (appStoreAppId === null || appStoreAppId === undefined) {
                throw new RequiredError('appStoreAppId', 'Required parameter appStoreAppId was null or undefined when calling getAppExternalProduct.');
            }
            var localVarPath = "/api/v1.0/oauthclients/{oauthAppId}/appstore/apps/{appStoreAppId}/external_product"
                .replace("{".concat("oauthAppId", "}"), encodeURIComponent(String(oauthAppId)))
                .replace("{".concat("appStoreAppId", "}"), encodeURIComponent(String(appStoreAppId)));
            var localVarUrlObj = url.parse(localVarPath, true);
            var localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            var localVarHeaderParameter = {};
            var localVarQueryParameter = {};
            if (configuration && configuration.accessToken) {
                var localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("oauth2", ["api"])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        getExternalFunctionSigningKey: function (oauthAppId, appStoreAppId, options) {
            if (options === void 0) { options = {}; }
            if (oauthAppId === null || oauthAppId === undefined) {
                throw new RequiredError('oauthAppId', 'Required parameter oauthAppId was null or undefined when calling getExternalFunctionSigningKey.');
            }
            if (appStoreAppId === null || appStoreAppId === undefined) {
                throw new RequiredError('appStoreAppId', 'Required parameter appStoreAppId was null or undefined when calling getExternalFunctionSigningKey.');
            }
            var localVarPath = "/api/v1.0/oauthclients/{oauthAppId}/appstore/apps/{appStoreAppId}/external_function_signing_key"
                .replace("{".concat("oauthAppId", "}"), encodeURIComponent(String(oauthAppId)))
                .replace("{".concat("appStoreAppId", "}"), encodeURIComponent(String(appStoreAppId)));
            var localVarUrlObj = url.parse(localVarPath, true);
            var localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            var localVarHeaderParameter = {};
            var localVarQueryParameter = {};
            if (configuration && configuration.accessToken) {
                var localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("oauth2", ["api"])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        updateAppStoreApp: function (oauthAppId, appStoreAppId, UpdateAppStoreApp, options) {
            if (options === void 0) { options = {}; }
            if (oauthAppId === null || oauthAppId === undefined) {
                throw new RequiredError('oauthAppId', 'Required parameter oauthAppId was null or undefined when calling updateAppStoreApp.');
            }
            if (appStoreAppId === null || appStoreAppId === undefined) {
                throw new RequiredError('appStoreAppId', 'Required parameter appStoreAppId was null or undefined when calling updateAppStoreApp.');
            }
            if (UpdateAppStoreApp === null || UpdateAppStoreApp === undefined) {
                throw new RequiredError('UpdateAppStoreApp', 'Required parameter UpdateAppStoreApp was null or undefined when calling updateAppStoreApp.');
            }
            var localVarPath = "/api/v1.0/oauthclients/{oauthAppId}/appstore/apps/{appStoreAppId}"
                .replace("{".concat("oauthAppId", "}"), encodeURIComponent(String(oauthAppId)))
                .replace("{".concat("appStoreAppId", "}"), encodeURIComponent(String(appStoreAppId)));
            var localVarUrlObj = url.parse(localVarPath, true);
            var localVarRequestOptions = Object.assign({ method: 'PUT' }, options);
            var localVarHeaderParameter = {};
            var localVarQueryParameter = {};
            if (configuration && configuration.accessToken) {
                var localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("oauth2", ["api"])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }
            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            var needsSerialization = ("UpdateAppStoreApp" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body = needsSerialization ? JSON.stringify(UpdateAppStoreApp || {}) : (UpdateAppStoreApp || "");
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        updateExternalProduct: function (oauthAppId, appStoreAppId, UpdateAppStoreAppExternalProduct, options) {
            if (options === void 0) { options = {}; }
            if (oauthAppId === null || oauthAppId === undefined) {
                throw new RequiredError('oauthAppId', 'Required parameter oauthAppId was null or undefined when calling updateExternalProduct.');
            }
            if (appStoreAppId === null || appStoreAppId === undefined) {
                throw new RequiredError('appStoreAppId', 'Required parameter appStoreAppId was null or undefined when calling updateExternalProduct.');
            }
            if (UpdateAppStoreAppExternalProduct === null || UpdateAppStoreAppExternalProduct === undefined) {
                throw new RequiredError('UpdateAppStoreAppExternalProduct', 'Required parameter UpdateAppStoreAppExternalProduct was null or undefined when calling updateExternalProduct.');
            }
            var localVarPath = "/api/v1.0/oauthclients/{oauthAppId}/appstore/apps/{appStoreAppId}/external_product"
                .replace("{".concat("oauthAppId", "}"), encodeURIComponent(String(oauthAppId)))
                .replace("{".concat("appStoreAppId", "}"), encodeURIComponent(String(appStoreAppId)));
            var localVarUrlObj = url.parse(localVarPath, true);
            var localVarRequestOptions = Object.assign({ method: 'PUT' }, options);
            var localVarHeaderParameter = {};
            var localVarQueryParameter = {};
            if (configuration && configuration.accessToken) {
                var localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("oauth2", ["api"])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }
            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            var needsSerialization = ("UpdateAppStoreAppExternalProduct" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body = needsSerialization ? JSON.stringify(UpdateAppStoreAppExternalProduct || {}) : (UpdateAppStoreAppExternalProduct || "");
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        uploadAppStoreAppLogo: function (oauthAppId, appStoreAppId, Image, options) {
            if (options === void 0) { options = {}; }
            if (oauthAppId === null || oauthAppId === undefined) {
                throw new RequiredError('oauthAppId', 'Required parameter oauthAppId was null or undefined when calling uploadAppStoreAppLogo.');
            }
            if (appStoreAppId === null || appStoreAppId === undefined) {
                throw new RequiredError('appStoreAppId', 'Required parameter appStoreAppId was null or undefined when calling uploadAppStoreAppLogo.');
            }
            if (Image === null || Image === undefined) {
                throw new RequiredError('Image', 'Required parameter Image was null or undefined when calling uploadAppStoreAppLogo.');
            }
            var localVarPath = "/api/v1.0/oauthclients/{oauthAppId}/appstore/apps/{appStoreAppId}/logo"
                .replace("{".concat("oauthAppId", "}"), encodeURIComponent(String(oauthAppId)))
                .replace("{".concat("appStoreAppId", "}"), encodeURIComponent(String(appStoreAppId)));
            var localVarUrlObj = url.parse(localVarPath, true);
            var localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            var localVarHeaderParameter = {};
            var localVarQueryParameter = {};
            var localVarFormParams = new url.URLSearchParams();
            if (configuration && configuration.accessToken) {
                var localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("oauth2", ["api"])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }
            if (Image !== undefined) {
                localVarFormParams.set('Image', Image);
            }
            localVarHeaderParameter['Content-Type'] = 'application/x-www-form-urlencoded';
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            localVarRequestOptions.body = localVarFormParams.toString();
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    };
};
exports.AppStoreDeveloperApiFetchParamCreator = AppStoreDeveloperApiFetchParamCreator;
var AppStoreDeveloperApiFp = function (configuration) {
    return {
        appVerificationUpdate: function (oauthAppId, appStoreAppId, verificationStatus, options) {
            var localVarFetchArgs = (0, exports.AppStoreDeveloperApiFetchParamCreator)(configuration).appVerificationUpdate(oauthAppId, appStoreAppId, verificationStatus, options);
            return function (fetch, basePath) {
                if (fetch === void 0) { fetch = portableFetch; }
                if (basePath === void 0) { basePath = BASE_PATH; }
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then(function (response) {
                    if (response.status >= 200 && response.status < 300) {
                        return response;
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
        createAppStoreApp: function (oauthAppId, CreateAppStoreApp, options) {
            var localVarFetchArgs = (0, exports.AppStoreDeveloperApiFetchParamCreator)(configuration).createAppStoreApp(oauthAppId, CreateAppStoreApp, options);
            return function (fetch, basePath) {
                if (fetch === void 0) { fetch = portableFetch; }
                if (basePath === void 0) { basePath = BASE_PATH; }
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then(function (response) {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
        deleteAppStoreApp: function (oauthAppId, appStoreAppId, options) {
            var localVarFetchArgs = (0, exports.AppStoreDeveloperApiFetchParamCreator)(configuration).deleteAppStoreApp(oauthAppId, appStoreAppId, options);
            return function (fetch, basePath) {
                if (fetch === void 0) { fetch = portableFetch; }
                if (basePath === void 0) { basePath = BASE_PATH; }
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then(function (response) {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
        getAppExternalProduct: function (oauthAppId, appStoreAppId, options) {
            var localVarFetchArgs = (0, exports.AppStoreDeveloperApiFetchParamCreator)(configuration).getAppExternalProduct(oauthAppId, appStoreAppId, options);
            return function (fetch, basePath) {
                if (fetch === void 0) { fetch = portableFetch; }
                if (basePath === void 0) { basePath = BASE_PATH; }
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then(function (response) {
                    if (response.status >= 200 && response.status < 300) {
                        return response;
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
        getExternalFunctionSigningKey: function (oauthAppId, appStoreAppId, options) {
            var localVarFetchArgs = (0, exports.AppStoreDeveloperApiFetchParamCreator)(configuration).getExternalFunctionSigningKey(oauthAppId, appStoreAppId, options);
            return function (fetch, basePath) {
                if (fetch === void 0) { fetch = portableFetch; }
                if (basePath === void 0) { basePath = BASE_PATH; }
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then(function (response) {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
        updateAppStoreApp: function (oauthAppId, appStoreAppId, UpdateAppStoreApp, options) {
            var localVarFetchArgs = (0, exports.AppStoreDeveloperApiFetchParamCreator)(configuration).updateAppStoreApp(oauthAppId, appStoreAppId, UpdateAppStoreApp, options);
            return function (fetch, basePath) {
                if (fetch === void 0) { fetch = portableFetch; }
                if (basePath === void 0) { basePath = BASE_PATH; }
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then(function (response) {
                    if (response.status >= 200 && response.status < 300) {
                        return response;
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
        updateExternalProduct: function (oauthAppId, appStoreAppId, UpdateAppStoreAppExternalProduct, options) {
            var localVarFetchArgs = (0, exports.AppStoreDeveloperApiFetchParamCreator)(configuration).updateExternalProduct(oauthAppId, appStoreAppId, UpdateAppStoreAppExternalProduct, options);
            return function (fetch, basePath) {
                if (fetch === void 0) { fetch = portableFetch; }
                if (basePath === void 0) { basePath = BASE_PATH; }
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then(function (response) {
                    if (response.status >= 200 && response.status < 300) {
                        return response;
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
        uploadAppStoreAppLogo: function (oauthAppId, appStoreAppId, Image, options) {
            var localVarFetchArgs = (0, exports.AppStoreDeveloperApiFetchParamCreator)(configuration).uploadAppStoreAppLogo(oauthAppId, appStoreAppId, Image, options);
            return function (fetch, basePath) {
                if (fetch === void 0) { fetch = portableFetch; }
                if (basePath === void 0) { basePath = BASE_PATH; }
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then(function (response) {
                    if (response.status >= 200 && response.status < 300) {
                        return response;
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
    };
};
exports.AppStoreDeveloperApiFp = AppStoreDeveloperApiFp;
var AppStoreDeveloperApiFactory = function (configuration, fetch, basePath) {
    return {
        appVerificationUpdate: function (oauthAppId, appStoreAppId, verificationStatus, options) {
            return (0, exports.AppStoreDeveloperApiFp)(configuration).appVerificationUpdate(oauthAppId, appStoreAppId, verificationStatus, options)(fetch, basePath);
        },
        createAppStoreApp: function (oauthAppId, CreateAppStoreApp, options) {
            return (0, exports.AppStoreDeveloperApiFp)(configuration).createAppStoreApp(oauthAppId, CreateAppStoreApp, options)(fetch, basePath);
        },
        deleteAppStoreApp: function (oauthAppId, appStoreAppId, options) {
            return (0, exports.AppStoreDeveloperApiFp)(configuration).deleteAppStoreApp(oauthAppId, appStoreAppId, options)(fetch, basePath);
        },
        getAppExternalProduct: function (oauthAppId, appStoreAppId, options) {
            return (0, exports.AppStoreDeveloperApiFp)(configuration).getAppExternalProduct(oauthAppId, appStoreAppId, options)(fetch, basePath);
        },
        getExternalFunctionSigningKey: function (oauthAppId, appStoreAppId, options) {
            return (0, exports.AppStoreDeveloperApiFp)(configuration).getExternalFunctionSigningKey(oauthAppId, appStoreAppId, options)(fetch, basePath);
        },
        updateAppStoreApp: function (oauthAppId, appStoreAppId, UpdateAppStoreApp, options) {
            return (0, exports.AppStoreDeveloperApiFp)(configuration).updateAppStoreApp(oauthAppId, appStoreAppId, UpdateAppStoreApp, options)(fetch, basePath);
        },
        updateExternalProduct: function (oauthAppId, appStoreAppId, UpdateAppStoreAppExternalProduct, options) {
            return (0, exports.AppStoreDeveloperApiFp)(configuration).updateExternalProduct(oauthAppId, appStoreAppId, UpdateAppStoreAppExternalProduct, options)(fetch, basePath);
        },
        uploadAppStoreAppLogo: function (oauthAppId, appStoreAppId, Image, options) {
            return (0, exports.AppStoreDeveloperApiFp)(configuration).uploadAppStoreAppLogo(oauthAppId, appStoreAppId, Image, options)(fetch, basePath);
        },
    };
};
exports.AppStoreDeveloperApiFactory = AppStoreDeveloperApiFactory;
var AppStoreDeveloperApi = (function (_super) {
    __extends(AppStoreDeveloperApi, _super);
    function AppStoreDeveloperApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    AppStoreDeveloperApi.prototype.appVerificationUpdate = function (oauthAppId, appStoreAppId, verificationStatus, options) {
        return (0, exports.AppStoreDeveloperApiFp)(this.configuration).appVerificationUpdate(oauthAppId, appStoreAppId, verificationStatus, options)(this.fetch, this.basePath);
    };
    AppStoreDeveloperApi.prototype.createAppStoreApp = function (oauthAppId, CreateAppStoreApp, options) {
        return (0, exports.AppStoreDeveloperApiFp)(this.configuration).createAppStoreApp(oauthAppId, CreateAppStoreApp, options)(this.fetch, this.basePath);
    };
    AppStoreDeveloperApi.prototype.deleteAppStoreApp = function (oauthAppId, appStoreAppId, options) {
        return (0, exports.AppStoreDeveloperApiFp)(this.configuration).deleteAppStoreApp(oauthAppId, appStoreAppId, options)(this.fetch, this.basePath);
    };
    AppStoreDeveloperApi.prototype.getAppExternalProduct = function (oauthAppId, appStoreAppId, options) {
        return (0, exports.AppStoreDeveloperApiFp)(this.configuration).getAppExternalProduct(oauthAppId, appStoreAppId, options)(this.fetch, this.basePath);
    };
    AppStoreDeveloperApi.prototype.getExternalFunctionSigningKey = function (oauthAppId, appStoreAppId, options) {
        return (0, exports.AppStoreDeveloperApiFp)(this.configuration).getExternalFunctionSigningKey(oauthAppId, appStoreAppId, options)(this.fetch, this.basePath);
    };
    AppStoreDeveloperApi.prototype.updateAppStoreApp = function (oauthAppId, appStoreAppId, UpdateAppStoreApp, options) {
        return (0, exports.AppStoreDeveloperApiFp)(this.configuration).updateAppStoreApp(oauthAppId, appStoreAppId, UpdateAppStoreApp, options)(this.fetch, this.basePath);
    };
    AppStoreDeveloperApi.prototype.updateExternalProduct = function (oauthAppId, appStoreAppId, UpdateAppStoreAppExternalProduct, options) {
        return (0, exports.AppStoreDeveloperApiFp)(this.configuration).updateExternalProduct(oauthAppId, appStoreAppId, UpdateAppStoreAppExternalProduct, options)(this.fetch, this.basePath);
    };
    AppStoreDeveloperApi.prototype.uploadAppStoreAppLogo = function (oauthAppId, appStoreAppId, Image, options) {
        return (0, exports.AppStoreDeveloperApiFp)(this.configuration).uploadAppStoreAppLogo(oauthAppId, appStoreAppId, Image, options)(this.fetch, this.basePath);
    };
    return AppStoreDeveloperApi;
}(BaseAPI));
exports.AppStoreDeveloperApi = AppStoreDeveloperApi;
var AppStoreEntitlementsApiFetchParamCreator = function (configuration) {
    return {
        getAppStoreAppEntitlements: function (appId, appStoreAppId, options) {
            if (options === void 0) { options = {}; }
            if (appId === null || appId === undefined) {
                throw new RequiredError('appId', 'Required parameter appId was null or undefined when calling getAppStoreAppEntitlements.');
            }
            if (appStoreAppId === null || appStoreAppId === undefined) {
                throw new RequiredError('appStoreAppId', 'Required parameter appStoreAppId was null or undefined when calling getAppStoreAppEntitlements.');
            }
            var localVarPath = "/api/v1.0/{appId}/appstore/apps/{appStoreAppId}/entitlements"
                .replace("{".concat("appId", "}"), encodeURIComponent(String(appId)))
                .replace("{".concat("appStoreAppId", "}"), encodeURIComponent(String(appStoreAppId)));
            var localVarUrlObj = url.parse(localVarPath, true);
            var localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            var localVarHeaderParameter = {};
            var localVarQueryParameter = {};
            if (configuration && configuration.accessToken) {
                var localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("oauth2", ["api"])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    };
};
exports.AppStoreEntitlementsApiFetchParamCreator = AppStoreEntitlementsApiFetchParamCreator;
var AppStoreEntitlementsApiFp = function (configuration) {
    return {
        getAppStoreAppEntitlements: function (appId, appStoreAppId, options) {
            var localVarFetchArgs = (0, exports.AppStoreEntitlementsApiFetchParamCreator)(configuration).getAppStoreAppEntitlements(appId, appStoreAppId, options);
            return function (fetch, basePath) {
                if (fetch === void 0) { fetch = portableFetch; }
                if (basePath === void 0) { basePath = BASE_PATH; }
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then(function (response) {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
    };
};
exports.AppStoreEntitlementsApiFp = AppStoreEntitlementsApiFp;
var AppStoreEntitlementsApiFactory = function (configuration, fetch, basePath) {
    return {
        getAppStoreAppEntitlements: function (appId, appStoreAppId, options) {
            return (0, exports.AppStoreEntitlementsApiFp)(configuration).getAppStoreAppEntitlements(appId, appStoreAppId, options)(fetch, basePath);
        },
    };
};
exports.AppStoreEntitlementsApiFactory = AppStoreEntitlementsApiFactory;
var AppStoreEntitlementsApi = (function (_super) {
    __extends(AppStoreEntitlementsApi, _super);
    function AppStoreEntitlementsApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    AppStoreEntitlementsApi.prototype.getAppStoreAppEntitlements = function (appId, appStoreAppId, options) {
        return (0, exports.AppStoreEntitlementsApiFp)(this.configuration).getAppStoreAppEntitlements(appId, appStoreAppId, options)(this.fetch, this.basePath);
    };
    return AppStoreEntitlementsApi;
}(BaseAPI));
exports.AppStoreEntitlementsApi = AppStoreEntitlementsApi;
var AppsApiFetchParamCreator = function (configuration) {
    return {
        appsSetPropertyId: function (appId, orgId, options) {
            if (options === void 0) { options = {}; }
            if (appId === null || appId === undefined) {
                throw new RequiredError('appId', 'Required parameter appId was null or undefined when calling appsSetPropertyId.');
            }
            if (orgId === null || orgId === undefined) {
                throw new RequiredError('orgId', 'Required parameter orgId was null or undefined when calling appsSetPropertyId.');
            }
            var localVarPath = "/api/v1.0/apps/{appId}/orgId/{orgId}"
                .replace("{".concat("appId", "}"), encodeURIComponent(String(appId)))
                .replace("{".concat("orgId", "}"), encodeURIComponent(String(orgId)));
            var localVarUrlObj = url.parse(localVarPath, true);
            var localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            var localVarHeaderParameter = {};
            var localVarQueryParameter = {};
            if (configuration && configuration.accessToken) {
                var localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("oauth2", ["api"])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        createApp: function (CreateAppParameters, options) {
            if (options === void 0) { options = {}; }
            if (CreateAppParameters === null || CreateAppParameters === undefined) {
                throw new RequiredError('CreateAppParameters', 'Required parameter CreateAppParameters was null or undefined when calling createApp.');
            }
            var localVarPath = "/api/v1.0/apps";
            var localVarUrlObj = url.parse(localVarPath, true);
            var localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            var localVarHeaderParameter = {};
            var localVarQueryParameter = {};
            if (configuration && configuration.accessToken) {
                var localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("oauth2", ["api"])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }
            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            var needsSerialization = ("CreateAppParameters" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body = needsSerialization ? JSON.stringify(CreateAppParameters || {}) : (CreateAppParameters || "");
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        getApp: function (appId, options) {
            if (options === void 0) { options = {}; }
            if (appId === null || appId === undefined) {
                throw new RequiredError('appId', 'Required parameter appId was null or undefined when calling getApp.');
            }
            var localVarPath = "/api/v1.0/apps/{appId}"
                .replace("{".concat("appId", "}"), encodeURIComponent(String(appId)));
            var localVarUrlObj = url.parse(localVarPath, true);
            var localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            var localVarHeaderParameter = {};
            var localVarQueryParameter = {};
            if (configuration && configuration.accessToken) {
                var localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("oauth2", ["api"])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        getAppHostnameStatus: function (appId, options) {
            if (options === void 0) { options = {}; }
            if (appId === null || appId === undefined) {
                throw new RequiredError('appId', 'Required parameter appId was null or undefined when calling getAppHostnameStatus.');
            }
            var localVarPath = "/api/v1.0/apps/{appId}/hostnamestatus"
                .replace("{".concat("appId", "}"), encodeURIComponent(String(appId)));
            var localVarUrlObj = url.parse(localVarPath, true);
            var localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            var localVarHeaderParameter = {};
            var localVarQueryParameter = {};
            if (configuration && configuration.accessToken) {
                var localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("oauth2", ["api"])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        getAppName: function (appId, options) {
            if (options === void 0) { options = {}; }
            if (appId === null || appId === undefined) {
                throw new RequiredError('appId', 'Required parameter appId was null or undefined when calling getAppName.');
            }
            var localVarPath = "/api/v1.0/apps/{appId}/name"
                .replace("{".concat("appId", "}"), encodeURIComponent(String(appId)));
            var localVarUrlObj = url.parse(localVarPath, true);
            var localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            var localVarHeaderParameter = {};
            var localVarQueryParameter = {};
            if (configuration && configuration.accessToken) {
                var localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("oauth2", ["api"])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        getApps: function (nameFilter, page, limit, options) {
            if (options === void 0) { options = {}; }
            var localVarPath = "/api/v1.0/apps";
            var localVarUrlObj = url.parse(localVarPath, true);
            var localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            var localVarHeaderParameter = {};
            var localVarQueryParameter = {};
            if (configuration && configuration.accessToken) {
                var localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("oauth2", ["api"])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }
            if (nameFilter !== undefined) {
                localVarQueryParameter['nameFilter'] = nameFilter;
            }
            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }
            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        getCompliance: function (appId, options) {
            if (options === void 0) { options = {}; }
            if (appId === null || appId === undefined) {
                throw new RequiredError('appId', 'Required parameter appId was null or undefined when calling getCompliance.');
            }
            var localVarPath = "/api/v1.0/apps/{appId}/compliance"
                .replace("{".concat("appId", "}"), encodeURIComponent(String(appId)));
            var localVarUrlObj = url.parse(localVarPath, true);
            var localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            var localVarHeaderParameter = {};
            var localVarQueryParameter = {};
            if (configuration && configuration.accessToken) {
                var localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("oauth2", ["api"])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        getPanaceaVanityUrl: function (appId, options) {
            if (options === void 0) { options = {}; }
            if (appId === null || appId === undefined) {
                throw new RequiredError('appId', 'Required parameter appId was null or undefined when calling getPanaceaVanityUrl.');
            }
            var localVarPath = "/api/v1.0/apps/{appId}/panacea/url"
                .replace("{".concat("appId", "}"), encodeURIComponent(String(appId)));
            var localVarUrlObj = url.parse(localVarPath, true);
            var localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            var localVarHeaderParameter = {};
            var localVarQueryParameter = {};
            if (configuration && configuration.accessToken) {
                var localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("oauth2", ["api"])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        getSupportedCountries: function (options) {
            if (options === void 0) { options = {}; }
            var localVarPath = "/api/v1.0/apps/supportedcountries";
            var localVarUrlObj = url.parse(localVarPath, true);
            var localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            var localVarHeaderParameter = {};
            var localVarQueryParameter = {};
            if (configuration && configuration.accessToken) {
                var localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("oauth2", ["api"])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        isPanaceaVanityUrlAvailable: function (vanityUrl, appId, options) {
            if (options === void 0) { options = {}; }
            if (vanityUrl === null || vanityUrl === undefined) {
                throw new RequiredError('vanityUrl', 'Required parameter vanityUrl was null or undefined when calling isPanaceaVanityUrlAvailable.');
            }
            if (appId === null || appId === undefined) {
                throw new RequiredError('appId', 'Required parameter appId was null or undefined when calling isPanaceaVanityUrlAvailable.');
            }
            var localVarPath = "/api/v1.0/apps/{appId}/panacea/url/available"
                .replace("{".concat("appId", "}"), encodeURIComponent(String(appId)));
            var localVarUrlObj = url.parse(localVarPath, true);
            var localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            var localVarHeaderParameter = {};
            var localVarQueryParameter = {};
            if (configuration && configuration.accessToken) {
                var localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("oauth2", ["api"])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }
            if (vanityUrl !== undefined) {
                localVarQueryParameter['vanityUrl'] = vanityUrl;
            }
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        lookupByWhitelabelId: function (whitelabelId, options) {
            if (options === void 0) { options = {}; }
            if (whitelabelId === null || whitelabelId === undefined) {
                throw new RequiredError('whitelabelId', 'Required parameter whitelabelId was null or undefined when calling lookupByWhitelabelId.');
            }
            var localVarPath = "/api/v1.0/apps/{whitelabelId}/lookup"
                .replace("{".concat("whitelabelId", "}"), encodeURIComponent(String(whitelabelId)));
            var localVarUrlObj = url.parse(localVarPath, true);
            var localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            var localVarHeaderParameter = {};
            var localVarQueryParameter = {};
            if (configuration && configuration.accessToken) {
                var localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("oauth2", ["api"])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        sendPushNotification: function (appId, customerId, body, options) {
            if (options === void 0) { options = {}; }
            if (appId === null || appId === undefined) {
                throw new RequiredError('appId', 'Required parameter appId was null or undefined when calling sendPushNotification.');
            }
            if (customerId === null || customerId === undefined) {
                throw new RequiredError('customerId', 'Required parameter customerId was null or undefined when calling sendPushNotification.');
            }
            if (body === null || body === undefined) {
                throw new RequiredError('body', 'Required parameter body was null or undefined when calling sendPushNotification.');
            }
            var localVarPath = "/api/v1.0/apps/{appId}/SendPushNotification/{customerId}"
                .replace("{".concat("appId", "}"), encodeURIComponent(String(appId)))
                .replace("{".concat("customerId", "}"), encodeURIComponent(String(customerId)));
            var localVarUrlObj = url.parse(localVarPath, true);
            var localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            var localVarHeaderParameter = {};
            var localVarQueryParameter = {};
            if (configuration && configuration.accessToken) {
                var localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("oauth2", ["api"])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }
            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            var needsSerialization = ("string" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body = needsSerialization ? JSON.stringify(body || {}) : (body || "");
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        setAppConfig: function (appId, AppConfigUpdateModel, options) {
            if (options === void 0) { options = {}; }
            if (appId === null || appId === undefined) {
                throw new RequiredError('appId', 'Required parameter appId was null or undefined when calling setAppConfig.');
            }
            if (AppConfigUpdateModel === null || AppConfigUpdateModel === undefined) {
                throw new RequiredError('AppConfigUpdateModel', 'Required parameter AppConfigUpdateModel was null or undefined when calling setAppConfig.');
            }
            var localVarPath = "/api/v1.0/apps/{appId}/config"
                .replace("{".concat("appId", "}"), encodeURIComponent(String(appId)));
            var localVarUrlObj = url.parse(localVarPath, true);
            var localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            var localVarHeaderParameter = {};
            var localVarQueryParameter = {};
            if (configuration && configuration.accessToken) {
                var localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("oauth2", ["api"])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }
            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            var needsSerialization = ("AppConfigUpdateModel" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body = needsSerialization ? JSON.stringify(AppConfigUpdateModel || {}) : (AppConfigUpdateModel || "");
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        setAppHostname: function (appId, hostname, isEmbed, options) {
            if (options === void 0) { options = {}; }
            if (appId === null || appId === undefined) {
                throw new RequiredError('appId', 'Required parameter appId was null or undefined when calling setAppHostname.');
            }
            if (hostname === null || hostname === undefined) {
                throw new RequiredError('hostname', 'Required parameter hostname was null or undefined when calling setAppHostname.');
            }
            var localVarPath = "/api/v1.0/apps/{appId}/hostname"
                .replace("{".concat("appId", "}"), encodeURIComponent(String(appId)));
            var localVarUrlObj = url.parse(localVarPath, true);
            var localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            var localVarHeaderParameter = {};
            var localVarQueryParameter = {};
            if (configuration && configuration.accessToken) {
                var localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("oauth2", ["api"])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }
            if (hostname !== undefined) {
                localVarQueryParameter['hostname'] = hostname;
            }
            if (isEmbed !== undefined) {
                localVarQueryParameter['isEmbed'] = isEmbed;
            }
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        setAppLanguages: function (appId, Language, options) {
            if (options === void 0) { options = {}; }
            if (appId === null || appId === undefined) {
                throw new RequiredError('appId', 'Required parameter appId was null or undefined when calling setAppLanguages.');
            }
            if (Language === null || Language === undefined) {
                throw new RequiredError('Language', 'Required parameter Language was null or undefined when calling setAppLanguages.');
            }
            var localVarPath = "/api/v1.0/apps/{appId}/config/languages"
                .replace("{".concat("appId", "}"), encodeURIComponent(String(appId)));
            var localVarUrlObj = url.parse(localVarPath, true);
            var localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            var localVarHeaderParameter = {};
            var localVarQueryParameter = {};
            if (configuration && configuration.accessToken) {
                var localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("oauth2", ["api"])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }
            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            var needsSerialization = ("Array&lt;Language&gt;" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body = needsSerialization ? JSON.stringify(Language || {}) : (Language || "");
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        setAppStoreName: function (appId, body, options) {
            if (options === void 0) { options = {}; }
            if (appId === null || appId === undefined) {
                throw new RequiredError('appId', 'Required parameter appId was null or undefined when calling setAppStoreName.');
            }
            if (body === null || body === undefined) {
                throw new RequiredError('body', 'Required parameter body was null or undefined when calling setAppStoreName.');
            }
            var localVarPath = "/api/v1.0/apps/{appId}/appstorename"
                .replace("{".concat("appId", "}"), encodeURIComponent(String(appId)));
            var localVarUrlObj = url.parse(localVarPath, true);
            var localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            var localVarHeaderParameter = {};
            var localVarQueryParameter = {};
            if (configuration && configuration.accessToken) {
                var localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("oauth2", ["api"])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }
            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            var needsSerialization = ("string" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body = needsSerialization ? JSON.stringify(body || {}) : (body || "");
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        setCompliance: function (appId, complianceType, options) {
            if (options === void 0) { options = {}; }
            if (appId === null || appId === undefined) {
                throw new RequiredError('appId', 'Required parameter appId was null or undefined when calling setCompliance.');
            }
            if (complianceType === null || complianceType === undefined) {
                throw new RequiredError('complianceType', 'Required parameter complianceType was null or undefined when calling setCompliance.');
            }
            var localVarPath = "/api/v1.0/apps/{appId}/compliance"
                .replace("{".concat("appId", "}"), encodeURIComponent(String(appId)));
            var localVarUrlObj = url.parse(localVarPath, true);
            var localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            var localVarHeaderParameter = {};
            var localVarQueryParameter = {};
            if (configuration && configuration.accessToken) {
                var localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("oauth2", ["api"])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }
            if (complianceType !== undefined) {
                localVarQueryParameter['complianceType'] = complianceType;
            }
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        setPanaceaVanityUrl: function (appId, vanityUrl, options) {
            if (options === void 0) { options = {}; }
            if (appId === null || appId === undefined) {
                throw new RequiredError('appId', 'Required parameter appId was null or undefined when calling setPanaceaVanityUrl.');
            }
            if (vanityUrl === null || vanityUrl === undefined) {
                throw new RequiredError('vanityUrl', 'Required parameter vanityUrl was null or undefined when calling setPanaceaVanityUrl.');
            }
            var localVarPath = "/api/v1.0/apps/{appId}/panacea/url"
                .replace("{".concat("appId", "}"), encodeURIComponent(String(appId)));
            var localVarUrlObj = url.parse(localVarPath, true);
            var localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            var localVarHeaderParameter = {};
            var localVarQueryParameter = {};
            if (configuration && configuration.accessToken) {
                var localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("oauth2", ["api"])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }
            if (vanityUrl !== undefined) {
                localVarQueryParameter['vanityUrl'] = vanityUrl;
            }
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        setThirdPartyIntegrations: function (appId, enabled, options) {
            if (options === void 0) { options = {}; }
            if (appId === null || appId === undefined) {
                throw new RequiredError('appId', 'Required parameter appId was null or undefined when calling setThirdPartyIntegrations.');
            }
            if (enabled === null || enabled === undefined) {
                throw new RequiredError('enabled', 'Required parameter enabled was null or undefined when calling setThirdPartyIntegrations.');
            }
            var localVarPath = "/api/v1.0/apps/{appId}/third-party-integrations"
                .replace("{".concat("appId", "}"), encodeURIComponent(String(appId)));
            var localVarUrlObj = url.parse(localVarPath, true);
            var localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            var localVarHeaderParameter = {};
            var localVarQueryParameter = {};
            if (configuration && configuration.accessToken) {
                var localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("oauth2", ["api"])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }
            if (enabled !== undefined) {
                localVarQueryParameter['enabled'] = enabled;
            }
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        toggleNextGenWeb: function (appId, hostname, vanityUrl, isNextGenWeb, options) {
            if (options === void 0) { options = {}; }
            if (appId === null || appId === undefined) {
                throw new RequiredError('appId', 'Required parameter appId was null or undefined when calling toggleNextGenWeb.');
            }
            if (hostname === null || hostname === undefined) {
                throw new RequiredError('hostname', 'Required parameter hostname was null or undefined when calling toggleNextGenWeb.');
            }
            if (vanityUrl === null || vanityUrl === undefined) {
                throw new RequiredError('vanityUrl', 'Required parameter vanityUrl was null or undefined when calling toggleNextGenWeb.');
            }
            if (isNextGenWeb === null || isNextGenWeb === undefined) {
                throw new RequiredError('isNextGenWeb', 'Required parameter isNextGenWeb was null or undefined when calling toggleNextGenWeb.');
            }
            var localVarPath = "/api/v1.0/apps/{appId}/nextgenweb"
                .replace("{".concat("appId", "}"), encodeURIComponent(String(appId)));
            var localVarUrlObj = url.parse(localVarPath, true);
            var localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            var localVarHeaderParameter = {};
            var localVarQueryParameter = {};
            if (configuration && configuration.accessToken) {
                var localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("oauth2", ["api"])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }
            if (hostname !== undefined) {
                localVarQueryParameter['hostname'] = hostname;
            }
            if (vanityUrl !== undefined) {
                localVarQueryParameter['vanityUrl'] = vanityUrl;
            }
            if (isNextGenWeb !== undefined) {
                localVarQueryParameter['isNextGenWeb'] = isNextGenWeb;
            }
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        uploadAppLogo: function (appId, Image, options) {
            if (options === void 0) { options = {}; }
            if (appId === null || appId === undefined) {
                throw new RequiredError('appId', 'Required parameter appId was null or undefined when calling uploadAppLogo.');
            }
            if (Image === null || Image === undefined) {
                throw new RequiredError('Image', 'Required parameter Image was null or undefined when calling uploadAppLogo.');
            }
            var localVarPath = "/api/v1.0/apps/{appId}/logo"
                .replace("{".concat("appId", "}"), encodeURIComponent(String(appId)));
            var localVarUrlObj = url.parse(localVarPath, true);
            var localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            var localVarHeaderParameter = {};
            var localVarQueryParameter = {};
            var localVarFormParams = new url.URLSearchParams();
            if (configuration && configuration.accessToken) {
                var localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("oauth2", ["api"])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }
            if (Image !== undefined) {
                localVarFormParams.set('Image', Image);
            }
            localVarHeaderParameter['Content-Type'] = 'application/x-www-form-urlencoded';
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            localVarRequestOptions.body = localVarFormParams.toString();
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    };
};
exports.AppsApiFetchParamCreator = AppsApiFetchParamCreator;
var AppsApiFp = function (configuration) {
    return {
        appsSetPropertyId: function (appId, orgId, options) {
            var localVarFetchArgs = (0, exports.AppsApiFetchParamCreator)(configuration).appsSetPropertyId(appId, orgId, options);
            return function (fetch, basePath) {
                if (fetch === void 0) { fetch = portableFetch; }
                if (basePath === void 0) { basePath = BASE_PATH; }
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then(function (response) {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
        createApp: function (CreateAppParameters, options) {
            var localVarFetchArgs = (0, exports.AppsApiFetchParamCreator)(configuration).createApp(CreateAppParameters, options);
            return function (fetch, basePath) {
                if (fetch === void 0) { fetch = portableFetch; }
                if (basePath === void 0) { basePath = BASE_PATH; }
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then(function (response) {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
        getApp: function (appId, options) {
            var localVarFetchArgs = (0, exports.AppsApiFetchParamCreator)(configuration).getApp(appId, options);
            return function (fetch, basePath) {
                if (fetch === void 0) { fetch = portableFetch; }
                if (basePath === void 0) { basePath = BASE_PATH; }
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then(function (response) {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
        getAppHostnameStatus: function (appId, options) {
            var localVarFetchArgs = (0, exports.AppsApiFetchParamCreator)(configuration).getAppHostnameStatus(appId, options);
            return function (fetch, basePath) {
                if (fetch === void 0) { fetch = portableFetch; }
                if (basePath === void 0) { basePath = BASE_PATH; }
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then(function (response) {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
        getAppName: function (appId, options) {
            var localVarFetchArgs = (0, exports.AppsApiFetchParamCreator)(configuration).getAppName(appId, options);
            return function (fetch, basePath) {
                if (fetch === void 0) { fetch = portableFetch; }
                if (basePath === void 0) { basePath = BASE_PATH; }
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then(function (response) {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
        getApps: function (nameFilter, page, limit, options) {
            var localVarFetchArgs = (0, exports.AppsApiFetchParamCreator)(configuration).getApps(nameFilter, page, limit, options);
            return function (fetch, basePath) {
                if (fetch === void 0) { fetch = portableFetch; }
                if (basePath === void 0) { basePath = BASE_PATH; }
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then(function (response) {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
        getCompliance: function (appId, options) {
            var localVarFetchArgs = (0, exports.AppsApiFetchParamCreator)(configuration).getCompliance(appId, options);
            return function (fetch, basePath) {
                if (fetch === void 0) { fetch = portableFetch; }
                if (basePath === void 0) { basePath = BASE_PATH; }
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then(function (response) {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
        getPanaceaVanityUrl: function (appId, options) {
            var localVarFetchArgs = (0, exports.AppsApiFetchParamCreator)(configuration).getPanaceaVanityUrl(appId, options);
            return function (fetch, basePath) {
                if (fetch === void 0) { fetch = portableFetch; }
                if (basePath === void 0) { basePath = BASE_PATH; }
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then(function (response) {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
        getSupportedCountries: function (options) {
            var localVarFetchArgs = (0, exports.AppsApiFetchParamCreator)(configuration).getSupportedCountries(options);
            return function (fetch, basePath) {
                if (fetch === void 0) { fetch = portableFetch; }
                if (basePath === void 0) { basePath = BASE_PATH; }
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then(function (response) {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
        isPanaceaVanityUrlAvailable: function (vanityUrl, appId, options) {
            var localVarFetchArgs = (0, exports.AppsApiFetchParamCreator)(configuration).isPanaceaVanityUrlAvailable(vanityUrl, appId, options);
            return function (fetch, basePath) {
                if (fetch === void 0) { fetch = portableFetch; }
                if (basePath === void 0) { basePath = BASE_PATH; }
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then(function (response) {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
        lookupByWhitelabelId: function (whitelabelId, options) {
            var localVarFetchArgs = (0, exports.AppsApiFetchParamCreator)(configuration).lookupByWhitelabelId(whitelabelId, options);
            return function (fetch, basePath) {
                if (fetch === void 0) { fetch = portableFetch; }
                if (basePath === void 0) { basePath = BASE_PATH; }
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then(function (response) {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
        sendPushNotification: function (appId, customerId, body, options) {
            var localVarFetchArgs = (0, exports.AppsApiFetchParamCreator)(configuration).sendPushNotification(appId, customerId, body, options);
            return function (fetch, basePath) {
                if (fetch === void 0) { fetch = portableFetch; }
                if (basePath === void 0) { basePath = BASE_PATH; }
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then(function (response) {
                    if (response.status >= 200 && response.status < 300) {
                        return response;
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
        setAppConfig: function (appId, AppConfigUpdateModel, options) {
            var localVarFetchArgs = (0, exports.AppsApiFetchParamCreator)(configuration).setAppConfig(appId, AppConfigUpdateModel, options);
            return function (fetch, basePath) {
                if (fetch === void 0) { fetch = portableFetch; }
                if (basePath === void 0) { basePath = BASE_PATH; }
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then(function (response) {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
        setAppHostname: function (appId, hostname, isEmbed, options) {
            var localVarFetchArgs = (0, exports.AppsApiFetchParamCreator)(configuration).setAppHostname(appId, hostname, isEmbed, options);
            return function (fetch, basePath) {
                if (fetch === void 0) { fetch = portableFetch; }
                if (basePath === void 0) { basePath = BASE_PATH; }
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then(function (response) {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
        setAppLanguages: function (appId, Language, options) {
            var localVarFetchArgs = (0, exports.AppsApiFetchParamCreator)(configuration).setAppLanguages(appId, Language, options);
            return function (fetch, basePath) {
                if (fetch === void 0) { fetch = portableFetch; }
                if (basePath === void 0) { basePath = BASE_PATH; }
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then(function (response) {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
        setAppStoreName: function (appId, body, options) {
            var localVarFetchArgs = (0, exports.AppsApiFetchParamCreator)(configuration).setAppStoreName(appId, body, options);
            return function (fetch, basePath) {
                if (fetch === void 0) { fetch = portableFetch; }
                if (basePath === void 0) { basePath = BASE_PATH; }
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then(function (response) {
                    if (response.status >= 200 && response.status < 300) {
                        return response;
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
        setCompliance: function (appId, complianceType, options) {
            var localVarFetchArgs = (0, exports.AppsApiFetchParamCreator)(configuration).setCompliance(appId, complianceType, options);
            return function (fetch, basePath) {
                if (fetch === void 0) { fetch = portableFetch; }
                if (basePath === void 0) { basePath = BASE_PATH; }
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then(function (response) {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
        setPanaceaVanityUrl: function (appId, vanityUrl, options) {
            var localVarFetchArgs = (0, exports.AppsApiFetchParamCreator)(configuration).setPanaceaVanityUrl(appId, vanityUrl, options);
            return function (fetch, basePath) {
                if (fetch === void 0) { fetch = portableFetch; }
                if (basePath === void 0) { basePath = BASE_PATH; }
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then(function (response) {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
        setThirdPartyIntegrations: function (appId, enabled, options) {
            var localVarFetchArgs = (0, exports.AppsApiFetchParamCreator)(configuration).setThirdPartyIntegrations(appId, enabled, options);
            return function (fetch, basePath) {
                if (fetch === void 0) { fetch = portableFetch; }
                if (basePath === void 0) { basePath = BASE_PATH; }
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then(function (response) {
                    if (response.status >= 200 && response.status < 300) {
                        return response;
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
        toggleNextGenWeb: function (appId, hostname, vanityUrl, isNextGenWeb, options) {
            var localVarFetchArgs = (0, exports.AppsApiFetchParamCreator)(configuration).toggleNextGenWeb(appId, hostname, vanityUrl, isNextGenWeb, options);
            return function (fetch, basePath) {
                if (fetch === void 0) { fetch = portableFetch; }
                if (basePath === void 0) { basePath = BASE_PATH; }
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then(function (response) {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
        uploadAppLogo: function (appId, Image, options) {
            var localVarFetchArgs = (0, exports.AppsApiFetchParamCreator)(configuration).uploadAppLogo(appId, Image, options);
            return function (fetch, basePath) {
                if (fetch === void 0) { fetch = portableFetch; }
                if (basePath === void 0) { basePath = BASE_PATH; }
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then(function (response) {
                    if (response.status >= 200 && response.status < 300) {
                        return response;
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
    };
};
exports.AppsApiFp = AppsApiFp;
var AppsApiFactory = function (configuration, fetch, basePath) {
    return {
        appsSetPropertyId: function (appId, orgId, options) {
            return (0, exports.AppsApiFp)(configuration).appsSetPropertyId(appId, orgId, options)(fetch, basePath);
        },
        createApp: function (CreateAppParameters, options) {
            return (0, exports.AppsApiFp)(configuration).createApp(CreateAppParameters, options)(fetch, basePath);
        },
        getApp: function (appId, options) {
            return (0, exports.AppsApiFp)(configuration).getApp(appId, options)(fetch, basePath);
        },
        getAppHostnameStatus: function (appId, options) {
            return (0, exports.AppsApiFp)(configuration).getAppHostnameStatus(appId, options)(fetch, basePath);
        },
        getAppName: function (appId, options) {
            return (0, exports.AppsApiFp)(configuration).getAppName(appId, options)(fetch, basePath);
        },
        getApps: function (nameFilter, page, limit, options) {
            return (0, exports.AppsApiFp)(configuration).getApps(nameFilter, page, limit, options)(fetch, basePath);
        },
        getCompliance: function (appId, options) {
            return (0, exports.AppsApiFp)(configuration).getCompliance(appId, options)(fetch, basePath);
        },
        getPanaceaVanityUrl: function (appId, options) {
            return (0, exports.AppsApiFp)(configuration).getPanaceaVanityUrl(appId, options)(fetch, basePath);
        },
        getSupportedCountries: function (options) {
            return (0, exports.AppsApiFp)(configuration).getSupportedCountries(options)(fetch, basePath);
        },
        isPanaceaVanityUrlAvailable: function (vanityUrl, appId, options) {
            return (0, exports.AppsApiFp)(configuration).isPanaceaVanityUrlAvailable(vanityUrl, appId, options)(fetch, basePath);
        },
        lookupByWhitelabelId: function (whitelabelId, options) {
            return (0, exports.AppsApiFp)(configuration).lookupByWhitelabelId(whitelabelId, options)(fetch, basePath);
        },
        sendPushNotification: function (appId, customerId, body, options) {
            return (0, exports.AppsApiFp)(configuration).sendPushNotification(appId, customerId, body, options)(fetch, basePath);
        },
        setAppConfig: function (appId, AppConfigUpdateModel, options) {
            return (0, exports.AppsApiFp)(configuration).setAppConfig(appId, AppConfigUpdateModel, options)(fetch, basePath);
        },
        setAppHostname: function (appId, hostname, isEmbed, options) {
            return (0, exports.AppsApiFp)(configuration).setAppHostname(appId, hostname, isEmbed, options)(fetch, basePath);
        },
        setAppLanguages: function (appId, Language, options) {
            return (0, exports.AppsApiFp)(configuration).setAppLanguages(appId, Language, options)(fetch, basePath);
        },
        setAppStoreName: function (appId, body, options) {
            return (0, exports.AppsApiFp)(configuration).setAppStoreName(appId, body, options)(fetch, basePath);
        },
        setCompliance: function (appId, complianceType, options) {
            return (0, exports.AppsApiFp)(configuration).setCompliance(appId, complianceType, options)(fetch, basePath);
        },
        setPanaceaVanityUrl: function (appId, vanityUrl, options) {
            return (0, exports.AppsApiFp)(configuration).setPanaceaVanityUrl(appId, vanityUrl, options)(fetch, basePath);
        },
        setThirdPartyIntegrations: function (appId, enabled, options) {
            return (0, exports.AppsApiFp)(configuration).setThirdPartyIntegrations(appId, enabled, options)(fetch, basePath);
        },
        toggleNextGenWeb: function (appId, hostname, vanityUrl, isNextGenWeb, options) {
            return (0, exports.AppsApiFp)(configuration).toggleNextGenWeb(appId, hostname, vanityUrl, isNextGenWeb, options)(fetch, basePath);
        },
        uploadAppLogo: function (appId, Image, options) {
            return (0, exports.AppsApiFp)(configuration).uploadAppLogo(appId, Image, options)(fetch, basePath);
        },
    };
};
exports.AppsApiFactory = AppsApiFactory;
var AppsApi = (function (_super) {
    __extends(AppsApi, _super);
    function AppsApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    AppsApi.prototype.appsSetPropertyId = function (appId, orgId, options) {
        return (0, exports.AppsApiFp)(this.configuration).appsSetPropertyId(appId, orgId, options)(this.fetch, this.basePath);
    };
    AppsApi.prototype.createApp = function (CreateAppParameters, options) {
        return (0, exports.AppsApiFp)(this.configuration).createApp(CreateAppParameters, options)(this.fetch, this.basePath);
    };
    AppsApi.prototype.getApp = function (appId, options) {
        return (0, exports.AppsApiFp)(this.configuration).getApp(appId, options)(this.fetch, this.basePath);
    };
    AppsApi.prototype.getAppHostnameStatus = function (appId, options) {
        return (0, exports.AppsApiFp)(this.configuration).getAppHostnameStatus(appId, options)(this.fetch, this.basePath);
    };
    AppsApi.prototype.getAppName = function (appId, options) {
        return (0, exports.AppsApiFp)(this.configuration).getAppName(appId, options)(this.fetch, this.basePath);
    };
    AppsApi.prototype.getApps = function (nameFilter, page, limit, options) {
        return (0, exports.AppsApiFp)(this.configuration).getApps(nameFilter, page, limit, options)(this.fetch, this.basePath);
    };
    AppsApi.prototype.getCompliance = function (appId, options) {
        return (0, exports.AppsApiFp)(this.configuration).getCompliance(appId, options)(this.fetch, this.basePath);
    };
    AppsApi.prototype.getPanaceaVanityUrl = function (appId, options) {
        return (0, exports.AppsApiFp)(this.configuration).getPanaceaVanityUrl(appId, options)(this.fetch, this.basePath);
    };
    AppsApi.prototype.getSupportedCountries = function (options) {
        return (0, exports.AppsApiFp)(this.configuration).getSupportedCountries(options)(this.fetch, this.basePath);
    };
    AppsApi.prototype.isPanaceaVanityUrlAvailable = function (vanityUrl, appId, options) {
        return (0, exports.AppsApiFp)(this.configuration).isPanaceaVanityUrlAvailable(vanityUrl, appId, options)(this.fetch, this.basePath);
    };
    AppsApi.prototype.lookupByWhitelabelId = function (whitelabelId, options) {
        return (0, exports.AppsApiFp)(this.configuration).lookupByWhitelabelId(whitelabelId, options)(this.fetch, this.basePath);
    };
    AppsApi.prototype.sendPushNotification = function (appId, customerId, body, options) {
        return (0, exports.AppsApiFp)(this.configuration).sendPushNotification(appId, customerId, body, options)(this.fetch, this.basePath);
    };
    AppsApi.prototype.setAppConfig = function (appId, AppConfigUpdateModel, options) {
        return (0, exports.AppsApiFp)(this.configuration).setAppConfig(appId, AppConfigUpdateModel, options)(this.fetch, this.basePath);
    };
    AppsApi.prototype.setAppHostname = function (appId, hostname, isEmbed, options) {
        return (0, exports.AppsApiFp)(this.configuration).setAppHostname(appId, hostname, isEmbed, options)(this.fetch, this.basePath);
    };
    AppsApi.prototype.setAppLanguages = function (appId, Language, options) {
        return (0, exports.AppsApiFp)(this.configuration).setAppLanguages(appId, Language, options)(this.fetch, this.basePath);
    };
    AppsApi.prototype.setAppStoreName = function (appId, body, options) {
        return (0, exports.AppsApiFp)(this.configuration).setAppStoreName(appId, body, options)(this.fetch, this.basePath);
    };
    AppsApi.prototype.setCompliance = function (appId, complianceType, options) {
        return (0, exports.AppsApiFp)(this.configuration).setCompliance(appId, complianceType, options)(this.fetch, this.basePath);
    };
    AppsApi.prototype.setPanaceaVanityUrl = function (appId, vanityUrl, options) {
        return (0, exports.AppsApiFp)(this.configuration).setPanaceaVanityUrl(appId, vanityUrl, options)(this.fetch, this.basePath);
    };
    AppsApi.prototype.setThirdPartyIntegrations = function (appId, enabled, options) {
        return (0, exports.AppsApiFp)(this.configuration).setThirdPartyIntegrations(appId, enabled, options)(this.fetch, this.basePath);
    };
    AppsApi.prototype.toggleNextGenWeb = function (appId, hostname, vanityUrl, isNextGenWeb, options) {
        return (0, exports.AppsApiFp)(this.configuration).toggleNextGenWeb(appId, hostname, vanityUrl, isNextGenWeb, options)(this.fetch, this.basePath);
    };
    AppsApi.prototype.uploadAppLogo = function (appId, Image, options) {
        return (0, exports.AppsApiFp)(this.configuration).uploadAppLogo(appId, Image, options)(this.fetch, this.basePath);
    };
    return AppsApi;
}(BaseAPI));
exports.AppsApi = AppsApi;
var AuditLogsApiFetchParamCreator = function (configuration) {
    return {
        addOrderAuditLog: function (orderId, ExternalStoreAuditLog, options) {
            if (options === void 0) { options = {}; }
            if (orderId === null || orderId === undefined) {
                throw new RequiredError('orderId', 'Required parameter orderId was null or undefined when calling addOrderAuditLog.');
            }
            if (ExternalStoreAuditLog === null || ExternalStoreAuditLog === undefined) {
                throw new RequiredError('ExternalStoreAuditLog', 'Required parameter ExternalStoreAuditLog was null or undefined when calling addOrderAuditLog.');
            }
            var localVarPath = "/api/v1.0/auditlogs/orders/{orderId}"
                .replace("{".concat("orderId", "}"), encodeURIComponent(String(orderId)));
            var localVarUrlObj = url.parse(localVarPath, true);
            var localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            var localVarHeaderParameter = {};
            var localVarQueryParameter = {};
            if (configuration && configuration.accessToken) {
                var localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("oauth2", ["api"])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }
            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            var needsSerialization = ("Array&lt;ExternalStoreAuditLog&gt;" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body = needsSerialization ? JSON.stringify(ExternalStoreAuditLog || {}) : (ExternalStoreAuditLog || "");
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        addStoreAuditLogEvent: function (storeId, ExternalStoreAuditLog, options) {
            if (options === void 0) { options = {}; }
            if (storeId === null || storeId === undefined) {
                throw new RequiredError('storeId', 'Required parameter storeId was null or undefined when calling addStoreAuditLogEvent.');
            }
            if (ExternalStoreAuditLog === null || ExternalStoreAuditLog === undefined) {
                throw new RequiredError('ExternalStoreAuditLog', 'Required parameter ExternalStoreAuditLog was null or undefined when calling addStoreAuditLogEvent.');
            }
            var localVarPath = "/api/v1.0/auditlogs/stores/{storeId}"
                .replace("{".concat("storeId", "}"), encodeURIComponent(String(storeId)));
            var localVarUrlObj = url.parse(localVarPath, true);
            var localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            var localVarHeaderParameter = {};
            var localVarQueryParameter = {};
            if (configuration && configuration.accessToken) {
                var localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("oauth2", ["api"])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }
            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            var needsSerialization = ("Array&lt;ExternalStoreAuditLog&gt;" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body = needsSerialization ? JSON.stringify(ExternalStoreAuditLog || {}) : (ExternalStoreAuditLog || "");
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    };
};
exports.AuditLogsApiFetchParamCreator = AuditLogsApiFetchParamCreator;
var AuditLogsApiFp = function (configuration) {
    return {
        addOrderAuditLog: function (orderId, ExternalStoreAuditLog, options) {
            var localVarFetchArgs = (0, exports.AuditLogsApiFetchParamCreator)(configuration).addOrderAuditLog(orderId, ExternalStoreAuditLog, options);
            return function (fetch, basePath) {
                if (fetch === void 0) { fetch = portableFetch; }
                if (basePath === void 0) { basePath = BASE_PATH; }
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then(function (response) {
                    if (response.status >= 200 && response.status < 300) {
                        return response;
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
        addStoreAuditLogEvent: function (storeId, ExternalStoreAuditLog, options) {
            var localVarFetchArgs = (0, exports.AuditLogsApiFetchParamCreator)(configuration).addStoreAuditLogEvent(storeId, ExternalStoreAuditLog, options);
            return function (fetch, basePath) {
                if (fetch === void 0) { fetch = portableFetch; }
                if (basePath === void 0) { basePath = BASE_PATH; }
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then(function (response) {
                    if (response.status >= 200 && response.status < 300) {
                        return response;
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
    };
};
exports.AuditLogsApiFp = AuditLogsApiFp;
var AuditLogsApiFactory = function (configuration, fetch, basePath) {
    return {
        addOrderAuditLog: function (orderId, ExternalStoreAuditLog, options) {
            return (0, exports.AuditLogsApiFp)(configuration).addOrderAuditLog(orderId, ExternalStoreAuditLog, options)(fetch, basePath);
        },
        addStoreAuditLogEvent: function (storeId, ExternalStoreAuditLog, options) {
            return (0, exports.AuditLogsApiFp)(configuration).addStoreAuditLogEvent(storeId, ExternalStoreAuditLog, options)(fetch, basePath);
        },
    };
};
exports.AuditLogsApiFactory = AuditLogsApiFactory;
var AuditLogsApi = (function (_super) {
    __extends(AuditLogsApi, _super);
    function AuditLogsApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    AuditLogsApi.prototype.addOrderAuditLog = function (orderId, ExternalStoreAuditLog, options) {
        return (0, exports.AuditLogsApiFp)(this.configuration).addOrderAuditLog(orderId, ExternalStoreAuditLog, options)(this.fetch, this.basePath);
    };
    AuditLogsApi.prototype.addStoreAuditLogEvent = function (storeId, ExternalStoreAuditLog, options) {
        return (0, exports.AuditLogsApiFp)(this.configuration).addStoreAuditLogEvent(storeId, ExternalStoreAuditLog, options)(this.fetch, this.basePath);
    };
    return AuditLogsApi;
}(BaseAPI));
exports.AuditLogsApi = AuditLogsApi;
var AuthorizationTokensApiFetchParamCreator = function (configuration) {
    return {
        getAuthorizationTokens: function (oauthAppId, appId, page, limit, options) {
            if (options === void 0) { options = {}; }
            if (oauthAppId === null || oauthAppId === undefined) {
                throw new RequiredError('oauthAppId', 'Required parameter oauthAppId was null or undefined when calling getAuthorizationTokens.');
            }
            if (appId === null || appId === undefined) {
                throw new RequiredError('appId', 'Required parameter appId was null or undefined when calling getAuthorizationTokens.');
            }
            var localVarPath = "/api/v1.0/{appId}/authorizationtokens/{oauthAppId}"
                .replace("{".concat("oauthAppId", "}"), encodeURIComponent(String(oauthAppId)))
                .replace("{".concat("appId", "}"), encodeURIComponent(String(appId)));
            var localVarUrlObj = url.parse(localVarPath, true);
            var localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            var localVarHeaderParameter = {};
            var localVarQueryParameter = {};
            if (configuration && configuration.accessToken) {
                var localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("oauth2", ["api"])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }
            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }
            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        revokeToken: function (key, appId, options) {
            if (options === void 0) { options = {}; }
            if (key === null || key === undefined) {
                throw new RequiredError('key', 'Required parameter key was null or undefined when calling revokeToken.');
            }
            if (appId === null || appId === undefined) {
                throw new RequiredError('appId', 'Required parameter appId was null or undefined when calling revokeToken.');
            }
            var localVarPath = "/api/v1.0/{appId}/authorizationtokens/{key}"
                .replace("{".concat("key", "}"), encodeURIComponent(String(key)))
                .replace("{".concat("appId", "}"), encodeURIComponent(String(appId)));
            var localVarUrlObj = url.parse(localVarPath, true);
            var localVarRequestOptions = Object.assign({ method: 'DELETE' }, options);
            var localVarHeaderParameter = {};
            var localVarQueryParameter = {};
            if (configuration && configuration.accessToken) {
                var localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("oauth2", ["api"])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    };
};
exports.AuthorizationTokensApiFetchParamCreator = AuthorizationTokensApiFetchParamCreator;
var AuthorizationTokensApiFp = function (configuration) {
    return {
        getAuthorizationTokens: function (oauthAppId, appId, page, limit, options) {
            var localVarFetchArgs = (0, exports.AuthorizationTokensApiFetchParamCreator)(configuration).getAuthorizationTokens(oauthAppId, appId, page, limit, options);
            return function (fetch, basePath) {
                if (fetch === void 0) { fetch = portableFetch; }
                if (basePath === void 0) { basePath = BASE_PATH; }
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then(function (response) {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
        revokeToken: function (key, appId, options) {
            var localVarFetchArgs = (0, exports.AuthorizationTokensApiFetchParamCreator)(configuration).revokeToken(key, appId, options);
            return function (fetch, basePath) {
                if (fetch === void 0) { fetch = portableFetch; }
                if (basePath === void 0) { basePath = BASE_PATH; }
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then(function (response) {
                    if (response.status >= 200 && response.status < 300) {
                        return response;
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
    };
};
exports.AuthorizationTokensApiFp = AuthorizationTokensApiFp;
var AuthorizationTokensApiFactory = function (configuration, fetch, basePath) {
    return {
        getAuthorizationTokens: function (oauthAppId, appId, page, limit, options) {
            return (0, exports.AuthorizationTokensApiFp)(configuration).getAuthorizationTokens(oauthAppId, appId, page, limit, options)(fetch, basePath);
        },
        revokeToken: function (key, appId, options) {
            return (0, exports.AuthorizationTokensApiFp)(configuration).revokeToken(key, appId, options)(fetch, basePath);
        },
    };
};
exports.AuthorizationTokensApiFactory = AuthorizationTokensApiFactory;
var AuthorizationTokensApi = (function (_super) {
    __extends(AuthorizationTokensApi, _super);
    function AuthorizationTokensApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    AuthorizationTokensApi.prototype.getAuthorizationTokens = function (oauthAppId, appId, page, limit, options) {
        return (0, exports.AuthorizationTokensApiFp)(this.configuration).getAuthorizationTokens(oauthAppId, appId, page, limit, options)(this.fetch, this.basePath);
    };
    AuthorizationTokensApi.prototype.revokeToken = function (key, appId, options) {
        return (0, exports.AuthorizationTokensApiFp)(this.configuration).revokeToken(key, appId, options)(this.fetch, this.basePath);
    };
    return AuthorizationTokensApi;
}(BaseAPI));
exports.AuthorizationTokensApi = AuthorizationTokensApi;
var BankAccountApiFetchParamCreator = function (configuration) {
    return {
        attachBankAccountToStore: function (appId, bankAccountId, storeId, skipBankAccountUpdateWarningEmail, options) {
            if (options === void 0) { options = {}; }
            if (appId === null || appId === undefined) {
                throw new RequiredError('appId', 'Required parameter appId was null or undefined when calling attachBankAccountToStore.');
            }
            if (bankAccountId === null || bankAccountId === undefined) {
                throw new RequiredError('bankAccountId', 'Required parameter bankAccountId was null or undefined when calling attachBankAccountToStore.');
            }
            if (storeId === null || storeId === undefined) {
                throw new RequiredError('storeId', 'Required parameter storeId was null or undefined when calling attachBankAccountToStore.');
            }
            var localVarPath = "/api/v1.0/{appId}/bankaccounts/{bankAccountId}/store/{storeId}"
                .replace("{".concat("appId", "}"), encodeURIComponent(String(appId)))
                .replace("{".concat("bankAccountId", "}"), encodeURIComponent(String(bankAccountId)))
                .replace("{".concat("storeId", "}"), encodeURIComponent(String(storeId)));
            var localVarUrlObj = url.parse(localVarPath, true);
            var localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            var localVarHeaderParameter = {};
            var localVarQueryParameter = {};
            if (configuration && configuration.accessToken) {
                var localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("oauth2", ["api"])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }
            if (skipBankAccountUpdateWarningEmail !== undefined) {
                localVarQueryParameter['skipBankAccountUpdateWarningEmail'] = skipBankAccountUpdateWarningEmail;
            }
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        createBankAccount: function (appId, BankAccountCreate, options) {
            if (options === void 0) { options = {}; }
            if (appId === null || appId === undefined) {
                throw new RequiredError('appId', 'Required parameter appId was null or undefined when calling createBankAccount.');
            }
            if (BankAccountCreate === null || BankAccountCreate === undefined) {
                throw new RequiredError('BankAccountCreate', 'Required parameter BankAccountCreate was null or undefined when calling createBankAccount.');
            }
            var localVarPath = "/api/v1.0/{appId}/bankaccounts"
                .replace("{".concat("appId", "}"), encodeURIComponent(String(appId)));
            var localVarUrlObj = url.parse(localVarPath, true);
            var localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            var localVarHeaderParameter = {};
            var localVarQueryParameter = {};
            if (configuration && configuration.accessToken) {
                var localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("oauth2", ["api"])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }
            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            var needsSerialization = ("BankAccountCreate" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body = needsSerialization ? JSON.stringify(BankAccountCreate || {}) : (BankAccountCreate || "");
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        deleteBankAccount: function (appId, bankAccountId, options) {
            if (options === void 0) { options = {}; }
            if (appId === null || appId === undefined) {
                throw new RequiredError('appId', 'Required parameter appId was null or undefined when calling deleteBankAccount.');
            }
            if (bankAccountId === null || bankAccountId === undefined) {
                throw new RequiredError('bankAccountId', 'Required parameter bankAccountId was null or undefined when calling deleteBankAccount.');
            }
            var localVarPath = "/api/v1.0/{appId}/bankaccounts/{bankAccountId}"
                .replace("{".concat("appId", "}"), encodeURIComponent(String(appId)))
                .replace("{".concat("bankAccountId", "}"), encodeURIComponent(String(bankAccountId)));
            var localVarUrlObj = url.parse(localVarPath, true);
            var localVarRequestOptions = Object.assign({ method: 'DELETE' }, options);
            var localVarHeaderParameter = {};
            var localVarQueryParameter = {};
            if (configuration && configuration.accessToken) {
                var localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("oauth2", ["api"])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        getBankAccountById: function (bankAccountId, appId, options) {
            if (options === void 0) { options = {}; }
            if (bankAccountId === null || bankAccountId === undefined) {
                throw new RequiredError('bankAccountId', 'Required parameter bankAccountId was null or undefined when calling getBankAccountById.');
            }
            if (appId === null || appId === undefined) {
                throw new RequiredError('appId', 'Required parameter appId was null or undefined when calling getBankAccountById.');
            }
            var localVarPath = "/api/v1.0/{appId}/bankaccounts/{bankAccountId}"
                .replace("{".concat("bankAccountId", "}"), encodeURIComponent(String(bankAccountId)))
                .replace("{".concat("appId", "}"), encodeURIComponent(String(appId)));
            var localVarUrlObj = url.parse(localVarPath, true);
            var localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            var localVarHeaderParameter = {};
            var localVarQueryParameter = {};
            if (configuration && configuration.accessToken) {
                var localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("oauth2", ["api"])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        getBankAccounts: function (appId, options) {
            if (options === void 0) { options = {}; }
            if (appId === null || appId === undefined) {
                throw new RequiredError('appId', 'Required parameter appId was null or undefined when calling getBankAccounts.');
            }
            var localVarPath = "/api/v1.0/{appId}/bankaccounts"
                .replace("{".concat("appId", "}"), encodeURIComponent(String(appId)));
            var localVarUrlObj = url.parse(localVarPath, true);
            var localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            var localVarHeaderParameter = {};
            var localVarQueryParameter = {};
            if (configuration && configuration.accessToken) {
                var localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("oauth2", ["api"])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        getCountriesWithFieldDefinitions: function (appId, options) {
            if (options === void 0) { options = {}; }
            if (appId === null || appId === undefined) {
                throw new RequiredError('appId', 'Required parameter appId was null or undefined when calling getCountriesWithFieldDefinitions.');
            }
            var localVarPath = "/api/v1.0/{appId}/bankaccounts/countries-field-definitions"
                .replace("{".concat("appId", "}"), encodeURIComponent(String(appId)));
            var localVarUrlObj = url.parse(localVarPath, true);
            var localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            var localVarHeaderParameter = {};
            var localVarQueryParameter = {};
            if (configuration && configuration.accessToken) {
                var localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("oauth2", ["api"])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        getFieldDefinitions: function (appId, options) {
            if (options === void 0) { options = {}; }
            if (appId === null || appId === undefined) {
                throw new RequiredError('appId', 'Required parameter appId was null or undefined when calling getFieldDefinitions.');
            }
            var localVarPath = "/api/v1.0/{appId}/bankaccounts/field-definitions"
                .replace("{".concat("appId", "}"), encodeURIComponent(String(appId)));
            var localVarUrlObj = url.parse(localVarPath, true);
            var localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            var localVarHeaderParameter = {};
            var localVarQueryParameter = {};
            if (configuration && configuration.accessToken) {
                var localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("oauth2", ["api"])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        updateBankAccount: function (appId, bankAccountId, BankAccountCreate, options) {
            if (options === void 0) { options = {}; }
            if (appId === null || appId === undefined) {
                throw new RequiredError('appId', 'Required parameter appId was null or undefined when calling updateBankAccount.');
            }
            if (bankAccountId === null || bankAccountId === undefined) {
                throw new RequiredError('bankAccountId', 'Required parameter bankAccountId was null or undefined when calling updateBankAccount.');
            }
            if (BankAccountCreate === null || BankAccountCreate === undefined) {
                throw new RequiredError('BankAccountCreate', 'Required parameter BankAccountCreate was null or undefined when calling updateBankAccount.');
            }
            var localVarPath = "/api/v1.0/{appId}/bankaccounts/{bankAccountId}"
                .replace("{".concat("appId", "}"), encodeURIComponent(String(appId)))
                .replace("{".concat("bankAccountId", "}"), encodeURIComponent(String(bankAccountId)));
            var localVarUrlObj = url.parse(localVarPath, true);
            var localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            var localVarHeaderParameter = {};
            var localVarQueryParameter = {};
            if (configuration && configuration.accessToken) {
                var localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("oauth2", ["api"])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }
            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            var needsSerialization = ("BankAccountCreate" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body = needsSerialization ? JSON.stringify(BankAccountCreate || {}) : (BankAccountCreate || "");
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        updateBankAccountState: function (appId, bankAccountId, state, body, options) {
            if (options === void 0) { options = {}; }
            if (appId === null || appId === undefined) {
                throw new RequiredError('appId', 'Required parameter appId was null or undefined when calling updateBankAccountState.');
            }
            if (bankAccountId === null || bankAccountId === undefined) {
                throw new RequiredError('bankAccountId', 'Required parameter bankAccountId was null or undefined when calling updateBankAccountState.');
            }
            if (state === null || state === undefined) {
                throw new RequiredError('state', 'Required parameter state was null or undefined when calling updateBankAccountState.');
            }
            if (body === null || body === undefined) {
                throw new RequiredError('body', 'Required parameter body was null or undefined when calling updateBankAccountState.');
            }
            var localVarPath = "/api/v1.0/{appId}/bankaccounts/{bankAccountId}/state/{state}"
                .replace("{".concat("appId", "}"), encodeURIComponent(String(appId)))
                .replace("{".concat("bankAccountId", "}"), encodeURIComponent(String(bankAccountId)))
                .replace("{".concat("state", "}"), encodeURIComponent(String(state)));
            var localVarUrlObj = url.parse(localVarPath, true);
            var localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            var localVarHeaderParameter = {};
            var localVarQueryParameter = {};
            if (configuration && configuration.accessToken) {
                var localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("oauth2", ["api"])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }
            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            var needsSerialization = ("string" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body = needsSerialization ? JSON.stringify(body || {}) : (body || "");
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    };
};
exports.BankAccountApiFetchParamCreator = BankAccountApiFetchParamCreator;
var BankAccountApiFp = function (configuration) {
    return {
        attachBankAccountToStore: function (appId, bankAccountId, storeId, skipBankAccountUpdateWarningEmail, options) {
            var localVarFetchArgs = (0, exports.BankAccountApiFetchParamCreator)(configuration).attachBankAccountToStore(appId, bankAccountId, storeId, skipBankAccountUpdateWarningEmail, options);
            return function (fetch, basePath) {
                if (fetch === void 0) { fetch = portableFetch; }
                if (basePath === void 0) { basePath = BASE_PATH; }
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then(function (response) {
                    if (response.status >= 200 && response.status < 300) {
                        return response;
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
        createBankAccount: function (appId, BankAccountCreate, options) {
            var localVarFetchArgs = (0, exports.BankAccountApiFetchParamCreator)(configuration).createBankAccount(appId, BankAccountCreate, options);
            return function (fetch, basePath) {
                if (fetch === void 0) { fetch = portableFetch; }
                if (basePath === void 0) { basePath = BASE_PATH; }
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then(function (response) {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
        deleteBankAccount: function (appId, bankAccountId, options) {
            var localVarFetchArgs = (0, exports.BankAccountApiFetchParamCreator)(configuration).deleteBankAccount(appId, bankAccountId, options);
            return function (fetch, basePath) {
                if (fetch === void 0) { fetch = portableFetch; }
                if (basePath === void 0) { basePath = BASE_PATH; }
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then(function (response) {
                    if (response.status >= 200 && response.status < 300) {
                        return response;
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
        getBankAccountById: function (bankAccountId, appId, options) {
            var localVarFetchArgs = (0, exports.BankAccountApiFetchParamCreator)(configuration).getBankAccountById(bankAccountId, appId, options);
            return function (fetch, basePath) {
                if (fetch === void 0) { fetch = portableFetch; }
                if (basePath === void 0) { basePath = BASE_PATH; }
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then(function (response) {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
        getBankAccounts: function (appId, options) {
            var localVarFetchArgs = (0, exports.BankAccountApiFetchParamCreator)(configuration).getBankAccounts(appId, options);
            return function (fetch, basePath) {
                if (fetch === void 0) { fetch = portableFetch; }
                if (basePath === void 0) { basePath = BASE_PATH; }
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then(function (response) {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
        getCountriesWithFieldDefinitions: function (appId, options) {
            var localVarFetchArgs = (0, exports.BankAccountApiFetchParamCreator)(configuration).getCountriesWithFieldDefinitions(appId, options);
            return function (fetch, basePath) {
                if (fetch === void 0) { fetch = portableFetch; }
                if (basePath === void 0) { basePath = BASE_PATH; }
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then(function (response) {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
        getFieldDefinitions: function (appId, options) {
            var localVarFetchArgs = (0, exports.BankAccountApiFetchParamCreator)(configuration).getFieldDefinitions(appId, options);
            return function (fetch, basePath) {
                if (fetch === void 0) { fetch = portableFetch; }
                if (basePath === void 0) { basePath = BASE_PATH; }
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then(function (response) {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
        updateBankAccount: function (appId, bankAccountId, BankAccountCreate, options) {
            var localVarFetchArgs = (0, exports.BankAccountApiFetchParamCreator)(configuration).updateBankAccount(appId, bankAccountId, BankAccountCreate, options);
            return function (fetch, basePath) {
                if (fetch === void 0) { fetch = portableFetch; }
                if (basePath === void 0) { basePath = BASE_PATH; }
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then(function (response) {
                    if (response.status >= 200 && response.status < 300) {
                        return response;
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
        updateBankAccountState: function (appId, bankAccountId, state, body, options) {
            var localVarFetchArgs = (0, exports.BankAccountApiFetchParamCreator)(configuration).updateBankAccountState(appId, bankAccountId, state, body, options);
            return function (fetch, basePath) {
                if (fetch === void 0) { fetch = portableFetch; }
                if (basePath === void 0) { basePath = BASE_PATH; }
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then(function (response) {
                    if (response.status >= 200 && response.status < 300) {
                        return response;
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
    };
};
exports.BankAccountApiFp = BankAccountApiFp;
var BankAccountApiFactory = function (configuration, fetch, basePath) {
    return {
        attachBankAccountToStore: function (appId, bankAccountId, storeId, skipBankAccountUpdateWarningEmail, options) {
            return (0, exports.BankAccountApiFp)(configuration).attachBankAccountToStore(appId, bankAccountId, storeId, skipBankAccountUpdateWarningEmail, options)(fetch, basePath);
        },
        createBankAccount: function (appId, BankAccountCreate, options) {
            return (0, exports.BankAccountApiFp)(configuration).createBankAccount(appId, BankAccountCreate, options)(fetch, basePath);
        },
        deleteBankAccount: function (appId, bankAccountId, options) {
            return (0, exports.BankAccountApiFp)(configuration).deleteBankAccount(appId, bankAccountId, options)(fetch, basePath);
        },
        getBankAccountById: function (bankAccountId, appId, options) {
            return (0, exports.BankAccountApiFp)(configuration).getBankAccountById(bankAccountId, appId, options)(fetch, basePath);
        },
        getBankAccounts: function (appId, options) {
            return (0, exports.BankAccountApiFp)(configuration).getBankAccounts(appId, options)(fetch, basePath);
        },
        getCountriesWithFieldDefinitions: function (appId, options) {
            return (0, exports.BankAccountApiFp)(configuration).getCountriesWithFieldDefinitions(appId, options)(fetch, basePath);
        },
        getFieldDefinitions: function (appId, options) {
            return (0, exports.BankAccountApiFp)(configuration).getFieldDefinitions(appId, options)(fetch, basePath);
        },
        updateBankAccount: function (appId, bankAccountId, BankAccountCreate, options) {
            return (0, exports.BankAccountApiFp)(configuration).updateBankAccount(appId, bankAccountId, BankAccountCreate, options)(fetch, basePath);
        },
        updateBankAccountState: function (appId, bankAccountId, state, body, options) {
            return (0, exports.BankAccountApiFp)(configuration).updateBankAccountState(appId, bankAccountId, state, body, options)(fetch, basePath);
        },
    };
};
exports.BankAccountApiFactory = BankAccountApiFactory;
var BankAccountApi = (function (_super) {
    __extends(BankAccountApi, _super);
    function BankAccountApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    BankAccountApi.prototype.attachBankAccountToStore = function (appId, bankAccountId, storeId, skipBankAccountUpdateWarningEmail, options) {
        return (0, exports.BankAccountApiFp)(this.configuration).attachBankAccountToStore(appId, bankAccountId, storeId, skipBankAccountUpdateWarningEmail, options)(this.fetch, this.basePath);
    };
    BankAccountApi.prototype.createBankAccount = function (appId, BankAccountCreate, options) {
        return (0, exports.BankAccountApiFp)(this.configuration).createBankAccount(appId, BankAccountCreate, options)(this.fetch, this.basePath);
    };
    BankAccountApi.prototype.deleteBankAccount = function (appId, bankAccountId, options) {
        return (0, exports.BankAccountApiFp)(this.configuration).deleteBankAccount(appId, bankAccountId, options)(this.fetch, this.basePath);
    };
    BankAccountApi.prototype.getBankAccountById = function (bankAccountId, appId, options) {
        return (0, exports.BankAccountApiFp)(this.configuration).getBankAccountById(bankAccountId, appId, options)(this.fetch, this.basePath);
    };
    BankAccountApi.prototype.getBankAccounts = function (appId, options) {
        return (0, exports.BankAccountApiFp)(this.configuration).getBankAccounts(appId, options)(this.fetch, this.basePath);
    };
    BankAccountApi.prototype.getCountriesWithFieldDefinitions = function (appId, options) {
        return (0, exports.BankAccountApiFp)(this.configuration).getCountriesWithFieldDefinitions(appId, options)(this.fetch, this.basePath);
    };
    BankAccountApi.prototype.getFieldDefinitions = function (appId, options) {
        return (0, exports.BankAccountApiFp)(this.configuration).getFieldDefinitions(appId, options)(this.fetch, this.basePath);
    };
    BankAccountApi.prototype.updateBankAccount = function (appId, bankAccountId, BankAccountCreate, options) {
        return (0, exports.BankAccountApiFp)(this.configuration).updateBankAccount(appId, bankAccountId, BankAccountCreate, options)(this.fetch, this.basePath);
    };
    BankAccountApi.prototype.updateBankAccountState = function (appId, bankAccountId, state, body, options) {
        return (0, exports.BankAccountApiFp)(this.configuration).updateBankAccountState(appId, bankAccountId, state, body, options)(this.fetch, this.basePath);
    };
    return BankAccountApi;
}(BaseAPI));
exports.BankAccountApi = BankAccountApi;
var CampaignsApiFetchParamCreator = function (configuration) {
    return {
        createLoyaltyCampaign: function (appId, LoyaltyCampaignBase, options) {
            if (options === void 0) { options = {}; }
            if (appId === null || appId === undefined) {
                throw new RequiredError('appId', 'Required parameter appId was null or undefined when calling createLoyaltyCampaign.');
            }
            if (LoyaltyCampaignBase === null || LoyaltyCampaignBase === undefined) {
                throw new RequiredError('LoyaltyCampaignBase', 'Required parameter LoyaltyCampaignBase was null or undefined when calling createLoyaltyCampaign.');
            }
            var localVarPath = "/api/v1.0/{appId}/campaigns/loyalty"
                .replace("{".concat("appId", "}"), encodeURIComponent(String(appId)));
            var localVarUrlObj = url.parse(localVarPath, true);
            var localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            var localVarHeaderParameter = {};
            var localVarQueryParameter = {};
            if (configuration && configuration.accessToken) {
                var localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("oauth2", ["api"])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }
            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            var needsSerialization = ("LoyaltyCampaignBase" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body = needsSerialization ? JSON.stringify(LoyaltyCampaignBase || {}) : (LoyaltyCampaignBase || "");
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        createRetentionCampaign: function (appId, RetentionCampaignBase, options) {
            if (options === void 0) { options = {}; }
            if (appId === null || appId === undefined) {
                throw new RequiredError('appId', 'Required parameter appId was null or undefined when calling createRetentionCampaign.');
            }
            if (RetentionCampaignBase === null || RetentionCampaignBase === undefined) {
                throw new RequiredError('RetentionCampaignBase', 'Required parameter RetentionCampaignBase was null or undefined when calling createRetentionCampaign.');
            }
            var localVarPath = "/api/v1.0/{appId}/campaigns/retention"
                .replace("{".concat("appId", "}"), encodeURIComponent(String(appId)));
            var localVarUrlObj = url.parse(localVarPath, true);
            var localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            var localVarHeaderParameter = {};
            var localVarQueryParameter = {};
            if (configuration && configuration.accessToken) {
                var localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("oauth2", ["api"])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }
            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            var needsSerialization = ("RetentionCampaignBase" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body = needsSerialization ? JSON.stringify(RetentionCampaignBase || {}) : (RetentionCampaignBase || "");
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        getLoyaltyCampaignsForApp: function (appId, options) {
            if (options === void 0) { options = {}; }
            if (appId === null || appId === undefined) {
                throw new RequiredError('appId', 'Required parameter appId was null or undefined when calling getLoyaltyCampaignsForApp.');
            }
            var localVarPath = "/api/v1.0/{appId}/campaigns/loyalty"
                .replace("{".concat("appId", "}"), encodeURIComponent(String(appId)));
            var localVarUrlObj = url.parse(localVarPath, true);
            var localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            var localVarHeaderParameter = {};
            var localVarQueryParameter = {};
            if (configuration && configuration.accessToken) {
                var localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("oauth2", ["api"])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        getLoyaltyCampaignsForStore: function (appId, storeId, options) {
            if (options === void 0) { options = {}; }
            if (appId === null || appId === undefined) {
                throw new RequiredError('appId', 'Required parameter appId was null or undefined when calling getLoyaltyCampaignsForStore.');
            }
            if (storeId === null || storeId === undefined) {
                throw new RequiredError('storeId', 'Required parameter storeId was null or undefined when calling getLoyaltyCampaignsForStore.');
            }
            var localVarPath = "/api/v1.0/{appId}/campaigns/loyalty/{storeId}"
                .replace("{".concat("appId", "}"), encodeURIComponent(String(appId)))
                .replace("{".concat("storeId", "}"), encodeURIComponent(String(storeId)));
            var localVarUrlObj = url.parse(localVarPath, true);
            var localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            var localVarHeaderParameter = {};
            var localVarQueryParameter = {};
            if (configuration && configuration.accessToken) {
                var localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("oauth2", ["api"])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        getRetentionCampaignsForApp: function (appId, options) {
            if (options === void 0) { options = {}; }
            if (appId === null || appId === undefined) {
                throw new RequiredError('appId', 'Required parameter appId was null or undefined when calling getRetentionCampaignsForApp.');
            }
            var localVarPath = "/api/v1.0/{appId}/campaigns/retention"
                .replace("{".concat("appId", "}"), encodeURIComponent(String(appId)));
            var localVarUrlObj = url.parse(localVarPath, true);
            var localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            var localVarHeaderParameter = {};
            var localVarQueryParameter = {};
            if (configuration && configuration.accessToken) {
                var localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("oauth2", ["api"])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        getRetentionCampaignsForStore: function (appId, storeId, options) {
            if (options === void 0) { options = {}; }
            if (appId === null || appId === undefined) {
                throw new RequiredError('appId', 'Required parameter appId was null or undefined when calling getRetentionCampaignsForStore.');
            }
            if (storeId === null || storeId === undefined) {
                throw new RequiredError('storeId', 'Required parameter storeId was null or undefined when calling getRetentionCampaignsForStore.');
            }
            var localVarPath = "/api/v1.0/{appId}/campaigns/retention/{storeId}"
                .replace("{".concat("appId", "}"), encodeURIComponent(String(appId)))
                .replace("{".concat("storeId", "}"), encodeURIComponent(String(storeId)));
            var localVarUrlObj = url.parse(localVarPath, true);
            var localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            var localVarHeaderParameter = {};
            var localVarQueryParameter = {};
            if (configuration && configuration.accessToken) {
                var localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("oauth2", ["api"])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        getStoreList: function (appId, onlyPublished, options) {
            if (options === void 0) { options = {}; }
            if (appId === null || appId === undefined) {
                throw new RequiredError('appId', 'Required parameter appId was null or undefined when calling getStoreList.');
            }
            var localVarPath = "/api/v1.0/{appId}/campaigns/stores"
                .replace("{".concat("appId", "}"), encodeURIComponent(String(appId)));
            var localVarUrlObj = url.parse(localVarPath, true);
            var localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            var localVarHeaderParameter = {};
            var localVarQueryParameter = {};
            if (configuration && configuration.accessToken) {
                var localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("oauth2", ["api"])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }
            if (onlyPublished !== undefined) {
                localVarQueryParameter['onlyPublished'] = onlyPublished;
            }
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        removeCampaign: function (appId, campaignId, options) {
            if (options === void 0) { options = {}; }
            if (appId === null || appId === undefined) {
                throw new RequiredError('appId', 'Required parameter appId was null or undefined when calling removeCampaign.');
            }
            if (campaignId === null || campaignId === undefined) {
                throw new RequiredError('campaignId', 'Required parameter campaignId was null or undefined when calling removeCampaign.');
            }
            var localVarPath = "/api/v1.0/{appId}/campaigns/{campaignId}"
                .replace("{".concat("appId", "}"), encodeURIComponent(String(appId)))
                .replace("{".concat("campaignId", "}"), encodeURIComponent(String(campaignId)));
            var localVarUrlObj = url.parse(localVarPath, true);
            var localVarRequestOptions = Object.assign({ method: 'DELETE' }, options);
            var localVarHeaderParameter = {};
            var localVarQueryParameter = {};
            if (configuration && configuration.accessToken) {
                var localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("oauth2", ["api"])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        updateLoyaltyCampaign: function (appId, campaignId, LoyaltyCampaignBase, options) {
            if (options === void 0) { options = {}; }
            if (appId === null || appId === undefined) {
                throw new RequiredError('appId', 'Required parameter appId was null or undefined when calling updateLoyaltyCampaign.');
            }
            if (campaignId === null || campaignId === undefined) {
                throw new RequiredError('campaignId', 'Required parameter campaignId was null or undefined when calling updateLoyaltyCampaign.');
            }
            if (LoyaltyCampaignBase === null || LoyaltyCampaignBase === undefined) {
                throw new RequiredError('LoyaltyCampaignBase', 'Required parameter LoyaltyCampaignBase was null or undefined when calling updateLoyaltyCampaign.');
            }
            var localVarPath = "/api/v1.0/{appId}/campaigns/loyalty/{campaignId}"
                .replace("{".concat("appId", "}"), encodeURIComponent(String(appId)))
                .replace("{".concat("campaignId", "}"), encodeURIComponent(String(campaignId)));
            var localVarUrlObj = url.parse(localVarPath, true);
            var localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            var localVarHeaderParameter = {};
            var localVarQueryParameter = {};
            if (configuration && configuration.accessToken) {
                var localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("oauth2", ["api"])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }
            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            var needsSerialization = ("LoyaltyCampaignBase" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body = needsSerialization ? JSON.stringify(LoyaltyCampaignBase || {}) : (LoyaltyCampaignBase || "");
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        updateRetentionCampaign: function (appId, campaignId, RetentionCampaignBase, options) {
            if (options === void 0) { options = {}; }
            if (appId === null || appId === undefined) {
                throw new RequiredError('appId', 'Required parameter appId was null or undefined when calling updateRetentionCampaign.');
            }
            if (campaignId === null || campaignId === undefined) {
                throw new RequiredError('campaignId', 'Required parameter campaignId was null or undefined when calling updateRetentionCampaign.');
            }
            if (RetentionCampaignBase === null || RetentionCampaignBase === undefined) {
                throw new RequiredError('RetentionCampaignBase', 'Required parameter RetentionCampaignBase was null or undefined when calling updateRetentionCampaign.');
            }
            var localVarPath = "/api/v1.0/{appId}/campaigns/retention/{campaignId}"
                .replace("{".concat("appId", "}"), encodeURIComponent(String(appId)))
                .replace("{".concat("campaignId", "}"), encodeURIComponent(String(campaignId)));
            var localVarUrlObj = url.parse(localVarPath, true);
            var localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            var localVarHeaderParameter = {};
            var localVarQueryParameter = {};
            if (configuration && configuration.accessToken) {
                var localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("oauth2", ["api"])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }
            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            var needsSerialization = ("RetentionCampaignBase" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body = needsSerialization ? JSON.stringify(RetentionCampaignBase || {}) : (RetentionCampaignBase || "");
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    };
};
exports.CampaignsApiFetchParamCreator = CampaignsApiFetchParamCreator;
var CampaignsApiFp = function (configuration) {
    return {
        createLoyaltyCampaign: function (appId, LoyaltyCampaignBase, options) {
            var localVarFetchArgs = (0, exports.CampaignsApiFetchParamCreator)(configuration).createLoyaltyCampaign(appId, LoyaltyCampaignBase, options);
            return function (fetch, basePath) {
                if (fetch === void 0) { fetch = portableFetch; }
                if (basePath === void 0) { basePath = BASE_PATH; }
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then(function (response) {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
        createRetentionCampaign: function (appId, RetentionCampaignBase, options) {
            var localVarFetchArgs = (0, exports.CampaignsApiFetchParamCreator)(configuration).createRetentionCampaign(appId, RetentionCampaignBase, options);
            return function (fetch, basePath) {
                if (fetch === void 0) { fetch = portableFetch; }
                if (basePath === void 0) { basePath = BASE_PATH; }
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then(function (response) {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
        getLoyaltyCampaignsForApp: function (appId, options) {
            var localVarFetchArgs = (0, exports.CampaignsApiFetchParamCreator)(configuration).getLoyaltyCampaignsForApp(appId, options);
            return function (fetch, basePath) {
                if (fetch === void 0) { fetch = portableFetch; }
                if (basePath === void 0) { basePath = BASE_PATH; }
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then(function (response) {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
        getLoyaltyCampaignsForStore: function (appId, storeId, options) {
            var localVarFetchArgs = (0, exports.CampaignsApiFetchParamCreator)(configuration).getLoyaltyCampaignsForStore(appId, storeId, options);
            return function (fetch, basePath) {
                if (fetch === void 0) { fetch = portableFetch; }
                if (basePath === void 0) { basePath = BASE_PATH; }
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then(function (response) {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
        getRetentionCampaignsForApp: function (appId, options) {
            var localVarFetchArgs = (0, exports.CampaignsApiFetchParamCreator)(configuration).getRetentionCampaignsForApp(appId, options);
            return function (fetch, basePath) {
                if (fetch === void 0) { fetch = portableFetch; }
                if (basePath === void 0) { basePath = BASE_PATH; }
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then(function (response) {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
        getRetentionCampaignsForStore: function (appId, storeId, options) {
            var localVarFetchArgs = (0, exports.CampaignsApiFetchParamCreator)(configuration).getRetentionCampaignsForStore(appId, storeId, options);
            return function (fetch, basePath) {
                if (fetch === void 0) { fetch = portableFetch; }
                if (basePath === void 0) { basePath = BASE_PATH; }
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then(function (response) {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
        getStoreList: function (appId, onlyPublished, options) {
            var localVarFetchArgs = (0, exports.CampaignsApiFetchParamCreator)(configuration).getStoreList(appId, onlyPublished, options);
            return function (fetch, basePath) {
                if (fetch === void 0) { fetch = portableFetch; }
                if (basePath === void 0) { basePath = BASE_PATH; }
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then(function (response) {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
        removeCampaign: function (appId, campaignId, options) {
            var localVarFetchArgs = (0, exports.CampaignsApiFetchParamCreator)(configuration).removeCampaign(appId, campaignId, options);
            return function (fetch, basePath) {
                if (fetch === void 0) { fetch = portableFetch; }
                if (basePath === void 0) { basePath = BASE_PATH; }
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then(function (response) {
                    if (response.status >= 200 && response.status < 300) {
                        return response;
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
        updateLoyaltyCampaign: function (appId, campaignId, LoyaltyCampaignBase, options) {
            var localVarFetchArgs = (0, exports.CampaignsApiFetchParamCreator)(configuration).updateLoyaltyCampaign(appId, campaignId, LoyaltyCampaignBase, options);
            return function (fetch, basePath) {
                if (fetch === void 0) { fetch = portableFetch; }
                if (basePath === void 0) { basePath = BASE_PATH; }
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then(function (response) {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
        updateRetentionCampaign: function (appId, campaignId, RetentionCampaignBase, options) {
            var localVarFetchArgs = (0, exports.CampaignsApiFetchParamCreator)(configuration).updateRetentionCampaign(appId, campaignId, RetentionCampaignBase, options);
            return function (fetch, basePath) {
                if (fetch === void 0) { fetch = portableFetch; }
                if (basePath === void 0) { basePath = BASE_PATH; }
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then(function (response) {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
    };
};
exports.CampaignsApiFp = CampaignsApiFp;
var CampaignsApiFactory = function (configuration, fetch, basePath) {
    return {
        createLoyaltyCampaign: function (appId, LoyaltyCampaignBase, options) {
            return (0, exports.CampaignsApiFp)(configuration).createLoyaltyCampaign(appId, LoyaltyCampaignBase, options)(fetch, basePath);
        },
        createRetentionCampaign: function (appId, RetentionCampaignBase, options) {
            return (0, exports.CampaignsApiFp)(configuration).createRetentionCampaign(appId, RetentionCampaignBase, options)(fetch, basePath);
        },
        getLoyaltyCampaignsForApp: function (appId, options) {
            return (0, exports.CampaignsApiFp)(configuration).getLoyaltyCampaignsForApp(appId, options)(fetch, basePath);
        },
        getLoyaltyCampaignsForStore: function (appId, storeId, options) {
            return (0, exports.CampaignsApiFp)(configuration).getLoyaltyCampaignsForStore(appId, storeId, options)(fetch, basePath);
        },
        getRetentionCampaignsForApp: function (appId, options) {
            return (0, exports.CampaignsApiFp)(configuration).getRetentionCampaignsForApp(appId, options)(fetch, basePath);
        },
        getRetentionCampaignsForStore: function (appId, storeId, options) {
            return (0, exports.CampaignsApiFp)(configuration).getRetentionCampaignsForStore(appId, storeId, options)(fetch, basePath);
        },
        getStoreList: function (appId, onlyPublished, options) {
            return (0, exports.CampaignsApiFp)(configuration).getStoreList(appId, onlyPublished, options)(fetch, basePath);
        },
        removeCampaign: function (appId, campaignId, options) {
            return (0, exports.CampaignsApiFp)(configuration).removeCampaign(appId, campaignId, options)(fetch, basePath);
        },
        updateLoyaltyCampaign: function (appId, campaignId, LoyaltyCampaignBase, options) {
            return (0, exports.CampaignsApiFp)(configuration).updateLoyaltyCampaign(appId, campaignId, LoyaltyCampaignBase, options)(fetch, basePath);
        },
        updateRetentionCampaign: function (appId, campaignId, RetentionCampaignBase, options) {
            return (0, exports.CampaignsApiFp)(configuration).updateRetentionCampaign(appId, campaignId, RetentionCampaignBase, options)(fetch, basePath);
        },
    };
};
exports.CampaignsApiFactory = CampaignsApiFactory;
var CampaignsApi = (function (_super) {
    __extends(CampaignsApi, _super);
    function CampaignsApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    CampaignsApi.prototype.createLoyaltyCampaign = function (appId, LoyaltyCampaignBase, options) {
        return (0, exports.CampaignsApiFp)(this.configuration).createLoyaltyCampaign(appId, LoyaltyCampaignBase, options)(this.fetch, this.basePath);
    };
    CampaignsApi.prototype.createRetentionCampaign = function (appId, RetentionCampaignBase, options) {
        return (0, exports.CampaignsApiFp)(this.configuration).createRetentionCampaign(appId, RetentionCampaignBase, options)(this.fetch, this.basePath);
    };
    CampaignsApi.prototype.getLoyaltyCampaignsForApp = function (appId, options) {
        return (0, exports.CampaignsApiFp)(this.configuration).getLoyaltyCampaignsForApp(appId, options)(this.fetch, this.basePath);
    };
    CampaignsApi.prototype.getLoyaltyCampaignsForStore = function (appId, storeId, options) {
        return (0, exports.CampaignsApiFp)(this.configuration).getLoyaltyCampaignsForStore(appId, storeId, options)(this.fetch, this.basePath);
    };
    CampaignsApi.prototype.getRetentionCampaignsForApp = function (appId, options) {
        return (0, exports.CampaignsApiFp)(this.configuration).getRetentionCampaignsForApp(appId, options)(this.fetch, this.basePath);
    };
    CampaignsApi.prototype.getRetentionCampaignsForStore = function (appId, storeId, options) {
        return (0, exports.CampaignsApiFp)(this.configuration).getRetentionCampaignsForStore(appId, storeId, options)(this.fetch, this.basePath);
    };
    CampaignsApi.prototype.getStoreList = function (appId, onlyPublished, options) {
        return (0, exports.CampaignsApiFp)(this.configuration).getStoreList(appId, onlyPublished, options)(this.fetch, this.basePath);
    };
    CampaignsApi.prototype.removeCampaign = function (appId, campaignId, options) {
        return (0, exports.CampaignsApiFp)(this.configuration).removeCampaign(appId, campaignId, options)(this.fetch, this.basePath);
    };
    CampaignsApi.prototype.updateLoyaltyCampaign = function (appId, campaignId, LoyaltyCampaignBase, options) {
        return (0, exports.CampaignsApiFp)(this.configuration).updateLoyaltyCampaign(appId, campaignId, LoyaltyCampaignBase, options)(this.fetch, this.basePath);
    };
    CampaignsApi.prototype.updateRetentionCampaign = function (appId, campaignId, RetentionCampaignBase, options) {
        return (0, exports.CampaignsApiFp)(this.configuration).updateRetentionCampaign(appId, campaignId, RetentionCampaignBase, options)(this.fetch, this.basePath);
    };
    return CampaignsApi;
}(BaseAPI));
exports.CampaignsApi = CampaignsApi;
var CardReadersApiFetchParamCreator = function (configuration) {
    return {
        cancelCurrentlyInitiatedBluetoothDeviceUpdate: function (appId, deviceId, terminalType, options) {
            if (options === void 0) { options = {}; }
            if (appId === null || appId === undefined) {
                throw new RequiredError('appId', 'Required parameter appId was null or undefined when calling cancelCurrentlyInitiatedBluetoothDeviceUpdate.');
            }
            if (deviceId === null || deviceId === undefined) {
                throw new RequiredError('deviceId', 'Required parameter deviceId was null or undefined when calling cancelCurrentlyInitiatedBluetoothDeviceUpdate.');
            }
            if (terminalType === null || terminalType === undefined) {
                throw new RequiredError('terminalType', 'Required parameter terminalType was null or undefined when calling cancelCurrentlyInitiatedBluetoothDeviceUpdate.');
            }
            var localVarPath = "/api/v1.0/{appId}/cardreaders/kiosk/{deviceId}/bluetooth/{terminalType}/cancelUpdate"
                .replace("{".concat("appId", "}"), encodeURIComponent(String(appId)))
                .replace("{".concat("deviceId", "}"), encodeURIComponent(String(deviceId)))
                .replace("{".concat("terminalType", "}"), encodeURIComponent(String(terminalType)));
            var localVarUrlObj = url.parse(localVarPath, true);
            var localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            var localVarHeaderParameter = {};
            var localVarQueryParameter = {};
            if (configuration && configuration.accessToken) {
                var localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("oauth2", ["api"])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        cancelReaderAction: function (readerId, appId, options) {
            if (options === void 0) { options = {}; }
            if (readerId === null || readerId === undefined) {
                throw new RequiredError('readerId', 'Required parameter readerId was null or undefined when calling cancelReaderAction.');
            }
            if (appId === null || appId === undefined) {
                throw new RequiredError('appId', 'Required parameter appId was null or undefined when calling cancelReaderAction.');
            }
            var localVarPath = "/api/v1.0/{appId}/payments/terminals/stripe/{readerId}/cancel_action"
                .replace("{".concat("readerId", "}"), encodeURIComponent(String(readerId)))
                .replace("{".concat("appId", "}"), encodeURIComponent(String(appId)));
            var localVarUrlObj = url.parse(localVarPath, true);
            var localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            var localVarHeaderParameter = {};
            var localVarQueryParameter = {};
            if (configuration && configuration.accessToken) {
                var localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("oauth2", ["api"])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        cardReadersGetReader: function (readerId, appId, options) {
            if (options === void 0) { options = {}; }
            if (readerId === null || readerId === undefined) {
                throw new RequiredError('readerId', 'Required parameter readerId was null or undefined when calling cardReadersGetReader.');
            }
            if (appId === null || appId === undefined) {
                throw new RequiredError('appId', 'Required parameter appId was null or undefined when calling cardReadersGetReader.');
            }
            var localVarPath = "/api/v1.0/{appId}/payments/terminals/stripe/{readerId}"
                .replace("{".concat("readerId", "}"), encodeURIComponent(String(readerId)))
                .replace("{".concat("appId", "}"), encodeURIComponent(String(appId)));
            var localVarUrlObj = url.parse(localVarPath, true);
            var localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            var localVarHeaderParameter = {};
            var localVarQueryParameter = {};
            if (configuration && configuration.accessToken) {
                var localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("oauth2", ["api"])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        generateStripeTerminalLocation: function (appId, GeoPointRequest, options) {
            if (options === void 0) { options = {}; }
            if (appId === null || appId === undefined) {
                throw new RequiredError('appId', 'Required parameter appId was null or undefined when calling generateStripeTerminalLocation.');
            }
            if (GeoPointRequest === null || GeoPointRequest === undefined) {
                throw new RequiredError('GeoPointRequest', 'Required parameter GeoPointRequest was null or undefined when calling generateStripeTerminalLocation.');
            }
            var localVarPath = "/api/v1.0/{appId}/stripeterminal/location"
                .replace("{".concat("appId", "}"), encodeURIComponent(String(appId)));
            var localVarUrlObj = url.parse(localVarPath, true);
            var localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            var localVarHeaderParameter = {};
            var localVarQueryParameter = {};
            if (configuration && configuration.accessToken) {
                var localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("oauth2", ["api"])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }
            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            var needsSerialization = ("GeoPointRequest" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body = needsSerialization ? JSON.stringify(GeoPointRequest || {}) : (GeoPointRequest || "");
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        getBluetoothTerminalStatus: function (appId, deviceId, options) {
            if (options === void 0) { options = {}; }
            if (appId === null || appId === undefined) {
                throw new RequiredError('appId', 'Required parameter appId was null or undefined when calling getBluetoothTerminalStatus.');
            }
            if (deviceId === null || deviceId === undefined) {
                throw new RequiredError('deviceId', 'Required parameter deviceId was null or undefined when calling getBluetoothTerminalStatus.');
            }
            var localVarPath = "/api/v1.0/{appId}/cardreaders/kiosk/{deviceId}/bluetooth/status"
                .replace("{".concat("appId", "}"), encodeURIComponent(String(appId)))
                .replace("{".concat("deviceId", "}"), encodeURIComponent(String(deviceId)));
            var localVarUrlObj = url.parse(localVarPath, true);
            var localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            var localVarHeaderParameter = {};
            var localVarQueryParameter = {};
            if (configuration && configuration.accessToken) {
                var localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("oauth2", ["api"])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        getKioskStripeLocation: function (appId, deviceId, options) {
            if (options === void 0) { options = {}; }
            if (appId === null || appId === undefined) {
                throw new RequiredError('appId', 'Required parameter appId was null or undefined when calling getKioskStripeLocation.');
            }
            if (deviceId === null || deviceId === undefined) {
                throw new RequiredError('deviceId', 'Required parameter deviceId was null or undefined when calling getKioskStripeLocation.');
            }
            var localVarPath = "/api/v1.0/{appId}/cardreaders/kiosk/{deviceId}/stripe-location"
                .replace("{".concat("appId", "}"), encodeURIComponent(String(appId)))
                .replace("{".concat("deviceId", "}"), encodeURIComponent(String(deviceId)));
            var localVarUrlObj = url.parse(localVarPath, true);
            var localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            var localVarHeaderParameter = {};
            var localVarQueryParameter = {};
            if (configuration && configuration.accessToken) {
                var localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("oauth2", ["api"])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        getStripeConnectionToken: function (appId, options) {
            if (options === void 0) { options = {}; }
            if (appId === null || appId === undefined) {
                throw new RequiredError('appId', 'Required parameter appId was null or undefined when calling getStripeConnectionToken.');
            }
            var localVarPath = "/api/v1.0/{appId}/stripeterminal/connectiontoken"
                .replace("{".concat("appId", "}"), encodeURIComponent(String(appId)));
            var localVarUrlObj = url.parse(localVarPath, true);
            var localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            var localVarHeaderParameter = {};
            var localVarQueryParameter = {};
            if (configuration && configuration.accessToken) {
                var localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("oauth2", ["api"])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        initiateBluetoothTerminalDeviceUpdateCheck: function (appId, deviceId, terminalType, options) {
            if (options === void 0) { options = {}; }
            if (appId === null || appId === undefined) {
                throw new RequiredError('appId', 'Required parameter appId was null or undefined when calling initiateBluetoothTerminalDeviceUpdateCheck.');
            }
            if (deviceId === null || deviceId === undefined) {
                throw new RequiredError('deviceId', 'Required parameter deviceId was null or undefined when calling initiateBluetoothTerminalDeviceUpdateCheck.');
            }
            if (terminalType === null || terminalType === undefined) {
                throw new RequiredError('terminalType', 'Required parameter terminalType was null or undefined when calling initiateBluetoothTerminalDeviceUpdateCheck.');
            }
            var localVarPath = "/api/v1.0/{appId}/cardreaders/kiosk/{deviceId}/bluetooth/{terminalType}/checkForUpdate"
                .replace("{".concat("appId", "}"), encodeURIComponent(String(appId)))
                .replace("{".concat("deviceId", "}"), encodeURIComponent(String(deviceId)))
                .replace("{".concat("terminalType", "}"), encodeURIComponent(String(terminalType)));
            var localVarUrlObj = url.parse(localVarPath, true);
            var localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            var localVarHeaderParameter = {};
            var localVarQueryParameter = {};
            if (configuration && configuration.accessToken) {
                var localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("oauth2", ["api"])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        initiateKioskBluetoothPairingMode: function (appId, deviceId, terminalType, options) {
            if (options === void 0) { options = {}; }
            if (appId === null || appId === undefined) {
                throw new RequiredError('appId', 'Required parameter appId was null or undefined when calling initiateKioskBluetoothPairingMode.');
            }
            if (deviceId === null || deviceId === undefined) {
                throw new RequiredError('deviceId', 'Required parameter deviceId was null or undefined when calling initiateKioskBluetoothPairingMode.');
            }
            if (terminalType === null || terminalType === undefined) {
                throw new RequiredError('terminalType', 'Required parameter terminalType was null or undefined when calling initiateKioskBluetoothPairingMode.');
            }
            var localVarPath = "/api/v1.0/{appId}/cardreaders/kiosk/{deviceId}/bluetooth/{terminalType}/pair"
                .replace("{".concat("appId", "}"), encodeURIComponent(String(appId)))
                .replace("{".concat("deviceId", "}"), encodeURIComponent(String(deviceId)))
                .replace("{".concat("terminalType", "}"), encodeURIComponent(String(terminalType)));
            var localVarUrlObj = url.parse(localVarPath, true);
            var localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            var localVarHeaderParameter = {};
            var localVarQueryParameter = {};
            if (configuration && configuration.accessToken) {
                var localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("oauth2", ["api"])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        initiateKioskBluetoothUpdateInstall: function (appId, deviceId, terminalType, options) {
            if (options === void 0) { options = {}; }
            if (appId === null || appId === undefined) {
                throw new RequiredError('appId', 'Required parameter appId was null or undefined when calling initiateKioskBluetoothUpdateInstall.');
            }
            if (deviceId === null || deviceId === undefined) {
                throw new RequiredError('deviceId', 'Required parameter deviceId was null or undefined when calling initiateKioskBluetoothUpdateInstall.');
            }
            if (terminalType === null || terminalType === undefined) {
                throw new RequiredError('terminalType', 'Required parameter terminalType was null or undefined when calling initiateKioskBluetoothUpdateInstall.');
            }
            var localVarPath = "/api/v1.0/{appId}/cardreaders/kiosk/{deviceId}/bluetooth/{terminalType}/installUpdate"
                .replace("{".concat("appId", "}"), encodeURIComponent(String(appId)))
                .replace("{".concat("deviceId", "}"), encodeURIComponent(String(deviceId)))
                .replace("{".concat("terminalType", "}"), encodeURIComponent(String(terminalType)));
            var localVarUrlObj = url.parse(localVarPath, true);
            var localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            var localVarHeaderParameter = {};
            var localVarQueryParameter = {};
            if (configuration && configuration.accessToken) {
                var localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("oauth2", ["api"])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        initiateReaderProcessPaymentIntent: function (readerId, appId, ProcessPaymentIntentRequest, options) {
            if (options === void 0) { options = {}; }
            if (readerId === null || readerId === undefined) {
                throw new RequiredError('readerId', 'Required parameter readerId was null or undefined when calling initiateReaderProcessPaymentIntent.');
            }
            if (appId === null || appId === undefined) {
                throw new RequiredError('appId', 'Required parameter appId was null or undefined when calling initiateReaderProcessPaymentIntent.');
            }
            if (ProcessPaymentIntentRequest === null || ProcessPaymentIntentRequest === undefined) {
                throw new RequiredError('ProcessPaymentIntentRequest', 'Required parameter ProcessPaymentIntentRequest was null or undefined when calling initiateReaderProcessPaymentIntent.');
            }
            var localVarPath = "/api/v1.0/{appId}/payments/terminals/stripe/{readerId}/processPaymentIntent"
                .replace("{".concat("readerId", "}"), encodeURIComponent(String(readerId)))
                .replace("{".concat("appId", "}"), encodeURIComponent(String(appId)));
            var localVarUrlObj = url.parse(localVarPath, true);
            var localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            var localVarHeaderParameter = {};
            var localVarQueryParameter = {};
            if (configuration && configuration.accessToken) {
                var localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("oauth2", ["api"])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }
            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            var needsSerialization = ("ProcessPaymentIntentRequest" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body = needsSerialization ? JSON.stringify(ProcessPaymentIntentRequest || {}) : (ProcessPaymentIntentRequest || "");
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        registerStripeTerminal: function (appId, CardReaderRegistrationRequest, options) {
            if (options === void 0) { options = {}; }
            if (appId === null || appId === undefined) {
                throw new RequiredError('appId', 'Required parameter appId was null or undefined when calling registerStripeTerminal.');
            }
            if (CardReaderRegistrationRequest === null || CardReaderRegistrationRequest === undefined) {
                throw new RequiredError('CardReaderRegistrationRequest', 'Required parameter CardReaderRegistrationRequest was null or undefined when calling registerStripeTerminal.');
            }
            var localVarPath = "/api/v1.0/{appId}/payments/terminals/stripe/register"
                .replace("{".concat("appId", "}"), encodeURIComponent(String(appId)));
            var localVarUrlObj = url.parse(localVarPath, true);
            var localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            var localVarHeaderParameter = {};
            var localVarQueryParameter = {};
            if (configuration && configuration.accessToken) {
                var localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("oauth2", ["api"])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }
            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            var needsSerialization = ("CardReaderRegistrationRequest" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body = needsSerialization ? JSON.stringify(CardReaderRegistrationRequest || {}) : (CardReaderRegistrationRequest || "");
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        unRegisterTerminal: function (appId, UnRegisterCardReaderRequest, options) {
            if (options === void 0) { options = {}; }
            if (appId === null || appId === undefined) {
                throw new RequiredError('appId', 'Required parameter appId was null or undefined when calling unRegisterTerminal.');
            }
            if (UnRegisterCardReaderRequest === null || UnRegisterCardReaderRequest === undefined) {
                throw new RequiredError('UnRegisterCardReaderRequest', 'Required parameter UnRegisterCardReaderRequest was null or undefined when calling unRegisterTerminal.');
            }
            var localVarPath = "/api/v1.0/{appId}/payments/terminals/stripe/unregister"
                .replace("{".concat("appId", "}"), encodeURIComponent(String(appId)));
            var localVarUrlObj = url.parse(localVarPath, true);
            var localVarRequestOptions = Object.assign({ method: 'DELETE' }, options);
            var localVarHeaderParameter = {};
            var localVarQueryParameter = {};
            if (configuration && configuration.accessToken) {
                var localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("oauth2", ["api"])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }
            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            var needsSerialization = ("UnRegisterCardReaderRequest" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body = needsSerialization ? JSON.stringify(UnRegisterCardReaderRequest || {}) : (UnRegisterCardReaderRequest || "");
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        unpairCurrentlyPairedBluetoothDevice: function (appId, deviceId, options) {
            if (options === void 0) { options = {}; }
            if (appId === null || appId === undefined) {
                throw new RequiredError('appId', 'Required parameter appId was null or undefined when calling unpairCurrentlyPairedBluetoothDevice.');
            }
            if (deviceId === null || deviceId === undefined) {
                throw new RequiredError('deviceId', 'Required parameter deviceId was null or undefined when calling unpairCurrentlyPairedBluetoothDevice.');
            }
            var localVarPath = "/api/v1.0/{appId}/cardreaders/kiosk/{deviceId}/bluetooth/unpair"
                .replace("{".concat("appId", "}"), encodeURIComponent(String(appId)))
                .replace("{".concat("deviceId", "}"), encodeURIComponent(String(deviceId)));
            var localVarUrlObj = url.parse(localVarPath, true);
            var localVarRequestOptions = Object.assign({ method: 'DELETE' }, options);
            var localVarHeaderParameter = {};
            var localVarQueryParameter = {};
            if (configuration && configuration.accessToken) {
                var localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("oauth2", ["api"])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    };
};
exports.CardReadersApiFetchParamCreator = CardReadersApiFetchParamCreator;
var CardReadersApiFp = function (configuration) {
    return {
        cancelCurrentlyInitiatedBluetoothDeviceUpdate: function (appId, deviceId, terminalType, options) {
            var localVarFetchArgs = (0, exports.CardReadersApiFetchParamCreator)(configuration).cancelCurrentlyInitiatedBluetoothDeviceUpdate(appId, deviceId, terminalType, options);
            return function (fetch, basePath) {
                if (fetch === void 0) { fetch = portableFetch; }
                if (basePath === void 0) { basePath = BASE_PATH; }
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then(function (response) {
                    if (response.status >= 200 && response.status < 300) {
                        return response;
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
        cancelReaderAction: function (readerId, appId, options) {
            var localVarFetchArgs = (0, exports.CardReadersApiFetchParamCreator)(configuration).cancelReaderAction(readerId, appId, options);
            return function (fetch, basePath) {
                if (fetch === void 0) { fetch = portableFetch; }
                if (basePath === void 0) { basePath = BASE_PATH; }
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then(function (response) {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
        cardReadersGetReader: function (readerId, appId, options) {
            var localVarFetchArgs = (0, exports.CardReadersApiFetchParamCreator)(configuration).cardReadersGetReader(readerId, appId, options);
            return function (fetch, basePath) {
                if (fetch === void 0) { fetch = portableFetch; }
                if (basePath === void 0) { basePath = BASE_PATH; }
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then(function (response) {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
        generateStripeTerminalLocation: function (appId, GeoPointRequest, options) {
            var localVarFetchArgs = (0, exports.CardReadersApiFetchParamCreator)(configuration).generateStripeTerminalLocation(appId, GeoPointRequest, options);
            return function (fetch, basePath) {
                if (fetch === void 0) { fetch = portableFetch; }
                if (basePath === void 0) { basePath = BASE_PATH; }
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then(function (response) {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
        getBluetoothTerminalStatus: function (appId, deviceId, options) {
            var localVarFetchArgs = (0, exports.CardReadersApiFetchParamCreator)(configuration).getBluetoothTerminalStatus(appId, deviceId, options);
            return function (fetch, basePath) {
                if (fetch === void 0) { fetch = portableFetch; }
                if (basePath === void 0) { basePath = BASE_PATH; }
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then(function (response) {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
        getKioskStripeLocation: function (appId, deviceId, options) {
            var localVarFetchArgs = (0, exports.CardReadersApiFetchParamCreator)(configuration).getKioskStripeLocation(appId, deviceId, options);
            return function (fetch, basePath) {
                if (fetch === void 0) { fetch = portableFetch; }
                if (basePath === void 0) { basePath = BASE_PATH; }
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then(function (response) {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
        getStripeConnectionToken: function (appId, options) {
            var localVarFetchArgs = (0, exports.CardReadersApiFetchParamCreator)(configuration).getStripeConnectionToken(appId, options);
            return function (fetch, basePath) {
                if (fetch === void 0) { fetch = portableFetch; }
                if (basePath === void 0) { basePath = BASE_PATH; }
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then(function (response) {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
        initiateBluetoothTerminalDeviceUpdateCheck: function (appId, deviceId, terminalType, options) {
            var localVarFetchArgs = (0, exports.CardReadersApiFetchParamCreator)(configuration).initiateBluetoothTerminalDeviceUpdateCheck(appId, deviceId, terminalType, options);
            return function (fetch, basePath) {
                if (fetch === void 0) { fetch = portableFetch; }
                if (basePath === void 0) { basePath = BASE_PATH; }
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then(function (response) {
                    if (response.status >= 200 && response.status < 300) {
                        return response;
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
        initiateKioskBluetoothPairingMode: function (appId, deviceId, terminalType, options) {
            var localVarFetchArgs = (0, exports.CardReadersApiFetchParamCreator)(configuration).initiateKioskBluetoothPairingMode(appId, deviceId, terminalType, options);
            return function (fetch, basePath) {
                if (fetch === void 0) { fetch = portableFetch; }
                if (basePath === void 0) { basePath = BASE_PATH; }
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then(function (response) {
                    if (response.status >= 200 && response.status < 300) {
                        return response;
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
        initiateKioskBluetoothUpdateInstall: function (appId, deviceId, terminalType, options) {
            var localVarFetchArgs = (0, exports.CardReadersApiFetchParamCreator)(configuration).initiateKioskBluetoothUpdateInstall(appId, deviceId, terminalType, options);
            return function (fetch, basePath) {
                if (fetch === void 0) { fetch = portableFetch; }
                if (basePath === void 0) { basePath = BASE_PATH; }
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then(function (response) {
                    if (response.status >= 200 && response.status < 300) {
                        return response;
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
        initiateReaderProcessPaymentIntent: function (readerId, appId, ProcessPaymentIntentRequest, options) {
            var localVarFetchArgs = (0, exports.CardReadersApiFetchParamCreator)(configuration).initiateReaderProcessPaymentIntent(readerId, appId, ProcessPaymentIntentRequest, options);
            return function (fetch, basePath) {
                if (fetch === void 0) { fetch = portableFetch; }
                if (basePath === void 0) { basePath = BASE_PATH; }
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then(function (response) {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
        registerStripeTerminal: function (appId, CardReaderRegistrationRequest, options) {
            var localVarFetchArgs = (0, exports.CardReadersApiFetchParamCreator)(configuration).registerStripeTerminal(appId, CardReaderRegistrationRequest, options);
            return function (fetch, basePath) {
                if (fetch === void 0) { fetch = portableFetch; }
                if (basePath === void 0) { basePath = BASE_PATH; }
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then(function (response) {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
        unRegisterTerminal: function (appId, UnRegisterCardReaderRequest, options) {
            var localVarFetchArgs = (0, exports.CardReadersApiFetchParamCreator)(configuration).unRegisterTerminal(appId, UnRegisterCardReaderRequest, options);
            return function (fetch, basePath) {
                if (fetch === void 0) { fetch = portableFetch; }
                if (basePath === void 0) { basePath = BASE_PATH; }
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then(function (response) {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
        unpairCurrentlyPairedBluetoothDevice: function (appId, deviceId, options) {
            var localVarFetchArgs = (0, exports.CardReadersApiFetchParamCreator)(configuration).unpairCurrentlyPairedBluetoothDevice(appId, deviceId, options);
            return function (fetch, basePath) {
                if (fetch === void 0) { fetch = portableFetch; }
                if (basePath === void 0) { basePath = BASE_PATH; }
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then(function (response) {
                    if (response.status >= 200 && response.status < 300) {
                        return response;
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
    };
};
exports.CardReadersApiFp = CardReadersApiFp;
var CardReadersApiFactory = function (configuration, fetch, basePath) {
    return {
        cancelCurrentlyInitiatedBluetoothDeviceUpdate: function (appId, deviceId, terminalType, options) {
            return (0, exports.CardReadersApiFp)(configuration).cancelCurrentlyInitiatedBluetoothDeviceUpdate(appId, deviceId, terminalType, options)(fetch, basePath);
        },
        cancelReaderAction: function (readerId, appId, options) {
            return (0, exports.CardReadersApiFp)(configuration).cancelReaderAction(readerId, appId, options)(fetch, basePath);
        },
        cardReadersGetReader: function (readerId, appId, options) {
            return (0, exports.CardReadersApiFp)(configuration).cardReadersGetReader(readerId, appId, options)(fetch, basePath);
        },
        generateStripeTerminalLocation: function (appId, GeoPointRequest, options) {
            return (0, exports.CardReadersApiFp)(configuration).generateStripeTerminalLocation(appId, GeoPointRequest, options)(fetch, basePath);
        },
        getBluetoothTerminalStatus: function (appId, deviceId, options) {
            return (0, exports.CardReadersApiFp)(configuration).getBluetoothTerminalStatus(appId, deviceId, options)(fetch, basePath);
        },
        getKioskStripeLocation: function (appId, deviceId, options) {
            return (0, exports.CardReadersApiFp)(configuration).getKioskStripeLocation(appId, deviceId, options)(fetch, basePath);
        },
        getStripeConnectionToken: function (appId, options) {
            return (0, exports.CardReadersApiFp)(configuration).getStripeConnectionToken(appId, options)(fetch, basePath);
        },
        initiateBluetoothTerminalDeviceUpdateCheck: function (appId, deviceId, terminalType, options) {
            return (0, exports.CardReadersApiFp)(configuration).initiateBluetoothTerminalDeviceUpdateCheck(appId, deviceId, terminalType, options)(fetch, basePath);
        },
        initiateKioskBluetoothPairingMode: function (appId, deviceId, terminalType, options) {
            return (0, exports.CardReadersApiFp)(configuration).initiateKioskBluetoothPairingMode(appId, deviceId, terminalType, options)(fetch, basePath);
        },
        initiateKioskBluetoothUpdateInstall: function (appId, deviceId, terminalType, options) {
            return (0, exports.CardReadersApiFp)(configuration).initiateKioskBluetoothUpdateInstall(appId, deviceId, terminalType, options)(fetch, basePath);
        },
        initiateReaderProcessPaymentIntent: function (readerId, appId, ProcessPaymentIntentRequest, options) {
            return (0, exports.CardReadersApiFp)(configuration).initiateReaderProcessPaymentIntent(readerId, appId, ProcessPaymentIntentRequest, options)(fetch, basePath);
        },
        registerStripeTerminal: function (appId, CardReaderRegistrationRequest, options) {
            return (0, exports.CardReadersApiFp)(configuration).registerStripeTerminal(appId, CardReaderRegistrationRequest, options)(fetch, basePath);
        },
        unRegisterTerminal: function (appId, UnRegisterCardReaderRequest, options) {
            return (0, exports.CardReadersApiFp)(configuration).unRegisterTerminal(appId, UnRegisterCardReaderRequest, options)(fetch, basePath);
        },
        unpairCurrentlyPairedBluetoothDevice: function (appId, deviceId, options) {
            return (0, exports.CardReadersApiFp)(configuration).unpairCurrentlyPairedBluetoothDevice(appId, deviceId, options)(fetch, basePath);
        },
    };
};
exports.CardReadersApiFactory = CardReadersApiFactory;
var CardReadersApi = (function (_super) {
    __extends(CardReadersApi, _super);
    function CardReadersApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    CardReadersApi.prototype.cancelCurrentlyInitiatedBluetoothDeviceUpdate = function (appId, deviceId, terminalType, options) {
        return (0, exports.CardReadersApiFp)(this.configuration).cancelCurrentlyInitiatedBluetoothDeviceUpdate(appId, deviceId, terminalType, options)(this.fetch, this.basePath);
    };
    CardReadersApi.prototype.cancelReaderAction = function (readerId, appId, options) {
        return (0, exports.CardReadersApiFp)(this.configuration).cancelReaderAction(readerId, appId, options)(this.fetch, this.basePath);
    };
    CardReadersApi.prototype.cardReadersGetReader = function (readerId, appId, options) {
        return (0, exports.CardReadersApiFp)(this.configuration).cardReadersGetReader(readerId, appId, options)(this.fetch, this.basePath);
    };
    CardReadersApi.prototype.generateStripeTerminalLocation = function (appId, GeoPointRequest, options) {
        return (0, exports.CardReadersApiFp)(this.configuration).generateStripeTerminalLocation(appId, GeoPointRequest, options)(this.fetch, this.basePath);
    };
    CardReadersApi.prototype.getBluetoothTerminalStatus = function (appId, deviceId, options) {
        return (0, exports.CardReadersApiFp)(this.configuration).getBluetoothTerminalStatus(appId, deviceId, options)(this.fetch, this.basePath);
    };
    CardReadersApi.prototype.getKioskStripeLocation = function (appId, deviceId, options) {
        return (0, exports.CardReadersApiFp)(this.configuration).getKioskStripeLocation(appId, deviceId, options)(this.fetch, this.basePath);
    };
    CardReadersApi.prototype.getStripeConnectionToken = function (appId, options) {
        return (0, exports.CardReadersApiFp)(this.configuration).getStripeConnectionToken(appId, options)(this.fetch, this.basePath);
    };
    CardReadersApi.prototype.initiateBluetoothTerminalDeviceUpdateCheck = function (appId, deviceId, terminalType, options) {
        return (0, exports.CardReadersApiFp)(this.configuration).initiateBluetoothTerminalDeviceUpdateCheck(appId, deviceId, terminalType, options)(this.fetch, this.basePath);
    };
    CardReadersApi.prototype.initiateKioskBluetoothPairingMode = function (appId, deviceId, terminalType, options) {
        return (0, exports.CardReadersApiFp)(this.configuration).initiateKioskBluetoothPairingMode(appId, deviceId, terminalType, options)(this.fetch, this.basePath);
    };
    CardReadersApi.prototype.initiateKioskBluetoothUpdateInstall = function (appId, deviceId, terminalType, options) {
        return (0, exports.CardReadersApiFp)(this.configuration).initiateKioskBluetoothUpdateInstall(appId, deviceId, terminalType, options)(this.fetch, this.basePath);
    };
    CardReadersApi.prototype.initiateReaderProcessPaymentIntent = function (readerId, appId, ProcessPaymentIntentRequest, options) {
        return (0, exports.CardReadersApiFp)(this.configuration).initiateReaderProcessPaymentIntent(readerId, appId, ProcessPaymentIntentRequest, options)(this.fetch, this.basePath);
    };
    CardReadersApi.prototype.registerStripeTerminal = function (appId, CardReaderRegistrationRequest, options) {
        return (0, exports.CardReadersApiFp)(this.configuration).registerStripeTerminal(appId, CardReaderRegistrationRequest, options)(this.fetch, this.basePath);
    };
    CardReadersApi.prototype.unRegisterTerminal = function (appId, UnRegisterCardReaderRequest, options) {
        return (0, exports.CardReadersApiFp)(this.configuration).unRegisterTerminal(appId, UnRegisterCardReaderRequest, options)(this.fetch, this.basePath);
    };
    CardReadersApi.prototype.unpairCurrentlyPairedBluetoothDevice = function (appId, deviceId, options) {
        return (0, exports.CardReadersApiFp)(this.configuration).unpairCurrentlyPairedBluetoothDevice(appId, deviceId, options)(this.fetch, this.basePath);
    };
    return CardReadersApi;
}(BaseAPI));
exports.CardReadersApi = CardReadersApi;
var CatalogChangesApiFetchParamCreator = function (configuration) {
    return {
        getPendingMenuChanges: function (appId, menuId, catalogItemId, page, limit, options) {
            if (options === void 0) { options = {}; }
            if (appId === null || appId === undefined) {
                throw new RequiredError('appId', 'Required parameter appId was null or undefined when calling getPendingMenuChanges.');
            }
            var localVarPath = "/api/v1.0/{appId}/menus/catalog-changes"
                .replace("{".concat("appId", "}"), encodeURIComponent(String(appId)));
            var localVarUrlObj = url.parse(localVarPath, true);
            var localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            var localVarHeaderParameter = {};
            var localVarQueryParameter = {};
            if (configuration && configuration.accessToken) {
                var localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("oauth2", ["api"])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }
            if (menuId !== undefined) {
                localVarQueryParameter['menuId'] = menuId;
            }
            if (catalogItemId !== undefined) {
                localVarQueryParameter['catalogItemId'] = catalogItemId;
            }
            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }
            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        getPendingMenuChangesSummaries: function (appId, options) {
            if (options === void 0) { options = {}; }
            if (appId === null || appId === undefined) {
                throw new RequiredError('appId', 'Required parameter appId was null or undefined when calling getPendingMenuChangesSummaries.');
            }
            var localVarPath = "/api/v1.0/{appId}/menus/catalog-changes/summaries"
                .replace("{".concat("appId", "}"), encodeURIComponent(String(appId)));
            var localVarUrlObj = url.parse(localVarPath, true);
            var localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            var localVarHeaderParameter = {};
            var localVarQueryParameter = {};
            if (configuration && configuration.accessToken) {
                var localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("oauth2", ["api"])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        publishPendingMenuChanges: function (appId, PublishMenuChanges, options) {
            if (options === void 0) { options = {}; }
            if (appId === null || appId === undefined) {
                throw new RequiredError('appId', 'Required parameter appId was null or undefined when calling publishPendingMenuChanges.');
            }
            if (PublishMenuChanges === null || PublishMenuChanges === undefined) {
                throw new RequiredError('PublishMenuChanges', 'Required parameter PublishMenuChanges was null or undefined when calling publishPendingMenuChanges.');
            }
            var localVarPath = "/api/v1.0/{appId}/menus/catalog-changes/publish"
                .replace("{".concat("appId", "}"), encodeURIComponent(String(appId)));
            var localVarUrlObj = url.parse(localVarPath, true);
            var localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            var localVarHeaderParameter = {};
            var localVarQueryParameter = {};
            if (configuration && configuration.accessToken) {
                var localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("oauth2", ["api"])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }
            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            var needsSerialization = ("PublishMenuChanges" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body = needsSerialization ? JSON.stringify(PublishMenuChanges || {}) : (PublishMenuChanges || "");
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    };
};
exports.CatalogChangesApiFetchParamCreator = CatalogChangesApiFetchParamCreator;
var CatalogChangesApiFp = function (configuration) {
    return {
        getPendingMenuChanges: function (appId, menuId, catalogItemId, page, limit, options) {
            var localVarFetchArgs = (0, exports.CatalogChangesApiFetchParamCreator)(configuration).getPendingMenuChanges(appId, menuId, catalogItemId, page, limit, options);
            return function (fetch, basePath) {
                if (fetch === void 0) { fetch = portableFetch; }
                if (basePath === void 0) { basePath = BASE_PATH; }
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then(function (response) {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
        getPendingMenuChangesSummaries: function (appId, options) {
            var localVarFetchArgs = (0, exports.CatalogChangesApiFetchParamCreator)(configuration).getPendingMenuChangesSummaries(appId, options);
            return function (fetch, basePath) {
                if (fetch === void 0) { fetch = portableFetch; }
                if (basePath === void 0) { basePath = BASE_PATH; }
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then(function (response) {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
        publishPendingMenuChanges: function (appId, PublishMenuChanges, options) {
            var localVarFetchArgs = (0, exports.CatalogChangesApiFetchParamCreator)(configuration).publishPendingMenuChanges(appId, PublishMenuChanges, options);
            return function (fetch, basePath) {
                if (fetch === void 0) { fetch = portableFetch; }
                if (basePath === void 0) { basePath = BASE_PATH; }
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then(function (response) {
                    if (response.status >= 200 && response.status < 300) {
                        return response;
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
    };
};
exports.CatalogChangesApiFp = CatalogChangesApiFp;
var CatalogChangesApiFactory = function (configuration, fetch, basePath) {
    return {
        getPendingMenuChanges: function (appId, menuId, catalogItemId, page, limit, options) {
            return (0, exports.CatalogChangesApiFp)(configuration).getPendingMenuChanges(appId, menuId, catalogItemId, page, limit, options)(fetch, basePath);
        },
        getPendingMenuChangesSummaries: function (appId, options) {
            return (0, exports.CatalogChangesApiFp)(configuration).getPendingMenuChangesSummaries(appId, options)(fetch, basePath);
        },
        publishPendingMenuChanges: function (appId, PublishMenuChanges, options) {
            return (0, exports.CatalogChangesApiFp)(configuration).publishPendingMenuChanges(appId, PublishMenuChanges, options)(fetch, basePath);
        },
    };
};
exports.CatalogChangesApiFactory = CatalogChangesApiFactory;
var CatalogChangesApi = (function (_super) {
    __extends(CatalogChangesApi, _super);
    function CatalogChangesApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    CatalogChangesApi.prototype.getPendingMenuChanges = function (appId, menuId, catalogItemId, page, limit, options) {
        return (0, exports.CatalogChangesApiFp)(this.configuration).getPendingMenuChanges(appId, menuId, catalogItemId, page, limit, options)(this.fetch, this.basePath);
    };
    CatalogChangesApi.prototype.getPendingMenuChangesSummaries = function (appId, options) {
        return (0, exports.CatalogChangesApiFp)(this.configuration).getPendingMenuChangesSummaries(appId, options)(this.fetch, this.basePath);
    };
    CatalogChangesApi.prototype.publishPendingMenuChanges = function (appId, PublishMenuChanges, options) {
        return (0, exports.CatalogChangesApiFp)(this.configuration).publishPendingMenuChanges(appId, PublishMenuChanges, options)(this.fetch, this.basePath);
    };
    return CatalogChangesApi;
}(BaseAPI));
exports.CatalogChangesApi = CatalogChangesApi;
var CatalogGroupsApiFetchParamCreator = function (configuration) {
    return {
        archiveGroup: function (appId, catalogItemId, options) {
            if (options === void 0) { options = {}; }
            if (appId === null || appId === undefined) {
                throw new RequiredError('appId', 'Required parameter appId was null or undefined when calling archiveGroup.');
            }
            if (catalogItemId === null || catalogItemId === undefined) {
                throw new RequiredError('catalogItemId', 'Required parameter catalogItemId was null or undefined when calling archiveGroup.');
            }
            var localVarPath = "/api/v1.0/{appId}/catalog/groups/{catalogItemId}/archive"
                .replace("{".concat("appId", "}"), encodeURIComponent(String(appId)))
                .replace("{".concat("catalogItemId", "}"), encodeURIComponent(String(catalogItemId)));
            var localVarUrlObj = url.parse(localVarPath, true);
            var localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            var localVarHeaderParameter = {};
            var localVarQueryParameter = {};
            if (configuration && configuration.accessToken) {
                var localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("oauth2", ["api"])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        createGroup: function (appId, CreateGroup, options) {
            if (options === void 0) { options = {}; }
            if (appId === null || appId === undefined) {
                throw new RequiredError('appId', 'Required parameter appId was null or undefined when calling createGroup.');
            }
            if (CreateGroup === null || CreateGroup === undefined) {
                throw new RequiredError('CreateGroup', 'Required parameter CreateGroup was null or undefined when calling createGroup.');
            }
            var localVarPath = "/api/v1.0/{appId}/catalog/groups"
                .replace("{".concat("appId", "}"), encodeURIComponent(String(appId)));
            var localVarUrlObj = url.parse(localVarPath, true);
            var localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            var localVarHeaderParameter = {};
            var localVarQueryParameter = {};
            if (configuration && configuration.accessToken) {
                var localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("oauth2", ["api"])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }
            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            var needsSerialization = ("CreateGroup" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body = needsSerialization ? JSON.stringify(CreateGroup || {}) : (CreateGroup || "");
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        duplicateGroup: function (appId, catalogItemId, options) {
            if (options === void 0) { options = {}; }
            if (appId === null || appId === undefined) {
                throw new RequiredError('appId', 'Required parameter appId was null or undefined when calling duplicateGroup.');
            }
            if (catalogItemId === null || catalogItemId === undefined) {
                throw new RequiredError('catalogItemId', 'Required parameter catalogItemId was null or undefined when calling duplicateGroup.');
            }
            var localVarPath = "/api/v1.0/{appId}/catalog/groups/{catalogItemId}/duplicate"
                .replace("{".concat("appId", "}"), encodeURIComponent(String(appId)))
                .replace("{".concat("catalogItemId", "}"), encodeURIComponent(String(catalogItemId)));
            var localVarUrlObj = url.parse(localVarPath, true);
            var localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            var localVarHeaderParameter = {};
            var localVarQueryParameter = {};
            if (configuration && configuration.accessToken) {
                var localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("oauth2", ["api"])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        getGroupById: function (appId, catalogItemId, options) {
            if (options === void 0) { options = {}; }
            if (appId === null || appId === undefined) {
                throw new RequiredError('appId', 'Required parameter appId was null or undefined when calling getGroupById.');
            }
            if (catalogItemId === null || catalogItemId === undefined) {
                throw new RequiredError('catalogItemId', 'Required parameter catalogItemId was null or undefined when calling getGroupById.');
            }
            var localVarPath = "/api/v1.0/{appId}/catalog/groups/{catalogItemId}"
                .replace("{".concat("appId", "}"), encodeURIComponent(String(appId)))
                .replace("{".concat("catalogItemId", "}"), encodeURIComponent(String(catalogItemId)));
            var localVarUrlObj = url.parse(localVarPath, true);
            var localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            var localVarHeaderParameter = {};
            var localVarQueryParameter = {};
            if (configuration && configuration.accessToken) {
                var localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("oauth2", ["api"])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        getGroups: function (appId, groupTypes, searchTerm, page, limit, options) {
            if (options === void 0) { options = {}; }
            if (appId === null || appId === undefined) {
                throw new RequiredError('appId', 'Required parameter appId was null or undefined when calling getGroups.');
            }
            if (groupTypes === null || groupTypes === undefined) {
                throw new RequiredError('groupTypes', 'Required parameter groupTypes was null or undefined when calling getGroups.');
            }
            var localVarPath = "/api/v1.0/{appId}/catalog/groups"
                .replace("{".concat("appId", "}"), encodeURIComponent(String(appId)));
            var localVarUrlObj = url.parse(localVarPath, true);
            var localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            var localVarHeaderParameter = {};
            var localVarQueryParameter = {};
            if (configuration && configuration.accessToken) {
                var localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("oauth2", ["api"])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }
            if (groupTypes) {
                localVarQueryParameter['groupTypes'] = groupTypes;
            }
            if (searchTerm !== undefined) {
                localVarQueryParameter['searchTerm'] = searchTerm;
            }
            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }
            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        updateGroup: function (appId, catalogItemId, UpdateGroup, options) {
            if (options === void 0) { options = {}; }
            if (appId === null || appId === undefined) {
                throw new RequiredError('appId', 'Required parameter appId was null or undefined when calling updateGroup.');
            }
            if (catalogItemId === null || catalogItemId === undefined) {
                throw new RequiredError('catalogItemId', 'Required parameter catalogItemId was null or undefined when calling updateGroup.');
            }
            if (UpdateGroup === null || UpdateGroup === undefined) {
                throw new RequiredError('UpdateGroup', 'Required parameter UpdateGroup was null or undefined when calling updateGroup.');
            }
            var localVarPath = "/api/v1.0/{appId}/catalog/groups/{catalogItemId}"
                .replace("{".concat("appId", "}"), encodeURIComponent(String(appId)))
                .replace("{".concat("catalogItemId", "}"), encodeURIComponent(String(catalogItemId)));
            var localVarUrlObj = url.parse(localVarPath, true);
            var localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            var localVarHeaderParameter = {};
            var localVarQueryParameter = {};
            if (configuration && configuration.accessToken) {
                var localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("oauth2", ["api"])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }
            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            var needsSerialization = ("UpdateGroup" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body = needsSerialization ? JSON.stringify(UpdateGroup || {}) : (UpdateGroup || "");
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    };
};
exports.CatalogGroupsApiFetchParamCreator = CatalogGroupsApiFetchParamCreator;
var CatalogGroupsApiFp = function (configuration) {
    return {
        archiveGroup: function (appId, catalogItemId, options) {
            var localVarFetchArgs = (0, exports.CatalogGroupsApiFetchParamCreator)(configuration).archiveGroup(appId, catalogItemId, options);
            return function (fetch, basePath) {
                if (fetch === void 0) { fetch = portableFetch; }
                if (basePath === void 0) { basePath = BASE_PATH; }
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then(function (response) {
                    if (response.status >= 200 && response.status < 300) {
                        return response;
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
        createGroup: function (appId, CreateGroup, options) {
            var localVarFetchArgs = (0, exports.CatalogGroupsApiFetchParamCreator)(configuration).createGroup(appId, CreateGroup, options);
            return function (fetch, basePath) {
                if (fetch === void 0) { fetch = portableFetch; }
                if (basePath === void 0) { basePath = BASE_PATH; }
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then(function (response) {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
        duplicateGroup: function (appId, catalogItemId, options) {
            var localVarFetchArgs = (0, exports.CatalogGroupsApiFetchParamCreator)(configuration).duplicateGroup(appId, catalogItemId, options);
            return function (fetch, basePath) {
                if (fetch === void 0) { fetch = portableFetch; }
                if (basePath === void 0) { basePath = BASE_PATH; }
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then(function (response) {
                    if (response.status >= 200 && response.status < 300) {
                        return response;
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
        getGroupById: function (appId, catalogItemId, options) {
            var localVarFetchArgs = (0, exports.CatalogGroupsApiFetchParamCreator)(configuration).getGroupById(appId, catalogItemId, options);
            return function (fetch, basePath) {
                if (fetch === void 0) { fetch = portableFetch; }
                if (basePath === void 0) { basePath = BASE_PATH; }
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then(function (response) {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
        getGroups: function (appId, groupTypes, searchTerm, page, limit, options) {
            var localVarFetchArgs = (0, exports.CatalogGroupsApiFetchParamCreator)(configuration).getGroups(appId, groupTypes, searchTerm, page, limit, options);
            return function (fetch, basePath) {
                if (fetch === void 0) { fetch = portableFetch; }
                if (basePath === void 0) { basePath = BASE_PATH; }
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then(function (response) {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
        updateGroup: function (appId, catalogItemId, UpdateGroup, options) {
            var localVarFetchArgs = (0, exports.CatalogGroupsApiFetchParamCreator)(configuration).updateGroup(appId, catalogItemId, UpdateGroup, options);
            return function (fetch, basePath) {
                if (fetch === void 0) { fetch = portableFetch; }
                if (basePath === void 0) { basePath = BASE_PATH; }
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then(function (response) {
                    if (response.status >= 200 && response.status < 300) {
                        return response;
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
    };
};
exports.CatalogGroupsApiFp = CatalogGroupsApiFp;
var CatalogGroupsApiFactory = function (configuration, fetch, basePath) {
    return {
        archiveGroup: function (appId, catalogItemId, options) {
            return (0, exports.CatalogGroupsApiFp)(configuration).archiveGroup(appId, catalogItemId, options)(fetch, basePath);
        },
        createGroup: function (appId, CreateGroup, options) {
            return (0, exports.CatalogGroupsApiFp)(configuration).createGroup(appId, CreateGroup, options)(fetch, basePath);
        },
        duplicateGroup: function (appId, catalogItemId, options) {
            return (0, exports.CatalogGroupsApiFp)(configuration).duplicateGroup(appId, catalogItemId, options)(fetch, basePath);
        },
        getGroupById: function (appId, catalogItemId, options) {
            return (0, exports.CatalogGroupsApiFp)(configuration).getGroupById(appId, catalogItemId, options)(fetch, basePath);
        },
        getGroups: function (appId, groupTypes, searchTerm, page, limit, options) {
            return (0, exports.CatalogGroupsApiFp)(configuration).getGroups(appId, groupTypes, searchTerm, page, limit, options)(fetch, basePath);
        },
        updateGroup: function (appId, catalogItemId, UpdateGroup, options) {
            return (0, exports.CatalogGroupsApiFp)(configuration).updateGroup(appId, catalogItemId, UpdateGroup, options)(fetch, basePath);
        },
    };
};
exports.CatalogGroupsApiFactory = CatalogGroupsApiFactory;
var CatalogGroupsApi = (function (_super) {
    __extends(CatalogGroupsApi, _super);
    function CatalogGroupsApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    CatalogGroupsApi.prototype.archiveGroup = function (appId, catalogItemId, options) {
        return (0, exports.CatalogGroupsApiFp)(this.configuration).archiveGroup(appId, catalogItemId, options)(this.fetch, this.basePath);
    };
    CatalogGroupsApi.prototype.createGroup = function (appId, CreateGroup, options) {
        return (0, exports.CatalogGroupsApiFp)(this.configuration).createGroup(appId, CreateGroup, options)(this.fetch, this.basePath);
    };
    CatalogGroupsApi.prototype.duplicateGroup = function (appId, catalogItemId, options) {
        return (0, exports.CatalogGroupsApiFp)(this.configuration).duplicateGroup(appId, catalogItemId, options)(this.fetch, this.basePath);
    };
    CatalogGroupsApi.prototype.getGroupById = function (appId, catalogItemId, options) {
        return (0, exports.CatalogGroupsApiFp)(this.configuration).getGroupById(appId, catalogItemId, options)(this.fetch, this.basePath);
    };
    CatalogGroupsApi.prototype.getGroups = function (appId, groupTypes, searchTerm, page, limit, options) {
        return (0, exports.CatalogGroupsApiFp)(this.configuration).getGroups(appId, groupTypes, searchTerm, page, limit, options)(this.fetch, this.basePath);
    };
    CatalogGroupsApi.prototype.updateGroup = function (appId, catalogItemId, UpdateGroup, options) {
        return (0, exports.CatalogGroupsApiFp)(this.configuration).updateGroup(appId, catalogItemId, UpdateGroup, options)(this.fetch, this.basePath);
    };
    return CatalogGroupsApi;
}(BaseAPI));
exports.CatalogGroupsApi = CatalogGroupsApi;
var CatalogImagesApiFetchParamCreator = function (configuration) {
    return {
        uploadCatalogImage: function (appId, Image, options) {
            if (options === void 0) { options = {}; }
            if (appId === null || appId === undefined) {
                throw new RequiredError('appId', 'Required parameter appId was null or undefined when calling uploadCatalogImage.');
            }
            if (Image === null || Image === undefined) {
                throw new RequiredError('Image', 'Required parameter Image was null or undefined when calling uploadCatalogImage.');
            }
            var localVarPath = "/api/v1.0/{appId}/catalog/images"
                .replace("{".concat("appId", "}"), encodeURIComponent(String(appId)));
            var localVarUrlObj = url.parse(localVarPath, true);
            var localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            var localVarHeaderParameter = {};
            var localVarQueryParameter = {};
            var localVarFormParams = new url.URLSearchParams();
            if (configuration && configuration.accessToken) {
                var localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("oauth2", ["api"])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }
            if (Image !== undefined) {
                localVarFormParams.set('Image', Image);
            }
            localVarHeaderParameter['Content-Type'] = 'application/x-www-form-urlencoded';
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            localVarRequestOptions.body = localVarFormParams.toString();
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    };
};
exports.CatalogImagesApiFetchParamCreator = CatalogImagesApiFetchParamCreator;
var CatalogImagesApiFp = function (configuration) {
    return {
        uploadCatalogImage: function (appId, Image, options) {
            var localVarFetchArgs = (0, exports.CatalogImagesApiFetchParamCreator)(configuration).uploadCatalogImage(appId, Image, options);
            return function (fetch, basePath) {
                if (fetch === void 0) { fetch = portableFetch; }
                if (basePath === void 0) { basePath = BASE_PATH; }
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then(function (response) {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
    };
};
exports.CatalogImagesApiFp = CatalogImagesApiFp;
var CatalogImagesApiFactory = function (configuration, fetch, basePath) {
    return {
        uploadCatalogImage: function (appId, Image, options) {
            return (0, exports.CatalogImagesApiFp)(configuration).uploadCatalogImage(appId, Image, options)(fetch, basePath);
        },
    };
};
exports.CatalogImagesApiFactory = CatalogImagesApiFactory;
var CatalogImagesApi = (function (_super) {
    __extends(CatalogImagesApi, _super);
    function CatalogImagesApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    CatalogImagesApi.prototype.uploadCatalogImage = function (appId, Image, options) {
        return (0, exports.CatalogImagesApiFp)(this.configuration).uploadCatalogImage(appId, Image, options)(this.fetch, this.basePath);
    };
    return CatalogImagesApi;
}(BaseAPI));
exports.CatalogImagesApi = CatalogImagesApi;
var CatalogItemsApiFetchParamCreator = function (configuration) {
    return {
        archiveCatalogItem: function (appId, catalogItemId, options) {
            if (options === void 0) { options = {}; }
            if (appId === null || appId === undefined) {
                throw new RequiredError('appId', 'Required parameter appId was null or undefined when calling archiveCatalogItem.');
            }
            if (catalogItemId === null || catalogItemId === undefined) {
                throw new RequiredError('catalogItemId', 'Required parameter catalogItemId was null or undefined when calling archiveCatalogItem.');
            }
            var localVarPath = "/api/v1.0/{appId}/catalog/items/{catalogItemId}/archive"
                .replace("{".concat("appId", "}"), encodeURIComponent(String(appId)))
                .replace("{".concat("catalogItemId", "}"), encodeURIComponent(String(catalogItemId)));
            var localVarUrlObj = url.parse(localVarPath, true);
            var localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            var localVarHeaderParameter = {};
            var localVarQueryParameter = {};
            if (configuration && configuration.accessToken) {
                var localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("oauth2", ["api"])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        createCatalogItem: function (appId, CreateCatalogItem, options) {
            if (options === void 0) { options = {}; }
            if (appId === null || appId === undefined) {
                throw new RequiredError('appId', 'Required parameter appId was null or undefined when calling createCatalogItem.');
            }
            if (CreateCatalogItem === null || CreateCatalogItem === undefined) {
                throw new RequiredError('CreateCatalogItem', 'Required parameter CreateCatalogItem was null or undefined when calling createCatalogItem.');
            }
            var localVarPath = "/api/v1.0/{appId}/catalog/items"
                .replace("{".concat("appId", "}"), encodeURIComponent(String(appId)));
            var localVarUrlObj = url.parse(localVarPath, true);
            var localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            var localVarHeaderParameter = {};
            var localVarQueryParameter = {};
            if (configuration && configuration.accessToken) {
                var localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("oauth2", ["api"])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }
            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            var needsSerialization = ("CreateCatalogItem" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body = needsSerialization ? JSON.stringify(CreateCatalogItem || {}) : (CreateCatalogItem || "");
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        duplicateCatalogItem: function (appId, catalogItemId, options) {
            if (options === void 0) { options = {}; }
            if (appId === null || appId === undefined) {
                throw new RequiredError('appId', 'Required parameter appId was null or undefined when calling duplicateCatalogItem.');
            }
            if (catalogItemId === null || catalogItemId === undefined) {
                throw new RequiredError('catalogItemId', 'Required parameter catalogItemId was null or undefined when calling duplicateCatalogItem.');
            }
            var localVarPath = "/api/v1.0/{appId}/catalog/items/{catalogItemId}/duplicate"
                .replace("{".concat("appId", "}"), encodeURIComponent(String(appId)))
                .replace("{".concat("catalogItemId", "}"), encodeURIComponent(String(catalogItemId)));
            var localVarUrlObj = url.parse(localVarPath, true);
            var localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            var localVarHeaderParameter = {};
            var localVarQueryParameter = {};
            if (configuration && configuration.accessToken) {
                var localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("oauth2", ["api"])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        getCatalogItemById: function (appId, catalogItemId, options) {
            if (options === void 0) { options = {}; }
            if (appId === null || appId === undefined) {
                throw new RequiredError('appId', 'Required parameter appId was null or undefined when calling getCatalogItemById.');
            }
            if (catalogItemId === null || catalogItemId === undefined) {
                throw new RequiredError('catalogItemId', 'Required parameter catalogItemId was null or undefined when calling getCatalogItemById.');
            }
            var localVarPath = "/api/v1.0/{appId}/catalog/items/{catalogItemId}"
                .replace("{".concat("appId", "}"), encodeURIComponent(String(appId)))
                .replace("{".concat("catalogItemId", "}"), encodeURIComponent(String(catalogItemId)));
            var localVarUrlObj = url.parse(localVarPath, true);
            var localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            var localVarHeaderParameter = {};
            var localVarQueryParameter = {};
            if (configuration && configuration.accessToken) {
                var localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("oauth2", ["api"])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        getItems: function (appId, itemTypes, searchTerm, page, limit, options) {
            if (options === void 0) { options = {}; }
            if (appId === null || appId === undefined) {
                throw new RequiredError('appId', 'Required parameter appId was null or undefined when calling getItems.');
            }
            if (itemTypes === null || itemTypes === undefined) {
                throw new RequiredError('itemTypes', 'Required parameter itemTypes was null or undefined when calling getItems.');
            }
            var localVarPath = "/api/v1.0/{appId}/catalog/items"
                .replace("{".concat("appId", "}"), encodeURIComponent(String(appId)));
            var localVarUrlObj = url.parse(localVarPath, true);
            var localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            var localVarHeaderParameter = {};
            var localVarQueryParameter = {};
            if (configuration && configuration.accessToken) {
                var localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("oauth2", ["api"])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }
            if (itemTypes) {
                localVarQueryParameter['itemTypes'] = itemTypes;
            }
            if (searchTerm !== undefined) {
                localVarQueryParameter['searchTerm'] = searchTerm;
            }
            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }
            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        updateCatalogItem: function (appId, catalogItemId, UpdateCatalogItem, options) {
            if (options === void 0) { options = {}; }
            if (appId === null || appId === undefined) {
                throw new RequiredError('appId', 'Required parameter appId was null or undefined when calling updateCatalogItem.');
            }
            if (catalogItemId === null || catalogItemId === undefined) {
                throw new RequiredError('catalogItemId', 'Required parameter catalogItemId was null or undefined when calling updateCatalogItem.');
            }
            if (UpdateCatalogItem === null || UpdateCatalogItem === undefined) {
                throw new RequiredError('UpdateCatalogItem', 'Required parameter UpdateCatalogItem was null or undefined when calling updateCatalogItem.');
            }
            var localVarPath = "/api/v1.0/{appId}/catalog/items/{catalogItemId}"
                .replace("{".concat("appId", "}"), encodeURIComponent(String(appId)))
                .replace("{".concat("catalogItemId", "}"), encodeURIComponent(String(catalogItemId)));
            var localVarUrlObj = url.parse(localVarPath, true);
            var localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            var localVarHeaderParameter = {};
            var localVarQueryParameter = {};
            if (configuration && configuration.accessToken) {
                var localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("oauth2", ["api"])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }
            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            var needsSerialization = ("UpdateCatalogItem" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body = needsSerialization ? JSON.stringify(UpdateCatalogItem || {}) : (UpdateCatalogItem || "");
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    };
};
exports.CatalogItemsApiFetchParamCreator = CatalogItemsApiFetchParamCreator;
var CatalogItemsApiFp = function (configuration) {
    return {
        archiveCatalogItem: function (appId, catalogItemId, options) {
            var localVarFetchArgs = (0, exports.CatalogItemsApiFetchParamCreator)(configuration).archiveCatalogItem(appId, catalogItemId, options);
            return function (fetch, basePath) {
                if (fetch === void 0) { fetch = portableFetch; }
                if (basePath === void 0) { basePath = BASE_PATH; }
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then(function (response) {
                    if (response.status >= 200 && response.status < 300) {
                        return response;
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
        createCatalogItem: function (appId, CreateCatalogItem, options) {
            var localVarFetchArgs = (0, exports.CatalogItemsApiFetchParamCreator)(configuration).createCatalogItem(appId, CreateCatalogItem, options);
            return function (fetch, basePath) {
                if (fetch === void 0) { fetch = portableFetch; }
                if (basePath === void 0) { basePath = BASE_PATH; }
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then(function (response) {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
        duplicateCatalogItem: function (appId, catalogItemId, options) {
            var localVarFetchArgs = (0, exports.CatalogItemsApiFetchParamCreator)(configuration).duplicateCatalogItem(appId, catalogItemId, options);
            return function (fetch, basePath) {
                if (fetch === void 0) { fetch = portableFetch; }
                if (basePath === void 0) { basePath = BASE_PATH; }
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then(function (response) {
                    if (response.status >= 200 && response.status < 300) {
                        return response;
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
        getCatalogItemById: function (appId, catalogItemId, options) {
            var localVarFetchArgs = (0, exports.CatalogItemsApiFetchParamCreator)(configuration).getCatalogItemById(appId, catalogItemId, options);
            return function (fetch, basePath) {
                if (fetch === void 0) { fetch = portableFetch; }
                if (basePath === void 0) { basePath = BASE_PATH; }
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then(function (response) {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
        getItems: function (appId, itemTypes, searchTerm, page, limit, options) {
            var localVarFetchArgs = (0, exports.CatalogItemsApiFetchParamCreator)(configuration).getItems(appId, itemTypes, searchTerm, page, limit, options);
            return function (fetch, basePath) {
                if (fetch === void 0) { fetch = portableFetch; }
                if (basePath === void 0) { basePath = BASE_PATH; }
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then(function (response) {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
        updateCatalogItem: function (appId, catalogItemId, UpdateCatalogItem, options) {
            var localVarFetchArgs = (0, exports.CatalogItemsApiFetchParamCreator)(configuration).updateCatalogItem(appId, catalogItemId, UpdateCatalogItem, options);
            return function (fetch, basePath) {
                if (fetch === void 0) { fetch = portableFetch; }
                if (basePath === void 0) { basePath = BASE_PATH; }
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then(function (response) {
                    if (response.status >= 200 && response.status < 300) {
                        return response;
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
    };
};
exports.CatalogItemsApiFp = CatalogItemsApiFp;
var CatalogItemsApiFactory = function (configuration, fetch, basePath) {
    return {
        archiveCatalogItem: function (appId, catalogItemId, options) {
            return (0, exports.CatalogItemsApiFp)(configuration).archiveCatalogItem(appId, catalogItemId, options)(fetch, basePath);
        },
        createCatalogItem: function (appId, CreateCatalogItem, options) {
            return (0, exports.CatalogItemsApiFp)(configuration).createCatalogItem(appId, CreateCatalogItem, options)(fetch, basePath);
        },
        duplicateCatalogItem: function (appId, catalogItemId, options) {
            return (0, exports.CatalogItemsApiFp)(configuration).duplicateCatalogItem(appId, catalogItemId, options)(fetch, basePath);
        },
        getCatalogItemById: function (appId, catalogItemId, options) {
            return (0, exports.CatalogItemsApiFp)(configuration).getCatalogItemById(appId, catalogItemId, options)(fetch, basePath);
        },
        getItems: function (appId, itemTypes, searchTerm, page, limit, options) {
            return (0, exports.CatalogItemsApiFp)(configuration).getItems(appId, itemTypes, searchTerm, page, limit, options)(fetch, basePath);
        },
        updateCatalogItem: function (appId, catalogItemId, UpdateCatalogItem, options) {
            return (0, exports.CatalogItemsApiFp)(configuration).updateCatalogItem(appId, catalogItemId, UpdateCatalogItem, options)(fetch, basePath);
        },
    };
};
exports.CatalogItemsApiFactory = CatalogItemsApiFactory;
var CatalogItemsApi = (function (_super) {
    __extends(CatalogItemsApi, _super);
    function CatalogItemsApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    CatalogItemsApi.prototype.archiveCatalogItem = function (appId, catalogItemId, options) {
        return (0, exports.CatalogItemsApiFp)(this.configuration).archiveCatalogItem(appId, catalogItemId, options)(this.fetch, this.basePath);
    };
    CatalogItemsApi.prototype.createCatalogItem = function (appId, CreateCatalogItem, options) {
        return (0, exports.CatalogItemsApiFp)(this.configuration).createCatalogItem(appId, CreateCatalogItem, options)(this.fetch, this.basePath);
    };
    CatalogItemsApi.prototype.duplicateCatalogItem = function (appId, catalogItemId, options) {
        return (0, exports.CatalogItemsApiFp)(this.configuration).duplicateCatalogItem(appId, catalogItemId, options)(this.fetch, this.basePath);
    };
    CatalogItemsApi.prototype.getCatalogItemById = function (appId, catalogItemId, options) {
        return (0, exports.CatalogItemsApiFp)(this.configuration).getCatalogItemById(appId, catalogItemId, options)(this.fetch, this.basePath);
    };
    CatalogItemsApi.prototype.getItems = function (appId, itemTypes, searchTerm, page, limit, options) {
        return (0, exports.CatalogItemsApiFp)(this.configuration).getItems(appId, itemTypes, searchTerm, page, limit, options)(this.fetch, this.basePath);
    };
    CatalogItemsApi.prototype.updateCatalogItem = function (appId, catalogItemId, UpdateCatalogItem, options) {
        return (0, exports.CatalogItemsApiFp)(this.configuration).updateCatalogItem(appId, catalogItemId, UpdateCatalogItem, options)(this.fetch, this.basePath);
    };
    return CatalogItemsApi;
}(BaseAPI));
exports.CatalogItemsApi = CatalogItemsApi;
var CatalogProductsApiFetchParamCreator = function (configuration) {
    return {
        archiveProduct: function (appId, catalogItemId, options) {
            if (options === void 0) { options = {}; }
            if (appId === null || appId === undefined) {
                throw new RequiredError('appId', 'Required parameter appId was null or undefined when calling archiveProduct.');
            }
            if (catalogItemId === null || catalogItemId === undefined) {
                throw new RequiredError('catalogItemId', 'Required parameter catalogItemId was null or undefined when calling archiveProduct.');
            }
            var localVarPath = "/api/v1.0/{appId}/catalog/products/{catalogItemId}/archive"
                .replace("{".concat("appId", "}"), encodeURIComponent(String(appId)))
                .replace("{".concat("catalogItemId", "}"), encodeURIComponent(String(catalogItemId)));
            var localVarUrlObj = url.parse(localVarPath, true);
            var localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            var localVarHeaderParameter = {};
            var localVarQueryParameter = {};
            if (configuration && configuration.accessToken) {
                var localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("oauth2", ["api"])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        createProduct: function (appId, CreateProduct, options) {
            if (options === void 0) { options = {}; }
            if (appId === null || appId === undefined) {
                throw new RequiredError('appId', 'Required parameter appId was null or undefined when calling createProduct.');
            }
            if (CreateProduct === null || CreateProduct === undefined) {
                throw new RequiredError('CreateProduct', 'Required parameter CreateProduct was null or undefined when calling createProduct.');
            }
            var localVarPath = "/api/v1.0/{appId}/catalog/products"
                .replace("{".concat("appId", "}"), encodeURIComponent(String(appId)));
            var localVarUrlObj = url.parse(localVarPath, true);
            var localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            var localVarHeaderParameter = {};
            var localVarQueryParameter = {};
            if (configuration && configuration.accessToken) {
                var localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("oauth2", ["api"])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }
            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            var needsSerialization = ("CreateProduct" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body = needsSerialization ? JSON.stringify(CreateProduct || {}) : (CreateProduct || "");
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        duplicateProduct: function (appId, catalogItemId, options) {
            if (options === void 0) { options = {}; }
            if (appId === null || appId === undefined) {
                throw new RequiredError('appId', 'Required parameter appId was null or undefined when calling duplicateProduct.');
            }
            if (catalogItemId === null || catalogItemId === undefined) {
                throw new RequiredError('catalogItemId', 'Required parameter catalogItemId was null or undefined when calling duplicateProduct.');
            }
            var localVarPath = "/api/v1.0/{appId}/catalog/products/{catalogItemId}/duplicate"
                .replace("{".concat("appId", "}"), encodeURIComponent(String(appId)))
                .replace("{".concat("catalogItemId", "}"), encodeURIComponent(String(catalogItemId)));
            var localVarUrlObj = url.parse(localVarPath, true);
            var localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            var localVarHeaderParameter = {};
            var localVarQueryParameter = {};
            if (configuration && configuration.accessToken) {
                var localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("oauth2", ["api"])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        getProductById: function (appId, catalogItemId, options) {
            if (options === void 0) { options = {}; }
            if (appId === null || appId === undefined) {
                throw new RequiredError('appId', 'Required parameter appId was null or undefined when calling getProductById.');
            }
            if (catalogItemId === null || catalogItemId === undefined) {
                throw new RequiredError('catalogItemId', 'Required parameter catalogItemId was null or undefined when calling getProductById.');
            }
            var localVarPath = "/api/v1.0/{appId}/catalog/products/{catalogItemId}"
                .replace("{".concat("appId", "}"), encodeURIComponent(String(appId)))
                .replace("{".concat("catalogItemId", "}"), encodeURIComponent(String(catalogItemId)));
            var localVarUrlObj = url.parse(localVarPath, true);
            var localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            var localVarHeaderParameter = {};
            var localVarQueryParameter = {};
            if (configuration && configuration.accessToken) {
                var localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("oauth2", ["api"])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        getProducts: function (appId, productTypes, searchTerm, page, limit, options) {
            if (options === void 0) { options = {}; }
            if (appId === null || appId === undefined) {
                throw new RequiredError('appId', 'Required parameter appId was null or undefined when calling getProducts.');
            }
            if (productTypes === null || productTypes === undefined) {
                throw new RequiredError('productTypes', 'Required parameter productTypes was null or undefined when calling getProducts.');
            }
            var localVarPath = "/api/v1.0/{appId}/catalog/products"
                .replace("{".concat("appId", "}"), encodeURIComponent(String(appId)));
            var localVarUrlObj = url.parse(localVarPath, true);
            var localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            var localVarHeaderParameter = {};
            var localVarQueryParameter = {};
            if (configuration && configuration.accessToken) {
                var localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("oauth2", ["api"])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }
            if (productTypes) {
                localVarQueryParameter['productTypes'] = productTypes;
            }
            if (searchTerm !== undefined) {
                localVarQueryParameter['searchTerm'] = searchTerm;
            }
            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }
            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        updateProduct: function (appId, catalogItemId, UpdateProduct, options) {
            if (options === void 0) { options = {}; }
            if (appId === null || appId === undefined) {
                throw new RequiredError('appId', 'Required parameter appId was null or undefined when calling updateProduct.');
            }
            if (catalogItemId === null || catalogItemId === undefined) {
                throw new RequiredError('catalogItemId', 'Required parameter catalogItemId was null or undefined when calling updateProduct.');
            }
            if (UpdateProduct === null || UpdateProduct === undefined) {
                throw new RequiredError('UpdateProduct', 'Required parameter UpdateProduct was null or undefined when calling updateProduct.');
            }
            var localVarPath = "/api/v1.0/{appId}/catalog/products/{catalogItemId}"
                .replace("{".concat("appId", "}"), encodeURIComponent(String(appId)))
                .replace("{".concat("catalogItemId", "}"), encodeURIComponent(String(catalogItemId)));
            var localVarUrlObj = url.parse(localVarPath, true);
            var localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            var localVarHeaderParameter = {};
            var localVarQueryParameter = {};
            if (configuration && configuration.accessToken) {
                var localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("oauth2", ["api"])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }
            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            var needsSerialization = ("UpdateProduct" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body = needsSerialization ? JSON.stringify(UpdateProduct || {}) : (UpdateProduct || "");
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    };
};
exports.CatalogProductsApiFetchParamCreator = CatalogProductsApiFetchParamCreator;
var CatalogProductsApiFp = function (configuration) {
    return {
        archiveProduct: function (appId, catalogItemId, options) {
            var localVarFetchArgs = (0, exports.CatalogProductsApiFetchParamCreator)(configuration).archiveProduct(appId, catalogItemId, options);
            return function (fetch, basePath) {
                if (fetch === void 0) { fetch = portableFetch; }
                if (basePath === void 0) { basePath = BASE_PATH; }
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then(function (response) {
                    if (response.status >= 200 && response.status < 300) {
                        return response;
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
        createProduct: function (appId, CreateProduct, options) {
            var localVarFetchArgs = (0, exports.CatalogProductsApiFetchParamCreator)(configuration).createProduct(appId, CreateProduct, options);
            return function (fetch, basePath) {
                if (fetch === void 0) { fetch = portableFetch; }
                if (basePath === void 0) { basePath = BASE_PATH; }
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then(function (response) {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
        duplicateProduct: function (appId, catalogItemId, options) {
            var localVarFetchArgs = (0, exports.CatalogProductsApiFetchParamCreator)(configuration).duplicateProduct(appId, catalogItemId, options);
            return function (fetch, basePath) {
                if (fetch === void 0) { fetch = portableFetch; }
                if (basePath === void 0) { basePath = BASE_PATH; }
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then(function (response) {
                    if (response.status >= 200 && response.status < 300) {
                        return response;
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
        getProductById: function (appId, catalogItemId, options) {
            var localVarFetchArgs = (0, exports.CatalogProductsApiFetchParamCreator)(configuration).getProductById(appId, catalogItemId, options);
            return function (fetch, basePath) {
                if (fetch === void 0) { fetch = portableFetch; }
                if (basePath === void 0) { basePath = BASE_PATH; }
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then(function (response) {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
        getProducts: function (appId, productTypes, searchTerm, page, limit, options) {
            var localVarFetchArgs = (0, exports.CatalogProductsApiFetchParamCreator)(configuration).getProducts(appId, productTypes, searchTerm, page, limit, options);
            return function (fetch, basePath) {
                if (fetch === void 0) { fetch = portableFetch; }
                if (basePath === void 0) { basePath = BASE_PATH; }
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then(function (response) {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
        updateProduct: function (appId, catalogItemId, UpdateProduct, options) {
            var localVarFetchArgs = (0, exports.CatalogProductsApiFetchParamCreator)(configuration).updateProduct(appId, catalogItemId, UpdateProduct, options);
            return function (fetch, basePath) {
                if (fetch === void 0) { fetch = portableFetch; }
                if (basePath === void 0) { basePath = BASE_PATH; }
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then(function (response) {
                    if (response.status >= 200 && response.status < 300) {
                        return response;
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
    };
};
exports.CatalogProductsApiFp = CatalogProductsApiFp;
var CatalogProductsApiFactory = function (configuration, fetch, basePath) {
    return {
        archiveProduct: function (appId, catalogItemId, options) {
            return (0, exports.CatalogProductsApiFp)(configuration).archiveProduct(appId, catalogItemId, options)(fetch, basePath);
        },
        createProduct: function (appId, CreateProduct, options) {
            return (0, exports.CatalogProductsApiFp)(configuration).createProduct(appId, CreateProduct, options)(fetch, basePath);
        },
        duplicateProduct: function (appId, catalogItemId, options) {
            return (0, exports.CatalogProductsApiFp)(configuration).duplicateProduct(appId, catalogItemId, options)(fetch, basePath);
        },
        getProductById: function (appId, catalogItemId, options) {
            return (0, exports.CatalogProductsApiFp)(configuration).getProductById(appId, catalogItemId, options)(fetch, basePath);
        },
        getProducts: function (appId, productTypes, searchTerm, page, limit, options) {
            return (0, exports.CatalogProductsApiFp)(configuration).getProducts(appId, productTypes, searchTerm, page, limit, options)(fetch, basePath);
        },
        updateProduct: function (appId, catalogItemId, UpdateProduct, options) {
            return (0, exports.CatalogProductsApiFp)(configuration).updateProduct(appId, catalogItemId, UpdateProduct, options)(fetch, basePath);
        },
    };
};
exports.CatalogProductsApiFactory = CatalogProductsApiFactory;
var CatalogProductsApi = (function (_super) {
    __extends(CatalogProductsApi, _super);
    function CatalogProductsApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    CatalogProductsApi.prototype.archiveProduct = function (appId, catalogItemId, options) {
        return (0, exports.CatalogProductsApiFp)(this.configuration).archiveProduct(appId, catalogItemId, options)(this.fetch, this.basePath);
    };
    CatalogProductsApi.prototype.createProduct = function (appId, CreateProduct, options) {
        return (0, exports.CatalogProductsApiFp)(this.configuration).createProduct(appId, CreateProduct, options)(this.fetch, this.basePath);
    };
    CatalogProductsApi.prototype.duplicateProduct = function (appId, catalogItemId, options) {
        return (0, exports.CatalogProductsApiFp)(this.configuration).duplicateProduct(appId, catalogItemId, options)(this.fetch, this.basePath);
    };
    CatalogProductsApi.prototype.getProductById = function (appId, catalogItemId, options) {
        return (0, exports.CatalogProductsApiFp)(this.configuration).getProductById(appId, catalogItemId, options)(this.fetch, this.basePath);
    };
    CatalogProductsApi.prototype.getProducts = function (appId, productTypes, searchTerm, page, limit, options) {
        return (0, exports.CatalogProductsApiFp)(this.configuration).getProducts(appId, productTypes, searchTerm, page, limit, options)(this.fetch, this.basePath);
    };
    CatalogProductsApi.prototype.updateProduct = function (appId, catalogItemId, UpdateProduct, options) {
        return (0, exports.CatalogProductsApiFp)(this.configuration).updateProduct(appId, catalogItemId, UpdateProduct, options)(this.fetch, this.basePath);
    };
    return CatalogProductsApi;
}(BaseAPI));
exports.CatalogProductsApi = CatalogProductsApi;
var ChannelsApiFetchParamCreator = function (configuration) {
    return {
        assignAppIdToSalesChannel: function (appId, channelId, options) {
            if (options === void 0) { options = {}; }
            if (appId === null || appId === undefined) {
                throw new RequiredError('appId', 'Required parameter appId was null or undefined when calling assignAppIdToSalesChannel.');
            }
            if (channelId === null || channelId === undefined) {
                throw new RequiredError('channelId', 'Required parameter channelId was null or undefined when calling assignAppIdToSalesChannel.');
            }
            var localVarPath = "/api/v1.0/{appId}/channels/{channelId}/assign-appId"
                .replace("{".concat("appId", "}"), encodeURIComponent(String(appId)))
                .replace("{".concat("channelId", "}"), encodeURIComponent(String(channelId)));
            var localVarUrlObj = url.parse(localVarPath, true);
            var localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            var localVarHeaderParameter = {};
            var localVarQueryParameter = {};
            if (configuration && configuration.accessToken) {
                var localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("oauth2", ["api"])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        assignStoreToChannel: function (storeId, appId, channelId, options) {
            if (options === void 0) { options = {}; }
            if (storeId === null || storeId === undefined) {
                throw new RequiredError('storeId', 'Required parameter storeId was null or undefined when calling assignStoreToChannel.');
            }
            if (appId === null || appId === undefined) {
                throw new RequiredError('appId', 'Required parameter appId was null or undefined when calling assignStoreToChannel.');
            }
            if (channelId === null || channelId === undefined) {
                throw new RequiredError('channelId', 'Required parameter channelId was null or undefined when calling assignStoreToChannel.');
            }
            var localVarPath = "/api/v1.0/{appId}/channels/assign-store"
                .replace("{".concat("appId", "}"), encodeURIComponent(String(appId)));
            var localVarUrlObj = url.parse(localVarPath, true);
            var localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            var localVarHeaderParameter = {};
            var localVarQueryParameter = {};
            if (configuration && configuration.accessToken) {
                var localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("oauth2", ["api"])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }
            if (storeId !== undefined) {
                localVarQueryParameter['storeId'] = storeId;
            }
            if (channelId !== undefined) {
                localVarQueryParameter['channelId'] = channelId;
            }
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        attachStoreToSalesChannel: function (appId, channelId, storeId, options) {
            if (options === void 0) { options = {}; }
            if (appId === null || appId === undefined) {
                throw new RequiredError('appId', 'Required parameter appId was null or undefined when calling attachStoreToSalesChannel.');
            }
            if (channelId === null || channelId === undefined) {
                throw new RequiredError('channelId', 'Required parameter channelId was null or undefined when calling attachStoreToSalesChannel.');
            }
            if (storeId === null || storeId === undefined) {
                throw new RequiredError('storeId', 'Required parameter storeId was null or undefined when calling attachStoreToSalesChannel.');
            }
            var localVarPath = "/api/v1.0/{appId}/channels/{channelId}/stores/{storeId}"
                .replace("{".concat("appId", "}"), encodeURIComponent(String(appId)))
                .replace("{".concat("channelId", "}"), encodeURIComponent(String(channelId)))
                .replace("{".concat("storeId", "}"), encodeURIComponent(String(storeId)));
            var localVarUrlObj = url.parse(localVarPath, true);
            var localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            var localVarHeaderParameter = {};
            var localVarQueryParameter = {};
            if (configuration && configuration.accessToken) {
                var localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("oauth2", ["api"])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        detachAllStoresFromSalesChannel: function (appId, channelId, options) {
            if (options === void 0) { options = {}; }
            if (appId === null || appId === undefined) {
                throw new RequiredError('appId', 'Required parameter appId was null or undefined when calling detachAllStoresFromSalesChannel.');
            }
            if (channelId === null || channelId === undefined) {
                throw new RequiredError('channelId', 'Required parameter channelId was null or undefined when calling detachAllStoresFromSalesChannel.');
            }
            var localVarPath = "/api/v1.0/{appId}/channels/{channelId}/stores"
                .replace("{".concat("appId", "}"), encodeURIComponent(String(appId)))
                .replace("{".concat("channelId", "}"), encodeURIComponent(String(channelId)));
            var localVarUrlObj = url.parse(localVarPath, true);
            var localVarRequestOptions = Object.assign({ method: 'DELETE' }, options);
            var localVarHeaderParameter = {};
            var localVarQueryParameter = {};
            if (configuration && configuration.accessToken) {
                var localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("oauth2", ["api"])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        detachStoreFromSalesChannel: function (appId, channelId, storeId, options) {
            if (options === void 0) { options = {}; }
            if (appId === null || appId === undefined) {
                throw new RequiredError('appId', 'Required parameter appId was null or undefined when calling detachStoreFromSalesChannel.');
            }
            if (channelId === null || channelId === undefined) {
                throw new RequiredError('channelId', 'Required parameter channelId was null or undefined when calling detachStoreFromSalesChannel.');
            }
            if (storeId === null || storeId === undefined) {
                throw new RequiredError('storeId', 'Required parameter storeId was null or undefined when calling detachStoreFromSalesChannel.');
            }
            var localVarPath = "/api/v1.0/{appId}/channels/{channelId}/stores/{storeId}"
                .replace("{".concat("appId", "}"), encodeURIComponent(String(appId)))
                .replace("{".concat("channelId", "}"), encodeURIComponent(String(channelId)))
                .replace("{".concat("storeId", "}"), encodeURIComponent(String(storeId)));
            var localVarUrlObj = url.parse(localVarPath, true);
            var localVarRequestOptions = Object.assign({ method: 'DELETE' }, options);
            var localVarHeaderParameter = {};
            var localVarQueryParameter = {};
            if (configuration && configuration.accessToken) {
                var localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("oauth2", ["api"])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        getAssignedChannels: function (appId, options) {
            if (options === void 0) { options = {}; }
            if (appId === null || appId === undefined) {
                throw new RequiredError('appId', 'Required parameter appId was null or undefined when calling getAssignedChannels.');
            }
            var localVarPath = "/api/v1.0/{appId}/channels/assigned-channels"
                .replace("{".concat("appId", "}"), encodeURIComponent(String(appId)));
            var localVarUrlObj = url.parse(localVarPath, true);
            var localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            var localVarHeaderParameter = {};
            var localVarQueryParameter = {};
            if (configuration && configuration.accessToken) {
                var localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("oauth2", ["api"])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        getAvailableChannels: function (appId, options) {
            if (options === void 0) { options = {}; }
            if (appId === null || appId === undefined) {
                throw new RequiredError('appId', 'Required parameter appId was null or undefined when calling getAvailableChannels.');
            }
            var localVarPath = "/api/v1.0/{appId}/channels/available-channels"
                .replace("{".concat("appId", "}"), encodeURIComponent(String(appId)));
            var localVarUrlObj = url.parse(localVarPath, true);
            var localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            var localVarHeaderParameter = {};
            var localVarQueryParameter = {};
            if (configuration && configuration.accessToken) {
                var localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("oauth2", ["api"])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        getChannel: function (id, appId, options) {
            if (options === void 0) { options = {}; }
            if (id === null || id === undefined) {
                throw new RequiredError('id', 'Required parameter id was null or undefined when calling getChannel.');
            }
            if (appId === null || appId === undefined) {
                throw new RequiredError('appId', 'Required parameter appId was null or undefined when calling getChannel.');
            }
            var localVarPath = "/api/v1.0/{appId}/channels/{id}"
                .replace("{".concat("id", "}"), encodeURIComponent(String(id)))
                .replace("{".concat("appId", "}"), encodeURIComponent(String(appId)));
            var localVarUrlObj = url.parse(localVarPath, true);
            var localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            var localVarHeaderParameter = {};
            var localVarQueryParameter = {};
            if (configuration && configuration.accessToken) {
                var localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("oauth2", ["api"])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        getChannels: function (appId, options) {
            if (options === void 0) { options = {}; }
            if (appId === null || appId === undefined) {
                throw new RequiredError('appId', 'Required parameter appId was null or undefined when calling getChannels.');
            }
            var localVarPath = "/api/v1.0/{appId}/channels"
                .replace("{".concat("appId", "}"), encodeURIComponent(String(appId)));
            var localVarUrlObj = url.parse(localVarPath, true);
            var localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            var localVarHeaderParameter = {};
            var localVarQueryParameter = {};
            if (configuration && configuration.accessToken) {
                var localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("oauth2", ["api"])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        getStoresAssignedToChannel: function (appId, channelId, options) {
            if (options === void 0) { options = {}; }
            if (appId === null || appId === undefined) {
                throw new RequiredError('appId', 'Required parameter appId was null or undefined when calling getStoresAssignedToChannel.');
            }
            if (channelId === null || channelId === undefined) {
                throw new RequiredError('channelId', 'Required parameter channelId was null or undefined when calling getStoresAssignedToChannel.');
            }
            var localVarPath = "/api/v1.0/{appId}/channels/{channelId}/assigned-stores"
                .replace("{".concat("appId", "}"), encodeURIComponent(String(appId)))
                .replace("{".concat("channelId", "}"), encodeURIComponent(String(channelId)));
            var localVarUrlObj = url.parse(localVarPath, true);
            var localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            var localVarHeaderParameter = {};
            var localVarQueryParameter = {};
            if (configuration && configuration.accessToken) {
                var localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("oauth2", ["api"])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        getStoresBySalesChannel: function (appId, channelId, options) {
            if (options === void 0) { options = {}; }
            if (appId === null || appId === undefined) {
                throw new RequiredError('appId', 'Required parameter appId was null or undefined when calling getStoresBySalesChannel.');
            }
            if (channelId === null || channelId === undefined) {
                throw new RequiredError('channelId', 'Required parameter channelId was null or undefined when calling getStoresBySalesChannel.');
            }
            var localVarPath = "/api/v1.0/{appId}/channels/{channelId}/stores"
                .replace("{".concat("appId", "}"), encodeURIComponent(String(appId)))
                .replace("{".concat("channelId", "}"), encodeURIComponent(String(channelId)));
            var localVarUrlObj = url.parse(localVarPath, true);
            var localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            var localVarHeaderParameter = {};
            var localVarQueryParameter = {};
            if (configuration && configuration.accessToken) {
                var localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("oauth2", ["api"])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        unassignStoreFromChannel: function (storeId, appId, channelId, options) {
            if (options === void 0) { options = {}; }
            if (storeId === null || storeId === undefined) {
                throw new RequiredError('storeId', 'Required parameter storeId was null or undefined when calling unassignStoreFromChannel.');
            }
            if (appId === null || appId === undefined) {
                throw new RequiredError('appId', 'Required parameter appId was null or undefined when calling unassignStoreFromChannel.');
            }
            if (channelId === null || channelId === undefined) {
                throw new RequiredError('channelId', 'Required parameter channelId was null or undefined when calling unassignStoreFromChannel.');
            }
            var localVarPath = "/api/v1.0/{appId}/channels/unassign-store"
                .replace("{".concat("appId", "}"), encodeURIComponent(String(appId)));
            var localVarUrlObj = url.parse(localVarPath, true);
            var localVarRequestOptions = Object.assign({ method: 'DELETE' }, options);
            var localVarHeaderParameter = {};
            var localVarQueryParameter = {};
            if (configuration && configuration.accessToken) {
                var localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("oauth2", ["api"])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }
            if (storeId !== undefined) {
                localVarQueryParameter['storeId'] = storeId;
            }
            if (channelId !== undefined) {
                localVarQueryParameter['channelId'] = channelId;
            }
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    };
};
exports.ChannelsApiFetchParamCreator = ChannelsApiFetchParamCreator;
var ChannelsApiFp = function (configuration) {
    return {
        assignAppIdToSalesChannel: function (appId, channelId, options) {
            var localVarFetchArgs = (0, exports.ChannelsApiFetchParamCreator)(configuration).assignAppIdToSalesChannel(appId, channelId, options);
            return function (fetch, basePath) {
                if (fetch === void 0) { fetch = portableFetch; }
                if (basePath === void 0) { basePath = BASE_PATH; }
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then(function (response) {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
        assignStoreToChannel: function (storeId, appId, channelId, options) {
            var localVarFetchArgs = (0, exports.ChannelsApiFetchParamCreator)(configuration).assignStoreToChannel(storeId, appId, channelId, options);
            return function (fetch, basePath) {
                if (fetch === void 0) { fetch = portableFetch; }
                if (basePath === void 0) { basePath = BASE_PATH; }
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then(function (response) {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
        attachStoreToSalesChannel: function (appId, channelId, storeId, options) {
            var localVarFetchArgs = (0, exports.ChannelsApiFetchParamCreator)(configuration).attachStoreToSalesChannel(appId, channelId, storeId, options);
            return function (fetch, basePath) {
                if (fetch === void 0) { fetch = portableFetch; }
                if (basePath === void 0) { basePath = BASE_PATH; }
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then(function (response) {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
        detachAllStoresFromSalesChannel: function (appId, channelId, options) {
            var localVarFetchArgs = (0, exports.ChannelsApiFetchParamCreator)(configuration).detachAllStoresFromSalesChannel(appId, channelId, options);
            return function (fetch, basePath) {
                if (fetch === void 0) { fetch = portableFetch; }
                if (basePath === void 0) { basePath = BASE_PATH; }
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then(function (response) {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
        detachStoreFromSalesChannel: function (appId, channelId, storeId, options) {
            var localVarFetchArgs = (0, exports.ChannelsApiFetchParamCreator)(configuration).detachStoreFromSalesChannel(appId, channelId, storeId, options);
            return function (fetch, basePath) {
                if (fetch === void 0) { fetch = portableFetch; }
                if (basePath === void 0) { basePath = BASE_PATH; }
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then(function (response) {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
        getAssignedChannels: function (appId, options) {
            var localVarFetchArgs = (0, exports.ChannelsApiFetchParamCreator)(configuration).getAssignedChannels(appId, options);
            return function (fetch, basePath) {
                if (fetch === void 0) { fetch = portableFetch; }
                if (basePath === void 0) { basePath = BASE_PATH; }
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then(function (response) {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
        getAvailableChannels: function (appId, options) {
            var localVarFetchArgs = (0, exports.ChannelsApiFetchParamCreator)(configuration).getAvailableChannels(appId, options);
            return function (fetch, basePath) {
                if (fetch === void 0) { fetch = portableFetch; }
                if (basePath === void 0) { basePath = BASE_PATH; }
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then(function (response) {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
        getChannel: function (id, appId, options) {
            var localVarFetchArgs = (0, exports.ChannelsApiFetchParamCreator)(configuration).getChannel(id, appId, options);
            return function (fetch, basePath) {
                if (fetch === void 0) { fetch = portableFetch; }
                if (basePath === void 0) { basePath = BASE_PATH; }
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then(function (response) {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
        getChannels: function (appId, options) {
            var localVarFetchArgs = (0, exports.ChannelsApiFetchParamCreator)(configuration).getChannels(appId, options);
            return function (fetch, basePath) {
                if (fetch === void 0) { fetch = portableFetch; }
                if (basePath === void 0) { basePath = BASE_PATH; }
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then(function (response) {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
        getStoresAssignedToChannel: function (appId, channelId, options) {
            var localVarFetchArgs = (0, exports.ChannelsApiFetchParamCreator)(configuration).getStoresAssignedToChannel(appId, channelId, options);
            return function (fetch, basePath) {
                if (fetch === void 0) { fetch = portableFetch; }
                if (basePath === void 0) { basePath = BASE_PATH; }
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then(function (response) {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
        getStoresBySalesChannel: function (appId, channelId, options) {
            var localVarFetchArgs = (0, exports.ChannelsApiFetchParamCreator)(configuration).getStoresBySalesChannel(appId, channelId, options);
            return function (fetch, basePath) {
                if (fetch === void 0) { fetch = portableFetch; }
                if (basePath === void 0) { basePath = BASE_PATH; }
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then(function (response) {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
        unassignStoreFromChannel: function (storeId, appId, channelId, options) {
            var localVarFetchArgs = (0, exports.ChannelsApiFetchParamCreator)(configuration).unassignStoreFromChannel(storeId, appId, channelId, options);
            return function (fetch, basePath) {
                if (fetch === void 0) { fetch = portableFetch; }
                if (basePath === void 0) { basePath = BASE_PATH; }
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then(function (response) {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
    };
};
exports.ChannelsApiFp = ChannelsApiFp;
var ChannelsApiFactory = function (configuration, fetch, basePath) {
    return {
        assignAppIdToSalesChannel: function (appId, channelId, options) {
            return (0, exports.ChannelsApiFp)(configuration).assignAppIdToSalesChannel(appId, channelId, options)(fetch, basePath);
        },
        assignStoreToChannel: function (storeId, appId, channelId, options) {
            return (0, exports.ChannelsApiFp)(configuration).assignStoreToChannel(storeId, appId, channelId, options)(fetch, basePath);
        },
        attachStoreToSalesChannel: function (appId, channelId, storeId, options) {
            return (0, exports.ChannelsApiFp)(configuration).attachStoreToSalesChannel(appId, channelId, storeId, options)(fetch, basePath);
        },
        detachAllStoresFromSalesChannel: function (appId, channelId, options) {
            return (0, exports.ChannelsApiFp)(configuration).detachAllStoresFromSalesChannel(appId, channelId, options)(fetch, basePath);
        },
        detachStoreFromSalesChannel: function (appId, channelId, storeId, options) {
            return (0, exports.ChannelsApiFp)(configuration).detachStoreFromSalesChannel(appId, channelId, storeId, options)(fetch, basePath);
        },
        getAssignedChannels: function (appId, options) {
            return (0, exports.ChannelsApiFp)(configuration).getAssignedChannels(appId, options)(fetch, basePath);
        },
        getAvailableChannels: function (appId, options) {
            return (0, exports.ChannelsApiFp)(configuration).getAvailableChannels(appId, options)(fetch, basePath);
        },
        getChannel: function (id, appId, options) {
            return (0, exports.ChannelsApiFp)(configuration).getChannel(id, appId, options)(fetch, basePath);
        },
        getChannels: function (appId, options) {
            return (0, exports.ChannelsApiFp)(configuration).getChannels(appId, options)(fetch, basePath);
        },
        getStoresAssignedToChannel: function (appId, channelId, options) {
            return (0, exports.ChannelsApiFp)(configuration).getStoresAssignedToChannel(appId, channelId, options)(fetch, basePath);
        },
        getStoresBySalesChannel: function (appId, channelId, options) {
            return (0, exports.ChannelsApiFp)(configuration).getStoresBySalesChannel(appId, channelId, options)(fetch, basePath);
        },
        unassignStoreFromChannel: function (storeId, appId, channelId, options) {
            return (0, exports.ChannelsApiFp)(configuration).unassignStoreFromChannel(storeId, appId, channelId, options)(fetch, basePath);
        },
    };
};
exports.ChannelsApiFactory = ChannelsApiFactory;
var ChannelsApi = (function (_super) {
    __extends(ChannelsApi, _super);
    function ChannelsApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    ChannelsApi.prototype.assignAppIdToSalesChannel = function (appId, channelId, options) {
        return (0, exports.ChannelsApiFp)(this.configuration).assignAppIdToSalesChannel(appId, channelId, options)(this.fetch, this.basePath);
    };
    ChannelsApi.prototype.assignStoreToChannel = function (storeId, appId, channelId, options) {
        return (0, exports.ChannelsApiFp)(this.configuration).assignStoreToChannel(storeId, appId, channelId, options)(this.fetch, this.basePath);
    };
    ChannelsApi.prototype.attachStoreToSalesChannel = function (appId, channelId, storeId, options) {
        return (0, exports.ChannelsApiFp)(this.configuration).attachStoreToSalesChannel(appId, channelId, storeId, options)(this.fetch, this.basePath);
    };
    ChannelsApi.prototype.detachAllStoresFromSalesChannel = function (appId, channelId, options) {
        return (0, exports.ChannelsApiFp)(this.configuration).detachAllStoresFromSalesChannel(appId, channelId, options)(this.fetch, this.basePath);
    };
    ChannelsApi.prototype.detachStoreFromSalesChannel = function (appId, channelId, storeId, options) {
        return (0, exports.ChannelsApiFp)(this.configuration).detachStoreFromSalesChannel(appId, channelId, storeId, options)(this.fetch, this.basePath);
    };
    ChannelsApi.prototype.getAssignedChannels = function (appId, options) {
        return (0, exports.ChannelsApiFp)(this.configuration).getAssignedChannels(appId, options)(this.fetch, this.basePath);
    };
    ChannelsApi.prototype.getAvailableChannels = function (appId, options) {
        return (0, exports.ChannelsApiFp)(this.configuration).getAvailableChannels(appId, options)(this.fetch, this.basePath);
    };
    ChannelsApi.prototype.getChannel = function (id, appId, options) {
        return (0, exports.ChannelsApiFp)(this.configuration).getChannel(id, appId, options)(this.fetch, this.basePath);
    };
    ChannelsApi.prototype.getChannels = function (appId, options) {
        return (0, exports.ChannelsApiFp)(this.configuration).getChannels(appId, options)(this.fetch, this.basePath);
    };
    ChannelsApi.prototype.getStoresAssignedToChannel = function (appId, channelId, options) {
        return (0, exports.ChannelsApiFp)(this.configuration).getStoresAssignedToChannel(appId, channelId, options)(this.fetch, this.basePath);
    };
    ChannelsApi.prototype.getStoresBySalesChannel = function (appId, channelId, options) {
        return (0, exports.ChannelsApiFp)(this.configuration).getStoresBySalesChannel(appId, channelId, options)(this.fetch, this.basePath);
    };
    ChannelsApi.prototype.unassignStoreFromChannel = function (storeId, appId, channelId, options) {
        return (0, exports.ChannelsApiFp)(this.configuration).unassignStoreFromChannel(storeId, appId, channelId, options)(this.fetch, this.basePath);
    };
    return ChannelsApi;
}(BaseAPI));
exports.ChannelsApi = ChannelsApi;
var ClientsApiFetchParamCreator = function (configuration) {
    return {
        getClient: function (clientId, options) {
            if (options === void 0) { options = {}; }
            if (clientId === null || clientId === undefined) {
                throw new RequiredError('clientId', 'Required parameter clientId was null or undefined when calling getClient.');
            }
            var localVarPath = "/api/v1.0/clients/{clientId}"
                .replace("{".concat("clientId", "}"), encodeURIComponent(String(clientId)));
            var localVarUrlObj = url.parse(localVarPath, true);
            var localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            var localVarHeaderParameter = {};
            var localVarQueryParameter = {};
            if (configuration && configuration.accessToken) {
                var localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("oauth2", ["api"])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        setSalesForceContactId: function (clientId, body, options) {
            if (options === void 0) { options = {}; }
            if (clientId === null || clientId === undefined) {
                throw new RequiredError('clientId', 'Required parameter clientId was null or undefined when calling setSalesForceContactId.');
            }
            if (body === null || body === undefined) {
                throw new RequiredError('body', 'Required parameter body was null or undefined when calling setSalesForceContactId.');
            }
            var localVarPath = "/api/v1.0/clients/{clientId}/salesforcecontactid"
                .replace("{".concat("clientId", "}"), encodeURIComponent(String(clientId)));
            var localVarUrlObj = url.parse(localVarPath, true);
            var localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            var localVarHeaderParameter = {};
            var localVarQueryParameter = {};
            if (configuration && configuration.accessToken) {
                var localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("oauth2", ["api"])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }
            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            var needsSerialization = ("string" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body = needsSerialization ? JSON.stringify(body || {}) : (body || "");
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        setStripeCustomerId: function (clientId, body, options) {
            if (options === void 0) { options = {}; }
            if (clientId === null || clientId === undefined) {
                throw new RequiredError('clientId', 'Required parameter clientId was null or undefined when calling setStripeCustomerId.');
            }
            if (body === null || body === undefined) {
                throw new RequiredError('body', 'Required parameter body was null or undefined when calling setStripeCustomerId.');
            }
            var localVarPath = "/api/v1.0/clients/{clientId}/stripecustomerid"
                .replace("{".concat("clientId", "}"), encodeURIComponent(String(clientId)));
            var localVarUrlObj = url.parse(localVarPath, true);
            var localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            var localVarHeaderParameter = {};
            var localVarQueryParameter = {};
            if (configuration && configuration.accessToken) {
                var localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("oauth2", ["api"])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }
            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            var needsSerialization = ("string" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body = needsSerialization ? JSON.stringify(body || {}) : (body || "");
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    };
};
exports.ClientsApiFetchParamCreator = ClientsApiFetchParamCreator;
var ClientsApiFp = function (configuration) {
    return {
        getClient: function (clientId, options) {
            var localVarFetchArgs = (0, exports.ClientsApiFetchParamCreator)(configuration).getClient(clientId, options);
            return function (fetch, basePath) {
                if (fetch === void 0) { fetch = portableFetch; }
                if (basePath === void 0) { basePath = BASE_PATH; }
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then(function (response) {
                    if (response.status >= 200 && response.status < 300) {
                        return response;
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
        setSalesForceContactId: function (clientId, body, options) {
            var localVarFetchArgs = (0, exports.ClientsApiFetchParamCreator)(configuration).setSalesForceContactId(clientId, body, options);
            return function (fetch, basePath) {
                if (fetch === void 0) { fetch = portableFetch; }
                if (basePath === void 0) { basePath = BASE_PATH; }
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then(function (response) {
                    if (response.status >= 200 && response.status < 300) {
                        return response;
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
        setStripeCustomerId: function (clientId, body, options) {
            var localVarFetchArgs = (0, exports.ClientsApiFetchParamCreator)(configuration).setStripeCustomerId(clientId, body, options);
            return function (fetch, basePath) {
                if (fetch === void 0) { fetch = portableFetch; }
                if (basePath === void 0) { basePath = BASE_PATH; }
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then(function (response) {
                    if (response.status >= 200 && response.status < 300) {
                        return response;
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
    };
};
exports.ClientsApiFp = ClientsApiFp;
var ClientsApiFactory = function (configuration, fetch, basePath) {
    return {
        getClient: function (clientId, options) {
            return (0, exports.ClientsApiFp)(configuration).getClient(clientId, options)(fetch, basePath);
        },
        setSalesForceContactId: function (clientId, body, options) {
            return (0, exports.ClientsApiFp)(configuration).setSalesForceContactId(clientId, body, options)(fetch, basePath);
        },
        setStripeCustomerId: function (clientId, body, options) {
            return (0, exports.ClientsApiFp)(configuration).setStripeCustomerId(clientId, body, options)(fetch, basePath);
        },
    };
};
exports.ClientsApiFactory = ClientsApiFactory;
var ClientsApi = (function (_super) {
    __extends(ClientsApi, _super);
    function ClientsApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    ClientsApi.prototype.getClient = function (clientId, options) {
        return (0, exports.ClientsApiFp)(this.configuration).getClient(clientId, options)(this.fetch, this.basePath);
    };
    ClientsApi.prototype.setSalesForceContactId = function (clientId, body, options) {
        return (0, exports.ClientsApiFp)(this.configuration).setSalesForceContactId(clientId, body, options)(this.fetch, this.basePath);
    };
    ClientsApi.prototype.setStripeCustomerId = function (clientId, body, options) {
        return (0, exports.ClientsApiFp)(this.configuration).setStripeCustomerId(clientId, body, options)(this.fetch, this.basePath);
    };
    return ClientsApi;
}(BaseAPI));
exports.ClientsApi = ClientsApi;
var ContentSecurityPolicyApiFetchParamCreator = function (configuration) {
    return {
        contentSecurityPolicyReport: function (CspReportRequest, options) {
            if (options === void 0) { options = {}; }
            if (CspReportRequest === null || CspReportRequest === undefined) {
                throw new RequiredError('CspReportRequest', 'Required parameter CspReportRequest was null or undefined when calling contentSecurityPolicyReport.');
            }
            var localVarPath = "/api/v1.0/csp/report";
            var localVarUrlObj = url.parse(localVarPath, true);
            var localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            var localVarHeaderParameter = {};
            var localVarQueryParameter = {};
            if (configuration && configuration.accessToken) {
                var localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("oauth2", ["api"])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }
            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            var needsSerialization = ("CspReportRequest" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body = needsSerialization ? JSON.stringify(CspReportRequest || {}) : (CspReportRequest || "");
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    };
};
exports.ContentSecurityPolicyApiFetchParamCreator = ContentSecurityPolicyApiFetchParamCreator;
var ContentSecurityPolicyApiFp = function (configuration) {
    return {
        contentSecurityPolicyReport: function (CspReportRequest, options) {
            var localVarFetchArgs = (0, exports.ContentSecurityPolicyApiFetchParamCreator)(configuration).contentSecurityPolicyReport(CspReportRequest, options);
            return function (fetch, basePath) {
                if (fetch === void 0) { fetch = portableFetch; }
                if (basePath === void 0) { basePath = BASE_PATH; }
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then(function (response) {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
    };
};
exports.ContentSecurityPolicyApiFp = ContentSecurityPolicyApiFp;
var ContentSecurityPolicyApiFactory = function (configuration, fetch, basePath) {
    return {
        contentSecurityPolicyReport: function (CspReportRequest, options) {
            return (0, exports.ContentSecurityPolicyApiFp)(configuration).contentSecurityPolicyReport(CspReportRequest, options)(fetch, basePath);
        },
    };
};
exports.ContentSecurityPolicyApiFactory = ContentSecurityPolicyApiFactory;
var ContentSecurityPolicyApi = (function (_super) {
    __extends(ContentSecurityPolicyApi, _super);
    function ContentSecurityPolicyApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    ContentSecurityPolicyApi.prototype.contentSecurityPolicyReport = function (CspReportRequest, options) {
        return (0, exports.ContentSecurityPolicyApiFp)(this.configuration).contentSecurityPolicyReport(CspReportRequest, options)(this.fetch, this.basePath);
    };
    return ContentSecurityPolicyApi;
}(BaseAPI));
exports.ContentSecurityPolicyApi = ContentSecurityPolicyApi;
var CrossSellApiFetchParamCreator = function (configuration) {
    return {
        getCrossSellMenuItems: function (appId, menuId, menuItemId, limit, totalValue, options) {
            if (options === void 0) { options = {}; }
            if (appId === null || appId === undefined) {
                throw new RequiredError('appId', 'Required parameter appId was null or undefined when calling getCrossSellMenuItems.');
            }
            if (menuId === null || menuId === undefined) {
                throw new RequiredError('menuId', 'Required parameter menuId was null or undefined when calling getCrossSellMenuItems.');
            }
            if (menuItemId === null || menuItemId === undefined) {
                throw new RequiredError('menuItemId', 'Required parameter menuItemId was null or undefined when calling getCrossSellMenuItems.');
            }
            if (limit === null || limit === undefined) {
                throw new RequiredError('limit', 'Required parameter limit was null or undefined when calling getCrossSellMenuItems.');
            }
            if (totalValue === null || totalValue === undefined) {
                throw new RequiredError('totalValue', 'Required parameter totalValue was null or undefined when calling getCrossSellMenuItems.');
            }
            var localVarPath = "/api/v1.0/{appId}/crossSell/menuItems"
                .replace("{".concat("appId", "}"), encodeURIComponent(String(appId)));
            var localVarUrlObj = url.parse(localVarPath, true);
            var localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            var localVarHeaderParameter = {};
            var localVarQueryParameter = {};
            if (configuration && configuration.accessToken) {
                var localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("oauth2", ["api"])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }
            if (menuId !== undefined) {
                localVarQueryParameter['menuId'] = menuId;
            }
            if (menuItemId) {
                localVarQueryParameter['menuItemId'] = menuItemId;
            }
            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }
            if (totalValue !== undefined) {
                localVarQueryParameter['totalValue'] = totalValue;
            }
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    };
};
exports.CrossSellApiFetchParamCreator = CrossSellApiFetchParamCreator;
var CrossSellApiFp = function (configuration) {
    return {
        getCrossSellMenuItems: function (appId, menuId, menuItemId, limit, totalValue, options) {
            var localVarFetchArgs = (0, exports.CrossSellApiFetchParamCreator)(configuration).getCrossSellMenuItems(appId, menuId, menuItemId, limit, totalValue, options);
            return function (fetch, basePath) {
                if (fetch === void 0) { fetch = portableFetch; }
                if (basePath === void 0) { basePath = BASE_PATH; }
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then(function (response) {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
    };
};
exports.CrossSellApiFp = CrossSellApiFp;
var CrossSellApiFactory = function (configuration, fetch, basePath) {
    return {
        getCrossSellMenuItems: function (appId, menuId, menuItemId, limit, totalValue, options) {
            return (0, exports.CrossSellApiFp)(configuration).getCrossSellMenuItems(appId, menuId, menuItemId, limit, totalValue, options)(fetch, basePath);
        },
    };
};
exports.CrossSellApiFactory = CrossSellApiFactory;
var CrossSellApi = (function (_super) {
    __extends(CrossSellApi, _super);
    function CrossSellApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    CrossSellApi.prototype.getCrossSellMenuItems = function (appId, menuId, menuItemId, limit, totalValue, options) {
        return (0, exports.CrossSellApiFp)(this.configuration).getCrossSellMenuItems(appId, menuId, menuItemId, limit, totalValue, options)(this.fetch, this.basePath);
    };
    return CrossSellApi;
}(BaseAPI));
exports.CrossSellApi = CrossSellApi;
var CustomersApiFetchParamCreator = function (configuration) {
    return {
        createCustomer: function (appId, CustomerCreateModel, options) {
            if (options === void 0) { options = {}; }
            if (appId === null || appId === undefined) {
                throw new RequiredError('appId', 'Required parameter appId was null or undefined when calling createCustomer.');
            }
            if (CustomerCreateModel === null || CustomerCreateModel === undefined) {
                throw new RequiredError('CustomerCreateModel', 'Required parameter CustomerCreateModel was null or undefined when calling createCustomer.');
            }
            var localVarPath = "/api/v1.0/{appId}/customers"
                .replace("{".concat("appId", "}"), encodeURIComponent(String(appId)));
            var localVarUrlObj = url.parse(localVarPath, true);
            var localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            var localVarHeaderParameter = {};
            var localVarQueryParameter = {};
            if (configuration && configuration.accessToken) {
                var localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("oauth2", ["api"])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }
            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            var needsSerialization = ("CustomerCreateModel" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body = needsSerialization ? JSON.stringify(CustomerCreateModel || {}) : (CustomerCreateModel || "");
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        getCustomerById: function (appId, customerId, options) {
            if (options === void 0) { options = {}; }
            if (appId === null || appId === undefined) {
                throw new RequiredError('appId', 'Required parameter appId was null or undefined when calling getCustomerById.');
            }
            if (customerId === null || customerId === undefined) {
                throw new RequiredError('customerId', 'Required parameter customerId was null or undefined when calling getCustomerById.');
            }
            var localVarPath = "/api/v1.0/{appId}/customers/{customerId}"
                .replace("{".concat("appId", "}"), encodeURIComponent(String(appId)))
                .replace("{".concat("customerId", "}"), encodeURIComponent(String(customerId)));
            var localVarUrlObj = url.parse(localVarPath, true);
            var localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            var localVarHeaderParameter = {};
            var localVarQueryParameter = {};
            if (configuration && configuration.accessToken) {
                var localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("oauth2", ["api"])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        getCustomers: function (appId, phoneNumber, options) {
            if (options === void 0) { options = {}; }
            if (appId === null || appId === undefined) {
                throw new RequiredError('appId', 'Required parameter appId was null or undefined when calling getCustomers.');
            }
            if (phoneNumber === null || phoneNumber === undefined) {
                throw new RequiredError('phoneNumber', 'Required parameter phoneNumber was null or undefined when calling getCustomers.');
            }
            var localVarPath = "/api/v1.0/{appId}/customers"
                .replace("{".concat("appId", "}"), encodeURIComponent(String(appId)));
            var localVarUrlObj = url.parse(localVarPath, true);
            var localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            var localVarHeaderParameter = {};
            var localVarQueryParameter = {};
            if (configuration && configuration.accessToken) {
                var localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("oauth2", ["api"])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }
            if (phoneNumber !== undefined) {
                localVarQueryParameter['phoneNumber'] = phoneNumber;
            }
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        updateCustomerById: function (appId, customerId, CustomerUpdateModel, options) {
            if (options === void 0) { options = {}; }
            if (appId === null || appId === undefined) {
                throw new RequiredError('appId', 'Required parameter appId was null or undefined when calling updateCustomerById.');
            }
            if (customerId === null || customerId === undefined) {
                throw new RequiredError('customerId', 'Required parameter customerId was null or undefined when calling updateCustomerById.');
            }
            if (CustomerUpdateModel === null || CustomerUpdateModel === undefined) {
                throw new RequiredError('CustomerUpdateModel', 'Required parameter CustomerUpdateModel was null or undefined when calling updateCustomerById.');
            }
            var localVarPath = "/api/v1.0/{appId}/customers/{customerId}"
                .replace("{".concat("appId", "}"), encodeURIComponent(String(appId)))
                .replace("{".concat("customerId", "}"), encodeURIComponent(String(customerId)));
            var localVarUrlObj = url.parse(localVarPath, true);
            var localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            var localVarHeaderParameter = {};
            var localVarQueryParameter = {};
            if (configuration && configuration.accessToken) {
                var localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("oauth2", ["api"])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }
            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            var needsSerialization = ("CustomerUpdateModel" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body = needsSerialization ? JSON.stringify(CustomerUpdateModel || {}) : (CustomerUpdateModel || "");
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    };
};
exports.CustomersApiFetchParamCreator = CustomersApiFetchParamCreator;
var CustomersApiFp = function (configuration) {
    return {
        createCustomer: function (appId, CustomerCreateModel, options) {
            var localVarFetchArgs = (0, exports.CustomersApiFetchParamCreator)(configuration).createCustomer(appId, CustomerCreateModel, options);
            return function (fetch, basePath) {
                if (fetch === void 0) { fetch = portableFetch; }
                if (basePath === void 0) { basePath = BASE_PATH; }
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then(function (response) {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
        getCustomerById: function (appId, customerId, options) {
            var localVarFetchArgs = (0, exports.CustomersApiFetchParamCreator)(configuration).getCustomerById(appId, customerId, options);
            return function (fetch, basePath) {
                if (fetch === void 0) { fetch = portableFetch; }
                if (basePath === void 0) { basePath = BASE_PATH; }
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then(function (response) {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
        getCustomers: function (appId, phoneNumber, options) {
            var localVarFetchArgs = (0, exports.CustomersApiFetchParamCreator)(configuration).getCustomers(appId, phoneNumber, options);
            return function (fetch, basePath) {
                if (fetch === void 0) { fetch = portableFetch; }
                if (basePath === void 0) { basePath = BASE_PATH; }
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then(function (response) {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
        updateCustomerById: function (appId, customerId, CustomerUpdateModel, options) {
            var localVarFetchArgs = (0, exports.CustomersApiFetchParamCreator)(configuration).updateCustomerById(appId, customerId, CustomerUpdateModel, options);
            return function (fetch, basePath) {
                if (fetch === void 0) { fetch = portableFetch; }
                if (basePath === void 0) { basePath = BASE_PATH; }
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then(function (response) {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
    };
};
exports.CustomersApiFp = CustomersApiFp;
var CustomersApiFactory = function (configuration, fetch, basePath) {
    return {
        createCustomer: function (appId, CustomerCreateModel, options) {
            return (0, exports.CustomersApiFp)(configuration).createCustomer(appId, CustomerCreateModel, options)(fetch, basePath);
        },
        getCustomerById: function (appId, customerId, options) {
            return (0, exports.CustomersApiFp)(configuration).getCustomerById(appId, customerId, options)(fetch, basePath);
        },
        getCustomers: function (appId, phoneNumber, options) {
            return (0, exports.CustomersApiFp)(configuration).getCustomers(appId, phoneNumber, options)(fetch, basePath);
        },
        updateCustomerById: function (appId, customerId, CustomerUpdateModel, options) {
            return (0, exports.CustomersApiFp)(configuration).updateCustomerById(appId, customerId, CustomerUpdateModel, options)(fetch, basePath);
        },
    };
};
exports.CustomersApiFactory = CustomersApiFactory;
var CustomersApi = (function (_super) {
    __extends(CustomersApi, _super);
    function CustomersApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    CustomersApi.prototype.createCustomer = function (appId, CustomerCreateModel, options) {
        return (0, exports.CustomersApiFp)(this.configuration).createCustomer(appId, CustomerCreateModel, options)(this.fetch, this.basePath);
    };
    CustomersApi.prototype.getCustomerById = function (appId, customerId, options) {
        return (0, exports.CustomersApiFp)(this.configuration).getCustomerById(appId, customerId, options)(this.fetch, this.basePath);
    };
    CustomersApi.prototype.getCustomers = function (appId, phoneNumber, options) {
        return (0, exports.CustomersApiFp)(this.configuration).getCustomers(appId, phoneNumber, options)(this.fetch, this.basePath);
    };
    CustomersApi.prototype.updateCustomerById = function (appId, customerId, CustomerUpdateModel, options) {
        return (0, exports.CustomersApiFp)(this.configuration).updateCustomerById(appId, customerId, CustomerUpdateModel, options)(this.fetch, this.basePath);
    };
    return CustomersApi;
}(BaseAPI));
exports.CustomersApi = CustomersApi;
var DeliveryZoneApiFetchParamCreator = function (configuration) {
    return {
        addDeliveryZone: function (storeId, DeliveryZoneBase, options) {
            if (options === void 0) { options = {}; }
            if (storeId === null || storeId === undefined) {
                throw new RequiredError('storeId', 'Required parameter storeId was null or undefined when calling addDeliveryZone.');
            }
            if (DeliveryZoneBase === null || DeliveryZoneBase === undefined) {
                throw new RequiredError('DeliveryZoneBase', 'Required parameter DeliveryZoneBase was null or undefined when calling addDeliveryZone.');
            }
            var localVarPath = "/api/v1.0/stores/{storeId}/deliveryzones"
                .replace("{".concat("storeId", "}"), encodeURIComponent(String(storeId)));
            var localVarUrlObj = url.parse(localVarPath, true);
            var localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            var localVarHeaderParameter = {};
            var localVarQueryParameter = {};
            if (configuration && configuration.accessToken) {
                var localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("oauth2", ["api"])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }
            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            var needsSerialization = ("DeliveryZoneBase" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body = needsSerialization ? JSON.stringify(DeliveryZoneBase || {}) : (DeliveryZoneBase || "");
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        getDeliveryZones: function (storeId, options) {
            if (options === void 0) { options = {}; }
            if (storeId === null || storeId === undefined) {
                throw new RequiredError('storeId', 'Required parameter storeId was null or undefined when calling getDeliveryZones.');
            }
            var localVarPath = "/api/v1.0/stores/{storeId}/deliveryzones"
                .replace("{".concat("storeId", "}"), encodeURIComponent(String(storeId)));
            var localVarUrlObj = url.parse(localVarPath, true);
            var localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            var localVarHeaderParameter = {};
            var localVarQueryParameter = {};
            if (configuration && configuration.accessToken) {
                var localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("oauth2", ["api"])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        removeDeliveryZone: function (storeId, deliveryZoneId, options) {
            if (options === void 0) { options = {}; }
            if (storeId === null || storeId === undefined) {
                throw new RequiredError('storeId', 'Required parameter storeId was null or undefined when calling removeDeliveryZone.');
            }
            if (deliveryZoneId === null || deliveryZoneId === undefined) {
                throw new RequiredError('deliveryZoneId', 'Required parameter deliveryZoneId was null or undefined when calling removeDeliveryZone.');
            }
            var localVarPath = "/api/v1.0/stores/{storeId}/deliveryzones/{deliveryZoneId}"
                .replace("{".concat("storeId", "}"), encodeURIComponent(String(storeId)))
                .replace("{".concat("deliveryZoneId", "}"), encodeURIComponent(String(deliveryZoneId)));
            var localVarUrlObj = url.parse(localVarPath, true);
            var localVarRequestOptions = Object.assign({ method: 'DELETE' }, options);
            var localVarHeaderParameter = {};
            var localVarQueryParameter = {};
            if (configuration && configuration.accessToken) {
                var localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("oauth2", ["api"])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        updateDeliveryZone: function (storeId, deliveryZoneId, DeliveryZoneBase, options) {
            if (options === void 0) { options = {}; }
            if (storeId === null || storeId === undefined) {
                throw new RequiredError('storeId', 'Required parameter storeId was null or undefined when calling updateDeliveryZone.');
            }
            if (deliveryZoneId === null || deliveryZoneId === undefined) {
                throw new RequiredError('deliveryZoneId', 'Required parameter deliveryZoneId was null or undefined when calling updateDeliveryZone.');
            }
            if (DeliveryZoneBase === null || DeliveryZoneBase === undefined) {
                throw new RequiredError('DeliveryZoneBase', 'Required parameter DeliveryZoneBase was null or undefined when calling updateDeliveryZone.');
            }
            var localVarPath = "/api/v1.0/stores/{storeId}/deliveryzones/{deliveryZoneId}"
                .replace("{".concat("storeId", "}"), encodeURIComponent(String(storeId)))
                .replace("{".concat("deliveryZoneId", "}"), encodeURIComponent(String(deliveryZoneId)));
            var localVarUrlObj = url.parse(localVarPath, true);
            var localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            var localVarHeaderParameter = {};
            var localVarQueryParameter = {};
            if (configuration && configuration.accessToken) {
                var localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("oauth2", ["api"])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }
            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            var needsSerialization = ("DeliveryZoneBase" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body = needsSerialization ? JSON.stringify(DeliveryZoneBase || {}) : (DeliveryZoneBase || "");
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    };
};
exports.DeliveryZoneApiFetchParamCreator = DeliveryZoneApiFetchParamCreator;
var DeliveryZoneApiFp = function (configuration) {
    return {
        addDeliveryZone: function (storeId, DeliveryZoneBase, options) {
            var localVarFetchArgs = (0, exports.DeliveryZoneApiFetchParamCreator)(configuration).addDeliveryZone(storeId, DeliveryZoneBase, options);
            return function (fetch, basePath) {
                if (fetch === void 0) { fetch = portableFetch; }
                if (basePath === void 0) { basePath = BASE_PATH; }
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then(function (response) {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
        getDeliveryZones: function (storeId, options) {
            var localVarFetchArgs = (0, exports.DeliveryZoneApiFetchParamCreator)(configuration).getDeliveryZones(storeId, options);
            return function (fetch, basePath) {
                if (fetch === void 0) { fetch = portableFetch; }
                if (basePath === void 0) { basePath = BASE_PATH; }
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then(function (response) {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
        removeDeliveryZone: function (storeId, deliveryZoneId, options) {
            var localVarFetchArgs = (0, exports.DeliveryZoneApiFetchParamCreator)(configuration).removeDeliveryZone(storeId, deliveryZoneId, options);
            return function (fetch, basePath) {
                if (fetch === void 0) { fetch = portableFetch; }
                if (basePath === void 0) { basePath = BASE_PATH; }
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then(function (response) {
                    if (response.status >= 200 && response.status < 300) {
                        return response;
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
        updateDeliveryZone: function (storeId, deliveryZoneId, DeliveryZoneBase, options) {
            var localVarFetchArgs = (0, exports.DeliveryZoneApiFetchParamCreator)(configuration).updateDeliveryZone(storeId, deliveryZoneId, DeliveryZoneBase, options);
            return function (fetch, basePath) {
                if (fetch === void 0) { fetch = portableFetch; }
                if (basePath === void 0) { basePath = BASE_PATH; }
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then(function (response) {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
    };
};
exports.DeliveryZoneApiFp = DeliveryZoneApiFp;
var DeliveryZoneApiFactory = function (configuration, fetch, basePath) {
    return {
        addDeliveryZone: function (storeId, DeliveryZoneBase, options) {
            return (0, exports.DeliveryZoneApiFp)(configuration).addDeliveryZone(storeId, DeliveryZoneBase, options)(fetch, basePath);
        },
        getDeliveryZones: function (storeId, options) {
            return (0, exports.DeliveryZoneApiFp)(configuration).getDeliveryZones(storeId, options)(fetch, basePath);
        },
        removeDeliveryZone: function (storeId, deliveryZoneId, options) {
            return (0, exports.DeliveryZoneApiFp)(configuration).removeDeliveryZone(storeId, deliveryZoneId, options)(fetch, basePath);
        },
        updateDeliveryZone: function (storeId, deliveryZoneId, DeliveryZoneBase, options) {
            return (0, exports.DeliveryZoneApiFp)(configuration).updateDeliveryZone(storeId, deliveryZoneId, DeliveryZoneBase, options)(fetch, basePath);
        },
    };
};
exports.DeliveryZoneApiFactory = DeliveryZoneApiFactory;
var DeliveryZoneApi = (function (_super) {
    __extends(DeliveryZoneApi, _super);
    function DeliveryZoneApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    DeliveryZoneApi.prototype.addDeliveryZone = function (storeId, DeliveryZoneBase, options) {
        return (0, exports.DeliveryZoneApiFp)(this.configuration).addDeliveryZone(storeId, DeliveryZoneBase, options)(this.fetch, this.basePath);
    };
    DeliveryZoneApi.prototype.getDeliveryZones = function (storeId, options) {
        return (0, exports.DeliveryZoneApiFp)(this.configuration).getDeliveryZones(storeId, options)(this.fetch, this.basePath);
    };
    DeliveryZoneApi.prototype.removeDeliveryZone = function (storeId, deliveryZoneId, options) {
        return (0, exports.DeliveryZoneApiFp)(this.configuration).removeDeliveryZone(storeId, deliveryZoneId, options)(this.fetch, this.basePath);
    };
    DeliveryZoneApi.prototype.updateDeliveryZone = function (storeId, deliveryZoneId, DeliveryZoneBase, options) {
        return (0, exports.DeliveryZoneApiFp)(this.configuration).updateDeliveryZone(storeId, deliveryZoneId, DeliveryZoneBase, options)(this.fetch, this.basePath);
    };
    return DeliveryZoneApi;
}(BaseAPI));
exports.DeliveryZoneApi = DeliveryZoneApi;
var DeviceApiFetchParamCreator = function (configuration) {
    return {
        assignDevice: function (appId, ClientDeviceAssignEnrolledDevice, options) {
            if (options === void 0) { options = {}; }
            if (appId === null || appId === undefined) {
                throw new RequiredError('appId', 'Required parameter appId was null or undefined when calling assignDevice.');
            }
            if (ClientDeviceAssignEnrolledDevice === null || ClientDeviceAssignEnrolledDevice === undefined) {
                throw new RequiredError('ClientDeviceAssignEnrolledDevice', 'Required parameter ClientDeviceAssignEnrolledDevice was null or undefined when calling assignDevice.');
            }
            var localVarPath = "/api/v1.0/{appId}/devices/assign"
                .replace("{".concat("appId", "}"), encodeURIComponent(String(appId)));
            var localVarUrlObj = url.parse(localVarPath, true);
            var localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            var localVarHeaderParameter = {};
            var localVarQueryParameter = {};
            if (configuration && configuration.accessToken) {
                var localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("oauth2", ["api"])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }
            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            var needsSerialization = ("ClientDeviceAssignEnrolledDevice" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body = needsSerialization ? JSON.stringify(ClientDeviceAssignEnrolledDevice || {}) : (ClientDeviceAssignEnrolledDevice || "");
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        enrollDevice: function (appId, ClientDeviceEnroll, options) {
            if (options === void 0) { options = {}; }
            if (appId === null || appId === undefined) {
                throw new RequiredError('appId', 'Required parameter appId was null or undefined when calling enrollDevice.');
            }
            if (ClientDeviceEnroll === null || ClientDeviceEnroll === undefined) {
                throw new RequiredError('ClientDeviceEnroll', 'Required parameter ClientDeviceEnroll was null or undefined when calling enrollDevice.');
            }
            var localVarPath = "/api/v1.0/{appId}/devices/enroll"
                .replace("{".concat("appId", "}"), encodeURIComponent(String(appId)));
            var localVarUrlObj = url.parse(localVarPath, true);
            var localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            var localVarHeaderParameter = {};
            var localVarQueryParameter = {};
            if (configuration && configuration.accessToken) {
                var localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("oauth2", ["api"])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }
            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            var needsSerialization = ("ClientDeviceEnroll" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body = needsSerialization ? JSON.stringify(ClientDeviceEnroll || {}) : (ClientDeviceEnroll || "");
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        getDeviceDetails: function (appId, deviceModel, deviceId, options) {
            if (options === void 0) { options = {}; }
            if (appId === null || appId === undefined) {
                throw new RequiredError('appId', 'Required parameter appId was null or undefined when calling getDeviceDetails.');
            }
            if (deviceModel === null || deviceModel === undefined) {
                throw new RequiredError('deviceModel', 'Required parameter deviceModel was null or undefined when calling getDeviceDetails.');
            }
            if (deviceId === null || deviceId === undefined) {
                throw new RequiredError('deviceId', 'Required parameter deviceId was null or undefined when calling getDeviceDetails.');
            }
            var localVarPath = "/api/v1.0/{appId}/devices/device/{deviceModel}/{deviceId}"
                .replace("{".concat("appId", "}"), encodeURIComponent(String(appId)))
                .replace("{".concat("deviceModel", "}"), encodeURIComponent(String(deviceModel)))
                .replace("{".concat("deviceId", "}"), encodeURIComponent(String(deviceId)));
            var localVarUrlObj = url.parse(localVarPath, true);
            var localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            var localVarHeaderParameter = {};
            var localVarQueryParameter = {};
            if (configuration && configuration.accessToken) {
                var localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("oauth2", ["api"])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        searchDevices: function (appId, storeId, deviceModel, options) {
            if (options === void 0) { options = {}; }
            if (appId === null || appId === undefined) {
                throw new RequiredError('appId', 'Required parameter appId was null or undefined when calling searchDevices.');
            }
            var localVarPath = "/api/v1.0/{appId}/devices/search"
                .replace("{".concat("appId", "}"), encodeURIComponent(String(appId)));
            var localVarUrlObj = url.parse(localVarPath, true);
            var localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            var localVarHeaderParameter = {};
            var localVarQueryParameter = {};
            if (configuration && configuration.accessToken) {
                var localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("oauth2", ["api"])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }
            if (storeId !== undefined) {
                localVarQueryParameter['storeId'] = storeId;
            }
            if (deviceModel !== undefined) {
                localVarQueryParameter['deviceModel'] = deviceModel;
            }
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    };
};
exports.DeviceApiFetchParamCreator = DeviceApiFetchParamCreator;
var DeviceApiFp = function (configuration) {
    return {
        assignDevice: function (appId, ClientDeviceAssignEnrolledDevice, options) {
            var localVarFetchArgs = (0, exports.DeviceApiFetchParamCreator)(configuration).assignDevice(appId, ClientDeviceAssignEnrolledDevice, options);
            return function (fetch, basePath) {
                if (fetch === void 0) { fetch = portableFetch; }
                if (basePath === void 0) { basePath = BASE_PATH; }
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then(function (response) {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
        enrollDevice: function (appId, ClientDeviceEnroll, options) {
            var localVarFetchArgs = (0, exports.DeviceApiFetchParamCreator)(configuration).enrollDevice(appId, ClientDeviceEnroll, options);
            return function (fetch, basePath) {
                if (fetch === void 0) { fetch = portableFetch; }
                if (basePath === void 0) { basePath = BASE_PATH; }
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then(function (response) {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
        getDeviceDetails: function (appId, deviceModel, deviceId, options) {
            var localVarFetchArgs = (0, exports.DeviceApiFetchParamCreator)(configuration).getDeviceDetails(appId, deviceModel, deviceId, options);
            return function (fetch, basePath) {
                if (fetch === void 0) { fetch = portableFetch; }
                if (basePath === void 0) { basePath = BASE_PATH; }
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then(function (response) {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
        searchDevices: function (appId, storeId, deviceModel, options) {
            var localVarFetchArgs = (0, exports.DeviceApiFetchParamCreator)(configuration).searchDevices(appId, storeId, deviceModel, options);
            return function (fetch, basePath) {
                if (fetch === void 0) { fetch = portableFetch; }
                if (basePath === void 0) { basePath = BASE_PATH; }
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then(function (response) {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
    };
};
exports.DeviceApiFp = DeviceApiFp;
var DeviceApiFactory = function (configuration, fetch, basePath) {
    return {
        assignDevice: function (appId, ClientDeviceAssignEnrolledDevice, options) {
            return (0, exports.DeviceApiFp)(configuration).assignDevice(appId, ClientDeviceAssignEnrolledDevice, options)(fetch, basePath);
        },
        enrollDevice: function (appId, ClientDeviceEnroll, options) {
            return (0, exports.DeviceApiFp)(configuration).enrollDevice(appId, ClientDeviceEnroll, options)(fetch, basePath);
        },
        getDeviceDetails: function (appId, deviceModel, deviceId, options) {
            return (0, exports.DeviceApiFp)(configuration).getDeviceDetails(appId, deviceModel, deviceId, options)(fetch, basePath);
        },
        searchDevices: function (appId, storeId, deviceModel, options) {
            return (0, exports.DeviceApiFp)(configuration).searchDevices(appId, storeId, deviceModel, options)(fetch, basePath);
        },
    };
};
exports.DeviceApiFactory = DeviceApiFactory;
var DeviceApi = (function (_super) {
    __extends(DeviceApi, _super);
    function DeviceApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    DeviceApi.prototype.assignDevice = function (appId, ClientDeviceAssignEnrolledDevice, options) {
        return (0, exports.DeviceApiFp)(this.configuration).assignDevice(appId, ClientDeviceAssignEnrolledDevice, options)(this.fetch, this.basePath);
    };
    DeviceApi.prototype.enrollDevice = function (appId, ClientDeviceEnroll, options) {
        return (0, exports.DeviceApiFp)(this.configuration).enrollDevice(appId, ClientDeviceEnroll, options)(this.fetch, this.basePath);
    };
    DeviceApi.prototype.getDeviceDetails = function (appId, deviceModel, deviceId, options) {
        return (0, exports.DeviceApiFp)(this.configuration).getDeviceDetails(appId, deviceModel, deviceId, options)(this.fetch, this.basePath);
    };
    DeviceApi.prototype.searchDevices = function (appId, storeId, deviceModel, options) {
        return (0, exports.DeviceApiFp)(this.configuration).searchDevices(appId, storeId, deviceModel, options)(this.fetch, this.basePath);
    };
    return DeviceApi;
}(BaseAPI));
exports.DeviceApi = DeviceApi;
var DriversApiFetchParamCreator = function (configuration) {
    return {
        driversAddDriverNotificationToken: function (UpdateDriverNotificationToken, options) {
            if (options === void 0) { options = {}; }
            if (UpdateDriverNotificationToken === null || UpdateDriverNotificationToken === undefined) {
                throw new RequiredError('UpdateDriverNotificationToken', 'Required parameter UpdateDriverNotificationToken was null or undefined when calling driversAddDriverNotificationToken.');
            }
            var localVarPath = "/api/v1.0/drivers/token";
            var localVarUrlObj = url.parse(localVarPath, true);
            var localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            var localVarHeaderParameter = {};
            var localVarQueryParameter = {};
            if (configuration && configuration.accessToken) {
                var localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("oauth2", ["api"])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }
            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            var needsSerialization = ("UpdateDriverNotificationToken" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body = needsSerialization ? JSON.stringify(UpdateDriverNotificationToken || {}) : (UpdateDriverNotificationToken || "");
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        driversDeleteDriverProfileImage: function (options) {
            if (options === void 0) { options = {}; }
            var localVarPath = "/api/v1.0/drivers/profile/image";
            var localVarUrlObj = url.parse(localVarPath, true);
            var localVarRequestOptions = Object.assign({ method: 'DELETE' }, options);
            var localVarHeaderParameter = {};
            var localVarQueryParameter = {};
            if (configuration && configuration.accessToken) {
                var localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("oauth2", ["api"])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        driversDriverLogin: function (DriverLoginModel, options) {
            if (options === void 0) { options = {}; }
            if (DriverLoginModel === null || DriverLoginModel === undefined) {
                throw new RequiredError('DriverLoginModel', 'Required parameter DriverLoginModel was null or undefined when calling driversDriverLogin.');
            }
            var localVarPath = "/api/v1.0/drivers/login";
            var localVarUrlObj = url.parse(localVarPath, true);
            var localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            var localVarHeaderParameter = {};
            var localVarQueryParameter = {};
            if (configuration && configuration.accessToken) {
                var localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("oauth2", ["api"])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }
            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            var needsSerialization = ("DriverLoginModel" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body = needsSerialization ? JSON.stringify(DriverLoginModel || {}) : (DriverLoginModel || "");
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        driversDriverRequestLoginCodeSms: function (DriverRequestLoginPinModel, options) {
            if (options === void 0) { options = {}; }
            if (DriverRequestLoginPinModel === null || DriverRequestLoginPinModel === undefined) {
                throw new RequiredError('DriverRequestLoginPinModel', 'Required parameter DriverRequestLoginPinModel was null or undefined when calling driversDriverRequestLoginCodeSms.');
            }
            var localVarPath = "/api/v1.0/drivers/pin";
            var localVarUrlObj = url.parse(localVarPath, true);
            var localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            var localVarHeaderParameter = {};
            var localVarQueryParameter = {};
            if (configuration && configuration.accessToken) {
                var localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("oauth2", ["api"])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }
            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            var needsSerialization = ("DriverRequestLoginPinModel" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body = needsSerialization ? JSON.stringify(DriverRequestLoginPinModel || {}) : (DriverRequestLoginPinModel || "");
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        driversGetDriverProfile: function (options) {
            if (options === void 0) { options = {}; }
            var localVarPath = "/api/v1.0/drivers/profile";
            var localVarUrlObj = url.parse(localVarPath, true);
            var localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            var localVarHeaderParameter = {};
            var localVarQueryParameter = {};
            if (configuration && configuration.accessToken) {
                var localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("oauth2", ["api"])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        driversGetStoresForDriver: function (options) {
            if (options === void 0) { options = {}; }
            var localVarPath = "/api/v1.0/drivers/assignedstores";
            var localVarUrlObj = url.parse(localVarPath, true);
            var localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            var localVarHeaderParameter = {};
            var localVarQueryParameter = {};
            if (configuration && configuration.accessToken) {
                var localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("oauth2", ["api"])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        driversRemoveDriverNotificationToken: function (UpdateDriverNotificationToken, options) {
            if (options === void 0) { options = {}; }
            if (UpdateDriverNotificationToken === null || UpdateDriverNotificationToken === undefined) {
                throw new RequiredError('UpdateDriverNotificationToken', 'Required parameter UpdateDriverNotificationToken was null or undefined when calling driversRemoveDriverNotificationToken.');
            }
            var localVarPath = "/api/v1.0/drivers/token";
            var localVarUrlObj = url.parse(localVarPath, true);
            var localVarRequestOptions = Object.assign({ method: 'DELETE' }, options);
            var localVarHeaderParameter = {};
            var localVarQueryParameter = {};
            if (configuration && configuration.accessToken) {
                var localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("oauth2", ["api"])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }
            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            var needsSerialization = ("UpdateDriverNotificationToken" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body = needsSerialization ? JSON.stringify(UpdateDriverNotificationToken || {}) : (UpdateDriverNotificationToken || "");
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        driversSetDriverPresenceForStore: function (storeId, presence, options) {
            if (options === void 0) { options = {}; }
            if (storeId === null || storeId === undefined) {
                throw new RequiredError('storeId', 'Required parameter storeId was null or undefined when calling driversSetDriverPresenceForStore.');
            }
            if (presence === null || presence === undefined) {
                throw new RequiredError('presence', 'Required parameter presence was null or undefined when calling driversSetDriverPresenceForStore.');
            }
            var localVarPath = "/api/v1.0/drivers/stores/{storeId}/presence/{presence}"
                .replace("{".concat("storeId", "}"), encodeURIComponent(String(storeId)))
                .replace("{".concat("presence", "}"), encodeURIComponent(String(presence)));
            var localVarUrlObj = url.parse(localVarPath, true);
            var localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            var localVarHeaderParameter = {};
            var localVarQueryParameter = {};
            if (configuration && configuration.accessToken) {
                var localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("oauth2", ["api"])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        driversSetDriverProfileImage: function (options) {
            if (options === void 0) { options = {}; }
            var localVarPath = "/api/v1.0/drivers/profile/image";
            var localVarUrlObj = url.parse(localVarPath, true);
            var localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            var localVarHeaderParameter = {};
            var localVarQueryParameter = {};
            if (configuration && configuration.accessToken) {
                var localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("oauth2", ["api"])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        driversUpdateDeliveryTrackingStatus: function (orderId, deliveryTrackingStatus, options) {
            if (options === void 0) { options = {}; }
            if (orderId === null || orderId === undefined) {
                throw new RequiredError('orderId', 'Required parameter orderId was null or undefined when calling driversUpdateDeliveryTrackingStatus.');
            }
            if (deliveryTrackingStatus === null || deliveryTrackingStatus === undefined) {
                throw new RequiredError('deliveryTrackingStatus', 'Required parameter deliveryTrackingStatus was null or undefined when calling driversUpdateDeliveryTrackingStatus.');
            }
            var localVarPath = "/api/v1.0/orders/{orderId}/tracking/{deliveryTrackingStatus}"
                .replace("{".concat("orderId", "}"), encodeURIComponent(String(orderId)))
                .replace("{".concat("deliveryTrackingStatus", "}"), encodeURIComponent(String(deliveryTrackingStatus)));
            var localVarUrlObj = url.parse(localVarPath, true);
            var localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            var localVarHeaderParameter = {};
            var localVarQueryParameter = {};
            if (configuration && configuration.accessToken) {
                var localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("oauth2", ["api"])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        driversUpdateDriverProfile: function (UpdateDriverProfileModel, options) {
            if (options === void 0) { options = {}; }
            if (UpdateDriverProfileModel === null || UpdateDriverProfileModel === undefined) {
                throw new RequiredError('UpdateDriverProfileModel', 'Required parameter UpdateDriverProfileModel was null or undefined when calling driversUpdateDriverProfile.');
            }
            var localVarPath = "/api/v1.0/drivers/profile";
            var localVarUrlObj = url.parse(localVarPath, true);
            var localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            var localVarHeaderParameter = {};
            var localVarQueryParameter = {};
            if (configuration && configuration.accessToken) {
                var localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("oauth2", ["api"])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }
            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            var needsSerialization = ("UpdateDriverProfileModel" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body = needsSerialization ? JSON.stringify(UpdateDriverProfileModel || {}) : (UpdateDriverProfileModel || "");
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    };
};
exports.DriversApiFetchParamCreator = DriversApiFetchParamCreator;
var DriversApiFp = function (configuration) {
    return {
        driversAddDriverNotificationToken: function (UpdateDriverNotificationToken, options) {
            var localVarFetchArgs = (0, exports.DriversApiFetchParamCreator)(configuration).driversAddDriverNotificationToken(UpdateDriverNotificationToken, options);
            return function (fetch, basePath) {
                if (fetch === void 0) { fetch = portableFetch; }
                if (basePath === void 0) { basePath = BASE_PATH; }
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then(function (response) {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
        driversDeleteDriverProfileImage: function (options) {
            var localVarFetchArgs = (0, exports.DriversApiFetchParamCreator)(configuration).driversDeleteDriverProfileImage(options);
            return function (fetch, basePath) {
                if (fetch === void 0) { fetch = portableFetch; }
                if (basePath === void 0) { basePath = BASE_PATH; }
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then(function (response) {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
        driversDriverLogin: function (DriverLoginModel, options) {
            var localVarFetchArgs = (0, exports.DriversApiFetchParamCreator)(configuration).driversDriverLogin(DriverLoginModel, options);
            return function (fetch, basePath) {
                if (fetch === void 0) { fetch = portableFetch; }
                if (basePath === void 0) { basePath = BASE_PATH; }
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then(function (response) {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
        driversDriverRequestLoginCodeSms: function (DriverRequestLoginPinModel, options) {
            var localVarFetchArgs = (0, exports.DriversApiFetchParamCreator)(configuration).driversDriverRequestLoginCodeSms(DriverRequestLoginPinModel, options);
            return function (fetch, basePath) {
                if (fetch === void 0) { fetch = portableFetch; }
                if (basePath === void 0) { basePath = BASE_PATH; }
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then(function (response) {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
        driversGetDriverProfile: function (options) {
            var localVarFetchArgs = (0, exports.DriversApiFetchParamCreator)(configuration).driversGetDriverProfile(options);
            return function (fetch, basePath) {
                if (fetch === void 0) { fetch = portableFetch; }
                if (basePath === void 0) { basePath = BASE_PATH; }
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then(function (response) {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
        driversGetStoresForDriver: function (options) {
            var localVarFetchArgs = (0, exports.DriversApiFetchParamCreator)(configuration).driversGetStoresForDriver(options);
            return function (fetch, basePath) {
                if (fetch === void 0) { fetch = portableFetch; }
                if (basePath === void 0) { basePath = BASE_PATH; }
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then(function (response) {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
        driversRemoveDriverNotificationToken: function (UpdateDriverNotificationToken, options) {
            var localVarFetchArgs = (0, exports.DriversApiFetchParamCreator)(configuration).driversRemoveDriverNotificationToken(UpdateDriverNotificationToken, options);
            return function (fetch, basePath) {
                if (fetch === void 0) { fetch = portableFetch; }
                if (basePath === void 0) { basePath = BASE_PATH; }
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then(function (response) {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
        driversSetDriverPresenceForStore: function (storeId, presence, options) {
            var localVarFetchArgs = (0, exports.DriversApiFetchParamCreator)(configuration).driversSetDriverPresenceForStore(storeId, presence, options);
            return function (fetch, basePath) {
                if (fetch === void 0) { fetch = portableFetch; }
                if (basePath === void 0) { basePath = BASE_PATH; }
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then(function (response) {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
        driversSetDriverProfileImage: function (options) {
            var localVarFetchArgs = (0, exports.DriversApiFetchParamCreator)(configuration).driversSetDriverProfileImage(options);
            return function (fetch, basePath) {
                if (fetch === void 0) { fetch = portableFetch; }
                if (basePath === void 0) { basePath = BASE_PATH; }
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then(function (response) {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
        driversUpdateDeliveryTrackingStatus: function (orderId, deliveryTrackingStatus, options) {
            var localVarFetchArgs = (0, exports.DriversApiFetchParamCreator)(configuration).driversUpdateDeliveryTrackingStatus(orderId, deliveryTrackingStatus, options);
            return function (fetch, basePath) {
                if (fetch === void 0) { fetch = portableFetch; }
                if (basePath === void 0) { basePath = BASE_PATH; }
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then(function (response) {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
        driversUpdateDriverProfile: function (UpdateDriverProfileModel, options) {
            var localVarFetchArgs = (0, exports.DriversApiFetchParamCreator)(configuration).driversUpdateDriverProfile(UpdateDriverProfileModel, options);
            return function (fetch, basePath) {
                if (fetch === void 0) { fetch = portableFetch; }
                if (basePath === void 0) { basePath = BASE_PATH; }
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then(function (response) {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
    };
};
exports.DriversApiFp = DriversApiFp;
var DriversApiFactory = function (configuration, fetch, basePath) {
    return {
        driversAddDriverNotificationToken: function (UpdateDriverNotificationToken, options) {
            return (0, exports.DriversApiFp)(configuration).driversAddDriverNotificationToken(UpdateDriverNotificationToken, options)(fetch, basePath);
        },
        driversDeleteDriverProfileImage: function (options) {
            return (0, exports.DriversApiFp)(configuration).driversDeleteDriverProfileImage(options)(fetch, basePath);
        },
        driversDriverLogin: function (DriverLoginModel, options) {
            return (0, exports.DriversApiFp)(configuration).driversDriverLogin(DriverLoginModel, options)(fetch, basePath);
        },
        driversDriverRequestLoginCodeSms: function (DriverRequestLoginPinModel, options) {
            return (0, exports.DriversApiFp)(configuration).driversDriverRequestLoginCodeSms(DriverRequestLoginPinModel, options)(fetch, basePath);
        },
        driversGetDriverProfile: function (options) {
            return (0, exports.DriversApiFp)(configuration).driversGetDriverProfile(options)(fetch, basePath);
        },
        driversGetStoresForDriver: function (options) {
            return (0, exports.DriversApiFp)(configuration).driversGetStoresForDriver(options)(fetch, basePath);
        },
        driversRemoveDriverNotificationToken: function (UpdateDriverNotificationToken, options) {
            return (0, exports.DriversApiFp)(configuration).driversRemoveDriverNotificationToken(UpdateDriverNotificationToken, options)(fetch, basePath);
        },
        driversSetDriverPresenceForStore: function (storeId, presence, options) {
            return (0, exports.DriversApiFp)(configuration).driversSetDriverPresenceForStore(storeId, presence, options)(fetch, basePath);
        },
        driversSetDriverProfileImage: function (options) {
            return (0, exports.DriversApiFp)(configuration).driversSetDriverProfileImage(options)(fetch, basePath);
        },
        driversUpdateDeliveryTrackingStatus: function (orderId, deliveryTrackingStatus, options) {
            return (0, exports.DriversApiFp)(configuration).driversUpdateDeliveryTrackingStatus(orderId, deliveryTrackingStatus, options)(fetch, basePath);
        },
        driversUpdateDriverProfile: function (UpdateDriverProfileModel, options) {
            return (0, exports.DriversApiFp)(configuration).driversUpdateDriverProfile(UpdateDriverProfileModel, options)(fetch, basePath);
        },
    };
};
exports.DriversApiFactory = DriversApiFactory;
var DriversApi = (function (_super) {
    __extends(DriversApi, _super);
    function DriversApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    DriversApi.prototype.driversAddDriverNotificationToken = function (UpdateDriverNotificationToken, options) {
        return (0, exports.DriversApiFp)(this.configuration).driversAddDriverNotificationToken(UpdateDriverNotificationToken, options)(this.fetch, this.basePath);
    };
    DriversApi.prototype.driversDeleteDriverProfileImage = function (options) {
        return (0, exports.DriversApiFp)(this.configuration).driversDeleteDriverProfileImage(options)(this.fetch, this.basePath);
    };
    DriversApi.prototype.driversDriverLogin = function (DriverLoginModel, options) {
        return (0, exports.DriversApiFp)(this.configuration).driversDriverLogin(DriverLoginModel, options)(this.fetch, this.basePath);
    };
    DriversApi.prototype.driversDriverRequestLoginCodeSms = function (DriverRequestLoginPinModel, options) {
        return (0, exports.DriversApiFp)(this.configuration).driversDriverRequestLoginCodeSms(DriverRequestLoginPinModel, options)(this.fetch, this.basePath);
    };
    DriversApi.prototype.driversGetDriverProfile = function (options) {
        return (0, exports.DriversApiFp)(this.configuration).driversGetDriverProfile(options)(this.fetch, this.basePath);
    };
    DriversApi.prototype.driversGetStoresForDriver = function (options) {
        return (0, exports.DriversApiFp)(this.configuration).driversGetStoresForDriver(options)(this.fetch, this.basePath);
    };
    DriversApi.prototype.driversRemoveDriverNotificationToken = function (UpdateDriverNotificationToken, options) {
        return (0, exports.DriversApiFp)(this.configuration).driversRemoveDriverNotificationToken(UpdateDriverNotificationToken, options)(this.fetch, this.basePath);
    };
    DriversApi.prototype.driversSetDriverPresenceForStore = function (storeId, presence, options) {
        return (0, exports.DriversApiFp)(this.configuration).driversSetDriverPresenceForStore(storeId, presence, options)(this.fetch, this.basePath);
    };
    DriversApi.prototype.driversSetDriverProfileImage = function (options) {
        return (0, exports.DriversApiFp)(this.configuration).driversSetDriverProfileImage(options)(this.fetch, this.basePath);
    };
    DriversApi.prototype.driversUpdateDeliveryTrackingStatus = function (orderId, deliveryTrackingStatus, options) {
        return (0, exports.DriversApiFp)(this.configuration).driversUpdateDeliveryTrackingStatus(orderId, deliveryTrackingStatus, options)(this.fetch, this.basePath);
    };
    DriversApi.prototype.driversUpdateDriverProfile = function (UpdateDriverProfileModel, options) {
        return (0, exports.DriversApiFp)(this.configuration).driversUpdateDriverProfile(UpdateDriverProfileModel, options)(this.fetch, this.basePath);
    };
    return DriversApi;
}(BaseAPI));
exports.DriversApi = DriversApi;
var EndUserFeesApiFetchParamCreator = function (configuration) {
    return {
        createEndUserFeeConfig: function (appId, storeId, CreateEndUserFeeConfig, options) {
            if (options === void 0) { options = {}; }
            if (appId === null || appId === undefined) {
                throw new RequiredError('appId', 'Required parameter appId was null or undefined when calling createEndUserFeeConfig.');
            }
            if (storeId === null || storeId === undefined) {
                throw new RequiredError('storeId', 'Required parameter storeId was null or undefined when calling createEndUserFeeConfig.');
            }
            if (CreateEndUserFeeConfig === null || CreateEndUserFeeConfig === undefined) {
                throw new RequiredError('CreateEndUserFeeConfig', 'Required parameter CreateEndUserFeeConfig was null or undefined when calling createEndUserFeeConfig.');
            }
            var localVarPath = "/api/v1.0/{appId}/stores/{storeId}/end-user-fees"
                .replace("{".concat("appId", "}"), encodeURIComponent(String(appId)))
                .replace("{".concat("storeId", "}"), encodeURIComponent(String(storeId)));
            var localVarUrlObj = url.parse(localVarPath, true);
            var localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            var localVarHeaderParameter = {};
            var localVarQueryParameter = {};
            if (configuration && configuration.accessToken) {
                var localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("oauth2", ["api"])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }
            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            var needsSerialization = ("CreateEndUserFeeConfig" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body = needsSerialization ? JSON.stringify(CreateEndUserFeeConfig || {}) : (CreateEndUserFeeConfig || "");
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        getEndUserFeesForStore: function (appId, storeId, options) {
            if (options === void 0) { options = {}; }
            if (appId === null || appId === undefined) {
                throw new RequiredError('appId', 'Required parameter appId was null or undefined when calling getEndUserFeesForStore.');
            }
            if (storeId === null || storeId === undefined) {
                throw new RequiredError('storeId', 'Required parameter storeId was null or undefined when calling getEndUserFeesForStore.');
            }
            var localVarPath = "/api/v1.0/{appId}/stores/{storeId}/end-user-fees"
                .replace("{".concat("appId", "}"), encodeURIComponent(String(appId)))
                .replace("{".concat("storeId", "}"), encodeURIComponent(String(storeId)));
            var localVarUrlObj = url.parse(localVarPath, true);
            var localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            var localVarHeaderParameter = {};
            var localVarQueryParameter = {};
            if (configuration && configuration.accessToken) {
                var localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("oauth2", ["api"])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        setV2FeeCalculation: function (appId, storeId, SetV2FeeCalculationRequest, options) {
            if (options === void 0) { options = {}; }
            if (appId === null || appId === undefined) {
                throw new RequiredError('appId', 'Required parameter appId was null or undefined when calling setV2FeeCalculation.');
            }
            if (storeId === null || storeId === undefined) {
                throw new RequiredError('storeId', 'Required parameter storeId was null or undefined when calling setV2FeeCalculation.');
            }
            if (SetV2FeeCalculationRequest === null || SetV2FeeCalculationRequest === undefined) {
                throw new RequiredError('SetV2FeeCalculationRequest', 'Required parameter SetV2FeeCalculationRequest was null or undefined when calling setV2FeeCalculation.');
            }
            var localVarPath = "/api/v1.0/{appId}/stores/{storeId}/end-user-fees/v2-fee-calculation"
                .replace("{".concat("appId", "}"), encodeURIComponent(String(appId)))
                .replace("{".concat("storeId", "}"), encodeURIComponent(String(storeId)));
            var localVarUrlObj = url.parse(localVarPath, true);
            var localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            var localVarHeaderParameter = {};
            var localVarQueryParameter = {};
            if (configuration && configuration.accessToken) {
                var localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("oauth2", ["api"])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }
            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            var needsSerialization = ("SetV2FeeCalculationRequest" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body = needsSerialization ? JSON.stringify(SetV2FeeCalculationRequest || {}) : (SetV2FeeCalculationRequest || "");
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    };
};
exports.EndUserFeesApiFetchParamCreator = EndUserFeesApiFetchParamCreator;
var EndUserFeesApiFp = function (configuration) {
    return {
        createEndUserFeeConfig: function (appId, storeId, CreateEndUserFeeConfig, options) {
            var localVarFetchArgs = (0, exports.EndUserFeesApiFetchParamCreator)(configuration).createEndUserFeeConfig(appId, storeId, CreateEndUserFeeConfig, options);
            return function (fetch, basePath) {
                if (fetch === void 0) { fetch = portableFetch; }
                if (basePath === void 0) { basePath = BASE_PATH; }
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then(function (response) {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
        getEndUserFeesForStore: function (appId, storeId, options) {
            var localVarFetchArgs = (0, exports.EndUserFeesApiFetchParamCreator)(configuration).getEndUserFeesForStore(appId, storeId, options);
            return function (fetch, basePath) {
                if (fetch === void 0) { fetch = portableFetch; }
                if (basePath === void 0) { basePath = BASE_PATH; }
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then(function (response) {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
        setV2FeeCalculation: function (appId, storeId, SetV2FeeCalculationRequest, options) {
            var localVarFetchArgs = (0, exports.EndUserFeesApiFetchParamCreator)(configuration).setV2FeeCalculation(appId, storeId, SetV2FeeCalculationRequest, options);
            return function (fetch, basePath) {
                if (fetch === void 0) { fetch = portableFetch; }
                if (basePath === void 0) { basePath = BASE_PATH; }
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then(function (response) {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
    };
};
exports.EndUserFeesApiFp = EndUserFeesApiFp;
var EndUserFeesApiFactory = function (configuration, fetch, basePath) {
    return {
        createEndUserFeeConfig: function (appId, storeId, CreateEndUserFeeConfig, options) {
            return (0, exports.EndUserFeesApiFp)(configuration).createEndUserFeeConfig(appId, storeId, CreateEndUserFeeConfig, options)(fetch, basePath);
        },
        getEndUserFeesForStore: function (appId, storeId, options) {
            return (0, exports.EndUserFeesApiFp)(configuration).getEndUserFeesForStore(appId, storeId, options)(fetch, basePath);
        },
        setV2FeeCalculation: function (appId, storeId, SetV2FeeCalculationRequest, options) {
            return (0, exports.EndUserFeesApiFp)(configuration).setV2FeeCalculation(appId, storeId, SetV2FeeCalculationRequest, options)(fetch, basePath);
        },
    };
};
exports.EndUserFeesApiFactory = EndUserFeesApiFactory;
var EndUserFeesApi = (function (_super) {
    __extends(EndUserFeesApi, _super);
    function EndUserFeesApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    EndUserFeesApi.prototype.createEndUserFeeConfig = function (appId, storeId, CreateEndUserFeeConfig, options) {
        return (0, exports.EndUserFeesApiFp)(this.configuration).createEndUserFeeConfig(appId, storeId, CreateEndUserFeeConfig, options)(this.fetch, this.basePath);
    };
    EndUserFeesApi.prototype.getEndUserFeesForStore = function (appId, storeId, options) {
        return (0, exports.EndUserFeesApiFp)(this.configuration).getEndUserFeesForStore(appId, storeId, options)(this.fetch, this.basePath);
    };
    EndUserFeesApi.prototype.setV2FeeCalculation = function (appId, storeId, SetV2FeeCalculationRequest, options) {
        return (0, exports.EndUserFeesApiFp)(this.configuration).setV2FeeCalculation(appId, storeId, SetV2FeeCalculationRequest, options)(this.fetch, this.basePath);
    };
    return EndUserFeesApi;
}(BaseAPI));
exports.EndUserFeesApi = EndUserFeesApi;
var EventsApiFetchParamCreator = function (configuration) {
    return {
        getCustomerEvents: function (appId, customerId, limit, page, start, end, orderId, storeId, storeIdList, storeGroupId, userId, menuId, campaignId, userEmail, userName, voucherCode, eventType, flipdishEventId, options) {
            if (options === void 0) { options = {}; }
            if (appId === null || appId === undefined) {
                throw new RequiredError('appId', 'Required parameter appId was null or undefined when calling getCustomerEvents.');
            }
            if (customerId === null || customerId === undefined) {
                throw new RequiredError('customerId', 'Required parameter customerId was null or undefined when calling getCustomerEvents.');
            }
            var localVarPath = "/api/v1.0/{appId}/events/customer/{customerId}"
                .replace("{".concat("appId", "}"), encodeURIComponent(String(appId)))
                .replace("{".concat("customerId", "}"), encodeURIComponent(String(customerId)));
            var localVarUrlObj = url.parse(localVarPath, true);
            var localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            var localVarHeaderParameter = {};
            var localVarQueryParameter = {};
            if (configuration && configuration.accessToken) {
                var localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("oauth2", ["api"])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }
            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }
            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }
            if (start !== undefined) {
                localVarQueryParameter['start'] = start;
            }
            if (end !== undefined) {
                localVarQueryParameter['end'] = end;
            }
            if (orderId !== undefined) {
                localVarQueryParameter['orderId'] = orderId;
            }
            if (storeId !== undefined) {
                localVarQueryParameter['storeId'] = storeId;
            }
            if (storeIdList) {
                localVarQueryParameter['storeIdList'] = storeIdList;
            }
            if (storeGroupId !== undefined) {
                localVarQueryParameter['storeGroupId'] = storeGroupId;
            }
            if (userId !== undefined) {
                localVarQueryParameter['userId'] = userId;
            }
            if (menuId !== undefined) {
                localVarQueryParameter['menuId'] = menuId;
            }
            if (campaignId !== undefined) {
                localVarQueryParameter['campaignId'] = campaignId;
            }
            if (userEmail !== undefined) {
                localVarQueryParameter['userEmail'] = userEmail;
            }
            if (userName !== undefined) {
                localVarQueryParameter['userName'] = userName;
            }
            if (voucherCode !== undefined) {
                localVarQueryParameter['voucherCode'] = voucherCode;
            }
            if (eventType) {
                localVarQueryParameter['eventType'] = eventType;
            }
            if (flipdishEventId !== undefined) {
                localVarQueryParameter['flipdishEventId'] = flipdishEventId;
            }
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        getEvents: function (appId, whiteLabelId, customerId, limit, page, start, end, orderId, storeId, storeIdList, storeGroupId, userId, menuId, campaignId, userEmail, userName, voucherCode, eventType, flipdishEventId, options) {
            if (options === void 0) { options = {}; }
            if (appId === null || appId === undefined) {
                throw new RequiredError('appId', 'Required parameter appId was null or undefined when calling getEvents.');
            }
            var localVarPath = "/api/v1.0/{appId}/events"
                .replace("{".concat("appId", "}"), encodeURIComponent(String(appId)));
            var localVarUrlObj = url.parse(localVarPath, true);
            var localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            var localVarHeaderParameter = {};
            var localVarQueryParameter = {};
            if (configuration && configuration.accessToken) {
                var localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("oauth2", ["api"])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }
            if (whiteLabelId !== undefined) {
                localVarQueryParameter['whiteLabelId'] = whiteLabelId;
            }
            if (customerId !== undefined) {
                localVarQueryParameter['customerId'] = customerId;
            }
            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }
            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }
            if (start !== undefined) {
                localVarQueryParameter['start'] = start;
            }
            if (end !== undefined) {
                localVarQueryParameter['end'] = end;
            }
            if (orderId !== undefined) {
                localVarQueryParameter['orderId'] = orderId;
            }
            if (storeId !== undefined) {
                localVarQueryParameter['storeId'] = storeId;
            }
            if (storeIdList) {
                localVarQueryParameter['storeIdList'] = storeIdList;
            }
            if (storeGroupId !== undefined) {
                localVarQueryParameter['storeGroupId'] = storeGroupId;
            }
            if (userId !== undefined) {
                localVarQueryParameter['userId'] = userId;
            }
            if (menuId !== undefined) {
                localVarQueryParameter['menuId'] = menuId;
            }
            if (campaignId !== undefined) {
                localVarQueryParameter['campaignId'] = campaignId;
            }
            if (userEmail !== undefined) {
                localVarQueryParameter['userEmail'] = userEmail;
            }
            if (userName !== undefined) {
                localVarQueryParameter['userName'] = userName;
            }
            if (voucherCode !== undefined) {
                localVarQueryParameter['voucherCode'] = voucherCode;
            }
            if (eventType) {
                localVarQueryParameter['eventType'] = eventType;
            }
            if (flipdishEventId !== undefined) {
                localVarQueryParameter['flipdishEventId'] = flipdishEventId;
            }
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        getEventsById: function (eventId, appId, options) {
            if (options === void 0) { options = {}; }
            if (eventId === null || eventId === undefined) {
                throw new RequiredError('eventId', 'Required parameter eventId was null or undefined when calling getEventsById.');
            }
            if (appId === null || appId === undefined) {
                throw new RequiredError('appId', 'Required parameter appId was null or undefined when calling getEventsById.');
            }
            var localVarPath = "/api/v1.0/{appId}/events/{eventId}"
                .replace("{".concat("eventId", "}"), encodeURIComponent(String(eventId)))
                .replace("{".concat("appId", "}"), encodeURIComponent(String(appId)));
            var localVarUrlObj = url.parse(localVarPath, true);
            var localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            var localVarHeaderParameter = {};
            var localVarQueryParameter = {};
            if (configuration && configuration.accessToken) {
                var localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("oauth2", ["api"])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        getMenuEvents: function (appId, menuId2, limit, page, start, end, orderId, storeId, storeIdList, storeGroupId, userId, menuId, campaignId, userEmail, userName, voucherCode, eventType, flipdishEventId, options) {
            if (options === void 0) { options = {}; }
            if (appId === null || appId === undefined) {
                throw new RequiredError('appId', 'Required parameter appId was null or undefined when calling getMenuEvents.');
            }
            if (menuId2 === null || menuId2 === undefined) {
                throw new RequiredError('menuId2', 'Required parameter menuId2 was null or undefined when calling getMenuEvents.');
            }
            var localVarPath = "/api/v1.0/{appId}/events/menu/{menuId}"
                .replace("{".concat("appId", "}"), encodeURIComponent(String(appId)))
                .replace("{".concat("menuId", "}"), encodeURIComponent(String(menuId)));
            var localVarUrlObj = url.parse(localVarPath, true);
            var localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            var localVarHeaderParameter = {};
            var localVarQueryParameter = {};
            if (configuration && configuration.accessToken) {
                var localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("oauth2", ["api"])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }
            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }
            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }
            if (start !== undefined) {
                localVarQueryParameter['start'] = start;
            }
            if (end !== undefined) {
                localVarQueryParameter['end'] = end;
            }
            if (orderId !== undefined) {
                localVarQueryParameter['orderId'] = orderId;
            }
            if (storeId !== undefined) {
                localVarQueryParameter['storeId'] = storeId;
            }
            if (storeIdList) {
                localVarQueryParameter['storeIdList'] = storeIdList;
            }
            if (storeGroupId !== undefined) {
                localVarQueryParameter['storeGroupId'] = storeGroupId;
            }
            if (userId !== undefined) {
                localVarQueryParameter['userId'] = userId;
            }
            if (menuId !== undefined) {
                localVarQueryParameter['menuId'] = menuId;
            }
            if (campaignId !== undefined) {
                localVarQueryParameter['campaignId'] = campaignId;
            }
            if (userEmail !== undefined) {
                localVarQueryParameter['userEmail'] = userEmail;
            }
            if (userName !== undefined) {
                localVarQueryParameter['userName'] = userName;
            }
            if (voucherCode !== undefined) {
                localVarQueryParameter['voucherCode'] = voucherCode;
            }
            if (eventType) {
                localVarQueryParameter['eventType'] = eventType;
            }
            if (flipdishEventId !== undefined) {
                localVarQueryParameter['flipdishEventId'] = flipdishEventId;
            }
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        getOrderEvents: function (appId, orderId2, limit, page, start, end, orderId, storeId, storeIdList, storeGroupId, userId, menuId, campaignId, userEmail, userName, voucherCode, eventType, flipdishEventId, options) {
            if (options === void 0) { options = {}; }
            if (appId === null || appId === undefined) {
                throw new RequiredError('appId', 'Required parameter appId was null or undefined when calling getOrderEvents.');
            }
            if (orderId2 === null || orderId2 === undefined) {
                throw new RequiredError('orderId2', 'Required parameter orderId2 was null or undefined when calling getOrderEvents.');
            }
            var localVarPath = "/api/v1.0/{appId}/events/order/{orderId}"
                .replace("{".concat("appId", "}"), encodeURIComponent(String(appId)))
                .replace("{".concat("orderId", "}"), encodeURIComponent(String(orderId)));
            var localVarUrlObj = url.parse(localVarPath, true);
            var localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            var localVarHeaderParameter = {};
            var localVarQueryParameter = {};
            if (configuration && configuration.accessToken) {
                var localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("oauth2", ["api"])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }
            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }
            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }
            if (start !== undefined) {
                localVarQueryParameter['start'] = start;
            }
            if (end !== undefined) {
                localVarQueryParameter['end'] = end;
            }
            if (orderId !== undefined) {
                localVarQueryParameter['orderId'] = orderId;
            }
            if (storeId !== undefined) {
                localVarQueryParameter['storeId'] = storeId;
            }
            if (storeIdList) {
                localVarQueryParameter['storeIdList'] = storeIdList;
            }
            if (storeGroupId !== undefined) {
                localVarQueryParameter['storeGroupId'] = storeGroupId;
            }
            if (userId !== undefined) {
                localVarQueryParameter['userId'] = userId;
            }
            if (menuId !== undefined) {
                localVarQueryParameter['menuId'] = menuId;
            }
            if (campaignId !== undefined) {
                localVarQueryParameter['campaignId'] = campaignId;
            }
            if (userEmail !== undefined) {
                localVarQueryParameter['userEmail'] = userEmail;
            }
            if (userName !== undefined) {
                localVarQueryParameter['userName'] = userName;
            }
            if (voucherCode !== undefined) {
                localVarQueryParameter['voucherCode'] = voucherCode;
            }
            if (eventType) {
                localVarQueryParameter['eventType'] = eventType;
            }
            if (flipdishEventId !== undefined) {
                localVarQueryParameter['flipdishEventId'] = flipdishEventId;
            }
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        getOrderEventsByCustomer: function (appId, customerId, limit, page, start, end, orderId, storeId, storeIdList, storeGroupId, userId, menuId, campaignId, userEmail, userName, voucherCode, eventType, flipdishEventId, options) {
            if (options === void 0) { options = {}; }
            if (appId === null || appId === undefined) {
                throw new RequiredError('appId', 'Required parameter appId was null or undefined when calling getOrderEventsByCustomer.');
            }
            if (customerId === null || customerId === undefined) {
                throw new RequiredError('customerId', 'Required parameter customerId was null or undefined when calling getOrderEventsByCustomer.');
            }
            var localVarPath = "/api/v1.0/{appId}/events/order"
                .replace("{".concat("appId", "}"), encodeURIComponent(String(appId)));
            var localVarUrlObj = url.parse(localVarPath, true);
            var localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            var localVarHeaderParameter = {};
            var localVarQueryParameter = {};
            if (configuration && configuration.accessToken) {
                var localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("oauth2", ["api"])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }
            if (customerId !== undefined) {
                localVarQueryParameter['customerId'] = customerId;
            }
            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }
            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }
            if (start !== undefined) {
                localVarQueryParameter['start'] = start;
            }
            if (end !== undefined) {
                localVarQueryParameter['end'] = end;
            }
            if (orderId !== undefined) {
                localVarQueryParameter['orderId'] = orderId;
            }
            if (storeId !== undefined) {
                localVarQueryParameter['storeId'] = storeId;
            }
            if (storeIdList) {
                localVarQueryParameter['storeIdList'] = storeIdList;
            }
            if (storeGroupId !== undefined) {
                localVarQueryParameter['storeGroupId'] = storeGroupId;
            }
            if (userId !== undefined) {
                localVarQueryParameter['userId'] = userId;
            }
            if (menuId !== undefined) {
                localVarQueryParameter['menuId'] = menuId;
            }
            if (campaignId !== undefined) {
                localVarQueryParameter['campaignId'] = campaignId;
            }
            if (userEmail !== undefined) {
                localVarQueryParameter['userEmail'] = userEmail;
            }
            if (userName !== undefined) {
                localVarQueryParameter['userName'] = userName;
            }
            if (voucherCode !== undefined) {
                localVarQueryParameter['voucherCode'] = voucherCode;
            }
            if (eventType) {
                localVarQueryParameter['eventType'] = eventType;
            }
            if (flipdishEventId !== undefined) {
                localVarQueryParameter['flipdishEventId'] = flipdishEventId;
            }
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        getStoreEvents: function (appId, storeId2, limit, page, start, end, orderId, storeId, storeIdList, storeGroupId, userId, menuId, campaignId, userEmail, userName, voucherCode, eventType, flipdishEventId, options) {
            if (options === void 0) { options = {}; }
            if (appId === null || appId === undefined) {
                throw new RequiredError('appId', 'Required parameter appId was null or undefined when calling getStoreEvents.');
            }
            if (storeId2 === null || storeId2 === undefined) {
                throw new RequiredError('storeId2', 'Required parameter storeId2 was null or undefined when calling getStoreEvents.');
            }
            var localVarPath = "/api/v1.0/{appId}/events/store/{storeId}"
                .replace("{".concat("appId", "}"), encodeURIComponent(String(appId)))
                .replace("{".concat("storeId", "}"), encodeURIComponent(String(storeId)));
            var localVarUrlObj = url.parse(localVarPath, true);
            var localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            var localVarHeaderParameter = {};
            var localVarQueryParameter = {};
            if (configuration && configuration.accessToken) {
                var localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("oauth2", ["api"])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }
            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }
            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }
            if (start !== undefined) {
                localVarQueryParameter['start'] = start;
            }
            if (end !== undefined) {
                localVarQueryParameter['end'] = end;
            }
            if (orderId !== undefined) {
                localVarQueryParameter['orderId'] = orderId;
            }
            if (storeId !== undefined) {
                localVarQueryParameter['storeId'] = storeId;
            }
            if (storeIdList) {
                localVarQueryParameter['storeIdList'] = storeIdList;
            }
            if (storeGroupId !== undefined) {
                localVarQueryParameter['storeGroupId'] = storeGroupId;
            }
            if (userId !== undefined) {
                localVarQueryParameter['userId'] = userId;
            }
            if (menuId !== undefined) {
                localVarQueryParameter['menuId'] = menuId;
            }
            if (campaignId !== undefined) {
                localVarQueryParameter['campaignId'] = campaignId;
            }
            if (userEmail !== undefined) {
                localVarQueryParameter['userEmail'] = userEmail;
            }
            if (userName !== undefined) {
                localVarQueryParameter['userName'] = userName;
            }
            if (voucherCode !== undefined) {
                localVarQueryParameter['voucherCode'] = voucherCode;
            }
            if (eventType) {
                localVarQueryParameter['eventType'] = eventType;
            }
            if (flipdishEventId !== undefined) {
                localVarQueryParameter['flipdishEventId'] = flipdishEventId;
            }
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        getUserEvents: function (appId, userId2, limit, page, start, end, orderId, storeId, storeIdList, storeGroupId, userId, menuId, campaignId, userEmail, userName, voucherCode, eventType, flipdishEventId, options) {
            if (options === void 0) { options = {}; }
            if (appId === null || appId === undefined) {
                throw new RequiredError('appId', 'Required parameter appId was null or undefined when calling getUserEvents.');
            }
            if (userId2 === null || userId2 === undefined) {
                throw new RequiredError('userId2', 'Required parameter userId2 was null or undefined when calling getUserEvents.');
            }
            var localVarPath = "/api/v1.0/{appId}/events/user/{userId}"
                .replace("{".concat("appId", "}"), encodeURIComponent(String(appId)))
                .replace("{".concat("userId", "}"), encodeURIComponent(String(userId)));
            var localVarUrlObj = url.parse(localVarPath, true);
            var localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            var localVarHeaderParameter = {};
            var localVarQueryParameter = {};
            if (configuration && configuration.accessToken) {
                var localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("oauth2", ["api"])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }
            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }
            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }
            if (start !== undefined) {
                localVarQueryParameter['start'] = start;
            }
            if (end !== undefined) {
                localVarQueryParameter['end'] = end;
            }
            if (orderId !== undefined) {
                localVarQueryParameter['orderId'] = orderId;
            }
            if (storeId !== undefined) {
                localVarQueryParameter['storeId'] = storeId;
            }
            if (storeIdList) {
                localVarQueryParameter['storeIdList'] = storeIdList;
            }
            if (storeGroupId !== undefined) {
                localVarQueryParameter['storeGroupId'] = storeGroupId;
            }
            if (userId !== undefined) {
                localVarQueryParameter['userId'] = userId;
            }
            if (menuId !== undefined) {
                localVarQueryParameter['menuId'] = menuId;
            }
            if (campaignId !== undefined) {
                localVarQueryParameter['campaignId'] = campaignId;
            }
            if (userEmail !== undefined) {
                localVarQueryParameter['userEmail'] = userEmail;
            }
            if (userName !== undefined) {
                localVarQueryParameter['userName'] = userName;
            }
            if (voucherCode !== undefined) {
                localVarQueryParameter['voucherCode'] = voucherCode;
            }
            if (eventType) {
                localVarQueryParameter['eventType'] = eventType;
            }
            if (flipdishEventId !== undefined) {
                localVarQueryParameter['flipdishEventId'] = flipdishEventId;
            }
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        getWhiteLabelEvents: function (appId, whitelabelId, limit, page, start, end, orderId, storeId, storeIdList, storeGroupId, userId, menuId, campaignId, userEmail, userName, voucherCode, eventType, flipdishEventId, options) {
            if (options === void 0) { options = {}; }
            if (appId === null || appId === undefined) {
                throw new RequiredError('appId', 'Required parameter appId was null or undefined when calling getWhiteLabelEvents.');
            }
            if (whitelabelId === null || whitelabelId === undefined) {
                throw new RequiredError('whitelabelId', 'Required parameter whitelabelId was null or undefined when calling getWhiteLabelEvents.');
            }
            var localVarPath = "/api/v1.0/{appId}/events/whitelabel/{whitelabelId}"
                .replace("{".concat("appId", "}"), encodeURIComponent(String(appId)))
                .replace("{".concat("whitelabelId", "}"), encodeURIComponent(String(whitelabelId)));
            var localVarUrlObj = url.parse(localVarPath, true);
            var localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            var localVarHeaderParameter = {};
            var localVarQueryParameter = {};
            if (configuration && configuration.accessToken) {
                var localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("oauth2", ["api"])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }
            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }
            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }
            if (start !== undefined) {
                localVarQueryParameter['start'] = start;
            }
            if (end !== undefined) {
                localVarQueryParameter['end'] = end;
            }
            if (orderId !== undefined) {
                localVarQueryParameter['orderId'] = orderId;
            }
            if (storeId !== undefined) {
                localVarQueryParameter['storeId'] = storeId;
            }
            if (storeIdList) {
                localVarQueryParameter['storeIdList'] = storeIdList;
            }
            if (storeGroupId !== undefined) {
                localVarQueryParameter['storeGroupId'] = storeGroupId;
            }
            if (userId !== undefined) {
                localVarQueryParameter['userId'] = userId;
            }
            if (menuId !== undefined) {
                localVarQueryParameter['menuId'] = menuId;
            }
            if (campaignId !== undefined) {
                localVarQueryParameter['campaignId'] = campaignId;
            }
            if (userEmail !== undefined) {
                localVarQueryParameter['userEmail'] = userEmail;
            }
            if (userName !== undefined) {
                localVarQueryParameter['userName'] = userName;
            }
            if (voucherCode !== undefined) {
                localVarQueryParameter['voucherCode'] = voucherCode;
            }
            if (eventType) {
                localVarQueryParameter['eventType'] = eventType;
            }
            if (flipdishEventId !== undefined) {
                localVarQueryParameter['flipdishEventId'] = flipdishEventId;
            }
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    };
};
exports.EventsApiFetchParamCreator = EventsApiFetchParamCreator;
var EventsApiFp = function (configuration) {
    return {
        getCustomerEvents: function (appId, customerId, limit, page, start, end, orderId, storeId, storeIdList, storeGroupId, userId, menuId, campaignId, userEmail, userName, voucherCode, eventType, flipdishEventId, options) {
            var localVarFetchArgs = (0, exports.EventsApiFetchParamCreator)(configuration).getCustomerEvents(appId, customerId, limit, page, start, end, orderId, storeId, storeIdList, storeGroupId, userId, menuId, campaignId, userEmail, userName, voucherCode, eventType, flipdishEventId, options);
            return function (fetch, basePath) {
                if (fetch === void 0) { fetch = portableFetch; }
                if (basePath === void 0) { basePath = BASE_PATH; }
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then(function (response) {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
        getEvents: function (appId, whiteLabelId, customerId, limit, page, start, end, orderId, storeId, storeIdList, storeGroupId, userId, menuId, campaignId, userEmail, userName, voucherCode, eventType, flipdishEventId, options) {
            var localVarFetchArgs = (0, exports.EventsApiFetchParamCreator)(configuration).getEvents(appId, whiteLabelId, customerId, limit, page, start, end, orderId, storeId, storeIdList, storeGroupId, userId, menuId, campaignId, userEmail, userName, voucherCode, eventType, flipdishEventId, options);
            return function (fetch, basePath) {
                if (fetch === void 0) { fetch = portableFetch; }
                if (basePath === void 0) { basePath = BASE_PATH; }
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then(function (response) {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
        getEventsById: function (eventId, appId, options) {
            var localVarFetchArgs = (0, exports.EventsApiFetchParamCreator)(configuration).getEventsById(eventId, appId, options);
            return function (fetch, basePath) {
                if (fetch === void 0) { fetch = portableFetch; }
                if (basePath === void 0) { basePath = BASE_PATH; }
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then(function (response) {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
        getMenuEvents: function (appId, menuId2, limit, page, start, end, orderId, storeId, storeIdList, storeGroupId, userId, menuId, campaignId, userEmail, userName, voucherCode, eventType, flipdishEventId, options) {
            var localVarFetchArgs = (0, exports.EventsApiFetchParamCreator)(configuration).getMenuEvents(appId, menuId2, limit, page, start, end, orderId, storeId, storeIdList, storeGroupId, userId, menuId, campaignId, userEmail, userName, voucherCode, eventType, flipdishEventId, options);
            return function (fetch, basePath) {
                if (fetch === void 0) { fetch = portableFetch; }
                if (basePath === void 0) { basePath = BASE_PATH; }
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then(function (response) {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
        getOrderEvents: function (appId, orderId2, limit, page, start, end, orderId, storeId, storeIdList, storeGroupId, userId, menuId, campaignId, userEmail, userName, voucherCode, eventType, flipdishEventId, options) {
            var localVarFetchArgs = (0, exports.EventsApiFetchParamCreator)(configuration).getOrderEvents(appId, orderId2, limit, page, start, end, orderId, storeId, storeIdList, storeGroupId, userId, menuId, campaignId, userEmail, userName, voucherCode, eventType, flipdishEventId, options);
            return function (fetch, basePath) {
                if (fetch === void 0) { fetch = portableFetch; }
                if (basePath === void 0) { basePath = BASE_PATH; }
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then(function (response) {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
        getOrderEventsByCustomer: function (appId, customerId, limit, page, start, end, orderId, storeId, storeIdList, storeGroupId, userId, menuId, campaignId, userEmail, userName, voucherCode, eventType, flipdishEventId, options) {
            var localVarFetchArgs = (0, exports.EventsApiFetchParamCreator)(configuration).getOrderEventsByCustomer(appId, customerId, limit, page, start, end, orderId, storeId, storeIdList, storeGroupId, userId, menuId, campaignId, userEmail, userName, voucherCode, eventType, flipdishEventId, options);
            return function (fetch, basePath) {
                if (fetch === void 0) { fetch = portableFetch; }
                if (basePath === void 0) { basePath = BASE_PATH; }
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then(function (response) {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
        getStoreEvents: function (appId, storeId2, limit, page, start, end, orderId, storeId, storeIdList, storeGroupId, userId, menuId, campaignId, userEmail, userName, voucherCode, eventType, flipdishEventId, options) {
            var localVarFetchArgs = (0, exports.EventsApiFetchParamCreator)(configuration).getStoreEvents(appId, storeId2, limit, page, start, end, orderId, storeId, storeIdList, storeGroupId, userId, menuId, campaignId, userEmail, userName, voucherCode, eventType, flipdishEventId, options);
            return function (fetch, basePath) {
                if (fetch === void 0) { fetch = portableFetch; }
                if (basePath === void 0) { basePath = BASE_PATH; }
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then(function (response) {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
        getUserEvents: function (appId, userId2, limit, page, start, end, orderId, storeId, storeIdList, storeGroupId, userId, menuId, campaignId, userEmail, userName, voucherCode, eventType, flipdishEventId, options) {
            var localVarFetchArgs = (0, exports.EventsApiFetchParamCreator)(configuration).getUserEvents(appId, userId2, limit, page, start, end, orderId, storeId, storeIdList, storeGroupId, userId, menuId, campaignId, userEmail, userName, voucherCode, eventType, flipdishEventId, options);
            return function (fetch, basePath) {
                if (fetch === void 0) { fetch = portableFetch; }
                if (basePath === void 0) { basePath = BASE_PATH; }
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then(function (response) {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
        getWhiteLabelEvents: function (appId, whitelabelId, limit, page, start, end, orderId, storeId, storeIdList, storeGroupId, userId, menuId, campaignId, userEmail, userName, voucherCode, eventType, flipdishEventId, options) {
            var localVarFetchArgs = (0, exports.EventsApiFetchParamCreator)(configuration).getWhiteLabelEvents(appId, whitelabelId, limit, page, start, end, orderId, storeId, storeIdList, storeGroupId, userId, menuId, campaignId, userEmail, userName, voucherCode, eventType, flipdishEventId, options);
            return function (fetch, basePath) {
                if (fetch === void 0) { fetch = portableFetch; }
                if (basePath === void 0) { basePath = BASE_PATH; }
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then(function (response) {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
    };
};
exports.EventsApiFp = EventsApiFp;
var EventsApiFactory = function (configuration, fetch, basePath) {
    return {
        getCustomerEvents: function (appId, customerId, limit, page, start, end, orderId, storeId, storeIdList, storeGroupId, userId, menuId, campaignId, userEmail, userName, voucherCode, eventType, flipdishEventId, options) {
            return (0, exports.EventsApiFp)(configuration).getCustomerEvents(appId, customerId, limit, page, start, end, orderId, storeId, storeIdList, storeGroupId, userId, menuId, campaignId, userEmail, userName, voucherCode, eventType, flipdishEventId, options)(fetch, basePath);
        },
        getEvents: function (appId, whiteLabelId, customerId, limit, page, start, end, orderId, storeId, storeIdList, storeGroupId, userId, menuId, campaignId, userEmail, userName, voucherCode, eventType, flipdishEventId, options) {
            return (0, exports.EventsApiFp)(configuration).getEvents(appId, whiteLabelId, customerId, limit, page, start, end, orderId, storeId, storeIdList, storeGroupId, userId, menuId, campaignId, userEmail, userName, voucherCode, eventType, flipdishEventId, options)(fetch, basePath);
        },
        getEventsById: function (eventId, appId, options) {
            return (0, exports.EventsApiFp)(configuration).getEventsById(eventId, appId, options)(fetch, basePath);
        },
        getMenuEvents: function (appId, menuId2, limit, page, start, end, orderId, storeId, storeIdList, storeGroupId, userId, menuId, campaignId, userEmail, userName, voucherCode, eventType, flipdishEventId, options) {
            return (0, exports.EventsApiFp)(configuration).getMenuEvents(appId, menuId2, limit, page, start, end, orderId, storeId, storeIdList, storeGroupId, userId, menuId, campaignId, userEmail, userName, voucherCode, eventType, flipdishEventId, options)(fetch, basePath);
        },
        getOrderEvents: function (appId, orderId2, limit, page, start, end, orderId, storeId, storeIdList, storeGroupId, userId, menuId, campaignId, userEmail, userName, voucherCode, eventType, flipdishEventId, options) {
            return (0, exports.EventsApiFp)(configuration).getOrderEvents(appId, orderId2, limit, page, start, end, orderId, storeId, storeIdList, storeGroupId, userId, menuId, campaignId, userEmail, userName, voucherCode, eventType, flipdishEventId, options)(fetch, basePath);
        },
        getOrderEventsByCustomer: function (appId, customerId, limit, page, start, end, orderId, storeId, storeIdList, storeGroupId, userId, menuId, campaignId, userEmail, userName, voucherCode, eventType, flipdishEventId, options) {
            return (0, exports.EventsApiFp)(configuration).getOrderEventsByCustomer(appId, customerId, limit, page, start, end, orderId, storeId, storeIdList, storeGroupId, userId, menuId, campaignId, userEmail, userName, voucherCode, eventType, flipdishEventId, options)(fetch, basePath);
        },
        getStoreEvents: function (appId, storeId2, limit, page, start, end, orderId, storeId, storeIdList, storeGroupId, userId, menuId, campaignId, userEmail, userName, voucherCode, eventType, flipdishEventId, options) {
            return (0, exports.EventsApiFp)(configuration).getStoreEvents(appId, storeId2, limit, page, start, end, orderId, storeId, storeIdList, storeGroupId, userId, menuId, campaignId, userEmail, userName, voucherCode, eventType, flipdishEventId, options)(fetch, basePath);
        },
        getUserEvents: function (appId, userId2, limit, page, start, end, orderId, storeId, storeIdList, storeGroupId, userId, menuId, campaignId, userEmail, userName, voucherCode, eventType, flipdishEventId, options) {
            return (0, exports.EventsApiFp)(configuration).getUserEvents(appId, userId2, limit, page, start, end, orderId, storeId, storeIdList, storeGroupId, userId, menuId, campaignId, userEmail, userName, voucherCode, eventType, flipdishEventId, options)(fetch, basePath);
        },
        getWhiteLabelEvents: function (appId, whitelabelId, limit, page, start, end, orderId, storeId, storeIdList, storeGroupId, userId, menuId, campaignId, userEmail, userName, voucherCode, eventType, flipdishEventId, options) {
            return (0, exports.EventsApiFp)(configuration).getWhiteLabelEvents(appId, whitelabelId, limit, page, start, end, orderId, storeId, storeIdList, storeGroupId, userId, menuId, campaignId, userEmail, userName, voucherCode, eventType, flipdishEventId, options)(fetch, basePath);
        },
    };
};
exports.EventsApiFactory = EventsApiFactory;
var EventsApi = (function (_super) {
    __extends(EventsApi, _super);
    function EventsApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    EventsApi.prototype.getCustomerEvents = function (appId, customerId, limit, page, start, end, orderId, storeId, storeIdList, storeGroupId, userId, menuId, campaignId, userEmail, userName, voucherCode, eventType, flipdishEventId, options) {
        return (0, exports.EventsApiFp)(this.configuration).getCustomerEvents(appId, customerId, limit, page, start, end, orderId, storeId, storeIdList, storeGroupId, userId, menuId, campaignId, userEmail, userName, voucherCode, eventType, flipdishEventId, options)(this.fetch, this.basePath);
    };
    EventsApi.prototype.getEvents = function (appId, whiteLabelId, customerId, limit, page, start, end, orderId, storeId, storeIdList, storeGroupId, userId, menuId, campaignId, userEmail, userName, voucherCode, eventType, flipdishEventId, options) {
        return (0, exports.EventsApiFp)(this.configuration).getEvents(appId, whiteLabelId, customerId, limit, page, start, end, orderId, storeId, storeIdList, storeGroupId, userId, menuId, campaignId, userEmail, userName, voucherCode, eventType, flipdishEventId, options)(this.fetch, this.basePath);
    };
    EventsApi.prototype.getEventsById = function (eventId, appId, options) {
        return (0, exports.EventsApiFp)(this.configuration).getEventsById(eventId, appId, options)(this.fetch, this.basePath);
    };
    EventsApi.prototype.getMenuEvents = function (appId, menuId2, limit, page, start, end, orderId, storeId, storeIdList, storeGroupId, userId, menuId, campaignId, userEmail, userName, voucherCode, eventType, flipdishEventId, options) {
        return (0, exports.EventsApiFp)(this.configuration).getMenuEvents(appId, menuId2, limit, page, start, end, orderId, storeId, storeIdList, storeGroupId, userId, menuId, campaignId, userEmail, userName, voucherCode, eventType, flipdishEventId, options)(this.fetch, this.basePath);
    };
    EventsApi.prototype.getOrderEvents = function (appId, orderId2, limit, page, start, end, orderId, storeId, storeIdList, storeGroupId, userId, menuId, campaignId, userEmail, userName, voucherCode, eventType, flipdishEventId, options) {
        return (0, exports.EventsApiFp)(this.configuration).getOrderEvents(appId, orderId2, limit, page, start, end, orderId, storeId, storeIdList, storeGroupId, userId, menuId, campaignId, userEmail, userName, voucherCode, eventType, flipdishEventId, options)(this.fetch, this.basePath);
    };
    EventsApi.prototype.getOrderEventsByCustomer = function (appId, customerId, limit, page, start, end, orderId, storeId, storeIdList, storeGroupId, userId, menuId, campaignId, userEmail, userName, voucherCode, eventType, flipdishEventId, options) {
        return (0, exports.EventsApiFp)(this.configuration).getOrderEventsByCustomer(appId, customerId, limit, page, start, end, orderId, storeId, storeIdList, storeGroupId, userId, menuId, campaignId, userEmail, userName, voucherCode, eventType, flipdishEventId, options)(this.fetch, this.basePath);
    };
    EventsApi.prototype.getStoreEvents = function (appId, storeId2, limit, page, start, end, orderId, storeId, storeIdList, storeGroupId, userId, menuId, campaignId, userEmail, userName, voucherCode, eventType, flipdishEventId, options) {
        return (0, exports.EventsApiFp)(this.configuration).getStoreEvents(appId, storeId2, limit, page, start, end, orderId, storeId, storeIdList, storeGroupId, userId, menuId, campaignId, userEmail, userName, voucherCode, eventType, flipdishEventId, options)(this.fetch, this.basePath);
    };
    EventsApi.prototype.getUserEvents = function (appId, userId2, limit, page, start, end, orderId, storeId, storeIdList, storeGroupId, userId, menuId, campaignId, userEmail, userName, voucherCode, eventType, flipdishEventId, options) {
        return (0, exports.EventsApiFp)(this.configuration).getUserEvents(appId, userId2, limit, page, start, end, orderId, storeId, storeIdList, storeGroupId, userId, menuId, campaignId, userEmail, userName, voucherCode, eventType, flipdishEventId, options)(this.fetch, this.basePath);
    };
    EventsApi.prototype.getWhiteLabelEvents = function (appId, whitelabelId, limit, page, start, end, orderId, storeId, storeIdList, storeGroupId, userId, menuId, campaignId, userEmail, userName, voucherCode, eventType, flipdishEventId, options) {
        return (0, exports.EventsApiFp)(this.configuration).getWhiteLabelEvents(appId, whitelabelId, limit, page, start, end, orderId, storeId, storeIdList, storeGroupId, userId, menuId, campaignId, userEmail, userName, voucherCode, eventType, flipdishEventId, options)(this.fetch, this.basePath);
    };
    return EventsApi;
}(BaseAPI));
exports.EventsApi = EventsApi;
var FeaturesApiFetchParamCreator = function (configuration) {
    return {
        disableFeatures: function (appId, ERROR_UNKNOWN, options) {
            if (options === void 0) { options = {}; }
            if (appId === null || appId === undefined) {
                throw new RequiredError('appId', 'Required parameter appId was null or undefined when calling disableFeatures.');
            }
            if (ERROR_UNKNOWN === null || ERROR_UNKNOWN === undefined) {
                throw new RequiredError('ERROR_UNKNOWN', 'Required parameter ERROR_UNKNOWN was null or undefined when calling disableFeatures.');
            }
            var localVarPath = "/api/v1.0/{appId}/features/disable"
                .replace("{".concat("appId", "}"), encodeURIComponent(String(appId)));
            var localVarUrlObj = url.parse(localVarPath, true);
            var localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            var localVarHeaderParameter = {};
            var localVarQueryParameter = {};
            if (configuration && configuration.accessToken) {
                var localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("oauth2", ["api"])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }
            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            var needsSerialization = ("Array&lt;string&gt;" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body = needsSerialization ? JSON.stringify(ERROR_UNKNOWN || {}) : (ERROR_UNKNOWN || "");
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        enableFeatures: function (appId, ERROR_UNKNOWN, options) {
            if (options === void 0) { options = {}; }
            if (appId === null || appId === undefined) {
                throw new RequiredError('appId', 'Required parameter appId was null or undefined when calling enableFeatures.');
            }
            if (ERROR_UNKNOWN === null || ERROR_UNKNOWN === undefined) {
                throw new RequiredError('ERROR_UNKNOWN', 'Required parameter ERROR_UNKNOWN was null or undefined when calling enableFeatures.');
            }
            var localVarPath = "/api/v1.0/{appId}/features/enable"
                .replace("{".concat("appId", "}"), encodeURIComponent(String(appId)));
            var localVarUrlObj = url.parse(localVarPath, true);
            var localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            var localVarHeaderParameter = {};
            var localVarQueryParameter = {};
            if (configuration && configuration.accessToken) {
                var localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("oauth2", ["api"])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }
            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            var needsSerialization = ("Array&lt;string&gt;" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body = needsSerialization ? JSON.stringify(ERROR_UNKNOWN || {}) : (ERROR_UNKNOWN || "");
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    };
};
exports.FeaturesApiFetchParamCreator = FeaturesApiFetchParamCreator;
var FeaturesApiFp = function (configuration) {
    return {
        disableFeatures: function (appId, ERROR_UNKNOWN, options) {
            var localVarFetchArgs = (0, exports.FeaturesApiFetchParamCreator)(configuration).disableFeatures(appId, ERROR_UNKNOWN, options);
            return function (fetch, basePath) {
                if (fetch === void 0) { fetch = portableFetch; }
                if (basePath === void 0) { basePath = BASE_PATH; }
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then(function (response) {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
        enableFeatures: function (appId, ERROR_UNKNOWN, options) {
            var localVarFetchArgs = (0, exports.FeaturesApiFetchParamCreator)(configuration).enableFeatures(appId, ERROR_UNKNOWN, options);
            return function (fetch, basePath) {
                if (fetch === void 0) { fetch = portableFetch; }
                if (basePath === void 0) { basePath = BASE_PATH; }
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then(function (response) {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
    };
};
exports.FeaturesApiFp = FeaturesApiFp;
var FeaturesApiFactory = function (configuration, fetch, basePath) {
    return {
        disableFeatures: function (appId, ERROR_UNKNOWN, options) {
            return (0, exports.FeaturesApiFp)(configuration).disableFeatures(appId, ERROR_UNKNOWN, options)(fetch, basePath);
        },
        enableFeatures: function (appId, ERROR_UNKNOWN, options) {
            return (0, exports.FeaturesApiFp)(configuration).enableFeatures(appId, ERROR_UNKNOWN, options)(fetch, basePath);
        },
    };
};
exports.FeaturesApiFactory = FeaturesApiFactory;
var FeaturesApi = (function (_super) {
    __extends(FeaturesApi, _super);
    function FeaturesApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    FeaturesApi.prototype.disableFeatures = function (appId, ERROR_UNKNOWN, options) {
        return (0, exports.FeaturesApiFp)(this.configuration).disableFeatures(appId, ERROR_UNKNOWN, options)(this.fetch, this.basePath);
    };
    FeaturesApi.prototype.enableFeatures = function (appId, ERROR_UNKNOWN, options) {
        return (0, exports.FeaturesApiFp)(this.configuration).enableFeatures(appId, ERROR_UNKNOWN, options)(this.fetch, this.basePath);
    };
    return FeaturesApi;
}(BaseAPI));
exports.FeaturesApi = FeaturesApi;
var FirebaseAppsApiFetchParamCreator = function (configuration) {
    return {
        firebaseAppsAddFirebaseApp: function (FirebaseApp, options) {
            if (options === void 0) { options = {}; }
            if (FirebaseApp === null || FirebaseApp === undefined) {
                throw new RequiredError('FirebaseApp', 'Required parameter FirebaseApp was null or undefined when calling firebaseAppsAddFirebaseApp.');
            }
            var localVarPath = "/api/v1.0/FirebaseApp";
            var localVarUrlObj = url.parse(localVarPath, true);
            var localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            var localVarHeaderParameter = {};
            var localVarQueryParameter = {};
            if (configuration && configuration.accessToken) {
                var localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("oauth2", ["api"])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }
            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            var needsSerialization = ("FirebaseApp" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body = needsSerialization ? JSON.stringify(FirebaseApp || {}) : (FirebaseApp || "");
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        firebaseAppsDeleteFirebaseApp: function (whiteLabelId, options) {
            if (options === void 0) { options = {}; }
            if (whiteLabelId === null || whiteLabelId === undefined) {
                throw new RequiredError('whiteLabelId', 'Required parameter whiteLabelId was null or undefined when calling firebaseAppsDeleteFirebaseApp.');
            }
            var localVarPath = "/api/v1.0/FirebaseApp/{whiteLabelId}"
                .replace("{".concat("whiteLabelId", "}"), encodeURIComponent(String(whiteLabelId)));
            var localVarUrlObj = url.parse(localVarPath, true);
            var localVarRequestOptions = Object.assign({ method: 'DELETE' }, options);
            var localVarHeaderParameter = {};
            var localVarQueryParameter = {};
            if (configuration && configuration.accessToken) {
                var localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("oauth2", ["api"])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        firebaseAppsGetFirebaseApp: function (whitelabelId, options) {
            if (options === void 0) { options = {}; }
            if (whitelabelId === null || whitelabelId === undefined) {
                throw new RequiredError('whitelabelId', 'Required parameter whitelabelId was null or undefined when calling firebaseAppsGetFirebaseApp.');
            }
            var localVarPath = "/api/v1.0/FirebaseApp/{whitelabelId}"
                .replace("{".concat("whitelabelId", "}"), encodeURIComponent(String(whitelabelId)));
            var localVarUrlObj = url.parse(localVarPath, true);
            var localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            var localVarHeaderParameter = {};
            var localVarQueryParameter = {};
            if (configuration && configuration.accessToken) {
                var localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("oauth2", ["api"])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    };
};
exports.FirebaseAppsApiFetchParamCreator = FirebaseAppsApiFetchParamCreator;
var FirebaseAppsApiFp = function (configuration) {
    return {
        firebaseAppsAddFirebaseApp: function (FirebaseApp, options) {
            var localVarFetchArgs = (0, exports.FirebaseAppsApiFetchParamCreator)(configuration).firebaseAppsAddFirebaseApp(FirebaseApp, options);
            return function (fetch, basePath) {
                if (fetch === void 0) { fetch = portableFetch; }
                if (basePath === void 0) { basePath = BASE_PATH; }
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then(function (response) {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
        firebaseAppsDeleteFirebaseApp: function (whiteLabelId, options) {
            var localVarFetchArgs = (0, exports.FirebaseAppsApiFetchParamCreator)(configuration).firebaseAppsDeleteFirebaseApp(whiteLabelId, options);
            return function (fetch, basePath) {
                if (fetch === void 0) { fetch = portableFetch; }
                if (basePath === void 0) { basePath = BASE_PATH; }
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then(function (response) {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
        firebaseAppsGetFirebaseApp: function (whitelabelId, options) {
            var localVarFetchArgs = (0, exports.FirebaseAppsApiFetchParamCreator)(configuration).firebaseAppsGetFirebaseApp(whitelabelId, options);
            return function (fetch, basePath) {
                if (fetch === void 0) { fetch = portableFetch; }
                if (basePath === void 0) { basePath = BASE_PATH; }
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then(function (response) {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
    };
};
exports.FirebaseAppsApiFp = FirebaseAppsApiFp;
var FirebaseAppsApiFactory = function (configuration, fetch, basePath) {
    return {
        firebaseAppsAddFirebaseApp: function (FirebaseApp, options) {
            return (0, exports.FirebaseAppsApiFp)(configuration).firebaseAppsAddFirebaseApp(FirebaseApp, options)(fetch, basePath);
        },
        firebaseAppsDeleteFirebaseApp: function (whiteLabelId, options) {
            return (0, exports.FirebaseAppsApiFp)(configuration).firebaseAppsDeleteFirebaseApp(whiteLabelId, options)(fetch, basePath);
        },
        firebaseAppsGetFirebaseApp: function (whitelabelId, options) {
            return (0, exports.FirebaseAppsApiFp)(configuration).firebaseAppsGetFirebaseApp(whitelabelId, options)(fetch, basePath);
        },
    };
};
exports.FirebaseAppsApiFactory = FirebaseAppsApiFactory;
var FirebaseAppsApi = (function (_super) {
    __extends(FirebaseAppsApi, _super);
    function FirebaseAppsApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    FirebaseAppsApi.prototype.firebaseAppsAddFirebaseApp = function (FirebaseApp, options) {
        return (0, exports.FirebaseAppsApiFp)(this.configuration).firebaseAppsAddFirebaseApp(FirebaseApp, options)(this.fetch, this.basePath);
    };
    FirebaseAppsApi.prototype.firebaseAppsDeleteFirebaseApp = function (whiteLabelId, options) {
        return (0, exports.FirebaseAppsApiFp)(this.configuration).firebaseAppsDeleteFirebaseApp(whiteLabelId, options)(this.fetch, this.basePath);
    };
    FirebaseAppsApi.prototype.firebaseAppsGetFirebaseApp = function (whitelabelId, options) {
        return (0, exports.FirebaseAppsApiFp)(this.configuration).firebaseAppsGetFirebaseApp(whitelabelId, options)(this.fetch, this.basePath);
    };
    return FirebaseAppsApi;
}(BaseAPI));
exports.FirebaseAppsApi = FirebaseAppsApi;
var FpmApiFetchParamCreator = function (configuration) {
    return {
        createFpmForStore: function (storeId, phoneNumber, options) {
            if (options === void 0) { options = {}; }
            if (storeId === null || storeId === undefined) {
                throw new RequiredError('storeId', 'Required parameter storeId was null or undefined when calling createFpmForStore.');
            }
            if (phoneNumber === null || phoneNumber === undefined) {
                throw new RequiredError('phoneNumber', 'Required parameter phoneNumber was null or undefined when calling createFpmForStore.');
            }
            var localVarPath = "/api/v1.0/{storeId}/fpm"
                .replace("{".concat("storeId", "}"), encodeURIComponent(String(storeId)));
            var localVarUrlObj = url.parse(localVarPath, true);
            var localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            var localVarHeaderParameter = {};
            var localVarQueryParameter = {};
            if (configuration && configuration.accessToken) {
                var localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("oauth2", ["api"])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }
            if (phoneNumber !== undefined) {
                localVarQueryParameter['phoneNumber'] = phoneNumber;
            }
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        deleteFpmForStore: function (storeId, options) {
            if (options === void 0) { options = {}; }
            if (storeId === null || storeId === undefined) {
                throw new RequiredError('storeId', 'Required parameter storeId was null or undefined when calling deleteFpmForStore.');
            }
            var localVarPath = "/api/v1.0/{storeId}/fpm"
                .replace("{".concat("storeId", "}"), encodeURIComponent(String(storeId)));
            var localVarUrlObj = url.parse(localVarPath, true);
            var localVarRequestOptions = Object.assign({ method: 'DELETE' }, options);
            var localVarHeaderParameter = {};
            var localVarQueryParameter = {};
            if (configuration && configuration.accessToken) {
                var localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("oauth2", ["api"])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        editFpmForStore: function (storeId, TelephonyConfig, options) {
            if (options === void 0) { options = {}; }
            if (storeId === null || storeId === undefined) {
                throw new RequiredError('storeId', 'Required parameter storeId was null or undefined when calling editFpmForStore.');
            }
            if (TelephonyConfig === null || TelephonyConfig === undefined) {
                throw new RequiredError('TelephonyConfig', 'Required parameter TelephonyConfig was null or undefined when calling editFpmForStore.');
            }
            var localVarPath = "/api/v1.0/{storeId}/fpm/edit"
                .replace("{".concat("storeId", "}"), encodeURIComponent(String(storeId)));
            var localVarUrlObj = url.parse(localVarPath, true);
            var localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            var localVarHeaderParameter = {};
            var localVarQueryParameter = {};
            if (configuration && configuration.accessToken) {
                var localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("oauth2", ["api"])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }
            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            var needsSerialization = ("TelephonyConfig" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body = needsSerialization ? JSON.stringify(TelephonyConfig || {}) : (TelephonyConfig || "");
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        getFpmForStore: function (storeId, options) {
            if (options === void 0) { options = {}; }
            if (storeId === null || storeId === undefined) {
                throw new RequiredError('storeId', 'Required parameter storeId was null or undefined when calling getFpmForStore.');
            }
            var localVarPath = "/api/v1.0/{storeId}/fpm"
                .replace("{".concat("storeId", "}"), encodeURIComponent(String(storeId)));
            var localVarUrlObj = url.parse(localVarPath, true);
            var localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            var localVarHeaderParameter = {};
            var localVarQueryParameter = {};
            if (configuration && configuration.accessToken) {
                var localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("oauth2", ["api"])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    };
};
exports.FpmApiFetchParamCreator = FpmApiFetchParamCreator;
var FpmApiFp = function (configuration) {
    return {
        createFpmForStore: function (storeId, phoneNumber, options) {
            var localVarFetchArgs = (0, exports.FpmApiFetchParamCreator)(configuration).createFpmForStore(storeId, phoneNumber, options);
            return function (fetch, basePath) {
                if (fetch === void 0) { fetch = portableFetch; }
                if (basePath === void 0) { basePath = BASE_PATH; }
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then(function (response) {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
        deleteFpmForStore: function (storeId, options) {
            var localVarFetchArgs = (0, exports.FpmApiFetchParamCreator)(configuration).deleteFpmForStore(storeId, options);
            return function (fetch, basePath) {
                if (fetch === void 0) { fetch = portableFetch; }
                if (basePath === void 0) { basePath = BASE_PATH; }
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then(function (response) {
                    if (response.status >= 200 && response.status < 300) {
                        return response;
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
        editFpmForStore: function (storeId, TelephonyConfig, options) {
            var localVarFetchArgs = (0, exports.FpmApiFetchParamCreator)(configuration).editFpmForStore(storeId, TelephonyConfig, options);
            return function (fetch, basePath) {
                if (fetch === void 0) { fetch = portableFetch; }
                if (basePath === void 0) { basePath = BASE_PATH; }
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then(function (response) {
                    if (response.status >= 200 && response.status < 300) {
                        return response;
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
        getFpmForStore: function (storeId, options) {
            var localVarFetchArgs = (0, exports.FpmApiFetchParamCreator)(configuration).getFpmForStore(storeId, options);
            return function (fetch, basePath) {
                if (fetch === void 0) { fetch = portableFetch; }
                if (basePath === void 0) { basePath = BASE_PATH; }
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then(function (response) {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
    };
};
exports.FpmApiFp = FpmApiFp;
var FpmApiFactory = function (configuration, fetch, basePath) {
    return {
        createFpmForStore: function (storeId, phoneNumber, options) {
            return (0, exports.FpmApiFp)(configuration).createFpmForStore(storeId, phoneNumber, options)(fetch, basePath);
        },
        deleteFpmForStore: function (storeId, options) {
            return (0, exports.FpmApiFp)(configuration).deleteFpmForStore(storeId, options)(fetch, basePath);
        },
        editFpmForStore: function (storeId, TelephonyConfig, options) {
            return (0, exports.FpmApiFp)(configuration).editFpmForStore(storeId, TelephonyConfig, options)(fetch, basePath);
        },
        getFpmForStore: function (storeId, options) {
            return (0, exports.FpmApiFp)(configuration).getFpmForStore(storeId, options)(fetch, basePath);
        },
    };
};
exports.FpmApiFactory = FpmApiFactory;
var FpmApi = (function (_super) {
    __extends(FpmApi, _super);
    function FpmApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    FpmApi.prototype.createFpmForStore = function (storeId, phoneNumber, options) {
        return (0, exports.FpmApiFp)(this.configuration).createFpmForStore(storeId, phoneNumber, options)(this.fetch, this.basePath);
    };
    FpmApi.prototype.deleteFpmForStore = function (storeId, options) {
        return (0, exports.FpmApiFp)(this.configuration).deleteFpmForStore(storeId, options)(this.fetch, this.basePath);
    };
    FpmApi.prototype.editFpmForStore = function (storeId, TelephonyConfig, options) {
        return (0, exports.FpmApiFp)(this.configuration).editFpmForStore(storeId, TelephonyConfig, options)(this.fetch, this.basePath);
    };
    FpmApi.prototype.getFpmForStore = function (storeId, options) {
        return (0, exports.FpmApiFp)(this.configuration).getFpmForStore(storeId, options)(this.fetch, this.basePath);
    };
    return FpmApi;
}(BaseAPI));
exports.FpmApi = FpmApi;
var FulfillmentStateConfigurationApiFetchParamCreator = function (configuration) {
    return {
        createFulfillmentStatesConfig: function (appId, CreateFulfillmentStatesConfiguration, options) {
            if (options === void 0) { options = {}; }
            if (appId === null || appId === undefined) {
                throw new RequiredError('appId', 'Required parameter appId was null or undefined when calling createFulfillmentStatesConfig.');
            }
            if (CreateFulfillmentStatesConfiguration === null || CreateFulfillmentStatesConfiguration === undefined) {
                throw new RequiredError('CreateFulfillmentStatesConfiguration', 'Required parameter CreateFulfillmentStatesConfiguration was null or undefined when calling createFulfillmentStatesConfig.');
            }
            var localVarPath = "/api/v1.0/{appId}/fulfillment/configuration/states"
                .replace("{".concat("appId", "}"), encodeURIComponent(String(appId)));
            var localVarUrlObj = url.parse(localVarPath, true);
            var localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            var localVarHeaderParameter = {};
            var localVarQueryParameter = {};
            if (configuration && configuration.accessToken) {
                var localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("oauth2", ["api"])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }
            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            var needsSerialization = ("CreateFulfillmentStatesConfiguration" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body = needsSerialization ? JSON.stringify(CreateFulfillmentStatesConfiguration || {}) : (CreateFulfillmentStatesConfiguration || "");
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        deleteFulfillmentStatesConfig: function (appId, configId, options) {
            if (options === void 0) { options = {}; }
            if (appId === null || appId === undefined) {
                throw new RequiredError('appId', 'Required parameter appId was null or undefined when calling deleteFulfillmentStatesConfig.');
            }
            if (configId === null || configId === undefined) {
                throw new RequiredError('configId', 'Required parameter configId was null or undefined when calling deleteFulfillmentStatesConfig.');
            }
            var localVarPath = "/api/v1.0/{appId}/fulfillment/configuration/states/{configId}"
                .replace("{".concat("appId", "}"), encodeURIComponent(String(appId)))
                .replace("{".concat("configId", "}"), encodeURIComponent(String(configId)));
            var localVarUrlObj = url.parse(localVarPath, true);
            var localVarRequestOptions = Object.assign({ method: 'DELETE' }, options);
            var localVarHeaderParameter = {};
            var localVarQueryParameter = {};
            if (configuration && configuration.accessToken) {
                var localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("oauth2", ["api"])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        getFulfillmentStatesConfiguration: function (appId, configId, options) {
            if (options === void 0) { options = {}; }
            if (appId === null || appId === undefined) {
                throw new RequiredError('appId', 'Required parameter appId was null or undefined when calling getFulfillmentStatesConfiguration.');
            }
            if (configId === null || configId === undefined) {
                throw new RequiredError('configId', 'Required parameter configId was null or undefined when calling getFulfillmentStatesConfiguration.');
            }
            var localVarPath = "/api/v1.0/{appId}/fulfillment/configuration/states/{configId}"
                .replace("{".concat("appId", "}"), encodeURIComponent(String(appId)))
                .replace("{".concat("configId", "}"), encodeURIComponent(String(configId)));
            var localVarUrlObj = url.parse(localVarPath, true);
            var localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            var localVarHeaderParameter = {};
            var localVarQueryParameter = {};
            if (configuration && configuration.accessToken) {
                var localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("oauth2", ["api"])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        getFulfillmentStatesConfigurationTemplate: function (appId, options) {
            if (options === void 0) { options = {}; }
            if (appId === null || appId === undefined) {
                throw new RequiredError('appId', 'Required parameter appId was null or undefined when calling getFulfillmentStatesConfigurationTemplate.');
            }
            var localVarPath = "/api/v1.0/{appId}/fulfillment/configuration/states_template"
                .replace("{".concat("appId", "}"), encodeURIComponent(String(appId)));
            var localVarUrlObj = url.parse(localVarPath, true);
            var localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            var localVarHeaderParameter = {};
            var localVarQueryParameter = {};
            if (configuration && configuration.accessToken) {
                var localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("oauth2", ["api"])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        searchFulfillmentStatesConfigurations: function (appId, options) {
            if (options === void 0) { options = {}; }
            if (appId === null || appId === undefined) {
                throw new RequiredError('appId', 'Required parameter appId was null or undefined when calling searchFulfillmentStatesConfigurations.');
            }
            var localVarPath = "/api/v1.0/{appId}/fulfillment/configuration/states"
                .replace("{".concat("appId", "}"), encodeURIComponent(String(appId)));
            var localVarUrlObj = url.parse(localVarPath, true);
            var localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            var localVarHeaderParameter = {};
            var localVarQueryParameter = {};
            if (configuration && configuration.accessToken) {
                var localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("oauth2", ["api"])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        updateFulfillmentStatesConfig: function (appId, configId, UpdateFulfillmentStatesConfiguration, options) {
            if (options === void 0) { options = {}; }
            if (appId === null || appId === undefined) {
                throw new RequiredError('appId', 'Required parameter appId was null or undefined when calling updateFulfillmentStatesConfig.');
            }
            if (configId === null || configId === undefined) {
                throw new RequiredError('configId', 'Required parameter configId was null or undefined when calling updateFulfillmentStatesConfig.');
            }
            if (UpdateFulfillmentStatesConfiguration === null || UpdateFulfillmentStatesConfiguration === undefined) {
                throw new RequiredError('UpdateFulfillmentStatesConfiguration', 'Required parameter UpdateFulfillmentStatesConfiguration was null or undefined when calling updateFulfillmentStatesConfig.');
            }
            var localVarPath = "/api/v1.0/{appId}/fulfillment/configuration/states/{configId}"
                .replace("{".concat("appId", "}"), encodeURIComponent(String(appId)))
                .replace("{".concat("configId", "}"), encodeURIComponent(String(configId)));
            var localVarUrlObj = url.parse(localVarPath, true);
            var localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            var localVarHeaderParameter = {};
            var localVarQueryParameter = {};
            if (configuration && configuration.accessToken) {
                var localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("oauth2", ["api"])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }
            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            var needsSerialization = ("UpdateFulfillmentStatesConfiguration" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body = needsSerialization ? JSON.stringify(UpdateFulfillmentStatesConfiguration || {}) : (UpdateFulfillmentStatesConfiguration || "");
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    };
};
exports.FulfillmentStateConfigurationApiFetchParamCreator = FulfillmentStateConfigurationApiFetchParamCreator;
var FulfillmentStateConfigurationApiFp = function (configuration) {
    return {
        createFulfillmentStatesConfig: function (appId, CreateFulfillmentStatesConfiguration, options) {
            var localVarFetchArgs = (0, exports.FulfillmentStateConfigurationApiFetchParamCreator)(configuration).createFulfillmentStatesConfig(appId, CreateFulfillmentStatesConfiguration, options);
            return function (fetch, basePath) {
                if (fetch === void 0) { fetch = portableFetch; }
                if (basePath === void 0) { basePath = BASE_PATH; }
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then(function (response) {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
        deleteFulfillmentStatesConfig: function (appId, configId, options) {
            var localVarFetchArgs = (0, exports.FulfillmentStateConfigurationApiFetchParamCreator)(configuration).deleteFulfillmentStatesConfig(appId, configId, options);
            return function (fetch, basePath) {
                if (fetch === void 0) { fetch = portableFetch; }
                if (basePath === void 0) { basePath = BASE_PATH; }
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then(function (response) {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
        getFulfillmentStatesConfiguration: function (appId, configId, options) {
            var localVarFetchArgs = (0, exports.FulfillmentStateConfigurationApiFetchParamCreator)(configuration).getFulfillmentStatesConfiguration(appId, configId, options);
            return function (fetch, basePath) {
                if (fetch === void 0) { fetch = portableFetch; }
                if (basePath === void 0) { basePath = BASE_PATH; }
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then(function (response) {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
        getFulfillmentStatesConfigurationTemplate: function (appId, options) {
            var localVarFetchArgs = (0, exports.FulfillmentStateConfigurationApiFetchParamCreator)(configuration).getFulfillmentStatesConfigurationTemplate(appId, options);
            return function (fetch, basePath) {
                if (fetch === void 0) { fetch = portableFetch; }
                if (basePath === void 0) { basePath = BASE_PATH; }
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then(function (response) {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
        searchFulfillmentStatesConfigurations: function (appId, options) {
            var localVarFetchArgs = (0, exports.FulfillmentStateConfigurationApiFetchParamCreator)(configuration).searchFulfillmentStatesConfigurations(appId, options);
            return function (fetch, basePath) {
                if (fetch === void 0) { fetch = portableFetch; }
                if (basePath === void 0) { basePath = BASE_PATH; }
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then(function (response) {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
        updateFulfillmentStatesConfig: function (appId, configId, UpdateFulfillmentStatesConfiguration, options) {
            var localVarFetchArgs = (0, exports.FulfillmentStateConfigurationApiFetchParamCreator)(configuration).updateFulfillmentStatesConfig(appId, configId, UpdateFulfillmentStatesConfiguration, options);
            return function (fetch, basePath) {
                if (fetch === void 0) { fetch = portableFetch; }
                if (basePath === void 0) { basePath = BASE_PATH; }
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then(function (response) {
                    if (response.status >= 200 && response.status < 300) {
                        return response;
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
    };
};
exports.FulfillmentStateConfigurationApiFp = FulfillmentStateConfigurationApiFp;
var FulfillmentStateConfigurationApiFactory = function (configuration, fetch, basePath) {
    return {
        createFulfillmentStatesConfig: function (appId, CreateFulfillmentStatesConfiguration, options) {
            return (0, exports.FulfillmentStateConfigurationApiFp)(configuration).createFulfillmentStatesConfig(appId, CreateFulfillmentStatesConfiguration, options)(fetch, basePath);
        },
        deleteFulfillmentStatesConfig: function (appId, configId, options) {
            return (0, exports.FulfillmentStateConfigurationApiFp)(configuration).deleteFulfillmentStatesConfig(appId, configId, options)(fetch, basePath);
        },
        getFulfillmentStatesConfiguration: function (appId, configId, options) {
            return (0, exports.FulfillmentStateConfigurationApiFp)(configuration).getFulfillmentStatesConfiguration(appId, configId, options)(fetch, basePath);
        },
        getFulfillmentStatesConfigurationTemplate: function (appId, options) {
            return (0, exports.FulfillmentStateConfigurationApiFp)(configuration).getFulfillmentStatesConfigurationTemplate(appId, options)(fetch, basePath);
        },
        searchFulfillmentStatesConfigurations: function (appId, options) {
            return (0, exports.FulfillmentStateConfigurationApiFp)(configuration).searchFulfillmentStatesConfigurations(appId, options)(fetch, basePath);
        },
        updateFulfillmentStatesConfig: function (appId, configId, UpdateFulfillmentStatesConfiguration, options) {
            return (0, exports.FulfillmentStateConfigurationApiFp)(configuration).updateFulfillmentStatesConfig(appId, configId, UpdateFulfillmentStatesConfiguration, options)(fetch, basePath);
        },
    };
};
exports.FulfillmentStateConfigurationApiFactory = FulfillmentStateConfigurationApiFactory;
var FulfillmentStateConfigurationApi = (function (_super) {
    __extends(FulfillmentStateConfigurationApi, _super);
    function FulfillmentStateConfigurationApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    FulfillmentStateConfigurationApi.prototype.createFulfillmentStatesConfig = function (appId, CreateFulfillmentStatesConfiguration, options) {
        return (0, exports.FulfillmentStateConfigurationApiFp)(this.configuration).createFulfillmentStatesConfig(appId, CreateFulfillmentStatesConfiguration, options)(this.fetch, this.basePath);
    };
    FulfillmentStateConfigurationApi.prototype.deleteFulfillmentStatesConfig = function (appId, configId, options) {
        return (0, exports.FulfillmentStateConfigurationApiFp)(this.configuration).deleteFulfillmentStatesConfig(appId, configId, options)(this.fetch, this.basePath);
    };
    FulfillmentStateConfigurationApi.prototype.getFulfillmentStatesConfiguration = function (appId, configId, options) {
        return (0, exports.FulfillmentStateConfigurationApiFp)(this.configuration).getFulfillmentStatesConfiguration(appId, configId, options)(this.fetch, this.basePath);
    };
    FulfillmentStateConfigurationApi.prototype.getFulfillmentStatesConfigurationTemplate = function (appId, options) {
        return (0, exports.FulfillmentStateConfigurationApiFp)(this.configuration).getFulfillmentStatesConfigurationTemplate(appId, options)(this.fetch, this.basePath);
    };
    FulfillmentStateConfigurationApi.prototype.searchFulfillmentStatesConfigurations = function (appId, options) {
        return (0, exports.FulfillmentStateConfigurationApiFp)(this.configuration).searchFulfillmentStatesConfigurations(appId, options)(this.fetch, this.basePath);
    };
    FulfillmentStateConfigurationApi.prototype.updateFulfillmentStatesConfig = function (appId, configId, UpdateFulfillmentStatesConfiguration, options) {
        return (0, exports.FulfillmentStateConfigurationApiFp)(this.configuration).updateFulfillmentStatesConfig(appId, configId, UpdateFulfillmentStatesConfiguration, options)(this.fetch, this.basePath);
    };
    return FulfillmentStateConfigurationApi;
}(BaseAPI));
exports.FulfillmentStateConfigurationApi = FulfillmentStateConfigurationApi;
var HeartbeatApiFetchParamCreator = function (configuration) {
    return {
        headHostname: function (options) {
            if (options === void 0) { options = {}; }
            var localVarPath = "/api/v1.0/heartbeat/Hostname";
            var localVarUrlObj = url.parse(localVarPath, true);
            var localVarRequestOptions = Object.assign({ method: 'HEAD' }, options);
            var localVarHeaderParameter = {};
            var localVarQueryParameter = {};
            if (configuration && configuration.accessToken) {
                var localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("oauth2", ["api"])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        headPing: function (options) {
            if (options === void 0) { options = {}; }
            var localVarPath = "/api/v1.0/heartbeat";
            var localVarUrlObj = url.parse(localVarPath, true);
            var localVarRequestOptions = Object.assign({ method: 'HEAD' }, options);
            var localVarHeaderParameter = {};
            var localVarQueryParameter = {};
            if (configuration && configuration.accessToken) {
                var localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("oauth2", ["api"])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        hostname: function (options) {
            if (options === void 0) { options = {}; }
            var localVarPath = "/api/v1.0/heartbeat/Hostname";
            var localVarUrlObj = url.parse(localVarPath, true);
            var localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            var localVarHeaderParameter = {};
            var localVarQueryParameter = {};
            if (configuration && configuration.accessToken) {
                var localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("oauth2", ["api"])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        ping: function (options) {
            if (options === void 0) { options = {}; }
            var localVarPath = "/api/v1.0/heartbeat";
            var localVarUrlObj = url.parse(localVarPath, true);
            var localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            var localVarHeaderParameter = {};
            var localVarQueryParameter = {};
            if (configuration && configuration.accessToken) {
                var localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("oauth2", ["api"])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    };
};
exports.HeartbeatApiFetchParamCreator = HeartbeatApiFetchParamCreator;
var HeartbeatApiFp = function (configuration) {
    return {
        headHostname: function (options) {
            var localVarFetchArgs = (0, exports.HeartbeatApiFetchParamCreator)(configuration).headHostname(options);
            return function (fetch, basePath) {
                if (fetch === void 0) { fetch = portableFetch; }
                if (basePath === void 0) { basePath = BASE_PATH; }
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then(function (response) {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
        headPing: function (options) {
            var localVarFetchArgs = (0, exports.HeartbeatApiFetchParamCreator)(configuration).headPing(options);
            return function (fetch, basePath) {
                if (fetch === void 0) { fetch = portableFetch; }
                if (basePath === void 0) { basePath = BASE_PATH; }
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then(function (response) {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
        hostname: function (options) {
            var localVarFetchArgs = (0, exports.HeartbeatApiFetchParamCreator)(configuration).hostname(options);
            return function (fetch, basePath) {
                if (fetch === void 0) { fetch = portableFetch; }
                if (basePath === void 0) { basePath = BASE_PATH; }
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then(function (response) {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
        ping: function (options) {
            var localVarFetchArgs = (0, exports.HeartbeatApiFetchParamCreator)(configuration).ping(options);
            return function (fetch, basePath) {
                if (fetch === void 0) { fetch = portableFetch; }
                if (basePath === void 0) { basePath = BASE_PATH; }
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then(function (response) {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
    };
};
exports.HeartbeatApiFp = HeartbeatApiFp;
var HeartbeatApiFactory = function (configuration, fetch, basePath) {
    return {
        headHostname: function (options) {
            return (0, exports.HeartbeatApiFp)(configuration).headHostname(options)(fetch, basePath);
        },
        headPing: function (options) {
            return (0, exports.HeartbeatApiFp)(configuration).headPing(options)(fetch, basePath);
        },
        hostname: function (options) {
            return (0, exports.HeartbeatApiFp)(configuration).hostname(options)(fetch, basePath);
        },
        ping: function (options) {
            return (0, exports.HeartbeatApiFp)(configuration).ping(options)(fetch, basePath);
        },
    };
};
exports.HeartbeatApiFactory = HeartbeatApiFactory;
var HeartbeatApi = (function (_super) {
    __extends(HeartbeatApi, _super);
    function HeartbeatApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    HeartbeatApi.prototype.headHostname = function (options) {
        return (0, exports.HeartbeatApiFp)(this.configuration).headHostname(options)(this.fetch, this.basePath);
    };
    HeartbeatApi.prototype.headPing = function (options) {
        return (0, exports.HeartbeatApiFp)(this.configuration).headPing(options)(this.fetch, this.basePath);
    };
    HeartbeatApi.prototype.hostname = function (options) {
        return (0, exports.HeartbeatApiFp)(this.configuration).hostname(options)(this.fetch, this.basePath);
    };
    HeartbeatApi.prototype.ping = function (options) {
        return (0, exports.HeartbeatApiFp)(this.configuration).ping(options)(this.fetch, this.basePath);
    };
    return HeartbeatApi;
}(BaseAPI));
exports.HeartbeatApi = HeartbeatApi;
var HomeApiFetchParamCreator = function (configuration) {
    return {
        completeHomeAction: function (appId, homeActionId, isDismissed, options) {
            if (options === void 0) { options = {}; }
            if (appId === null || appId === undefined) {
                throw new RequiredError('appId', 'Required parameter appId was null or undefined when calling completeHomeAction.');
            }
            if (homeActionId === null || homeActionId === undefined) {
                throw new RequiredError('homeActionId', 'Required parameter homeActionId was null or undefined when calling completeHomeAction.');
            }
            if (isDismissed === null || isDismissed === undefined) {
                throw new RequiredError('isDismissed', 'Required parameter isDismissed was null or undefined when calling completeHomeAction.');
            }
            var localVarPath = "/api/v1.0/{appId}/home/{homeActionId}"
                .replace("{".concat("appId", "}"), encodeURIComponent(String(appId)))
                .replace("{".concat("homeActionId", "}"), encodeURIComponent(String(homeActionId)));
            var localVarUrlObj = url.parse(localVarPath, true);
            var localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            var localVarHeaderParameter = {};
            var localVarQueryParameter = {};
            if (configuration && configuration.accessToken) {
                var localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("oauth2", ["api"])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }
            if (isDismissed !== undefined) {
                localVarQueryParameter['isDismissed'] = isDismissed;
            }
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        getHomeActions: function (appId, options) {
            if (options === void 0) { options = {}; }
            if (appId === null || appId === undefined) {
                throw new RequiredError('appId', 'Required parameter appId was null or undefined when calling getHomeActions.');
            }
            var localVarPath = "/api/v1.0/{appId}/home"
                .replace("{".concat("appId", "}"), encodeURIComponent(String(appId)));
            var localVarUrlObj = url.parse(localVarPath, true);
            var localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            var localVarHeaderParameter = {};
            var localVarQueryParameter = {};
            if (configuration && configuration.accessToken) {
                var localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("oauth2", ["api"])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        getHomeStatistics: function (appId, options) {
            if (options === void 0) { options = {}; }
            if (appId === null || appId === undefined) {
                throw new RequiredError('appId', 'Required parameter appId was null or undefined when calling getHomeStatistics.');
            }
            var localVarPath = "/api/v1.0/{appId}/home/stats"
                .replace("{".concat("appId", "}"), encodeURIComponent(String(appId)));
            var localVarUrlObj = url.parse(localVarPath, true);
            var localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            var localVarHeaderParameter = {};
            var localVarQueryParameter = {};
            if (configuration && configuration.accessToken) {
                var localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("oauth2", ["api"])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        getOktaPortalFeatureFlag: function (options) {
            if (options === void 0) { options = {}; }
            var localVarPath = "/api/v1.0/home/okta-portal";
            var localVarUrlObj = url.parse(localVarPath, true);
            var localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            var localVarHeaderParameter = {};
            var localVarQueryParameter = {};
            if (configuration && configuration.accessToken) {
                var localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("oauth2", ["api"])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    };
};
exports.HomeApiFetchParamCreator = HomeApiFetchParamCreator;
var HomeApiFp = function (configuration) {
    return {
        completeHomeAction: function (appId, homeActionId, isDismissed, options) {
            var localVarFetchArgs = (0, exports.HomeApiFetchParamCreator)(configuration).completeHomeAction(appId, homeActionId, isDismissed, options);
            return function (fetch, basePath) {
                if (fetch === void 0) { fetch = portableFetch; }
                if (basePath === void 0) { basePath = BASE_PATH; }
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then(function (response) {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
        getHomeActions: function (appId, options) {
            var localVarFetchArgs = (0, exports.HomeApiFetchParamCreator)(configuration).getHomeActions(appId, options);
            return function (fetch, basePath) {
                if (fetch === void 0) { fetch = portableFetch; }
                if (basePath === void 0) { basePath = BASE_PATH; }
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then(function (response) {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
        getHomeStatistics: function (appId, options) {
            var localVarFetchArgs = (0, exports.HomeApiFetchParamCreator)(configuration).getHomeStatistics(appId, options);
            return function (fetch, basePath) {
                if (fetch === void 0) { fetch = portableFetch; }
                if (basePath === void 0) { basePath = BASE_PATH; }
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then(function (response) {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
        getOktaPortalFeatureFlag: function (options) {
            var localVarFetchArgs = (0, exports.HomeApiFetchParamCreator)(configuration).getOktaPortalFeatureFlag(options);
            return function (fetch, basePath) {
                if (fetch === void 0) { fetch = portableFetch; }
                if (basePath === void 0) { basePath = BASE_PATH; }
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then(function (response) {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
    };
};
exports.HomeApiFp = HomeApiFp;
var HomeApiFactory = function (configuration, fetch, basePath) {
    return {
        completeHomeAction: function (appId, homeActionId, isDismissed, options) {
            return (0, exports.HomeApiFp)(configuration).completeHomeAction(appId, homeActionId, isDismissed, options)(fetch, basePath);
        },
        getHomeActions: function (appId, options) {
            return (0, exports.HomeApiFp)(configuration).getHomeActions(appId, options)(fetch, basePath);
        },
        getHomeStatistics: function (appId, options) {
            return (0, exports.HomeApiFp)(configuration).getHomeStatistics(appId, options)(fetch, basePath);
        },
        getOktaPortalFeatureFlag: function (options) {
            return (0, exports.HomeApiFp)(configuration).getOktaPortalFeatureFlag(options)(fetch, basePath);
        },
    };
};
exports.HomeApiFactory = HomeApiFactory;
var HomeApi = (function (_super) {
    __extends(HomeApi, _super);
    function HomeApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    HomeApi.prototype.completeHomeAction = function (appId, homeActionId, isDismissed, options) {
        return (0, exports.HomeApiFp)(this.configuration).completeHomeAction(appId, homeActionId, isDismissed, options)(this.fetch, this.basePath);
    };
    HomeApi.prototype.getHomeActions = function (appId, options) {
        return (0, exports.HomeApiFp)(this.configuration).getHomeActions(appId, options)(this.fetch, this.basePath);
    };
    HomeApi.prototype.getHomeStatistics = function (appId, options) {
        return (0, exports.HomeApiFp)(this.configuration).getHomeStatistics(appId, options)(this.fetch, this.basePath);
    };
    HomeApi.prototype.getOktaPortalFeatureFlag = function (options) {
        return (0, exports.HomeApiFp)(this.configuration).getOktaPortalFeatureFlag(options)(this.fetch, this.basePath);
    };
    return HomeApi;
}(BaseAPI));
exports.HomeApi = HomeApi;
var HydraApiFetchParamCreator = function (configuration) {
    return {
        assignEmv: function (appId, hydraConfigId, emvTerminalId, options) {
            if (options === void 0) { options = {}; }
            if (appId === null || appId === undefined) {
                throw new RequiredError('appId', 'Required parameter appId was null or undefined when calling assignEmv.');
            }
            if (hydraConfigId === null || hydraConfigId === undefined) {
                throw new RequiredError('hydraConfigId', 'Required parameter hydraConfigId was null or undefined when calling assignEmv.');
            }
            if (emvTerminalId === null || emvTerminalId === undefined) {
                throw new RequiredError('emvTerminalId', 'Required parameter emvTerminalId was null or undefined when calling assignEmv.');
            }
            var localVarPath = "/api/v1.0/{appId}/hydra/emvterminal/assign/{hydraConfigId}/{emvTerminalId}"
                .replace("{".concat("appId", "}"), encodeURIComponent(String(appId)))
                .replace("{".concat("hydraConfigId", "}"), encodeURIComponent(String(hydraConfigId)))
                .replace("{".concat("emvTerminalId", "}"), encodeURIComponent(String(emvTerminalId)));
            var localVarUrlObj = url.parse(localVarPath, true);
            var localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            var localVarHeaderParameter = {};
            var localVarQueryParameter = {};
            if (configuration && configuration.accessToken) {
                var localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("oauth2", ["api"])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        attachStoreToKiosk: function (appId, storeId, deviceId, options) {
            if (options === void 0) { options = {}; }
            if (appId === null || appId === undefined) {
                throw new RequiredError('appId', 'Required parameter appId was null or undefined when calling attachStoreToKiosk.');
            }
            if (storeId === null || storeId === undefined) {
                throw new RequiredError('storeId', 'Required parameter storeId was null or undefined when calling attachStoreToKiosk.');
            }
            if (deviceId === null || deviceId === undefined) {
                throw new RequiredError('deviceId', 'Required parameter deviceId was null or undefined when calling attachStoreToKiosk.');
            }
            var localVarPath = "/api/v1.0/{appId}/AttachStoreToKiosk/{deviceId}/store/{storeId}"
                .replace("{".concat("appId", "}"), encodeURIComponent(String(appId)))
                .replace("{".concat("storeId", "}"), encodeURIComponent(String(storeId)))
                .replace("{".concat("deviceId", "}"), encodeURIComponent(String(deviceId)));
            var localVarUrlObj = url.parse(localVarPath, true);
            var localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            var localVarHeaderParameter = {};
            var localVarQueryParameter = {};
            if (configuration && configuration.accessToken) {
                var localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("oauth2", ["api"])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        attachStoreToTerminal: function (appId, deviceId, storeId, options) {
            if (options === void 0) { options = {}; }
            if (appId === null || appId === undefined) {
                throw new RequiredError('appId', 'Required parameter appId was null or undefined when calling attachStoreToTerminal.');
            }
            if (deviceId === null || deviceId === undefined) {
                throw new RequiredError('deviceId', 'Required parameter deviceId was null or undefined when calling attachStoreToTerminal.');
            }
            if (storeId === null || storeId === undefined) {
                throw new RequiredError('storeId', 'Required parameter storeId was null or undefined when calling attachStoreToTerminal.');
            }
            var localVarPath = "/api/v1.0/{appId}/hydra/{deviceId}/attach/{storeId}"
                .replace("{".concat("appId", "}"), encodeURIComponent(String(appId)))
                .replace("{".concat("deviceId", "}"), encodeURIComponent(String(deviceId)))
                .replace("{".concat("storeId", "}"), encodeURIComponent(String(storeId)));
            var localVarUrlObj = url.parse(localVarPath, true);
            var localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            var localVarHeaderParameter = {};
            var localVarQueryParameter = {};
            if (configuration && configuration.accessToken) {
                var localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("oauth2", ["api"])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        cancelEmvPayment: function (orderId, appId, options) {
            if (options === void 0) { options = {}; }
            if (orderId === null || orderId === undefined) {
                throw new RequiredError('orderId', 'Required parameter orderId was null or undefined when calling cancelEmvPayment.');
            }
            if (appId === null || appId === undefined) {
                throw new RequiredError('appId', 'Required parameter appId was null or undefined when calling cancelEmvPayment.');
            }
            var localVarPath = "/api/v1.0/{appId}/hydra/cancelemvpayment/{orderId}"
                .replace("{".concat("orderId", "}"), encodeURIComponent(String(orderId)))
                .replace("{".concat("appId", "}"), encodeURIComponent(String(appId)));
            var localVarUrlObj = url.parse(localVarPath, true);
            var localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            var localVarHeaderParameter = {};
            var localVarQueryParameter = {};
            if (configuration && configuration.accessToken) {
                var localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("oauth2", ["api"])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        detachStoreFromTerminal: function (appId, deviceId, storeId, options) {
            if (options === void 0) { options = {}; }
            if (appId === null || appId === undefined) {
                throw new RequiredError('appId', 'Required parameter appId was null or undefined when calling detachStoreFromTerminal.');
            }
            if (deviceId === null || deviceId === undefined) {
                throw new RequiredError('deviceId', 'Required parameter deviceId was null or undefined when calling detachStoreFromTerminal.');
            }
            if (storeId === null || storeId === undefined) {
                throw new RequiredError('storeId', 'Required parameter storeId was null or undefined when calling detachStoreFromTerminal.');
            }
            var localVarPath = "/api/v1.0/{appId}/hydra/{deviceId}/detach/{storeId}"
                .replace("{".concat("appId", "}"), encodeURIComponent(String(appId)))
                .replace("{".concat("deviceId", "}"), encodeURIComponent(String(deviceId)))
                .replace("{".concat("storeId", "}"), encodeURIComponent(String(storeId)));
            var localVarUrlObj = url.parse(localVarPath, true);
            var localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            var localVarHeaderParameter = {};
            var localVarQueryParameter = {};
            if (configuration && configuration.accessToken) {
                var localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("oauth2", ["api"])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        getAblyToken: function (options) {
            if (options === void 0) { options = {}; }
            var localVarPath = "/api/v1.0/hydra/ably_token";
            var localVarUrlObj = url.parse(localVarPath, true);
            var localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            var localVarHeaderParameter = {};
            var localVarQueryParameter = {};
            if (configuration && configuration.accessToken) {
                var localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("oauth2", ["api"])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        getAttachedDevice: function (appId, deviceType, deviceId, options) {
            if (options === void 0) { options = {}; }
            if (appId === null || appId === undefined) {
                throw new RequiredError('appId', 'Required parameter appId was null or undefined when calling getAttachedDevice.');
            }
            if (deviceType === null || deviceType === undefined) {
                throw new RequiredError('deviceType', 'Required parameter deviceType was null or undefined when calling getAttachedDevice.');
            }
            if (deviceId === null || deviceId === undefined) {
                throw new RequiredError('deviceId', 'Required parameter deviceId was null or undefined when calling getAttachedDevice.');
            }
            var localVarPath = "/api/v1.0/{appId}/hydra/{deviceType}/{deviceId}"
                .replace("{".concat("appId", "}"), encodeURIComponent(String(appId)))
                .replace("{".concat("deviceType", "}"), encodeURIComponent(String(deviceType)))
                .replace("{".concat("deviceId", "}"), encodeURIComponent(String(deviceId)));
            var localVarUrlObj = url.parse(localVarPath, true);
            var localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            var localVarHeaderParameter = {};
            var localVarQueryParameter = {};
            if (configuration && configuration.accessToken) {
                var localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("oauth2", ["api"])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        getAttachedDevices: function (appId, deviceType, pageIndex, pageSize, storeId, deviceName, deviceSerial, options) {
            if (options === void 0) { options = {}; }
            if (appId === null || appId === undefined) {
                throw new RequiredError('appId', 'Required parameter appId was null or undefined when calling getAttachedDevices.');
            }
            if (deviceType === null || deviceType === undefined) {
                throw new RequiredError('deviceType', 'Required parameter deviceType was null or undefined when calling getAttachedDevices.');
            }
            var localVarPath = "/api/v1.0/{appId}/hydra/{deviceType}/list"
                .replace("{".concat("appId", "}"), encodeURIComponent(String(appId)))
                .replace("{".concat("deviceType", "}"), encodeURIComponent(String(deviceType)));
            var localVarUrlObj = url.parse(localVarPath, true);
            var localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            var localVarHeaderParameter = {};
            var localVarQueryParameter = {};
            if (configuration && configuration.accessToken) {
                var localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("oauth2", ["api"])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }
            if (pageIndex !== undefined) {
                localVarQueryParameter['pageIndex'] = pageIndex;
            }
            if (pageSize !== undefined) {
                localVarQueryParameter['pageSize'] = pageSize;
            }
            if (storeId !== undefined) {
                localVarQueryParameter['storeId'] = storeId;
            }
            if (deviceName !== undefined) {
                localVarQueryParameter['deviceName'] = deviceName;
            }
            if (deviceSerial !== undefined) {
                localVarQueryParameter['deviceSerial'] = deviceSerial;
            }
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        getEMVTerminalDetails: function (appId, options) {
            if (options === void 0) { options = {}; }
            if (appId === null || appId === undefined) {
                throw new RequiredError('appId', 'Required parameter appId was null or undefined when calling getEMVTerminalDetails.');
            }
            var localVarPath = "/api/v1.0/{appId}/hydra/emvterminal"
                .replace("{".concat("appId", "}"), encodeURIComponent(String(appId)));
            var localVarUrlObj = url.parse(localVarPath, true);
            var localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            var localVarHeaderParameter = {};
            var localVarQueryParameter = {};
            if (configuration && configuration.accessToken) {
                var localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("oauth2", ["api"])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        getEmvOrderState: function (orderId, appId, options) {
            if (options === void 0) { options = {}; }
            if (orderId === null || orderId === undefined) {
                throw new RequiredError('orderId', 'Required parameter orderId was null or undefined when calling getEmvOrderState.');
            }
            if (appId === null || appId === undefined) {
                throw new RequiredError('appId', 'Required parameter appId was null or undefined when calling getEmvOrderState.');
            }
            var localVarPath = "/api/v1.0/{appId}/hydra/emvorderstate/{orderId}"
                .replace("{".concat("orderId", "}"), encodeURIComponent(String(orderId)))
                .replace("{".concat("appId", "}"), encodeURIComponent(String(appId)));
            var localVarUrlObj = url.parse(localVarPath, true);
            var localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            var localVarHeaderParameter = {};
            var localVarQueryParameter = {};
            if (configuration && configuration.accessToken) {
                var localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("oauth2", ["api"])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        getKioskCashPaymentSettings: function (appId, deviceId, options) {
            if (options === void 0) { options = {}; }
            if (appId === null || appId === undefined) {
                throw new RequiredError('appId', 'Required parameter appId was null or undefined when calling getKioskCashPaymentSettings.');
            }
            if (deviceId === null || deviceId === undefined) {
                throw new RequiredError('deviceId', 'Required parameter deviceId was null or undefined when calling getKioskCashPaymentSettings.');
            }
            var localVarPath = "/api/v1.0/{appId}/kioskcashsettings/{deviceId}"
                .replace("{".concat("appId", "}"), encodeURIComponent(String(appId)))
                .replace("{".concat("deviceId", "}"), encodeURIComponent(String(deviceId)));
            var localVarUrlObj = url.parse(localVarPath, true);
            var localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            var localVarHeaderParameter = {};
            var localVarQueryParameter = {};
            if (configuration && configuration.accessToken) {
                var localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("oauth2", ["api"])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        getKioskSettings: function (appId, deviceId, options) {
            if (options === void 0) { options = {}; }
            if (appId === null || appId === undefined) {
                throw new RequiredError('appId', 'Required parameter appId was null or undefined when calling getKioskSettings.');
            }
            if (deviceId === null || deviceId === undefined) {
                throw new RequiredError('deviceId', 'Required parameter deviceId was null or undefined when calling getKioskSettings.');
            }
            var localVarPath = "/api/v1.0/{appId}/kiosksettings/{deviceId}"
                .replace("{".concat("appId", "}"), encodeURIComponent(String(appId)))
                .replace("{".concat("deviceId", "}"), encodeURIComponent(String(deviceId)));
            var localVarUrlObj = url.parse(localVarPath, true);
            var localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            var localVarHeaderParameter = {};
            var localVarQueryParameter = {};
            if (configuration && configuration.accessToken) {
                var localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("oauth2", ["api"])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        getRegistration: function (options) {
            if (options === void 0) { options = {}; }
            var localVarPath = "/api/v1.0/hydra/registration";
            var localVarUrlObj = url.parse(localVarPath, true);
            var localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            var localVarHeaderParameter = {};
            var localVarQueryParameter = {};
            if (configuration && configuration.accessToken) {
                var localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("oauth2", ["api"])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        getSettings: function (options) {
            if (options === void 0) { options = {}; }
            var localVarPath = "/api/v1.0/hydra/settings";
            var localVarUrlObj = url.parse(localVarPath, true);
            var localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            var localVarHeaderParameter = {};
            var localVarQueryParameter = {};
            if (configuration && configuration.accessToken) {
                var localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("oauth2", ["api"])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        hydraCreateEmv: function (appId, EmvTerminal, options) {
            if (options === void 0) { options = {}; }
            if (appId === null || appId === undefined) {
                throw new RequiredError('appId', 'Required parameter appId was null or undefined when calling hydraCreateEmv.');
            }
            if (EmvTerminal === null || EmvTerminal === undefined) {
                throw new RequiredError('EmvTerminal', 'Required parameter EmvTerminal was null or undefined when calling hydraCreateEmv.');
            }
            var localVarPath = "/api/v1.0/{appId}/emvterminals"
                .replace("{".concat("appId", "}"), encodeURIComponent(String(appId)));
            var localVarUrlObj = url.parse(localVarPath, true);
            var localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            var localVarHeaderParameter = {};
            var localVarQueryParameter = {};
            if (configuration && configuration.accessToken) {
                var localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("oauth2", ["api"])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }
            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            var needsSerialization = ("EmvTerminal" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body = needsSerialization ? JSON.stringify(EmvTerminal || {}) : (EmvTerminal || "");
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        hydraDeleteEmv: function (appId, id, options) {
            if (options === void 0) { options = {}; }
            if (appId === null || appId === undefined) {
                throw new RequiredError('appId', 'Required parameter appId was null or undefined when calling hydraDeleteEmv.');
            }
            if (id === null || id === undefined) {
                throw new RequiredError('id', 'Required parameter id was null or undefined when calling hydraDeleteEmv.');
            }
            var localVarPath = "/api/v1.0/{appId}/emvterminals/{id}"
                .replace("{".concat("appId", "}"), encodeURIComponent(String(appId)))
                .replace("{".concat("id", "}"), encodeURIComponent(String(id)));
            var localVarUrlObj = url.parse(localVarPath, true);
            var localVarRequestOptions = Object.assign({ method: 'DELETE' }, options);
            var localVarHeaderParameter = {};
            var localVarQueryParameter = {};
            if (configuration && configuration.accessToken) {
                var localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("oauth2", ["api"])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        hydraDetachStoreFromKiosk: function (appId, storeId, deviceId, options) {
            if (options === void 0) { options = {}; }
            if (appId === null || appId === undefined) {
                throw new RequiredError('appId', 'Required parameter appId was null or undefined when calling hydraDetachStoreFromKiosk.');
            }
            if (storeId === null || storeId === undefined) {
                throw new RequiredError('storeId', 'Required parameter storeId was null or undefined when calling hydraDetachStoreFromKiosk.');
            }
            if (deviceId === null || deviceId === undefined) {
                throw new RequiredError('deviceId', 'Required parameter deviceId was null or undefined when calling hydraDetachStoreFromKiosk.');
            }
            var localVarPath = "/api/v1.0/{appId}/DetachStoreFromKiosk/{deviceId}/store/{storeId}"
                .replace("{".concat("appId", "}"), encodeURIComponent(String(appId)))
                .replace("{".concat("storeId", "}"), encodeURIComponent(String(storeId)))
                .replace("{".concat("deviceId", "}"), encodeURIComponent(String(deviceId)));
            var localVarUrlObj = url.parse(localVarPath, true);
            var localVarRequestOptions = Object.assign({ method: 'DELETE' }, options);
            var localVarHeaderParameter = {};
            var localVarQueryParameter = {};
            if (configuration && configuration.accessToken) {
                var localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("oauth2", ["api"])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        hydraGetEmvsForAppId: function (appId, options) {
            if (options === void 0) { options = {}; }
            if (appId === null || appId === undefined) {
                throw new RequiredError('appId', 'Required parameter appId was null or undefined when calling hydraGetEmvsForAppId.');
            }
            var localVarPath = "/api/v1.0/{appId}/emvterminals"
                .replace("{".concat("appId", "}"), encodeURIComponent(String(appId)));
            var localVarUrlObj = url.parse(localVarPath, true);
            var localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            var localVarHeaderParameter = {};
            var localVarQueryParameter = {};
            if (configuration && configuration.accessToken) {
                var localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("oauth2", ["api"])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        loginWithDeviceId: function (deviceId, hydraUserType, serialNumber, options) {
            if (options === void 0) { options = {}; }
            if (deviceId === null || deviceId === undefined) {
                throw new RequiredError('deviceId', 'Required parameter deviceId was null or undefined when calling loginWithDeviceId.');
            }
            var localVarPath = "/api/v1.0/hydra/{deviceId}/login"
                .replace("{".concat("deviceId", "}"), encodeURIComponent(String(deviceId)));
            var localVarUrlObj = url.parse(localVarPath, true);
            var localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            var localVarHeaderParameter = {};
            var localVarQueryParameter = {};
            if (configuration && configuration.accessToken) {
                var localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("oauth2", ["api"])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }
            if (hydraUserType !== undefined) {
                localVarQueryParameter['hydraUserType'] = hydraUserType;
            }
            if (serialNumber !== undefined) {
                localVarQueryParameter['serialNumber'] = serialNumber;
            }
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        register: function (appId, HydraRegistrationRequest, options) {
            if (options === void 0) { options = {}; }
            if (appId === null || appId === undefined) {
                throw new RequiredError('appId', 'Required parameter appId was null or undefined when calling register.');
            }
            if (HydraRegistrationRequest === null || HydraRegistrationRequest === undefined) {
                throw new RequiredError('HydraRegistrationRequest', 'Required parameter HydraRegistrationRequest was null or undefined when calling register.');
            }
            var localVarPath = "/api/v1.0/{appId}/hydra/registration"
                .replace("{".concat("appId", "}"), encodeURIComponent(String(appId)));
            var localVarUrlObj = url.parse(localVarPath, true);
            var localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            var localVarHeaderParameter = {};
            var localVarQueryParameter = {};
            if (configuration && configuration.accessToken) {
                var localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("oauth2", ["api"])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }
            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            var needsSerialization = ("HydraRegistrationRequest" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body = needsSerialization ? JSON.stringify(HydraRegistrationRequest || {}) : (HydraRegistrationRequest || "");
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        unAssign: function (appId, deviceId, options) {
            if (options === void 0) { options = {}; }
            if (appId === null || appId === undefined) {
                throw new RequiredError('appId', 'Required parameter appId was null or undefined when calling unAssign.');
            }
            if (deviceId === null || deviceId === undefined) {
                throw new RequiredError('deviceId', 'Required parameter deviceId was null or undefined when calling unAssign.');
            }
            var localVarPath = "/api/v1.0/{appId}/hydra/{deviceId}/registration"
                .replace("{".concat("appId", "}"), encodeURIComponent(String(appId)))
                .replace("{".concat("deviceId", "}"), encodeURIComponent(String(deviceId)));
            var localVarUrlObj = url.parse(localVarPath, true);
            var localVarRequestOptions = Object.assign({ method: 'DELETE' }, options);
            var localVarHeaderParameter = {};
            var localVarQueryParameter = {};
            if (configuration && configuration.accessToken) {
                var localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("oauth2", ["api"])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        unassignEmv: function (appId, hydraConfigId, options) {
            if (options === void 0) { options = {}; }
            if (appId === null || appId === undefined) {
                throw new RequiredError('appId', 'Required parameter appId was null or undefined when calling unassignEmv.');
            }
            if (hydraConfigId === null || hydraConfigId === undefined) {
                throw new RequiredError('hydraConfigId', 'Required parameter hydraConfigId was null or undefined when calling unassignEmv.');
            }
            var localVarPath = "/api/v1.0/{appId}/hydra/emvterminal/unassign/{hydraConfigId}"
                .replace("{".concat("appId", "}"), encodeURIComponent(String(appId)))
                .replace("{".concat("hydraConfigId", "}"), encodeURIComponent(String(hydraConfigId)));
            var localVarUrlObj = url.parse(localVarPath, true);
            var localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            var localVarHeaderParameter = {};
            var localVarQueryParameter = {};
            if (configuration && configuration.accessToken) {
                var localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("oauth2", ["api"])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        updateKioskCashVisibilitySettings: function (appId, deviceId, isCashEnabled, options) {
            if (options === void 0) { options = {}; }
            if (appId === null || appId === undefined) {
                throw new RequiredError('appId', 'Required parameter appId was null or undefined when calling updateKioskCashVisibilitySettings.');
            }
            if (deviceId === null || deviceId === undefined) {
                throw new RequiredError('deviceId', 'Required parameter deviceId was null or undefined when calling updateKioskCashVisibilitySettings.');
            }
            if (isCashEnabled === null || isCashEnabled === undefined) {
                throw new RequiredError('isCashEnabled', 'Required parameter isCashEnabled was null or undefined when calling updateKioskCashVisibilitySettings.');
            }
            var localVarPath = "/api/v1.0/{appId}/kioskupdatecashsettings"
                .replace("{".concat("appId", "}"), encodeURIComponent(String(appId)));
            var localVarUrlObj = url.parse(localVarPath, true);
            var localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            var localVarHeaderParameter = {};
            var localVarQueryParameter = {};
            if (configuration && configuration.accessToken) {
                var localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("oauth2", ["api"])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }
            if (deviceId !== undefined) {
                localVarQueryParameter['deviceId'] = deviceId;
            }
            if (isCashEnabled !== undefined) {
                localVarQueryParameter['isCashEnabled'] = isCashEnabled;
            }
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        updateKioskSettings: function (appId, deviceId, KioskSettings, options) {
            if (options === void 0) { options = {}; }
            if (appId === null || appId === undefined) {
                throw new RequiredError('appId', 'Required parameter appId was null or undefined when calling updateKioskSettings.');
            }
            if (deviceId === null || deviceId === undefined) {
                throw new RequiredError('deviceId', 'Required parameter deviceId was null or undefined when calling updateKioskSettings.');
            }
            if (KioskSettings === null || KioskSettings === undefined) {
                throw new RequiredError('KioskSettings', 'Required parameter KioskSettings was null or undefined when calling updateKioskSettings.');
            }
            var localVarPath = "/api/v1.0/{appId}/kiosksettings/{deviceId}"
                .replace("{".concat("appId", "}"), encodeURIComponent(String(appId)))
                .replace("{".concat("deviceId", "}"), encodeURIComponent(String(deviceId)));
            var localVarUrlObj = url.parse(localVarPath, true);
            var localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            var localVarHeaderParameter = {};
            var localVarQueryParameter = {};
            if (configuration && configuration.accessToken) {
                var localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("oauth2", ["api"])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }
            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            var needsSerialization = ("KioskSettings" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body = needsSerialization ? JSON.stringify(KioskSettings || {}) : (KioskSettings || "");
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    };
};
exports.HydraApiFetchParamCreator = HydraApiFetchParamCreator;
var HydraApiFp = function (configuration) {
    return {
        assignEmv: function (appId, hydraConfigId, emvTerminalId, options) {
            var localVarFetchArgs = (0, exports.HydraApiFetchParamCreator)(configuration).assignEmv(appId, hydraConfigId, emvTerminalId, options);
            return function (fetch, basePath) {
                if (fetch === void 0) { fetch = portableFetch; }
                if (basePath === void 0) { basePath = BASE_PATH; }
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then(function (response) {
                    if (response.status >= 200 && response.status < 300) {
                        return response;
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
        attachStoreToKiosk: function (appId, storeId, deviceId, options) {
            var localVarFetchArgs = (0, exports.HydraApiFetchParamCreator)(configuration).attachStoreToKiosk(appId, storeId, deviceId, options);
            return function (fetch, basePath) {
                if (fetch === void 0) { fetch = portableFetch; }
                if (basePath === void 0) { basePath = BASE_PATH; }
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then(function (response) {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
        attachStoreToTerminal: function (appId, deviceId, storeId, options) {
            var localVarFetchArgs = (0, exports.HydraApiFetchParamCreator)(configuration).attachStoreToTerminal(appId, deviceId, storeId, options);
            return function (fetch, basePath) {
                if (fetch === void 0) { fetch = portableFetch; }
                if (basePath === void 0) { basePath = BASE_PATH; }
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then(function (response) {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
        cancelEmvPayment: function (orderId, appId, options) {
            var localVarFetchArgs = (0, exports.HydraApiFetchParamCreator)(configuration).cancelEmvPayment(orderId, appId, options);
            return function (fetch, basePath) {
                if (fetch === void 0) { fetch = portableFetch; }
                if (basePath === void 0) { basePath = BASE_PATH; }
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then(function (response) {
                    if (response.status >= 200 && response.status < 300) {
                        return response;
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
        detachStoreFromTerminal: function (appId, deviceId, storeId, options) {
            var localVarFetchArgs = (0, exports.HydraApiFetchParamCreator)(configuration).detachStoreFromTerminal(appId, deviceId, storeId, options);
            return function (fetch, basePath) {
                if (fetch === void 0) { fetch = portableFetch; }
                if (basePath === void 0) { basePath = BASE_PATH; }
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then(function (response) {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
        getAblyToken: function (options) {
            var localVarFetchArgs = (0, exports.HydraApiFetchParamCreator)(configuration).getAblyToken(options);
            return function (fetch, basePath) {
                if (fetch === void 0) { fetch = portableFetch; }
                if (basePath === void 0) { basePath = BASE_PATH; }
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then(function (response) {
                    if (response.status >= 200 && response.status < 300) {
                        return response;
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
        getAttachedDevice: function (appId, deviceType, deviceId, options) {
            var localVarFetchArgs = (0, exports.HydraApiFetchParamCreator)(configuration).getAttachedDevice(appId, deviceType, deviceId, options);
            return function (fetch, basePath) {
                if (fetch === void 0) { fetch = portableFetch; }
                if (basePath === void 0) { basePath = BASE_PATH; }
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then(function (response) {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
        getAttachedDevices: function (appId, deviceType, pageIndex, pageSize, storeId, deviceName, deviceSerial, options) {
            var localVarFetchArgs = (0, exports.HydraApiFetchParamCreator)(configuration).getAttachedDevices(appId, deviceType, pageIndex, pageSize, storeId, deviceName, deviceSerial, options);
            return function (fetch, basePath) {
                if (fetch === void 0) { fetch = portableFetch; }
                if (basePath === void 0) { basePath = BASE_PATH; }
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then(function (response) {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
        getEMVTerminalDetails: function (appId, options) {
            var localVarFetchArgs = (0, exports.HydraApiFetchParamCreator)(configuration).getEMVTerminalDetails(appId, options);
            return function (fetch, basePath) {
                if (fetch === void 0) { fetch = portableFetch; }
                if (basePath === void 0) { basePath = BASE_PATH; }
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then(function (response) {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
        getEmvOrderState: function (orderId, appId, options) {
            var localVarFetchArgs = (0, exports.HydraApiFetchParamCreator)(configuration).getEmvOrderState(orderId, appId, options);
            return function (fetch, basePath) {
                if (fetch === void 0) { fetch = portableFetch; }
                if (basePath === void 0) { basePath = BASE_PATH; }
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then(function (response) {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
        getKioskCashPaymentSettings: function (appId, deviceId, options) {
            var localVarFetchArgs = (0, exports.HydraApiFetchParamCreator)(configuration).getKioskCashPaymentSettings(appId, deviceId, options);
            return function (fetch, basePath) {
                if (fetch === void 0) { fetch = portableFetch; }
                if (basePath === void 0) { basePath = BASE_PATH; }
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then(function (response) {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
        getKioskSettings: function (appId, deviceId, options) {
            var localVarFetchArgs = (0, exports.HydraApiFetchParamCreator)(configuration).getKioskSettings(appId, deviceId, options);
            return function (fetch, basePath) {
                if (fetch === void 0) { fetch = portableFetch; }
                if (basePath === void 0) { basePath = BASE_PATH; }
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then(function (response) {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
        getRegistration: function (options) {
            var localVarFetchArgs = (0, exports.HydraApiFetchParamCreator)(configuration).getRegistration(options);
            return function (fetch, basePath) {
                if (fetch === void 0) { fetch = portableFetch; }
                if (basePath === void 0) { basePath = BASE_PATH; }
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then(function (response) {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
        getSettings: function (options) {
            var localVarFetchArgs = (0, exports.HydraApiFetchParamCreator)(configuration).getSettings(options);
            return function (fetch, basePath) {
                if (fetch === void 0) { fetch = portableFetch; }
                if (basePath === void 0) { basePath = BASE_PATH; }
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then(function (response) {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
        hydraCreateEmv: function (appId, EmvTerminal, options) {
            var localVarFetchArgs = (0, exports.HydraApiFetchParamCreator)(configuration).hydraCreateEmv(appId, EmvTerminal, options);
            return function (fetch, basePath) {
                if (fetch === void 0) { fetch = portableFetch; }
                if (basePath === void 0) { basePath = BASE_PATH; }
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then(function (response) {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
        hydraDeleteEmv: function (appId, id, options) {
            var localVarFetchArgs = (0, exports.HydraApiFetchParamCreator)(configuration).hydraDeleteEmv(appId, id, options);
            return function (fetch, basePath) {
                if (fetch === void 0) { fetch = portableFetch; }
                if (basePath === void 0) { basePath = BASE_PATH; }
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then(function (response) {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
        hydraDetachStoreFromKiosk: function (appId, storeId, deviceId, options) {
            var localVarFetchArgs = (0, exports.HydraApiFetchParamCreator)(configuration).hydraDetachStoreFromKiosk(appId, storeId, deviceId, options);
            return function (fetch, basePath) {
                if (fetch === void 0) { fetch = portableFetch; }
                if (basePath === void 0) { basePath = BASE_PATH; }
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then(function (response) {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
        hydraGetEmvsForAppId: function (appId, options) {
            var localVarFetchArgs = (0, exports.HydraApiFetchParamCreator)(configuration).hydraGetEmvsForAppId(appId, options);
            return function (fetch, basePath) {
                if (fetch === void 0) { fetch = portableFetch; }
                if (basePath === void 0) { basePath = BASE_PATH; }
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then(function (response) {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
        loginWithDeviceId: function (deviceId, hydraUserType, serialNumber, options) {
            var localVarFetchArgs = (0, exports.HydraApiFetchParamCreator)(configuration).loginWithDeviceId(deviceId, hydraUserType, serialNumber, options);
            return function (fetch, basePath) {
                if (fetch === void 0) { fetch = portableFetch; }
                if (basePath === void 0) { basePath = BASE_PATH; }
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then(function (response) {
                    if (response.status >= 200 && response.status < 300) {
                        return response;
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
        register: function (appId, HydraRegistrationRequest, options) {
            var localVarFetchArgs = (0, exports.HydraApiFetchParamCreator)(configuration).register(appId, HydraRegistrationRequest, options);
            return function (fetch, basePath) {
                if (fetch === void 0) { fetch = portableFetch; }
                if (basePath === void 0) { basePath = BASE_PATH; }
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then(function (response) {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
        unAssign: function (appId, deviceId, options) {
            var localVarFetchArgs = (0, exports.HydraApiFetchParamCreator)(configuration).unAssign(appId, deviceId, options);
            return function (fetch, basePath) {
                if (fetch === void 0) { fetch = portableFetch; }
                if (basePath === void 0) { basePath = BASE_PATH; }
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then(function (response) {
                    if (response.status >= 200 && response.status < 300) {
                        return response;
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
        unassignEmv: function (appId, hydraConfigId, options) {
            var localVarFetchArgs = (0, exports.HydraApiFetchParamCreator)(configuration).unassignEmv(appId, hydraConfigId, options);
            return function (fetch, basePath) {
                if (fetch === void 0) { fetch = portableFetch; }
                if (basePath === void 0) { basePath = BASE_PATH; }
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then(function (response) {
                    if (response.status >= 200 && response.status < 300) {
                        return response;
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
        updateKioskCashVisibilitySettings: function (appId, deviceId, isCashEnabled, options) {
            var localVarFetchArgs = (0, exports.HydraApiFetchParamCreator)(configuration).updateKioskCashVisibilitySettings(appId, deviceId, isCashEnabled, options);
            return function (fetch, basePath) {
                if (fetch === void 0) { fetch = portableFetch; }
                if (basePath === void 0) { basePath = BASE_PATH; }
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then(function (response) {
                    if (response.status >= 200 && response.status < 300) {
                        return response;
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
        updateKioskSettings: function (appId, deviceId, KioskSettings, options) {
            var localVarFetchArgs = (0, exports.HydraApiFetchParamCreator)(configuration).updateKioskSettings(appId, deviceId, KioskSettings, options);
            return function (fetch, basePath) {
                if (fetch === void 0) { fetch = portableFetch; }
                if (basePath === void 0) { basePath = BASE_PATH; }
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then(function (response) {
                    if (response.status >= 200 && response.status < 300) {
                        return response;
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
    };
};
exports.HydraApiFp = HydraApiFp;
var HydraApiFactory = function (configuration, fetch, basePath) {
    return {
        assignEmv: function (appId, hydraConfigId, emvTerminalId, options) {
            return (0, exports.HydraApiFp)(configuration).assignEmv(appId, hydraConfigId, emvTerminalId, options)(fetch, basePath);
        },
        attachStoreToKiosk: function (appId, storeId, deviceId, options) {
            return (0, exports.HydraApiFp)(configuration).attachStoreToKiosk(appId, storeId, deviceId, options)(fetch, basePath);
        },
        attachStoreToTerminal: function (appId, deviceId, storeId, options) {
            return (0, exports.HydraApiFp)(configuration).attachStoreToTerminal(appId, deviceId, storeId, options)(fetch, basePath);
        },
        cancelEmvPayment: function (orderId, appId, options) {
            return (0, exports.HydraApiFp)(configuration).cancelEmvPayment(orderId, appId, options)(fetch, basePath);
        },
        detachStoreFromTerminal: function (appId, deviceId, storeId, options) {
            return (0, exports.HydraApiFp)(configuration).detachStoreFromTerminal(appId, deviceId, storeId, options)(fetch, basePath);
        },
        getAblyToken: function (options) {
            return (0, exports.HydraApiFp)(configuration).getAblyToken(options)(fetch, basePath);
        },
        getAttachedDevice: function (appId, deviceType, deviceId, options) {
            return (0, exports.HydraApiFp)(configuration).getAttachedDevice(appId, deviceType, deviceId, options)(fetch, basePath);
        },
        getAttachedDevices: function (appId, deviceType, pageIndex, pageSize, storeId, deviceName, deviceSerial, options) {
            return (0, exports.HydraApiFp)(configuration).getAttachedDevices(appId, deviceType, pageIndex, pageSize, storeId, deviceName, deviceSerial, options)(fetch, basePath);
        },
        getEMVTerminalDetails: function (appId, options) {
            return (0, exports.HydraApiFp)(configuration).getEMVTerminalDetails(appId, options)(fetch, basePath);
        },
        getEmvOrderState: function (orderId, appId, options) {
            return (0, exports.HydraApiFp)(configuration).getEmvOrderState(orderId, appId, options)(fetch, basePath);
        },
        getKioskCashPaymentSettings: function (appId, deviceId, options) {
            return (0, exports.HydraApiFp)(configuration).getKioskCashPaymentSettings(appId, deviceId, options)(fetch, basePath);
        },
        getKioskSettings: function (appId, deviceId, options) {
            return (0, exports.HydraApiFp)(configuration).getKioskSettings(appId, deviceId, options)(fetch, basePath);
        },
        getRegistration: function (options) {
            return (0, exports.HydraApiFp)(configuration).getRegistration(options)(fetch, basePath);
        },
        getSettings: function (options) {
            return (0, exports.HydraApiFp)(configuration).getSettings(options)(fetch, basePath);
        },
        hydraCreateEmv: function (appId, EmvTerminal, options) {
            return (0, exports.HydraApiFp)(configuration).hydraCreateEmv(appId, EmvTerminal, options)(fetch, basePath);
        },
        hydraDeleteEmv: function (appId, id, options) {
            return (0, exports.HydraApiFp)(configuration).hydraDeleteEmv(appId, id, options)(fetch, basePath);
        },
        hydraDetachStoreFromKiosk: function (appId, storeId, deviceId, options) {
            return (0, exports.HydraApiFp)(configuration).hydraDetachStoreFromKiosk(appId, storeId, deviceId, options)(fetch, basePath);
        },
        hydraGetEmvsForAppId: function (appId, options) {
            return (0, exports.HydraApiFp)(configuration).hydraGetEmvsForAppId(appId, options)(fetch, basePath);
        },
        loginWithDeviceId: function (deviceId, hydraUserType, serialNumber, options) {
            return (0, exports.HydraApiFp)(configuration).loginWithDeviceId(deviceId, hydraUserType, serialNumber, options)(fetch, basePath);
        },
        register: function (appId, HydraRegistrationRequest, options) {
            return (0, exports.HydraApiFp)(configuration).register(appId, HydraRegistrationRequest, options)(fetch, basePath);
        },
        unAssign: function (appId, deviceId, options) {
            return (0, exports.HydraApiFp)(configuration).unAssign(appId, deviceId, options)(fetch, basePath);
        },
        unassignEmv: function (appId, hydraConfigId, options) {
            return (0, exports.HydraApiFp)(configuration).unassignEmv(appId, hydraConfigId, options)(fetch, basePath);
        },
        updateKioskCashVisibilitySettings: function (appId, deviceId, isCashEnabled, options) {
            return (0, exports.HydraApiFp)(configuration).updateKioskCashVisibilitySettings(appId, deviceId, isCashEnabled, options)(fetch, basePath);
        },
        updateKioskSettings: function (appId, deviceId, KioskSettings, options) {
            return (0, exports.HydraApiFp)(configuration).updateKioskSettings(appId, deviceId, KioskSettings, options)(fetch, basePath);
        },
    };
};
exports.HydraApiFactory = HydraApiFactory;
var HydraApi = (function (_super) {
    __extends(HydraApi, _super);
    function HydraApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    HydraApi.prototype.assignEmv = function (appId, hydraConfigId, emvTerminalId, options) {
        return (0, exports.HydraApiFp)(this.configuration).assignEmv(appId, hydraConfigId, emvTerminalId, options)(this.fetch, this.basePath);
    };
    HydraApi.prototype.attachStoreToKiosk = function (appId, storeId, deviceId, options) {
        return (0, exports.HydraApiFp)(this.configuration).attachStoreToKiosk(appId, storeId, deviceId, options)(this.fetch, this.basePath);
    };
    HydraApi.prototype.attachStoreToTerminal = function (appId, deviceId, storeId, options) {
        return (0, exports.HydraApiFp)(this.configuration).attachStoreToTerminal(appId, deviceId, storeId, options)(this.fetch, this.basePath);
    };
    HydraApi.prototype.cancelEmvPayment = function (orderId, appId, options) {
        return (0, exports.HydraApiFp)(this.configuration).cancelEmvPayment(orderId, appId, options)(this.fetch, this.basePath);
    };
    HydraApi.prototype.detachStoreFromTerminal = function (appId, deviceId, storeId, options) {
        return (0, exports.HydraApiFp)(this.configuration).detachStoreFromTerminal(appId, deviceId, storeId, options)(this.fetch, this.basePath);
    };
    HydraApi.prototype.getAblyToken = function (options) {
        return (0, exports.HydraApiFp)(this.configuration).getAblyToken(options)(this.fetch, this.basePath);
    };
    HydraApi.prototype.getAttachedDevice = function (appId, deviceType, deviceId, options) {
        return (0, exports.HydraApiFp)(this.configuration).getAttachedDevice(appId, deviceType, deviceId, options)(this.fetch, this.basePath);
    };
    HydraApi.prototype.getAttachedDevices = function (appId, deviceType, pageIndex, pageSize, storeId, deviceName, deviceSerial, options) {
        return (0, exports.HydraApiFp)(this.configuration).getAttachedDevices(appId, deviceType, pageIndex, pageSize, storeId, deviceName, deviceSerial, options)(this.fetch, this.basePath);
    };
    HydraApi.prototype.getEMVTerminalDetails = function (appId, options) {
        return (0, exports.HydraApiFp)(this.configuration).getEMVTerminalDetails(appId, options)(this.fetch, this.basePath);
    };
    HydraApi.prototype.getEmvOrderState = function (orderId, appId, options) {
        return (0, exports.HydraApiFp)(this.configuration).getEmvOrderState(orderId, appId, options)(this.fetch, this.basePath);
    };
    HydraApi.prototype.getKioskCashPaymentSettings = function (appId, deviceId, options) {
        return (0, exports.HydraApiFp)(this.configuration).getKioskCashPaymentSettings(appId, deviceId, options)(this.fetch, this.basePath);
    };
    HydraApi.prototype.getKioskSettings = function (appId, deviceId, options) {
        return (0, exports.HydraApiFp)(this.configuration).getKioskSettings(appId, deviceId, options)(this.fetch, this.basePath);
    };
    HydraApi.prototype.getRegistration = function (options) {
        return (0, exports.HydraApiFp)(this.configuration).getRegistration(options)(this.fetch, this.basePath);
    };
    HydraApi.prototype.getSettings = function (options) {
        return (0, exports.HydraApiFp)(this.configuration).getSettings(options)(this.fetch, this.basePath);
    };
    HydraApi.prototype.hydraCreateEmv = function (appId, EmvTerminal, options) {
        return (0, exports.HydraApiFp)(this.configuration).hydraCreateEmv(appId, EmvTerminal, options)(this.fetch, this.basePath);
    };
    HydraApi.prototype.hydraDeleteEmv = function (appId, id, options) {
        return (0, exports.HydraApiFp)(this.configuration).hydraDeleteEmv(appId, id, options)(this.fetch, this.basePath);
    };
    HydraApi.prototype.hydraDetachStoreFromKiosk = function (appId, storeId, deviceId, options) {
        return (0, exports.HydraApiFp)(this.configuration).hydraDetachStoreFromKiosk(appId, storeId, deviceId, options)(this.fetch, this.basePath);
    };
    HydraApi.prototype.hydraGetEmvsForAppId = function (appId, options) {
        return (0, exports.HydraApiFp)(this.configuration).hydraGetEmvsForAppId(appId, options)(this.fetch, this.basePath);
    };
    HydraApi.prototype.loginWithDeviceId = function (deviceId, hydraUserType, serialNumber, options) {
        return (0, exports.HydraApiFp)(this.configuration).loginWithDeviceId(deviceId, hydraUserType, serialNumber, options)(this.fetch, this.basePath);
    };
    HydraApi.prototype.register = function (appId, HydraRegistrationRequest, options) {
        return (0, exports.HydraApiFp)(this.configuration).register(appId, HydraRegistrationRequest, options)(this.fetch, this.basePath);
    };
    HydraApi.prototype.unAssign = function (appId, deviceId, options) {
        return (0, exports.HydraApiFp)(this.configuration).unAssign(appId, deviceId, options)(this.fetch, this.basePath);
    };
    HydraApi.prototype.unassignEmv = function (appId, hydraConfigId, options) {
        return (0, exports.HydraApiFp)(this.configuration).unassignEmv(appId, hydraConfigId, options)(this.fetch, this.basePath);
    };
    HydraApi.prototype.updateKioskCashVisibilitySettings = function (appId, deviceId, isCashEnabled, options) {
        return (0, exports.HydraApiFp)(this.configuration).updateKioskCashVisibilitySettings(appId, deviceId, isCashEnabled, options)(this.fetch, this.basePath);
    };
    HydraApi.prototype.updateKioskSettings = function (appId, deviceId, KioskSettings, options) {
        return (0, exports.HydraApiFp)(this.configuration).updateKioskSettings(appId, deviceId, KioskSettings, options)(this.fetch, this.basePath);
    };
    return HydraApi;
}(BaseAPI));
exports.HydraApi = HydraApi;
var IntegrationMetadataCatalogueApiFetchParamCreator = function (configuration) {
    return {
        integrationMetadataCatalogueGetPixelPointProducts: function (storeId, nameContains, page, pageSize, options) {
            if (options === void 0) { options = {}; }
            if (storeId === null || storeId === undefined) {
                throw new RequiredError('storeId', 'Required parameter storeId was null or undefined when calling integrationMetadataCatalogueGetPixelPointProducts.');
            }
            var localVarPath = "/api/v1.0/integrationmetadatacatalogue/pixelpoint/stores/{storeId}/products"
                .replace("{".concat("storeId", "}"), encodeURIComponent(String(storeId)));
            var localVarUrlObj = url.parse(localVarPath, true);
            var localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            var localVarHeaderParameter = {};
            var localVarQueryParameter = {};
            if (configuration && configuration.accessToken) {
                var localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("oauth2", ["api"])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }
            if (nameContains !== undefined) {
                localVarQueryParameter['nameContains'] = nameContains;
            }
            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }
            if (pageSize !== undefined) {
                localVarQueryParameter['pageSize'] = pageSize;
            }
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    };
};
exports.IntegrationMetadataCatalogueApiFetchParamCreator = IntegrationMetadataCatalogueApiFetchParamCreator;
var IntegrationMetadataCatalogueApiFp = function (configuration) {
    return {
        integrationMetadataCatalogueGetPixelPointProducts: function (storeId, nameContains, page, pageSize, options) {
            var localVarFetchArgs = (0, exports.IntegrationMetadataCatalogueApiFetchParamCreator)(configuration).integrationMetadataCatalogueGetPixelPointProducts(storeId, nameContains, page, pageSize, options);
            return function (fetch, basePath) {
                if (fetch === void 0) { fetch = portableFetch; }
                if (basePath === void 0) { basePath = BASE_PATH; }
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then(function (response) {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
    };
};
exports.IntegrationMetadataCatalogueApiFp = IntegrationMetadataCatalogueApiFp;
var IntegrationMetadataCatalogueApiFactory = function (configuration, fetch, basePath) {
    return {
        integrationMetadataCatalogueGetPixelPointProducts: function (storeId, nameContains, page, pageSize, options) {
            return (0, exports.IntegrationMetadataCatalogueApiFp)(configuration).integrationMetadataCatalogueGetPixelPointProducts(storeId, nameContains, page, pageSize, options)(fetch, basePath);
        },
    };
};
exports.IntegrationMetadataCatalogueApiFactory = IntegrationMetadataCatalogueApiFactory;
var IntegrationMetadataCatalogueApi = (function (_super) {
    __extends(IntegrationMetadataCatalogueApi, _super);
    function IntegrationMetadataCatalogueApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    IntegrationMetadataCatalogueApi.prototype.integrationMetadataCatalogueGetPixelPointProducts = function (storeId, nameContains, page, pageSize, options) {
        return (0, exports.IntegrationMetadataCatalogueApiFp)(this.configuration).integrationMetadataCatalogueGetPixelPointProducts(storeId, nameContains, page, pageSize, options)(this.fetch, this.basePath);
    };
    return IntegrationMetadataCatalogueApi;
}(BaseAPI));
exports.IntegrationMetadataCatalogueApi = IntegrationMetadataCatalogueApi;
var IntercomApiFetchParamCreator = function (configuration) {
    return {
        userHash: function (options) {
            if (options === void 0) { options = {}; }
            var localVarPath = "/api/v1.0/intercom/userHash";
            var localVarUrlObj = url.parse(localVarPath, true);
            var localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            var localVarHeaderParameter = {};
            var localVarQueryParameter = {};
            if (configuration && configuration.accessToken) {
                var localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("oauth2", ["api"])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    };
};
exports.IntercomApiFetchParamCreator = IntercomApiFetchParamCreator;
var IntercomApiFp = function (configuration) {
    return {
        userHash: function (options) {
            var localVarFetchArgs = (0, exports.IntercomApiFetchParamCreator)(configuration).userHash(options);
            return function (fetch, basePath) {
                if (fetch === void 0) { fetch = portableFetch; }
                if (basePath === void 0) { basePath = BASE_PATH; }
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then(function (response) {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
    };
};
exports.IntercomApiFp = IntercomApiFp;
var IntercomApiFactory = function (configuration, fetch, basePath) {
    return {
        userHash: function (options) {
            return (0, exports.IntercomApiFp)(configuration).userHash(options)(fetch, basePath);
        },
    };
};
exports.IntercomApiFactory = IntercomApiFactory;
var IntercomApi = (function (_super) {
    __extends(IntercomApi, _super);
    function IntercomApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    IntercomApi.prototype.userHash = function (options) {
        return (0, exports.IntercomApiFp)(this.configuration).userHash(options)(this.fetch, this.basePath);
    };
    return IntercomApi;
}(BaseAPI));
exports.IntercomApi = IntercomApi;
var InvoicesApiFetchParamCreator = function (configuration) {
    return {
        getInvoices: function (appId, subscriptionId, limit, pageId, excludeNotOwnedInvoices, dateFrom, dateTo, invoiceNumber, storeId, options) {
            if (options === void 0) { options = {}; }
            if (appId === null || appId === undefined) {
                throw new RequiredError('appId', 'Required parameter appId was null or undefined when calling getInvoices.');
            }
            var localVarPath = "/api/v1.0/{appId}/invoices"
                .replace("{".concat("appId", "}"), encodeURIComponent(String(appId)));
            var localVarUrlObj = url.parse(localVarPath, true);
            var localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            var localVarHeaderParameter = {};
            var localVarQueryParameter = {};
            if (configuration && configuration.accessToken) {
                var localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("oauth2", ["api"])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }
            if (subscriptionId !== undefined) {
                localVarQueryParameter['subscriptionId'] = subscriptionId;
            }
            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }
            if (pageId !== undefined) {
                localVarQueryParameter['pageId'] = pageId;
            }
            if (excludeNotOwnedInvoices !== undefined) {
                localVarQueryParameter['excludeNotOwnedInvoices'] = excludeNotOwnedInvoices;
            }
            if (dateFrom !== undefined) {
                localVarQueryParameter['dateFrom'] = dateFrom;
            }
            if (dateTo !== undefined) {
                localVarQueryParameter['dateTo'] = dateTo;
            }
            if (invoiceNumber !== undefined) {
                localVarQueryParameter['invoiceNumber'] = invoiceNumber;
            }
            if (storeId) {
                localVarQueryParameter['storeId'] = storeId;
            }
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        invoicePdf: function (invoiceNumber, appId, options) {
            if (options === void 0) { options = {}; }
            if (invoiceNumber === null || invoiceNumber === undefined) {
                throw new RequiredError('invoiceNumber', 'Required parameter invoiceNumber was null or undefined when calling invoicePdf.');
            }
            if (appId === null || appId === undefined) {
                throw new RequiredError('appId', 'Required parameter appId was null or undefined when calling invoicePdf.');
            }
            var localVarPath = "/api/v1.0/{appId}/invoices/InvoicePdf"
                .replace("{".concat("appId", "}"), encodeURIComponent(String(appId)));
            var localVarUrlObj = url.parse(localVarPath, true);
            var localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            var localVarHeaderParameter = {};
            var localVarQueryParameter = {};
            if (configuration && configuration.accessToken) {
                var localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("oauth2", ["api"])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }
            if (invoiceNumber !== undefined) {
                localVarQueryParameter['invoiceNumber'] = invoiceNumber;
            }
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        listInvoices: function (storeId, appId, limit, page, options) {
            if (options === void 0) { options = {}; }
            if (storeId === null || storeId === undefined) {
                throw new RequiredError('storeId', 'Required parameter storeId was null or undefined when calling listInvoices.');
            }
            if (appId === null || appId === undefined) {
                throw new RequiredError('appId', 'Required parameter appId was null or undefined when calling listInvoices.');
            }
            var localVarPath = "/api/v1.0/{appId}/invoices/ListInvoices"
                .replace("{".concat("appId", "}"), encodeURIComponent(String(appId)));
            var localVarUrlObj = url.parse(localVarPath, true);
            var localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            var localVarHeaderParameter = {};
            var localVarQueryParameter = {};
            if (configuration && configuration.accessToken) {
                var localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("oauth2", ["api"])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }
            if (storeId !== undefined) {
                localVarQueryParameter['storeId'] = storeId;
            }
            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }
            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        listSubscriptionInvoices: function (appId, subscriptionId, limit, pageId, excludeNotOwnedInvoices, dateFrom, dateTo, invoiceNumber, storeId, options) {
            if (options === void 0) { options = {}; }
            if (appId === null || appId === undefined) {
                throw new RequiredError('appId', 'Required parameter appId was null or undefined when calling listSubscriptionInvoices.');
            }
            var localVarPath = "/api/v1.0/{appId}/invoices/ListSubscriptionInvoices"
                .replace("{".concat("appId", "}"), encodeURIComponent(String(appId)));
            var localVarUrlObj = url.parse(localVarPath, true);
            var localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            var localVarHeaderParameter = {};
            var localVarQueryParameter = {};
            if (configuration && configuration.accessToken) {
                var localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("oauth2", ["api"])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }
            if (subscriptionId !== undefined) {
                localVarQueryParameter['subscriptionId'] = subscriptionId;
            }
            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }
            if (pageId !== undefined) {
                localVarQueryParameter['pageId'] = pageId;
            }
            if (excludeNotOwnedInvoices !== undefined) {
                localVarQueryParameter['excludeNotOwnedInvoices'] = excludeNotOwnedInvoices;
            }
            if (dateFrom !== undefined) {
                localVarQueryParameter['dateFrom'] = dateFrom;
            }
            if (dateTo !== undefined) {
                localVarQueryParameter['dateTo'] = dateTo;
            }
            if (invoiceNumber !== undefined) {
                localVarQueryParameter['invoiceNumber'] = invoiceNumber;
            }
            if (storeId) {
                localVarQueryParameter['storeId'] = storeId;
            }
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    };
};
exports.InvoicesApiFetchParamCreator = InvoicesApiFetchParamCreator;
var InvoicesApiFp = function (configuration) {
    return {
        getInvoices: function (appId, subscriptionId, limit, pageId, excludeNotOwnedInvoices, dateFrom, dateTo, invoiceNumber, storeId, options) {
            var localVarFetchArgs = (0, exports.InvoicesApiFetchParamCreator)(configuration).getInvoices(appId, subscriptionId, limit, pageId, excludeNotOwnedInvoices, dateFrom, dateTo, invoiceNumber, storeId, options);
            return function (fetch, basePath) {
                if (fetch === void 0) { fetch = portableFetch; }
                if (basePath === void 0) { basePath = BASE_PATH; }
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then(function (response) {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
        invoicePdf: function (invoiceNumber, appId, options) {
            var localVarFetchArgs = (0, exports.InvoicesApiFetchParamCreator)(configuration).invoicePdf(invoiceNumber, appId, options);
            return function (fetch, basePath) {
                if (fetch === void 0) { fetch = portableFetch; }
                if (basePath === void 0) { basePath = BASE_PATH; }
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then(function (response) {
                    if (response.status >= 200 && response.status < 300) {
                        return response;
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
        listInvoices: function (storeId, appId, limit, page, options) {
            var localVarFetchArgs = (0, exports.InvoicesApiFetchParamCreator)(configuration).listInvoices(storeId, appId, limit, page, options);
            return function (fetch, basePath) {
                if (fetch === void 0) { fetch = portableFetch; }
                if (basePath === void 0) { basePath = BASE_PATH; }
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then(function (response) {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
        listSubscriptionInvoices: function (appId, subscriptionId, limit, pageId, excludeNotOwnedInvoices, dateFrom, dateTo, invoiceNumber, storeId, options) {
            var localVarFetchArgs = (0, exports.InvoicesApiFetchParamCreator)(configuration).listSubscriptionInvoices(appId, subscriptionId, limit, pageId, excludeNotOwnedInvoices, dateFrom, dateTo, invoiceNumber, storeId, options);
            return function (fetch, basePath) {
                if (fetch === void 0) { fetch = portableFetch; }
                if (basePath === void 0) { basePath = BASE_PATH; }
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then(function (response) {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
    };
};
exports.InvoicesApiFp = InvoicesApiFp;
var InvoicesApiFactory = function (configuration, fetch, basePath) {
    return {
        getInvoices: function (appId, subscriptionId, limit, pageId, excludeNotOwnedInvoices, dateFrom, dateTo, invoiceNumber, storeId, options) {
            return (0, exports.InvoicesApiFp)(configuration).getInvoices(appId, subscriptionId, limit, pageId, excludeNotOwnedInvoices, dateFrom, dateTo, invoiceNumber, storeId, options)(fetch, basePath);
        },
        invoicePdf: function (invoiceNumber, appId, options) {
            return (0, exports.InvoicesApiFp)(configuration).invoicePdf(invoiceNumber, appId, options)(fetch, basePath);
        },
        listInvoices: function (storeId, appId, limit, page, options) {
            return (0, exports.InvoicesApiFp)(configuration).listInvoices(storeId, appId, limit, page, options)(fetch, basePath);
        },
        listSubscriptionInvoices: function (appId, subscriptionId, limit, pageId, excludeNotOwnedInvoices, dateFrom, dateTo, invoiceNumber, storeId, options) {
            return (0, exports.InvoicesApiFp)(configuration).listSubscriptionInvoices(appId, subscriptionId, limit, pageId, excludeNotOwnedInvoices, dateFrom, dateTo, invoiceNumber, storeId, options)(fetch, basePath);
        },
    };
};
exports.InvoicesApiFactory = InvoicesApiFactory;
var InvoicesApi = (function (_super) {
    __extends(InvoicesApi, _super);
    function InvoicesApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    InvoicesApi.prototype.getInvoices = function (appId, subscriptionId, limit, pageId, excludeNotOwnedInvoices, dateFrom, dateTo, invoiceNumber, storeId, options) {
        return (0, exports.InvoicesApiFp)(this.configuration).getInvoices(appId, subscriptionId, limit, pageId, excludeNotOwnedInvoices, dateFrom, dateTo, invoiceNumber, storeId, options)(this.fetch, this.basePath);
    };
    InvoicesApi.prototype.invoicePdf = function (invoiceNumber, appId, options) {
        return (0, exports.InvoicesApiFp)(this.configuration).invoicePdf(invoiceNumber, appId, options)(this.fetch, this.basePath);
    };
    InvoicesApi.prototype.listInvoices = function (storeId, appId, limit, page, options) {
        return (0, exports.InvoicesApiFp)(this.configuration).listInvoices(storeId, appId, limit, page, options)(this.fetch, this.basePath);
    };
    InvoicesApi.prototype.listSubscriptionInvoices = function (appId, subscriptionId, limit, pageId, excludeNotOwnedInvoices, dateFrom, dateTo, invoiceNumber, storeId, options) {
        return (0, exports.InvoicesApiFp)(this.configuration).listSubscriptionInvoices(appId, subscriptionId, limit, pageId, excludeNotOwnedInvoices, dateFrom, dateTo, invoiceNumber, storeId, options)(this.fetch, this.basePath);
    };
    return InvoicesApi;
}(BaseAPI));
exports.InvoicesApi = InvoicesApi;
var KioskEntitlementsApiFetchParamCreator = function (configuration) {
    return {
        queryKioskEntitlementsByOrgId: function (orgId, options) {
            if (options === void 0) { options = {}; }
            if (orgId === null || orgId === undefined) {
                throw new RequiredError('orgId', 'Required parameter orgId was null or undefined when calling queryKioskEntitlementsByOrgId.');
            }
            var localVarPath = "/api/v1.0/orgs/{orgId}/kiosk/entitlements"
                .replace("{".concat("orgId", "}"), encodeURIComponent(String(orgId)));
            var localVarUrlObj = url.parse(localVarPath, true);
            var localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            var localVarHeaderParameter = {};
            var localVarQueryParameter = {};
            if (configuration && configuration.accessToken) {
                var localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("oauth2", ["api"])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    };
};
exports.KioskEntitlementsApiFetchParamCreator = KioskEntitlementsApiFetchParamCreator;
var KioskEntitlementsApiFp = function (configuration) {
    return {
        queryKioskEntitlementsByOrgId: function (orgId, options) {
            var localVarFetchArgs = (0, exports.KioskEntitlementsApiFetchParamCreator)(configuration).queryKioskEntitlementsByOrgId(orgId, options);
            return function (fetch, basePath) {
                if (fetch === void 0) { fetch = portableFetch; }
                if (basePath === void 0) { basePath = BASE_PATH; }
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then(function (response) {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
    };
};
exports.KioskEntitlementsApiFp = KioskEntitlementsApiFp;
var KioskEntitlementsApiFactory = function (configuration, fetch, basePath) {
    return {
        queryKioskEntitlementsByOrgId: function (orgId, options) {
            return (0, exports.KioskEntitlementsApiFp)(configuration).queryKioskEntitlementsByOrgId(orgId, options)(fetch, basePath);
        },
    };
};
exports.KioskEntitlementsApiFactory = KioskEntitlementsApiFactory;
var KioskEntitlementsApi = (function (_super) {
    __extends(KioskEntitlementsApi, _super);
    function KioskEntitlementsApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    KioskEntitlementsApi.prototype.queryKioskEntitlementsByOrgId = function (orgId, options) {
        return (0, exports.KioskEntitlementsApiFp)(this.configuration).queryKioskEntitlementsByOrgId(orgId, options)(this.fetch, this.basePath);
    };
    return KioskEntitlementsApi;
}(BaseAPI));
exports.KioskEntitlementsApi = KioskEntitlementsApi;
var KioskIotApiFetchParamCreator = function (configuration) {
    return {
        getKioskIotConnection: function (options) {
            if (options === void 0) { options = {}; }
            var localVarPath = "/api/v1.0/kioskiot/connect";
            var localVarUrlObj = url.parse(localVarPath, true);
            var localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            var localVarHeaderParameter = {};
            var localVarQueryParameter = {};
            if (configuration && configuration.accessToken) {
                var localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("oauth2", ["api"])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        queryTelemetrySeries: function (appId, TelemetrySeriesQueryParameters, options) {
            if (options === void 0) { options = {}; }
            if (appId === null || appId === undefined) {
                throw new RequiredError('appId', 'Required parameter appId was null or undefined when calling queryTelemetrySeries.');
            }
            if (TelemetrySeriesQueryParameters === null || TelemetrySeriesQueryParameters === undefined) {
                throw new RequiredError('TelemetrySeriesQueryParameters', 'Required parameter TelemetrySeriesQueryParameters was null or undefined when calling queryTelemetrySeries.');
            }
            var localVarPath = "/api/v1.0/{appId}/kioskiot/timeseries/query"
                .replace("{".concat("appId", "}"), encodeURIComponent(String(appId)));
            var localVarUrlObj = url.parse(localVarPath, true);
            var localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            var localVarHeaderParameter = {};
            var localVarQueryParameter = {};
            if (configuration && configuration.accessToken) {
                var localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("oauth2", ["api"])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }
            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            var needsSerialization = ("TelemetrySeriesQueryParameters" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body = needsSerialization ? JSON.stringify(TelemetrySeriesQueryParameters || {}) : (TelemetrySeriesQueryParameters || "");
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    };
};
exports.KioskIotApiFetchParamCreator = KioskIotApiFetchParamCreator;
var KioskIotApiFp = function (configuration) {
    return {
        getKioskIotConnection: function (options) {
            var localVarFetchArgs = (0, exports.KioskIotApiFetchParamCreator)(configuration).getKioskIotConnection(options);
            return function (fetch, basePath) {
                if (fetch === void 0) { fetch = portableFetch; }
                if (basePath === void 0) { basePath = BASE_PATH; }
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then(function (response) {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
        queryTelemetrySeries: function (appId, TelemetrySeriesQueryParameters, options) {
            var localVarFetchArgs = (0, exports.KioskIotApiFetchParamCreator)(configuration).queryTelemetrySeries(appId, TelemetrySeriesQueryParameters, options);
            return function (fetch, basePath) {
                if (fetch === void 0) { fetch = portableFetch; }
                if (basePath === void 0) { basePath = BASE_PATH; }
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then(function (response) {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
    };
};
exports.KioskIotApiFp = KioskIotApiFp;
var KioskIotApiFactory = function (configuration, fetch, basePath) {
    return {
        getKioskIotConnection: function (options) {
            return (0, exports.KioskIotApiFp)(configuration).getKioskIotConnection(options)(fetch, basePath);
        },
        queryTelemetrySeries: function (appId, TelemetrySeriesQueryParameters, options) {
            return (0, exports.KioskIotApiFp)(configuration).queryTelemetrySeries(appId, TelemetrySeriesQueryParameters, options)(fetch, basePath);
        },
    };
};
exports.KioskIotApiFactory = KioskIotApiFactory;
var KioskIotApi = (function (_super) {
    __extends(KioskIotApi, _super);
    function KioskIotApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    KioskIotApi.prototype.getKioskIotConnection = function (options) {
        return (0, exports.KioskIotApiFp)(this.configuration).getKioskIotConnection(options)(this.fetch, this.basePath);
    };
    KioskIotApi.prototype.queryTelemetrySeries = function (appId, TelemetrySeriesQueryParameters, options) {
        return (0, exports.KioskIotApiFp)(this.configuration).queryTelemetrySeries(appId, TelemetrySeriesQueryParameters, options)(this.fetch, this.basePath);
    };
    return KioskIotApi;
}(BaseAPI));
exports.KioskIotApi = KioskIotApi;
var LightspeedApiFetchParamCreator = function (configuration) {
    return {
        lightspeedGenerateMenu: function (storeId, options) {
            if (options === void 0) { options = {}; }
            if (storeId === null || storeId === undefined) {
                throw new RequiredError('storeId', 'Required parameter storeId was null or undefined when calling lightspeedGenerateMenu.');
            }
            var localVarPath = "/api/v1.0/lightspeed/{storeId}/menu/generate"
                .replace("{".concat("storeId", "}"), encodeURIComponent(String(storeId)));
            var localVarUrlObj = url.parse(localVarPath, true);
            var localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            var localVarHeaderParameter = {};
            var localVarQueryParameter = {};
            if (configuration && configuration.accessToken) {
                var localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("oauth2", ["api"])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        lightspeedGetStoreSettings: function (storeId, options) {
            if (options === void 0) { options = {}; }
            if (storeId === null || storeId === undefined) {
                throw new RequiredError('storeId', 'Required parameter storeId was null or undefined when calling lightspeedGetStoreSettings.');
            }
            var localVarPath = "/api/v1.0/lightspeed/{storeId}/settings"
                .replace("{".concat("storeId", "}"), encodeURIComponent(String(storeId)));
            var localVarUrlObj = url.parse(localVarPath, true);
            var localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            var localVarHeaderParameter = {};
            var localVarQueryParameter = {};
            if (configuration && configuration.accessToken) {
                var localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("oauth2", ["api"])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        lightspeedSaveStoreSettings: function (storeId, LightspeedSettings, options) {
            if (options === void 0) { options = {}; }
            if (storeId === null || storeId === undefined) {
                throw new RequiredError('storeId', 'Required parameter storeId was null or undefined when calling lightspeedSaveStoreSettings.');
            }
            if (LightspeedSettings === null || LightspeedSettings === undefined) {
                throw new RequiredError('LightspeedSettings', 'Required parameter LightspeedSettings was null or undefined when calling lightspeedSaveStoreSettings.');
            }
            var localVarPath = "/api/v1.0/lightspeed/{storeId}/settings"
                .replace("{".concat("storeId", "}"), encodeURIComponent(String(storeId)));
            var localVarUrlObj = url.parse(localVarPath, true);
            var localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            var localVarHeaderParameter = {};
            var localVarQueryParameter = {};
            if (configuration && configuration.accessToken) {
                var localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("oauth2", ["api"])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }
            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            var needsSerialization = ("LightspeedSettings" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body = needsSerialization ? JSON.stringify(LightspeedSettings || {}) : (LightspeedSettings || "");
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    };
};
exports.LightspeedApiFetchParamCreator = LightspeedApiFetchParamCreator;
var LightspeedApiFp = function (configuration) {
    return {
        lightspeedGenerateMenu: function (storeId, options) {
            var localVarFetchArgs = (0, exports.LightspeedApiFetchParamCreator)(configuration).lightspeedGenerateMenu(storeId, options);
            return function (fetch, basePath) {
                if (fetch === void 0) { fetch = portableFetch; }
                if (basePath === void 0) { basePath = BASE_PATH; }
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then(function (response) {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
        lightspeedGetStoreSettings: function (storeId, options) {
            var localVarFetchArgs = (0, exports.LightspeedApiFetchParamCreator)(configuration).lightspeedGetStoreSettings(storeId, options);
            return function (fetch, basePath) {
                if (fetch === void 0) { fetch = portableFetch; }
                if (basePath === void 0) { basePath = BASE_PATH; }
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then(function (response) {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
        lightspeedSaveStoreSettings: function (storeId, LightspeedSettings, options) {
            var localVarFetchArgs = (0, exports.LightspeedApiFetchParamCreator)(configuration).lightspeedSaveStoreSettings(storeId, LightspeedSettings, options);
            return function (fetch, basePath) {
                if (fetch === void 0) { fetch = portableFetch; }
                if (basePath === void 0) { basePath = BASE_PATH; }
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then(function (response) {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
    };
};
exports.LightspeedApiFp = LightspeedApiFp;
var LightspeedApiFactory = function (configuration, fetch, basePath) {
    return {
        lightspeedGenerateMenu: function (storeId, options) {
            return (0, exports.LightspeedApiFp)(configuration).lightspeedGenerateMenu(storeId, options)(fetch, basePath);
        },
        lightspeedGetStoreSettings: function (storeId, options) {
            return (0, exports.LightspeedApiFp)(configuration).lightspeedGetStoreSettings(storeId, options)(fetch, basePath);
        },
        lightspeedSaveStoreSettings: function (storeId, LightspeedSettings, options) {
            return (0, exports.LightspeedApiFp)(configuration).lightspeedSaveStoreSettings(storeId, LightspeedSettings, options)(fetch, basePath);
        },
    };
};
exports.LightspeedApiFactory = LightspeedApiFactory;
var LightspeedApi = (function (_super) {
    __extends(LightspeedApi, _super);
    function LightspeedApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    LightspeedApi.prototype.lightspeedGenerateMenu = function (storeId, options) {
        return (0, exports.LightspeedApiFp)(this.configuration).lightspeedGenerateMenu(storeId, options)(this.fetch, this.basePath);
    };
    LightspeedApi.prototype.lightspeedGetStoreSettings = function (storeId, options) {
        return (0, exports.LightspeedApiFp)(this.configuration).lightspeedGetStoreSettings(storeId, options)(this.fetch, this.basePath);
    };
    LightspeedApi.prototype.lightspeedSaveStoreSettings = function (storeId, LightspeedSettings, options) {
        return (0, exports.LightspeedApiFp)(this.configuration).lightspeedSaveStoreSettings(storeId, LightspeedSettings, options)(this.fetch, this.basePath);
    };
    return LightspeedApi;
}(BaseAPI));
exports.LightspeedApi = LightspeedApi;
var LocationApiFetchParamCreator = function (configuration) {
    return {
        createLocation: function (locationAreaId, appId, storeId, CreateLocation, options) {
            if (options === void 0) { options = {}; }
            if (locationAreaId === null || locationAreaId === undefined) {
                throw new RequiredError('locationAreaId', 'Required parameter locationAreaId was null or undefined when calling createLocation.');
            }
            if (appId === null || appId === undefined) {
                throw new RequiredError('appId', 'Required parameter appId was null or undefined when calling createLocation.');
            }
            if (storeId === null || storeId === undefined) {
                throw new RequiredError('storeId', 'Required parameter storeId was null or undefined when calling createLocation.');
            }
            if (CreateLocation === null || CreateLocation === undefined) {
                throw new RequiredError('CreateLocation', 'Required parameter CreateLocation was null or undefined when calling createLocation.');
            }
            var localVarPath = "/api/v1.0/{appId}/stores/{storeId}/location-areas/{locationAreaId}/location"
                .replace("{".concat("locationAreaId", "}"), encodeURIComponent(String(locationAreaId)))
                .replace("{".concat("appId", "}"), encodeURIComponent(String(appId)))
                .replace("{".concat("storeId", "}"), encodeURIComponent(String(storeId)));
            var localVarUrlObj = url.parse(localVarPath, true);
            var localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            var localVarHeaderParameter = {};
            var localVarQueryParameter = {};
            if (configuration && configuration.accessToken) {
                var localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("oauth2", ["api"])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }
            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            var needsSerialization = ("Array&lt;CreateLocation&gt;" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body = needsSerialization ? JSON.stringify(CreateLocation || {}) : (CreateLocation || "");
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        deleteLocation: function (locationId, locationAreaId, appId, storeId, options) {
            if (options === void 0) { options = {}; }
            if (locationId === null || locationId === undefined) {
                throw new RequiredError('locationId', 'Required parameter locationId was null or undefined when calling deleteLocation.');
            }
            if (locationAreaId === null || locationAreaId === undefined) {
                throw new RequiredError('locationAreaId', 'Required parameter locationAreaId was null or undefined when calling deleteLocation.');
            }
            if (appId === null || appId === undefined) {
                throw new RequiredError('appId', 'Required parameter appId was null or undefined when calling deleteLocation.');
            }
            if (storeId === null || storeId === undefined) {
                throw new RequiredError('storeId', 'Required parameter storeId was null or undefined when calling deleteLocation.');
            }
            var localVarPath = "/api/v1.0/{appId}/stores/{storeId}/location-areas/{locationAreaId}/location/{locationId}/delete"
                .replace("{".concat("locationId", "}"), encodeURIComponent(String(locationId)))
                .replace("{".concat("locationAreaId", "}"), encodeURIComponent(String(locationAreaId)))
                .replace("{".concat("appId", "}"), encodeURIComponent(String(appId)))
                .replace("{".concat("storeId", "}"), encodeURIComponent(String(storeId)));
            var localVarUrlObj = url.parse(localVarPath, true);
            var localVarRequestOptions = Object.assign({ method: 'DELETE' }, options);
            var localVarHeaderParameter = {};
            var localVarQueryParameter = {};
            if (configuration && configuration.accessToken) {
                var localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("oauth2", ["api"])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        mapLocationToExternalId: function (locationId, locationAreaId, appId, storeId, externalLocationId, options) {
            if (options === void 0) { options = {}; }
            if (locationId === null || locationId === undefined) {
                throw new RequiredError('locationId', 'Required parameter locationId was null or undefined when calling mapLocationToExternalId.');
            }
            if (locationAreaId === null || locationAreaId === undefined) {
                throw new RequiredError('locationAreaId', 'Required parameter locationAreaId was null or undefined when calling mapLocationToExternalId.');
            }
            if (appId === null || appId === undefined) {
                throw new RequiredError('appId', 'Required parameter appId was null or undefined when calling mapLocationToExternalId.');
            }
            if (storeId === null || storeId === undefined) {
                throw new RequiredError('storeId', 'Required parameter storeId was null or undefined when calling mapLocationToExternalId.');
            }
            var localVarPath = "/api/v1.0/{appId}/stores/{storeId}/location-areas/{locationAreaId}/location/{locationId}/map-external"
                .replace("{".concat("locationId", "}"), encodeURIComponent(String(locationId)))
                .replace("{".concat("locationAreaId", "}"), encodeURIComponent(String(locationAreaId)))
                .replace("{".concat("appId", "}"), encodeURIComponent(String(appId)))
                .replace("{".concat("storeId", "}"), encodeURIComponent(String(storeId)));
            var localVarUrlObj = url.parse(localVarPath, true);
            var localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            var localVarHeaderParameter = {};
            var localVarQueryParameter = {};
            if (configuration && configuration.accessToken) {
                var localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("oauth2", ["api"])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }
            if (externalLocationId !== undefined) {
                localVarQueryParameter['externalLocationId'] = externalLocationId;
            }
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        moveLocation: function (locationId, locationAreaId, newLocationAreaId, appId, storeId, options) {
            if (options === void 0) { options = {}; }
            if (locationId === null || locationId === undefined) {
                throw new RequiredError('locationId', 'Required parameter locationId was null or undefined when calling moveLocation.');
            }
            if (locationAreaId === null || locationAreaId === undefined) {
                throw new RequiredError('locationAreaId', 'Required parameter locationAreaId was null or undefined when calling moveLocation.');
            }
            if (newLocationAreaId === null || newLocationAreaId === undefined) {
                throw new RequiredError('newLocationAreaId', 'Required parameter newLocationAreaId was null or undefined when calling moveLocation.');
            }
            if (appId === null || appId === undefined) {
                throw new RequiredError('appId', 'Required parameter appId was null or undefined when calling moveLocation.');
            }
            if (storeId === null || storeId === undefined) {
                throw new RequiredError('storeId', 'Required parameter storeId was null or undefined when calling moveLocation.');
            }
            var localVarPath = "/api/v1.0/{appId}/stores/{storeId}/location-areas/{locationAreaId}/location/{locationId}/move"
                .replace("{".concat("locationId", "}"), encodeURIComponent(String(locationId)))
                .replace("{".concat("locationAreaId", "}"), encodeURIComponent(String(locationAreaId)))
                .replace("{".concat("appId", "}"), encodeURIComponent(String(appId)))
                .replace("{".concat("storeId", "}"), encodeURIComponent(String(storeId)));
            var localVarUrlObj = url.parse(localVarPath, true);
            var localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            var localVarHeaderParameter = {};
            var localVarQueryParameter = {};
            if (configuration && configuration.accessToken) {
                var localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("oauth2", ["api"])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }
            if (newLocationAreaId !== undefined) {
                localVarQueryParameter['newLocationAreaId'] = newLocationAreaId;
            }
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        updateLocation: function (locationAreaId, locationId, appId, storeId, CreateLocation, options) {
            if (options === void 0) { options = {}; }
            if (locationAreaId === null || locationAreaId === undefined) {
                throw new RequiredError('locationAreaId', 'Required parameter locationAreaId was null or undefined when calling updateLocation.');
            }
            if (locationId === null || locationId === undefined) {
                throw new RequiredError('locationId', 'Required parameter locationId was null or undefined when calling updateLocation.');
            }
            if (appId === null || appId === undefined) {
                throw new RequiredError('appId', 'Required parameter appId was null or undefined when calling updateLocation.');
            }
            if (storeId === null || storeId === undefined) {
                throw new RequiredError('storeId', 'Required parameter storeId was null or undefined when calling updateLocation.');
            }
            if (CreateLocation === null || CreateLocation === undefined) {
                throw new RequiredError('CreateLocation', 'Required parameter CreateLocation was null or undefined when calling updateLocation.');
            }
            var localVarPath = "/api/v1.0/{appId}/stores/{storeId}/location-areas/{locationAreaId}/location/{locationId}/update"
                .replace("{".concat("locationAreaId", "}"), encodeURIComponent(String(locationAreaId)))
                .replace("{".concat("locationId", "}"), encodeURIComponent(String(locationId)))
                .replace("{".concat("appId", "}"), encodeURIComponent(String(appId)))
                .replace("{".concat("storeId", "}"), encodeURIComponent(String(storeId)));
            var localVarUrlObj = url.parse(localVarPath, true);
            var localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            var localVarHeaderParameter = {};
            var localVarQueryParameter = {};
            if (configuration && configuration.accessToken) {
                var localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("oauth2", ["api"])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }
            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            var needsSerialization = ("CreateLocation" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body = needsSerialization ? JSON.stringify(CreateLocation || {}) : (CreateLocation || "");
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    };
};
exports.LocationApiFetchParamCreator = LocationApiFetchParamCreator;
var LocationApiFp = function (configuration) {
    return {
        createLocation: function (locationAreaId, appId, storeId, CreateLocation, options) {
            var localVarFetchArgs = (0, exports.LocationApiFetchParamCreator)(configuration).createLocation(locationAreaId, appId, storeId, CreateLocation, options);
            return function (fetch, basePath) {
                if (fetch === void 0) { fetch = portableFetch; }
                if (basePath === void 0) { basePath = BASE_PATH; }
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then(function (response) {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
        deleteLocation: function (locationId, locationAreaId, appId, storeId, options) {
            var localVarFetchArgs = (0, exports.LocationApiFetchParamCreator)(configuration).deleteLocation(locationId, locationAreaId, appId, storeId, options);
            return function (fetch, basePath) {
                if (fetch === void 0) { fetch = portableFetch; }
                if (basePath === void 0) { basePath = BASE_PATH; }
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then(function (response) {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
        mapLocationToExternalId: function (locationId, locationAreaId, appId, storeId, externalLocationId, options) {
            var localVarFetchArgs = (0, exports.LocationApiFetchParamCreator)(configuration).mapLocationToExternalId(locationId, locationAreaId, appId, storeId, externalLocationId, options);
            return function (fetch, basePath) {
                if (fetch === void 0) { fetch = portableFetch; }
                if (basePath === void 0) { basePath = BASE_PATH; }
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then(function (response) {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
        moveLocation: function (locationId, locationAreaId, newLocationAreaId, appId, storeId, options) {
            var localVarFetchArgs = (0, exports.LocationApiFetchParamCreator)(configuration).moveLocation(locationId, locationAreaId, newLocationAreaId, appId, storeId, options);
            return function (fetch, basePath) {
                if (fetch === void 0) { fetch = portableFetch; }
                if (basePath === void 0) { basePath = BASE_PATH; }
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then(function (response) {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
        updateLocation: function (locationAreaId, locationId, appId, storeId, CreateLocation, options) {
            var localVarFetchArgs = (0, exports.LocationApiFetchParamCreator)(configuration).updateLocation(locationAreaId, locationId, appId, storeId, CreateLocation, options);
            return function (fetch, basePath) {
                if (fetch === void 0) { fetch = portableFetch; }
                if (basePath === void 0) { basePath = BASE_PATH; }
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then(function (response) {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
    };
};
exports.LocationApiFp = LocationApiFp;
var LocationApiFactory = function (configuration, fetch, basePath) {
    return {
        createLocation: function (locationAreaId, appId, storeId, CreateLocation, options) {
            return (0, exports.LocationApiFp)(configuration).createLocation(locationAreaId, appId, storeId, CreateLocation, options)(fetch, basePath);
        },
        deleteLocation: function (locationId, locationAreaId, appId, storeId, options) {
            return (0, exports.LocationApiFp)(configuration).deleteLocation(locationId, locationAreaId, appId, storeId, options)(fetch, basePath);
        },
        mapLocationToExternalId: function (locationId, locationAreaId, appId, storeId, externalLocationId, options) {
            return (0, exports.LocationApiFp)(configuration).mapLocationToExternalId(locationId, locationAreaId, appId, storeId, externalLocationId, options)(fetch, basePath);
        },
        moveLocation: function (locationId, locationAreaId, newLocationAreaId, appId, storeId, options) {
            return (0, exports.LocationApiFp)(configuration).moveLocation(locationId, locationAreaId, newLocationAreaId, appId, storeId, options)(fetch, basePath);
        },
        updateLocation: function (locationAreaId, locationId, appId, storeId, CreateLocation, options) {
            return (0, exports.LocationApiFp)(configuration).updateLocation(locationAreaId, locationId, appId, storeId, CreateLocation, options)(fetch, basePath);
        },
    };
};
exports.LocationApiFactory = LocationApiFactory;
var LocationApi = (function (_super) {
    __extends(LocationApi, _super);
    function LocationApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    LocationApi.prototype.createLocation = function (locationAreaId, appId, storeId, CreateLocation, options) {
        return (0, exports.LocationApiFp)(this.configuration).createLocation(locationAreaId, appId, storeId, CreateLocation, options)(this.fetch, this.basePath);
    };
    LocationApi.prototype.deleteLocation = function (locationId, locationAreaId, appId, storeId, options) {
        return (0, exports.LocationApiFp)(this.configuration).deleteLocation(locationId, locationAreaId, appId, storeId, options)(this.fetch, this.basePath);
    };
    LocationApi.prototype.mapLocationToExternalId = function (locationId, locationAreaId, appId, storeId, externalLocationId, options) {
        return (0, exports.LocationApiFp)(this.configuration).mapLocationToExternalId(locationId, locationAreaId, appId, storeId, externalLocationId, options)(this.fetch, this.basePath);
    };
    LocationApi.prototype.moveLocation = function (locationId, locationAreaId, newLocationAreaId, appId, storeId, options) {
        return (0, exports.LocationApiFp)(this.configuration).moveLocation(locationId, locationAreaId, newLocationAreaId, appId, storeId, options)(this.fetch, this.basePath);
    };
    LocationApi.prototype.updateLocation = function (locationAreaId, locationId, appId, storeId, CreateLocation, options) {
        return (0, exports.LocationApiFp)(this.configuration).updateLocation(locationAreaId, locationId, appId, storeId, CreateLocation, options)(this.fetch, this.basePath);
    };
    return LocationApi;
}(BaseAPI));
exports.LocationApi = LocationApi;
var LocationAreasApiFetchParamCreator = function (configuration) {
    return {
        createLocationArea: function (appId, storeId, CreateLocationArea, options) {
            if (options === void 0) { options = {}; }
            if (appId === null || appId === undefined) {
                throw new RequiredError('appId', 'Required parameter appId was null or undefined when calling createLocationArea.');
            }
            if (storeId === null || storeId === undefined) {
                throw new RequiredError('storeId', 'Required parameter storeId was null or undefined when calling createLocationArea.');
            }
            if (CreateLocationArea === null || CreateLocationArea === undefined) {
                throw new RequiredError('CreateLocationArea', 'Required parameter CreateLocationArea was null or undefined when calling createLocationArea.');
            }
            var localVarPath = "/api/v1.0/{appId}/stores/{storeId}/location-areas"
                .replace("{".concat("appId", "}"), encodeURIComponent(String(appId)))
                .replace("{".concat("storeId", "}"), encodeURIComponent(String(storeId)));
            var localVarUrlObj = url.parse(localVarPath, true);
            var localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            var localVarHeaderParameter = {};
            var localVarQueryParameter = {};
            if (configuration && configuration.accessToken) {
                var localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("oauth2", ["api"])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }
            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            var needsSerialization = ("CreateLocationArea" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body = needsSerialization ? JSON.stringify(CreateLocationArea || {}) : (CreateLocationArea || "");
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        getLocationArea: function (locationAreaId, appId, storeId, options) {
            if (options === void 0) { options = {}; }
            if (locationAreaId === null || locationAreaId === undefined) {
                throw new RequiredError('locationAreaId', 'Required parameter locationAreaId was null or undefined when calling getLocationArea.');
            }
            if (appId === null || appId === undefined) {
                throw new RequiredError('appId', 'Required parameter appId was null or undefined when calling getLocationArea.');
            }
            if (storeId === null || storeId === undefined) {
                throw new RequiredError('storeId', 'Required parameter storeId was null or undefined when calling getLocationArea.');
            }
            var localVarPath = "/api/v1.0/{appId}/stores/{storeId}/location-areas/{locationAreaId}"
                .replace("{".concat("locationAreaId", "}"), encodeURIComponent(String(locationAreaId)))
                .replace("{".concat("appId", "}"), encodeURIComponent(String(appId)))
                .replace("{".concat("storeId", "}"), encodeURIComponent(String(storeId)));
            var localVarUrlObj = url.parse(localVarPath, true);
            var localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            var localVarHeaderParameter = {};
            var localVarQueryParameter = {};
            if (configuration && configuration.accessToken) {
                var localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("oauth2", ["api"])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        getLocationAreasForStore: function (appId, storeId, options) {
            if (options === void 0) { options = {}; }
            if (appId === null || appId === undefined) {
                throw new RequiredError('appId', 'Required parameter appId was null or undefined when calling getLocationAreasForStore.');
            }
            if (storeId === null || storeId === undefined) {
                throw new RequiredError('storeId', 'Required parameter storeId was null or undefined when calling getLocationAreasForStore.');
            }
            var localVarPath = "/api/v1.0/{appId}/stores/{storeId}/location-areas"
                .replace("{".concat("appId", "}"), encodeURIComponent(String(appId)))
                .replace("{".concat("storeId", "}"), encodeURIComponent(String(storeId)));
            var localVarUrlObj = url.parse(localVarPath, true);
            var localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            var localVarHeaderParameter = {};
            var localVarQueryParameter = {};
            if (configuration && configuration.accessToken) {
                var localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("oauth2", ["api"])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        updateLocationArea: function (appId, storeId, locationAreaId, UpdateLocationArea, options) {
            if (options === void 0) { options = {}; }
            if (appId === null || appId === undefined) {
                throw new RequiredError('appId', 'Required parameter appId was null or undefined when calling updateLocationArea.');
            }
            if (storeId === null || storeId === undefined) {
                throw new RequiredError('storeId', 'Required parameter storeId was null or undefined when calling updateLocationArea.');
            }
            if (locationAreaId === null || locationAreaId === undefined) {
                throw new RequiredError('locationAreaId', 'Required parameter locationAreaId was null or undefined when calling updateLocationArea.');
            }
            if (UpdateLocationArea === null || UpdateLocationArea === undefined) {
                throw new RequiredError('UpdateLocationArea', 'Required parameter UpdateLocationArea was null or undefined when calling updateLocationArea.');
            }
            var localVarPath = "/api/v1.0/{appId}/stores/{storeId}/location-areas/{locationAreaId}/update"
                .replace("{".concat("appId", "}"), encodeURIComponent(String(appId)))
                .replace("{".concat("storeId", "}"), encodeURIComponent(String(storeId)))
                .replace("{".concat("locationAreaId", "}"), encodeURIComponent(String(locationAreaId)));
            var localVarUrlObj = url.parse(localVarPath, true);
            var localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            var localVarHeaderParameter = {};
            var localVarQueryParameter = {};
            if (configuration && configuration.accessToken) {
                var localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("oauth2", ["api"])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }
            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            var needsSerialization = ("UpdateLocationArea" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body = needsSerialization ? JSON.stringify(UpdateLocationArea || {}) : (UpdateLocationArea || "");
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    };
};
exports.LocationAreasApiFetchParamCreator = LocationAreasApiFetchParamCreator;
var LocationAreasApiFp = function (configuration) {
    return {
        createLocationArea: function (appId, storeId, CreateLocationArea, options) {
            var localVarFetchArgs = (0, exports.LocationAreasApiFetchParamCreator)(configuration).createLocationArea(appId, storeId, CreateLocationArea, options);
            return function (fetch, basePath) {
                if (fetch === void 0) { fetch = portableFetch; }
                if (basePath === void 0) { basePath = BASE_PATH; }
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then(function (response) {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
        getLocationArea: function (locationAreaId, appId, storeId, options) {
            var localVarFetchArgs = (0, exports.LocationAreasApiFetchParamCreator)(configuration).getLocationArea(locationAreaId, appId, storeId, options);
            return function (fetch, basePath) {
                if (fetch === void 0) { fetch = portableFetch; }
                if (basePath === void 0) { basePath = BASE_PATH; }
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then(function (response) {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
        getLocationAreasForStore: function (appId, storeId, options) {
            var localVarFetchArgs = (0, exports.LocationAreasApiFetchParamCreator)(configuration).getLocationAreasForStore(appId, storeId, options);
            return function (fetch, basePath) {
                if (fetch === void 0) { fetch = portableFetch; }
                if (basePath === void 0) { basePath = BASE_PATH; }
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then(function (response) {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
        updateLocationArea: function (appId, storeId, locationAreaId, UpdateLocationArea, options) {
            var localVarFetchArgs = (0, exports.LocationAreasApiFetchParamCreator)(configuration).updateLocationArea(appId, storeId, locationAreaId, UpdateLocationArea, options);
            return function (fetch, basePath) {
                if (fetch === void 0) { fetch = portableFetch; }
                if (basePath === void 0) { basePath = BASE_PATH; }
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then(function (response) {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
    };
};
exports.LocationAreasApiFp = LocationAreasApiFp;
var LocationAreasApiFactory = function (configuration, fetch, basePath) {
    return {
        createLocationArea: function (appId, storeId, CreateLocationArea, options) {
            return (0, exports.LocationAreasApiFp)(configuration).createLocationArea(appId, storeId, CreateLocationArea, options)(fetch, basePath);
        },
        getLocationArea: function (locationAreaId, appId, storeId, options) {
            return (0, exports.LocationAreasApiFp)(configuration).getLocationArea(locationAreaId, appId, storeId, options)(fetch, basePath);
        },
        getLocationAreasForStore: function (appId, storeId, options) {
            return (0, exports.LocationAreasApiFp)(configuration).getLocationAreasForStore(appId, storeId, options)(fetch, basePath);
        },
        updateLocationArea: function (appId, storeId, locationAreaId, UpdateLocationArea, options) {
            return (0, exports.LocationAreasApiFp)(configuration).updateLocationArea(appId, storeId, locationAreaId, UpdateLocationArea, options)(fetch, basePath);
        },
    };
};
exports.LocationAreasApiFactory = LocationAreasApiFactory;
var LocationAreasApi = (function (_super) {
    __extends(LocationAreasApi, _super);
    function LocationAreasApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    LocationAreasApi.prototype.createLocationArea = function (appId, storeId, CreateLocationArea, options) {
        return (0, exports.LocationAreasApiFp)(this.configuration).createLocationArea(appId, storeId, CreateLocationArea, options)(this.fetch, this.basePath);
    };
    LocationAreasApi.prototype.getLocationArea = function (locationAreaId, appId, storeId, options) {
        return (0, exports.LocationAreasApiFp)(this.configuration).getLocationArea(locationAreaId, appId, storeId, options)(this.fetch, this.basePath);
    };
    LocationAreasApi.prototype.getLocationAreasForStore = function (appId, storeId, options) {
        return (0, exports.LocationAreasApiFp)(this.configuration).getLocationAreasForStore(appId, storeId, options)(this.fetch, this.basePath);
    };
    LocationAreasApi.prototype.updateLocationArea = function (appId, storeId, locationAreaId, UpdateLocationArea, options) {
        return (0, exports.LocationAreasApiFp)(this.configuration).updateLocationArea(appId, storeId, locationAreaId, UpdateLocationArea, options)(this.fetch, this.basePath);
    };
    return LocationAreasApi;
}(BaseAPI));
exports.LocationAreasApi = LocationAreasApi;
var LookerDashboardApiFetchParamCreator = function (configuration) {
    return {
        lookerDashboardGetAll: function (appId, options) {
            if (options === void 0) { options = {}; }
            if (appId === null || appId === undefined) {
                throw new RequiredError('appId', 'Required parameter appId was null or undefined when calling lookerDashboardGetAll.');
            }
            var localVarPath = "/api/v1.0/{appId}/looker/dashboards"
                .replace("{".concat("appId", "}"), encodeURIComponent(String(appId)));
            var localVarUrlObj = url.parse(localVarPath, true);
            var localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            var localVarHeaderParameter = {};
            var localVarQueryParameter = {};
            if (configuration && configuration.accessToken) {
                var localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("oauth2", ["api"])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    };
};
exports.LookerDashboardApiFetchParamCreator = LookerDashboardApiFetchParamCreator;
var LookerDashboardApiFp = function (configuration) {
    return {
        lookerDashboardGetAll: function (appId, options) {
            var localVarFetchArgs = (0, exports.LookerDashboardApiFetchParamCreator)(configuration).lookerDashboardGetAll(appId, options);
            return function (fetch, basePath) {
                if (fetch === void 0) { fetch = portableFetch; }
                if (basePath === void 0) { basePath = BASE_PATH; }
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then(function (response) {
                    if (response.status >= 200 && response.status < 300) {
                        return response;
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
    };
};
exports.LookerDashboardApiFp = LookerDashboardApiFp;
var LookerDashboardApiFactory = function (configuration, fetch, basePath) {
    return {
        lookerDashboardGetAll: function (appId, options) {
            return (0, exports.LookerDashboardApiFp)(configuration).lookerDashboardGetAll(appId, options)(fetch, basePath);
        },
    };
};
exports.LookerDashboardApiFactory = LookerDashboardApiFactory;
var LookerDashboardApi = (function (_super) {
    __extends(LookerDashboardApi, _super);
    function LookerDashboardApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    LookerDashboardApi.prototype.lookerDashboardGetAll = function (appId, options) {
        return (0, exports.LookerDashboardApiFp)(this.configuration).lookerDashboardGetAll(appId, options)(this.fetch, this.basePath);
    };
    return LookerDashboardApi;
}(BaseAPI));
exports.LookerDashboardApi = LookerDashboardApi;
var LookerSingleSignOnApiFetchParamCreator = function (configuration) {
    return {
        getSSOEndpoint: function (appId, embedPath, filters, options) {
            if (options === void 0) { options = {}; }
            if (appId === null || appId === undefined) {
                throw new RequiredError('appId', 'Required parameter appId was null or undefined when calling getSSOEndpoint.');
            }
            if (embedPath === null || embedPath === undefined) {
                throw new RequiredError('embedPath', 'Required parameter embedPath was null or undefined when calling getSSOEndpoint.');
            }
            var localVarPath = "/api/v1.0/{appId}/looker/sso"
                .replace("{".concat("appId", "}"), encodeURIComponent(String(appId)));
            var localVarUrlObj = url.parse(localVarPath, true);
            var localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            var localVarHeaderParameter = {};
            var localVarQueryParameter = {};
            if (configuration && configuration.accessToken) {
                var localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("oauth2", ["api"])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }
            if (embedPath !== undefined) {
                localVarQueryParameter['embedPath'] = embedPath;
            }
            if (filters !== undefined) {
                localVarQueryParameter['filters'] = filters;
            }
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    };
};
exports.LookerSingleSignOnApiFetchParamCreator = LookerSingleSignOnApiFetchParamCreator;
var LookerSingleSignOnApiFp = function (configuration) {
    return {
        getSSOEndpoint: function (appId, embedPath, filters, options) {
            var localVarFetchArgs = (0, exports.LookerSingleSignOnApiFetchParamCreator)(configuration).getSSOEndpoint(appId, embedPath, filters, options);
            return function (fetch, basePath) {
                if (fetch === void 0) { fetch = portableFetch; }
                if (basePath === void 0) { basePath = BASE_PATH; }
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then(function (response) {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
    };
};
exports.LookerSingleSignOnApiFp = LookerSingleSignOnApiFp;
var LookerSingleSignOnApiFactory = function (configuration, fetch, basePath) {
    return {
        getSSOEndpoint: function (appId, embedPath, filters, options) {
            return (0, exports.LookerSingleSignOnApiFp)(configuration).getSSOEndpoint(appId, embedPath, filters, options)(fetch, basePath);
        },
    };
};
exports.LookerSingleSignOnApiFactory = LookerSingleSignOnApiFactory;
var LookerSingleSignOnApi = (function (_super) {
    __extends(LookerSingleSignOnApi, _super);
    function LookerSingleSignOnApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    LookerSingleSignOnApi.prototype.getSSOEndpoint = function (appId, embedPath, filters, options) {
        return (0, exports.LookerSingleSignOnApiFp)(this.configuration).getSSOEndpoint(appId, embedPath, filters, options)(this.fetch, this.basePath);
    };
    return LookerSingleSignOnApi;
}(BaseAPI));
exports.LookerSingleSignOnApi = LookerSingleSignOnApi;
var MenuOptionSetItemsApiFetchParamCreator = function (configuration) {
    return {
        addMenuItemOptionSetItem: function (menuId, menuSectionId, menuSectionItemId, optionSetId, MenuItemOptionSetItemBase, options) {
            if (options === void 0) { options = {}; }
            if (menuId === null || menuId === undefined) {
                throw new RequiredError('menuId', 'Required parameter menuId was null or undefined when calling addMenuItemOptionSetItem.');
            }
            if (menuSectionId === null || menuSectionId === undefined) {
                throw new RequiredError('menuSectionId', 'Required parameter menuSectionId was null or undefined when calling addMenuItemOptionSetItem.');
            }
            if (menuSectionItemId === null || menuSectionItemId === undefined) {
                throw new RequiredError('menuSectionItemId', 'Required parameter menuSectionItemId was null or undefined when calling addMenuItemOptionSetItem.');
            }
            if (optionSetId === null || optionSetId === undefined) {
                throw new RequiredError('optionSetId', 'Required parameter optionSetId was null or undefined when calling addMenuItemOptionSetItem.');
            }
            if (MenuItemOptionSetItemBase === null || MenuItemOptionSetItemBase === undefined) {
                throw new RequiredError('MenuItemOptionSetItemBase', 'Required parameter MenuItemOptionSetItemBase was null or undefined when calling addMenuItemOptionSetItem.');
            }
            var localVarPath = "/api/v1.0/menus/{menuId}/sections/{menuSectionId}/sectionitems/{menuSectionItemId}/optionsets/{optionSetId}/optionsetitems"
                .replace("{".concat("menuId", "}"), encodeURIComponent(String(menuId)))
                .replace("{".concat("menuSectionId", "}"), encodeURIComponent(String(menuSectionId)))
                .replace("{".concat("menuSectionItemId", "}"), encodeURIComponent(String(menuSectionItemId)))
                .replace("{".concat("optionSetId", "}"), encodeURIComponent(String(optionSetId)));
            var localVarUrlObj = url.parse(localVarPath, true);
            var localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            var localVarHeaderParameter = {};
            var localVarQueryParameter = {};
            if (configuration && configuration.accessToken) {
                var localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("oauth2", ["api"])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }
            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            var needsSerialization = ("MenuItemOptionSetItemBase" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body = needsSerialization ? JSON.stringify(MenuItemOptionSetItemBase || {}) : (MenuItemOptionSetItemBase || "");
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        deleteOptionSetItemImage: function (menuId, menuSectionId, menuSectionItemId, optionSetId, menuItemOptionSetItemId, options) {
            if (options === void 0) { options = {}; }
            if (menuId === null || menuId === undefined) {
                throw new RequiredError('menuId', 'Required parameter menuId was null or undefined when calling deleteOptionSetItemImage.');
            }
            if (menuSectionId === null || menuSectionId === undefined) {
                throw new RequiredError('menuSectionId', 'Required parameter menuSectionId was null or undefined when calling deleteOptionSetItemImage.');
            }
            if (menuSectionItemId === null || menuSectionItemId === undefined) {
                throw new RequiredError('menuSectionItemId', 'Required parameter menuSectionItemId was null or undefined when calling deleteOptionSetItemImage.');
            }
            if (optionSetId === null || optionSetId === undefined) {
                throw new RequiredError('optionSetId', 'Required parameter optionSetId was null or undefined when calling deleteOptionSetItemImage.');
            }
            if (menuItemOptionSetItemId === null || menuItemOptionSetItemId === undefined) {
                throw new RequiredError('menuItemOptionSetItemId', 'Required parameter menuItemOptionSetItemId was null or undefined when calling deleteOptionSetItemImage.');
            }
            var localVarPath = "/api/v1.0/menus/{menuId}/sections/{menuSectionId}/sectionitems/{menuSectionItemId}/optionsets/{optionSetId}/optionsetitems/{menuItemOptionSetItemId}/image"
                .replace("{".concat("menuId", "}"), encodeURIComponent(String(menuId)))
                .replace("{".concat("menuSectionId", "}"), encodeURIComponent(String(menuSectionId)))
                .replace("{".concat("menuSectionItemId", "}"), encodeURIComponent(String(menuSectionItemId)))
                .replace("{".concat("optionSetId", "}"), encodeURIComponent(String(optionSetId)))
                .replace("{".concat("menuItemOptionSetItemId", "}"), encodeURIComponent(String(menuItemOptionSetItemId)));
            var localVarUrlObj = url.parse(localVarPath, true);
            var localVarRequestOptions = Object.assign({ method: 'DELETE' }, options);
            var localVarHeaderParameter = {};
            var localVarQueryParameter = {};
            if (configuration && configuration.accessToken) {
                var localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("oauth2", ["api"])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        getMenuItemOptionSetItemById: function (menuId, menuSectionId, menuSectionItemId, optionSetId, menuItemOptionSetItemId, options) {
            if (options === void 0) { options = {}; }
            if (menuId === null || menuId === undefined) {
                throw new RequiredError('menuId', 'Required parameter menuId was null or undefined when calling getMenuItemOptionSetItemById.');
            }
            if (menuSectionId === null || menuSectionId === undefined) {
                throw new RequiredError('menuSectionId', 'Required parameter menuSectionId was null or undefined when calling getMenuItemOptionSetItemById.');
            }
            if (menuSectionItemId === null || menuSectionItemId === undefined) {
                throw new RequiredError('menuSectionItemId', 'Required parameter menuSectionItemId was null or undefined when calling getMenuItemOptionSetItemById.');
            }
            if (optionSetId === null || optionSetId === undefined) {
                throw new RequiredError('optionSetId', 'Required parameter optionSetId was null or undefined when calling getMenuItemOptionSetItemById.');
            }
            if (menuItemOptionSetItemId === null || menuItemOptionSetItemId === undefined) {
                throw new RequiredError('menuItemOptionSetItemId', 'Required parameter menuItemOptionSetItemId was null or undefined when calling getMenuItemOptionSetItemById.');
            }
            var localVarPath = "/api/v1.0/menus/{menuId}/sections/{menuSectionId}/sectionitems/{menuSectionItemId}/optionsets/{optionSetId}/optionsetitems/{menuItemOptionSetItemId}"
                .replace("{".concat("menuId", "}"), encodeURIComponent(String(menuId)))
                .replace("{".concat("menuSectionId", "}"), encodeURIComponent(String(menuSectionId)))
                .replace("{".concat("menuSectionItemId", "}"), encodeURIComponent(String(menuSectionItemId)))
                .replace("{".concat("optionSetId", "}"), encodeURIComponent(String(optionSetId)))
                .replace("{".concat("menuItemOptionSetItemId", "}"), encodeURIComponent(String(menuItemOptionSetItemId)));
            var localVarUrlObj = url.parse(localVarPath, true);
            var localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            var localVarHeaderParameter = {};
            var localVarQueryParameter = {};
            if (configuration && configuration.accessToken) {
                var localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("oauth2", ["api"])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        getMenuItemOptionSetItems: function (menuId, menuSectionId, menuSectionItemId, optionSetId, options) {
            if (options === void 0) { options = {}; }
            if (menuId === null || menuId === undefined) {
                throw new RequiredError('menuId', 'Required parameter menuId was null or undefined when calling getMenuItemOptionSetItems.');
            }
            if (menuSectionId === null || menuSectionId === undefined) {
                throw new RequiredError('menuSectionId', 'Required parameter menuSectionId was null or undefined when calling getMenuItemOptionSetItems.');
            }
            if (menuSectionItemId === null || menuSectionItemId === undefined) {
                throw new RequiredError('menuSectionItemId', 'Required parameter menuSectionItemId was null or undefined when calling getMenuItemOptionSetItems.');
            }
            if (optionSetId === null || optionSetId === undefined) {
                throw new RequiredError('optionSetId', 'Required parameter optionSetId was null or undefined when calling getMenuItemOptionSetItems.');
            }
            var localVarPath = "/api/v1.0/menus/{menuId}/sections/{menuSectionId}/sectionitems/{menuSectionItemId}/optionsets/{optionSetId}/optionsetitems"
                .replace("{".concat("menuId", "}"), encodeURIComponent(String(menuId)))
                .replace("{".concat("menuSectionId", "}"), encodeURIComponent(String(menuSectionId)))
                .replace("{".concat("menuSectionItemId", "}"), encodeURIComponent(String(menuSectionItemId)))
                .replace("{".concat("optionSetId", "}"), encodeURIComponent(String(optionSetId)));
            var localVarUrlObj = url.parse(localVarPath, true);
            var localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            var localVarHeaderParameter = {};
            var localVarQueryParameter = {};
            if (configuration && configuration.accessToken) {
                var localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("oauth2", ["api"])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        removeMenuItemOptionSetItem: function (menuId, menuSectionId, menuSectionItemId, optionSetId, menuItemOptionSetItemId, options) {
            if (options === void 0) { options = {}; }
            if (menuId === null || menuId === undefined) {
                throw new RequiredError('menuId', 'Required parameter menuId was null or undefined when calling removeMenuItemOptionSetItem.');
            }
            if (menuSectionId === null || menuSectionId === undefined) {
                throw new RequiredError('menuSectionId', 'Required parameter menuSectionId was null or undefined when calling removeMenuItemOptionSetItem.');
            }
            if (menuSectionItemId === null || menuSectionItemId === undefined) {
                throw new RequiredError('menuSectionItemId', 'Required parameter menuSectionItemId was null or undefined when calling removeMenuItemOptionSetItem.');
            }
            if (optionSetId === null || optionSetId === undefined) {
                throw new RequiredError('optionSetId', 'Required parameter optionSetId was null or undefined when calling removeMenuItemOptionSetItem.');
            }
            if (menuItemOptionSetItemId === null || menuItemOptionSetItemId === undefined) {
                throw new RequiredError('menuItemOptionSetItemId', 'Required parameter menuItemOptionSetItemId was null or undefined when calling removeMenuItemOptionSetItem.');
            }
            var localVarPath = "/api/v1.0/menus/{menuId}/sections/{menuSectionId}/sectionitems/{menuSectionItemId}/optionsets/{optionSetId}/optionsetitems/{menuItemOptionSetItemId}"
                .replace("{".concat("menuId", "}"), encodeURIComponent(String(menuId)))
                .replace("{".concat("menuSectionId", "}"), encodeURIComponent(String(menuSectionId)))
                .replace("{".concat("menuSectionItemId", "}"), encodeURIComponent(String(menuSectionItemId)))
                .replace("{".concat("optionSetId", "}"), encodeURIComponent(String(optionSetId)))
                .replace("{".concat("menuItemOptionSetItemId", "}"), encodeURIComponent(String(menuItemOptionSetItemId)));
            var localVarUrlObj = url.parse(localVarPath, true);
            var localVarRequestOptions = Object.assign({ method: 'DELETE' }, options);
            var localVarHeaderParameter = {};
            var localVarQueryParameter = {};
            if (configuration && configuration.accessToken) {
                var localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("oauth2", ["api"])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        setOptionSetItemTax: function (menuId, menuSectionId, menuSectionItemId, optionSetId, menuItemOptionSetItemId, taxRateId, options) {
            if (options === void 0) { options = {}; }
            if (menuId === null || menuId === undefined) {
                throw new RequiredError('menuId', 'Required parameter menuId was null or undefined when calling setOptionSetItemTax.');
            }
            if (menuSectionId === null || menuSectionId === undefined) {
                throw new RequiredError('menuSectionId', 'Required parameter menuSectionId was null or undefined when calling setOptionSetItemTax.');
            }
            if (menuSectionItemId === null || menuSectionItemId === undefined) {
                throw new RequiredError('menuSectionItemId', 'Required parameter menuSectionItemId was null or undefined when calling setOptionSetItemTax.');
            }
            if (optionSetId === null || optionSetId === undefined) {
                throw new RequiredError('optionSetId', 'Required parameter optionSetId was null or undefined when calling setOptionSetItemTax.');
            }
            if (menuItemOptionSetItemId === null || menuItemOptionSetItemId === undefined) {
                throw new RequiredError('menuItemOptionSetItemId', 'Required parameter menuItemOptionSetItemId was null or undefined when calling setOptionSetItemTax.');
            }
            if (taxRateId === null || taxRateId === undefined) {
                throw new RequiredError('taxRateId', 'Required parameter taxRateId was null or undefined when calling setOptionSetItemTax.');
            }
            var localVarPath = "/api/v1.0/menus/{menuId}/sections/{menuSectionId}/sectionitems/{menuSectionItemId}/optionsets/{optionSetId}/optionsetitems/{menuItemOptionSetItemId}/taxrate/{taxRateId}"
                .replace("{".concat("menuId", "}"), encodeURIComponent(String(menuId)))
                .replace("{".concat("menuSectionId", "}"), encodeURIComponent(String(menuSectionId)))
                .replace("{".concat("menuSectionItemId", "}"), encodeURIComponent(String(menuSectionItemId)))
                .replace("{".concat("optionSetId", "}"), encodeURIComponent(String(optionSetId)))
                .replace("{".concat("menuItemOptionSetItemId", "}"), encodeURIComponent(String(menuItemOptionSetItemId)))
                .replace("{".concat("taxRateId", "}"), encodeURIComponent(String(taxRateId)));
            var localVarUrlObj = url.parse(localVarPath, true);
            var localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            var localVarHeaderParameter = {};
            var localVarQueryParameter = {};
            if (configuration && configuration.accessToken) {
                var localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("oauth2", ["api"])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        updateMenuItemOptionSetItem: function (menuId, menuSectionId, menuSectionItemId, optionSetId, menuItemOptionSetItemId, MenuItemOptionSetItemBase, undoAfter, options) {
            if (options === void 0) { options = {}; }
            if (menuId === null || menuId === undefined) {
                throw new RequiredError('menuId', 'Required parameter menuId was null or undefined when calling updateMenuItemOptionSetItem.');
            }
            if (menuSectionId === null || menuSectionId === undefined) {
                throw new RequiredError('menuSectionId', 'Required parameter menuSectionId was null or undefined when calling updateMenuItemOptionSetItem.');
            }
            if (menuSectionItemId === null || menuSectionItemId === undefined) {
                throw new RequiredError('menuSectionItemId', 'Required parameter menuSectionItemId was null or undefined when calling updateMenuItemOptionSetItem.');
            }
            if (optionSetId === null || optionSetId === undefined) {
                throw new RequiredError('optionSetId', 'Required parameter optionSetId was null or undefined when calling updateMenuItemOptionSetItem.');
            }
            if (menuItemOptionSetItemId === null || menuItemOptionSetItemId === undefined) {
                throw new RequiredError('menuItemOptionSetItemId', 'Required parameter menuItemOptionSetItemId was null or undefined when calling updateMenuItemOptionSetItem.');
            }
            if (MenuItemOptionSetItemBase === null || MenuItemOptionSetItemBase === undefined) {
                throw new RequiredError('MenuItemOptionSetItemBase', 'Required parameter MenuItemOptionSetItemBase was null or undefined when calling updateMenuItemOptionSetItem.');
            }
            var localVarPath = "/api/v1.0/menus/{menuId}/sections/{menuSectionId}/sectionitems/{menuSectionItemId}/optionsets/{optionSetId}/optionsetitems/{menuItemOptionSetItemId}"
                .replace("{".concat("menuId", "}"), encodeURIComponent(String(menuId)))
                .replace("{".concat("menuSectionId", "}"), encodeURIComponent(String(menuSectionId)))
                .replace("{".concat("menuSectionItemId", "}"), encodeURIComponent(String(menuSectionItemId)))
                .replace("{".concat("optionSetId", "}"), encodeURIComponent(String(optionSetId)))
                .replace("{".concat("menuItemOptionSetItemId", "}"), encodeURIComponent(String(menuItemOptionSetItemId)));
            var localVarUrlObj = url.parse(localVarPath, true);
            var localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            var localVarHeaderParameter = {};
            var localVarQueryParameter = {};
            if (configuration && configuration.accessToken) {
                var localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("oauth2", ["api"])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }
            if (undoAfter !== undefined) {
                localVarQueryParameter['undoAfter'] = undoAfter;
            }
            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            var needsSerialization = ("MenuItemOptionSetItemBase" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body = needsSerialization ? JSON.stringify(MenuItemOptionSetItemBase || {}) : (MenuItemOptionSetItemBase || "");
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        uploadOptionSetItemImage: function (menuId, menuSectionId, menuSectionItemId, optionSetId, menuItemOptionSetItemId, Image, options) {
            if (options === void 0) { options = {}; }
            if (menuId === null || menuId === undefined) {
                throw new RequiredError('menuId', 'Required parameter menuId was null or undefined when calling uploadOptionSetItemImage.');
            }
            if (menuSectionId === null || menuSectionId === undefined) {
                throw new RequiredError('menuSectionId', 'Required parameter menuSectionId was null or undefined when calling uploadOptionSetItemImage.');
            }
            if (menuSectionItemId === null || menuSectionItemId === undefined) {
                throw new RequiredError('menuSectionItemId', 'Required parameter menuSectionItemId was null or undefined when calling uploadOptionSetItemImage.');
            }
            if (optionSetId === null || optionSetId === undefined) {
                throw new RequiredError('optionSetId', 'Required parameter optionSetId was null or undefined when calling uploadOptionSetItemImage.');
            }
            if (menuItemOptionSetItemId === null || menuItemOptionSetItemId === undefined) {
                throw new RequiredError('menuItemOptionSetItemId', 'Required parameter menuItemOptionSetItemId was null or undefined when calling uploadOptionSetItemImage.');
            }
            if (Image === null || Image === undefined) {
                throw new RequiredError('Image', 'Required parameter Image was null or undefined when calling uploadOptionSetItemImage.');
            }
            var localVarPath = "/api/v1.0/menus/{menuId}/sections/{menuSectionId}/sectionitems/{menuSectionItemId}/optionsets/{optionSetId}/optionsetitems/{menuItemOptionSetItemId}/image"
                .replace("{".concat("menuId", "}"), encodeURIComponent(String(menuId)))
                .replace("{".concat("menuSectionId", "}"), encodeURIComponent(String(menuSectionId)))
                .replace("{".concat("menuSectionItemId", "}"), encodeURIComponent(String(menuSectionItemId)))
                .replace("{".concat("optionSetId", "}"), encodeURIComponent(String(optionSetId)))
                .replace("{".concat("menuItemOptionSetItemId", "}"), encodeURIComponent(String(menuItemOptionSetItemId)));
            var localVarUrlObj = url.parse(localVarPath, true);
            var localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            var localVarHeaderParameter = {};
            var localVarQueryParameter = {};
            var localVarFormParams = new url.URLSearchParams();
            if (configuration && configuration.accessToken) {
                var localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("oauth2", ["api"])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }
            if (Image !== undefined) {
                localVarFormParams.set('Image', Image);
            }
            localVarHeaderParameter['Content-Type'] = 'application/x-www-form-urlencoded';
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            localVarRequestOptions.body = localVarFormParams.toString();
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    };
};
exports.MenuOptionSetItemsApiFetchParamCreator = MenuOptionSetItemsApiFetchParamCreator;
var MenuOptionSetItemsApiFp = function (configuration) {
    return {
        addMenuItemOptionSetItem: function (menuId, menuSectionId, menuSectionItemId, optionSetId, MenuItemOptionSetItemBase, options) {
            var localVarFetchArgs = (0, exports.MenuOptionSetItemsApiFetchParamCreator)(configuration).addMenuItemOptionSetItem(menuId, menuSectionId, menuSectionItemId, optionSetId, MenuItemOptionSetItemBase, options);
            return function (fetch, basePath) {
                if (fetch === void 0) { fetch = portableFetch; }
                if (basePath === void 0) { basePath = BASE_PATH; }
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then(function (response) {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
        deleteOptionSetItemImage: function (menuId, menuSectionId, menuSectionItemId, optionSetId, menuItemOptionSetItemId, options) {
            var localVarFetchArgs = (0, exports.MenuOptionSetItemsApiFetchParamCreator)(configuration).deleteOptionSetItemImage(menuId, menuSectionId, menuSectionItemId, optionSetId, menuItemOptionSetItemId, options);
            return function (fetch, basePath) {
                if (fetch === void 0) { fetch = portableFetch; }
                if (basePath === void 0) { basePath = BASE_PATH; }
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then(function (response) {
                    if (response.status >= 200 && response.status < 300) {
                        return response;
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
        getMenuItemOptionSetItemById: function (menuId, menuSectionId, menuSectionItemId, optionSetId, menuItemOptionSetItemId, options) {
            var localVarFetchArgs = (0, exports.MenuOptionSetItemsApiFetchParamCreator)(configuration).getMenuItemOptionSetItemById(menuId, menuSectionId, menuSectionItemId, optionSetId, menuItemOptionSetItemId, options);
            return function (fetch, basePath) {
                if (fetch === void 0) { fetch = portableFetch; }
                if (basePath === void 0) { basePath = BASE_PATH; }
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then(function (response) {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
        getMenuItemOptionSetItems: function (menuId, menuSectionId, menuSectionItemId, optionSetId, options) {
            var localVarFetchArgs = (0, exports.MenuOptionSetItemsApiFetchParamCreator)(configuration).getMenuItemOptionSetItems(menuId, menuSectionId, menuSectionItemId, optionSetId, options);
            return function (fetch, basePath) {
                if (fetch === void 0) { fetch = portableFetch; }
                if (basePath === void 0) { basePath = BASE_PATH; }
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then(function (response) {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
        removeMenuItemOptionSetItem: function (menuId, menuSectionId, menuSectionItemId, optionSetId, menuItemOptionSetItemId, options) {
            var localVarFetchArgs = (0, exports.MenuOptionSetItemsApiFetchParamCreator)(configuration).removeMenuItemOptionSetItem(menuId, menuSectionId, menuSectionItemId, optionSetId, menuItemOptionSetItemId, options);
            return function (fetch, basePath) {
                if (fetch === void 0) { fetch = portableFetch; }
                if (basePath === void 0) { basePath = BASE_PATH; }
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then(function (response) {
                    if (response.status >= 200 && response.status < 300) {
                        return response;
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
        setOptionSetItemTax: function (menuId, menuSectionId, menuSectionItemId, optionSetId, menuItemOptionSetItemId, taxRateId, options) {
            var localVarFetchArgs = (0, exports.MenuOptionSetItemsApiFetchParamCreator)(configuration).setOptionSetItemTax(menuId, menuSectionId, menuSectionItemId, optionSetId, menuItemOptionSetItemId, taxRateId, options);
            return function (fetch, basePath) {
                if (fetch === void 0) { fetch = portableFetch; }
                if (basePath === void 0) { basePath = BASE_PATH; }
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then(function (response) {
                    if (response.status >= 200 && response.status < 300) {
                        return response;
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
        updateMenuItemOptionSetItem: function (menuId, menuSectionId, menuSectionItemId, optionSetId, menuItemOptionSetItemId, MenuItemOptionSetItemBase, undoAfter, options) {
            var localVarFetchArgs = (0, exports.MenuOptionSetItemsApiFetchParamCreator)(configuration).updateMenuItemOptionSetItem(menuId, menuSectionId, menuSectionItemId, optionSetId, menuItemOptionSetItemId, MenuItemOptionSetItemBase, undoAfter, options);
            return function (fetch, basePath) {
                if (fetch === void 0) { fetch = portableFetch; }
                if (basePath === void 0) { basePath = BASE_PATH; }
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then(function (response) {
                    if (response.status >= 200 && response.status < 300) {
                        return response;
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
        uploadOptionSetItemImage: function (menuId, menuSectionId, menuSectionItemId, optionSetId, menuItemOptionSetItemId, Image, options) {
            var localVarFetchArgs = (0, exports.MenuOptionSetItemsApiFetchParamCreator)(configuration).uploadOptionSetItemImage(menuId, menuSectionId, menuSectionItemId, optionSetId, menuItemOptionSetItemId, Image, options);
            return function (fetch, basePath) {
                if (fetch === void 0) { fetch = portableFetch; }
                if (basePath === void 0) { basePath = BASE_PATH; }
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then(function (response) {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
    };
};
exports.MenuOptionSetItemsApiFp = MenuOptionSetItemsApiFp;
var MenuOptionSetItemsApiFactory = function (configuration, fetch, basePath) {
    return {
        addMenuItemOptionSetItem: function (menuId, menuSectionId, menuSectionItemId, optionSetId, MenuItemOptionSetItemBase, options) {
            return (0, exports.MenuOptionSetItemsApiFp)(configuration).addMenuItemOptionSetItem(menuId, menuSectionId, menuSectionItemId, optionSetId, MenuItemOptionSetItemBase, options)(fetch, basePath);
        },
        deleteOptionSetItemImage: function (menuId, menuSectionId, menuSectionItemId, optionSetId, menuItemOptionSetItemId, options) {
            return (0, exports.MenuOptionSetItemsApiFp)(configuration).deleteOptionSetItemImage(menuId, menuSectionId, menuSectionItemId, optionSetId, menuItemOptionSetItemId, options)(fetch, basePath);
        },
        getMenuItemOptionSetItemById: function (menuId, menuSectionId, menuSectionItemId, optionSetId, menuItemOptionSetItemId, options) {
            return (0, exports.MenuOptionSetItemsApiFp)(configuration).getMenuItemOptionSetItemById(menuId, menuSectionId, menuSectionItemId, optionSetId, menuItemOptionSetItemId, options)(fetch, basePath);
        },
        getMenuItemOptionSetItems: function (menuId, menuSectionId, menuSectionItemId, optionSetId, options) {
            return (0, exports.MenuOptionSetItemsApiFp)(configuration).getMenuItemOptionSetItems(menuId, menuSectionId, menuSectionItemId, optionSetId, options)(fetch, basePath);
        },
        removeMenuItemOptionSetItem: function (menuId, menuSectionId, menuSectionItemId, optionSetId, menuItemOptionSetItemId, options) {
            return (0, exports.MenuOptionSetItemsApiFp)(configuration).removeMenuItemOptionSetItem(menuId, menuSectionId, menuSectionItemId, optionSetId, menuItemOptionSetItemId, options)(fetch, basePath);
        },
        setOptionSetItemTax: function (menuId, menuSectionId, menuSectionItemId, optionSetId, menuItemOptionSetItemId, taxRateId, options) {
            return (0, exports.MenuOptionSetItemsApiFp)(configuration).setOptionSetItemTax(menuId, menuSectionId, menuSectionItemId, optionSetId, menuItemOptionSetItemId, taxRateId, options)(fetch, basePath);
        },
        updateMenuItemOptionSetItem: function (menuId, menuSectionId, menuSectionItemId, optionSetId, menuItemOptionSetItemId, MenuItemOptionSetItemBase, undoAfter, options) {
            return (0, exports.MenuOptionSetItemsApiFp)(configuration).updateMenuItemOptionSetItem(menuId, menuSectionId, menuSectionItemId, optionSetId, menuItemOptionSetItemId, MenuItemOptionSetItemBase, undoAfter, options)(fetch, basePath);
        },
        uploadOptionSetItemImage: function (menuId, menuSectionId, menuSectionItemId, optionSetId, menuItemOptionSetItemId, Image, options) {
            return (0, exports.MenuOptionSetItemsApiFp)(configuration).uploadOptionSetItemImage(menuId, menuSectionId, menuSectionItemId, optionSetId, menuItemOptionSetItemId, Image, options)(fetch, basePath);
        },
    };
};
exports.MenuOptionSetItemsApiFactory = MenuOptionSetItemsApiFactory;
var MenuOptionSetItemsApi = (function (_super) {
    __extends(MenuOptionSetItemsApi, _super);
    function MenuOptionSetItemsApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    MenuOptionSetItemsApi.prototype.addMenuItemOptionSetItem = function (menuId, menuSectionId, menuSectionItemId, optionSetId, MenuItemOptionSetItemBase, options) {
        return (0, exports.MenuOptionSetItemsApiFp)(this.configuration).addMenuItemOptionSetItem(menuId, menuSectionId, menuSectionItemId, optionSetId, MenuItemOptionSetItemBase, options)(this.fetch, this.basePath);
    };
    MenuOptionSetItemsApi.prototype.deleteOptionSetItemImage = function (menuId, menuSectionId, menuSectionItemId, optionSetId, menuItemOptionSetItemId, options) {
        return (0, exports.MenuOptionSetItemsApiFp)(this.configuration).deleteOptionSetItemImage(menuId, menuSectionId, menuSectionItemId, optionSetId, menuItemOptionSetItemId, options)(this.fetch, this.basePath);
    };
    MenuOptionSetItemsApi.prototype.getMenuItemOptionSetItemById = function (menuId, menuSectionId, menuSectionItemId, optionSetId, menuItemOptionSetItemId, options) {
        return (0, exports.MenuOptionSetItemsApiFp)(this.configuration).getMenuItemOptionSetItemById(menuId, menuSectionId, menuSectionItemId, optionSetId, menuItemOptionSetItemId, options)(this.fetch, this.basePath);
    };
    MenuOptionSetItemsApi.prototype.getMenuItemOptionSetItems = function (menuId, menuSectionId, menuSectionItemId, optionSetId, options) {
        return (0, exports.MenuOptionSetItemsApiFp)(this.configuration).getMenuItemOptionSetItems(menuId, menuSectionId, menuSectionItemId, optionSetId, options)(this.fetch, this.basePath);
    };
    MenuOptionSetItemsApi.prototype.removeMenuItemOptionSetItem = function (menuId, menuSectionId, menuSectionItemId, optionSetId, menuItemOptionSetItemId, options) {
        return (0, exports.MenuOptionSetItemsApiFp)(this.configuration).removeMenuItemOptionSetItem(menuId, menuSectionId, menuSectionItemId, optionSetId, menuItemOptionSetItemId, options)(this.fetch, this.basePath);
    };
    MenuOptionSetItemsApi.prototype.setOptionSetItemTax = function (menuId, menuSectionId, menuSectionItemId, optionSetId, menuItemOptionSetItemId, taxRateId, options) {
        return (0, exports.MenuOptionSetItemsApiFp)(this.configuration).setOptionSetItemTax(menuId, menuSectionId, menuSectionItemId, optionSetId, menuItemOptionSetItemId, taxRateId, options)(this.fetch, this.basePath);
    };
    MenuOptionSetItemsApi.prototype.updateMenuItemOptionSetItem = function (menuId, menuSectionId, menuSectionItemId, optionSetId, menuItemOptionSetItemId, MenuItemOptionSetItemBase, undoAfter, options) {
        return (0, exports.MenuOptionSetItemsApiFp)(this.configuration).updateMenuItemOptionSetItem(menuId, menuSectionId, menuSectionItemId, optionSetId, menuItemOptionSetItemId, MenuItemOptionSetItemBase, undoAfter, options)(this.fetch, this.basePath);
    };
    MenuOptionSetItemsApi.prototype.uploadOptionSetItemImage = function (menuId, menuSectionId, menuSectionItemId, optionSetId, menuItemOptionSetItemId, Image, options) {
        return (0, exports.MenuOptionSetItemsApiFp)(this.configuration).uploadOptionSetItemImage(menuId, menuSectionId, menuSectionItemId, optionSetId, menuItemOptionSetItemId, Image, options)(this.fetch, this.basePath);
    };
    return MenuOptionSetItemsApi;
}(BaseAPI));
exports.MenuOptionSetItemsApi = MenuOptionSetItemsApi;
var MenuOptionSetsApiFetchParamCreator = function (configuration) {
    return {
        createMenuItemOptionSet: function (menuId, menuSectionId, menuSectionItemId, MenuItemOptionSetBase, options) {
            if (options === void 0) { options = {}; }
            if (menuId === null || menuId === undefined) {
                throw new RequiredError('menuId', 'Required parameter menuId was null or undefined when calling createMenuItemOptionSet.');
            }
            if (menuSectionId === null || menuSectionId === undefined) {
                throw new RequiredError('menuSectionId', 'Required parameter menuSectionId was null or undefined when calling createMenuItemOptionSet.');
            }
            if (menuSectionItemId === null || menuSectionItemId === undefined) {
                throw new RequiredError('menuSectionItemId', 'Required parameter menuSectionItemId was null or undefined when calling createMenuItemOptionSet.');
            }
            if (MenuItemOptionSetBase === null || MenuItemOptionSetBase === undefined) {
                throw new RequiredError('MenuItemOptionSetBase', 'Required parameter MenuItemOptionSetBase was null or undefined when calling createMenuItemOptionSet.');
            }
            var localVarPath = "/api/v1.0/menus/{menuId}/sections/{menuSectionId}/sectionitems/{menuSectionItemId}/optionsets"
                .replace("{".concat("menuId", "}"), encodeURIComponent(String(menuId)))
                .replace("{".concat("menuSectionId", "}"), encodeURIComponent(String(menuSectionId)))
                .replace("{".concat("menuSectionItemId", "}"), encodeURIComponent(String(menuSectionItemId)));
            var localVarUrlObj = url.parse(localVarPath, true);
            var localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            var localVarHeaderParameter = {};
            var localVarQueryParameter = {};
            if (configuration && configuration.accessToken) {
                var localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("oauth2", ["api"])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }
            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            var needsSerialization = ("MenuItemOptionSetBase" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body = needsSerialization ? JSON.stringify(MenuItemOptionSetBase || {}) : (MenuItemOptionSetBase || "");
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        deleteMenuItemOptionSet: function (menuId, menuSectionItemId, menuSectionId, optionSetId, options) {
            if (options === void 0) { options = {}; }
            if (menuId === null || menuId === undefined) {
                throw new RequiredError('menuId', 'Required parameter menuId was null or undefined when calling deleteMenuItemOptionSet.');
            }
            if (menuSectionItemId === null || menuSectionItemId === undefined) {
                throw new RequiredError('menuSectionItemId', 'Required parameter menuSectionItemId was null or undefined when calling deleteMenuItemOptionSet.');
            }
            if (menuSectionId === null || menuSectionId === undefined) {
                throw new RequiredError('menuSectionId', 'Required parameter menuSectionId was null or undefined when calling deleteMenuItemOptionSet.');
            }
            if (optionSetId === null || optionSetId === undefined) {
                throw new RequiredError('optionSetId', 'Required parameter optionSetId was null or undefined when calling deleteMenuItemOptionSet.');
            }
            var localVarPath = "/api/v1.0/menus/{menuId}/sections/{menuSectionId}/sectionitems/{menuSectionItemId}/optionsets/{optionSetId}"
                .replace("{".concat("menuId", "}"), encodeURIComponent(String(menuId)))
                .replace("{".concat("menuSectionItemId", "}"), encodeURIComponent(String(menuSectionItemId)))
                .replace("{".concat("menuSectionId", "}"), encodeURIComponent(String(menuSectionId)))
                .replace("{".concat("optionSetId", "}"), encodeURIComponent(String(optionSetId)));
            var localVarUrlObj = url.parse(localVarPath, true);
            var localVarRequestOptions = Object.assign({ method: 'DELETE' }, options);
            var localVarHeaderParameter = {};
            var localVarQueryParameter = {};
            if (configuration && configuration.accessToken) {
                var localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("oauth2", ["api"])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        deleteOptionSetImage: function (menuId, menuSectionId, menuSectionItemId, optionSetId, options) {
            if (options === void 0) { options = {}; }
            if (menuId === null || menuId === undefined) {
                throw new RequiredError('menuId', 'Required parameter menuId was null or undefined when calling deleteOptionSetImage.');
            }
            if (menuSectionId === null || menuSectionId === undefined) {
                throw new RequiredError('menuSectionId', 'Required parameter menuSectionId was null or undefined when calling deleteOptionSetImage.');
            }
            if (menuSectionItemId === null || menuSectionItemId === undefined) {
                throw new RequiredError('menuSectionItemId', 'Required parameter menuSectionItemId was null or undefined when calling deleteOptionSetImage.');
            }
            if (optionSetId === null || optionSetId === undefined) {
                throw new RequiredError('optionSetId', 'Required parameter optionSetId was null or undefined when calling deleteOptionSetImage.');
            }
            var localVarPath = "/api/v1.0/menus/{menuId}/sections/{menuSectionId}/sectionitems/{menuSectionItemId}/optionsets/{optionSetId}/image"
                .replace("{".concat("menuId", "}"), encodeURIComponent(String(menuId)))
                .replace("{".concat("menuSectionId", "}"), encodeURIComponent(String(menuSectionId)))
                .replace("{".concat("menuSectionItemId", "}"), encodeURIComponent(String(menuSectionItemId)))
                .replace("{".concat("optionSetId", "}"), encodeURIComponent(String(optionSetId)));
            var localVarUrlObj = url.parse(localVarPath, true);
            var localVarRequestOptions = Object.assign({ method: 'DELETE' }, options);
            var localVarHeaderParameter = {};
            var localVarQueryParameter = {};
            if (configuration && configuration.accessToken) {
                var localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("oauth2", ["api"])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        getMenuItemOptionSetById: function (menuId, menuSectionId, menuSectionItemId, optionSetId, options) {
            if (options === void 0) { options = {}; }
            if (menuId === null || menuId === undefined) {
                throw new RequiredError('menuId', 'Required parameter menuId was null or undefined when calling getMenuItemOptionSetById.');
            }
            if (menuSectionId === null || menuSectionId === undefined) {
                throw new RequiredError('menuSectionId', 'Required parameter menuSectionId was null or undefined when calling getMenuItemOptionSetById.');
            }
            if (menuSectionItemId === null || menuSectionItemId === undefined) {
                throw new RequiredError('menuSectionItemId', 'Required parameter menuSectionItemId was null or undefined when calling getMenuItemOptionSetById.');
            }
            if (optionSetId === null || optionSetId === undefined) {
                throw new RequiredError('optionSetId', 'Required parameter optionSetId was null or undefined when calling getMenuItemOptionSetById.');
            }
            var localVarPath = "/api/v1.0/menus/{menuId}/sections/{menuSectionId}/sectionitems/{menuSectionItemId}/optionsets/{optionSetId}"
                .replace("{".concat("menuId", "}"), encodeURIComponent(String(menuId)))
                .replace("{".concat("menuSectionId", "}"), encodeURIComponent(String(menuSectionId)))
                .replace("{".concat("menuSectionItemId", "}"), encodeURIComponent(String(menuSectionItemId)))
                .replace("{".concat("optionSetId", "}"), encodeURIComponent(String(optionSetId)));
            var localVarUrlObj = url.parse(localVarPath, true);
            var localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            var localVarHeaderParameter = {};
            var localVarQueryParameter = {};
            if (configuration && configuration.accessToken) {
                var localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("oauth2", ["api"])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        getMenuItemOptionSets: function (menuId, menuSectionId, menuSectionItemId, options) {
            if (options === void 0) { options = {}; }
            if (menuId === null || menuId === undefined) {
                throw new RequiredError('menuId', 'Required parameter menuId was null or undefined when calling getMenuItemOptionSets.');
            }
            if (menuSectionId === null || menuSectionId === undefined) {
                throw new RequiredError('menuSectionId', 'Required parameter menuSectionId was null or undefined when calling getMenuItemOptionSets.');
            }
            if (menuSectionItemId === null || menuSectionItemId === undefined) {
                throw new RequiredError('menuSectionItemId', 'Required parameter menuSectionItemId was null or undefined when calling getMenuItemOptionSets.');
            }
            var localVarPath = "/api/v1.0/menus/{menuId}/sections/{menuSectionId}/sectionitems/{menuSectionItemId}/optionsets"
                .replace("{".concat("menuId", "}"), encodeURIComponent(String(menuId)))
                .replace("{".concat("menuSectionId", "}"), encodeURIComponent(String(menuSectionId)))
                .replace("{".concat("menuSectionItemId", "}"), encodeURIComponent(String(menuSectionItemId)));
            var localVarUrlObj = url.parse(localVarPath, true);
            var localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            var localVarHeaderParameter = {};
            var localVarQueryParameter = {};
            if (configuration && configuration.accessToken) {
                var localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("oauth2", ["api"])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        updateMenuItemOptionSet: function (menuId, menuSectionId, menuSectionItemId, optionSetId, MenuItemOptionSetBase, options) {
            if (options === void 0) { options = {}; }
            if (menuId === null || menuId === undefined) {
                throw new RequiredError('menuId', 'Required parameter menuId was null or undefined when calling updateMenuItemOptionSet.');
            }
            if (menuSectionId === null || menuSectionId === undefined) {
                throw new RequiredError('menuSectionId', 'Required parameter menuSectionId was null or undefined when calling updateMenuItemOptionSet.');
            }
            if (menuSectionItemId === null || menuSectionItemId === undefined) {
                throw new RequiredError('menuSectionItemId', 'Required parameter menuSectionItemId was null or undefined when calling updateMenuItemOptionSet.');
            }
            if (optionSetId === null || optionSetId === undefined) {
                throw new RequiredError('optionSetId', 'Required parameter optionSetId was null or undefined when calling updateMenuItemOptionSet.');
            }
            if (MenuItemOptionSetBase === null || MenuItemOptionSetBase === undefined) {
                throw new RequiredError('MenuItemOptionSetBase', 'Required parameter MenuItemOptionSetBase was null or undefined when calling updateMenuItemOptionSet.');
            }
            var localVarPath = "/api/v1.0/menus/{menuId}/sections/{menuSectionId}/sectionitems/{menuSectionItemId}/optionsets/{optionSetId}"
                .replace("{".concat("menuId", "}"), encodeURIComponent(String(menuId)))
                .replace("{".concat("menuSectionId", "}"), encodeURIComponent(String(menuSectionId)))
                .replace("{".concat("menuSectionItemId", "}"), encodeURIComponent(String(menuSectionItemId)))
                .replace("{".concat("optionSetId", "}"), encodeURIComponent(String(optionSetId)));
            var localVarUrlObj = url.parse(localVarPath, true);
            var localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            var localVarHeaderParameter = {};
            var localVarQueryParameter = {};
            if (configuration && configuration.accessToken) {
                var localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("oauth2", ["api"])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }
            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            var needsSerialization = ("MenuItemOptionSetBase" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body = needsSerialization ? JSON.stringify(MenuItemOptionSetBase || {}) : (MenuItemOptionSetBase || "");
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        uploadOptionSetImage: function (menuId, menuSectionId, menuSectionItemId, optionSetId, Image, options) {
            if (options === void 0) { options = {}; }
            if (menuId === null || menuId === undefined) {
                throw new RequiredError('menuId', 'Required parameter menuId was null or undefined when calling uploadOptionSetImage.');
            }
            if (menuSectionId === null || menuSectionId === undefined) {
                throw new RequiredError('menuSectionId', 'Required parameter menuSectionId was null or undefined when calling uploadOptionSetImage.');
            }
            if (menuSectionItemId === null || menuSectionItemId === undefined) {
                throw new RequiredError('menuSectionItemId', 'Required parameter menuSectionItemId was null or undefined when calling uploadOptionSetImage.');
            }
            if (optionSetId === null || optionSetId === undefined) {
                throw new RequiredError('optionSetId', 'Required parameter optionSetId was null or undefined when calling uploadOptionSetImage.');
            }
            if (Image === null || Image === undefined) {
                throw new RequiredError('Image', 'Required parameter Image was null or undefined when calling uploadOptionSetImage.');
            }
            var localVarPath = "/api/v1.0/menus/{menuId}/sections/{menuSectionId}/sectionitems/{menuSectionItemId}/optionsets/{optionSetId}/image"
                .replace("{".concat("menuId", "}"), encodeURIComponent(String(menuId)))
                .replace("{".concat("menuSectionId", "}"), encodeURIComponent(String(menuSectionId)))
                .replace("{".concat("menuSectionItemId", "}"), encodeURIComponent(String(menuSectionItemId)))
                .replace("{".concat("optionSetId", "}"), encodeURIComponent(String(optionSetId)));
            var localVarUrlObj = url.parse(localVarPath, true);
            var localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            var localVarHeaderParameter = {};
            var localVarQueryParameter = {};
            var localVarFormParams = new url.URLSearchParams();
            if (configuration && configuration.accessToken) {
                var localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("oauth2", ["api"])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }
            if (Image !== undefined) {
                localVarFormParams.set('Image', Image);
            }
            localVarHeaderParameter['Content-Type'] = 'application/x-www-form-urlencoded';
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            localVarRequestOptions.body = localVarFormParams.toString();
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    };
};
exports.MenuOptionSetsApiFetchParamCreator = MenuOptionSetsApiFetchParamCreator;
var MenuOptionSetsApiFp = function (configuration) {
    return {
        createMenuItemOptionSet: function (menuId, menuSectionId, menuSectionItemId, MenuItemOptionSetBase, options) {
            var localVarFetchArgs = (0, exports.MenuOptionSetsApiFetchParamCreator)(configuration).createMenuItemOptionSet(menuId, menuSectionId, menuSectionItemId, MenuItemOptionSetBase, options);
            return function (fetch, basePath) {
                if (fetch === void 0) { fetch = portableFetch; }
                if (basePath === void 0) { basePath = BASE_PATH; }
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then(function (response) {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
        deleteMenuItemOptionSet: function (menuId, menuSectionItemId, menuSectionId, optionSetId, options) {
            var localVarFetchArgs = (0, exports.MenuOptionSetsApiFetchParamCreator)(configuration).deleteMenuItemOptionSet(menuId, menuSectionItemId, menuSectionId, optionSetId, options);
            return function (fetch, basePath) {
                if (fetch === void 0) { fetch = portableFetch; }
                if (basePath === void 0) { basePath = BASE_PATH; }
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then(function (response) {
                    if (response.status >= 200 && response.status < 300) {
                        return response;
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
        deleteOptionSetImage: function (menuId, menuSectionId, menuSectionItemId, optionSetId, options) {
            var localVarFetchArgs = (0, exports.MenuOptionSetsApiFetchParamCreator)(configuration).deleteOptionSetImage(menuId, menuSectionId, menuSectionItemId, optionSetId, options);
            return function (fetch, basePath) {
                if (fetch === void 0) { fetch = portableFetch; }
                if (basePath === void 0) { basePath = BASE_PATH; }
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then(function (response) {
                    if (response.status >= 200 && response.status < 300) {
                        return response;
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
        getMenuItemOptionSetById: function (menuId, menuSectionId, menuSectionItemId, optionSetId, options) {
            var localVarFetchArgs = (0, exports.MenuOptionSetsApiFetchParamCreator)(configuration).getMenuItemOptionSetById(menuId, menuSectionId, menuSectionItemId, optionSetId, options);
            return function (fetch, basePath) {
                if (fetch === void 0) { fetch = portableFetch; }
                if (basePath === void 0) { basePath = BASE_PATH; }
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then(function (response) {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
        getMenuItemOptionSets: function (menuId, menuSectionId, menuSectionItemId, options) {
            var localVarFetchArgs = (0, exports.MenuOptionSetsApiFetchParamCreator)(configuration).getMenuItemOptionSets(menuId, menuSectionId, menuSectionItemId, options);
            return function (fetch, basePath) {
                if (fetch === void 0) { fetch = portableFetch; }
                if (basePath === void 0) { basePath = BASE_PATH; }
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then(function (response) {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
        updateMenuItemOptionSet: function (menuId, menuSectionId, menuSectionItemId, optionSetId, MenuItemOptionSetBase, options) {
            var localVarFetchArgs = (0, exports.MenuOptionSetsApiFetchParamCreator)(configuration).updateMenuItemOptionSet(menuId, menuSectionId, menuSectionItemId, optionSetId, MenuItemOptionSetBase, options);
            return function (fetch, basePath) {
                if (fetch === void 0) { fetch = portableFetch; }
                if (basePath === void 0) { basePath = BASE_PATH; }
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then(function (response) {
                    if (response.status >= 200 && response.status < 300) {
                        return response;
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
        uploadOptionSetImage: function (menuId, menuSectionId, menuSectionItemId, optionSetId, Image, options) {
            var localVarFetchArgs = (0, exports.MenuOptionSetsApiFetchParamCreator)(configuration).uploadOptionSetImage(menuId, menuSectionId, menuSectionItemId, optionSetId, Image, options);
            return function (fetch, basePath) {
                if (fetch === void 0) { fetch = portableFetch; }
                if (basePath === void 0) { basePath = BASE_PATH; }
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then(function (response) {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
    };
};
exports.MenuOptionSetsApiFp = MenuOptionSetsApiFp;
var MenuOptionSetsApiFactory = function (configuration, fetch, basePath) {
    return {
        createMenuItemOptionSet: function (menuId, menuSectionId, menuSectionItemId, MenuItemOptionSetBase, options) {
            return (0, exports.MenuOptionSetsApiFp)(configuration).createMenuItemOptionSet(menuId, menuSectionId, menuSectionItemId, MenuItemOptionSetBase, options)(fetch, basePath);
        },
        deleteMenuItemOptionSet: function (menuId, menuSectionItemId, menuSectionId, optionSetId, options) {
            return (0, exports.MenuOptionSetsApiFp)(configuration).deleteMenuItemOptionSet(menuId, menuSectionItemId, menuSectionId, optionSetId, options)(fetch, basePath);
        },
        deleteOptionSetImage: function (menuId, menuSectionId, menuSectionItemId, optionSetId, options) {
            return (0, exports.MenuOptionSetsApiFp)(configuration).deleteOptionSetImage(menuId, menuSectionId, menuSectionItemId, optionSetId, options)(fetch, basePath);
        },
        getMenuItemOptionSetById: function (menuId, menuSectionId, menuSectionItemId, optionSetId, options) {
            return (0, exports.MenuOptionSetsApiFp)(configuration).getMenuItemOptionSetById(menuId, menuSectionId, menuSectionItemId, optionSetId, options)(fetch, basePath);
        },
        getMenuItemOptionSets: function (menuId, menuSectionId, menuSectionItemId, options) {
            return (0, exports.MenuOptionSetsApiFp)(configuration).getMenuItemOptionSets(menuId, menuSectionId, menuSectionItemId, options)(fetch, basePath);
        },
        updateMenuItemOptionSet: function (menuId, menuSectionId, menuSectionItemId, optionSetId, MenuItemOptionSetBase, options) {
            return (0, exports.MenuOptionSetsApiFp)(configuration).updateMenuItemOptionSet(menuId, menuSectionId, menuSectionItemId, optionSetId, MenuItemOptionSetBase, options)(fetch, basePath);
        },
        uploadOptionSetImage: function (menuId, menuSectionId, menuSectionItemId, optionSetId, Image, options) {
            return (0, exports.MenuOptionSetsApiFp)(configuration).uploadOptionSetImage(menuId, menuSectionId, menuSectionItemId, optionSetId, Image, options)(fetch, basePath);
        },
    };
};
exports.MenuOptionSetsApiFactory = MenuOptionSetsApiFactory;
var MenuOptionSetsApi = (function (_super) {
    __extends(MenuOptionSetsApi, _super);
    function MenuOptionSetsApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    MenuOptionSetsApi.prototype.createMenuItemOptionSet = function (menuId, menuSectionId, menuSectionItemId, MenuItemOptionSetBase, options) {
        return (0, exports.MenuOptionSetsApiFp)(this.configuration).createMenuItemOptionSet(menuId, menuSectionId, menuSectionItemId, MenuItemOptionSetBase, options)(this.fetch, this.basePath);
    };
    MenuOptionSetsApi.prototype.deleteMenuItemOptionSet = function (menuId, menuSectionItemId, menuSectionId, optionSetId, options) {
        return (0, exports.MenuOptionSetsApiFp)(this.configuration).deleteMenuItemOptionSet(menuId, menuSectionItemId, menuSectionId, optionSetId, options)(this.fetch, this.basePath);
    };
    MenuOptionSetsApi.prototype.deleteOptionSetImage = function (menuId, menuSectionId, menuSectionItemId, optionSetId, options) {
        return (0, exports.MenuOptionSetsApiFp)(this.configuration).deleteOptionSetImage(menuId, menuSectionId, menuSectionItemId, optionSetId, options)(this.fetch, this.basePath);
    };
    MenuOptionSetsApi.prototype.getMenuItemOptionSetById = function (menuId, menuSectionId, menuSectionItemId, optionSetId, options) {
        return (0, exports.MenuOptionSetsApiFp)(this.configuration).getMenuItemOptionSetById(menuId, menuSectionId, menuSectionItemId, optionSetId, options)(this.fetch, this.basePath);
    };
    MenuOptionSetsApi.prototype.getMenuItemOptionSets = function (menuId, menuSectionId, menuSectionItemId, options) {
        return (0, exports.MenuOptionSetsApiFp)(this.configuration).getMenuItemOptionSets(menuId, menuSectionId, menuSectionItemId, options)(this.fetch, this.basePath);
    };
    MenuOptionSetsApi.prototype.updateMenuItemOptionSet = function (menuId, menuSectionId, menuSectionItemId, optionSetId, MenuItemOptionSetBase, options) {
        return (0, exports.MenuOptionSetsApiFp)(this.configuration).updateMenuItemOptionSet(menuId, menuSectionId, menuSectionItemId, optionSetId, MenuItemOptionSetBase, options)(this.fetch, this.basePath);
    };
    MenuOptionSetsApi.prototype.uploadOptionSetImage = function (menuId, menuSectionId, menuSectionItemId, optionSetId, Image, options) {
        return (0, exports.MenuOptionSetsApiFp)(this.configuration).uploadOptionSetImage(menuId, menuSectionId, menuSectionItemId, optionSetId, Image, options)(this.fetch, this.basePath);
    };
    return MenuOptionSetsApi;
}(BaseAPI));
exports.MenuOptionSetsApi = MenuOptionSetsApi;
var MenuSectionItemsApiFetchParamCreator = function (configuration) {
    return {
        cloneMenuSectionItem: function (menuId, menuSectionId, menuSectionItemId, options) {
            if (options === void 0) { options = {}; }
            if (menuId === null || menuId === undefined) {
                throw new RequiredError('menuId', 'Required parameter menuId was null or undefined when calling cloneMenuSectionItem.');
            }
            if (menuSectionId === null || menuSectionId === undefined) {
                throw new RequiredError('menuSectionId', 'Required parameter menuSectionId was null or undefined when calling cloneMenuSectionItem.');
            }
            if (menuSectionItemId === null || menuSectionItemId === undefined) {
                throw new RequiredError('menuSectionItemId', 'Required parameter menuSectionItemId was null or undefined when calling cloneMenuSectionItem.');
            }
            var localVarPath = "/api/v1.0/menus/{menuId}/sections/{menuSectionId}/sectionitems/{menuSectionItemId}/clone"
                .replace("{".concat("menuId", "}"), encodeURIComponent(String(menuId)))
                .replace("{".concat("menuSectionId", "}"), encodeURIComponent(String(menuSectionId)))
                .replace("{".concat("menuSectionItemId", "}"), encodeURIComponent(String(menuSectionItemId)));
            var localVarUrlObj = url.parse(localVarPath, true);
            var localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            var localVarHeaderParameter = {};
            var localVarQueryParameter = {};
            if (configuration && configuration.accessToken) {
                var localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("oauth2", ["api"])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        createMenuSectionItem: function (menuId, menuSectionId, MenuSectionItemBase, options) {
            if (options === void 0) { options = {}; }
            if (menuId === null || menuId === undefined) {
                throw new RequiredError('menuId', 'Required parameter menuId was null or undefined when calling createMenuSectionItem.');
            }
            if (menuSectionId === null || menuSectionId === undefined) {
                throw new RequiredError('menuSectionId', 'Required parameter menuSectionId was null or undefined when calling createMenuSectionItem.');
            }
            if (MenuSectionItemBase === null || MenuSectionItemBase === undefined) {
                throw new RequiredError('MenuSectionItemBase', 'Required parameter MenuSectionItemBase was null or undefined when calling createMenuSectionItem.');
            }
            var localVarPath = "/api/v1.0/menus/{menuId}/sections/{menuSectionId}/sectionitems"
                .replace("{".concat("menuId", "}"), encodeURIComponent(String(menuId)))
                .replace("{".concat("menuSectionId", "}"), encodeURIComponent(String(menuSectionId)));
            var localVarUrlObj = url.parse(localVarPath, true);
            var localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            var localVarHeaderParameter = {};
            var localVarQueryParameter = {};
            if (configuration && configuration.accessToken) {
                var localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("oauth2", ["api"])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }
            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            var needsSerialization = ("MenuSectionItemBase" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body = needsSerialization ? JSON.stringify(MenuSectionItemBase || {}) : (MenuSectionItemBase || "");
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        createMenuSectionItemFromCatalogItems: function (menuId, menuSectionId, CreateMenuSectionItemFromCatalogItems, options) {
            if (options === void 0) { options = {}; }
            if (menuId === null || menuId === undefined) {
                throw new RequiredError('menuId', 'Required parameter menuId was null or undefined when calling createMenuSectionItemFromCatalogItems.');
            }
            if (menuSectionId === null || menuSectionId === undefined) {
                throw new RequiredError('menuSectionId', 'Required parameter menuSectionId was null or undefined when calling createMenuSectionItemFromCatalogItems.');
            }
            if (CreateMenuSectionItemFromCatalogItems === null || CreateMenuSectionItemFromCatalogItems === undefined) {
                throw new RequiredError('CreateMenuSectionItemFromCatalogItems', 'Required parameter CreateMenuSectionItemFromCatalogItems was null or undefined when calling createMenuSectionItemFromCatalogItems.');
            }
            var localVarPath = "/api/v1.0/menus/{menuId}/sections/{menuSectionId}/sectionitems/add-catalogitems"
                .replace("{".concat("menuId", "}"), encodeURIComponent(String(menuId)))
                .replace("{".concat("menuSectionId", "}"), encodeURIComponent(String(menuSectionId)));
            var localVarUrlObj = url.parse(localVarPath, true);
            var localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            var localVarHeaderParameter = {};
            var localVarQueryParameter = {};
            if (configuration && configuration.accessToken) {
                var localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("oauth2", ["api"])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }
            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            var needsSerialization = ("CreateMenuSectionItemFromCatalogItems" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body = needsSerialization ? JSON.stringify(CreateMenuSectionItemFromCatalogItems || {}) : (CreateMenuSectionItemFromCatalogItems || "");
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        deleteMenuSectionItem: function (menuId, menuSectionId, menuSectionItemId, options) {
            if (options === void 0) { options = {}; }
            if (menuId === null || menuId === undefined) {
                throw new RequiredError('menuId', 'Required parameter menuId was null or undefined when calling deleteMenuSectionItem.');
            }
            if (menuSectionId === null || menuSectionId === undefined) {
                throw new RequiredError('menuSectionId', 'Required parameter menuSectionId was null or undefined when calling deleteMenuSectionItem.');
            }
            if (menuSectionItemId === null || menuSectionItemId === undefined) {
                throw new RequiredError('menuSectionItemId', 'Required parameter menuSectionItemId was null or undefined when calling deleteMenuSectionItem.');
            }
            var localVarPath = "/api/v1.0/menus/{menuId}/sections/{menuSectionId}/sectionitems/{menuSectionItemId}"
                .replace("{".concat("menuId", "}"), encodeURIComponent(String(menuId)))
                .replace("{".concat("menuSectionId", "}"), encodeURIComponent(String(menuSectionId)))
                .replace("{".concat("menuSectionItemId", "}"), encodeURIComponent(String(menuSectionItemId)));
            var localVarUrlObj = url.parse(localVarPath, true);
            var localVarRequestOptions = Object.assign({ method: 'DELETE' }, options);
            var localVarHeaderParameter = {};
            var localVarQueryParameter = {};
            if (configuration && configuration.accessToken) {
                var localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("oauth2", ["api"])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        deleteMenuSectionItemImage: function (menuId, menuSectionId, menuSectionItemId, options) {
            if (options === void 0) { options = {}; }
            if (menuId === null || menuId === undefined) {
                throw new RequiredError('menuId', 'Required parameter menuId was null or undefined when calling deleteMenuSectionItemImage.');
            }
            if (menuSectionId === null || menuSectionId === undefined) {
                throw new RequiredError('menuSectionId', 'Required parameter menuSectionId was null or undefined when calling deleteMenuSectionItemImage.');
            }
            if (menuSectionItemId === null || menuSectionItemId === undefined) {
                throw new RequiredError('menuSectionItemId', 'Required parameter menuSectionItemId was null or undefined when calling deleteMenuSectionItemImage.');
            }
            var localVarPath = "/api/v1.0/menus/{menuId}/sections/{menuSectionId}/sectionitems/{menuSectionItemId}/image"
                .replace("{".concat("menuId", "}"), encodeURIComponent(String(menuId)))
                .replace("{".concat("menuSectionId", "}"), encodeURIComponent(String(menuSectionId)))
                .replace("{".concat("menuSectionItemId", "}"), encodeURIComponent(String(menuSectionItemId)));
            var localVarUrlObj = url.parse(localVarPath, true);
            var localVarRequestOptions = Object.assign({ method: 'DELETE' }, options);
            var localVarHeaderParameter = {};
            var localVarQueryParameter = {};
            if (configuration && configuration.accessToken) {
                var localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("oauth2", ["api"])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        getMenuItemById: function (menuId, menuSectionId, menuSectionItemId, options) {
            if (options === void 0) { options = {}; }
            if (menuId === null || menuId === undefined) {
                throw new RequiredError('menuId', 'Required parameter menuId was null or undefined when calling getMenuItemById.');
            }
            if (menuSectionId === null || menuSectionId === undefined) {
                throw new RequiredError('menuSectionId', 'Required parameter menuSectionId was null or undefined when calling getMenuItemById.');
            }
            if (menuSectionItemId === null || menuSectionItemId === undefined) {
                throw new RequiredError('menuSectionItemId', 'Required parameter menuSectionItemId was null or undefined when calling getMenuItemById.');
            }
            var localVarPath = "/api/v1.0/menus/{menuId}/sections/{menuSectionId}/sectionitems/{menuSectionItemId}"
                .replace("{".concat("menuId", "}"), encodeURIComponent(String(menuId)))
                .replace("{".concat("menuSectionId", "}"), encodeURIComponent(String(menuSectionId)))
                .replace("{".concat("menuSectionItemId", "}"), encodeURIComponent(String(menuSectionItemId)));
            var localVarUrlObj = url.parse(localVarPath, true);
            var localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            var localVarHeaderParameter = {};
            var localVarQueryParameter = {};
            if (configuration && configuration.accessToken) {
                var localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("oauth2", ["api"])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        getMenuItems: function (menuId, menuSectionId, options) {
            if (options === void 0) { options = {}; }
            if (menuId === null || menuId === undefined) {
                throw new RequiredError('menuId', 'Required parameter menuId was null or undefined when calling getMenuItems.');
            }
            if (menuSectionId === null || menuSectionId === undefined) {
                throw new RequiredError('menuSectionId', 'Required parameter menuSectionId was null or undefined when calling getMenuItems.');
            }
            var localVarPath = "/api/v1.0/menus/{menuId}/sections/{menuSectionId}/sectionitems"
                .replace("{".concat("menuId", "}"), encodeURIComponent(String(menuId)))
                .replace("{".concat("menuSectionId", "}"), encodeURIComponent(String(menuSectionId)));
            var localVarUrlObj = url.parse(localVarPath, true);
            var localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            var localVarHeaderParameter = {};
            var localVarQueryParameter = {};
            if (configuration && configuration.accessToken) {
                var localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("oauth2", ["api"])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        moveMenuItem: function (menuId, menuSectionId, menuSectionItemId, destinationDisplayOrder, options) {
            if (options === void 0) { options = {}; }
            if (menuId === null || menuId === undefined) {
                throw new RequiredError('menuId', 'Required parameter menuId was null or undefined when calling moveMenuItem.');
            }
            if (menuSectionId === null || menuSectionId === undefined) {
                throw new RequiredError('menuSectionId', 'Required parameter menuSectionId was null or undefined when calling moveMenuItem.');
            }
            if (menuSectionItemId === null || menuSectionItemId === undefined) {
                throw new RequiredError('menuSectionItemId', 'Required parameter menuSectionItemId was null or undefined when calling moveMenuItem.');
            }
            if (destinationDisplayOrder === null || destinationDisplayOrder === undefined) {
                throw new RequiredError('destinationDisplayOrder', 'Required parameter destinationDisplayOrder was null or undefined when calling moveMenuItem.');
            }
            var localVarPath = "/api/v1.0/menus/{menuId}/sections/{menuSectionId}/sectionitems/{menuSectionItemId}/setorder/{destinationDisplayOrder}"
                .replace("{".concat("menuId", "}"), encodeURIComponent(String(menuId)))
                .replace("{".concat("menuSectionId", "}"), encodeURIComponent(String(menuSectionId)))
                .replace("{".concat("menuSectionItemId", "}"), encodeURIComponent(String(menuSectionItemId)))
                .replace("{".concat("destinationDisplayOrder", "}"), encodeURIComponent(String(destinationDisplayOrder)));
            var localVarUrlObj = url.parse(localVarPath, true);
            var localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            var localVarHeaderParameter = {};
            var localVarQueryParameter = {};
            if (configuration && configuration.accessToken) {
                var localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("oauth2", ["api"])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        setSectionItemTax: function (menuId, menuSectionId, menuSectionItemId, taxRateId, options) {
            if (options === void 0) { options = {}; }
            if (menuId === null || menuId === undefined) {
                throw new RequiredError('menuId', 'Required parameter menuId was null or undefined when calling setSectionItemTax.');
            }
            if (menuSectionId === null || menuSectionId === undefined) {
                throw new RequiredError('menuSectionId', 'Required parameter menuSectionId was null or undefined when calling setSectionItemTax.');
            }
            if (menuSectionItemId === null || menuSectionItemId === undefined) {
                throw new RequiredError('menuSectionItemId', 'Required parameter menuSectionItemId was null or undefined when calling setSectionItemTax.');
            }
            if (taxRateId === null || taxRateId === undefined) {
                throw new RequiredError('taxRateId', 'Required parameter taxRateId was null or undefined when calling setSectionItemTax.');
            }
            var localVarPath = "/api/v1.0/menus/{menuId}/sections/{menuSectionId}/sectionitems/{menuSectionItemId}/taxrate/{taxRateId}"
                .replace("{".concat("menuId", "}"), encodeURIComponent(String(menuId)))
                .replace("{".concat("menuSectionId", "}"), encodeURIComponent(String(menuSectionId)))
                .replace("{".concat("menuSectionItemId", "}"), encodeURIComponent(String(menuSectionItemId)))
                .replace("{".concat("taxRateId", "}"), encodeURIComponent(String(taxRateId)));
            var localVarUrlObj = url.parse(localVarPath, true);
            var localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            var localVarHeaderParameter = {};
            var localVarQueryParameter = {};
            if (configuration && configuration.accessToken) {
                var localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("oauth2", ["api"])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        updateMenuSectionItem: function (menuId, menuSectionId, menuSectionItemId, MenuSectionItemBase, undoAfter, options) {
            if (options === void 0) { options = {}; }
            if (menuId === null || menuId === undefined) {
                throw new RequiredError('menuId', 'Required parameter menuId was null or undefined when calling updateMenuSectionItem.');
            }
            if (menuSectionId === null || menuSectionId === undefined) {
                throw new RequiredError('menuSectionId', 'Required parameter menuSectionId was null or undefined when calling updateMenuSectionItem.');
            }
            if (menuSectionItemId === null || menuSectionItemId === undefined) {
                throw new RequiredError('menuSectionItemId', 'Required parameter menuSectionItemId was null or undefined when calling updateMenuSectionItem.');
            }
            if (MenuSectionItemBase === null || MenuSectionItemBase === undefined) {
                throw new RequiredError('MenuSectionItemBase', 'Required parameter MenuSectionItemBase was null or undefined when calling updateMenuSectionItem.');
            }
            var localVarPath = "/api/v1.0/menus/{menuId}/sections/{menuSectionId}/sectionitems/{menuSectionItemId}"
                .replace("{".concat("menuId", "}"), encodeURIComponent(String(menuId)))
                .replace("{".concat("menuSectionId", "}"), encodeURIComponent(String(menuSectionId)))
                .replace("{".concat("menuSectionItemId", "}"), encodeURIComponent(String(menuSectionItemId)));
            var localVarUrlObj = url.parse(localVarPath, true);
            var localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            var localVarHeaderParameter = {};
            var localVarQueryParameter = {};
            if (configuration && configuration.accessToken) {
                var localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("oauth2", ["api"])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }
            if (undoAfter !== undefined) {
                localVarQueryParameter['undoAfter'] = undoAfter;
            }
            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            var needsSerialization = ("MenuSectionItemBase" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body = needsSerialization ? JSON.stringify(MenuSectionItemBase || {}) : (MenuSectionItemBase || "");
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        uploadMenuSectionItemImage: function (menuId, menuSectionId, menuSectionItemId, Image, options) {
            if (options === void 0) { options = {}; }
            if (menuId === null || menuId === undefined) {
                throw new RequiredError('menuId', 'Required parameter menuId was null or undefined when calling uploadMenuSectionItemImage.');
            }
            if (menuSectionId === null || menuSectionId === undefined) {
                throw new RequiredError('menuSectionId', 'Required parameter menuSectionId was null or undefined when calling uploadMenuSectionItemImage.');
            }
            if (menuSectionItemId === null || menuSectionItemId === undefined) {
                throw new RequiredError('menuSectionItemId', 'Required parameter menuSectionItemId was null or undefined when calling uploadMenuSectionItemImage.');
            }
            if (Image === null || Image === undefined) {
                throw new RequiredError('Image', 'Required parameter Image was null or undefined when calling uploadMenuSectionItemImage.');
            }
            var localVarPath = "/api/v1.0/menus/{menuId}/sections/{menuSectionId}/sectionitems/{menuSectionItemId}/image"
                .replace("{".concat("menuId", "}"), encodeURIComponent(String(menuId)))
                .replace("{".concat("menuSectionId", "}"), encodeURIComponent(String(menuSectionId)))
                .replace("{".concat("menuSectionItemId", "}"), encodeURIComponent(String(menuSectionItemId)));
            var localVarUrlObj = url.parse(localVarPath, true);
            var localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            var localVarHeaderParameter = {};
            var localVarQueryParameter = {};
            var localVarFormParams = new url.URLSearchParams();
            if (configuration && configuration.accessToken) {
                var localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("oauth2", ["api"])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }
            if (Image !== undefined) {
                localVarFormParams.set('Image', Image);
            }
            localVarHeaderParameter['Content-Type'] = 'application/x-www-form-urlencoded';
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            localVarRequestOptions.body = localVarFormParams.toString();
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    };
};
exports.MenuSectionItemsApiFetchParamCreator = MenuSectionItemsApiFetchParamCreator;
var MenuSectionItemsApiFp = function (configuration) {
    return {
        cloneMenuSectionItem: function (menuId, menuSectionId, menuSectionItemId, options) {
            var localVarFetchArgs = (0, exports.MenuSectionItemsApiFetchParamCreator)(configuration).cloneMenuSectionItem(menuId, menuSectionId, menuSectionItemId, options);
            return function (fetch, basePath) {
                if (fetch === void 0) { fetch = portableFetch; }
                if (basePath === void 0) { basePath = BASE_PATH; }
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then(function (response) {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
        createMenuSectionItem: function (menuId, menuSectionId, MenuSectionItemBase, options) {
            var localVarFetchArgs = (0, exports.MenuSectionItemsApiFetchParamCreator)(configuration).createMenuSectionItem(menuId, menuSectionId, MenuSectionItemBase, options);
            return function (fetch, basePath) {
                if (fetch === void 0) { fetch = portableFetch; }
                if (basePath === void 0) { basePath = BASE_PATH; }
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then(function (response) {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
        createMenuSectionItemFromCatalogItems: function (menuId, menuSectionId, CreateMenuSectionItemFromCatalogItems, options) {
            var localVarFetchArgs = (0, exports.MenuSectionItemsApiFetchParamCreator)(configuration).createMenuSectionItemFromCatalogItems(menuId, menuSectionId, CreateMenuSectionItemFromCatalogItems, options);
            return function (fetch, basePath) {
                if (fetch === void 0) { fetch = portableFetch; }
                if (basePath === void 0) { basePath = BASE_PATH; }
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then(function (response) {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
        deleteMenuSectionItem: function (menuId, menuSectionId, menuSectionItemId, options) {
            var localVarFetchArgs = (0, exports.MenuSectionItemsApiFetchParamCreator)(configuration).deleteMenuSectionItem(menuId, menuSectionId, menuSectionItemId, options);
            return function (fetch, basePath) {
                if (fetch === void 0) { fetch = portableFetch; }
                if (basePath === void 0) { basePath = BASE_PATH; }
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then(function (response) {
                    if (response.status >= 200 && response.status < 300) {
                        return response;
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
        deleteMenuSectionItemImage: function (menuId, menuSectionId, menuSectionItemId, options) {
            var localVarFetchArgs = (0, exports.MenuSectionItemsApiFetchParamCreator)(configuration).deleteMenuSectionItemImage(menuId, menuSectionId, menuSectionItemId, options);
            return function (fetch, basePath) {
                if (fetch === void 0) { fetch = portableFetch; }
                if (basePath === void 0) { basePath = BASE_PATH; }
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then(function (response) {
                    if (response.status >= 200 && response.status < 300) {
                        return response;
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
        getMenuItemById: function (menuId, menuSectionId, menuSectionItemId, options) {
            var localVarFetchArgs = (0, exports.MenuSectionItemsApiFetchParamCreator)(configuration).getMenuItemById(menuId, menuSectionId, menuSectionItemId, options);
            return function (fetch, basePath) {
                if (fetch === void 0) { fetch = portableFetch; }
                if (basePath === void 0) { basePath = BASE_PATH; }
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then(function (response) {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
        getMenuItems: function (menuId, menuSectionId, options) {
            var localVarFetchArgs = (0, exports.MenuSectionItemsApiFetchParamCreator)(configuration).getMenuItems(menuId, menuSectionId, options);
            return function (fetch, basePath) {
                if (fetch === void 0) { fetch = portableFetch; }
                if (basePath === void 0) { basePath = BASE_PATH; }
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then(function (response) {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
        moveMenuItem: function (menuId, menuSectionId, menuSectionItemId, destinationDisplayOrder, options) {
            var localVarFetchArgs = (0, exports.MenuSectionItemsApiFetchParamCreator)(configuration).moveMenuItem(menuId, menuSectionId, menuSectionItemId, destinationDisplayOrder, options);
            return function (fetch, basePath) {
                if (fetch === void 0) { fetch = portableFetch; }
                if (basePath === void 0) { basePath = BASE_PATH; }
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then(function (response) {
                    if (response.status >= 200 && response.status < 300) {
                        return response;
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
        setSectionItemTax: function (menuId, menuSectionId, menuSectionItemId, taxRateId, options) {
            var localVarFetchArgs = (0, exports.MenuSectionItemsApiFetchParamCreator)(configuration).setSectionItemTax(menuId, menuSectionId, menuSectionItemId, taxRateId, options);
            return function (fetch, basePath) {
                if (fetch === void 0) { fetch = portableFetch; }
                if (basePath === void 0) { basePath = BASE_PATH; }
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then(function (response) {
                    if (response.status >= 200 && response.status < 300) {
                        return response;
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
        updateMenuSectionItem: function (menuId, menuSectionId, menuSectionItemId, MenuSectionItemBase, undoAfter, options) {
            var localVarFetchArgs = (0, exports.MenuSectionItemsApiFetchParamCreator)(configuration).updateMenuSectionItem(menuId, menuSectionId, menuSectionItemId, MenuSectionItemBase, undoAfter, options);
            return function (fetch, basePath) {
                if (fetch === void 0) { fetch = portableFetch; }
                if (basePath === void 0) { basePath = BASE_PATH; }
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then(function (response) {
                    if (response.status >= 200 && response.status < 300) {
                        return response;
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
        uploadMenuSectionItemImage: function (menuId, menuSectionId, menuSectionItemId, Image, options) {
            var localVarFetchArgs = (0, exports.MenuSectionItemsApiFetchParamCreator)(configuration).uploadMenuSectionItemImage(menuId, menuSectionId, menuSectionItemId, Image, options);
            return function (fetch, basePath) {
                if (fetch === void 0) { fetch = portableFetch; }
                if (basePath === void 0) { basePath = BASE_PATH; }
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then(function (response) {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
    };
};
exports.MenuSectionItemsApiFp = MenuSectionItemsApiFp;
var MenuSectionItemsApiFactory = function (configuration, fetch, basePath) {
    return {
        cloneMenuSectionItem: function (menuId, menuSectionId, menuSectionItemId, options) {
            return (0, exports.MenuSectionItemsApiFp)(configuration).cloneMenuSectionItem(menuId, menuSectionId, menuSectionItemId, options)(fetch, basePath);
        },
        createMenuSectionItem: function (menuId, menuSectionId, MenuSectionItemBase, options) {
            return (0, exports.MenuSectionItemsApiFp)(configuration).createMenuSectionItem(menuId, menuSectionId, MenuSectionItemBase, options)(fetch, basePath);
        },
        createMenuSectionItemFromCatalogItems: function (menuId, menuSectionId, CreateMenuSectionItemFromCatalogItems, options) {
            return (0, exports.MenuSectionItemsApiFp)(configuration).createMenuSectionItemFromCatalogItems(menuId, menuSectionId, CreateMenuSectionItemFromCatalogItems, options)(fetch, basePath);
        },
        deleteMenuSectionItem: function (menuId, menuSectionId, menuSectionItemId, options) {
            return (0, exports.MenuSectionItemsApiFp)(configuration).deleteMenuSectionItem(menuId, menuSectionId, menuSectionItemId, options)(fetch, basePath);
        },
        deleteMenuSectionItemImage: function (menuId, menuSectionId, menuSectionItemId, options) {
            return (0, exports.MenuSectionItemsApiFp)(configuration).deleteMenuSectionItemImage(menuId, menuSectionId, menuSectionItemId, options)(fetch, basePath);
        },
        getMenuItemById: function (menuId, menuSectionId, menuSectionItemId, options) {
            return (0, exports.MenuSectionItemsApiFp)(configuration).getMenuItemById(menuId, menuSectionId, menuSectionItemId, options)(fetch, basePath);
        },
        getMenuItems: function (menuId, menuSectionId, options) {
            return (0, exports.MenuSectionItemsApiFp)(configuration).getMenuItems(menuId, menuSectionId, options)(fetch, basePath);
        },
        moveMenuItem: function (menuId, menuSectionId, menuSectionItemId, destinationDisplayOrder, options) {
            return (0, exports.MenuSectionItemsApiFp)(configuration).moveMenuItem(menuId, menuSectionId, menuSectionItemId, destinationDisplayOrder, options)(fetch, basePath);
        },
        setSectionItemTax: function (menuId, menuSectionId, menuSectionItemId, taxRateId, options) {
            return (0, exports.MenuSectionItemsApiFp)(configuration).setSectionItemTax(menuId, menuSectionId, menuSectionItemId, taxRateId, options)(fetch, basePath);
        },
        updateMenuSectionItem: function (menuId, menuSectionId, menuSectionItemId, MenuSectionItemBase, undoAfter, options) {
            return (0, exports.MenuSectionItemsApiFp)(configuration).updateMenuSectionItem(menuId, menuSectionId, menuSectionItemId, MenuSectionItemBase, undoAfter, options)(fetch, basePath);
        },
        uploadMenuSectionItemImage: function (menuId, menuSectionId, menuSectionItemId, Image, options) {
            return (0, exports.MenuSectionItemsApiFp)(configuration).uploadMenuSectionItemImage(menuId, menuSectionId, menuSectionItemId, Image, options)(fetch, basePath);
        },
    };
};
exports.MenuSectionItemsApiFactory = MenuSectionItemsApiFactory;
var MenuSectionItemsApi = (function (_super) {
    __extends(MenuSectionItemsApi, _super);
    function MenuSectionItemsApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    MenuSectionItemsApi.prototype.cloneMenuSectionItem = function (menuId, menuSectionId, menuSectionItemId, options) {
        return (0, exports.MenuSectionItemsApiFp)(this.configuration).cloneMenuSectionItem(menuId, menuSectionId, menuSectionItemId, options)(this.fetch, this.basePath);
    };
    MenuSectionItemsApi.prototype.createMenuSectionItem = function (menuId, menuSectionId, MenuSectionItemBase, options) {
        return (0, exports.MenuSectionItemsApiFp)(this.configuration).createMenuSectionItem(menuId, menuSectionId, MenuSectionItemBase, options)(this.fetch, this.basePath);
    };
    MenuSectionItemsApi.prototype.createMenuSectionItemFromCatalogItems = function (menuId, menuSectionId, CreateMenuSectionItemFromCatalogItems, options) {
        return (0, exports.MenuSectionItemsApiFp)(this.configuration).createMenuSectionItemFromCatalogItems(menuId, menuSectionId, CreateMenuSectionItemFromCatalogItems, options)(this.fetch, this.basePath);
    };
    MenuSectionItemsApi.prototype.deleteMenuSectionItem = function (menuId, menuSectionId, menuSectionItemId, options) {
        return (0, exports.MenuSectionItemsApiFp)(this.configuration).deleteMenuSectionItem(menuId, menuSectionId, menuSectionItemId, options)(this.fetch, this.basePath);
    };
    MenuSectionItemsApi.prototype.deleteMenuSectionItemImage = function (menuId, menuSectionId, menuSectionItemId, options) {
        return (0, exports.MenuSectionItemsApiFp)(this.configuration).deleteMenuSectionItemImage(menuId, menuSectionId, menuSectionItemId, options)(this.fetch, this.basePath);
    };
    MenuSectionItemsApi.prototype.getMenuItemById = function (menuId, menuSectionId, menuSectionItemId, options) {
        return (0, exports.MenuSectionItemsApiFp)(this.configuration).getMenuItemById(menuId, menuSectionId, menuSectionItemId, options)(this.fetch, this.basePath);
    };
    MenuSectionItemsApi.prototype.getMenuItems = function (menuId, menuSectionId, options) {
        return (0, exports.MenuSectionItemsApiFp)(this.configuration).getMenuItems(menuId, menuSectionId, options)(this.fetch, this.basePath);
    };
    MenuSectionItemsApi.prototype.moveMenuItem = function (menuId, menuSectionId, menuSectionItemId, destinationDisplayOrder, options) {
        return (0, exports.MenuSectionItemsApiFp)(this.configuration).moveMenuItem(menuId, menuSectionId, menuSectionItemId, destinationDisplayOrder, options)(this.fetch, this.basePath);
    };
    MenuSectionItemsApi.prototype.setSectionItemTax = function (menuId, menuSectionId, menuSectionItemId, taxRateId, options) {
        return (0, exports.MenuSectionItemsApiFp)(this.configuration).setSectionItemTax(menuId, menuSectionId, menuSectionItemId, taxRateId, options)(this.fetch, this.basePath);
    };
    MenuSectionItemsApi.prototype.updateMenuSectionItem = function (menuId, menuSectionId, menuSectionItemId, MenuSectionItemBase, undoAfter, options) {
        return (0, exports.MenuSectionItemsApiFp)(this.configuration).updateMenuSectionItem(menuId, menuSectionId, menuSectionItemId, MenuSectionItemBase, undoAfter, options)(this.fetch, this.basePath);
    };
    MenuSectionItemsApi.prototype.uploadMenuSectionItemImage = function (menuId, menuSectionId, menuSectionItemId, Image, options) {
        return (0, exports.MenuSectionItemsApiFp)(this.configuration).uploadMenuSectionItemImage(menuId, menuSectionId, menuSectionItemId, Image, options)(this.fetch, this.basePath);
    };
    return MenuSectionItemsApi;
}(BaseAPI));
exports.MenuSectionItemsApi = MenuSectionItemsApi;
var MenuSectionsApiFetchParamCreator = function (configuration) {
    return {
        cloneMenuSection: function (menuId, menuSectionId, options) {
            if (options === void 0) { options = {}; }
            if (menuId === null || menuId === undefined) {
                throw new RequiredError('menuId', 'Required parameter menuId was null or undefined when calling cloneMenuSection.');
            }
            if (menuSectionId === null || menuSectionId === undefined) {
                throw new RequiredError('menuSectionId', 'Required parameter menuSectionId was null or undefined when calling cloneMenuSection.');
            }
            var localVarPath = "/api/v1.0/menus/{menuId}/sections/{menuSectionId}/clone"
                .replace("{".concat("menuId", "}"), encodeURIComponent(String(menuId)))
                .replace("{".concat("menuSectionId", "}"), encodeURIComponent(String(menuSectionId)));
            var localVarUrlObj = url.parse(localVarPath, true);
            var localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            var localVarHeaderParameter = {};
            var localVarQueryParameter = {};
            if (configuration && configuration.accessToken) {
                var localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("oauth2", ["api"])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        createMenuAvailabilityForDay: function (menuId, menuSectionId, dayOfWeek, BusinessHoursPeriodBase, options) {
            if (options === void 0) { options = {}; }
            if (menuId === null || menuId === undefined) {
                throw new RequiredError('menuId', 'Required parameter menuId was null or undefined when calling createMenuAvailabilityForDay.');
            }
            if (menuSectionId === null || menuSectionId === undefined) {
                throw new RequiredError('menuSectionId', 'Required parameter menuSectionId was null or undefined when calling createMenuAvailabilityForDay.');
            }
            if (dayOfWeek === null || dayOfWeek === undefined) {
                throw new RequiredError('dayOfWeek', 'Required parameter dayOfWeek was null or undefined when calling createMenuAvailabilityForDay.');
            }
            if (BusinessHoursPeriodBase === null || BusinessHoursPeriodBase === undefined) {
                throw new RequiredError('BusinessHoursPeriodBase', 'Required parameter BusinessHoursPeriodBase was null or undefined when calling createMenuAvailabilityForDay.');
            }
            var localVarPath = "/api/v1.0/menus/{menuId}/sections/{menuSectionId}/availability/times/{dayOfWeek}"
                .replace("{".concat("menuId", "}"), encodeURIComponent(String(menuId)))
                .replace("{".concat("menuSectionId", "}"), encodeURIComponent(String(menuSectionId)))
                .replace("{".concat("dayOfWeek", "}"), encodeURIComponent(String(dayOfWeek)));
            var localVarUrlObj = url.parse(localVarPath, true);
            var localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            var localVarHeaderParameter = {};
            var localVarQueryParameter = {};
            if (configuration && configuration.accessToken) {
                var localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("oauth2", ["api"])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }
            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            var needsSerialization = ("BusinessHoursPeriodBase" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body = needsSerialization ? JSON.stringify(BusinessHoursPeriodBase || {}) : (BusinessHoursPeriodBase || "");
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        createMenuSection: function (menuId, MenuSectionBase, options) {
            if (options === void 0) { options = {}; }
            if (menuId === null || menuId === undefined) {
                throw new RequiredError('menuId', 'Required parameter menuId was null or undefined when calling createMenuSection.');
            }
            if (MenuSectionBase === null || MenuSectionBase === undefined) {
                throw new RequiredError('MenuSectionBase', 'Required parameter MenuSectionBase was null or undefined when calling createMenuSection.');
            }
            var localVarPath = "/api/v1.0/menus/{menuId}/sections"
                .replace("{".concat("menuId", "}"), encodeURIComponent(String(menuId)));
            var localVarUrlObj = url.parse(localVarPath, true);
            var localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            var localVarHeaderParameter = {};
            var localVarQueryParameter = {};
            if (configuration && configuration.accessToken) {
                var localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("oauth2", ["api"])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }
            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            var needsSerialization = ("MenuSectionBase" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body = needsSerialization ? JSON.stringify(MenuSectionBase || {}) : (MenuSectionBase || "");
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        createMenuSectionAvailability: function (menuId, menuSectionId, MenuSectionAvailabilityBase, options) {
            if (options === void 0) { options = {}; }
            if (menuId === null || menuId === undefined) {
                throw new RequiredError('menuId', 'Required parameter menuId was null or undefined when calling createMenuSectionAvailability.');
            }
            if (menuSectionId === null || menuSectionId === undefined) {
                throw new RequiredError('menuSectionId', 'Required parameter menuSectionId was null or undefined when calling createMenuSectionAvailability.');
            }
            if (MenuSectionAvailabilityBase === null || MenuSectionAvailabilityBase === undefined) {
                throw new RequiredError('MenuSectionAvailabilityBase', 'Required parameter MenuSectionAvailabilityBase was null or undefined when calling createMenuSectionAvailability.');
            }
            var localVarPath = "/api/v1.0/menus/{menuId}/sections/{menuSectionId}/availability"
                .replace("{".concat("menuId", "}"), encodeURIComponent(String(menuId)))
                .replace("{".concat("menuSectionId", "}"), encodeURIComponent(String(menuSectionId)));
            var localVarUrlObj = url.parse(localVarPath, true);
            var localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            var localVarHeaderParameter = {};
            var localVarQueryParameter = {};
            if (configuration && configuration.accessToken) {
                var localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("oauth2", ["api"])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }
            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            var needsSerialization = ("MenuSectionAvailabilityBase" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body = needsSerialization ? JSON.stringify(MenuSectionAvailabilityBase || {}) : (MenuSectionAvailabilityBase || "");
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        deleteMenuSection: function (menuId, menuSectionId, options) {
            if (options === void 0) { options = {}; }
            if (menuId === null || menuId === undefined) {
                throw new RequiredError('menuId', 'Required parameter menuId was null or undefined when calling deleteMenuSection.');
            }
            if (menuSectionId === null || menuSectionId === undefined) {
                throw new RequiredError('menuSectionId', 'Required parameter menuSectionId was null or undefined when calling deleteMenuSection.');
            }
            var localVarPath = "/api/v1.0/menus/{menuId}/sections/{menuSectionId}"
                .replace("{".concat("menuId", "}"), encodeURIComponent(String(menuId)))
                .replace("{".concat("menuSectionId", "}"), encodeURIComponent(String(menuSectionId)));
            var localVarUrlObj = url.parse(localVarPath, true);
            var localVarRequestOptions = Object.assign({ method: 'DELETE' }, options);
            var localVarHeaderParameter = {};
            var localVarQueryParameter = {};
            if (configuration && configuration.accessToken) {
                var localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("oauth2", ["api"])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        deleteMenuSectionImage: function (menuId, menuSectionId, options) {
            if (options === void 0) { options = {}; }
            if (menuId === null || menuId === undefined) {
                throw new RequiredError('menuId', 'Required parameter menuId was null or undefined when calling deleteMenuSectionImage.');
            }
            if (menuSectionId === null || menuSectionId === undefined) {
                throw new RequiredError('menuSectionId', 'Required parameter menuSectionId was null or undefined when calling deleteMenuSectionImage.');
            }
            var localVarPath = "/api/v1.0/menus/{menuId}/sections/{menuSectionId}/image"
                .replace("{".concat("menuId", "}"), encodeURIComponent(String(menuId)))
                .replace("{".concat("menuSectionId", "}"), encodeURIComponent(String(menuSectionId)));
            var localVarUrlObj = url.parse(localVarPath, true);
            var localVarRequestOptions = Object.assign({ method: 'DELETE' }, options);
            var localVarHeaderParameter = {};
            var localVarQueryParameter = {};
            if (configuration && configuration.accessToken) {
                var localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("oauth2", ["api"])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        getMenuSectionById: function (menuId, menuSectionId, options) {
            if (options === void 0) { options = {}; }
            if (menuId === null || menuId === undefined) {
                throw new RequiredError('menuId', 'Required parameter menuId was null or undefined when calling getMenuSectionById.');
            }
            if (menuSectionId === null || menuSectionId === undefined) {
                throw new RequiredError('menuSectionId', 'Required parameter menuSectionId was null or undefined when calling getMenuSectionById.');
            }
            var localVarPath = "/api/v1.0/menus/{menuId}/sections/{menuSectionId}"
                .replace("{".concat("menuId", "}"), encodeURIComponent(String(menuId)))
                .replace("{".concat("menuSectionId", "}"), encodeURIComponent(String(menuSectionId)));
            var localVarUrlObj = url.parse(localVarPath, true);
            var localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            var localVarHeaderParameter = {};
            var localVarQueryParameter = {};
            if (configuration && configuration.accessToken) {
                var localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("oauth2", ["api"])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        getMenuSections: function (menuId, options) {
            if (options === void 0) { options = {}; }
            if (menuId === null || menuId === undefined) {
                throw new RequiredError('menuId', 'Required parameter menuId was null or undefined when calling getMenuSections.');
            }
            var localVarPath = "/api/v1.0/menus/{menuId}/sections"
                .replace("{".concat("menuId", "}"), encodeURIComponent(String(menuId)));
            var localVarUrlObj = url.parse(localVarPath, true);
            var localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            var localVarHeaderParameter = {};
            var localVarQueryParameter = {};
            if (configuration && configuration.accessToken) {
                var localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("oauth2", ["api"])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        menuSectionsSetItemDisplayOrders: function (menuId, menuSectionId, MenuObjectDisplayOrders, options) {
            if (options === void 0) { options = {}; }
            if (menuId === null || menuId === undefined) {
                throw new RequiredError('menuId', 'Required parameter menuId was null or undefined when calling menuSectionsSetItemDisplayOrders.');
            }
            if (menuSectionId === null || menuSectionId === undefined) {
                throw new RequiredError('menuSectionId', 'Required parameter menuSectionId was null or undefined when calling menuSectionsSetItemDisplayOrders.');
            }
            if (MenuObjectDisplayOrders === null || MenuObjectDisplayOrders === undefined) {
                throw new RequiredError('MenuObjectDisplayOrders', 'Required parameter MenuObjectDisplayOrders was null or undefined when calling menuSectionsSetItemDisplayOrders.');
            }
            var localVarPath = "/api/v1.0/menus/{menuId}/sections/{menuSectionId}/sectionitemdisplayorders"
                .replace("{".concat("menuId", "}"), encodeURIComponent(String(menuId)))
                .replace("{".concat("menuSectionId", "}"), encodeURIComponent(String(menuSectionId)));
            var localVarUrlObj = url.parse(localVarPath, true);
            var localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            var localVarHeaderParameter = {};
            var localVarQueryParameter = {};
            if (configuration && configuration.accessToken) {
                var localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("oauth2", ["api"])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }
            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            var needsSerialization = ("MenuObjectDisplayOrders" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body = needsSerialization ? JSON.stringify(MenuObjectDisplayOrders || {}) : (MenuObjectDisplayOrders || "");
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        updateMenuSection: function (menuId, menuSectionId, MenuSectionBase, undoAfter, options) {
            if (options === void 0) { options = {}; }
            if (menuId === null || menuId === undefined) {
                throw new RequiredError('menuId', 'Required parameter menuId was null or undefined when calling updateMenuSection.');
            }
            if (menuSectionId === null || menuSectionId === undefined) {
                throw new RequiredError('menuSectionId', 'Required parameter menuSectionId was null or undefined when calling updateMenuSection.');
            }
            if (MenuSectionBase === null || MenuSectionBase === undefined) {
                throw new RequiredError('MenuSectionBase', 'Required parameter MenuSectionBase was null or undefined when calling updateMenuSection.');
            }
            var localVarPath = "/api/v1.0/menus/{menuId}/sections/{menuSectionId}"
                .replace("{".concat("menuId", "}"), encodeURIComponent(String(menuId)))
                .replace("{".concat("menuSectionId", "}"), encodeURIComponent(String(menuSectionId)));
            var localVarUrlObj = url.parse(localVarPath, true);
            var localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            var localVarHeaderParameter = {};
            var localVarQueryParameter = {};
            if (configuration && configuration.accessToken) {
                var localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("oauth2", ["api"])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }
            if (undoAfter !== undefined) {
                localVarQueryParameter['undoAfter'] = undoAfter;
            }
            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            var needsSerialization = ("MenuSectionBase" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body = needsSerialization ? JSON.stringify(MenuSectionBase || {}) : (MenuSectionBase || "");
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        uploadMenuSectionImage: function (menuId, menuSectionId, Image, options) {
            if (options === void 0) { options = {}; }
            if (menuId === null || menuId === undefined) {
                throw new RequiredError('menuId', 'Required parameter menuId was null or undefined when calling uploadMenuSectionImage.');
            }
            if (menuSectionId === null || menuSectionId === undefined) {
                throw new RequiredError('menuSectionId', 'Required parameter menuSectionId was null or undefined when calling uploadMenuSectionImage.');
            }
            if (Image === null || Image === undefined) {
                throw new RequiredError('Image', 'Required parameter Image was null or undefined when calling uploadMenuSectionImage.');
            }
            var localVarPath = "/api/v1.0/menus/{menuId}/sections/{menuSectionId}/image"
                .replace("{".concat("menuId", "}"), encodeURIComponent(String(menuId)))
                .replace("{".concat("menuSectionId", "}"), encodeURIComponent(String(menuSectionId)));
            var localVarUrlObj = url.parse(localVarPath, true);
            var localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            var localVarHeaderParameter = {};
            var localVarQueryParameter = {};
            var localVarFormParams = new url.URLSearchParams();
            if (configuration && configuration.accessToken) {
                var localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("oauth2", ["api"])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }
            if (Image !== undefined) {
                localVarFormParams.set('Image', Image);
            }
            localVarHeaderParameter['Content-Type'] = 'application/x-www-form-urlencoded';
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            localVarRequestOptions.body = localVarFormParams.toString();
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    };
};
exports.MenuSectionsApiFetchParamCreator = MenuSectionsApiFetchParamCreator;
var MenuSectionsApiFp = function (configuration) {
    return {
        cloneMenuSection: function (menuId, menuSectionId, options) {
            var localVarFetchArgs = (0, exports.MenuSectionsApiFetchParamCreator)(configuration).cloneMenuSection(menuId, menuSectionId, options);
            return function (fetch, basePath) {
                if (fetch === void 0) { fetch = portableFetch; }
                if (basePath === void 0) { basePath = BASE_PATH; }
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then(function (response) {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
        createMenuAvailabilityForDay: function (menuId, menuSectionId, dayOfWeek, BusinessHoursPeriodBase, options) {
            var localVarFetchArgs = (0, exports.MenuSectionsApiFetchParamCreator)(configuration).createMenuAvailabilityForDay(menuId, menuSectionId, dayOfWeek, BusinessHoursPeriodBase, options);
            return function (fetch, basePath) {
                if (fetch === void 0) { fetch = portableFetch; }
                if (basePath === void 0) { basePath = BASE_PATH; }
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then(function (response) {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
        createMenuSection: function (menuId, MenuSectionBase, options) {
            var localVarFetchArgs = (0, exports.MenuSectionsApiFetchParamCreator)(configuration).createMenuSection(menuId, MenuSectionBase, options);
            return function (fetch, basePath) {
                if (fetch === void 0) { fetch = portableFetch; }
                if (basePath === void 0) { basePath = BASE_PATH; }
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then(function (response) {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
        createMenuSectionAvailability: function (menuId, menuSectionId, MenuSectionAvailabilityBase, options) {
            var localVarFetchArgs = (0, exports.MenuSectionsApiFetchParamCreator)(configuration).createMenuSectionAvailability(menuId, menuSectionId, MenuSectionAvailabilityBase, options);
            return function (fetch, basePath) {
                if (fetch === void 0) { fetch = portableFetch; }
                if (basePath === void 0) { basePath = BASE_PATH; }
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then(function (response) {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
        deleteMenuSection: function (menuId, menuSectionId, options) {
            var localVarFetchArgs = (0, exports.MenuSectionsApiFetchParamCreator)(configuration).deleteMenuSection(menuId, menuSectionId, options);
            return function (fetch, basePath) {
                if (fetch === void 0) { fetch = portableFetch; }
                if (basePath === void 0) { basePath = BASE_PATH; }
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then(function (response) {
                    if (response.status >= 200 && response.status < 300) {
                        return response;
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
        deleteMenuSectionImage: function (menuId, menuSectionId, options) {
            var localVarFetchArgs = (0, exports.MenuSectionsApiFetchParamCreator)(configuration).deleteMenuSectionImage(menuId, menuSectionId, options);
            return function (fetch, basePath) {
                if (fetch === void 0) { fetch = portableFetch; }
                if (basePath === void 0) { basePath = BASE_PATH; }
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then(function (response) {
                    if (response.status >= 200 && response.status < 300) {
                        return response;
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
        getMenuSectionById: function (menuId, menuSectionId, options) {
            var localVarFetchArgs = (0, exports.MenuSectionsApiFetchParamCreator)(configuration).getMenuSectionById(menuId, menuSectionId, options);
            return function (fetch, basePath) {
                if (fetch === void 0) { fetch = portableFetch; }
                if (basePath === void 0) { basePath = BASE_PATH; }
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then(function (response) {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
        getMenuSections: function (menuId, options) {
            var localVarFetchArgs = (0, exports.MenuSectionsApiFetchParamCreator)(configuration).getMenuSections(menuId, options);
            return function (fetch, basePath) {
                if (fetch === void 0) { fetch = portableFetch; }
                if (basePath === void 0) { basePath = BASE_PATH; }
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then(function (response) {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
        menuSectionsSetItemDisplayOrders: function (menuId, menuSectionId, MenuObjectDisplayOrders, options) {
            var localVarFetchArgs = (0, exports.MenuSectionsApiFetchParamCreator)(configuration).menuSectionsSetItemDisplayOrders(menuId, menuSectionId, MenuObjectDisplayOrders, options);
            return function (fetch, basePath) {
                if (fetch === void 0) { fetch = portableFetch; }
                if (basePath === void 0) { basePath = BASE_PATH; }
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then(function (response) {
                    if (response.status >= 200 && response.status < 300) {
                        return response;
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
        updateMenuSection: function (menuId, menuSectionId, MenuSectionBase, undoAfter, options) {
            var localVarFetchArgs = (0, exports.MenuSectionsApiFetchParamCreator)(configuration).updateMenuSection(menuId, menuSectionId, MenuSectionBase, undoAfter, options);
            return function (fetch, basePath) {
                if (fetch === void 0) { fetch = portableFetch; }
                if (basePath === void 0) { basePath = BASE_PATH; }
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then(function (response) {
                    if (response.status >= 200 && response.status < 300) {
                        return response;
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
        uploadMenuSectionImage: function (menuId, menuSectionId, Image, options) {
            var localVarFetchArgs = (0, exports.MenuSectionsApiFetchParamCreator)(configuration).uploadMenuSectionImage(menuId, menuSectionId, Image, options);
            return function (fetch, basePath) {
                if (fetch === void 0) { fetch = portableFetch; }
                if (basePath === void 0) { basePath = BASE_PATH; }
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then(function (response) {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
    };
};
exports.MenuSectionsApiFp = MenuSectionsApiFp;
var MenuSectionsApiFactory = function (configuration, fetch, basePath) {
    return {
        cloneMenuSection: function (menuId, menuSectionId, options) {
            return (0, exports.MenuSectionsApiFp)(configuration).cloneMenuSection(menuId, menuSectionId, options)(fetch, basePath);
        },
        createMenuAvailabilityForDay: function (menuId, menuSectionId, dayOfWeek, BusinessHoursPeriodBase, options) {
            return (0, exports.MenuSectionsApiFp)(configuration).createMenuAvailabilityForDay(menuId, menuSectionId, dayOfWeek, BusinessHoursPeriodBase, options)(fetch, basePath);
        },
        createMenuSection: function (menuId, MenuSectionBase, options) {
            return (0, exports.MenuSectionsApiFp)(configuration).createMenuSection(menuId, MenuSectionBase, options)(fetch, basePath);
        },
        createMenuSectionAvailability: function (menuId, menuSectionId, MenuSectionAvailabilityBase, options) {
            return (0, exports.MenuSectionsApiFp)(configuration).createMenuSectionAvailability(menuId, menuSectionId, MenuSectionAvailabilityBase, options)(fetch, basePath);
        },
        deleteMenuSection: function (menuId, menuSectionId, options) {
            return (0, exports.MenuSectionsApiFp)(configuration).deleteMenuSection(menuId, menuSectionId, options)(fetch, basePath);
        },
        deleteMenuSectionImage: function (menuId, menuSectionId, options) {
            return (0, exports.MenuSectionsApiFp)(configuration).deleteMenuSectionImage(menuId, menuSectionId, options)(fetch, basePath);
        },
        getMenuSectionById: function (menuId, menuSectionId, options) {
            return (0, exports.MenuSectionsApiFp)(configuration).getMenuSectionById(menuId, menuSectionId, options)(fetch, basePath);
        },
        getMenuSections: function (menuId, options) {
            return (0, exports.MenuSectionsApiFp)(configuration).getMenuSections(menuId, options)(fetch, basePath);
        },
        menuSectionsSetItemDisplayOrders: function (menuId, menuSectionId, MenuObjectDisplayOrders, options) {
            return (0, exports.MenuSectionsApiFp)(configuration).menuSectionsSetItemDisplayOrders(menuId, menuSectionId, MenuObjectDisplayOrders, options)(fetch, basePath);
        },
        updateMenuSection: function (menuId, menuSectionId, MenuSectionBase, undoAfter, options) {
            return (0, exports.MenuSectionsApiFp)(configuration).updateMenuSection(menuId, menuSectionId, MenuSectionBase, undoAfter, options)(fetch, basePath);
        },
        uploadMenuSectionImage: function (menuId, menuSectionId, Image, options) {
            return (0, exports.MenuSectionsApiFp)(configuration).uploadMenuSectionImage(menuId, menuSectionId, Image, options)(fetch, basePath);
        },
    };
};
exports.MenuSectionsApiFactory = MenuSectionsApiFactory;
var MenuSectionsApi = (function (_super) {
    __extends(MenuSectionsApi, _super);
    function MenuSectionsApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    MenuSectionsApi.prototype.cloneMenuSection = function (menuId, menuSectionId, options) {
        return (0, exports.MenuSectionsApiFp)(this.configuration).cloneMenuSection(menuId, menuSectionId, options)(this.fetch, this.basePath);
    };
    MenuSectionsApi.prototype.createMenuAvailabilityForDay = function (menuId, menuSectionId, dayOfWeek, BusinessHoursPeriodBase, options) {
        return (0, exports.MenuSectionsApiFp)(this.configuration).createMenuAvailabilityForDay(menuId, menuSectionId, dayOfWeek, BusinessHoursPeriodBase, options)(this.fetch, this.basePath);
    };
    MenuSectionsApi.prototype.createMenuSection = function (menuId, MenuSectionBase, options) {
        return (0, exports.MenuSectionsApiFp)(this.configuration).createMenuSection(menuId, MenuSectionBase, options)(this.fetch, this.basePath);
    };
    MenuSectionsApi.prototype.createMenuSectionAvailability = function (menuId, menuSectionId, MenuSectionAvailabilityBase, options) {
        return (0, exports.MenuSectionsApiFp)(this.configuration).createMenuSectionAvailability(menuId, menuSectionId, MenuSectionAvailabilityBase, options)(this.fetch, this.basePath);
    };
    MenuSectionsApi.prototype.deleteMenuSection = function (menuId, menuSectionId, options) {
        return (0, exports.MenuSectionsApiFp)(this.configuration).deleteMenuSection(menuId, menuSectionId, options)(this.fetch, this.basePath);
    };
    MenuSectionsApi.prototype.deleteMenuSectionImage = function (menuId, menuSectionId, options) {
        return (0, exports.MenuSectionsApiFp)(this.configuration).deleteMenuSectionImage(menuId, menuSectionId, options)(this.fetch, this.basePath);
    };
    MenuSectionsApi.prototype.getMenuSectionById = function (menuId, menuSectionId, options) {
        return (0, exports.MenuSectionsApiFp)(this.configuration).getMenuSectionById(menuId, menuSectionId, options)(this.fetch, this.basePath);
    };
    MenuSectionsApi.prototype.getMenuSections = function (menuId, options) {
        return (0, exports.MenuSectionsApiFp)(this.configuration).getMenuSections(menuId, options)(this.fetch, this.basePath);
    };
    MenuSectionsApi.prototype.menuSectionsSetItemDisplayOrders = function (menuId, menuSectionId, MenuObjectDisplayOrders, options) {
        return (0, exports.MenuSectionsApiFp)(this.configuration).menuSectionsSetItemDisplayOrders(menuId, menuSectionId, MenuObjectDisplayOrders, options)(this.fetch, this.basePath);
    };
    MenuSectionsApi.prototype.updateMenuSection = function (menuId, menuSectionId, MenuSectionBase, undoAfter, options) {
        return (0, exports.MenuSectionsApiFp)(this.configuration).updateMenuSection(menuId, menuSectionId, MenuSectionBase, undoAfter, options)(this.fetch, this.basePath);
    };
    MenuSectionsApi.prototype.uploadMenuSectionImage = function (menuId, menuSectionId, Image, options) {
        return (0, exports.MenuSectionsApiFp)(this.configuration).uploadMenuSectionImage(menuId, menuSectionId, Image, options)(this.fetch, this.basePath);
    };
    return MenuSectionsApi;
}(BaseAPI));
exports.MenuSectionsApi = MenuSectionsApi;
var MenuZonesApiFetchParamCreator = function (configuration) {
    return {
        addMenuZone: function (menuId, MenuZone, options) {
            if (options === void 0) { options = {}; }
            if (menuId === null || menuId === undefined) {
                throw new RequiredError('menuId', 'Required parameter menuId was null or undefined when calling addMenuZone.');
            }
            if (MenuZone === null || MenuZone === undefined) {
                throw new RequiredError('MenuZone', 'Required parameter MenuZone was null or undefined when calling addMenuZone.');
            }
            var localVarPath = "/api/v1.0/menus/{menuId}/zones"
                .replace("{".concat("menuId", "}"), encodeURIComponent(String(menuId)));
            var localVarUrlObj = url.parse(localVarPath, true);
            var localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            var localVarHeaderParameter = {};
            var localVarQueryParameter = {};
            if (configuration && configuration.accessToken) {
                var localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("oauth2", ["api"])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }
            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            var needsSerialization = ("MenuZone" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body = needsSerialization ? JSON.stringify(MenuZone || {}) : (MenuZone || "");
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        deleteMenuZone: function (menuId, menuZoneId, options) {
            if (options === void 0) { options = {}; }
            if (menuId === null || menuId === undefined) {
                throw new RequiredError('menuId', 'Required parameter menuId was null or undefined when calling deleteMenuZone.');
            }
            if (menuZoneId === null || menuZoneId === undefined) {
                throw new RequiredError('menuZoneId', 'Required parameter menuZoneId was null or undefined when calling deleteMenuZone.');
            }
            var localVarPath = "/api/v1.0/menus/{menuId}/zones/{menuZoneId}"
                .replace("{".concat("menuId", "}"), encodeURIComponent(String(menuId)))
                .replace("{".concat("menuZoneId", "}"), encodeURIComponent(String(menuZoneId)));
            var localVarUrlObj = url.parse(localVarPath, true);
            var localVarRequestOptions = Object.assign({ method: 'DELETE' }, options);
            var localVarHeaderParameter = {};
            var localVarQueryParameter = {};
            if (configuration && configuration.accessToken) {
                var localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("oauth2", ["api"])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        deleteMenuZoneImage: function (menuId, menuZoneId, options) {
            if (options === void 0) { options = {}; }
            if (menuId === null || menuId === undefined) {
                throw new RequiredError('menuId', 'Required parameter menuId was null or undefined when calling deleteMenuZoneImage.');
            }
            if (menuZoneId === null || menuZoneId === undefined) {
                throw new RequiredError('menuZoneId', 'Required parameter menuZoneId was null or undefined when calling deleteMenuZoneImage.');
            }
            var localVarPath = "/api/v1.0/menus/{menuId}/zones/{menuZoneId}/image"
                .replace("{".concat("menuId", "}"), encodeURIComponent(String(menuId)))
                .replace("{".concat("menuZoneId", "}"), encodeURIComponent(String(menuZoneId)));
            var localVarUrlObj = url.parse(localVarPath, true);
            var localVarRequestOptions = Object.assign({ method: 'DELETE' }, options);
            var localVarHeaderParameter = {};
            var localVarQueryParameter = {};
            if (configuration && configuration.accessToken) {
                var localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("oauth2", ["api"])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        flipMenuZones: function (menuId, menuZoneId, menuZoneI2, options) {
            if (options === void 0) { options = {}; }
            if (menuId === null || menuId === undefined) {
                throw new RequiredError('menuId', 'Required parameter menuId was null or undefined when calling flipMenuZones.');
            }
            if (menuZoneId === null || menuZoneId === undefined) {
                throw new RequiredError('menuZoneId', 'Required parameter menuZoneId was null or undefined when calling flipMenuZones.');
            }
            if (menuZoneI2 === null || menuZoneI2 === undefined) {
                throw new RequiredError('menuZoneI2', 'Required parameter menuZoneI2 was null or undefined when calling flipMenuZones.');
            }
            var localVarPath = "/api/v1.0/menus/{menuId}/zones/{menuZoneId}/flip/{menuZoneI2}"
                .replace("{".concat("menuId", "}"), encodeURIComponent(String(menuId)))
                .replace("{".concat("menuZoneId", "}"), encodeURIComponent(String(menuZoneId)))
                .replace("{".concat("menuZoneI2", "}"), encodeURIComponent(String(menuZoneI2)));
            var localVarUrlObj = url.parse(localVarPath, true);
            var localVarRequestOptions = Object.assign({ method: 'PUT' }, options);
            var localVarHeaderParameter = {};
            var localVarQueryParameter = {};
            if (configuration && configuration.accessToken) {
                var localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("oauth2", ["api"])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        getMenuZone: function (menuId, menuZoneId, options) {
            if (options === void 0) { options = {}; }
            if (menuId === null || menuId === undefined) {
                throw new RequiredError('menuId', 'Required parameter menuId was null or undefined when calling getMenuZone.');
            }
            if (menuZoneId === null || menuZoneId === undefined) {
                throw new RequiredError('menuZoneId', 'Required parameter menuZoneId was null or undefined when calling getMenuZone.');
            }
            var localVarPath = "/api/v1.0/menus/{menuId}/zones/{menuZoneId}"
                .replace("{".concat("menuId", "}"), encodeURIComponent(String(menuId)))
                .replace("{".concat("menuZoneId", "}"), encodeURIComponent(String(menuZoneId)));
            var localVarUrlObj = url.parse(localVarPath, true);
            var localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            var localVarHeaderParameter = {};
            var localVarQueryParameter = {};
            if (configuration && configuration.accessToken) {
                var localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("oauth2", ["api"])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        getMenuZonesForMenuId: function (menuId, options) {
            if (options === void 0) { options = {}; }
            if (menuId === null || menuId === undefined) {
                throw new RequiredError('menuId', 'Required parameter menuId was null or undefined when calling getMenuZonesForMenuId.');
            }
            var localVarPath = "/api/v1.0/menus/{menuId}/zones"
                .replace("{".concat("menuId", "}"), encodeURIComponent(String(menuId)));
            var localVarUrlObj = url.parse(localVarPath, true);
            var localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            var localVarHeaderParameter = {};
            var localVarQueryParameter = {};
            if (configuration && configuration.accessToken) {
                var localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("oauth2", ["api"])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        setMenuSectionMenuZone: function (menuId, menuZoneId, menuSectionId, options) {
            if (options === void 0) { options = {}; }
            if (menuId === null || menuId === undefined) {
                throw new RequiredError('menuId', 'Required parameter menuId was null or undefined when calling setMenuSectionMenuZone.');
            }
            if (menuZoneId === null || menuZoneId === undefined) {
                throw new RequiredError('menuZoneId', 'Required parameter menuZoneId was null or undefined when calling setMenuSectionMenuZone.');
            }
            if (menuSectionId === null || menuSectionId === undefined) {
                throw new RequiredError('menuSectionId', 'Required parameter menuSectionId was null or undefined when calling setMenuSectionMenuZone.');
            }
            var localVarPath = "/api/v1.0/menus/{menuId}/zones/{menuZoneId}/section/{menuSectionId}"
                .replace("{".concat("menuId", "}"), encodeURIComponent(String(menuId)))
                .replace("{".concat("menuZoneId", "}"), encodeURIComponent(String(menuZoneId)))
                .replace("{".concat("menuSectionId", "}"), encodeURIComponent(String(menuSectionId)));
            var localVarUrlObj = url.parse(localVarPath, true);
            var localVarRequestOptions = Object.assign({ method: 'PUT' }, options);
            var localVarHeaderParameter = {};
            var localVarQueryParameter = {};
            if (configuration && configuration.accessToken) {
                var localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("oauth2", ["api"])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        setMenuZoneDescription: function (menuId, menuZoneId, body, options) {
            if (options === void 0) { options = {}; }
            if (menuId === null || menuId === undefined) {
                throw new RequiredError('menuId', 'Required parameter menuId was null or undefined when calling setMenuZoneDescription.');
            }
            if (menuZoneId === null || menuZoneId === undefined) {
                throw new RequiredError('menuZoneId', 'Required parameter menuZoneId was null or undefined when calling setMenuZoneDescription.');
            }
            if (body === null || body === undefined) {
                throw new RequiredError('body', 'Required parameter body was null or undefined when calling setMenuZoneDescription.');
            }
            var localVarPath = "/api/v1.0/menus/{menuId}/zones/{menuZoneId}/description"
                .replace("{".concat("menuId", "}"), encodeURIComponent(String(menuId)))
                .replace("{".concat("menuZoneId", "}"), encodeURIComponent(String(menuZoneId)));
            var localVarUrlObj = url.parse(localVarPath, true);
            var localVarRequestOptions = Object.assign({ method: 'PUT' }, options);
            var localVarHeaderParameter = {};
            var localVarQueryParameter = {};
            if (configuration && configuration.accessToken) {
                var localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("oauth2", ["api"])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }
            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            var needsSerialization = ("string" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body = needsSerialization ? JSON.stringify(body || {}) : (body || "");
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        setMenuZoneName: function (menuId, menuZoneId, menuZoneName, options) {
            if (options === void 0) { options = {}; }
            if (menuId === null || menuId === undefined) {
                throw new RequiredError('menuId', 'Required parameter menuId was null or undefined when calling setMenuZoneName.');
            }
            if (menuZoneId === null || menuZoneId === undefined) {
                throw new RequiredError('menuZoneId', 'Required parameter menuZoneId was null or undefined when calling setMenuZoneName.');
            }
            if (menuZoneName === null || menuZoneName === undefined) {
                throw new RequiredError('menuZoneName', 'Required parameter menuZoneName was null or undefined when calling setMenuZoneName.');
            }
            var localVarPath = "/api/v1.0/menus/{menuId}/zones/{menuZoneId}/name/{menuZoneName}"
                .replace("{".concat("menuId", "}"), encodeURIComponent(String(menuId)))
                .replace("{".concat("menuZoneId", "}"), encodeURIComponent(String(menuZoneId)))
                .replace("{".concat("menuZoneName", "}"), encodeURIComponent(String(menuZoneName)));
            var localVarUrlObj = url.parse(localVarPath, true);
            var localVarRequestOptions = Object.assign({ method: 'PUT' }, options);
            var localVarHeaderParameter = {};
            var localVarQueryParameter = {};
            if (configuration && configuration.accessToken) {
                var localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("oauth2", ["api"])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        updateMenuZone: function (menuId, menuZoneId, MenuZone, options) {
            if (options === void 0) { options = {}; }
            if (menuId === null || menuId === undefined) {
                throw new RequiredError('menuId', 'Required parameter menuId was null or undefined when calling updateMenuZone.');
            }
            if (menuZoneId === null || menuZoneId === undefined) {
                throw new RequiredError('menuZoneId', 'Required parameter menuZoneId was null or undefined when calling updateMenuZone.');
            }
            if (MenuZone === null || MenuZone === undefined) {
                throw new RequiredError('MenuZone', 'Required parameter MenuZone was null or undefined when calling updateMenuZone.');
            }
            var localVarPath = "/api/v1.0/menus/{menuId}/zones/{menuZoneId}"
                .replace("{".concat("menuId", "}"), encodeURIComponent(String(menuId)))
                .replace("{".concat("menuZoneId", "}"), encodeURIComponent(String(menuZoneId)));
            var localVarUrlObj = url.parse(localVarPath, true);
            var localVarRequestOptions = Object.assign({ method: 'PUT' }, options);
            var localVarHeaderParameter = {};
            var localVarQueryParameter = {};
            if (configuration && configuration.accessToken) {
                var localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("oauth2", ["api"])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }
            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            var needsSerialization = ("MenuZone" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body = needsSerialization ? JSON.stringify(MenuZone || {}) : (MenuZone || "");
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        uploadMenuZoneImage: function (menuId, menuZoneId, HttpPostedFileBase, options) {
            if (options === void 0) { options = {}; }
            if (menuId === null || menuId === undefined) {
                throw new RequiredError('menuId', 'Required parameter menuId was null or undefined when calling uploadMenuZoneImage.');
            }
            if (menuZoneId === null || menuZoneId === undefined) {
                throw new RequiredError('menuZoneId', 'Required parameter menuZoneId was null or undefined when calling uploadMenuZoneImage.');
            }
            if (HttpPostedFileBase === null || HttpPostedFileBase === undefined) {
                throw new RequiredError('HttpPostedFileBase', 'Required parameter HttpPostedFileBase was null or undefined when calling uploadMenuZoneImage.');
            }
            var localVarPath = "/api/v1.0/menus/{menuId}/zones/{menuZoneId}/image"
                .replace("{".concat("menuId", "}"), encodeURIComponent(String(menuId)))
                .replace("{".concat("menuZoneId", "}"), encodeURIComponent(String(menuZoneId)));
            var localVarUrlObj = url.parse(localVarPath, true);
            var localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            var localVarHeaderParameter = {};
            var localVarQueryParameter = {};
            if (configuration && configuration.accessToken) {
                var localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("oauth2", ["api"])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }
            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            var needsSerialization = ("Array&lt;HttpPostedFileBase&gt;" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body = needsSerialization ? JSON.stringify(HttpPostedFileBase || {}) : (HttpPostedFileBase || "");
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    };
};
exports.MenuZonesApiFetchParamCreator = MenuZonesApiFetchParamCreator;
var MenuZonesApiFp = function (configuration) {
    return {
        addMenuZone: function (menuId, MenuZone, options) {
            var localVarFetchArgs = (0, exports.MenuZonesApiFetchParamCreator)(configuration).addMenuZone(menuId, MenuZone, options);
            return function (fetch, basePath) {
                if (fetch === void 0) { fetch = portableFetch; }
                if (basePath === void 0) { basePath = BASE_PATH; }
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then(function (response) {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
        deleteMenuZone: function (menuId, menuZoneId, options) {
            var localVarFetchArgs = (0, exports.MenuZonesApiFetchParamCreator)(configuration).deleteMenuZone(menuId, menuZoneId, options);
            return function (fetch, basePath) {
                if (fetch === void 0) { fetch = portableFetch; }
                if (basePath === void 0) { basePath = BASE_PATH; }
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then(function (response) {
                    if (response.status >= 200 && response.status < 300) {
                        return response;
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
        deleteMenuZoneImage: function (menuId, menuZoneId, options) {
            var localVarFetchArgs = (0, exports.MenuZonesApiFetchParamCreator)(configuration).deleteMenuZoneImage(menuId, menuZoneId, options);
            return function (fetch, basePath) {
                if (fetch === void 0) { fetch = portableFetch; }
                if (basePath === void 0) { basePath = BASE_PATH; }
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then(function (response) {
                    if (response.status >= 200 && response.status < 300) {
                        return response;
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
        flipMenuZones: function (menuId, menuZoneId, menuZoneI2, options) {
            var localVarFetchArgs = (0, exports.MenuZonesApiFetchParamCreator)(configuration).flipMenuZones(menuId, menuZoneId, menuZoneI2, options);
            return function (fetch, basePath) {
                if (fetch === void 0) { fetch = portableFetch; }
                if (basePath === void 0) { basePath = BASE_PATH; }
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then(function (response) {
                    if (response.status >= 200 && response.status < 300) {
                        return response;
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
        getMenuZone: function (menuId, menuZoneId, options) {
            var localVarFetchArgs = (0, exports.MenuZonesApiFetchParamCreator)(configuration).getMenuZone(menuId, menuZoneId, options);
            return function (fetch, basePath) {
                if (fetch === void 0) { fetch = portableFetch; }
                if (basePath === void 0) { basePath = BASE_PATH; }
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then(function (response) {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
        getMenuZonesForMenuId: function (menuId, options) {
            var localVarFetchArgs = (0, exports.MenuZonesApiFetchParamCreator)(configuration).getMenuZonesForMenuId(menuId, options);
            return function (fetch, basePath) {
                if (fetch === void 0) { fetch = portableFetch; }
                if (basePath === void 0) { basePath = BASE_PATH; }
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then(function (response) {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
        setMenuSectionMenuZone: function (menuId, menuZoneId, menuSectionId, options) {
            var localVarFetchArgs = (0, exports.MenuZonesApiFetchParamCreator)(configuration).setMenuSectionMenuZone(menuId, menuZoneId, menuSectionId, options);
            return function (fetch, basePath) {
                if (fetch === void 0) { fetch = portableFetch; }
                if (basePath === void 0) { basePath = BASE_PATH; }
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then(function (response) {
                    if (response.status >= 200 && response.status < 300) {
                        return response;
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
        setMenuZoneDescription: function (menuId, menuZoneId, body, options) {
            var localVarFetchArgs = (0, exports.MenuZonesApiFetchParamCreator)(configuration).setMenuZoneDescription(menuId, menuZoneId, body, options);
            return function (fetch, basePath) {
                if (fetch === void 0) { fetch = portableFetch; }
                if (basePath === void 0) { basePath = BASE_PATH; }
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then(function (response) {
                    if (response.status >= 200 && response.status < 300) {
                        return response;
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
        setMenuZoneName: function (menuId, menuZoneId, menuZoneName, options) {
            var localVarFetchArgs = (0, exports.MenuZonesApiFetchParamCreator)(configuration).setMenuZoneName(menuId, menuZoneId, menuZoneName, options);
            return function (fetch, basePath) {
                if (fetch === void 0) { fetch = portableFetch; }
                if (basePath === void 0) { basePath = BASE_PATH; }
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then(function (response) {
                    if (response.status >= 200 && response.status < 300) {
                        return response;
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
        updateMenuZone: function (menuId, menuZoneId, MenuZone, options) {
            var localVarFetchArgs = (0, exports.MenuZonesApiFetchParamCreator)(configuration).updateMenuZone(menuId, menuZoneId, MenuZone, options);
            return function (fetch, basePath) {
                if (fetch === void 0) { fetch = portableFetch; }
                if (basePath === void 0) { basePath = BASE_PATH; }
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then(function (response) {
                    if (response.status >= 200 && response.status < 300) {
                        return response;
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
        uploadMenuZoneImage: function (menuId, menuZoneId, HttpPostedFileBase, options) {
            var localVarFetchArgs = (0, exports.MenuZonesApiFetchParamCreator)(configuration).uploadMenuZoneImage(menuId, menuZoneId, HttpPostedFileBase, options);
            return function (fetch, basePath) {
                if (fetch === void 0) { fetch = portableFetch; }
                if (basePath === void 0) { basePath = BASE_PATH; }
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then(function (response) {
                    if (response.status >= 200 && response.status < 300) {
                        return response;
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
    };
};
exports.MenuZonesApiFp = MenuZonesApiFp;
var MenuZonesApiFactory = function (configuration, fetch, basePath) {
    return {
        addMenuZone: function (menuId, MenuZone, options) {
            return (0, exports.MenuZonesApiFp)(configuration).addMenuZone(menuId, MenuZone, options)(fetch, basePath);
        },
        deleteMenuZone: function (menuId, menuZoneId, options) {
            return (0, exports.MenuZonesApiFp)(configuration).deleteMenuZone(menuId, menuZoneId, options)(fetch, basePath);
        },
        deleteMenuZoneImage: function (menuId, menuZoneId, options) {
            return (0, exports.MenuZonesApiFp)(configuration).deleteMenuZoneImage(menuId, menuZoneId, options)(fetch, basePath);
        },
        flipMenuZones: function (menuId, menuZoneId, menuZoneI2, options) {
            return (0, exports.MenuZonesApiFp)(configuration).flipMenuZones(menuId, menuZoneId, menuZoneI2, options)(fetch, basePath);
        },
        getMenuZone: function (menuId, menuZoneId, options) {
            return (0, exports.MenuZonesApiFp)(configuration).getMenuZone(menuId, menuZoneId, options)(fetch, basePath);
        },
        getMenuZonesForMenuId: function (menuId, options) {
            return (0, exports.MenuZonesApiFp)(configuration).getMenuZonesForMenuId(menuId, options)(fetch, basePath);
        },
        setMenuSectionMenuZone: function (menuId, menuZoneId, menuSectionId, options) {
            return (0, exports.MenuZonesApiFp)(configuration).setMenuSectionMenuZone(menuId, menuZoneId, menuSectionId, options)(fetch, basePath);
        },
        setMenuZoneDescription: function (menuId, menuZoneId, body, options) {
            return (0, exports.MenuZonesApiFp)(configuration).setMenuZoneDescription(menuId, menuZoneId, body, options)(fetch, basePath);
        },
        setMenuZoneName: function (menuId, menuZoneId, menuZoneName, options) {
            return (0, exports.MenuZonesApiFp)(configuration).setMenuZoneName(menuId, menuZoneId, menuZoneName, options)(fetch, basePath);
        },
        updateMenuZone: function (menuId, menuZoneId, MenuZone, options) {
            return (0, exports.MenuZonesApiFp)(configuration).updateMenuZone(menuId, menuZoneId, MenuZone, options)(fetch, basePath);
        },
        uploadMenuZoneImage: function (menuId, menuZoneId, HttpPostedFileBase, options) {
            return (0, exports.MenuZonesApiFp)(configuration).uploadMenuZoneImage(menuId, menuZoneId, HttpPostedFileBase, options)(fetch, basePath);
        },
    };
};
exports.MenuZonesApiFactory = MenuZonesApiFactory;
var MenuZonesApi = (function (_super) {
    __extends(MenuZonesApi, _super);
    function MenuZonesApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    MenuZonesApi.prototype.addMenuZone = function (menuId, MenuZone, options) {
        return (0, exports.MenuZonesApiFp)(this.configuration).addMenuZone(menuId, MenuZone, options)(this.fetch, this.basePath);
    };
    MenuZonesApi.prototype.deleteMenuZone = function (menuId, menuZoneId, options) {
        return (0, exports.MenuZonesApiFp)(this.configuration).deleteMenuZone(menuId, menuZoneId, options)(this.fetch, this.basePath);
    };
    MenuZonesApi.prototype.deleteMenuZoneImage = function (menuId, menuZoneId, options) {
        return (0, exports.MenuZonesApiFp)(this.configuration).deleteMenuZoneImage(menuId, menuZoneId, options)(this.fetch, this.basePath);
    };
    MenuZonesApi.prototype.flipMenuZones = function (menuId, menuZoneId, menuZoneI2, options) {
        return (0, exports.MenuZonesApiFp)(this.configuration).flipMenuZones(menuId, menuZoneId, menuZoneI2, options)(this.fetch, this.basePath);
    };
    MenuZonesApi.prototype.getMenuZone = function (menuId, menuZoneId, options) {
        return (0, exports.MenuZonesApiFp)(this.configuration).getMenuZone(menuId, menuZoneId, options)(this.fetch, this.basePath);
    };
    MenuZonesApi.prototype.getMenuZonesForMenuId = function (menuId, options) {
        return (0, exports.MenuZonesApiFp)(this.configuration).getMenuZonesForMenuId(menuId, options)(this.fetch, this.basePath);
    };
    MenuZonesApi.prototype.setMenuSectionMenuZone = function (menuId, menuZoneId, menuSectionId, options) {
        return (0, exports.MenuZonesApiFp)(this.configuration).setMenuSectionMenuZone(menuId, menuZoneId, menuSectionId, options)(this.fetch, this.basePath);
    };
    MenuZonesApi.prototype.setMenuZoneDescription = function (menuId, menuZoneId, body, options) {
        return (0, exports.MenuZonesApiFp)(this.configuration).setMenuZoneDescription(menuId, menuZoneId, body, options)(this.fetch, this.basePath);
    };
    MenuZonesApi.prototype.setMenuZoneName = function (menuId, menuZoneId, menuZoneName, options) {
        return (0, exports.MenuZonesApiFp)(this.configuration).setMenuZoneName(menuId, menuZoneId, menuZoneName, options)(this.fetch, this.basePath);
    };
    MenuZonesApi.prototype.updateMenuZone = function (menuId, menuZoneId, MenuZone, options) {
        return (0, exports.MenuZonesApiFp)(this.configuration).updateMenuZone(menuId, menuZoneId, MenuZone, options)(this.fetch, this.basePath);
    };
    MenuZonesApi.prototype.uploadMenuZoneImage = function (menuId, menuZoneId, HttpPostedFileBase, options) {
        return (0, exports.MenuZonesApiFp)(this.configuration).uploadMenuZoneImage(menuId, menuZoneId, HttpPostedFileBase, options)(this.fetch, this.basePath);
    };
    return MenuZonesApi;
}(BaseAPI));
exports.MenuZonesApi = MenuZonesApi;
var MenusApiFetchParamCreator = function (configuration) {
    return {
        createDraftMenuFromExistingMenu: function (menuId, newName, options) {
            if (options === void 0) { options = {}; }
            if (menuId === null || menuId === undefined) {
                throw new RequiredError('menuId', 'Required parameter menuId was null or undefined when calling createDraftMenuFromExistingMenu.');
            }
            if (newName === null || newName === undefined) {
                throw new RequiredError('newName', 'Required parameter newName was null or undefined when calling createDraftMenuFromExistingMenu.');
            }
            var localVarPath = "/api/v1.0/menus/{menuId}/clone/{newName}"
                .replace("{".concat("menuId", "}"), encodeURIComponent(String(menuId)))
                .replace("{".concat("newName", "}"), encodeURIComponent(String(newName)));
            var localVarUrlObj = url.parse(localVarPath, true);
            var localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            var localVarHeaderParameter = {};
            var localVarQueryParameter = {};
            if (configuration && configuration.accessToken) {
                var localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("oauth2", ["api"])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        createNewMenuAsync: function (appId, CreateFullMenu, orgId, options) {
            if (options === void 0) { options = {}; }
            if (appId === null || appId === undefined) {
                throw new RequiredError('appId', 'Required parameter appId was null or undefined when calling createNewMenuAsync.');
            }
            if (CreateFullMenu === null || CreateFullMenu === undefined) {
                throw new RequiredError('CreateFullMenu', 'Required parameter CreateFullMenu was null or undefined when calling createNewMenuAsync.');
            }
            var localVarPath = "/api/v1.0/{appId}/menus/async"
                .replace("{".concat("appId", "}"), encodeURIComponent(String(appId)));
            var localVarUrlObj = url.parse(localVarPath, true);
            var localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            var localVarHeaderParameter = {};
            var localVarQueryParameter = {};
            if (configuration && configuration.accessToken) {
                var localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("oauth2", ["api"])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }
            if (orgId !== undefined) {
                localVarQueryParameter['orgId'] = orgId;
            }
            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            var needsSerialization = ("CreateFullMenu" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body = needsSerialization ? JSON.stringify(CreateFullMenu || {}) : (CreateFullMenu || "");
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        createNewMenuForApp: function (appId, CreateFullMenu, options) {
            if (options === void 0) { options = {}; }
            if (appId === null || appId === undefined) {
                throw new RequiredError('appId', 'Required parameter appId was null or undefined when calling createNewMenuForApp.');
            }
            if (CreateFullMenu === null || CreateFullMenu === undefined) {
                throw new RequiredError('CreateFullMenu', 'Required parameter CreateFullMenu was null or undefined when calling createNewMenuForApp.');
            }
            var localVarPath = "/api/v1.0/{appId}/menus"
                .replace("{".concat("appId", "}"), encodeURIComponent(String(appId)));
            var localVarUrlObj = url.parse(localVarPath, true);
            var localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            var localVarHeaderParameter = {};
            var localVarQueryParameter = {};
            if (configuration && configuration.accessToken) {
                var localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("oauth2", ["api"])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }
            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            var needsSerialization = ("CreateFullMenu" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body = needsSerialization ? JSON.stringify(CreateFullMenu || {}) : (CreateFullMenu || "");
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        deleteMenu: function (menuId, options) {
            if (options === void 0) { options = {}; }
            if (menuId === null || menuId === undefined) {
                throw new RequiredError('menuId', 'Required parameter menuId was null or undefined when calling deleteMenu.');
            }
            var localVarPath = "/api/v1.0/menus/{menuId}"
                .replace("{".concat("menuId", "}"), encodeURIComponent(String(menuId)));
            var localVarUrlObj = url.parse(localVarPath, true);
            var localVarRequestOptions = Object.assign({ method: 'DELETE' }, options);
            var localVarHeaderParameter = {};
            var localVarQueryParameter = {};
            if (configuration && configuration.accessToken) {
                var localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("oauth2", ["api"])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        deleteMenuImage: function (menuId, options) {
            if (options === void 0) { options = {}; }
            if (menuId === null || menuId === undefined) {
                throw new RequiredError('menuId', 'Required parameter menuId was null or undefined when calling deleteMenuImage.');
            }
            var localVarPath = "/api/v1.0/menus/{menuId}/image"
                .replace("{".concat("menuId", "}"), encodeURIComponent(String(menuId)));
            var localVarUrlObj = url.parse(localVarPath, true);
            var localVarRequestOptions = Object.assign({ method: 'DELETE' }, options);
            var localVarHeaderParameter = {};
            var localVarQueryParameter = {};
            if (configuration && configuration.accessToken) {
                var localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("oauth2", ["api"])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        deleteMenuItemMetadata: function (menuId, storeId, menuItemId, key, options) {
            if (options === void 0) { options = {}; }
            if (menuId === null || menuId === undefined) {
                throw new RequiredError('menuId', 'Required parameter menuId was null or undefined when calling deleteMenuItemMetadata.');
            }
            if (storeId === null || storeId === undefined) {
                throw new RequiredError('storeId', 'Required parameter storeId was null or undefined when calling deleteMenuItemMetadata.');
            }
            if (menuItemId === null || menuItemId === undefined) {
                throw new RequiredError('menuItemId', 'Required parameter menuItemId was null or undefined when calling deleteMenuItemMetadata.');
            }
            if (key === null || key === undefined) {
                throw new RequiredError('key', 'Required parameter key was null or undefined when calling deleteMenuItemMetadata.');
            }
            var localVarPath = "/api/v1.0/menus/{menuId}/menuitem/{menuItemId}/metadata/{key}/store/{storeId}"
                .replace("{".concat("menuId", "}"), encodeURIComponent(String(menuId)))
                .replace("{".concat("storeId", "}"), encodeURIComponent(String(storeId)))
                .replace("{".concat("menuItemId", "}"), encodeURIComponent(String(menuItemId)))
                .replace("{".concat("key", "}"), encodeURIComponent(String(key)));
            var localVarUrlObj = url.parse(localVarPath, true);
            var localVarRequestOptions = Object.assign({ method: 'DELETE' }, options);
            var localVarHeaderParameter = {};
            var localVarQueryParameter = {};
            if (configuration && configuration.accessToken) {
                var localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("oauth2", ["api"])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        getAllMenuMetadataByMenuIdAndStoreId: function (menuId, storeId, options) {
            if (options === void 0) { options = {}; }
            if (menuId === null || menuId === undefined) {
                throw new RequiredError('menuId', 'Required parameter menuId was null or undefined when calling getAllMenuMetadataByMenuIdAndStoreId.');
            }
            if (storeId === null || storeId === undefined) {
                throw new RequiredError('storeId', 'Required parameter storeId was null or undefined when calling getAllMenuMetadataByMenuIdAndStoreId.');
            }
            var localVarPath = "/api/v1.0/menus/{menuId}/metadata/store/{storeId}"
                .replace("{".concat("menuId", "}"), encodeURIComponent(String(menuId)))
                .replace("{".concat("storeId", "}"), encodeURIComponent(String(storeId)));
            var localVarUrlObj = url.parse(localVarPath, true);
            var localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            var localVarHeaderParameter = {};
            var localVarQueryParameter = {};
            if (configuration && configuration.accessToken) {
                var localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("oauth2", ["api"])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        getMenuById: function (menuId, options) {
            if (options === void 0) { options = {}; }
            if (menuId === null || menuId === undefined) {
                throw new RequiredError('menuId', 'Required parameter menuId was null or undefined when calling getMenuById.');
            }
            var localVarPath = "/api/v1.0/menus/{menuId}"
                .replace("{".concat("menuId", "}"), encodeURIComponent(String(menuId)));
            var localVarUrlObj = url.parse(localVarPath, true);
            var localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            var localVarHeaderParameter = {};
            var localVarQueryParameter = {};
            if (configuration && configuration.accessToken) {
                var localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("oauth2", ["api"])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        getMenuItemMetadata: function (menuId, storeId, menuItemId, options) {
            if (options === void 0) { options = {}; }
            if (menuId === null || menuId === undefined) {
                throw new RequiredError('menuId', 'Required parameter menuId was null or undefined when calling getMenuItemMetadata.');
            }
            if (storeId === null || storeId === undefined) {
                throw new RequiredError('storeId', 'Required parameter storeId was null or undefined when calling getMenuItemMetadata.');
            }
            if (menuItemId === null || menuItemId === undefined) {
                throw new RequiredError('menuItemId', 'Required parameter menuItemId was null or undefined when calling getMenuItemMetadata.');
            }
            var localVarPath = "/api/v1.0/menus/{menuId}/menuitem/{menuItemId}/metadata/store/{storeId}"
                .replace("{".concat("menuId", "}"), encodeURIComponent(String(menuId)))
                .replace("{".concat("storeId", "}"), encodeURIComponent(String(storeId)))
                .replace("{".concat("menuItemId", "}"), encodeURIComponent(String(menuItemId)));
            var localVarUrlObj = url.parse(localVarPath, true);
            var localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            var localVarHeaderParameter = {};
            var localVarQueryParameter = {};
            if (configuration && configuration.accessToken) {
                var localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("oauth2", ["api"])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        getMenuItemMetadataByKey: function (menuId, storeId, menuItemId, key, options) {
            if (options === void 0) { options = {}; }
            if (menuId === null || menuId === undefined) {
                throw new RequiredError('menuId', 'Required parameter menuId was null or undefined when calling getMenuItemMetadataByKey.');
            }
            if (storeId === null || storeId === undefined) {
                throw new RequiredError('storeId', 'Required parameter storeId was null or undefined when calling getMenuItemMetadataByKey.');
            }
            if (menuItemId === null || menuItemId === undefined) {
                throw new RequiredError('menuItemId', 'Required parameter menuItemId was null or undefined when calling getMenuItemMetadataByKey.');
            }
            if (key === null || key === undefined) {
                throw new RequiredError('key', 'Required parameter key was null or undefined when calling getMenuItemMetadataByKey.');
            }
            var localVarPath = "/api/v1.0/menus/{menuId}/menuitem/{menuItemId}/metadata/{key}/store/{storeId}"
                .replace("{".concat("menuId", "}"), encodeURIComponent(String(menuId)))
                .replace("{".concat("storeId", "}"), encodeURIComponent(String(storeId)))
                .replace("{".concat("menuItemId", "}"), encodeURIComponent(String(menuItemId)))
                .replace("{".concat("key", "}"), encodeURIComponent(String(key)));
            var localVarUrlObj = url.parse(localVarPath, true);
            var localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            var localVarHeaderParameter = {};
            var localVarQueryParameter = {};
            if (configuration && configuration.accessToken) {
                var localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("oauth2", ["api"])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        getMenuItemOptionSetItemMetadata: function (menuId, storeId, optionSetItemId, options) {
            if (options === void 0) { options = {}; }
            if (menuId === null || menuId === undefined) {
                throw new RequiredError('menuId', 'Required parameter menuId was null or undefined when calling getMenuItemOptionSetItemMetadata.');
            }
            if (storeId === null || storeId === undefined) {
                throw new RequiredError('storeId', 'Required parameter storeId was null or undefined when calling getMenuItemOptionSetItemMetadata.');
            }
            if (optionSetItemId === null || optionSetItemId === undefined) {
                throw new RequiredError('optionSetItemId', 'Required parameter optionSetItemId was null or undefined when calling getMenuItemOptionSetItemMetadata.');
            }
            var localVarPath = "/api/v1.0/menus/{menuId}/optionsetitem/{optionSetItemId}/metadata/store/{storeId}"
                .replace("{".concat("menuId", "}"), encodeURIComponent(String(menuId)))
                .replace("{".concat("storeId", "}"), encodeURIComponent(String(storeId)))
                .replace("{".concat("optionSetItemId", "}"), encodeURIComponent(String(optionSetItemId)));
            var localVarUrlObj = url.parse(localVarPath, true);
            var localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            var localVarHeaderParameter = {};
            var localVarQueryParameter = {};
            if (configuration && configuration.accessToken) {
                var localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("oauth2", ["api"])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        getMenuName: function (menuId, options) {
            if (options === void 0) { options = {}; }
            if (menuId === null || menuId === undefined) {
                throw new RequiredError('menuId', 'Required parameter menuId was null or undefined when calling getMenuName.');
            }
            var localVarPath = "/api/v1.0/menus/{menuId}/name"
                .replace("{".concat("menuId", "}"), encodeURIComponent(String(menuId)));
            var localVarUrlObj = url.parse(localVarPath, true);
            var localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            var localVarHeaderParameter = {};
            var localVarQueryParameter = {};
            if (configuration && configuration.accessToken) {
                var localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("oauth2", ["api"])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        getMenuStoreNames: function (menuId, options) {
            if (options === void 0) { options = {}; }
            if (menuId === null || menuId === undefined) {
                throw new RequiredError('menuId', 'Required parameter menuId was null or undefined when calling getMenuStoreNames.');
            }
            var localVarPath = "/api/v1.0/menus/{menuId}/stores"
                .replace("{".concat("menuId", "}"), encodeURIComponent(String(menuId)));
            var localVarUrlObj = url.parse(localVarPath, true);
            var localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            var localVarHeaderParameter = {};
            var localVarQueryParameter = {};
            if (configuration && configuration.accessToken) {
                var localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("oauth2", ["api"])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        getMenuTaxDetails: function (menuId, options) {
            if (options === void 0) { options = {}; }
            if (menuId === null || menuId === undefined) {
                throw new RequiredError('menuId', 'Required parameter menuId was null or undefined when calling getMenuTaxDetails.');
            }
            var localVarPath = "/api/v1.0/menus/{menuId}/tax"
                .replace("{".concat("menuId", "}"), encodeURIComponent(String(menuId)));
            var localVarUrlObj = url.parse(localVarPath, true);
            var localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            var localVarHeaderParameter = {};
            var localVarQueryParameter = {};
            if (configuration && configuration.accessToken) {
                var localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("oauth2", ["api"])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        getMenusByAppId: function (appId, options) {
            if (options === void 0) { options = {}; }
            if (appId === null || appId === undefined) {
                throw new RequiredError('appId', 'Required parameter appId was null or undefined when calling getMenusByAppId.');
            }
            var localVarPath = "/api/v1.0/{appId}/menus"
                .replace("{".concat("appId", "}"), encodeURIComponent(String(appId)));
            var localVarUrlObj = url.parse(localVarPath, true);
            var localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            var localVarHeaderParameter = {};
            var localVarQueryParameter = {};
            if (configuration && configuration.accessToken) {
                var localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("oauth2", ["api"])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        getMenusCheckpoints: function (menuId, options) {
            if (options === void 0) { options = {}; }
            if (menuId === null || menuId === undefined) {
                throw new RequiredError('menuId', 'Required parameter menuId was null or undefined when calling getMenusCheckpoints.');
            }
            var localVarPath = "/api/v1.0/menus/{menuId}/checkpoints"
                .replace("{".concat("menuId", "}"), encodeURIComponent(String(menuId)));
            var localVarUrlObj = url.parse(localVarPath, true);
            var localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            var localVarHeaderParameter = {};
            var localVarQueryParameter = {};
            if (configuration && configuration.accessToken) {
                var localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("oauth2", ["api"])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        menusDeleteTaxRate: function (menuId, taxId, options) {
            if (options === void 0) { options = {}; }
            if (menuId === null || menuId === undefined) {
                throw new RequiredError('menuId', 'Required parameter menuId was null or undefined when calling menusDeleteTaxRate.');
            }
            if (taxId === null || taxId === undefined) {
                throw new RequiredError('taxId', 'Required parameter taxId was null or undefined when calling menusDeleteTaxRate.');
            }
            var localVarPath = "/api/v1.0/menus/{menuId}/tax/{taxId}"
                .replace("{".concat("menuId", "}"), encodeURIComponent(String(menuId)))
                .replace("{".concat("taxId", "}"), encodeURIComponent(String(taxId)));
            var localVarUrlObj = url.parse(localVarPath, true);
            var localVarRequestOptions = Object.assign({ method: 'DELETE' }, options);
            var localVarHeaderParameter = {};
            var localVarQueryParameter = {};
            if (configuration && configuration.accessToken) {
                var localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("oauth2", ["api"])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        menusGetMenuBulkShowHide: function (menuId, isAvailable, options) {
            if (options === void 0) { options = {}; }
            if (menuId === null || menuId === undefined) {
                throw new RequiredError('menuId', 'Required parameter menuId was null or undefined when calling menusGetMenuBulkShowHide.');
            }
            if (isAvailable === null || isAvailable === undefined) {
                throw new RequiredError('isAvailable', 'Required parameter isAvailable was null or undefined when calling menusGetMenuBulkShowHide.');
            }
            var localVarPath = "/api/v1.0/menus/{menuId}/bulkshowhide/list"
                .replace("{".concat("menuId", "}"), encodeURIComponent(String(menuId)));
            var localVarUrlObj = url.parse(localVarPath, true);
            var localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            var localVarHeaderParameter = {};
            var localVarQueryParameter = {};
            if (configuration && configuration.accessToken) {
                var localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("oauth2", ["api"])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }
            if (isAvailable !== undefined) {
                localVarQueryParameter['isAvailable'] = isAvailable;
            }
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        menusSetDisplayOnMenuTax: function (menuId, show, options) {
            if (options === void 0) { options = {}; }
            if (menuId === null || menuId === undefined) {
                throw new RequiredError('menuId', 'Required parameter menuId was null or undefined when calling menusSetDisplayOnMenuTax.');
            }
            if (show === null || show === undefined) {
                throw new RequiredError('show', 'Required parameter show was null or undefined when calling menusSetDisplayOnMenuTax.');
            }
            var localVarPath = "/api/v1.0/menus/{menuId}/tax/show/{show}"
                .replace("{".concat("menuId", "}"), encodeURIComponent(String(menuId)))
                .replace("{".concat("show", "}"), encodeURIComponent(String(show)));
            var localVarUrlObj = url.parse(localVarPath, true);
            var localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            var localVarHeaderParameter = {};
            var localVarQueryParameter = {};
            if (configuration && configuration.accessToken) {
                var localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("oauth2", ["api"])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        menusSetItemDisplayOrders: function (menuId, MenuObjectDisplayOrders, options) {
            if (options === void 0) { options = {}; }
            if (menuId === null || menuId === undefined) {
                throw new RequiredError('menuId', 'Required parameter menuId was null or undefined when calling menusSetItemDisplayOrders.');
            }
            if (MenuObjectDisplayOrders === null || MenuObjectDisplayOrders === undefined) {
                throw new RequiredError('MenuObjectDisplayOrders', 'Required parameter MenuObjectDisplayOrders was null or undefined when calling menusSetItemDisplayOrders.');
            }
            var localVarPath = "/api/v1.0/menus/{menuId}/sectiondisplayorders"
                .replace("{".concat("menuId", "}"), encodeURIComponent(String(menuId)));
            var localVarUrlObj = url.parse(localVarPath, true);
            var localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            var localVarHeaderParameter = {};
            var localVarQueryParameter = {};
            if (configuration && configuration.accessToken) {
                var localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("oauth2", ["api"])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }
            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            var needsSerialization = ("MenuObjectDisplayOrders" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body = needsSerialization ? JSON.stringify(MenuObjectDisplayOrders || {}) : (MenuObjectDisplayOrders || "");
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        menusShowHideBulkItems: function (menuId, isAvailable, MenuElementHide, options) {
            if (options === void 0) { options = {}; }
            if (menuId === null || menuId === undefined) {
                throw new RequiredError('menuId', 'Required parameter menuId was null or undefined when calling menusShowHideBulkItems.');
            }
            if (isAvailable === null || isAvailable === undefined) {
                throw new RequiredError('isAvailable', 'Required parameter isAvailable was null or undefined when calling menusShowHideBulkItems.');
            }
            if (MenuElementHide === null || MenuElementHide === undefined) {
                throw new RequiredError('MenuElementHide', 'Required parameter MenuElementHide was null or undefined when calling menusShowHideBulkItems.');
            }
            var localVarPath = "/api/v1.0/menus/{menuId}/bulkshowhide"
                .replace("{".concat("menuId", "}"), encodeURIComponent(String(menuId)));
            var localVarUrlObj = url.parse(localVarPath, true);
            var localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            var localVarHeaderParameter = {};
            var localVarQueryParameter = {};
            if (configuration && configuration.accessToken) {
                var localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("oauth2", ["api"])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }
            if (isAvailable !== undefined) {
                localVarQueryParameter['isAvailable'] = isAvailable;
            }
            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            var needsSerialization = ("Array&lt;MenuElementHide&gt;" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body = needsSerialization ? JSON.stringify(MenuElementHide || {}) : (MenuElementHide || "");
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        menusUpdateTaxType: function (menuId, type, options) {
            if (options === void 0) { options = {}; }
            if (menuId === null || menuId === undefined) {
                throw new RequiredError('menuId', 'Required parameter menuId was null or undefined when calling menusUpdateTaxType.');
            }
            if (type === null || type === undefined) {
                throw new RequiredError('type', 'Required parameter type was null or undefined when calling menusUpdateTaxType.');
            }
            var localVarPath = "/api/v1.0/menus/{menuId}/tax/type/{type}"
                .replace("{".concat("menuId", "}"), encodeURIComponent(String(menuId)))
                .replace("{".concat("type", "}"), encodeURIComponent(String(type)));
            var localVarUrlObj = url.parse(localVarPath, true);
            var localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            var localVarHeaderParameter = {};
            var localVarQueryParameter = {};
            if (configuration && configuration.accessToken) {
                var localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("oauth2", ["api"])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        menusUpsertTaxRate: function (menuId, MenuTaxRate, options) {
            if (options === void 0) { options = {}; }
            if (menuId === null || menuId === undefined) {
                throw new RequiredError('menuId', 'Required parameter menuId was null or undefined when calling menusUpsertTaxRate.');
            }
            if (MenuTaxRate === null || MenuTaxRate === undefined) {
                throw new RequiredError('MenuTaxRate', 'Required parameter MenuTaxRate was null or undefined when calling menusUpsertTaxRate.');
            }
            var localVarPath = "/api/v1.0/menus/{menuId}/taxrate"
                .replace("{".concat("menuId", "}"), encodeURIComponent(String(menuId)));
            var localVarUrlObj = url.parse(localVarPath, true);
            var localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            var localVarHeaderParameter = {};
            var localVarQueryParameter = {};
            if (configuration && configuration.accessToken) {
                var localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("oauth2", ["api"])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }
            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            var needsSerialization = ("MenuTaxRate" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body = needsSerialization ? JSON.stringify(MenuTaxRate || {}) : (MenuTaxRate || "");
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        restoreAMenuCheckpoint: function (menuId, checkpointId, options) {
            if (options === void 0) { options = {}; }
            if (menuId === null || menuId === undefined) {
                throw new RequiredError('menuId', 'Required parameter menuId was null or undefined when calling restoreAMenuCheckpoint.');
            }
            if (checkpointId === null || checkpointId === undefined) {
                throw new RequiredError('checkpointId', 'Required parameter checkpointId was null or undefined when calling restoreAMenuCheckpoint.');
            }
            var localVarPath = "/api/v1.0/menus/{menuId}/checkpoints/{checkpointId}/restore"
                .replace("{".concat("menuId", "}"), encodeURIComponent(String(menuId)))
                .replace("{".concat("checkpointId", "}"), encodeURIComponent(String(checkpointId)));
            var localVarUrlObj = url.parse(localVarPath, true);
            var localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            var localVarHeaderParameter = {};
            var localVarQueryParameter = {};
            if (configuration && configuration.accessToken) {
                var localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("oauth2", ["api"])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        setMenuItemMetadata: function (menuId, storeId, menuItemId, Metadata, options) {
            if (options === void 0) { options = {}; }
            if (menuId === null || menuId === undefined) {
                throw new RequiredError('menuId', 'Required parameter menuId was null or undefined when calling setMenuItemMetadata.');
            }
            if (storeId === null || storeId === undefined) {
                throw new RequiredError('storeId', 'Required parameter storeId was null or undefined when calling setMenuItemMetadata.');
            }
            if (menuItemId === null || menuItemId === undefined) {
                throw new RequiredError('menuItemId', 'Required parameter menuItemId was null or undefined when calling setMenuItemMetadata.');
            }
            if (Metadata === null || Metadata === undefined) {
                throw new RequiredError('Metadata', 'Required parameter Metadata was null or undefined when calling setMenuItemMetadata.');
            }
            var localVarPath = "/api/v1.0/menus/{menuId}/menuitem/{menuItemId}/metadata/store/{storeId}"
                .replace("{".concat("menuId", "}"), encodeURIComponent(String(menuId)))
                .replace("{".concat("storeId", "}"), encodeURIComponent(String(storeId)))
                .replace("{".concat("menuItemId", "}"), encodeURIComponent(String(menuItemId)));
            var localVarUrlObj = url.parse(localVarPath, true);
            var localVarRequestOptions = Object.assign({ method: 'PUT' }, options);
            var localVarHeaderParameter = {};
            var localVarQueryParameter = {};
            if (configuration && configuration.accessToken) {
                var localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("oauth2", ["api"])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }
            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            var needsSerialization = ("Metadata" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body = needsSerialization ? JSON.stringify(Metadata || {}) : (Metadata || "");
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        setMenuItemOptionSetItemMetadata: function (menuId, storeId, optionSetItemId, Metadata, options) {
            if (options === void 0) { options = {}; }
            if (menuId === null || menuId === undefined) {
                throw new RequiredError('menuId', 'Required parameter menuId was null or undefined when calling setMenuItemOptionSetItemMetadata.');
            }
            if (storeId === null || storeId === undefined) {
                throw new RequiredError('storeId', 'Required parameter storeId was null or undefined when calling setMenuItemOptionSetItemMetadata.');
            }
            if (optionSetItemId === null || optionSetItemId === undefined) {
                throw new RequiredError('optionSetItemId', 'Required parameter optionSetItemId was null or undefined when calling setMenuItemOptionSetItemMetadata.');
            }
            if (Metadata === null || Metadata === undefined) {
                throw new RequiredError('Metadata', 'Required parameter Metadata was null or undefined when calling setMenuItemOptionSetItemMetadata.');
            }
            var localVarPath = "/api/v1.0/menus/{menuId}/optionsetitem/{optionSetItemId}/metadata/store/{storeId}"
                .replace("{".concat("menuId", "}"), encodeURIComponent(String(menuId)))
                .replace("{".concat("storeId", "}"), encodeURIComponent(String(storeId)))
                .replace("{".concat("optionSetItemId", "}"), encodeURIComponent(String(optionSetItemId)));
            var localVarUrlObj = url.parse(localVarPath, true);
            var localVarRequestOptions = Object.assign({ method: 'PUT' }, options);
            var localVarHeaderParameter = {};
            var localVarQueryParameter = {};
            if (configuration && configuration.accessToken) {
                var localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("oauth2", ["api"])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }
            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            var needsSerialization = ("Metadata" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body = needsSerialization ? JSON.stringify(Metadata || {}) : (Metadata || "");
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        setMenuLock: function (menuId, body, options) {
            if (options === void 0) { options = {}; }
            if (menuId === null || menuId === undefined) {
                throw new RequiredError('menuId', 'Required parameter menuId was null or undefined when calling setMenuLock.');
            }
            if (body === null || body === undefined) {
                throw new RequiredError('body', 'Required parameter body was null or undefined when calling setMenuLock.');
            }
            var localVarPath = "/api/v1.0/menus/{menuId}/lock"
                .replace("{".concat("menuId", "}"), encodeURIComponent(String(menuId)));
            var localVarUrlObj = url.parse(localVarPath, true);
            var localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            var localVarHeaderParameter = {};
            var localVarQueryParameter = {};
            if (configuration && configuration.accessToken) {
                var localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("oauth2", ["api"])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }
            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            var needsSerialization = ("boolean" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body = needsSerialization ? JSON.stringify(body || {}) : (body || "");
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        setMenuName: function (menuId, body, options) {
            if (options === void 0) { options = {}; }
            if (menuId === null || menuId === undefined) {
                throw new RequiredError('menuId', 'Required parameter menuId was null or undefined when calling setMenuName.');
            }
            if (body === null || body === undefined) {
                throw new RequiredError('body', 'Required parameter body was null or undefined when calling setMenuName.');
            }
            var localVarPath = "/api/v1.0/menus/{menuId}/name"
                .replace("{".concat("menuId", "}"), encodeURIComponent(String(menuId)));
            var localVarUrlObj = url.parse(localVarPath, true);
            var localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            var localVarHeaderParameter = {};
            var localVarQueryParameter = {};
            if (configuration && configuration.accessToken) {
                var localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("oauth2", ["api"])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }
            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            var needsSerialization = ("string" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body = needsSerialization ? JSON.stringify(body || {}) : (body || "");
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        updateMenu: function (menuId, MenuBase, options) {
            if (options === void 0) { options = {}; }
            if (menuId === null || menuId === undefined) {
                throw new RequiredError('menuId', 'Required parameter menuId was null or undefined when calling updateMenu.');
            }
            if (MenuBase === null || MenuBase === undefined) {
                throw new RequiredError('MenuBase', 'Required parameter MenuBase was null or undefined when calling updateMenu.');
            }
            var localVarPath = "/api/v1.0/menus/{menuId}"
                .replace("{".concat("menuId", "}"), encodeURIComponent(String(menuId)));
            var localVarUrlObj = url.parse(localVarPath, true);
            var localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            var localVarHeaderParameter = {};
            var localVarQueryParameter = {};
            if (configuration && configuration.accessToken) {
                var localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("oauth2", ["api"])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }
            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            var needsSerialization = ("MenuBase" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body = needsSerialization ? JSON.stringify(MenuBase || {}) : (MenuBase || "");
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        uploadMenuImage: function (menuId, Image, options) {
            if (options === void 0) { options = {}; }
            if (menuId === null || menuId === undefined) {
                throw new RequiredError('menuId', 'Required parameter menuId was null or undefined when calling uploadMenuImage.');
            }
            if (Image === null || Image === undefined) {
                throw new RequiredError('Image', 'Required parameter Image was null or undefined when calling uploadMenuImage.');
            }
            var localVarPath = "/api/v1.0/menus/{menuId}/image"
                .replace("{".concat("menuId", "}"), encodeURIComponent(String(menuId)));
            var localVarUrlObj = url.parse(localVarPath, true);
            var localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            var localVarHeaderParameter = {};
            var localVarQueryParameter = {};
            var localVarFormParams = new url.URLSearchParams();
            if (configuration && configuration.accessToken) {
                var localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("oauth2", ["api"])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }
            if (Image !== undefined) {
                localVarFormParams.set('Image', Image);
            }
            localVarHeaderParameter['Content-Type'] = 'application/x-www-form-urlencoded';
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            localVarRequestOptions.body = localVarFormParams.toString();
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        uploadNewMenuForApp: function (appId, Menu, options) {
            if (options === void 0) { options = {}; }
            if (appId === null || appId === undefined) {
                throw new RequiredError('appId', 'Required parameter appId was null or undefined when calling uploadNewMenuForApp.');
            }
            if (Menu === null || Menu === undefined) {
                throw new RequiredError('Menu', 'Required parameter Menu was null or undefined when calling uploadNewMenuForApp.');
            }
            var localVarPath = "/api/v1.0/{appId}/menus/xlsx"
                .replace("{".concat("appId", "}"), encodeURIComponent(String(appId)));
            var localVarUrlObj = url.parse(localVarPath, true);
            var localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            var localVarHeaderParameter = {};
            var localVarQueryParameter = {};
            var localVarFormParams = new url.URLSearchParams();
            if (configuration && configuration.accessToken) {
                var localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("oauth2", ["api"])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }
            if (Menu !== undefined) {
                localVarFormParams.set('Menu', Menu);
            }
            localVarHeaderParameter['Content-Type'] = 'application/x-www-form-urlencoded';
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            localVarRequestOptions.body = localVarFormParams.toString();
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    };
};
exports.MenusApiFetchParamCreator = MenusApiFetchParamCreator;
var MenusApiFp = function (configuration) {
    return {
        createDraftMenuFromExistingMenu: function (menuId, newName, options) {
            var localVarFetchArgs = (0, exports.MenusApiFetchParamCreator)(configuration).createDraftMenuFromExistingMenu(menuId, newName, options);
            return function (fetch, basePath) {
                if (fetch === void 0) { fetch = portableFetch; }
                if (basePath === void 0) { basePath = BASE_PATH; }
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then(function (response) {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
        createNewMenuAsync: function (appId, CreateFullMenu, orgId, options) {
            var localVarFetchArgs = (0, exports.MenusApiFetchParamCreator)(configuration).createNewMenuAsync(appId, CreateFullMenu, orgId, options);
            return function (fetch, basePath) {
                if (fetch === void 0) { fetch = portableFetch; }
                if (basePath === void 0) { basePath = BASE_PATH; }
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then(function (response) {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
        createNewMenuForApp: function (appId, CreateFullMenu, options) {
            var localVarFetchArgs = (0, exports.MenusApiFetchParamCreator)(configuration).createNewMenuForApp(appId, CreateFullMenu, options);
            return function (fetch, basePath) {
                if (fetch === void 0) { fetch = portableFetch; }
                if (basePath === void 0) { basePath = BASE_PATH; }
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then(function (response) {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
        deleteMenu: function (menuId, options) {
            var localVarFetchArgs = (0, exports.MenusApiFetchParamCreator)(configuration).deleteMenu(menuId, options);
            return function (fetch, basePath) {
                if (fetch === void 0) { fetch = portableFetch; }
                if (basePath === void 0) { basePath = BASE_PATH; }
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then(function (response) {
                    if (response.status >= 200 && response.status < 300) {
                        return response;
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
        deleteMenuImage: function (menuId, options) {
            var localVarFetchArgs = (0, exports.MenusApiFetchParamCreator)(configuration).deleteMenuImage(menuId, options);
            return function (fetch, basePath) {
                if (fetch === void 0) { fetch = portableFetch; }
                if (basePath === void 0) { basePath = BASE_PATH; }
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then(function (response) {
                    if (response.status >= 200 && response.status < 300) {
                        return response;
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
        deleteMenuItemMetadata: function (menuId, storeId, menuItemId, key, options) {
            var localVarFetchArgs = (0, exports.MenusApiFetchParamCreator)(configuration).deleteMenuItemMetadata(menuId, storeId, menuItemId, key, options);
            return function (fetch, basePath) {
                if (fetch === void 0) { fetch = portableFetch; }
                if (basePath === void 0) { basePath = BASE_PATH; }
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then(function (response) {
                    if (response.status >= 200 && response.status < 300) {
                        return response;
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
        getAllMenuMetadataByMenuIdAndStoreId: function (menuId, storeId, options) {
            var localVarFetchArgs = (0, exports.MenusApiFetchParamCreator)(configuration).getAllMenuMetadataByMenuIdAndStoreId(menuId, storeId, options);
            return function (fetch, basePath) {
                if (fetch === void 0) { fetch = portableFetch; }
                if (basePath === void 0) { basePath = BASE_PATH; }
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then(function (response) {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
        getMenuById: function (menuId, options) {
            var localVarFetchArgs = (0, exports.MenusApiFetchParamCreator)(configuration).getMenuById(menuId, options);
            return function (fetch, basePath) {
                if (fetch === void 0) { fetch = portableFetch; }
                if (basePath === void 0) { basePath = BASE_PATH; }
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then(function (response) {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
        getMenuItemMetadata: function (menuId, storeId, menuItemId, options) {
            var localVarFetchArgs = (0, exports.MenusApiFetchParamCreator)(configuration).getMenuItemMetadata(menuId, storeId, menuItemId, options);
            return function (fetch, basePath) {
                if (fetch === void 0) { fetch = portableFetch; }
                if (basePath === void 0) { basePath = BASE_PATH; }
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then(function (response) {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
        getMenuItemMetadataByKey: function (menuId, storeId, menuItemId, key, options) {
            var localVarFetchArgs = (0, exports.MenusApiFetchParamCreator)(configuration).getMenuItemMetadataByKey(menuId, storeId, menuItemId, key, options);
            return function (fetch, basePath) {
                if (fetch === void 0) { fetch = portableFetch; }
                if (basePath === void 0) { basePath = BASE_PATH; }
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then(function (response) {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
        getMenuItemOptionSetItemMetadata: function (menuId, storeId, optionSetItemId, options) {
            var localVarFetchArgs = (0, exports.MenusApiFetchParamCreator)(configuration).getMenuItemOptionSetItemMetadata(menuId, storeId, optionSetItemId, options);
            return function (fetch, basePath) {
                if (fetch === void 0) { fetch = portableFetch; }
                if (basePath === void 0) { basePath = BASE_PATH; }
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then(function (response) {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
        getMenuName: function (menuId, options) {
            var localVarFetchArgs = (0, exports.MenusApiFetchParamCreator)(configuration).getMenuName(menuId, options);
            return function (fetch, basePath) {
                if (fetch === void 0) { fetch = portableFetch; }
                if (basePath === void 0) { basePath = BASE_PATH; }
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then(function (response) {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
        getMenuStoreNames: function (menuId, options) {
            var localVarFetchArgs = (0, exports.MenusApiFetchParamCreator)(configuration).getMenuStoreNames(menuId, options);
            return function (fetch, basePath) {
                if (fetch === void 0) { fetch = portableFetch; }
                if (basePath === void 0) { basePath = BASE_PATH; }
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then(function (response) {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
        getMenuTaxDetails: function (menuId, options) {
            var localVarFetchArgs = (0, exports.MenusApiFetchParamCreator)(configuration).getMenuTaxDetails(menuId, options);
            return function (fetch, basePath) {
                if (fetch === void 0) { fetch = portableFetch; }
                if (basePath === void 0) { basePath = BASE_PATH; }
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then(function (response) {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
        getMenusByAppId: function (appId, options) {
            var localVarFetchArgs = (0, exports.MenusApiFetchParamCreator)(configuration).getMenusByAppId(appId, options);
            return function (fetch, basePath) {
                if (fetch === void 0) { fetch = portableFetch; }
                if (basePath === void 0) { basePath = BASE_PATH; }
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then(function (response) {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
        getMenusCheckpoints: function (menuId, options) {
            var localVarFetchArgs = (0, exports.MenusApiFetchParamCreator)(configuration).getMenusCheckpoints(menuId, options);
            return function (fetch, basePath) {
                if (fetch === void 0) { fetch = portableFetch; }
                if (basePath === void 0) { basePath = BASE_PATH; }
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then(function (response) {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
        menusDeleteTaxRate: function (menuId, taxId, options) {
            var localVarFetchArgs = (0, exports.MenusApiFetchParamCreator)(configuration).menusDeleteTaxRate(menuId, taxId, options);
            return function (fetch, basePath) {
                if (fetch === void 0) { fetch = portableFetch; }
                if (basePath === void 0) { basePath = BASE_PATH; }
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then(function (response) {
                    if (response.status >= 200 && response.status < 300) {
                        return response;
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
        menusGetMenuBulkShowHide: function (menuId, isAvailable, options) {
            var localVarFetchArgs = (0, exports.MenusApiFetchParamCreator)(configuration).menusGetMenuBulkShowHide(menuId, isAvailable, options);
            return function (fetch, basePath) {
                if (fetch === void 0) { fetch = portableFetch; }
                if (basePath === void 0) { basePath = BASE_PATH; }
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then(function (response) {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
        menusSetDisplayOnMenuTax: function (menuId, show, options) {
            var localVarFetchArgs = (0, exports.MenusApiFetchParamCreator)(configuration).menusSetDisplayOnMenuTax(menuId, show, options);
            return function (fetch, basePath) {
                if (fetch === void 0) { fetch = portableFetch; }
                if (basePath === void 0) { basePath = BASE_PATH; }
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then(function (response) {
                    if (response.status >= 200 && response.status < 300) {
                        return response;
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
        menusSetItemDisplayOrders: function (menuId, MenuObjectDisplayOrders, options) {
            var localVarFetchArgs = (0, exports.MenusApiFetchParamCreator)(configuration).menusSetItemDisplayOrders(menuId, MenuObjectDisplayOrders, options);
            return function (fetch, basePath) {
                if (fetch === void 0) { fetch = portableFetch; }
                if (basePath === void 0) { basePath = BASE_PATH; }
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then(function (response) {
                    if (response.status >= 200 && response.status < 300) {
                        return response;
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
        menusShowHideBulkItems: function (menuId, isAvailable, MenuElementHide, options) {
            var localVarFetchArgs = (0, exports.MenusApiFetchParamCreator)(configuration).menusShowHideBulkItems(menuId, isAvailable, MenuElementHide, options);
            return function (fetch, basePath) {
                if (fetch === void 0) { fetch = portableFetch; }
                if (basePath === void 0) { basePath = BASE_PATH; }
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then(function (response) {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
        menusUpdateTaxType: function (menuId, type, options) {
            var localVarFetchArgs = (0, exports.MenusApiFetchParamCreator)(configuration).menusUpdateTaxType(menuId, type, options);
            return function (fetch, basePath) {
                if (fetch === void 0) { fetch = portableFetch; }
                if (basePath === void 0) { basePath = BASE_PATH; }
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then(function (response) {
                    if (response.status >= 200 && response.status < 300) {
                        return response;
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
        menusUpsertTaxRate: function (menuId, MenuTaxRate, options) {
            var localVarFetchArgs = (0, exports.MenusApiFetchParamCreator)(configuration).menusUpsertTaxRate(menuId, MenuTaxRate, options);
            return function (fetch, basePath) {
                if (fetch === void 0) { fetch = portableFetch; }
                if (basePath === void 0) { basePath = BASE_PATH; }
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then(function (response) {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
        restoreAMenuCheckpoint: function (menuId, checkpointId, options) {
            var localVarFetchArgs = (0, exports.MenusApiFetchParamCreator)(configuration).restoreAMenuCheckpoint(menuId, checkpointId, options);
            return function (fetch, basePath) {
                if (fetch === void 0) { fetch = portableFetch; }
                if (basePath === void 0) { basePath = BASE_PATH; }
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then(function (response) {
                    if (response.status >= 200 && response.status < 300) {
                        return response;
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
        setMenuItemMetadata: function (menuId, storeId, menuItemId, Metadata, options) {
            var localVarFetchArgs = (0, exports.MenusApiFetchParamCreator)(configuration).setMenuItemMetadata(menuId, storeId, menuItemId, Metadata, options);
            return function (fetch, basePath) {
                if (fetch === void 0) { fetch = portableFetch; }
                if (basePath === void 0) { basePath = BASE_PATH; }
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then(function (response) {
                    if (response.status >= 200 && response.status < 300) {
                        return response;
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
        setMenuItemOptionSetItemMetadata: function (menuId, storeId, optionSetItemId, Metadata, options) {
            var localVarFetchArgs = (0, exports.MenusApiFetchParamCreator)(configuration).setMenuItemOptionSetItemMetadata(menuId, storeId, optionSetItemId, Metadata, options);
            return function (fetch, basePath) {
                if (fetch === void 0) { fetch = portableFetch; }
                if (basePath === void 0) { basePath = BASE_PATH; }
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then(function (response) {
                    if (response.status >= 200 && response.status < 300) {
                        return response;
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
        setMenuLock: function (menuId, body, options) {
            var localVarFetchArgs = (0, exports.MenusApiFetchParamCreator)(configuration).setMenuLock(menuId, body, options);
            return function (fetch, basePath) {
                if (fetch === void 0) { fetch = portableFetch; }
                if (basePath === void 0) { basePath = BASE_PATH; }
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then(function (response) {
                    if (response.status >= 200 && response.status < 300) {
                        return response;
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
        setMenuName: function (menuId, body, options) {
            var localVarFetchArgs = (0, exports.MenusApiFetchParamCreator)(configuration).setMenuName(menuId, body, options);
            return function (fetch, basePath) {
                if (fetch === void 0) { fetch = portableFetch; }
                if (basePath === void 0) { basePath = BASE_PATH; }
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then(function (response) {
                    if (response.status >= 200 && response.status < 300) {
                        return response;
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
        updateMenu: function (menuId, MenuBase, options) {
            var localVarFetchArgs = (0, exports.MenusApiFetchParamCreator)(configuration).updateMenu(menuId, MenuBase, options);
            return function (fetch, basePath) {
                if (fetch === void 0) { fetch = portableFetch; }
                if (basePath === void 0) { basePath = BASE_PATH; }
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then(function (response) {
                    if (response.status >= 200 && response.status < 300) {
                        return response;
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
        uploadMenuImage: function (menuId, Image, options) {
            var localVarFetchArgs = (0, exports.MenusApiFetchParamCreator)(configuration).uploadMenuImage(menuId, Image, options);
            return function (fetch, basePath) {
                if (fetch === void 0) { fetch = portableFetch; }
                if (basePath === void 0) { basePath = BASE_PATH; }
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then(function (response) {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
        uploadNewMenuForApp: function (appId, Menu, options) {
            var localVarFetchArgs = (0, exports.MenusApiFetchParamCreator)(configuration).uploadNewMenuForApp(appId, Menu, options);
            return function (fetch, basePath) {
                if (fetch === void 0) { fetch = portableFetch; }
                if (basePath === void 0) { basePath = BASE_PATH; }
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then(function (response) {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
    };
};
exports.MenusApiFp = MenusApiFp;
var MenusApiFactory = function (configuration, fetch, basePath) {
    return {
        createDraftMenuFromExistingMenu: function (menuId, newName, options) {
            return (0, exports.MenusApiFp)(configuration).createDraftMenuFromExistingMenu(menuId, newName, options)(fetch, basePath);
        },
        createNewMenuAsync: function (appId, CreateFullMenu, orgId, options) {
            return (0, exports.MenusApiFp)(configuration).createNewMenuAsync(appId, CreateFullMenu, orgId, options)(fetch, basePath);
        },
        createNewMenuForApp: function (appId, CreateFullMenu, options) {
            return (0, exports.MenusApiFp)(configuration).createNewMenuForApp(appId, CreateFullMenu, options)(fetch, basePath);
        },
        deleteMenu: function (menuId, options) {
            return (0, exports.MenusApiFp)(configuration).deleteMenu(menuId, options)(fetch, basePath);
        },
        deleteMenuImage: function (menuId, options) {
            return (0, exports.MenusApiFp)(configuration).deleteMenuImage(menuId, options)(fetch, basePath);
        },
        deleteMenuItemMetadata: function (menuId, storeId, menuItemId, key, options) {
            return (0, exports.MenusApiFp)(configuration).deleteMenuItemMetadata(menuId, storeId, menuItemId, key, options)(fetch, basePath);
        },
        getAllMenuMetadataByMenuIdAndStoreId: function (menuId, storeId, options) {
            return (0, exports.MenusApiFp)(configuration).getAllMenuMetadataByMenuIdAndStoreId(menuId, storeId, options)(fetch, basePath);
        },
        getMenuById: function (menuId, options) {
            return (0, exports.MenusApiFp)(configuration).getMenuById(menuId, options)(fetch, basePath);
        },
        getMenuItemMetadata: function (menuId, storeId, menuItemId, options) {
            return (0, exports.MenusApiFp)(configuration).getMenuItemMetadata(menuId, storeId, menuItemId, options)(fetch, basePath);
        },
        getMenuItemMetadataByKey: function (menuId, storeId, menuItemId, key, options) {
            return (0, exports.MenusApiFp)(configuration).getMenuItemMetadataByKey(menuId, storeId, menuItemId, key, options)(fetch, basePath);
        },
        getMenuItemOptionSetItemMetadata: function (menuId, storeId, optionSetItemId, options) {
            return (0, exports.MenusApiFp)(configuration).getMenuItemOptionSetItemMetadata(menuId, storeId, optionSetItemId, options)(fetch, basePath);
        },
        getMenuName: function (menuId, options) {
            return (0, exports.MenusApiFp)(configuration).getMenuName(menuId, options)(fetch, basePath);
        },
        getMenuStoreNames: function (menuId, options) {
            return (0, exports.MenusApiFp)(configuration).getMenuStoreNames(menuId, options)(fetch, basePath);
        },
        getMenuTaxDetails: function (menuId, options) {
            return (0, exports.MenusApiFp)(configuration).getMenuTaxDetails(menuId, options)(fetch, basePath);
        },
        getMenusByAppId: function (appId, options) {
            return (0, exports.MenusApiFp)(configuration).getMenusByAppId(appId, options)(fetch, basePath);
        },
        getMenusCheckpoints: function (menuId, options) {
            return (0, exports.MenusApiFp)(configuration).getMenusCheckpoints(menuId, options)(fetch, basePath);
        },
        menusDeleteTaxRate: function (menuId, taxId, options) {
            return (0, exports.MenusApiFp)(configuration).menusDeleteTaxRate(menuId, taxId, options)(fetch, basePath);
        },
        menusGetMenuBulkShowHide: function (menuId, isAvailable, options) {
            return (0, exports.MenusApiFp)(configuration).menusGetMenuBulkShowHide(menuId, isAvailable, options)(fetch, basePath);
        },
        menusSetDisplayOnMenuTax: function (menuId, show, options) {
            return (0, exports.MenusApiFp)(configuration).menusSetDisplayOnMenuTax(menuId, show, options)(fetch, basePath);
        },
        menusSetItemDisplayOrders: function (menuId, MenuObjectDisplayOrders, options) {
            return (0, exports.MenusApiFp)(configuration).menusSetItemDisplayOrders(menuId, MenuObjectDisplayOrders, options)(fetch, basePath);
        },
        menusShowHideBulkItems: function (menuId, isAvailable, MenuElementHide, options) {
            return (0, exports.MenusApiFp)(configuration).menusShowHideBulkItems(menuId, isAvailable, MenuElementHide, options)(fetch, basePath);
        },
        menusUpdateTaxType: function (menuId, type, options) {
            return (0, exports.MenusApiFp)(configuration).menusUpdateTaxType(menuId, type, options)(fetch, basePath);
        },
        menusUpsertTaxRate: function (menuId, MenuTaxRate, options) {
            return (0, exports.MenusApiFp)(configuration).menusUpsertTaxRate(menuId, MenuTaxRate, options)(fetch, basePath);
        },
        restoreAMenuCheckpoint: function (menuId, checkpointId, options) {
            return (0, exports.MenusApiFp)(configuration).restoreAMenuCheckpoint(menuId, checkpointId, options)(fetch, basePath);
        },
        setMenuItemMetadata: function (menuId, storeId, menuItemId, Metadata, options) {
            return (0, exports.MenusApiFp)(configuration).setMenuItemMetadata(menuId, storeId, menuItemId, Metadata, options)(fetch, basePath);
        },
        setMenuItemOptionSetItemMetadata: function (menuId, storeId, optionSetItemId, Metadata, options) {
            return (0, exports.MenusApiFp)(configuration).setMenuItemOptionSetItemMetadata(menuId, storeId, optionSetItemId, Metadata, options)(fetch, basePath);
        },
        setMenuLock: function (menuId, body, options) {
            return (0, exports.MenusApiFp)(configuration).setMenuLock(menuId, body, options)(fetch, basePath);
        },
        setMenuName: function (menuId, body, options) {
            return (0, exports.MenusApiFp)(configuration).setMenuName(menuId, body, options)(fetch, basePath);
        },
        updateMenu: function (menuId, MenuBase, options) {
            return (0, exports.MenusApiFp)(configuration).updateMenu(menuId, MenuBase, options)(fetch, basePath);
        },
        uploadMenuImage: function (menuId, Image, options) {
            return (0, exports.MenusApiFp)(configuration).uploadMenuImage(menuId, Image, options)(fetch, basePath);
        },
        uploadNewMenuForApp: function (appId, Menu, options) {
            return (0, exports.MenusApiFp)(configuration).uploadNewMenuForApp(appId, Menu, options)(fetch, basePath);
        },
    };
};
exports.MenusApiFactory = MenusApiFactory;
var MenusApi = (function (_super) {
    __extends(MenusApi, _super);
    function MenusApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    MenusApi.prototype.createDraftMenuFromExistingMenu = function (menuId, newName, options) {
        return (0, exports.MenusApiFp)(this.configuration).createDraftMenuFromExistingMenu(menuId, newName, options)(this.fetch, this.basePath);
    };
    MenusApi.prototype.createNewMenuAsync = function (appId, CreateFullMenu, orgId, options) {
        return (0, exports.MenusApiFp)(this.configuration).createNewMenuAsync(appId, CreateFullMenu, orgId, options)(this.fetch, this.basePath);
    };
    MenusApi.prototype.createNewMenuForApp = function (appId, CreateFullMenu, options) {
        return (0, exports.MenusApiFp)(this.configuration).createNewMenuForApp(appId, CreateFullMenu, options)(this.fetch, this.basePath);
    };
    MenusApi.prototype.deleteMenu = function (menuId, options) {
        return (0, exports.MenusApiFp)(this.configuration).deleteMenu(menuId, options)(this.fetch, this.basePath);
    };
    MenusApi.prototype.deleteMenuImage = function (menuId, options) {
        return (0, exports.MenusApiFp)(this.configuration).deleteMenuImage(menuId, options)(this.fetch, this.basePath);
    };
    MenusApi.prototype.deleteMenuItemMetadata = function (menuId, storeId, menuItemId, key, options) {
        return (0, exports.MenusApiFp)(this.configuration).deleteMenuItemMetadata(menuId, storeId, menuItemId, key, options)(this.fetch, this.basePath);
    };
    MenusApi.prototype.getAllMenuMetadataByMenuIdAndStoreId = function (menuId, storeId, options) {
        return (0, exports.MenusApiFp)(this.configuration).getAllMenuMetadataByMenuIdAndStoreId(menuId, storeId, options)(this.fetch, this.basePath);
    };
    MenusApi.prototype.getMenuById = function (menuId, options) {
        return (0, exports.MenusApiFp)(this.configuration).getMenuById(menuId, options)(this.fetch, this.basePath);
    };
    MenusApi.prototype.getMenuItemMetadata = function (menuId, storeId, menuItemId, options) {
        return (0, exports.MenusApiFp)(this.configuration).getMenuItemMetadata(menuId, storeId, menuItemId, options)(this.fetch, this.basePath);
    };
    MenusApi.prototype.getMenuItemMetadataByKey = function (menuId, storeId, menuItemId, key, options) {
        return (0, exports.MenusApiFp)(this.configuration).getMenuItemMetadataByKey(menuId, storeId, menuItemId, key, options)(this.fetch, this.basePath);
    };
    MenusApi.prototype.getMenuItemOptionSetItemMetadata = function (menuId, storeId, optionSetItemId, options) {
        return (0, exports.MenusApiFp)(this.configuration).getMenuItemOptionSetItemMetadata(menuId, storeId, optionSetItemId, options)(this.fetch, this.basePath);
    };
    MenusApi.prototype.getMenuName = function (menuId, options) {
        return (0, exports.MenusApiFp)(this.configuration).getMenuName(menuId, options)(this.fetch, this.basePath);
    };
    MenusApi.prototype.getMenuStoreNames = function (menuId, options) {
        return (0, exports.MenusApiFp)(this.configuration).getMenuStoreNames(menuId, options)(this.fetch, this.basePath);
    };
    MenusApi.prototype.getMenuTaxDetails = function (menuId, options) {
        return (0, exports.MenusApiFp)(this.configuration).getMenuTaxDetails(menuId, options)(this.fetch, this.basePath);
    };
    MenusApi.prototype.getMenusByAppId = function (appId, options) {
        return (0, exports.MenusApiFp)(this.configuration).getMenusByAppId(appId, options)(this.fetch, this.basePath);
    };
    MenusApi.prototype.getMenusCheckpoints = function (menuId, options) {
        return (0, exports.MenusApiFp)(this.configuration).getMenusCheckpoints(menuId, options)(this.fetch, this.basePath);
    };
    MenusApi.prototype.menusDeleteTaxRate = function (menuId, taxId, options) {
        return (0, exports.MenusApiFp)(this.configuration).menusDeleteTaxRate(menuId, taxId, options)(this.fetch, this.basePath);
    };
    MenusApi.prototype.menusGetMenuBulkShowHide = function (menuId, isAvailable, options) {
        return (0, exports.MenusApiFp)(this.configuration).menusGetMenuBulkShowHide(menuId, isAvailable, options)(this.fetch, this.basePath);
    };
    MenusApi.prototype.menusSetDisplayOnMenuTax = function (menuId, show, options) {
        return (0, exports.MenusApiFp)(this.configuration).menusSetDisplayOnMenuTax(menuId, show, options)(this.fetch, this.basePath);
    };
    MenusApi.prototype.menusSetItemDisplayOrders = function (menuId, MenuObjectDisplayOrders, options) {
        return (0, exports.MenusApiFp)(this.configuration).menusSetItemDisplayOrders(menuId, MenuObjectDisplayOrders, options)(this.fetch, this.basePath);
    };
    MenusApi.prototype.menusShowHideBulkItems = function (menuId, isAvailable, MenuElementHide, options) {
        return (0, exports.MenusApiFp)(this.configuration).menusShowHideBulkItems(menuId, isAvailable, MenuElementHide, options)(this.fetch, this.basePath);
    };
    MenusApi.prototype.menusUpdateTaxType = function (menuId, type, options) {
        return (0, exports.MenusApiFp)(this.configuration).menusUpdateTaxType(menuId, type, options)(this.fetch, this.basePath);
    };
    MenusApi.prototype.menusUpsertTaxRate = function (menuId, MenuTaxRate, options) {
        return (0, exports.MenusApiFp)(this.configuration).menusUpsertTaxRate(menuId, MenuTaxRate, options)(this.fetch, this.basePath);
    };
    MenusApi.prototype.restoreAMenuCheckpoint = function (menuId, checkpointId, options) {
        return (0, exports.MenusApiFp)(this.configuration).restoreAMenuCheckpoint(menuId, checkpointId, options)(this.fetch, this.basePath);
    };
    MenusApi.prototype.setMenuItemMetadata = function (menuId, storeId, menuItemId, Metadata, options) {
        return (0, exports.MenusApiFp)(this.configuration).setMenuItemMetadata(menuId, storeId, menuItemId, Metadata, options)(this.fetch, this.basePath);
    };
    MenusApi.prototype.setMenuItemOptionSetItemMetadata = function (menuId, storeId, optionSetItemId, Metadata, options) {
        return (0, exports.MenusApiFp)(this.configuration).setMenuItemOptionSetItemMetadata(menuId, storeId, optionSetItemId, Metadata, options)(this.fetch, this.basePath);
    };
    MenusApi.prototype.setMenuLock = function (menuId, body, options) {
        return (0, exports.MenusApiFp)(this.configuration).setMenuLock(menuId, body, options)(this.fetch, this.basePath);
    };
    MenusApi.prototype.setMenuName = function (menuId, body, options) {
        return (0, exports.MenusApiFp)(this.configuration).setMenuName(menuId, body, options)(this.fetch, this.basePath);
    };
    MenusApi.prototype.updateMenu = function (menuId, MenuBase, options) {
        return (0, exports.MenusApiFp)(this.configuration).updateMenu(menuId, MenuBase, options)(this.fetch, this.basePath);
    };
    MenusApi.prototype.uploadMenuImage = function (menuId, Image, options) {
        return (0, exports.MenusApiFp)(this.configuration).uploadMenuImage(menuId, Image, options)(this.fetch, this.basePath);
    };
    MenusApi.prototype.uploadNewMenuForApp = function (appId, Menu, options) {
        return (0, exports.MenusApiFp)(this.configuration).uploadNewMenuForApp(appId, Menu, options)(this.fetch, this.basePath);
    };
    return MenusApi;
}(BaseAPI));
exports.MenusApi = MenusApi;
var MenusNutritionInfoApiFetchParamCreator = function (configuration) {
    return {
        addOrUpdateMenuItemNutritionInfo: function (menuId, publicId, ItemNutritionInfoAddUpdateModel, options) {
            if (options === void 0) { options = {}; }
            if (menuId === null || menuId === undefined) {
                throw new RequiredError('menuId', 'Required parameter menuId was null or undefined when calling addOrUpdateMenuItemNutritionInfo.');
            }
            if (publicId === null || publicId === undefined) {
                throw new RequiredError('publicId', 'Required parameter publicId was null or undefined when calling addOrUpdateMenuItemNutritionInfo.');
            }
            if (ItemNutritionInfoAddUpdateModel === null || ItemNutritionInfoAddUpdateModel === undefined) {
                throw new RequiredError('ItemNutritionInfoAddUpdateModel', 'Required parameter ItemNutritionInfoAddUpdateModel was null or undefined when calling addOrUpdateMenuItemNutritionInfo.');
            }
            var localVarPath = "/api/v1.0/menus/{menuId}/menuItem/{publicId}/nutrition"
                .replace("{".concat("menuId", "}"), encodeURIComponent(String(menuId)))
                .replace("{".concat("publicId", "}"), encodeURIComponent(String(publicId)));
            var localVarUrlObj = url.parse(localVarPath, true);
            var localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            var localVarHeaderParameter = {};
            var localVarQueryParameter = {};
            if (configuration && configuration.accessToken) {
                var localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("oauth2", ["api"])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }
            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            var needsSerialization = ("ItemNutritionInfoAddUpdateModel" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body = needsSerialization ? JSON.stringify(ItemNutritionInfoAddUpdateModel || {}) : (ItemNutritionInfoAddUpdateModel || "");
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        addOrUpdateMenuItemOptionSetItemNutritionInfo: function (menuId, publicId, ItemNutritionInfoAddUpdateModel, options) {
            if (options === void 0) { options = {}; }
            if (menuId === null || menuId === undefined) {
                throw new RequiredError('menuId', 'Required parameter menuId was null or undefined when calling addOrUpdateMenuItemOptionSetItemNutritionInfo.');
            }
            if (publicId === null || publicId === undefined) {
                throw new RequiredError('publicId', 'Required parameter publicId was null or undefined when calling addOrUpdateMenuItemOptionSetItemNutritionInfo.');
            }
            if (ItemNutritionInfoAddUpdateModel === null || ItemNutritionInfoAddUpdateModel === undefined) {
                throw new RequiredError('ItemNutritionInfoAddUpdateModel', 'Required parameter ItemNutritionInfoAddUpdateModel was null or undefined when calling addOrUpdateMenuItemOptionSetItemNutritionInfo.');
            }
            var localVarPath = "/api/v1.0/menus/{menuId}/menuItemOption/{publicId}/nutrition"
                .replace("{".concat("menuId", "}"), encodeURIComponent(String(menuId)))
                .replace("{".concat("publicId", "}"), encodeURIComponent(String(publicId)));
            var localVarUrlObj = url.parse(localVarPath, true);
            var localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            var localVarHeaderParameter = {};
            var localVarQueryParameter = {};
            if (configuration && configuration.accessToken) {
                var localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("oauth2", ["api"])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }
            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            var needsSerialization = ("ItemNutritionInfoAddUpdateModel" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body = needsSerialization ? JSON.stringify(ItemNutritionInfoAddUpdateModel || {}) : (ItemNutritionInfoAddUpdateModel || "");
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        addOrUpdateMenuNutritionInfoByMenuId: function (menuId, options) {
            if (options === void 0) { options = {}; }
            if (menuId === null || menuId === undefined) {
                throw new RequiredError('menuId', 'Required parameter menuId was null or undefined when calling addOrUpdateMenuNutritionInfoByMenuId.');
            }
            var localVarPath = "/api/v1.0/menus/{menuId}/nutrition"
                .replace("{".concat("menuId", "}"), encodeURIComponent(String(menuId)));
            var localVarUrlObj = url.parse(localVarPath, true);
            var localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            var localVarHeaderParameter = {};
            var localVarQueryParameter = {};
            if (configuration && configuration.accessToken) {
                var localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("oauth2", ["api"])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        deleteMenuNutritionInfoByMenuId: function (menuId, options) {
            if (options === void 0) { options = {}; }
            if (menuId === null || menuId === undefined) {
                throw new RequiredError('menuId', 'Required parameter menuId was null or undefined when calling deleteMenuNutritionInfoByMenuId.');
            }
            var localVarPath = "/api/v1.0/menus/{menuId}/nutrition"
                .replace("{".concat("menuId", "}"), encodeURIComponent(String(menuId)));
            var localVarUrlObj = url.parse(localVarPath, true);
            var localVarRequestOptions = Object.assign({ method: 'DELETE' }, options);
            var localVarHeaderParameter = {};
            var localVarQueryParameter = {};
            if (configuration && configuration.accessToken) {
                var localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("oauth2", ["api"])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        getAllergens: function (appId, languageId, options) {
            if (options === void 0) { options = {}; }
            if (appId === null || appId === undefined) {
                throw new RequiredError('appId', 'Required parameter appId was null or undefined when calling getAllergens.');
            }
            var localVarPath = "/api/v1.0/{appId}/menus/nutrition/allergens"
                .replace("{".concat("appId", "}"), encodeURIComponent(String(appId)));
            var localVarUrlObj = url.parse(localVarPath, true);
            var localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            var localVarHeaderParameter = {};
            var localVarQueryParameter = {};
            if (configuration && configuration.accessToken) {
                var localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("oauth2", ["api"])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }
            if (languageId !== undefined) {
                localVarQueryParameter['languageId'] = languageId;
            }
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        getMenuNutritionInfoByMenuId: function (menuId, options) {
            if (options === void 0) { options = {}; }
            if (menuId === null || menuId === undefined) {
                throw new RequiredError('menuId', 'Required parameter menuId was null or undefined when calling getMenuNutritionInfoByMenuId.');
            }
            var localVarPath = "/api/v1.0/menus/{menuId}/nutrition"
                .replace("{".concat("menuId", "}"), encodeURIComponent(String(menuId)));
            var localVarUrlObj = url.parse(localVarPath, true);
            var localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            var localVarHeaderParameter = {};
            var localVarQueryParameter = {};
            if (configuration && configuration.accessToken) {
                var localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("oauth2", ["api"])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    };
};
exports.MenusNutritionInfoApiFetchParamCreator = MenusNutritionInfoApiFetchParamCreator;
var MenusNutritionInfoApiFp = function (configuration) {
    return {
        addOrUpdateMenuItemNutritionInfo: function (menuId, publicId, ItemNutritionInfoAddUpdateModel, options) {
            var localVarFetchArgs = (0, exports.MenusNutritionInfoApiFetchParamCreator)(configuration).addOrUpdateMenuItemNutritionInfo(menuId, publicId, ItemNutritionInfoAddUpdateModel, options);
            return function (fetch, basePath) {
                if (fetch === void 0) { fetch = portableFetch; }
                if (basePath === void 0) { basePath = BASE_PATH; }
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then(function (response) {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
        addOrUpdateMenuItemOptionSetItemNutritionInfo: function (menuId, publicId, ItemNutritionInfoAddUpdateModel, options) {
            var localVarFetchArgs = (0, exports.MenusNutritionInfoApiFetchParamCreator)(configuration).addOrUpdateMenuItemOptionSetItemNutritionInfo(menuId, publicId, ItemNutritionInfoAddUpdateModel, options);
            return function (fetch, basePath) {
                if (fetch === void 0) { fetch = portableFetch; }
                if (basePath === void 0) { basePath = BASE_PATH; }
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then(function (response) {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
        addOrUpdateMenuNutritionInfoByMenuId: function (menuId, options) {
            var localVarFetchArgs = (0, exports.MenusNutritionInfoApiFetchParamCreator)(configuration).addOrUpdateMenuNutritionInfoByMenuId(menuId, options);
            return function (fetch, basePath) {
                if (fetch === void 0) { fetch = portableFetch; }
                if (basePath === void 0) { basePath = BASE_PATH; }
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then(function (response) {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
        deleteMenuNutritionInfoByMenuId: function (menuId, options) {
            var localVarFetchArgs = (0, exports.MenusNutritionInfoApiFetchParamCreator)(configuration).deleteMenuNutritionInfoByMenuId(menuId, options);
            return function (fetch, basePath) {
                if (fetch === void 0) { fetch = portableFetch; }
                if (basePath === void 0) { basePath = BASE_PATH; }
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then(function (response) {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
        getAllergens: function (appId, languageId, options) {
            var localVarFetchArgs = (0, exports.MenusNutritionInfoApiFetchParamCreator)(configuration).getAllergens(appId, languageId, options);
            return function (fetch, basePath) {
                if (fetch === void 0) { fetch = portableFetch; }
                if (basePath === void 0) { basePath = BASE_PATH; }
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then(function (response) {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
        getMenuNutritionInfoByMenuId: function (menuId, options) {
            var localVarFetchArgs = (0, exports.MenusNutritionInfoApiFetchParamCreator)(configuration).getMenuNutritionInfoByMenuId(menuId, options);
            return function (fetch, basePath) {
                if (fetch === void 0) { fetch = portableFetch; }
                if (basePath === void 0) { basePath = BASE_PATH; }
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then(function (response) {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
    };
};
exports.MenusNutritionInfoApiFp = MenusNutritionInfoApiFp;
var MenusNutritionInfoApiFactory = function (configuration, fetch, basePath) {
    return {
        addOrUpdateMenuItemNutritionInfo: function (menuId, publicId, ItemNutritionInfoAddUpdateModel, options) {
            return (0, exports.MenusNutritionInfoApiFp)(configuration).addOrUpdateMenuItemNutritionInfo(menuId, publicId, ItemNutritionInfoAddUpdateModel, options)(fetch, basePath);
        },
        addOrUpdateMenuItemOptionSetItemNutritionInfo: function (menuId, publicId, ItemNutritionInfoAddUpdateModel, options) {
            return (0, exports.MenusNutritionInfoApiFp)(configuration).addOrUpdateMenuItemOptionSetItemNutritionInfo(menuId, publicId, ItemNutritionInfoAddUpdateModel, options)(fetch, basePath);
        },
        addOrUpdateMenuNutritionInfoByMenuId: function (menuId, options) {
            return (0, exports.MenusNutritionInfoApiFp)(configuration).addOrUpdateMenuNutritionInfoByMenuId(menuId, options)(fetch, basePath);
        },
        deleteMenuNutritionInfoByMenuId: function (menuId, options) {
            return (0, exports.MenusNutritionInfoApiFp)(configuration).deleteMenuNutritionInfoByMenuId(menuId, options)(fetch, basePath);
        },
        getAllergens: function (appId, languageId, options) {
            return (0, exports.MenusNutritionInfoApiFp)(configuration).getAllergens(appId, languageId, options)(fetch, basePath);
        },
        getMenuNutritionInfoByMenuId: function (menuId, options) {
            return (0, exports.MenusNutritionInfoApiFp)(configuration).getMenuNutritionInfoByMenuId(menuId, options)(fetch, basePath);
        },
    };
};
exports.MenusNutritionInfoApiFactory = MenusNutritionInfoApiFactory;
var MenusNutritionInfoApi = (function (_super) {
    __extends(MenusNutritionInfoApi, _super);
    function MenusNutritionInfoApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    MenusNutritionInfoApi.prototype.addOrUpdateMenuItemNutritionInfo = function (menuId, publicId, ItemNutritionInfoAddUpdateModel, options) {
        return (0, exports.MenusNutritionInfoApiFp)(this.configuration).addOrUpdateMenuItemNutritionInfo(menuId, publicId, ItemNutritionInfoAddUpdateModel, options)(this.fetch, this.basePath);
    };
    MenusNutritionInfoApi.prototype.addOrUpdateMenuItemOptionSetItemNutritionInfo = function (menuId, publicId, ItemNutritionInfoAddUpdateModel, options) {
        return (0, exports.MenusNutritionInfoApiFp)(this.configuration).addOrUpdateMenuItemOptionSetItemNutritionInfo(menuId, publicId, ItemNutritionInfoAddUpdateModel, options)(this.fetch, this.basePath);
    };
    MenusNutritionInfoApi.prototype.addOrUpdateMenuNutritionInfoByMenuId = function (menuId, options) {
        return (0, exports.MenusNutritionInfoApiFp)(this.configuration).addOrUpdateMenuNutritionInfoByMenuId(menuId, options)(this.fetch, this.basePath);
    };
    MenusNutritionInfoApi.prototype.deleteMenuNutritionInfoByMenuId = function (menuId, options) {
        return (0, exports.MenusNutritionInfoApiFp)(this.configuration).deleteMenuNutritionInfoByMenuId(menuId, options)(this.fetch, this.basePath);
    };
    MenusNutritionInfoApi.prototype.getAllergens = function (appId, languageId, options) {
        return (0, exports.MenusNutritionInfoApiFp)(this.configuration).getAllergens(appId, languageId, options)(this.fetch, this.basePath);
    };
    MenusNutritionInfoApi.prototype.getMenuNutritionInfoByMenuId = function (menuId, options) {
        return (0, exports.MenusNutritionInfoApiFp)(this.configuration).getMenuNutritionInfoByMenuId(menuId, options)(this.fetch, this.basePath);
    };
    return MenusNutritionInfoApi;
}(BaseAPI));
exports.MenusNutritionInfoApi = MenusNutritionInfoApi;
var MenusNutritionInfoV2ApiFetchParamCreator = function (configuration) {
    return {
        addOrUpdateMenuItemNutritionInfoV2: function (menuId, publicId, appId, ItemNutritionInfoV2AddUpdateModel, options) {
            if (options === void 0) { options = {}; }
            if (menuId === null || menuId === undefined) {
                throw new RequiredError('menuId', 'Required parameter menuId was null or undefined when calling addOrUpdateMenuItemNutritionInfoV2.');
            }
            if (publicId === null || publicId === undefined) {
                throw new RequiredError('publicId', 'Required parameter publicId was null or undefined when calling addOrUpdateMenuItemNutritionInfoV2.');
            }
            if (appId === null || appId === undefined) {
                throw new RequiredError('appId', 'Required parameter appId was null or undefined when calling addOrUpdateMenuItemNutritionInfoV2.');
            }
            if (ItemNutritionInfoV2AddUpdateModel === null || ItemNutritionInfoV2AddUpdateModel === undefined) {
                throw new RequiredError('ItemNutritionInfoV2AddUpdateModel', 'Required parameter ItemNutritionInfoV2AddUpdateModel was null or undefined when calling addOrUpdateMenuItemNutritionInfoV2.');
            }
            var localVarPath = "/api/v1.0/{appId}/menus/{menuId}/menuItem/{publicId}/nutritionv2"
                .replace("{".concat("menuId", "}"), encodeURIComponent(String(menuId)))
                .replace("{".concat("publicId", "}"), encodeURIComponent(String(publicId)))
                .replace("{".concat("appId", "}"), encodeURIComponent(String(appId)));
            var localVarUrlObj = url.parse(localVarPath, true);
            var localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            var localVarHeaderParameter = {};
            var localVarQueryParameter = {};
            if (configuration && configuration.accessToken) {
                var localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("oauth2", ["api"])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }
            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            var needsSerialization = ("ItemNutritionInfoV2AddUpdateModel" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body = needsSerialization ? JSON.stringify(ItemNutritionInfoV2AddUpdateModel || {}) : (ItemNutritionInfoV2AddUpdateModel || "");
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        addOrUpdateMenuItemOptionSetItemNutritionInfoV2: function (menuId, publicId, appId, ItemNutritionInfoV2AddUpdateModel, options) {
            if (options === void 0) { options = {}; }
            if (menuId === null || menuId === undefined) {
                throw new RequiredError('menuId', 'Required parameter menuId was null or undefined when calling addOrUpdateMenuItemOptionSetItemNutritionInfoV2.');
            }
            if (publicId === null || publicId === undefined) {
                throw new RequiredError('publicId', 'Required parameter publicId was null or undefined when calling addOrUpdateMenuItemOptionSetItemNutritionInfoV2.');
            }
            if (appId === null || appId === undefined) {
                throw new RequiredError('appId', 'Required parameter appId was null or undefined when calling addOrUpdateMenuItemOptionSetItemNutritionInfoV2.');
            }
            if (ItemNutritionInfoV2AddUpdateModel === null || ItemNutritionInfoV2AddUpdateModel === undefined) {
                throw new RequiredError('ItemNutritionInfoV2AddUpdateModel', 'Required parameter ItemNutritionInfoV2AddUpdateModel was null or undefined when calling addOrUpdateMenuItemOptionSetItemNutritionInfoV2.');
            }
            var localVarPath = "/api/v1.0/{appId}/menus/{menuId}/menuItemOption/{publicId}/nutritionv2"
                .replace("{".concat("menuId", "}"), encodeURIComponent(String(menuId)))
                .replace("{".concat("publicId", "}"), encodeURIComponent(String(publicId)))
                .replace("{".concat("appId", "}"), encodeURIComponent(String(appId)));
            var localVarUrlObj = url.parse(localVarPath, true);
            var localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            var localVarHeaderParameter = {};
            var localVarQueryParameter = {};
            if (configuration && configuration.accessToken) {
                var localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("oauth2", ["api"])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }
            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            var needsSerialization = ("ItemNutritionInfoV2AddUpdateModel" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body = needsSerialization ? JSON.stringify(ItemNutritionInfoV2AddUpdateModel || {}) : (ItemNutritionInfoV2AddUpdateModel || "");
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        getAllergensV2: function (appId, languageId, options) {
            if (options === void 0) { options = {}; }
            if (appId === null || appId === undefined) {
                throw new RequiredError('appId', 'Required parameter appId was null or undefined when calling getAllergensV2.');
            }
            var localVarPath = "/api/v1.0/{appId}/menus/nutritionv2/allergens"
                .replace("{".concat("appId", "}"), encodeURIComponent(String(appId)));
            var localVarUrlObj = url.parse(localVarPath, true);
            var localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            var localVarHeaderParameter = {};
            var localVarQueryParameter = {};
            if (configuration && configuration.accessToken) {
                var localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("oauth2", ["api"])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }
            if (languageId !== undefined) {
                localVarQueryParameter['languageId'] = languageId;
            }
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        getMenuNutritionInfoV2ByMenuId: function (appId, menuId, languageId, options) {
            if (options === void 0) { options = {}; }
            if (appId === null || appId === undefined) {
                throw new RequiredError('appId', 'Required parameter appId was null or undefined when calling getMenuNutritionInfoV2ByMenuId.');
            }
            if (menuId === null || menuId === undefined) {
                throw new RequiredError('menuId', 'Required parameter menuId was null or undefined when calling getMenuNutritionInfoV2ByMenuId.');
            }
            var localVarPath = "/api/v1.0/{appId}/menus/{menuId}/nutritionv2"
                .replace("{".concat("appId", "}"), encodeURIComponent(String(appId)))
                .replace("{".concat("menuId", "}"), encodeURIComponent(String(menuId)));
            var localVarUrlObj = url.parse(localVarPath, true);
            var localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            var localVarHeaderParameter = {};
            var localVarQueryParameter = {};
            if (configuration && configuration.accessToken) {
                var localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("oauth2", ["api"])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }
            if (languageId !== undefined) {
                localVarQueryParameter['languageId'] = languageId;
            }
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    };
};
exports.MenusNutritionInfoV2ApiFetchParamCreator = MenusNutritionInfoV2ApiFetchParamCreator;
var MenusNutritionInfoV2ApiFp = function (configuration) {
    return {
        addOrUpdateMenuItemNutritionInfoV2: function (menuId, publicId, appId, ItemNutritionInfoV2AddUpdateModel, options) {
            var localVarFetchArgs = (0, exports.MenusNutritionInfoV2ApiFetchParamCreator)(configuration).addOrUpdateMenuItemNutritionInfoV2(menuId, publicId, appId, ItemNutritionInfoV2AddUpdateModel, options);
            return function (fetch, basePath) {
                if (fetch === void 0) { fetch = portableFetch; }
                if (basePath === void 0) { basePath = BASE_PATH; }
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then(function (response) {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
        addOrUpdateMenuItemOptionSetItemNutritionInfoV2: function (menuId, publicId, appId, ItemNutritionInfoV2AddUpdateModel, options) {
            var localVarFetchArgs = (0, exports.MenusNutritionInfoV2ApiFetchParamCreator)(configuration).addOrUpdateMenuItemOptionSetItemNutritionInfoV2(menuId, publicId, appId, ItemNutritionInfoV2AddUpdateModel, options);
            return function (fetch, basePath) {
                if (fetch === void 0) { fetch = portableFetch; }
                if (basePath === void 0) { basePath = BASE_PATH; }
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then(function (response) {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
        getAllergensV2: function (appId, languageId, options) {
            var localVarFetchArgs = (0, exports.MenusNutritionInfoV2ApiFetchParamCreator)(configuration).getAllergensV2(appId, languageId, options);
            return function (fetch, basePath) {
                if (fetch === void 0) { fetch = portableFetch; }
                if (basePath === void 0) { basePath = BASE_PATH; }
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then(function (response) {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
        getMenuNutritionInfoV2ByMenuId: function (appId, menuId, languageId, options) {
            var localVarFetchArgs = (0, exports.MenusNutritionInfoV2ApiFetchParamCreator)(configuration).getMenuNutritionInfoV2ByMenuId(appId, menuId, languageId, options);
            return function (fetch, basePath) {
                if (fetch === void 0) { fetch = portableFetch; }
                if (basePath === void 0) { basePath = BASE_PATH; }
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then(function (response) {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
    };
};
exports.MenusNutritionInfoV2ApiFp = MenusNutritionInfoV2ApiFp;
var MenusNutritionInfoV2ApiFactory = function (configuration, fetch, basePath) {
    return {
        addOrUpdateMenuItemNutritionInfoV2: function (menuId, publicId, appId, ItemNutritionInfoV2AddUpdateModel, options) {
            return (0, exports.MenusNutritionInfoV2ApiFp)(configuration).addOrUpdateMenuItemNutritionInfoV2(menuId, publicId, appId, ItemNutritionInfoV2AddUpdateModel, options)(fetch, basePath);
        },
        addOrUpdateMenuItemOptionSetItemNutritionInfoV2: function (menuId, publicId, appId, ItemNutritionInfoV2AddUpdateModel, options) {
            return (0, exports.MenusNutritionInfoV2ApiFp)(configuration).addOrUpdateMenuItemOptionSetItemNutritionInfoV2(menuId, publicId, appId, ItemNutritionInfoV2AddUpdateModel, options)(fetch, basePath);
        },
        getAllergensV2: function (appId, languageId, options) {
            return (0, exports.MenusNutritionInfoV2ApiFp)(configuration).getAllergensV2(appId, languageId, options)(fetch, basePath);
        },
        getMenuNutritionInfoV2ByMenuId: function (appId, menuId, languageId, options) {
            return (0, exports.MenusNutritionInfoV2ApiFp)(configuration).getMenuNutritionInfoV2ByMenuId(appId, menuId, languageId, options)(fetch, basePath);
        },
    };
};
exports.MenusNutritionInfoV2ApiFactory = MenusNutritionInfoV2ApiFactory;
var MenusNutritionInfoV2Api = (function (_super) {
    __extends(MenusNutritionInfoV2Api, _super);
    function MenusNutritionInfoV2Api() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    MenusNutritionInfoV2Api.prototype.addOrUpdateMenuItemNutritionInfoV2 = function (menuId, publicId, appId, ItemNutritionInfoV2AddUpdateModel, options) {
        return (0, exports.MenusNutritionInfoV2ApiFp)(this.configuration).addOrUpdateMenuItemNutritionInfoV2(menuId, publicId, appId, ItemNutritionInfoV2AddUpdateModel, options)(this.fetch, this.basePath);
    };
    MenusNutritionInfoV2Api.prototype.addOrUpdateMenuItemOptionSetItemNutritionInfoV2 = function (menuId, publicId, appId, ItemNutritionInfoV2AddUpdateModel, options) {
        return (0, exports.MenusNutritionInfoV2ApiFp)(this.configuration).addOrUpdateMenuItemOptionSetItemNutritionInfoV2(menuId, publicId, appId, ItemNutritionInfoV2AddUpdateModel, options)(this.fetch, this.basePath);
    };
    MenusNutritionInfoV2Api.prototype.getAllergensV2 = function (appId, languageId, options) {
        return (0, exports.MenusNutritionInfoV2ApiFp)(this.configuration).getAllergensV2(appId, languageId, options)(this.fetch, this.basePath);
    };
    MenusNutritionInfoV2Api.prototype.getMenuNutritionInfoV2ByMenuId = function (appId, menuId, languageId, options) {
        return (0, exports.MenusNutritionInfoV2ApiFp)(this.configuration).getMenuNutritionInfoV2ByMenuId(appId, menuId, languageId, options)(this.fetch, this.basePath);
    };
    return MenusNutritionInfoV2Api;
}(BaseAPI));
exports.MenusNutritionInfoV2Api = MenusNutritionInfoV2Api;
var MetafieldDefinitionsApiFetchParamCreator = function (configuration) {
    return {
        createMetafieldDefinition: function (appId, ownerEntity, CreateMetafieldDefinition, options) {
            if (options === void 0) { options = {}; }
            if (appId === null || appId === undefined) {
                throw new RequiredError('appId', 'Required parameter appId was null or undefined when calling createMetafieldDefinition.');
            }
            if (ownerEntity === null || ownerEntity === undefined) {
                throw new RequiredError('ownerEntity', 'Required parameter ownerEntity was null or undefined when calling createMetafieldDefinition.');
            }
            if (CreateMetafieldDefinition === null || CreateMetafieldDefinition === undefined) {
                throw new RequiredError('CreateMetafieldDefinition', 'Required parameter CreateMetafieldDefinition was null or undefined when calling createMetafieldDefinition.');
            }
            var localVarPath = "/api/v1.0/{appId}/metafields/definitions/{ownerEntity}"
                .replace("{".concat("appId", "}"), encodeURIComponent(String(appId)))
                .replace("{".concat("ownerEntity", "}"), encodeURIComponent(String(ownerEntity)));
            var localVarUrlObj = url.parse(localVarPath, true);
            var localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            var localVarHeaderParameter = {};
            var localVarQueryParameter = {};
            if (configuration && configuration.accessToken) {
                var localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("oauth2", ["api"])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }
            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            var needsSerialization = ("CreateMetafieldDefinition" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body = needsSerialization ? JSON.stringify(CreateMetafieldDefinition || {}) : (CreateMetafieldDefinition || "");
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        getMetafieldDefinitionByKey: function (appId, ownerEntity, key, options) {
            if (options === void 0) { options = {}; }
            if (appId === null || appId === undefined) {
                throw new RequiredError('appId', 'Required parameter appId was null or undefined when calling getMetafieldDefinitionByKey.');
            }
            if (ownerEntity === null || ownerEntity === undefined) {
                throw new RequiredError('ownerEntity', 'Required parameter ownerEntity was null or undefined when calling getMetafieldDefinitionByKey.');
            }
            if (key === null || key === undefined) {
                throw new RequiredError('key', 'Required parameter key was null or undefined when calling getMetafieldDefinitionByKey.');
            }
            var localVarPath = "/api/v1.0/{appId}/metafields/definitions/{ownerEntity}/{key}"
                .replace("{".concat("appId", "}"), encodeURIComponent(String(appId)))
                .replace("{".concat("ownerEntity", "}"), encodeURIComponent(String(ownerEntity)))
                .replace("{".concat("key", "}"), encodeURIComponent(String(key)));
            var localVarUrlObj = url.parse(localVarPath, true);
            var localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            var localVarHeaderParameter = {};
            var localVarQueryParameter = {};
            if (configuration && configuration.accessToken) {
                var localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("oauth2", ["api"])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        getMetafieldDefinitions: function (appId, ownerEntity, searchTerm, page, limit, options) {
            if (options === void 0) { options = {}; }
            if (appId === null || appId === undefined) {
                throw new RequiredError('appId', 'Required parameter appId was null or undefined when calling getMetafieldDefinitions.');
            }
            if (ownerEntity === null || ownerEntity === undefined) {
                throw new RequiredError('ownerEntity', 'Required parameter ownerEntity was null or undefined when calling getMetafieldDefinitions.');
            }
            var localVarPath = "/api/v1.0/{appId}/metafields/definitions/{ownerEntity}"
                .replace("{".concat("appId", "}"), encodeURIComponent(String(appId)))
                .replace("{".concat("ownerEntity", "}"), encodeURIComponent(String(ownerEntity)));
            var localVarUrlObj = url.parse(localVarPath, true);
            var localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            var localVarHeaderParameter = {};
            var localVarQueryParameter = {};
            if (configuration && configuration.accessToken) {
                var localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("oauth2", ["api"])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }
            if (searchTerm !== undefined) {
                localVarQueryParameter['searchTerm'] = searchTerm;
            }
            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }
            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        getOwnerEntityConfigurations: function (appId, options) {
            if (options === void 0) { options = {}; }
            if (appId === null || appId === undefined) {
                throw new RequiredError('appId', 'Required parameter appId was null or undefined when calling getOwnerEntityConfigurations.');
            }
            var localVarPath = "/api/v1.0/{appId}/metafields/definitions"
                .replace("{".concat("appId", "}"), encodeURIComponent(String(appId)));
            var localVarUrlObj = url.parse(localVarPath, true);
            var localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            var localVarHeaderParameter = {};
            var localVarQueryParameter = {};
            if (configuration && configuration.accessToken) {
                var localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("oauth2", ["api"])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        getOwnerEntityRecommendations: function (appId, ownerEntity, searchTerm, page, limit, options) {
            if (options === void 0) { options = {}; }
            if (appId === null || appId === undefined) {
                throw new RequiredError('appId', 'Required parameter appId was null or undefined when calling getOwnerEntityRecommendations.');
            }
            if (ownerEntity === null || ownerEntity === undefined) {
                throw new RequiredError('ownerEntity', 'Required parameter ownerEntity was null or undefined when calling getOwnerEntityRecommendations.');
            }
            var localVarPath = "/api/v1.0/{appId}/metafields/definitions/recommendations/{ownerEntity}"
                .replace("{".concat("appId", "}"), encodeURIComponent(String(appId)))
                .replace("{".concat("ownerEntity", "}"), encodeURIComponent(String(ownerEntity)));
            var localVarUrlObj = url.parse(localVarPath, true);
            var localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            var localVarHeaderParameter = {};
            var localVarQueryParameter = {};
            if (configuration && configuration.accessToken) {
                var localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("oauth2", ["api"])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }
            if (searchTerm !== undefined) {
                localVarQueryParameter['searchTerm'] = searchTerm;
            }
            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }
            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        updateMetafieldDefinition: function (appId, ownerEntity, key, UpdateMetafieldDefinition, options) {
            if (options === void 0) { options = {}; }
            if (appId === null || appId === undefined) {
                throw new RequiredError('appId', 'Required parameter appId was null or undefined when calling updateMetafieldDefinition.');
            }
            if (ownerEntity === null || ownerEntity === undefined) {
                throw new RequiredError('ownerEntity', 'Required parameter ownerEntity was null or undefined when calling updateMetafieldDefinition.');
            }
            if (key === null || key === undefined) {
                throw new RequiredError('key', 'Required parameter key was null or undefined when calling updateMetafieldDefinition.');
            }
            if (UpdateMetafieldDefinition === null || UpdateMetafieldDefinition === undefined) {
                throw new RequiredError('UpdateMetafieldDefinition', 'Required parameter UpdateMetafieldDefinition was null or undefined when calling updateMetafieldDefinition.');
            }
            var localVarPath = "/api/v1.0/{appId}/metafields/definitions/{ownerEntity}/{key}"
                .replace("{".concat("appId", "}"), encodeURIComponent(String(appId)))
                .replace("{".concat("ownerEntity", "}"), encodeURIComponent(String(ownerEntity)))
                .replace("{".concat("key", "}"), encodeURIComponent(String(key)));
            var localVarUrlObj = url.parse(localVarPath, true);
            var localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            var localVarHeaderParameter = {};
            var localVarQueryParameter = {};
            if (configuration && configuration.accessToken) {
                var localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("oauth2", ["api"])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }
            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            var needsSerialization = ("UpdateMetafieldDefinition" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body = needsSerialization ? JSON.stringify(UpdateMetafieldDefinition || {}) : (UpdateMetafieldDefinition || "");
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    };
};
exports.MetafieldDefinitionsApiFetchParamCreator = MetafieldDefinitionsApiFetchParamCreator;
var MetafieldDefinitionsApiFp = function (configuration) {
    return {
        createMetafieldDefinition: function (appId, ownerEntity, CreateMetafieldDefinition, options) {
            var localVarFetchArgs = (0, exports.MetafieldDefinitionsApiFetchParamCreator)(configuration).createMetafieldDefinition(appId, ownerEntity, CreateMetafieldDefinition, options);
            return function (fetch, basePath) {
                if (fetch === void 0) { fetch = portableFetch; }
                if (basePath === void 0) { basePath = BASE_PATH; }
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then(function (response) {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
        getMetafieldDefinitionByKey: function (appId, ownerEntity, key, options) {
            var localVarFetchArgs = (0, exports.MetafieldDefinitionsApiFetchParamCreator)(configuration).getMetafieldDefinitionByKey(appId, ownerEntity, key, options);
            return function (fetch, basePath) {
                if (fetch === void 0) { fetch = portableFetch; }
                if (basePath === void 0) { basePath = BASE_PATH; }
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then(function (response) {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
        getMetafieldDefinitions: function (appId, ownerEntity, searchTerm, page, limit, options) {
            var localVarFetchArgs = (0, exports.MetafieldDefinitionsApiFetchParamCreator)(configuration).getMetafieldDefinitions(appId, ownerEntity, searchTerm, page, limit, options);
            return function (fetch, basePath) {
                if (fetch === void 0) { fetch = portableFetch; }
                if (basePath === void 0) { basePath = BASE_PATH; }
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then(function (response) {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
        getOwnerEntityConfigurations: function (appId, options) {
            var localVarFetchArgs = (0, exports.MetafieldDefinitionsApiFetchParamCreator)(configuration).getOwnerEntityConfigurations(appId, options);
            return function (fetch, basePath) {
                if (fetch === void 0) { fetch = portableFetch; }
                if (basePath === void 0) { basePath = BASE_PATH; }
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then(function (response) {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
        getOwnerEntityRecommendations: function (appId, ownerEntity, searchTerm, page, limit, options) {
            var localVarFetchArgs = (0, exports.MetafieldDefinitionsApiFetchParamCreator)(configuration).getOwnerEntityRecommendations(appId, ownerEntity, searchTerm, page, limit, options);
            return function (fetch, basePath) {
                if (fetch === void 0) { fetch = portableFetch; }
                if (basePath === void 0) { basePath = BASE_PATH; }
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then(function (response) {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
        updateMetafieldDefinition: function (appId, ownerEntity, key, UpdateMetafieldDefinition, options) {
            var localVarFetchArgs = (0, exports.MetafieldDefinitionsApiFetchParamCreator)(configuration).updateMetafieldDefinition(appId, ownerEntity, key, UpdateMetafieldDefinition, options);
            return function (fetch, basePath) {
                if (fetch === void 0) { fetch = portableFetch; }
                if (basePath === void 0) { basePath = BASE_PATH; }
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then(function (response) {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
    };
};
exports.MetafieldDefinitionsApiFp = MetafieldDefinitionsApiFp;
var MetafieldDefinitionsApiFactory = function (configuration, fetch, basePath) {
    return {
        createMetafieldDefinition: function (appId, ownerEntity, CreateMetafieldDefinition, options) {
            return (0, exports.MetafieldDefinitionsApiFp)(configuration).createMetafieldDefinition(appId, ownerEntity, CreateMetafieldDefinition, options)(fetch, basePath);
        },
        getMetafieldDefinitionByKey: function (appId, ownerEntity, key, options) {
            return (0, exports.MetafieldDefinitionsApiFp)(configuration).getMetafieldDefinitionByKey(appId, ownerEntity, key, options)(fetch, basePath);
        },
        getMetafieldDefinitions: function (appId, ownerEntity, searchTerm, page, limit, options) {
            return (0, exports.MetafieldDefinitionsApiFp)(configuration).getMetafieldDefinitions(appId, ownerEntity, searchTerm, page, limit, options)(fetch, basePath);
        },
        getOwnerEntityConfigurations: function (appId, options) {
            return (0, exports.MetafieldDefinitionsApiFp)(configuration).getOwnerEntityConfigurations(appId, options)(fetch, basePath);
        },
        getOwnerEntityRecommendations: function (appId, ownerEntity, searchTerm, page, limit, options) {
            return (0, exports.MetafieldDefinitionsApiFp)(configuration).getOwnerEntityRecommendations(appId, ownerEntity, searchTerm, page, limit, options)(fetch, basePath);
        },
        updateMetafieldDefinition: function (appId, ownerEntity, key, UpdateMetafieldDefinition, options) {
            return (0, exports.MetafieldDefinitionsApiFp)(configuration).updateMetafieldDefinition(appId, ownerEntity, key, UpdateMetafieldDefinition, options)(fetch, basePath);
        },
    };
};
exports.MetafieldDefinitionsApiFactory = MetafieldDefinitionsApiFactory;
var MetafieldDefinitionsApi = (function (_super) {
    __extends(MetafieldDefinitionsApi, _super);
    function MetafieldDefinitionsApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    MetafieldDefinitionsApi.prototype.createMetafieldDefinition = function (appId, ownerEntity, CreateMetafieldDefinition, options) {
        return (0, exports.MetafieldDefinitionsApiFp)(this.configuration).createMetafieldDefinition(appId, ownerEntity, CreateMetafieldDefinition, options)(this.fetch, this.basePath);
    };
    MetafieldDefinitionsApi.prototype.getMetafieldDefinitionByKey = function (appId, ownerEntity, key, options) {
        return (0, exports.MetafieldDefinitionsApiFp)(this.configuration).getMetafieldDefinitionByKey(appId, ownerEntity, key, options)(this.fetch, this.basePath);
    };
    MetafieldDefinitionsApi.prototype.getMetafieldDefinitions = function (appId, ownerEntity, searchTerm, page, limit, options) {
        return (0, exports.MetafieldDefinitionsApiFp)(this.configuration).getMetafieldDefinitions(appId, ownerEntity, searchTerm, page, limit, options)(this.fetch, this.basePath);
    };
    MetafieldDefinitionsApi.prototype.getOwnerEntityConfigurations = function (appId, options) {
        return (0, exports.MetafieldDefinitionsApiFp)(this.configuration).getOwnerEntityConfigurations(appId, options)(this.fetch, this.basePath);
    };
    MetafieldDefinitionsApi.prototype.getOwnerEntityRecommendations = function (appId, ownerEntity, searchTerm, page, limit, options) {
        return (0, exports.MetafieldDefinitionsApiFp)(this.configuration).getOwnerEntityRecommendations(appId, ownerEntity, searchTerm, page, limit, options)(this.fetch, this.basePath);
    };
    MetafieldDefinitionsApi.prototype.updateMetafieldDefinition = function (appId, ownerEntity, key, UpdateMetafieldDefinition, options) {
        return (0, exports.MetafieldDefinitionsApiFp)(this.configuration).updateMetafieldDefinition(appId, ownerEntity, key, UpdateMetafieldDefinition, options)(this.fetch, this.basePath);
    };
    return MetafieldDefinitionsApi;
}(BaseAPI));
exports.MetafieldDefinitionsApi = MetafieldDefinitionsApi;
var MobileAppsApiFetchParamCreator = function (configuration) {
    return {
        getAppConfigSalesChannel: function (appId, options) {
            if (options === void 0) { options = {}; }
            if (appId === null || appId === undefined) {
                throw new RequiredError('appId', 'Required parameter appId was null or undefined when calling getAppConfigSalesChannel.');
            }
            var localVarPath = "/api/v1.0/mobileapps/{appId}/saleschannel/details"
                .replace("{".concat("appId", "}"), encodeURIComponent(String(appId)));
            var localVarUrlObj = url.parse(localVarPath, true);
            var localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            var localVarHeaderParameter = {};
            var localVarQueryParameter = {};
            if (configuration && configuration.accessToken) {
                var localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("oauth2", ["api"])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        getStatistics: function (appId, platformTypes, options) {
            if (options === void 0) { options = {}; }
            if (appId === null || appId === undefined) {
                throw new RequiredError('appId', 'Required parameter appId was null or undefined when calling getStatistics.');
            }
            if (platformTypes === null || platformTypes === undefined) {
                throw new RequiredError('platformTypes', 'Required parameter platformTypes was null or undefined when calling getStatistics.');
            }
            var localVarPath = "/api/v1.0/mobileapps/{appId}/statistics"
                .replace("{".concat("appId", "}"), encodeURIComponent(String(appId)));
            var localVarUrlObj = url.parse(localVarPath, true);
            var localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            var localVarHeaderParameter = {};
            var localVarQueryParameter = {};
            if (configuration && configuration.accessToken) {
                var localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("oauth2", ["api"])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }
            if (platformTypes) {
                localVarQueryParameter['platformTypes'] = platformTypes;
            }
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        getSubmissionDetails: function (appId, options) {
            if (options === void 0) { options = {}; }
            if (appId === null || appId === undefined) {
                throw new RequiredError('appId', 'Required parameter appId was null or undefined when calling getSubmissionDetails.');
            }
            var localVarPath = "/api/v1.0/mobileapps/{appId}/submission/details"
                .replace("{".concat("appId", "}"), encodeURIComponent(String(appId)));
            var localVarUrlObj = url.parse(localVarPath, true);
            var localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            var localVarHeaderParameter = {};
            var localVarQueryParameter = {};
            if (configuration && configuration.accessToken) {
                var localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("oauth2", ["api"])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        getSubmissionStatus: function (appId, submissionId, options) {
            if (options === void 0) { options = {}; }
            if (appId === null || appId === undefined) {
                throw new RequiredError('appId', 'Required parameter appId was null or undefined when calling getSubmissionStatus.');
            }
            if (submissionId === null || submissionId === undefined) {
                throw new RequiredError('submissionId', 'Required parameter submissionId was null or undefined when calling getSubmissionStatus.');
            }
            var localVarPath = "/api/v1.0/mobileapps/{appId}/submission/{submissionId}/status"
                .replace("{".concat("appId", "}"), encodeURIComponent(String(appId)))
                .replace("{".concat("submissionId", "}"), encodeURIComponent(String(submissionId)));
            var localVarUrlObj = url.parse(localVarPath, true);
            var localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            var localVarHeaderParameter = {};
            var localVarQueryParameter = {};
            if (configuration && configuration.accessToken) {
                var localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("oauth2", ["api"])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        publish: function (appId, submissionId, platformType, options) {
            if (options === void 0) { options = {}; }
            if (appId === null || appId === undefined) {
                throw new RequiredError('appId', 'Required parameter appId was null or undefined when calling publish.');
            }
            if (submissionId === null || submissionId === undefined) {
                throw new RequiredError('submissionId', 'Required parameter submissionId was null or undefined when calling publish.');
            }
            var localVarPath = "/api/v1.0/mobileapps/{appId}/submission/{submissionId}/publish"
                .replace("{".concat("appId", "}"), encodeURIComponent(String(appId)))
                .replace("{".concat("submissionId", "}"), encodeURIComponent(String(submissionId)));
            var localVarUrlObj = url.parse(localVarPath, true);
            var localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            var localVarHeaderParameter = {};
            var localVarQueryParameter = {};
            if (configuration && configuration.accessToken) {
                var localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("oauth2", ["api"])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }
            if (platformType !== undefined) {
                localVarQueryParameter['platformType'] = platformType;
            }
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        resubmission: function (appId, MobileAppsSubmission, options) {
            if (options === void 0) { options = {}; }
            if (appId === null || appId === undefined) {
                throw new RequiredError('appId', 'Required parameter appId was null or undefined when calling resubmission.');
            }
            if (MobileAppsSubmission === null || MobileAppsSubmission === undefined) {
                throw new RequiredError('MobileAppsSubmission', 'Required parameter MobileAppsSubmission was null or undefined when calling resubmission.');
            }
            var localVarPath = "/api/v1.0/mobileapps/{appId}/resubmission"
                .replace("{".concat("appId", "}"), encodeURIComponent(String(appId)));
            var localVarUrlObj = url.parse(localVarPath, true);
            var localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            var localVarHeaderParameter = {};
            var localVarQueryParameter = {};
            if (configuration && configuration.accessToken) {
                var localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("oauth2", ["api"])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }
            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            var needsSerialization = ("MobileAppsSubmission" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body = needsSerialization ? JSON.stringify(MobileAppsSubmission || {}) : (MobileAppsSubmission || "");
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        submission: function (appId, MobileAppsSubmission, options) {
            if (options === void 0) { options = {}; }
            if (appId === null || appId === undefined) {
                throw new RequiredError('appId', 'Required parameter appId was null or undefined when calling submission.');
            }
            if (MobileAppsSubmission === null || MobileAppsSubmission === undefined) {
                throw new RequiredError('MobileAppsSubmission', 'Required parameter MobileAppsSubmission was null or undefined when calling submission.');
            }
            var localVarPath = "/api/v1.0/mobileapps/{appId}/submission"
                .replace("{".concat("appId", "}"), encodeURIComponent(String(appId)));
            var localVarUrlObj = url.parse(localVarPath, true);
            var localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            var localVarHeaderParameter = {};
            var localVarQueryParameter = {};
            if (configuration && configuration.accessToken) {
                var localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("oauth2", ["api"])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }
            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            var needsSerialization = ("MobileAppsSubmission" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body = needsSerialization ? JSON.stringify(MobileAppsSubmission || {}) : (MobileAppsSubmission || "");
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        unpublish: function (appId, submissionId, platformType, options) {
            if (options === void 0) { options = {}; }
            if (appId === null || appId === undefined) {
                throw new RequiredError('appId', 'Required parameter appId was null or undefined when calling unpublish.');
            }
            if (submissionId === null || submissionId === undefined) {
                throw new RequiredError('submissionId', 'Required parameter submissionId was null or undefined when calling unpublish.');
            }
            var localVarPath = "/api/v1.0/mobileapps/{appId}/submission/{submissionId}/unpublish"
                .replace("{".concat("appId", "}"), encodeURIComponent(String(appId)))
                .replace("{".concat("submissionId", "}"), encodeURIComponent(String(submissionId)));
            var localVarUrlObj = url.parse(localVarPath, true);
            var localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            var localVarHeaderParameter = {};
            var localVarQueryParameter = {};
            if (configuration && configuration.accessToken) {
                var localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("oauth2", ["api"])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }
            if (platformType !== undefined) {
                localVarQueryParameter['platformType'] = platformType;
            }
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        updateAppConfigSalesChannel: function (appId, AppConfigSalesChannel, options) {
            if (options === void 0) { options = {}; }
            if (appId === null || appId === undefined) {
                throw new RequiredError('appId', 'Required parameter appId was null or undefined when calling updateAppConfigSalesChannel.');
            }
            if (AppConfigSalesChannel === null || AppConfigSalesChannel === undefined) {
                throw new RequiredError('AppConfigSalesChannel', 'Required parameter AppConfigSalesChannel was null or undefined when calling updateAppConfigSalesChannel.');
            }
            var localVarPath = "/api/v1.0/mobileapps/{appId}/saleschannel"
                .replace("{".concat("appId", "}"), encodeURIComponent(String(appId)));
            var localVarUrlObj = url.parse(localVarPath, true);
            var localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            var localVarHeaderParameter = {};
            var localVarQueryParameter = {};
            if (configuration && configuration.accessToken) {
                var localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("oauth2", ["api"])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }
            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            var needsSerialization = ("AppConfigSalesChannel" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body = needsSerialization ? JSON.stringify(AppConfigSalesChannel || {}) : (AppConfigSalesChannel || "");
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        updateSubmissionStatus: function (appId, submissionId, UpdateMobileAppsSubmissionStatus, options) {
            if (options === void 0) { options = {}; }
            if (appId === null || appId === undefined) {
                throw new RequiredError('appId', 'Required parameter appId was null or undefined when calling updateSubmissionStatus.');
            }
            if (submissionId === null || submissionId === undefined) {
                throw new RequiredError('submissionId', 'Required parameter submissionId was null or undefined when calling updateSubmissionStatus.');
            }
            if (UpdateMobileAppsSubmissionStatus === null || UpdateMobileAppsSubmissionStatus === undefined) {
                throw new RequiredError('UpdateMobileAppsSubmissionStatus', 'Required parameter UpdateMobileAppsSubmissionStatus was null or undefined when calling updateSubmissionStatus.');
            }
            var localVarPath = "/api/v1.0/mobileapps/{appId}/submission/{submissionId}/status"
                .replace("{".concat("appId", "}"), encodeURIComponent(String(appId)))
                .replace("{".concat("submissionId", "}"), encodeURIComponent(String(submissionId)));
            var localVarUrlObj = url.parse(localVarPath, true);
            var localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            var localVarHeaderParameter = {};
            var localVarQueryParameter = {};
            if (configuration && configuration.accessToken) {
                var localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("oauth2", ["api"])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }
            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            var needsSerialization = ("UpdateMobileAppsSubmissionStatus" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body = needsSerialization ? JSON.stringify(UpdateMobileAppsSubmissionStatus || {}) : (UpdateMobileAppsSubmissionStatus || "");
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        uploadImage: function (appId, Image, options) {
            if (options === void 0) { options = {}; }
            if (appId === null || appId === undefined) {
                throw new RequiredError('appId', 'Required parameter appId was null or undefined when calling uploadImage.');
            }
            if (Image === null || Image === undefined) {
                throw new RequiredError('Image', 'Required parameter Image was null or undefined when calling uploadImage.');
            }
            var localVarPath = "/api/v1.0/mobileapps/{appId}/submission/image"
                .replace("{".concat("appId", "}"), encodeURIComponent(String(appId)));
            var localVarUrlObj = url.parse(localVarPath, true);
            var localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            var localVarHeaderParameter = {};
            var localVarQueryParameter = {};
            var localVarFormParams = new url.URLSearchParams();
            if (configuration && configuration.accessToken) {
                var localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("oauth2", ["api"])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }
            if (Image !== undefined) {
                localVarFormParams.set('Image', Image);
            }
            localVarHeaderParameter['Content-Type'] = 'application/x-www-form-urlencoded';
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            localVarRequestOptions.body = localVarFormParams.toString();
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    };
};
exports.MobileAppsApiFetchParamCreator = MobileAppsApiFetchParamCreator;
var MobileAppsApiFp = function (configuration) {
    return {
        getAppConfigSalesChannel: function (appId, options) {
            var localVarFetchArgs = (0, exports.MobileAppsApiFetchParamCreator)(configuration).getAppConfigSalesChannel(appId, options);
            return function (fetch, basePath) {
                if (fetch === void 0) { fetch = portableFetch; }
                if (basePath === void 0) { basePath = BASE_PATH; }
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then(function (response) {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
        getStatistics: function (appId, platformTypes, options) {
            var localVarFetchArgs = (0, exports.MobileAppsApiFetchParamCreator)(configuration).getStatistics(appId, platformTypes, options);
            return function (fetch, basePath) {
                if (fetch === void 0) { fetch = portableFetch; }
                if (basePath === void 0) { basePath = BASE_PATH; }
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then(function (response) {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
        getSubmissionDetails: function (appId, options) {
            var localVarFetchArgs = (0, exports.MobileAppsApiFetchParamCreator)(configuration).getSubmissionDetails(appId, options);
            return function (fetch, basePath) {
                if (fetch === void 0) { fetch = portableFetch; }
                if (basePath === void 0) { basePath = BASE_PATH; }
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then(function (response) {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
        getSubmissionStatus: function (appId, submissionId, options) {
            var localVarFetchArgs = (0, exports.MobileAppsApiFetchParamCreator)(configuration).getSubmissionStatus(appId, submissionId, options);
            return function (fetch, basePath) {
                if (fetch === void 0) { fetch = portableFetch; }
                if (basePath === void 0) { basePath = BASE_PATH; }
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then(function (response) {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
        publish: function (appId, submissionId, platformType, options) {
            var localVarFetchArgs = (0, exports.MobileAppsApiFetchParamCreator)(configuration).publish(appId, submissionId, platformType, options);
            return function (fetch, basePath) {
                if (fetch === void 0) { fetch = portableFetch; }
                if (basePath === void 0) { basePath = BASE_PATH; }
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then(function (response) {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
        resubmission: function (appId, MobileAppsSubmission, options) {
            var localVarFetchArgs = (0, exports.MobileAppsApiFetchParamCreator)(configuration).resubmission(appId, MobileAppsSubmission, options);
            return function (fetch, basePath) {
                if (fetch === void 0) { fetch = portableFetch; }
                if (basePath === void 0) { basePath = BASE_PATH; }
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then(function (response) {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
        submission: function (appId, MobileAppsSubmission, options) {
            var localVarFetchArgs = (0, exports.MobileAppsApiFetchParamCreator)(configuration).submission(appId, MobileAppsSubmission, options);
            return function (fetch, basePath) {
                if (fetch === void 0) { fetch = portableFetch; }
                if (basePath === void 0) { basePath = BASE_PATH; }
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then(function (response) {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
        unpublish: function (appId, submissionId, platformType, options) {
            var localVarFetchArgs = (0, exports.MobileAppsApiFetchParamCreator)(configuration).unpublish(appId, submissionId, platformType, options);
            return function (fetch, basePath) {
                if (fetch === void 0) { fetch = portableFetch; }
                if (basePath === void 0) { basePath = BASE_PATH; }
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then(function (response) {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
        updateAppConfigSalesChannel: function (appId, AppConfigSalesChannel, options) {
            var localVarFetchArgs = (0, exports.MobileAppsApiFetchParamCreator)(configuration).updateAppConfigSalesChannel(appId, AppConfigSalesChannel, options);
            return function (fetch, basePath) {
                if (fetch === void 0) { fetch = portableFetch; }
                if (basePath === void 0) { basePath = BASE_PATH; }
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then(function (response) {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
        updateSubmissionStatus: function (appId, submissionId, UpdateMobileAppsSubmissionStatus, options) {
            var localVarFetchArgs = (0, exports.MobileAppsApiFetchParamCreator)(configuration).updateSubmissionStatus(appId, submissionId, UpdateMobileAppsSubmissionStatus, options);
            return function (fetch, basePath) {
                if (fetch === void 0) { fetch = portableFetch; }
                if (basePath === void 0) { basePath = BASE_PATH; }
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then(function (response) {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
        uploadImage: function (appId, Image, options) {
            var localVarFetchArgs = (0, exports.MobileAppsApiFetchParamCreator)(configuration).uploadImage(appId, Image, options);
            return function (fetch, basePath) {
                if (fetch === void 0) { fetch = portableFetch; }
                if (basePath === void 0) { basePath = BASE_PATH; }
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then(function (response) {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
    };
};
exports.MobileAppsApiFp = MobileAppsApiFp;
var MobileAppsApiFactory = function (configuration, fetch, basePath) {
    return {
        getAppConfigSalesChannel: function (appId, options) {
            return (0, exports.MobileAppsApiFp)(configuration).getAppConfigSalesChannel(appId, options)(fetch, basePath);
        },
        getStatistics: function (appId, platformTypes, options) {
            return (0, exports.MobileAppsApiFp)(configuration).getStatistics(appId, platformTypes, options)(fetch, basePath);
        },
        getSubmissionDetails: function (appId, options) {
            return (0, exports.MobileAppsApiFp)(configuration).getSubmissionDetails(appId, options)(fetch, basePath);
        },
        getSubmissionStatus: function (appId, submissionId, options) {
            return (0, exports.MobileAppsApiFp)(configuration).getSubmissionStatus(appId, submissionId, options)(fetch, basePath);
        },
        publish: function (appId, submissionId, platformType, options) {
            return (0, exports.MobileAppsApiFp)(configuration).publish(appId, submissionId, platformType, options)(fetch, basePath);
        },
        resubmission: function (appId, MobileAppsSubmission, options) {
            return (0, exports.MobileAppsApiFp)(configuration).resubmission(appId, MobileAppsSubmission, options)(fetch, basePath);
        },
        submission: function (appId, MobileAppsSubmission, options) {
            return (0, exports.MobileAppsApiFp)(configuration).submission(appId, MobileAppsSubmission, options)(fetch, basePath);
        },
        unpublish: function (appId, submissionId, platformType, options) {
            return (0, exports.MobileAppsApiFp)(configuration).unpublish(appId, submissionId, platformType, options)(fetch, basePath);
        },
        updateAppConfigSalesChannel: function (appId, AppConfigSalesChannel, options) {
            return (0, exports.MobileAppsApiFp)(configuration).updateAppConfigSalesChannel(appId, AppConfigSalesChannel, options)(fetch, basePath);
        },
        updateSubmissionStatus: function (appId, submissionId, UpdateMobileAppsSubmissionStatus, options) {
            return (0, exports.MobileAppsApiFp)(configuration).updateSubmissionStatus(appId, submissionId, UpdateMobileAppsSubmissionStatus, options)(fetch, basePath);
        },
        uploadImage: function (appId, Image, options) {
            return (0, exports.MobileAppsApiFp)(configuration).uploadImage(appId, Image, options)(fetch, basePath);
        },
    };
};
exports.MobileAppsApiFactory = MobileAppsApiFactory;
var MobileAppsApi = (function (_super) {
    __extends(MobileAppsApi, _super);
    function MobileAppsApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    MobileAppsApi.prototype.getAppConfigSalesChannel = function (appId, options) {
        return (0, exports.MobileAppsApiFp)(this.configuration).getAppConfigSalesChannel(appId, options)(this.fetch, this.basePath);
    };
    MobileAppsApi.prototype.getStatistics = function (appId, platformTypes, options) {
        return (0, exports.MobileAppsApiFp)(this.configuration).getStatistics(appId, platformTypes, options)(this.fetch, this.basePath);
    };
    MobileAppsApi.prototype.getSubmissionDetails = function (appId, options) {
        return (0, exports.MobileAppsApiFp)(this.configuration).getSubmissionDetails(appId, options)(this.fetch, this.basePath);
    };
    MobileAppsApi.prototype.getSubmissionStatus = function (appId, submissionId, options) {
        return (0, exports.MobileAppsApiFp)(this.configuration).getSubmissionStatus(appId, submissionId, options)(this.fetch, this.basePath);
    };
    MobileAppsApi.prototype.publish = function (appId, submissionId, platformType, options) {
        return (0, exports.MobileAppsApiFp)(this.configuration).publish(appId, submissionId, platformType, options)(this.fetch, this.basePath);
    };
    MobileAppsApi.prototype.resubmission = function (appId, MobileAppsSubmission, options) {
        return (0, exports.MobileAppsApiFp)(this.configuration).resubmission(appId, MobileAppsSubmission, options)(this.fetch, this.basePath);
    };
    MobileAppsApi.prototype.submission = function (appId, MobileAppsSubmission, options) {
        return (0, exports.MobileAppsApiFp)(this.configuration).submission(appId, MobileAppsSubmission, options)(this.fetch, this.basePath);
    };
    MobileAppsApi.prototype.unpublish = function (appId, submissionId, platformType, options) {
        return (0, exports.MobileAppsApiFp)(this.configuration).unpublish(appId, submissionId, platformType, options)(this.fetch, this.basePath);
    };
    MobileAppsApi.prototype.updateAppConfigSalesChannel = function (appId, AppConfigSalesChannel, options) {
        return (0, exports.MobileAppsApiFp)(this.configuration).updateAppConfigSalesChannel(appId, AppConfigSalesChannel, options)(this.fetch, this.basePath);
    };
    MobileAppsApi.prototype.updateSubmissionStatus = function (appId, submissionId, UpdateMobileAppsSubmissionStatus, options) {
        return (0, exports.MobileAppsApiFp)(this.configuration).updateSubmissionStatus(appId, submissionId, UpdateMobileAppsSubmissionStatus, options)(this.fetch, this.basePath);
    };
    MobileAppsApi.prototype.uploadImage = function (appId, Image, options) {
        return (0, exports.MobileAppsApiFp)(this.configuration).uploadImage(appId, Image, options)(this.fetch, this.basePath);
    };
    return MobileAppsApi;
}(BaseAPI));
exports.MobileAppsApi = MobileAppsApi;
var OAuthClientsApiFetchParamCreator = function (configuration) {
    return {
        addRedirectUri: function (oauthAppId, appId, body, options) {
            if (options === void 0) { options = {}; }
            if (oauthAppId === null || oauthAppId === undefined) {
                throw new RequiredError('oauthAppId', 'Required parameter oauthAppId was null or undefined when calling addRedirectUri.');
            }
            if (appId === null || appId === undefined) {
                throw new RequiredError('appId', 'Required parameter appId was null or undefined when calling addRedirectUri.');
            }
            if (body === null || body === undefined) {
                throw new RequiredError('body', 'Required parameter body was null or undefined when calling addRedirectUri.');
            }
            var localVarPath = "/api/v1.0/{appId}/oauthclients/{oauthAppId}/redirecturis"
                .replace("{".concat("oauthAppId", "}"), encodeURIComponent(String(oauthAppId)))
                .replace("{".concat("appId", "}"), encodeURIComponent(String(appId)));
            var localVarUrlObj = url.parse(localVarPath, true);
            var localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            var localVarHeaderParameter = {};
            var localVarQueryParameter = {};
            if (configuration && configuration.accessToken) {
                var localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("oauth2", ["api"])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }
            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            var needsSerialization = ("string" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body = needsSerialization ? JSON.stringify(body || {}) : (body || "");
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        createOAuthApp: function (appId, OAuthApp, options) {
            if (options === void 0) { options = {}; }
            if (appId === null || appId === undefined) {
                throw new RequiredError('appId', 'Required parameter appId was null or undefined when calling createOAuthApp.');
            }
            if (OAuthApp === null || OAuthApp === undefined) {
                throw new RequiredError('OAuthApp', 'Required parameter OAuthApp was null or undefined when calling createOAuthApp.');
            }
            var localVarPath = "/api/v1.0/{appId}/oauthclients"
                .replace("{".concat("appId", "}"), encodeURIComponent(String(appId)));
            var localVarUrlObj = url.parse(localVarPath, true);
            var localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            var localVarHeaderParameter = {};
            var localVarQueryParameter = {};
            if (configuration && configuration.accessToken) {
                var localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("oauth2", ["api"])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }
            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            var needsSerialization = ("OAuthApp" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body = needsSerialization ? JSON.stringify(OAuthApp || {}) : (OAuthApp || "");
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        deleteOAuthApp: function (oauthAppId, appId, options) {
            if (options === void 0) { options = {}; }
            if (oauthAppId === null || oauthAppId === undefined) {
                throw new RequiredError('oauthAppId', 'Required parameter oauthAppId was null or undefined when calling deleteOAuthApp.');
            }
            if (appId === null || appId === undefined) {
                throw new RequiredError('appId', 'Required parameter appId was null or undefined when calling deleteOAuthApp.');
            }
            var localVarPath = "/api/v1.0/{appId}/oauthclients/{oauthAppId}"
                .replace("{".concat("oauthAppId", "}"), encodeURIComponent(String(oauthAppId)))
                .replace("{".concat("appId", "}"), encodeURIComponent(String(appId)));
            var localVarUrlObj = url.parse(localVarPath, true);
            var localVarRequestOptions = Object.assign({ method: 'DELETE' }, options);
            var localVarHeaderParameter = {};
            var localVarQueryParameter = {};
            if (configuration && configuration.accessToken) {
                var localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("oauth2", ["api"])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        getOAuthApps: function (appId, oauthAppName, options) {
            if (options === void 0) { options = {}; }
            if (appId === null || appId === undefined) {
                throw new RequiredError('appId', 'Required parameter appId was null or undefined when calling getOAuthApps.');
            }
            var localVarPath = "/api/v1.0/{appId}/oauthclients"
                .replace("{".concat("appId", "}"), encodeURIComponent(String(appId)));
            var localVarUrlObj = url.parse(localVarPath, true);
            var localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            var localVarHeaderParameter = {};
            var localVarQueryParameter = {};
            if (configuration && configuration.accessToken) {
                var localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("oauth2", ["api"])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }
            if (oauthAppName !== undefined) {
                localVarQueryParameter['oauthAppName'] = oauthAppName;
            }
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        getOAuthClientByClientId: function (oauthAppId, appId, options) {
            if (options === void 0) { options = {}; }
            if (oauthAppId === null || oauthAppId === undefined) {
                throw new RequiredError('oauthAppId', 'Required parameter oauthAppId was null or undefined when calling getOAuthClientByClientId.');
            }
            if (appId === null || appId === undefined) {
                throw new RequiredError('appId', 'Required parameter appId was null or undefined when calling getOAuthClientByClientId.');
            }
            var localVarPath = "/api/v1.0/{appId}/oauthclients/{oauthAppId}"
                .replace("{".concat("oauthAppId", "}"), encodeURIComponent(String(oauthAppId)))
                .replace("{".concat("appId", "}"), encodeURIComponent(String(appId)));
            var localVarUrlObj = url.parse(localVarPath, true);
            var localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            var localVarHeaderParameter = {};
            var localVarQueryParameter = {};
            if (configuration && configuration.accessToken) {
                var localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("oauth2", ["api"])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        getOAuthClientSecret: function (oauthAppId, appId, options) {
            if (options === void 0) { options = {}; }
            if (oauthAppId === null || oauthAppId === undefined) {
                throw new RequiredError('oauthAppId', 'Required parameter oauthAppId was null or undefined when calling getOAuthClientSecret.');
            }
            if (appId === null || appId === undefined) {
                throw new RequiredError('appId', 'Required parameter appId was null or undefined when calling getOAuthClientSecret.');
            }
            var localVarPath = "/api/v1.0/{appId}/oauthclients/{oauthAppId}/secret"
                .replace("{".concat("oauthAppId", "}"), encodeURIComponent(String(oauthAppId)))
                .replace("{".concat("appId", "}"), encodeURIComponent(String(appId)));
            var localVarUrlObj = url.parse(localVarPath, true);
            var localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            var localVarHeaderParameter = {};
            var localVarQueryParameter = {};
            if (configuration && configuration.accessToken) {
                var localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("oauth2", ["api"])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        getOauthAccessToken: function (oauthAppId, appId, options) {
            if (options === void 0) { options = {}; }
            if (oauthAppId === null || oauthAppId === undefined) {
                throw new RequiredError('oauthAppId', 'Required parameter oauthAppId was null or undefined when calling getOauthAccessToken.');
            }
            if (appId === null || appId === undefined) {
                throw new RequiredError('appId', 'Required parameter appId was null or undefined when calling getOauthAccessToken.');
            }
            var localVarPath = "/api/v1.0/{appId}/oauthclients/{oauthAppId}/accesstoken"
                .replace("{".concat("oauthAppId", "}"), encodeURIComponent(String(oauthAppId)))
                .replace("{".concat("appId", "}"), encodeURIComponent(String(appId)));
            var localVarUrlObj = url.parse(localVarPath, true);
            var localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            var localVarHeaderParameter = {};
            var localVarQueryParameter = {};
            if (configuration && configuration.accessToken) {
                var localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("oauth2", ["api"])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        getRedirectUris: function (oauthAppId, appId, options) {
            if (options === void 0) { options = {}; }
            if (oauthAppId === null || oauthAppId === undefined) {
                throw new RequiredError('oauthAppId', 'Required parameter oauthAppId was null or undefined when calling getRedirectUris.');
            }
            if (appId === null || appId === undefined) {
                throw new RequiredError('appId', 'Required parameter appId was null or undefined when calling getRedirectUris.');
            }
            var localVarPath = "/api/v1.0/{appId}/oauthclients/{oauthAppId}/redirecturis"
                .replace("{".concat("oauthAppId", "}"), encodeURIComponent(String(oauthAppId)))
                .replace("{".concat("appId", "}"), encodeURIComponent(String(appId)));
            var localVarUrlObj = url.parse(localVarPath, true);
            var localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            var localVarHeaderParameter = {};
            var localVarQueryParameter = {};
            if (configuration && configuration.accessToken) {
                var localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("oauth2", ["api"])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        oAuthClientsGetApplications: function (appId, options) {
            if (options === void 0) { options = {}; }
            if (appId === null || appId === undefined) {
                throw new RequiredError('appId', 'Required parameter appId was null or undefined when calling oAuthClientsGetApplications.');
            }
            var localVarPath = "/api/v1.0/{appId}/oauthclients/appnames"
                .replace("{".concat("appId", "}"), encodeURIComponent(String(appId)));
            var localVarUrlObj = url.parse(localVarPath, true);
            var localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            var localVarHeaderParameter = {};
            var localVarQueryParameter = {};
            if (configuration && configuration.accessToken) {
                var localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("oauth2", ["api"])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        removeRedirectUri: function (oauthAppId, uriId, appId, options) {
            if (options === void 0) { options = {}; }
            if (oauthAppId === null || oauthAppId === undefined) {
                throw new RequiredError('oauthAppId', 'Required parameter oauthAppId was null or undefined when calling removeRedirectUri.');
            }
            if (uriId === null || uriId === undefined) {
                throw new RequiredError('uriId', 'Required parameter uriId was null or undefined when calling removeRedirectUri.');
            }
            if (appId === null || appId === undefined) {
                throw new RequiredError('appId', 'Required parameter appId was null or undefined when calling removeRedirectUri.');
            }
            var localVarPath = "/api/v1.0/{appId}/oauthclients/{oauthAppId}/redirecturis/{uriId}"
                .replace("{".concat("oauthAppId", "}"), encodeURIComponent(String(oauthAppId)))
                .replace("{".concat("uriId", "}"), encodeURIComponent(String(uriId)))
                .replace("{".concat("appId", "}"), encodeURIComponent(String(appId)));
            var localVarUrlObj = url.parse(localVarPath, true);
            var localVarRequestOptions = Object.assign({ method: 'DELETE' }, options);
            var localVarHeaderParameter = {};
            var localVarQueryParameter = {};
            if (configuration && configuration.accessToken) {
                var localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("oauth2", ["api"])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        updateOAuthApp: function (oauthAppId, appId, OAuthApp, options) {
            if (options === void 0) { options = {}; }
            if (oauthAppId === null || oauthAppId === undefined) {
                throw new RequiredError('oauthAppId', 'Required parameter oauthAppId was null or undefined when calling updateOAuthApp.');
            }
            if (appId === null || appId === undefined) {
                throw new RequiredError('appId', 'Required parameter appId was null or undefined when calling updateOAuthApp.');
            }
            if (OAuthApp === null || OAuthApp === undefined) {
                throw new RequiredError('OAuthApp', 'Required parameter OAuthApp was null or undefined when calling updateOAuthApp.');
            }
            var localVarPath = "/api/v1.0/{appId}/oauthclients/{oauthAppId}"
                .replace("{".concat("oauthAppId", "}"), encodeURIComponent(String(oauthAppId)))
                .replace("{".concat("appId", "}"), encodeURIComponent(String(appId)));
            var localVarUrlObj = url.parse(localVarPath, true);
            var localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            var localVarHeaderParameter = {};
            var localVarQueryParameter = {};
            if (configuration && configuration.accessToken) {
                var localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("oauth2", ["api"])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }
            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            var needsSerialization = ("OAuthApp" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body = needsSerialization ? JSON.stringify(OAuthApp || {}) : (OAuthApp || "");
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    };
};
exports.OAuthClientsApiFetchParamCreator = OAuthClientsApiFetchParamCreator;
var OAuthClientsApiFp = function (configuration) {
    return {
        addRedirectUri: function (oauthAppId, appId, body, options) {
            var localVarFetchArgs = (0, exports.OAuthClientsApiFetchParamCreator)(configuration).addRedirectUri(oauthAppId, appId, body, options);
            return function (fetch, basePath) {
                if (fetch === void 0) { fetch = portableFetch; }
                if (basePath === void 0) { basePath = BASE_PATH; }
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then(function (response) {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
        createOAuthApp: function (appId, OAuthApp, options) {
            var localVarFetchArgs = (0, exports.OAuthClientsApiFetchParamCreator)(configuration).createOAuthApp(appId, OAuthApp, options);
            return function (fetch, basePath) {
                if (fetch === void 0) { fetch = portableFetch; }
                if (basePath === void 0) { basePath = BASE_PATH; }
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then(function (response) {
                    if (response.status >= 200 && response.status < 300) {
                        return response;
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
        deleteOAuthApp: function (oauthAppId, appId, options) {
            var localVarFetchArgs = (0, exports.OAuthClientsApiFetchParamCreator)(configuration).deleteOAuthApp(oauthAppId, appId, options);
            return function (fetch, basePath) {
                if (fetch === void 0) { fetch = portableFetch; }
                if (basePath === void 0) { basePath = BASE_PATH; }
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then(function (response) {
                    if (response.status >= 200 && response.status < 300) {
                        return response;
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
        getOAuthApps: function (appId, oauthAppName, options) {
            var localVarFetchArgs = (0, exports.OAuthClientsApiFetchParamCreator)(configuration).getOAuthApps(appId, oauthAppName, options);
            return function (fetch, basePath) {
                if (fetch === void 0) { fetch = portableFetch; }
                if (basePath === void 0) { basePath = BASE_PATH; }
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then(function (response) {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
        getOAuthClientByClientId: function (oauthAppId, appId, options) {
            var localVarFetchArgs = (0, exports.OAuthClientsApiFetchParamCreator)(configuration).getOAuthClientByClientId(oauthAppId, appId, options);
            return function (fetch, basePath) {
                if (fetch === void 0) { fetch = portableFetch; }
                if (basePath === void 0) { basePath = BASE_PATH; }
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then(function (response) {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
        getOAuthClientSecret: function (oauthAppId, appId, options) {
            var localVarFetchArgs = (0, exports.OAuthClientsApiFetchParamCreator)(configuration).getOAuthClientSecret(oauthAppId, appId, options);
            return function (fetch, basePath) {
                if (fetch === void 0) { fetch = portableFetch; }
                if (basePath === void 0) { basePath = BASE_PATH; }
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then(function (response) {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
        getOauthAccessToken: function (oauthAppId, appId, options) {
            var localVarFetchArgs = (0, exports.OAuthClientsApiFetchParamCreator)(configuration).getOauthAccessToken(oauthAppId, appId, options);
            return function (fetch, basePath) {
                if (fetch === void 0) { fetch = portableFetch; }
                if (basePath === void 0) { basePath = BASE_PATH; }
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then(function (response) {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
        getRedirectUris: function (oauthAppId, appId, options) {
            var localVarFetchArgs = (0, exports.OAuthClientsApiFetchParamCreator)(configuration).getRedirectUris(oauthAppId, appId, options);
            return function (fetch, basePath) {
                if (fetch === void 0) { fetch = portableFetch; }
                if (basePath === void 0) { basePath = BASE_PATH; }
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then(function (response) {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
        oAuthClientsGetApplications: function (appId, options) {
            var localVarFetchArgs = (0, exports.OAuthClientsApiFetchParamCreator)(configuration).oAuthClientsGetApplications(appId, options);
            return function (fetch, basePath) {
                if (fetch === void 0) { fetch = portableFetch; }
                if (basePath === void 0) { basePath = BASE_PATH; }
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then(function (response) {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
        removeRedirectUri: function (oauthAppId, uriId, appId, options) {
            var localVarFetchArgs = (0, exports.OAuthClientsApiFetchParamCreator)(configuration).removeRedirectUri(oauthAppId, uriId, appId, options);
            return function (fetch, basePath) {
                if (fetch === void 0) { fetch = portableFetch; }
                if (basePath === void 0) { basePath = BASE_PATH; }
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then(function (response) {
                    if (response.status >= 200 && response.status < 300) {
                        return response;
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
        updateOAuthApp: function (oauthAppId, appId, OAuthApp, options) {
            var localVarFetchArgs = (0, exports.OAuthClientsApiFetchParamCreator)(configuration).updateOAuthApp(oauthAppId, appId, OAuthApp, options);
            return function (fetch, basePath) {
                if (fetch === void 0) { fetch = portableFetch; }
                if (basePath === void 0) { basePath = BASE_PATH; }
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then(function (response) {
                    if (response.status >= 200 && response.status < 300) {
                        return response;
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
    };
};
exports.OAuthClientsApiFp = OAuthClientsApiFp;
var OAuthClientsApiFactory = function (configuration, fetch, basePath) {
    return {
        addRedirectUri: function (oauthAppId, appId, body, options) {
            return (0, exports.OAuthClientsApiFp)(configuration).addRedirectUri(oauthAppId, appId, body, options)(fetch, basePath);
        },
        createOAuthApp: function (appId, OAuthApp, options) {
            return (0, exports.OAuthClientsApiFp)(configuration).createOAuthApp(appId, OAuthApp, options)(fetch, basePath);
        },
        deleteOAuthApp: function (oauthAppId, appId, options) {
            return (0, exports.OAuthClientsApiFp)(configuration).deleteOAuthApp(oauthAppId, appId, options)(fetch, basePath);
        },
        getOAuthApps: function (appId, oauthAppName, options) {
            return (0, exports.OAuthClientsApiFp)(configuration).getOAuthApps(appId, oauthAppName, options)(fetch, basePath);
        },
        getOAuthClientByClientId: function (oauthAppId, appId, options) {
            return (0, exports.OAuthClientsApiFp)(configuration).getOAuthClientByClientId(oauthAppId, appId, options)(fetch, basePath);
        },
        getOAuthClientSecret: function (oauthAppId, appId, options) {
            return (0, exports.OAuthClientsApiFp)(configuration).getOAuthClientSecret(oauthAppId, appId, options)(fetch, basePath);
        },
        getOauthAccessToken: function (oauthAppId, appId, options) {
            return (0, exports.OAuthClientsApiFp)(configuration).getOauthAccessToken(oauthAppId, appId, options)(fetch, basePath);
        },
        getRedirectUris: function (oauthAppId, appId, options) {
            return (0, exports.OAuthClientsApiFp)(configuration).getRedirectUris(oauthAppId, appId, options)(fetch, basePath);
        },
        oAuthClientsGetApplications: function (appId, options) {
            return (0, exports.OAuthClientsApiFp)(configuration).oAuthClientsGetApplications(appId, options)(fetch, basePath);
        },
        removeRedirectUri: function (oauthAppId, uriId, appId, options) {
            return (0, exports.OAuthClientsApiFp)(configuration).removeRedirectUri(oauthAppId, uriId, appId, options)(fetch, basePath);
        },
        updateOAuthApp: function (oauthAppId, appId, OAuthApp, options) {
            return (0, exports.OAuthClientsApiFp)(configuration).updateOAuthApp(oauthAppId, appId, OAuthApp, options)(fetch, basePath);
        },
    };
};
exports.OAuthClientsApiFactory = OAuthClientsApiFactory;
var OAuthClientsApi = (function (_super) {
    __extends(OAuthClientsApi, _super);
    function OAuthClientsApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    OAuthClientsApi.prototype.addRedirectUri = function (oauthAppId, appId, body, options) {
        return (0, exports.OAuthClientsApiFp)(this.configuration).addRedirectUri(oauthAppId, appId, body, options)(this.fetch, this.basePath);
    };
    OAuthClientsApi.prototype.createOAuthApp = function (appId, OAuthApp, options) {
        return (0, exports.OAuthClientsApiFp)(this.configuration).createOAuthApp(appId, OAuthApp, options)(this.fetch, this.basePath);
    };
    OAuthClientsApi.prototype.deleteOAuthApp = function (oauthAppId, appId, options) {
        return (0, exports.OAuthClientsApiFp)(this.configuration).deleteOAuthApp(oauthAppId, appId, options)(this.fetch, this.basePath);
    };
    OAuthClientsApi.prototype.getOAuthApps = function (appId, oauthAppName, options) {
        return (0, exports.OAuthClientsApiFp)(this.configuration).getOAuthApps(appId, oauthAppName, options)(this.fetch, this.basePath);
    };
    OAuthClientsApi.prototype.getOAuthClientByClientId = function (oauthAppId, appId, options) {
        return (0, exports.OAuthClientsApiFp)(this.configuration).getOAuthClientByClientId(oauthAppId, appId, options)(this.fetch, this.basePath);
    };
    OAuthClientsApi.prototype.getOAuthClientSecret = function (oauthAppId, appId, options) {
        return (0, exports.OAuthClientsApiFp)(this.configuration).getOAuthClientSecret(oauthAppId, appId, options)(this.fetch, this.basePath);
    };
    OAuthClientsApi.prototype.getOauthAccessToken = function (oauthAppId, appId, options) {
        return (0, exports.OAuthClientsApiFp)(this.configuration).getOauthAccessToken(oauthAppId, appId, options)(this.fetch, this.basePath);
    };
    OAuthClientsApi.prototype.getRedirectUris = function (oauthAppId, appId, options) {
        return (0, exports.OAuthClientsApiFp)(this.configuration).getRedirectUris(oauthAppId, appId, options)(this.fetch, this.basePath);
    };
    OAuthClientsApi.prototype.oAuthClientsGetApplications = function (appId, options) {
        return (0, exports.OAuthClientsApiFp)(this.configuration).oAuthClientsGetApplications(appId, options)(this.fetch, this.basePath);
    };
    OAuthClientsApi.prototype.removeRedirectUri = function (oauthAppId, uriId, appId, options) {
        return (0, exports.OAuthClientsApiFp)(this.configuration).removeRedirectUri(oauthAppId, uriId, appId, options)(this.fetch, this.basePath);
    };
    OAuthClientsApi.prototype.updateOAuthApp = function (oauthAppId, appId, OAuthApp, options) {
        return (0, exports.OAuthClientsApiFp)(this.configuration).updateOAuthApp(oauthAppId, appId, OAuthApp, options)(this.fetch, this.basePath);
    };
    return OAuthClientsApi;
}(BaseAPI));
exports.OAuthClientsApi = OAuthClientsApi;
var OnboardingApiFetchParamCreator = function (configuration) {
    return {
        onboardingGetOnboardingConfig: function (appId, options) {
            if (options === void 0) { options = {}; }
            if (appId === null || appId === undefined) {
                throw new RequiredError('appId', 'Required parameter appId was null or undefined when calling onboardingGetOnboardingConfig.');
            }
            var localVarPath = "/api/v1.0/clients/{appId}/onboarding/config"
                .replace("{".concat("appId", "}"), encodeURIComponent(String(appId)));
            var localVarUrlObj = url.parse(localVarPath, true);
            var localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            var localVarHeaderParameter = {};
            var localVarQueryParameter = {};
            if (configuration && configuration.accessToken) {
                var localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("oauth2", ["api"])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        onboardingGetOnboardingConfigs: function (appId, options) {
            if (options === void 0) { options = {}; }
            if (appId === null || appId === undefined) {
                throw new RequiredError('appId', 'Required parameter appId was null or undefined when calling onboardingGetOnboardingConfigs.');
            }
            var localVarPath = "/api/v1.0/clients/{appId}/onboarding/configs"
                .replace("{".concat("appId", "}"), encodeURIComponent(String(appId)));
            var localVarUrlObj = url.parse(localVarPath, true);
            var localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            var localVarHeaderParameter = {};
            var localVarQueryParameter = {};
            if (configuration && configuration.accessToken) {
                var localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("oauth2", ["api"])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        onboardingGetOnboardingItems: function (appId, storeId, milestoneId, options) {
            if (options === void 0) { options = {}; }
            if (appId === null || appId === undefined) {
                throw new RequiredError('appId', 'Required parameter appId was null or undefined when calling onboardingGetOnboardingItems.');
            }
            if (storeId === null || storeId === undefined) {
                throw new RequiredError('storeId', 'Required parameter storeId was null or undefined when calling onboardingGetOnboardingItems.');
            }
            var localVarPath = "/api/v1.0/clients/{appId}/onboarding/stores/{storeId}"
                .replace("{".concat("appId", "}"), encodeURIComponent(String(appId)))
                .replace("{".concat("storeId", "}"), encodeURIComponent(String(storeId)));
            var localVarUrlObj = url.parse(localVarPath, true);
            var localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            var localVarHeaderParameter = {};
            var localVarQueryParameter = {};
            if (configuration && configuration.accessToken) {
                var localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("oauth2", ["api"])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }
            if (milestoneId !== undefined) {
                localVarQueryParameter['milestoneId'] = milestoneId;
            }
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        onboardingGetOnboardingItemsV2: function (appId, storeId, milestoneId, options) {
            if (options === void 0) { options = {}; }
            if (appId === null || appId === undefined) {
                throw new RequiredError('appId', 'Required parameter appId was null or undefined when calling onboardingGetOnboardingItemsV2.');
            }
            var localVarPath = "/api/v1.0/clients/{appId}/onboarding/stores"
                .replace("{".concat("appId", "}"), encodeURIComponent(String(appId)));
            var localVarUrlObj = url.parse(localVarPath, true);
            var localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            var localVarHeaderParameter = {};
            var localVarQueryParameter = {};
            if (configuration && configuration.accessToken) {
                var localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("oauth2", ["api"])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }
            if (storeId !== undefined) {
                localVarQueryParameter['storeId'] = storeId;
            }
            if (milestoneId !== undefined) {
                localVarQueryParameter['milestoneId'] = milestoneId;
            }
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        onboardingUpdateOnboardingConfig: function (appId, OnboardingConfigUpdate, options) {
            if (options === void 0) { options = {}; }
            if (appId === null || appId === undefined) {
                throw new RequiredError('appId', 'Required parameter appId was null or undefined when calling onboardingUpdateOnboardingConfig.');
            }
            if (OnboardingConfigUpdate === null || OnboardingConfigUpdate === undefined) {
                throw new RequiredError('OnboardingConfigUpdate', 'Required parameter OnboardingConfigUpdate was null or undefined when calling onboardingUpdateOnboardingConfig.');
            }
            var localVarPath = "/api/v1.0/clients/{appId}/onboarding/config"
                .replace("{".concat("appId", "}"), encodeURIComponent(String(appId)));
            var localVarUrlObj = url.parse(localVarPath, true);
            var localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            var localVarHeaderParameter = {};
            var localVarQueryParameter = {};
            if (configuration && configuration.accessToken) {
                var localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("oauth2", ["api"])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }
            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            var needsSerialization = ("OnboardingConfigUpdate" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body = needsSerialization ? JSON.stringify(OnboardingConfigUpdate || {}) : (OnboardingConfigUpdate || "");
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        onboardingUpdateOnboardingConfigById: function (appId, configId, OnboardingConfigUpdate, options) {
            if (options === void 0) { options = {}; }
            if (appId === null || appId === undefined) {
                throw new RequiredError('appId', 'Required parameter appId was null or undefined when calling onboardingUpdateOnboardingConfigById.');
            }
            if (configId === null || configId === undefined) {
                throw new RequiredError('configId', 'Required parameter configId was null or undefined when calling onboardingUpdateOnboardingConfigById.');
            }
            if (OnboardingConfigUpdate === null || OnboardingConfigUpdate === undefined) {
                throw new RequiredError('OnboardingConfigUpdate', 'Required parameter OnboardingConfigUpdate was null or undefined when calling onboardingUpdateOnboardingConfigById.');
            }
            var localVarPath = "/api/v1.0/clients/{appId}/onboarding/config/{configId}"
                .replace("{".concat("appId", "}"), encodeURIComponent(String(appId)))
                .replace("{".concat("configId", "}"), encodeURIComponent(String(configId)));
            var localVarUrlObj = url.parse(localVarPath, true);
            var localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            var localVarHeaderParameter = {};
            var localVarQueryParameter = {};
            if (configuration && configuration.accessToken) {
                var localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("oauth2", ["api"])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }
            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            var needsSerialization = ("OnboardingConfigUpdate" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body = needsSerialization ? JSON.stringify(OnboardingConfigUpdate || {}) : (OnboardingConfigUpdate || "");
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        onboardingUpdateOnboardingItem: function (appId, storeId, onboardingItemId, OnboardingItemUpdate, options) {
            if (options === void 0) { options = {}; }
            if (appId === null || appId === undefined) {
                throw new RequiredError('appId', 'Required parameter appId was null or undefined when calling onboardingUpdateOnboardingItem.');
            }
            if (storeId === null || storeId === undefined) {
                throw new RequiredError('storeId', 'Required parameter storeId was null or undefined when calling onboardingUpdateOnboardingItem.');
            }
            if (onboardingItemId === null || onboardingItemId === undefined) {
                throw new RequiredError('onboardingItemId', 'Required parameter onboardingItemId was null or undefined when calling onboardingUpdateOnboardingItem.');
            }
            if (OnboardingItemUpdate === null || OnboardingItemUpdate === undefined) {
                throw new RequiredError('OnboardingItemUpdate', 'Required parameter OnboardingItemUpdate was null or undefined when calling onboardingUpdateOnboardingItem.');
            }
            var localVarPath = "/api/v1.0/clients/{appId}/onboarding/stores/{storeId}/items/{onboardingItemId}"
                .replace("{".concat("appId", "}"), encodeURIComponent(String(appId)))
                .replace("{".concat("storeId", "}"), encodeURIComponent(String(storeId)))
                .replace("{".concat("onboardingItemId", "}"), encodeURIComponent(String(onboardingItemId)));
            var localVarUrlObj = url.parse(localVarPath, true);
            var localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            var localVarHeaderParameter = {};
            var localVarQueryParameter = {};
            if (configuration && configuration.accessToken) {
                var localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("oauth2", ["api"])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }
            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            var needsSerialization = ("OnboardingItemUpdate" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body = needsSerialization ? JSON.stringify(OnboardingItemUpdate || {}) : (OnboardingItemUpdate || "");
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        onboardingUpdateOnboardingItemV2: function (appId, onboardingItemId, OnboardingItemUpdate, storeId, options) {
            if (options === void 0) { options = {}; }
            if (appId === null || appId === undefined) {
                throw new RequiredError('appId', 'Required parameter appId was null or undefined when calling onboardingUpdateOnboardingItemV2.');
            }
            if (onboardingItemId === null || onboardingItemId === undefined) {
                throw new RequiredError('onboardingItemId', 'Required parameter onboardingItemId was null or undefined when calling onboardingUpdateOnboardingItemV2.');
            }
            if (OnboardingItemUpdate === null || OnboardingItemUpdate === undefined) {
                throw new RequiredError('OnboardingItemUpdate', 'Required parameter OnboardingItemUpdate was null or undefined when calling onboardingUpdateOnboardingItemV2.');
            }
            var localVarPath = "/api/v1.0/clients/{appId}/onboarding/stores/items/{onboardingItemId}"
                .replace("{".concat("appId", "}"), encodeURIComponent(String(appId)))
                .replace("{".concat("onboardingItemId", "}"), encodeURIComponent(String(onboardingItemId)));
            var localVarUrlObj = url.parse(localVarPath, true);
            var localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            var localVarHeaderParameter = {};
            var localVarQueryParameter = {};
            if (configuration && configuration.accessToken) {
                var localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("oauth2", ["api"])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }
            if (storeId !== undefined) {
                localVarQueryParameter['storeId'] = storeId;
            }
            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            var needsSerialization = ("OnboardingItemUpdate" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body = needsSerialization ? JSON.stringify(OnboardingItemUpdate || {}) : (OnboardingItemUpdate || "");
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    };
};
exports.OnboardingApiFetchParamCreator = OnboardingApiFetchParamCreator;
var OnboardingApiFp = function (configuration) {
    return {
        onboardingGetOnboardingConfig: function (appId, options) {
            var localVarFetchArgs = (0, exports.OnboardingApiFetchParamCreator)(configuration).onboardingGetOnboardingConfig(appId, options);
            return function (fetch, basePath) {
                if (fetch === void 0) { fetch = portableFetch; }
                if (basePath === void 0) { basePath = BASE_PATH; }
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then(function (response) {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
        onboardingGetOnboardingConfigs: function (appId, options) {
            var localVarFetchArgs = (0, exports.OnboardingApiFetchParamCreator)(configuration).onboardingGetOnboardingConfigs(appId, options);
            return function (fetch, basePath) {
                if (fetch === void 0) { fetch = portableFetch; }
                if (basePath === void 0) { basePath = BASE_PATH; }
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then(function (response) {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
        onboardingGetOnboardingItems: function (appId, storeId, milestoneId, options) {
            var localVarFetchArgs = (0, exports.OnboardingApiFetchParamCreator)(configuration).onboardingGetOnboardingItems(appId, storeId, milestoneId, options);
            return function (fetch, basePath) {
                if (fetch === void 0) { fetch = portableFetch; }
                if (basePath === void 0) { basePath = BASE_PATH; }
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then(function (response) {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
        onboardingGetOnboardingItemsV2: function (appId, storeId, milestoneId, options) {
            var localVarFetchArgs = (0, exports.OnboardingApiFetchParamCreator)(configuration).onboardingGetOnboardingItemsV2(appId, storeId, milestoneId, options);
            return function (fetch, basePath) {
                if (fetch === void 0) { fetch = portableFetch; }
                if (basePath === void 0) { basePath = BASE_PATH; }
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then(function (response) {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
        onboardingUpdateOnboardingConfig: function (appId, OnboardingConfigUpdate, options) {
            var localVarFetchArgs = (0, exports.OnboardingApiFetchParamCreator)(configuration).onboardingUpdateOnboardingConfig(appId, OnboardingConfigUpdate, options);
            return function (fetch, basePath) {
                if (fetch === void 0) { fetch = portableFetch; }
                if (basePath === void 0) { basePath = BASE_PATH; }
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then(function (response) {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
        onboardingUpdateOnboardingConfigById: function (appId, configId, OnboardingConfigUpdate, options) {
            var localVarFetchArgs = (0, exports.OnboardingApiFetchParamCreator)(configuration).onboardingUpdateOnboardingConfigById(appId, configId, OnboardingConfigUpdate, options);
            return function (fetch, basePath) {
                if (fetch === void 0) { fetch = portableFetch; }
                if (basePath === void 0) { basePath = BASE_PATH; }
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then(function (response) {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
        onboardingUpdateOnboardingItem: function (appId, storeId, onboardingItemId, OnboardingItemUpdate, options) {
            var localVarFetchArgs = (0, exports.OnboardingApiFetchParamCreator)(configuration).onboardingUpdateOnboardingItem(appId, storeId, onboardingItemId, OnboardingItemUpdate, options);
            return function (fetch, basePath) {
                if (fetch === void 0) { fetch = portableFetch; }
                if (basePath === void 0) { basePath = BASE_PATH; }
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then(function (response) {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
        onboardingUpdateOnboardingItemV2: function (appId, onboardingItemId, OnboardingItemUpdate, storeId, options) {
            var localVarFetchArgs = (0, exports.OnboardingApiFetchParamCreator)(configuration).onboardingUpdateOnboardingItemV2(appId, onboardingItemId, OnboardingItemUpdate, storeId, options);
            return function (fetch, basePath) {
                if (fetch === void 0) { fetch = portableFetch; }
                if (basePath === void 0) { basePath = BASE_PATH; }
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then(function (response) {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
    };
};
exports.OnboardingApiFp = OnboardingApiFp;
var OnboardingApiFactory = function (configuration, fetch, basePath) {
    return {
        onboardingGetOnboardingConfig: function (appId, options) {
            return (0, exports.OnboardingApiFp)(configuration).onboardingGetOnboardingConfig(appId, options)(fetch, basePath);
        },
        onboardingGetOnboardingConfigs: function (appId, options) {
            return (0, exports.OnboardingApiFp)(configuration).onboardingGetOnboardingConfigs(appId, options)(fetch, basePath);
        },
        onboardingGetOnboardingItems: function (appId, storeId, milestoneId, options) {
            return (0, exports.OnboardingApiFp)(configuration).onboardingGetOnboardingItems(appId, storeId, milestoneId, options)(fetch, basePath);
        },
        onboardingGetOnboardingItemsV2: function (appId, storeId, milestoneId, options) {
            return (0, exports.OnboardingApiFp)(configuration).onboardingGetOnboardingItemsV2(appId, storeId, milestoneId, options)(fetch, basePath);
        },
        onboardingUpdateOnboardingConfig: function (appId, OnboardingConfigUpdate, options) {
            return (0, exports.OnboardingApiFp)(configuration).onboardingUpdateOnboardingConfig(appId, OnboardingConfigUpdate, options)(fetch, basePath);
        },
        onboardingUpdateOnboardingConfigById: function (appId, configId, OnboardingConfigUpdate, options) {
            return (0, exports.OnboardingApiFp)(configuration).onboardingUpdateOnboardingConfigById(appId, configId, OnboardingConfigUpdate, options)(fetch, basePath);
        },
        onboardingUpdateOnboardingItem: function (appId, storeId, onboardingItemId, OnboardingItemUpdate, options) {
            return (0, exports.OnboardingApiFp)(configuration).onboardingUpdateOnboardingItem(appId, storeId, onboardingItemId, OnboardingItemUpdate, options)(fetch, basePath);
        },
        onboardingUpdateOnboardingItemV2: function (appId, onboardingItemId, OnboardingItemUpdate, storeId, options) {
            return (0, exports.OnboardingApiFp)(configuration).onboardingUpdateOnboardingItemV2(appId, onboardingItemId, OnboardingItemUpdate, storeId, options)(fetch, basePath);
        },
    };
};
exports.OnboardingApiFactory = OnboardingApiFactory;
var OnboardingApi = (function (_super) {
    __extends(OnboardingApi, _super);
    function OnboardingApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    OnboardingApi.prototype.onboardingGetOnboardingConfig = function (appId, options) {
        return (0, exports.OnboardingApiFp)(this.configuration).onboardingGetOnboardingConfig(appId, options)(this.fetch, this.basePath);
    };
    OnboardingApi.prototype.onboardingGetOnboardingConfigs = function (appId, options) {
        return (0, exports.OnboardingApiFp)(this.configuration).onboardingGetOnboardingConfigs(appId, options)(this.fetch, this.basePath);
    };
    OnboardingApi.prototype.onboardingGetOnboardingItems = function (appId, storeId, milestoneId, options) {
        return (0, exports.OnboardingApiFp)(this.configuration).onboardingGetOnboardingItems(appId, storeId, milestoneId, options)(this.fetch, this.basePath);
    };
    OnboardingApi.prototype.onboardingGetOnboardingItemsV2 = function (appId, storeId, milestoneId, options) {
        return (0, exports.OnboardingApiFp)(this.configuration).onboardingGetOnboardingItemsV2(appId, storeId, milestoneId, options)(this.fetch, this.basePath);
    };
    OnboardingApi.prototype.onboardingUpdateOnboardingConfig = function (appId, OnboardingConfigUpdate, options) {
        return (0, exports.OnboardingApiFp)(this.configuration).onboardingUpdateOnboardingConfig(appId, OnboardingConfigUpdate, options)(this.fetch, this.basePath);
    };
    OnboardingApi.prototype.onboardingUpdateOnboardingConfigById = function (appId, configId, OnboardingConfigUpdate, options) {
        return (0, exports.OnboardingApiFp)(this.configuration).onboardingUpdateOnboardingConfigById(appId, configId, OnboardingConfigUpdate, options)(this.fetch, this.basePath);
    };
    OnboardingApi.prototype.onboardingUpdateOnboardingItem = function (appId, storeId, onboardingItemId, OnboardingItemUpdate, options) {
        return (0, exports.OnboardingApiFp)(this.configuration).onboardingUpdateOnboardingItem(appId, storeId, onboardingItemId, OnboardingItemUpdate, options)(this.fetch, this.basePath);
    };
    OnboardingApi.prototype.onboardingUpdateOnboardingItemV2 = function (appId, onboardingItemId, OnboardingItemUpdate, storeId, options) {
        return (0, exports.OnboardingApiFp)(this.configuration).onboardingUpdateOnboardingItemV2(appId, onboardingItemId, OnboardingItemUpdate, storeId, options)(this.fetch, this.basePath);
    };
    return OnboardingApi;
}(BaseAPI));
exports.OnboardingApi = OnboardingApi;
var OrderBatchesApiFetchParamCreator = function (configuration) {
    return {
        getAllOrderBatches: function (appId, storeIds, createdFrom, createdTo, options) {
            if (options === void 0) { options = {}; }
            if (appId === null || appId === undefined) {
                throw new RequiredError('appId', 'Required parameter appId was null or undefined when calling getAllOrderBatches.');
            }
            var localVarPath = "/api/v1.0/{appId}/order-batches"
                .replace("{".concat("appId", "}"), encodeURIComponent(String(appId)));
            var localVarUrlObj = url.parse(localVarPath, true);
            var localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            var localVarHeaderParameter = {};
            var localVarQueryParameter = {};
            if (configuration && configuration.accessToken) {
                var localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("oauth2", ["api"])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }
            if (storeIds) {
                localVarQueryParameter['storeIds'] = storeIds;
            }
            if (createdFrom !== undefined) {
                localVarQueryParameter['createdFrom'] = createdFrom;
            }
            if (createdTo !== undefined) {
                localVarQueryParameter['createdTo'] = createdTo;
            }
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        getOrderBatch: function (appId, orderBatchId, options) {
            if (options === void 0) { options = {}; }
            if (appId === null || appId === undefined) {
                throw new RequiredError('appId', 'Required parameter appId was null or undefined when calling getOrderBatch.');
            }
            if (orderBatchId === null || orderBatchId === undefined) {
                throw new RequiredError('orderBatchId', 'Required parameter orderBatchId was null or undefined when calling getOrderBatch.');
            }
            var localVarPath = "/api/v1.0/{appId}/order-batches/{orderBatchId}"
                .replace("{".concat("appId", "}"), encodeURIComponent(String(appId)))
                .replace("{".concat("orderBatchId", "}"), encodeURIComponent(String(orderBatchId)));
            var localVarUrlObj = url.parse(localVarPath, true);
            var localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            var localVarHeaderParameter = {};
            var localVarQueryParameter = {};
            if (configuration && configuration.accessToken) {
                var localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("oauth2", ["api"])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    };
};
exports.OrderBatchesApiFetchParamCreator = OrderBatchesApiFetchParamCreator;
var OrderBatchesApiFp = function (configuration) {
    return {
        getAllOrderBatches: function (appId, storeIds, createdFrom, createdTo, options) {
            var localVarFetchArgs = (0, exports.OrderBatchesApiFetchParamCreator)(configuration).getAllOrderBatches(appId, storeIds, createdFrom, createdTo, options);
            return function (fetch, basePath) {
                if (fetch === void 0) { fetch = portableFetch; }
                if (basePath === void 0) { basePath = BASE_PATH; }
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then(function (response) {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
        getOrderBatch: function (appId, orderBatchId, options) {
            var localVarFetchArgs = (0, exports.OrderBatchesApiFetchParamCreator)(configuration).getOrderBatch(appId, orderBatchId, options);
            return function (fetch, basePath) {
                if (fetch === void 0) { fetch = portableFetch; }
                if (basePath === void 0) { basePath = BASE_PATH; }
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then(function (response) {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
    };
};
exports.OrderBatchesApiFp = OrderBatchesApiFp;
var OrderBatchesApiFactory = function (configuration, fetch, basePath) {
    return {
        getAllOrderBatches: function (appId, storeIds, createdFrom, createdTo, options) {
            return (0, exports.OrderBatchesApiFp)(configuration).getAllOrderBatches(appId, storeIds, createdFrom, createdTo, options)(fetch, basePath);
        },
        getOrderBatch: function (appId, orderBatchId, options) {
            return (0, exports.OrderBatchesApiFp)(configuration).getOrderBatch(appId, orderBatchId, options)(fetch, basePath);
        },
    };
};
exports.OrderBatchesApiFactory = OrderBatchesApiFactory;
var OrderBatchesApi = (function (_super) {
    __extends(OrderBatchesApi, _super);
    function OrderBatchesApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    OrderBatchesApi.prototype.getAllOrderBatches = function (appId, storeIds, createdFrom, createdTo, options) {
        return (0, exports.OrderBatchesApiFp)(this.configuration).getAllOrderBatches(appId, storeIds, createdFrom, createdTo, options)(this.fetch, this.basePath);
    };
    OrderBatchesApi.prototype.getOrderBatch = function (appId, orderBatchId, options) {
        return (0, exports.OrderBatchesApiFp)(this.configuration).getOrderBatch(appId, orderBatchId, options)(this.fetch, this.basePath);
    };
    return OrderBatchesApi;
}(BaseAPI));
exports.OrderBatchesApi = OrderBatchesApi;
var OrderBatchingConfigurationApiFetchParamCreator = function (configuration) {
    return {
        get: function (storeId, options) {
            if (options === void 0) { options = {}; }
            if (storeId === null || storeId === undefined) {
                throw new RequiredError('storeId', 'Required parameter storeId was null or undefined when calling get.');
            }
            var localVarPath = "/api/v1.0/stores/{storeId}/order-batching-configuration"
                .replace("{".concat("storeId", "}"), encodeURIComponent(String(storeId)));
            var localVarUrlObj = url.parse(localVarPath, true);
            var localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            var localVarHeaderParameter = {};
            var localVarQueryParameter = {};
            if (configuration && configuration.accessToken) {
                var localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("oauth2", ["api"])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        post: function (storeId, SetOrderBatchingConfiguration, options) {
            if (options === void 0) { options = {}; }
            if (storeId === null || storeId === undefined) {
                throw new RequiredError('storeId', 'Required parameter storeId was null or undefined when calling post.');
            }
            if (SetOrderBatchingConfiguration === null || SetOrderBatchingConfiguration === undefined) {
                throw new RequiredError('SetOrderBatchingConfiguration', 'Required parameter SetOrderBatchingConfiguration was null or undefined when calling post.');
            }
            var localVarPath = "/api/v1.0/stores/{storeId}/order-batching-configuration"
                .replace("{".concat("storeId", "}"), encodeURIComponent(String(storeId)));
            var localVarUrlObj = url.parse(localVarPath, true);
            var localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            var localVarHeaderParameter = {};
            var localVarQueryParameter = {};
            if (configuration && configuration.accessToken) {
                var localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("oauth2", ["api"])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }
            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            var needsSerialization = ("SetOrderBatchingConfiguration" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body = needsSerialization ? JSON.stringify(SetOrderBatchingConfiguration || {}) : (SetOrderBatchingConfiguration || "");
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    };
};
exports.OrderBatchingConfigurationApiFetchParamCreator = OrderBatchingConfigurationApiFetchParamCreator;
var OrderBatchingConfigurationApiFp = function (configuration) {
    return {
        get: function (storeId, options) {
            var localVarFetchArgs = (0, exports.OrderBatchingConfigurationApiFetchParamCreator)(configuration).get(storeId, options);
            return function (fetch, basePath) {
                if (fetch === void 0) { fetch = portableFetch; }
                if (basePath === void 0) { basePath = BASE_PATH; }
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then(function (response) {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
        post: function (storeId, SetOrderBatchingConfiguration, options) {
            var localVarFetchArgs = (0, exports.OrderBatchingConfigurationApiFetchParamCreator)(configuration).post(storeId, SetOrderBatchingConfiguration, options);
            return function (fetch, basePath) {
                if (fetch === void 0) { fetch = portableFetch; }
                if (basePath === void 0) { basePath = BASE_PATH; }
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then(function (response) {
                    if (response.status >= 200 && response.status < 300) {
                        return response;
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
    };
};
exports.OrderBatchingConfigurationApiFp = OrderBatchingConfigurationApiFp;
var OrderBatchingConfigurationApiFactory = function (configuration, fetch, basePath) {
    return {
        get: function (storeId, options) {
            return (0, exports.OrderBatchingConfigurationApiFp)(configuration).get(storeId, options)(fetch, basePath);
        },
        post: function (storeId, SetOrderBatchingConfiguration, options) {
            return (0, exports.OrderBatchingConfigurationApiFp)(configuration).post(storeId, SetOrderBatchingConfiguration, options)(fetch, basePath);
        },
    };
};
exports.OrderBatchingConfigurationApiFactory = OrderBatchingConfigurationApiFactory;
var OrderBatchingConfigurationApi = (function (_super) {
    __extends(OrderBatchingConfigurationApi, _super);
    function OrderBatchingConfigurationApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    OrderBatchingConfigurationApi.prototype.get = function (storeId, options) {
        return (0, exports.OrderBatchingConfigurationApiFp)(this.configuration).get(storeId, options)(this.fetch, this.basePath);
    };
    OrderBatchingConfigurationApi.prototype.post = function (storeId, SetOrderBatchingConfiguration, options) {
        return (0, exports.OrderBatchingConfigurationApiFp)(this.configuration).post(storeId, SetOrderBatchingConfiguration, options)(this.fetch, this.basePath);
    };
    return OrderBatchingConfigurationApi;
}(BaseAPI));
exports.OrderBatchingConfigurationApi = OrderBatchingConfigurationApi;
var OrdersApiFetchParamCreator = function (configuration) {
    return {
        acceptOrder: function (id, Accept, options) {
            if (options === void 0) { options = {}; }
            if (id === null || id === undefined) {
                throw new RequiredError('id', 'Required parameter id was null or undefined when calling acceptOrder.');
            }
            if (Accept === null || Accept === undefined) {
                throw new RequiredError('Accept', 'Required parameter Accept was null or undefined when calling acceptOrder.');
            }
            var localVarPath = "/api/v1.0/orders/{id}/accept"
                .replace("{".concat("id", "}"), encodeURIComponent(String(id)));
            var localVarUrlObj = url.parse(localVarPath, true);
            var localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            var localVarHeaderParameter = {};
            var localVarQueryParameter = {};
            if (configuration && configuration.accessToken) {
                var localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("oauth2", ["api"])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }
            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            var needsSerialization = ("Accept" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body = needsSerialization ? JSON.stringify(Accept || {}) : (Accept || "");
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        dispatchOrder: function (id, options) {
            if (options === void 0) { options = {}; }
            if (id === null || id === undefined) {
                throw new RequiredError('id', 'Required parameter id was null or undefined when calling dispatchOrder.');
            }
            var localVarPath = "/api/v1.0/orders/{id}/dispatch"
                .replace("{".concat("id", "}"), encodeURIComponent(String(id)));
            var localVarUrlObj = url.parse(localVarPath, true);
            var localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            var localVarHeaderParameter = {};
            var localVarQueryParameter = {};
            if (configuration && configuration.accessToken) {
                var localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("oauth2", ["api"])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        getDeliveryInformation: function (orderId, options) {
            if (options === void 0) { options = {}; }
            if (orderId === null || orderId === undefined) {
                throw new RequiredError('orderId', 'Required parameter orderId was null or undefined when calling getDeliveryInformation.');
            }
            var localVarPath = "/api/v1.0/orders/{orderId}/deliveryinfo"
                .replace("{".concat("orderId", "}"), encodeURIComponent(String(orderId)));
            var localVarUrlObj = url.parse(localVarPath, true);
            var localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            var localVarHeaderParameter = {};
            var localVarQueryParameter = {};
            if (configuration && configuration.accessToken) {
                var localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("oauth2", ["api"])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        getFulfillmentState: function (orderId, options) {
            if (options === void 0) { options = {}; }
            if (orderId === null || orderId === undefined) {
                throw new RequiredError('orderId', 'Required parameter orderId was null or undefined when calling getFulfillmentState.');
            }
            var localVarPath = "/api/v1.0/orders/{orderId}/fulfillment/state"
                .replace("{".concat("orderId", "}"), encodeURIComponent(String(orderId)));
            var localVarUrlObj = url.parse(localVarPath, true);
            var localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            var localVarHeaderParameter = {};
            var localVarQueryParameter = {};
            if (configuration && configuration.accessToken) {
                var localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("oauth2", ["api"])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        getFulfillmentStatusWithDetailsAndActions: function (orderId, options) {
            if (options === void 0) { options = {}; }
            if (orderId === null || orderId === undefined) {
                throw new RequiredError('orderId', 'Required parameter orderId was null or undefined when calling getFulfillmentStatusWithDetailsAndActions.');
            }
            var localVarPath = "/api/v1.0/orders/{orderId}/fulfillment/state/details"
                .replace("{".concat("orderId", "}"), encodeURIComponent(String(orderId)));
            var localVarUrlObj = url.parse(localVarPath, true);
            var localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            var localVarHeaderParameter = {};
            var localVarQueryParameter = {};
            if (configuration && configuration.accessToken) {
                var localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("oauth2", ["api"])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        getOrderById: function (id, options) {
            if (options === void 0) { options = {}; }
            if (id === null || id === undefined) {
                throw new RequiredError('id', 'Required parameter id was null or undefined when calling getOrderById.');
            }
            var localVarPath = "/api/v1.0/orders/{id}"
                .replace("{".concat("id", "}"), encodeURIComponent(String(id)));
            var localVarUrlObj = url.parse(localVarPath, true);
            var localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            var localVarHeaderParameter = {};
            var localVarQueryParameter = {};
            if (configuration && configuration.accessToken) {
                var localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("oauth2", ["api"])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        getOrders: function (physicalRestaurantId, state, from, to, page, limit, options) {
            if (options === void 0) { options = {}; }
            var localVarPath = "/api/v1.0/orders";
            var localVarUrlObj = url.parse(localVarPath, true);
            var localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            var localVarHeaderParameter = {};
            var localVarQueryParameter = {};
            if (configuration && configuration.accessToken) {
                var localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("oauth2", ["api"])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }
            if (physicalRestaurantId) {
                localVarQueryParameter['physicalRestaurantId'] = physicalRestaurantId;
            }
            if (state) {
                localVarQueryParameter['state'] = state;
            }
            if (from !== undefined) {
                localVarQueryParameter['from'] = from;
            }
            if (to !== undefined) {
                localVarQueryParameter['to'] = to;
            }
            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }
            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        getOrdersSummary: function (appId, searchQuery, physicalRestaurantId, state, page, limit, orderByRequestedForTime, channels, orderIds, from, to, logSql, options) {
            if (options === void 0) { options = {}; }
            if (appId === null || appId === undefined) {
                throw new RequiredError('appId', 'Required parameter appId was null or undefined when calling getOrdersSummary.');
            }
            var localVarPath = "/api/v1.0/{appId}/orders/summaries"
                .replace("{".concat("appId", "}"), encodeURIComponent(String(appId)));
            var localVarUrlObj = url.parse(localVarPath, true);
            var localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            var localVarHeaderParameter = {};
            var localVarQueryParameter = {};
            if (configuration && configuration.accessToken) {
                var localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("oauth2", ["api"])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }
            if (searchQuery !== undefined) {
                localVarQueryParameter['searchQuery'] = searchQuery;
            }
            if (physicalRestaurantId) {
                localVarQueryParameter['physicalRestaurantId'] = physicalRestaurantId;
            }
            if (state) {
                localVarQueryParameter['state'] = state;
            }
            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }
            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }
            if (orderByRequestedForTime !== undefined) {
                localVarQueryParameter['orderByRequestedForTime'] = orderByRequestedForTime;
            }
            if (channels) {
                localVarQueryParameter['channels'] = channels;
            }
            if (orderIds) {
                localVarQueryParameter['orderIds'] = orderIds;
            }
            if (from !== undefined) {
                localVarQueryParameter['from'] = from;
            }
            if (to !== undefined) {
                localVarQueryParameter['to'] = to;
            }
            if (logSql !== undefined) {
                localVarQueryParameter['logSql'] = logSql;
            }
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        getOrdersSummaryNew: function (appId, searchQuery, physicalRestaurantId, state, page, limit, orderByRequestedForTime, channels, orderIds, from, to, logSql, options) {
            if (options === void 0) { options = {}; }
            if (appId === null || appId === undefined) {
                throw new RequiredError('appId', 'Required parameter appId was null or undefined when calling getOrdersSummaryNew.');
            }
            var localVarPath = "/api/v1.0/{appId}/orders/summariesNew"
                .replace("{".concat("appId", "}"), encodeURIComponent(String(appId)));
            var localVarUrlObj = url.parse(localVarPath, true);
            var localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            var localVarHeaderParameter = {};
            var localVarQueryParameter = {};
            if (configuration && configuration.accessToken) {
                var localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("oauth2", ["api"])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }
            if (searchQuery !== undefined) {
                localVarQueryParameter['searchQuery'] = searchQuery;
            }
            if (physicalRestaurantId) {
                localVarQueryParameter['physicalRestaurantId'] = physicalRestaurantId;
            }
            if (state) {
                localVarQueryParameter['state'] = state;
            }
            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }
            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }
            if (orderByRequestedForTime !== undefined) {
                localVarQueryParameter['orderByRequestedForTime'] = orderByRequestedForTime;
            }
            if (channels) {
                localVarQueryParameter['channels'] = channels;
            }
            if (orderIds) {
                localVarQueryParameter['orderIds'] = orderIds;
            }
            if (from !== undefined) {
                localVarQueryParameter['from'] = from;
            }
            if (to !== undefined) {
                localVarQueryParameter['to'] = to;
            }
            if (logSql !== undefined) {
                localVarQueryParameter['logSql'] = logSql;
            }
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        getReadyToProcess: function (appId, storeId, options) {
            if (options === void 0) { options = {}; }
            if (appId === null || appId === undefined) {
                throw new RequiredError('appId', 'Required parameter appId was null or undefined when calling getReadyToProcess.');
            }
            var localVarPath = "/api/v1.0/{appId}/orders/ready_to_process"
                .replace("{".concat("appId", "}"), encodeURIComponent(String(appId)));
            var localVarUrlObj = url.parse(localVarPath, true);
            var localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            var localVarHeaderParameter = {};
            var localVarQueryParameter = {};
            if (configuration && configuration.accessToken) {
                var localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("oauth2", ["api"])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }
            if (storeId) {
                localVarQueryParameter['storeId'] = storeId;
            }
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        refundOrder: function (id, Refund, options) {
            if (options === void 0) { options = {}; }
            if (id === null || id === undefined) {
                throw new RequiredError('id', 'Required parameter id was null or undefined when calling refundOrder.');
            }
            if (Refund === null || Refund === undefined) {
                throw new RequiredError('Refund', 'Required parameter Refund was null or undefined when calling refundOrder.');
            }
            var localVarPath = "/api/v1.0/orders/{id}/refund"
                .replace("{".concat("id", "}"), encodeURIComponent(String(id)));
            var localVarUrlObj = url.parse(localVarPath, true);
            var localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            var localVarHeaderParameter = {};
            var localVarQueryParameter = {};
            if (configuration && configuration.accessToken) {
                var localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("oauth2", ["api"])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }
            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            var needsSerialization = ("Refund" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body = needsSerialization ? JSON.stringify(Refund || {}) : (Refund || "");
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        rejectOrder: function (id, Reject, options) {
            if (options === void 0) { options = {}; }
            if (id === null || id === undefined) {
                throw new RequiredError('id', 'Required parameter id was null or undefined when calling rejectOrder.');
            }
            if (Reject === null || Reject === undefined) {
                throw new RequiredError('Reject', 'Required parameter Reject was null or undefined when calling rejectOrder.');
            }
            var localVarPath = "/api/v1.0/orders/{id}/reject"
                .replace("{".concat("id", "}"), encodeURIComponent(String(id)));
            var localVarUrlObj = url.parse(localVarPath, true);
            var localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            var localVarHeaderParameter = {};
            var localVarQueryParameter = {};
            if (configuration && configuration.accessToken) {
                var localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("oauth2", ["api"])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }
            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            var needsSerialization = ("Reject" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body = needsSerialization ? JSON.stringify(Reject || {}) : (Reject || "");
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        searchFulfillmentStatuses: function (appId, orderIds, options) {
            if (options === void 0) { options = {}; }
            if (appId === null || appId === undefined) {
                throw new RequiredError('appId', 'Required parameter appId was null or undefined when calling searchFulfillmentStatuses.');
            }
            if (orderIds === null || orderIds === undefined) {
                throw new RequiredError('orderIds', 'Required parameter orderIds was null or undefined when calling searchFulfillmentStatuses.');
            }
            var localVarPath = "/api/v1.0/{appId}/orders/fulfillmentstatuses"
                .replace("{".concat("appId", "}"), encodeURIComponent(String(appId)));
            var localVarUrlObj = url.parse(localVarPath, true);
            var localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            var localVarHeaderParameter = {};
            var localVarQueryParameter = {};
            if (configuration && configuration.accessToken) {
                var localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("oauth2", ["api"])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }
            if (orderIds !== undefined) {
                localVarQueryParameter['orderIds'] = orderIds;
            }
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        updateDeliveryInformation: function (orderId, OrderDeliveryInformationBase, options) {
            if (options === void 0) { options = {}; }
            if (orderId === null || orderId === undefined) {
                throw new RequiredError('orderId', 'Required parameter orderId was null or undefined when calling updateDeliveryInformation.');
            }
            if (OrderDeliveryInformationBase === null || OrderDeliveryInformationBase === undefined) {
                throw new RequiredError('OrderDeliveryInformationBase', 'Required parameter OrderDeliveryInformationBase was null or undefined when calling updateDeliveryInformation.');
            }
            var localVarPath = "/api/v1.0/orders/{orderId}/deliveryinfo"
                .replace("{".concat("orderId", "}"), encodeURIComponent(String(orderId)));
            var localVarUrlObj = url.parse(localVarPath, true);
            var localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            var localVarHeaderParameter = {};
            var localVarQueryParameter = {};
            if (configuration && configuration.accessToken) {
                var localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("oauth2", ["api"])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }
            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            var needsSerialization = ("OrderDeliveryInformationBase" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body = needsSerialization ? JSON.stringify(OrderDeliveryInformationBase || {}) : (OrderDeliveryInformationBase || "");
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        updateFulfillmentState: function (orderId, OrderFulfillmentStatusUpdate, options) {
            if (options === void 0) { options = {}; }
            if (orderId === null || orderId === undefined) {
                throw new RequiredError('orderId', 'Required parameter orderId was null or undefined when calling updateFulfillmentState.');
            }
            if (OrderFulfillmentStatusUpdate === null || OrderFulfillmentStatusUpdate === undefined) {
                throw new RequiredError('OrderFulfillmentStatusUpdate', 'Required parameter OrderFulfillmentStatusUpdate was null or undefined when calling updateFulfillmentState.');
            }
            var localVarPath = "/api/v1.0/orders/{orderId}/fulfillment/state"
                .replace("{".concat("orderId", "}"), encodeURIComponent(String(orderId)));
            var localVarUrlObj = url.parse(localVarPath, true);
            var localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            var localVarHeaderParameter = {};
            var localVarQueryParameter = {};
            if (configuration && configuration.accessToken) {
                var localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("oauth2", ["api"])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }
            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            var needsSerialization = ("OrderFulfillmentStatusUpdate" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body = needsSerialization ? JSON.stringify(OrderFulfillmentStatusUpdate || {}) : (OrderFulfillmentStatusUpdate || "");
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    };
};
exports.OrdersApiFetchParamCreator = OrdersApiFetchParamCreator;
var OrdersApiFp = function (configuration) {
    return {
        acceptOrder: function (id, Accept, options) {
            var localVarFetchArgs = (0, exports.OrdersApiFetchParamCreator)(configuration).acceptOrder(id, Accept, options);
            return function (fetch, basePath) {
                if (fetch === void 0) { fetch = portableFetch; }
                if (basePath === void 0) { basePath = BASE_PATH; }
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then(function (response) {
                    if (response.status >= 200 && response.status < 300) {
                        return response;
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
        dispatchOrder: function (id, options) {
            var localVarFetchArgs = (0, exports.OrdersApiFetchParamCreator)(configuration).dispatchOrder(id, options);
            return function (fetch, basePath) {
                if (fetch === void 0) { fetch = portableFetch; }
                if (basePath === void 0) { basePath = BASE_PATH; }
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then(function (response) {
                    if (response.status >= 200 && response.status < 300) {
                        return response;
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
        getDeliveryInformation: function (orderId, options) {
            var localVarFetchArgs = (0, exports.OrdersApiFetchParamCreator)(configuration).getDeliveryInformation(orderId, options);
            return function (fetch, basePath) {
                if (fetch === void 0) { fetch = portableFetch; }
                if (basePath === void 0) { basePath = BASE_PATH; }
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then(function (response) {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
        getFulfillmentState: function (orderId, options) {
            var localVarFetchArgs = (0, exports.OrdersApiFetchParamCreator)(configuration).getFulfillmentState(orderId, options);
            return function (fetch, basePath) {
                if (fetch === void 0) { fetch = portableFetch; }
                if (basePath === void 0) { basePath = BASE_PATH; }
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then(function (response) {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
        getFulfillmentStatusWithDetailsAndActions: function (orderId, options) {
            var localVarFetchArgs = (0, exports.OrdersApiFetchParamCreator)(configuration).getFulfillmentStatusWithDetailsAndActions(orderId, options);
            return function (fetch, basePath) {
                if (fetch === void 0) { fetch = portableFetch; }
                if (basePath === void 0) { basePath = BASE_PATH; }
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then(function (response) {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
        getOrderById: function (id, options) {
            var localVarFetchArgs = (0, exports.OrdersApiFetchParamCreator)(configuration).getOrderById(id, options);
            return function (fetch, basePath) {
                if (fetch === void 0) { fetch = portableFetch; }
                if (basePath === void 0) { basePath = BASE_PATH; }
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then(function (response) {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
        getOrders: function (physicalRestaurantId, state, from, to, page, limit, options) {
            var localVarFetchArgs = (0, exports.OrdersApiFetchParamCreator)(configuration).getOrders(physicalRestaurantId, state, from, to, page, limit, options);
            return function (fetch, basePath) {
                if (fetch === void 0) { fetch = portableFetch; }
                if (basePath === void 0) { basePath = BASE_PATH; }
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then(function (response) {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
        getOrdersSummary: function (appId, searchQuery, physicalRestaurantId, state, page, limit, orderByRequestedForTime, channels, orderIds, from, to, logSql, options) {
            var localVarFetchArgs = (0, exports.OrdersApiFetchParamCreator)(configuration).getOrdersSummary(appId, searchQuery, physicalRestaurantId, state, page, limit, orderByRequestedForTime, channels, orderIds, from, to, logSql, options);
            return function (fetch, basePath) {
                if (fetch === void 0) { fetch = portableFetch; }
                if (basePath === void 0) { basePath = BASE_PATH; }
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then(function (response) {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
        getOrdersSummaryNew: function (appId, searchQuery, physicalRestaurantId, state, page, limit, orderByRequestedForTime, channels, orderIds, from, to, logSql, options) {
            var localVarFetchArgs = (0, exports.OrdersApiFetchParamCreator)(configuration).getOrdersSummaryNew(appId, searchQuery, physicalRestaurantId, state, page, limit, orderByRequestedForTime, channels, orderIds, from, to, logSql, options);
            return function (fetch, basePath) {
                if (fetch === void 0) { fetch = portableFetch; }
                if (basePath === void 0) { basePath = BASE_PATH; }
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then(function (response) {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
        getReadyToProcess: function (appId, storeId, options) {
            var localVarFetchArgs = (0, exports.OrdersApiFetchParamCreator)(configuration).getReadyToProcess(appId, storeId, options);
            return function (fetch, basePath) {
                if (fetch === void 0) { fetch = portableFetch; }
                if (basePath === void 0) { basePath = BASE_PATH; }
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then(function (response) {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
        refundOrder: function (id, Refund, options) {
            var localVarFetchArgs = (0, exports.OrdersApiFetchParamCreator)(configuration).refundOrder(id, Refund, options);
            return function (fetch, basePath) {
                if (fetch === void 0) { fetch = portableFetch; }
                if (basePath === void 0) { basePath = BASE_PATH; }
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then(function (response) {
                    if (response.status >= 200 && response.status < 300) {
                        return response;
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
        rejectOrder: function (id, Reject, options) {
            var localVarFetchArgs = (0, exports.OrdersApiFetchParamCreator)(configuration).rejectOrder(id, Reject, options);
            return function (fetch, basePath) {
                if (fetch === void 0) { fetch = portableFetch; }
                if (basePath === void 0) { basePath = BASE_PATH; }
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then(function (response) {
                    if (response.status >= 200 && response.status < 300) {
                        return response;
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
        searchFulfillmentStatuses: function (appId, orderIds, options) {
            var localVarFetchArgs = (0, exports.OrdersApiFetchParamCreator)(configuration).searchFulfillmentStatuses(appId, orderIds, options);
            return function (fetch, basePath) {
                if (fetch === void 0) { fetch = portableFetch; }
                if (basePath === void 0) { basePath = BASE_PATH; }
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then(function (response) {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
        updateDeliveryInformation: function (orderId, OrderDeliveryInformationBase, options) {
            var localVarFetchArgs = (0, exports.OrdersApiFetchParamCreator)(configuration).updateDeliveryInformation(orderId, OrderDeliveryInformationBase, options);
            return function (fetch, basePath) {
                if (fetch === void 0) { fetch = portableFetch; }
                if (basePath === void 0) { basePath = BASE_PATH; }
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then(function (response) {
                    if (response.status >= 200 && response.status < 300) {
                        return response;
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
        updateFulfillmentState: function (orderId, OrderFulfillmentStatusUpdate, options) {
            var localVarFetchArgs = (0, exports.OrdersApiFetchParamCreator)(configuration).updateFulfillmentState(orderId, OrderFulfillmentStatusUpdate, options);
            return function (fetch, basePath) {
                if (fetch === void 0) { fetch = portableFetch; }
                if (basePath === void 0) { basePath = BASE_PATH; }
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then(function (response) {
                    if (response.status >= 200 && response.status < 300) {
                        return response;
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
    };
};
exports.OrdersApiFp = OrdersApiFp;
var OrdersApiFactory = function (configuration, fetch, basePath) {
    return {
        acceptOrder: function (id, Accept, options) {
            return (0, exports.OrdersApiFp)(configuration).acceptOrder(id, Accept, options)(fetch, basePath);
        },
        dispatchOrder: function (id, options) {
            return (0, exports.OrdersApiFp)(configuration).dispatchOrder(id, options)(fetch, basePath);
        },
        getDeliveryInformation: function (orderId, options) {
            return (0, exports.OrdersApiFp)(configuration).getDeliveryInformation(orderId, options)(fetch, basePath);
        },
        getFulfillmentState: function (orderId, options) {
            return (0, exports.OrdersApiFp)(configuration).getFulfillmentState(orderId, options)(fetch, basePath);
        },
        getFulfillmentStatusWithDetailsAndActions: function (orderId, options) {
            return (0, exports.OrdersApiFp)(configuration).getFulfillmentStatusWithDetailsAndActions(orderId, options)(fetch, basePath);
        },
        getOrderById: function (id, options) {
            return (0, exports.OrdersApiFp)(configuration).getOrderById(id, options)(fetch, basePath);
        },
        getOrders: function (physicalRestaurantId, state, from, to, page, limit, options) {
            return (0, exports.OrdersApiFp)(configuration).getOrders(physicalRestaurantId, state, from, to, page, limit, options)(fetch, basePath);
        },
        getOrdersSummary: function (appId, searchQuery, physicalRestaurantId, state, page, limit, orderByRequestedForTime, channels, orderIds, from, to, logSql, options) {
            return (0, exports.OrdersApiFp)(configuration).getOrdersSummary(appId, searchQuery, physicalRestaurantId, state, page, limit, orderByRequestedForTime, channels, orderIds, from, to, logSql, options)(fetch, basePath);
        },
        getOrdersSummaryNew: function (appId, searchQuery, physicalRestaurantId, state, page, limit, orderByRequestedForTime, channels, orderIds, from, to, logSql, options) {
            return (0, exports.OrdersApiFp)(configuration).getOrdersSummaryNew(appId, searchQuery, physicalRestaurantId, state, page, limit, orderByRequestedForTime, channels, orderIds, from, to, logSql, options)(fetch, basePath);
        },
        getReadyToProcess: function (appId, storeId, options) {
            return (0, exports.OrdersApiFp)(configuration).getReadyToProcess(appId, storeId, options)(fetch, basePath);
        },
        refundOrder: function (id, Refund, options) {
            return (0, exports.OrdersApiFp)(configuration).refundOrder(id, Refund, options)(fetch, basePath);
        },
        rejectOrder: function (id, Reject, options) {
            return (0, exports.OrdersApiFp)(configuration).rejectOrder(id, Reject, options)(fetch, basePath);
        },
        searchFulfillmentStatuses: function (appId, orderIds, options) {
            return (0, exports.OrdersApiFp)(configuration).searchFulfillmentStatuses(appId, orderIds, options)(fetch, basePath);
        },
        updateDeliveryInformation: function (orderId, OrderDeliveryInformationBase, options) {
            return (0, exports.OrdersApiFp)(configuration).updateDeliveryInformation(orderId, OrderDeliveryInformationBase, options)(fetch, basePath);
        },
        updateFulfillmentState: function (orderId, OrderFulfillmentStatusUpdate, options) {
            return (0, exports.OrdersApiFp)(configuration).updateFulfillmentState(orderId, OrderFulfillmentStatusUpdate, options)(fetch, basePath);
        },
    };
};
exports.OrdersApiFactory = OrdersApiFactory;
var OrdersApi = (function (_super) {
    __extends(OrdersApi, _super);
    function OrdersApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    OrdersApi.prototype.acceptOrder = function (id, Accept, options) {
        return (0, exports.OrdersApiFp)(this.configuration).acceptOrder(id, Accept, options)(this.fetch, this.basePath);
    };
    OrdersApi.prototype.dispatchOrder = function (id, options) {
        return (0, exports.OrdersApiFp)(this.configuration).dispatchOrder(id, options)(this.fetch, this.basePath);
    };
    OrdersApi.prototype.getDeliveryInformation = function (orderId, options) {
        return (0, exports.OrdersApiFp)(this.configuration).getDeliveryInformation(orderId, options)(this.fetch, this.basePath);
    };
    OrdersApi.prototype.getFulfillmentState = function (orderId, options) {
        return (0, exports.OrdersApiFp)(this.configuration).getFulfillmentState(orderId, options)(this.fetch, this.basePath);
    };
    OrdersApi.prototype.getFulfillmentStatusWithDetailsAndActions = function (orderId, options) {
        return (0, exports.OrdersApiFp)(this.configuration).getFulfillmentStatusWithDetailsAndActions(orderId, options)(this.fetch, this.basePath);
    };
    OrdersApi.prototype.getOrderById = function (id, options) {
        return (0, exports.OrdersApiFp)(this.configuration).getOrderById(id, options)(this.fetch, this.basePath);
    };
    OrdersApi.prototype.getOrders = function (physicalRestaurantId, state, from, to, page, limit, options) {
        return (0, exports.OrdersApiFp)(this.configuration).getOrders(physicalRestaurantId, state, from, to, page, limit, options)(this.fetch, this.basePath);
    };
    OrdersApi.prototype.getOrdersSummary = function (appId, searchQuery, physicalRestaurantId, state, page, limit, orderByRequestedForTime, channels, orderIds, from, to, logSql, options) {
        return (0, exports.OrdersApiFp)(this.configuration).getOrdersSummary(appId, searchQuery, physicalRestaurantId, state, page, limit, orderByRequestedForTime, channels, orderIds, from, to, logSql, options)(this.fetch, this.basePath);
    };
    OrdersApi.prototype.getOrdersSummaryNew = function (appId, searchQuery, physicalRestaurantId, state, page, limit, orderByRequestedForTime, channels, orderIds, from, to, logSql, options) {
        return (0, exports.OrdersApiFp)(this.configuration).getOrdersSummaryNew(appId, searchQuery, physicalRestaurantId, state, page, limit, orderByRequestedForTime, channels, orderIds, from, to, logSql, options)(this.fetch, this.basePath);
    };
    OrdersApi.prototype.getReadyToProcess = function (appId, storeId, options) {
        return (0, exports.OrdersApiFp)(this.configuration).getReadyToProcess(appId, storeId, options)(this.fetch, this.basePath);
    };
    OrdersApi.prototype.refundOrder = function (id, Refund, options) {
        return (0, exports.OrdersApiFp)(this.configuration).refundOrder(id, Refund, options)(this.fetch, this.basePath);
    };
    OrdersApi.prototype.rejectOrder = function (id, Reject, options) {
        return (0, exports.OrdersApiFp)(this.configuration).rejectOrder(id, Reject, options)(this.fetch, this.basePath);
    };
    OrdersApi.prototype.searchFulfillmentStatuses = function (appId, orderIds, options) {
        return (0, exports.OrdersApiFp)(this.configuration).searchFulfillmentStatuses(appId, orderIds, options)(this.fetch, this.basePath);
    };
    OrdersApi.prototype.updateDeliveryInformation = function (orderId, OrderDeliveryInformationBase, options) {
        return (0, exports.OrdersApiFp)(this.configuration).updateDeliveryInformation(orderId, OrderDeliveryInformationBase, options)(this.fetch, this.basePath);
    };
    OrdersApi.prototype.updateFulfillmentState = function (orderId, OrderFulfillmentStatusUpdate, options) {
        return (0, exports.OrdersApiFp)(this.configuration).updateFulfillmentState(orderId, OrderFulfillmentStatusUpdate, options)(this.fetch, this.basePath);
    };
    return OrdersApi;
}(BaseAPI));
exports.OrdersApi = OrdersApi;
var PaymentIntentsApiFetchParamCreator = function (configuration) {
    return {
        getPaymentIntent: function (paymentIntentId, options) {
            if (options === void 0) { options = {}; }
            if (paymentIntentId === null || paymentIntentId === undefined) {
                throw new RequiredError('paymentIntentId', 'Required parameter paymentIntentId was null or undefined when calling getPaymentIntent.');
            }
            var localVarPath = "/api/v1.0/payment_intents/{paymentIntentId}"
                .replace("{".concat("paymentIntentId", "}"), encodeURIComponent(String(paymentIntentId)));
            var localVarUrlObj = url.parse(localVarPath, true);
            var localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            var localVarHeaderParameter = {};
            var localVarQueryParameter = {};
            if (configuration && configuration.accessToken) {
                var localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("oauth2", ["api"])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    };
};
exports.PaymentIntentsApiFetchParamCreator = PaymentIntentsApiFetchParamCreator;
var PaymentIntentsApiFp = function (configuration) {
    return {
        getPaymentIntent: function (paymentIntentId, options) {
            var localVarFetchArgs = (0, exports.PaymentIntentsApiFetchParamCreator)(configuration).getPaymentIntent(paymentIntentId, options);
            return function (fetch, basePath) {
                if (fetch === void 0) { fetch = portableFetch; }
                if (basePath === void 0) { basePath = BASE_PATH; }
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then(function (response) {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
    };
};
exports.PaymentIntentsApiFp = PaymentIntentsApiFp;
var PaymentIntentsApiFactory = function (configuration, fetch, basePath) {
    return {
        getPaymentIntent: function (paymentIntentId, options) {
            return (0, exports.PaymentIntentsApiFp)(configuration).getPaymentIntent(paymentIntentId, options)(fetch, basePath);
        },
    };
};
exports.PaymentIntentsApiFactory = PaymentIntentsApiFactory;
var PaymentIntentsApi = (function (_super) {
    __extends(PaymentIntentsApi, _super);
    function PaymentIntentsApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    PaymentIntentsApi.prototype.getPaymentIntent = function (paymentIntentId, options) {
        return (0, exports.PaymentIntentsApiFp)(this.configuration).getPaymentIntent(paymentIntentId, options)(this.fetch, this.basePath);
    };
    return PaymentIntentsApi;
}(BaseAPI));
exports.PaymentIntentsApi = PaymentIntentsApi;
var PaymentsApiFetchParamCreator = function (configuration) {
    return {
        getOrderPaymentInformation: function (orderId, options) {
            if (options === void 0) { options = {}; }
            if (orderId === null || orderId === undefined) {
                throw new RequiredError('orderId', 'Required parameter orderId was null or undefined when calling getOrderPaymentInformation.');
            }
            var localVarPath = "/api/v1.0/payments/payment/{orderId}/refundable"
                .replace("{".concat("orderId", "}"), encodeURIComponent(String(orderId)));
            var localVarUrlObj = url.parse(localVarPath, true);
            var localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            var localVarHeaderParameter = {};
            var localVarQueryParameter = {};
            if (configuration && configuration.accessToken) {
                var localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("oauth2", ["api"])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    };
};
exports.PaymentsApiFetchParamCreator = PaymentsApiFetchParamCreator;
var PaymentsApiFp = function (configuration) {
    return {
        getOrderPaymentInformation: function (orderId, options) {
            var localVarFetchArgs = (0, exports.PaymentsApiFetchParamCreator)(configuration).getOrderPaymentInformation(orderId, options);
            return function (fetch, basePath) {
                if (fetch === void 0) { fetch = portableFetch; }
                if (basePath === void 0) { basePath = BASE_PATH; }
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then(function (response) {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
    };
};
exports.PaymentsApiFp = PaymentsApiFp;
var PaymentsApiFactory = function (configuration, fetch, basePath) {
    return {
        getOrderPaymentInformation: function (orderId, options) {
            return (0, exports.PaymentsApiFp)(configuration).getOrderPaymentInformation(orderId, options)(fetch, basePath);
        },
    };
};
exports.PaymentsApiFactory = PaymentsApiFactory;
var PaymentsApi = (function (_super) {
    __extends(PaymentsApi, _super);
    function PaymentsApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    PaymentsApi.prototype.getOrderPaymentInformation = function (orderId, options) {
        return (0, exports.PaymentsApiFp)(this.configuration).getOrderPaymentInformation(orderId, options)(this.fetch, this.basePath);
    };
    return PaymentsApi;
}(BaseAPI));
exports.PaymentsApi = PaymentsApi;
var PayoutReportsApiFetchParamCreator = function (configuration) {
    return {
        getPayoutReport3Details: function (appId, bankAccountId, payoutId, storeIds, options) {
            if (options === void 0) { options = {}; }
            if (appId === null || appId === undefined) {
                throw new RequiredError('appId', 'Required parameter appId was null or undefined when calling getPayoutReport3Details.');
            }
            if (bankAccountId === null || bankAccountId === undefined) {
                throw new RequiredError('bankAccountId', 'Required parameter bankAccountId was null or undefined when calling getPayoutReport3Details.');
            }
            if (payoutId === null || payoutId === undefined) {
                throw new RequiredError('payoutId', 'Required parameter payoutId was null or undefined when calling getPayoutReport3Details.');
            }
            var localVarPath = "/api/v1.0/{appId}/reporting/reports/payouts3/{bankAccountId}/{payoutId}/details"
                .replace("{".concat("appId", "}"), encodeURIComponent(String(appId)))
                .replace("{".concat("bankAccountId", "}"), encodeURIComponent(String(bankAccountId)))
                .replace("{".concat("payoutId", "}"), encodeURIComponent(String(payoutId)));
            var localVarUrlObj = url.parse(localVarPath, true);
            var localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            var localVarHeaderParameter = {};
            var localVarQueryParameter = {};
            if (configuration && configuration.accessToken) {
                var localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("oauth2", ["api"])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }
            if (storeIds) {
                localVarQueryParameter['storeIds'] = storeIds;
            }
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        getPayoutReport3Overview: function (appId, bankAccountId, payoutId, options) {
            if (options === void 0) { options = {}; }
            if (appId === null || appId === undefined) {
                throw new RequiredError('appId', 'Required parameter appId was null or undefined when calling getPayoutReport3Overview.');
            }
            if (bankAccountId === null || bankAccountId === undefined) {
                throw new RequiredError('bankAccountId', 'Required parameter bankAccountId was null or undefined when calling getPayoutReport3Overview.');
            }
            if (payoutId === null || payoutId === undefined) {
                throw new RequiredError('payoutId', 'Required parameter payoutId was null or undefined when calling getPayoutReport3Overview.');
            }
            var localVarPath = "/api/v1.0/{appId}/reporting/reports/payouts3/{bankAccountId}/{payoutId}/overview"
                .replace("{".concat("appId", "}"), encodeURIComponent(String(appId)))
                .replace("{".concat("bankAccountId", "}"), encodeURIComponent(String(bankAccountId)))
                .replace("{".concat("payoutId", "}"), encodeURIComponent(String(payoutId)));
            var localVarUrlObj = url.parse(localVarPath, true);
            var localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            var localVarHeaderParameter = {};
            var localVarQueryParameter = {};
            if (configuration && configuration.accessToken) {
                var localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("oauth2", ["api"])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        getPayoutReport3PropertyDetails: function (appId, bankAccountId, payoutId, propertyIds, storeIds, options) {
            if (options === void 0) { options = {}; }
            if (appId === null || appId === undefined) {
                throw new RequiredError('appId', 'Required parameter appId was null or undefined when calling getPayoutReport3PropertyDetails.');
            }
            if (bankAccountId === null || bankAccountId === undefined) {
                throw new RequiredError('bankAccountId', 'Required parameter bankAccountId was null or undefined when calling getPayoutReport3PropertyDetails.');
            }
            if (payoutId === null || payoutId === undefined) {
                throw new RequiredError('payoutId', 'Required parameter payoutId was null or undefined when calling getPayoutReport3PropertyDetails.');
            }
            var localVarPath = "/api/v1.0/{appId}/reporting/reports/payouts3/{bankAccountId}/{payoutId}/properties"
                .replace("{".concat("appId", "}"), encodeURIComponent(String(appId)))
                .replace("{".concat("bankAccountId", "}"), encodeURIComponent(String(bankAccountId)))
                .replace("{".concat("payoutId", "}"), encodeURIComponent(String(payoutId)));
            var localVarUrlObj = url.parse(localVarPath, true);
            var localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            var localVarHeaderParameter = {};
            var localVarQueryParameter = {};
            if (configuration && configuration.accessToken) {
                var localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("oauth2", ["api"])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }
            if (propertyIds) {
                localVarQueryParameter['propertyIds'] = propertyIds;
            }
            if (storeIds) {
                localVarQueryParameter['storeIds'] = storeIds;
            }
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        getPayoutReport3RefundedOrders: function (appId, bankAccountId, payoutId, storeIds, page, limit, options) {
            if (options === void 0) { options = {}; }
            if (appId === null || appId === undefined) {
                throw new RequiredError('appId', 'Required parameter appId was null or undefined when calling getPayoutReport3RefundedOrders.');
            }
            if (bankAccountId === null || bankAccountId === undefined) {
                throw new RequiredError('bankAccountId', 'Required parameter bankAccountId was null or undefined when calling getPayoutReport3RefundedOrders.');
            }
            if (payoutId === null || payoutId === undefined) {
                throw new RequiredError('payoutId', 'Required parameter payoutId was null or undefined when calling getPayoutReport3RefundedOrders.');
            }
            var localVarPath = "/api/v1.0/{appId}/reporting/reports/payouts3/{bankAccountId}/{payoutId}/refundedOrders"
                .replace("{".concat("appId", "}"), encodeURIComponent(String(appId)))
                .replace("{".concat("bankAccountId", "}"), encodeURIComponent(String(bankAccountId)))
                .replace("{".concat("payoutId", "}"), encodeURIComponent(String(payoutId)));
            var localVarUrlObj = url.parse(localVarPath, true);
            var localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            var localVarHeaderParameter = {};
            var localVarQueryParameter = {};
            if (configuration && configuration.accessToken) {
                var localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("oauth2", ["api"])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }
            if (storeIds) {
                localVarQueryParameter['storeIds'] = storeIds;
            }
            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }
            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        getPayoutReport3Stores: function (appId, bankAccountId, payoutId, stores, options) {
            if (options === void 0) { options = {}; }
            if (appId === null || appId === undefined) {
                throw new RequiredError('appId', 'Required parameter appId was null or undefined when calling getPayoutReport3Stores.');
            }
            if (bankAccountId === null || bankAccountId === undefined) {
                throw new RequiredError('bankAccountId', 'Required parameter bankAccountId was null or undefined when calling getPayoutReport3Stores.');
            }
            if (payoutId === null || payoutId === undefined) {
                throw new RequiredError('payoutId', 'Required parameter payoutId was null or undefined when calling getPayoutReport3Stores.');
            }
            var localVarPath = "/api/v1.0/{appId}/reporting/reports/payouts3/{bankAccountId}/{payoutId}/stores"
                .replace("{".concat("appId", "}"), encodeURIComponent(String(appId)))
                .replace("{".concat("bankAccountId", "}"), encodeURIComponent(String(bankAccountId)))
                .replace("{".concat("payoutId", "}"), encodeURIComponent(String(payoutId)));
            var localVarUrlObj = url.parse(localVarPath, true);
            var localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            var localVarHeaderParameter = {};
            var localVarQueryParameter = {};
            if (configuration && configuration.accessToken) {
                var localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("oauth2", ["api"])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }
            if (stores) {
                localVarQueryParameter['stores'] = stores;
            }
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    };
};
exports.PayoutReportsApiFetchParamCreator = PayoutReportsApiFetchParamCreator;
var PayoutReportsApiFp = function (configuration) {
    return {
        getPayoutReport3Details: function (appId, bankAccountId, payoutId, storeIds, options) {
            var localVarFetchArgs = (0, exports.PayoutReportsApiFetchParamCreator)(configuration).getPayoutReport3Details(appId, bankAccountId, payoutId, storeIds, options);
            return function (fetch, basePath) {
                if (fetch === void 0) { fetch = portableFetch; }
                if (basePath === void 0) { basePath = BASE_PATH; }
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then(function (response) {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
        getPayoutReport3Overview: function (appId, bankAccountId, payoutId, options) {
            var localVarFetchArgs = (0, exports.PayoutReportsApiFetchParamCreator)(configuration).getPayoutReport3Overview(appId, bankAccountId, payoutId, options);
            return function (fetch, basePath) {
                if (fetch === void 0) { fetch = portableFetch; }
                if (basePath === void 0) { basePath = BASE_PATH; }
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then(function (response) {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
        getPayoutReport3PropertyDetails: function (appId, bankAccountId, payoutId, propertyIds, storeIds, options) {
            var localVarFetchArgs = (0, exports.PayoutReportsApiFetchParamCreator)(configuration).getPayoutReport3PropertyDetails(appId, bankAccountId, payoutId, propertyIds, storeIds, options);
            return function (fetch, basePath) {
                if (fetch === void 0) { fetch = portableFetch; }
                if (basePath === void 0) { basePath = BASE_PATH; }
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then(function (response) {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
        getPayoutReport3RefundedOrders: function (appId, bankAccountId, payoutId, storeIds, page, limit, options) {
            var localVarFetchArgs = (0, exports.PayoutReportsApiFetchParamCreator)(configuration).getPayoutReport3RefundedOrders(appId, bankAccountId, payoutId, storeIds, page, limit, options);
            return function (fetch, basePath) {
                if (fetch === void 0) { fetch = portableFetch; }
                if (basePath === void 0) { basePath = BASE_PATH; }
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then(function (response) {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
        getPayoutReport3Stores: function (appId, bankAccountId, payoutId, stores, options) {
            var localVarFetchArgs = (0, exports.PayoutReportsApiFetchParamCreator)(configuration).getPayoutReport3Stores(appId, bankAccountId, payoutId, stores, options);
            return function (fetch, basePath) {
                if (fetch === void 0) { fetch = portableFetch; }
                if (basePath === void 0) { basePath = BASE_PATH; }
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then(function (response) {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
    };
};
exports.PayoutReportsApiFp = PayoutReportsApiFp;
var PayoutReportsApiFactory = function (configuration, fetch, basePath) {
    return {
        getPayoutReport3Details: function (appId, bankAccountId, payoutId, storeIds, options) {
            return (0, exports.PayoutReportsApiFp)(configuration).getPayoutReport3Details(appId, bankAccountId, payoutId, storeIds, options)(fetch, basePath);
        },
        getPayoutReport3Overview: function (appId, bankAccountId, payoutId, options) {
            return (0, exports.PayoutReportsApiFp)(configuration).getPayoutReport3Overview(appId, bankAccountId, payoutId, options)(fetch, basePath);
        },
        getPayoutReport3PropertyDetails: function (appId, bankAccountId, payoutId, propertyIds, storeIds, options) {
            return (0, exports.PayoutReportsApiFp)(configuration).getPayoutReport3PropertyDetails(appId, bankAccountId, payoutId, propertyIds, storeIds, options)(fetch, basePath);
        },
        getPayoutReport3RefundedOrders: function (appId, bankAccountId, payoutId, storeIds, page, limit, options) {
            return (0, exports.PayoutReportsApiFp)(configuration).getPayoutReport3RefundedOrders(appId, bankAccountId, payoutId, storeIds, page, limit, options)(fetch, basePath);
        },
        getPayoutReport3Stores: function (appId, bankAccountId, payoutId, stores, options) {
            return (0, exports.PayoutReportsApiFp)(configuration).getPayoutReport3Stores(appId, bankAccountId, payoutId, stores, options)(fetch, basePath);
        },
    };
};
exports.PayoutReportsApiFactory = PayoutReportsApiFactory;
var PayoutReportsApi = (function (_super) {
    __extends(PayoutReportsApi, _super);
    function PayoutReportsApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    PayoutReportsApi.prototype.getPayoutReport3Details = function (appId, bankAccountId, payoutId, storeIds, options) {
        return (0, exports.PayoutReportsApiFp)(this.configuration).getPayoutReport3Details(appId, bankAccountId, payoutId, storeIds, options)(this.fetch, this.basePath);
    };
    PayoutReportsApi.prototype.getPayoutReport3Overview = function (appId, bankAccountId, payoutId, options) {
        return (0, exports.PayoutReportsApiFp)(this.configuration).getPayoutReport3Overview(appId, bankAccountId, payoutId, options)(this.fetch, this.basePath);
    };
    PayoutReportsApi.prototype.getPayoutReport3PropertyDetails = function (appId, bankAccountId, payoutId, propertyIds, storeIds, options) {
        return (0, exports.PayoutReportsApiFp)(this.configuration).getPayoutReport3PropertyDetails(appId, bankAccountId, payoutId, propertyIds, storeIds, options)(this.fetch, this.basePath);
    };
    PayoutReportsApi.prototype.getPayoutReport3RefundedOrders = function (appId, bankAccountId, payoutId, storeIds, page, limit, options) {
        return (0, exports.PayoutReportsApiFp)(this.configuration).getPayoutReport3RefundedOrders(appId, bankAccountId, payoutId, storeIds, page, limit, options)(this.fetch, this.basePath);
    };
    PayoutReportsApi.prototype.getPayoutReport3Stores = function (appId, bankAccountId, payoutId, stores, options) {
        return (0, exports.PayoutReportsApiFp)(this.configuration).getPayoutReport3Stores(appId, bankAccountId, payoutId, stores, options)(this.fetch, this.basePath);
    };
    return PayoutReportsApi;
}(BaseAPI));
exports.PayoutReportsApi = PayoutReportsApi;
var PayoutsApiFetchParamCreator = function (configuration) {
    return {
        getPayout: function (appId, bankAccountId, payoutId, options) {
            if (options === void 0) { options = {}; }
            if (appId === null || appId === undefined) {
                throw new RequiredError('appId', 'Required parameter appId was null or undefined when calling getPayout.');
            }
            if (bankAccountId === null || bankAccountId === undefined) {
                throw new RequiredError('bankAccountId', 'Required parameter bankAccountId was null or undefined when calling getPayout.');
            }
            if (payoutId === null || payoutId === undefined) {
                throw new RequiredError('payoutId', 'Required parameter payoutId was null or undefined when calling getPayout.');
            }
            var localVarPath = "/api/v1.0/{appId}/bankaccounts/{bankAccountId}/payouts/{payoutId}"
                .replace("{".concat("appId", "}"), encodeURIComponent(String(appId)))
                .replace("{".concat("bankAccountId", "}"), encodeURIComponent(String(bankAccountId)))
                .replace("{".concat("payoutId", "}"), encodeURIComponent(String(payoutId)));
            var localVarUrlObj = url.parse(localVarPath, true);
            var localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            var localVarHeaderParameter = {};
            var localVarQueryParameter = {};
            if (configuration && configuration.accessToken) {
                var localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("oauth2", ["api"])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        getPayoutChargebacks: function (appId, bankAccountId, payoutId, page, limit, storeIds, options) {
            if (options === void 0) { options = {}; }
            if (appId === null || appId === undefined) {
                throw new RequiredError('appId', 'Required parameter appId was null or undefined when calling getPayoutChargebacks.');
            }
            if (bankAccountId === null || bankAccountId === undefined) {
                throw new RequiredError('bankAccountId', 'Required parameter bankAccountId was null or undefined when calling getPayoutChargebacks.');
            }
            if (payoutId === null || payoutId === undefined) {
                throw new RequiredError('payoutId', 'Required parameter payoutId was null or undefined when calling getPayoutChargebacks.');
            }
            var localVarPath = "/api/v1.0/{appId}/bankaccounts/{bankAccountId}/payouts/{payoutId}/chargebacks"
                .replace("{".concat("appId", "}"), encodeURIComponent(String(appId)))
                .replace("{".concat("bankAccountId", "}"), encodeURIComponent(String(bankAccountId)))
                .replace("{".concat("payoutId", "}"), encodeURIComponent(String(payoutId)));
            var localVarUrlObj = url.parse(localVarPath, true);
            var localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            var localVarHeaderParameter = {};
            var localVarQueryParameter = {};
            if (configuration && configuration.accessToken) {
                var localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("oauth2", ["api"])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }
            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }
            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }
            if (storeIds) {
                localVarQueryParameter['storeIds'] = storeIds;
            }
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        getPayoutOrders: function (appId, bankAccountId, payoutId, page, limit, storeIds, options) {
            if (options === void 0) { options = {}; }
            if (appId === null || appId === undefined) {
                throw new RequiredError('appId', 'Required parameter appId was null or undefined when calling getPayoutOrders.');
            }
            if (bankAccountId === null || bankAccountId === undefined) {
                throw new RequiredError('bankAccountId', 'Required parameter bankAccountId was null or undefined when calling getPayoutOrders.');
            }
            if (payoutId === null || payoutId === undefined) {
                throw new RequiredError('payoutId', 'Required parameter payoutId was null or undefined when calling getPayoutOrders.');
            }
            var localVarPath = "/api/v1.0/{appId}/bankaccounts/{bankAccountId}/payouts/{payoutId}/orders"
                .replace("{".concat("appId", "}"), encodeURIComponent(String(appId)))
                .replace("{".concat("bankAccountId", "}"), encodeURIComponent(String(bankAccountId)))
                .replace("{".concat("payoutId", "}"), encodeURIComponent(String(payoutId)));
            var localVarUrlObj = url.parse(localVarPath, true);
            var localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            var localVarHeaderParameter = {};
            var localVarQueryParameter = {};
            if (configuration && configuration.accessToken) {
                var localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("oauth2", ["api"])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }
            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }
            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }
            if (storeIds) {
                localVarQueryParameter['storeIds'] = storeIds;
            }
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        getPayoutOtherCharges: function (appId, bankAccountId, payoutId, page, limit, storeIds, options) {
            if (options === void 0) { options = {}; }
            if (appId === null || appId === undefined) {
                throw new RequiredError('appId', 'Required parameter appId was null or undefined when calling getPayoutOtherCharges.');
            }
            if (bankAccountId === null || bankAccountId === undefined) {
                throw new RequiredError('bankAccountId', 'Required parameter bankAccountId was null or undefined when calling getPayoutOtherCharges.');
            }
            if (payoutId === null || payoutId === undefined) {
                throw new RequiredError('payoutId', 'Required parameter payoutId was null or undefined when calling getPayoutOtherCharges.');
            }
            var localVarPath = "/api/v1.0/{appId}/bankaccounts/{bankAccountId}/payouts/{payoutId}/othercharges"
                .replace("{".concat("appId", "}"), encodeURIComponent(String(appId)))
                .replace("{".concat("bankAccountId", "}"), encodeURIComponent(String(bankAccountId)))
                .replace("{".concat("payoutId", "}"), encodeURIComponent(String(payoutId)));
            var localVarUrlObj = url.parse(localVarPath, true);
            var localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            var localVarHeaderParameter = {};
            var localVarQueryParameter = {};
            if (configuration && configuration.accessToken) {
                var localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("oauth2", ["api"])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }
            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }
            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }
            if (storeIds) {
                localVarQueryParameter['storeIds'] = storeIds;
            }
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        getPayoutRefunds: function (appId, bankAccountId, payoutId, page, limit, storeIds, options) {
            if (options === void 0) { options = {}; }
            if (appId === null || appId === undefined) {
                throw new RequiredError('appId', 'Required parameter appId was null or undefined when calling getPayoutRefunds.');
            }
            if (bankAccountId === null || bankAccountId === undefined) {
                throw new RequiredError('bankAccountId', 'Required parameter bankAccountId was null or undefined when calling getPayoutRefunds.');
            }
            if (payoutId === null || payoutId === undefined) {
                throw new RequiredError('payoutId', 'Required parameter payoutId was null or undefined when calling getPayoutRefunds.');
            }
            var localVarPath = "/api/v1.0/{appId}/bankaccounts/{bankAccountId}/payouts/{payoutId}/refunds"
                .replace("{".concat("appId", "}"), encodeURIComponent(String(appId)))
                .replace("{".concat("bankAccountId", "}"), encodeURIComponent(String(bankAccountId)))
                .replace("{".concat("payoutId", "}"), encodeURIComponent(String(payoutId)));
            var localVarUrlObj = url.parse(localVarPath, true);
            var localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            var localVarHeaderParameter = {};
            var localVarQueryParameter = {};
            if (configuration && configuration.accessToken) {
                var localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("oauth2", ["api"])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }
            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }
            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }
            if (storeIds) {
                localVarQueryParameter['storeIds'] = storeIds;
            }
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        getPayoutSummaries: function (appId, startDate, endDate, payoutRequestIds_bankAccountIds, payoutRequestIds_states, options) {
            if (options === void 0) { options = {}; }
            if (appId === null || appId === undefined) {
                throw new RequiredError('appId', 'Required parameter appId was null or undefined when calling getPayoutSummaries.');
            }
            var localVarPath = "/api/v1.0/{appId}/payouts/summaries"
                .replace("{".concat("appId", "}"), encodeURIComponent(String(appId)));
            var localVarUrlObj = url.parse(localVarPath, true);
            var localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            var localVarHeaderParameter = {};
            var localVarQueryParameter = {};
            if (configuration && configuration.accessToken) {
                var localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("oauth2", ["api"])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }
            if (startDate !== undefined) {
                localVarQueryParameter['startDate'] = startDate;
            }
            if (endDate !== undefined) {
                localVarQueryParameter['endDate'] = endDate;
            }
            if (payoutRequestIds_bankAccountIds) {
                localVarQueryParameter['payoutRequestIds.bankAccountIds'] = payoutRequestIds_bankAccountIds;
            }
            if (payoutRequestIds_states) {
                localVarQueryParameter['payoutRequestIds.states'] = payoutRequestIds_states;
            }
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        getPayouts: function (appId, startDate, endDate, page, limit, payoutRequestIds_bankAccountIds, payoutRequestIds_states, options) {
            if (options === void 0) { options = {}; }
            if (appId === null || appId === undefined) {
                throw new RequiredError('appId', 'Required parameter appId was null or undefined when calling getPayouts.');
            }
            var localVarPath = "/api/v1.0/{appId}/payouts"
                .replace("{".concat("appId", "}"), encodeURIComponent(String(appId)));
            var localVarUrlObj = url.parse(localVarPath, true);
            var localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            var localVarHeaderParameter = {};
            var localVarQueryParameter = {};
            if (configuration && configuration.accessToken) {
                var localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("oauth2", ["api"])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }
            if (startDate !== undefined) {
                localVarQueryParameter['startDate'] = startDate;
            }
            if (endDate !== undefined) {
                localVarQueryParameter['endDate'] = endDate;
            }
            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }
            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }
            if (payoutRequestIds_bankAccountIds) {
                localVarQueryParameter['payoutRequestIds.bankAccountIds'] = payoutRequestIds_bankAccountIds;
            }
            if (payoutRequestIds_states) {
                localVarQueryParameter['payoutRequestIds.states'] = payoutRequestIds_states;
            }
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    };
};
exports.PayoutsApiFetchParamCreator = PayoutsApiFetchParamCreator;
var PayoutsApiFp = function (configuration) {
    return {
        getPayout: function (appId, bankAccountId, payoutId, options) {
            var localVarFetchArgs = (0, exports.PayoutsApiFetchParamCreator)(configuration).getPayout(appId, bankAccountId, payoutId, options);
            return function (fetch, basePath) {
                if (fetch === void 0) { fetch = portableFetch; }
                if (basePath === void 0) { basePath = BASE_PATH; }
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then(function (response) {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
        getPayoutChargebacks: function (appId, bankAccountId, payoutId, page, limit, storeIds, options) {
            var localVarFetchArgs = (0, exports.PayoutsApiFetchParamCreator)(configuration).getPayoutChargebacks(appId, bankAccountId, payoutId, page, limit, storeIds, options);
            return function (fetch, basePath) {
                if (fetch === void 0) { fetch = portableFetch; }
                if (basePath === void 0) { basePath = BASE_PATH; }
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then(function (response) {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
        getPayoutOrders: function (appId, bankAccountId, payoutId, page, limit, storeIds, options) {
            var localVarFetchArgs = (0, exports.PayoutsApiFetchParamCreator)(configuration).getPayoutOrders(appId, bankAccountId, payoutId, page, limit, storeIds, options);
            return function (fetch, basePath) {
                if (fetch === void 0) { fetch = portableFetch; }
                if (basePath === void 0) { basePath = BASE_PATH; }
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then(function (response) {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
        getPayoutOtherCharges: function (appId, bankAccountId, payoutId, page, limit, storeIds, options) {
            var localVarFetchArgs = (0, exports.PayoutsApiFetchParamCreator)(configuration).getPayoutOtherCharges(appId, bankAccountId, payoutId, page, limit, storeIds, options);
            return function (fetch, basePath) {
                if (fetch === void 0) { fetch = portableFetch; }
                if (basePath === void 0) { basePath = BASE_PATH; }
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then(function (response) {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
        getPayoutRefunds: function (appId, bankAccountId, payoutId, page, limit, storeIds, options) {
            var localVarFetchArgs = (0, exports.PayoutsApiFetchParamCreator)(configuration).getPayoutRefunds(appId, bankAccountId, payoutId, page, limit, storeIds, options);
            return function (fetch, basePath) {
                if (fetch === void 0) { fetch = portableFetch; }
                if (basePath === void 0) { basePath = BASE_PATH; }
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then(function (response) {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
        getPayoutSummaries: function (appId, startDate, endDate, payoutRequestIds_bankAccountIds, payoutRequestIds_states, options) {
            var localVarFetchArgs = (0, exports.PayoutsApiFetchParamCreator)(configuration).getPayoutSummaries(appId, startDate, endDate, payoutRequestIds_bankAccountIds, payoutRequestIds_states, options);
            return function (fetch, basePath) {
                if (fetch === void 0) { fetch = portableFetch; }
                if (basePath === void 0) { basePath = BASE_PATH; }
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then(function (response) {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
        getPayouts: function (appId, startDate, endDate, page, limit, payoutRequestIds_bankAccountIds, payoutRequestIds_states, options) {
            var localVarFetchArgs = (0, exports.PayoutsApiFetchParamCreator)(configuration).getPayouts(appId, startDate, endDate, page, limit, payoutRequestIds_bankAccountIds, payoutRequestIds_states, options);
            return function (fetch, basePath) {
                if (fetch === void 0) { fetch = portableFetch; }
                if (basePath === void 0) { basePath = BASE_PATH; }
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then(function (response) {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
    };
};
exports.PayoutsApiFp = PayoutsApiFp;
var PayoutsApiFactory = function (configuration, fetch, basePath) {
    return {
        getPayout: function (appId, bankAccountId, payoutId, options) {
            return (0, exports.PayoutsApiFp)(configuration).getPayout(appId, bankAccountId, payoutId, options)(fetch, basePath);
        },
        getPayoutChargebacks: function (appId, bankAccountId, payoutId, page, limit, storeIds, options) {
            return (0, exports.PayoutsApiFp)(configuration).getPayoutChargebacks(appId, bankAccountId, payoutId, page, limit, storeIds, options)(fetch, basePath);
        },
        getPayoutOrders: function (appId, bankAccountId, payoutId, page, limit, storeIds, options) {
            return (0, exports.PayoutsApiFp)(configuration).getPayoutOrders(appId, bankAccountId, payoutId, page, limit, storeIds, options)(fetch, basePath);
        },
        getPayoutOtherCharges: function (appId, bankAccountId, payoutId, page, limit, storeIds, options) {
            return (0, exports.PayoutsApiFp)(configuration).getPayoutOtherCharges(appId, bankAccountId, payoutId, page, limit, storeIds, options)(fetch, basePath);
        },
        getPayoutRefunds: function (appId, bankAccountId, payoutId, page, limit, storeIds, options) {
            return (0, exports.PayoutsApiFp)(configuration).getPayoutRefunds(appId, bankAccountId, payoutId, page, limit, storeIds, options)(fetch, basePath);
        },
        getPayoutSummaries: function (appId, startDate, endDate, payoutRequestIds_bankAccountIds, payoutRequestIds_states, options) {
            return (0, exports.PayoutsApiFp)(configuration).getPayoutSummaries(appId, startDate, endDate, payoutRequestIds_bankAccountIds, payoutRequestIds_states, options)(fetch, basePath);
        },
        getPayouts: function (appId, startDate, endDate, page, limit, payoutRequestIds_bankAccountIds, payoutRequestIds_states, options) {
            return (0, exports.PayoutsApiFp)(configuration).getPayouts(appId, startDate, endDate, page, limit, payoutRequestIds_bankAccountIds, payoutRequestIds_states, options)(fetch, basePath);
        },
    };
};
exports.PayoutsApiFactory = PayoutsApiFactory;
var PayoutsApi = (function (_super) {
    __extends(PayoutsApi, _super);
    function PayoutsApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    PayoutsApi.prototype.getPayout = function (appId, bankAccountId, payoutId, options) {
        return (0, exports.PayoutsApiFp)(this.configuration).getPayout(appId, bankAccountId, payoutId, options)(this.fetch, this.basePath);
    };
    PayoutsApi.prototype.getPayoutChargebacks = function (appId, bankAccountId, payoutId, page, limit, storeIds, options) {
        return (0, exports.PayoutsApiFp)(this.configuration).getPayoutChargebacks(appId, bankAccountId, payoutId, page, limit, storeIds, options)(this.fetch, this.basePath);
    };
    PayoutsApi.prototype.getPayoutOrders = function (appId, bankAccountId, payoutId, page, limit, storeIds, options) {
        return (0, exports.PayoutsApiFp)(this.configuration).getPayoutOrders(appId, bankAccountId, payoutId, page, limit, storeIds, options)(this.fetch, this.basePath);
    };
    PayoutsApi.prototype.getPayoutOtherCharges = function (appId, bankAccountId, payoutId, page, limit, storeIds, options) {
        return (0, exports.PayoutsApiFp)(this.configuration).getPayoutOtherCharges(appId, bankAccountId, payoutId, page, limit, storeIds, options)(this.fetch, this.basePath);
    };
    PayoutsApi.prototype.getPayoutRefunds = function (appId, bankAccountId, payoutId, page, limit, storeIds, options) {
        return (0, exports.PayoutsApiFp)(this.configuration).getPayoutRefunds(appId, bankAccountId, payoutId, page, limit, storeIds, options)(this.fetch, this.basePath);
    };
    PayoutsApi.prototype.getPayoutSummaries = function (appId, startDate, endDate, payoutRequestIds_bankAccountIds, payoutRequestIds_states, options) {
        return (0, exports.PayoutsApiFp)(this.configuration).getPayoutSummaries(appId, startDate, endDate, payoutRequestIds_bankAccountIds, payoutRequestIds_states, options)(this.fetch, this.basePath);
    };
    PayoutsApi.prototype.getPayouts = function (appId, startDate, endDate, page, limit, payoutRequestIds_bankAccountIds, payoutRequestIds_states, options) {
        return (0, exports.PayoutsApiFp)(this.configuration).getPayouts(appId, startDate, endDate, page, limit, payoutRequestIds_bankAccountIds, payoutRequestIds_states, options)(this.fetch, this.basePath);
    };
    return PayoutsApi;
}(BaseAPI));
exports.PayoutsApi = PayoutsApi;
var ProcessingFeeConfigsApiFetchParamCreator = function (configuration) {
    return {
        getProcessingFeeConfigsByStoreIds: function (storeIds, options) {
            if (options === void 0) { options = {}; }
            if (storeIds === null || storeIds === undefined) {
                throw new RequiredError('storeIds', 'Required parameter storeIds was null or undefined when calling getProcessingFeeConfigsByStoreIds.');
            }
            var localVarPath = "/api/v1.0/processingfeeconfigs";
            var localVarUrlObj = url.parse(localVarPath, true);
            var localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            var localVarHeaderParameter = {};
            var localVarQueryParameter = {};
            if (configuration && configuration.accessToken) {
                var localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("oauth2", ["api"])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }
            if (storeIds) {
                localVarQueryParameter['storeIds'] = storeIds;
            }
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    };
};
exports.ProcessingFeeConfigsApiFetchParamCreator = ProcessingFeeConfigsApiFetchParamCreator;
var ProcessingFeeConfigsApiFp = function (configuration) {
    return {
        getProcessingFeeConfigsByStoreIds: function (storeIds, options) {
            var localVarFetchArgs = (0, exports.ProcessingFeeConfigsApiFetchParamCreator)(configuration).getProcessingFeeConfigsByStoreIds(storeIds, options);
            return function (fetch, basePath) {
                if (fetch === void 0) { fetch = portableFetch; }
                if (basePath === void 0) { basePath = BASE_PATH; }
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then(function (response) {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
    };
};
exports.ProcessingFeeConfigsApiFp = ProcessingFeeConfigsApiFp;
var ProcessingFeeConfigsApiFactory = function (configuration, fetch, basePath) {
    return {
        getProcessingFeeConfigsByStoreIds: function (storeIds, options) {
            return (0, exports.ProcessingFeeConfigsApiFp)(configuration).getProcessingFeeConfigsByStoreIds(storeIds, options)(fetch, basePath);
        },
    };
};
exports.ProcessingFeeConfigsApiFactory = ProcessingFeeConfigsApiFactory;
var ProcessingFeeConfigsApi = (function (_super) {
    __extends(ProcessingFeeConfigsApi, _super);
    function ProcessingFeeConfigsApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    ProcessingFeeConfigsApi.prototype.getProcessingFeeConfigsByStoreIds = function (storeIds, options) {
        return (0, exports.ProcessingFeeConfigsApiFp)(this.configuration).getProcessingFeeConfigsByStoreIds(storeIds, options)(this.fetch, this.basePath);
    };
    return ProcessingFeeConfigsApi;
}(BaseAPI));
exports.ProcessingFeeConfigsApi = ProcessingFeeConfigsApi;
var PushNotificationsApiFetchParamCreator = function (configuration) {
    return {
        deletePushNotification: function (appId, scheduledPushNotificationId, options) {
            if (options === void 0) { options = {}; }
            if (appId === null || appId === undefined) {
                throw new RequiredError('appId', 'Required parameter appId was null or undefined when calling deletePushNotification.');
            }
            if (scheduledPushNotificationId === null || scheduledPushNotificationId === undefined) {
                throw new RequiredError('scheduledPushNotificationId', 'Required parameter scheduledPushNotificationId was null or undefined when calling deletePushNotification.');
            }
            var localVarPath = "/api/v1.0/{appId}/pushnotifications/{scheduledPushNotificationId}"
                .replace("{".concat("appId", "}"), encodeURIComponent(String(appId)))
                .replace("{".concat("scheduledPushNotificationId", "}"), encodeURIComponent(String(scheduledPushNotificationId)));
            var localVarUrlObj = url.parse(localVarPath, true);
            var localVarRequestOptions = Object.assign({ method: 'DELETE' }, options);
            var localVarHeaderParameter = {};
            var localVarQueryParameter = {};
            if (configuration && configuration.accessToken) {
                var localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("oauth2", ["api"])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        getPushNotifications: function (appId, page, limit, options) {
            if (options === void 0) { options = {}; }
            if (appId === null || appId === undefined) {
                throw new RequiredError('appId', 'Required parameter appId was null or undefined when calling getPushNotifications.');
            }
            var localVarPath = "/api/v1.0/{appId}/pushnotifications"
                .replace("{".concat("appId", "}"), encodeURIComponent(String(appId)));
            var localVarUrlObj = url.parse(localVarPath, true);
            var localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            var localVarHeaderParameter = {};
            var localVarQueryParameter = {};
            if (configuration && configuration.accessToken) {
                var localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("oauth2", ["api"])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }
            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }
            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        schedulePushNotification: function (appId, PushNotificationRequest, options) {
            if (options === void 0) { options = {}; }
            if (appId === null || appId === undefined) {
                throw new RequiredError('appId', 'Required parameter appId was null or undefined when calling schedulePushNotification.');
            }
            if (PushNotificationRequest === null || PushNotificationRequest === undefined) {
                throw new RequiredError('PushNotificationRequest', 'Required parameter PushNotificationRequest was null or undefined when calling schedulePushNotification.');
            }
            var localVarPath = "/api/v1.0/{appId}/pushnotifications"
                .replace("{".concat("appId", "}"), encodeURIComponent(String(appId)));
            var localVarUrlObj = url.parse(localVarPath, true);
            var localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            var localVarHeaderParameter = {};
            var localVarQueryParameter = {};
            if (configuration && configuration.accessToken) {
                var localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("oauth2", ["api"])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }
            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            var needsSerialization = ("PushNotificationRequest" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body = needsSerialization ? JSON.stringify(PushNotificationRequest || {}) : (PushNotificationRequest || "");
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        updatePushNotification: function (appId, scheduledPushNotificationId, PushNotificationRequest, options) {
            if (options === void 0) { options = {}; }
            if (appId === null || appId === undefined) {
                throw new RequiredError('appId', 'Required parameter appId was null or undefined when calling updatePushNotification.');
            }
            if (scheduledPushNotificationId === null || scheduledPushNotificationId === undefined) {
                throw new RequiredError('scheduledPushNotificationId', 'Required parameter scheduledPushNotificationId was null or undefined when calling updatePushNotification.');
            }
            if (PushNotificationRequest === null || PushNotificationRequest === undefined) {
                throw new RequiredError('PushNotificationRequest', 'Required parameter PushNotificationRequest was null or undefined when calling updatePushNotification.');
            }
            var localVarPath = "/api/v1.0/{appId}/pushnotifications/{scheduledPushNotificationId}"
                .replace("{".concat("appId", "}"), encodeURIComponent(String(appId)))
                .replace("{".concat("scheduledPushNotificationId", "}"), encodeURIComponent(String(scheduledPushNotificationId)));
            var localVarUrlObj = url.parse(localVarPath, true);
            var localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            var localVarHeaderParameter = {};
            var localVarQueryParameter = {};
            if (configuration && configuration.accessToken) {
                var localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("oauth2", ["api"])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }
            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            var needsSerialization = ("PushNotificationRequest" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body = needsSerialization ? JSON.stringify(PushNotificationRequest || {}) : (PushNotificationRequest || "");
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    };
};
exports.PushNotificationsApiFetchParamCreator = PushNotificationsApiFetchParamCreator;
var PushNotificationsApiFp = function (configuration) {
    return {
        deletePushNotification: function (appId, scheduledPushNotificationId, options) {
            var localVarFetchArgs = (0, exports.PushNotificationsApiFetchParamCreator)(configuration).deletePushNotification(appId, scheduledPushNotificationId, options);
            return function (fetch, basePath) {
                if (fetch === void 0) { fetch = portableFetch; }
                if (basePath === void 0) { basePath = BASE_PATH; }
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then(function (response) {
                    if (response.status >= 200 && response.status < 300) {
                        return response;
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
        getPushNotifications: function (appId, page, limit, options) {
            var localVarFetchArgs = (0, exports.PushNotificationsApiFetchParamCreator)(configuration).getPushNotifications(appId, page, limit, options);
            return function (fetch, basePath) {
                if (fetch === void 0) { fetch = portableFetch; }
                if (basePath === void 0) { basePath = BASE_PATH; }
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then(function (response) {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
        schedulePushNotification: function (appId, PushNotificationRequest, options) {
            var localVarFetchArgs = (0, exports.PushNotificationsApiFetchParamCreator)(configuration).schedulePushNotification(appId, PushNotificationRequest, options);
            return function (fetch, basePath) {
                if (fetch === void 0) { fetch = portableFetch; }
                if (basePath === void 0) { basePath = BASE_PATH; }
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then(function (response) {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
        updatePushNotification: function (appId, scheduledPushNotificationId, PushNotificationRequest, options) {
            var localVarFetchArgs = (0, exports.PushNotificationsApiFetchParamCreator)(configuration).updatePushNotification(appId, scheduledPushNotificationId, PushNotificationRequest, options);
            return function (fetch, basePath) {
                if (fetch === void 0) { fetch = portableFetch; }
                if (basePath === void 0) { basePath = BASE_PATH; }
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then(function (response) {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
    };
};
exports.PushNotificationsApiFp = PushNotificationsApiFp;
var PushNotificationsApiFactory = function (configuration, fetch, basePath) {
    return {
        deletePushNotification: function (appId, scheduledPushNotificationId, options) {
            return (0, exports.PushNotificationsApiFp)(configuration).deletePushNotification(appId, scheduledPushNotificationId, options)(fetch, basePath);
        },
        getPushNotifications: function (appId, page, limit, options) {
            return (0, exports.PushNotificationsApiFp)(configuration).getPushNotifications(appId, page, limit, options)(fetch, basePath);
        },
        schedulePushNotification: function (appId, PushNotificationRequest, options) {
            return (0, exports.PushNotificationsApiFp)(configuration).schedulePushNotification(appId, PushNotificationRequest, options)(fetch, basePath);
        },
        updatePushNotification: function (appId, scheduledPushNotificationId, PushNotificationRequest, options) {
            return (0, exports.PushNotificationsApiFp)(configuration).updatePushNotification(appId, scheduledPushNotificationId, PushNotificationRequest, options)(fetch, basePath);
        },
    };
};
exports.PushNotificationsApiFactory = PushNotificationsApiFactory;
var PushNotificationsApi = (function (_super) {
    __extends(PushNotificationsApi, _super);
    function PushNotificationsApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    PushNotificationsApi.prototype.deletePushNotification = function (appId, scheduledPushNotificationId, options) {
        return (0, exports.PushNotificationsApiFp)(this.configuration).deletePushNotification(appId, scheduledPushNotificationId, options)(this.fetch, this.basePath);
    };
    PushNotificationsApi.prototype.getPushNotifications = function (appId, page, limit, options) {
        return (0, exports.PushNotificationsApiFp)(this.configuration).getPushNotifications(appId, page, limit, options)(this.fetch, this.basePath);
    };
    PushNotificationsApi.prototype.schedulePushNotification = function (appId, PushNotificationRequest, options) {
        return (0, exports.PushNotificationsApiFp)(this.configuration).schedulePushNotification(appId, PushNotificationRequest, options)(this.fetch, this.basePath);
    };
    PushNotificationsApi.prototype.updatePushNotification = function (appId, scheduledPushNotificationId, PushNotificationRequest, options) {
        return (0, exports.PushNotificationsApiFp)(this.configuration).updatePushNotification(appId, scheduledPushNotificationId, PushNotificationRequest, options)(this.fetch, this.basePath);
    };
    return PushNotificationsApi;
}(BaseAPI));
exports.PushNotificationsApi = PushNotificationsApi;
var ReceiptsApiFetchParamCreator = function (configuration) {
    return {
        getReceipt: function (orderId, options) {
            if (options === void 0) { options = {}; }
            if (orderId === null || orderId === undefined) {
                throw new RequiredError('orderId', 'Required parameter orderId was null or undefined when calling getReceipt.');
            }
            var localVarPath = "/api/v1.0/receipts/{orderId}"
                .replace("{".concat("orderId", "}"), encodeURIComponent(String(orderId)));
            var localVarUrlObj = url.parse(localVarPath, true);
            var localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            var localVarHeaderParameter = {};
            var localVarQueryParameter = {};
            if (configuration && configuration.accessToken) {
                var localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("oauth2", ["api"])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    };
};
exports.ReceiptsApiFetchParamCreator = ReceiptsApiFetchParamCreator;
var ReceiptsApiFp = function (configuration) {
    return {
        getReceipt: function (orderId, options) {
            var localVarFetchArgs = (0, exports.ReceiptsApiFetchParamCreator)(configuration).getReceipt(orderId, options);
            return function (fetch, basePath) {
                if (fetch === void 0) { fetch = portableFetch; }
                if (basePath === void 0) { basePath = BASE_PATH; }
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then(function (response) {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
    };
};
exports.ReceiptsApiFp = ReceiptsApiFp;
var ReceiptsApiFactory = function (configuration, fetch, basePath) {
    return {
        getReceipt: function (orderId, options) {
            return (0, exports.ReceiptsApiFp)(configuration).getReceipt(orderId, options)(fetch, basePath);
        },
    };
};
exports.ReceiptsApiFactory = ReceiptsApiFactory;
var ReceiptsApi = (function (_super) {
    __extends(ReceiptsApi, _super);
    function ReceiptsApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    ReceiptsApi.prototype.getReceipt = function (orderId, options) {
        return (0, exports.ReceiptsApiFp)(this.configuration).getReceipt(orderId, options)(this.fetch, this.basePath);
    };
    return ReceiptsApi;
}(BaseAPI));
exports.ReceiptsApi = ReceiptsApi;
var RestaurantVouchersPayGreenApiFetchParamCreator = function (configuration) {
    return {
        createPayGreenConfiguration: function (appId, CreatePayGreenConfigurationRequest, options) {
            if (options === void 0) { options = {}; }
            if (appId === null || appId === undefined) {
                throw new RequiredError('appId', 'Required parameter appId was null or undefined when calling createPayGreenConfiguration.');
            }
            if (CreatePayGreenConfigurationRequest === null || CreatePayGreenConfigurationRequest === undefined) {
                throw new RequiredError('CreatePayGreenConfigurationRequest', 'Required parameter CreatePayGreenConfigurationRequest was null or undefined when calling createPayGreenConfiguration.');
            }
            var localVarPath = "/api/v1.0/{appId}/restaurant-vouchers/paygreen"
                .replace("{".concat("appId", "}"), encodeURIComponent(String(appId)));
            var localVarUrlObj = url.parse(localVarPath, true);
            var localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            var localVarHeaderParameter = {};
            var localVarQueryParameter = {};
            if (configuration && configuration.accessToken) {
                var localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("oauth2", ["api"])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }
            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            var needsSerialization = ("CreatePayGreenConfigurationRequest" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body = needsSerialization ? JSON.stringify(CreatePayGreenConfigurationRequest || {}) : (CreatePayGreenConfigurationRequest || "");
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        deletePayGreenConfiguration: function (appId, paygreenConfigurationId, options) {
            if (options === void 0) { options = {}; }
            if (appId === null || appId === undefined) {
                throw new RequiredError('appId', 'Required parameter appId was null or undefined when calling deletePayGreenConfiguration.');
            }
            if (paygreenConfigurationId === null || paygreenConfigurationId === undefined) {
                throw new RequiredError('paygreenConfigurationId', 'Required parameter paygreenConfigurationId was null or undefined when calling deletePayGreenConfiguration.');
            }
            var localVarPath = "/api/v1.0/{appId}/restaurant-vouchers/paygreen/{paygreenConfigurationId}"
                .replace("{".concat("appId", "}"), encodeURIComponent(String(appId)))
                .replace("{".concat("paygreenConfigurationId", "}"), encodeURIComponent(String(paygreenConfigurationId)));
            var localVarUrlObj = url.parse(localVarPath, true);
            var localVarRequestOptions = Object.assign({ method: 'DELETE' }, options);
            var localVarHeaderParameter = {};
            var localVarQueryParameter = {};
            if (configuration && configuration.accessToken) {
                var localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("oauth2", ["api"])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        getElegibleStores: function (appId, options) {
            if (options === void 0) { options = {}; }
            if (appId === null || appId === undefined) {
                throw new RequiredError('appId', 'Required parameter appId was null or undefined when calling getElegibleStores.');
            }
            var localVarPath = "/api/v1.0/{appId}/restaurant-vouchers/paygreen/stores"
                .replace("{".concat("appId", "}"), encodeURIComponent(String(appId)));
            var localVarUrlObj = url.parse(localVarPath, true);
            var localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            var localVarHeaderParameter = {};
            var localVarQueryParameter = {};
            if (configuration && configuration.accessToken) {
                var localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("oauth2", ["api"])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        getPayGreenConfigurations: function (appId, options) {
            if (options === void 0) { options = {}; }
            if (appId === null || appId === undefined) {
                throw new RequiredError('appId', 'Required parameter appId was null or undefined when calling getPayGreenConfigurations.');
            }
            var localVarPath = "/api/v1.0/{appId}/restaurant-vouchers/paygreen"
                .replace("{".concat("appId", "}"), encodeURIComponent(String(appId)));
            var localVarUrlObj = url.parse(localVarPath, true);
            var localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            var localVarHeaderParameter = {};
            var localVarQueryParameter = {};
            if (configuration && configuration.accessToken) {
                var localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("oauth2", ["api"])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        getStoreAvailablePayGreenConfigurations: function (appId, storeId, options) {
            if (options === void 0) { options = {}; }
            if (appId === null || appId === undefined) {
                throw new RequiredError('appId', 'Required parameter appId was null or undefined when calling getStoreAvailablePayGreenConfigurations.');
            }
            if (storeId === null || storeId === undefined) {
                throw new RequiredError('storeId', 'Required parameter storeId was null or undefined when calling getStoreAvailablePayGreenConfigurations.');
            }
            var localVarPath = "/api/v1.0/{appId}/restaurant-vouchers/paygreen/stores/{storeId}/available-configurations"
                .replace("{".concat("appId", "}"), encodeURIComponent(String(appId)))
                .replace("{".concat("storeId", "}"), encodeURIComponent(String(storeId)));
            var localVarUrlObj = url.parse(localVarPath, true);
            var localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            var localVarHeaderParameter = {};
            var localVarQueryParameter = {};
            if (configuration && configuration.accessToken) {
                var localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("oauth2", ["api"])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        getStorePayGreenConfiguration: function (appId, storeId, options) {
            if (options === void 0) { options = {}; }
            if (appId === null || appId === undefined) {
                throw new RequiredError('appId', 'Required parameter appId was null or undefined when calling getStorePayGreenConfiguration.');
            }
            if (storeId === null || storeId === undefined) {
                throw new RequiredError('storeId', 'Required parameter storeId was null or undefined when calling getStorePayGreenConfiguration.');
            }
            var localVarPath = "/api/v1.0/{appId}/restaurant-vouchers/paygreen/stores/{storeId}"
                .replace("{".concat("appId", "}"), encodeURIComponent(String(appId)))
                .replace("{".concat("storeId", "}"), encodeURIComponent(String(storeId)));
            var localVarUrlObj = url.parse(localVarPath, true);
            var localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            var localVarHeaderParameter = {};
            var localVarQueryParameter = {};
            if (configuration && configuration.accessToken) {
                var localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("oauth2", ["api"])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        listPayGreenConfigurations: function (appId, paygreenConfigurationId, options) {
            if (options === void 0) { options = {}; }
            if (appId === null || appId === undefined) {
                throw new RequiredError('appId', 'Required parameter appId was null or undefined when calling listPayGreenConfigurations.');
            }
            if (paygreenConfigurationId === null || paygreenConfigurationId === undefined) {
                throw new RequiredError('paygreenConfigurationId', 'Required parameter paygreenConfigurationId was null or undefined when calling listPayGreenConfigurations.');
            }
            var localVarPath = "/api/v1.0/{appId}/restaurant-vouchers/paygreen/{paygreenConfigurationId}"
                .replace("{".concat("appId", "}"), encodeURIComponent(String(appId)))
                .replace("{".concat("paygreenConfigurationId", "}"), encodeURIComponent(String(paygreenConfigurationId)));
            var localVarUrlObj = url.parse(localVarPath, true);
            var localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            var localVarHeaderParameter = {};
            var localVarQueryParameter = {};
            if (configuration && configuration.accessToken) {
                var localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("oauth2", ["api"])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        updatePayGreenConfiguration: function (appId, paygreenConfigurationId, UpdatePayGreenConfigurationRequest, options) {
            if (options === void 0) { options = {}; }
            if (appId === null || appId === undefined) {
                throw new RequiredError('appId', 'Required parameter appId was null or undefined when calling updatePayGreenConfiguration.');
            }
            if (paygreenConfigurationId === null || paygreenConfigurationId === undefined) {
                throw new RequiredError('paygreenConfigurationId', 'Required parameter paygreenConfigurationId was null or undefined when calling updatePayGreenConfiguration.');
            }
            if (UpdatePayGreenConfigurationRequest === null || UpdatePayGreenConfigurationRequest === undefined) {
                throw new RequiredError('UpdatePayGreenConfigurationRequest', 'Required parameter UpdatePayGreenConfigurationRequest was null or undefined when calling updatePayGreenConfiguration.');
            }
            var localVarPath = "/api/v1.0/{appId}/restaurant-vouchers/paygreen/{paygreenConfigurationId}"
                .replace("{".concat("appId", "}"), encodeURIComponent(String(appId)))
                .replace("{".concat("paygreenConfigurationId", "}"), encodeURIComponent(String(paygreenConfigurationId)));
            var localVarUrlObj = url.parse(localVarPath, true);
            var localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            var localVarHeaderParameter = {};
            var localVarQueryParameter = {};
            if (configuration && configuration.accessToken) {
                var localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("oauth2", ["api"])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }
            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            var needsSerialization = ("UpdatePayGreenConfigurationRequest" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body = needsSerialization ? JSON.stringify(UpdatePayGreenConfigurationRequest || {}) : (UpdatePayGreenConfigurationRequest || "");
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        updateStorePayGreenConfiguration: function (appId, storeId, UpdateStorePayGreenConfigurationRequest, options) {
            if (options === void 0) { options = {}; }
            if (appId === null || appId === undefined) {
                throw new RequiredError('appId', 'Required parameter appId was null or undefined when calling updateStorePayGreenConfiguration.');
            }
            if (storeId === null || storeId === undefined) {
                throw new RequiredError('storeId', 'Required parameter storeId was null or undefined when calling updateStorePayGreenConfiguration.');
            }
            if (UpdateStorePayGreenConfigurationRequest === null || UpdateStorePayGreenConfigurationRequest === undefined) {
                throw new RequiredError('UpdateStorePayGreenConfigurationRequest', 'Required parameter UpdateStorePayGreenConfigurationRequest was null or undefined when calling updateStorePayGreenConfiguration.');
            }
            var localVarPath = "/api/v1.0/{appId}/restaurant-vouchers/paygreen/stores/{storeId}"
                .replace("{".concat("appId", "}"), encodeURIComponent(String(appId)))
                .replace("{".concat("storeId", "}"), encodeURIComponent(String(storeId)));
            var localVarUrlObj = url.parse(localVarPath, true);
            var localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            var localVarHeaderParameter = {};
            var localVarQueryParameter = {};
            if (configuration && configuration.accessToken) {
                var localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("oauth2", ["api"])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }
            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            var needsSerialization = ("UpdateStorePayGreenConfigurationRequest" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body = needsSerialization ? JSON.stringify(UpdateStorePayGreenConfigurationRequest || {}) : (UpdateStorePayGreenConfigurationRequest || "");
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    };
};
exports.RestaurantVouchersPayGreenApiFetchParamCreator = RestaurantVouchersPayGreenApiFetchParamCreator;
var RestaurantVouchersPayGreenApiFp = function (configuration) {
    return {
        createPayGreenConfiguration: function (appId, CreatePayGreenConfigurationRequest, options) {
            var localVarFetchArgs = (0, exports.RestaurantVouchersPayGreenApiFetchParamCreator)(configuration).createPayGreenConfiguration(appId, CreatePayGreenConfigurationRequest, options);
            return function (fetch, basePath) {
                if (fetch === void 0) { fetch = portableFetch; }
                if (basePath === void 0) { basePath = BASE_PATH; }
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then(function (response) {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
        deletePayGreenConfiguration: function (appId, paygreenConfigurationId, options) {
            var localVarFetchArgs = (0, exports.RestaurantVouchersPayGreenApiFetchParamCreator)(configuration).deletePayGreenConfiguration(appId, paygreenConfigurationId, options);
            return function (fetch, basePath) {
                if (fetch === void 0) { fetch = portableFetch; }
                if (basePath === void 0) { basePath = BASE_PATH; }
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then(function (response) {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
        getElegibleStores: function (appId, options) {
            var localVarFetchArgs = (0, exports.RestaurantVouchersPayGreenApiFetchParamCreator)(configuration).getElegibleStores(appId, options);
            return function (fetch, basePath) {
                if (fetch === void 0) { fetch = portableFetch; }
                if (basePath === void 0) { basePath = BASE_PATH; }
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then(function (response) {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
        getPayGreenConfigurations: function (appId, options) {
            var localVarFetchArgs = (0, exports.RestaurantVouchersPayGreenApiFetchParamCreator)(configuration).getPayGreenConfigurations(appId, options);
            return function (fetch, basePath) {
                if (fetch === void 0) { fetch = portableFetch; }
                if (basePath === void 0) { basePath = BASE_PATH; }
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then(function (response) {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
        getStoreAvailablePayGreenConfigurations: function (appId, storeId, options) {
            var localVarFetchArgs = (0, exports.RestaurantVouchersPayGreenApiFetchParamCreator)(configuration).getStoreAvailablePayGreenConfigurations(appId, storeId, options);
            return function (fetch, basePath) {
                if (fetch === void 0) { fetch = portableFetch; }
                if (basePath === void 0) { basePath = BASE_PATH; }
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then(function (response) {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
        getStorePayGreenConfiguration: function (appId, storeId, options) {
            var localVarFetchArgs = (0, exports.RestaurantVouchersPayGreenApiFetchParamCreator)(configuration).getStorePayGreenConfiguration(appId, storeId, options);
            return function (fetch, basePath) {
                if (fetch === void 0) { fetch = portableFetch; }
                if (basePath === void 0) { basePath = BASE_PATH; }
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then(function (response) {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
        listPayGreenConfigurations: function (appId, paygreenConfigurationId, options) {
            var localVarFetchArgs = (0, exports.RestaurantVouchersPayGreenApiFetchParamCreator)(configuration).listPayGreenConfigurations(appId, paygreenConfigurationId, options);
            return function (fetch, basePath) {
                if (fetch === void 0) { fetch = portableFetch; }
                if (basePath === void 0) { basePath = BASE_PATH; }
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then(function (response) {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
        updatePayGreenConfiguration: function (appId, paygreenConfigurationId, UpdatePayGreenConfigurationRequest, options) {
            var localVarFetchArgs = (0, exports.RestaurantVouchersPayGreenApiFetchParamCreator)(configuration).updatePayGreenConfiguration(appId, paygreenConfigurationId, UpdatePayGreenConfigurationRequest, options);
            return function (fetch, basePath) {
                if (fetch === void 0) { fetch = portableFetch; }
                if (basePath === void 0) { basePath = BASE_PATH; }
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then(function (response) {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
        updateStorePayGreenConfiguration: function (appId, storeId, UpdateStorePayGreenConfigurationRequest, options) {
            var localVarFetchArgs = (0, exports.RestaurantVouchersPayGreenApiFetchParamCreator)(configuration).updateStorePayGreenConfiguration(appId, storeId, UpdateStorePayGreenConfigurationRequest, options);
            return function (fetch, basePath) {
                if (fetch === void 0) { fetch = portableFetch; }
                if (basePath === void 0) { basePath = BASE_PATH; }
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then(function (response) {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
    };
};
exports.RestaurantVouchersPayGreenApiFp = RestaurantVouchersPayGreenApiFp;
var RestaurantVouchersPayGreenApiFactory = function (configuration, fetch, basePath) {
    return {
        createPayGreenConfiguration: function (appId, CreatePayGreenConfigurationRequest, options) {
            return (0, exports.RestaurantVouchersPayGreenApiFp)(configuration).createPayGreenConfiguration(appId, CreatePayGreenConfigurationRequest, options)(fetch, basePath);
        },
        deletePayGreenConfiguration: function (appId, paygreenConfigurationId, options) {
            return (0, exports.RestaurantVouchersPayGreenApiFp)(configuration).deletePayGreenConfiguration(appId, paygreenConfigurationId, options)(fetch, basePath);
        },
        getElegibleStores: function (appId, options) {
            return (0, exports.RestaurantVouchersPayGreenApiFp)(configuration).getElegibleStores(appId, options)(fetch, basePath);
        },
        getPayGreenConfigurations: function (appId, options) {
            return (0, exports.RestaurantVouchersPayGreenApiFp)(configuration).getPayGreenConfigurations(appId, options)(fetch, basePath);
        },
        getStoreAvailablePayGreenConfigurations: function (appId, storeId, options) {
            return (0, exports.RestaurantVouchersPayGreenApiFp)(configuration).getStoreAvailablePayGreenConfigurations(appId, storeId, options)(fetch, basePath);
        },
        getStorePayGreenConfiguration: function (appId, storeId, options) {
            return (0, exports.RestaurantVouchersPayGreenApiFp)(configuration).getStorePayGreenConfiguration(appId, storeId, options)(fetch, basePath);
        },
        listPayGreenConfigurations: function (appId, paygreenConfigurationId, options) {
            return (0, exports.RestaurantVouchersPayGreenApiFp)(configuration).listPayGreenConfigurations(appId, paygreenConfigurationId, options)(fetch, basePath);
        },
        updatePayGreenConfiguration: function (appId, paygreenConfigurationId, UpdatePayGreenConfigurationRequest, options) {
            return (0, exports.RestaurantVouchersPayGreenApiFp)(configuration).updatePayGreenConfiguration(appId, paygreenConfigurationId, UpdatePayGreenConfigurationRequest, options)(fetch, basePath);
        },
        updateStorePayGreenConfiguration: function (appId, storeId, UpdateStorePayGreenConfigurationRequest, options) {
            return (0, exports.RestaurantVouchersPayGreenApiFp)(configuration).updateStorePayGreenConfiguration(appId, storeId, UpdateStorePayGreenConfigurationRequest, options)(fetch, basePath);
        },
    };
};
exports.RestaurantVouchersPayGreenApiFactory = RestaurantVouchersPayGreenApiFactory;
var RestaurantVouchersPayGreenApi = (function (_super) {
    __extends(RestaurantVouchersPayGreenApi, _super);
    function RestaurantVouchersPayGreenApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    RestaurantVouchersPayGreenApi.prototype.createPayGreenConfiguration = function (appId, CreatePayGreenConfigurationRequest, options) {
        return (0, exports.RestaurantVouchersPayGreenApiFp)(this.configuration).createPayGreenConfiguration(appId, CreatePayGreenConfigurationRequest, options)(this.fetch, this.basePath);
    };
    RestaurantVouchersPayGreenApi.prototype.deletePayGreenConfiguration = function (appId, paygreenConfigurationId, options) {
        return (0, exports.RestaurantVouchersPayGreenApiFp)(this.configuration).deletePayGreenConfiguration(appId, paygreenConfigurationId, options)(this.fetch, this.basePath);
    };
    RestaurantVouchersPayGreenApi.prototype.getElegibleStores = function (appId, options) {
        return (0, exports.RestaurantVouchersPayGreenApiFp)(this.configuration).getElegibleStores(appId, options)(this.fetch, this.basePath);
    };
    RestaurantVouchersPayGreenApi.prototype.getPayGreenConfigurations = function (appId, options) {
        return (0, exports.RestaurantVouchersPayGreenApiFp)(this.configuration).getPayGreenConfigurations(appId, options)(this.fetch, this.basePath);
    };
    RestaurantVouchersPayGreenApi.prototype.getStoreAvailablePayGreenConfigurations = function (appId, storeId, options) {
        return (0, exports.RestaurantVouchersPayGreenApiFp)(this.configuration).getStoreAvailablePayGreenConfigurations(appId, storeId, options)(this.fetch, this.basePath);
    };
    RestaurantVouchersPayGreenApi.prototype.getStorePayGreenConfiguration = function (appId, storeId, options) {
        return (0, exports.RestaurantVouchersPayGreenApiFp)(this.configuration).getStorePayGreenConfiguration(appId, storeId, options)(this.fetch, this.basePath);
    };
    RestaurantVouchersPayGreenApi.prototype.listPayGreenConfigurations = function (appId, paygreenConfigurationId, options) {
        return (0, exports.RestaurantVouchersPayGreenApiFp)(this.configuration).listPayGreenConfigurations(appId, paygreenConfigurationId, options)(this.fetch, this.basePath);
    };
    RestaurantVouchersPayGreenApi.prototype.updatePayGreenConfiguration = function (appId, paygreenConfigurationId, UpdatePayGreenConfigurationRequest, options) {
        return (0, exports.RestaurantVouchersPayGreenApiFp)(this.configuration).updatePayGreenConfiguration(appId, paygreenConfigurationId, UpdatePayGreenConfigurationRequest, options)(this.fetch, this.basePath);
    };
    RestaurantVouchersPayGreenApi.prototype.updateStorePayGreenConfiguration = function (appId, storeId, UpdateStorePayGreenConfigurationRequest, options) {
        return (0, exports.RestaurantVouchersPayGreenApiFp)(this.configuration).updateStorePayGreenConfiguration(appId, storeId, UpdateStorePayGreenConfigurationRequest, options)(this.fetch, this.basePath);
    };
    return RestaurantVouchersPayGreenApi;
}(BaseAPI));
exports.RestaurantVouchersPayGreenApi = RestaurantVouchersPayGreenApi;
var SearchApiFetchParamCreator = function (configuration) {
    return {
        searchRestaurants: function (query, countryId, includeArchivedStores, searchType, publishedStatus, page, limit, options) {
            if (options === void 0) { options = {}; }
            if (query === null || query === undefined) {
                throw new RequiredError('query', 'Required parameter query was null or undefined when calling searchRestaurants.');
            }
            if (countryId === null || countryId === undefined) {
                throw new RequiredError('countryId', 'Required parameter countryId was null or undefined when calling searchRestaurants.');
            }
            var localVarPath = "/api/v1.0/search/restaurants";
            var localVarUrlObj = url.parse(localVarPath, true);
            var localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            var localVarHeaderParameter = {};
            var localVarQueryParameter = {};
            if (configuration && configuration.accessToken) {
                var localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("oauth2", ["api"])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }
            if (query !== undefined) {
                localVarQueryParameter['query'] = query;
            }
            if (countryId !== undefined) {
                localVarQueryParameter['countryId'] = countryId;
            }
            if (includeArchivedStores !== undefined) {
                localVarQueryParameter['includeArchivedStores'] = includeArchivedStores;
            }
            if (searchType !== undefined) {
                localVarQueryParameter['searchType'] = searchType;
            }
            if (publishedStatus !== undefined) {
                localVarQueryParameter['publishedStatus'] = publishedStatus;
            }
            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }
            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    };
};
exports.SearchApiFetchParamCreator = SearchApiFetchParamCreator;
var SearchApiFp = function (configuration) {
    return {
        searchRestaurants: function (query, countryId, includeArchivedStores, searchType, publishedStatus, page, limit, options) {
            var localVarFetchArgs = (0, exports.SearchApiFetchParamCreator)(configuration).searchRestaurants(query, countryId, includeArchivedStores, searchType, publishedStatus, page, limit, options);
            return function (fetch, basePath) {
                if (fetch === void 0) { fetch = portableFetch; }
                if (basePath === void 0) { basePath = BASE_PATH; }
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then(function (response) {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
    };
};
exports.SearchApiFp = SearchApiFp;
var SearchApiFactory = function (configuration, fetch, basePath) {
    return {
        searchRestaurants: function (query, countryId, includeArchivedStores, searchType, publishedStatus, page, limit, options) {
            return (0, exports.SearchApiFp)(configuration).searchRestaurants(query, countryId, includeArchivedStores, searchType, publishedStatus, page, limit, options)(fetch, basePath);
        },
    };
};
exports.SearchApiFactory = SearchApiFactory;
var SearchApi = (function (_super) {
    __extends(SearchApi, _super);
    function SearchApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    SearchApi.prototype.searchRestaurants = function (query, countryId, includeArchivedStores, searchType, publishedStatus, page, limit, options) {
        return (0, exports.SearchApiFp)(this.configuration).searchRestaurants(query, countryId, includeArchivedStores, searchType, publishedStatus, page, limit, options)(this.fetch, this.basePath);
    };
    return SearchApi;
}(BaseAPI));
exports.SearchApi = SearchApi;
var SmsProviderCredentialsApiFetchParamCreator = function (configuration) {
    return {
        getBrandSmsProviderCredentialByServiceType: function (orgId, brandId, serviceType, withFallback, options) {
            if (options === void 0) { options = {}; }
            if (orgId === null || orgId === undefined) {
                throw new RequiredError('orgId', 'Required parameter orgId was null or undefined when calling getBrandSmsProviderCredentialByServiceType.');
            }
            if (brandId === null || brandId === undefined) {
                throw new RequiredError('brandId', 'Required parameter brandId was null or undefined when calling getBrandSmsProviderCredentialByServiceType.');
            }
            if (serviceType === null || serviceType === undefined) {
                throw new RequiredError('serviceType', 'Required parameter serviceType was null or undefined when calling getBrandSmsProviderCredentialByServiceType.');
            }
            var localVarPath = "/api/v1.0/sms-providers/orgs/{orgId}/brands/{brandId}/provider-credentials/{serviceType}"
                .replace("{".concat("orgId", "}"), encodeURIComponent(String(orgId)))
                .replace("{".concat("brandId", "}"), encodeURIComponent(String(brandId)))
                .replace("{".concat("serviceType", "}"), encodeURIComponent(String(serviceType)));
            var localVarUrlObj = url.parse(localVarPath, true);
            var localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            var localVarHeaderParameter = {};
            var localVarQueryParameter = {};
            if (configuration && configuration.accessToken) {
                var localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("oauth2", ["api"])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }
            if (withFallback !== undefined) {
                localVarQueryParameter['withFallback'] = withFallback;
            }
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        getBrandSmsProviderCredentials: function (orgId, brandId, options) {
            if (options === void 0) { options = {}; }
            if (orgId === null || orgId === undefined) {
                throw new RequiredError('orgId', 'Required parameter orgId was null or undefined when calling getBrandSmsProviderCredentials.');
            }
            if (brandId === null || brandId === undefined) {
                throw new RequiredError('brandId', 'Required parameter brandId was null or undefined when calling getBrandSmsProviderCredentials.');
            }
            var localVarPath = "/api/v1.0/sms-providers/orgs/{orgId}/brands/{brandId}/provider-credentials"
                .replace("{".concat("orgId", "}"), encodeURIComponent(String(orgId)))
                .replace("{".concat("brandId", "}"), encodeURIComponent(String(brandId)));
            var localVarUrlObj = url.parse(localVarPath, true);
            var localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            var localVarHeaderParameter = {};
            var localVarQueryParameter = {};
            if (configuration && configuration.accessToken) {
                var localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("oauth2", ["api"])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        smsProviderCredentialDelete: function (orgId, brandId, serviceType, options) {
            if (options === void 0) { options = {}; }
            if (orgId === null || orgId === undefined) {
                throw new RequiredError('orgId', 'Required parameter orgId was null or undefined when calling smsProviderCredentialDelete.');
            }
            if (brandId === null || brandId === undefined) {
                throw new RequiredError('brandId', 'Required parameter brandId was null or undefined when calling smsProviderCredentialDelete.');
            }
            if (serviceType === null || serviceType === undefined) {
                throw new RequiredError('serviceType', 'Required parameter serviceType was null or undefined when calling smsProviderCredentialDelete.');
            }
            var localVarPath = "/api/v1.0/sms-providers/orgs/{orgId}/brands/{brandId}/provider-credentials/{serviceType}"
                .replace("{".concat("orgId", "}"), encodeURIComponent(String(orgId)))
                .replace("{".concat("brandId", "}"), encodeURIComponent(String(brandId)))
                .replace("{".concat("serviceType", "}"), encodeURIComponent(String(serviceType)));
            var localVarUrlObj = url.parse(localVarPath, true);
            var localVarRequestOptions = Object.assign({ method: 'DELETE' }, options);
            var localVarHeaderParameter = {};
            var localVarQueryParameter = {};
            if (configuration && configuration.accessToken) {
                var localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("oauth2", ["api"])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        smsProviderCredentialUpdate: function (orgId, brandId, serviceType, SmsProviderCredentialUpdateRequest, options) {
            if (options === void 0) { options = {}; }
            if (orgId === null || orgId === undefined) {
                throw new RequiredError('orgId', 'Required parameter orgId was null or undefined when calling smsProviderCredentialUpdate.');
            }
            if (brandId === null || brandId === undefined) {
                throw new RequiredError('brandId', 'Required parameter brandId was null or undefined when calling smsProviderCredentialUpdate.');
            }
            if (serviceType === null || serviceType === undefined) {
                throw new RequiredError('serviceType', 'Required parameter serviceType was null or undefined when calling smsProviderCredentialUpdate.');
            }
            if (SmsProviderCredentialUpdateRequest === null || SmsProviderCredentialUpdateRequest === undefined) {
                throw new RequiredError('SmsProviderCredentialUpdateRequest', 'Required parameter SmsProviderCredentialUpdateRequest was null or undefined when calling smsProviderCredentialUpdate.');
            }
            var localVarPath = "/api/v1.0/sms-providers/orgs/{orgId}/brands/{brandId}/provider-credentials/{serviceType}"
                .replace("{".concat("orgId", "}"), encodeURIComponent(String(orgId)))
                .replace("{".concat("brandId", "}"), encodeURIComponent(String(brandId)))
                .replace("{".concat("serviceType", "}"), encodeURIComponent(String(serviceType)));
            var localVarUrlObj = url.parse(localVarPath, true);
            var localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            var localVarHeaderParameter = {};
            var localVarQueryParameter = {};
            if (configuration && configuration.accessToken) {
                var localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("oauth2", ["api"])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }
            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            var needsSerialization = ("SmsProviderCredentialUpdateRequest" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body = needsSerialization ? JSON.stringify(SmsProviderCredentialUpdateRequest || {}) : (SmsProviderCredentialUpdateRequest || "");
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        smsProviderCredentialsBulkUpsert: function (SmsProviderCredential, options) {
            if (options === void 0) { options = {}; }
            if (SmsProviderCredential === null || SmsProviderCredential === undefined) {
                throw new RequiredError('SmsProviderCredential', 'Required parameter SmsProviderCredential was null or undefined when calling smsProviderCredentialsBulkUpsert.');
            }
            var localVarPath = "/api/v1.0/sms-providers/bulk-upsert";
            var localVarUrlObj = url.parse(localVarPath, true);
            var localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            var localVarHeaderParameter = {};
            var localVarQueryParameter = {};
            if (configuration && configuration.accessToken) {
                var localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("oauth2", ["api"])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }
            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            var needsSerialization = ("Array&lt;SmsProviderCredential&gt;" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body = needsSerialization ? JSON.stringify(SmsProviderCredential || {}) : (SmsProviderCredential || "");
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    };
};
exports.SmsProviderCredentialsApiFetchParamCreator = SmsProviderCredentialsApiFetchParamCreator;
var SmsProviderCredentialsApiFp = function (configuration) {
    return {
        getBrandSmsProviderCredentialByServiceType: function (orgId, brandId, serviceType, withFallback, options) {
            var localVarFetchArgs = (0, exports.SmsProviderCredentialsApiFetchParamCreator)(configuration).getBrandSmsProviderCredentialByServiceType(orgId, brandId, serviceType, withFallback, options);
            return function (fetch, basePath) {
                if (fetch === void 0) { fetch = portableFetch; }
                if (basePath === void 0) { basePath = BASE_PATH; }
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then(function (response) {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
        getBrandSmsProviderCredentials: function (orgId, brandId, options) {
            var localVarFetchArgs = (0, exports.SmsProviderCredentialsApiFetchParamCreator)(configuration).getBrandSmsProviderCredentials(orgId, brandId, options);
            return function (fetch, basePath) {
                if (fetch === void 0) { fetch = portableFetch; }
                if (basePath === void 0) { basePath = BASE_PATH; }
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then(function (response) {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
        smsProviderCredentialDelete: function (orgId, brandId, serviceType, options) {
            var localVarFetchArgs = (0, exports.SmsProviderCredentialsApiFetchParamCreator)(configuration).smsProviderCredentialDelete(orgId, brandId, serviceType, options);
            return function (fetch, basePath) {
                if (fetch === void 0) { fetch = portableFetch; }
                if (basePath === void 0) { basePath = BASE_PATH; }
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then(function (response) {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
        smsProviderCredentialUpdate: function (orgId, brandId, serviceType, SmsProviderCredentialUpdateRequest, options) {
            var localVarFetchArgs = (0, exports.SmsProviderCredentialsApiFetchParamCreator)(configuration).smsProviderCredentialUpdate(orgId, brandId, serviceType, SmsProviderCredentialUpdateRequest, options);
            return function (fetch, basePath) {
                if (fetch === void 0) { fetch = portableFetch; }
                if (basePath === void 0) { basePath = BASE_PATH; }
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then(function (response) {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
        smsProviderCredentialsBulkUpsert: function (SmsProviderCredential, options) {
            var localVarFetchArgs = (0, exports.SmsProviderCredentialsApiFetchParamCreator)(configuration).smsProviderCredentialsBulkUpsert(SmsProviderCredential, options);
            return function (fetch, basePath) {
                if (fetch === void 0) { fetch = portableFetch; }
                if (basePath === void 0) { basePath = BASE_PATH; }
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then(function (response) {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
    };
};
exports.SmsProviderCredentialsApiFp = SmsProviderCredentialsApiFp;
var SmsProviderCredentialsApiFactory = function (configuration, fetch, basePath) {
    return {
        getBrandSmsProviderCredentialByServiceType: function (orgId, brandId, serviceType, withFallback, options) {
            return (0, exports.SmsProviderCredentialsApiFp)(configuration).getBrandSmsProviderCredentialByServiceType(orgId, brandId, serviceType, withFallback, options)(fetch, basePath);
        },
        getBrandSmsProviderCredentials: function (orgId, brandId, options) {
            return (0, exports.SmsProviderCredentialsApiFp)(configuration).getBrandSmsProviderCredentials(orgId, brandId, options)(fetch, basePath);
        },
        smsProviderCredentialDelete: function (orgId, brandId, serviceType, options) {
            return (0, exports.SmsProviderCredentialsApiFp)(configuration).smsProviderCredentialDelete(orgId, brandId, serviceType, options)(fetch, basePath);
        },
        smsProviderCredentialUpdate: function (orgId, brandId, serviceType, SmsProviderCredentialUpdateRequest, options) {
            return (0, exports.SmsProviderCredentialsApiFp)(configuration).smsProviderCredentialUpdate(orgId, brandId, serviceType, SmsProviderCredentialUpdateRequest, options)(fetch, basePath);
        },
        smsProviderCredentialsBulkUpsert: function (SmsProviderCredential, options) {
            return (0, exports.SmsProviderCredentialsApiFp)(configuration).smsProviderCredentialsBulkUpsert(SmsProviderCredential, options)(fetch, basePath);
        },
    };
};
exports.SmsProviderCredentialsApiFactory = SmsProviderCredentialsApiFactory;
var SmsProviderCredentialsApi = (function (_super) {
    __extends(SmsProviderCredentialsApi, _super);
    function SmsProviderCredentialsApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    SmsProviderCredentialsApi.prototype.getBrandSmsProviderCredentialByServiceType = function (orgId, brandId, serviceType, withFallback, options) {
        return (0, exports.SmsProviderCredentialsApiFp)(this.configuration).getBrandSmsProviderCredentialByServiceType(orgId, brandId, serviceType, withFallback, options)(this.fetch, this.basePath);
    };
    SmsProviderCredentialsApi.prototype.getBrandSmsProviderCredentials = function (orgId, brandId, options) {
        return (0, exports.SmsProviderCredentialsApiFp)(this.configuration).getBrandSmsProviderCredentials(orgId, brandId, options)(this.fetch, this.basePath);
    };
    SmsProviderCredentialsApi.prototype.smsProviderCredentialDelete = function (orgId, brandId, serviceType, options) {
        return (0, exports.SmsProviderCredentialsApiFp)(this.configuration).smsProviderCredentialDelete(orgId, brandId, serviceType, options)(this.fetch, this.basePath);
    };
    SmsProviderCredentialsApi.prototype.smsProviderCredentialUpdate = function (orgId, brandId, serviceType, SmsProviderCredentialUpdateRequest, options) {
        return (0, exports.SmsProviderCredentialsApiFp)(this.configuration).smsProviderCredentialUpdate(orgId, brandId, serviceType, SmsProviderCredentialUpdateRequest, options)(this.fetch, this.basePath);
    };
    SmsProviderCredentialsApi.prototype.smsProviderCredentialsBulkUpsert = function (SmsProviderCredential, options) {
        return (0, exports.SmsProviderCredentialsApiFp)(this.configuration).smsProviderCredentialsBulkUpsert(SmsProviderCredential, options)(this.fetch, this.basePath);
    };
    return SmsProviderCredentialsApi;
}(BaseAPI));
exports.SmsProviderCredentialsApi = SmsProviderCredentialsApi;
var StoreGroupsApiFetchParamCreator = function (configuration) {
    return {
        assignStoresToStoreGroup: function (appId, storeGroupId, ERROR_UNKNOWN, options) {
            if (options === void 0) { options = {}; }
            if (appId === null || appId === undefined) {
                throw new RequiredError('appId', 'Required parameter appId was null or undefined when calling assignStoresToStoreGroup.');
            }
            if (storeGroupId === null || storeGroupId === undefined) {
                throw new RequiredError('storeGroupId', 'Required parameter storeGroupId was null or undefined when calling assignStoresToStoreGroup.');
            }
            if (ERROR_UNKNOWN === null || ERROR_UNKNOWN === undefined) {
                throw new RequiredError('ERROR_UNKNOWN', 'Required parameter ERROR_UNKNOWN was null or undefined when calling assignStoresToStoreGroup.');
            }
            var localVarPath = "/api/v1.0/{appId}/storegroups/{storeGroupId}/assignStores"
                .replace("{".concat("appId", "}"), encodeURIComponent(String(appId)))
                .replace("{".concat("storeGroupId", "}"), encodeURIComponent(String(storeGroupId)));
            var localVarUrlObj = url.parse(localVarPath, true);
            var localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            var localVarHeaderParameter = {};
            var localVarQueryParameter = {};
            if (configuration && configuration.accessToken) {
                var localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("oauth2", ["api"])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }
            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            var needsSerialization = ("Array&lt;number&gt;" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body = needsSerialization ? JSON.stringify(ERROR_UNKNOWN || {}) : (ERROR_UNKNOWN || "");
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        createStoreGroup: function (appNameId, StoreGroupBase, options) {
            if (options === void 0) { options = {}; }
            if (appNameId === null || appNameId === undefined) {
                throw new RequiredError('appNameId', 'Required parameter appNameId was null or undefined when calling createStoreGroup.');
            }
            if (StoreGroupBase === null || StoreGroupBase === undefined) {
                throw new RequiredError('StoreGroupBase', 'Required parameter StoreGroupBase was null or undefined when calling createStoreGroup.');
            }
            var localVarPath = "/api/v1.0/{appNameId}/storegroups"
                .replace("{".concat("appNameId", "}"), encodeURIComponent(String(appNameId)));
            var localVarUrlObj = url.parse(localVarPath, true);
            var localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            var localVarHeaderParameter = {};
            var localVarQueryParameter = {};
            if (configuration && configuration.accessToken) {
                var localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("oauth2", ["api"])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }
            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            var needsSerialization = ("StoreGroupBase" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body = needsSerialization ? JSON.stringify(StoreGroupBase || {}) : (StoreGroupBase || "");
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        getStoreGroup: function (storeGroupId, options) {
            if (options === void 0) { options = {}; }
            if (storeGroupId === null || storeGroupId === undefined) {
                throw new RequiredError('storeGroupId', 'Required parameter storeGroupId was null or undefined when calling getStoreGroup.');
            }
            var localVarPath = "/api/v1.0/storegroups/{storeGroupId}"
                .replace("{".concat("storeGroupId", "}"), encodeURIComponent(String(storeGroupId)));
            var localVarUrlObj = url.parse(localVarPath, true);
            var localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            var localVarHeaderParameter = {};
            var localVarQueryParameter = {};
            if (configuration && configuration.accessToken) {
                var localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("oauth2", ["api"])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        getStoreGroups: function (appNameId, searchQuery, page, limit, options) {
            if (options === void 0) { options = {}; }
            if (appNameId === null || appNameId === undefined) {
                throw new RequiredError('appNameId', 'Required parameter appNameId was null or undefined when calling getStoreGroups.');
            }
            var localVarPath = "/api/v1.0/{appNameId}/storegroups"
                .replace("{".concat("appNameId", "}"), encodeURIComponent(String(appNameId)));
            var localVarUrlObj = url.parse(localVarPath, true);
            var localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            var localVarHeaderParameter = {};
            var localVarQueryParameter = {};
            if (configuration && configuration.accessToken) {
                var localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("oauth2", ["api"])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }
            if (searchQuery !== undefined) {
                localVarQueryParameter['searchQuery'] = searchQuery;
            }
            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }
            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        getStoreGroupsExtended: function (appNameId, searchQuery, page, limit, groupingRadius, options) {
            if (options === void 0) { options = {}; }
            if (appNameId === null || appNameId === undefined) {
                throw new RequiredError('appNameId', 'Required parameter appNameId was null or undefined when calling getStoreGroupsExtended.');
            }
            var localVarPath = "/api/v1.0/{appNameId}/storegroups/extended"
                .replace("{".concat("appNameId", "}"), encodeURIComponent(String(appNameId)));
            var localVarUrlObj = url.parse(localVarPath, true);
            var localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            var localVarHeaderParameter = {};
            var localVarQueryParameter = {};
            if (configuration && configuration.accessToken) {
                var localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("oauth2", ["api"])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }
            if (searchQuery !== undefined) {
                localVarQueryParameter['searchQuery'] = searchQuery;
            }
            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }
            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }
            if (groupingRadius !== undefined) {
                localVarQueryParameter['groupingRadius'] = groupingRadius;
            }
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        removeStoreGroup: function (storeGroupId, options) {
            if (options === void 0) { options = {}; }
            if (storeGroupId === null || storeGroupId === undefined) {
                throw new RequiredError('storeGroupId', 'Required parameter storeGroupId was null or undefined when calling removeStoreGroup.');
            }
            var localVarPath = "/api/v1.0/storegroups/{storeGroupId}"
                .replace("{".concat("storeGroupId", "}"), encodeURIComponent(String(storeGroupId)));
            var localVarUrlObj = url.parse(localVarPath, true);
            var localVarRequestOptions = Object.assign({ method: 'DELETE' }, options);
            var localVarHeaderParameter = {};
            var localVarQueryParameter = {};
            if (configuration && configuration.accessToken) {
                var localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("oauth2", ["api"])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        setCustomerMessages: function (storeGroupId, CustomerMessages, options) {
            if (options === void 0) { options = {}; }
            if (storeGroupId === null || storeGroupId === undefined) {
                throw new RequiredError('storeGroupId', 'Required parameter storeGroupId was null or undefined when calling setCustomerMessages.');
            }
            if (CustomerMessages === null || CustomerMessages === undefined) {
                throw new RequiredError('CustomerMessages', 'Required parameter CustomerMessages was null or undefined when calling setCustomerMessages.');
            }
            var localVarPath = "/api/v1.0/storegroups/{storeGroupId}/CustomerMessages"
                .replace("{".concat("storeGroupId", "}"), encodeURIComponent(String(storeGroupId)));
            var localVarUrlObj = url.parse(localVarPath, true);
            var localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            var localVarHeaderParameter = {};
            var localVarQueryParameter = {};
            if (configuration && configuration.accessToken) {
                var localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("oauth2", ["api"])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }
            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            var needsSerialization = ("CustomerMessages" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body = needsSerialization ? JSON.stringify(CustomerMessages || {}) : (CustomerMessages || "");
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        updateStoreGroup: function (storeGroupId, StoreGroupBase, options) {
            if (options === void 0) { options = {}; }
            if (storeGroupId === null || storeGroupId === undefined) {
                throw new RequiredError('storeGroupId', 'Required parameter storeGroupId was null or undefined when calling updateStoreGroup.');
            }
            if (StoreGroupBase === null || StoreGroupBase === undefined) {
                throw new RequiredError('StoreGroupBase', 'Required parameter StoreGroupBase was null or undefined when calling updateStoreGroup.');
            }
            var localVarPath = "/api/v1.0/storegroups/{storeGroupId}"
                .replace("{".concat("storeGroupId", "}"), encodeURIComponent(String(storeGroupId)));
            var localVarUrlObj = url.parse(localVarPath, true);
            var localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            var localVarHeaderParameter = {};
            var localVarQueryParameter = {};
            if (configuration && configuration.accessToken) {
                var localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("oauth2", ["api"])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }
            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            var needsSerialization = ("StoreGroupBase" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body = needsSerialization ? JSON.stringify(StoreGroupBase || {}) : (StoreGroupBase || "");
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    };
};
exports.StoreGroupsApiFetchParamCreator = StoreGroupsApiFetchParamCreator;
var StoreGroupsApiFp = function (configuration) {
    return {
        assignStoresToStoreGroup: function (appId, storeGroupId, ERROR_UNKNOWN, options) {
            var localVarFetchArgs = (0, exports.StoreGroupsApiFetchParamCreator)(configuration).assignStoresToStoreGroup(appId, storeGroupId, ERROR_UNKNOWN, options);
            return function (fetch, basePath) {
                if (fetch === void 0) { fetch = portableFetch; }
                if (basePath === void 0) { basePath = BASE_PATH; }
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then(function (response) {
                    if (response.status >= 200 && response.status < 300) {
                        return response;
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
        createStoreGroup: function (appNameId, StoreGroupBase, options) {
            var localVarFetchArgs = (0, exports.StoreGroupsApiFetchParamCreator)(configuration).createStoreGroup(appNameId, StoreGroupBase, options);
            return function (fetch, basePath) {
                if (fetch === void 0) { fetch = portableFetch; }
                if (basePath === void 0) { basePath = BASE_PATH; }
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then(function (response) {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
        getStoreGroup: function (storeGroupId, options) {
            var localVarFetchArgs = (0, exports.StoreGroupsApiFetchParamCreator)(configuration).getStoreGroup(storeGroupId, options);
            return function (fetch, basePath) {
                if (fetch === void 0) { fetch = portableFetch; }
                if (basePath === void 0) { basePath = BASE_PATH; }
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then(function (response) {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
        getStoreGroups: function (appNameId, searchQuery, page, limit, options) {
            var localVarFetchArgs = (0, exports.StoreGroupsApiFetchParamCreator)(configuration).getStoreGroups(appNameId, searchQuery, page, limit, options);
            return function (fetch, basePath) {
                if (fetch === void 0) { fetch = portableFetch; }
                if (basePath === void 0) { basePath = BASE_PATH; }
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then(function (response) {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
        getStoreGroupsExtended: function (appNameId, searchQuery, page, limit, groupingRadius, options) {
            var localVarFetchArgs = (0, exports.StoreGroupsApiFetchParamCreator)(configuration).getStoreGroupsExtended(appNameId, searchQuery, page, limit, groupingRadius, options);
            return function (fetch, basePath) {
                if (fetch === void 0) { fetch = portableFetch; }
                if (basePath === void 0) { basePath = BASE_PATH; }
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then(function (response) {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
        removeStoreGroup: function (storeGroupId, options) {
            var localVarFetchArgs = (0, exports.StoreGroupsApiFetchParamCreator)(configuration).removeStoreGroup(storeGroupId, options);
            return function (fetch, basePath) {
                if (fetch === void 0) { fetch = portableFetch; }
                if (basePath === void 0) { basePath = BASE_PATH; }
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then(function (response) {
                    if (response.status >= 200 && response.status < 300) {
                        return response;
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
        setCustomerMessages: function (storeGroupId, CustomerMessages, options) {
            var localVarFetchArgs = (0, exports.StoreGroupsApiFetchParamCreator)(configuration).setCustomerMessages(storeGroupId, CustomerMessages, options);
            return function (fetch, basePath) {
                if (fetch === void 0) { fetch = portableFetch; }
                if (basePath === void 0) { basePath = BASE_PATH; }
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then(function (response) {
                    if (response.status >= 200 && response.status < 300) {
                        return response;
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
        updateStoreGroup: function (storeGroupId, StoreGroupBase, options) {
            var localVarFetchArgs = (0, exports.StoreGroupsApiFetchParamCreator)(configuration).updateStoreGroup(storeGroupId, StoreGroupBase, options);
            return function (fetch, basePath) {
                if (fetch === void 0) { fetch = portableFetch; }
                if (basePath === void 0) { basePath = BASE_PATH; }
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then(function (response) {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
    };
};
exports.StoreGroupsApiFp = StoreGroupsApiFp;
var StoreGroupsApiFactory = function (configuration, fetch, basePath) {
    return {
        assignStoresToStoreGroup: function (appId, storeGroupId, ERROR_UNKNOWN, options) {
            return (0, exports.StoreGroupsApiFp)(configuration).assignStoresToStoreGroup(appId, storeGroupId, ERROR_UNKNOWN, options)(fetch, basePath);
        },
        createStoreGroup: function (appNameId, StoreGroupBase, options) {
            return (0, exports.StoreGroupsApiFp)(configuration).createStoreGroup(appNameId, StoreGroupBase, options)(fetch, basePath);
        },
        getStoreGroup: function (storeGroupId, options) {
            return (0, exports.StoreGroupsApiFp)(configuration).getStoreGroup(storeGroupId, options)(fetch, basePath);
        },
        getStoreGroups: function (appNameId, searchQuery, page, limit, options) {
            return (0, exports.StoreGroupsApiFp)(configuration).getStoreGroups(appNameId, searchQuery, page, limit, options)(fetch, basePath);
        },
        getStoreGroupsExtended: function (appNameId, searchQuery, page, limit, groupingRadius, options) {
            return (0, exports.StoreGroupsApiFp)(configuration).getStoreGroupsExtended(appNameId, searchQuery, page, limit, groupingRadius, options)(fetch, basePath);
        },
        removeStoreGroup: function (storeGroupId, options) {
            return (0, exports.StoreGroupsApiFp)(configuration).removeStoreGroup(storeGroupId, options)(fetch, basePath);
        },
        setCustomerMessages: function (storeGroupId, CustomerMessages, options) {
            return (0, exports.StoreGroupsApiFp)(configuration).setCustomerMessages(storeGroupId, CustomerMessages, options)(fetch, basePath);
        },
        updateStoreGroup: function (storeGroupId, StoreGroupBase, options) {
            return (0, exports.StoreGroupsApiFp)(configuration).updateStoreGroup(storeGroupId, StoreGroupBase, options)(fetch, basePath);
        },
    };
};
exports.StoreGroupsApiFactory = StoreGroupsApiFactory;
var StoreGroupsApi = (function (_super) {
    __extends(StoreGroupsApi, _super);
    function StoreGroupsApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    StoreGroupsApi.prototype.assignStoresToStoreGroup = function (appId, storeGroupId, ERROR_UNKNOWN, options) {
        return (0, exports.StoreGroupsApiFp)(this.configuration).assignStoresToStoreGroup(appId, storeGroupId, ERROR_UNKNOWN, options)(this.fetch, this.basePath);
    };
    StoreGroupsApi.prototype.createStoreGroup = function (appNameId, StoreGroupBase, options) {
        return (0, exports.StoreGroupsApiFp)(this.configuration).createStoreGroup(appNameId, StoreGroupBase, options)(this.fetch, this.basePath);
    };
    StoreGroupsApi.prototype.getStoreGroup = function (storeGroupId, options) {
        return (0, exports.StoreGroupsApiFp)(this.configuration).getStoreGroup(storeGroupId, options)(this.fetch, this.basePath);
    };
    StoreGroupsApi.prototype.getStoreGroups = function (appNameId, searchQuery, page, limit, options) {
        return (0, exports.StoreGroupsApiFp)(this.configuration).getStoreGroups(appNameId, searchQuery, page, limit, options)(this.fetch, this.basePath);
    };
    StoreGroupsApi.prototype.getStoreGroupsExtended = function (appNameId, searchQuery, page, limit, groupingRadius, options) {
        return (0, exports.StoreGroupsApiFp)(this.configuration).getStoreGroupsExtended(appNameId, searchQuery, page, limit, groupingRadius, options)(this.fetch, this.basePath);
    };
    StoreGroupsApi.prototype.removeStoreGroup = function (storeGroupId, options) {
        return (0, exports.StoreGroupsApiFp)(this.configuration).removeStoreGroup(storeGroupId, options)(this.fetch, this.basePath);
    };
    StoreGroupsApi.prototype.setCustomerMessages = function (storeGroupId, CustomerMessages, options) {
        return (0, exports.StoreGroupsApiFp)(this.configuration).setCustomerMessages(storeGroupId, CustomerMessages, options)(this.fetch, this.basePath);
    };
    StoreGroupsApi.prototype.updateStoreGroup = function (storeGroupId, StoreGroupBase, options) {
        return (0, exports.StoreGroupsApiFp)(this.configuration).updateStoreGroup(storeGroupId, StoreGroupBase, options)(this.fetch, this.basePath);
    };
    return StoreGroupsApi;
}(BaseAPI));
exports.StoreGroupsApi = StoreGroupsApi;
var StoreOrderCapacityApiFetchParamCreator = function (configuration) {
    return {
        getStoreOrderCapacity: function (appId, storeId, deliveryType, options) {
            if (options === void 0) { options = {}; }
            if (appId === null || appId === undefined) {
                throw new RequiredError('appId', 'Required parameter appId was null or undefined when calling getStoreOrderCapacity.');
            }
            if (storeId === null || storeId === undefined) {
                throw new RequiredError('storeId', 'Required parameter storeId was null or undefined when calling getStoreOrderCapacity.');
            }
            if (deliveryType === null || deliveryType === undefined) {
                throw new RequiredError('deliveryType', 'Required parameter deliveryType was null or undefined when calling getStoreOrderCapacity.');
            }
            var localVarPath = "/api/v1.0/{appId}/storeordercapacity/{storeId}/{deliveryType}"
                .replace("{".concat("appId", "}"), encodeURIComponent(String(appId)))
                .replace("{".concat("storeId", "}"), encodeURIComponent(String(storeId)))
                .replace("{".concat("deliveryType", "}"), encodeURIComponent(String(deliveryType)));
            var localVarUrlObj = url.parse(localVarPath, true);
            var localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            var localVarHeaderParameter = {};
            var localVarQueryParameter = {};
            if (configuration && configuration.accessToken) {
                var localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("oauth2", ["api"])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        updateStoreOrderCapacityConfig: function (storeId, deliveryType, appId, StoreOrderCapacityConfigEditModel, options) {
            if (options === void 0) { options = {}; }
            if (storeId === null || storeId === undefined) {
                throw new RequiredError('storeId', 'Required parameter storeId was null or undefined when calling updateStoreOrderCapacityConfig.');
            }
            if (deliveryType === null || deliveryType === undefined) {
                throw new RequiredError('deliveryType', 'Required parameter deliveryType was null or undefined when calling updateStoreOrderCapacityConfig.');
            }
            if (appId === null || appId === undefined) {
                throw new RequiredError('appId', 'Required parameter appId was null or undefined when calling updateStoreOrderCapacityConfig.');
            }
            if (StoreOrderCapacityConfigEditModel === null || StoreOrderCapacityConfigEditModel === undefined) {
                throw new RequiredError('StoreOrderCapacityConfigEditModel', 'Required parameter StoreOrderCapacityConfigEditModel was null or undefined when calling updateStoreOrderCapacityConfig.');
            }
            var localVarPath = "/api/v1.0/{appId}/storeordercapacity/{storeId}"
                .replace("{".concat("storeId", "}"), encodeURIComponent(String(storeId)))
                .replace("{".concat("appId", "}"), encodeURIComponent(String(appId)));
            var localVarUrlObj = url.parse(localVarPath, true);
            var localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            var localVarHeaderParameter = {};
            var localVarQueryParameter = {};
            if (configuration && configuration.accessToken) {
                var localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("oauth2", ["api"])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }
            if (deliveryType !== undefined) {
                localVarQueryParameter['deliveryType'] = deliveryType;
            }
            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            var needsSerialization = ("StoreOrderCapacityConfigEditModel" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body = needsSerialization ? JSON.stringify(StoreOrderCapacityConfigEditModel || {}) : (StoreOrderCapacityConfigEditModel || "");
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    };
};
exports.StoreOrderCapacityApiFetchParamCreator = StoreOrderCapacityApiFetchParamCreator;
var StoreOrderCapacityApiFp = function (configuration) {
    return {
        getStoreOrderCapacity: function (appId, storeId, deliveryType, options) {
            var localVarFetchArgs = (0, exports.StoreOrderCapacityApiFetchParamCreator)(configuration).getStoreOrderCapacity(appId, storeId, deliveryType, options);
            return function (fetch, basePath) {
                if (fetch === void 0) { fetch = portableFetch; }
                if (basePath === void 0) { basePath = BASE_PATH; }
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then(function (response) {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
        updateStoreOrderCapacityConfig: function (storeId, deliveryType, appId, StoreOrderCapacityConfigEditModel, options) {
            var localVarFetchArgs = (0, exports.StoreOrderCapacityApiFetchParamCreator)(configuration).updateStoreOrderCapacityConfig(storeId, deliveryType, appId, StoreOrderCapacityConfigEditModel, options);
            return function (fetch, basePath) {
                if (fetch === void 0) { fetch = portableFetch; }
                if (basePath === void 0) { basePath = BASE_PATH; }
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then(function (response) {
                    if (response.status >= 200 && response.status < 300) {
                        return response;
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
    };
};
exports.StoreOrderCapacityApiFp = StoreOrderCapacityApiFp;
var StoreOrderCapacityApiFactory = function (configuration, fetch, basePath) {
    return {
        getStoreOrderCapacity: function (appId, storeId, deliveryType, options) {
            return (0, exports.StoreOrderCapacityApiFp)(configuration).getStoreOrderCapacity(appId, storeId, deliveryType, options)(fetch, basePath);
        },
        updateStoreOrderCapacityConfig: function (storeId, deliveryType, appId, StoreOrderCapacityConfigEditModel, options) {
            return (0, exports.StoreOrderCapacityApiFp)(configuration).updateStoreOrderCapacityConfig(storeId, deliveryType, appId, StoreOrderCapacityConfigEditModel, options)(fetch, basePath);
        },
    };
};
exports.StoreOrderCapacityApiFactory = StoreOrderCapacityApiFactory;
var StoreOrderCapacityApi = (function (_super) {
    __extends(StoreOrderCapacityApi, _super);
    function StoreOrderCapacityApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    StoreOrderCapacityApi.prototype.getStoreOrderCapacity = function (appId, storeId, deliveryType, options) {
        return (0, exports.StoreOrderCapacityApiFp)(this.configuration).getStoreOrderCapacity(appId, storeId, deliveryType, options)(this.fetch, this.basePath);
    };
    StoreOrderCapacityApi.prototype.updateStoreOrderCapacityConfig = function (storeId, deliveryType, appId, StoreOrderCapacityConfigEditModel, options) {
        return (0, exports.StoreOrderCapacityApiFp)(this.configuration).updateStoreOrderCapacityConfig(storeId, deliveryType, appId, StoreOrderCapacityConfigEditModel, options)(this.fetch, this.basePath);
    };
    return StoreOrderCapacityApi;
}(BaseAPI));
exports.StoreOrderCapacityApi = StoreOrderCapacityApi;
var StoresApiFetchParamCreator = function (configuration) {
    return {
        archiveStore: function (storeId, options) {
            if (options === void 0) { options = {}; }
            if (storeId === null || storeId === undefined) {
                throw new RequiredError('storeId', 'Required parameter storeId was null or undefined when calling archiveStore.');
            }
            var localVarPath = "/api/v1.0/stores/{storeId}/archive"
                .replace("{".concat("storeId", "}"), encodeURIComponent(String(storeId)));
            var localVarUrlObj = url.parse(localVarPath, true);
            var localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            var localVarHeaderParameter = {};
            var localVarQueryParameter = {};
            if (configuration && configuration.accessToken) {
                var localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("oauth2", ["api"])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        assignMenu: function (storeId, menuId, options) {
            if (options === void 0) { options = {}; }
            if (storeId === null || storeId === undefined) {
                throw new RequiredError('storeId', 'Required parameter storeId was null or undefined when calling assignMenu.');
            }
            if (menuId === null || menuId === undefined) {
                throw new RequiredError('menuId', 'Required parameter menuId was null or undefined when calling assignMenu.');
            }
            var localVarPath = "/api/v1.0/stores/{storeId}/menu/{menuId}"
                .replace("{".concat("storeId", "}"), encodeURIComponent(String(storeId)))
                .replace("{".concat("menuId", "}"), encodeURIComponent(String(menuId)));
            var localVarUrlObj = url.parse(localVarPath, true);
            var localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            var localVarHeaderParameter = {};
            var localVarQueryParameter = {};
            if (configuration && configuration.accessToken) {
                var localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("oauth2", ["api"])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        cloneStore: function (storeId, StoreCloneSettings, options) {
            if (options === void 0) { options = {}; }
            if (storeId === null || storeId === undefined) {
                throw new RequiredError('storeId', 'Required parameter storeId was null or undefined when calling cloneStore.');
            }
            if (StoreCloneSettings === null || StoreCloneSettings === undefined) {
                throw new RequiredError('StoreCloneSettings', 'Required parameter StoreCloneSettings was null or undefined when calling cloneStore.');
            }
            var localVarPath = "/api/v1.0/stores/{storeId}/clone"
                .replace("{".concat("storeId", "}"), encodeURIComponent(String(storeId)));
            var localVarUrlObj = url.parse(localVarPath, true);
            var localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            var localVarHeaderParameter = {};
            var localVarQueryParameter = {};
            if (configuration && configuration.accessToken) {
                var localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("oauth2", ["api"])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }
            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            var needsSerialization = ("StoreCloneSettings" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body = needsSerialization ? JSON.stringify(StoreCloneSettings || {}) : (StoreCloneSettings || "");
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        configureStoreServiceCharge: function (storeId, ServiceCharge, options) {
            if (options === void 0) { options = {}; }
            if (storeId === null || storeId === undefined) {
                throw new RequiredError('storeId', 'Required parameter storeId was null or undefined when calling configureStoreServiceCharge.');
            }
            if (ServiceCharge === null || ServiceCharge === undefined) {
                throw new RequiredError('ServiceCharge', 'Required parameter ServiceCharge was null or undefined when calling configureStoreServiceCharge.');
            }
            var localVarPath = "/api/v1.0/stores/{storeId}/servicecharge"
                .replace("{".concat("storeId", "}"), encodeURIComponent(String(storeId)));
            var localVarUrlObj = url.parse(localVarPath, true);
            var localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            var localVarHeaderParameter = {};
            var localVarQueryParameter = {};
            if (configuration && configuration.accessToken) {
                var localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("oauth2", ["api"])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }
            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            var needsSerialization = ("ServiceCharge" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body = needsSerialization ? JSON.stringify(ServiceCharge || {}) : (ServiceCharge || "");
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        createBusinessHoursOverrideByStoreId: function (storeId, BusinessHoursOverrideBase, options) {
            if (options === void 0) { options = {}; }
            if (storeId === null || storeId === undefined) {
                throw new RequiredError('storeId', 'Required parameter storeId was null or undefined when calling createBusinessHoursOverrideByStoreId.');
            }
            if (BusinessHoursOverrideBase === null || BusinessHoursOverrideBase === undefined) {
                throw new RequiredError('BusinessHoursOverrideBase', 'Required parameter BusinessHoursOverrideBase was null or undefined when calling createBusinessHoursOverrideByStoreId.');
            }
            var localVarPath = "/api/v1.0/stores/{storeId}/businesshoursoverrides"
                .replace("{".concat("storeId", "}"), encodeURIComponent(String(storeId)));
            var localVarUrlObj = url.parse(localVarPath, true);
            var localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            var localVarHeaderParameter = {};
            var localVarQueryParameter = {};
            if (configuration && configuration.accessToken) {
                var localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("oauth2", ["api"])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }
            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            var needsSerialization = ("BusinessHoursOverrideBase" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body = needsSerialization ? JSON.stringify(BusinessHoursOverrideBase || {}) : (BusinessHoursOverrideBase || "");
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        createStore: function (storeGroupId, StoreCreateBase, options) {
            if (options === void 0) { options = {}; }
            if (storeGroupId === null || storeGroupId === undefined) {
                throw new RequiredError('storeGroupId', 'Required parameter storeGroupId was null or undefined when calling createStore.');
            }
            if (StoreCreateBase === null || StoreCreateBase === undefined) {
                throw new RequiredError('StoreCreateBase', 'Required parameter StoreCreateBase was null or undefined when calling createStore.');
            }
            var localVarPath = "/api/v1.0/stores";
            var localVarUrlObj = url.parse(localVarPath, true);
            var localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            var localVarHeaderParameter = {};
            var localVarQueryParameter = {};
            if (configuration && configuration.accessToken) {
                var localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("oauth2", ["api"])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }
            if (storeGroupId !== undefined) {
                localVarQueryParameter['storeGroupId'] = storeGroupId;
            }
            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            var needsSerialization = ("StoreCreateBase" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body = needsSerialization ? JSON.stringify(StoreCreateBase || {}) : (StoreCreateBase || "");
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        createStoreInProperty: function (storeGroupId, propertyId, StoreCreateBase, autoAssignMenu, options) {
            if (options === void 0) { options = {}; }
            if (storeGroupId === null || storeGroupId === undefined) {
                throw new RequiredError('storeGroupId', 'Required parameter storeGroupId was null or undefined when calling createStoreInProperty.');
            }
            if (propertyId === null || propertyId === undefined) {
                throw new RequiredError('propertyId', 'Required parameter propertyId was null or undefined when calling createStoreInProperty.');
            }
            if (StoreCreateBase === null || StoreCreateBase === undefined) {
                throw new RequiredError('StoreCreateBase', 'Required parameter StoreCreateBase was null or undefined when calling createStoreInProperty.');
            }
            var localVarPath = "/api/v1.0/properties/{propertyId}/stores"
                .replace("{".concat("propertyId", "}"), encodeURIComponent(String(propertyId)));
            var localVarUrlObj = url.parse(localVarPath, true);
            var localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            var localVarHeaderParameter = {};
            var localVarQueryParameter = {};
            if (configuration && configuration.accessToken) {
                var localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("oauth2", ["api"])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }
            if (storeGroupId !== undefined) {
                localVarQueryParameter['storeGroupId'] = storeGroupId;
            }
            if (autoAssignMenu !== undefined) {
                localVarQueryParameter['autoAssignMenu'] = autoAssignMenu;
            }
            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            var needsSerialization = ("StoreCreateBase" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body = needsSerialization ? JSON.stringify(StoreCreateBase || {}) : (StoreCreateBase || "");
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        deleteBusinessHoursOverride: function (storeId, businessHoursOverrideId, options) {
            if (options === void 0) { options = {}; }
            if (storeId === null || storeId === undefined) {
                throw new RequiredError('storeId', 'Required parameter storeId was null or undefined when calling deleteBusinessHoursOverride.');
            }
            if (businessHoursOverrideId === null || businessHoursOverrideId === undefined) {
                throw new RequiredError('businessHoursOverrideId', 'Required parameter businessHoursOverrideId was null or undefined when calling deleteBusinessHoursOverride.');
            }
            var localVarPath = "/api/v1.0/stores/{storeId}/businesshoursoverrides/{businessHoursOverrideId}"
                .replace("{".concat("storeId", "}"), encodeURIComponent(String(storeId)))
                .replace("{".concat("businessHoursOverrideId", "}"), encodeURIComponent(String(businessHoursOverrideId)));
            var localVarUrlObj = url.parse(localVarPath, true);
            var localVarRequestOptions = Object.assign({ method: 'DELETE' }, options);
            var localVarHeaderParameter = {};
            var localVarQueryParameter = {};
            if (configuration && configuration.accessToken) {
                var localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("oauth2", ["api"])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        getBankAccountForStore: function (storeId, options) {
            if (options === void 0) { options = {}; }
            if (storeId === null || storeId === undefined) {
                throw new RequiredError('storeId', 'Required parameter storeId was null or undefined when calling getBankAccountForStore.');
            }
            var localVarPath = "/api/v1.0/stores/{storeId}/bankaccount"
                .replace("{".concat("storeId", "}"), encodeURIComponent(String(storeId)));
            var localVarUrlObj = url.parse(localVarPath, true);
            var localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            var localVarHeaderParameter = {};
            var localVarQueryParameter = {};
            if (configuration && configuration.accessToken) {
                var localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("oauth2", ["api"])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        getBusinessHours: function (storeId, deliveryType, options) {
            if (options === void 0) { options = {}; }
            if (storeId === null || storeId === undefined) {
                throw new RequiredError('storeId', 'Required parameter storeId was null or undefined when calling getBusinessHours.');
            }
            if (deliveryType === null || deliveryType === undefined) {
                throw new RequiredError('deliveryType', 'Required parameter deliveryType was null or undefined when calling getBusinessHours.');
            }
            var localVarPath = "/api/v1.0/stores/{storeId}/availability/{deliveryType}"
                .replace("{".concat("storeId", "}"), encodeURIComponent(String(storeId)))
                .replace("{".concat("deliveryType", "}"), encodeURIComponent(String(deliveryType)));
            var localVarUrlObj = url.parse(localVarPath, true);
            var localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            var localVarHeaderParameter = {};
            var localVarQueryParameter = {};
            if (configuration && configuration.accessToken) {
                var localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("oauth2", ["api"])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        getBusinessHoursOverrideByStoreId: function (storeId, after, page, limit, options) {
            if (options === void 0) { options = {}; }
            if (storeId === null || storeId === undefined) {
                throw new RequiredError('storeId', 'Required parameter storeId was null or undefined when calling getBusinessHoursOverrideByStoreId.');
            }
            var localVarPath = "/api/v1.0/stores/{storeId}/businesshoursoverrides"
                .replace("{".concat("storeId", "}"), encodeURIComponent(String(storeId)));
            var localVarUrlObj = url.parse(localVarPath, true);
            var localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            var localVarHeaderParameter = {};
            var localVarQueryParameter = {};
            if (configuration && configuration.accessToken) {
                var localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("oauth2", ["api"])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }
            if (after !== undefined) {
                localVarQueryParameter['after'] = after;
            }
            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }
            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        getEndOfDayReport: function (storeId, date, options) {
            if (options === void 0) { options = {}; }
            if (storeId === null || storeId === undefined) {
                throw new RequiredError('storeId', 'Required parameter storeId was null or undefined when calling getEndOfDayReport.');
            }
            var localVarPath = "/api/v1.0/stores/{storeId}/endofdayreport"
                .replace("{".concat("storeId", "}"), encodeURIComponent(String(storeId)));
            var localVarUrlObj = url.parse(localVarPath, true);
            var localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            var localVarHeaderParameter = {};
            var localVarQueryParameter = {};
            if (configuration && configuration.accessToken) {
                var localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("oauth2", ["api"])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }
            if (date !== undefined) {
                localVarQueryParameter['date'] = date;
            }
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        getPreOrderConfig: function (storeId, deliveryType, options) {
            if (options === void 0) { options = {}; }
            if (storeId === null || storeId === undefined) {
                throw new RequiredError('storeId', 'Required parameter storeId was null or undefined when calling getPreOrderConfig.');
            }
            if (deliveryType === null || deliveryType === undefined) {
                throw new RequiredError('deliveryType', 'Required parameter deliveryType was null or undefined when calling getPreOrderConfig.');
            }
            var localVarPath = "/api/v1.0/stores/{storeId}/preorderconfig/{deliveryType}"
                .replace("{".concat("storeId", "}"), encodeURIComponent(String(storeId)))
                .replace("{".concat("deliveryType", "}"), encodeURIComponent(String(deliveryType)));
            var localVarUrlObj = url.parse(localVarPath, true);
            var localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            var localVarHeaderParameter = {};
            var localVarQueryParameter = {};
            if (configuration && configuration.accessToken) {
                var localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("oauth2", ["api"])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        getPreOrderPreview: function (storeId, deliveryType, preOrderConfig_leadTimeMinutes, preOrderConfig_intervalMinutes, preOrderConfig_maxOrderAheadDays, preOrderConfig_includeAsap, preOrderConfig_includeMoreGranularInitialTime, preOrderConfig_cutOffTimePreviousDayBasic, preOrderConfig_cutOffTimeCurrentDayBasic, preOrderConfig_preOrderTimeDisplayType, preOrderConfig_alwaysAppearOpen, preOrderConfig_requireExplicitSelectAlways, options) {
            if (options === void 0) { options = {}; }
            if (storeId === null || storeId === undefined) {
                throw new RequiredError('storeId', 'Required parameter storeId was null or undefined when calling getPreOrderPreview.');
            }
            if (deliveryType === null || deliveryType === undefined) {
                throw new RequiredError('deliveryType', 'Required parameter deliveryType was null or undefined when calling getPreOrderPreview.');
            }
            var localVarPath = "/api/v1.0/stores/{storeId}/preorderconfig/{deliveryType}/preview"
                .replace("{".concat("storeId", "}"), encodeURIComponent(String(storeId)))
                .replace("{".concat("deliveryType", "}"), encodeURIComponent(String(deliveryType)));
            var localVarUrlObj = url.parse(localVarPath, true);
            var localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            var localVarHeaderParameter = {};
            var localVarQueryParameter = {};
            if (configuration && configuration.accessToken) {
                var localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("oauth2", ["api"])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }
            if (preOrderConfig_leadTimeMinutes !== undefined) {
                localVarQueryParameter['preOrderConfig.leadTimeMinutes'] = preOrderConfig_leadTimeMinutes;
            }
            if (preOrderConfig_intervalMinutes !== undefined) {
                localVarQueryParameter['preOrderConfig.intervalMinutes'] = preOrderConfig_intervalMinutes;
            }
            if (preOrderConfig_maxOrderAheadDays !== undefined) {
                localVarQueryParameter['preOrderConfig.maxOrderAheadDays'] = preOrderConfig_maxOrderAheadDays;
            }
            if (preOrderConfig_includeAsap !== undefined) {
                localVarQueryParameter['preOrderConfig.includeAsap'] = preOrderConfig_includeAsap;
            }
            if (preOrderConfig_includeMoreGranularInitialTime !== undefined) {
                localVarQueryParameter['preOrderConfig.includeMoreGranularInitialTime'] = preOrderConfig_includeMoreGranularInitialTime;
            }
            if (preOrderConfig_cutOffTimePreviousDayBasic !== undefined) {
                localVarQueryParameter['preOrderConfig.cutOffTimePreviousDayBasic'] = preOrderConfig_cutOffTimePreviousDayBasic;
            }
            if (preOrderConfig_cutOffTimeCurrentDayBasic !== undefined) {
                localVarQueryParameter['preOrderConfig.cutOffTimeCurrentDayBasic'] = preOrderConfig_cutOffTimeCurrentDayBasic;
            }
            if (preOrderConfig_preOrderTimeDisplayType !== undefined) {
                localVarQueryParameter['preOrderConfig.preOrderTimeDisplayType'] = preOrderConfig_preOrderTimeDisplayType;
            }
            if (preOrderConfig_alwaysAppearOpen !== undefined) {
                localVarQueryParameter['preOrderConfig.alwaysAppearOpen'] = preOrderConfig_alwaysAppearOpen;
            }
            if (preOrderConfig_requireExplicitSelectAlways !== undefined) {
                localVarQueryParameter['preOrderConfig.requireExplicitSelectAlways'] = preOrderConfig_requireExplicitSelectAlways;
            }
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        getProcessingFeeConfigsByStoreId: function (storeId, appNameId, options) {
            if (options === void 0) { options = {}; }
            if (storeId === null || storeId === undefined) {
                throw new RequiredError('storeId', 'Required parameter storeId was null or undefined when calling getProcessingFeeConfigsByStoreId.');
            }
            var localVarPath = "/api/v1.0/stores/{storeId}/processingfeeconfigs"
                .replace("{".concat("storeId", "}"), encodeURIComponent(String(storeId)));
            var localVarUrlObj = url.parse(localVarPath, true);
            var localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            var localVarHeaderParameter = {};
            var localVarQueryParameter = {};
            if (configuration && configuration.accessToken) {
                var localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("oauth2", ["api"])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }
            if (appNameId !== undefined) {
                localVarQueryParameter['appNameId'] = appNameId;
            }
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        getProcessingFeeConfigsByStoreIdAndPaymentAccountType: function (storeId, paymentAccountType, appNameId, options) {
            if (options === void 0) { options = {}; }
            if (storeId === null || storeId === undefined) {
                throw new RequiredError('storeId', 'Required parameter storeId was null or undefined when calling getProcessingFeeConfigsByStoreIdAndPaymentAccountType.');
            }
            if (paymentAccountType === null || paymentAccountType === undefined) {
                throw new RequiredError('paymentAccountType', 'Required parameter paymentAccountType was null or undefined when calling getProcessingFeeConfigsByStoreIdAndPaymentAccountType.');
            }
            var localVarPath = "/api/v1.0/stores/{storeId}/processingfeeconfigs/{paymentAccountType}"
                .replace("{".concat("storeId", "}"), encodeURIComponent(String(storeId)))
                .replace("{".concat("paymentAccountType", "}"), encodeURIComponent(String(paymentAccountType)));
            var localVarUrlObj = url.parse(localVarPath, true);
            var localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            var localVarHeaderParameter = {};
            var localVarQueryParameter = {};
            if (configuration && configuration.accessToken) {
                var localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("oauth2", ["api"])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }
            if (appNameId !== undefined) {
                localVarQueryParameter['appNameId'] = appNameId;
            }
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        getStoreById: function (storeId, options) {
            if (options === void 0) { options = {}; }
            if (storeId === null || storeId === undefined) {
                throw new RequiredError('storeId', 'Required parameter storeId was null or undefined when calling getStoreById.');
            }
            var localVarPath = "/api/v1.0/stores/{storeId}"
                .replace("{".concat("storeId", "}"), encodeURIComponent(String(storeId)));
            var localVarUrlObj = url.parse(localVarPath, true);
            var localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            var localVarHeaderParameter = {};
            var localVarQueryParameter = {};
            if (configuration && configuration.accessToken) {
                var localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("oauth2", ["api"])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        getStoreDeliveryFeeConfig: function (storeId, options) {
            if (options === void 0) { options = {}; }
            if (storeId === null || storeId === undefined) {
                throw new RequiredError('storeId', 'Required parameter storeId was null or undefined when calling getStoreDeliveryFeeConfig.');
            }
            var localVarPath = "/api/v1.0/stores/{storeId}/feeConfig/deliveryZones"
                .replace("{".concat("storeId", "}"), encodeURIComponent(String(storeId)));
            var localVarUrlObj = url.parse(localVarPath, true);
            var localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            var localVarHeaderParameter = {};
            var localVarQueryParameter = {};
            if (configuration && configuration.accessToken) {
                var localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("oauth2", ["api"])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        getStoreFeeConfig: function (storeId, options) {
            if (options === void 0) { options = {}; }
            if (storeId === null || storeId === undefined) {
                throw new RequiredError('storeId', 'Required parameter storeId was null or undefined when calling getStoreFeeConfig.');
            }
            var localVarPath = "/api/v1.0/stores/{storeId}/feeConfig"
                .replace("{".concat("storeId", "}"), encodeURIComponent(String(storeId)));
            var localVarUrlObj = url.parse(localVarPath, true);
            var localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            var localVarHeaderParameter = {};
            var localVarQueryParameter = {};
            if (configuration && configuration.accessToken) {
                var localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("oauth2", ["api"])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        getStoreHeadersByAppId: function (appId, storeNameQuery, salesChannelType, page, limit, options) {
            if (options === void 0) { options = {}; }
            if (appId === null || appId === undefined) {
                throw new RequiredError('appId', 'Required parameter appId was null or undefined when calling getStoreHeadersByAppId.');
            }
            var localVarPath = "/api/v1.0/{appId}/stores/header"
                .replace("{".concat("appId", "}"), encodeURIComponent(String(appId)));
            var localVarUrlObj = url.parse(localVarPath, true);
            var localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            var localVarHeaderParameter = {};
            var localVarQueryParameter = {};
            if (configuration && configuration.accessToken) {
                var localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("oauth2", ["api"])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }
            if (storeNameQuery !== undefined) {
                localVarQueryParameter['storeNameQuery'] = storeNameQuery;
            }
            if (salesChannelType !== undefined) {
                localVarQueryParameter['salesChannelType'] = salesChannelType;
            }
            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }
            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        getStoreLeadTimes: function (storeId, options) {
            if (options === void 0) { options = {}; }
            if (storeId === null || storeId === undefined) {
                throw new RequiredError('storeId', 'Required parameter storeId was null or undefined when calling getStoreLeadTimes.');
            }
            var localVarPath = "/api/v1.0/stores/{storeId}/leadTimes"
                .replace("{".concat("storeId", "}"), encodeURIComponent(String(storeId)));
            var localVarUrlObj = url.parse(localVarPath, true);
            var localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            var localVarHeaderParameter = {};
            var localVarQueryParameter = {};
            if (configuration && configuration.accessToken) {
                var localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("oauth2", ["api"])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        getStoreNetSales: function (appId, storeId, options) {
            if (options === void 0) { options = {}; }
            if (appId === null || appId === undefined) {
                throw new RequiredError('appId', 'Required parameter appId was null or undefined when calling getStoreNetSales.');
            }
            if (storeId === null || storeId === undefined) {
                throw new RequiredError('storeId', 'Required parameter storeId was null or undefined when calling getStoreNetSales.');
            }
            var localVarPath = "/api/v1.0/{appId}/stores/stats"
                .replace("{".concat("appId", "}"), encodeURIComponent(String(appId)));
            var localVarUrlObj = url.parse(localVarPath, true);
            var localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            var localVarHeaderParameter = {};
            var localVarQueryParameter = {};
            if (configuration && configuration.accessToken) {
                var localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("oauth2", ["api"])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }
            if (storeId) {
                localVarQueryParameter['storeId'] = storeId;
            }
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        getStoreServiceCharge: function (storeId, options) {
            if (options === void 0) { options = {}; }
            if (storeId === null || storeId === undefined) {
                throw new RequiredError('storeId', 'Required parameter storeId was null or undefined when calling getStoreServiceCharge.');
            }
            var localVarPath = "/api/v1.0/stores/{storeId}/servicecharge"
                .replace("{".concat("storeId", "}"), encodeURIComponent(String(storeId)));
            var localVarUrlObj = url.parse(localVarPath, true);
            var localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            var localVarHeaderParameter = {};
            var localVarQueryParameter = {};
            if (configuration && configuration.accessToken) {
                var localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("oauth2", ["api"])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        getStores: function (searchQuery, page, limit, storeGroupId, options) {
            if (options === void 0) { options = {}; }
            var localVarPath = "/api/v1.0/stores";
            var localVarUrlObj = url.parse(localVarPath, true);
            var localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            var localVarHeaderParameter = {};
            var localVarQueryParameter = {};
            if (configuration && configuration.accessToken) {
                var localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("oauth2", ["api"])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }
            if (searchQuery !== undefined) {
                localVarQueryParameter['searchQuery'] = searchQuery;
            }
            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }
            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }
            if (storeGroupId !== undefined) {
                localVarQueryParameter['storeGroupId'] = storeGroupId;
            }
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        getStoresByAppId: function (appId, searchQuery, salesChannelType, excludeUnpublished, page, limit, options) {
            if (options === void 0) { options = {}; }
            if (appId === null || appId === undefined) {
                throw new RequiredError('appId', 'Required parameter appId was null or undefined when calling getStoresByAppId.');
            }
            var localVarPath = "/api/v1.0/{appId}/stores"
                .replace("{".concat("appId", "}"), encodeURIComponent(String(appId)));
            var localVarUrlObj = url.parse(localVarPath, true);
            var localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            var localVarHeaderParameter = {};
            var localVarQueryParameter = {};
            if (configuration && configuration.accessToken) {
                var localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("oauth2", ["api"])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }
            if (searchQuery !== undefined) {
                localVarQueryParameter['searchQuery'] = searchQuery;
            }
            if (salesChannelType !== undefined) {
                localVarQueryParameter['salesChannelType'] = salesChannelType;
            }
            if (excludeUnpublished !== undefined) {
                localVarQueryParameter['excludeUnpublished'] = excludeUnpublished;
            }
            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }
            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        getStoresByStoreIdWithValidations: function (storeId, appId, page, limit, options) {
            if (options === void 0) { options = {}; }
            if (storeId === null || storeId === undefined) {
                throw new RequiredError('storeId', 'Required parameter storeId was null or undefined when calling getStoresByStoreIdWithValidations.');
            }
            if (appId === null || appId === undefined) {
                throw new RequiredError('appId', 'Required parameter appId was null or undefined when calling getStoresByStoreIdWithValidations.');
            }
            var localVarPath = "/api/v1.0/{appId}/storevalidation/kiosk"
                .replace("{".concat("appId", "}"), encodeURIComponent(String(appId)));
            var localVarUrlObj = url.parse(localVarPath, true);
            var localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            var localVarHeaderParameter = {};
            var localVarQueryParameter = {};
            if (configuration && configuration.accessToken) {
                var localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("oauth2", ["api"])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }
            if (storeId) {
                localVarQueryParameter['storeId'] = storeId;
            }
            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }
            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        publishStore: function (storeId, options) {
            if (options === void 0) { options = {}; }
            if (storeId === null || storeId === undefined) {
                throw new RequiredError('storeId', 'Required parameter storeId was null or undefined when calling publishStore.');
            }
            var localVarPath = "/api/v1.0/stores/{storeId}/publish"
                .replace("{".concat("storeId", "}"), encodeURIComponent(String(storeId)));
            var localVarUrlObj = url.parse(localVarPath, true);
            var localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            var localVarHeaderParameter = {};
            var localVarQueryParameter = {};
            if (configuration && configuration.accessToken) {
                var localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("oauth2", ["api"])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        putStoreDeliveryFeeConfig: function (storeId, StoreDeliveryZoneFeeConfigUpdateRequest, options) {
            if (options === void 0) { options = {}; }
            if (storeId === null || storeId === undefined) {
                throw new RequiredError('storeId', 'Required parameter storeId was null or undefined when calling putStoreDeliveryFeeConfig.');
            }
            if (StoreDeliveryZoneFeeConfigUpdateRequest === null || StoreDeliveryZoneFeeConfigUpdateRequest === undefined) {
                throw new RequiredError('StoreDeliveryZoneFeeConfigUpdateRequest', 'Required parameter StoreDeliveryZoneFeeConfigUpdateRequest was null or undefined when calling putStoreDeliveryFeeConfig.');
            }
            var localVarPath = "/api/v1.0/stores/{storeId}/feeConfig/deliveryZones"
                .replace("{".concat("storeId", "}"), encodeURIComponent(String(storeId)));
            var localVarUrlObj = url.parse(localVarPath, true);
            var localVarRequestOptions = Object.assign({ method: 'PUT' }, options);
            var localVarHeaderParameter = {};
            var localVarQueryParameter = {};
            if (configuration && configuration.accessToken) {
                var localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("oauth2", ["api"])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }
            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            var needsSerialization = ("StoreDeliveryZoneFeeConfigUpdateRequest" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body = needsSerialization ? JSON.stringify(StoreDeliveryZoneFeeConfigUpdateRequest || {}) : (StoreDeliveryZoneFeeConfigUpdateRequest || "");
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        setBusinessHours: function (storeId, deliveryType, BusinessHoursPeriodBase, options) {
            if (options === void 0) { options = {}; }
            if (storeId === null || storeId === undefined) {
                throw new RequiredError('storeId', 'Required parameter storeId was null or undefined when calling setBusinessHours.');
            }
            if (deliveryType === null || deliveryType === undefined) {
                throw new RequiredError('deliveryType', 'Required parameter deliveryType was null or undefined when calling setBusinessHours.');
            }
            if (BusinessHoursPeriodBase === null || BusinessHoursPeriodBase === undefined) {
                throw new RequiredError('BusinessHoursPeriodBase', 'Required parameter BusinessHoursPeriodBase was null or undefined when calling setBusinessHours.');
            }
            var localVarPath = "/api/v1.0/stores/{storeId}/availability/{deliveryType}"
                .replace("{".concat("storeId", "}"), encodeURIComponent(String(storeId)))
                .replace("{".concat("deliveryType", "}"), encodeURIComponent(String(deliveryType)));
            var localVarUrlObj = url.parse(localVarPath, true);
            var localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            var localVarHeaderParameter = {};
            var localVarQueryParameter = {};
            if (configuration && configuration.accessToken) {
                var localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("oauth2", ["api"])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }
            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            var needsSerialization = ("BusinessHoursPeriodBase" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body = needsSerialization ? JSON.stringify(BusinessHoursPeriodBase || {}) : (BusinessHoursPeriodBase || "");
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        setPreOrdeEnabled: function (storeId, deliveryType, enabled, options) {
            if (options === void 0) { options = {}; }
            if (storeId === null || storeId === undefined) {
                throw new RequiredError('storeId', 'Required parameter storeId was null or undefined when calling setPreOrdeEnabled.');
            }
            if (deliveryType === null || deliveryType === undefined) {
                throw new RequiredError('deliveryType', 'Required parameter deliveryType was null or undefined when calling setPreOrdeEnabled.');
            }
            if (enabled === null || enabled === undefined) {
                throw new RequiredError('enabled', 'Required parameter enabled was null or undefined when calling setPreOrdeEnabled.');
            }
            var localVarPath = "/api/v1.0/stores/{storeId}/preorderconfig/{deliveryType}/enabled"
                .replace("{".concat("storeId", "}"), encodeURIComponent(String(storeId)))
                .replace("{".concat("deliveryType", "}"), encodeURIComponent(String(deliveryType)));
            var localVarUrlObj = url.parse(localVarPath, true);
            var localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            var localVarHeaderParameter = {};
            var localVarQueryParameter = {};
            if (configuration && configuration.accessToken) {
                var localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("oauth2", ["api"])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }
            if (enabled !== undefined) {
                localVarQueryParameter['enabled'] = enabled;
            }
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        setStoreCollectionSettings: function (storeId, StoreCollectionSettings, inheritFromProperty, options) {
            if (options === void 0) { options = {}; }
            if (storeId === null || storeId === undefined) {
                throw new RequiredError('storeId', 'Required parameter storeId was null or undefined when calling setStoreCollectionSettings.');
            }
            if (StoreCollectionSettings === null || StoreCollectionSettings === undefined) {
                throw new RequiredError('StoreCollectionSettings', 'Required parameter StoreCollectionSettings was null or undefined when calling setStoreCollectionSettings.');
            }
            var localVarPath = "/api/v1.0/stores/{storeId}/collectionsettings"
                .replace("{".concat("storeId", "}"), encodeURIComponent(String(storeId)));
            var localVarUrlObj = url.parse(localVarPath, true);
            var localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            var localVarHeaderParameter = {};
            var localVarQueryParameter = {};
            if (configuration && configuration.accessToken) {
                var localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("oauth2", ["api"])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }
            if (inheritFromProperty !== undefined) {
                localVarQueryParameter['inheritFromProperty'] = inheritFromProperty;
            }
            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            var needsSerialization = ("StoreCollectionSettings" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body = needsSerialization ? JSON.stringify(StoreCollectionSettings || {}) : (StoreCollectionSettings || "");
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        setStoreLeadTimes: function (storeId, LeadTime, options) {
            if (options === void 0) { options = {}; }
            if (storeId === null || storeId === undefined) {
                throw new RequiredError('storeId', 'Required parameter storeId was null or undefined when calling setStoreLeadTimes.');
            }
            if (LeadTime === null || LeadTime === undefined) {
                throw new RequiredError('LeadTime', 'Required parameter LeadTime was null or undefined when calling setStoreLeadTimes.');
            }
            var localVarPath = "/api/v1.0/stores/{storeId}/leadTimes"
                .replace("{".concat("storeId", "}"), encodeURIComponent(String(storeId)));
            var localVarUrlObj = url.parse(localVarPath, true);
            var localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            var localVarHeaderParameter = {};
            var localVarQueryParameter = {};
            if (configuration && configuration.accessToken) {
                var localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("oauth2", ["api"])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }
            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            var needsSerialization = ("LeadTime" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body = needsSerialization ? JSON.stringify(LeadTime || {}) : (LeadTime || "");
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        storesSetPropertyId: function (storeId, propertyId, options) {
            if (options === void 0) { options = {}; }
            if (storeId === null || storeId === undefined) {
                throw new RequiredError('storeId', 'Required parameter storeId was null or undefined when calling storesSetPropertyId.');
            }
            if (propertyId === null || propertyId === undefined) {
                throw new RequiredError('propertyId', 'Required parameter propertyId was null or undefined when calling storesSetPropertyId.');
            }
            var localVarPath = "/api/v1.0/stores/{storeId}/propertyId/{propertyId}"
                .replace("{".concat("storeId", "}"), encodeURIComponent(String(storeId)))
                .replace("{".concat("propertyId", "}"), encodeURIComponent(String(propertyId)));
            var localVarUrlObj = url.parse(localVarPath, true);
            var localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            var localVarHeaderParameter = {};
            var localVarQueryParameter = {};
            if (configuration && configuration.accessToken) {
                var localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("oauth2", ["api"])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        supportedSalesChannelsTypes: function (propertyId, storeId, ERROR_UNKNOWN, options) {
            if (options === void 0) { options = {}; }
            if (propertyId === null || propertyId === undefined) {
                throw new RequiredError('propertyId', 'Required parameter propertyId was null or undefined when calling supportedSalesChannelsTypes.');
            }
            if (storeId === null || storeId === undefined) {
                throw new RequiredError('storeId', 'Required parameter storeId was null or undefined when calling supportedSalesChannelsTypes.');
            }
            if (ERROR_UNKNOWN === null || ERROR_UNKNOWN === undefined) {
                throw new RequiredError('ERROR_UNKNOWN', 'Required parameter ERROR_UNKNOWN was null or undefined when calling supportedSalesChannelsTypes.');
            }
            var localVarPath = "/api/v1.0/properties/{propertyId}/stores/{storeId}/supportedSalesChannels"
                .replace("{".concat("propertyId", "}"), encodeURIComponent(String(propertyId)))
                .replace("{".concat("storeId", "}"), encodeURIComponent(String(storeId)));
            var localVarUrlObj = url.parse(localVarPath, true);
            var localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            var localVarHeaderParameter = {};
            var localVarQueryParameter = {};
            if (configuration && configuration.accessToken) {
                var localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("oauth2", ["api"])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }
            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            var needsSerialization = ("Array&lt;string&gt;" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body = needsSerialization ? JSON.stringify(ERROR_UNKNOWN || {}) : (ERROR_UNKNOWN || "");
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        unpublishStore: function (storeId, options) {
            if (options === void 0) { options = {}; }
            if (storeId === null || storeId === undefined) {
                throw new RequiredError('storeId', 'Required parameter storeId was null or undefined when calling unpublishStore.');
            }
            var localVarPath = "/api/v1.0/stores/{storeId}/unpublish"
                .replace("{".concat("storeId", "}"), encodeURIComponent(String(storeId)));
            var localVarUrlObj = url.parse(localVarPath, true);
            var localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            var localVarHeaderParameter = {};
            var localVarQueryParameter = {};
            if (configuration && configuration.accessToken) {
                var localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("oauth2", ["api"])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        updatePreOrderConfig: function (storeId, deliveryType, PreOrderConfig, options) {
            if (options === void 0) { options = {}; }
            if (storeId === null || storeId === undefined) {
                throw new RequiredError('storeId', 'Required parameter storeId was null or undefined when calling updatePreOrderConfig.');
            }
            if (deliveryType === null || deliveryType === undefined) {
                throw new RequiredError('deliveryType', 'Required parameter deliveryType was null or undefined when calling updatePreOrderConfig.');
            }
            if (PreOrderConfig === null || PreOrderConfig === undefined) {
                throw new RequiredError('PreOrderConfig', 'Required parameter PreOrderConfig was null or undefined when calling updatePreOrderConfig.');
            }
            var localVarPath = "/api/v1.0/stores/{storeId}/preorderconfig/{deliveryType}"
                .replace("{".concat("storeId", "}"), encodeURIComponent(String(storeId)))
                .replace("{".concat("deliveryType", "}"), encodeURIComponent(String(deliveryType)));
            var localVarUrlObj = url.parse(localVarPath, true);
            var localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            var localVarHeaderParameter = {};
            var localVarQueryParameter = {};
            if (configuration && configuration.accessToken) {
                var localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("oauth2", ["api"])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }
            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            var needsSerialization = ("PreOrderConfig" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body = needsSerialization ? JSON.stringify(PreOrderConfig || {}) : (PreOrderConfig || "");
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        updateStore: function (storeId, StoreBase, options) {
            if (options === void 0) { options = {}; }
            if (storeId === null || storeId === undefined) {
                throw new RequiredError('storeId', 'Required parameter storeId was null or undefined when calling updateStore.');
            }
            if (StoreBase === null || StoreBase === undefined) {
                throw new RequiredError('StoreBase', 'Required parameter StoreBase was null or undefined when calling updateStore.');
            }
            var localVarPath = "/api/v1.0/stores/{storeId}"
                .replace("{".concat("storeId", "}"), encodeURIComponent(String(storeId)));
            var localVarUrlObj = url.parse(localVarPath, true);
            var localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            var localVarHeaderParameter = {};
            var localVarQueryParameter = {};
            if (configuration && configuration.accessToken) {
                var localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("oauth2", ["api"])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }
            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            var needsSerialization = ("StoreBase" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body = needsSerialization ? JSON.stringify(StoreBase || {}) : (StoreBase || "");
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        updateStoreAddress: function (storeId, StoreAddressBase, options) {
            if (options === void 0) { options = {}; }
            if (storeId === null || storeId === undefined) {
                throw new RequiredError('storeId', 'Required parameter storeId was null or undefined when calling updateStoreAddress.');
            }
            if (StoreAddressBase === null || StoreAddressBase === undefined) {
                throw new RequiredError('StoreAddressBase', 'Required parameter StoreAddressBase was null or undefined when calling updateStoreAddress.');
            }
            var localVarPath = "/api/v1.0/stores/{storeId}/address"
                .replace("{".concat("storeId", "}"), encodeURIComponent(String(storeId)));
            var localVarUrlObj = url.parse(localVarPath, true);
            var localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            var localVarHeaderParameter = {};
            var localVarQueryParameter = {};
            if (configuration && configuration.accessToken) {
                var localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("oauth2", ["api"])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }
            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            var needsSerialization = ("StoreAddressBase" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body = needsSerialization ? JSON.stringify(StoreAddressBase || {}) : (StoreAddressBase || "");
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        updateStoreAddressCoordinates: function (storeId, Coordinates, appNameId, options) {
            if (options === void 0) { options = {}; }
            if (storeId === null || storeId === undefined) {
                throw new RequiredError('storeId', 'Required parameter storeId was null or undefined when calling updateStoreAddressCoordinates.');
            }
            if (Coordinates === null || Coordinates === undefined) {
                throw new RequiredError('Coordinates', 'Required parameter Coordinates was null or undefined when calling updateStoreAddressCoordinates.');
            }
            var localVarPath = "/api/v1.0/stores/{storeId}/address/coordinates"
                .replace("{".concat("storeId", "}"), encodeURIComponent(String(storeId)));
            var localVarUrlObj = url.parse(localVarPath, true);
            var localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            var localVarHeaderParameter = {};
            var localVarQueryParameter = {};
            if (configuration && configuration.accessToken) {
                var localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("oauth2", ["api"])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }
            if (appNameId !== undefined) {
                localVarQueryParameter['appNameId'] = appNameId;
            }
            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            var needsSerialization = ("Coordinates" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body = needsSerialization ? JSON.stringify(Coordinates || {}) : (Coordinates || "");
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        updateStoreAddressForm: function (storeId, StoreAddressForm, options) {
            if (options === void 0) { options = {}; }
            if (storeId === null || storeId === undefined) {
                throw new RequiredError('storeId', 'Required parameter storeId was null or undefined when calling updateStoreAddressForm.');
            }
            if (StoreAddressForm === null || StoreAddressForm === undefined) {
                throw new RequiredError('StoreAddressForm', 'Required parameter StoreAddressForm was null or undefined when calling updateStoreAddressForm.');
            }
            var localVarPath = "/api/v1.0/stores/{storeId}/addressform"
                .replace("{".concat("storeId", "}"), encodeURIComponent(String(storeId)));
            var localVarUrlObj = url.parse(localVarPath, true);
            var localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            var localVarHeaderParameter = {};
            var localVarQueryParameter = {};
            if (configuration && configuration.accessToken) {
                var localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("oauth2", ["api"])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }
            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            var needsSerialization = ("StoreAddressForm" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body = needsSerialization ? JSON.stringify(StoreAddressForm || {}) : (StoreAddressForm || "");
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    };
};
exports.StoresApiFetchParamCreator = StoresApiFetchParamCreator;
var StoresApiFp = function (configuration) {
    return {
        archiveStore: function (storeId, options) {
            var localVarFetchArgs = (0, exports.StoresApiFetchParamCreator)(configuration).archiveStore(storeId, options);
            return function (fetch, basePath) {
                if (fetch === void 0) { fetch = portableFetch; }
                if (basePath === void 0) { basePath = BASE_PATH; }
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then(function (response) {
                    if (response.status >= 200 && response.status < 300) {
                        return response;
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
        assignMenu: function (storeId, menuId, options) {
            var localVarFetchArgs = (0, exports.StoresApiFetchParamCreator)(configuration).assignMenu(storeId, menuId, options);
            return function (fetch, basePath) {
                if (fetch === void 0) { fetch = portableFetch; }
                if (basePath === void 0) { basePath = BASE_PATH; }
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then(function (response) {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
        cloneStore: function (storeId, StoreCloneSettings, options) {
            var localVarFetchArgs = (0, exports.StoresApiFetchParamCreator)(configuration).cloneStore(storeId, StoreCloneSettings, options);
            return function (fetch, basePath) {
                if (fetch === void 0) { fetch = portableFetch; }
                if (basePath === void 0) { basePath = BASE_PATH; }
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then(function (response) {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
        configureStoreServiceCharge: function (storeId, ServiceCharge, options) {
            var localVarFetchArgs = (0, exports.StoresApiFetchParamCreator)(configuration).configureStoreServiceCharge(storeId, ServiceCharge, options);
            return function (fetch, basePath) {
                if (fetch === void 0) { fetch = portableFetch; }
                if (basePath === void 0) { basePath = BASE_PATH; }
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then(function (response) {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
        createBusinessHoursOverrideByStoreId: function (storeId, BusinessHoursOverrideBase, options) {
            var localVarFetchArgs = (0, exports.StoresApiFetchParamCreator)(configuration).createBusinessHoursOverrideByStoreId(storeId, BusinessHoursOverrideBase, options);
            return function (fetch, basePath) {
                if (fetch === void 0) { fetch = portableFetch; }
                if (basePath === void 0) { basePath = BASE_PATH; }
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then(function (response) {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
        createStore: function (storeGroupId, StoreCreateBase, options) {
            var localVarFetchArgs = (0, exports.StoresApiFetchParamCreator)(configuration).createStore(storeGroupId, StoreCreateBase, options);
            return function (fetch, basePath) {
                if (fetch === void 0) { fetch = portableFetch; }
                if (basePath === void 0) { basePath = BASE_PATH; }
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then(function (response) {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
        createStoreInProperty: function (storeGroupId, propertyId, StoreCreateBase, autoAssignMenu, options) {
            var localVarFetchArgs = (0, exports.StoresApiFetchParamCreator)(configuration).createStoreInProperty(storeGroupId, propertyId, StoreCreateBase, autoAssignMenu, options);
            return function (fetch, basePath) {
                if (fetch === void 0) { fetch = portableFetch; }
                if (basePath === void 0) { basePath = BASE_PATH; }
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then(function (response) {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
        deleteBusinessHoursOverride: function (storeId, businessHoursOverrideId, options) {
            var localVarFetchArgs = (0, exports.StoresApiFetchParamCreator)(configuration).deleteBusinessHoursOverride(storeId, businessHoursOverrideId, options);
            return function (fetch, basePath) {
                if (fetch === void 0) { fetch = portableFetch; }
                if (basePath === void 0) { basePath = BASE_PATH; }
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then(function (response) {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
        getBankAccountForStore: function (storeId, options) {
            var localVarFetchArgs = (0, exports.StoresApiFetchParamCreator)(configuration).getBankAccountForStore(storeId, options);
            return function (fetch, basePath) {
                if (fetch === void 0) { fetch = portableFetch; }
                if (basePath === void 0) { basePath = BASE_PATH; }
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then(function (response) {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
        getBusinessHours: function (storeId, deliveryType, options) {
            var localVarFetchArgs = (0, exports.StoresApiFetchParamCreator)(configuration).getBusinessHours(storeId, deliveryType, options);
            return function (fetch, basePath) {
                if (fetch === void 0) { fetch = portableFetch; }
                if (basePath === void 0) { basePath = BASE_PATH; }
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then(function (response) {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
        getBusinessHoursOverrideByStoreId: function (storeId, after, page, limit, options) {
            var localVarFetchArgs = (0, exports.StoresApiFetchParamCreator)(configuration).getBusinessHoursOverrideByStoreId(storeId, after, page, limit, options);
            return function (fetch, basePath) {
                if (fetch === void 0) { fetch = portableFetch; }
                if (basePath === void 0) { basePath = BASE_PATH; }
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then(function (response) {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
        getEndOfDayReport: function (storeId, date, options) {
            var localVarFetchArgs = (0, exports.StoresApiFetchParamCreator)(configuration).getEndOfDayReport(storeId, date, options);
            return function (fetch, basePath) {
                if (fetch === void 0) { fetch = portableFetch; }
                if (basePath === void 0) { basePath = BASE_PATH; }
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then(function (response) {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
        getPreOrderConfig: function (storeId, deliveryType, options) {
            var localVarFetchArgs = (0, exports.StoresApiFetchParamCreator)(configuration).getPreOrderConfig(storeId, deliveryType, options);
            return function (fetch, basePath) {
                if (fetch === void 0) { fetch = portableFetch; }
                if (basePath === void 0) { basePath = BASE_PATH; }
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then(function (response) {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
        getPreOrderPreview: function (storeId, deliveryType, preOrderConfig_leadTimeMinutes, preOrderConfig_intervalMinutes, preOrderConfig_maxOrderAheadDays, preOrderConfig_includeAsap, preOrderConfig_includeMoreGranularInitialTime, preOrderConfig_cutOffTimePreviousDayBasic, preOrderConfig_cutOffTimeCurrentDayBasic, preOrderConfig_preOrderTimeDisplayType, preOrderConfig_alwaysAppearOpen, preOrderConfig_requireExplicitSelectAlways, options) {
            var localVarFetchArgs = (0, exports.StoresApiFetchParamCreator)(configuration).getPreOrderPreview(storeId, deliveryType, preOrderConfig_leadTimeMinutes, preOrderConfig_intervalMinutes, preOrderConfig_maxOrderAheadDays, preOrderConfig_includeAsap, preOrderConfig_includeMoreGranularInitialTime, preOrderConfig_cutOffTimePreviousDayBasic, preOrderConfig_cutOffTimeCurrentDayBasic, preOrderConfig_preOrderTimeDisplayType, preOrderConfig_alwaysAppearOpen, preOrderConfig_requireExplicitSelectAlways, options);
            return function (fetch, basePath) {
                if (fetch === void 0) { fetch = portableFetch; }
                if (basePath === void 0) { basePath = BASE_PATH; }
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then(function (response) {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
        getProcessingFeeConfigsByStoreId: function (storeId, appNameId, options) {
            var localVarFetchArgs = (0, exports.StoresApiFetchParamCreator)(configuration).getProcessingFeeConfigsByStoreId(storeId, appNameId, options);
            return function (fetch, basePath) {
                if (fetch === void 0) { fetch = portableFetch; }
                if (basePath === void 0) { basePath = BASE_PATH; }
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then(function (response) {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
        getProcessingFeeConfigsByStoreIdAndPaymentAccountType: function (storeId, paymentAccountType, appNameId, options) {
            var localVarFetchArgs = (0, exports.StoresApiFetchParamCreator)(configuration).getProcessingFeeConfigsByStoreIdAndPaymentAccountType(storeId, paymentAccountType, appNameId, options);
            return function (fetch, basePath) {
                if (fetch === void 0) { fetch = portableFetch; }
                if (basePath === void 0) { basePath = BASE_PATH; }
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then(function (response) {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
        getStoreById: function (storeId, options) {
            var localVarFetchArgs = (0, exports.StoresApiFetchParamCreator)(configuration).getStoreById(storeId, options);
            return function (fetch, basePath) {
                if (fetch === void 0) { fetch = portableFetch; }
                if (basePath === void 0) { basePath = BASE_PATH; }
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then(function (response) {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
        getStoreDeliveryFeeConfig: function (storeId, options) {
            var localVarFetchArgs = (0, exports.StoresApiFetchParamCreator)(configuration).getStoreDeliveryFeeConfig(storeId, options);
            return function (fetch, basePath) {
                if (fetch === void 0) { fetch = portableFetch; }
                if (basePath === void 0) { basePath = BASE_PATH; }
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then(function (response) {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
        getStoreFeeConfig: function (storeId, options) {
            var localVarFetchArgs = (0, exports.StoresApiFetchParamCreator)(configuration).getStoreFeeConfig(storeId, options);
            return function (fetch, basePath) {
                if (fetch === void 0) { fetch = portableFetch; }
                if (basePath === void 0) { basePath = BASE_PATH; }
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then(function (response) {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
        getStoreHeadersByAppId: function (appId, storeNameQuery, salesChannelType, page, limit, options) {
            var localVarFetchArgs = (0, exports.StoresApiFetchParamCreator)(configuration).getStoreHeadersByAppId(appId, storeNameQuery, salesChannelType, page, limit, options);
            return function (fetch, basePath) {
                if (fetch === void 0) { fetch = portableFetch; }
                if (basePath === void 0) { basePath = BASE_PATH; }
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then(function (response) {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
        getStoreLeadTimes: function (storeId, options) {
            var localVarFetchArgs = (0, exports.StoresApiFetchParamCreator)(configuration).getStoreLeadTimes(storeId, options);
            return function (fetch, basePath) {
                if (fetch === void 0) { fetch = portableFetch; }
                if (basePath === void 0) { basePath = BASE_PATH; }
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then(function (response) {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
        getStoreNetSales: function (appId, storeId, options) {
            var localVarFetchArgs = (0, exports.StoresApiFetchParamCreator)(configuration).getStoreNetSales(appId, storeId, options);
            return function (fetch, basePath) {
                if (fetch === void 0) { fetch = portableFetch; }
                if (basePath === void 0) { basePath = BASE_PATH; }
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then(function (response) {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
        getStoreServiceCharge: function (storeId, options) {
            var localVarFetchArgs = (0, exports.StoresApiFetchParamCreator)(configuration).getStoreServiceCharge(storeId, options);
            return function (fetch, basePath) {
                if (fetch === void 0) { fetch = portableFetch; }
                if (basePath === void 0) { basePath = BASE_PATH; }
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then(function (response) {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
        getStores: function (searchQuery, page, limit, storeGroupId, options) {
            var localVarFetchArgs = (0, exports.StoresApiFetchParamCreator)(configuration).getStores(searchQuery, page, limit, storeGroupId, options);
            return function (fetch, basePath) {
                if (fetch === void 0) { fetch = portableFetch; }
                if (basePath === void 0) { basePath = BASE_PATH; }
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then(function (response) {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
        getStoresByAppId: function (appId, searchQuery, salesChannelType, excludeUnpublished, page, limit, options) {
            var localVarFetchArgs = (0, exports.StoresApiFetchParamCreator)(configuration).getStoresByAppId(appId, searchQuery, salesChannelType, excludeUnpublished, page, limit, options);
            return function (fetch, basePath) {
                if (fetch === void 0) { fetch = portableFetch; }
                if (basePath === void 0) { basePath = BASE_PATH; }
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then(function (response) {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
        getStoresByStoreIdWithValidations: function (storeId, appId, page, limit, options) {
            var localVarFetchArgs = (0, exports.StoresApiFetchParamCreator)(configuration).getStoresByStoreIdWithValidations(storeId, appId, page, limit, options);
            return function (fetch, basePath) {
                if (fetch === void 0) { fetch = portableFetch; }
                if (basePath === void 0) { basePath = BASE_PATH; }
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then(function (response) {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
        publishStore: function (storeId, options) {
            var localVarFetchArgs = (0, exports.StoresApiFetchParamCreator)(configuration).publishStore(storeId, options);
            return function (fetch, basePath) {
                if (fetch === void 0) { fetch = portableFetch; }
                if (basePath === void 0) { basePath = BASE_PATH; }
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then(function (response) {
                    if (response.status >= 200 && response.status < 300) {
                        return response;
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
        putStoreDeliveryFeeConfig: function (storeId, StoreDeliveryZoneFeeConfigUpdateRequest, options) {
            var localVarFetchArgs = (0, exports.StoresApiFetchParamCreator)(configuration).putStoreDeliveryFeeConfig(storeId, StoreDeliveryZoneFeeConfigUpdateRequest, options);
            return function (fetch, basePath) {
                if (fetch === void 0) { fetch = portableFetch; }
                if (basePath === void 0) { basePath = BASE_PATH; }
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then(function (response) {
                    if (response.status >= 200 && response.status < 300) {
                        return response;
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
        setBusinessHours: function (storeId, deliveryType, BusinessHoursPeriodBase, options) {
            var localVarFetchArgs = (0, exports.StoresApiFetchParamCreator)(configuration).setBusinessHours(storeId, deliveryType, BusinessHoursPeriodBase, options);
            return function (fetch, basePath) {
                if (fetch === void 0) { fetch = portableFetch; }
                if (basePath === void 0) { basePath = BASE_PATH; }
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then(function (response) {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
        setPreOrdeEnabled: function (storeId, deliveryType, enabled, options) {
            var localVarFetchArgs = (0, exports.StoresApiFetchParamCreator)(configuration).setPreOrdeEnabled(storeId, deliveryType, enabled, options);
            return function (fetch, basePath) {
                if (fetch === void 0) { fetch = portableFetch; }
                if (basePath === void 0) { basePath = BASE_PATH; }
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then(function (response) {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
        setStoreCollectionSettings: function (storeId, StoreCollectionSettings, inheritFromProperty, options) {
            var localVarFetchArgs = (0, exports.StoresApiFetchParamCreator)(configuration).setStoreCollectionSettings(storeId, StoreCollectionSettings, inheritFromProperty, options);
            return function (fetch, basePath) {
                if (fetch === void 0) { fetch = portableFetch; }
                if (basePath === void 0) { basePath = BASE_PATH; }
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then(function (response) {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
        setStoreLeadTimes: function (storeId, LeadTime, options) {
            var localVarFetchArgs = (0, exports.StoresApiFetchParamCreator)(configuration).setStoreLeadTimes(storeId, LeadTime, options);
            return function (fetch, basePath) {
                if (fetch === void 0) { fetch = portableFetch; }
                if (basePath === void 0) { basePath = BASE_PATH; }
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then(function (response) {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
        storesSetPropertyId: function (storeId, propertyId, options) {
            var localVarFetchArgs = (0, exports.StoresApiFetchParamCreator)(configuration).storesSetPropertyId(storeId, propertyId, options);
            return function (fetch, basePath) {
                if (fetch === void 0) { fetch = portableFetch; }
                if (basePath === void 0) { basePath = BASE_PATH; }
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then(function (response) {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
        supportedSalesChannelsTypes: function (propertyId, storeId, ERROR_UNKNOWN, options) {
            var localVarFetchArgs = (0, exports.StoresApiFetchParamCreator)(configuration).supportedSalesChannelsTypes(propertyId, storeId, ERROR_UNKNOWN, options);
            return function (fetch, basePath) {
                if (fetch === void 0) { fetch = portableFetch; }
                if (basePath === void 0) { basePath = BASE_PATH; }
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then(function (response) {
                    if (response.status >= 200 && response.status < 300) {
                        return response;
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
        unpublishStore: function (storeId, options) {
            var localVarFetchArgs = (0, exports.StoresApiFetchParamCreator)(configuration).unpublishStore(storeId, options);
            return function (fetch, basePath) {
                if (fetch === void 0) { fetch = portableFetch; }
                if (basePath === void 0) { basePath = BASE_PATH; }
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then(function (response) {
                    if (response.status >= 200 && response.status < 300) {
                        return response;
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
        updatePreOrderConfig: function (storeId, deliveryType, PreOrderConfig, options) {
            var localVarFetchArgs = (0, exports.StoresApiFetchParamCreator)(configuration).updatePreOrderConfig(storeId, deliveryType, PreOrderConfig, options);
            return function (fetch, basePath) {
                if (fetch === void 0) { fetch = portableFetch; }
                if (basePath === void 0) { basePath = BASE_PATH; }
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then(function (response) {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
        updateStore: function (storeId, StoreBase, options) {
            var localVarFetchArgs = (0, exports.StoresApiFetchParamCreator)(configuration).updateStore(storeId, StoreBase, options);
            return function (fetch, basePath) {
                if (fetch === void 0) { fetch = portableFetch; }
                if (basePath === void 0) { basePath = BASE_PATH; }
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then(function (response) {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
        updateStoreAddress: function (storeId, StoreAddressBase, options) {
            var localVarFetchArgs = (0, exports.StoresApiFetchParamCreator)(configuration).updateStoreAddress(storeId, StoreAddressBase, options);
            return function (fetch, basePath) {
                if (fetch === void 0) { fetch = portableFetch; }
                if (basePath === void 0) { basePath = BASE_PATH; }
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then(function (response) {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
        updateStoreAddressCoordinates: function (storeId, Coordinates, appNameId, options) {
            var localVarFetchArgs = (0, exports.StoresApiFetchParamCreator)(configuration).updateStoreAddressCoordinates(storeId, Coordinates, appNameId, options);
            return function (fetch, basePath) {
                if (fetch === void 0) { fetch = portableFetch; }
                if (basePath === void 0) { basePath = BASE_PATH; }
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then(function (response) {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
        updateStoreAddressForm: function (storeId, StoreAddressForm, options) {
            var localVarFetchArgs = (0, exports.StoresApiFetchParamCreator)(configuration).updateStoreAddressForm(storeId, StoreAddressForm, options);
            return function (fetch, basePath) {
                if (fetch === void 0) { fetch = portableFetch; }
                if (basePath === void 0) { basePath = BASE_PATH; }
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then(function (response) {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
    };
};
exports.StoresApiFp = StoresApiFp;
var StoresApiFactory = function (configuration, fetch, basePath) {
    return {
        archiveStore: function (storeId, options) {
            return (0, exports.StoresApiFp)(configuration).archiveStore(storeId, options)(fetch, basePath);
        },
        assignMenu: function (storeId, menuId, options) {
            return (0, exports.StoresApiFp)(configuration).assignMenu(storeId, menuId, options)(fetch, basePath);
        },
        cloneStore: function (storeId, StoreCloneSettings, options) {
            return (0, exports.StoresApiFp)(configuration).cloneStore(storeId, StoreCloneSettings, options)(fetch, basePath);
        },
        configureStoreServiceCharge: function (storeId, ServiceCharge, options) {
            return (0, exports.StoresApiFp)(configuration).configureStoreServiceCharge(storeId, ServiceCharge, options)(fetch, basePath);
        },
        createBusinessHoursOverrideByStoreId: function (storeId, BusinessHoursOverrideBase, options) {
            return (0, exports.StoresApiFp)(configuration).createBusinessHoursOverrideByStoreId(storeId, BusinessHoursOverrideBase, options)(fetch, basePath);
        },
        createStore: function (storeGroupId, StoreCreateBase, options) {
            return (0, exports.StoresApiFp)(configuration).createStore(storeGroupId, StoreCreateBase, options)(fetch, basePath);
        },
        createStoreInProperty: function (storeGroupId, propertyId, StoreCreateBase, autoAssignMenu, options) {
            return (0, exports.StoresApiFp)(configuration).createStoreInProperty(storeGroupId, propertyId, StoreCreateBase, autoAssignMenu, options)(fetch, basePath);
        },
        deleteBusinessHoursOverride: function (storeId, businessHoursOverrideId, options) {
            return (0, exports.StoresApiFp)(configuration).deleteBusinessHoursOverride(storeId, businessHoursOverrideId, options)(fetch, basePath);
        },
        getBankAccountForStore: function (storeId, options) {
            return (0, exports.StoresApiFp)(configuration).getBankAccountForStore(storeId, options)(fetch, basePath);
        },
        getBusinessHours: function (storeId, deliveryType, options) {
            return (0, exports.StoresApiFp)(configuration).getBusinessHours(storeId, deliveryType, options)(fetch, basePath);
        },
        getBusinessHoursOverrideByStoreId: function (storeId, after, page, limit, options) {
            return (0, exports.StoresApiFp)(configuration).getBusinessHoursOverrideByStoreId(storeId, after, page, limit, options)(fetch, basePath);
        },
        getEndOfDayReport: function (storeId, date, options) {
            return (0, exports.StoresApiFp)(configuration).getEndOfDayReport(storeId, date, options)(fetch, basePath);
        },
        getPreOrderConfig: function (storeId, deliveryType, options) {
            return (0, exports.StoresApiFp)(configuration).getPreOrderConfig(storeId, deliveryType, options)(fetch, basePath);
        },
        getPreOrderPreview: function (storeId, deliveryType, preOrderConfig_leadTimeMinutes, preOrderConfig_intervalMinutes, preOrderConfig_maxOrderAheadDays, preOrderConfig_includeAsap, preOrderConfig_includeMoreGranularInitialTime, preOrderConfig_cutOffTimePreviousDayBasic, preOrderConfig_cutOffTimeCurrentDayBasic, preOrderConfig_preOrderTimeDisplayType, preOrderConfig_alwaysAppearOpen, preOrderConfig_requireExplicitSelectAlways, options) {
            return (0, exports.StoresApiFp)(configuration).getPreOrderPreview(storeId, deliveryType, preOrderConfig_leadTimeMinutes, preOrderConfig_intervalMinutes, preOrderConfig_maxOrderAheadDays, preOrderConfig_includeAsap, preOrderConfig_includeMoreGranularInitialTime, preOrderConfig_cutOffTimePreviousDayBasic, preOrderConfig_cutOffTimeCurrentDayBasic, preOrderConfig_preOrderTimeDisplayType, preOrderConfig_alwaysAppearOpen, preOrderConfig_requireExplicitSelectAlways, options)(fetch, basePath);
        },
        getProcessingFeeConfigsByStoreId: function (storeId, appNameId, options) {
            return (0, exports.StoresApiFp)(configuration).getProcessingFeeConfigsByStoreId(storeId, appNameId, options)(fetch, basePath);
        },
        getProcessingFeeConfigsByStoreIdAndPaymentAccountType: function (storeId, paymentAccountType, appNameId, options) {
            return (0, exports.StoresApiFp)(configuration).getProcessingFeeConfigsByStoreIdAndPaymentAccountType(storeId, paymentAccountType, appNameId, options)(fetch, basePath);
        },
        getStoreById: function (storeId, options) {
            return (0, exports.StoresApiFp)(configuration).getStoreById(storeId, options)(fetch, basePath);
        },
        getStoreDeliveryFeeConfig: function (storeId, options) {
            return (0, exports.StoresApiFp)(configuration).getStoreDeliveryFeeConfig(storeId, options)(fetch, basePath);
        },
        getStoreFeeConfig: function (storeId, options) {
            return (0, exports.StoresApiFp)(configuration).getStoreFeeConfig(storeId, options)(fetch, basePath);
        },
        getStoreHeadersByAppId: function (appId, storeNameQuery, salesChannelType, page, limit, options) {
            return (0, exports.StoresApiFp)(configuration).getStoreHeadersByAppId(appId, storeNameQuery, salesChannelType, page, limit, options)(fetch, basePath);
        },
        getStoreLeadTimes: function (storeId, options) {
            return (0, exports.StoresApiFp)(configuration).getStoreLeadTimes(storeId, options)(fetch, basePath);
        },
        getStoreNetSales: function (appId, storeId, options) {
            return (0, exports.StoresApiFp)(configuration).getStoreNetSales(appId, storeId, options)(fetch, basePath);
        },
        getStoreServiceCharge: function (storeId, options) {
            return (0, exports.StoresApiFp)(configuration).getStoreServiceCharge(storeId, options)(fetch, basePath);
        },
        getStores: function (searchQuery, page, limit, storeGroupId, options) {
            return (0, exports.StoresApiFp)(configuration).getStores(searchQuery, page, limit, storeGroupId, options)(fetch, basePath);
        },
        getStoresByAppId: function (appId, searchQuery, salesChannelType, excludeUnpublished, page, limit, options) {
            return (0, exports.StoresApiFp)(configuration).getStoresByAppId(appId, searchQuery, salesChannelType, excludeUnpublished, page, limit, options)(fetch, basePath);
        },
        getStoresByStoreIdWithValidations: function (storeId, appId, page, limit, options) {
            return (0, exports.StoresApiFp)(configuration).getStoresByStoreIdWithValidations(storeId, appId, page, limit, options)(fetch, basePath);
        },
        publishStore: function (storeId, options) {
            return (0, exports.StoresApiFp)(configuration).publishStore(storeId, options)(fetch, basePath);
        },
        putStoreDeliveryFeeConfig: function (storeId, StoreDeliveryZoneFeeConfigUpdateRequest, options) {
            return (0, exports.StoresApiFp)(configuration).putStoreDeliveryFeeConfig(storeId, StoreDeliveryZoneFeeConfigUpdateRequest, options)(fetch, basePath);
        },
        setBusinessHours: function (storeId, deliveryType, BusinessHoursPeriodBase, options) {
            return (0, exports.StoresApiFp)(configuration).setBusinessHours(storeId, deliveryType, BusinessHoursPeriodBase, options)(fetch, basePath);
        },
        setPreOrdeEnabled: function (storeId, deliveryType, enabled, options) {
            return (0, exports.StoresApiFp)(configuration).setPreOrdeEnabled(storeId, deliveryType, enabled, options)(fetch, basePath);
        },
        setStoreCollectionSettings: function (storeId, StoreCollectionSettings, inheritFromProperty, options) {
            return (0, exports.StoresApiFp)(configuration).setStoreCollectionSettings(storeId, StoreCollectionSettings, inheritFromProperty, options)(fetch, basePath);
        },
        setStoreLeadTimes: function (storeId, LeadTime, options) {
            return (0, exports.StoresApiFp)(configuration).setStoreLeadTimes(storeId, LeadTime, options)(fetch, basePath);
        },
        storesSetPropertyId: function (storeId, propertyId, options) {
            return (0, exports.StoresApiFp)(configuration).storesSetPropertyId(storeId, propertyId, options)(fetch, basePath);
        },
        supportedSalesChannelsTypes: function (propertyId, storeId, ERROR_UNKNOWN, options) {
            return (0, exports.StoresApiFp)(configuration).supportedSalesChannelsTypes(propertyId, storeId, ERROR_UNKNOWN, options)(fetch, basePath);
        },
        unpublishStore: function (storeId, options) {
            return (0, exports.StoresApiFp)(configuration).unpublishStore(storeId, options)(fetch, basePath);
        },
        updatePreOrderConfig: function (storeId, deliveryType, PreOrderConfig, options) {
            return (0, exports.StoresApiFp)(configuration).updatePreOrderConfig(storeId, deliveryType, PreOrderConfig, options)(fetch, basePath);
        },
        updateStore: function (storeId, StoreBase, options) {
            return (0, exports.StoresApiFp)(configuration).updateStore(storeId, StoreBase, options)(fetch, basePath);
        },
        updateStoreAddress: function (storeId, StoreAddressBase, options) {
            return (0, exports.StoresApiFp)(configuration).updateStoreAddress(storeId, StoreAddressBase, options)(fetch, basePath);
        },
        updateStoreAddressCoordinates: function (storeId, Coordinates, appNameId, options) {
            return (0, exports.StoresApiFp)(configuration).updateStoreAddressCoordinates(storeId, Coordinates, appNameId, options)(fetch, basePath);
        },
        updateStoreAddressForm: function (storeId, StoreAddressForm, options) {
            return (0, exports.StoresApiFp)(configuration).updateStoreAddressForm(storeId, StoreAddressForm, options)(fetch, basePath);
        },
    };
};
exports.StoresApiFactory = StoresApiFactory;
var StoresApi = (function (_super) {
    __extends(StoresApi, _super);
    function StoresApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    StoresApi.prototype.archiveStore = function (storeId, options) {
        return (0, exports.StoresApiFp)(this.configuration).archiveStore(storeId, options)(this.fetch, this.basePath);
    };
    StoresApi.prototype.assignMenu = function (storeId, menuId, options) {
        return (0, exports.StoresApiFp)(this.configuration).assignMenu(storeId, menuId, options)(this.fetch, this.basePath);
    };
    StoresApi.prototype.cloneStore = function (storeId, StoreCloneSettings, options) {
        return (0, exports.StoresApiFp)(this.configuration).cloneStore(storeId, StoreCloneSettings, options)(this.fetch, this.basePath);
    };
    StoresApi.prototype.configureStoreServiceCharge = function (storeId, ServiceCharge, options) {
        return (0, exports.StoresApiFp)(this.configuration).configureStoreServiceCharge(storeId, ServiceCharge, options)(this.fetch, this.basePath);
    };
    StoresApi.prototype.createBusinessHoursOverrideByStoreId = function (storeId, BusinessHoursOverrideBase, options) {
        return (0, exports.StoresApiFp)(this.configuration).createBusinessHoursOverrideByStoreId(storeId, BusinessHoursOverrideBase, options)(this.fetch, this.basePath);
    };
    StoresApi.prototype.createStore = function (storeGroupId, StoreCreateBase, options) {
        return (0, exports.StoresApiFp)(this.configuration).createStore(storeGroupId, StoreCreateBase, options)(this.fetch, this.basePath);
    };
    StoresApi.prototype.createStoreInProperty = function (storeGroupId, propertyId, StoreCreateBase, autoAssignMenu, options) {
        return (0, exports.StoresApiFp)(this.configuration).createStoreInProperty(storeGroupId, propertyId, StoreCreateBase, autoAssignMenu, options)(this.fetch, this.basePath);
    };
    StoresApi.prototype.deleteBusinessHoursOverride = function (storeId, businessHoursOverrideId, options) {
        return (0, exports.StoresApiFp)(this.configuration).deleteBusinessHoursOverride(storeId, businessHoursOverrideId, options)(this.fetch, this.basePath);
    };
    StoresApi.prototype.getBankAccountForStore = function (storeId, options) {
        return (0, exports.StoresApiFp)(this.configuration).getBankAccountForStore(storeId, options)(this.fetch, this.basePath);
    };
    StoresApi.prototype.getBusinessHours = function (storeId, deliveryType, options) {
        return (0, exports.StoresApiFp)(this.configuration).getBusinessHours(storeId, deliveryType, options)(this.fetch, this.basePath);
    };
    StoresApi.prototype.getBusinessHoursOverrideByStoreId = function (storeId, after, page, limit, options) {
        return (0, exports.StoresApiFp)(this.configuration).getBusinessHoursOverrideByStoreId(storeId, after, page, limit, options)(this.fetch, this.basePath);
    };
    StoresApi.prototype.getEndOfDayReport = function (storeId, date, options) {
        return (0, exports.StoresApiFp)(this.configuration).getEndOfDayReport(storeId, date, options)(this.fetch, this.basePath);
    };
    StoresApi.prototype.getPreOrderConfig = function (storeId, deliveryType, options) {
        return (0, exports.StoresApiFp)(this.configuration).getPreOrderConfig(storeId, deliveryType, options)(this.fetch, this.basePath);
    };
    StoresApi.prototype.getPreOrderPreview = function (storeId, deliveryType, preOrderConfig_leadTimeMinutes, preOrderConfig_intervalMinutes, preOrderConfig_maxOrderAheadDays, preOrderConfig_includeAsap, preOrderConfig_includeMoreGranularInitialTime, preOrderConfig_cutOffTimePreviousDayBasic, preOrderConfig_cutOffTimeCurrentDayBasic, preOrderConfig_preOrderTimeDisplayType, preOrderConfig_alwaysAppearOpen, preOrderConfig_requireExplicitSelectAlways, options) {
        return (0, exports.StoresApiFp)(this.configuration).getPreOrderPreview(storeId, deliveryType, preOrderConfig_leadTimeMinutes, preOrderConfig_intervalMinutes, preOrderConfig_maxOrderAheadDays, preOrderConfig_includeAsap, preOrderConfig_includeMoreGranularInitialTime, preOrderConfig_cutOffTimePreviousDayBasic, preOrderConfig_cutOffTimeCurrentDayBasic, preOrderConfig_preOrderTimeDisplayType, preOrderConfig_alwaysAppearOpen, preOrderConfig_requireExplicitSelectAlways, options)(this.fetch, this.basePath);
    };
    StoresApi.prototype.getProcessingFeeConfigsByStoreId = function (storeId, appNameId, options) {
        return (0, exports.StoresApiFp)(this.configuration).getProcessingFeeConfigsByStoreId(storeId, appNameId, options)(this.fetch, this.basePath);
    };
    StoresApi.prototype.getProcessingFeeConfigsByStoreIdAndPaymentAccountType = function (storeId, paymentAccountType, appNameId, options) {
        return (0, exports.StoresApiFp)(this.configuration).getProcessingFeeConfigsByStoreIdAndPaymentAccountType(storeId, paymentAccountType, appNameId, options)(this.fetch, this.basePath);
    };
    StoresApi.prototype.getStoreById = function (storeId, options) {
        return (0, exports.StoresApiFp)(this.configuration).getStoreById(storeId, options)(this.fetch, this.basePath);
    };
    StoresApi.prototype.getStoreDeliveryFeeConfig = function (storeId, options) {
        return (0, exports.StoresApiFp)(this.configuration).getStoreDeliveryFeeConfig(storeId, options)(this.fetch, this.basePath);
    };
    StoresApi.prototype.getStoreFeeConfig = function (storeId, options) {
        return (0, exports.StoresApiFp)(this.configuration).getStoreFeeConfig(storeId, options)(this.fetch, this.basePath);
    };
    StoresApi.prototype.getStoreHeadersByAppId = function (appId, storeNameQuery, salesChannelType, page, limit, options) {
        return (0, exports.StoresApiFp)(this.configuration).getStoreHeadersByAppId(appId, storeNameQuery, salesChannelType, page, limit, options)(this.fetch, this.basePath);
    };
    StoresApi.prototype.getStoreLeadTimes = function (storeId, options) {
        return (0, exports.StoresApiFp)(this.configuration).getStoreLeadTimes(storeId, options)(this.fetch, this.basePath);
    };
    StoresApi.prototype.getStoreNetSales = function (appId, storeId, options) {
        return (0, exports.StoresApiFp)(this.configuration).getStoreNetSales(appId, storeId, options)(this.fetch, this.basePath);
    };
    StoresApi.prototype.getStoreServiceCharge = function (storeId, options) {
        return (0, exports.StoresApiFp)(this.configuration).getStoreServiceCharge(storeId, options)(this.fetch, this.basePath);
    };
    StoresApi.prototype.getStores = function (searchQuery, page, limit, storeGroupId, options) {
        return (0, exports.StoresApiFp)(this.configuration).getStores(searchQuery, page, limit, storeGroupId, options)(this.fetch, this.basePath);
    };
    StoresApi.prototype.getStoresByAppId = function (appId, searchQuery, salesChannelType, excludeUnpublished, page, limit, options) {
        return (0, exports.StoresApiFp)(this.configuration).getStoresByAppId(appId, searchQuery, salesChannelType, excludeUnpublished, page, limit, options)(this.fetch, this.basePath);
    };
    StoresApi.prototype.getStoresByStoreIdWithValidations = function (storeId, appId, page, limit, options) {
        return (0, exports.StoresApiFp)(this.configuration).getStoresByStoreIdWithValidations(storeId, appId, page, limit, options)(this.fetch, this.basePath);
    };
    StoresApi.prototype.publishStore = function (storeId, options) {
        return (0, exports.StoresApiFp)(this.configuration).publishStore(storeId, options)(this.fetch, this.basePath);
    };
    StoresApi.prototype.putStoreDeliveryFeeConfig = function (storeId, StoreDeliveryZoneFeeConfigUpdateRequest, options) {
        return (0, exports.StoresApiFp)(this.configuration).putStoreDeliveryFeeConfig(storeId, StoreDeliveryZoneFeeConfigUpdateRequest, options)(this.fetch, this.basePath);
    };
    StoresApi.prototype.setBusinessHours = function (storeId, deliveryType, BusinessHoursPeriodBase, options) {
        return (0, exports.StoresApiFp)(this.configuration).setBusinessHours(storeId, deliveryType, BusinessHoursPeriodBase, options)(this.fetch, this.basePath);
    };
    StoresApi.prototype.setPreOrdeEnabled = function (storeId, deliveryType, enabled, options) {
        return (0, exports.StoresApiFp)(this.configuration).setPreOrdeEnabled(storeId, deliveryType, enabled, options)(this.fetch, this.basePath);
    };
    StoresApi.prototype.setStoreCollectionSettings = function (storeId, StoreCollectionSettings, inheritFromProperty, options) {
        return (0, exports.StoresApiFp)(this.configuration).setStoreCollectionSettings(storeId, StoreCollectionSettings, inheritFromProperty, options)(this.fetch, this.basePath);
    };
    StoresApi.prototype.setStoreLeadTimes = function (storeId, LeadTime, options) {
        return (0, exports.StoresApiFp)(this.configuration).setStoreLeadTimes(storeId, LeadTime, options)(this.fetch, this.basePath);
    };
    StoresApi.prototype.storesSetPropertyId = function (storeId, propertyId, options) {
        return (0, exports.StoresApiFp)(this.configuration).storesSetPropertyId(storeId, propertyId, options)(this.fetch, this.basePath);
    };
    StoresApi.prototype.supportedSalesChannelsTypes = function (propertyId, storeId, ERROR_UNKNOWN, options) {
        return (0, exports.StoresApiFp)(this.configuration).supportedSalesChannelsTypes(propertyId, storeId, ERROR_UNKNOWN, options)(this.fetch, this.basePath);
    };
    StoresApi.prototype.unpublishStore = function (storeId, options) {
        return (0, exports.StoresApiFp)(this.configuration).unpublishStore(storeId, options)(this.fetch, this.basePath);
    };
    StoresApi.prototype.updatePreOrderConfig = function (storeId, deliveryType, PreOrderConfig, options) {
        return (0, exports.StoresApiFp)(this.configuration).updatePreOrderConfig(storeId, deliveryType, PreOrderConfig, options)(this.fetch, this.basePath);
    };
    StoresApi.prototype.updateStore = function (storeId, StoreBase, options) {
        return (0, exports.StoresApiFp)(this.configuration).updateStore(storeId, StoreBase, options)(this.fetch, this.basePath);
    };
    StoresApi.prototype.updateStoreAddress = function (storeId, StoreAddressBase, options) {
        return (0, exports.StoresApiFp)(this.configuration).updateStoreAddress(storeId, StoreAddressBase, options)(this.fetch, this.basePath);
    };
    StoresApi.prototype.updateStoreAddressCoordinates = function (storeId, Coordinates, appNameId, options) {
        return (0, exports.StoresApiFp)(this.configuration).updateStoreAddressCoordinates(storeId, Coordinates, appNameId, options)(this.fetch, this.basePath);
    };
    StoresApi.prototype.updateStoreAddressForm = function (storeId, StoreAddressForm, options) {
        return (0, exports.StoresApiFp)(this.configuration).updateStoreAddressForm(storeId, StoreAddressForm, options)(this.fetch, this.basePath);
    };
    return StoresApi;
}(BaseAPI));
exports.StoresApi = StoresApi;
var StripeCustomConnectApiFetchParamCreator = function (configuration) {
    return {
        createBankAccountAndConnectedAccount: function (appId, BankAccountCreate, options) {
            if (options === void 0) { options = {}; }
            if (appId === null || appId === undefined) {
                throw new RequiredError('appId', 'Required parameter appId was null or undefined when calling createBankAccountAndConnectedAccount.');
            }
            if (BankAccountCreate === null || BankAccountCreate === undefined) {
                throw new RequiredError('BankAccountCreate', 'Required parameter BankAccountCreate was null or undefined when calling createBankAccountAndConnectedAccount.');
            }
            var localVarPath = "/api/v1.0/{appId}/customconnect/bank-account"
                .replace("{".concat("appId", "}"), encodeURIComponent(String(appId)));
            var localVarUrlObj = url.parse(localVarPath, true);
            var localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            var localVarHeaderParameter = {};
            var localVarQueryParameter = {};
            if (configuration && configuration.accessToken) {
                var localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("oauth2", ["api"])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }
            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            var needsSerialization = ("BankAccountCreate" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body = needsSerialization ? JSON.stringify(BankAccountCreate || {}) : (BankAccountCreate || "");
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        createStripeConnectedAccount: function (appId, bankAccountId, options) {
            if (options === void 0) { options = {}; }
            if (appId === null || appId === undefined) {
                throw new RequiredError('appId', 'Required parameter appId was null or undefined when calling createStripeConnectedAccount.');
            }
            if (bankAccountId === null || bankAccountId === undefined) {
                throw new RequiredError('bankAccountId', 'Required parameter bankAccountId was null or undefined when calling createStripeConnectedAccount.');
            }
            var localVarPath = "/api/v1.0/{appId}/customconnect/{bankAccountId}/create-update-account"
                .replace("{".concat("appId", "}"), encodeURIComponent(String(appId)))
                .replace("{".concat("bankAccountId", "}"), encodeURIComponent(String(bankAccountId)));
            var localVarUrlObj = url.parse(localVarPath, true);
            var localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            var localVarHeaderParameter = {};
            var localVarQueryParameter = {};
            if (configuration && configuration.accessToken) {
                var localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("oauth2", ["api"])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        createStripeConnectedAccountLink: function (appId, stripeConnectedAccountId, StripeAccountLinkRequest, options) {
            if (options === void 0) { options = {}; }
            if (appId === null || appId === undefined) {
                throw new RequiredError('appId', 'Required parameter appId was null or undefined when calling createStripeConnectedAccountLink.');
            }
            if (stripeConnectedAccountId === null || stripeConnectedAccountId === undefined) {
                throw new RequiredError('stripeConnectedAccountId', 'Required parameter stripeConnectedAccountId was null or undefined when calling createStripeConnectedAccountLink.');
            }
            if (StripeAccountLinkRequest === null || StripeAccountLinkRequest === undefined) {
                throw new RequiredError('StripeAccountLinkRequest', 'Required parameter StripeAccountLinkRequest was null or undefined when calling createStripeConnectedAccountLink.');
            }
            var localVarPath = "/api/v1.0/{appId}/customconnect/{stripeConnectedAccountId}/create-account-link"
                .replace("{".concat("appId", "}"), encodeURIComponent(String(appId)))
                .replace("{".concat("stripeConnectedAccountId", "}"), encodeURIComponent(String(stripeConnectedAccountId)));
            var localVarUrlObj = url.parse(localVarPath, true);
            var localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            var localVarHeaderParameter = {};
            var localVarQueryParameter = {};
            if (configuration && configuration.accessToken) {
                var localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("oauth2", ["api"])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }
            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            var needsSerialization = ("StripeAccountLinkRequest" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body = needsSerialization ? JSON.stringify(StripeAccountLinkRequest || {}) : (StripeAccountLinkRequest || "");
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        getCustomConnect: function (storeId, appId, options) {
            if (options === void 0) { options = {}; }
            if (storeId === null || storeId === undefined) {
                throw new RequiredError('storeId', 'Required parameter storeId was null or undefined when calling getCustomConnect.');
            }
            if (appId === null || appId === undefined) {
                throw new RequiredError('appId', 'Required parameter appId was null or undefined when calling getCustomConnect.');
            }
            var localVarPath = "/api/v1.0/{appId}/customconnect/{storeId}"
                .replace("{".concat("storeId", "}"), encodeURIComponent(String(storeId)))
                .replace("{".concat("appId", "}"), encodeURIComponent(String(appId)));
            var localVarUrlObj = url.parse(localVarPath, true);
            var localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            var localVarHeaderParameter = {};
            var localVarQueryParameter = {};
            if (configuration && configuration.accessToken) {
                var localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("oauth2", ["api"])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        setBankAccountBusinessType: function (appId, bankAccountId, body, options) {
            if (options === void 0) { options = {}; }
            if (appId === null || appId === undefined) {
                throw new RequiredError('appId', 'Required parameter appId was null or undefined when calling setBankAccountBusinessType.');
            }
            if (bankAccountId === null || bankAccountId === undefined) {
                throw new RequiredError('bankAccountId', 'Required parameter bankAccountId was null or undefined when calling setBankAccountBusinessType.');
            }
            if (body === null || body === undefined) {
                throw new RequiredError('body', 'Required parameter body was null or undefined when calling setBankAccountBusinessType.');
            }
            var localVarPath = "/api/v1.0/{appId}/customconnect/bank-account/{bankAccountId}/businesstype"
                .replace("{".concat("appId", "}"), encodeURIComponent(String(appId)))
                .replace("{".concat("bankAccountId", "}"), encodeURIComponent(String(bankAccountId)));
            var localVarUrlObj = url.parse(localVarPath, true);
            var localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            var localVarHeaderParameter = {};
            var localVarQueryParameter = {};
            if (configuration && configuration.accessToken) {
                var localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("oauth2", ["api"])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }
            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            var needsSerialization = ("string" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body = needsSerialization ? JSON.stringify(body || {}) : (body || "");
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        stripeCustomConnectRefresh: function (linkRequestId, appId, options) {
            if (options === void 0) { options = {}; }
            if (linkRequestId === null || linkRequestId === undefined) {
                throw new RequiredError('linkRequestId', 'Required parameter linkRequestId was null or undefined when calling stripeCustomConnectRefresh.');
            }
            if (appId === null || appId === undefined) {
                throw new RequiredError('appId', 'Required parameter appId was null or undefined when calling stripeCustomConnectRefresh.');
            }
            var localVarPath = "/api/v1.0/{appId}/customconnect/refresh-link"
                .replace("{".concat("appId", "}"), encodeURIComponent(String(appId)));
            var localVarUrlObj = url.parse(localVarPath, true);
            var localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            var localVarHeaderParameter = {};
            var localVarQueryParameter = {};
            if (configuration && configuration.accessToken) {
                var localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("oauth2", ["api"])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }
            if (linkRequestId !== undefined) {
                localVarQueryParameter['linkRequestId'] = linkRequestId;
            }
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        updateBankAccountDetails: function (appId, bankAccountId, BankAccountDetailsUpdateRequest, options) {
            if (options === void 0) { options = {}; }
            if (appId === null || appId === undefined) {
                throw new RequiredError('appId', 'Required parameter appId was null or undefined when calling updateBankAccountDetails.');
            }
            if (bankAccountId === null || bankAccountId === undefined) {
                throw new RequiredError('bankAccountId', 'Required parameter bankAccountId was null or undefined when calling updateBankAccountDetails.');
            }
            if (BankAccountDetailsUpdateRequest === null || BankAccountDetailsUpdateRequest === undefined) {
                throw new RequiredError('BankAccountDetailsUpdateRequest', 'Required parameter BankAccountDetailsUpdateRequest was null or undefined when calling updateBankAccountDetails.');
            }
            var localVarPath = "/api/v1.0/{appId}/customconnect/{bankAccountId}/update-bank-account-details"
                .replace("{".concat("appId", "}"), encodeURIComponent(String(appId)))
                .replace("{".concat("bankAccountId", "}"), encodeURIComponent(String(bankAccountId)));
            var localVarUrlObj = url.parse(localVarPath, true);
            var localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            var localVarHeaderParameter = {};
            var localVarQueryParameter = {};
            if (configuration && configuration.accessToken) {
                var localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("oauth2", ["api"])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }
            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            var needsSerialization = ("BankAccountDetailsUpdateRequest" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body = needsSerialization ? JSON.stringify(BankAccountDetailsUpdateRequest || {}) : (BankAccountDetailsUpdateRequest || "");
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        updatePayoutSchedule: function (appId, stripeConnectedAccountId, interval, options) {
            if (options === void 0) { options = {}; }
            if (appId === null || appId === undefined) {
                throw new RequiredError('appId', 'Required parameter appId was null or undefined when calling updatePayoutSchedule.');
            }
            if (stripeConnectedAccountId === null || stripeConnectedAccountId === undefined) {
                throw new RequiredError('stripeConnectedAccountId', 'Required parameter stripeConnectedAccountId was null or undefined when calling updatePayoutSchedule.');
            }
            if (interval === null || interval === undefined) {
                throw new RequiredError('interval', 'Required parameter interval was null or undefined when calling updatePayoutSchedule.');
            }
            var localVarPath = "/api/v1.0/{appId}/customconnect/update-payout-schedule/{stripeConnectedAccountId}/{interval}"
                .replace("{".concat("appId", "}"), encodeURIComponent(String(appId)))
                .replace("{".concat("stripeConnectedAccountId", "}"), encodeURIComponent(String(stripeConnectedAccountId)))
                .replace("{".concat("interval", "}"), encodeURIComponent(String(interval)));
            var localVarUrlObj = url.parse(localVarPath, true);
            var localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            var localVarHeaderParameter = {};
            var localVarQueryParameter = {};
            if (configuration && configuration.accessToken) {
                var localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("oauth2", ["api"])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    };
};
exports.StripeCustomConnectApiFetchParamCreator = StripeCustomConnectApiFetchParamCreator;
var StripeCustomConnectApiFp = function (configuration) {
    return {
        createBankAccountAndConnectedAccount: function (appId, BankAccountCreate, options) {
            var localVarFetchArgs = (0, exports.StripeCustomConnectApiFetchParamCreator)(configuration).createBankAccountAndConnectedAccount(appId, BankAccountCreate, options);
            return function (fetch, basePath) {
                if (fetch === void 0) { fetch = portableFetch; }
                if (basePath === void 0) { basePath = BASE_PATH; }
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then(function (response) {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
        createStripeConnectedAccount: function (appId, bankAccountId, options) {
            var localVarFetchArgs = (0, exports.StripeCustomConnectApiFetchParamCreator)(configuration).createStripeConnectedAccount(appId, bankAccountId, options);
            return function (fetch, basePath) {
                if (fetch === void 0) { fetch = portableFetch; }
                if (basePath === void 0) { basePath = BASE_PATH; }
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then(function (response) {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
        createStripeConnectedAccountLink: function (appId, stripeConnectedAccountId, StripeAccountLinkRequest, options) {
            var localVarFetchArgs = (0, exports.StripeCustomConnectApiFetchParamCreator)(configuration).createStripeConnectedAccountLink(appId, stripeConnectedAccountId, StripeAccountLinkRequest, options);
            return function (fetch, basePath) {
                if (fetch === void 0) { fetch = portableFetch; }
                if (basePath === void 0) { basePath = BASE_PATH; }
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then(function (response) {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
        getCustomConnect: function (storeId, appId, options) {
            var localVarFetchArgs = (0, exports.StripeCustomConnectApiFetchParamCreator)(configuration).getCustomConnect(storeId, appId, options);
            return function (fetch, basePath) {
                if (fetch === void 0) { fetch = portableFetch; }
                if (basePath === void 0) { basePath = BASE_PATH; }
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then(function (response) {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
        setBankAccountBusinessType: function (appId, bankAccountId, body, options) {
            var localVarFetchArgs = (0, exports.StripeCustomConnectApiFetchParamCreator)(configuration).setBankAccountBusinessType(appId, bankAccountId, body, options);
            return function (fetch, basePath) {
                if (fetch === void 0) { fetch = portableFetch; }
                if (basePath === void 0) { basePath = BASE_PATH; }
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then(function (response) {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
        stripeCustomConnectRefresh: function (linkRequestId, appId, options) {
            var localVarFetchArgs = (0, exports.StripeCustomConnectApiFetchParamCreator)(configuration).stripeCustomConnectRefresh(linkRequestId, appId, options);
            return function (fetch, basePath) {
                if (fetch === void 0) { fetch = portableFetch; }
                if (basePath === void 0) { basePath = BASE_PATH; }
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then(function (response) {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
        updateBankAccountDetails: function (appId, bankAccountId, BankAccountDetailsUpdateRequest, options) {
            var localVarFetchArgs = (0, exports.StripeCustomConnectApiFetchParamCreator)(configuration).updateBankAccountDetails(appId, bankAccountId, BankAccountDetailsUpdateRequest, options);
            return function (fetch, basePath) {
                if (fetch === void 0) { fetch = portableFetch; }
                if (basePath === void 0) { basePath = BASE_PATH; }
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then(function (response) {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
        updatePayoutSchedule: function (appId, stripeConnectedAccountId, interval, options) {
            var localVarFetchArgs = (0, exports.StripeCustomConnectApiFetchParamCreator)(configuration).updatePayoutSchedule(appId, stripeConnectedAccountId, interval, options);
            return function (fetch, basePath) {
                if (fetch === void 0) { fetch = portableFetch; }
                if (basePath === void 0) { basePath = BASE_PATH; }
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then(function (response) {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
    };
};
exports.StripeCustomConnectApiFp = StripeCustomConnectApiFp;
var StripeCustomConnectApiFactory = function (configuration, fetch, basePath) {
    return {
        createBankAccountAndConnectedAccount: function (appId, BankAccountCreate, options) {
            return (0, exports.StripeCustomConnectApiFp)(configuration).createBankAccountAndConnectedAccount(appId, BankAccountCreate, options)(fetch, basePath);
        },
        createStripeConnectedAccount: function (appId, bankAccountId, options) {
            return (0, exports.StripeCustomConnectApiFp)(configuration).createStripeConnectedAccount(appId, bankAccountId, options)(fetch, basePath);
        },
        createStripeConnectedAccountLink: function (appId, stripeConnectedAccountId, StripeAccountLinkRequest, options) {
            return (0, exports.StripeCustomConnectApiFp)(configuration).createStripeConnectedAccountLink(appId, stripeConnectedAccountId, StripeAccountLinkRequest, options)(fetch, basePath);
        },
        getCustomConnect: function (storeId, appId, options) {
            return (0, exports.StripeCustomConnectApiFp)(configuration).getCustomConnect(storeId, appId, options)(fetch, basePath);
        },
        setBankAccountBusinessType: function (appId, bankAccountId, body, options) {
            return (0, exports.StripeCustomConnectApiFp)(configuration).setBankAccountBusinessType(appId, bankAccountId, body, options)(fetch, basePath);
        },
        stripeCustomConnectRefresh: function (linkRequestId, appId, options) {
            return (0, exports.StripeCustomConnectApiFp)(configuration).stripeCustomConnectRefresh(linkRequestId, appId, options)(fetch, basePath);
        },
        updateBankAccountDetails: function (appId, bankAccountId, BankAccountDetailsUpdateRequest, options) {
            return (0, exports.StripeCustomConnectApiFp)(configuration).updateBankAccountDetails(appId, bankAccountId, BankAccountDetailsUpdateRequest, options)(fetch, basePath);
        },
        updatePayoutSchedule: function (appId, stripeConnectedAccountId, interval, options) {
            return (0, exports.StripeCustomConnectApiFp)(configuration).updatePayoutSchedule(appId, stripeConnectedAccountId, interval, options)(fetch, basePath);
        },
    };
};
exports.StripeCustomConnectApiFactory = StripeCustomConnectApiFactory;
var StripeCustomConnectApi = (function (_super) {
    __extends(StripeCustomConnectApi, _super);
    function StripeCustomConnectApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    StripeCustomConnectApi.prototype.createBankAccountAndConnectedAccount = function (appId, BankAccountCreate, options) {
        return (0, exports.StripeCustomConnectApiFp)(this.configuration).createBankAccountAndConnectedAccount(appId, BankAccountCreate, options)(this.fetch, this.basePath);
    };
    StripeCustomConnectApi.prototype.createStripeConnectedAccount = function (appId, bankAccountId, options) {
        return (0, exports.StripeCustomConnectApiFp)(this.configuration).createStripeConnectedAccount(appId, bankAccountId, options)(this.fetch, this.basePath);
    };
    StripeCustomConnectApi.prototype.createStripeConnectedAccountLink = function (appId, stripeConnectedAccountId, StripeAccountLinkRequest, options) {
        return (0, exports.StripeCustomConnectApiFp)(this.configuration).createStripeConnectedAccountLink(appId, stripeConnectedAccountId, StripeAccountLinkRequest, options)(this.fetch, this.basePath);
    };
    StripeCustomConnectApi.prototype.getCustomConnect = function (storeId, appId, options) {
        return (0, exports.StripeCustomConnectApiFp)(this.configuration).getCustomConnect(storeId, appId, options)(this.fetch, this.basePath);
    };
    StripeCustomConnectApi.prototype.setBankAccountBusinessType = function (appId, bankAccountId, body, options) {
        return (0, exports.StripeCustomConnectApiFp)(this.configuration).setBankAccountBusinessType(appId, bankAccountId, body, options)(this.fetch, this.basePath);
    };
    StripeCustomConnectApi.prototype.stripeCustomConnectRefresh = function (linkRequestId, appId, options) {
        return (0, exports.StripeCustomConnectApiFp)(this.configuration).stripeCustomConnectRefresh(linkRequestId, appId, options)(this.fetch, this.basePath);
    };
    StripeCustomConnectApi.prototype.updateBankAccountDetails = function (appId, bankAccountId, BankAccountDetailsUpdateRequest, options) {
        return (0, exports.StripeCustomConnectApiFp)(this.configuration).updateBankAccountDetails(appId, bankAccountId, BankAccountDetailsUpdateRequest, options)(this.fetch, this.basePath);
    };
    StripeCustomConnectApi.prototype.updatePayoutSchedule = function (appId, stripeConnectedAccountId, interval, options) {
        return (0, exports.StripeCustomConnectApiFp)(this.configuration).updatePayoutSchedule(appId, stripeConnectedAccountId, interval, options)(this.fetch, this.basePath);
    };
    return StripeCustomConnectApi;
}(BaseAPI));
exports.StripeCustomConnectApi = StripeCustomConnectApi;
var StuartApiFetchParamCreator = function (configuration) {
    return {
        stuartCancelJob: function (jobId, storeId, options) {
            if (options === void 0) { options = {}; }
            if (jobId === null || jobId === undefined) {
                throw new RequiredError('jobId', 'Required parameter jobId was null or undefined when calling stuartCancelJob.');
            }
            if (storeId === null || storeId === undefined) {
                throw new RequiredError('storeId', 'Required parameter storeId was null or undefined when calling stuartCancelJob.');
            }
            var localVarPath = "/api/v1.0/stuart/jobs/{jobId}"
                .replace("{".concat("jobId", "}"), encodeURIComponent(String(jobId)));
            var localVarUrlObj = url.parse(localVarPath, true);
            var localVarRequestOptions = Object.assign({ method: 'DELETE' }, options);
            var localVarHeaderParameter = {};
            var localVarQueryParameter = {};
            if (configuration && configuration.accessToken) {
                var localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("oauth2", ["api"])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }
            if (storeId !== undefined) {
                localVarQueryParameter['storeId'] = storeId;
            }
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        stuartGetJob: function (jobId, storeId, options) {
            if (options === void 0) { options = {}; }
            if (jobId === null || jobId === undefined) {
                throw new RequiredError('jobId', 'Required parameter jobId was null or undefined when calling stuartGetJob.');
            }
            if (storeId === null || storeId === undefined) {
                throw new RequiredError('storeId', 'Required parameter storeId was null or undefined when calling stuartGetJob.');
            }
            var localVarPath = "/api/v1.0/stuart/jobs/{jobId}"
                .replace("{".concat("jobId", "}"), encodeURIComponent(String(jobId)));
            var localVarUrlObj = url.parse(localVarPath, true);
            var localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            var localVarHeaderParameter = {};
            var localVarQueryParameter = {};
            if (configuration && configuration.accessToken) {
                var localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("oauth2", ["api"])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }
            if (storeId !== undefined) {
                localVarQueryParameter['storeId'] = storeId;
            }
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        stuartGetStuartSettings: function (storeId, options) {
            if (options === void 0) { options = {}; }
            if (storeId === null || storeId === undefined) {
                throw new RequiredError('storeId', 'Required parameter storeId was null or undefined when calling stuartGetStuartSettings.');
            }
            var localVarPath = "/api/v1.0/stuart/settings/{storeId}"
                .replace("{".concat("storeId", "}"), encodeURIComponent(String(storeId)));
            var localVarUrlObj = url.parse(localVarPath, true);
            var localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            var localVarHeaderParameter = {};
            var localVarQueryParameter = {};
            if (configuration && configuration.accessToken) {
                var localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("oauth2", ["api"])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        stuartPostStuartSettings: function (storeId, StuartSettings, options) {
            if (options === void 0) { options = {}; }
            if (storeId === null || storeId === undefined) {
                throw new RequiredError('storeId', 'Required parameter storeId was null or undefined when calling stuartPostStuartSettings.');
            }
            if (StuartSettings === null || StuartSettings === undefined) {
                throw new RequiredError('StuartSettings', 'Required parameter StuartSettings was null or undefined when calling stuartPostStuartSettings.');
            }
            var localVarPath = "/api/v1.0/stuart/settings/{storeId}"
                .replace("{".concat("storeId", "}"), encodeURIComponent(String(storeId)));
            var localVarUrlObj = url.parse(localVarPath, true);
            var localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            var localVarHeaderParameter = {};
            var localVarQueryParameter = {};
            if (configuration && configuration.accessToken) {
                var localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("oauth2", ["api"])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }
            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            var needsSerialization = ("StuartSettings" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body = needsSerialization ? JSON.stringify(StuartSettings || {}) : (StuartSettings || "");
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    };
};
exports.StuartApiFetchParamCreator = StuartApiFetchParamCreator;
var StuartApiFp = function (configuration) {
    return {
        stuartCancelJob: function (jobId, storeId, options) {
            var localVarFetchArgs = (0, exports.StuartApiFetchParamCreator)(configuration).stuartCancelJob(jobId, storeId, options);
            return function (fetch, basePath) {
                if (fetch === void 0) { fetch = portableFetch; }
                if (basePath === void 0) { basePath = BASE_PATH; }
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then(function (response) {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
        stuartGetJob: function (jobId, storeId, options) {
            var localVarFetchArgs = (0, exports.StuartApiFetchParamCreator)(configuration).stuartGetJob(jobId, storeId, options);
            return function (fetch, basePath) {
                if (fetch === void 0) { fetch = portableFetch; }
                if (basePath === void 0) { basePath = BASE_PATH; }
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then(function (response) {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
        stuartGetStuartSettings: function (storeId, options) {
            var localVarFetchArgs = (0, exports.StuartApiFetchParamCreator)(configuration).stuartGetStuartSettings(storeId, options);
            return function (fetch, basePath) {
                if (fetch === void 0) { fetch = portableFetch; }
                if (basePath === void 0) { basePath = BASE_PATH; }
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then(function (response) {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
        stuartPostStuartSettings: function (storeId, StuartSettings, options) {
            var localVarFetchArgs = (0, exports.StuartApiFetchParamCreator)(configuration).stuartPostStuartSettings(storeId, StuartSettings, options);
            return function (fetch, basePath) {
                if (fetch === void 0) { fetch = portableFetch; }
                if (basePath === void 0) { basePath = BASE_PATH; }
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then(function (response) {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
    };
};
exports.StuartApiFp = StuartApiFp;
var StuartApiFactory = function (configuration, fetch, basePath) {
    return {
        stuartCancelJob: function (jobId, storeId, options) {
            return (0, exports.StuartApiFp)(configuration).stuartCancelJob(jobId, storeId, options)(fetch, basePath);
        },
        stuartGetJob: function (jobId, storeId, options) {
            return (0, exports.StuartApiFp)(configuration).stuartGetJob(jobId, storeId, options)(fetch, basePath);
        },
        stuartGetStuartSettings: function (storeId, options) {
            return (0, exports.StuartApiFp)(configuration).stuartGetStuartSettings(storeId, options)(fetch, basePath);
        },
        stuartPostStuartSettings: function (storeId, StuartSettings, options) {
            return (0, exports.StuartApiFp)(configuration).stuartPostStuartSettings(storeId, StuartSettings, options)(fetch, basePath);
        },
    };
};
exports.StuartApiFactory = StuartApiFactory;
var StuartApi = (function (_super) {
    __extends(StuartApi, _super);
    function StuartApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    StuartApi.prototype.stuartCancelJob = function (jobId, storeId, options) {
        return (0, exports.StuartApiFp)(this.configuration).stuartCancelJob(jobId, storeId, options)(this.fetch, this.basePath);
    };
    StuartApi.prototype.stuartGetJob = function (jobId, storeId, options) {
        return (0, exports.StuartApiFp)(this.configuration).stuartGetJob(jobId, storeId, options)(this.fetch, this.basePath);
    };
    StuartApi.prototype.stuartGetStuartSettings = function (storeId, options) {
        return (0, exports.StuartApiFp)(this.configuration).stuartGetStuartSettings(storeId, options)(this.fetch, this.basePath);
    };
    StuartApi.prototype.stuartPostStuartSettings = function (storeId, StuartSettings, options) {
        return (0, exports.StuartApiFp)(this.configuration).stuartPostStuartSettings(storeId, StuartSettings, options)(this.fetch, this.basePath);
    };
    return StuartApi;
}(BaseAPI));
exports.StuartApi = StuartApi;
var SubscriptionsApiFetchParamCreator = function (configuration) {
    return {
        getSubscriptionById: function (appId, subscriptionId, options) {
            if (options === void 0) { options = {}; }
            if (appId === null || appId === undefined) {
                throw new RequiredError('appId', 'Required parameter appId was null or undefined when calling getSubscriptionById.');
            }
            if (subscriptionId === null || subscriptionId === undefined) {
                throw new RequiredError('subscriptionId', 'Required parameter subscriptionId was null or undefined when calling getSubscriptionById.');
            }
            var localVarPath = "/api/v1.0/{appId}/subscriptions/{subscriptionId}"
                .replace("{".concat("appId", "}"), encodeURIComponent(String(appId)))
                .replace("{".concat("subscriptionId", "}"), encodeURIComponent(String(subscriptionId)));
            var localVarUrlObj = url.parse(localVarPath, true);
            var localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            var localVarHeaderParameter = {};
            var localVarQueryParameter = {};
            if (configuration && configuration.accessToken) {
                var localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("oauth2", ["api"])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        getSubscriptionsForApp: function (appId, excludeNotOwnedSubscriptions, storeId, excludeCancelledSubscriptions, options) {
            if (options === void 0) { options = {}; }
            if (appId === null || appId === undefined) {
                throw new RequiredError('appId', 'Required parameter appId was null or undefined when calling getSubscriptionsForApp.');
            }
            var localVarPath = "/api/v1.0/{appId}/subscriptions"
                .replace("{".concat("appId", "}"), encodeURIComponent(String(appId)));
            var localVarUrlObj = url.parse(localVarPath, true);
            var localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            var localVarHeaderParameter = {};
            var localVarQueryParameter = {};
            if (configuration && configuration.accessToken) {
                var localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("oauth2", ["api"])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }
            if (excludeNotOwnedSubscriptions !== undefined) {
                localVarQueryParameter['excludeNotOwnedSubscriptions'] = excludeNotOwnedSubscriptions;
            }
            if (storeId) {
                localVarQueryParameter['storeId'] = storeId;
            }
            if (excludeCancelledSubscriptions !== undefined) {
                localVarQueryParameter['excludeCancelledSubscriptions'] = excludeCancelledSubscriptions;
            }
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        hasCustomerGotPaymentMethodOnFile: function (appId, email, options) {
            if (options === void 0) { options = {}; }
            if (appId === null || appId === undefined) {
                throw new RequiredError('appId', 'Required parameter appId was null or undefined when calling hasCustomerGotPaymentMethodOnFile.');
            }
            var localVarPath = "/api/v1.0/{appId}/subscriptions/hasPaymentMethod"
                .replace("{".concat("appId", "}"), encodeURIComponent(String(appId)));
            var localVarUrlObj = url.parse(localVarPath, true);
            var localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            var localVarHeaderParameter = {};
            var localVarQueryParameter = {};
            if (configuration && configuration.accessToken) {
                var localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("oauth2", ["api"])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }
            if (email !== undefined) {
                localVarQueryParameter['email'] = email;
            }
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    };
};
exports.SubscriptionsApiFetchParamCreator = SubscriptionsApiFetchParamCreator;
var SubscriptionsApiFp = function (configuration) {
    return {
        getSubscriptionById: function (appId, subscriptionId, options) {
            var localVarFetchArgs = (0, exports.SubscriptionsApiFetchParamCreator)(configuration).getSubscriptionById(appId, subscriptionId, options);
            return function (fetch, basePath) {
                if (fetch === void 0) { fetch = portableFetch; }
                if (basePath === void 0) { basePath = BASE_PATH; }
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then(function (response) {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
        getSubscriptionsForApp: function (appId, excludeNotOwnedSubscriptions, storeId, excludeCancelledSubscriptions, options) {
            var localVarFetchArgs = (0, exports.SubscriptionsApiFetchParamCreator)(configuration).getSubscriptionsForApp(appId, excludeNotOwnedSubscriptions, storeId, excludeCancelledSubscriptions, options);
            return function (fetch, basePath) {
                if (fetch === void 0) { fetch = portableFetch; }
                if (basePath === void 0) { basePath = BASE_PATH; }
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then(function (response) {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
        hasCustomerGotPaymentMethodOnFile: function (appId, email, options) {
            var localVarFetchArgs = (0, exports.SubscriptionsApiFetchParamCreator)(configuration).hasCustomerGotPaymentMethodOnFile(appId, email, options);
            return function (fetch, basePath) {
                if (fetch === void 0) { fetch = portableFetch; }
                if (basePath === void 0) { basePath = BASE_PATH; }
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then(function (response) {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
    };
};
exports.SubscriptionsApiFp = SubscriptionsApiFp;
var SubscriptionsApiFactory = function (configuration, fetch, basePath) {
    return {
        getSubscriptionById: function (appId, subscriptionId, options) {
            return (0, exports.SubscriptionsApiFp)(configuration).getSubscriptionById(appId, subscriptionId, options)(fetch, basePath);
        },
        getSubscriptionsForApp: function (appId, excludeNotOwnedSubscriptions, storeId, excludeCancelledSubscriptions, options) {
            return (0, exports.SubscriptionsApiFp)(configuration).getSubscriptionsForApp(appId, excludeNotOwnedSubscriptions, storeId, excludeCancelledSubscriptions, options)(fetch, basePath);
        },
        hasCustomerGotPaymentMethodOnFile: function (appId, email, options) {
            return (0, exports.SubscriptionsApiFp)(configuration).hasCustomerGotPaymentMethodOnFile(appId, email, options)(fetch, basePath);
        },
    };
};
exports.SubscriptionsApiFactory = SubscriptionsApiFactory;
var SubscriptionsApi = (function (_super) {
    __extends(SubscriptionsApi, _super);
    function SubscriptionsApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    SubscriptionsApi.prototype.getSubscriptionById = function (appId, subscriptionId, options) {
        return (0, exports.SubscriptionsApiFp)(this.configuration).getSubscriptionById(appId, subscriptionId, options)(this.fetch, this.basePath);
    };
    SubscriptionsApi.prototype.getSubscriptionsForApp = function (appId, excludeNotOwnedSubscriptions, storeId, excludeCancelledSubscriptions, options) {
        return (0, exports.SubscriptionsApiFp)(this.configuration).getSubscriptionsForApp(appId, excludeNotOwnedSubscriptions, storeId, excludeCancelledSubscriptions, options)(this.fetch, this.basePath);
    };
    SubscriptionsApi.prototype.hasCustomerGotPaymentMethodOnFile = function (appId, email, options) {
        return (0, exports.SubscriptionsApiFp)(this.configuration).hasCustomerGotPaymentMethodOnFile(appId, email, options)(this.fetch, this.basePath);
    };
    return SubscriptionsApi;
}(BaseAPI));
exports.SubscriptionsApi = SubscriptionsApi;
var TeammatesApiFetchParamCreator = function (configuration) {
    return {
        createTeammate: function (appId, CreateTeammate, options) {
            if (options === void 0) { options = {}; }
            if (appId === null || appId === undefined) {
                throw new RequiredError('appId', 'Required parameter appId was null or undefined when calling createTeammate.');
            }
            if (CreateTeammate === null || CreateTeammate === undefined) {
                throw new RequiredError('CreateTeammate', 'Required parameter CreateTeammate was null or undefined when calling createTeammate.');
            }
            var localVarPath = "/api/v1.0/{appId}/teammates"
                .replace("{".concat("appId", "}"), encodeURIComponent(String(appId)));
            var localVarUrlObj = url.parse(localVarPath, true);
            var localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            var localVarHeaderParameter = {};
            var localVarQueryParameter = {};
            if (configuration && configuration.accessToken) {
                var localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("oauth2", ["api"])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }
            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            var needsSerialization = ("CreateTeammate" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body = needsSerialization ? JSON.stringify(CreateTeammate || {}) : (CreateTeammate || "");
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        deleteTeammate: function (appId, id, options) {
            if (options === void 0) { options = {}; }
            if (appId === null || appId === undefined) {
                throw new RequiredError('appId', 'Required parameter appId was null or undefined when calling deleteTeammate.');
            }
            if (id === null || id === undefined) {
                throw new RequiredError('id', 'Required parameter id was null or undefined when calling deleteTeammate.');
            }
            var localVarPath = "/api/v1.0/{appId}/teammates/{id}"
                .replace("{".concat("appId", "}"), encodeURIComponent(String(appId)))
                .replace("{".concat("id", "}"), encodeURIComponent(String(id)));
            var localVarUrlObj = url.parse(localVarPath, true);
            var localVarRequestOptions = Object.assign({ method: 'DELETE' }, options);
            var localVarHeaderParameter = {};
            var localVarQueryParameter = {};
            if (configuration && configuration.accessToken) {
                var localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("oauth2", ["api"])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        getTeammateByAppIdAndTeammateId: function (appId, id, options) {
            if (options === void 0) { options = {}; }
            if (appId === null || appId === undefined) {
                throw new RequiredError('appId', 'Required parameter appId was null or undefined when calling getTeammateByAppIdAndTeammateId.');
            }
            if (id === null || id === undefined) {
                throw new RequiredError('id', 'Required parameter id was null or undefined when calling getTeammateByAppIdAndTeammateId.');
            }
            var localVarPath = "/api/v1.0/{appId}/teammates/{id}"
                .replace("{".concat("appId", "}"), encodeURIComponent(String(appId)))
                .replace("{".concat("id", "}"), encodeURIComponent(String(id)));
            var localVarUrlObj = url.parse(localVarPath, true);
            var localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            var localVarHeaderParameter = {};
            var localVarQueryParameter = {};
            if (configuration && configuration.accessToken) {
                var localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("oauth2", ["api"])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        getTeammatesByAppId: function (appId, options) {
            if (options === void 0) { options = {}; }
            if (appId === null || appId === undefined) {
                throw new RequiredError('appId', 'Required parameter appId was null or undefined when calling getTeammatesByAppId.');
            }
            var localVarPath = "/api/v1.0/{appId}/teammates"
                .replace("{".concat("appId", "}"), encodeURIComponent(String(appId)));
            var localVarUrlObj = url.parse(localVarPath, true);
            var localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            var localVarHeaderParameter = {};
            var localVarQueryParameter = {};
            if (configuration && configuration.accessToken) {
                var localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("oauth2", ["api"])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        grantaccess: function (appId, CreateTeammate, options) {
            if (options === void 0) { options = {}; }
            if (appId === null || appId === undefined) {
                throw new RequiredError('appId', 'Required parameter appId was null or undefined when calling grantaccess.');
            }
            if (CreateTeammate === null || CreateTeammate === undefined) {
                throw new RequiredError('CreateTeammate', 'Required parameter CreateTeammate was null or undefined when calling grantaccess.');
            }
            var localVarPath = "/api/v1.0/{appId}/teammates/grantaccess"
                .replace("{".concat("appId", "}"), encodeURIComponent(String(appId)));
            var localVarUrlObj = url.parse(localVarPath, true);
            var localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            var localVarHeaderParameter = {};
            var localVarQueryParameter = {};
            if (configuration && configuration.accessToken) {
                var localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("oauth2", ["api"])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }
            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            var needsSerialization = ("CreateTeammate" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body = needsSerialization ? JSON.stringify(CreateTeammate || {}) : (CreateTeammate || "");
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        redeemInvitation: function (otc, appId, options) {
            if (options === void 0) { options = {}; }
            if (otc === null || otc === undefined) {
                throw new RequiredError('otc', 'Required parameter otc was null or undefined when calling redeemInvitation.');
            }
            if (appId === null || appId === undefined) {
                throw new RequiredError('appId', 'Required parameter appId was null or undefined when calling redeemInvitation.');
            }
            var localVarPath = "/api/v1.0/{appId}/teammates/redeem/{otc}"
                .replace("{".concat("otc", "}"), encodeURIComponent(String(otc)))
                .replace("{".concat("appId", "}"), encodeURIComponent(String(appId)));
            var localVarUrlObj = url.parse(localVarPath, true);
            var localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            var localVarHeaderParameter = {};
            var localVarQueryParameter = {};
            if (configuration && configuration.accessToken) {
                var localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("oauth2", ["api"])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        teammateMobileRedirect: function (portalUrl, options) {
            if (options === void 0) { options = {}; }
            if (portalUrl === null || portalUrl === undefined) {
                throw new RequiredError('portalUrl', 'Required parameter portalUrl was null or undefined when calling teammateMobileRedirect.');
            }
            var localVarPath = "/api/v1.0/teammates/mobile-redirect";
            var localVarUrlObj = url.parse(localVarPath, true);
            var localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            var localVarHeaderParameter = {};
            var localVarQueryParameter = {};
            if (configuration && configuration.accessToken) {
                var localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("oauth2", ["api"])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }
            if (portalUrl !== undefined) {
                localVarQueryParameter['portalUrl'] = portalUrl;
            }
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        teammatesAcceptInvitation: function (otc, appId, options) {
            if (options === void 0) { options = {}; }
            if (otc === null || otc === undefined) {
                throw new RequiredError('otc', 'Required parameter otc was null or undefined when calling teammatesAcceptInvitation.');
            }
            if (appId === null || appId === undefined) {
                throw new RequiredError('appId', 'Required parameter appId was null or undefined when calling teammatesAcceptInvitation.');
            }
            var localVarPath = "/api/v1.0/{appId}/teammates/accept/{otc}"
                .replace("{".concat("otc", "}"), encodeURIComponent(String(otc)))
                .replace("{".concat("appId", "}"), encodeURIComponent(String(appId)));
            var localVarUrlObj = url.parse(localVarPath, true);
            var localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            var localVarHeaderParameter = {};
            var localVarQueryParameter = {};
            if (configuration && configuration.accessToken) {
                var localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("oauth2", ["api"])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        teammatesAcceptInvitations: function (options) {
            if (options === void 0) { options = {}; }
            var localVarPath = "/api/v1.0/teammates/acceptInvitations";
            var localVarUrlObj = url.parse(localVarPath, true);
            var localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            var localVarHeaderParameter = {};
            var localVarQueryParameter = {};
            if (configuration && configuration.accessToken) {
                var localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("oauth2", ["api"])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        teammatesPendingInvitations: function (options) {
            if (options === void 0) { options = {}; }
            var localVarPath = "/api/v1.0/teammates/pending-invitations";
            var localVarUrlObj = url.parse(localVarPath, true);
            var localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            var localVarHeaderParameter = {};
            var localVarQueryParameter = {};
            if (configuration && configuration.accessToken) {
                var localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("oauth2", ["api"])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        updateTeammate: function (appId, id, TeammateBase, options) {
            if (options === void 0) { options = {}; }
            if (appId === null || appId === undefined) {
                throw new RequiredError('appId', 'Required parameter appId was null or undefined when calling updateTeammate.');
            }
            if (id === null || id === undefined) {
                throw new RequiredError('id', 'Required parameter id was null or undefined when calling updateTeammate.');
            }
            if (TeammateBase === null || TeammateBase === undefined) {
                throw new RequiredError('TeammateBase', 'Required parameter TeammateBase was null or undefined when calling updateTeammate.');
            }
            var localVarPath = "/api/v1.0/{appId}/teammates/{id}"
                .replace("{".concat("appId", "}"), encodeURIComponent(String(appId)))
                .replace("{".concat("id", "}"), encodeURIComponent(String(id)));
            var localVarUrlObj = url.parse(localVarPath, true);
            var localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            var localVarHeaderParameter = {};
            var localVarQueryParameter = {};
            if (configuration && configuration.accessToken) {
                var localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("oauth2", ["api"])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }
            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            var needsSerialization = ("TeammateBase" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body = needsSerialization ? JSON.stringify(TeammateBase || {}) : (TeammateBase || "");
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    };
};
exports.TeammatesApiFetchParamCreator = TeammatesApiFetchParamCreator;
var TeammatesApiFp = function (configuration) {
    return {
        createTeammate: function (appId, CreateTeammate, options) {
            var localVarFetchArgs = (0, exports.TeammatesApiFetchParamCreator)(configuration).createTeammate(appId, CreateTeammate, options);
            return function (fetch, basePath) {
                if (fetch === void 0) { fetch = portableFetch; }
                if (basePath === void 0) { basePath = BASE_PATH; }
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then(function (response) {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
        deleteTeammate: function (appId, id, options) {
            var localVarFetchArgs = (0, exports.TeammatesApiFetchParamCreator)(configuration).deleteTeammate(appId, id, options);
            return function (fetch, basePath) {
                if (fetch === void 0) { fetch = portableFetch; }
                if (basePath === void 0) { basePath = BASE_PATH; }
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then(function (response) {
                    if (response.status >= 200 && response.status < 300) {
                        return response;
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
        getTeammateByAppIdAndTeammateId: function (appId, id, options) {
            var localVarFetchArgs = (0, exports.TeammatesApiFetchParamCreator)(configuration).getTeammateByAppIdAndTeammateId(appId, id, options);
            return function (fetch, basePath) {
                if (fetch === void 0) { fetch = portableFetch; }
                if (basePath === void 0) { basePath = BASE_PATH; }
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then(function (response) {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
        getTeammatesByAppId: function (appId, options) {
            var localVarFetchArgs = (0, exports.TeammatesApiFetchParamCreator)(configuration).getTeammatesByAppId(appId, options);
            return function (fetch, basePath) {
                if (fetch === void 0) { fetch = portableFetch; }
                if (basePath === void 0) { basePath = BASE_PATH; }
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then(function (response) {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
        grantaccess: function (appId, CreateTeammate, options) {
            var localVarFetchArgs = (0, exports.TeammatesApiFetchParamCreator)(configuration).grantaccess(appId, CreateTeammate, options);
            return function (fetch, basePath) {
                if (fetch === void 0) { fetch = portableFetch; }
                if (basePath === void 0) { basePath = BASE_PATH; }
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then(function (response) {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
        redeemInvitation: function (otc, appId, options) {
            var localVarFetchArgs = (0, exports.TeammatesApiFetchParamCreator)(configuration).redeemInvitation(otc, appId, options);
            return function (fetch, basePath) {
                if (fetch === void 0) { fetch = portableFetch; }
                if (basePath === void 0) { basePath = BASE_PATH; }
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then(function (response) {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
        teammateMobileRedirect: function (portalUrl, options) {
            var localVarFetchArgs = (0, exports.TeammatesApiFetchParamCreator)(configuration).teammateMobileRedirect(portalUrl, options);
            return function (fetch, basePath) {
                if (fetch === void 0) { fetch = portableFetch; }
                if (basePath === void 0) { basePath = BASE_PATH; }
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then(function (response) {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
        teammatesAcceptInvitation: function (otc, appId, options) {
            var localVarFetchArgs = (0, exports.TeammatesApiFetchParamCreator)(configuration).teammatesAcceptInvitation(otc, appId, options);
            return function (fetch, basePath) {
                if (fetch === void 0) { fetch = portableFetch; }
                if (basePath === void 0) { basePath = BASE_PATH; }
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then(function (response) {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
        teammatesAcceptInvitations: function (options) {
            var localVarFetchArgs = (0, exports.TeammatesApiFetchParamCreator)(configuration).teammatesAcceptInvitations(options);
            return function (fetch, basePath) {
                if (fetch === void 0) { fetch = portableFetch; }
                if (basePath === void 0) { basePath = BASE_PATH; }
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then(function (response) {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
        teammatesPendingInvitations: function (options) {
            var localVarFetchArgs = (0, exports.TeammatesApiFetchParamCreator)(configuration).teammatesPendingInvitations(options);
            return function (fetch, basePath) {
                if (fetch === void 0) { fetch = portableFetch; }
                if (basePath === void 0) { basePath = BASE_PATH; }
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then(function (response) {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
        updateTeammate: function (appId, id, TeammateBase, options) {
            var localVarFetchArgs = (0, exports.TeammatesApiFetchParamCreator)(configuration).updateTeammate(appId, id, TeammateBase, options);
            return function (fetch, basePath) {
                if (fetch === void 0) { fetch = portableFetch; }
                if (basePath === void 0) { basePath = BASE_PATH; }
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then(function (response) {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
    };
};
exports.TeammatesApiFp = TeammatesApiFp;
var TeammatesApiFactory = function (configuration, fetch, basePath) {
    return {
        createTeammate: function (appId, CreateTeammate, options) {
            return (0, exports.TeammatesApiFp)(configuration).createTeammate(appId, CreateTeammate, options)(fetch, basePath);
        },
        deleteTeammate: function (appId, id, options) {
            return (0, exports.TeammatesApiFp)(configuration).deleteTeammate(appId, id, options)(fetch, basePath);
        },
        getTeammateByAppIdAndTeammateId: function (appId, id, options) {
            return (0, exports.TeammatesApiFp)(configuration).getTeammateByAppIdAndTeammateId(appId, id, options)(fetch, basePath);
        },
        getTeammatesByAppId: function (appId, options) {
            return (0, exports.TeammatesApiFp)(configuration).getTeammatesByAppId(appId, options)(fetch, basePath);
        },
        grantaccess: function (appId, CreateTeammate, options) {
            return (0, exports.TeammatesApiFp)(configuration).grantaccess(appId, CreateTeammate, options)(fetch, basePath);
        },
        redeemInvitation: function (otc, appId, options) {
            return (0, exports.TeammatesApiFp)(configuration).redeemInvitation(otc, appId, options)(fetch, basePath);
        },
        teammateMobileRedirect: function (portalUrl, options) {
            return (0, exports.TeammatesApiFp)(configuration).teammateMobileRedirect(portalUrl, options)(fetch, basePath);
        },
        teammatesAcceptInvitation: function (otc, appId, options) {
            return (0, exports.TeammatesApiFp)(configuration).teammatesAcceptInvitation(otc, appId, options)(fetch, basePath);
        },
        teammatesAcceptInvitations: function (options) {
            return (0, exports.TeammatesApiFp)(configuration).teammatesAcceptInvitations(options)(fetch, basePath);
        },
        teammatesPendingInvitations: function (options) {
            return (0, exports.TeammatesApiFp)(configuration).teammatesPendingInvitations(options)(fetch, basePath);
        },
        updateTeammate: function (appId, id, TeammateBase, options) {
            return (0, exports.TeammatesApiFp)(configuration).updateTeammate(appId, id, TeammateBase, options)(fetch, basePath);
        },
    };
};
exports.TeammatesApiFactory = TeammatesApiFactory;
var TeammatesApi = (function (_super) {
    __extends(TeammatesApi, _super);
    function TeammatesApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    TeammatesApi.prototype.createTeammate = function (appId, CreateTeammate, options) {
        return (0, exports.TeammatesApiFp)(this.configuration).createTeammate(appId, CreateTeammate, options)(this.fetch, this.basePath);
    };
    TeammatesApi.prototype.deleteTeammate = function (appId, id, options) {
        return (0, exports.TeammatesApiFp)(this.configuration).deleteTeammate(appId, id, options)(this.fetch, this.basePath);
    };
    TeammatesApi.prototype.getTeammateByAppIdAndTeammateId = function (appId, id, options) {
        return (0, exports.TeammatesApiFp)(this.configuration).getTeammateByAppIdAndTeammateId(appId, id, options)(this.fetch, this.basePath);
    };
    TeammatesApi.prototype.getTeammatesByAppId = function (appId, options) {
        return (0, exports.TeammatesApiFp)(this.configuration).getTeammatesByAppId(appId, options)(this.fetch, this.basePath);
    };
    TeammatesApi.prototype.grantaccess = function (appId, CreateTeammate, options) {
        return (0, exports.TeammatesApiFp)(this.configuration).grantaccess(appId, CreateTeammate, options)(this.fetch, this.basePath);
    };
    TeammatesApi.prototype.redeemInvitation = function (otc, appId, options) {
        return (0, exports.TeammatesApiFp)(this.configuration).redeemInvitation(otc, appId, options)(this.fetch, this.basePath);
    };
    TeammatesApi.prototype.teammateMobileRedirect = function (portalUrl, options) {
        return (0, exports.TeammatesApiFp)(this.configuration).teammateMobileRedirect(portalUrl, options)(this.fetch, this.basePath);
    };
    TeammatesApi.prototype.teammatesAcceptInvitation = function (otc, appId, options) {
        return (0, exports.TeammatesApiFp)(this.configuration).teammatesAcceptInvitation(otc, appId, options)(this.fetch, this.basePath);
    };
    TeammatesApi.prototype.teammatesAcceptInvitations = function (options) {
        return (0, exports.TeammatesApiFp)(this.configuration).teammatesAcceptInvitations(options)(this.fetch, this.basePath);
    };
    TeammatesApi.prototype.teammatesPendingInvitations = function (options) {
        return (0, exports.TeammatesApiFp)(this.configuration).teammatesPendingInvitations(options)(this.fetch, this.basePath);
    };
    TeammatesApi.prototype.updateTeammate = function (appId, id, TeammateBase, options) {
        return (0, exports.TeammatesApiFp)(this.configuration).updateTeammate(appId, id, TeammateBase, options)(this.fetch, this.basePath);
    };
    return TeammatesApi;
}(BaseAPI));
exports.TeammatesApi = TeammatesApi;
var TerminalIotApiFetchParamCreator = function (configuration) {
    return {
        getTerminalIotConnection: function (options) {
            if (options === void 0) { options = {}; }
            var localVarPath = "/api/v1.0/terminaliot/connect";
            var localVarUrlObj = url.parse(localVarPath, true);
            var localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            var localVarHeaderParameter = {};
            var localVarQueryParameter = {};
            if (configuration && configuration.accessToken) {
                var localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("oauth2", ["api"])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    };
};
exports.TerminalIotApiFetchParamCreator = TerminalIotApiFetchParamCreator;
var TerminalIotApiFp = function (configuration) {
    return {
        getTerminalIotConnection: function (options) {
            var localVarFetchArgs = (0, exports.TerminalIotApiFetchParamCreator)(configuration).getTerminalIotConnection(options);
            return function (fetch, basePath) {
                if (fetch === void 0) { fetch = portableFetch; }
                if (basePath === void 0) { basePath = BASE_PATH; }
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then(function (response) {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
    };
};
exports.TerminalIotApiFp = TerminalIotApiFp;
var TerminalIotApiFactory = function (configuration, fetch, basePath) {
    return {
        getTerminalIotConnection: function (options) {
            return (0, exports.TerminalIotApiFp)(configuration).getTerminalIotConnection(options)(fetch, basePath);
        },
    };
};
exports.TerminalIotApiFactory = TerminalIotApiFactory;
var TerminalIotApi = (function (_super) {
    __extends(TerminalIotApi, _super);
    function TerminalIotApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    TerminalIotApi.prototype.getTerminalIotConnection = function (options) {
        return (0, exports.TerminalIotApiFp)(this.configuration).getTerminalIotConnection(options)(this.fetch, this.basePath);
    };
    return TerminalIotApi;
}(BaseAPI));
exports.TerminalIotApi = TerminalIotApi;
var TipsApiFetchParamCreator = function (configuration) {
    return {
        tipConfigGet: function (storeId, options) {
            if (options === void 0) { options = {}; }
            if (storeId === null || storeId === undefined) {
                throw new RequiredError('storeId', 'Required parameter storeId was null or undefined when calling tipConfigGet.');
            }
            var localVarPath = "/api/v1.0/stores/{storeId}/tipconfig"
                .replace("{".concat("storeId", "}"), encodeURIComponent(String(storeId)));
            var localVarUrlObj = url.parse(localVarPath, true);
            var localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            var localVarHeaderParameter = {};
            var localVarQueryParameter = {};
            if (configuration && configuration.accessToken) {
                var localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("oauth2", ["api"])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        tipConfigUpsert: function (storeId, UpdateTipConfiguration, options) {
            if (options === void 0) { options = {}; }
            if (storeId === null || storeId === undefined) {
                throw new RequiredError('storeId', 'Required parameter storeId was null or undefined when calling tipConfigUpsert.');
            }
            if (UpdateTipConfiguration === null || UpdateTipConfiguration === undefined) {
                throw new RequiredError('UpdateTipConfiguration', 'Required parameter UpdateTipConfiguration was null or undefined when calling tipConfigUpsert.');
            }
            var localVarPath = "/api/v1.0/stores/{storeId}/tipconfig"
                .replace("{".concat("storeId", "}"), encodeURIComponent(String(storeId)));
            var localVarUrlObj = url.parse(localVarPath, true);
            var localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            var localVarHeaderParameter = {};
            var localVarQueryParameter = {};
            if (configuration && configuration.accessToken) {
                var localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("oauth2", ["api"])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }
            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            var needsSerialization = ("UpdateTipConfiguration" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body = needsSerialization ? JSON.stringify(UpdateTipConfiguration || {}) : (UpdateTipConfiguration || "");
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    };
};
exports.TipsApiFetchParamCreator = TipsApiFetchParamCreator;
var TipsApiFp = function (configuration) {
    return {
        tipConfigGet: function (storeId, options) {
            var localVarFetchArgs = (0, exports.TipsApiFetchParamCreator)(configuration).tipConfigGet(storeId, options);
            return function (fetch, basePath) {
                if (fetch === void 0) { fetch = portableFetch; }
                if (basePath === void 0) { basePath = BASE_PATH; }
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then(function (response) {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
        tipConfigUpsert: function (storeId, UpdateTipConfiguration, options) {
            var localVarFetchArgs = (0, exports.TipsApiFetchParamCreator)(configuration).tipConfigUpsert(storeId, UpdateTipConfiguration, options);
            return function (fetch, basePath) {
                if (fetch === void 0) { fetch = portableFetch; }
                if (basePath === void 0) { basePath = BASE_PATH; }
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then(function (response) {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
    };
};
exports.TipsApiFp = TipsApiFp;
var TipsApiFactory = function (configuration, fetch, basePath) {
    return {
        tipConfigGet: function (storeId, options) {
            return (0, exports.TipsApiFp)(configuration).tipConfigGet(storeId, options)(fetch, basePath);
        },
        tipConfigUpsert: function (storeId, UpdateTipConfiguration, options) {
            return (0, exports.TipsApiFp)(configuration).tipConfigUpsert(storeId, UpdateTipConfiguration, options)(fetch, basePath);
        },
    };
};
exports.TipsApiFactory = TipsApiFactory;
var TipsApi = (function (_super) {
    __extends(TipsApi, _super);
    function TipsApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    TipsApi.prototype.tipConfigGet = function (storeId, options) {
        return (0, exports.TipsApiFp)(this.configuration).tipConfigGet(storeId, options)(this.fetch, this.basePath);
    };
    TipsApi.prototype.tipConfigUpsert = function (storeId, UpdateTipConfiguration, options) {
        return (0, exports.TipsApiFp)(this.configuration).tipConfigUpsert(storeId, UpdateTipConfiguration, options)(this.fetch, this.basePath);
    };
    return TipsApi;
}(BaseAPI));
exports.TipsApi = TipsApi;
var UsersApiFetchParamCreator = function (configuration) {
    return {
        addUserNote: function (userId, body, options) {
            if (options === void 0) { options = {}; }
            if (userId === null || userId === undefined) {
                throw new RequiredError('userId', 'Required parameter userId was null or undefined when calling addUserNote.');
            }
            if (body === null || body === undefined) {
                throw new RequiredError('body', 'Required parameter body was null or undefined when calling addUserNote.');
            }
            var localVarPath = "/api/v1.0/users/{userId}/AddUserNote"
                .replace("{".concat("userId", "}"), encodeURIComponent(String(userId)));
            var localVarUrlObj = url.parse(localVarPath, true);
            var localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            var localVarHeaderParameter = {};
            var localVarQueryParameter = {};
            if (configuration && configuration.accessToken) {
                var localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("oauth2", ["api"])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }
            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            var needsSerialization = ("string" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body = needsSerialization ? JSON.stringify(body || {}) : (body || "");
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        addUserToRole: function (userId, roleName, options) {
            if (options === void 0) { options = {}; }
            if (userId === null || userId === undefined) {
                throw new RequiredError('userId', 'Required parameter userId was null or undefined when calling addUserToRole.');
            }
            if (roleName === null || roleName === undefined) {
                throw new RequiredError('roleName', 'Required parameter roleName was null or undefined when calling addUserToRole.');
            }
            var localVarPath = "/api/v1.0/users/{userId}/AddUserToRole/{roleName}"
                .replace("{".concat("userId", "}"), encodeURIComponent(String(userId)))
                .replace("{".concat("roleName", "}"), encodeURIComponent(String(roleName)));
            var localVarUrlObj = url.parse(localVarPath, true);
            var localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            var localVarHeaderParameter = {};
            var localVarQueryParameter = {};
            if (configuration && configuration.accessToken) {
                var localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("oauth2", ["api"])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        anonymizeUser: function (userId, options) {
            if (options === void 0) { options = {}; }
            if (userId === null || userId === undefined) {
                throw new RequiredError('userId', 'Required parameter userId was null or undefined when calling anonymizeUser.');
            }
            var localVarPath = "/api/v1.0/users/{userId}/AnonymizeUser"
                .replace("{".concat("userId", "}"), encodeURIComponent(String(userId)));
            var localVarUrlObj = url.parse(localVarPath, true);
            var localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            var localVarHeaderParameter = {};
            var localVarQueryParameter = {};
            if (configuration && configuration.accessToken) {
                var localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("oauth2", ["api"])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        blockUserPhoneNumber: function (userId, options) {
            if (options === void 0) { options = {}; }
            if (userId === null || userId === undefined) {
                throw new RequiredError('userId', 'Required parameter userId was null or undefined when calling blockUserPhoneNumber.');
            }
            var localVarPath = "/api/v1.0/users/{userId}/BlockUserPhoneNumber"
                .replace("{".concat("userId", "}"), encodeURIComponent(String(userId)));
            var localVarUrlObj = url.parse(localVarPath, true);
            var localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            var localVarHeaderParameter = {};
            var localVarQueryParameter = {};
            if (configuration && configuration.accessToken) {
                var localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("oauth2", ["api"])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        createUserDeliveryLocation: function (userId, CreateUserDeliveryLocationRequest, options) {
            if (options === void 0) { options = {}; }
            if (userId === null || userId === undefined) {
                throw new RequiredError('userId', 'Required parameter userId was null or undefined when calling createUserDeliveryLocation.');
            }
            if (CreateUserDeliveryLocationRequest === null || CreateUserDeliveryLocationRequest === undefined) {
                throw new RequiredError('CreateUserDeliveryLocationRequest', 'Required parameter CreateUserDeliveryLocationRequest was null or undefined when calling createUserDeliveryLocation.');
            }
            var localVarPath = "/api/v1.0/users/{userId}/deliveryLocations"
                .replace("{".concat("userId", "}"), encodeURIComponent(String(userId)));
            var localVarUrlObj = url.parse(localVarPath, true);
            var localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            var localVarHeaderParameter = {};
            var localVarQueryParameter = {};
            if (configuration && configuration.accessToken) {
                var localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("oauth2", ["api"])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }
            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            var needsSerialization = ("CreateUserDeliveryLocationRequest" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body = needsSerialization ? JSON.stringify(CreateUserDeliveryLocationRequest || {}) : (CreateUserDeliveryLocationRequest || "");
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        getPreviousOrderCountForStore: function (userId, storeId, options) {
            if (options === void 0) { options = {}; }
            if (userId === null || userId === undefined) {
                throw new RequiredError('userId', 'Required parameter userId was null or undefined when calling getPreviousOrderCountForStore.');
            }
            if (storeId === null || storeId === undefined) {
                throw new RequiredError('storeId', 'Required parameter storeId was null or undefined when calling getPreviousOrderCountForStore.');
            }
            var localVarPath = "/api/v1.0/users/{userId}/previousordercount/{storeId}"
                .replace("{".concat("userId", "}"), encodeURIComponent(String(userId)))
                .replace("{".concat("storeId", "}"), encodeURIComponent(String(storeId)));
            var localVarUrlObj = url.parse(localVarPath, true);
            var localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            var localVarHeaderParameter = {};
            var localVarQueryParameter = {};
            if (configuration && configuration.accessToken) {
                var localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("oauth2", ["api"])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        getRestaurantUserAccounts: function (userId, options) {
            if (options === void 0) { options = {}; }
            if (userId === null || userId === undefined) {
                throw new RequiredError('userId', 'Required parameter userId was null or undefined when calling getRestaurantUserAccounts.');
            }
            var localVarPath = "/api/v1.0/users/{userId}/RestaurantUserAccounts"
                .replace("{".concat("userId", "}"), encodeURIComponent(String(userId)));
            var localVarUrlObj = url.parse(localVarPath, true);
            var localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            var localVarHeaderParameter = {};
            var localVarQueryParameter = {};
            if (configuration && configuration.accessToken) {
                var localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("oauth2", ["api"])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        getRestaurantUserStores: function (userId, options) {
            if (options === void 0) { options = {}; }
            if (userId === null || userId === undefined) {
                throw new RequiredError('userId', 'Required parameter userId was null or undefined when calling getRestaurantUserStores.');
            }
            var localVarPath = "/api/v1.0/users/{userId}/RestaurantUserStores"
                .replace("{".concat("userId", "}"), encodeURIComponent(String(userId)));
            var localVarUrlObj = url.parse(localVarPath, true);
            var localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            var localVarHeaderParameter = {};
            var localVarQueryParameter = {};
            if (configuration && configuration.accessToken) {
                var localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("oauth2", ["api"])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        getRoles: function (options) {
            if (options === void 0) { options = {}; }
            var localVarPath = "/api/v1.0/users/roles";
            var localVarUrlObj = url.parse(localVarPath, true);
            var localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            var localVarHeaderParameter = {};
            var localVarQueryParameter = {};
            if (configuration && configuration.accessToken) {
                var localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("oauth2", ["api"])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        getRolesAndUnassignedRoles: function (userId, options) {
            if (options === void 0) { options = {}; }
            if (userId === null || userId === undefined) {
                throw new RequiredError('userId', 'Required parameter userId was null or undefined when calling getRolesAndUnassignedRoles.');
            }
            var localVarPath = "/api/v1.0/users/{userId}/roles"
                .replace("{".concat("userId", "}"), encodeURIComponent(String(userId)));
            var localVarUrlObj = url.parse(localVarPath, true);
            var localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            var localVarHeaderParameter = {};
            var localVarQueryParameter = {};
            if (configuration && configuration.accessToken) {
                var localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("oauth2", ["api"])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        getUserById: function (userId, options) {
            if (options === void 0) { options = {}; }
            if (userId === null || userId === undefined) {
                throw new RequiredError('userId', 'Required parameter userId was null or undefined when calling getUserById.');
            }
            var localVarPath = "/api/v1.0/users/{userId}"
                .replace("{".concat("userId", "}"), encodeURIComponent(String(userId)));
            var localVarUrlObj = url.parse(localVarPath, true);
            var localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            var localVarHeaderParameter = {};
            var localVarQueryParameter = {};
            if (configuration && configuration.accessToken) {
                var localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("oauth2", ["api"])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        getUserDeliveryLocationsForAdmin: function (userId, whiteLabelId, options) {
            if (options === void 0) { options = {}; }
            if (userId === null || userId === undefined) {
                throw new RequiredError('userId', 'Required parameter userId was null or undefined when calling getUserDeliveryLocationsForAdmin.');
            }
            var localVarPath = "/api/v1.0/users/{userId}/deliveryLocations"
                .replace("{".concat("userId", "}"), encodeURIComponent(String(userId)));
            var localVarUrlObj = url.parse(localVarPath, true);
            var localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            var localVarHeaderParameter = {};
            var localVarQueryParameter = {};
            if (configuration && configuration.accessToken) {
                var localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("oauth2", ["api"])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }
            if (whiteLabelId !== undefined) {
                localVarQueryParameter['whiteLabelId'] = whiteLabelId;
            }
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        getUserNotes: function (userId, options) {
            if (options === void 0) { options = {}; }
            if (userId === null || userId === undefined) {
                throw new RequiredError('userId', 'Required parameter userId was null or undefined when calling getUserNotes.');
            }
            var localVarPath = "/api/v1.0/users/{userId}/UserNotes"
                .replace("{".concat("userId", "}"), encodeURIComponent(String(userId)));
            var localVarUrlObj = url.parse(localVarPath, true);
            var localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            var localVarHeaderParameter = {};
            var localVarQueryParameter = {};
            if (configuration && configuration.accessToken) {
                var localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("oauth2", ["api"])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        getUserOrderByIdForAdmin: function (userId, orderId, options) {
            if (options === void 0) { options = {}; }
            if (userId === null || userId === undefined) {
                throw new RequiredError('userId', 'Required parameter userId was null or undefined when calling getUserOrderByIdForAdmin.');
            }
            if (orderId === null || orderId === undefined) {
                throw new RequiredError('orderId', 'Required parameter orderId was null or undefined when calling getUserOrderByIdForAdmin.');
            }
            var localVarPath = "/api/v1.0/users/{userId}/orders/{orderId}"
                .replace("{".concat("userId", "}"), encodeURIComponent(String(userId)))
                .replace("{".concat("orderId", "}"), encodeURIComponent(String(orderId)));
            var localVarUrlObj = url.parse(localVarPath, true);
            var localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            var localVarHeaderParameter = {};
            var localVarQueryParameter = {};
            if (configuration && configuration.accessToken) {
                var localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("oauth2", ["api"])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        getUserOrdersForAdmin: function (userId, skip, take, brandId, options) {
            if (options === void 0) { options = {}; }
            if (userId === null || userId === undefined) {
                throw new RequiredError('userId', 'Required parameter userId was null or undefined when calling getUserOrdersForAdmin.');
            }
            var localVarPath = "/api/v1.0/users/{userId}/orders"
                .replace("{".concat("userId", "}"), encodeURIComponent(String(userId)));
            var localVarUrlObj = url.parse(localVarPath, true);
            var localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            var localVarHeaderParameter = {};
            var localVarQueryParameter = {};
            if (configuration && configuration.accessToken) {
                var localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("oauth2", ["api"])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }
            if (skip !== undefined) {
                localVarQueryParameter['skip'] = skip;
            }
            if (take !== undefined) {
                localVarQueryParameter['take'] = take;
            }
            if (brandId !== undefined) {
                localVarQueryParameter['brandId'] = brandId;
            }
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        getUserSmsConversationItems: function (userId, mostRecentCount, options) {
            if (options === void 0) { options = {}; }
            if (userId === null || userId === undefined) {
                throw new RequiredError('userId', 'Required parameter userId was null or undefined when calling getUserSmsConversationItems.');
            }
            var localVarPath = "/api/v1.0/users/{userId}/smsConversationItems"
                .replace("{".concat("userId", "}"), encodeURIComponent(String(userId)));
            var localVarUrlObj = url.parse(localVarPath, true);
            var localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            var localVarHeaderParameter = {};
            var localVarQueryParameter = {};
            if (configuration && configuration.accessToken) {
                var localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("oauth2", ["api"])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }
            if (mostRecentCount !== undefined) {
                localVarQueryParameter['mostRecentCount'] = mostRecentCount;
            }
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        hideUserDeliveryLocation: function (userId, deliveryLocationId, options) {
            if (options === void 0) { options = {}; }
            if (userId === null || userId === undefined) {
                throw new RequiredError('userId', 'Required parameter userId was null or undefined when calling hideUserDeliveryLocation.');
            }
            if (deliveryLocationId === null || deliveryLocationId === undefined) {
                throw new RequiredError('deliveryLocationId', 'Required parameter deliveryLocationId was null or undefined when calling hideUserDeliveryLocation.');
            }
            var localVarPath = "/api/v1.0/users/{userId}/deliveryLocations/{deliveryLocationId}/hide"
                .replace("{".concat("userId", "}"), encodeURIComponent(String(userId)))
                .replace("{".concat("deliveryLocationId", "}"), encodeURIComponent(String(deliveryLocationId)));
            var localVarUrlObj = url.parse(localVarPath, true);
            var localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            var localVarHeaderParameter = {};
            var localVarQueryParameter = {};
            if (configuration && configuration.accessToken) {
                var localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("oauth2", ["api"])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        markUserAsFraudulent: function (userId, options) {
            if (options === void 0) { options = {}; }
            if (userId === null || userId === undefined) {
                throw new RequiredError('userId', 'Required parameter userId was null or undefined when calling markUserAsFraudulent.');
            }
            var localVarPath = "/api/v1.0/users/{userId}/MarkUserAsFraudulent"
                .replace("{".concat("userId", "}"), encodeURIComponent(String(userId)));
            var localVarUrlObj = url.parse(localVarPath, true);
            var localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            var localVarHeaderParameter = {};
            var localVarQueryParameter = {};
            if (configuration && configuration.accessToken) {
                var localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("oauth2", ["api"])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        markUserAsSuspicious: function (userId, options) {
            if (options === void 0) { options = {}; }
            if (userId === null || userId === undefined) {
                throw new RequiredError('userId', 'Required parameter userId was null or undefined when calling markUserAsSuspicious.');
            }
            var localVarPath = "/api/v1.0/users/{userId}/MarkUserAsSuspicious"
                .replace("{".concat("userId", "}"), encodeURIComponent(String(userId)));
            var localVarUrlObj = url.parse(localVarPath, true);
            var localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            var localVarHeaderParameter = {};
            var localVarQueryParameter = {};
            if (configuration && configuration.accessToken) {
                var localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("oauth2", ["api"])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        removeFlipdishAccountIdForUser: function (userId, accountId, options) {
            if (options === void 0) { options = {}; }
            if (userId === null || userId === undefined) {
                throw new RequiredError('userId', 'Required parameter userId was null or undefined when calling removeFlipdishAccountIdForUser.');
            }
            if (accountId === null || accountId === undefined) {
                throw new RequiredError('accountId', 'Required parameter accountId was null or undefined when calling removeFlipdishAccountIdForUser.');
            }
            var localVarPath = "/api/v1.0/users/{userId}/RemoveFlipdishAccountId/{accountId}"
                .replace("{".concat("userId", "}"), encodeURIComponent(String(userId)))
                .replace("{".concat("accountId", "}"), encodeURIComponent(String(accountId)));
            var localVarUrlObj = url.parse(localVarPath, true);
            var localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            var localVarHeaderParameter = {};
            var localVarQueryParameter = {};
            if (configuration && configuration.accessToken) {
                var localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("oauth2", ["api"])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        removeUserFromRole: function (userId, roleName, options) {
            if (options === void 0) { options = {}; }
            if (userId === null || userId === undefined) {
                throw new RequiredError('userId', 'Required parameter userId was null or undefined when calling removeUserFromRole.');
            }
            if (roleName === null || roleName === undefined) {
                throw new RequiredError('roleName', 'Required parameter roleName was null or undefined when calling removeUserFromRole.');
            }
            var localVarPath = "/api/v1.0/users/{userId}/RemoveUserFromRole/{roleName}"
                .replace("{".concat("userId", "}"), encodeURIComponent(String(userId)))
                .replace("{".concat("roleName", "}"), encodeURIComponent(String(roleName)));
            var localVarUrlObj = url.parse(localVarPath, true);
            var localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            var localVarHeaderParameter = {};
            var localVarQueryParameter = {};
            if (configuration && configuration.accessToken) {
                var localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("oauth2", ["api"])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        resetMfa: function (userId, options) {
            if (options === void 0) { options = {}; }
            if (userId === null || userId === undefined) {
                throw new RequiredError('userId', 'Required parameter userId was null or undefined when calling resetMfa.');
            }
            var localVarPath = "/api/v1.0/users/{userId}/ResetMfa"
                .replace("{".concat("userId", "}"), encodeURIComponent(String(userId)));
            var localVarUrlObj = url.parse(localVarPath, true);
            var localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            var localVarHeaderParameter = {};
            var localVarQueryParameter = {};
            if (configuration && configuration.accessToken) {
                var localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("oauth2", ["api"])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        searchFlipdishAccounts: function (searchPattern, options) {
            if (options === void 0) { options = {}; }
            if (searchPattern === null || searchPattern === undefined) {
                throw new RequiredError('searchPattern', 'Required parameter searchPattern was null or undefined when calling searchFlipdishAccounts.');
            }
            var localVarPath = "/api/v1.0/users/searchFlipdishAccounts";
            var localVarUrlObj = url.parse(localVarPath, true);
            var localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            var localVarHeaderParameter = {};
            var localVarQueryParameter = {};
            if (configuration && configuration.accessToken) {
                var localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("oauth2", ["api"])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }
            if (searchPattern !== undefined) {
                localVarQueryParameter['searchPattern'] = searchPattern;
            }
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        searchUsers: function (searchQuery, hasUserLoggedIn, userDiscriminator, searchIn, pageIndex, pageSize, options) {
            if (options === void 0) { options = {}; }
            if (searchQuery === null || searchQuery === undefined) {
                throw new RequiredError('searchQuery', 'Required parameter searchQuery was null or undefined when calling searchUsers.');
            }
            var localVarPath = "/api/v1.0/users/search";
            var localVarUrlObj = url.parse(localVarPath, true);
            var localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            var localVarHeaderParameter = {};
            var localVarQueryParameter = {};
            if (configuration && configuration.accessToken) {
                var localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("oauth2", ["api"])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }
            if (searchQuery !== undefined) {
                localVarQueryParameter['searchQuery'] = searchQuery;
            }
            if (hasUserLoggedIn !== undefined) {
                localVarQueryParameter['hasUserLoggedIn'] = hasUserLoggedIn;
            }
            if (userDiscriminator !== undefined) {
                localVarQueryParameter['userDiscriminator'] = userDiscriminator;
            }
            if (searchIn !== undefined) {
                localVarQueryParameter['searchIn'] = searchIn;
            }
            if (pageIndex !== undefined) {
                localVarQueryParameter['pageIndex'] = pageIndex;
            }
            if (pageSize !== undefined) {
                localVarQueryParameter['pageSize'] = pageSize;
            }
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        sendUserPushNotification: function (userId, SendUserPushNotificationRequest, options) {
            if (options === void 0) { options = {}; }
            if (userId === null || userId === undefined) {
                throw new RequiredError('userId', 'Required parameter userId was null or undefined when calling sendUserPushNotification.');
            }
            if (SendUserPushNotificationRequest === null || SendUserPushNotificationRequest === undefined) {
                throw new RequiredError('SendUserPushNotificationRequest', 'Required parameter SendUserPushNotificationRequest was null or undefined when calling sendUserPushNotification.');
            }
            var localVarPath = "/api/v1.0/users/{userId}/pushNotifications"
                .replace("{".concat("userId", "}"), encodeURIComponent(String(userId)));
            var localVarUrlObj = url.parse(localVarPath, true);
            var localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            var localVarHeaderParameter = {};
            var localVarQueryParameter = {};
            if (configuration && configuration.accessToken) {
                var localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("oauth2", ["api"])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }
            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            var needsSerialization = ("SendUserPushNotificationRequest" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body = needsSerialization ? JSON.stringify(SendUserPushNotificationRequest || {}) : (SendUserPushNotificationRequest || "");
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        sendUserSms: function (userId, SendUserSmsRequest, options) {
            if (options === void 0) { options = {}; }
            if (userId === null || userId === undefined) {
                throw new RequiredError('userId', 'Required parameter userId was null or undefined when calling sendUserSms.');
            }
            if (SendUserSmsRequest === null || SendUserSmsRequest === undefined) {
                throw new RequiredError('SendUserSmsRequest', 'Required parameter SendUserSmsRequest was null or undefined when calling sendUserSms.');
            }
            var localVarPath = "/api/v1.0/users/{userId}/sms"
                .replace("{".concat("userId", "}"), encodeURIComponent(String(userId)));
            var localVarUrlObj = url.parse(localVarPath, true);
            var localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            var localVarHeaderParameter = {};
            var localVarQueryParameter = {};
            if (configuration && configuration.accessToken) {
                var localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("oauth2", ["api"])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }
            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            var needsSerialization = ("SendUserSmsRequest" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body = needsSerialization ? JSON.stringify(SendUserSmsRequest || {}) : (SendUserSmsRequest || "");
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        setCustomerName: function (userId, body, options) {
            if (options === void 0) { options = {}; }
            if (userId === null || userId === undefined) {
                throw new RequiredError('userId', 'Required parameter userId was null or undefined when calling setCustomerName.');
            }
            if (body === null || body === undefined) {
                throw new RequiredError('body', 'Required parameter body was null or undefined when calling setCustomerName.');
            }
            var localVarPath = "/api/v1.0/users/{userId}/SetCustomerName"
                .replace("{".concat("userId", "}"), encodeURIComponent(String(userId)));
            var localVarUrlObj = url.parse(localVarPath, true);
            var localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            var localVarHeaderParameter = {};
            var localVarQueryParameter = {};
            if (configuration && configuration.accessToken) {
                var localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("oauth2", ["api"])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }
            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            var needsSerialization = ("string" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body = needsSerialization ? JSON.stringify(body || {}) : (body || "");
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        setFlipdishAccountIdForUser: function (userId, accountId, options) {
            if (options === void 0) { options = {}; }
            if (userId === null || userId === undefined) {
                throw new RequiredError('userId', 'Required parameter userId was null or undefined when calling setFlipdishAccountIdForUser.');
            }
            if (accountId === null || accountId === undefined) {
                throw new RequiredError('accountId', 'Required parameter accountId was null or undefined when calling setFlipdishAccountIdForUser.');
            }
            var localVarPath = "/api/v1.0/users/{userId}/SetFlipdishAccountId/{accountId}"
                .replace("{".concat("userId", "}"), encodeURIComponent(String(userId)))
                .replace("{".concat("accountId", "}"), encodeURIComponent(String(accountId)));
            var localVarUrlObj = url.parse(localVarPath, true);
            var localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            var localVarHeaderParameter = {};
            var localVarQueryParameter = {};
            if (configuration && configuration.accessToken) {
                var localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("oauth2", ["api"])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        setUserDeliveryLocationCoordinates: function (userId, deliveryLocationId, SetUserDeliveryLocationCoordinatesRequest, options) {
            if (options === void 0) { options = {}; }
            if (userId === null || userId === undefined) {
                throw new RequiredError('userId', 'Required parameter userId was null or undefined when calling setUserDeliveryLocationCoordinates.');
            }
            if (deliveryLocationId === null || deliveryLocationId === undefined) {
                throw new RequiredError('deliveryLocationId', 'Required parameter deliveryLocationId was null or undefined when calling setUserDeliveryLocationCoordinates.');
            }
            if (SetUserDeliveryLocationCoordinatesRequest === null || SetUserDeliveryLocationCoordinatesRequest === undefined) {
                throw new RequiredError('SetUserDeliveryLocationCoordinatesRequest', 'Required parameter SetUserDeliveryLocationCoordinatesRequest was null or undefined when calling setUserDeliveryLocationCoordinates.');
            }
            var localVarPath = "/api/v1.0/users/{userId}/deliveryLocations/{deliveryLocationId}/coordinates"
                .replace("{".concat("userId", "}"), encodeURIComponent(String(userId)))
                .replace("{".concat("deliveryLocationId", "}"), encodeURIComponent(String(deliveryLocationId)));
            var localVarUrlObj = url.parse(localVarPath, true);
            var localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            var localVarHeaderParameter = {};
            var localVarQueryParameter = {};
            if (configuration && configuration.accessToken) {
                var localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("oauth2", ["api"])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }
            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            var needsSerialization = ("SetUserDeliveryLocationCoordinatesRequest" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body = needsSerialization ? JSON.stringify(SetUserDeliveryLocationCoordinatesRequest || {}) : (SetUserDeliveryLocationCoordinatesRequest || "");
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        setUserDeliveryLocationField: function (userId, deliveryLocationId, SetUserDeliveryLocationFieldRequest, options) {
            if (options === void 0) { options = {}; }
            if (userId === null || userId === undefined) {
                throw new RequiredError('userId', 'Required parameter userId was null or undefined when calling setUserDeliveryLocationField.');
            }
            if (deliveryLocationId === null || deliveryLocationId === undefined) {
                throw new RequiredError('deliveryLocationId', 'Required parameter deliveryLocationId was null or undefined when calling setUserDeliveryLocationField.');
            }
            if (SetUserDeliveryLocationFieldRequest === null || SetUserDeliveryLocationFieldRequest === undefined) {
                throw new RequiredError('SetUserDeliveryLocationFieldRequest', 'Required parameter SetUserDeliveryLocationFieldRequest was null or undefined when calling setUserDeliveryLocationField.');
            }
            var localVarPath = "/api/v1.0/users/{userId}/deliveryLocations/{deliveryLocationId}/fields"
                .replace("{".concat("userId", "}"), encodeURIComponent(String(userId)))
                .replace("{".concat("deliveryLocationId", "}"), encodeURIComponent(String(deliveryLocationId)));
            var localVarUrlObj = url.parse(localVarPath, true);
            var localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            var localVarHeaderParameter = {};
            var localVarQueryParameter = {};
            if (configuration && configuration.accessToken) {
                var localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("oauth2", ["api"])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }
            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            var needsSerialization = ("SetUserDeliveryLocationFieldRequest" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body = needsSerialization ? JSON.stringify(SetUserDeliveryLocationFieldRequest || {}) : (SetUserDeliveryLocationFieldRequest || "");
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        setUserLanguage: function (userId, languageId, options) {
            if (options === void 0) { options = {}; }
            if (userId === null || userId === undefined) {
                throw new RequiredError('userId', 'Required parameter userId was null or undefined when calling setUserLanguage.');
            }
            if (languageId === null || languageId === undefined) {
                throw new RequiredError('languageId', 'Required parameter languageId was null or undefined when calling setUserLanguage.');
            }
            var localVarPath = "/api/v1.0/users/{userId}/SetLanguage/{languageId}"
                .replace("{".concat("userId", "}"), encodeURIComponent(String(userId)))
                .replace("{".concat("languageId", "}"), encodeURIComponent(String(languageId)));
            var localVarUrlObj = url.parse(localVarPath, true);
            var localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            var localVarHeaderParameter = {};
            var localVarQueryParameter = {};
            if (configuration && configuration.accessToken) {
                var localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("oauth2", ["api"])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        unblockUserPhoneNumber: function (userId, options) {
            if (options === void 0) { options = {}; }
            if (userId === null || userId === undefined) {
                throw new RequiredError('userId', 'Required parameter userId was null or undefined when calling unblockUserPhoneNumber.');
            }
            var localVarPath = "/api/v1.0/users/{userId}/UnblockUserPhoneNumber"
                .replace("{".concat("userId", "}"), encodeURIComponent(String(userId)));
            var localVarUrlObj = url.parse(localVarPath, true);
            var localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            var localVarHeaderParameter = {};
            var localVarQueryParameter = {};
            if (configuration && configuration.accessToken) {
                var localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("oauth2", ["api"])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    };
};
exports.UsersApiFetchParamCreator = UsersApiFetchParamCreator;
var UsersApiFp = function (configuration) {
    return {
        addUserNote: function (userId, body, options) {
            var localVarFetchArgs = (0, exports.UsersApiFetchParamCreator)(configuration).addUserNote(userId, body, options);
            return function (fetch, basePath) {
                if (fetch === void 0) { fetch = portableFetch; }
                if (basePath === void 0) { basePath = BASE_PATH; }
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then(function (response) {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
        addUserToRole: function (userId, roleName, options) {
            var localVarFetchArgs = (0, exports.UsersApiFetchParamCreator)(configuration).addUserToRole(userId, roleName, options);
            return function (fetch, basePath) {
                if (fetch === void 0) { fetch = portableFetch; }
                if (basePath === void 0) { basePath = BASE_PATH; }
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then(function (response) {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
        anonymizeUser: function (userId, options) {
            var localVarFetchArgs = (0, exports.UsersApiFetchParamCreator)(configuration).anonymizeUser(userId, options);
            return function (fetch, basePath) {
                if (fetch === void 0) { fetch = portableFetch; }
                if (basePath === void 0) { basePath = BASE_PATH; }
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then(function (response) {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
        blockUserPhoneNumber: function (userId, options) {
            var localVarFetchArgs = (0, exports.UsersApiFetchParamCreator)(configuration).blockUserPhoneNumber(userId, options);
            return function (fetch, basePath) {
                if (fetch === void 0) { fetch = portableFetch; }
                if (basePath === void 0) { basePath = BASE_PATH; }
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then(function (response) {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
        createUserDeliveryLocation: function (userId, CreateUserDeliveryLocationRequest, options) {
            var localVarFetchArgs = (0, exports.UsersApiFetchParamCreator)(configuration).createUserDeliveryLocation(userId, CreateUserDeliveryLocationRequest, options);
            return function (fetch, basePath) {
                if (fetch === void 0) { fetch = portableFetch; }
                if (basePath === void 0) { basePath = BASE_PATH; }
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then(function (response) {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
        getPreviousOrderCountForStore: function (userId, storeId, options) {
            var localVarFetchArgs = (0, exports.UsersApiFetchParamCreator)(configuration).getPreviousOrderCountForStore(userId, storeId, options);
            return function (fetch, basePath) {
                if (fetch === void 0) { fetch = portableFetch; }
                if (basePath === void 0) { basePath = BASE_PATH; }
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then(function (response) {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
        getRestaurantUserAccounts: function (userId, options) {
            var localVarFetchArgs = (0, exports.UsersApiFetchParamCreator)(configuration).getRestaurantUserAccounts(userId, options);
            return function (fetch, basePath) {
                if (fetch === void 0) { fetch = portableFetch; }
                if (basePath === void 0) { basePath = BASE_PATH; }
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then(function (response) {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
        getRestaurantUserStores: function (userId, options) {
            var localVarFetchArgs = (0, exports.UsersApiFetchParamCreator)(configuration).getRestaurantUserStores(userId, options);
            return function (fetch, basePath) {
                if (fetch === void 0) { fetch = portableFetch; }
                if (basePath === void 0) { basePath = BASE_PATH; }
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then(function (response) {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
        getRoles: function (options) {
            var localVarFetchArgs = (0, exports.UsersApiFetchParamCreator)(configuration).getRoles(options);
            return function (fetch, basePath) {
                if (fetch === void 0) { fetch = portableFetch; }
                if (basePath === void 0) { basePath = BASE_PATH; }
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then(function (response) {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
        getRolesAndUnassignedRoles: function (userId, options) {
            var localVarFetchArgs = (0, exports.UsersApiFetchParamCreator)(configuration).getRolesAndUnassignedRoles(userId, options);
            return function (fetch, basePath) {
                if (fetch === void 0) { fetch = portableFetch; }
                if (basePath === void 0) { basePath = BASE_PATH; }
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then(function (response) {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
        getUserById: function (userId, options) {
            var localVarFetchArgs = (0, exports.UsersApiFetchParamCreator)(configuration).getUserById(userId, options);
            return function (fetch, basePath) {
                if (fetch === void 0) { fetch = portableFetch; }
                if (basePath === void 0) { basePath = BASE_PATH; }
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then(function (response) {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
        getUserDeliveryLocationsForAdmin: function (userId, whiteLabelId, options) {
            var localVarFetchArgs = (0, exports.UsersApiFetchParamCreator)(configuration).getUserDeliveryLocationsForAdmin(userId, whiteLabelId, options);
            return function (fetch, basePath) {
                if (fetch === void 0) { fetch = portableFetch; }
                if (basePath === void 0) { basePath = BASE_PATH; }
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then(function (response) {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
        getUserNotes: function (userId, options) {
            var localVarFetchArgs = (0, exports.UsersApiFetchParamCreator)(configuration).getUserNotes(userId, options);
            return function (fetch, basePath) {
                if (fetch === void 0) { fetch = portableFetch; }
                if (basePath === void 0) { basePath = BASE_PATH; }
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then(function (response) {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
        getUserOrderByIdForAdmin: function (userId, orderId, options) {
            var localVarFetchArgs = (0, exports.UsersApiFetchParamCreator)(configuration).getUserOrderByIdForAdmin(userId, orderId, options);
            return function (fetch, basePath) {
                if (fetch === void 0) { fetch = portableFetch; }
                if (basePath === void 0) { basePath = BASE_PATH; }
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then(function (response) {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
        getUserOrdersForAdmin: function (userId, skip, take, brandId, options) {
            var localVarFetchArgs = (0, exports.UsersApiFetchParamCreator)(configuration).getUserOrdersForAdmin(userId, skip, take, brandId, options);
            return function (fetch, basePath) {
                if (fetch === void 0) { fetch = portableFetch; }
                if (basePath === void 0) { basePath = BASE_PATH; }
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then(function (response) {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
        getUserSmsConversationItems: function (userId, mostRecentCount, options) {
            var localVarFetchArgs = (0, exports.UsersApiFetchParamCreator)(configuration).getUserSmsConversationItems(userId, mostRecentCount, options);
            return function (fetch, basePath) {
                if (fetch === void 0) { fetch = portableFetch; }
                if (basePath === void 0) { basePath = BASE_PATH; }
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then(function (response) {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
        hideUserDeliveryLocation: function (userId, deliveryLocationId, options) {
            var localVarFetchArgs = (0, exports.UsersApiFetchParamCreator)(configuration).hideUserDeliveryLocation(userId, deliveryLocationId, options);
            return function (fetch, basePath) {
                if (fetch === void 0) { fetch = portableFetch; }
                if (basePath === void 0) { basePath = BASE_PATH; }
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then(function (response) {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
        markUserAsFraudulent: function (userId, options) {
            var localVarFetchArgs = (0, exports.UsersApiFetchParamCreator)(configuration).markUserAsFraudulent(userId, options);
            return function (fetch, basePath) {
                if (fetch === void 0) { fetch = portableFetch; }
                if (basePath === void 0) { basePath = BASE_PATH; }
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then(function (response) {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
        markUserAsSuspicious: function (userId, options) {
            var localVarFetchArgs = (0, exports.UsersApiFetchParamCreator)(configuration).markUserAsSuspicious(userId, options);
            return function (fetch, basePath) {
                if (fetch === void 0) { fetch = portableFetch; }
                if (basePath === void 0) { basePath = BASE_PATH; }
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then(function (response) {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
        removeFlipdishAccountIdForUser: function (userId, accountId, options) {
            var localVarFetchArgs = (0, exports.UsersApiFetchParamCreator)(configuration).removeFlipdishAccountIdForUser(userId, accountId, options);
            return function (fetch, basePath) {
                if (fetch === void 0) { fetch = portableFetch; }
                if (basePath === void 0) { basePath = BASE_PATH; }
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then(function (response) {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
        removeUserFromRole: function (userId, roleName, options) {
            var localVarFetchArgs = (0, exports.UsersApiFetchParamCreator)(configuration).removeUserFromRole(userId, roleName, options);
            return function (fetch, basePath) {
                if (fetch === void 0) { fetch = portableFetch; }
                if (basePath === void 0) { basePath = BASE_PATH; }
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then(function (response) {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
        resetMfa: function (userId, options) {
            var localVarFetchArgs = (0, exports.UsersApiFetchParamCreator)(configuration).resetMfa(userId, options);
            return function (fetch, basePath) {
                if (fetch === void 0) { fetch = portableFetch; }
                if (basePath === void 0) { basePath = BASE_PATH; }
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then(function (response) {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
        searchFlipdishAccounts: function (searchPattern, options) {
            var localVarFetchArgs = (0, exports.UsersApiFetchParamCreator)(configuration).searchFlipdishAccounts(searchPattern, options);
            return function (fetch, basePath) {
                if (fetch === void 0) { fetch = portableFetch; }
                if (basePath === void 0) { basePath = BASE_PATH; }
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then(function (response) {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
        searchUsers: function (searchQuery, hasUserLoggedIn, userDiscriminator, searchIn, pageIndex, pageSize, options) {
            var localVarFetchArgs = (0, exports.UsersApiFetchParamCreator)(configuration).searchUsers(searchQuery, hasUserLoggedIn, userDiscriminator, searchIn, pageIndex, pageSize, options);
            return function (fetch, basePath) {
                if (fetch === void 0) { fetch = portableFetch; }
                if (basePath === void 0) { basePath = BASE_PATH; }
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then(function (response) {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
        sendUserPushNotification: function (userId, SendUserPushNotificationRequest, options) {
            var localVarFetchArgs = (0, exports.UsersApiFetchParamCreator)(configuration).sendUserPushNotification(userId, SendUserPushNotificationRequest, options);
            return function (fetch, basePath) {
                if (fetch === void 0) { fetch = portableFetch; }
                if (basePath === void 0) { basePath = BASE_PATH; }
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then(function (response) {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
        sendUserSms: function (userId, SendUserSmsRequest, options) {
            var localVarFetchArgs = (0, exports.UsersApiFetchParamCreator)(configuration).sendUserSms(userId, SendUserSmsRequest, options);
            return function (fetch, basePath) {
                if (fetch === void 0) { fetch = portableFetch; }
                if (basePath === void 0) { basePath = BASE_PATH; }
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then(function (response) {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
        setCustomerName: function (userId, body, options) {
            var localVarFetchArgs = (0, exports.UsersApiFetchParamCreator)(configuration).setCustomerName(userId, body, options);
            return function (fetch, basePath) {
                if (fetch === void 0) { fetch = portableFetch; }
                if (basePath === void 0) { basePath = BASE_PATH; }
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then(function (response) {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
        setFlipdishAccountIdForUser: function (userId, accountId, options) {
            var localVarFetchArgs = (0, exports.UsersApiFetchParamCreator)(configuration).setFlipdishAccountIdForUser(userId, accountId, options);
            return function (fetch, basePath) {
                if (fetch === void 0) { fetch = portableFetch; }
                if (basePath === void 0) { basePath = BASE_PATH; }
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then(function (response) {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
        setUserDeliveryLocationCoordinates: function (userId, deliveryLocationId, SetUserDeliveryLocationCoordinatesRequest, options) {
            var localVarFetchArgs = (0, exports.UsersApiFetchParamCreator)(configuration).setUserDeliveryLocationCoordinates(userId, deliveryLocationId, SetUserDeliveryLocationCoordinatesRequest, options);
            return function (fetch, basePath) {
                if (fetch === void 0) { fetch = portableFetch; }
                if (basePath === void 0) { basePath = BASE_PATH; }
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then(function (response) {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
        setUserDeliveryLocationField: function (userId, deliveryLocationId, SetUserDeliveryLocationFieldRequest, options) {
            var localVarFetchArgs = (0, exports.UsersApiFetchParamCreator)(configuration).setUserDeliveryLocationField(userId, deliveryLocationId, SetUserDeliveryLocationFieldRequest, options);
            return function (fetch, basePath) {
                if (fetch === void 0) { fetch = portableFetch; }
                if (basePath === void 0) { basePath = BASE_PATH; }
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then(function (response) {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
        setUserLanguage: function (userId, languageId, options) {
            var localVarFetchArgs = (0, exports.UsersApiFetchParamCreator)(configuration).setUserLanguage(userId, languageId, options);
            return function (fetch, basePath) {
                if (fetch === void 0) { fetch = portableFetch; }
                if (basePath === void 0) { basePath = BASE_PATH; }
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then(function (response) {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
        unblockUserPhoneNumber: function (userId, options) {
            var localVarFetchArgs = (0, exports.UsersApiFetchParamCreator)(configuration).unblockUserPhoneNumber(userId, options);
            return function (fetch, basePath) {
                if (fetch === void 0) { fetch = portableFetch; }
                if (basePath === void 0) { basePath = BASE_PATH; }
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then(function (response) {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
    };
};
exports.UsersApiFp = UsersApiFp;
var UsersApiFactory = function (configuration, fetch, basePath) {
    return {
        addUserNote: function (userId, body, options) {
            return (0, exports.UsersApiFp)(configuration).addUserNote(userId, body, options)(fetch, basePath);
        },
        addUserToRole: function (userId, roleName, options) {
            return (0, exports.UsersApiFp)(configuration).addUserToRole(userId, roleName, options)(fetch, basePath);
        },
        anonymizeUser: function (userId, options) {
            return (0, exports.UsersApiFp)(configuration).anonymizeUser(userId, options)(fetch, basePath);
        },
        blockUserPhoneNumber: function (userId, options) {
            return (0, exports.UsersApiFp)(configuration).blockUserPhoneNumber(userId, options)(fetch, basePath);
        },
        createUserDeliveryLocation: function (userId, CreateUserDeliveryLocationRequest, options) {
            return (0, exports.UsersApiFp)(configuration).createUserDeliveryLocation(userId, CreateUserDeliveryLocationRequest, options)(fetch, basePath);
        },
        getPreviousOrderCountForStore: function (userId, storeId, options) {
            return (0, exports.UsersApiFp)(configuration).getPreviousOrderCountForStore(userId, storeId, options)(fetch, basePath);
        },
        getRestaurantUserAccounts: function (userId, options) {
            return (0, exports.UsersApiFp)(configuration).getRestaurantUserAccounts(userId, options)(fetch, basePath);
        },
        getRestaurantUserStores: function (userId, options) {
            return (0, exports.UsersApiFp)(configuration).getRestaurantUserStores(userId, options)(fetch, basePath);
        },
        getRoles: function (options) {
            return (0, exports.UsersApiFp)(configuration).getRoles(options)(fetch, basePath);
        },
        getRolesAndUnassignedRoles: function (userId, options) {
            return (0, exports.UsersApiFp)(configuration).getRolesAndUnassignedRoles(userId, options)(fetch, basePath);
        },
        getUserById: function (userId, options) {
            return (0, exports.UsersApiFp)(configuration).getUserById(userId, options)(fetch, basePath);
        },
        getUserDeliveryLocationsForAdmin: function (userId, whiteLabelId, options) {
            return (0, exports.UsersApiFp)(configuration).getUserDeliveryLocationsForAdmin(userId, whiteLabelId, options)(fetch, basePath);
        },
        getUserNotes: function (userId, options) {
            return (0, exports.UsersApiFp)(configuration).getUserNotes(userId, options)(fetch, basePath);
        },
        getUserOrderByIdForAdmin: function (userId, orderId, options) {
            return (0, exports.UsersApiFp)(configuration).getUserOrderByIdForAdmin(userId, orderId, options)(fetch, basePath);
        },
        getUserOrdersForAdmin: function (userId, skip, take, brandId, options) {
            return (0, exports.UsersApiFp)(configuration).getUserOrdersForAdmin(userId, skip, take, brandId, options)(fetch, basePath);
        },
        getUserSmsConversationItems: function (userId, mostRecentCount, options) {
            return (0, exports.UsersApiFp)(configuration).getUserSmsConversationItems(userId, mostRecentCount, options)(fetch, basePath);
        },
        hideUserDeliveryLocation: function (userId, deliveryLocationId, options) {
            return (0, exports.UsersApiFp)(configuration).hideUserDeliveryLocation(userId, deliveryLocationId, options)(fetch, basePath);
        },
        markUserAsFraudulent: function (userId, options) {
            return (0, exports.UsersApiFp)(configuration).markUserAsFraudulent(userId, options)(fetch, basePath);
        },
        markUserAsSuspicious: function (userId, options) {
            return (0, exports.UsersApiFp)(configuration).markUserAsSuspicious(userId, options)(fetch, basePath);
        },
        removeFlipdishAccountIdForUser: function (userId, accountId, options) {
            return (0, exports.UsersApiFp)(configuration).removeFlipdishAccountIdForUser(userId, accountId, options)(fetch, basePath);
        },
        removeUserFromRole: function (userId, roleName, options) {
            return (0, exports.UsersApiFp)(configuration).removeUserFromRole(userId, roleName, options)(fetch, basePath);
        },
        resetMfa: function (userId, options) {
            return (0, exports.UsersApiFp)(configuration).resetMfa(userId, options)(fetch, basePath);
        },
        searchFlipdishAccounts: function (searchPattern, options) {
            return (0, exports.UsersApiFp)(configuration).searchFlipdishAccounts(searchPattern, options)(fetch, basePath);
        },
        searchUsers: function (searchQuery, hasUserLoggedIn, userDiscriminator, searchIn, pageIndex, pageSize, options) {
            return (0, exports.UsersApiFp)(configuration).searchUsers(searchQuery, hasUserLoggedIn, userDiscriminator, searchIn, pageIndex, pageSize, options)(fetch, basePath);
        },
        sendUserPushNotification: function (userId, SendUserPushNotificationRequest, options) {
            return (0, exports.UsersApiFp)(configuration).sendUserPushNotification(userId, SendUserPushNotificationRequest, options)(fetch, basePath);
        },
        sendUserSms: function (userId, SendUserSmsRequest, options) {
            return (0, exports.UsersApiFp)(configuration).sendUserSms(userId, SendUserSmsRequest, options)(fetch, basePath);
        },
        setCustomerName: function (userId, body, options) {
            return (0, exports.UsersApiFp)(configuration).setCustomerName(userId, body, options)(fetch, basePath);
        },
        setFlipdishAccountIdForUser: function (userId, accountId, options) {
            return (0, exports.UsersApiFp)(configuration).setFlipdishAccountIdForUser(userId, accountId, options)(fetch, basePath);
        },
        setUserDeliveryLocationCoordinates: function (userId, deliveryLocationId, SetUserDeliveryLocationCoordinatesRequest, options) {
            return (0, exports.UsersApiFp)(configuration).setUserDeliveryLocationCoordinates(userId, deliveryLocationId, SetUserDeliveryLocationCoordinatesRequest, options)(fetch, basePath);
        },
        setUserDeliveryLocationField: function (userId, deliveryLocationId, SetUserDeliveryLocationFieldRequest, options) {
            return (0, exports.UsersApiFp)(configuration).setUserDeliveryLocationField(userId, deliveryLocationId, SetUserDeliveryLocationFieldRequest, options)(fetch, basePath);
        },
        setUserLanguage: function (userId, languageId, options) {
            return (0, exports.UsersApiFp)(configuration).setUserLanguage(userId, languageId, options)(fetch, basePath);
        },
        unblockUserPhoneNumber: function (userId, options) {
            return (0, exports.UsersApiFp)(configuration).unblockUserPhoneNumber(userId, options)(fetch, basePath);
        },
    };
};
exports.UsersApiFactory = UsersApiFactory;
var UsersApi = (function (_super) {
    __extends(UsersApi, _super);
    function UsersApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    UsersApi.prototype.addUserNote = function (userId, body, options) {
        return (0, exports.UsersApiFp)(this.configuration).addUserNote(userId, body, options)(this.fetch, this.basePath);
    };
    UsersApi.prototype.addUserToRole = function (userId, roleName, options) {
        return (0, exports.UsersApiFp)(this.configuration).addUserToRole(userId, roleName, options)(this.fetch, this.basePath);
    };
    UsersApi.prototype.anonymizeUser = function (userId, options) {
        return (0, exports.UsersApiFp)(this.configuration).anonymizeUser(userId, options)(this.fetch, this.basePath);
    };
    UsersApi.prototype.blockUserPhoneNumber = function (userId, options) {
        return (0, exports.UsersApiFp)(this.configuration).blockUserPhoneNumber(userId, options)(this.fetch, this.basePath);
    };
    UsersApi.prototype.createUserDeliveryLocation = function (userId, CreateUserDeliveryLocationRequest, options) {
        return (0, exports.UsersApiFp)(this.configuration).createUserDeliveryLocation(userId, CreateUserDeliveryLocationRequest, options)(this.fetch, this.basePath);
    };
    UsersApi.prototype.getPreviousOrderCountForStore = function (userId, storeId, options) {
        return (0, exports.UsersApiFp)(this.configuration).getPreviousOrderCountForStore(userId, storeId, options)(this.fetch, this.basePath);
    };
    UsersApi.prototype.getRestaurantUserAccounts = function (userId, options) {
        return (0, exports.UsersApiFp)(this.configuration).getRestaurantUserAccounts(userId, options)(this.fetch, this.basePath);
    };
    UsersApi.prototype.getRestaurantUserStores = function (userId, options) {
        return (0, exports.UsersApiFp)(this.configuration).getRestaurantUserStores(userId, options)(this.fetch, this.basePath);
    };
    UsersApi.prototype.getRoles = function (options) {
        return (0, exports.UsersApiFp)(this.configuration).getRoles(options)(this.fetch, this.basePath);
    };
    UsersApi.prototype.getRolesAndUnassignedRoles = function (userId, options) {
        return (0, exports.UsersApiFp)(this.configuration).getRolesAndUnassignedRoles(userId, options)(this.fetch, this.basePath);
    };
    UsersApi.prototype.getUserById = function (userId, options) {
        return (0, exports.UsersApiFp)(this.configuration).getUserById(userId, options)(this.fetch, this.basePath);
    };
    UsersApi.prototype.getUserDeliveryLocationsForAdmin = function (userId, whiteLabelId, options) {
        return (0, exports.UsersApiFp)(this.configuration).getUserDeliveryLocationsForAdmin(userId, whiteLabelId, options)(this.fetch, this.basePath);
    };
    UsersApi.prototype.getUserNotes = function (userId, options) {
        return (0, exports.UsersApiFp)(this.configuration).getUserNotes(userId, options)(this.fetch, this.basePath);
    };
    UsersApi.prototype.getUserOrderByIdForAdmin = function (userId, orderId, options) {
        return (0, exports.UsersApiFp)(this.configuration).getUserOrderByIdForAdmin(userId, orderId, options)(this.fetch, this.basePath);
    };
    UsersApi.prototype.getUserOrdersForAdmin = function (userId, skip, take, brandId, options) {
        return (0, exports.UsersApiFp)(this.configuration).getUserOrdersForAdmin(userId, skip, take, brandId, options)(this.fetch, this.basePath);
    };
    UsersApi.prototype.getUserSmsConversationItems = function (userId, mostRecentCount, options) {
        return (0, exports.UsersApiFp)(this.configuration).getUserSmsConversationItems(userId, mostRecentCount, options)(this.fetch, this.basePath);
    };
    UsersApi.prototype.hideUserDeliveryLocation = function (userId, deliveryLocationId, options) {
        return (0, exports.UsersApiFp)(this.configuration).hideUserDeliveryLocation(userId, deliveryLocationId, options)(this.fetch, this.basePath);
    };
    UsersApi.prototype.markUserAsFraudulent = function (userId, options) {
        return (0, exports.UsersApiFp)(this.configuration).markUserAsFraudulent(userId, options)(this.fetch, this.basePath);
    };
    UsersApi.prototype.markUserAsSuspicious = function (userId, options) {
        return (0, exports.UsersApiFp)(this.configuration).markUserAsSuspicious(userId, options)(this.fetch, this.basePath);
    };
    UsersApi.prototype.removeFlipdishAccountIdForUser = function (userId, accountId, options) {
        return (0, exports.UsersApiFp)(this.configuration).removeFlipdishAccountIdForUser(userId, accountId, options)(this.fetch, this.basePath);
    };
    UsersApi.prototype.removeUserFromRole = function (userId, roleName, options) {
        return (0, exports.UsersApiFp)(this.configuration).removeUserFromRole(userId, roleName, options)(this.fetch, this.basePath);
    };
    UsersApi.prototype.resetMfa = function (userId, options) {
        return (0, exports.UsersApiFp)(this.configuration).resetMfa(userId, options)(this.fetch, this.basePath);
    };
    UsersApi.prototype.searchFlipdishAccounts = function (searchPattern, options) {
        return (0, exports.UsersApiFp)(this.configuration).searchFlipdishAccounts(searchPattern, options)(this.fetch, this.basePath);
    };
    UsersApi.prototype.searchUsers = function (searchQuery, hasUserLoggedIn, userDiscriminator, searchIn, pageIndex, pageSize, options) {
        return (0, exports.UsersApiFp)(this.configuration).searchUsers(searchQuery, hasUserLoggedIn, userDiscriminator, searchIn, pageIndex, pageSize, options)(this.fetch, this.basePath);
    };
    UsersApi.prototype.sendUserPushNotification = function (userId, SendUserPushNotificationRequest, options) {
        return (0, exports.UsersApiFp)(this.configuration).sendUserPushNotification(userId, SendUserPushNotificationRequest, options)(this.fetch, this.basePath);
    };
    UsersApi.prototype.sendUserSms = function (userId, SendUserSmsRequest, options) {
        return (0, exports.UsersApiFp)(this.configuration).sendUserSms(userId, SendUserSmsRequest, options)(this.fetch, this.basePath);
    };
    UsersApi.prototype.setCustomerName = function (userId, body, options) {
        return (0, exports.UsersApiFp)(this.configuration).setCustomerName(userId, body, options)(this.fetch, this.basePath);
    };
    UsersApi.prototype.setFlipdishAccountIdForUser = function (userId, accountId, options) {
        return (0, exports.UsersApiFp)(this.configuration).setFlipdishAccountIdForUser(userId, accountId, options)(this.fetch, this.basePath);
    };
    UsersApi.prototype.setUserDeliveryLocationCoordinates = function (userId, deliveryLocationId, SetUserDeliveryLocationCoordinatesRequest, options) {
        return (0, exports.UsersApiFp)(this.configuration).setUserDeliveryLocationCoordinates(userId, deliveryLocationId, SetUserDeliveryLocationCoordinatesRequest, options)(this.fetch, this.basePath);
    };
    UsersApi.prototype.setUserDeliveryLocationField = function (userId, deliveryLocationId, SetUserDeliveryLocationFieldRequest, options) {
        return (0, exports.UsersApiFp)(this.configuration).setUserDeliveryLocationField(userId, deliveryLocationId, SetUserDeliveryLocationFieldRequest, options)(this.fetch, this.basePath);
    };
    UsersApi.prototype.setUserLanguage = function (userId, languageId, options) {
        return (0, exports.UsersApiFp)(this.configuration).setUserLanguage(userId, languageId, options)(this.fetch, this.basePath);
    };
    UsersApi.prototype.unblockUserPhoneNumber = function (userId, options) {
        return (0, exports.UsersApiFp)(this.configuration).unblockUserPhoneNumber(userId, options)(this.fetch, this.basePath);
    };
    return UsersApi;
}(BaseAPI));
exports.UsersApi = UsersApi;
var VouchersApiFetchParamCreator = function (configuration) {
    return {
        createVoucher: function (appId, CreateVoucher, options) {
            if (options === void 0) { options = {}; }
            if (appId === null || appId === undefined) {
                throw new RequiredError('appId', 'Required parameter appId was null or undefined when calling createVoucher.');
            }
            if (CreateVoucher === null || CreateVoucher === undefined) {
                throw new RequiredError('CreateVoucher', 'Required parameter CreateVoucher was null or undefined when calling createVoucher.');
            }
            var localVarPath = "/api/v1.0/vouchers/{appId}"
                .replace("{".concat("appId", "}"), encodeURIComponent(String(appId)));
            var localVarUrlObj = url.parse(localVarPath, true);
            var localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            var localVarHeaderParameter = {};
            var localVarQueryParameter = {};
            if (configuration && configuration.accessToken) {
                var localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("oauth2", ["api"])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }
            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            var needsSerialization = ("CreateVoucher" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body = needsSerialization ? JSON.stringify(CreateVoucher || {}) : (CreateVoucher || "");
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        getVoucherByCode: function (appId, code, options) {
            if (options === void 0) { options = {}; }
            if (appId === null || appId === undefined) {
                throw new RequiredError('appId', 'Required parameter appId was null or undefined when calling getVoucherByCode.');
            }
            if (code === null || code === undefined) {
                throw new RequiredError('code', 'Required parameter code was null or undefined when calling getVoucherByCode.');
            }
            var localVarPath = "/api/v1.0/{appId}/vouchers/code/{code}"
                .replace("{".concat("appId", "}"), encodeURIComponent(String(appId)))
                .replace("{".concat("code", "}"), encodeURIComponent(String(code)));
            var localVarUrlObj = url.parse(localVarPath, true);
            var localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            var localVarHeaderParameter = {};
            var localVarQueryParameter = {};
            if (configuration && configuration.accessToken) {
                var localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("oauth2", ["api"])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        getVoucherById: function (voucherId, options) {
            if (options === void 0) { options = {}; }
            if (voucherId === null || voucherId === undefined) {
                throw new RequiredError('voucherId', 'Required parameter voucherId was null or undefined when calling getVoucherById.');
            }
            var localVarPath = "/api/v1.0/vouchers/{voucherId}"
                .replace("{".concat("voucherId", "}"), encodeURIComponent(String(voucherId)));
            var localVarUrlObj = url.parse(localVarPath, true);
            var localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            var localVarHeaderParameter = {};
            var localVarQueryParameter = {};
            if (configuration && configuration.accessToken) {
                var localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("oauth2", ["api"])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        getVoucherStatsById: function (voucherId, aggregateDataBy, dataPointLimit, options) {
            if (options === void 0) { options = {}; }
            if (voucherId === null || voucherId === undefined) {
                throw new RequiredError('voucherId', 'Required parameter voucherId was null or undefined when calling getVoucherStatsById.');
            }
            if (aggregateDataBy === null || aggregateDataBy === undefined) {
                throw new RequiredError('aggregateDataBy', 'Required parameter aggregateDataBy was null or undefined when calling getVoucherStatsById.');
            }
            var localVarPath = "/api/v1.0/vouchers/stats/{voucherId}"
                .replace("{".concat("voucherId", "}"), encodeURIComponent(String(voucherId)));
            var localVarUrlObj = url.parse(localVarPath, true);
            var localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            var localVarHeaderParameter = {};
            var localVarQueryParameter = {};
            if (configuration && configuration.accessToken) {
                var localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("oauth2", ["api"])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }
            if (aggregateDataBy !== undefined) {
                localVarQueryParameter['aggregateDataBy'] = aggregateDataBy;
            }
            if (dataPointLimit !== undefined) {
                localVarQueryParameter['dataPointLimit'] = dataPointLimit;
            }
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        getVoucherValidityPeriods: function (appId, voucherId, options) {
            if (options === void 0) { options = {}; }
            if (appId === null || appId === undefined) {
                throw new RequiredError('appId', 'Required parameter appId was null or undefined when calling getVoucherValidityPeriods.');
            }
            if (voucherId === null || voucherId === undefined) {
                throw new RequiredError('voucherId', 'Required parameter voucherId was null or undefined when calling getVoucherValidityPeriods.');
            }
            var localVarPath = "/api/v1.0/{appId}/vouchers/{voucherId}/validity-periods"
                .replace("{".concat("appId", "}"), encodeURIComponent(String(appId)))
                .replace("{".concat("voucherId", "}"), encodeURIComponent(String(voucherId)));
            var localVarUrlObj = url.parse(localVarPath, true);
            var localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            var localVarHeaderParameter = {};
            var localVarQueryParameter = {};
            if (configuration && configuration.accessToken) {
                var localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("oauth2", ["api"])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        getVouchers: function (appId, pageIndex, pageSize, searchCodes, statusSearch, typeSearch, subTypeSearch, storeIds, channelRestrictions, options) {
            if (options === void 0) { options = {}; }
            if (appId === null || appId === undefined) {
                throw new RequiredError('appId', 'Required parameter appId was null or undefined when calling getVouchers.');
            }
            var localVarPath = "/api/v1.0/{appId}/vouchers/summaries"
                .replace("{".concat("appId", "}"), encodeURIComponent(String(appId)));
            var localVarUrlObj = url.parse(localVarPath, true);
            var localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            var localVarHeaderParameter = {};
            var localVarQueryParameter = {};
            if (configuration && configuration.accessToken) {
                var localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("oauth2", ["api"])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }
            if (pageIndex !== undefined) {
                localVarQueryParameter['pageIndex'] = pageIndex;
            }
            if (pageSize !== undefined) {
                localVarQueryParameter['pageSize'] = pageSize;
            }
            if (searchCodes) {
                localVarQueryParameter['searchCodes'] = searchCodes;
            }
            if (statusSearch) {
                localVarQueryParameter['statusSearch'] = statusSearch;
            }
            if (typeSearch) {
                localVarQueryParameter['typeSearch'] = typeSearch;
            }
            if (subTypeSearch) {
                localVarQueryParameter['subTypeSearch'] = subTypeSearch;
            }
            if (storeIds) {
                localVarQueryParameter['storeIds'] = storeIds;
            }
            if (channelRestrictions) {
                localVarQueryParameter['channelRestrictions'] = channelRestrictions;
            }
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        getVouchersByCustomerForApp: function (appId, customerId, options) {
            if (options === void 0) { options = {}; }
            if (appId === null || appId === undefined) {
                throw new RequiredError('appId', 'Required parameter appId was null or undefined when calling getVouchersByCustomerForApp.');
            }
            if (customerId === null || customerId === undefined) {
                throw new RequiredError('customerId', 'Required parameter customerId was null or undefined when calling getVouchersByCustomerForApp.');
            }
            var localVarPath = "/api/v1.0/vouchers/{appId}/customer/{customerId}"
                .replace("{".concat("appId", "}"), encodeURIComponent(String(appId)))
                .replace("{".concat("customerId", "}"), encodeURIComponent(String(customerId)));
            var localVarUrlObj = url.parse(localVarPath, true);
            var localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            var localVarHeaderParameter = {};
            var localVarQueryParameter = {};
            if (configuration && configuration.accessToken) {
                var localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("oauth2", ["api"])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        setVoucherValidityPeriodsSimplified: function (appId, voucherId, SetVoucherValidityPeriodsSimplifiedRequest, options) {
            if (options === void 0) { options = {}; }
            if (appId === null || appId === undefined) {
                throw new RequiredError('appId', 'Required parameter appId was null or undefined when calling setVoucherValidityPeriodsSimplified.');
            }
            if (voucherId === null || voucherId === undefined) {
                throw new RequiredError('voucherId', 'Required parameter voucherId was null or undefined when calling setVoucherValidityPeriodsSimplified.');
            }
            if (SetVoucherValidityPeriodsSimplifiedRequest === null || SetVoucherValidityPeriodsSimplifiedRequest === undefined) {
                throw new RequiredError('SetVoucherValidityPeriodsSimplifiedRequest', 'Required parameter SetVoucherValidityPeriodsSimplifiedRequest was null or undefined when calling setVoucherValidityPeriodsSimplified.');
            }
            var localVarPath = "/api/v1.0/{appId}/vouchers/{voucherId}/validity-periods-simplified"
                .replace("{".concat("appId", "}"), encodeURIComponent(String(appId)))
                .replace("{".concat("voucherId", "}"), encodeURIComponent(String(voucherId)));
            var localVarUrlObj = url.parse(localVarPath, true);
            var localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            var localVarHeaderParameter = {};
            var localVarQueryParameter = {};
            if (configuration && configuration.accessToken) {
                var localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("oauth2", ["api"])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }
            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            var needsSerialization = ("SetVoucherValidityPeriodsSimplifiedRequest" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body = needsSerialization ? JSON.stringify(SetVoucherValidityPeriodsSimplifiedRequest || {}) : (SetVoucherValidityPeriodsSimplifiedRequest || "");
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        updateVoucher: function (voucherId, UpdateVoucher, storeId, percentValue, lumpValue, maxDiscountAmount, options) {
            if (options === void 0) { options = {}; }
            if (voucherId === null || voucherId === undefined) {
                throw new RequiredError('voucherId', 'Required parameter voucherId was null or undefined when calling updateVoucher.');
            }
            if (UpdateVoucher === null || UpdateVoucher === undefined) {
                throw new RequiredError('UpdateVoucher', 'Required parameter UpdateVoucher was null or undefined when calling updateVoucher.');
            }
            var localVarPath = "/api/v1.0/vouchers/{voucherId}"
                .replace("{".concat("voucherId", "}"), encodeURIComponent(String(voucherId)));
            var localVarUrlObj = url.parse(localVarPath, true);
            var localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            var localVarHeaderParameter = {};
            var localVarQueryParameter = {};
            if (configuration && configuration.accessToken) {
                var localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("oauth2", ["api"])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }
            if (storeId) {
                localVarQueryParameter['storeId'] = storeId;
            }
            if (percentValue !== undefined) {
                localVarQueryParameter['percentValue'] = percentValue;
            }
            if (lumpValue !== undefined) {
                localVarQueryParameter['lumpValue'] = lumpValue;
            }
            if (maxDiscountAmount !== undefined) {
                localVarQueryParameter['maxDiscountAmount'] = maxDiscountAmount;
            }
            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            var needsSerialization = ("UpdateVoucher" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body = needsSerialization ? JSON.stringify(UpdateVoucher || {}) : (UpdateVoucher || "");
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        updateVoucherUsage: function (appId, voucherId, UpdateVoucherUsage, options) {
            if (options === void 0) { options = {}; }
            if (appId === null || appId === undefined) {
                throw new RequiredError('appId', 'Required parameter appId was null or undefined when calling updateVoucherUsage.');
            }
            if (voucherId === null || voucherId === undefined) {
                throw new RequiredError('voucherId', 'Required parameter voucherId was null or undefined when calling updateVoucherUsage.');
            }
            if (UpdateVoucherUsage === null || UpdateVoucherUsage === undefined) {
                throw new RequiredError('UpdateVoucherUsage', 'Required parameter UpdateVoucherUsage was null or undefined when calling updateVoucherUsage.');
            }
            var localVarPath = "/api/v1.0/{appId}/vouchers/{voucherId}/usage"
                .replace("{".concat("appId", "}"), encodeURIComponent(String(appId)))
                .replace("{".concat("voucherId", "}"), encodeURIComponent(String(voucherId)));
            var localVarUrlObj = url.parse(localVarPath, true);
            var localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            var localVarHeaderParameter = {};
            var localVarQueryParameter = {};
            if (configuration && configuration.accessToken) {
                var localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("oauth2", ["api"])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }
            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            var needsSerialization = ("UpdateVoucherUsage" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body = needsSerialization ? JSON.stringify(UpdateVoucherUsage || {}) : (UpdateVoucherUsage || "");
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    };
};
exports.VouchersApiFetchParamCreator = VouchersApiFetchParamCreator;
var VouchersApiFp = function (configuration) {
    return {
        createVoucher: function (appId, CreateVoucher, options) {
            var localVarFetchArgs = (0, exports.VouchersApiFetchParamCreator)(configuration).createVoucher(appId, CreateVoucher, options);
            return function (fetch, basePath) {
                if (fetch === void 0) { fetch = portableFetch; }
                if (basePath === void 0) { basePath = BASE_PATH; }
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then(function (response) {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
        getVoucherByCode: function (appId, code, options) {
            var localVarFetchArgs = (0, exports.VouchersApiFetchParamCreator)(configuration).getVoucherByCode(appId, code, options);
            return function (fetch, basePath) {
                if (fetch === void 0) { fetch = portableFetch; }
                if (basePath === void 0) { basePath = BASE_PATH; }
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then(function (response) {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
        getVoucherById: function (voucherId, options) {
            var localVarFetchArgs = (0, exports.VouchersApiFetchParamCreator)(configuration).getVoucherById(voucherId, options);
            return function (fetch, basePath) {
                if (fetch === void 0) { fetch = portableFetch; }
                if (basePath === void 0) { basePath = BASE_PATH; }
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then(function (response) {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
        getVoucherStatsById: function (voucherId, aggregateDataBy, dataPointLimit, options) {
            var localVarFetchArgs = (0, exports.VouchersApiFetchParamCreator)(configuration).getVoucherStatsById(voucherId, aggregateDataBy, dataPointLimit, options);
            return function (fetch, basePath) {
                if (fetch === void 0) { fetch = portableFetch; }
                if (basePath === void 0) { basePath = BASE_PATH; }
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then(function (response) {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
        getVoucherValidityPeriods: function (appId, voucherId, options) {
            var localVarFetchArgs = (0, exports.VouchersApiFetchParamCreator)(configuration).getVoucherValidityPeriods(appId, voucherId, options);
            return function (fetch, basePath) {
                if (fetch === void 0) { fetch = portableFetch; }
                if (basePath === void 0) { basePath = BASE_PATH; }
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then(function (response) {
                    if (response.status >= 200 && response.status < 300) {
                        return response;
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
        getVouchers: function (appId, pageIndex, pageSize, searchCodes, statusSearch, typeSearch, subTypeSearch, storeIds, channelRestrictions, options) {
            var localVarFetchArgs = (0, exports.VouchersApiFetchParamCreator)(configuration).getVouchers(appId, pageIndex, pageSize, searchCodes, statusSearch, typeSearch, subTypeSearch, storeIds, channelRestrictions, options);
            return function (fetch, basePath) {
                if (fetch === void 0) { fetch = portableFetch; }
                if (basePath === void 0) { basePath = BASE_PATH; }
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then(function (response) {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
        getVouchersByCustomerForApp: function (appId, customerId, options) {
            var localVarFetchArgs = (0, exports.VouchersApiFetchParamCreator)(configuration).getVouchersByCustomerForApp(appId, customerId, options);
            return function (fetch, basePath) {
                if (fetch === void 0) { fetch = portableFetch; }
                if (basePath === void 0) { basePath = BASE_PATH; }
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then(function (response) {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
        setVoucherValidityPeriodsSimplified: function (appId, voucherId, SetVoucherValidityPeriodsSimplifiedRequest, options) {
            var localVarFetchArgs = (0, exports.VouchersApiFetchParamCreator)(configuration).setVoucherValidityPeriodsSimplified(appId, voucherId, SetVoucherValidityPeriodsSimplifiedRequest, options);
            return function (fetch, basePath) {
                if (fetch === void 0) { fetch = portableFetch; }
                if (basePath === void 0) { basePath = BASE_PATH; }
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then(function (response) {
                    if (response.status >= 200 && response.status < 300) {
                        return response;
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
        updateVoucher: function (voucherId, UpdateVoucher, storeId, percentValue, lumpValue, maxDiscountAmount, options) {
            var localVarFetchArgs = (0, exports.VouchersApiFetchParamCreator)(configuration).updateVoucher(voucherId, UpdateVoucher, storeId, percentValue, lumpValue, maxDiscountAmount, options);
            return function (fetch, basePath) {
                if (fetch === void 0) { fetch = portableFetch; }
                if (basePath === void 0) { basePath = BASE_PATH; }
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then(function (response) {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
        updateVoucherUsage: function (appId, voucherId, UpdateVoucherUsage, options) {
            var localVarFetchArgs = (0, exports.VouchersApiFetchParamCreator)(configuration).updateVoucherUsage(appId, voucherId, UpdateVoucherUsage, options);
            return function (fetch, basePath) {
                if (fetch === void 0) { fetch = portableFetch; }
                if (basePath === void 0) { basePath = BASE_PATH; }
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then(function (response) {
                    if (response.status >= 200 && response.status < 300) {
                        return response;
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
    };
};
exports.VouchersApiFp = VouchersApiFp;
var VouchersApiFactory = function (configuration, fetch, basePath) {
    return {
        createVoucher: function (appId, CreateVoucher, options) {
            return (0, exports.VouchersApiFp)(configuration).createVoucher(appId, CreateVoucher, options)(fetch, basePath);
        },
        getVoucherByCode: function (appId, code, options) {
            return (0, exports.VouchersApiFp)(configuration).getVoucherByCode(appId, code, options)(fetch, basePath);
        },
        getVoucherById: function (voucherId, options) {
            return (0, exports.VouchersApiFp)(configuration).getVoucherById(voucherId, options)(fetch, basePath);
        },
        getVoucherStatsById: function (voucherId, aggregateDataBy, dataPointLimit, options) {
            return (0, exports.VouchersApiFp)(configuration).getVoucherStatsById(voucherId, aggregateDataBy, dataPointLimit, options)(fetch, basePath);
        },
        getVoucherValidityPeriods: function (appId, voucherId, options) {
            return (0, exports.VouchersApiFp)(configuration).getVoucherValidityPeriods(appId, voucherId, options)(fetch, basePath);
        },
        getVouchers: function (appId, pageIndex, pageSize, searchCodes, statusSearch, typeSearch, subTypeSearch, storeIds, channelRestrictions, options) {
            return (0, exports.VouchersApiFp)(configuration).getVouchers(appId, pageIndex, pageSize, searchCodes, statusSearch, typeSearch, subTypeSearch, storeIds, channelRestrictions, options)(fetch, basePath);
        },
        getVouchersByCustomerForApp: function (appId, customerId, options) {
            return (0, exports.VouchersApiFp)(configuration).getVouchersByCustomerForApp(appId, customerId, options)(fetch, basePath);
        },
        setVoucherValidityPeriodsSimplified: function (appId, voucherId, SetVoucherValidityPeriodsSimplifiedRequest, options) {
            return (0, exports.VouchersApiFp)(configuration).setVoucherValidityPeriodsSimplified(appId, voucherId, SetVoucherValidityPeriodsSimplifiedRequest, options)(fetch, basePath);
        },
        updateVoucher: function (voucherId, UpdateVoucher, storeId, percentValue, lumpValue, maxDiscountAmount, options) {
            return (0, exports.VouchersApiFp)(configuration).updateVoucher(voucherId, UpdateVoucher, storeId, percentValue, lumpValue, maxDiscountAmount, options)(fetch, basePath);
        },
        updateVoucherUsage: function (appId, voucherId, UpdateVoucherUsage, options) {
            return (0, exports.VouchersApiFp)(configuration).updateVoucherUsage(appId, voucherId, UpdateVoucherUsage, options)(fetch, basePath);
        },
    };
};
exports.VouchersApiFactory = VouchersApiFactory;
var VouchersApi = (function (_super) {
    __extends(VouchersApi, _super);
    function VouchersApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    VouchersApi.prototype.createVoucher = function (appId, CreateVoucher, options) {
        return (0, exports.VouchersApiFp)(this.configuration).createVoucher(appId, CreateVoucher, options)(this.fetch, this.basePath);
    };
    VouchersApi.prototype.getVoucherByCode = function (appId, code, options) {
        return (0, exports.VouchersApiFp)(this.configuration).getVoucherByCode(appId, code, options)(this.fetch, this.basePath);
    };
    VouchersApi.prototype.getVoucherById = function (voucherId, options) {
        return (0, exports.VouchersApiFp)(this.configuration).getVoucherById(voucherId, options)(this.fetch, this.basePath);
    };
    VouchersApi.prototype.getVoucherStatsById = function (voucherId, aggregateDataBy, dataPointLimit, options) {
        return (0, exports.VouchersApiFp)(this.configuration).getVoucherStatsById(voucherId, aggregateDataBy, dataPointLimit, options)(this.fetch, this.basePath);
    };
    VouchersApi.prototype.getVoucherValidityPeriods = function (appId, voucherId, options) {
        return (0, exports.VouchersApiFp)(this.configuration).getVoucherValidityPeriods(appId, voucherId, options)(this.fetch, this.basePath);
    };
    VouchersApi.prototype.getVouchers = function (appId, pageIndex, pageSize, searchCodes, statusSearch, typeSearch, subTypeSearch, storeIds, channelRestrictions, options) {
        return (0, exports.VouchersApiFp)(this.configuration).getVouchers(appId, pageIndex, pageSize, searchCodes, statusSearch, typeSearch, subTypeSearch, storeIds, channelRestrictions, options)(this.fetch, this.basePath);
    };
    VouchersApi.prototype.getVouchersByCustomerForApp = function (appId, customerId, options) {
        return (0, exports.VouchersApiFp)(this.configuration).getVouchersByCustomerForApp(appId, customerId, options)(this.fetch, this.basePath);
    };
    VouchersApi.prototype.setVoucherValidityPeriodsSimplified = function (appId, voucherId, SetVoucherValidityPeriodsSimplifiedRequest, options) {
        return (0, exports.VouchersApiFp)(this.configuration).setVoucherValidityPeriodsSimplified(appId, voucherId, SetVoucherValidityPeriodsSimplifiedRequest, options)(this.fetch, this.basePath);
    };
    VouchersApi.prototype.updateVoucher = function (voucherId, UpdateVoucher, storeId, percentValue, lumpValue, maxDiscountAmount, options) {
        return (0, exports.VouchersApiFp)(this.configuration).updateVoucher(voucherId, UpdateVoucher, storeId, percentValue, lumpValue, maxDiscountAmount, options)(this.fetch, this.basePath);
    };
    VouchersApi.prototype.updateVoucherUsage = function (appId, voucherId, UpdateVoucherUsage, options) {
        return (0, exports.VouchersApiFp)(this.configuration).updateVoucherUsage(appId, voucherId, UpdateVoucherUsage, options)(this.fetch, this.basePath);
    };
    return VouchersApi;
}(BaseAPI));
exports.VouchersApi = VouchersApi;
var WebhooksApiFetchParamCreator = function (configuration) {
    return {
        createWebhookSubscription: function (oauthAppId, appId, WebhookSubscription, options) {
            if (options === void 0) { options = {}; }
            if (oauthAppId === null || oauthAppId === undefined) {
                throw new RequiredError('oauthAppId', 'Required parameter oauthAppId was null or undefined when calling createWebhookSubscription.');
            }
            if (appId === null || appId === undefined) {
                throw new RequiredError('appId', 'Required parameter appId was null or undefined when calling createWebhookSubscription.');
            }
            if (WebhookSubscription === null || WebhookSubscription === undefined) {
                throw new RequiredError('WebhookSubscription', 'Required parameter WebhookSubscription was null or undefined when calling createWebhookSubscription.');
            }
            var localVarPath = "/api/v1.0/{appId}/webhooks/{oauthAppId}/subscriptions"
                .replace("{".concat("oauthAppId", "}"), encodeURIComponent(String(oauthAppId)))
                .replace("{".concat("appId", "}"), encodeURIComponent(String(appId)));
            var localVarUrlObj = url.parse(localVarPath, true);
            var localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            var localVarHeaderParameter = {};
            var localVarQueryParameter = {};
            if (configuration && configuration.accessToken) {
                var localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("oauth2", ["api"])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }
            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            var needsSerialization = ("WebhookSubscription" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body = needsSerialization ? JSON.stringify(WebhookSubscription || {}) : (WebhookSubscription || "");
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        createWebhookSubscriptionEventNames: function (oauthAppId, webhookSubscriptionId, eventName, appId, options) {
            if (options === void 0) { options = {}; }
            if (oauthAppId === null || oauthAppId === undefined) {
                throw new RequiredError('oauthAppId', 'Required parameter oauthAppId was null or undefined when calling createWebhookSubscriptionEventNames.');
            }
            if (webhookSubscriptionId === null || webhookSubscriptionId === undefined) {
                throw new RequiredError('webhookSubscriptionId', 'Required parameter webhookSubscriptionId was null or undefined when calling createWebhookSubscriptionEventNames.');
            }
            if (eventName === null || eventName === undefined) {
                throw new RequiredError('eventName', 'Required parameter eventName was null or undefined when calling createWebhookSubscriptionEventNames.');
            }
            if (appId === null || appId === undefined) {
                throw new RequiredError('appId', 'Required parameter appId was null or undefined when calling createWebhookSubscriptionEventNames.');
            }
            var localVarPath = "/api/v1.0/{appId}/webhooks/{oauthAppId}/subscriptions/{webhookSubscriptionId}/events/{eventName}"
                .replace("{".concat("oauthAppId", "}"), encodeURIComponent(String(oauthAppId)))
                .replace("{".concat("webhookSubscriptionId", "}"), encodeURIComponent(String(webhookSubscriptionId)))
                .replace("{".concat("eventName", "}"), encodeURIComponent(String(eventName)))
                .replace("{".concat("appId", "}"), encodeURIComponent(String(appId)));
            var localVarUrlObj = url.parse(localVarPath, true);
            var localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            var localVarHeaderParameter = {};
            var localVarQueryParameter = {};
            if (configuration && configuration.accessToken) {
                var localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("oauth2", ["api"])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        deleteWebhookSubscription: function (oauthAppId, webhookSubscriptionId, appId, options) {
            if (options === void 0) { options = {}; }
            if (oauthAppId === null || oauthAppId === undefined) {
                throw new RequiredError('oauthAppId', 'Required parameter oauthAppId was null or undefined when calling deleteWebhookSubscription.');
            }
            if (webhookSubscriptionId === null || webhookSubscriptionId === undefined) {
                throw new RequiredError('webhookSubscriptionId', 'Required parameter webhookSubscriptionId was null or undefined when calling deleteWebhookSubscription.');
            }
            if (appId === null || appId === undefined) {
                throw new RequiredError('appId', 'Required parameter appId was null or undefined when calling deleteWebhookSubscription.');
            }
            var localVarPath = "/api/v1.0/{appId}/webhooks/{oauthAppId}/subscriptions/{webhookSubscriptionId}"
                .replace("{".concat("oauthAppId", "}"), encodeURIComponent(String(oauthAppId)))
                .replace("{".concat("webhookSubscriptionId", "}"), encodeURIComponent(String(webhookSubscriptionId)))
                .replace("{".concat("appId", "}"), encodeURIComponent(String(appId)));
            var localVarUrlObj = url.parse(localVarPath, true);
            var localVarRequestOptions = Object.assign({ method: 'DELETE' }, options);
            var localVarHeaderParameter = {};
            var localVarQueryParameter = {};
            if (configuration && configuration.accessToken) {
                var localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("oauth2", ["api"])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        deleteWebhookSubscriptionEventName: function (oauthAppId, webhookSubscriptionId, eventName, appId, options) {
            if (options === void 0) { options = {}; }
            if (oauthAppId === null || oauthAppId === undefined) {
                throw new RequiredError('oauthAppId', 'Required parameter oauthAppId was null or undefined when calling deleteWebhookSubscriptionEventName.');
            }
            if (webhookSubscriptionId === null || webhookSubscriptionId === undefined) {
                throw new RequiredError('webhookSubscriptionId', 'Required parameter webhookSubscriptionId was null or undefined when calling deleteWebhookSubscriptionEventName.');
            }
            if (eventName === null || eventName === undefined) {
                throw new RequiredError('eventName', 'Required parameter eventName was null or undefined when calling deleteWebhookSubscriptionEventName.');
            }
            if (appId === null || appId === undefined) {
                throw new RequiredError('appId', 'Required parameter appId was null or undefined when calling deleteWebhookSubscriptionEventName.');
            }
            var localVarPath = "/api/v1.0/{appId}/webhooks/{oauthAppId}/subscriptions/{webhookSubscriptionId}/events/{eventName}"
                .replace("{".concat("oauthAppId", "}"), encodeURIComponent(String(oauthAppId)))
                .replace("{".concat("webhookSubscriptionId", "}"), encodeURIComponent(String(webhookSubscriptionId)))
                .replace("{".concat("eventName", "}"), encodeURIComponent(String(eventName)))
                .replace("{".concat("appId", "}"), encodeURIComponent(String(appId)));
            var localVarUrlObj = url.parse(localVarPath, true);
            var localVarRequestOptions = Object.assign({ method: 'DELETE' }, options);
            var localVarHeaderParameter = {};
            var localVarQueryParameter = {};
            if (configuration && configuration.accessToken) {
                var localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("oauth2", ["api"])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        getWebhookEventNames: function (appId, options) {
            if (options === void 0) { options = {}; }
            if (appId === null || appId === undefined) {
                throw new RequiredError('appId', 'Required parameter appId was null or undefined when calling getWebhookEventNames.');
            }
            var localVarPath = "/api/v1.0/{appId}/webhooks/events"
                .replace("{".concat("appId", "}"), encodeURIComponent(String(appId)));
            var localVarUrlObj = url.parse(localVarPath, true);
            var localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            var localVarHeaderParameter = {};
            var localVarQueryParameter = {};
            if (configuration && configuration.accessToken) {
                var localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("oauth2", ["api"])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        getWebhookEventNamesBySubscriptionId: function (oauthAppId, webhookSubscriptionId, appId, options) {
            if (options === void 0) { options = {}; }
            if (oauthAppId === null || oauthAppId === undefined) {
                throw new RequiredError('oauthAppId', 'Required parameter oauthAppId was null or undefined when calling getWebhookEventNamesBySubscriptionId.');
            }
            if (webhookSubscriptionId === null || webhookSubscriptionId === undefined) {
                throw new RequiredError('webhookSubscriptionId', 'Required parameter webhookSubscriptionId was null or undefined when calling getWebhookEventNamesBySubscriptionId.');
            }
            if (appId === null || appId === undefined) {
                throw new RequiredError('appId', 'Required parameter appId was null or undefined when calling getWebhookEventNamesBySubscriptionId.');
            }
            var localVarPath = "/api/v1.0/{appId}/webhooks/{oauthAppId}/subscriptions/{webhookSubscriptionId}/events"
                .replace("{".concat("oauthAppId", "}"), encodeURIComponent(String(oauthAppId)))
                .replace("{".concat("webhookSubscriptionId", "}"), encodeURIComponent(String(webhookSubscriptionId)))
                .replace("{".concat("appId", "}"), encodeURIComponent(String(appId)));
            var localVarUrlObj = url.parse(localVarPath, true);
            var localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            var localVarHeaderParameter = {};
            var localVarQueryParameter = {};
            if (configuration && configuration.accessToken) {
                var localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("oauth2", ["api"])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        getWebhookEventSample: function (eventName, appId, oauthAppId, webhookSubscriptionId, version, options) {
            if (options === void 0) { options = {}; }
            if (eventName === null || eventName === undefined) {
                throw new RequiredError('eventName', 'Required parameter eventName was null or undefined when calling getWebhookEventSample.');
            }
            if (appId === null || appId === undefined) {
                throw new RequiredError('appId', 'Required parameter appId was null or undefined when calling getWebhookEventSample.');
            }
            if (oauthAppId === null || oauthAppId === undefined) {
                throw new RequiredError('oauthAppId', 'Required parameter oauthAppId was null or undefined when calling getWebhookEventSample.');
            }
            if (webhookSubscriptionId === null || webhookSubscriptionId === undefined) {
                throw new RequiredError('webhookSubscriptionId', 'Required parameter webhookSubscriptionId was null or undefined when calling getWebhookEventSample.');
            }
            var localVarPath = "/api/v1.0/{appId}/webhooks/{oauthAppId}/subscriptions/{webhookSubscriptionId}/events/{eventName}/test"
                .replace("{".concat("eventName", "}"), encodeURIComponent(String(eventName)))
                .replace("{".concat("appId", "}"), encodeURIComponent(String(appId)))
                .replace("{".concat("oauthAppId", "}"), encodeURIComponent(String(oauthAppId)))
                .replace("{".concat("webhookSubscriptionId", "}"), encodeURIComponent(String(webhookSubscriptionId)));
            var localVarUrlObj = url.parse(localVarPath, true);
            var localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            var localVarHeaderParameter = {};
            var localVarQueryParameter = {};
            if (configuration && configuration.accessToken) {
                var localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("oauth2", ["api"])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }
            if (version !== undefined) {
                localVarQueryParameter['version'] = version;
            }
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        getWebhookLogs: function (oauthAppId, webhookSubscriptionId, start, end, appId, page, limit, options) {
            if (options === void 0) { options = {}; }
            if (oauthAppId === null || oauthAppId === undefined) {
                throw new RequiredError('oauthAppId', 'Required parameter oauthAppId was null or undefined when calling getWebhookLogs.');
            }
            if (webhookSubscriptionId === null || webhookSubscriptionId === undefined) {
                throw new RequiredError('webhookSubscriptionId', 'Required parameter webhookSubscriptionId was null or undefined when calling getWebhookLogs.');
            }
            if (start === null || start === undefined) {
                throw new RequiredError('start', 'Required parameter start was null or undefined when calling getWebhookLogs.');
            }
            if (end === null || end === undefined) {
                throw new RequiredError('end', 'Required parameter end was null or undefined when calling getWebhookLogs.');
            }
            if (appId === null || appId === undefined) {
                throw new RequiredError('appId', 'Required parameter appId was null or undefined when calling getWebhookLogs.');
            }
            var localVarPath = "/api/v1.0/{appId}/webhooks/{oauthAppId}/subscriptions/{webhookSubscriptionId}/logs"
                .replace("{".concat("oauthAppId", "}"), encodeURIComponent(String(oauthAppId)))
                .replace("{".concat("webhookSubscriptionId", "}"), encodeURIComponent(String(webhookSubscriptionId)))
                .replace("{".concat("appId", "}"), encodeURIComponent(String(appId)));
            var localVarUrlObj = url.parse(localVarPath, true);
            var localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            var localVarHeaderParameter = {};
            var localVarQueryParameter = {};
            if (configuration && configuration.accessToken) {
                var localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("oauth2", ["api"])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }
            if (start !== undefined) {
                localVarQueryParameter['start'] = start;
            }
            if (end !== undefined) {
                localVarQueryParameter['end'] = end;
            }
            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }
            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        getWebhookSubscriptions: function (oauthAppId, appId, page, limit, options) {
            if (options === void 0) { options = {}; }
            if (oauthAppId === null || oauthAppId === undefined) {
                throw new RequiredError('oauthAppId', 'Required parameter oauthAppId was null or undefined when calling getWebhookSubscriptions.');
            }
            if (appId === null || appId === undefined) {
                throw new RequiredError('appId', 'Required parameter appId was null or undefined when calling getWebhookSubscriptions.');
            }
            var localVarPath = "/api/v1.0/{appId}/webhooks/{oauthAppId}/subscriptions"
                .replace("{".concat("oauthAppId", "}"), encodeURIComponent(String(oauthAppId)))
                .replace("{".concat("appId", "}"), encodeURIComponent(String(appId)));
            var localVarUrlObj = url.parse(localVarPath, true);
            var localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            var localVarHeaderParameter = {};
            var localVarQueryParameter = {};
            if (configuration && configuration.accessToken) {
                var localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("oauth2", ["api"])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }
            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }
            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        updateWebhookSubscription: function (oauthAppId, webhookSubscriptionId, appId, WebhookSubscription, options) {
            if (options === void 0) { options = {}; }
            if (oauthAppId === null || oauthAppId === undefined) {
                throw new RequiredError('oauthAppId', 'Required parameter oauthAppId was null or undefined when calling updateWebhookSubscription.');
            }
            if (webhookSubscriptionId === null || webhookSubscriptionId === undefined) {
                throw new RequiredError('webhookSubscriptionId', 'Required parameter webhookSubscriptionId was null or undefined when calling updateWebhookSubscription.');
            }
            if (appId === null || appId === undefined) {
                throw new RequiredError('appId', 'Required parameter appId was null or undefined when calling updateWebhookSubscription.');
            }
            if (WebhookSubscription === null || WebhookSubscription === undefined) {
                throw new RequiredError('WebhookSubscription', 'Required parameter WebhookSubscription was null or undefined when calling updateWebhookSubscription.');
            }
            var localVarPath = "/api/v1.0/{appId}/webhooks/{oauthAppId}/subscriptions/{webhookSubscriptionId}"
                .replace("{".concat("oauthAppId", "}"), encodeURIComponent(String(oauthAppId)))
                .replace("{".concat("webhookSubscriptionId", "}"), encodeURIComponent(String(webhookSubscriptionId)))
                .replace("{".concat("appId", "}"), encodeURIComponent(String(appId)));
            var localVarUrlObj = url.parse(localVarPath, true);
            var localVarRequestOptions = Object.assign({ method: 'PUT' }, options);
            var localVarHeaderParameter = {};
            var localVarQueryParameter = {};
            if (configuration && configuration.accessToken) {
                var localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("oauth2", ["api"])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }
            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            var needsSerialization = ("WebhookSubscription" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body = needsSerialization ? JSON.stringify(WebhookSubscription || {}) : (WebhookSubscription || "");
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    };
};
exports.WebhooksApiFetchParamCreator = WebhooksApiFetchParamCreator;
var WebhooksApiFp = function (configuration) {
    return {
        createWebhookSubscription: function (oauthAppId, appId, WebhookSubscription, options) {
            var localVarFetchArgs = (0, exports.WebhooksApiFetchParamCreator)(configuration).createWebhookSubscription(oauthAppId, appId, WebhookSubscription, options);
            return function (fetch, basePath) {
                if (fetch === void 0) { fetch = portableFetch; }
                if (basePath === void 0) { basePath = BASE_PATH; }
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then(function (response) {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
        createWebhookSubscriptionEventNames: function (oauthAppId, webhookSubscriptionId, eventName, appId, options) {
            var localVarFetchArgs = (0, exports.WebhooksApiFetchParamCreator)(configuration).createWebhookSubscriptionEventNames(oauthAppId, webhookSubscriptionId, eventName, appId, options);
            return function (fetch, basePath) {
                if (fetch === void 0) { fetch = portableFetch; }
                if (basePath === void 0) { basePath = BASE_PATH; }
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then(function (response) {
                    if (response.status >= 200 && response.status < 300) {
                        return response;
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
        deleteWebhookSubscription: function (oauthAppId, webhookSubscriptionId, appId, options) {
            var localVarFetchArgs = (0, exports.WebhooksApiFetchParamCreator)(configuration).deleteWebhookSubscription(oauthAppId, webhookSubscriptionId, appId, options);
            return function (fetch, basePath) {
                if (fetch === void 0) { fetch = portableFetch; }
                if (basePath === void 0) { basePath = BASE_PATH; }
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then(function (response) {
                    if (response.status >= 200 && response.status < 300) {
                        return response;
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
        deleteWebhookSubscriptionEventName: function (oauthAppId, webhookSubscriptionId, eventName, appId, options) {
            var localVarFetchArgs = (0, exports.WebhooksApiFetchParamCreator)(configuration).deleteWebhookSubscriptionEventName(oauthAppId, webhookSubscriptionId, eventName, appId, options);
            return function (fetch, basePath) {
                if (fetch === void 0) { fetch = portableFetch; }
                if (basePath === void 0) { basePath = BASE_PATH; }
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then(function (response) {
                    if (response.status >= 200 && response.status < 300) {
                        return response;
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
        getWebhookEventNames: function (appId, options) {
            var localVarFetchArgs = (0, exports.WebhooksApiFetchParamCreator)(configuration).getWebhookEventNames(appId, options);
            return function (fetch, basePath) {
                if (fetch === void 0) { fetch = portableFetch; }
                if (basePath === void 0) { basePath = BASE_PATH; }
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then(function (response) {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
        getWebhookEventNamesBySubscriptionId: function (oauthAppId, webhookSubscriptionId, appId, options) {
            var localVarFetchArgs = (0, exports.WebhooksApiFetchParamCreator)(configuration).getWebhookEventNamesBySubscriptionId(oauthAppId, webhookSubscriptionId, appId, options);
            return function (fetch, basePath) {
                if (fetch === void 0) { fetch = portableFetch; }
                if (basePath === void 0) { basePath = BASE_PATH; }
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then(function (response) {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
        getWebhookEventSample: function (eventName, appId, oauthAppId, webhookSubscriptionId, version, options) {
            var localVarFetchArgs = (0, exports.WebhooksApiFetchParamCreator)(configuration).getWebhookEventSample(eventName, appId, oauthAppId, webhookSubscriptionId, version, options);
            return function (fetch, basePath) {
                if (fetch === void 0) { fetch = portableFetch; }
                if (basePath === void 0) { basePath = BASE_PATH; }
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then(function (response) {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
        getWebhookLogs: function (oauthAppId, webhookSubscriptionId, start, end, appId, page, limit, options) {
            var localVarFetchArgs = (0, exports.WebhooksApiFetchParamCreator)(configuration).getWebhookLogs(oauthAppId, webhookSubscriptionId, start, end, appId, page, limit, options);
            return function (fetch, basePath) {
                if (fetch === void 0) { fetch = portableFetch; }
                if (basePath === void 0) { basePath = BASE_PATH; }
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then(function (response) {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
        getWebhookSubscriptions: function (oauthAppId, appId, page, limit, options) {
            var localVarFetchArgs = (0, exports.WebhooksApiFetchParamCreator)(configuration).getWebhookSubscriptions(oauthAppId, appId, page, limit, options);
            return function (fetch, basePath) {
                if (fetch === void 0) { fetch = portableFetch; }
                if (basePath === void 0) { basePath = BASE_PATH; }
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then(function (response) {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
        updateWebhookSubscription: function (oauthAppId, webhookSubscriptionId, appId, WebhookSubscription, options) {
            var localVarFetchArgs = (0, exports.WebhooksApiFetchParamCreator)(configuration).updateWebhookSubscription(oauthAppId, webhookSubscriptionId, appId, WebhookSubscription, options);
            return function (fetch, basePath) {
                if (fetch === void 0) { fetch = portableFetch; }
                if (basePath === void 0) { basePath = BASE_PATH; }
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then(function (response) {
                    if (response.status >= 200 && response.status < 300) {
                        return response;
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
    };
};
exports.WebhooksApiFp = WebhooksApiFp;
var WebhooksApiFactory = function (configuration, fetch, basePath) {
    return {
        createWebhookSubscription: function (oauthAppId, appId, WebhookSubscription, options) {
            return (0, exports.WebhooksApiFp)(configuration).createWebhookSubscription(oauthAppId, appId, WebhookSubscription, options)(fetch, basePath);
        },
        createWebhookSubscriptionEventNames: function (oauthAppId, webhookSubscriptionId, eventName, appId, options) {
            return (0, exports.WebhooksApiFp)(configuration).createWebhookSubscriptionEventNames(oauthAppId, webhookSubscriptionId, eventName, appId, options)(fetch, basePath);
        },
        deleteWebhookSubscription: function (oauthAppId, webhookSubscriptionId, appId, options) {
            return (0, exports.WebhooksApiFp)(configuration).deleteWebhookSubscription(oauthAppId, webhookSubscriptionId, appId, options)(fetch, basePath);
        },
        deleteWebhookSubscriptionEventName: function (oauthAppId, webhookSubscriptionId, eventName, appId, options) {
            return (0, exports.WebhooksApiFp)(configuration).deleteWebhookSubscriptionEventName(oauthAppId, webhookSubscriptionId, eventName, appId, options)(fetch, basePath);
        },
        getWebhookEventNames: function (appId, options) {
            return (0, exports.WebhooksApiFp)(configuration).getWebhookEventNames(appId, options)(fetch, basePath);
        },
        getWebhookEventNamesBySubscriptionId: function (oauthAppId, webhookSubscriptionId, appId, options) {
            return (0, exports.WebhooksApiFp)(configuration).getWebhookEventNamesBySubscriptionId(oauthAppId, webhookSubscriptionId, appId, options)(fetch, basePath);
        },
        getWebhookEventSample: function (eventName, appId, oauthAppId, webhookSubscriptionId, version, options) {
            return (0, exports.WebhooksApiFp)(configuration).getWebhookEventSample(eventName, appId, oauthAppId, webhookSubscriptionId, version, options)(fetch, basePath);
        },
        getWebhookLogs: function (oauthAppId, webhookSubscriptionId, start, end, appId, page, limit, options) {
            return (0, exports.WebhooksApiFp)(configuration).getWebhookLogs(oauthAppId, webhookSubscriptionId, start, end, appId, page, limit, options)(fetch, basePath);
        },
        getWebhookSubscriptions: function (oauthAppId, appId, page, limit, options) {
            return (0, exports.WebhooksApiFp)(configuration).getWebhookSubscriptions(oauthAppId, appId, page, limit, options)(fetch, basePath);
        },
        updateWebhookSubscription: function (oauthAppId, webhookSubscriptionId, appId, WebhookSubscription, options) {
            return (0, exports.WebhooksApiFp)(configuration).updateWebhookSubscription(oauthAppId, webhookSubscriptionId, appId, WebhookSubscription, options)(fetch, basePath);
        },
    };
};
exports.WebhooksApiFactory = WebhooksApiFactory;
var WebhooksApi = (function (_super) {
    __extends(WebhooksApi, _super);
    function WebhooksApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    WebhooksApi.prototype.createWebhookSubscription = function (oauthAppId, appId, WebhookSubscription, options) {
        return (0, exports.WebhooksApiFp)(this.configuration).createWebhookSubscription(oauthAppId, appId, WebhookSubscription, options)(this.fetch, this.basePath);
    };
    WebhooksApi.prototype.createWebhookSubscriptionEventNames = function (oauthAppId, webhookSubscriptionId, eventName, appId, options) {
        return (0, exports.WebhooksApiFp)(this.configuration).createWebhookSubscriptionEventNames(oauthAppId, webhookSubscriptionId, eventName, appId, options)(this.fetch, this.basePath);
    };
    WebhooksApi.prototype.deleteWebhookSubscription = function (oauthAppId, webhookSubscriptionId, appId, options) {
        return (0, exports.WebhooksApiFp)(this.configuration).deleteWebhookSubscription(oauthAppId, webhookSubscriptionId, appId, options)(this.fetch, this.basePath);
    };
    WebhooksApi.prototype.deleteWebhookSubscriptionEventName = function (oauthAppId, webhookSubscriptionId, eventName, appId, options) {
        return (0, exports.WebhooksApiFp)(this.configuration).deleteWebhookSubscriptionEventName(oauthAppId, webhookSubscriptionId, eventName, appId, options)(this.fetch, this.basePath);
    };
    WebhooksApi.prototype.getWebhookEventNames = function (appId, options) {
        return (0, exports.WebhooksApiFp)(this.configuration).getWebhookEventNames(appId, options)(this.fetch, this.basePath);
    };
    WebhooksApi.prototype.getWebhookEventNamesBySubscriptionId = function (oauthAppId, webhookSubscriptionId, appId, options) {
        return (0, exports.WebhooksApiFp)(this.configuration).getWebhookEventNamesBySubscriptionId(oauthAppId, webhookSubscriptionId, appId, options)(this.fetch, this.basePath);
    };
    WebhooksApi.prototype.getWebhookEventSample = function (eventName, appId, oauthAppId, webhookSubscriptionId, version, options) {
        return (0, exports.WebhooksApiFp)(this.configuration).getWebhookEventSample(eventName, appId, oauthAppId, webhookSubscriptionId, version, options)(this.fetch, this.basePath);
    };
    WebhooksApi.prototype.getWebhookLogs = function (oauthAppId, webhookSubscriptionId, start, end, appId, page, limit, options) {
        return (0, exports.WebhooksApiFp)(this.configuration).getWebhookLogs(oauthAppId, webhookSubscriptionId, start, end, appId, page, limit, options)(this.fetch, this.basePath);
    };
    WebhooksApi.prototype.getWebhookSubscriptions = function (oauthAppId, appId, page, limit, options) {
        return (0, exports.WebhooksApiFp)(this.configuration).getWebhookSubscriptions(oauthAppId, appId, page, limit, options)(this.fetch, this.basePath);
    };
    WebhooksApi.prototype.updateWebhookSubscription = function (oauthAppId, webhookSubscriptionId, appId, WebhookSubscription, options) {
        return (0, exports.WebhooksApiFp)(this.configuration).updateWebhookSubscription(oauthAppId, webhookSubscriptionId, appId, WebhookSubscription, options)(this.fetch, this.basePath);
    };
    return WebhooksApi;
}(BaseAPI));
exports.WebhooksApi = WebhooksApi;
var WebsiteApiFetchParamCreator = function (configuration) {
    return {
        addTestimonial: function (appId, WebsiteTestimonialBase, options) {
            if (options === void 0) { options = {}; }
            if (appId === null || appId === undefined) {
                throw new RequiredError('appId', 'Required parameter appId was null or undefined when calling addTestimonial.');
            }
            if (WebsiteTestimonialBase === null || WebsiteTestimonialBase === undefined) {
                throw new RequiredError('WebsiteTestimonialBase', 'Required parameter WebsiteTestimonialBase was null or undefined when calling addTestimonial.');
            }
            var localVarPath = "/api/v1.0/{appId}/website/testimonial"
                .replace("{".concat("appId", "}"), encodeURIComponent(String(appId)));
            var localVarUrlObj = url.parse(localVarPath, true);
            var localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            var localVarHeaderParameter = {};
            var localVarQueryParameter = {};
            if (configuration && configuration.accessToken) {
                var localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("oauth2", ["api"])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }
            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            var needsSerialization = ("WebsiteTestimonialBase" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body = needsSerialization ? JSON.stringify(WebsiteTestimonialBase || {}) : (WebsiteTestimonialBase || "");
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        deleteTestimonial: function (appId, testimonialId, options) {
            if (options === void 0) { options = {}; }
            if (appId === null || appId === undefined) {
                throw new RequiredError('appId', 'Required parameter appId was null or undefined when calling deleteTestimonial.');
            }
            if (testimonialId === null || testimonialId === undefined) {
                throw new RequiredError('testimonialId', 'Required parameter testimonialId was null or undefined when calling deleteTestimonial.');
            }
            var localVarPath = "/api/v1.0/{appId}/website/testimonial/{testimonialId}"
                .replace("{".concat("appId", "}"), encodeURIComponent(String(appId)))
                .replace("{".concat("testimonialId", "}"), encodeURIComponent(String(testimonialId)));
            var localVarUrlObj = url.parse(localVarPath, true);
            var localVarRequestOptions = Object.assign({ method: 'DELETE' }, options);
            var localVarHeaderParameter = {};
            var localVarQueryParameter = {};
            if (configuration && configuration.accessToken) {
                var localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("oauth2", ["api"])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        deleteWebsiteImage: function (appId, imageId, options) {
            if (options === void 0) { options = {}; }
            if (appId === null || appId === undefined) {
                throw new RequiredError('appId', 'Required parameter appId was null or undefined when calling deleteWebsiteImage.');
            }
            if (imageId === null || imageId === undefined) {
                throw new RequiredError('imageId', 'Required parameter imageId was null or undefined when calling deleteWebsiteImage.');
            }
            var localVarPath = "/api/v1.0/{appId}/website/image/{imageId}"
                .replace("{".concat("appId", "}"), encodeURIComponent(String(appId)))
                .replace("{".concat("imageId", "}"), encodeURIComponent(String(imageId)));
            var localVarUrlObj = url.parse(localVarPath, true);
            var localVarRequestOptions = Object.assign({ method: 'DELETE' }, options);
            var localVarHeaderParameter = {};
            var localVarQueryParameter = {};
            if (configuration && configuration.accessToken) {
                var localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("oauth2", ["api"])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        editTestimonial: function (appId, testimonialId, WebsiteTestimonialBase, options) {
            if (options === void 0) { options = {}; }
            if (appId === null || appId === undefined) {
                throw new RequiredError('appId', 'Required parameter appId was null or undefined when calling editTestimonial.');
            }
            if (testimonialId === null || testimonialId === undefined) {
                throw new RequiredError('testimonialId', 'Required parameter testimonialId was null or undefined when calling editTestimonial.');
            }
            if (WebsiteTestimonialBase === null || WebsiteTestimonialBase === undefined) {
                throw new RequiredError('WebsiteTestimonialBase', 'Required parameter WebsiteTestimonialBase was null or undefined when calling editTestimonial.');
            }
            var localVarPath = "/api/v1.0/{appId}/website/testimonial/{testimonialId}"
                .replace("{".concat("appId", "}"), encodeURIComponent(String(appId)))
                .replace("{".concat("testimonialId", "}"), encodeURIComponent(String(testimonialId)));
            var localVarUrlObj = url.parse(localVarPath, true);
            var localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            var localVarHeaderParameter = {};
            var localVarQueryParameter = {};
            if (configuration && configuration.accessToken) {
                var localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("oauth2", ["api"])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }
            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            var needsSerialization = ("WebsiteTestimonialBase" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body = needsSerialization ? JSON.stringify(WebsiteTestimonialBase || {}) : (WebsiteTestimonialBase || "");
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        getIndexConfiguration: function (appId, options) {
            if (options === void 0) { options = {}; }
            if (appId === null || appId === undefined) {
                throw new RequiredError('appId', 'Required parameter appId was null or undefined when calling getIndexConfiguration.');
            }
            var localVarPath = "/api/v1.0/{appId}/website/index"
                .replace("{".concat("appId", "}"), encodeURIComponent(String(appId)));
            var localVarUrlObj = url.parse(localVarPath, true);
            var localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            var localVarHeaderParameter = {};
            var localVarQueryParameter = {};
            if (configuration && configuration.accessToken) {
                var localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("oauth2", ["api"])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        setIndexConfiguration: function (appId, IndexPageBase, options) {
            if (options === void 0) { options = {}; }
            if (appId === null || appId === undefined) {
                throw new RequiredError('appId', 'Required parameter appId was null or undefined when calling setIndexConfiguration.');
            }
            if (IndexPageBase === null || IndexPageBase === undefined) {
                throw new RequiredError('IndexPageBase', 'Required parameter IndexPageBase was null or undefined when calling setIndexConfiguration.');
            }
            var localVarPath = "/api/v1.0/{appId}/website/index"
                .replace("{".concat("appId", "}"), encodeURIComponent(String(appId)));
            var localVarUrlObj = url.parse(localVarPath, true);
            var localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            var localVarHeaderParameter = {};
            var localVarQueryParameter = {};
            if (configuration && configuration.accessToken) {
                var localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("oauth2", ["api"])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }
            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            var needsSerialization = ("IndexPageBase" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body = needsSerialization ? JSON.stringify(IndexPageBase || {}) : (IndexPageBase || "");
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        uploadWebsiteImage: function (appId, imageLocation, Image, options) {
            if (options === void 0) { options = {}; }
            if (appId === null || appId === undefined) {
                throw new RequiredError('appId', 'Required parameter appId was null or undefined when calling uploadWebsiteImage.');
            }
            if (imageLocation === null || imageLocation === undefined) {
                throw new RequiredError('imageLocation', 'Required parameter imageLocation was null or undefined when calling uploadWebsiteImage.');
            }
            if (Image === null || Image === undefined) {
                throw new RequiredError('Image', 'Required parameter Image was null or undefined when calling uploadWebsiteImage.');
            }
            var localVarPath = "/api/v1.0/{appId}/website/image/{imageLocation}"
                .replace("{".concat("appId", "}"), encodeURIComponent(String(appId)))
                .replace("{".concat("imageLocation", "}"), encodeURIComponent(String(imageLocation)));
            var localVarUrlObj = url.parse(localVarPath, true);
            var localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            var localVarHeaderParameter = {};
            var localVarQueryParameter = {};
            var localVarFormParams = new url.URLSearchParams();
            if (configuration && configuration.accessToken) {
                var localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("oauth2", ["api"])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }
            if (Image !== undefined) {
                localVarFormParams.set('Image', Image);
            }
            localVarHeaderParameter['Content-Type'] = 'application/x-www-form-urlencoded';
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            localVarRequestOptions.body = localVarFormParams.toString();
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        websiteCheckNow: function (appId, options) {
            if (options === void 0) { options = {}; }
            if (appId === null || appId === undefined) {
                throw new RequiredError('appId', 'Required parameter appId was null or undefined when calling websiteCheckNow.');
            }
            var localVarPath = "/api/v1.0/{appId}/website/dnscheck"
                .replace("{".concat("appId", "}"), encodeURIComponent(String(appId)));
            var localVarUrlObj = url.parse(localVarPath, true);
            var localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            var localVarHeaderParameter = {};
            var localVarQueryParameter = {};
            if (configuration && configuration.accessToken) {
                var localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("oauth2", ["api"])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    };
};
exports.WebsiteApiFetchParamCreator = WebsiteApiFetchParamCreator;
var WebsiteApiFp = function (configuration) {
    return {
        addTestimonial: function (appId, WebsiteTestimonialBase, options) {
            var localVarFetchArgs = (0, exports.WebsiteApiFetchParamCreator)(configuration).addTestimonial(appId, WebsiteTestimonialBase, options);
            return function (fetch, basePath) {
                if (fetch === void 0) { fetch = portableFetch; }
                if (basePath === void 0) { basePath = BASE_PATH; }
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then(function (response) {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
        deleteTestimonial: function (appId, testimonialId, options) {
            var localVarFetchArgs = (0, exports.WebsiteApiFetchParamCreator)(configuration).deleteTestimonial(appId, testimonialId, options);
            return function (fetch, basePath) {
                if (fetch === void 0) { fetch = portableFetch; }
                if (basePath === void 0) { basePath = BASE_PATH; }
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then(function (response) {
                    if (response.status >= 200 && response.status < 300) {
                        return response;
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
        deleteWebsiteImage: function (appId, imageId, options) {
            var localVarFetchArgs = (0, exports.WebsiteApiFetchParamCreator)(configuration).deleteWebsiteImage(appId, imageId, options);
            return function (fetch, basePath) {
                if (fetch === void 0) { fetch = portableFetch; }
                if (basePath === void 0) { basePath = BASE_PATH; }
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then(function (response) {
                    if (response.status >= 200 && response.status < 300) {
                        return response;
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
        editTestimonial: function (appId, testimonialId, WebsiteTestimonialBase, options) {
            var localVarFetchArgs = (0, exports.WebsiteApiFetchParamCreator)(configuration).editTestimonial(appId, testimonialId, WebsiteTestimonialBase, options);
            return function (fetch, basePath) {
                if (fetch === void 0) { fetch = portableFetch; }
                if (basePath === void 0) { basePath = BASE_PATH; }
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then(function (response) {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
        getIndexConfiguration: function (appId, options) {
            var localVarFetchArgs = (0, exports.WebsiteApiFetchParamCreator)(configuration).getIndexConfiguration(appId, options);
            return function (fetch, basePath) {
                if (fetch === void 0) { fetch = portableFetch; }
                if (basePath === void 0) { basePath = BASE_PATH; }
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then(function (response) {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
        setIndexConfiguration: function (appId, IndexPageBase, options) {
            var localVarFetchArgs = (0, exports.WebsiteApiFetchParamCreator)(configuration).setIndexConfiguration(appId, IndexPageBase, options);
            return function (fetch, basePath) {
                if (fetch === void 0) { fetch = portableFetch; }
                if (basePath === void 0) { basePath = BASE_PATH; }
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then(function (response) {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
        uploadWebsiteImage: function (appId, imageLocation, Image, options) {
            var localVarFetchArgs = (0, exports.WebsiteApiFetchParamCreator)(configuration).uploadWebsiteImage(appId, imageLocation, Image, options);
            return function (fetch, basePath) {
                if (fetch === void 0) { fetch = portableFetch; }
                if (basePath === void 0) { basePath = BASE_PATH; }
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then(function (response) {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
        websiteCheckNow: function (appId, options) {
            var localVarFetchArgs = (0, exports.WebsiteApiFetchParamCreator)(configuration).websiteCheckNow(appId, options);
            return function (fetch, basePath) {
                if (fetch === void 0) { fetch = portableFetch; }
                if (basePath === void 0) { basePath = BASE_PATH; }
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then(function (response) {
                    if (response.status >= 200 && response.status < 300) {
                        return response;
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
    };
};
exports.WebsiteApiFp = WebsiteApiFp;
var WebsiteApiFactory = function (configuration, fetch, basePath) {
    return {
        addTestimonial: function (appId, WebsiteTestimonialBase, options) {
            return (0, exports.WebsiteApiFp)(configuration).addTestimonial(appId, WebsiteTestimonialBase, options)(fetch, basePath);
        },
        deleteTestimonial: function (appId, testimonialId, options) {
            return (0, exports.WebsiteApiFp)(configuration).deleteTestimonial(appId, testimonialId, options)(fetch, basePath);
        },
        deleteWebsiteImage: function (appId, imageId, options) {
            return (0, exports.WebsiteApiFp)(configuration).deleteWebsiteImage(appId, imageId, options)(fetch, basePath);
        },
        editTestimonial: function (appId, testimonialId, WebsiteTestimonialBase, options) {
            return (0, exports.WebsiteApiFp)(configuration).editTestimonial(appId, testimonialId, WebsiteTestimonialBase, options)(fetch, basePath);
        },
        getIndexConfiguration: function (appId, options) {
            return (0, exports.WebsiteApiFp)(configuration).getIndexConfiguration(appId, options)(fetch, basePath);
        },
        setIndexConfiguration: function (appId, IndexPageBase, options) {
            return (0, exports.WebsiteApiFp)(configuration).setIndexConfiguration(appId, IndexPageBase, options)(fetch, basePath);
        },
        uploadWebsiteImage: function (appId, imageLocation, Image, options) {
            return (0, exports.WebsiteApiFp)(configuration).uploadWebsiteImage(appId, imageLocation, Image, options)(fetch, basePath);
        },
        websiteCheckNow: function (appId, options) {
            return (0, exports.WebsiteApiFp)(configuration).websiteCheckNow(appId, options)(fetch, basePath);
        },
    };
};
exports.WebsiteApiFactory = WebsiteApiFactory;
var WebsiteApi = (function (_super) {
    __extends(WebsiteApi, _super);
    function WebsiteApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    WebsiteApi.prototype.addTestimonial = function (appId, WebsiteTestimonialBase, options) {
        return (0, exports.WebsiteApiFp)(this.configuration).addTestimonial(appId, WebsiteTestimonialBase, options)(this.fetch, this.basePath);
    };
    WebsiteApi.prototype.deleteTestimonial = function (appId, testimonialId, options) {
        return (0, exports.WebsiteApiFp)(this.configuration).deleteTestimonial(appId, testimonialId, options)(this.fetch, this.basePath);
    };
    WebsiteApi.prototype.deleteWebsiteImage = function (appId, imageId, options) {
        return (0, exports.WebsiteApiFp)(this.configuration).deleteWebsiteImage(appId, imageId, options)(this.fetch, this.basePath);
    };
    WebsiteApi.prototype.editTestimonial = function (appId, testimonialId, WebsiteTestimonialBase, options) {
        return (0, exports.WebsiteApiFp)(this.configuration).editTestimonial(appId, testimonialId, WebsiteTestimonialBase, options)(this.fetch, this.basePath);
    };
    WebsiteApi.prototype.getIndexConfiguration = function (appId, options) {
        return (0, exports.WebsiteApiFp)(this.configuration).getIndexConfiguration(appId, options)(this.fetch, this.basePath);
    };
    WebsiteApi.prototype.setIndexConfiguration = function (appId, IndexPageBase, options) {
        return (0, exports.WebsiteApiFp)(this.configuration).setIndexConfiguration(appId, IndexPageBase, options)(this.fetch, this.basePath);
    };
    WebsiteApi.prototype.uploadWebsiteImage = function (appId, imageLocation, Image, options) {
        return (0, exports.WebsiteApiFp)(this.configuration).uploadWebsiteImage(appId, imageLocation, Image, options)(this.fetch, this.basePath);
    };
    WebsiteApi.prototype.websiteCheckNow = function (appId, options) {
        return (0, exports.WebsiteApiFp)(this.configuration).websiteCheckNow(appId, options)(this.fetch, this.basePath);
    };
    return WebsiteApi;
}(BaseAPI));
exports.WebsiteApi = WebsiteApi;
var WhiteLabelBuildsApiFetchParamCreator = function (configuration) {
    return {
        healthCheck: function (options) {
            if (options === void 0) { options = {}; }
            var localVarPath = "/api/v1.0/whitelabelbuilds/health";
            var localVarUrlObj = url.parse(localVarPath, true);
            var localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            var localVarHeaderParameter = {};
            var localVarQueryParameter = {};
            if (configuration && configuration.accessToken) {
                var localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("oauth2", ["api"])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        submitAndroidApps: function (whiteLabelIds, branch, buildType, options) {
            if (options === void 0) { options = {}; }
            if (whiteLabelIds === null || whiteLabelIds === undefined) {
                throw new RequiredError('whiteLabelIds', 'Required parameter whiteLabelIds was null or undefined when calling submitAndroidApps.');
            }
            var localVarPath = "/api/v1.0/whitelabelbuilds/android/multiple";
            var localVarUrlObj = url.parse(localVarPath, true);
            var localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            var localVarHeaderParameter = {};
            var localVarQueryParameter = {};
            if (configuration && configuration.accessToken) {
                var localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("oauth2", ["api"])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }
            if (whiteLabelIds !== undefined) {
                localVarQueryParameter['whiteLabelIds'] = whiteLabelIds;
            }
            if (branch !== undefined) {
                localVarQueryParameter['branch'] = branch;
            }
            if (buildType !== undefined) {
                localVarQueryParameter['buildType'] = buildType;
            }
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        submitAndroidBuild: function (appId, branch, lane, buildType, options) {
            if (options === void 0) { options = {}; }
            if (appId === null || appId === undefined) {
                throw new RequiredError('appId', 'Required parameter appId was null or undefined when calling submitAndroidBuild.');
            }
            if (branch === null || branch === undefined) {
                throw new RequiredError('branch', 'Required parameter branch was null or undefined when calling submitAndroidBuild.');
            }
            if (lane === null || lane === undefined) {
                throw new RequiredError('lane', 'Required parameter lane was null or undefined when calling submitAndroidBuild.');
            }
            if (buildType === null || buildType === undefined) {
                throw new RequiredError('buildType', 'Required parameter buildType was null or undefined when calling submitAndroidBuild.');
            }
            var localVarPath = "/api/v1.0/whitelabelbuilds/{appId}/android"
                .replace("{".concat("appId", "}"), encodeURIComponent(String(appId)));
            var localVarUrlObj = url.parse(localVarPath, true);
            var localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            var localVarHeaderParameter = {};
            var localVarQueryParameter = {};
            if (configuration && configuration.accessToken) {
                var localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("oauth2", ["api"])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }
            if (branch !== undefined) {
                localVarQueryParameter['branch'] = branch;
            }
            if (lane !== undefined) {
                localVarQueryParameter['lane'] = lane;
            }
            if (buildType !== undefined) {
                localVarQueryParameter['buildType'] = buildType;
            }
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        submitIosApps: function (whiteLabelIds, branch, buildType, options) {
            if (options === void 0) { options = {}; }
            if (whiteLabelIds === null || whiteLabelIds === undefined) {
                throw new RequiredError('whiteLabelIds', 'Required parameter whiteLabelIds was null or undefined when calling submitIosApps.');
            }
            var localVarPath = "/api/v1.0/whitelabelbuilds/ios/multiple";
            var localVarUrlObj = url.parse(localVarPath, true);
            var localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            var localVarHeaderParameter = {};
            var localVarQueryParameter = {};
            if (configuration && configuration.accessToken) {
                var localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("oauth2", ["api"])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }
            if (whiteLabelIds !== undefined) {
                localVarQueryParameter['whiteLabelIds'] = whiteLabelIds;
            }
            if (branch !== undefined) {
                localVarQueryParameter['branch'] = branch;
            }
            if (buildType !== undefined) {
                localVarQueryParameter['buildType'] = buildType;
            }
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        submitIosBuild: function (appId, buildType, branch, submitForReview, options) {
            if (options === void 0) { options = {}; }
            if (appId === null || appId === undefined) {
                throw new RequiredError('appId', 'Required parameter appId was null or undefined when calling submitIosBuild.');
            }
            if (buildType === null || buildType === undefined) {
                throw new RequiredError('buildType', 'Required parameter buildType was null or undefined when calling submitIosBuild.');
            }
            if (branch === null || branch === undefined) {
                throw new RequiredError('branch', 'Required parameter branch was null or undefined when calling submitIosBuild.');
            }
            var localVarPath = "/api/v1.0/whitelabelbuilds/{appId}/ios"
                .replace("{".concat("appId", "}"), encodeURIComponent(String(appId)));
            var localVarUrlObj = url.parse(localVarPath, true);
            var localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            var localVarHeaderParameter = {};
            var localVarQueryParameter = {};
            if (configuration && configuration.accessToken) {
                var localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("oauth2", ["api"])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }
            if (buildType !== undefined) {
                localVarQueryParameter['buildType'] = buildType;
            }
            if (branch !== undefined) {
                localVarQueryParameter['branch'] = branch;
            }
            if (submitForReview !== undefined) {
                localVarQueryParameter['submitForReview'] = submitForReview;
            }
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    };
};
exports.WhiteLabelBuildsApiFetchParamCreator = WhiteLabelBuildsApiFetchParamCreator;
var WhiteLabelBuildsApiFp = function (configuration) {
    return {
        healthCheck: function (options) {
            var localVarFetchArgs = (0, exports.WhiteLabelBuildsApiFetchParamCreator)(configuration).healthCheck(options);
            return function (fetch, basePath) {
                if (fetch === void 0) { fetch = portableFetch; }
                if (basePath === void 0) { basePath = BASE_PATH; }
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then(function (response) {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
        submitAndroidApps: function (whiteLabelIds, branch, buildType, options) {
            var localVarFetchArgs = (0, exports.WhiteLabelBuildsApiFetchParamCreator)(configuration).submitAndroidApps(whiteLabelIds, branch, buildType, options);
            return function (fetch, basePath) {
                if (fetch === void 0) { fetch = portableFetch; }
                if (basePath === void 0) { basePath = BASE_PATH; }
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then(function (response) {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
        submitAndroidBuild: function (appId, branch, lane, buildType, options) {
            var localVarFetchArgs = (0, exports.WhiteLabelBuildsApiFetchParamCreator)(configuration).submitAndroidBuild(appId, branch, lane, buildType, options);
            return function (fetch, basePath) {
                if (fetch === void 0) { fetch = portableFetch; }
                if (basePath === void 0) { basePath = BASE_PATH; }
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then(function (response) {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
        submitIosApps: function (whiteLabelIds, branch, buildType, options) {
            var localVarFetchArgs = (0, exports.WhiteLabelBuildsApiFetchParamCreator)(configuration).submitIosApps(whiteLabelIds, branch, buildType, options);
            return function (fetch, basePath) {
                if (fetch === void 0) { fetch = portableFetch; }
                if (basePath === void 0) { basePath = BASE_PATH; }
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then(function (response) {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
        submitIosBuild: function (appId, buildType, branch, submitForReview, options) {
            var localVarFetchArgs = (0, exports.WhiteLabelBuildsApiFetchParamCreator)(configuration).submitIosBuild(appId, buildType, branch, submitForReview, options);
            return function (fetch, basePath) {
                if (fetch === void 0) { fetch = portableFetch; }
                if (basePath === void 0) { basePath = BASE_PATH; }
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then(function (response) {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
    };
};
exports.WhiteLabelBuildsApiFp = WhiteLabelBuildsApiFp;
var WhiteLabelBuildsApiFactory = function (configuration, fetch, basePath) {
    return {
        healthCheck: function (options) {
            return (0, exports.WhiteLabelBuildsApiFp)(configuration).healthCheck(options)(fetch, basePath);
        },
        submitAndroidApps: function (whiteLabelIds, branch, buildType, options) {
            return (0, exports.WhiteLabelBuildsApiFp)(configuration).submitAndroidApps(whiteLabelIds, branch, buildType, options)(fetch, basePath);
        },
        submitAndroidBuild: function (appId, branch, lane, buildType, options) {
            return (0, exports.WhiteLabelBuildsApiFp)(configuration).submitAndroidBuild(appId, branch, lane, buildType, options)(fetch, basePath);
        },
        submitIosApps: function (whiteLabelIds, branch, buildType, options) {
            return (0, exports.WhiteLabelBuildsApiFp)(configuration).submitIosApps(whiteLabelIds, branch, buildType, options)(fetch, basePath);
        },
        submitIosBuild: function (appId, buildType, branch, submitForReview, options) {
            return (0, exports.WhiteLabelBuildsApiFp)(configuration).submitIosBuild(appId, buildType, branch, submitForReview, options)(fetch, basePath);
        },
    };
};
exports.WhiteLabelBuildsApiFactory = WhiteLabelBuildsApiFactory;
var WhiteLabelBuildsApi = (function (_super) {
    __extends(WhiteLabelBuildsApi, _super);
    function WhiteLabelBuildsApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    WhiteLabelBuildsApi.prototype.healthCheck = function (options) {
        return (0, exports.WhiteLabelBuildsApiFp)(this.configuration).healthCheck(options)(this.fetch, this.basePath);
    };
    WhiteLabelBuildsApi.prototype.submitAndroidApps = function (whiteLabelIds, branch, buildType, options) {
        return (0, exports.WhiteLabelBuildsApiFp)(this.configuration).submitAndroidApps(whiteLabelIds, branch, buildType, options)(this.fetch, this.basePath);
    };
    WhiteLabelBuildsApi.prototype.submitAndroidBuild = function (appId, branch, lane, buildType, options) {
        return (0, exports.WhiteLabelBuildsApiFp)(this.configuration).submitAndroidBuild(appId, branch, lane, buildType, options)(this.fetch, this.basePath);
    };
    WhiteLabelBuildsApi.prototype.submitIosApps = function (whiteLabelIds, branch, buildType, options) {
        return (0, exports.WhiteLabelBuildsApiFp)(this.configuration).submitIosApps(whiteLabelIds, branch, buildType, options)(this.fetch, this.basePath);
    };
    WhiteLabelBuildsApi.prototype.submitIosBuild = function (appId, buildType, branch, submitForReview, options) {
        return (0, exports.WhiteLabelBuildsApiFp)(this.configuration).submitIosBuild(appId, buildType, branch, submitForReview, options)(this.fetch, this.basePath);
    };
    return WhiteLabelBuildsApi;
}(BaseAPI));
exports.WhiteLabelBuildsApi = WhiteLabelBuildsApi;
var WhiteLabelConfigApiFetchParamCreator = function (configuration) {
    return {
        getAppGeneralConfig: function (appId, options) {
            if (options === void 0) { options = {}; }
            if (appId === null || appId === undefined) {
                throw new RequiredError('appId', 'Required parameter appId was null or undefined when calling getAppGeneralConfig.');
            }
            var localVarPath = "/api/v1.0/whitelabelconfig/{appId}/general"
                .replace("{".concat("appId", "}"), encodeURIComponent(String(appId)));
            var localVarUrlObj = url.parse(localVarPath, true);
            var localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            var localVarHeaderParameter = {};
            var localVarQueryParameter = {};
            if (configuration && configuration.accessToken) {
                var localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("oauth2", ["api"])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        getAppStoreConfig: function (appId, options) {
            if (options === void 0) { options = {}; }
            if (appId === null || appId === undefined) {
                throw new RequiredError('appId', 'Required parameter appId was null or undefined when calling getAppStoreConfig.');
            }
            var localVarPath = "/api/v1.0/whitelabelconfig/{appId}/appstore"
                .replace("{".concat("appId", "}"), encodeURIComponent(String(appId)));
            var localVarUrlObj = url.parse(localVarPath, true);
            var localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            var localVarHeaderParameter = {};
            var localVarQueryParameter = {};
            if (configuration && configuration.accessToken) {
                var localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("oauth2", ["api"])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        getPlayStoreConfig: function (appId, options) {
            if (options === void 0) { options = {}; }
            if (appId === null || appId === undefined) {
                throw new RequiredError('appId', 'Required parameter appId was null or undefined when calling getPlayStoreConfig.');
            }
            var localVarPath = "/api/v1.0/whitelabelconfig/{appId}/playstore"
                .replace("{".concat("appId", "}"), encodeURIComponent(String(appId)));
            var localVarUrlObj = url.parse(localVarPath, true);
            var localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            var localVarHeaderParameter = {};
            var localVarQueryParameter = {};
            if (configuration && configuration.accessToken) {
                var localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("oauth2", ["api"])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        getWhiteLabelConfig: function (wlid, options) {
            if (options === void 0) { options = {}; }
            if (wlid === null || wlid === undefined) {
                throw new RequiredError('wlid', 'Required parameter wlid was null or undefined when calling getWhiteLabelConfig.');
            }
            var localVarPath = "/api/v1.0/whitelabelconfig/id/{wlid}"
                .replace("{".concat("wlid", "}"), encodeURIComponent(String(wlid)));
            var localVarUrlObj = url.parse(localVarPath, true);
            var localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            var localVarHeaderParameter = {};
            var localVarQueryParameter = {};
            if (configuration && configuration.accessToken) {
                var localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("oauth2", ["api"])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        getWhiteLabelConfigByAppNameId: function (appId, options) {
            if (options === void 0) { options = {}; }
            if (appId === null || appId === undefined) {
                throw new RequiredError('appId', 'Required parameter appId was null or undefined when calling getWhiteLabelConfigByAppNameId.');
            }
            var localVarPath = "/api/v1.0/whitelabelconfig/name/{appId}"
                .replace("{".concat("appId", "}"), encodeURIComponent(String(appId)));
            var localVarUrlObj = url.parse(localVarPath, true);
            var localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            var localVarHeaderParameter = {};
            var localVarQueryParameter = {};
            if (configuration && configuration.accessToken) {
                var localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("oauth2", ["api"])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        healthCheck: function (options) {
            if (options === void 0) { options = {}; }
            var localVarPath = "/api/v1.0/whitelabelconfig/health";
            var localVarUrlObj = url.parse(localVarPath, true);
            var localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            var localVarHeaderParameter = {};
            var localVarQueryParameter = {};
            if (configuration && configuration.accessToken) {
                var localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("oauth2", ["api"])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        updateAppGeneralConfig: function (appId, AppGeneralConfigModel, options) {
            if (options === void 0) { options = {}; }
            if (appId === null || appId === undefined) {
                throw new RequiredError('appId', 'Required parameter appId was null or undefined when calling updateAppGeneralConfig.');
            }
            if (AppGeneralConfigModel === null || AppGeneralConfigModel === undefined) {
                throw new RequiredError('AppGeneralConfigModel', 'Required parameter AppGeneralConfigModel was null or undefined when calling updateAppGeneralConfig.');
            }
            var localVarPath = "/api/v1.0/whitelabelconfig/{appId}/general"
                .replace("{".concat("appId", "}"), encodeURIComponent(String(appId)));
            var localVarUrlObj = url.parse(localVarPath, true);
            var localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            var localVarHeaderParameter = {};
            var localVarQueryParameter = {};
            if (configuration && configuration.accessToken) {
                var localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("oauth2", ["api"])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }
            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            var needsSerialization = ("AppGeneralConfigModel" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body = needsSerialization ? JSON.stringify(AppGeneralConfigModel || {}) : (AppGeneralConfigModel || "");
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        updateAppStoreConfig: function (appId, AppStoreConfigModel, options) {
            if (options === void 0) { options = {}; }
            if (appId === null || appId === undefined) {
                throw new RequiredError('appId', 'Required parameter appId was null or undefined when calling updateAppStoreConfig.');
            }
            if (AppStoreConfigModel === null || AppStoreConfigModel === undefined) {
                throw new RequiredError('AppStoreConfigModel', 'Required parameter AppStoreConfigModel was null or undefined when calling updateAppStoreConfig.');
            }
            var localVarPath = "/api/v1.0/whitelabelconfig/{appId}/appstore"
                .replace("{".concat("appId", "}"), encodeURIComponent(String(appId)));
            var localVarUrlObj = url.parse(localVarPath, true);
            var localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            var localVarHeaderParameter = {};
            var localVarQueryParameter = {};
            if (configuration && configuration.accessToken) {
                var localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("oauth2", ["api"])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }
            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            var needsSerialization = ("AppStoreConfigModel" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body = needsSerialization ? JSON.stringify(AppStoreConfigModel || {}) : (AppStoreConfigModel || "");
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        updatePlayStoreConfig: function (appId, PlayStoreConfigModel, options) {
            if (options === void 0) { options = {}; }
            if (appId === null || appId === undefined) {
                throw new RequiredError('appId', 'Required parameter appId was null or undefined when calling updatePlayStoreConfig.');
            }
            if (PlayStoreConfigModel === null || PlayStoreConfigModel === undefined) {
                throw new RequiredError('PlayStoreConfigModel', 'Required parameter PlayStoreConfigModel was null or undefined when calling updatePlayStoreConfig.');
            }
            var localVarPath = "/api/v1.0/whitelabelconfig/{appId}/playstore"
                .replace("{".concat("appId", "}"), encodeURIComponent(String(appId)));
            var localVarUrlObj = url.parse(localVarPath, true);
            var localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            var localVarHeaderParameter = {};
            var localVarQueryParameter = {};
            if (configuration && configuration.accessToken) {
                var localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("oauth2", ["api"])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }
            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            var needsSerialization = ("PlayStoreConfigModel" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body = needsSerialization ? JSON.stringify(PlayStoreConfigModel || {}) : (PlayStoreConfigModel || "");
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        uploadAppStoreIcon: function (appId, HttpPostedFileBase, options) {
            if (options === void 0) { options = {}; }
            if (appId === null || appId === undefined) {
                throw new RequiredError('appId', 'Required parameter appId was null or undefined when calling uploadAppStoreIcon.');
            }
            if (HttpPostedFileBase === null || HttpPostedFileBase === undefined) {
                throw new RequiredError('HttpPostedFileBase', 'Required parameter HttpPostedFileBase was null or undefined when calling uploadAppStoreIcon.');
            }
            var localVarPath = "/api/v1.0/whitelabelconfig/{appId}/app-store-icon"
                .replace("{".concat("appId", "}"), encodeURIComponent(String(appId)));
            var localVarUrlObj = url.parse(localVarPath, true);
            var localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            var localVarHeaderParameter = {};
            var localVarQueryParameter = {};
            if (configuration && configuration.accessToken) {
                var localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("oauth2", ["api"])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }
            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            var needsSerialization = ("HttpPostedFileBase" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body = needsSerialization ? JSON.stringify(HttpPostedFileBase || {}) : (HttpPostedFileBase || "");
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    };
};
exports.WhiteLabelConfigApiFetchParamCreator = WhiteLabelConfigApiFetchParamCreator;
var WhiteLabelConfigApiFp = function (configuration) {
    return {
        getAppGeneralConfig: function (appId, options) {
            var localVarFetchArgs = (0, exports.WhiteLabelConfigApiFetchParamCreator)(configuration).getAppGeneralConfig(appId, options);
            return function (fetch, basePath) {
                if (fetch === void 0) { fetch = portableFetch; }
                if (basePath === void 0) { basePath = BASE_PATH; }
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then(function (response) {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
        getAppStoreConfig: function (appId, options) {
            var localVarFetchArgs = (0, exports.WhiteLabelConfigApiFetchParamCreator)(configuration).getAppStoreConfig(appId, options);
            return function (fetch, basePath) {
                if (fetch === void 0) { fetch = portableFetch; }
                if (basePath === void 0) { basePath = BASE_PATH; }
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then(function (response) {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
        getPlayStoreConfig: function (appId, options) {
            var localVarFetchArgs = (0, exports.WhiteLabelConfigApiFetchParamCreator)(configuration).getPlayStoreConfig(appId, options);
            return function (fetch, basePath) {
                if (fetch === void 0) { fetch = portableFetch; }
                if (basePath === void 0) { basePath = BASE_PATH; }
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then(function (response) {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
        getWhiteLabelConfig: function (wlid, options) {
            var localVarFetchArgs = (0, exports.WhiteLabelConfigApiFetchParamCreator)(configuration).getWhiteLabelConfig(wlid, options);
            return function (fetch, basePath) {
                if (fetch === void 0) { fetch = portableFetch; }
                if (basePath === void 0) { basePath = BASE_PATH; }
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then(function (response) {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
        getWhiteLabelConfigByAppNameId: function (appId, options) {
            var localVarFetchArgs = (0, exports.WhiteLabelConfigApiFetchParamCreator)(configuration).getWhiteLabelConfigByAppNameId(appId, options);
            return function (fetch, basePath) {
                if (fetch === void 0) { fetch = portableFetch; }
                if (basePath === void 0) { basePath = BASE_PATH; }
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then(function (response) {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
        healthCheck: function (options) {
            var localVarFetchArgs = (0, exports.WhiteLabelConfigApiFetchParamCreator)(configuration).healthCheck(options);
            return function (fetch, basePath) {
                if (fetch === void 0) { fetch = portableFetch; }
                if (basePath === void 0) { basePath = BASE_PATH; }
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then(function (response) {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
        updateAppGeneralConfig: function (appId, AppGeneralConfigModel, options) {
            var localVarFetchArgs = (0, exports.WhiteLabelConfigApiFetchParamCreator)(configuration).updateAppGeneralConfig(appId, AppGeneralConfigModel, options);
            return function (fetch, basePath) {
                if (fetch === void 0) { fetch = portableFetch; }
                if (basePath === void 0) { basePath = BASE_PATH; }
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then(function (response) {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
        updateAppStoreConfig: function (appId, AppStoreConfigModel, options) {
            var localVarFetchArgs = (0, exports.WhiteLabelConfigApiFetchParamCreator)(configuration).updateAppStoreConfig(appId, AppStoreConfigModel, options);
            return function (fetch, basePath) {
                if (fetch === void 0) { fetch = portableFetch; }
                if (basePath === void 0) { basePath = BASE_PATH; }
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then(function (response) {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
        updatePlayStoreConfig: function (appId, PlayStoreConfigModel, options) {
            var localVarFetchArgs = (0, exports.WhiteLabelConfigApiFetchParamCreator)(configuration).updatePlayStoreConfig(appId, PlayStoreConfigModel, options);
            return function (fetch, basePath) {
                if (fetch === void 0) { fetch = portableFetch; }
                if (basePath === void 0) { basePath = BASE_PATH; }
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then(function (response) {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
        uploadAppStoreIcon: function (appId, HttpPostedFileBase, options) {
            var localVarFetchArgs = (0, exports.WhiteLabelConfigApiFetchParamCreator)(configuration).uploadAppStoreIcon(appId, HttpPostedFileBase, options);
            return function (fetch, basePath) {
                if (fetch === void 0) { fetch = portableFetch; }
                if (basePath === void 0) { basePath = BASE_PATH; }
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then(function (response) {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
    };
};
exports.WhiteLabelConfigApiFp = WhiteLabelConfigApiFp;
var WhiteLabelConfigApiFactory = function (configuration, fetch, basePath) {
    return {
        getAppGeneralConfig: function (appId, options) {
            return (0, exports.WhiteLabelConfigApiFp)(configuration).getAppGeneralConfig(appId, options)(fetch, basePath);
        },
        getAppStoreConfig: function (appId, options) {
            return (0, exports.WhiteLabelConfigApiFp)(configuration).getAppStoreConfig(appId, options)(fetch, basePath);
        },
        getPlayStoreConfig: function (appId, options) {
            return (0, exports.WhiteLabelConfigApiFp)(configuration).getPlayStoreConfig(appId, options)(fetch, basePath);
        },
        getWhiteLabelConfig: function (wlid, options) {
            return (0, exports.WhiteLabelConfigApiFp)(configuration).getWhiteLabelConfig(wlid, options)(fetch, basePath);
        },
        getWhiteLabelConfigByAppNameId: function (appId, options) {
            return (0, exports.WhiteLabelConfigApiFp)(configuration).getWhiteLabelConfigByAppNameId(appId, options)(fetch, basePath);
        },
        healthCheck: function (options) {
            return (0, exports.WhiteLabelConfigApiFp)(configuration).healthCheck(options)(fetch, basePath);
        },
        updateAppGeneralConfig: function (appId, AppGeneralConfigModel, options) {
            return (0, exports.WhiteLabelConfigApiFp)(configuration).updateAppGeneralConfig(appId, AppGeneralConfigModel, options)(fetch, basePath);
        },
        updateAppStoreConfig: function (appId, AppStoreConfigModel, options) {
            return (0, exports.WhiteLabelConfigApiFp)(configuration).updateAppStoreConfig(appId, AppStoreConfigModel, options)(fetch, basePath);
        },
        updatePlayStoreConfig: function (appId, PlayStoreConfigModel, options) {
            return (0, exports.WhiteLabelConfigApiFp)(configuration).updatePlayStoreConfig(appId, PlayStoreConfigModel, options)(fetch, basePath);
        },
        uploadAppStoreIcon: function (appId, HttpPostedFileBase, options) {
            return (0, exports.WhiteLabelConfigApiFp)(configuration).uploadAppStoreIcon(appId, HttpPostedFileBase, options)(fetch, basePath);
        },
    };
};
exports.WhiteLabelConfigApiFactory = WhiteLabelConfigApiFactory;
var WhiteLabelConfigApi = (function (_super) {
    __extends(WhiteLabelConfigApi, _super);
    function WhiteLabelConfigApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    WhiteLabelConfigApi.prototype.getAppGeneralConfig = function (appId, options) {
        return (0, exports.WhiteLabelConfigApiFp)(this.configuration).getAppGeneralConfig(appId, options)(this.fetch, this.basePath);
    };
    WhiteLabelConfigApi.prototype.getAppStoreConfig = function (appId, options) {
        return (0, exports.WhiteLabelConfigApiFp)(this.configuration).getAppStoreConfig(appId, options)(this.fetch, this.basePath);
    };
    WhiteLabelConfigApi.prototype.getPlayStoreConfig = function (appId, options) {
        return (0, exports.WhiteLabelConfigApiFp)(this.configuration).getPlayStoreConfig(appId, options)(this.fetch, this.basePath);
    };
    WhiteLabelConfigApi.prototype.getWhiteLabelConfig = function (wlid, options) {
        return (0, exports.WhiteLabelConfigApiFp)(this.configuration).getWhiteLabelConfig(wlid, options)(this.fetch, this.basePath);
    };
    WhiteLabelConfigApi.prototype.getWhiteLabelConfigByAppNameId = function (appId, options) {
        return (0, exports.WhiteLabelConfigApiFp)(this.configuration).getWhiteLabelConfigByAppNameId(appId, options)(this.fetch, this.basePath);
    };
    WhiteLabelConfigApi.prototype.healthCheck = function (options) {
        return (0, exports.WhiteLabelConfigApiFp)(this.configuration).healthCheck(options)(this.fetch, this.basePath);
    };
    WhiteLabelConfigApi.prototype.updateAppGeneralConfig = function (appId, AppGeneralConfigModel, options) {
        return (0, exports.WhiteLabelConfigApiFp)(this.configuration).updateAppGeneralConfig(appId, AppGeneralConfigModel, options)(this.fetch, this.basePath);
    };
    WhiteLabelConfigApi.prototype.updateAppStoreConfig = function (appId, AppStoreConfigModel, options) {
        return (0, exports.WhiteLabelConfigApiFp)(this.configuration).updateAppStoreConfig(appId, AppStoreConfigModel, options)(this.fetch, this.basePath);
    };
    WhiteLabelConfigApi.prototype.updatePlayStoreConfig = function (appId, PlayStoreConfigModel, options) {
        return (0, exports.WhiteLabelConfigApiFp)(this.configuration).updatePlayStoreConfig(appId, PlayStoreConfigModel, options)(this.fetch, this.basePath);
    };
    WhiteLabelConfigApi.prototype.uploadAppStoreIcon = function (appId, HttpPostedFileBase, options) {
        return (0, exports.WhiteLabelConfigApiFp)(this.configuration).uploadAppStoreIcon(appId, HttpPostedFileBase, options)(this.fetch, this.basePath);
    };
    return WhiteLabelConfigApi;
}(BaseAPI));
exports.WhiteLabelConfigApi = WhiteLabelConfigApi;
var WhiteLabelContactFormTypeApiFetchParamCreator = function (configuration) {
    return {
        getAppContactFormType: function (appId, options) {
            if (options === void 0) { options = {}; }
            if (appId === null || appId === undefined) {
                throw new RequiredError('appId', 'Required parameter appId was null or undefined when calling getAppContactFormType.');
            }
            var localVarPath = "/api/v1.0/whitelabelconfig/{appId}/contact-form-type"
                .replace("{".concat("appId", "}"), encodeURIComponent(String(appId)));
            var localVarUrlObj = url.parse(localVarPath, true);
            var localVarRequestOptions = Object.assign({ method: 'GET' }, options);
            var localVarHeaderParameter = {};
            var localVarQueryParameter = {};
            if (configuration && configuration.accessToken) {
                var localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("oauth2", ["api"])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        updateAppContactFormType: function (appId, ContactFormTypeConfigModel, options) {
            if (options === void 0) { options = {}; }
            if (appId === null || appId === undefined) {
                throw new RequiredError('appId', 'Required parameter appId was null or undefined when calling updateAppContactFormType.');
            }
            if (ContactFormTypeConfigModel === null || ContactFormTypeConfigModel === undefined) {
                throw new RequiredError('ContactFormTypeConfigModel', 'Required parameter ContactFormTypeConfigModel was null or undefined when calling updateAppContactFormType.');
            }
            var localVarPath = "/api/v1.0/whitelabelconfig/{appId}/contact-form-type"
                .replace("{".concat("appId", "}"), encodeURIComponent(String(appId)));
            var localVarUrlObj = url.parse(localVarPath, true);
            var localVarRequestOptions = Object.assign({ method: 'POST' }, options);
            var localVarHeaderParameter = {};
            var localVarQueryParameter = {};
            if (configuration && configuration.accessToken) {
                var localVarAccessTokenValue = typeof configuration.accessToken === 'function'
                    ? configuration.accessToken("oauth2", ["api"])
                    : configuration.accessToken;
                localVarHeaderParameter["Authorization"] = "Bearer " + localVarAccessTokenValue;
            }
            localVarHeaderParameter['Content-Type'] = 'application/json';
            localVarUrlObj.query = Object.assign({}, localVarUrlObj.query, localVarQueryParameter, options.query);
            delete localVarUrlObj.search;
            localVarRequestOptions.headers = Object.assign({}, localVarHeaderParameter, options.headers);
            var needsSerialization = ("ContactFormTypeConfigModel" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.body = needsSerialization ? JSON.stringify(ContactFormTypeConfigModel || {}) : (ContactFormTypeConfigModel || "");
            return {
                url: url.format(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    };
};
exports.WhiteLabelContactFormTypeApiFetchParamCreator = WhiteLabelContactFormTypeApiFetchParamCreator;
var WhiteLabelContactFormTypeApiFp = function (configuration) {
    return {
        getAppContactFormType: function (appId, options) {
            var localVarFetchArgs = (0, exports.WhiteLabelContactFormTypeApiFetchParamCreator)(configuration).getAppContactFormType(appId, options);
            return function (fetch, basePath) {
                if (fetch === void 0) { fetch = portableFetch; }
                if (basePath === void 0) { basePath = BASE_PATH; }
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then(function (response) {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
        updateAppContactFormType: function (appId, ContactFormTypeConfigModel, options) {
            var localVarFetchArgs = (0, exports.WhiteLabelContactFormTypeApiFetchParamCreator)(configuration).updateAppContactFormType(appId, ContactFormTypeConfigModel, options);
            return function (fetch, basePath) {
                if (fetch === void 0) { fetch = portableFetch; }
                if (basePath === void 0) { basePath = BASE_PATH; }
                return fetch(basePath + localVarFetchArgs.url, localVarFetchArgs.options).then(function (response) {
                    if (response.status >= 200 && response.status < 300) {
                        return response.json();
                    }
                    else {
                        throw response;
                    }
                });
            };
        },
    };
};
exports.WhiteLabelContactFormTypeApiFp = WhiteLabelContactFormTypeApiFp;
var WhiteLabelContactFormTypeApiFactory = function (configuration, fetch, basePath) {
    return {
        getAppContactFormType: function (appId, options) {
            return (0, exports.WhiteLabelContactFormTypeApiFp)(configuration).getAppContactFormType(appId, options)(fetch, basePath);
        },
        updateAppContactFormType: function (appId, ContactFormTypeConfigModel, options) {
            return (0, exports.WhiteLabelContactFormTypeApiFp)(configuration).updateAppContactFormType(appId, ContactFormTypeConfigModel, options)(fetch, basePath);
        },
    };
};
exports.WhiteLabelContactFormTypeApiFactory = WhiteLabelContactFormTypeApiFactory;
var WhiteLabelContactFormTypeApi = (function (_super) {
    __extends(WhiteLabelContactFormTypeApi, _super);
    function WhiteLabelContactFormTypeApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    WhiteLabelContactFormTypeApi.prototype.getAppContactFormType = function (appId, options) {
        return (0, exports.WhiteLabelContactFormTypeApiFp)(this.configuration).getAppContactFormType(appId, options)(this.fetch, this.basePath);
    };
    WhiteLabelContactFormTypeApi.prototype.updateAppContactFormType = function (appId, ContactFormTypeConfigModel, options) {
        return (0, exports.WhiteLabelContactFormTypeApiFp)(this.configuration).updateAppContactFormType(appId, ContactFormTypeConfigModel, options)(this.fetch, this.basePath);
    };
    return WhiteLabelContactFormTypeApi;
}(BaseAPI));
exports.WhiteLabelContactFormTypeApi = WhiteLabelContactFormTypeApi;
//# sourceMappingURL=api.js.map